import "./principal.css";
const Principal = () => {
  return (
    <>
      <svg viewBox="0 0 1368.5 768.96">
        <defs>
          <linearGradient
            id="Degradado_sin_nombre_31"
            x1="684"
            y1="596"
            x2="684"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#d8f0fe" />
            <stop offset="0.4" stop-color="#d6effe" />
            <stop offset="0.58" stop-color="#cfecfe" />
            <stop offset="0.71" stop-color="#c2e7fd" />
            <stop offset="0.83" stop-color="#b0e0fd" />
            <stop offset="0.92" stop-color="#99d6fd" />
            <stop offset="1" stop-color="#81cdfc" />
          </linearGradient>
          <linearGradient
            id="Degradado_sin_nombre_31-2"
            x1="684"
            y1="506.67"
            x2="684"
            y2="434"
            xlinkHref="#Degradado_sin_nombre_31"
          />
          <linearGradient
            id="Degradado_sin_nombre_21"
            x1="110.5"
            y1="383.5"
            x2="136.5"
            y2="383.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="#89e6f8" />
            <stop offset="0.29" stop-color="#87e4f6" />
            <stop offset="0.39" stop-color="#80ddef" />
            <stop offset="0.46" stop-color="#75d2e4" />
            <stop offset="0.52" stop-color="#64c1d3" />
            <stop offset="0.55" stop-color="#5ab7c9" />
          </linearGradient>
          <linearGradient
            id="Degradado_sin_nombre_21-2"
            y1="412.5"
            y2="412.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-3"
            y1="462.5"
            x2="137.5"
            y2="462.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-4"
            x1="109.5"
            y1="491.5"
            x2="137.5"
            y2="491.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-5"
            x1="253.5"
            y1="392.5"
            x2="275.5"
            y2="392.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-6"
            x1="253.5"
            y1="414"
            x2="275.5"
            y2="414"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-7"
            x1="287.5"
            y1="398.5"
            x2="301.5"
            y2="398.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-8"
            x1="287.5"
            y1="419"
            x2="301.5"
            y2="419"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-9"
            x1="313.5"
            y1="402.73"
            x2="320.5"
            y2="402.73"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-10"
            x1="313.5"
            y1="421.36"
            x2="320.5"
            y2="421.36"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-11"
            x1="256.5"
            y1="460"
            x2="271.5"
            y2="460"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-12"
            x1="256.5"
            y1="467.5"
            x2="271.5"
            y2="467.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-13"
            x1="256.5"
            y1="484"
            x2="271.5"
            y2="484"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-14"
            x1="288.5"
            y1="461.5"
            x2="302.5"
            y2="461.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-15"
            x1="288.5"
            y1="482"
            x2="302.5"
            y2="482"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-16"
            x1="314.5"
            y1="462.5"
            x2="321.5"
            y2="462.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_21-17"
            x1="314.5"
            y1="482.5"
            x2="321.5"
            y2="482.5"
            xlinkHref="#Degradado_sin_nombre_21"
          />
          <linearGradient
            id="Degradado_sin_nombre_11"
            x1="1.5"
            y1="558.75"
            x2="72.5"
            y2="558.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2" stop-color="#343434" />
            <stop offset="0.21" stop-color="#373737" />
            <stop offset="0.38" stop-color="#4e4e4e" />
            <stop offset="0.55" stop-color="#5e5e5e" />
            <stop offset="0.75" stop-color="#686868" />
            <stop offset="1" stop-color="#6b6b6b" />
          </linearGradient>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
          <g id="fondo">
            <rect class="cls-1" width="1368" height="596" />
          </g>
          <g id="chimboraz">
            <polygon
              class="cls-2"
              points="991.72 288.41 957.04 287.61 976.59 278.44 991.72 288.41"
            />
            <polygon
              class="cls-3"
              points="938.81 262.12 933.27 277.71 917.41 285.04 904.96 275.11 938.81 262.12"
            />
            <polygon
              class="cls-4"
              points="917.41 285.04 873.83 287.06 904.96 275.11 917.41 285.04"
            />
            <polygon
              class="cls-4"
              points="873.56 303.01 782.69 312.54 808.31 305.76 850.05 297.32 873.56 303.01"
            />
            <polygon
              class="cls-2"
              points="917.41 285.04 873.56 303.01 862.73 288.89 873.83 287.06 917.41 285.04"
            />
            <polygon
              class="cls-3"
              points="917.41 285.04 893.64 302.64 851.9 316.21 873.56 303.01 917.41 285.04"
            />
            <polygon
              class="cls-3"
              points="1081.73 303.37 1028.1 315.9 1018.33 305.94 1045.8 297.14 1081.73 303.37"
            />
            <polygon
              class="cls-2"
              points="1130.34 308.51 1109.73 315.47 1081.73 303.37 1130.34 308.51"
            />
            <polygon
              class="cls-2"
              points="1051.88 255.89 1025.73 266.71 1041.84 249.29 1051.88 255.89"
            />
            <polygon
              class="cls-3"
              points="1041.84 249.29 1025.73 266.71 997.72 261.57 982.67 242.69 1041.84 249.29"
            />
            <polygon
              class="cls-3"
              points="1090.45 266.16 1081.73 274.77 1065.88 265.61 1068.26 252.96 1090.45 266.16"
            />
            <polygon
              class="cls-2"
              points="982.67 242.69 972.36 263.41 964.97 268.54 938.81 262.12 982.67 242.69"
            />
            <polygon
              class="cls-4"
              points="964.97 268.54 933.27 277.71 938.81 262.12 964.97 268.54"
            />
            <polygon
              class="cls-4"
              points="976.59 278.44 957.04 287.61 964.97 268.54 972.36 263.41 976.59 278.44"
            />
            <polygon
              class="cls-3"
              points="1004.59 280.64 991.72 288.41 976.59 278.44 1004.59 280.64"
            />
            <polygon
              class="cls-2"
              points="1081.73 274.77 1045.8 297.14 1065.88 265.61 1081.73 274.77"
            />
            <polygon
              class="cls-3"
              points="1065.88 265.61 1045.8 297.14 1025.73 266.71 1065.88 265.61"
            />
            <polygon
              class="cls-2"
              points="1045.8 297.14 1018.33 305.94 1025.73 266.71 1045.8 297.14"
            />
            <polygon
              class="cls-4"
              points="1025.73 266.71 1004.59 280.64 997.72 261.57 1025.73 266.71"
            />
            <polygon
              class="cls-4"
              points="1090.45 266.16 1087.49 278.77 1081.73 274.77 1090.45 266.16"
            />
            <polygon
              class="cls-2"
              points="1163.89 294.39 1090.45 266.16 1098.9 262.86 1163.89 294.39"
            />
            <polygon
              class="cls-4"
              points="1188.98 300.07 1153.06 305.57 1163.89 294.39 1172.61 291.27 1188.98 300.07"
            />
            <polygon
              class="cls-3"
              points="1163.89 294.39 1153.06 305.57 1145.13 313.64 1130.34 308.51 1163.89 294.39"
            />
            <polygon
              class="cls-2"
              points="1243.93 314.37 1200.61 309.24 1188.98 300.07 1243.93 314.37"
            />
            <line
              class="cls-5"
              x1="1034.35"
              y1="452.53"
              x2="1034.21"
              y2="452.46"
            />
            <polygon
              class="cls-4"
              points="997.72 261.57 972.36 263.41 982.67 242.69 997.72 261.57"
            />
            <polygon
              class="cls-4"
              points="1068.26 252.96 1065.88 265.61 1025.73 266.71 1051.88 255.89 1068.26 252.96"
            />
            <polygon
              class="cls-2"
              points="964.97 268.54 957.04 287.61 930.1 290.17 893.64 302.64 917.41 285.04 933.27 277.71 964.97 268.54"
            />
            <polygon
              class="cls-3"
              points="873.56 303.01 850.05 297.32 862.73 288.89 873.56 303.01"
            />
            <path
              class="cls-3"
              d="M990,320.24l-26.13-15,27.81-16.8C991.68,288.85,989.28,319.15,990,320.24Z"
            />
            <path
              class="cls-2"
              d="M1018.33,305.94,990,320.24c-.76-1.09,1.64-31.39,1.68-31.83h0Z"
            />
            <polygon
              class="cls-6"
              points="1294.37 328.12 1183.7 320.24 1175.78 312.54 1214.87 315.84 1200.61 309.24 1243.93 314.37 1294.37 328.12"
            />
            <polygon
              class="cls-7"
              points="1366.98 320.25 1294.37 328.12 1366.98 312.54 1366.98 320.25"
            />
            <polygon
              class="cls-2"
              points="1366.98 318.77 1366.98 320.25 1366.98 312.54 1366.98 318.77"
            />
            <polygon
              class="cls-3"
              points="1366.98 338.39 1366.98 344.32 1342.2 338.9 1366.98 338.45 1366.98 338.39"
            />
            <polygon
              class="cls-4"
              points="1018.33 305.94 991.72 288.41 1004.59 280.64 1018.33 305.94"
            />
            <polygon
              class="cls-3"
              points="997.72 261.57 976.59 278.44 972.36 263.41 997.72 261.57"
            />
            <polygon
              class="cls-4"
              points="1130.34 308.51 1081.73 303.37 1087.49 278.77 1130.34 308.51"
            />
            <polygon
              class="cls-3"
              points="1087.49 278.77 1081.73 303.37 1081.73 274.77 1087.49 278.77"
            />
            <polygon
              class="cls-4"
              points="1081.73 274.77 1081.73 303.37 1045.8 297.14 1081.73 274.77"
            />
            <polygon
              class="cls-2"
              points="1163.89 294.39 1130.34 308.51 1087.49 278.77 1163.89 294.39"
            />
            <polygon
              class="cls-3"
              points="1163.89 294.39 1087.49 278.77 1090.45 266.16 1163.89 294.39"
            />
            <polygon
              class="cls-2"
              points="1004.59 280.64 976.59 278.44 997.72 261.57 1004.59 280.64"
            />
            <polygon
              class="cls-3"
              points="1025.73 266.71 1018.33 305.94 1004.59 280.64 1025.73 266.71"
            />
            <polygon
              class="cls-3"
              points="1175.78 312.54 1183.7 320.24 1153.06 305.57 1188.98 300.07 1200.61 309.24 1214.87 315.84 1175.78 312.54"
            />
            <polygon
              class="cls-3"
              points="930.1 290.17 917.94 318.77 893.64 302.64 930.1 290.17"
            />
            <polygon
              class="cls-2"
              points="957.04 287.61 917.94 318.77 930.1 290.17 957.04 287.61"
            />
            <polygon
              class="cls-8"
              points="790.86 312.18 609.12 361.66 1.02 398.87 1.02 380.99 608.77 359.42 790.86 312.18"
            />
            <polygon
              class="cls-6"
              points="828.88 337.66 610.7 385.88 1.02 395.39 606.52 362.04 783.69 313.28 828.88 337.66"
            />
            <polygon
              class="cls-8"
              points="873.56 303.01 851.9 316.21 827.88 336.92 782.69 312.54 873.56 303.01"
            />
            <polygon
              class="cls-4"
              points="991.72 288.41 991.72 288.41 963.91 305.21 917.94 318.77 957.04 287.61 991.72 288.41"
            />
            <polygon
              class="cls-6"
              points="990.04 320.24 967.98 345.17 967.66 345.54 967.39 345.83 967.15 345.7 965.93 345.03 917.94 318.77 963.91 305.21 990.04 320.24"
            />
            <polygon
              class="cls-9"
              points="827.88 347.27 609.87 401.1 1.02 432.1 1.02 422.49 1.02 423.36 1.02 395.39 609.56 385.79 827.1 337.6 827.11 337.6 827.88 347.27"
            />
            <polygon
              class="cls-6"
              points="1.02 422.62 1.02 397.24 1.02 394.65 1.02 422.62"
            />
            <path
              class="cls-10"
              d="M1367,466.43,1294.9,459,1,534.45V466.17l737.52-60.3,145.57-34.11,82.82-27.32,212.81,12.73L1367,374.66C1365.48,374.06,1367,466.43,1367,466.43Z"
            />
            <polygon
              class="cls-6"
              points="967.15 383.39 930.88 383.13 889.89 394.96 821.23 404.98 619.86 447.92 1.02 431.36 611.35 400.2 827.88 346.53 826.76 335.6 965.93 345.03 967.15 383.39"
            />
            <polygon
              class="cls-8"
              points="965.93 345.03 830.76 336.34 917.94 318.77 965.93 345.03"
            />
            <polygon
              class="cls-9"
              points="917.94 318.77 827.76 336.34 827.88 336.92 828.52 336.37 851.9 316.21 893.64 302.64 917.94 318.77"
            />
            <polygon
              class="cls-9"
              points="1200.61 345.83 1173.47 356.39 1154.11 356.54 1138.99 356.54 965.87 380.17 960.73 346.57 990.04 320.24 1132.04 336.92 1200.61 345.83"
            />
            <line
              class="cls-5"
              x1="1178.21"
              y1="373.59"
              x2="1178.21"
              y2="373.41"
            />
            <line
              class="cls-5"
              x1="1209.57"
              y1="376.59"
              x2="1209.57"
              y2="376.34"
            />
            <polygon
              class="cls-10"
              points="1366.98 344.32 1366.98 374.5 1178.21 357.68 1192.87 353.95 1192.87 353.95 1243.77 341 1294.37 328.12 1342.19 338.9 1342.2 338.9 1366.98 344.32"
            />
            <polygon
              class="cls-8"
              points="1200.61 345.83 1132.04 336.92 990.04 320.24 1018.33 305.94 1028.1 315.9 1081.73 303.37 1109.73 315.47 1200.61 345.83"
            />
            <polygon
              class="cls-11"
              points="1173.47 356.39 1168.38 358.37 1154.11 357.48 1138.99 356.54 1154.11 356.54 1173.47 356.39"
            />
            <polygon
              class="cls-6"
              points="1294.37 328.12 1178.21 357.68 1168.38 358.37 1173.47 356.39 1200.61 345.83 1294.37 328.12"
            />
            <polygon
              class="cls-9"
              points="1294.37 328.12 1200.61 345.83 1109.73 315.47 1130.34 308.51 1145.13 313.64 1153.06 305.57 1183.7 320.24 1294.37 328.12"
            />
            <line
              class="cls-12"
              x1="911.87"
              y1="475.53"
              x2="909.35"
              y2="476.21"
            />
            <polygon
              class="cls-7"
              points="1366.98 318.77 1366.98 338.39 1366.98 338.45 1366.98 320.25 1366.98 318.77"
            />
            <line
              class="cls-12"
              x1="1366.98"
              y1="344.32"
              x2="1366.98"
              y2="338.45"
            />
            <polygon
              class="cls-2"
              points="1366.98 338.45 1342.2 338.9 1366.98 320.25 1366.98 338.45"
            />
            <polygon
              class="cls-3"
              points="1366.98 320.25 1342.2 338.9 1342.19 338.9 1294.37 328.12 1366.98 320.25"
            />
            <path
              class="cls-13"
              d="M402.31,492.47c-4.62,0-9.23-.07-13.85-.07H211.67l-2.37,0a5.06,5.06,0,0,1-2.23.34H194a5.11,5.11,0,0,1-2.23-.34l-36.08,0h-62l-88.78,0v-3.87a3.8,3.8,0,0,1,1.75-.12c3,0,5.92.05,8.88,0a5.16,5.16,0,0,0,2.3-.4,19.89,19.89,0,0,0-2-.65,9.63,9.63,0,0,0-3.39-.21,44.54,44.54,0,0,0-6.33.14,1.77,1.77,0,0,1-1.18,0v-.43a3.34,3.34,0,0,1,2.4-.55c2.91,0,5.82,0,8.73,0a5.56,5.56,0,0,0,2.52-.46,13.68,13.68,0,0,1,7,0,6.18,6.18,0,0,0,2.7.47c3.15,0,6.3,0,9.45,0a15.54,15.54,0,0,0,3.92-.58,11.16,11.16,0,0,1,6.76.19,6.44,6.44,0,0,0,2.39.37c2.55,0,5.1,0,7.64,0,1,0,1.91,0,2.86,0a4.46,4.46,0,0,0,2.84-.68c2.66-.19,5.32-.65,7.8.47.87.39,2.12.15,3.2.18.66,0,1.33,0,2,0,2.46.08,4.93,0,7.39,0A3,3,0,0,0,86.1,486a2.69,2.69,0,0,1,.76-.37c2.68-.16,5.39-.58,7.87.48a5.46,5.46,0,0,0,2.12.2c3.28,0,6.55,0,9.82,0a7.82,7.82,0,0,0,2.86-.48,9.54,9.54,0,0,1,6,0,8.15,8.15,0,0,0,2.71.45c3,0,6,0,9,0,1.44,0,3,.16,4-.7,2.54-.13,5.14-.63,7.44.53a4.58,4.58,0,0,0,1.77.14h9.27a17.15,17.15,0,0,0,4.27-.57A10.86,10.86,0,0,1,161,486a4.23,4.23,0,0,0,1.85.32c1.39,0,2.78-.05,4.17,0,1.95-.05,3.89,0,5.84,0a8.14,8.14,0,0,0,3.74-.58c1.18-.6,5.76-.34,6.89.28a3.41,3.41,0,0,0,1.66.33c3.89,0,7.77,0,11.66,0a3.52,3.52,0,0,0,2.22-.6c2.66-.31,5.31-.68,7.82.35,1,.4,2.29.08,3.35.39.69.76-.89.53-1.12.9a15,15,0,0,1-2.3.65,61.2,61.2,0,0,0,14.06.11,10.9,10.9,0,0,0-2.17-.8c-1.83-.38-3.72-.09-5.57-.19-.74,0-1.63.11-2-.48a1.25,1.25,0,0,1,.52-.24c2-.2,4.1-.06,6.16-.09a16.1,16.1,0,0,0,4.09-.59,13.17,13.17,0,0,1,7,.07,9.55,9.55,0,0,0,2.88.47h11.07a1.76,1.76,0,0,0,.88-.06c1.8-1.18,4.15-.7,6.33-.76a1.28,1.28,0,0,1,.53.05c3,1.33,6.41.61,9.64.77,1.08.06,2.18,0,3.27,0,1.44,0,3,.18,4-.68a22.2,22.2,0,0,1,6.41.05c.4.18.58.47.95.66l.29.12c.49.2,1.48.07,1.47.59s-.92.42-1.48.56a.5.5,0,0,0-.32.23c.21.49.95.4,1.49.44a89.68,89.68,0,0,0,11.24.06c.41-.05.82-.05,1.23-.08s.6-.1.62-.31-.23-.28-.5-.38c-1.59-.57-1.59-.58.08-1.19.51-.23.71-.65,1.36-.81a41,41,0,0,1,4.71-.11,2.85,2.85,0,0,1,1.38.21,7.14,7.14,0,0,0,3.87.64c3.33,0,6.66,0,10,0a3.91,3.91,0,0,0,1.86-.31,12,12,0,0,1,7.31-.18,5.67,5.67,0,0,0,2.51.46c2.48,0,5,0,7.45,0a25.56,25.56,0,0,0,6.31-.63,10.68,10.68,0,0,1,6.77.32,5.33,5.33,0,0,0,2.08.3c1.89,0,3.77,0,5.66,0,2.24-.11,4.52.14,6.75-.17a13.17,13.17,0,0,1,8.39-.14,6.64,6.64,0,0,0,2.59.29c.66,0,1.32,0,2,0,2.86,0,5.71,0,8.56,0a3.25,3.25,0,0,0,2.32-.65c2.17-.25,4.29-.56,6.33.38,1.09.5,2.58.16,3.88.23,3.1.08,6.2,0,9.3,0a3.62,3.62,0,0,0,1.4-.17,10.92,10.92,0,0,1,8.05-.07,8.81,8.81,0,0,0,2.67.22c.85,0,1.71,0,2.55,0,.52,0,1.26,0,1.27.44s-.63.51-1.19.54a24.05,24.05,0,0,0-4.11.44c-.27.06-.6.05-.77.23,2.2.64,11.22.66,13.88,0a14.21,14.21,0,0,0-3.75-.62c-.36,0-.73,0-1.09,0-.75,0-1.86.09-1.87-.52s1-.48,1.74-.51c.91-.05,1.82,0,2.74,0a7.11,7.11,0,0,0,3.21-.54c1.52-.72,6-.36,7.46.45,2.72.21,5.45-.2,8.18.08a6.05,6.05,0,0,1,2.24.34V487a7.4,7.4,0,0,1-3.16.32,24.71,24.71,0,0,0-7.2.64,14.43,14.43,0,0,0,3.56.41c1.51.06,3,0,4.55,0a4.9,4.9,0,0,1,2.25.33v3.65H412.77c-.91,0-1.82,0-2.73.05A20.72,20.72,0,0,1,402.31,492.47Z"
            />
            <path
              class="cls-14"
              d="M19.87,455.44l.25,1.18c1.88-.32,1.94-1.18,2-2,1.73,1.41,4.42,1,6.75,1.15,4.28.25,8.59-.05,12.9.13a7.6,7.6,0,0,0,3.47-.5,4.67,4.67,0,0,1,2.07,0c2.81.6,4,2.41,2.69,3.95a3.67,3.67,0,0,1-1.17,1.06.74.74,0,0,1-.66-.07c-2.4-1.83-6-1.66-9.31-1.86a1.84,1.84,0,0,0-2,1.2c-.37.58.22.86,1,1.1s1.28.42,2,.57a2.74,2.74,0,0,1,2.26,1.52c.45,1.06,1.62,1.53,3.26,1.55,1.92,0,2.82-.34,3.45-1.52a1.89,1.89,0,0,1,2.23-1.08c2,1.46,2.42,3.44,1.08,4.64-1,.15-1.54-.35-2.29-.53-1.71-.41-2.54-.31-3.58.58a4.3,4.3,0,0,1-2.58,1.08,1.31,1.31,0,0,0-1.17.59,6.51,6.51,0,0,1-1.2,2.55c-.56.57,2,1.74,3.36,1.56,2-.27,4-.51,6.05-.78a36.81,36.81,0,0,1,5.77-.41,3.54,3.54,0,0,1,2.71.89A30.75,30.75,0,0,0,65,476.78c.4.27.74.57.78.94,0,0,0,.09,0,.11-2.12,1-1.42,2,.15,3a5.15,5.15,0,0,1,1.6,1.78c.29.45.63,1-.36,1.31a2.79,2.79,0,0,1-1.39-.45,99.37,99.37,0,0,1-10.54-5.74c-1.29-.86-4.25-.62-5.18.37a2.81,2.81,0,0,1-1.34,1c-1.33.42-.95.89-.1,1.33,1.28.66,2.38,1.43,3.6,2.12.38.22.9.57.5.84s-1.14,0-1.53-.24a58.24,58.24,0,0,1-5.94-3.62c-.25-.33,0-.9-1.27-.66a2,2,0,0,1-2.08-.8,2.26,2.26,0,0,0-2.52-.58,7.39,7.39,0,0,1-1.77.2,2.92,2.92,0,0,0-2.19.81A7.37,7.37,0,0,1,31,480.21c-1.64.23-3.14.83-5,.49-.79-.15-1,.6-1.81.58-1-.41-1.18-1-.84-1.61a2,2,0,0,0,.18-1.79,2.29,2.29,0,0,1,.52-2c.75-1.26.42-1.76-1.51-2.36-3.55-1.12-5.13-3-4.57-5.42.39-.7,1.27-1.25,1.37-2.06.07-.61,1.2-.92,2.15-1,4.35-.43,5.77-4.43,4.26-6.3a.9.9,0,0,0-1.07-.4,21.33,21.33,0,0,1-4.81.44c-.75,0-1.32.36-2,.46a3.35,3.35,0,0,1-1.67-.27,6.24,6.24,0,0,0-4.52,0,1.8,1.8,0,0,1-.52,0c-2.37-1-4-2.42-6.22-3.53v-1.29a2.75,2.75,0,0,1,2.19.13c2.78,1,5.94,1.21,9,1.68C17.57,456.19,18.63,455.65,19.87,455.44Z"
            />
            <path
              class="cls-15"
              d="M24.29,481.27c.22-1,1.47-1.06,2.75-.85.8.12,1.41.3,2.09-.21a4.63,4.63,0,0,1,1.71-.27c1.92-.18,3.45-.68,4.26-1.77a2.46,2.46,0,0,1,2.44-.82h.37c2.43-.08,3.17.08,4.87,1.07,1,.61,1.7-.1,2.7-.39v1.49c.2.63.88,1.17.89,1.83a.56.56,0,0,1-.38.35c-2.44.59-4.12,1.82-6.32,2.61-.71.26-1,.57-1.05,1a1.26,1.26,0,0,1-.83,1.25l-10.91,0c-.64,0-1.38.08-1.52-.5-.08-.31-.5-.37-.95-.37H19.87c-.43,0-.93,0-1,.33-.14.63-.93.54-1.64.54l-10.18,0a6.48,6.48,0,0,0-2.12.19v-9.89a1.42,1.42,0,0,1,1.24.3c2.4,1.76,5.93,2.51,9.09,3.59.19.2.11.42.13.63,0,.61.5.72,1.42.45,1.7-.5,2.19-.35,2.84.74.36.59.35,1.25.83,1.86a3.34,3.34,0,0,0,2.19-1.81C23,482.15,23,481.45,24.29,481.27Z"
            />
            <path
              class="cls-16"
              d="M19.87,455.44c-.81.95-2.31,1-3.72.82-3.18-.46-6.52-.65-9.35-1.77a4.43,4.43,0,0,0-1.87-.34V433.51c1.29-.36,1.73,0,1.76.72,0,.32,0,.65,0,1,0,.8.53,1.11,2,.72,1.63-.44,2.31-.21,2.7.81.24.63.35,1.27.53,1.91a4,4,0,0,0,2.68,2.8c1.35.54,1.7,1.38,1,2.28s-.25,1.28,1.25,1.6c3.71.8,4.77,3.31,2.27,5.11l-.8.59c-1.29,1-1.32,1.37.29,2.15C19.88,453.81,20.3,454.52,19.87,455.44Z"
            />
            <path
              class="cls-17"
              d="M17.71,459.09a6.94,6.94,0,0,1,3.54-.65,6.66,6.66,0,0,0,3.28-.44c.68-.34,1.29-.2,1.53.29.84,1.73,1.39,3.38-.45,5.13a7.13,7.13,0,0,1-4.31,2c-1,.15-2.13.44-1.51,1.37.47.72-1.51.69-1.36,1.36-.21.43-.61.62-1.29.31a2,2,0,0,0-2.4.34,6,6,0,0,1-4.26,1.34,3.28,3.28,0,0,1-1.69-.31,10.26,10.26,0,0,0-3.86-1.46V461c1.28-.63,2.4-1.48,4.42-.95a.85.85,0,0,0,.92-.41c.22-.29.32-.62.88-.78l.35,0c.6-.22,1.5-.41,1.86-.11C14.67,459.85,16.22,459.21,17.71,459.09Z"
            />
            <path
              class="cls-18"
              d="M442.86,469v9c-.09.05-.25.12-.3.09-1.57-.79-2.82-.19-4.1.31a1.88,1.88,0,0,1-.67.16,7.26,7.26,0,0,0-5.18,2,2.24,2.24,0,0,1-2.22.67c-.43-.24-.27-.6-.54-.93a2.48,2.48,0,0,1-3.1-.72,9.59,9.59,0,0,0-1.51-1.17c-.15-.35.13-.63.46-.89s.44-.55-.22-.77c-1.17-.4-.9-1-.28-1.47,1-.79,1.25-1.53,0-2.32-.48-.31-.4-.67.11-1a2,2,0,0,0,1-1.67c.12-.82.77-1.43,2.19-1.66a3.72,3.72,0,0,0,1.76-.72c1.85-1.4,3.37-1.55,5.89-.58.4.16.78.35,1.17.51a3,3,0,0,1,.5.31c.6.43.92,1,1.79,1.3,1.12.35,1.58-.5,2.49-.59A1.6,1.6,0,0,1,442.86,469Z"
            />
            <path
              class="cls-19"
              d="M4.93,468.34c1.49,0,2.83.07,3.68,1,.61.68,3,.72,4.29.15a5.84,5.84,0,0,0,1.48-.93c.87-.75,1.71-1.27,3-.3.48.35.67-.07,1-.15-.21,1.2-.57,2.42,1.49,3.27.12.05.24.2.19.27-.59.93.63,1.06,1.63,1.32,3.52.89,3.8,1.26,2.54,3.39a1.65,1.65,0,0,0-.15,1.77c.2.35.33.88,0,1.14-.88.73-.33,1.34.14,2a2.79,2.79,0,0,0-1.06,1.21,9.38,9.38,0,0,1-.73,1.2A2.84,2.84,0,0,1,20.3,485c-.72,0-.46-.91-.75-1.39s-.38-.89-.63-1.32c-.34-.6-.91-.7-1.7-.22a1.66,1.66,0,0,1-1.81.32c-.77-.35-.78-.76-.36-1.23.08-.09.06-.21.09-.31a9.72,9.72,0,0,0-1-2.88c-.38-.61.29-1.17.78-1.7.76-.83,2.06-1.4,2.91-2.18s.66-1.3-.71-1.64a18.9,18.9,0,0,0-7.64.06c-.61.1-.8.52-1.21.77a4.05,4.05,0,0,1-3.33.91Z"
            />
            <path
              class="cls-20"
              d="M430.51,481.24A3.74,3.74,0,0,0,433,479.9a4.64,4.64,0,0,1,3.52-1.44,6.89,6.89,0,0,0,3.09-.79c1-.62,1.76-.68,2.5.14.11.11.52.13.8.2v8.6c-3.65-.2-7.31,0-11,0,.88-1.62-.43-2.93-1.76-4.24C429.72,481.92,429.7,481.53,430.51,481.24Z"
            />
            <path
              class="cls-21"
              d="M430.48,456.26a17.68,17.68,0,0,0,8.27-1c1.18-.42,2.81-.3,4.11-.7v12c-1.63.34-3.31,0-4.95.14-1.1-.33-1.2-1-1.63-1.58a3.14,3.14,0,0,0-2-2.16c-.76-.3-1-.77-.87-1.31.69-.86,1.49-1.68,1-2.72a1.91,1.91,0,0,0-1.76-1.18,6.42,6.42,0,0,1-2.07-.54C430,457,429.92,456.6,430.48,456.26Z"
            />
            <path
              class="cls-22"
              d="M4.93,474.14c1.44-.29,2.9-.56,3.43-1.56a1.22,1.22,0,0,1,.79-.41,21,21,0,0,1,8.21,0c1.75.44,2.05,1.13.94,2s-2.07,1.5-3.05,2.27-1.06,1.4-.35,2.12a1.64,1.64,0,0,1,.24,2.26,1.77,1.77,0,0,1-1.44-.07c-3.06-1.16-6.43-2.06-8.77-3.8Z"
            />
            <path
              class="cls-23"
              d="M16.2,487.05a2.36,2.36,0,0,0,1.75.4c.63,0,.82.23.81.57s-.18.45-.72.49a72.67,72.67,0,0,1-13.11,0v-1.29l.78-.2A94.12,94.12,0,0,1,16.2,487.05Z"
            />
            <path
              class="cls-16"
              d="M11.15,458.89a4.49,4.49,0,0,1-.44,1c-.34.48-.74.9-1.85.46a2,2,0,0,0-2.27.24c-.38.44-1,.44-1.66.43v-5.59c1.8.12,2.33,1.17,3.54,1.73A20.13,20.13,0,0,1,11.15,458.89Z"
            />
            <path
              class="cls-24"
              d="M442.86,488.76a98.57,98.57,0,0,1-10.32-.24c-.64-.07-1-.15-1-.58s.42-.41.94-.5a56.13,56.13,0,0,1,10.38-.4Z"
            />
            <path
              class="cls-25"
              d="M437.74,466.6a16.59,16.59,0,0,1,5.12,0V469c-.37.12-.78.21-1.11.35-2.06.91-2.06.91-3.47-.32-.33-.29-.65-.59-1-.89C436.77,467.55,437,467.05,437.74,466.6Z"
            />
            <path
              class="cls-26"
              d="M380.06,452.86c.16.15.27.37.5.44,2.68.75,3.08,2.25,3.84,3.71.55,1.05,1,2,.47,3.12-.32.63,2.35,2.95,3.4,3a1.52,1.52,0,0,0,1.12-.47,7.45,7.45,0,0,1,4.84-1.11,8.53,8.53,0,0,0,4.47-1c2-1,2.39-.94,4.34,0-.36,1.1-1.9,1.44-3.39,1.65a20.06,20.06,0,0,0-4.19,1,10.67,10.67,0,0,1-4.42.37c-2-.11-2.35,0-2.79,1.15a2.05,2.05,0,0,1-1.57,1.23,2.62,2.62,0,0,0-2,1.55,16.34,16.34,0,0,1-.8,1.77,3.46,3.46,0,0,1-2.58,1.68c-1.39.27-1.89.81-1.81,1.63a1.37,1.37,0,0,1-.8,1.49c-1.2.62-1.1,1.29-.28,2a1.28,1.28,0,0,1,.45.69c-.08.63-1.28.68-1.67,1.14-.36.3-.22.72-.73,1-1.14.12-1.09-.39-1.19-.8-.14-.57.35-1.12.17-1.77-.93.08-1.76.57-2.74.22a3.84,3.84,0,0,1-1.65-1.26,2.43,2.43,0,0,0-2.71-.53,3.83,3.83,0,0,1-1.39.23,5.64,5.64,0,0,0-4.89,1.73,6.82,6.82,0,0,1-5.23,1.55c-.35-.2-.14-.39,0-.58a7.14,7.14,0,0,1,2.09-4,.4.4,0,0,0,.06-.43c-.53-1.23.76-1.93,2.15-2.62s1.44-.71-.11-1.35a4.59,4.59,0,0,1-1.81-1.33,4.74,4.74,0,0,0-1.25-1.18,3,3,0,0,0-2.92-.19,10.41,10.41,0,0,1-4.56.92,4.81,4.81,0,0,0-2.45.62,2.37,2.37,0,0,1-2.89-.19,4.73,4.73,0,0,1-1.56-1.43c.58-1.54-.53-2.93-1.05-4.37a3.37,3.37,0,0,1-.2-.49c-1-1.78-.5-2.31,2.64-2.87,1.8-.31,3.53-.63,3.94-1.92,0-.13.22-.25.38-.36,2.9-1.88,1.93-4,1-6.08-.35-.79-1.28-.56-2.17-.32a20.69,20.69,0,0,1-7.08.36c.05-.35.55-.46,1-.57.83-.21,1.11-.55.78-1s0-1,.87-1.22c1.42-.39,1.81-1.09,1.73-1.94s.29-1.32,1.9-1.29a2.3,2.3,0,0,0,2.3-1.15c.29-.51.66-.94,1.82-.7.88.19,1-.24,1.17-.57a1.62,1.62,0,0,1,1.9-.72,3.79,3.79,0,0,0,3.36-.9c1.36-1.14,2.59-2.34,3.91-3.49.39-.34.75-.87,1.57-.77s.7.68.89,1.07.19.49.31.73c.34.68.89.84,2,.39,1.61-.67,2.18-.57,3,.49.47.62.8,1.27,1.22,1.9a4.93,4.93,0,0,0,3.24,2.19c1.45.36,2,1.06,1.84,2-.09.45-.37.93.26,1.34-.22.88-1.38,1.47-2.11,2.17-.44.43-.32.51.07.8s1.81.71,1.16,1.26-1.71.08-2.54-.06a43.6,43.6,0,0,0-4.86-.36c-.41,0-.95-.12-1.13.17s.37.4.72.5a24.71,24.71,0,0,0,7.27,1.21A13.91,13.91,0,0,1,380.06,452.86Z"
            />
            <path
              class="cls-27"
              d="M292.1,437.15c1.4-.17,1.2.55,1.41,1,.67,1.33.65,1.36,2.73.76a1.57,1.57,0,0,1,1.79.37,11.69,11.69,0,0,1,1,1.49,5.39,5.39,0,0,0,3.7,2.76c1.32.31,1.68,1.08,1.4,1.91s.2,1.15,1.62,1.29c3.54.35,5.2,2.51,3.5,4.38-1.47,1.62-1.5,1.64,1.05,2.68,1.59.65,1,1.7,1.54,2.53s.63,1.63-.52,2.33a15.49,15.49,0,0,1-6.9,2.2,5.39,5.39,0,0,0-1.63.46,11,11,0,0,1-5.06.64c-1.46-.15-2.37.11-2.64,1a2.64,2.64,0,0,1-2.14,1.62,2,2,0,0,0-1.48,1.16c-.23.52-.46,1-.71,1.55a4.21,4.21,0,0,1-3.23,2.17c-1.07.23-1.62.62-1.36,1.3s0,1.41-1.16,1.89c-.7.3-.69.71-.44,1.16s.79.89.83,1.41c-.61.65-1.77,1-2.42,1.65-1,.21-2.4-.35-2.94.13a8.84,8.84,0,0,0-2.08,2.22,5.3,5.3,0,0,1-2.47,2.69,2.63,2.63,0,0,1-1.67.54c-.83-.11-.73-.6-.87-1a17.2,17.2,0,0,0-.83-2.19c-.31-.6-.81-.88-1.8-.37a2.35,2.35,0,0,1-1.79.33c-.61-.59.31-.81.81-1.1.69-.4,1.58-.67,2-1.22.54-1.38,1.86-2.62,1.8-4.1,0-.72,1-1.16,1.93-1.6,2-1,2-1.43,0-2.36a18.55,18.55,0,0,1-1.71-1c-.68-.4-1.14-.85-.59-1.43.37-.39.09-.66-.4-.93a1.92,1.92,0,0,0-1.49-.05,11.73,11.73,0,0,0-3,.91,20.58,20.58,0,0,1-3.6.14,9.29,9.29,0,0,0-5.13,1.28,1,1,0,0,1-1.13-.65c-.2-1.16.32-2.34-.39-3.49-.14-.24-.09-.53.31-.68a1.55,1.55,0,0,1,1.29.21,6.81,6.81,0,0,0,7.37-.28c1-.65,1.8-1.56,3.67-.78.15.06.47,0,.51,0,.45-.81,2.16-1.21,2.07-2.14s.59-1.34,1.86-1.63c.79-.19,1.57-.38,2.38-.54a3.11,3.11,0,0,0,2-1,2.78,2.78,0,0,1,.71-.75c2.48-1.61,1.85-3.44,1.08-5.27-.38-.91-.9-1.06-2.37-.59a17.75,17.75,0,0,1-5.35.34c-.36,0-.7-.12-.77-.37.43-.5,1.11-.93.91-1.58-.11-.33.28-.61.72-.82,1.23-.6,2.05-1.31,2-2.29a.57.57,0,0,1,.59-.61c2-.12,2.8-1.14,4.07-1.8,1,.08,2,.3,2.25-.64.08-.34.71-.55,1.27-.47a4.62,4.62,0,0,0,4.31-1.5c.46-.42,1.06-.78,1.27-1.29,0-.3.28-.48.63-.66l1.07-.91A1.42,1.42,0,0,1,292.1,437.15Z"
            />
            <path
              class="cls-28"
              d="M48.71,460.39a10.1,10.1,0,0,1,.84-1.17c1.32-1.4.29-3.05-2.27-3.57-.38-.92,1-1,1.82-1.12A7.14,7.14,0,0,0,53,452.59c1.48-1.35,1.21-2.69.68-4.1-.23-.61-.75-.86-1.81-.55a9.73,9.73,0,0,1-3.2.25c-.55,0-1.29.05-1.37-.48a5.19,5.19,0,0,1,2.4-2.57c.23-.13.1-.48.13-.72s0-.49.11-.52a15.34,15.34,0,0,0,4.18-1.81c.34-.18,1.1-.16,1.32-.6a1.1,1.1,0,0,1,1.13-.42A3.92,3.92,0,0,0,60,439.85c.82-.7,1.55-1.45,2.35-2.16a1.45,1.45,0,0,1,1.2-.57c.54.06.53.44.63.72.28.82.59,1.57,2.36.7a1.28,1.28,0,0,1,1.27.18c.11.08.25.17.29.27a7.88,7.88,0,0,0,5,4c.41,1.19,1.54,1.95,3.58,2.28a.94.94,0,0,1,.84,1,2.48,2.48,0,0,1-.82,3.13c-.7.52,0,1,.73,1.22a2.39,2.39,0,0,1,1.91,1.67c.38,1.17,1.22,2.23.77,3.53-.25.71,1.32,1.44,2.47,2a.84.84,0,0,0,.48,0c1.5-1.4,4-1.06,6.2-1.26.55.77.56,1.49-.52,2.13a15.79,15.79,0,0,1-6.7,2.19,5.83,5.83,0,0,0-1.64.44,11.07,11.07,0,0,1-5.38.6c-1.48-.19-2.34.14-2.55,1-.18.72-.72,1.26-2,1.53a1.89,1.89,0,0,0-1.44,1,1.73,1.73,0,0,1-.81,1.06,3.26,3.26,0,0,1-2.51.06,2.46,2.46,0,0,0-1.86-.08c-1.85.95-4.14,1-6.39,1.21-.89.24-1.42.86-2.55.85-1.81-.32-2.62-1.11-2.89-2.15a2.61,2.61,0,0,0-.1-3.06c-.28-.5-.64-1-1-1.46C49.81,461.59,48.4,461.43,48.71,460.39Z"
            />
            <path
              class="cls-29"
              d="M258.2,467.05l.74.64a3.59,3.59,0,0,0,2.52-.19,6.44,6.44,0,0,1,4.4-.51c.16.51-.56.48-1,.56-1.19.2-1.6.67-1.24,1.31a21.9,21.9,0,0,0,6,6.48,5.57,5.57,0,0,0,1.43.45,1.74,1.74,0,0,1,.68,1.15c-.11.71-1.2.9-1.94,1.29a12.34,12.34,0,0,0-1.31.86,6.39,6.39,0,0,1,2.06,1.52c0,1.07-.74,1.33-2.32.76-2.28-.83-3.66-2.18-5.43-3.3-.41-.26-.77-.55-1.18-.82a3.79,3.79,0,0,0-2.58-.43,11.54,11.54,0,0,0-5.51,2.05c-.65.4,0,.58.32.77,1.91,1.15,3.87,2.28,5.78,3.43.54.32,1.25.59,1.28,1.12a.7.7,0,0,1-.41.17,3.19,3.19,0,0,1-1.78-.66c-1.93-1.13-3.86-2.25-5.76-3.4a7.39,7.39,0,0,0-2.49-1c-.32-.19.09-.8-1-.54a2.15,2.15,0,0,1-2.16-.65,3.44,3.44,0,0,0-1.95-1,8.84,8.84,0,0,1-3.34-1.78,1.5,1.5,0,0,0-2,0,5.12,5.12,0,0,1-3.54.83c-.57,0-1.13-.16-1.17-.55s.49-.48,1-.55c1.06-.18,2.1-.36,2.47-1.15-.59,0-.73.24-1,.39-2.41,1.38-6.09.89-7.25-1a2.81,2.81,0,0,1-.26-.52c-.18-.52-.21-1.09-1.51-1.12s-2.18.08-2.61.84a.65.65,0,0,1-.22.17c-.73.12-.94-.17-1.11-.49.19-.57-.59-.88-1-1.28-.87-.77-.6-1.63-.61-2.48.17-.89,1.33-1.55,1.52-2.47.11-.53,1.26-.71,2.11-.9,3-.68,4.76-2.16,4.75-4.06a4.26,4.26,0,0,0-.09-1.07c-.38-1.5-.52-1.54-3-1.24a9.74,9.74,0,0,1-3.57-.09,1.62,1.62,0,0,1,.81-2.21,2.11,2.11,0,0,0,1.24-1.68c.7-.92,2-1.11,3.53-1a7.85,7.85,0,0,0,2.35.53,130.71,130.71,0,0,0,14.68,0c1.06-.07,2-.62,3.13-.31-.56,1.46-.41,1.57,2.21,1.71,2.31.14,3.8,2.05,2.7,3.47a2.35,2.35,0,0,1-1.39.94c-1.28,0-1.92-.69-3-.89a54.27,54.27,0,0,0-6-.75c-1.67-.11-2.25.18-2.93,1.19s.31,1.25,1.39,1.59c.11,0,.21.07.32.09,2.37.4,4.52.91,5.7,2.39.53.67,1.86.85,3.19.61a2.92,2.92,0,0,0,2.45-1.57c.18-.44-.05-.94.62-1.3,1.27.11,1.34.75,1.48,1.29.32,1.16,1.36,2.28.72,3.53C257.75,466.48,258.16,466.76,258.2,467.05Z"
            />
            <path
              class="cls-30"
              d="M311.1,458.44c1.15-.61.28-1.47.77-2.17,1.73.35,1.77-.39,1.87-1s-.2-1.22,1.39-1.1a5.5,5.5,0,0,0,2.79.9,157.05,157.05,0,0,0,18.79,0c.8,0,1.52.24,2.28.34,1.56.23,2.55.8,2.84,1.73.33,1.08.49,2.15-1.41,2.85a31,31,0,0,0-8.48-1.59c-1.56-.13-2.49.11-3.17,1-1.28,1.63-1.35,1.61,1.37,2.42a32.92,32.92,0,0,0,10.24,1.09,7.84,7.84,0,0,0,2.49-.79c.75,1.47,2,2.91,1.07,4.52-.87.12-1.28-.32-1.88-.53-1.89-.67-2.84-.58-4.23.43a3.18,3.18,0,0,1-1.58.85c-1.75.18-2.2.9-2.33,1.77s-.5,1.33-1.78,1.67a7.26,7.26,0,0,0,1.62.41c1.16-.05,1.44.35,1.6.9.22.76,1,1.12,2.33,1a2.35,2.35,0,0,0,1.89-.72c.3-.47-.18-.81-.64-1.16s-1.85-.58-1-1.15,1.6.14,2.29.42c1.3.53,2.44,1.18,3.62,1.8a5.51,5.51,0,0,0,4,.46,2.71,2.71,0,0,1,2.77.55c1,1,2.4,1.9,3.45,2.9a9.16,9.16,0,0,0,3,1.54l-.35.39c-1,.7-1,1.3.09,2s1.92,1.38,1.92,2.34c-.74.87-1.77.6-2.7.19a61.31,61.31,0,0,1-9.26-4.73,4.37,4.37,0,0,0-5.21.35,3.24,3.24,0,0,1-4.48.43.79.79,0,0,0-.63-.15,2.63,2.63,0,0,1-2.85-.65,2.4,2.4,0,0,0-2.57-.54,7.42,7.42,0,0,1-1.78.17,2.45,2.45,0,0,0-2.14.81c-.85,1.07-2.39,1.57-4.3,1.74a4,4,0,0,0-2,.49,1.57,1.57,0,0,1-1.31.18,4.36,4.36,0,0,0-3.5.46c-1.14-.37-1.17-1-.88-1.59a2.84,2.84,0,0,0,.23-1.89,2.8,2.8,0,0,1,.41-2c.68-1.2.32-1.86-1.65-2.34-3.65-.89-4.2-2.76-4.65-4.7a1.51,1.51,0,0,1,.89-1.36c.37-.21.65-.45.54-.76-.35-.94.64-1.37,1.91-1.51,4.25-.48,6.48-4.12,4.69-6.34-.44-.55-.94-.5-1.73-.34A9.1,9.1,0,0,1,311.1,458.44Z"
            />
            <path
              class="cls-31"
              d="M88.51,458.45c1.08-.55.25-1.33.71-1.95l1.88-.84c5.18.86,10.5.75,15.8.75a2.33,2.33,0,0,0,1-.15c1.24-.81,2.47-.48,3.75-.06a26.24,26.24,0,0,0,4.77.65c1.17.15.73-.62,1.28-.84,1.72,1.28,1.67,2.59.23,3.93-1.65-.22-2.91-1-4.66-1.11-1.08-.07-2.13-.27-3.21-.37-2.82-.25-2.83-.25-4.12,1.18a4.45,4.45,0,0,1-.6.53c-1.4,1-1.41,1.21.49,1.84a29.91,29.91,0,0,0,13.32,1.4c.62-.08,1.29-.35,1.71.19.85.83,1.13,1.68.39,2.59a2,2,0,0,1-1.52,0c-2.84-.67-2.85-.67-5,.7a3.51,3.51,0,0,1-1.49.59c-1.21.15-1.65.63-1.82,1.3a2.22,2.22,0,0,1-1.1,1.77c-.25.14-.27.33,0,.48a3.45,3.45,0,0,1,1.42,1.71c.23.5,1,.45,1.67.39,2.21-.22,4.4-.51,6.6-.78a14.83,14.83,0,0,1,5.36-.17,2.13,2.13,0,0,0,1.93-.59,1.71,1.71,0,0,1,1.46-.51c.78.15.56.58.48.92-.23,1,.53,1.65,2.07,2,1.05.25,1.67.53.48,1.11-.94.45-.32.91.06,1.33s1.46,1,1.69,1.64c-.79.85-.31,1.47.72,2.19s2.16,1.47,2.16,2.52a2.26,2.26,0,0,1-2.63.26c-2-.92-4-1.82-6-2.78a1.69,1.69,0,0,1-1-1.12c-.17-.8-1-1.38-1.83-1.93a2.41,2.41,0,0,0-2.77-.24,3.53,3.53,0,0,1-1.39.22,7.49,7.49,0,0,0-3.66,1.07,2.57,2.57,0,0,1-2.39.35,1.91,1.91,0,0,0-.89,0A2.55,2.55,0,0,1,111,478a2.34,2.34,0,0,0-2.55-.55,4.8,4.8,0,0,1-1.42.15,3,3,0,0,0-2.7,1,5,5,0,0,1-3.22,1.45c-1.1.18-2.31.15-3.14.74a1.35,1.35,0,0,1-1,.05,4.4,4.4,0,0,0-3.51.46c-1.07-.33-1.18-.93-.9-1.48a3.49,3.49,0,0,0,.23-2.22,2.73,2.73,0,0,1,.44-1.78c.65-1.18.35-1.83-1.49-2.29-3.84-.95-4.53-2.86-4.79-5a1.47,1.47,0,0,1,.87-1.14c.35-.2.67-.43.55-.75-.36-.93.63-1.27,1.86-1.54,4.4-1,6.28-3.29,4.93-6-.34-.69-.82-.9-2.09-.64A8.85,8.85,0,0,1,88.51,458.45Z"
            />
            <path
              class="cls-32"
              d="M148.32,458.65c.44-.37.94-.7.75-1.23s.24-.67,1-.72a38.84,38.84,0,0,1,4.31.19c1.7,0,3.22-.62,4.76-.57s2.82.9,4.53.89c2.54,0,5.08-.08,7.63.06,1.71.09,3.34.33,5,.56a3.24,3.24,0,0,1,1.51.56c.32.24.5.51.25.8s-.68.26-1.11.25a38.26,38.26,0,0,1-4.46-.51,29,29,0,0,0-3.4-.39,3.25,3.25,0,0,0-2.81.93,5.2,5.2,0,0,1-1.48,1.21c-1.24.75-1.21.93.34,1.54a29.34,29.34,0,0,0,15.8,1.52c1.56.48,1.08,1.33,1.1,2.09a.94.94,0,0,1-.14.33c-.37.49-.91.55-1.75.32-3.13-.86-2.89-.66-5.44.48-2,.9-3.28,1.81-3.93,3.25-.29.67-.77,1.13-.07,1.81s.09,1.24-.54,1.79c-.4.36-1,.7-.52,1.16s1.25.36,2,.39c1.41.06,2.76-.23,4.16-.22a22.74,22.74,0,0,1,3.61.21,8.47,8.47,0,0,0,5.31-.46,2.17,2.17,0,0,1,2.46.39c2,1.63,4.4,3,6.48,4.62.81,1.36.09,2-2.34,2.13a65,65,0,0,1-6.62-3.64,4.73,4.73,0,0,0-5.82.3,3.11,3.11,0,0,1-4.39.14.94.94,0,0,0-.68,0,2.15,2.15,0,0,1-2.65-.5c-.61-.78-1.46-.89-2.81-.64-2.4.45-2.93.58-4.54,1.63a3.52,3.52,0,0,1-1.58.7c-2.33.25-4.42,1.24-7,.79a2,2,0,0,0-1.58.39c-1.63,0-1.36-.68-1.13-1.16a2.85,2.85,0,0,0,.19-2.21c-.2-.62.2-1.19.55-1.76.75-1.27.51-1.73-1.58-2.31-3.61-1-4.6-2.86-4.87-5a1.54,1.54,0,0,1,.93-1.12c.41-.23.72-.49.64-.84-.18-.86.65-1.28,1.89-1.44,4.3-.58,6.32-4,4.77-6.25-.45-.65-1.07-.62-2-.42A8.41,8.41,0,0,1,148.32,458.65Z"
            />
            <path
              class="cls-33"
              d="M437.74,466.6c-.14.51-.29,1-.43,1.52-1.18-.25-2-.87-3.34-1s-2.28,0-2.9.72a3.52,3.52,0,0,1-2.71,1.21c-1.22.1-1.56.82-1.55,1.51a1.45,1.45,0,0,1-1.17,1.67c-.81.27-.34.51.07.74,1.32.71,1.26,1.46.19,2.25-.92.67-1.59,1.28.63,1.53.89.1.45.39.11.6a2.8,2.8,0,0,0-1.26,1.15c-.43.76-1.59.81-2.65.86a3.1,3.1,0,0,0-2.43.94,5.54,5.54,0,0,1-3.84,1.6c-1.79.17-3.38.95-5.36.54-.65-.13-1,.34-1.44.56-1.35-.23-1.6-.86-1.3-1.51a3.09,3.09,0,0,0,.17-2.11c-.15-.69.35-1.33.68-2,.53-1,.28-1.58-1.38-2-3.92-1.06-5-3-4.87-5.29.25-.87,1.32-1.55,1.54-2.46.13-.53,1.27-.73,2.16-.85,4.33-.59,5.62-4.26,4.09-6.3-.39-.52-1-.37-1.66-.25a9.76,9.76,0,0,1-4.89,0c.49-.32,1-.53.78-1.15s1.4-.92,2-1.45c3.44.06,6.86.38,10.31.36a8.16,8.16,0,0,0,4-.53,2.11,2.11,0,0,1,1.54.06c3,.85,6.33.51,9.47.83.92.1.45-.47.75-.69,1.69.46,2.62,2,1.81,3a11.14,11.14,0,0,1-1.09,1.08c-1.86-.27-3.36-1.06-5.34-1.21-1.19-.09-2.38-.25-3.58-.36a2.62,2.62,0,0,0-2.61.85,3.16,3.16,0,0,1-1.22,1.18c-1.08.56-.7.94.32,1.33a30.74,30.74,0,0,0,13.93,1.7,3.35,3.35,0,0,1,1.41-.05Z"
            />
            <path
              class="cls-34"
              d="M227.17,454.8a1.24,1.24,0,0,1-.78,1.44c-.73.37-1.62.73-1.13,1.49.11.17-.41.47-.64.72a8.34,8.34,0,0,1-4.65,1.86c-2.42-1.38-4.74-2.81-7.15-4.19,1.9,1.12,3.82,2.24,5.71,3.37.45.28,1.31.54.49,1.05-1,.3-2.11.54-3.1.9a11.48,11.48,0,0,1-5.11.43c-1.43-.14-2.27.21-2.41,1s-.68,1.22-1.88,1.55c-1.37.37-1.52,1.22-1.89,2-.44.94-.63,2-2.52,2.44-1-.11-1-.61-.92-1,.08-1-.8-1.52-2.28-1.81a15.75,15.75,0,0,1-2.15-.59c-.62-.21-1.08-.53-.95-1,.2-.65-.3-1.09-.94-1.54-1.59-1.12-1.53-2.84.14-4,.4-.28.88-.5.67-.92-.39-.75.35-1.14,1.31-1.45a2.61,2.61,0,0,1,.66-.19c3.19-.22,4.37-1.74,5.71-3.12,1.51-1.55.43-3.05-.47-4.54-.16-.26-.62-.32-1.08-.24a4.28,4.28,0,0,1-1.6.13c-1.12-.63-2.66-1.06-3-2.08l1.53-.82c.28-.29.09-1,1.1-.71,1.89.5,3.84.2,5.75.31,2.65.15,5.34.51,8,.42,4.09-.14,8.24.21,12.27-.47a2.73,2.73,0,0,0,1.12.21c2.44.17,3.1.69,3.68,2.05.49,1.14-.18,2.05-1.29,2.92a29.48,29.48,0,0,0-7.38-1.65c-.47-.06-.94-.13-1.43-.17-3.15-.23-3.52-.11-5,1.53s-1.49,1.69,1.45,2.57a31,31,0,0,0,7.65,1.3A4,4,0,0,1,227.17,454.8Z"
            />
            <path
              class="cls-35"
              d="M147.26,468.77a2.43,2.43,0,0,0,1.74,2.77c.09,0,.27.12.25.14-.85,1.54,1.65,1.37,2.77,1.78,2.23.81,2.71,1.26,1.68,2.69a1.93,1.93,0,0,0-.33,2.27c.28.49,0,1-.37,1.45s-.54.89.51,1.13c.67.07.58.36.36.56a21,21,0,0,0-2,2.62,3.93,3.93,0,0,1-1.08.84c-1.16.63-1.81.51-2.27-.4-.28-.55-.36-1.12-.66-1.66a.84.84,0,0,0-1.16-.42,3.21,3.21,0,0,1-2.79,0c-1-.64-.39-1.25,0-1.88.08-.14,0,0,0-.11a1.17,1.17,0,0,0-.2-1.55c-.91-1-.56-1.92.56-2.79.77-.6,1.66-1.13,2.41-1.74,1.13-.94.82-1.66-1-2a21.92,21.92,0,0,0-6.47,0,1.88,1.88,0,0,0-1.41.77,15.12,15.12,0,0,1-1.9,2.43c-.31.33-.44.66-.22,1s.33.7-.13,1c-.65.25-1.1.84-2.16.49-.62-.48-1.29-.94-1.88-1.44-1.23-1-1.09-1.49.78-2.21-3-.47-4.36-1.5-3.31-3.26-.66-.12-.85.07-1,.25a2.93,2.93,0,0,1-3.61.73,4.11,4.11,0,0,0-1.78,0c-3.06.4-6.12.8-9.19,1.17-1.28.15-2.31.08-2.26-1,0-.79-1-1.25-2.13-1.76,2.21-.42,1.77-1.56,2.11-2.44.24-.61.59-1,1.7-1a2.77,2.77,0,0,0,1.88-.75c1.78-1.4,2.64-1.52,5.14-.66a3.62,3.62,0,0,0,1.49.33c.31.83,1.31,1.4,2.22,2a1.08,1.08,0,0,0,1.34-.09,7,7,0,0,1,3-1.07,14.14,14.14,0,0,0,4.25-.84,4.71,4.71,0,0,1,2.46-.12c1.73.28,3.8.15,3.86,1.81,0,.52,1.34,1,2.21,1.36a1.61,1.61,0,0,0,1.75-.16c.57-.55-.39-.57-.86-.69-1.78-.44-2.94-1.17-3.06-2.32s.92-1.74,2.29-2.3a4.93,4.93,0,0,1,2.6-.27c.89.13,1.88.23,2.19.83s-.52.84-1,1.17-1.31.75-1.9,1.16c-.2.14-.37.31-.21.49a1.1,1.1,0,0,0,1,.17,2.16,2.16,0,0,0,1.92-1.3c.14-.32.14-.82,1-.75s.66.53.71.88a.8.8,0,0,1-.16.74C146.1,467.6,146.57,468.19,147.26,468.77Z"
            />
            <path
              class="cls-36"
              d="M200.18,448.55c3-.57,2.91-.55,3.89,1.34.86,1.66.21,3-1.18,4.51-1.22,1.36-2.85,1.84-5,2.27-1.23.25-2.72.56-1.53,1.66a.26.26,0,0,1-.14.47c-2.17.35-1.5,1.6-2.13,2.41-.75,1,1.09,1.47,1.91,2.11.34.27.78.34.36.75-.59.58-.2,1,.86,1.26.28.06.53.18.82.23,2.5.39,4.17,1.12,3.61,2.86,0,.1.21.24.33.36-.41.74-1.62.63-2.54.83a2.67,2.67,0,0,1-1.64-.36c-1.14-1-2.55-1.88-3.07-3.09-.15-1.09-.73-1.54-2.58-1.72a35.71,35.71,0,0,0-6.7,0,3,3,0,0,0-2.11.91,1.54,1.54,0,0,1-1.79.61c-.17-.73.41-1.55-.75-2.17a10.23,10.23,0,0,0-3.09-2.81c-.68-.35-.56-.94,0-1.47,1.36-1.28.68-2.65-1.57-3.43-.56-.19-1.28-.34-.82-.87a1.67,1.67,0,0,0,1.49-1.46c.28-1.35,1-1.72,3.23-1.48a13,13,0,0,0,6.56-.81,4.49,4.49,0,0,1,1.63-.45,14.2,14.2,0,0,0,6.78-2.05A10,10,0,0,1,200.18,448.55Z"
            />
            <path
              class="cls-37"
              d="M258.2,467.05c-1.11-.38-.64-1-.67-1.53a5.42,5.42,0,0,0-1.89-4c-1.72-.14-2.09-.46-1.83-1.52,2.29-1.68,1.85-3.36-1.12-4.31,1.06-1.91,1.06-1.94,4.42-1.68a11.85,11.85,0,0,0,5.66-.76,10.51,10.51,0,0,1,3.85-.82c2.23-.09,3.58-1.07,5.09-1.87.32-.09,0-.58.72-.4,2.11.15,4.25.4,6.2-.37,1.35-.53,2.08-.26,2.54.58a7,7,0,0,1,.74,4c0,.62-1.06,1-1.35,1.47-1,1.7-3.23,2.37-5.86,2.81-1.29.22-1.85.64-1.3,1.43a.27.27,0,0,1,.06.1,12.26,12.26,0,0,1-2.69,2.43,1,1,0,0,1-.81-.12c-1.17-.89-1.74-.35-2.53.28a8.69,8.69,0,0,1-7,1.51c-1.06-.24-1.31-1-2.73-1.32A4.72,4.72,0,0,1,258.2,467.05Z"
            />
            <path
              class="cls-38"
              d="M404.2,460.16c1.91,0,3.88.22,5.65-.47.75-.28,1.11,0,1.28.42.73,1.76,1.36,3.39-.62,5.19a7.66,7.66,0,0,1-4.21,1.81c-1,.18-2.16.46-1.49,1.37.22.31-.09.56-.58.7-.66.18-.83.49-.8.87a1,1,0,0,1-1.21.13,2.13,2.13,0,0,0-2.54.34,5.23,5.23,0,0,1-3,1.27,5.3,5.3,0,0,1-3.76-.71,5,5,0,0,0-3.62-.66c-.9.1-1.59.35-1.75.94-.07.25-.06.59-.4.7-2.57.81-2.74,3-5.82,3.5-1.09.18-.54.67-.39,1.06a2.27,2.27,0,0,1-2.27.33,13.66,13.66,0,0,1-1.23-1.32c-.35-.5-.61-1.11.39-1.43,1.21-.39,1.35-1,1.19-1.64-.23-1,.29-1.59,2-1.8a2.78,2.78,0,0,0,2.38-1.47c.38-.75.71-1.51,1.06-2.27.16-.35.32-.83.85-.91,2-.29,2.48-1.12,2.8-2.17.19-.64,1.3-.84,2.34-.69a10.46,10.46,0,0,0,6-.67,5,5,0,0,1,2-.48,7.79,7.79,0,0,0,4.61-1.48Z"
            />
            <path
              class="cls-39"
              d="M175.36,455.24c0,.27.23.46.67.58,3.08.85,3.83,2.11,2.09,3.82-.69.68-.45,1.29.42,1.58a2.89,2.89,0,0,1,2.29,2.6,3.16,3.16,0,0,1-2.19.63,32.2,32.2,0,0,1-14.44-2.2c-1.52-.66-1.51-.89,0-1.64.55-.28,1.19-.55,1.39-1,.72-1.56,2.08-1.57,4.92-1.3,2.2.22,4.31.71,6.54.84.3,0,.6.14.77-.09s0-.35-.22-.49a3.37,3.37,0,0,0-1.55-.54,72.23,72.23,0,0,0-11.05-.53c-1.73.07-3.95.23-5.26-.92-.38-.33-.76-.08-1.1,0a16.53,16.53,0,0,1-8.58.09,1.54,1.54,0,0,0,1.09-1.62c0-.49.28-.87,1.22-.86a2.07,2.07,0,0,0,2-.87,1,1,0,0,1,1.29-.54c.11,0,.32.05.34,0,1.46-1.4,5.37-1,6.16-2.9.15-.37.63-.69,1-1s.76-1.06,1.69-1,.68.74.92,1.15.68.84,1.65.42a1.6,1.6,0,0,1,2.22.48c.44.62.86,1.25,1.33,1.87a2.9,2.9,0,0,0,1.69,1.08c1.37.36,2.16.92,1.82,1.86C174.32,455.24,174.91,455.18,175.36,455.24Z"
            />
            <path
              class="cls-38"
              d="M147.26,468.77c-1.17-.47-2.21-.89-.91-1.85.48-.35.28-1,0-1.45-.84,0-.51.42-.58.65a2.52,2.52,0,0,1-2.06,1.5,2.72,2.72,0,0,1-2-.23c-.65-.45.2-.7.61-1,.79-.5,1.6-1,2.45-1.45s.67-.75-.31-1a5.18,5.18,0,0,0-5.08,1c-1,1-.47,2.19,1.34,2.87.4.15.9.21,1.28.38s1.46-.06,1.44.44-.68.8-1.42,1a1.79,1.79,0,0,1-1.76-.22c-1.05-.86-3.5-1.25-2.65-2.77.16-.28-.48-.33-.75-.19a2.46,2.46,0,0,1-2.26-.12,3.79,3.79,0,0,0-2.85.23,5.5,5.5,0,0,1-3.87.42c.26-.59.5-1.18.78-1.76a1.39,1.39,0,0,1,1.19-.88c1.69-.11,2-.72,2.1-1.55s1-1.26,2.33-1.09a12.24,12.24,0,0,0,6.69-.86,1.54,1.54,0,0,1,.49-.13c2.85-.07,4.83-1.13,6.88-2.11,1.86,0,3.75.17,5.44-.5a1.16,1.16,0,0,1,1.33.25c1.41,1.29.83,3.74-.4,5.13s-2.84,1.9-5.06,2.23c-.52.08-1,.3-.85.58.55.84-.11,1.31-1.2,1.73C147.21,468.22,147.26,468.52,147.26,468.77Z"
            />
            <path
              class="cls-40"
              d="M225.82,445.31a4,4,0,0,1-2.65.69c-3,0-6,.11-9,.15s-5.87-.29-8.8-.49a5.65,5.65,0,0,0-1.59,0,6.15,6.15,0,0,1-3.49-.24c-1.07-.45-1.17.05-1.56.34l.09-1.17c0-.59.45-1,1.54-.93a2.36,2.36,0,0,0,1.81-.58c.53-.55.62-1.43,2.34-1a.32.32,0,0,0,.16,0c.4-1.76,3.69-.67,4.91-1.75s2.23-2,3.38-3a5.46,5.46,0,0,1,.87-.68c.6-.38,1-.29,1.29.19a5.28,5.28,0,0,1,.33.73c.29.86.78,1.37,2.34.6a1.52,1.52,0,0,1,1.92.32,13.23,13.23,0,0,1,1.1,1.58,4.94,4.94,0,0,0,3.33,2.4c1.14.29,1.66.92,1.38,1.69C225.38,444.52,225.28,444.94,225.82,445.31Z"
            />
            <path
              class="cls-41"
              d="M117.74,456c.08.24.2.48.26.73.12.46-.12.7-1,.53-2.28-.43-4.88-.24-6.87-1.22-.3-.14-.76-.26-1-.05-1.35,1.43-3.77.77-5.53.79-3,0-6.12-.34-9.22-.28a4.67,4.67,0,0,1-3.31-.85c0-.84-.14-1.7,2-1.66a1.35,1.35,0,0,0,1.14-.63c.31-.44,1.41-.66,1.5-.76,1-1.2,3.6-.67,4.84-1.58,1.07-.79,1.88-1.67,2.84-2.49.39-.34.65-.91,1.49-.81s.62.63.77,1c.27.68.7,1.09,1.93.49a1.41,1.41,0,0,1,1.87.34c.41.52.73,1.06,1.09,1.59a3.93,3.93,0,0,0,2.53,1.73c1,.27,1.6.8,1.36,1.49s.19,1.22,1.62,1.26A3,3,0,0,1,117.74,456Z"
            />
            <path
              class="cls-18"
              d="M433,457.59c.29.36,1.15.7.51,1.13s-1.08-.12-1.64-.15q-3.22-.19-6.47-.33a8.79,8.79,0,0,1-1.77-.18c-1-.25-2-1-2.94.08-.11.14-.91.07-1.39.09-3.39.16-6.75-.27-10.13-.21a8.33,8.33,0,0,1-2.2-.46c0-.93-.08-1.91,2.27-1.91a1,1,0,0,0,.84-.53,1.5,1.5,0,0,1,1.79-.77.6.6,0,0,0,.64-.32c.28-.61.92-.75,1.94-.63a2.69,2.69,0,0,0,2.2-.78c1-.85,1.94-1.74,2.92-2.6a1.49,1.49,0,0,1,1.18-.59c.66.05.66.48.76.78.26.79.49,1.49,2.23.69a1.25,1.25,0,0,1,1.67.44c.45.54.77,1.12,1.16,1.69a3.74,3.74,0,0,0,2.34,1.56c1.23.31,1.59.93,1.56,1.67C430.08,457.52,432,457.23,433,457.59Z"
            />
            <path
              class="cls-16"
              d="M45.44,455.44c.08.54-.45.61-1.24.66-1.67.11-3.33,0-5,0-3.12-.06-6.26-.07-9.38,0-1.87,0-3.64-.38-5.59-.14-1.29.15-1.68-.75-2.06-1.38,0-.25.21-.46.59-.46,1.4,0,2.29-.37,2.68-1.17.12-.27.79-.25.95-.36,1.63-1.1,4.8-.75,6-2.25a17.46,17.46,0,0,1,2-1.92c.36-.31.65-.8,1.42-.72s.6.58.72.92c.28.79.69,1.18,2.13.55s1.45.62,2.4.7A7.5,7.5,0,0,0,44.84,453C46.27,453.54,46,454.55,45.44,455.44Z"
            />
            <path
              class="cls-42"
              d="M340.31,460a2.13,2.13,0,0,0,1.08-2.75c-.24-.69-.81-1.22-2.09-1.43a4.89,4.89,0,0,1-2.28-.55c-.53-.84-.94-1.71-1.45-2.55,2.27-.34,3.74-1.38,5.48-2.18a13,13,0,0,1,2.86-.21,11.14,11.14,0,0,0,4.69-.61c1.13-.45,1.81-.16,2.18.51a7.58,7.58,0,0,1,.82,4.65c0,.37-.44.65-.73,1-.66.7-2,1.15-2,2.1,0,.26-.55.46-1,.57-.78.2-1.54.43-2.35.57-3.54.6-3.69.73-2.71,2.65C340.84,461.53,340,461,340.31,460Z"
            />
            <path
              class="cls-43"
              d="M335.57,452.67c1.37.67,1.67,1.56,1.45,2.55a13,13,0,0,1-3.67.44c-5,0-10,0-15-.26-1.24-.08-3.33.19-3.22-1.26.28-.06.75-.09.82-.2.67-1,2.68-1.15,3.55-2a1.29,1.29,0,0,1,1.08-.31,3.6,3.6,0,0,0,3.24-1.06c.91-.76,1.69-1.57,2.55-2.35a1.41,1.41,0,0,1,1.08-.51c.61,0,.66.39.74.65.26.9.55,1.61,2.45.75a1.16,1.16,0,0,1,1.48.51c.51.64.89,1.33,1.41,2A2.39,2.39,0,0,0,335.57,452.67Z"
            />
            <path
              class="cls-44"
              d="M250.48,453.93c-4.43,1.05-9.06.95-13.67.75-1.32-.05-2.65,0-4-.11-1.09-.07-2.38,0-2.75-.85,0-1.09.23-1.23,2-1.11a3.76,3.76,0,0,1,3.12-1,2.56,2.56,0,0,0,1.88-.91c.94-.83,1.84-1.67,2.78-2.5a1.37,1.37,0,0,1,1.07-.52c.6,0,.61.42.7.68.29.87.58,1.63,2.45.73a1.16,1.16,0,0,1,1.42.38,9.51,9.51,0,0,1,.89,1.28,4.24,4.24,0,0,0,2.95,2.18C250,453.11,250.55,453.42,250.48,453.93Z"
            />
            <path
              class="cls-40"
              d="M232.05,452.61c-1.4-.09-1.57.58-2,1.11-.9.43-2.61.1-2.93,1.08-2.3-.69-5-.46-7.35-1a47.77,47.77,0,0,1-5.36-1.55c-1-.34-1-.74-.35-1.24a6.64,6.64,0,0,0,1-.89c1.67-1.91,1.82-2,5.39-1.73a49.27,49.27,0,0,1,6.49,1,5.07,5.07,0,0,1,2.35,1.13C229.07,451.71,231,452,232.05,452.61Z"
            />
            <path
              class="cls-45"
              d="M45.44,455.44c-.18-.23-.3-.44-.16-.71.45-.9-.19-1.53-1.55-1.94a3.27,3.27,0,0,1-2.67-2.91,10.13,10.13,0,0,0,5.22-1.75,1.68,1.68,0,0,1,1-.42,8.51,8.51,0,0,0,4.83-.19c.88-.33,1.38-.29,1.78.32,1.44,2.22.78,4.23-1.65,6.07a4.59,4.59,0,0,1-2,.68c-1.11.2-2.39.29-2.92,1.06Z"
            />
            <path
              class="cls-41"
              d="M120.9,463.6a31.86,31.86,0,0,0-4.14.27,29.1,29.1,0,0,1-12.36-2.1c-1.21-.5-1-.86-.12-1.33a3,3,0,0,0,1.65-1.49c.23-.69,1.12-1,2.12-.91,3.49.28,7.16.29,9.92,1.9-.38.47-.16.92.54,1.11A2.73,2.73,0,0,1,120.9,463.6Z"
            />
            <path
              class="cls-46"
              d="M380.06,452.86c-3.14-.83-6.7-.37-9.87-1.11-1.12-.27-2.24-.54-3.31-.86-.52-.16-1.56-.21-1.14-.75a2.25,2.25,0,0,1,1.87-.43,56.4,56.4,0,0,1,7.4.81l.39-.31c-.85-.43-1.74-.84-2.54-1.3-.58-.34-.6-.65.43-.57.36,0,.56.09.59-.18.08-.89,1.43-1.28,2.17-1.91a3.06,3.06,0,0,0,.51.1c3.61,0,5,1.28,5.36,3.26a2.12,2.12,0,0,1-.78,1.8C380.73,451.88,380.13,452.3,380.06,452.86Z"
            />
            <path
              class="cls-40"
              d="M200.18,448.55c-1.62.49-3.49,0-5.13.44.89-.56,2.08-1,1.46-2-.1-.17.37-.34.7-.43C198.1,447.29,199.5,447.73,200.18,448.55Z"
            />
            <path
              class="cls-47"
              d="M245.38,476.89a2.3,2.3,0,0,1,2.09,1,1.63,1.63,0,0,0,2.52.36.61.61,0,0,1,.6-.11.4.4,0,0,1,.21.36,6,6,0,0,1-.18.82,3.47,3.47,0,0,0,1,1.65c.29.23.36.52,0,.79-2.95.41-4.74,1.89-7.24,2.72-.67.22-.67.64-.72,1s0,.88-.82,1.11H230.34a3,3,0,0,1-1.2-.11c-1.83-1.52-4.45-.44-6.63-.74a.82.82,0,0,0-.49.1c-.63,1.22-2.33.72-3.62.75-2.29.06-4.6,0-6.9,0,.12-.57.92-.46,1.51-.48,1.5-.05,3,0,4.54,0-1.09-.47-2.93-.21-3.3-1.25-.08-.24-.17-.05-.22,0a3.2,3.2,0,0,1-2.5-.18c-5.16-1.49-8.62-3.87-10.52-7.05-.54-.91-.92-1.86-.27-2.83a2.65,2.65,0,0,1,1.71-.49c2.16,0,4.3-.1,6.45-.1.22.06.48.12.5.27.57,3.42,4.7,4.79,9.52,5.77a6.38,6.38,0,0,1,1.34.3.51.51,0,0,1,.24.39c.08,1.3.09,1.31,2,.76a1.79,1.79,0,0,1,2.24.61c.54.68.31,1.48,1,2.2,2.23-.78,2-2.34,3.31-3.37.91-1.22,1.49-1.35,3.82-.82.47.1.77.33,1.17-.13s1.33-.43,2.09-.54c1.31-.18,2.71-.39,3.32-1.15C240.67,476.89,243,476.94,245.38,476.89Z"
            />
            <path
              class="cls-15"
              d="M93.57,481.23c.18-.92.85-1.14,2.74-.78.77.14,1.32.34,1.9-.23a4.46,4.46,0,0,1,1.69-.28c2-.15,3.58-.64,4.36-1.8a2.2,2.2,0,0,1,2.26-.8,4.87,4.87,0,0,0,.54,0,8.39,8.39,0,0,1,4.93,1.07,1.57,1.57,0,0,0,1.72-.08c.43-.26.87-.5,1.07.1.7.76-.32,1.7.73,2.44.38.26.61.61.47,1-2.16.82-4.53,1.42-6.66,2.28-.83.33-1.38.6-1.4,1.21s-.27,1-1.15,1.23l-11.48,0a2.19,2.19,0,0,1-.71,0c-2.24-1.62-5.25-.56-7.87-.81-1.44-.31-3-.31-4.45-.5-7.73-1-13.21-3.59-16.2-7.94-1.31-1.85-.08-3,3.24-3.06a19.56,19.56,0,0,1,3.59-.09c.21.06.44.14.47.3.47,2.57,3.45,4,6.92,5.11a4.33,4.33,0,0,0,4.18-.33c.94.06.73.47.66.81s-.36.6-.51.91-.4.64.06.9,1,0,1.45-.14c1.18-.46,1.92-.2,2.39.5a17,17,0,0,1,1.07,2.39,3.78,3.78,0,0,0,2.18-1.95C92.12,482.1,92.24,481.4,93.57,481.23Z"
            />
            <path
              class="cls-48"
              d="M409.57,482.93c-.18-1.08,1.11-.93,2.15-.81s1.81.33,2.61-.24a3.06,3.06,0,0,1,1.2-.2c2.18-.08,3.82-.62,4.67-1.86a2.19,2.19,0,0,1,2.16-.75,6.26,6.26,0,0,0,3-.58,1.8,1.8,0,0,1,1.64.84c1.24,1.29,1.23,1.3,3.39.53,0,.48.07.93.1,1.38-.19.36-.44.68.14,1.07,1.13.75,1.36,1.79,2.17,2.65.61.66-.95,1-.92,1.62-.39-.68-1.15-.95-2.4-.86-1,.08-2.07,0-3.1,0-.68,0-1.31,0-1.5.53s-1,.33-1.53.34h-5.82c.09.54.68.44,1,.39,2-.31,3.76.21,5.61.45.49.06.79.16.79.47s-.26.54-.84.6a87.81,87.81,0,0,1-12.14.14c-.65,0-1.31-.13-2-.13s-1.06-.1-1.06-.53.44-.49,1.05-.56a28.53,28.53,0,0,1,6-.42l-.05-.41c-1.69,0-3.39,0-5.08,0-.8,0-1.74.17-2-.58-.12-.37-.78-.27-1.24-.28h-3.65c-.72,0-1.44-.07-1.67.54s-1,.32-1.55.32c-3.22,0-6.44,0-9.67,0,.25-.66,1.19-.48,1.89-.49,2.35,0,4.7,0,7.08-.1a46.79,46.79,0,0,1-7.76-1.6,15.47,15.47,0,0,1-8.64-6.1c-.47-.68-.73-1.45.18-2.13a29.63,29.63,0,0,1,5.08-.27c.31.07.48.2.5.4.31,2.66,3.22,4.1,6.93,5.19a12.19,12.19,0,0,0,4.26.13c.6.46,0,.89-.12,1.32-.07.26-.11.51.25.7a1.42,1.42,0,0,0,1.16,0c1.7-.48,2-.4,2.77.68.23.33.26.75.93.88a1.75,1.75,0,0,0,2.07-.69C408,483.84,408.16,483.11,409.57,482.93Z"
            />
            <path
              class="cls-49"
              d="M144.33,480.59a3.08,3.08,0,0,1-.4.7c-.49.52-.14.87.53,1.21a1.71,1.71,0,0,0,1.76-.17c1.23-.77,1.73-.29,2.05.4a14.91,14.91,0,0,1,.77,2.08c.15.5.48.52,1.06.22a4.08,4.08,0,0,0,1.52-1.19c.64-.94,1.26-1.89,1.89-2.84.18-.79,1.06-.6,1.91-.49,3,.39,7.47-.78,9-2.36a3.16,3.16,0,0,1,2.17-.67c2.4-.23,4.51-.56,5.64,1.24.26.42,1.15,0,1.61-.32.84-.51.76,0,.85.27.64.75.09,1.57.43,2.34a3.31,3.31,0,0,1-1.56.87,19.16,19.16,0,0,0-2.92,1.69,8.65,8.65,0,0,0-3.67,3c-1.74.13-3.52-.12-5.26.15a1.38,1.38,0,0,1-1-.24c-.45-.25-.36-.78-1.32-.76-1.7,0-4.17-.39-4.95.12-2.06,1.33-4.35.61-6.48.73-2.59.15-5.22.05-7.84,0-1,0-2.24.28-2.6-.7-.09-.26-.86-.17-1.34-.17l-4.92,0c-.22-.46.48-.48.82-.46a3.45,3.45,0,0,0,3.55-1.75l.54-.79a9.94,9.94,0,0,0-3-2.88c-1-.6-1-1.17.2-1.68.83.05,1.16-.47,1.85-.58,1.79,1.93,4.73,2.68,8.26,2.83A1.73,1.73,0,0,1,144.33,480.59Z"
            />
            <path
              class="cls-50"
              d="M358.56,482.52A9.75,9.75,0,0,0,356,480c-1.27-.77-1-1.31.75-1.83,2.85-.16,4.84-1,6-2.55a2.79,2.79,0,0,1,2.61-.87,7.19,7.19,0,0,0,3.15-.34,2.32,2.32,0,0,1,2.7.44c.32.3.56.63.85.94a2,2,0,0,0,2.72.31c.28-.16.53-.48,1-.35s.3.51.27.77c-.06.6-.23,1.2-.33,1.8-.05.28.1.5.68.49.66.64-.05,1-.88,1.12-1.6.32-2,.92-1.63,1.83s.06,1.48-1.28,1.79c-1.94.45-2.38,1.3-2.24,2.39a.9.9,0,0,1-.5.62l-3.65,0c-.66,0-1.39.06-1.45-.53,0-.2-.26-.33-.6-.33l-5.65,0c-1,0-.31.74-1.05.84-.85-.74-.53-1.48.15-2.16A3,3,0,0,0,358.56,482.52Z"
            />
            <path
              class="cls-51"
              d="M316.18,481.23c.18-.92.84-1.14,2.74-.78.76.14,1.34.36,1.9-.23a3.73,3.73,0,0,1,1.51-.26c2.07-.12,3.71-.61,4.53-1.81a2.29,2.29,0,0,1,2.27-.8,5.77,5.77,0,0,0,.72,0,7.73,7.73,0,0,1,4.74,1.06,1.55,1.55,0,0,0,1.72-.06c.89-.54,1-.19,1.08.3-.15,1,.6,1.87.83,2.81a8.47,8.47,0,0,1-2.47.88,15.08,15.08,0,0,0-2.39,1.12c-1.56.77-3.16,1.45-3.3,2.8,0,.16-.42.24-.68.33-2.67,0-5.34,0-8,0-.95,0-1.94.19-2.48-.67-.28-.46-1.67-.19-2.55-.19-1.51,0-3.25-.44-4.26.72-.13.15-.89.14-1.36.14-3.52,0-7,0-10.56,0,.31-.69,1.33-.52,2.09-.53,2.56,0,5.11,0,7.66,0,1.45.1,1-.88,1.82-1.13a5.13,5.13,0,0,0,2.81-2.55A1.85,1.85,0,0,1,316.18,481.23Z"
            />
            <path
              class="cls-52"
              d="M136.22,482.76c.23,1.62-1.34,2.74-3.95,2.81-.35,0-.73,0-1,.19,0,.64-.45.94-1.6.85-.7-.06-1.41,0-2.12,0a3.36,3.36,0,0,1-.87-.53c-1.56-1.44-3.8-1.77-6.38-.92a6.25,6.25,0,0,1-3.44.33c-.65-.14-1.51-.47-1.17-.81.94-.95.2-1.85.12-2.77-1.11-1.06-1.9-2.16-1.07-3.43.75.1,1.4.27,2-.32a6.08,6.08,0,0,1,3.36-1.15c1-.13,2,0,2.62-.68.24-.3.72-.11,1.08,0,1.68.72,3.24,1.47,3.4,2.83a1.42,1.42,0,0,0,.94,1c1.89.88,3.84,1.71,5.7,2.62A2.29,2.29,0,0,0,136.22,482.76Z"
            />
            <path
              class="cls-53"
              d="M338.11,481.45c-.82-.88-1.67-1.76-.72-2.8,1,.85,2.9.87,3.45-.12.79-1.42,2.65-1.33,4.42-1.54a1.28,1.28,0,0,1,1,.16c1.07,1.18,3.4,1.7,4.42,2.92.49.59,1.76.58,2.53,1,.95.49,1.94,1,2.92,1.43.79.38,1.59.72,2.44,0,.6.49.64,1.11.08,1.48a2.44,2.44,0,0,0-1.19,2.57h-7.26a3.82,3.82,0,0,1-.86-.54c-1.55-1.44-3.8-1.77-6.38-.92a7,7,0,0,1-2.58.41c-1.81-.07-2.36-.53-1.66-1.52a1,1,0,0,0-.09-1.34C338.32,482.29,337.94,481.9,338.11,481.45Z"
            />
            <path
              class="cls-54"
              d="M46.21,481.22c-.44-.54-1.44-1-.73-1.7l6.77,3.84c-.66-1-2-1.56-3.14-2.31-.27-.18-.66-.3-1-.48-1.6-1-1.6-1,.31-1.73a2.23,2.23,0,0,0,1-.73c1.08-1.46,4.54-1.63,6.32-.44a46.7,46.7,0,0,0,6.89,3.9,37.79,37.79,0,0,1,4.3,2.25c0,1.08-.89,1.69-2.87,1.93,0,.66-.45.92-1.6.86s-2.61,0-3.91,0c-1-.23-1.15-.81-1.65-1.25a2.67,2.67,0,0,0-2.11-.61,13.62,13.62,0,0,0-4.67.68,4.64,4.64,0,0,1-3-.09c-.62-.18-1.06-.49-.58-.86,1-.77.59-1.47-.06-2.19C46.28,481.93,46.33,481.56,46.21,481.22Z"
            />
            <path
              class="cls-55"
              d="M260.76,484.23c-2.55-1.53-5.1-3.05-7.63-4.59-.64-.39-1.85-.86.27-1a1.06,1.06,0,0,0,.68-.31c.95-1.71,3.92-1.3,5.87-1.94.64-.22,1.11.2,1.5.45,1.77,1.17,3.49,2.36,5.28,3.52a11,11,0,0,0,1.82.87c1.26.51,1.76.22,1.69-.6,1.75.53,3.06,2.36,2.43,3.41-1,1.61-1,1.61-3.94,1.63a3.63,3.63,0,0,0-1.4.1c.11.66-.35.95-1.51.87-.7-.05-1.41,0-2.11,0C262.79,485.77,261.68,485,260.76,484.23Z"
            />
            <path
              class="cls-56"
              d="M290,485.74c-.11.33,0,.73-.75.87a76.47,76.47,0,0,1-14.9,0c-.25-.19-.38-.39-.25-.62,1.33-.74,2.06-1.59,2-2.72,0-.86.9-1.45,2.25-1.75.82-.19,1.39-.48,1.29-1-.28-1.41.25-2.53,2.77-3.05.2,0,.33-.2.52-.3,1.43-.29,1.6.4,1.94.9a19.94,19.94,0,0,0,5.13,5.17c.67.47,1.52.81,2.24,1.25.47.28,1,.63.7,1s-1,.11-1.51.16A4.42,4.42,0,0,0,290,485.74Z"
            />
            <path
              class="cls-57"
              d="M290,485.74c.75-.45,1.76-.05,2.6-.3.12-.45-.44-.72-.93-.95a17.43,17.43,0,0,1-7.25-6.35c-.28-.4-.23-1-1.35-1-.2-.14-.23-.28,0-.44.2-.79,1.16-1.17,2.27-1.48a9.23,9.23,0,0,1,2.08-.68,2.23,2.23,0,0,1,1.59,0c.3,5.53,8.29,9.42,17,10.23,1.14.11,2.28.2,3.42.28,1.33.1,2,.52,1.41,1.33h-8.87a3.15,3.15,0,0,0-1.71.2H298c-.3,0-.77.05-.87,0-1.83-1.6-4.56-.53-6.82-.82A2.17,2.17,0,0,0,290,485.74Z"
            />
            <path
              class="cls-58"
              d="M383.73,476.29c.15,3.52,3.54,5.87,8.25,7.68a30.37,30.37,0,0,0,8,1.65c.53.05,1.49.08,1.42.5s-1,.25-1.53.26c-2.37,0-4.74,0-7.1,0a3.08,3.08,0,0,0-1.72.2l-3.07,0c-.77,0-1.57.08-1.76-.59-.11-.37-.76-.28-1.22-.29l-4.15,0c-.1-.1-.11-.19,0-.28.54-.29,1.3-.12,2.08-.4-2.77-2.22-5.08-4.58-6.12-7.29.33-.5,1.23-.56,1.84-.84a5.32,5.32,0,0,0,2.19-.44A2.73,2.73,0,0,1,383.73,476.29Z"
            />
            <path
              class="cls-59"
              d="M64.11,485.75A4.41,4.41,0,0,0,67,483.82c.55-.29.47-.66.22-1a11.54,11.54,0,0,0-2.71-2.75c-1.49-1-1.48-1.08.18-1.9l.84-.4a1,1,0,0,1,1.07-.44c3,4.27,8.51,6.75,16.08,7.71,1,.13,2.16,0,3.22.24.46.09.76.19.83.47l0,.41c-.42.43-1.14.3-1.78.32-2.56.07-5.14-.14-7.7.1l-4.7,0c-.72,0-1.46.07-1.63-.55-.13-.44-.84-.32-1.34-.33C67.72,485.73,65.91,485.74,64.11,485.75Z"
            />
            <path
              class="cls-60"
              d="M200.87,475c0,2.57,1.71,4.66,4.63,6.54a19.47,19.47,0,0,0,6.06,2.78c1.93.47,1.9.51,3.61-.25.16.44-1,.61-.54,1a4.75,4.75,0,0,0,1.78.47c.84.19,1.7.35,2.68.56-.66.47-1.42.25-2.06.29-1.84.14-3.73-.24-5.53.23h-.34a.89.89,0,0,1-.78,0c-1,0-2,0-3.08,0a2.77,2.77,0,0,1-1-.1c-.69-1.26-2.45-.68-3.77-.76-1.13-.07-2.28,0-3.42,0l-.09-.15c.59-.52,1.52-.33,2.32-.37a23.56,23.56,0,0,0,2.85-.1,15.29,15.29,0,0,0-2.85-2A12.69,12.69,0,0,1,197.2,479c-.27-.44-.77-.8-1-1.24a2.26,2.26,0,0,1-.09-1.18c.23-.83,1.19-1.27,2.43-1.55a11.88,11.88,0,0,1,1.9-.19A1.09,1.09,0,0,1,200.87,475Z"
            />
            <path
              class="cls-61"
              d="M260.76,484.23a4.27,4.27,0,0,1,2.95,2.35l-11.24,0c-.36,0-.79,0-1-.17s-.19-.72-1.08-.71a50.31,50.31,0,0,0-5.23.11c-.67.08-1,1-2.27.75.12-.28.34-.55.32-.82-.07-.92,0-1.71,2-1.85a2.32,2.32,0,0,0,1.19-.62c1.26-1.1,3.18-1.43,5.23-1.64,1.46.54,2.07,1.42,1.64,2.32-.13.28-.76.58-.15.86a3,3,0,0,0,1.91,0,19.18,19.18,0,0,1,2.11-.61,24.56,24.56,0,0,1,3.21,0A2.17,2.17,0,0,0,260.76,484.23Z"
            />
            <path
              class="cls-62"
              d="M46.21,481.22l1.58,1.9c.45.52-.06.91-.59,1.24-.74.47-.39.63.45.79s1.77.38,2.25.08c1.62-1,3.76-.54,5.6-.85a1.24,1.24,0,0,1,1.3.35l1.8,1.85-9.25,0c-.41,0-.93.06-1.17-.18s-.19-.72-1.08-.7c-1.75,0-4.27-.38-5.08.14-1.41.91-2.76.66-4.23.72a3.17,3.17,0,0,0,.36-1.36c-.1-.65.29-1.11,1.52-1.21a1.32,1.32,0,0,0,.51-.08C41.58,482.56,44.27,482.18,46.21,481.22Z"
            />
            <path
              class="cls-61"
              d="M338.11,481.45c.46.54.95,1.06,1.36,1.61a.7.7,0,0,1-.17,1c-.87.84-.54,1.18,1.19,1.24a3,3,0,0,0,1.39-.16c1.26-.72,2.85-.56,4.36-.74,1.85-.21,2.53.3,3.15,1.09.28.35.54.71.8,1.07-2.35,0-4.7,0-7.06,0a1.75,1.75,0,0,1-1-.16c-.38-.28-.35-.76-1.31-.73-1.75,0-4.24-.38-5.1.14-2,1.25-4.25.51-6.33.73l.15-.19c.67-1.1.34-2.6,3.25-2.81C333.78,482.21,336.11,482,338.11,481.45Z"
            />
            <path
              class="cls-63"
              d="M115.85,481.87c.65.84,2,1.63.31,2.59-.5.28,0,.51.46.65a4.53,4.53,0,0,0,3.39-.22c1.57-.81,3.57-.52,5.19-.45,1.41.07,1.8,1.32,2.39,2.13l-10.92,0a1.49,1.49,0,0,1-1.29-.42c-.42-.5-5.18-.76-5.46-.29-.64,1.11-2,.59-3.15.69a1.55,1.55,0,0,1,.24-.28c.89-.63-.2-1.8.89-2.07C110.65,483.55,112.77,482.14,115.85,481.87Z"
            />
            <path
              class="cls-64"
              d="M167,486.59c.12-.31.36-.62.33-.93-.1-.83.15-1.45,1.85-1.55a1.34,1.34,0,0,0,1.08-.51c.76-1.4,2.93-1.88,4.77-2.58,1.56.55,2.75,2.35,2.15,3.25-.46.7-.14,1,1.12.89a4,4,0,0,0,1.34-.29c1.61-.65,3.49-.48,5.26-.57.9,0,1.49.28,1.17.9-.21.26-.74.37-.86.68.25.29.73.2,1.11.2,3.39,0,6.79,0,10.18,0a25.75,25.75,0,0,0,2.6-.39l0,.07c.12.65-.36.87-1.46.86-4.42,0-8.85,0-13.27,0-.35,0-.9,0-1-.11-1.67-1.57-4.24-.43-6.31-.75C174.06,487.58,170.3,486.18,167,486.59Z"
            />
            <path
              class="cls-65"
              d="M283,476.71c0,.15,0,.3,0,.44,0,.5-.26.81-1.2.87-1.44.1-1.88.64-1.75,1.44a8.07,8.07,0,0,1,0,1.39c0,.46-.28.74-1.1.82-2,.21-2.66,1-2.53,2.11s-.5,1.88-2.41,2.19c-2.2-.54-4.48-.12-6.72-.23a1.74,1.74,0,0,1,1-.21c1-.1,2.41.32,2.84-.26.76-1,2.22-2.11.47-3.31-.57-.4-.67-1-1.37-1.36a4.2,4.2,0,0,1-1.81-1.51,2.84,2.84,0,0,0,2-.65c.93-.62,1.64-.39,2,.25a25.47,25.47,0,0,1,1.15,2.91c.08.2-.11.47.29.57s.72-.18,1-.32a5.17,5.17,0,0,0,2.67-2.73,2.37,2.37,0,0,1,1.27-1.38c.09,0,.26-.09.26-.14C279.24,475.58,281.49,476.72,283,476.71Z"
            />
            <path
              class="cls-47"
              d="M236.57,488.76a60.87,60.87,0,0,1-6.9-.22c-.64-.05-1-.14-1-.57s.35-.43.88-.53c3.49-.63,7.11-.42,10.67-.6,1.46-.07,2.62.64,4.1.69.48,0,.39.39.35.64s-.51.31-.93.37A51.84,51.84,0,0,1,236.57,488.76Z"
            />
            <path
              class="cls-66"
              d="M196.47,487a2.14,2.14,0,0,0,1.71.43c.51,0,.82.09.83.41s-.16.55-.77.61a72.4,72.4,0,0,1-12.58.08c-.48,0-1-.05-1.45-.06s-1.1,0-1.18-.45.39-.59,1-.72a7.62,7.62,0,0,0,1.89-.31C189.44,486.88,193,486.85,196.47,487Z"
            />
            <path
              class="cls-67"
              d="M168.15,488.77a64.48,64.48,0,0,1-6.79-.25c-.56,0-.92-.12-.93-.5s.21-.47.8-.57c3.92-.71,7.94-.37,11.92-.42.92,0,1.7.5,2.74.45.54,0,.53.32.53.58s-.45.4-1,.47A53.68,53.68,0,0,1,168.15,488.77Z"
            />
            <path
              class="cls-68"
              d="M38.85,487a2.75,2.75,0,0,0,1.77.42c.64,0,.8.24.79.57s-.18.45-.71.5a86.64,86.64,0,0,1-12.48.11l-2-.11c-.49,0-.81-.12-.82-.44s0-.62.51-.57c1.51.13,2.68-.63,4.16-.48A80,80,0,0,1,38.85,487Z"
            />
            <path
              class="cls-69"
              d="M399.44,487a4,4,0,0,0,1.79.43c.61,0,1.1.07,1,.52s-.51.49-1.11.54a88.81,88.81,0,0,1-14,0c-.6,0-.85-.2-.86-.54s.27-.53.87-.53a2.77,2.77,0,0,0,2.06-.44C392.61,486.88,396,486.87,399.44,487Z"
            />
            <path
              class="cls-70"
              d="M102,488.77a59.11,59.11,0,0,1-7-.24c-.65-.07-1.24-.1-1.26-.58s.73-.4,1.28-.51c2.86-.57,5.81-.36,8.73-.44a27.71,27.71,0,0,1,5.27.44c.63.11.71.32.7.63s-.5.39-1,.47A51.31,51.31,0,0,1,102,488.77Z"
            />
            <path
              class="cls-71"
              d="M123.48,488.76a57.79,57.79,0,0,1-7.21-.25c-.61-.08-1-.17-1-.58s.44-.4.94-.49c3.27-.57,6.64-.34,10-.48,1.64-.06,3,.44,4.51.48.58,0,.56.31.57.57s-.34.43-.89.51A52.23,52.23,0,0,1,123.48,488.76Z"
            />
            <path
              class="cls-72"
              d="M79,488.77a60,60,0,0,1-7.23-.24c-.61-.07-1-.17-1.07-.58s.51-.44,1.07-.54c3.29-.57,6.67-.31,10-.43,1.59-.05,2.86.46,4.35.51.57,0,.55.32.54.58s-.35.37-.82.44A47.4,47.4,0,0,1,79,488.77Z"
            />
            <path
              class="cls-73"
              d="M326.54,488.77a52.35,52.35,0,0,1-6.33-.24c-.6-.06-1.07-.09-1.07-.53s.46-.46,1-.56c3.24-.6,6.56-.32,9.84-.46,1.65-.07,3,.47,4.55.49.53,0,.61.3.55.57s-.5.42-1,.49A57,57,0,0,1,326.54,488.77Z"
            />
            <path
              class="cls-74"
              d="M219.14,487a2.29,2.29,0,0,0,1.73.42c.62,0,.85.2.83.54s-.18.46-.71.5a77.59,77.59,0,0,1-12.57.1c-.48,0-1-.07-1.44-.08-.65,0-1.22-.07-1.26-.56s.59-.51,1.22-.54,1.39.16,1.71-.36A96.59,96.59,0,0,1,219.14,487Z"
            />
            <path
              class="cls-75"
              d="M372.3,488.78a59,59,0,0,1-6.62-.27c-.55,0-.9-.12-.93-.49s.33-.49.95-.6c3.28-.58,6.64-.34,10-.46,1.65-.06,3,.48,4.53.51.56,0,.57.31.53.57s-.51.4-1,.48A55.19,55.19,0,0,1,372.3,488.78Z"
            />
            <path
              class="cls-76"
              d="M56.08,488.74A52.73,52.73,0,0,1,49,488.5c-.64-.07-1-.2-1-.61s.53-.36,1-.45c3-.55,6-.36,9.05-.46a35.61,35.61,0,0,1,5.24.44c.68.08.69.33.69.63s-.45.4-1,.47A51.62,51.62,0,0,1,56.08,488.74Z"
            />
            <path
              class="cls-77"
              d="M152.38,487.46c.64,0,1.4-.11,1.42.52s-.61.49-1.23.55a89.58,89.58,0,0,1-13.9,0c-.71,0-.92-.24-.92-.62s.45-.6,1.16-.64,1.45.47,1.82-.23a50.26,50.26,0,0,1,7.26,0h0C149.43,487.27,151,487.11,152.38,487.46Z"
            />
            <path
              class="cls-78"
              d="M287.75,488.53a5,5,0,0,1-2.09.23c-3.43-.06-6.85.11-10.28-.21-1.34-.13-1.66-.37-1.46-1.06,3.91-.81,8-.66,12-.69,1.33,0,2.12.77,3.49.64.37,0,.34.32.34.53s-.12.41-.58.45A5.15,5.15,0,0,0,287.75,488.53Z"
            />
            <path
              class="cls-79"
              d="M309.66,487l.37.21c.47.39,2.16.66.35,1.27a4.18,4.18,0,0,1-1.89.26c-3.6,0-7.22.15-10.81-.23-.64-.07-1.21-.06-1.2-.57s.6-.54,1.23-.54,1.36,0,1.74-.39C302.86,486.86,306.26,486.87,309.66,487Z"
            />
            <path
              class="cls-80"
              d="M259.21,488.5h-6.53c-.71,0-1.39,0-1.34-.61s.85-.34,1.36-.45c3.13-.67,6.39-.3,9.59-.47,1.64-.09,2.95.46,4.49.5.59,0,.49.33.49.58s-.44.46-1,.46h-7.08Z"
            />
            <path
              class="cls-81"
              d="M350.16,488.71a50.78,50.78,0,0,1-7.51-.22c-.6,0-.8-.26-.8-.59s.3-.4.79-.46a37.2,37.2,0,0,1,7.55-.4C350.81,487.6,350.91,488.15,350.16,488.71Z"
            />
            <path
              class="cls-82"
              d="M350.16,488.71l0-1.67a28.73,28.73,0,0,1,7,.39c.55.1.6.29.62.55s-.29.46-.86.52A45.38,45.38,0,0,1,350.16,488.71Z"
            />
            <path
              class="cls-83"
              d="M287.75,488.53a2.39,2.39,0,0,1,1.18-.2c.42,0,.64-.16.64-.42s-.23-.35-.63-.43c-3.74-.77-7.61-.46-11.4-.36-1.11,0-2.37.33-3.62.37.58-.51,1.66,0,2.35-.42-.42-.51-1.57,0-2-.48l14.9,0c-.27.28-.91.15-1.36.4.71.41,2.66.07,2.08,1.14C289.54,488.84,288.51,488.46,287.75,488.53Z"
            />
            <path
              class="cls-75"
              d="M380.84,485.54v.22c0,.61-.5.87-1.58.86-3.14,0-6.27,0-9.41,0,0-.2,0-.41,0-.61,1.62,0,3.22.14,4.85.12A20.54,20.54,0,0,0,380.84,485.54Z"
            />
            <path
              class="cls-47"
              d="M219.14,487l-10.49,0c.34-.46,1.33-.05,1.73-.44h.78c1.87.44,3.82.08,5.73.21C217.64,486.88,218.48,486.65,219.14,487Z"
            />
            <path
              class="cls-51"
              d="M310.38,488.51c1.13-.54-.4-.83-.35-1.27a5.07,5.07,0,0,1,.55,0c.74.12,1.95,0,1.91.67S311.22,488.48,310.38,488.51Z"
            />
            <path
              class="cls-15"
              d="M16.2,487.05H5.71a2.42,2.42,0,0,1,1.69-.22C10.33,487,13.3,486.53,16.2,487.05Z"
            />
            <path
              class="cls-64"
              d="M196.47,487H185.93c2.68-.46,5.41-.11,8.12-.19A4.51,4.51,0,0,1,196.47,487Z"
            />
            <path
              class="cls-51"
              d="M309.66,487H299.45a6.22,6.22,0,0,1,2.94-.2C304.81,486.91,307.27,486.56,309.66,487Z"
            />
            <path
              class="cls-48"
              d="M399.44,487H389.2c2.58-.44,5.22-.11,7.83-.18A4.79,4.79,0,0,1,399.44,487Z"
            />
            <path
              class="cls-15"
              d="M77.2,486.6c1.24-.44,2.6-.12,3.9-.2,1.85-.12,3.76.21,5.58-.22-.08.55-.8.43-1.36.43C82.61,486.62,79.9,486.61,77.2,486.6Z"
            />
            <path
              class="cls-15"
              d="M38.85,487H30.09A37.74,37.74,0,0,1,38.85,487Z"
            />
            <path
              class="cls-49"
              d="M148,487l-7.26,0A24.54,24.54,0,0,1,148,487Z"
            />
            <path
              class="cls-49"
              d="M152.38,487.46A17.69,17.69,0,0,1,148,487C149.48,487.09,151.08,486.74,152.38,487.46Z"
            />
            <path
              class="cls-84"
              d="M66.58,477.35l-1.07.44a28.39,28.39,0,0,0-3.72-2.88,23.83,23.83,0,0,1-2.27-2.05c-1.48-1.56-2.21-1.81-5.22-1.48s-5.92.67-8.84,1.09c-1.69.25-3.08.36-3.85-.83-.22-.34-.85-.59-1.37-.93a1.89,1.89,0,0,0,1.6-2c0-.74.21-1.54,2.1-1.45a2.27,2.27,0,0,0,1.71-.71c1.74-1.45,3.25-1.58,5.63-.46.24.12.49.22.73.32,1,.65,1.22,1.68,2.91,2,1.35.23,1.59-.48,2.2-.88a2.4,2.4,0,0,1,1.53-.21,8.59,8.59,0,0,0,4.52-.91,2.55,2.55,0,0,1,2.71-.05c.74.47,1.44.17,2.17.08.62.38.17.82.2,1.23a1.46,1.46,0,0,0,1.18,1.47c1,.31,1.38-.22,2-.5a7.94,7.94,0,0,1,6.2.2,4.35,4.35,0,0,0,5-.05l.37-.24c2-1.32,2.54-1.31,4.49.05a2.27,2.27,0,0,0,1.49,2.72s.12.06.11.08c-.4,1.52,1.83,1.51,3.27,2,1.81.6,2.31,1.39,1.49,2.51a2.54,2.54,0,0,0-.31,2.61.72.72,0,0,1-.15.92c-.73.65-.58,1.28.27,1.86a2.45,2.45,0,0,0-1.17,1.17,3.76,3.76,0,0,1-.65,1.12c-.51.6-1,1.44-2.23,1.39-1,0-.47-.92-.86-1.38-.18-.22-.18-.49-.3-.73-.59-1.25-.74-1.3-2.44-.54a1.76,1.76,0,0,1-1.47,0c-.7-.26-.71-.6-.57-1,.21-.66,1.48-1.21.62-2-1.58-.76-1.91-1.51-1-2.51a16.68,16.68,0,0,1,3.13-2.5c1.32-.88,1-1.56-.83-1.95a18.4,18.4,0,0,0-6.82,0c-.69.11-1,.53-1.4.81a6.86,6.86,0,0,1-4.38,1.22c-1.73.06-3.46.09-5.18.17-1.34.06-2.51,1.37-1.94,2.13C66.23,476.91,66.6,477.07,66.58,477.35Z"
            />
            <path
              class="cls-85"
              d="M48.71,460.39c.13.81,1.61.93,2.23,1.49-.75.2-1.4.32-1.57,1-.32,1.28-1.55,1.8-3.6,1.82-2.24,0-3.71-.5-4.12-1.74-.25-.78-.88-1.16-2-1.38a6.26,6.26,0,0,1-1.29-.38c-.82-.37-2.51-.31-2.08-1.31.71-1.61,1.25-1.74,3.64-1.68a51.14,51.14,0,0,1,5.17.5C46.72,458.91,48.08,459.37,48.71,460.39Z"
            />
            <path
              class="cls-16"
              d="M17.71,459.09l-2.42.71c-.6.18-1.29.06-1.4-.22-.32-.9-1.43-.68-2.39-.71a4.5,4.5,0,0,1,3.83-.46C16.16,458.59,16.92,458.86,17.71,459.09Z"
            />
            <path
              class="cls-18"
              d="M436.64,465.11a20.5,20.5,0,0,1-7.77.38,27.44,27.44,0,0,1-8.5-2c-.94-.41-1.29-.75-.2-1.23a3.14,3.14,0,0,0,1.64-1.51,2.47,2.47,0,0,1,2.52-1,56.91,56.91,0,0,1,7.23,1,20.57,20.57,0,0,1,2.17,1,1,1,0,0,0,.83,1.18A2.46,2.46,0,0,1,436.64,465.11Z"
            />
            <path
              class="cls-86"
              d="M357.09,477.8a3.07,3.07,0,0,1-2.22-.57,42.46,42.46,0,0,1-4.54-3.71,2,2,0,0,0-2.33-.44,5.17,5.17,0,0,1-4.15-.37c-1.45-.85-3.11-1.58-4.68-2.36-.33-.16-.7-.4-1.06-.11s.27.37.55.52c1,.49,2.11,1,1.41,1.87a3.71,3.71,0,0,1-3.09.85c-1.52-.1-2.16-.7-2.15-1.57,0-.17-.1-.5-.32-.42-1.59.58-1.74-.58-2.84-.69,2.16-.5,1.67-1.64,2-2.52.24-.61.61-1,1.72-1a2.32,2.32,0,0,0,1.75-.67c1.41-1.64,3.32-1.66,6.07-.31.23.12.48.22.71.33s.69.5,1,.76c1.44,1.15,1.45,1.16,3.24.31a5.47,5.47,0,0,1,2.55-.43,8.22,8.22,0,0,0,3.72-.71c1.71-.82,3.11-.71,4.33.4a11.18,11.18,0,0,1,1.09,1.23,3.87,3.87,0,0,0,2.08,1.15c1.54.4,1.6.65.18,1.24-.8.34-1.47.74-2.19,1.12s-.88.73-.6,1.16c.47.7-.08,1.26-.57,1.82-.7.8-2,1.48-.87,2.53C358.19,477.44,357.5,477.65,357.09,477.8Z"
            />
            <path
              class="cls-87"
              d="M380.84,485.54a4.27,4.27,0,0,1-3.2.87c-1.8-.07-3.61,0-5.42,0a5,5,0,0,1-2.33-.43c-.27-1.25.06-2.25,2.53-2.64,1.28-.19,1.19-.89,1-1.52-.47-1.49-.35-1.66,2-2.09.81-.15,1-.47,1-.88s-.16-.76.41-1a4.94,4.94,0,0,1,1.52,1.92,16.9,16.9,0,0,0,4.35,4.65c.37.3,1.28.5.91.94s-1.2.16-1.83.22C381.45,485.55,381.14,485.53,380.84,485.54Z"
            />
            <path
              class="cls-43"
              d="M340.31,460c0,1,1.34,1.33,2.53,1.73l0,.42c-.23.62-.86,1-2,1.07a33.1,33.1,0,0,1-12.27-1.5c-1.88-.65-1.92-.78-.68-1.88a2.6,2.6,0,0,0,.48-.69c.56-1,1.68-1.23,3.3-1s3.43.39,5.14.6A6,6,0,0,1,340.31,460Z"
            />
            <path
              class="cls-88"
              d="M287.39,474.79a5.59,5.59,0,0,1-2.14.44c-.33-.39-.67-.77-1-1.16-.56-.73-.93-1.4.79-1.85.9-.23,1-.77.69-1.31-.47-.94-.11-1.56,1.75-1.8a3.18,3.18,0,0,0,2.51-1.43c.37-.72.71-1.44,1-2.16a2.14,2.14,0,0,1,2-1.35,1.59,1.59,0,0,0,1.6-1.4c.35-1.11.92-1.35,2.86-1.15a10.51,10.51,0,0,0,5-.59,8.84,8.84,0,0,1,3.2-.68c2.32-.07,3.51-1.33,5.35-1.91,1.83-.06,3.75.27,5.42-.49a1,1,0,0,1,1.29.32c.5,1.36,1.75,2.77.46,4.13s-2.17,2.86-5.36,3.06c-1.1.07-2.22.38-1.33,1.29.38.39,0,.59-.55.75-.89.27-1.09.72-1,1.26-2.15-.87-3.45-.18-4.94.75a5.27,5.27,0,0,1-5.29-.14,5,5,0,0,0-5.93.59c-1.66,1.28-2.72,3-5.43,3.73C287.61,473.92,287.17,474.24,287.39,474.79Z"
            />
            <path
              class="cls-37"
              d="M271.68,476.94c-.83-.22-.7-.67-.72-1.08-.3-.44.23-.74.54-1.07s.88-.83.78-1.29c-.27-1.36,1-2.23,2.62-3,1.12-.5,1.12-.81-.19-1.16a5,5,0,0,1-2.28-1.62,4.86,4.86,0,0,0-4.19-1.47l-.19-.1c.27-.88,1.86-.55,2.53-.94,1.26-.73,1.73-.12,2.56.27s.79.57.15.93-.5.75.14,1.09a13.68,13.68,0,0,0,2.59,1.33c1.43.44,1.42,1.11.6,1.79a5.69,5.69,0,0,1-1.58.88c-1,.38-1.65.93-1.55,1.59C273.71,474.55,272.23,475.66,271.68,476.94Z"
            />
            <path
              class="cls-89"
              d="M265.83,467.08a7.81,7.81,0,0,0-4.5.82,1.68,1.68,0,0,1-2.39-.21c.81-1.44,3-1.35,4.92-1.48,1.38-.1,2.79,0,4.19,0v0C267.89,467.08,267.45,467.25,265.83,467.08Z"
            />
            <path
              class="cls-90"
              d="M87.4,468.55c-1.18.06-1.51-1.15-2.74-.74a11,11,0,0,0-2.07,1.31,4.57,4.57,0,0,1-5.3-.17c-1.27-.84-4.81-.84-5.91,0a2.34,2.34,0,0,1-3.32-.27c-.63-.78-.17-1.53,0-2.3.57-.65.16-1.68,1.46-2,1.92-.44,2.42-1.22,2.71-2.3.16-.62,1.43-.76,2.41-.59a10.53,10.53,0,0,0,5.84-.63,2.91,2.91,0,0,1,1-.29c2.89-.12,4.94-1.19,7.09-2.15,1.82-.11,3.76.3,5.45-.49a.85.85,0,0,1,1.19.38c1,1.75,1.53,3.33-.52,5.15a9.24,9.24,0,0,1-4.83,2.05c-.93.18-1.54.48-.91,1.11.4.4.2.65-.47.85S87.33,468.06,87.4,468.55Z"
            />
            <path
              class="cls-14"
              d="M57.12,467.48c-.35.62-.52,1.4-2.2.88C55.94,468.31,56.28,467.67,57.12,467.48Z"
            />
            <path
              class="cls-91"
              d="M200.53,475a7.48,7.48,0,0,1-1.84.23c-2.09-1.05-2.31-2-.7-3.16.36-.26.62-.52.52-.87-.29-.69-.48-1.37.94-1.75l2.56-.64a3.6,3.6,0,0,0,2.18-2.5,2.85,2.85,0,0,1,2.89-2.29c.85-.1.72-.59.77-1,.2-1.26,1-1.64,3.07-1.42a10.69,10.69,0,0,0,5.22-.54,8.11,8.11,0,0,1,3-.68c.21-.11.33-.34.74-.2,2-.18,3-1.31,4.74-1.72,1.8,0,3.64.18,5.3-.47.73-.29,1.12,0,1.29.4.72,1.76,1.38,3.39-.6,5.19a7.69,7.69,0,0,1-4.05,1.78c-1.06.21-2.34.42-1.67,1.41.22.31-.08.56-.57.69-.65.19-.84.49-.8.88a.89.89,0,0,1-.64.15,3.55,3.55,0,0,0-3.72.72,5.58,5.58,0,0,1-6.12.06,4.91,4.91,0,0,0-5.67.67c-1.53,1.29-2.7,2.89-5.25,3.67C201,473.93,200.58,474.32,200.53,475Z"
            />
            <path
              class="cls-92"
              d="M200.53,475c-.87-.76-.57-1.25.95-1.48a4,4,0,0,0,2.53-1.28,3.43,3.43,0,0,1,2.47-1.72.66.66,0,0,0,.61-.61c0-.85.7-1.37,2.09-1.47,1.55-.12,3.11-.23,4.26.68a4.48,4.48,0,0,0,5,.16c1.46-1,2.67-2,5.09-.92.14.88-.43,1.82.73,2.6-.24.46.54.69.72,1.05,0,.31.25.54.75.65a10.77,10.77,0,0,1,4.67,1.24,13.46,13.46,0,0,1,2.81,1.67c.3.23.59.51.09.76a1.47,1.47,0,0,1-1.16-.09c-.51-.17-.89-.7-1.48-.49-.8.29-1.2,1-.93,1.42,1,1.44-.61,2.75-.34,4.13-.88.67-1,1.53-1.6,2.26a2,2,0,0,1-.55.56c-.58.34-1,1-1.88.87s-.26-.76-.52-1.15c-.37-.56-.12-1.21-.75-1.75a1.11,1.11,0,0,0-1.44-.21c-.59.31-1,.94-2.07.5-1.23-.5-.57-1.14-.27-1.74a6.86,6.86,0,0,0-.94-2.49c-.56-.77.16-1.47.92-2.09s1.7-1.21,2.52-1.83c1.12-.84.87-1.48-.77-1.85a19.43,19.43,0,0,0-7.33.08c-.62.09-.84.49-1.25.75a6.07,6.07,0,0,1-4.15,1.21c-2.28.21-4.57.15-6.87.18a2.19,2.19,0,0,0-1.56.41A1.93,1.93,0,0,1,200.53,475Z"
            />
            <path
              class="cls-93"
              d="M229.38,481.27c-.32-.71-1.22-1.4.18-2.12.45-.24.32-.83-.15-1.2a.71.71,0,0,1-.17-1.1c.37-.56.42-1.43,1.08-1.63,1-.32,1.43.65,2.29.91.15,0,.33.05.84.13-2-1.84-4.69-2.86-7.73-3.63-.12-.91.56-1.32,2.13-1.29,1.33,0,2.65-.17,2.69,1.11s1.15,2,3.26,2.25a4.66,4.66,0,0,0,4.11-1.12,1,1,0,0,1,1-.39c.59.13.4.51.31.75-.3.8-1.32,1.15-2.61,1.27-.45,0-1.15,0-1.07.37s.76.26,1.23.28a4,4,0,0,0,3.06-.94,1.47,1.47,0,0,1,2.29,0,11.34,11.34,0,0,0,3.3,1.95,11.89,11.89,0,0,1-3.32.47,1.6,1.6,0,0,0-1.55.59c-.91,1.31-2.69,1.85-5,2-.81.06-2.07.06-1.36,1C231.11,479.93,230.15,480,229.38,481.27Z"
            />
            <path
              class="cls-94"
              d="M265.83,467.08a2.72,2.72,0,0,0,2.23-.87c2.26-.39,2.88-.26,4.34,1,1,.9,1.69,2,3.83,2.28.75.1.5.5,0,.74s-1.21.6-1.83.88c-1.24.56-1.86,1.25-1.65,2.22s-1.18,1.67-1.81,2.51a2.16,2.16,0,0,1-2.17-.62,30.09,30.09,0,0,1-5-5.18C262.37,468.09,262.57,467.69,265.83,467.08Z"
            />
            <path
              class="cls-44"
              d="M253.81,460a2,2,0,0,0,1.83,1.52,2.26,2.26,0,0,1-.77,2.25,5.08,5.08,0,0,1-3.65.93,4.25,4.25,0,0,1-3.46-1.85c-.33-.55-.7-.68-1.62-.72a11.51,11.51,0,0,1-4.38-1.18c-1.54-.7,0-1.36.25-2s1.3-.95,2.42-.84c2.08.19,4.15.4,6.2.72A12.38,12.38,0,0,1,253.81,460Z"
            />
            <path
              class="cls-55"
              d="M260.4,484.24a1.81,1.81,0,0,1-1.31.23,6.56,6.56,0,0,0-3.53.6,3.42,3.42,0,0,1-2.06.21c-1-.15-2.09-.25-.87-1.14s-.33-1.69-.95-2.48c-.21-.29-.29-.68-.66-.86-1-.46-.86-.95-.41-1.51.89-.38,1.3.08,1.79.36Z"
            />
            <path
              class="cls-91"
              d="M225,472c-.87-.2-1.35-.49-.72-1.05C224.42,471.29,225.78,471.38,225,472Z"
            />
            <path
              class="cls-95"
              d="M287.39,474.79c-1.42-.52-.62-1,.27-1.2a4.92,4.92,0,0,0,3.42-2.07,1.93,1.93,0,0,1,1.46-.87,1.15,1.15,0,0,0,1.09-.91c.14-.74.75-1.28,2.12-1.36,1.53-.09,3.08-.14,4.21.63a4.63,4.63,0,0,0,5.09.21l.52-.3c2.07-1.28,2.07-1.28,4.44-.16a2.07,2.07,0,0,0,1.36,2.43c.18.08.43.26.38.35-.59,1.23,1.12,1.27,2.32,1.55,2.49.6,3.15,1.47,2.17,3a2,2,0,0,0-.4.92c-.07,1,.6,2.08-.31,3.11-.31.36.07.84.65,1.16-.88.39-1.05,1-1.4,1.57a4.12,4.12,0,0,1-2.94,2.31c-.91-.35-.73-1-1-1.47a6.25,6.25,0,0,0-.46-1c-.2-.29-.47-.46-1.1-.35-3,.5-3.61.15-2.91-1.59a1.77,1.77,0,0,0-.06-1.89c-.8-1.21-.23-2.25,1.15-3.18.72-.49,1.43-1,2.07-1.5.9-.74.7-1.23-.63-1.66a15.55,15.55,0,0,0-4.83-.36,6.25,6.25,0,0,0-4.14,1.24,8.81,8.81,0,0,1-5,1.34,31.8,31.8,0,0,1-4.89.21,2.21,2.21,0,0,1-1.15-.29A3.5,3.5,0,0,0,287.39,474.79Z"
            />
            <path
              class="cls-39"
              d="M196.51,476.51v1.28a4.4,4.4,0,0,0-3.29,2.16,53.72,53.72,0,0,1-6.28-4.41,1.74,1.74,0,0,0-2.5-.21,4.46,4.46,0,0,1-3.2.5,46.45,46.45,0,0,0-10.07-.19c-.87,0-1.77,0-2.21-.51s0-1,.71-1.42c1.06-.7,1.26-1.46,0-2.17-.65-.36-.92-.6.1-.94a1.64,1.64,0,0,0,1.22-1.7c.06-.77.26-1.42,2-1.45a2.86,2.86,0,0,0,1.81-.84c1.7-1.25,3.08-1.4,5.37-.49.48.19.85.57,1.39.07.69.32.79.86,1.31,1.25a1.94,1.94,0,0,0,2.36.24,5,5,0,0,1,3.69-.26c.23,2.29,2,4.26,3.88,6.19a4.7,4.7,0,0,0,3,1.54c.37.39.14.82.25,1.23,0,.1-.08.2,0,.3C196.08,476.52,196.22,476.44,196.51,476.51Z"
            />
            <path
              class="cls-96"
              d="M186,485.1c-.08-.25-.33-.62-.7-.55-1.72.33-3.69-.21-5.26.52a4.66,4.66,0,0,1-2.55.4c-1.67-.18-1.82-.38-.83-1.2.33-.27.67-.51.37-.87L175,481c-1.28-.73-.13-1.57-.31-2.35,1.65,1.06,2.81.95,4-.35s4-1.44,5.63-.54a57.07,57.07,0,0,0,6.19,3.45c.36.15.58.37.58.64a5.22,5.22,0,0,0-.64,2.4,1.59,1.59,0,0,1-.94,1.34C188.07,486.43,186.7,486.23,186,485.1Z"
            />
            <path
              class="cls-91"
              d="M186,485.1c.77.2.81,1.1,2.24.68,1.28-.37,1.71-.92,1.74-1.69s-.36-1.66,1.09-2.22c2.42-.22,2.93-.67,2.17-1.92.05-1.57.77-2,3.29-2.16,1.1.41,1.08,1.16,1.49,1.77,1.22,1.79,3.37,3.18,5.48,4.6.56.38,1.88.68,1.48,1.18s-1.66.11-2.53.18c-1.12.09-2.29-.19-3.36.2a2.18,2.18,0,0,1-1.95.7c-3.83-.05-7.66,0-11.49,0-.57,0-1.44.2-1.63-.19s.63-.63,1.16-.85C185.41,485.24,185.71,485.18,186,485.1Z"
            />
            <path
              class="cls-97"
              d="M188.87,467.47c-1.54-.06-3-.09-4.07.78a1.11,1.11,0,0,1-1.37,0c-1-.59-2-1.16-1.92-2.07a.53.53,0,0,0,.07-.2c.59,0,1.19-.25,1.25-.54.21-1.13,1.7-1.27,3-1.33a26.47,26.47,0,0,1,7.55.22c1.29.32,2.55.81,1.64,1.87a23.4,23.4,0,0,0-4.19,1.15A2.49,2.49,0,0,1,188.87,467.47Z"
            />
            <path
              class="cls-95"
              d="M383.73,476.29a8.81,8.81,0,0,0-2.91.22c-.61,0-1.08-.18-1-.59s.52-.5,1-.57c2-.28,3.09-1,3.63-2.15a1.44,1.44,0,0,1,.88-.65c1.32-.23,1.8-.7,1.81-1.5s1.1-.8,2-.92a6.09,6.09,0,0,1,4.15.67,5.06,5.06,0,0,0,5.29.13,3.76,3.76,0,0,0,.74-.47c.89-.89,1.82-1.51,3.37-.38.23.17.56,0,.83,0,.12,1.11-.54,2.35,1.59,3.1-.44,1.56,2,1.48,3.36,2,1.61.62,2.1,1.2,1.39,2.25s-1.08,1.8-.52,2.79a.66.66,0,0,1-.08.83c-1,.74-.36,1.32.4,1.91a2.9,2.9,0,0,0-1.6,1.84c-.29.65-1,.77-2,.8s-1.47-.29-1.63-.84a3.71,3.71,0,0,0-.53-.91c-.31-.43-.76-.5-1.38-.16s-1.11.86-2.09.37-.63-1-.19-1.55c.22-.26.41-.52.33-.82-2.05-2.16-2-2.74.57-4.62a17.74,17.74,0,0,0,1.87-1.32c.71-.71.52-1.26-.76-1.58a19.1,19.1,0,0,0-7.68,0c-.56.09-.74.45-1.09.7a7.45,7.45,0,0,1-4.2,1.28A52.62,52.62,0,0,1,383.73,476.29Z"
            />
            <path
              class="cls-40"
              d="M219.88,460.17l-.74.2c0-.54-.8-.77-1.33-1.09-2.05-1.22-4.13-2.42-6.18-3.64Z"
            />
            <path
              class="cls-98"
              d="M144.33,480.59c-3.1.65-5.18-.66-7.6-1.35-1.18-.33-1.74-.84-1.5-1.62.1-.12.35-.32.29-.36-1.32-.93-.11-1.64.55-2.4.33-.38.78-.76.88-1.17.32-1.31,1.82-1.64,3.73-1.68a23,23,0,0,1,5.57.23c1.93.46,2.28,1.31,1,2.27-.95.69-1.92,1.37-2.83,2.08s-1.09,1.48-.25,2.28C144.71,479.42,145,480,144.33,480.59Z"
            />
            <path
              class="cls-38"
              d="M142.46,464.25c.5.05,1.19-.14,1.42.28s-.35.51-.67.71a8.8,8.8,0,0,1-1,.6c-.6.28-.94.9-1.78.8-.68-.07-.44-.61-.42-.95,0-.64.45-1.19,1.59-1.41A6.6,6.6,0,0,1,142.46,464.25Z"
            />
            <path
              class="cls-99"
              d="M188.87,467.47a7.88,7.88,0,0,0,3.31-1c.82-.53,1.89-.29,2.88-.3.9.9,1.77,1.8,2.71,2.68a2.92,2.92,0,0,0,1.68.53c-.78.52-1,1.08-.37,1.71-1.27.79-2.59,1.52-2,2.83.21.45-.35,1-1.31,1.25a2.59,2.59,0,0,1-2.3-.5,19.21,19.21,0,0,1-4.9-5.9A1.06,1.06,0,0,1,188.87,467.47Z"
            />
            <path
              class="cls-22"
              d="M209.3,474.39c1.7-.44,3.61-.71,4.36-1.91a1,1,0,0,1,.35-.24c1.52-.7,7.81-.59,9.26.18.93.49,1.26,1,.33,1.66s-1.86,1.31-2.76,2c-1.08.79-1.66,1.61-.63,2.62a1.22,1.22,0,0,1,.09,1.93c-5.12-.4-8.76-2-11.11-4.69A1,1,0,0,1,209.3,474.39Z"
            />
            <path
              class="cls-22"
              d="M73.19,474.39c1.71-.48,3.78-.67,4.51-1.95,0-.06.14-.11.23-.16,1.58-.85,8.23-.6,9.66.34.85.55.56,1.05-.1,1.53s-1.63,1.15-2.46,1.72c-1.57,1.06-2.21,2.18-.53,3.42-.38,1-1.85,1.31-3.89.77a16.44,16.44,0,0,1-7.1-3.84C72.92,475.67,72.64,475,73.19,474.39Z"
            />
            <path
              class="cls-100"
              d="M389.21,476.11c1.64-.61,3.7-.84,4.56-2.1.34-.5,1.55-.3,2.36-.38a18.14,18.14,0,0,1,5.93.13c2.1.47,2.49,1.28,1.11,2.31-.82.62-1.75,1.19-2.57,1.81-1.09.82-1.63,1.68-.47,2.65a1,1,0,0,1,.37,1.13c-2.29,1-4.35.18-6.21-.42a10.76,10.76,0,0,1-5-3.3C388.8,477.33,388.6,476.73,389.21,476.11Z"
            />
            <path
              class="cls-101"
              d="M311.14,483.58c.55.46.34,1,.7,1.53-.79.3.06,1.09-1.09,1.28,0-.73-.48-1-1.84-1.09-5.5-.21-10.6-1.2-14.67-3.43-2.89-1.59-5-3.58-5.72-5.94a1.22,1.22,0,0,1,.33-1.35H290a5.54,5.54,0,0,1,3.74,2.34c1.13,1.92,3.64,3.16,6.11,4.42a4.66,4.66,0,0,0,1.64.44c2.61.29,4.95,1.2,7.73,1.1C310,482.84,310.43,483.39,311.14,483.58Z"
            />
            <path
              class="cls-32"
              d="M195.79,475.21c.6-.74,1.25-1.4.91-2.37s1-1.42,2.38-1.71c0,.4.11.85-.57,1.06-1.88.59-1.29,1.35-.55,2.15.26.28.49.57.73.86-.92.33-2,.57-2.18,1.31-.16.14-.31.39-.48.39-.45,0-.16-.25-.28-.38A.85.85,0,0,1,195.79,475.21Z"
            />
            <path
              class="cls-30"
              d="M342.53,469.88c.84.25,1.4.44,2,.59.31.07.82,0,.72.32s-.55.38-1,.29C343.43,470.9,342.6,470.7,342.53,469.88Z"
            />
            <path
              class="cls-29"
              d="M252.68,462.44c.59.25,1.55-.2,1.69.42s-1.53,1.21-2.83,1.17c-.55,0-1.39-.07-1.18-.42A2.66,2.66,0,0,1,252.68,462.44Z"
            />
            <path
              class="cls-102"
              d="M295.07,474.38c2.08-.25,4.16-.52,5.09-1.86a1.14,1.14,0,0,1,.79-.41,20.91,20.91,0,0,1,8,0c2.05.48,2.29,1.23.88,2.25-.69.49-1.41,1-2.11,1.46-1.28.91-1.94,1.85-.85,3a1.32,1.32,0,0,1-.16,1.95,3,3,0,0,1-2.3.37c-4.66-.8-8-2.47-9.87-5.14C294.12,475.44,294.08,474.84,295.07,474.38Z"
            />
            <path
              class="cls-51"
              d="M295.07,474.38c-.59.75-.28,1.41.32,2.13,1.91,2.27,5.05,3.61,9,4.39a7.14,7.14,0,0,0,2.28-.1,7,7,0,0,0-.31.83c-.07.38.37.57.88.74a1.55,1.55,0,0,0,1.16-.07c1.86-.73,2.09-.67,2.61.64a2.82,2.82,0,0,1,.09.64c-.09.05-.21.15-.26.14-3.18-.84-6.67-1.05-9.95-1.7-1.66-.33-2.59-1.15-3.86-1.73a8.28,8.28,0,0,1-4-3.56c-.56-1-2.17-1.41-3.14-2.16Z"
            />
            <path
              class="cls-13"
              d="M97.41,504.11c4.62,0,9.24-.07,13.86-.07H288.05l2.37,0a5.06,5.06,0,0,0,2.23.34h13.07a5.09,5.09,0,0,0,2.23-.34L344,504h62l88.78,0v-3.87a3.77,3.77,0,0,0-1.74-.12c-3,0-5.93.05-8.88,0a5.18,5.18,0,0,1-2.31-.4,20.72,20.72,0,0,1,2-.65,9.63,9.63,0,0,1,3.39-.21,44.54,44.54,0,0,1,6.33.14,1.83,1.83,0,0,0,1.18,0v-.43a3.33,3.33,0,0,0-2.4-.55c-2.91,0-5.82,0-8.73,0a5.58,5.58,0,0,1-2.52-.46,13.68,13.68,0,0,0-7,0,6.16,6.16,0,0,1-2.69.47c-3.16,0-6.31,0-9.46,0a15.61,15.61,0,0,1-3.92-.58,11.16,11.16,0,0,0-6.76.19,6.44,6.44,0,0,1-2.39.37c-2.55,0-5.09,0-7.64,0-.95,0-1.91,0-2.86,0a4.4,4.4,0,0,1-2.84-.67c-2.66-.19-5.31-.65-7.8.47-.87.39-2.12.15-3.2.18-.66,0-1.33,0-2,0-2.46.08-4.93,0-7.39,0a3,3,0,0,1-1.62-.36,2.63,2.63,0,0,0-.75-.37c-2.68-.16-5.4-.58-7.88.48a5.46,5.46,0,0,1-2.12.2c-3.27,0-6.55,0-9.82,0a7.61,7.61,0,0,1-2.86-.47,9.54,9.54,0,0,0-6,0,8.11,8.11,0,0,1-2.71.45c-3,0-6,0-9,0-1.44,0-3,.16-4-.7-2.54-.13-5.14-.63-7.44.52a4.38,4.38,0,0,1-1.77.15h-9.26a17,17,0,0,1-4.27-.57,10.86,10.86,0,0,0-6.89.27,4.3,4.3,0,0,1-1.86.32c-1.39,0-2.78-.05-4.17,0-1.95-.05-3.89,0-5.84,0a8.14,8.14,0,0,1-3.74-.58c-1.18-.6-5.76-.34-6.89.28a3.37,3.37,0,0,1-1.65.33c-3.89,0-7.78,0-11.67,0a3.54,3.54,0,0,1-2.22-.6c-2.65-.31-5.31-.68-7.81.35-1,.4-2.3.08-3.36.39-.69.76.89.53,1.12.9a15.09,15.09,0,0,0,2.31.65,61.21,61.21,0,0,1-14.06.11,10.6,10.6,0,0,1,2.16-.8c1.83-.38,3.72-.09,5.58-.19.74,0,1.63.11,2-.48a1.25,1.25,0,0,0-.52-.24c-2-.2-4.1-.06-6.15-.09a16.11,16.11,0,0,1-4.1-.59,13.07,13.07,0,0,0-7,.07,9.55,9.55,0,0,1-2.88.47c-3.69,0-7.38,0-11.07,0a1.77,1.77,0,0,1-.88-.06c-1.8-1.18-4.15-.7-6.32-.76a1.33,1.33,0,0,0-.54.05c-3,1.33-6.4.61-9.64.77-1.08.06-2.18,0-3.26,0-1.44,0-3,.18-4-.68a22.21,22.21,0,0,0-6.41.05c-.4.18-.58.47-.95.66l-.29.12c-.49.2-1.47.07-1.47.59s.93.42,1.48.56a.48.48,0,0,1,.32.23c-.21.49-.95.4-1.49.44a89.68,89.68,0,0,1-11.24.06c-.4,0-.82,0-1.23-.08s-.6-.1-.61-.31.23-.28.5-.38c1.58-.57,1.58-.58-.08-1.19-.52-.23-.72-.65-1.36-.81a41.1,41.1,0,0,0-4.71-.11,3,3,0,0,0-1.39.2,7,7,0,0,1-3.87.64c-3.32.05-6.65,0-10,0a3.85,3.85,0,0,1-1.85-.31,12,12,0,0,0-7.31-.18,5.74,5.74,0,0,1-2.52.46c-2.48,0-5,0-7.44,0a25.64,25.64,0,0,1-6.32-.63,10.68,10.68,0,0,0-6.77.32,5.31,5.31,0,0,1-2.08.3c-1.88,0-3.77,0-5.65,0-2.25-.11-4.53.14-6.76-.17a13.17,13.17,0,0,0-8.39-.14,6.81,6.81,0,0,1-2.59.29c-.66,0-1.32,0-2,0-2.85,0-5.71,0-8.56,0a3.25,3.25,0,0,1-2.32-.65c-2.17-.25-4.29-.56-6.33.38-1.09.5-2.58.16-3.88.23-3.1.08-6.2,0-9.3,0a3.62,3.62,0,0,1-1.4-.17,10.92,10.92,0,0,0-8-.07,8.81,8.81,0,0,1-2.67.22c-.85,0-1.71,0-2.55,0-.52,0-1.26,0-1.27.44s.63.51,1.2.54a24,24,0,0,1,4.1.44c.28.06.61.05.78.23-2.21.64-11.22.66-13.89,0a14.27,14.27,0,0,1,3.75-.62c.37,0,.73,0,1.09,0,.75,0,1.86.09,1.87-.52s-1.05-.48-1.74-.51c-.91-.05-1.82,0-2.73,0a7.13,7.13,0,0,1-3.22-.54c-1.51-.73-6-.37-7.46.45-2.72.21-5.45-.2-8.17.08a6.11,6.11,0,0,0-2.25.34v.43A7.4,7.4,0,0,0,60,499a24.68,24.68,0,0,1,7.2.64,14.43,14.43,0,0,1-3.56.41c-1.51.06-3,0-4.55,0a4.9,4.9,0,0,0-2.25.33v3.65H87c.91,0,1.82,0,2.73,0A20.72,20.72,0,0,0,97.41,504.11Z"
            />
            <path
              class="cls-14"
              d="M479.85,467.08l-.24,1.18c-1.89-.32-1.95-1.18-2.05-2-1.73,1.41-4.42,1-6.74,1.15-4.29.25-8.6-.05-12.9.13a7.63,7.63,0,0,1-3.48-.5,4.67,4.67,0,0,0-2.07,0c-2.81.6-4.05,2.41-2.69,3.95a3.61,3.61,0,0,0,1.18,1.06.72.72,0,0,0,.65-.07c2.4-1.84,6-1.66,9.31-1.86a1.84,1.84,0,0,1,2,1.2c.37.58-.22.86-1,1.1s-1.28.42-2,.57a2.74,2.74,0,0,0-2.26,1.52c-.44,1.06-1.62,1.53-3.26,1.55-1.92,0-2.82-.34-3.45-1.52a1.89,1.89,0,0,0-2.23-1.08c-2,1.46-2.41,3.44-1.08,4.64,1,.15,1.54-.35,2.3-.53,1.7-.41,2.53-.31,3.58.58A4.26,4.26,0,0,0,456,479.2c.59.05,1,.25,1.17.59a6.51,6.51,0,0,0,1.2,2.55c.56.57-2,1.74-3.36,1.56-2-.27-4-.51-6-.78a36.81,36.81,0,0,0-5.77-.41,3.54,3.54,0,0,0-2.71.89,30.75,30.75,0,0,1-5.74,4.82c-.4.27-.74.56-.78.94,0,0,0,.09,0,.11,2.12,1,1.42,2-.15,3a5.15,5.15,0,0,0-1.6,1.78c-.29.45-.63,1,.36,1.31a2.79,2.79,0,0,0,1.39-.45,99.37,99.37,0,0,0,10.54-5.74c1.29-.86,4.25-.62,5.18.37a2.81,2.81,0,0,0,1.34,1c1.34.42.95.89.1,1.33-1.28.66-2.38,1.43-3.6,2.12-.38.22-.9.57-.5.84.55.36,1.14,0,1.54-.24a58.07,58.07,0,0,0,5.93-3.62c.25-.33,0-.9,1.27-.66a2,2,0,0,0,2.08-.8,2.26,2.26,0,0,1,2.52-.58,7.42,7.42,0,0,0,1.78.2,2.91,2.91,0,0,1,2.18.81,7.37,7.37,0,0,0,4.35,1.76c1.64.23,3.14.83,5,.49.79-.15,1,.6,1.81.58,1-.41,1.18-1,.84-1.61a2.07,2.07,0,0,1-.18-1.79c.27-.7-.13-1.34-.52-2-.75-1.26-.41-1.76,1.51-2.36,3.55-1.12,5.13-3,4.57-5.42-.39-.7-1.27-1.25-1.36-2.06-.08-.61-1.21-.92-2.16-1-4.34-.43-5.76-4.43-4.26-6.3A.9.9,0,0,1,475,470a21.42,21.42,0,0,0,4.82.44c.74,0,1.31.36,2,.46a3.41,3.41,0,0,0,1.68-.27,6.21,6.21,0,0,1,4.51,0,1.8,1.8,0,0,0,.52,0c2.37-1,4-2.42,6.22-3.53v-1.29a2.75,2.75,0,0,0-2.19.13c-2.78,1-5.94,1.21-9,1.68C482.15,467.83,481.09,467.29,479.85,467.08Z"
            />
            <path
              class="cls-15"
              d="M475.43,492.91c-.22-1.05-1.46-1.06-2.74-.85-.81.12-1.42.3-2.1-.21a4.56,4.56,0,0,0-1.71-.27c-1.91-.18-3.45-.68-4.26-1.77a2.46,2.46,0,0,0-2.44-.82h-.36c-2.44-.08-3.18.08-4.87,1.07-1.05.61-1.71-.1-2.71-.39v1.49c-.2.63-.88,1.17-.89,1.83a.6.6,0,0,0,.38.35c2.44.59,4.13,1.82,6.32,2.61.71.26,1,.57,1.05,1a1.26,1.26,0,0,0,.84,1.25l10.9,0c.64,0,1.39.08,1.52-.5.08-.31.5-.37.95-.37h4.54c.43,0,.93,0,1,.33.15.63.93.54,1.64.54l10.18,0a6.48,6.48,0,0,1,2.12.19v-9.89a1.43,1.43,0,0,0-1.24.3c-2.39,1.76-5.93,2.51-9.09,3.59-.19.2-.11.42-.12.63,0,.61-.51.72-1.43.45-1.7-.5-2.19-.35-2.84.74-.35.59-.35,1.25-.83,1.86a3.34,3.34,0,0,1-2.19-1.81C476.7,493.79,476.7,493.09,475.43,492.91Z"
            />
            <path
              class="cls-16"
              d="M479.85,467.08c.81.95,2.31,1,3.73.82,3.17-.46,6.52-.65,9.34-1.77a4.46,4.46,0,0,1,1.87-.34V445.15c-1.29-.36-1.73,0-1.75.72,0,.32,0,.64-.05,1-.05.8-.53,1.11-1.95.72-1.64-.44-2.31-.21-2.71.81-.24.63-.34,1.27-.53,1.91a4,4,0,0,1-2.68,2.8c-1.34.54-1.7,1.38-1,2.28s.26,1.28-1.25,1.6c-3.7.8-4.77,3.31-2.27,5.11l.8.59c1.29.95,1.32,1.37-.28,2.15C479.84,465.45,479.43,466.16,479.85,467.08Z"
            />
            <path
              class="cls-17"
              d="M482,470.73a7,7,0,0,0-3.54-.65,6.63,6.63,0,0,1-3.28-.44c-.69-.34-1.3-.2-1.54.29-.84,1.73-1.38,3.38.45,5.13a7.15,7.15,0,0,0,4.31,2c1,.15,2.13.44,1.52,1.37-.48.72,1.5.69,1.36,1.36.2.43.61.62,1.28.31a2,2,0,0,1,2.4.34,6,6,0,0,0,4.26,1.34,3.26,3.26,0,0,0,1.69-.31,10.16,10.16,0,0,1,3.86-1.46v-7.31c-1.28-.63-2.39-1.48-4.42-.95a.85.85,0,0,1-.92-.41c-.22-.29-.32-.62-.87-.78l-.36,0c-.6-.22-1.5-.41-1.86-.11C485.05,471.49,483.5,470.85,482,470.73Z"
            />
            <path
              class="cls-18"
              d="M56.86,480.62v9c.09.05.25.12.31.09,1.57-.79,2.82-.19,4.1.31a1.78,1.78,0,0,0,.66.16,7.26,7.26,0,0,1,5.18,2,2.24,2.24,0,0,0,2.22.67c.44-.24.27-.6.54-.93a2.49,2.49,0,0,0,3.1-.72,9.59,9.59,0,0,1,1.51-1.17c.15-.35-.12-.63-.46-.89s-.44-.55.22-.77c1.17-.4.9-1,.28-1.47-1-.79-1.25-1.53,0-2.32.48-.31.4-.67-.11-1a2,2,0,0,1-1-1.67c-.12-.82-.77-1.43-2.19-1.66a3.76,3.76,0,0,1-1.76-.72c-1.84-1.4-3.37-1.55-5.89-.58-.4.16-.77.35-1.17.51a3.52,3.52,0,0,0-.5.31c-.6.43-.92,1-1.79,1.3-1.12.35-1.58-.5-2.49-.59A1.6,1.6,0,0,0,56.86,480.62Z"
            />
            <path
              class="cls-19"
              d="M494.79,480c-1.49,0-2.82.07-3.67,1-.62.67-3,.72-4.29.15a5.91,5.91,0,0,1-1.49-.93c-.86-.75-1.71-1.27-3-.3-.48.35-.67-.07-1-.15.2,1.2.56,2.42-1.5,3.27-.12.05-.23.2-.19.27.59.93-.62,1.06-1.63,1.32-3.52.89-3.8,1.26-2.54,3.39a1.65,1.65,0,0,1,.15,1.77c-.19.35-.33.88,0,1.14.88.73.33,1.34-.14,2a2.73,2.73,0,0,1,1.06,1.21,9.38,9.38,0,0,0,.73,1.2,2.84,2.84,0,0,0,2.2,1.27c.72,0,.46-.91.75-1.39s.38-.89.63-1.32c.35-.6.91-.7,1.7-.22a1.66,1.66,0,0,0,1.81.32c.77-.35.78-.76.36-1.23-.08-.09-.06-.21-.09-.31a10,10,0,0,1,1-2.88c.38-.61-.28-1.17-.78-1.7-.76-.83-2.05-1.4-2.91-2.18s-.65-1.3.72-1.64a18.86,18.86,0,0,1,7.63.06c.61.1.8.52,1.21.77a4.05,4.05,0,0,0,3.33.91Z"
            />
            <path
              class="cls-20"
              d="M69.21,492.88a3.77,3.77,0,0,1-2.44-1.34,4.64,4.64,0,0,0-3.52-1.44,6.82,6.82,0,0,1-3.08-.79c-1-.62-1.77-.68-2.51.14-.11.11-.52.13-.8.2v8.6c3.66-.2,7.31,0,11,0-.89-1.62.43-2.93,1.75-4.24C70,493.56,70,493.17,69.21,492.88Z"
            />
            <path
              class="cls-21"
              d="M69.25,467.9a17.71,17.71,0,0,1-8.28-1c-1.18-.42-2.81-.3-4.11-.7v12c1.63.34,3.31,0,5,.13,1.09-.32,1.19-1,1.62-1.57a3.14,3.14,0,0,1,2-2.16c.75-.3,1-.77.86-1.31-.68-.86-1.49-1.68-1-2.72a1.91,1.91,0,0,1,1.76-1.18,6.55,6.55,0,0,0,2.08-.54C69.7,468.6,69.8,468.24,69.25,467.9Z"
            />
            <path
              class="cls-22"
              d="M494.79,485.78c-1.44-.29-2.89-.56-3.43-1.57a1.24,1.24,0,0,0-.78-.4,21,21,0,0,0-8.21,0c-1.76.44-2.06,1.13-.94,2,1,.78,2.06,1.5,3.05,2.27.83.65,1,1.4.34,2.11a1.67,1.67,0,0,0-.24,2.27,1.8,1.8,0,0,0,1.45-.07c3.05-1.16,6.43-2.06,8.76-3.8Z"
            />
            <path
              class="cls-23"
              d="M483.52,498.69a2.35,2.35,0,0,1-1.75.4c-.63,0-.82.23-.81.57s.18.45.72.49a72.67,72.67,0,0,0,13.11,0v-1.29l-.78-.2A94.12,94.12,0,0,0,483.52,498.69Z"
            />
            <path
              class="cls-16"
              d="M488.58,470.53a5,5,0,0,0,.43,1c.34.48.74.9,1.85.46a2,2,0,0,1,2.27.24c.38.44,1,.44,1.66.43v-5.59c-1.8.12-2.33,1.17-3.54,1.73A20,20,0,0,0,488.58,470.53Z"
            />
            <path
              class="cls-24"
              d="M56.86,500.4a98.82,98.82,0,0,0,10.33-.24c.63-.07,1-.15,1-.58s-.42-.41-.93-.5a56.23,56.23,0,0,0-10.39-.4Z"
            />
            <path
              class="cls-25"
              d="M62,478.24a16.59,16.59,0,0,0-5.12,0v2.36c.38.12.78.21,1.12.35,2.05.91,2.05.91,3.46-.32.33-.29.65-.59,1-.89C63,479.19,62.73,478.69,62,478.24Z"
            />
            <path
              class="cls-26"
              d="M119.66,464.5c-.16.15-.27.37-.5.44-2.68.75-3.07,2.25-3.84,3.71-.55,1.05-1,2-.47,3.12.32.63-2.35,3-3.4,3-.59,0-.81-.27-1.11-.47a7.48,7.48,0,0,0-4.85-1.11,8.53,8.53,0,0,1-4.47-1c-2-1-2.39-.94-4.34,0,.36,1.1,1.9,1.44,3.39,1.65a20.06,20.06,0,0,1,4.19,1,10.67,10.67,0,0,0,4.42.37c2-.11,2.35,0,2.8,1.15a2,2,0,0,0,1.56,1.23,2.6,2.6,0,0,1,2,1.55,16.34,16.34,0,0,0,.8,1.77,3.48,3.48,0,0,0,2.58,1.68c1.39.27,1.9.81,1.82,1.63a1.34,1.34,0,0,0,.8,1.49c1.19.62,1.09,1.28.28,2a1.25,1.25,0,0,0-.46.69c.08.63,1.29.68,1.67,1.14.36.3.22.72.73,1,1.15.12,1.09-.39,1.19-.8.14-.57-.34-1.12-.16-1.77.92.08,1.75.57,2.73.22a3.84,3.84,0,0,0,1.65-1.26,2.43,2.43,0,0,1,2.71-.53,3.83,3.83,0,0,0,1.39.23,5.63,5.63,0,0,1,4.89,1.73,6.82,6.82,0,0,0,5.23,1.55c.35-.2.14-.39,0-.58a7.18,7.18,0,0,0-2.08-4,.38.38,0,0,1-.07-.43c.53-1.23-.76-1.93-2.15-2.62s-1.44-.71.11-1.35a4.52,4.52,0,0,0,1.81-1.33,4.9,4.9,0,0,1,1.25-1.18,3,3,0,0,1,2.92-.19,10.41,10.41,0,0,0,4.56.92,4.81,4.81,0,0,1,2.45.62,2.37,2.37,0,0,0,2.89-.19,4.63,4.63,0,0,0,1.56-1.43c-.58-1.54.53-2.93,1.05-4.37a2.53,2.53,0,0,0,.2-.49c1-1.78.51-2.31-2.64-2.87-1.8-.31-3.53-.63-3.93-1.92,0-.13-.23-.25-.39-.36-2.9-1.88-1.93-4-1-6.08.35-.79,1.27-.56,2.16-.32a20.69,20.69,0,0,0,7.08.36c0-.35-.55-.46-1-.57-.83-.21-1.11-.55-.78-1s0-1-.87-1.22c-1.42-.39-1.81-1.09-1.72-1.94s-.3-1.32-1.91-1.29a2.31,2.31,0,0,1-2.3-1.15c-.29-.51-.66-.94-1.81-.7-.89.19-1-.24-1.18-.57a1.62,1.62,0,0,0-1.9-.72,3.77,3.77,0,0,1-3.36-.91c-1.36-1.13-2.59-2.33-3.91-3.48-.39-.34-.75-.87-1.56-.77s-.71.68-.9,1.07c-.12.24-.19.49-.31.73-.34.68-.88.84-2,.39-1.61-.67-2.18-.57-3,.49-.47.62-.8,1.27-1.22,1.9a4.93,4.93,0,0,1-3.24,2.19c-1.45.36-2,1.06-1.84,2,.09.45.37.93-.26,1.34.22.88,1.39,1.47,2.11,2.17.44.43.32.51-.07.8s-1.81.71-1.16,1.26,1.71.08,2.55-.06a43.42,43.42,0,0,1,4.85-.36c.41,0,1-.12,1.13.17s-.37.4-.72.5a24.64,24.64,0,0,1-7.26,1.21A13.92,13.92,0,0,0,119.66,464.5Z"
            />
            <path
              class="cls-27"
              d="M207.62,448.79c-1.39-.17-1.2.55-1.4.95-.68,1.33-.66,1.36-2.74.76a1.58,1.58,0,0,0-1.79.37,14.18,14.18,0,0,0-1,1.49,5.36,5.36,0,0,1-3.7,2.76c-1.32.31-1.67,1.08-1.39,1.91s-.21,1.15-1.63,1.29c-3.54.35-5.2,2.51-3.49,4.38,1.47,1.62,1.49,1.64-1.06,2.68-1.59.65-1,1.7-1.54,2.53s-.63,1.63.52,2.33a15.49,15.49,0,0,0,6.9,2.2,5.39,5.39,0,0,1,1.63.46,11,11,0,0,0,5.06.64c1.46-.15,2.37.11,2.65,1s.9,1.31,2.13,1.62a2,2,0,0,1,1.48,1.16c.23.52.46,1,.71,1.55a4.25,4.25,0,0,0,3.23,2.17c1.07.23,1.62.62,1.37,1.3s0,1.41,1.15,1.89c.7.3.69.71.44,1.16s-.79.89-.82,1.41c.6.65,1.76,1,2.41,1.65,1,.21,2.4-.35,2.94.13a8.49,8.49,0,0,1,2.08,2.22,5.34,5.34,0,0,0,2.47,2.69,2.66,2.66,0,0,0,1.68.54c.82-.11.72-.6.86-1a18.86,18.86,0,0,1,.83-2.19c.31-.6.81-.88,1.8-.37a2.37,2.37,0,0,0,1.8.33c.6-.59-.32-.81-.82-1.1-.68-.4-1.58-.67-2-1.22-.54-1.38-1.86-2.62-1.8-4.1,0-.72-1-1.16-1.93-1.6-2-1-2-1.43,0-2.36a18.55,18.55,0,0,0,1.71-1c.68-.4,1.14-.85.59-1.43-.37-.39-.09-.66.4-.93a1.92,1.92,0,0,1,1.49-.05,11.73,11.73,0,0,1,3,.91,20.58,20.58,0,0,0,3.6.14,9.27,9.27,0,0,1,5.13,1.28c.78,0,1-.3,1.13-.65.2-1.16-.31-2.34.39-3.49.15-.24.09-.53-.31-.68a1.52,1.52,0,0,0-1.28.21c-2.75,1.34-5,1.26-7.37-.28-1-.65-1.81-1.56-3.68-.78-.15.06-.47.05-.51,0-.45-.81-2.16-1.21-2.07-2.14s-.59-1.34-1.85-1.63c-.79-.19-1.58-.38-2.39-.54a3.11,3.11,0,0,1-2-1,2.78,2.78,0,0,0-.71-.75c-2.48-1.61-1.85-3.44-1.08-5.27.39-.91.9-1.06,2.37-.59a17.75,17.75,0,0,0,5.35.34c.36,0,.7-.12.77-.37-.43-.5-1.1-.93-.9-1.58.1-.33-.29-.61-.73-.82-1.22-.6-2-1.31-1.95-2.29a.56.56,0,0,0-.58-.61c-2-.12-2.81-1.14-4.08-1.81-1,.09-2,.31-2.25-.63-.08-.34-.7-.55-1.27-.47a4.64,4.64,0,0,1-4.31-1.5c-.46-.42-1.06-.78-1.26-1.29,0-.3-.29-.48-.64-.66l-1.07-.91A1.42,1.42,0,0,0,207.62,448.79Z"
            />
            <path
              class="cls-28"
              d="M451,472a8.4,8.4,0,0,0-.84-1.17c-1.32-1.4-.29-3.05,2.27-3.57.38-.92-1-1-1.82-1.12a7.07,7.07,0,0,1-3.84-1.94c-1.49-1.35-1.22-2.69-.69-4.1.23-.61.75-.86,1.81-.55a9.76,9.76,0,0,0,3.2.25c.55,0,1.29.05,1.37-.48a5.15,5.15,0,0,0-2.4-2.57c-.22-.13-.09-.48-.13-.72s0-.49-.1-.52a15.28,15.28,0,0,1-4.19-1.81c-.34-.18-1.1-.16-1.31-.6a1.12,1.12,0,0,0-1.13-.42,3.91,3.91,0,0,1-3.48-1.22c-.83-.7-1.56-1.45-2.35-2.16a1.49,1.49,0,0,0-1.21-.57c-.54.06-.53.44-.63.72-.28.82-.59,1.57-2.36.7a1.28,1.28,0,0,0-1.27.18c-.11.08-.25.17-.29.27a7.85,7.85,0,0,1-4.95,4c-.41,1.19-1.55,1.95-3.59,2.28a1,1,0,0,0-.84,1,2.48,2.48,0,0,0,.82,3.13c.7.52,0,1-.73,1.22a2.38,2.38,0,0,0-1.9,1.67c-.38,1.17-1.22,2.23-.77,3.53.24.71-1.33,1.44-2.48,2a.84.84,0,0,1-.48,0c-1.5-1.4-4-1.06-6.2-1.26-.55.77-.56,1.49.53,2.13a15.69,15.69,0,0,0,6.69,2.19,5.74,5.74,0,0,1,1.64.44,11.1,11.1,0,0,0,5.38.6c1.48-.19,2.34.14,2.56,1,.17.72.71,1.26,2,1.53a1.93,1.93,0,0,1,1.45,1,1.71,1.71,0,0,0,.8,1.06,3.28,3.28,0,0,0,2.52.06,2.43,2.43,0,0,1,1.85-.08c1.85.95,4.14,1,6.39,1.21.9.23,1.42.86,2.56.85,1.8-.32,2.61-1.11,2.88-2.15a2.61,2.61,0,0,1,.1-3.06c.28-.5.64-1,1-1.46C449.92,473.23,451.32,473.07,451,472Z"
            />
            <path
              class="cls-29"
              d="M241.52,478.69l-.74.64a3.59,3.59,0,0,1-2.52-.19,6.43,6.43,0,0,0-4.4-.51c-.16.51.57.48,1,.56,1.18.2,1.59.67,1.23,1.31a21.9,21.9,0,0,1-6,6.48,5.45,5.45,0,0,1-1.43.45,1.74,1.74,0,0,0-.68,1.15c.11.71,1.2.9,2,1.28a14,14,0,0,1,1.3.87,6.39,6.39,0,0,0-2.06,1.52c0,1.07.75,1.33,2.32.76,2.28-.83,3.66-2.18,5.43-3.3.42-.26.78-.55,1.18-.82a3.8,3.8,0,0,1,2.58-.43,11.54,11.54,0,0,1,5.51,2.05c.66.4,0,.58-.32.77-1.91,1.15-3.86,2.28-5.78,3.43-.54.32-1.25.59-1.27,1.12a.65.65,0,0,0,.4.17,3.19,3.19,0,0,0,1.78-.66c1.93-1.13,3.86-2.25,5.76-3.4a7.7,7.7,0,0,1,2.49-1c.33-.18-.09-.79,1-.53a2.15,2.15,0,0,0,2.16-.65,3.44,3.44,0,0,1,1.95-1,9,9,0,0,0,3.34-1.78,1.5,1.5,0,0,1,2,0,5.16,5.16,0,0,0,3.55.83c.56,0,1.13-.16,1.16-.55s-.48-.48-1-.55c-1.07-.18-2.11-.36-2.48-1.15.59,0,.73.24,1,.39,2.41,1.38,6.09.89,7.25-1a2.81,2.81,0,0,0,.26-.52c.18-.52.21-1.09,1.51-1.12s2.18.08,2.62.84c0,.07.13.12.22.17.72.12.93-.17,1.1-.49-.18-.57.59-.88,1.05-1.28.86-.77.6-1.63.6-2.48-.16-.89-1.33-1.55-1.52-2.47-.11-.53-1.25-.71-2.11-.9-3-.68-4.76-2.16-4.75-4.06a4.26,4.26,0,0,1,.09-1.07c.38-1.5.52-1.54,3-1.24a9.8,9.8,0,0,0,3.58-.09,1.63,1.63,0,0,0-.82-2.21,2.11,2.11,0,0,1-1.24-1.68c-.7-.92-2-1.11-3.53-1a7.85,7.85,0,0,1-2.35.53,130.71,130.71,0,0,1-14.68,0c-1.06-.07-2-.62-3.13-.31.56,1.46.41,1.57-2.21,1.71-2.3.14-3.8,2.05-2.7,3.47a2.37,2.37,0,0,0,1.4.94c1.28,0,1.91-.69,3-.89a54.16,54.16,0,0,1,6-.75c1.66-.11,2.24.18,2.92,1.19s-.31,1.25-1.39,1.58a1.7,1.7,0,0,1-.32.1c-2.37.4-4.52.91-5.7,2.39-.53.66-1.85.85-3.19.61a2.94,2.94,0,0,1-2.45-1.57c-.18-.44.05-.94-.61-1.3-1.28.11-1.35.75-1.49,1.28-.32,1.17-1.36,2.29-.72,3.54C242,478.12,241.57,478.4,241.52,478.69Z"
            />
            <path
              class="cls-30"
              d="M188.62,470.08c-1.15-.61-.28-1.47-.77-2.17-1.73.35-1.77-.39-1.86-1s.19-1.22-1.4-1.1a5.43,5.43,0,0,1-2.78.9,157.23,157.23,0,0,1-18.8,0c-.8,0-1.51.24-2.28.34-1.56.23-2.55.8-2.84,1.73s-.49,2.15,1.41,2.85a31,31,0,0,1,8.48-1.59c1.56-.13,2.49.11,3.17,1,1.28,1.63,1.35,1.61-1.37,2.42a32.89,32.89,0,0,1-10.23,1.09,7.9,7.9,0,0,1-2.5-.79c-.75,1.47-2,2.91-1.07,4.52.87.12,1.29-.32,1.88-.53,1.89-.67,2.84-.58,4.23.42a3.12,3.12,0,0,0,1.58.86c1.75.18,2.2.9,2.33,1.77s.5,1.33,1.78,1.67a7.26,7.26,0,0,1-1.62.41c-1.16-.05-1.44.35-1.6.9-.22.76-1,1.12-2.33,1a2.38,2.38,0,0,1-1.89-.72c-.3-.47.18-.81.64-1.16s1.85-.58,1-1.15-1.6.14-2.29.42c-1.3.53-2.44,1.18-3.62,1.8a5.51,5.51,0,0,1-4,.46,2.71,2.71,0,0,0-2.77.55c-1,1-2.4,1.9-3.45,2.9a8.86,8.86,0,0,1-3,1.53l.35.4c1.05.7,1,1.3-.09,2-1,.64-1.92,1.38-1.92,2.34.74.87,1.77.6,2.7.19a61.31,61.31,0,0,0,9.26-4.73,4.39,4.39,0,0,1,5.22.35,3.22,3.22,0,0,0,4.47.43.8.8,0,0,1,.63-.15,2.65,2.65,0,0,0,2.86-.65,2.39,2.39,0,0,1,2.56-.54,7.42,7.42,0,0,0,1.78.17,2.44,2.44,0,0,1,2.14.81c.85,1.07,2.39,1.57,4.3,1.74a4.15,4.15,0,0,1,2,.48,1.55,1.55,0,0,0,1.32.19,4.38,4.38,0,0,1,3.5.46c1.13-.37,1.16-1,.87-1.59a2.78,2.78,0,0,1-.22-1.89,2.81,2.81,0,0,0-.42-2c-.68-1.2-.32-1.86,1.65-2.34,3.65-.89,4.2-2.76,4.65-4.7a1.51,1.51,0,0,0-.89-1.36c-.36-.21-.65-.45-.54-.76.35-.94-.64-1.37-1.91-1.51-4.25-.48-6.48-4.12-4.69-6.34.45-.55.94-.5,1.73-.34A9.1,9.1,0,0,0,188.62,470.08Z"
            />
            <path
              class="cls-31"
              d="M411.22,470.09c-1.09-.55-.26-1.33-.72-1.95l-1.88-.84c-5.18.86-10.5.75-15.8.75a2.19,2.19,0,0,1-1-.16c-1.24-.8-2.46-.47-3.75-.05a26.24,26.24,0,0,1-4.77.65c-1.16.15-.73-.62-1.27-.84-1.73,1.28-1.68,2.59-.24,3.93,1.66-.22,2.91-1,4.66-1.11,1.08-.07,2.13-.27,3.22-.37,2.81-.25,2.82-.25,4.11,1.18a4,4,0,0,0,.61.53c1.39,1,1.4,1.21-.49,1.84a29.94,29.94,0,0,1-13.32,1.4c-.63-.08-1.3-.35-1.72.19-.85.83-1.13,1.68-.39,2.59a2,2,0,0,0,1.52,0c2.85-.67,2.85-.67,5,.7a3.56,3.56,0,0,0,1.49.59c1.21.15,1.65.63,1.83,1.3a2.19,2.19,0,0,0,1.09,1.77c.26.14.27.33,0,.48a3.37,3.37,0,0,0-1.41,1.71c-.24.5-1,.45-1.68.39-2.21-.22-4.4-.51-6.6-.78a14.77,14.77,0,0,0-5.35-.17,2.16,2.16,0,0,1-1.94-.59,1.71,1.71,0,0,0-1.46-.51c-.78.15-.56.58-.48.92.23,1-.53,1.65-2.06,2-1.05.25-1.68.53-.49,1.11.95.45.32.91-.06,1.33-.5.57-1.46,1-1.69,1.64.79.85.32,1.47-.72,2.19s-2.16,1.47-2.16,2.52a2.26,2.26,0,0,0,2.63.26c2-.92,4.06-1.82,6-2.78a1.69,1.69,0,0,0,1-1.12c.17-.8.95-1.38,1.84-1.93a2.41,2.41,0,0,1,2.77-.24,3.48,3.48,0,0,0,1.38.22,7.49,7.49,0,0,1,3.66,1.07,2.57,2.57,0,0,0,2.39.35,1.91,1.91,0,0,1,.89,0,2.55,2.55,0,0,0,2.85-.62,2.34,2.34,0,0,1,2.55-.55,4.8,4.8,0,0,0,1.42.15,3,3,0,0,1,2.7,1,5,5,0,0,0,3.22,1.45c1.1.18,2.31.15,3.14.74a1.35,1.35,0,0,0,1,.05,4.39,4.39,0,0,1,3.51.46c1.07-.33,1.18-.93.9-1.48a3.49,3.49,0,0,1-.23-2.22,2.77,2.77,0,0,0-.43-1.78c-.66-1.18-.36-1.83,1.49-2.29,3.84-.95,4.52-2.86,4.79-5a1.49,1.49,0,0,0-.87-1.14c-.36-.2-.68-.43-.56-.75.37-.93-.63-1.27-1.86-1.54-4.4-1-6.28-3.29-4.93-6,.35-.69.82-.9,2.09-.65A8.78,8.78,0,0,0,411.22,470.09Z"
            />
            <path
              class="cls-32"
              d="M351.4,470.29c-.44-.37-.93-.7-.75-1.23s-.24-.67-1-.72a38.84,38.84,0,0,0-4.31.19c-1.7,0-3.22-.62-4.76-.57s-2.81.9-4.53.89c-2.54,0-5.08-.08-7.62.06-1.71.09-3.35.33-5,.56a3.24,3.24,0,0,0-1.51.56c-.32.24-.5.51-.25.8s.68.26,1.11.25a38.68,38.68,0,0,0,4.47-.51,28.8,28.8,0,0,1,3.39-.39,3.24,3.24,0,0,1,2.81.93,5.2,5.2,0,0,0,1.48,1.21c1.24.75,1.22.93-.33,1.54a29.39,29.39,0,0,1-15.81,1.52c-1.56.48-1.08,1.33-1.1,2.09a.94.94,0,0,0,.14.33c.38.49.91.55,1.75.32,3.13-.86,2.9-.66,5.44.48,2,.9,3.28,1.81,3.93,3.25.3.67.77,1.13.07,1.81s-.08,1.24.55,1.79c.4.36,1,.7.51,1.16s-1.25.36-2,.39c-1.4.06-2.76-.23-4.16-.22a22.88,22.88,0,0,0-3.61.21,8.47,8.47,0,0,1-5.31-.46,2.17,2.17,0,0,0-2.46.39c-2,1.63-4.4,3-6.48,4.62-.81,1.36-.09,2,2.34,2.13a65,65,0,0,0,6.62-3.64,4.73,4.73,0,0,1,5.82.3,3.11,3.11,0,0,0,4.39.14.94.94,0,0,1,.68,0,2.15,2.15,0,0,0,2.65-.5c.61-.78,1.47-.89,2.81-.64,2.41.45,2.93.58,4.54,1.63a3.52,3.52,0,0,0,1.58.7c2.33.25,4.42,1.24,7,.79a2,2,0,0,1,1.58.39c1.63,0,1.36-.68,1.13-1.16a2.85,2.85,0,0,1-.19-2.21c.2-.62-.2-1.19-.55-1.76-.75-1.27-.5-1.73,1.58-2.31,3.61-1,4.61-2.86,4.87-5,0-.45-.38-.81-.93-1.12s-.71-.49-.64-.84c.18-.86-.65-1.28-1.89-1.44-4.3-.58-6.32-4-4.77-6.25.45-.65,1.07-.62,2-.42A8.41,8.41,0,0,0,351.4,470.29Z"
            />
            <path
              class="cls-33"
              d="M62,478.24c.15.51.29,1,.43,1.52,1.19-.25,2-.87,3.34-1s2.29,0,2.9.72a3.52,3.52,0,0,0,2.71,1.21c1.23.1,1.56.82,1.56,1.51a1.44,1.44,0,0,0,1.16,1.67c.81.27.34.51-.07.74-1.32.71-1.26,1.46-.19,2.25s1.59,1.28-.63,1.53c-.89.1-.45.39-.11.6a2.8,2.8,0,0,1,1.26,1.15c.44.76,1.59.81,2.65.86a3.11,3.11,0,0,1,2.43.93,5.51,5.51,0,0,0,3.84,1.61c1.79.17,3.38,1,5.37.54.64-.13,1,.34,1.43.56,1.35-.23,1.6-.86,1.3-1.51a3.14,3.14,0,0,1-.17-2.11c.16-.69-.35-1.33-.67-2-.53-1-.29-1.58,1.38-2,3.91-1.06,5-3,4.86-5.29-.25-.87-1.31-1.55-1.54-2.46-.13-.53-1.27-.73-2.16-.85-4.32-.59-5.62-4.26-4.09-6.3.39-.52,1-.37,1.66-.25a9.76,9.76,0,0,0,4.89-.05c-.49-.32-1-.53-.78-1.15s-1.4-.92-2-1.45c-3.45.06-6.86.38-10.32.36a8.16,8.16,0,0,1-4-.53,2.11,2.11,0,0,0-1.54.06c-3,.85-6.32.51-9.47.83-.92.1-.45-.47-.75-.69-1.69.46-2.62,2-1.81,3A13.91,13.91,0,0,0,66,473.31c1.87-.27,3.37-1.06,5.34-1.21,1.19-.09,2.39-.25,3.58-.36a2.62,2.62,0,0,1,2.61.85,3.12,3.12,0,0,0,1.23,1.18c1.08.56.7.94-.33,1.33a30.74,30.74,0,0,1-13.93,1.7,3.35,3.35,0,0,0-1.41-.05Z"
            />
            <path
              class="cls-34"
              d="M272.55,466.44a1.24,1.24,0,0,0,.78,1.44c.73.37,1.62.73,1.13,1.49-.11.17.41.47.64.72a8.45,8.45,0,0,0,4.65,1.86c2.42-1.38,4.75-2.81,7.15-4.19-1.9,1.12-3.82,2.24-5.7,3.37-.46.28-1.31.54-.5,1.05,1,.3,2.11.54,3.1.9a11.48,11.48,0,0,0,5.11.43c1.43-.14,2.27.21,2.41,1s.69,1.22,1.88,1.55c1.38.37,1.53,1.22,1.89,2,.45.94.63,2,2.52,2.44,1-.11,1-.61.93-1-.09-1,.79-1.52,2.28-1.81a15.61,15.61,0,0,0,2.14-.59c.62-.21,1.09-.53,1-.95-.2-.65.3-1.09.95-1.54,1.58-1.12,1.52-2.84-.15-4-.4-.28-.88-.5-.66-.92.38-.75-.36-1.14-1.32-1.46a2.93,2.93,0,0,0-.66-.18c-3.19-.22-4.36-1.74-5.7-3.12-1.51-1.55-.44-3.05.46-4.54.17-.26.62-.32,1.09-.24a4.21,4.21,0,0,0,1.59.13c1.13-.63,2.66-1.06,3-2.08L301,457.4c-.28-.29-.09-1-1.1-.71-1.89.5-3.83.2-5.74.31-2.66.15-5.35.51-8,.42-4.09-.14-8.24.21-12.27-.47a2.71,2.71,0,0,1-1.11.21c-2.45.17-3.11.69-3.69,2-.48,1.14.18,2.05,1.29,2.92a29.48,29.48,0,0,1,7.38-1.65c.48-.06,1-.13,1.43-.17,3.15-.23,3.52-.11,5,1.53s1.48,1.69-1.46,2.57a31,31,0,0,1-7.65,1.3A4,4,0,0,0,272.55,466.44Z"
            />
            <path
              class="cls-35"
              d="M352.47,480.41a2.45,2.45,0,0,1-1.74,2.77c-.1.05-.28.12-.26.14.85,1.54-1.65,1.37-2.77,1.78-2.23.81-2.7,1.26-1.68,2.69a1.93,1.93,0,0,1,.33,2.27c-.28.49,0,1,.37,1.45s.54.89-.51,1.13c-.66.07-.58.36-.35.56a22.61,22.61,0,0,1,2,2.61,3.77,3.77,0,0,0,1.08.85c1.16.63,1.81.51,2.28-.4.27-.55.35-1.12.65-1.66a.84.84,0,0,1,1.16-.42,3.21,3.21,0,0,0,2.79,0c1-.64.39-1.25,0-1.88-.08-.14,0,0,0-.11a1.17,1.17,0,0,1,.2-1.55c.92-1,.56-1.92-.56-2.79-.76-.6-1.66-1.13-2.4-1.74-1.14-.94-.83-1.66,1-2a21.92,21.92,0,0,1,6.47,0,1.88,1.88,0,0,1,1.41.77,15.7,15.7,0,0,0,1.9,2.43.79.79,0,0,1,.22,1c-.21.35-.33.69.13,1,.65.25,1.1.84,2.16.49.63-.48,1.29-.94,1.88-1.44,1.23-1,1.09-1.49-.78-2.21,3-.47,4.37-1.5,3.31-3.26.66-.12.85.07,1,.25a2.92,2.92,0,0,0,3.6.73,4.11,4.11,0,0,1,1.78,0c3.06.4,6.12.8,9.19,1.17,1.28.15,2.31.08,2.26-1,0-.79,1-1.25,2.14-1.76-2.22-.42-1.78-1.56-2.12-2.44-.23-.61-.58-1-1.7-1a2.79,2.79,0,0,1-1.88-.75c-1.78-1.4-2.64-1.52-5.14-.66a3.58,3.58,0,0,1-1.49.33c-.31.83-1.3,1.4-2.22,2a1,1,0,0,1-1.33-.08,7.13,7.13,0,0,0-3-1.07,14.14,14.14,0,0,1-4.26-.84,4.68,4.68,0,0,0-2.45-.12c-1.74.28-3.8.15-3.87,1.81,0,.52-1.33,1-2.21,1.36a1.62,1.62,0,0,1-1.75-.16c-.57-.55.39-.57.87-.69,1.77-.44,2.93-1.17,3.05-2.32s-.92-1.74-2.28-2.3a5,5,0,0,0-2.61-.27c-.89.13-1.87.23-2.18.83s.51.83,1,1.17,1.31.75,1.9,1.16c.2.14.37.31.21.49s-.6.22-1,.17a2.17,2.17,0,0,1-1.92-1.3c-.13-.32-.14-.82-1-.75s-.66.53-.71.88a.83.83,0,0,0,.16.74C353.62,479.24,353.15,479.83,352.47,480.41Z"
            />
            <path
              class="cls-36"
              d="M299.54,460.19c-3-.57-2.91-.55-3.89,1.34-.85,1.66-.2,3,1.18,4.51,1.22,1.36,2.85,1.84,5,2.27,1.23.25,2.71.56,1.52,1.66a.26.26,0,0,0,.14.47c2.17.35,1.5,1.6,2.13,2.41.75,1-1.08,1.47-1.91,2.11-.34.27-.78.34-.36.75.59.58.2,1-.86,1.26-.28.06-.53.18-.82.23-2.5.39-4.17,1.12-3.61,2.86,0,.1-.21.24-.33.36.41.74,1.62.63,2.54.83a2.65,2.65,0,0,0,1.64-.36c1.15-1,2.56-1.88,3.07-3.09.15-1.09.73-1.54,2.58-1.72a35.82,35.82,0,0,1,6.71,0,3,3,0,0,1,2.1.91,1.54,1.54,0,0,0,1.79.61c.17-.73-.41-1.55.75-2.17a10.28,10.28,0,0,1,3.1-2.81c.67-.36.55-.94,0-1.47-1.36-1.28-.68-2.65,1.57-3.43.56-.19,1.28-.34.83-.87a1.68,1.68,0,0,1-1.5-1.46c-.28-1.35-1-1.72-3.23-1.48a13,13,0,0,1-6.55-.81,4.6,4.6,0,0,0-1.63-.45,14.2,14.2,0,0,1-6.79-2.05A10,10,0,0,0,299.54,460.19Z"
            />
            <path
              class="cls-37"
              d="M241.52,478.69c1.12-.38.64-1,.67-1.53a5.44,5.44,0,0,1,1.9-4.05c1.71-.14,2.09-.46,1.82-1.52-2.28-1.68-1.85-3.36,1.12-4.31-1.06-1.91-1.06-1.94-4.42-1.68a11.79,11.79,0,0,1-5.65-.76,10.57,10.57,0,0,0-3.86-.82c-2.23-.09-3.58-1.07-5.09-1.87-.31-.09,0-.58-.71-.4-2.12.15-4.26.4-6.21-.37-1.35-.53-2.08-.26-2.54.58a7,7,0,0,0-.74,4c.05.62,1.06,1,1.35,1.47,1,1.7,3.23,2.37,5.86,2.81,1.3.22,1.86.64,1.3,1.43a.53.53,0,0,0-.06.1,12.5,12.5,0,0,0,2.69,2.43.94.94,0,0,0,.81-.12c1.17-.89,1.75-.35,2.53.28a8.69,8.69,0,0,0,7,1.51c1.06-.24,1.31-1,2.73-1.32A4.72,4.72,0,0,0,241.52,478.69Z"
            />
            <path
              class="cls-38"
              d="M95.52,471.8c-1.91,0-3.88.22-5.65-.47-.74-.28-1.11,0-1.28.42-.73,1.76-1.36,3.39.62,5.19a7.66,7.66,0,0,0,4.21,1.81c1,.18,2.16.46,1.49,1.37-.22.31.09.56.58.7.66.18.83.49.8.87a1,1,0,0,0,1.21.13,2.12,2.12,0,0,1,2.54.34,5.23,5.23,0,0,0,3,1.27,5.3,5.3,0,0,0,3.76-.71,5,5,0,0,1,3.63-.66c.89.1,1.58.35,1.74.94.07.25.06.59.4.7,2.57.81,2.74,3,5.82,3.5,1.09.18.55.67.39,1.06a2.28,2.28,0,0,0,2.28.33,14.9,14.9,0,0,0,1.22-1.32c.36-.5.61-1.11-.39-1.43-1.21-.39-1.34-1-1.19-1.64.23-1-.29-1.59-2-1.8a2.78,2.78,0,0,1-2.38-1.47c-.38-.75-.71-1.51-1.06-2.27-.16-.35-.31-.83-.85-.91-2-.29-2.48-1.12-2.8-2.17-.19-.64-1.3-.84-2.34-.69a10.46,10.46,0,0,1-6-.67,4.91,4.91,0,0,0-2-.48,7.8,7.8,0,0,1-4.62-1.48Z"
            />
            <path
              class="cls-39"
              d="M324.37,466.88c0,.27-.23.46-.67.58-3.09.85-3.84,2.11-2.1,3.82.69.68.46,1.29-.41,1.58a2.89,2.89,0,0,0-2.3,2.6,3.12,3.12,0,0,0,2.19.62,32.06,32.06,0,0,0,14.44-2.19c1.52-.66,1.52-.89,0-1.65-.55-.27-1.19-.54-1.39-1-.72-1.56-2.08-1.57-4.91-1.3-2.2.22-4.31.71-6.55.84-.29,0-.6.14-.77-.09s0-.35.23-.49a3.28,3.28,0,0,1,1.54-.54,72.29,72.29,0,0,1,11.05-.53c1.73.07,3.95.23,5.26-.92.38-.33.77-.08,1.1,0a16.53,16.53,0,0,0,8.58.09,1.54,1.54,0,0,1-1.09-1.62c0-.49-.28-.87-1.21-.86a2.08,2.08,0,0,1-2-.87,1,1,0,0,0-1.28-.54.89.89,0,0,1-.35,0c-1.45-1.4-5.37-1-6.16-2.9-.15-.37-.62-.69-1-1s-.77-1.06-1.69-1-.69.74-.93,1.15c-.32.56-.68.84-1.65.42a1.6,1.6,0,0,0-2.22.48c-.44.62-.86,1.25-1.33,1.87a2.87,2.87,0,0,1-1.69,1.08c-1.36.36-2.15.92-1.82,1.86C325.4,466.88,324.81,466.82,324.37,466.88Z"
            />
            <path
              class="cls-38"
              d="M352.47,480.41c1.16-.47,2.21-.89.91-1.85-.49-.35-.28-1,0-1.45.83,0,.5.42.57.65a2.52,2.52,0,0,0,2.06,1.5,2.71,2.71,0,0,0,2-.23c.65-.45-.2-.7-.61-1-.78-.5-1.6-1-2.44-1.45s-.68-.75.3-1a5.18,5.18,0,0,1,5.08,1c1,1,.47,2.19-1.34,2.87-.4.15-.9.21-1.28.38s-1.46-.06-1.44.44.68.8,1.43,1a1.77,1.77,0,0,0,1.75-.22c1-.86,3.5-1.25,2.65-2.77-.16-.28.48-.33.75-.19a2.46,2.46,0,0,0,2.26-.12,3.79,3.79,0,0,1,2.85.23,5.52,5.52,0,0,0,3.88.42c-.26-.59-.51-1.18-.79-1.76a1.39,1.39,0,0,0-1.19-.88c-1.68-.11-2-.72-2.09-1.55s-1-1.26-2.34-1.09a12.21,12.21,0,0,1-6.68-.86,1.37,1.37,0,0,0-.5-.13c-2.85-.07-4.83-1.13-6.88-2.11-1.86,0-3.75.17-5.44-.5a1.16,1.16,0,0,0-1.33.25c-1.4,1.29-.83,3.74.4,5.12s2.84,1.91,5.06,2.24c.52.08,1,.3.85.58-.54.84.11,1.31,1.2,1.73C352.52,479.86,352.46,480.16,352.47,480.41Z"
            />
            <path
              class="cls-40"
              d="M273.9,457a4,4,0,0,0,2.65.69c3,0,6,.11,9,.15s5.87-.29,8.8-.49a5.72,5.72,0,0,1,1.6,0,6.16,6.16,0,0,0,3.49-.24c1.06-.45,1.16.05,1.55.34l-.09-1.17c0-.59-.45-1-1.54-.94a2.33,2.33,0,0,1-1.81-.57c-.52-.55-.61-1.43-2.34-1a.32.32,0,0,1-.16,0c-.4-1.76-3.68-.67-4.91-1.75s-2.23-2-3.37-3a6,6,0,0,0-.88-.68c-.59-.38-1.05-.29-1.29.19a4.54,4.54,0,0,0-.32.72c-.3.87-.79,1.38-2.35.61a1.52,1.52,0,0,0-1.92.32,13.23,13.23,0,0,0-1.1,1.58,4.94,4.94,0,0,1-3.33,2.4c-1.14.29-1.66.92-1.38,1.69C274.34,456.16,274.45,456.58,273.9,457Z"
            />
            <path
              class="cls-41"
              d="M382,467.65c-.09.24-.2.48-.27.73-.12.46.13.7,1,.53,2.27-.43,4.87-.24,6.87-1.22.29-.14.76-.26,1-.05,1.35,1.43,3.77.77,5.53.79,3.05,0,6.12-.34,9.22-.28a4.66,4.66,0,0,0,3.31-.85c0-.84.14-1.7-2-1.66a1.37,1.37,0,0,1-1.14-.63c-.31-.44-1.41-.66-1.5-.76-1-1.2-3.6-.67-4.84-1.58-1.07-.79-1.87-1.67-2.84-2.49-.39-.34-.65-.91-1.49-.81s-.62.63-.77,1c-.27.68-.7,1.09-1.93.49a1.41,1.41,0,0,0-1.87.34c-.41.52-.73,1.06-1.09,1.59a3.91,3.91,0,0,1-2.53,1.73c-1.05.27-1.59.8-1.35,1.49s-.2,1.22-1.63,1.26A2.91,2.91,0,0,0,382,467.65Z"
            />
            <path
              class="cls-18"
              d="M66.71,469.23c-.29.36-1.14.7-.51,1.13s1.08-.12,1.64-.15q3.22-.19,6.47-.33a8.71,8.71,0,0,0,1.77-.18c1-.25,2-1,2.94.08.12.14.91.07,1.39.09,3.39.16,6.75-.27,10.14-.21a8.51,8.51,0,0,0,2.2-.46c0-.94.07-1.91-2.28-1.91a1.05,1.05,0,0,1-.84-.53,1.49,1.49,0,0,0-1.79-.77.6.6,0,0,1-.64-.32c-.28-.61-.91-.75-1.94-.63a2.72,2.72,0,0,1-2.2-.78c-1-.85-1.94-1.74-2.91-2.6a1.53,1.53,0,0,0-1.19-.59c-.66.05-.65.48-.75.78-.27.79-.5,1.49-2.23.69a1.27,1.27,0,0,0-1.68.44c-.44.54-.77,1.12-1.16,1.69a3.68,3.68,0,0,1-2.33,1.56c-1.24.31-1.6.93-1.56,1.67C69.64,469.16,67.69,468.87,66.71,469.23Z"
            />
            <path
              class="cls-16"
              d="M454.28,467.08c-.07.54.46.61,1.24.66,1.68.1,3.34,0,5,0,3.13-.06,6.26-.07,9.38,0,1.87,0,3.65-.38,5.59-.14,1.29.15,1.68-.75,2.06-1.38,0-.25-.21-.46-.59-.46-1.4,0-2.29-.37-2.67-1.17-.13-.27-.79-.25-1-.36-1.63-1.1-4.8-.75-6-2.25a17.46,17.46,0,0,0-2-1.92c-.35-.31-.65-.8-1.41-.72s-.61.58-.73.92c-.28.79-.69,1.18-2.12.55s-1.46.62-2.4.7a7.53,7.53,0,0,1-3.79,3.13C453.46,465.18,453.68,466.19,454.28,467.08Z"
            />
            <path
              class="cls-42"
              d="M159.41,471.59a2.12,2.12,0,0,1-1.07-2.75c.23-.69.8-1.22,2.08-1.43a4.86,4.86,0,0,0,2.28-.55c.53-.84.94-1.71,1.45-2.55-2.27-.34-3.74-1.38-5.48-2.18a12.9,12.9,0,0,0-2.86-.21,11.14,11.14,0,0,1-4.69-.61c-1.13-.45-1.8-.16-2.18.51a7.65,7.65,0,0,0-.82,4.65c0,.37.44.65.73,1,.66.7,2,1.15,2,2.1,0,.26.56.46,1,.57.78.2,1.55.43,2.35.57,3.54.6,3.69.73,2.72,2.65C158.88,473.17,159.74,472.59,159.41,471.59Z"
            />
            <path
              class="cls-43"
              d="M164.15,464.31c-1.37.67-1.67,1.56-1.45,2.55a13,13,0,0,0,3.68.44c5,0,10,.05,15-.26,1.25-.08,3.33.19,3.22-1.26-.28-.06-.74-.09-.82-.2-.67-1-2.68-1.15-3.55-2a1.29,1.29,0,0,0-1.08-.31,3.6,3.6,0,0,1-3.24-1.06c-.91-.76-1.69-1.57-2.55-2.35a1.41,1.41,0,0,0-1.08-.51c-.6,0-.66.39-.74.65-.26.9-.54,1.61-2.44.75a1.17,1.17,0,0,0-1.49.51c-.51.64-.89,1.33-1.4,2A2.39,2.39,0,0,1,164.15,464.31Z"
            />
            <path
              class="cls-44"
              d="M249.24,465.57c4.43,1.05,9.06.95,13.67.75,1.33-.05,2.65,0,4-.11,1.09-.07,2.38,0,2.75-.85,0-1.09-.24-1.23-2-1.11a3.73,3.73,0,0,0-3.12-1,2.56,2.56,0,0,1-1.88-.91c-.94-.83-1.84-1.67-2.77-2.5a1.41,1.41,0,0,0-1.08-.52c-.6,0-.6.42-.69.68-.3.87-.59,1.63-2.46.73a1.16,1.16,0,0,0-1.42.38,9.51,9.51,0,0,0-.89,1.28,4.24,4.24,0,0,1-3,2.18C249.77,464.75,249.17,465.05,249.24,465.57Z"
            />
            <path
              class="cls-40"
              d="M267.67,464.25c1.4-.09,1.57.58,2,1.11.89.43,2.61.1,2.92,1.08,2.31-.69,5-.46,7.35-1a47.77,47.77,0,0,0,5.36-1.55c1-.34,1-.74.35-1.24a6.64,6.64,0,0,1-1-.89c-1.67-1.91-1.82-2-5.39-1.73a49.53,49.53,0,0,0-6.49,1,5.07,5.07,0,0,0-2.35,1.13C270.65,463.35,268.77,463.63,267.67,464.25Z"
            />
            <path
              class="cls-45"
              d="M454.28,467.08c.18-.23.3-.44.16-.71-.44-.9.19-1.53,1.55-1.94a3.29,3.29,0,0,0,2.68-2.91,10.13,10.13,0,0,1-5.23-1.75,1.68,1.68,0,0,0-1-.42,8.51,8.51,0,0,1-4.83-.19c-.88-.33-1.38-.29-1.78.32-1.44,2.22-.78,4.23,1.65,6.07a4.59,4.59,0,0,0,2,.68c1.11.2,2.39.29,2.92,1.06Z"
            />
            <path
              class="cls-41"
              d="M378.82,475.24a31.75,31.75,0,0,1,4.14.27,28.94,28.94,0,0,0,12.36-2.11c1.21-.49,1-.85.12-1.32a3.1,3.1,0,0,1-1.65-1.49c-.23-.69-1.11-1-2.12-.91-3.48.28-7.15.29-9.92,1.9.39.47.16.92-.54,1.11A2.73,2.73,0,0,0,378.82,475.24Z"
            />
            <path
              class="cls-46"
              d="M119.66,464.5c3.14-.83,6.71-.37,9.87-1.11,1.12-.27,2.24-.54,3.32-.86.51-.16,1.55-.21,1.14-.75a2.29,2.29,0,0,0-1.88-.43,56.58,56.58,0,0,0-7.4.81l-.38-.31c.85-.43,1.73-.84,2.53-1.3.58-.34.6-.65-.43-.57-.35,0-.56.09-.58-.18-.09-.89-1.44-1.28-2.18-1.91a3,3,0,0,1-.5.1c-3.62.05-5,1.28-5.37,3.26a2.14,2.14,0,0,0,.78,1.8C119,463.52,119.59,463.94,119.66,464.5Z"
            />
            <path
              class="cls-40"
              d="M299.54,460.19c1.62.49,3.49,0,5.13.44-.89-.56-2.07-1-1.46-2,.11-.17-.37-.34-.7-.43C301.63,458.93,300.22,459.37,299.54,460.19Z"
            />
            <path
              class="cls-47"
              d="M254.34,488.53a2.3,2.3,0,0,0-2.09,1,1.63,1.63,0,0,1-2.51.36.62.62,0,0,0-.6-.11.39.39,0,0,0-.22.36,6.07,6.07,0,0,0,.19.82,3.57,3.57,0,0,1-1,1.65c-.28.23-.36.52,0,.79,2.95.41,4.74,1.89,7.24,2.72.68.22.67.64.72,1s0,.88.82,1.11h12.55a3,3,0,0,0,1.21-.11c1.82-1.52,4.44-.44,6.63-.74a.8.8,0,0,1,.48.1c.63,1.22,2.34.72,3.62.75,2.3.06,4.6,0,6.91,0-.13-.57-.93-.46-1.52-.48-1.5,0-3,0-4.54,0,1.09-.47,2.93-.21,3.3-1.25.09-.24.18-.05.22,0a3.2,3.2,0,0,0,2.5-.18c5.16-1.49,8.63-3.87,10.52-7,.54-.91.92-1.86.27-2.83a2.65,2.65,0,0,0-1.71-.49c-2.15,0-4.3-.1-6.45-.1-.22.06-.48.12-.5.27-.57,3.42-4.7,4.79-9.52,5.77a6.38,6.38,0,0,0-1.34.3.48.48,0,0,0-.23.39c-.09,1.3-.1,1.31-2,.76a1.79,1.79,0,0,0-2.24.61c-.54.68-.31,1.48-1,2.2-2.23-.78-2-2.34-3.32-3.37-.91-1.22-1.49-1.35-3.82-.82-.47.1-.77.33-1.17-.13s-1.32-.43-2.09-.54c-1.31-.18-2.71-.39-3.32-1.15C259.05,488.53,256.69,488.58,254.34,488.53Z"
            />
            <path
              class="cls-15"
              d="M406.15,492.87c-.17-.92-.85-1.14-2.74-.78-.77.14-1.31.34-1.9-.23a4.42,4.42,0,0,0-1.69-.28c-2-.15-3.58-.64-4.36-1.8a2.2,2.2,0,0,0-2.26-.8,4.82,4.82,0,0,1-.54,0,8.39,8.39,0,0,0-4.93,1.07A1.57,1.57,0,0,1,386,490c-.43-.26-.87-.5-1.07.1-.7.76.32,1.7-.73,2.44-.37.26-.61.61-.47,1,2.16.82,4.53,1.42,6.66,2.28.83.33,1.38.6,1.4,1.21s.27,1,1.15,1.23l11.48,0a2.19,2.19,0,0,0,.71,0c2.24-1.62,5.25-.56,7.87-.81,1.44-.31,3-.31,4.46-.5,7.72-1,13.2-3.59,16.19-7.94,1.31-1.85.09-3-3.24-3.06a19.48,19.48,0,0,0-3.58-.09c-.22.06-.45.14-.47.3-.47,2.57-3.45,4-6.92,5.11a4.35,4.35,0,0,1-4.19-.33c-.94.06-.73.47-.66.81s.36.6.51.91.41.64-.06.9-1,0-1.45-.14c-1.18-.46-1.91-.2-2.38.5a16.3,16.3,0,0,0-1.08,2.38,3.68,3.68,0,0,1-2.17-1.94C407.6,493.74,407.48,493,406.15,492.87Z"
            />
            <path
              class="cls-48"
              d="M90.16,494.57c.17-1.08-1.12-.93-2.15-.81s-1.82.33-2.62-.24a3.06,3.06,0,0,0-1.2-.2c-2.18-.08-3.82-.62-4.67-1.86a2.18,2.18,0,0,0-2.15-.75,6.3,6.3,0,0,1-3-.58,1.8,1.8,0,0,0-1.64.84c-1.23,1.29-1.22,1.3-3.39.53,0,.48-.07.93-.1,1.38.19.36.44.68-.14,1.07-1.13.75-1.36,1.79-2.17,2.65-.61.66.95,1,.92,1.62.4-.68,1.15-1,2.41-.86,1,.08,2.06,0,3.09,0,.69,0,1.31,0,1.51.53s1,.33,1.52.34h5.82c-.09.54-.68.44-1,.39-2-.31-3.77.21-5.62.45-.49.06-.79.16-.78.47s.26.54.83.6a87.81,87.81,0,0,0,12.14.14c.65,0,1.31-.13,2-.13s1-.1,1.06-.54-.45-.48-1.06-.55a28.44,28.44,0,0,0-6-.42l0-.41c1.7,0,3.39,0,5.08,0,.8,0,1.74.17,2-.58.12-.37.78-.27,1.24-.28h3.65c.72,0,1.45-.07,1.67.54s1,.32,1.55.32c3.22,0,6.45,0,9.67,0-.25-.66-1.19-.48-1.89-.49-2.35,0-4.7,0-7.08-.1a46.79,46.79,0,0,0,7.76-1.6,15.52,15.52,0,0,0,8.64-6.1c.47-.68.74-1.45-.17-2.13a29.74,29.74,0,0,0-5.09-.27c-.31.07-.48.2-.5.4-.31,2.66-3.22,4.1-6.92,5.18a12,12,0,0,1-4.27.14c-.6.46,0,.89.12,1.32.07.26.12.51-.25.7a1.42,1.42,0,0,1-1.16-.05c-1.7-.48-2-.4-2.77.68-.23.33-.25.75-.92.88a1.76,1.76,0,0,1-2.08-.69C91.72,495.48,91.56,494.75,90.16,494.57Z"
            />
            <path
              class="cls-49"
              d="M355.39,492.23a3.08,3.08,0,0,0,.4.7c.5.52.14.87-.53,1.21a1.71,1.71,0,0,1-1.76-.17c-1.22-.77-1.72-.29-2.05.4a16.3,16.3,0,0,0-.77,2.08c-.15.5-.48.52-1.06.22a4.08,4.08,0,0,1-1.52-1.19c-.64-.94-1.26-1.89-1.89-2.84-.17-.79-1-.6-1.91-.49-3,.39-7.47-.78-9-2.36a3.16,3.16,0,0,0-2.17-.67c-2.4-.23-4.5-.56-5.63,1.24-.27.42-1.16,0-1.62-.32-.84-.51-.75,0-.85.27-.64.75-.09,1.57-.43,2.34a3.36,3.36,0,0,0,1.56.87,18.69,18.69,0,0,1,2.92,1.69,8.59,8.59,0,0,1,3.67,3c1.75.13,3.52-.12,5.26.15a1.43,1.43,0,0,0,1-.24c.44-.25.35-.78,1.31-.76,1.7,0,4.18-.39,5,.12,2.05,1.33,4.34.6,6.47.73,2.59.15,5.23,0,7.84,0,1,0,2.24.28,2.6-.7.09-.26.87-.17,1.34-.17l4.93,0c.21-.46-.49-.48-.83-.46a3.45,3.45,0,0,1-3.55-1.75l-.54-.79a9.86,9.86,0,0,1,3.05-2.88c1-.6,1-1.17-.21-1.68-.83.05-1.16-.47-1.85-.58-1.79,1.93-4.73,2.68-8.26,2.83A1.75,1.75,0,0,0,355.39,492.23Z"
            />
            <path
              class="cls-50"
              d="M141.17,494.16a9.55,9.55,0,0,1,2.56-2.5c1.27-.77,1-1.31-.75-1.83-2.85-.16-4.83-1-6-2.55a2.79,2.79,0,0,0-2.61-.87,7.19,7.19,0,0,1-3.15-.34,2.32,2.32,0,0,0-2.7.44c-.32.3-.55.63-.85.94a2,2,0,0,1-2.72.31c-.28-.16-.53-.48-1-.35s-.3.51-.27.77c.06.6.23,1.2.33,1.8,0,.28-.1.5-.67.49-.67.64.05,1,.87,1.12,1.6.32,2,.92,1.64,1.83-.3.76-.07,1.48,1.27,1.79,1.94.45,2.38,1.3,2.24,2.39a.9.9,0,0,0,.5.62l3.65,0c.66,0,1.39.06,1.45-.53,0-.2.26-.33.6-.33l5.65,0c1,0,.31.74,1.05.84.85-.74.53-1.48-.15-2.16A2.92,2.92,0,0,1,141.17,494.16Z"
            />
            <path
              class="cls-51"
              d="M183.54,492.87c-.17-.92-.84-1.14-2.74-.78-.76.14-1.34.36-1.89-.23a3.59,3.59,0,0,0-1.51-.26c-2.08-.12-3.72-.61-4.54-1.81a2.29,2.29,0,0,0-2.27-.8,5.77,5.77,0,0,1-.72,0,7.73,7.73,0,0,0-4.74,1.06,1.55,1.55,0,0,1-1.72-.06c-.88-.55-1-.19-1.07.3.14,1-.61,1.87-.84,2.81A8.47,8.47,0,0,0,164,494a15.08,15.08,0,0,1,2.39,1.12c1.56.77,3.16,1.45,3.3,2.8,0,.16.43.24.68.33,2.67,0,5.34,0,8,0,1,0,1.94.19,2.47-.67.29-.46,1.67-.19,2.55-.19,1.51,0,3.25-.44,4.26.72.13.15.89.14,1.37.14,3.51,0,7,0,10.55,0-.31-.69-1.33-.52-2.09-.53-2.55,0-5.11,0-7.65,0-1.45.1-1-.88-1.83-1.13a5.08,5.08,0,0,1-2.8-2.55A1.87,1.87,0,0,0,183.54,492.87Z"
            />
            <path
              class="cls-52"
              d="M363.5,494.4c-.23,1.62,1.34,2.74,3.95,2.81.35,0,.73,0,1,.19,0,.64.44.94,1.59.85.7-.06,1.41,0,2.12,0a3.2,3.2,0,0,0,.87-.53c1.56-1.44,3.8-1.77,6.38-.92a6.28,6.28,0,0,0,3.45.33c.64-.14,1.5-.47,1.16-.81-.94-.95-.2-1.85-.11-2.77,1.11-1.06,1.89-2.16,1.06-3.43-.75.1-1.4.27-2-.32a6.15,6.15,0,0,0-3.37-1.15c-1-.13-2,0-2.62-.68-.24-.3-.71-.11-1.08,0-1.68.72-3.24,1.47-3.4,2.83a1.41,1.41,0,0,1-.93,1c-1.9.88-3.85,1.71-5.71,2.62A2.29,2.29,0,0,1,363.5,494.4Z"
            />
            <path
              class="cls-53"
              d="M161.61,493.09c.82-.88,1.67-1.76.73-2.8-1,.85-2.91.87-3.46-.12-.79-1.42-2.65-1.33-4.42-1.54-.39,0-.8,0-1,.16-1.08,1.18-3.41,1.7-4.43,2.92-.49.59-1.75.58-2.52,1-1,.49-1.95,1-2.93,1.43-.79.38-1.59.72-2.43,0-.61.49-.65,1.11-.08,1.48a2.47,2.47,0,0,1,1.19,2.57h7.25a3.61,3.61,0,0,0,.86-.54c1.55-1.44,3.8-1.77,6.38-.92a7,7,0,0,0,2.58.41c1.82-.07,2.36-.53,1.67-1.52a1,1,0,0,1,.09-1.34C161.4,493.93,161.78,493.54,161.61,493.09Z"
            />
            <path
              class="cls-54"
              d="M453.51,492.86c.44-.54,1.45-1,.73-1.7L447.47,495c.66-1,2-1.56,3.14-2.31.27-.18.67-.3,1-.48,1.59-1,1.59-1-.32-1.73a2.23,2.23,0,0,1-1-.73c-1.08-1.46-4.54-1.63-6.32-.44a46.7,46.7,0,0,1-6.89,3.9,37.79,37.79,0,0,0-4.3,2.25c0,1.08.89,1.69,2.88,1.93-.06.66.44.91,1.59.86,1.3-.06,2.61,0,3.92,0,.94-.23,1.15-.81,1.64-1.25a2.67,2.67,0,0,1,2.11-.61,13.59,13.59,0,0,1,4.67.68,4.67,4.67,0,0,0,3-.09c.61-.18,1.05-.49.57-.86-1-.77-.59-1.47.06-2.2C453.44,493.57,453.39,493.2,453.51,492.86Z"
            />
            <path
              class="cls-55"
              d="M239,495.87c2.54-1.53,5.09-3.05,7.62-4.59.65-.39,1.85-.86-.27-1a1.06,1.06,0,0,1-.68-.31c-.94-1.71-3.92-1.3-5.87-1.94-.64-.22-1.1.2-1.49.45-1.78,1.17-3.5,2.36-5.29,3.52a10.59,10.59,0,0,1-1.82.87c-1.26.51-1.76.22-1.69-.6-1.75.53-3.06,2.36-2.43,3.41,1,1.61,1,1.61,3.94,1.63a3.63,3.63,0,0,1,1.4.1c-.1.66.36.95,1.51.87.7-.05,1.41,0,2.11,0C236.93,497.41,238,496.68,239,495.87Z"
            />
            <path
              class="cls-56"
              d="M209.77,497.38c.11.33,0,.73.75.87a76.58,76.58,0,0,0,14.91,0c.25-.19.37-.39.24-.62-1.33-.74-2-1.59-2-2.72.06-.86-.9-1.45-2.25-1.75-.82-.19-1.39-.48-1.28-1,.27-1.41-.26-2.53-2.78-3.05-.2,0-.33-.2-.51-.3-1.44-.29-1.61.4-2,.9a19.89,19.89,0,0,1-5.12,5.17c-.68.47-1.53.81-2.25,1.25-.47.28-1,.63-.7,1s1,.11,1.51.16A4.42,4.42,0,0,1,209.77,497.38Z"
            />
            <path
              class="cls-57"
              d="M209.77,497.38c-.74-.45-1.76-.05-2.59-.3-.13-.46.43-.72.93-.95a17.46,17.46,0,0,0,7.24-6.35c.28-.4.23-1,1.35-1,.21-.14.23-.28,0-.44-.19-.79-1.16-1.17-2.27-1.48a9.06,9.06,0,0,0-2.08-.68,2.23,2.23,0,0,0-1.59,0c-.29,5.53-8.28,9.42-17,10.23-1.13.11-2.28.2-3.42.28-1.33.1-1.95.52-1.41,1.33h8.87a3.14,3.14,0,0,1,1.71.2h2.17c.3,0,.78.05.88,0,1.82-1.6,4.56-.53,6.81-.82A2.17,2.17,0,0,1,209.77,497.38Z"
            />
            <path
              class="cls-58"
              d="M116,487.93c-.15,3.52-3.54,5.86-8.25,7.68a30.37,30.37,0,0,1-8,1.65c-.52.05-1.49.08-1.42.5s1,.25,1.53.26c2.37,0,4.74,0,7.11,0a3.06,3.06,0,0,1,1.71.2l3.07,0c.77,0,1.57.08,1.77-.59.1-.37.75-.28,1.21-.29l4.15,0c.11-.1.11-.19,0-.28-.53-.29-1.29-.12-2.08-.4,2.77-2.22,5.08-4.58,6.13-7.29-.33-.5-1.24-.56-1.84-.84a5.25,5.25,0,0,1-2.19-.44A2.75,2.75,0,0,0,116,487.93Z"
            />
            <path
              class="cls-59"
              d="M435.62,497.39a4.43,4.43,0,0,1-2.88-1.93c-.54-.29-.47-.66-.22-1a11.54,11.54,0,0,1,2.71-2.75c1.5-1,1.49-1.08-.18-1.9l-.84-.4a1,1,0,0,0-1.06-.44c-3,4.27-8.52,6.75-16.09,7.71-1.05.13-2.16,0-3.22.24-.46.09-.76.19-.83.47l0,.41c.43.43,1.15.3,1.78.32,2.57.07,5.14-.14,7.7.1l4.7,0c.72,0,1.46.07,1.64-.55.12-.44.83-.32,1.34-.33C432,497.37,433.81,497.38,435.62,497.39Z"
            />
            <path
              class="cls-60"
              d="M298.85,486.62c0,2.56-1.71,4.66-4.63,6.53a19.15,19.15,0,0,1-6.06,2.79c-1.93.47-1.9.51-3.61-.25-.16.44,1,.61.54,1a4.75,4.75,0,0,1-1.78.47c-.84.19-1.69.35-2.68.56.66.47,1.42.25,2.06.29,1.84.14,3.74-.24,5.54.23h.33a.91.91,0,0,0,.79,0c1,0,2,0,3.07,0a2.77,2.77,0,0,0,1-.1c.69-1.26,2.45-.68,3.77-.76,1.13-.07,2.28,0,3.43,0l.08-.15c-.58-.52-1.51-.33-2.32-.37a21.83,21.83,0,0,1-2.85-.11,15.46,15.46,0,0,1,2.86-2,12.65,12.65,0,0,0,4.12-4.13c.27-.44.78-.81,1-1.24a2.26,2.26,0,0,0,.09-1.18c-.23-.83-1.19-1.27-2.43-1.55a11.76,11.76,0,0,0-1.9-.19A1.13,1.13,0,0,0,298.85,486.62Z"
            />
            <path
              class="cls-61"
              d="M239,495.87a4.27,4.27,0,0,0-3,2.35l11.24,0c.36,0,.8,0,1-.17s.2-.72,1.08-.71a50.31,50.31,0,0,1,5.23.11c.67.08,1,1,2.27.75-.11-.28-.34-.55-.32-.82.07-.92,0-1.71-2-1.85a2.32,2.32,0,0,1-1.19-.62c-1.26-1.1-3.18-1.43-5.23-1.64-1.45.54-2.07,1.42-1.64,2.32.13.28.76.58.15.86a3,3,0,0,1-1.91,0,19.18,19.18,0,0,0-2.11-.61,24.56,24.56,0,0,0-3.21,0A2,2,0,0,1,239,495.87Z"
            />
            <path
              class="cls-62"
              d="M453.51,492.86c-.52.63-1,1.27-1.58,1.9s.06.91.59,1.24c.74.47.39.63-.44.79s-1.78.38-2.26.08c-1.62-1-3.76-.54-5.6-.85a1.25,1.25,0,0,0-1.3.35c-.59.62-1.2,1.23-1.79,1.85l9.24,0c.41,0,.93.06,1.17-.18s.2-.72,1.08-.7c1.75,0,4.28-.38,5.08.14,1.41.91,2.76.66,4.24.72a3,3,0,0,1-.37-1.36c.1-.65-.29-1.11-1.52-1.21a1.26,1.26,0,0,1-.5-.08C458.14,494.2,455.45,493.82,453.51,492.86Z"
            />
            <path
              class="cls-61"
              d="M161.61,493.09c-.46.54-1,1.06-1.35,1.61a.7.7,0,0,0,.16,1c.88.84.54,1.18-1.19,1.23a2.85,2.85,0,0,1-1.39-.15c-1.26-.72-2.85-.56-4.36-.74-1.85-.21-2.53.3-3.15,1.09-.28.35-.54.71-.8,1.07l7.06,0a1.83,1.83,0,0,0,1-.16c.38-.28.35-.76,1.31-.73,1.75.05,4.24-.38,5.1.14,2.05,1.25,4.25.51,6.33.73l-.15-.19c-.67-1.1-.34-2.6-3.24-2.81C166,493.85,163.62,493.61,161.61,493.09Z"
            />
            <path
              class="cls-63"
              d="M383.88,493.51c-.66.84-2,1.63-.32,2.59.5.28,0,.51-.45.65a4.55,4.55,0,0,1-3.4-.22c-1.56-.81-3.57-.52-5.19-.45-1.41.07-1.8,1.32-2.39,2.13l10.92,0a1.49,1.49,0,0,0,1.29-.42c.42-.5,5.18-.76,5.46-.29.65,1.11,2,.59,3.15.69a1.27,1.27,0,0,0-.24-.28c-.89-.63.2-1.8-.89-2.07C389.08,495.19,387,493.78,383.88,493.51Z"
            />
            <path
              class="cls-64"
              d="M332.75,498.23c-.12-.31-.36-.62-.32-.93.09-.83-.16-1.45-1.86-1.55a1.34,1.34,0,0,1-1.08-.51c-.76-1.4-2.93-1.88-4.77-2.58-1.56.55-2.75,2.35-2.15,3.25.46.7.14,1-1.11.89a4,4,0,0,1-1.35-.29c-1.61-.65-3.48-.48-5.26-.57-.9,0-1.48.28-1.17.9.21.26.74.37.86.68-.25.29-.72.2-1.11.2-3.39,0-6.78,0-10.18,0a25.75,25.75,0,0,1-2.6-.39l0,.07c-.13.65.35.87,1.45.86,4.43,0,8.85,0,13.27,0,.35,0,.9,0,1-.11,1.67-1.57,4.24-.43,6.31-.75C325.67,499.22,329.42,497.82,332.75,498.23Z"
            />
            <path
              class="cls-65"
              d="M216.74,488.35c0,.15,0,.3,0,.44,0,.5.26.81,1.2.87,1.44.1,1.88.64,1.75,1.44a10.75,10.75,0,0,0,0,1.39c0,.45.28.74,1.1.82,2,.21,2.67,1,2.53,2.1s.5,1.89,2.41,2.2c2.2-.54,4.48-.12,6.72-.23a1.83,1.83,0,0,0-1-.22c-1-.09-2.41.33-2.84-.25-.76-1-2.22-2.11-.47-3.31.58-.4.67-1,1.37-1.36a4.2,4.2,0,0,0,1.81-1.51,2.81,2.81,0,0,1-2-.65c-.94-.62-1.64-.39-2,.25a27.46,27.46,0,0,0-1.15,2.91c-.08.2.11.47-.29.57s-.72-.18-1-.32a5.11,5.11,0,0,1-2.66-2.73,2.4,2.4,0,0,0-1.27-1.38c-.1,0-.26-.09-.27-.14C220.48,487.22,218.24,488.36,216.74,488.35Z"
            />
            <path
              class="cls-47"
              d="M263.15,500.4a61.11,61.11,0,0,0,6.91-.22c.63-.05,1-.14,1-.57s-.34-.43-.88-.53c-3.49-.63-7.11-.42-10.66-.6-1.47-.07-2.63.64-4.1.69-.48,0-.4.39-.36.64s.51.31.94.37A51.64,51.64,0,0,0,263.15,500.4Z"
            />
            <path
              class="cls-66"
              d="M303.26,498.68a2.18,2.18,0,0,1-1.72.43c-.5,0-.82.09-.83.41s.16.55.77.61a72.51,72.51,0,0,0,12.59.08c.47,0,1,0,1.44-.06s1.1,0,1.19-.45-.4-.59-1-.72a7.7,7.7,0,0,1-1.89-.31C310.28,498.52,306.77,498.49,303.26,498.68Z"
            />
            <path
              class="cls-67"
              d="M331.57,500.41a64.39,64.39,0,0,0,6.79-.25c.56,0,.93-.12.93-.5s-.21-.47-.8-.57c-3.92-.71-7.94-.37-11.92-.42-.92,0-1.69.5-2.73.45-.55,0-.54.32-.54.58s.46.4,1,.47A53.52,53.52,0,0,0,331.57,500.41Z"
            />
            <path
              class="cls-68"
              d="M460.87,498.67a2.74,2.74,0,0,1-1.76.42c-.65,0-.81.24-.8.57s.18.45.72.5a86.5,86.5,0,0,0,12.47.11c.66,0,1.32-.09,2-.11.49,0,.82-.12.83-.44s0-.62-.52-.57c-1.51.13-2.68-.63-4.16-.48A80,80,0,0,0,460.87,498.67Z"
            />
            <path
              class="cls-69"
              d="M100.28,498.67a4,4,0,0,1-1.79.43c-.61,0-1.1.07-1,.52s.52.49,1.12.54a88.68,88.68,0,0,0,14,0c.6,0,.85-.2.86-.54s-.26-.53-.87-.53a2.74,2.74,0,0,1-2-.44C107.11,498.52,103.69,498.51,100.28,498.67Z"
            />
            <path
              class="cls-70"
              d="M397.74,500.41a59.25,59.25,0,0,0,7.05-.24c.64-.07,1.23-.1,1.25-.58s-.73-.41-1.28-.51c-2.86-.57-5.81-.36-8.73-.44a27.71,27.71,0,0,0-5.27.44c-.63.11-.71.32-.7.63s.5.39,1,.47A51.25,51.25,0,0,0,397.74,500.41Z"
            />
            <path
              class="cls-71"
              d="M376.25,500.4a57.63,57.63,0,0,0,7.2-.25c.62-.08,1-.17,1-.58s-.43-.4-.94-.49c-3.27-.57-6.64-.34-10-.48-1.64-.06-3,.44-4.51.48-.58,0-.56.31-.57.57s.34.43.9.51A52.11,52.11,0,0,0,376.25,500.4Z"
            />
            <path
              class="cls-72"
              d="M420.73,500.41a59.87,59.87,0,0,0,7.22-.24c.62-.07,1.05-.17,1.07-.58s-.5-.44-1.07-.54c-3.29-.57-6.67-.31-10-.43-1.59-.05-2.86.46-4.35.51-.57,0-.55.32-.54.58s.36.37.82.44A47.54,47.54,0,0,0,420.73,500.41Z"
            />
            <path
              class="cls-73"
              d="M173.18,500.41a54.65,54.65,0,0,0,6.34-.24c.59-.06,1.06-.09,1.07-.53s-.47-.46-1-.56c-3.23-.6-6.56-.32-9.84-.46-1.65-.07-3,.47-4.55.49-.53,0-.61.3-.55.57s.5.42,1,.49A57.1,57.1,0,0,0,173.18,500.41Z"
            />
            <path
              class="cls-74"
              d="M280.58,498.68a2.27,2.27,0,0,1-1.73.42c-.62,0-.84.2-.83.54s.18.46.71.5a77.7,77.7,0,0,0,12.58.1c.47,0,.95-.07,1.43-.08.66,0,1.23-.07,1.26-.56s-.59-.51-1.22-.54-1.39.16-1.71-.36A96.59,96.59,0,0,0,280.58,498.68Z"
            />
            <path
              class="cls-75"
              d="M127.42,500.42a59,59,0,0,0,6.62-.27c.56,0,.9-.12.93-.49s-.33-.49-.95-.6c-3.28-.58-6.64-.34-10-.46-1.65-.06-3,.48-4.53.51-.56,0-.57.31-.53.57s.52.4,1,.48A55.25,55.25,0,0,0,127.42,500.42Z"
            />
            <path
              class="cls-76"
              d="M443.65,500.38a52.64,52.64,0,0,0,7.05-.24c.64-.07,1-.2,1-.61s-.53-.36-1-.45c-3-.55-6-.36-9.05-.46a35.72,35.72,0,0,0-5.24.44c-.68.08-.69.33-.69.63s.46.4,1,.47A51.71,51.71,0,0,0,443.65,500.38Z"
            />
            <path
              class="cls-77"
              d="M347.35,499.1c-.64,0-1.41-.11-1.42.52s.6.49,1.22.55a89.58,89.58,0,0,0,13.9,0c.71,0,.92-.24.92-.62s-.45-.6-1.15-.64-1.46.47-1.83-.23a50.26,50.26,0,0,0-7.26,0h0C350.3,498.91,348.75,498.75,347.35,499.1Z"
            />
            <path
              class="cls-78"
              d="M212,500.17a5,5,0,0,0,2.09.23c3.43-.06,6.85.11,10.29-.21,1.33-.13,1.65-.37,1.45-1.06-3.91-.81-8-.66-12-.69-1.32,0-2.12.77-3.49.64-.37,0-.34.32-.34.53s.12.41.58.45A5.15,5.15,0,0,1,212,500.17Z"
            />
            <path
              class="cls-79"
              d="M190.06,498.67l-.37.21c-.47.39-2.16.66-.35,1.27a4.18,4.18,0,0,0,1.89.26c3.61,0,7.23.15,10.82-.23.63-.07,1.2-.06,1.19-.57s-.6-.54-1.23-.54-1.36,0-1.74-.39C196.87,498.5,193.46,498.51,190.06,498.67Z"
            />
            <path
              class="cls-80"
              d="M240.51,500.14H247c.71,0,1.39,0,1.34-.61s-.84-.34-1.35-.45c-3.14-.67-6.4-.3-9.59-.47-1.65-.09-3,.46-4.5.5-.59,0-.49.33-.48.58s.43.46,1,.46h7.08Z"
            />
            <path
              class="cls-81"
              d="M149.56,500.35a50.78,50.78,0,0,0,7.51-.22c.6,0,.8-.26.8-.59s-.3-.4-.79-.46a36.46,36.46,0,0,0-7.55-.4C148.91,499.24,148.82,499.79,149.56,500.35Z"
            />
            <path
              class="cls-82"
              d="M149.56,500.35l0-1.67a28.75,28.75,0,0,0-7,.39c-.55.1-.6.29-.62.55s.29.46.87.52A45.21,45.21,0,0,0,149.56,500.35Z"
            />
            <path
              class="cls-83"
              d="M212,500.17a2.39,2.39,0,0,0-1.18-.2c-.42,0-.64-.16-.64-.42s.23-.35.63-.43c3.74-.77,7.61-.46,11.4-.36,1.11,0,2.38.33,3.62.37-.58-.51-1.65,0-2.35-.42.42-.51,1.57,0,2-.48l-14.91,0c.27.28.91.15,1.36.4-.7.41-2.66.07-2.08,1.14C210.18,500.48,211.21,500.1,212,500.17Z"
            />
            <path
              class="cls-75"
              d="M118.89,497.18a1.55,1.55,0,0,0,0,.22c0,.61.5.87,1.58.86,3.14,0,6.28,0,9.41,0,0-.21,0-.41,0-.61-1.62,0-3.22.14-4.84.12A20.51,20.51,0,0,1,118.89,497.18Z"
            />
            <path
              class="cls-47"
              d="M280.58,498.68l10.5,0c-.35-.46-1.34-.05-1.73-.44h-.79c-1.87.44-3.82.08-5.73.21C282.08,498.51,281.24,498.29,280.58,498.68Z"
            />
            <path
              class="cls-51"
              d="M189.34,500.15c-1.13-.54.4-.83.35-1.27a4.75,4.75,0,0,0-.54,0c-.75.12-2,0-1.92.67S188.5,500.12,189.34,500.15Z"
            />
            <path
              class="cls-15"
              d="M483.52,498.69H494a2.42,2.42,0,0,0-1.69-.22C489.39,498.59,486.42,498.17,483.52,498.69Z"
            />
            <path
              class="cls-64"
              d="M303.26,498.68h10.53c-2.67-.46-5.41-.11-8.11-.19A4.49,4.49,0,0,0,303.26,498.68Z"
            />
            <path
              class="cls-51"
              d="M190.06,498.67h10.21a6.2,6.2,0,0,0-2.94-.2C194.91,498.55,192.45,498.2,190.06,498.67Z"
            />
            <path
              class="cls-48"
              d="M100.28,498.67h10.24c-2.58-.44-5.21-.11-7.82-.18A4.82,4.82,0,0,0,100.28,498.67Z"
            />
            <path
              class="cls-15"
              d="M422.52,498.24c-1.24-.44-2.6-.12-3.9-.2-1.85-.12-3.75.21-5.58-.22.09.55.81.43,1.37.43C417.11,498.26,419.82,498.25,422.52,498.24Z"
            />
            <path
              class="cls-15"
              d="M460.87,498.67h8.76A37.74,37.74,0,0,0,460.87,498.67Z"
            />
            <path
              class="cls-49"
              d="M351.73,498.67l7.26,0A24.54,24.54,0,0,0,351.73,498.67Z"
            />
            <path
              class="cls-49"
              d="M347.35,499.1a17.66,17.66,0,0,0,4.38-.43C350.24,498.73,348.64,498.38,347.35,499.1Z"
            />
            <path
              class="cls-84"
              d="M433.15,489l1.06.44a29.07,29.07,0,0,1,3.72-2.88,24,24,0,0,0,2.27-2.05c1.49-1.56,2.21-1.81,5.22-1.48s5.92.67,8.84,1.09c1.7.25,3.08.36,3.85-.83.22-.34.86-.59,1.37-.93a1.9,1.9,0,0,1-1.6-2c0-.74-.21-1.54-2.1-1.45a2.29,2.29,0,0,1-1.71-.71c-1.74-1.45-3.25-1.58-5.63-.46-.24.12-.48.22-.73.32-1,.65-1.21,1.68-2.91,2-1.35.23-1.59-.48-2.2-.88a2.4,2.4,0,0,0-1.53-.21,8.62,8.62,0,0,1-4.52-.91,2.55,2.55,0,0,0-2.71-.05c-.74.47-1.44.17-2.17.08-.62.38-.17.82-.19,1.23a1.48,1.48,0,0,1-1.19,1.47c-1,.31-1.38-.22-2-.5a7.94,7.94,0,0,0-6.2.2,4.35,4.35,0,0,1-4.95-.05l-.37-.24c-2-1.32-2.53-1.31-4.49.05a2.27,2.27,0,0,1-1.49,2.72c-.05,0-.12.06-.11.08.4,1.52-1.83,1.51-3.27,2-1.8.6-2.3,1.39-1.49,2.51a2.54,2.54,0,0,1,.31,2.61.73.73,0,0,0,.15.92c.73.65.58,1.28-.27,1.86a2.41,2.41,0,0,1,1.17,1.17,4,4,0,0,0,.65,1.12c.51.6,1,1.44,2.24,1.39,1,0,.46-.92.85-1.38.19-.22.19-.49.3-.73.59-1.25.74-1.3,2.44-.54a1.78,1.78,0,0,0,1.48,0c.69-.26.71-.6.57-1-.22-.66-1.49-1.21-.63-2,1.59-.76,1.91-1.51,1-2.51a16.68,16.68,0,0,0-3.13-2.5c-1.32-.88-1.06-1.56.83-1.95a18.35,18.35,0,0,1,6.81,0c.69.11.95.53,1.41.81a6.83,6.83,0,0,0,4.37,1.22c1.73.06,3.46.09,5.19.17,1.33.06,2.5,1.37,1.93,2.13C433.49,488.55,433.12,488.71,433.15,489Z"
            />
            <path
              class="cls-85"
              d="M451,472c-.13.81-1.61.93-2.23,1.49.75.2,1.4.32,1.57,1,.32,1.28,1.55,1.8,3.61,1.82,2.24,0,3.71-.5,4.11-1.74.25-.78.88-1.16,2.05-1.38a6.36,6.36,0,0,0,1.3-.38c.81-.37,2.5-.31,2.07-1.31-.7-1.61-1.25-1.74-3.64-1.68a51.14,51.14,0,0,0-5.17.5C453,470.55,451.64,471,451,472Z"
            />
            <path
              class="cls-16"
              d="M482,470.73l2.41.71c.6.18,1.3.06,1.4-.22.32-.9,1.43-.68,2.39-.71a4.5,4.5,0,0,0-3.83-.46C483.57,470.23,482.8,470.5,482,470.73Z"
            />
            <path
              class="cls-18"
              d="M63.08,476.75a20.5,20.5,0,0,0,7.77.38,27.37,27.37,0,0,0,8.5-2c.94-.41,1.3-.75.2-1.24a3.13,3.13,0,0,1-1.64-1.5,2.46,2.46,0,0,0-2.52-1,57.15,57.15,0,0,0-7.23,1,21.53,21.53,0,0,0-2.17,1,1,1,0,0,1-.82,1.18A2.47,2.47,0,0,0,63.08,476.75Z"
            />
            <path
              class="cls-86"
              d="M142.63,489.43a3,3,0,0,0,2.22-.56,43.62,43.62,0,0,0,4.55-3.71,2,2,0,0,1,2.33-.44,5.14,5.14,0,0,0,4.14-.37c1.46-.85,3.12-1.58,4.68-2.36.33-.16.71-.4,1.07-.11s-.27.37-.56.52c-1,.49-2.1,1-1.41,1.87a3.71,3.71,0,0,0,3.09.85c1.52-.1,2.16-.7,2.16-1.57,0-.17.09-.5.31-.42,1.6.58,1.74-.58,2.84-.69-2.16-.5-1.67-1.64-2-2.52-.24-.61-.61-1-1.72-1a2.28,2.28,0,0,1-1.74-.67c-1.41-1.64-3.33-1.66-6.08-.31-.23.12-.47.22-.71.33s-.69.5-1,.75c-1.45,1.16-1.45,1.17-3.24.32a5.51,5.51,0,0,0-2.56-.43,8.2,8.2,0,0,1-3.71-.71c-1.72-.82-3.12-.71-4.34.4a11.3,11.3,0,0,0-1.09,1.23,3.88,3.88,0,0,1-2.07,1.15c-1.55.4-1.61.65-.19,1.24.8.34,1.48.74,2.19,1.12s.88.73.6,1.16c-.47.7.08,1.26.57,1.82.7.8,2,1.48.88,2.53C141.53,489.08,142.22,489.29,142.63,489.43Z"
            />
            <path
              class="cls-87"
              d="M118.89,497.18a4.23,4.23,0,0,0,3.19.87c1.8-.07,3.61-.05,5.42,0a5,5,0,0,0,2.33-.43c.27-1.25-.05-2.25-2.53-2.64-1.28-.19-1.19-.89-1-1.52.47-1.49.34-1.66-2-2.09-.81-.15-1-.47-1-.88s.15-.76-.41-1.05a4.88,4.88,0,0,0-1.53,1.92,16.75,16.75,0,0,1-4.35,4.65c-.36.3-1.28.5-.91.94s1.2.16,1.83.22C118.27,497.19,118.58,497.17,118.89,497.18Z"
            />
            <path
              class="cls-43"
              d="M159.41,471.59c0,1-1.34,1.33-2.52,1.73,0,.14,0,.28,0,.42.23.62.86,1,2,1.07a33.18,33.18,0,0,0,12.28-1.5c1.87-.65,1.92-.78.68-1.88a2.82,2.82,0,0,1-.49-.69c-.56-.95-1.67-1.23-3.29-1s-3.44.39-5.15.6A6,6,0,0,0,159.41,471.59Z"
            />
            <path
              class="cls-88"
              d="M212.33,486.43a5.59,5.59,0,0,0,2.14.44c.33-.39.68-.77,1-1.16.57-.73.93-1.4-.79-1.85-.89-.23-1-.77-.69-1.31.47-.94.11-1.56-1.75-1.8a3.14,3.14,0,0,1-2.5-1.43c-.37-.72-.72-1.44-1-2.16a2.14,2.14,0,0,0-2-1.35,1.58,1.58,0,0,1-1.59-1.4c-.36-1.11-.93-1.35-2.86-1.15a10.54,10.54,0,0,1-5-.59A9,9,0,0,0,194,472c-2.33-.06-3.51-1.32-5.36-1.9-1.83-.07-3.75.27-5.42-.49a1,1,0,0,0-1.28.32c-.51,1.36-1.75,2.77-.47,4.13s2.17,2.86,5.36,3.06c1.1.07,2.22.38,1.33,1.29-.38.39,0,.59.56.75.88.27,1.09.72,1,1.26,2.15-.87,3.45-.18,4.94.75a5.27,5.27,0,0,0,5.29-.14,5,5,0,0,1,5.93.59c1.66,1.28,2.72,3,5.43,3.73C212.11,485.56,212.56,485.88,212.33,486.43Z"
            />
            <path
              class="cls-37"
              d="M228,488.58c.83-.22.7-.67.72-1.08.3-.44-.23-.74-.54-1.07s-.87-.83-.78-1.29c.27-1.36-1-2.23-2.62-3-1.12-.5-1.11-.81.19-1.16a5,5,0,0,0,2.28-1.62,4.86,4.86,0,0,1,4.19-1.47l.2-.1c-.28-.88-1.87-.55-2.54-.94-1.25-.73-1.73-.12-2.56.27s-.79.57-.15.93.5.75-.14,1.09a13.1,13.1,0,0,1-2.59,1.33c-1.42.44-1.42,1.11-.59,1.79a5.49,5.49,0,0,0,1.57.88c1,.38,1.65.93,1.55,1.59C226,486.19,227.5,487.3,228,488.58Z"
            />
            <path
              class="cls-89"
              d="M233.89,478.72a7.86,7.86,0,0,1,4.51.82,1.67,1.67,0,0,0,2.38-.21c-.81-1.44-3-1.35-4.92-1.48-1.38-.1-2.79,0-4.18,0l0,0C231.84,478.72,232.27,478.89,233.89,478.72Z"
            />
            <path
              class="cls-90"
              d="M412.32,480.19c1.18.06,1.51-1.15,2.74-.74a11,11,0,0,1,2.07,1.31,4.57,4.57,0,0,0,5.3-.17c1.27-.84,4.82-.84,5.91,0a2.33,2.33,0,0,0,3.32-.27c.63-.78.17-1.53,0-2.3-.57-.65-.16-1.68-1.46-2-1.92-.44-2.41-1.22-2.7-2.3-.17-.62-1.44-.76-2.42-.59a10.53,10.53,0,0,1-5.84-.63,2.91,2.91,0,0,0-.95-.29c-2.89-.12-4.94-1.19-7.08-2.15-1.83-.11-3.77.3-5.45-.49a.85.85,0,0,0-1.19.38c-1,1.75-1.54,3.33.51,5.15a9.27,9.27,0,0,0,4.83,2.05c.93.18,1.54.48.91,1.11-.4.4-.2.65.48.85S412.4,479.7,412.32,480.19Z"
            />
            <path
              class="cls-14"
              d="M442.6,479.12c.36.62.52,1.4,2.2.88C443.78,480,443.45,479.31,442.6,479.12Z"
            />
            <path
              class="cls-91"
              d="M299.2,486.61a7.86,7.86,0,0,0,1.84.23c2.08-1,2.3-2,.69-3.16-.36-.26-.62-.52-.51-.87.28-.69.47-1.37-1-1.75l-2.56-.64a3.6,3.6,0,0,1-2.18-2.5,2.85,2.85,0,0,0-2.89-2.29c-.85-.1-.71-.59-.77-1-.19-1.26-1-1.64-3.07-1.42a10.65,10.65,0,0,1-5.21-.54,8.16,8.16,0,0,0-3-.68c-.21-.11-.33-.34-.74-.2-2-.18-3-1.31-4.74-1.72-1.79,0-3.64.18-5.3-.47-.72-.29-1.12,0-1.29.4-.72,1.76-1.38,3.39.6,5.19a7.76,7.76,0,0,0,4.05,1.78c1.06.21,2.35.42,1.67,1.41-.21.31.09.56.57.69.65.19.84.49.8.88a.91.91,0,0,0,.65.15,3.56,3.56,0,0,1,3.72.72,5.57,5.57,0,0,0,6.11.06,4.9,4.9,0,0,1,5.67.67c1.53,1.29,2.71,2.89,5.26,3.67C298.69,485.57,299.15,486,299.2,486.61Z"
            />
            <path
              class="cls-92"
              d="M299.2,486.61c.86-.76.56-1.25-1-1.48a4,4,0,0,1-2.53-1.28,3.43,3.43,0,0,0-2.47-1.72.67.67,0,0,1-.61-.61c0-.85-.7-1.37-2.09-1.47-1.55-.12-3.11-.23-4.26.68a4.45,4.45,0,0,1-5,.15c-1.47-1-2.68-2-5.1-.91-.14.88.43,1.82-.72,2.6.23.46-.54.69-.73,1.05,0,.31-.25.54-.75.65a10.77,10.77,0,0,0-4.67,1.24,13.46,13.46,0,0,0-2.81,1.67c-.3.23-.59.51-.09.76a1.46,1.46,0,0,0,1.16-.09c.51-.17.89-.7,1.48-.49.81.29,1.2,1,.94,1.42-1,1.44.61,2.75.33,4.13.89.67,1,1.53,1.6,2.26a2.09,2.09,0,0,0,.55.56c.58.34,1,1,1.88.87s.27-.76.53-1.15c.36-.56.11-1.21.74-1.75a1.12,1.12,0,0,1,1.44-.21c.59.31,1,.94,2.07.5,1.23-.5.57-1.14.27-1.74a7.24,7.24,0,0,1,.94-2.49c.56-.77-.15-1.47-.92-2.09s-1.69-1.21-2.52-1.83c-1.11-.84-.87-1.48.77-1.85a19.43,19.43,0,0,1,7.33.08c.62.09.85.49,1.25.75a6.07,6.07,0,0,0,4.15,1.21c2.28.21,4.58.15,6.87.18a2.17,2.17,0,0,1,1.56.41A2.08,2.08,0,0,0,299.2,486.61Z"
            />
            <path
              class="cls-93"
              d="M270.34,492.91c.32-.71,1.22-1.4-.18-2.12-.45-.24-.32-.83.15-1.2a.71.71,0,0,0,.17-1.1c-.37-.56-.42-1.43-1.08-1.63-1-.32-1.43.65-2.29.91-.15,0-.32.05-.84.13a17.52,17.52,0,0,1,7.73-3.63c.12-.91-.56-1.32-2.13-1.29-1.33,0-2.65-.17-2.68,1.11s-1.16,2-3.27,2.25a4.66,4.66,0,0,1-4.11-1.12,1,1,0,0,0-1-.39c-.59.13-.4.51-.31.75.31.8,1.32,1.15,2.61,1.27.45,0,1.15,0,1.07.37s-.75.26-1.22.28a4,4,0,0,1-3.07-.94,1.47,1.47,0,0,0-2.29,0,11.21,11.21,0,0,1-3.3,1.95,11.94,11.94,0,0,0,3.32.47,1.6,1.6,0,0,1,1.55.59c.92,1.31,2.69,1.85,5,2,.81.06,2.07.06,1.36,1C268.61,491.57,269.57,491.64,270.34,492.91Z"
            />
            <path
              class="cls-94"
              d="M233.89,478.72a2.74,2.74,0,0,1-2.23-.87c-2.26-.39-2.88-.26-4.34,1-1,.9-1.68,2-3.82,2.28-.76.1-.51.5,0,.74s1.2.6,1.82.88c1.24.56,1.86,1.25,1.65,2.22s1.18,1.67,1.81,2.51a2.15,2.15,0,0,0,2.17-.62,30.09,30.09,0,0,0,5-5.18C237.35,479.73,237.16,479.32,233.89,478.72Z"
            />
            <path
              class="cls-44"
              d="M245.91,471.59a2,2,0,0,1-1.82,1.52,2.23,2.23,0,0,0,.76,2.25,5.08,5.08,0,0,0,3.65.93,4.25,4.25,0,0,0,3.46-1.85c.33-.55.71-.68,1.62-.72a11.24,11.24,0,0,0,4.38-1.19c1.55-.69,0-1.35-.24-2s-1.31-.95-2.43-.85c-2.07.2-4.15.41-6.19.73A12.46,12.46,0,0,0,245.91,471.59Z"
            />
            <path
              class="cls-55"
              d="M239.32,495.88a1.82,1.82,0,0,0,1.32.23,6.52,6.52,0,0,1,3.52.6,3.42,3.42,0,0,0,2.06.21c1.05-.15,2.09-.25.87-1.14s.33-1.69.95-2.48c.22-.29.29-.68.66-.86,1-.46.86-.95.41-1.51-.89-.38-1.3.08-1.79.36Z"
            />
            <path
              class="cls-91"
              d="M274.75,483.62c.87-.2,1.35-.49.73-1.05C275.3,482.93,274,483,274.75,483.62Z"
            />
            <path
              class="cls-95"
              d="M212.33,486.43c1.42-.52.63-1-.27-1.21a4.9,4.9,0,0,1-3.42-2.06,1.94,1.94,0,0,0-1.46-.88,1.13,1.13,0,0,1-1.09-.9c-.14-.74-.75-1.28-2.12-1.36-1.53-.09-3.08-.14-4.21.63a4.63,4.63,0,0,1-5.09.21l-.51-.3c-2.08-1.28-2.08-1.28-4.45-.16a2.07,2.07,0,0,1-1.36,2.43c-.18.08-.42.26-.38.35.59,1.23-1.12,1.27-2.31,1.55-2.49.6-3.16,1.47-2.18,2.95a2,2,0,0,1,.4.92c.07,1-.6,2.08.31,3.11.32.36-.07.84-.65,1.16.88.39,1.05,1,1.4,1.57a4.12,4.12,0,0,0,2.94,2.31c.92-.35.73-1,1-1.47a5.57,5.57,0,0,1,.47-1c.2-.29.46-.46,1.1-.35,3,.5,3.6.15,2.9-1.59a1.77,1.77,0,0,1,.06-1.89c.8-1.21.23-2.25-1.15-3.18-.72-.49-1.42-1-2.06-1.5-.91-.74-.7-1.23.63-1.66a15.46,15.46,0,0,1,4.82-.36,6.18,6.18,0,0,1,4.14,1.24,8.84,8.84,0,0,0,5,1.34,31.85,31.85,0,0,0,4.89.21,2.21,2.21,0,0,0,1.15-.29A3.5,3.5,0,0,1,212.33,486.43Z"
            />
            <path
              class="cls-39"
              d="M303.21,488.15v1.28a4.4,4.4,0,0,1,3.29,2.16,54.72,54.72,0,0,0,6.29-4.41,1.74,1.74,0,0,1,2.5-.21,4.43,4.43,0,0,0,3.19.5,46.53,46.53,0,0,1,10.08-.19c.86,0,1.76,0,2.2-.51s-.05-1-.71-1.43c-1.06-.69-1.26-1.45,0-2.16.65-.36.92-.6-.1-.94a1.65,1.65,0,0,1-1.22-1.7c-.06-.77-.26-1.42-2-1.45a2.88,2.88,0,0,1-1.81-.84c-1.7-1.25-3.08-1.4-5.36-.49-.49.19-.86.57-1.4.07-.68.32-.78.86-1.3,1.25a2,2,0,0,1-2.37.24,5,5,0,0,0-3.69-.26c-.23,2.29-2,4.26-3.88,6.19a4.7,4.7,0,0,1-3,1.54c-.37.39-.14.82-.25,1.23,0,.1.09.2,0,.3C303.64,488.16,303.5,488.08,303.21,488.15Z"
            />
            <path
              class="cls-96"
              d="M313.74,496.74c.09-.26.34-.62.7-.55,1.72.33,3.69-.21,5.27.52a4.62,4.62,0,0,0,2.54.4c1.67-.18,1.83-.38.84-1.2-.33-.27-.67-.51-.38-.87l2-2.38c1.28-.73.13-1.57.31-2.35-1.65,1.06-2.81.95-4-.35s-4-1.44-5.63-.54a56.13,56.13,0,0,1-6.19,3.45c-.36.15-.57.37-.57.64a5.33,5.33,0,0,1,.63,2.39,1.61,1.61,0,0,0,.94,1.35C311.65,498.07,313,497.87,313.74,496.74Z"
            />
            <path
              class="cls-91"
              d="M313.74,496.74c-.76.2-.8,1.1-2.24.68-1.28-.37-1.7-.92-1.74-1.69s.36-1.66-1.08-2.22c-2.43-.22-2.94-.67-2.18-1.92,0-1.57-.77-2-3.29-2.16-1.1.41-1.07,1.16-1.49,1.76-1.22,1.8-3.37,3.19-5.47,4.61-.57.38-1.88.68-1.49,1.18s1.66.11,2.53.18c1.12.09,2.3-.19,3.36.19a2.18,2.18,0,0,0,2,.71c3.83-.05,7.66,0,11.49,0,.57,0,1.44.2,1.64-.19s-.63-.63-1.17-.85C314.31,496.88,314,496.82,313.74,496.74Z"
            />
            <path
              class="cls-97"
              d="M310.86,479.11c1.53-.06,3-.09,4.06.78a1.11,1.11,0,0,0,1.37,0c1-.59,2-1.16,1.92-2.07a.53.53,0,0,1-.07-.2c-.59,0-1.19-.25-1.25-.54-.2-1.13-1.7-1.27-3-1.33a26,26,0,0,0-7.54.22c-1.29.32-2.56.81-1.65,1.87a23.4,23.4,0,0,1,4.19,1.15A2.52,2.52,0,0,0,310.86,479.11Z"
            />
            <path
              class="cls-95"
              d="M116,487.93a8.87,8.87,0,0,1,2.92.22c.6,0,1.07-.18,1-.59s-.52-.5-1-.57c-2-.28-3.09-1-3.63-2.15a1.41,1.41,0,0,0-.88-.65c-1.32-.23-1.8-.7-1.81-1.5s-1.1-.8-2-.92a6.11,6.11,0,0,0-4.16.67,5.06,5.06,0,0,1-5.29.13,3.67,3.67,0,0,1-.73-.47c-.89-.89-1.83-1.51-3.38-.38-.23.17-.56,0-.83,0-.12,1.11.54,2.35-1.58,3.1.43,1.56-2,1.48-3.37,2-1.61.62-2.1,1.2-1.39,2.25s1.09,1.8.53,2.79a.66.66,0,0,0,.07.83c1,.74.36,1.32-.39,1.91a2.88,2.88,0,0,1,1.59,1.84c.29.65,1,.77,2,.8s1.46-.29,1.63-.84a3.37,3.37,0,0,1,.52-.91c.31-.43.76-.5,1.38-.16s1.11.86,2.1.37.62-1,.18-1.55c-.21-.26-.41-.52-.33-.82,2-2.16,2-2.74-.57-4.62a18.84,18.84,0,0,1-1.87-1.32c-.71-.71-.51-1.26.76-1.58a19.1,19.1,0,0,1,7.68,0c.56.09.74.45,1.1.7a7.39,7.39,0,0,0,4.19,1.28A52.62,52.62,0,0,0,116,487.93Z"
            />
            <path
              class="cls-40"
              d="M279.84,471.81l.74.2c0-.54.8-.77,1.33-1.09,2-1.22,4.13-2.42,6.19-3.64Z"
            />
            <path
              class="cls-98"
              d="M355.39,492.23c3.1.65,5.19-.67,7.6-1.35,1.18-.33,1.74-.84,1.5-1.62-.1-.12-.35-.32-.29-.36,1.32-.93.11-1.64-.55-2.4-.33-.38-.78-.76-.88-1.17-.32-1.31-1.82-1.64-3.73-1.68a22.94,22.94,0,0,0-5.56.23c-1.93.46-2.29,1.31-1,2.27.95.69,1.92,1.37,2.83,2.08s1.09,1.48.25,2.28C355,491.06,354.77,491.63,355.39,492.23Z"
            />
            <path
              class="cls-38"
              d="M357.26,475.89c-.5.05-1.19-.14-1.42.28s.35.51.68.71a7.94,7.94,0,0,0,1,.6c.6.28.94.9,1.78.8.68-.07.44-.61.42-.95,0-.64-.44-1.19-1.58-1.41A5.47,5.47,0,0,0,357.26,475.89Z"
            />
            <path
              class="cls-99"
              d="M310.86,479.11a7.88,7.88,0,0,1-3.32-1c-.82-.53-1.89-.29-2.88-.3-.9.9-1.77,1.8-2.71,2.68a2.92,2.92,0,0,1-1.68.53c.78.52,1,1.08.38,1.71,1.27.79,2.58,1.52,2,2.83-.21.45.36,1,1.32,1.25a2.58,2.58,0,0,0,2.29-.5,19.21,19.21,0,0,0,4.9-5.9A1.05,1.05,0,0,0,310.86,479.11Z"
            />
            <path
              class="cls-22"
              d="M290.42,486c-1.7-.44-3.61-.71-4.36-1.91a.89.89,0,0,0-.35-.24c-1.52-.7-7.81-.59-9.26.18-.93.49-1.26,1-.33,1.66s1.86,1.31,2.76,2c1.08.79,1.66,1.61.63,2.62a1.22,1.22,0,0,0-.09,1.93c5.12-.4,8.76-2,11.11-4.69A1,1,0,0,0,290.42,486Z"
            />
            <path
              class="cls-22"
              d="M426.53,486c-1.71-.48-3.78-.67-4.51-1.95,0-.06-.14-.11-.23-.16-1.58-.85-8.23-.6-9.66.34-.84.55-.56,1.05.1,1.53s1.63,1.15,2.46,1.72c1.57,1.06,2.21,2.18.53,3.42.38,1,1.86,1.31,3.9.77a16.46,16.46,0,0,0,7.09-3.84C426.81,487.31,427.09,486.68,426.53,486Z"
            />
            <path
              class="cls-100"
              d="M110.51,487.75c-1.64-.61-3.7-.84-4.56-2.1-.34-.5-1.55-.3-2.36-.38a18.14,18.14,0,0,0-5.93.13c-2.1.47-2.48,1.28-1.11,2.31.82.62,1.75,1.19,2.58,1.81,1.08.82,1.62,1.68.46,2.65a1,1,0,0,0-.37,1.13c2.29,1,4.36.18,6.21-.42a10.71,10.71,0,0,0,5-3.3C110.92,489,111.12,488.37,110.51,487.75Z"
            />
            <path
              class="cls-101"
              d="M188.58,495.22c-.54.46-.34,1-.7,1.53.8.3-.06,1.09,1.09,1.28,0-.73.48-1,1.84-1.09,5.5-.21,10.6-1.2,14.67-3.43,2.89-1.59,5-3.58,5.72-5.94a1.22,1.22,0,0,0-.33-1.35h-1.1a5.54,5.54,0,0,0-3.74,2.34c-1.12,1.92-3.64,3.16-6.11,4.42a4.66,4.66,0,0,1-1.64.44c-2.61.29-4.95,1.2-7.73,1.1C189.69,494.48,189.29,495,188.58,495.22Z"
            />
            <path
              class="cls-32"
              d="M303.94,486.85c-.61-.74-1.26-1.4-.92-2.37s-1-1.42-2.37-1.71c0,.4-.11.85.56,1.06,1.88.59,1.29,1.35.55,2.15-.26.28-.48.57-.73.86.92.33,2,.57,2.18,1.31.16.14.31.39.49.39.44,0,.16-.25.27-.38A.85.85,0,0,0,303.94,486.85Z"
            />
            <path
              class="cls-30"
              d="M157.19,481.52c-.83.25-1.39.44-2,.59-.3.07-.82,0-.72.32s.55.38,1,.29C156.29,482.54,157.12,482.34,157.19,481.52Z"
            />
            <path
              class="cls-29"
              d="M247,474.08c-.59.25-1.55-.2-1.69.42s1.53,1.21,2.83,1.17c.55,0,1.4-.07,1.18-.42A2.65,2.65,0,0,0,247,474.08Z"
            />
            <path
              class="cls-102"
              d="M204.65,486c-2.08-.25-4.15-.52-5.09-1.86a1.14,1.14,0,0,0-.78-.41,21,21,0,0,0-8,0c-2.05.48-2.29,1.23-.88,2.24.69.5,1.42,1,2.11,1.47,1.28.91,1.94,1.85.85,3a1.33,1.33,0,0,0,.16,1.95,3,3,0,0,0,2.3.37c4.66-.8,8-2.47,9.87-5.14C205.6,487.08,205.64,486.48,204.65,486Z"
            />
            <path
              class="cls-51"
              d="M204.65,486c.59.75.28,1.41-.32,2.13-1.91,2.27-5.05,3.61-9,4.39a7.14,7.14,0,0,1-2.28-.1,5.59,5.59,0,0,1,.31.83c.07.38-.37.57-.88.74a1.55,1.55,0,0,1-1.16-.07c-1.86-.73-2.09-.67-2.6.64a2,2,0,0,0-.09.64c.08,0,.21.15.25.14,3.18-.84,6.67-1.05,9.95-1.7,1.66-.33,2.59-1.15,3.86-1.73a8.35,8.35,0,0,0,4-3.56c.55-1,2.16-1.41,3.13-2.16Z"
            />
            <path
              class="cls-13"
              d="M968.62,504.11c4.62,0,9.24-.07,13.85-.07h176.79l2.37,0a5.06,5.06,0,0,0,2.23.34h13.07a5.09,5.09,0,0,0,2.23-.34l36.09,0h62l88.78,0v-3.87a3.77,3.77,0,0,0-1.74-.12c-3,0-5.93.05-8.88,0a5.18,5.18,0,0,1-2.31-.4,20.72,20.72,0,0,1,2-.65,9.63,9.63,0,0,1,3.39-.21,44.54,44.54,0,0,1,6.33.14,1.83,1.83,0,0,0,1.18,0v-.43a3.33,3.33,0,0,0-2.4-.55c-2.91,0-5.82,0-8.73,0a5.56,5.56,0,0,1-2.52-.46,13.68,13.68,0,0,0-7,0,6.16,6.16,0,0,1-2.69.47c-3.16,0-6.31,0-9.46,0a15.61,15.61,0,0,1-3.92-.58,11.16,11.16,0,0,0-6.76.19,6.44,6.44,0,0,1-2.39.37c-2.55,0-5.1,0-7.64,0-1,0-1.91,0-2.86,0a4.4,4.4,0,0,1-2.84-.67c-2.66-.19-5.32-.65-7.8.47-.87.39-2.12.15-3.2.18-.66,0-1.33,0-2,0-2.46.08-4.93,0-7.39,0a3,3,0,0,1-1.62-.36,2.63,2.63,0,0,0-.75-.37c-2.68-.16-5.4-.58-7.88.48a5.46,5.46,0,0,1-2.12.2c-3.27,0-6.55,0-9.82,0a7.61,7.61,0,0,1-2.86-.47,9.54,9.54,0,0,0-6,0,8.11,8.11,0,0,1-2.71.45c-3,0-6,0-9.05,0-1.44,0-3,.16-4-.7-2.54-.13-5.14-.63-7.44.52a4.38,4.38,0,0,1-1.77.15h-9.26a17,17,0,0,1-4.27-.57,10.86,10.86,0,0,0-6.89.27,4.3,4.3,0,0,1-1.86.32c-1.39,0-2.78-.05-4.17,0-2-.05-3.89,0-5.84,0a8.14,8.14,0,0,1-3.74-.58c-1.18-.6-5.76-.34-6.89.28a3.39,3.39,0,0,1-1.65.33c-3.89,0-7.78,0-11.67,0a3.52,3.52,0,0,1-2.22-.6c-2.65-.31-5.31-.68-7.81.35-1,.4-2.3.08-3.36.39-.69.76.89.53,1.12.9a15.09,15.09,0,0,0,2.31.65,61.21,61.21,0,0,1-14.06.11,10.6,10.6,0,0,1,2.16-.8c1.83-.38,3.72-.09,5.58-.19.74,0,1.63.11,2-.48a1.25,1.25,0,0,0-.52-.24c-2-.2-4.1-.06-6.16-.09a16.1,16.1,0,0,1-4.09-.59,13.07,13.07,0,0,0-7,.07,9.55,9.55,0,0,1-2.88.47c-3.69,0-7.38,0-11.07,0a1.76,1.76,0,0,1-.88-.06c-1.8-1.18-4.15-.7-6.32-.76a1.31,1.31,0,0,0-.54.05c-3,1.33-6.41.61-9.64.77-1.08.06-2.18,0-3.26,0-1.44,0-3,.18-4-.68a22.21,22.21,0,0,0-6.41.05c-.4.18-.58.47-.95.66l-.29.12c-.49.2-1.48.07-1.47.59s.93.42,1.48.56a.48.48,0,0,1,.32.23c-.21.49-1,.4-1.49.44a89.68,89.68,0,0,1-11.24.06c-.41,0-.82,0-1.23-.08s-.6-.1-.61-.31.22-.28.5-.38c1.58-.57,1.58-.58-.08-1.19-.52-.23-.72-.65-1.37-.81a40.92,40.92,0,0,0-4.7-.11,3,3,0,0,0-1.39.2,7,7,0,0,1-3.87.64c-3.32.05-6.65,0-10,0a3.85,3.85,0,0,1-1.85-.31,12,12,0,0,0-7.31-.18,5.74,5.74,0,0,1-2.52.46c-2.48,0-5,0-7.45,0a25.61,25.61,0,0,1-6.31-.63,10.68,10.68,0,0,0-6.77.32,5.33,5.33,0,0,1-2.08.3c-1.88,0-3.77,0-5.65,0-2.25-.11-4.53.14-6.76-.17a13.17,13.17,0,0,0-8.39-.14,6.83,6.83,0,0,1-2.59.29c-.66,0-1.32,0-2,0-2.85,0-5.71,0-8.56,0a3.25,3.25,0,0,1-2.32-.65c-2.17-.25-4.29-.56-6.33.38-1.09.5-2.58.16-3.88.23-3.1.08-6.2,0-9.3,0a3.62,3.62,0,0,1-1.4-.17,10.92,10.92,0,0,0-8-.07,8.81,8.81,0,0,1-2.67.22c-.85,0-1.71,0-2.55,0-.52,0-1.26,0-1.27.44s.63.51,1.19.54a24.05,24.05,0,0,1,4.11.44c.27.06.61.05.78.23-2.21.64-11.22.66-13.89,0a14.27,14.27,0,0,1,3.75-.62c.36,0,.73,0,1.09,0,.75,0,1.86.09,1.87-.52s-1-.48-1.74-.51c-.91-.05-1.82,0-2.73,0a7.13,7.13,0,0,1-3.22-.54c-1.52-.73-6-.37-7.46.45-2.72.21-5.45-.2-8.18.08a6.09,6.09,0,0,0-2.24.34v.43a7.4,7.4,0,0,0,3.16.32,24.68,24.68,0,0,1,7.2.64,14.43,14.43,0,0,1-3.56.41c-1.51.06-3,0-4.55,0a4.9,4.9,0,0,0-2.25.33v3.65h30.09c.91,0,1.82,0,2.73,0A20.72,20.72,0,0,0,968.62,504.11Z"
            />
            <path
              class="cls-14"
              d="M1351.06,467.08l-.24,1.18c-1.89-.32-2-1.18-2-2-1.73,1.41-4.42,1-6.74,1.15-4.29.25-8.6-.05-12.9.13a7.63,7.63,0,0,1-3.48-.5,4.67,4.67,0,0,0-2.07,0c-2.81.6-4,2.41-2.69,3.95a3.61,3.61,0,0,0,1.18,1.06.72.72,0,0,0,.65-.07c2.4-1.84,6-1.66,9.31-1.86a1.84,1.84,0,0,1,2,1.2c.37.58-.22.86-1,1.1s-1.28.42-2,.57a2.74,2.74,0,0,0-2.26,1.52c-.45,1.06-1.62,1.53-3.26,1.55-1.92,0-2.82-.34-3.45-1.52a1.89,1.89,0,0,0-2.23-1.08c-2,1.46-2.42,3.44-1.08,4.64,1,.15,1.54-.35,2.3-.53,1.7-.41,2.53-.31,3.58.58a4.24,4.24,0,0,0,2.57,1.08c.59.05,1,.25,1.17.59a6.51,6.51,0,0,0,1.2,2.55c.56.57-2,1.74-3.36,1.56-2-.27-4-.51-6-.78a36.81,36.81,0,0,0-5.77-.41,3.54,3.54,0,0,0-2.71.89,30.75,30.75,0,0,1-5.74,4.82c-.4.27-.74.56-.78.94,0,0,0,.09,0,.11,2.12,1,1.42,2-.15,3a5.15,5.15,0,0,0-1.6,1.78c-.29.45-.63,1,.36,1.31a2.79,2.79,0,0,0,1.39-.45,99.37,99.37,0,0,0,10.54-5.74c1.29-.86,4.25-.62,5.18.37a2.81,2.81,0,0,0,1.34,1c1.34.42,1,.89.1,1.33-1.28.66-2.38,1.43-3.6,2.12-.38.22-.9.57-.5.84.55.36,1.14,0,1.54-.24a59.18,59.18,0,0,0,5.93-3.62c.25-.33,0-.9,1.27-.66a2,2,0,0,0,2.08-.8,2.26,2.26,0,0,1,2.52-.58,7.42,7.42,0,0,0,1.78.2,2.91,2.91,0,0,1,2.18.81,7.37,7.37,0,0,0,4.35,1.76c1.64.23,3.14.83,5,.49.79-.15,1,.6,1.81.58,1-.41,1.18-1,.84-1.61a2.07,2.07,0,0,1-.18-1.79,2.29,2.29,0,0,0-.52-2c-.75-1.26-.41-1.76,1.51-2.36,3.55-1.12,5.13-3,4.57-5.42-.39-.7-1.27-1.25-1.36-2.06-.08-.61-1.21-.92-2.16-1-4.35-.43-5.76-4.43-4.26-6.3a.9.9,0,0,1,1.07-.4,21.36,21.36,0,0,0,4.82.44c.74,0,1.31.36,2,.46a3.35,3.35,0,0,0,1.67-.27,6.24,6.24,0,0,1,4.52,0,1.8,1.8,0,0,0,.52,0c2.37-1,4-2.42,6.22-3.53v-1.29a2.75,2.75,0,0,0-2.19.13c-2.78,1-5.94,1.21-9,1.68C1353.36,467.83,1352.3,467.29,1351.06,467.08Z"
            />
            <path
              class="cls-15"
              d="M1346.64,492.91c-.22-1.05-1.46-1.06-2.74-.85-.81.12-1.42.3-2.1-.21a4.59,4.59,0,0,0-1.71-.27c-1.92-.18-3.45-.68-4.26-1.77a2.46,2.46,0,0,0-2.44-.82H1333c-2.44-.08-3.18.08-4.87,1.07-1.05.61-1.71-.1-2.71-.39v1.49c-.2.63-.88,1.17-.89,1.83a.6.6,0,0,0,.38.35c2.44.59,4.12,1.82,6.32,2.61.71.26,1,.57,1,1a1.26,1.26,0,0,0,.84,1.25l10.9,0c.64,0,1.39.08,1.52-.5.08-.31.5-.37,1-.37h4.54c.43,0,.93,0,1,.33.15.63.93.54,1.64.54l10.18,0a6.48,6.48,0,0,1,2.12.19v-9.89a1.43,1.43,0,0,0-1.24.3c-2.39,1.76-5.93,2.51-9.09,3.59-.19.2-.11.42-.13.63,0,.61-.5.72-1.42.45-1.7-.5-2.19-.35-2.84.74-.35.59-.35,1.25-.83,1.86a3.34,3.34,0,0,1-2.19-1.81C1347.91,493.79,1347.91,493.09,1346.64,492.91Z"
            />
            <path
              class="cls-16"
              d="M1351.06,467.08c.81.95,2.31,1,3.73.82,3.17-.46,6.51-.65,9.34-1.77a4.43,4.43,0,0,1,1.87-.34V445.15c-1.29-.36-1.73,0-1.75.72,0,.32,0,.64,0,1,0,.8-.53,1.11-2,.72-1.64-.44-2.32-.21-2.71.81-.24.63-.35,1.27-.53,1.91a4,4,0,0,1-2.68,2.8c-1.34.54-1.7,1.38-1,2.28s.25,1.28-1.25,1.6c-3.7.8-4.77,3.31-2.27,5.11l.8.59c1.29.95,1.32,1.37-.28,2.15C1351.05,465.45,1350.64,466.16,1351.06,467.08Z"
            />
            <path
              class="cls-17"
              d="M1353.23,470.73a7,7,0,0,0-3.54-.65,6.69,6.69,0,0,1-3.29-.44c-.68-.34-1.29-.2-1.53.29-.84,1.73-1.38,3.38.45,5.13a7.15,7.15,0,0,0,4.31,2c1,.15,2.13.44,1.52,1.37-.48.72,1.5.69,1.36,1.36.2.43.6.62,1.28.31a2,2,0,0,1,2.4.34,6,6,0,0,0,4.26,1.34,3.26,3.26,0,0,0,1.69-.31A10.16,10.16,0,0,1,1366,480v-7.31c-1.28-.63-2.39-1.48-4.42-.95a.85.85,0,0,1-.92-.41c-.22-.29-.32-.62-.87-.78l-.36,0c-.6-.22-1.5-.41-1.86-.11C1356.26,471.49,1354.71,470.85,1353.23,470.73Z"
            />
            <path
              class="cls-18"
              d="M928.07,480.62v9c.09.05.25.12.31.09,1.56-.79,2.82-.19,4.1.31a1.78,1.78,0,0,0,.66.16,7.26,7.26,0,0,1,5.18,2,2.24,2.24,0,0,0,2.22.67c.43-.24.27-.6.54-.93a2.49,2.49,0,0,0,3.1-.72,9.59,9.59,0,0,1,1.51-1.17c.15-.35-.13-.63-.46-.89s-.44-.55.22-.77c1.17-.4.9-1,.28-1.47-1-.79-1.25-1.53,0-2.32.48-.31.4-.67-.11-1a2,2,0,0,1-1-1.67c-.12-.82-.77-1.43-2.19-1.66a3.76,3.76,0,0,1-1.76-.72c-1.84-1.4-3.37-1.55-5.89-.58-.4.16-.78.35-1.17.51a3.52,3.52,0,0,0-.5.31c-.6.43-.92,1-1.79,1.3-1.12.35-1.58-.5-2.49-.59A1.6,1.6,0,0,0,928.07,480.62Z"
            />
            <path
              class="cls-19"
              d="M1366,480c-1.49,0-2.82.07-3.67,1-.62.67-3,.72-4.29.15a5.91,5.91,0,0,1-1.49-.93c-.87-.75-1.71-1.27-3-.3-.48.35-.67-.07-1-.15.2,1.2.56,2.42-1.5,3.27-.12.05-.23.2-.19.27.59.93-.62,1.06-1.63,1.32-3.52.89-3.8,1.26-2.54,3.39a1.65,1.65,0,0,1,.15,1.77c-.19.35-.33.88,0,1.14.88.73.33,1.34-.14,2a2.73,2.73,0,0,1,1.06,1.21,9.38,9.38,0,0,0,.73,1.2,2.84,2.84,0,0,0,2.2,1.27c.72,0,.46-.91.75-1.39s.38-.89.63-1.32c.34-.6.91-.7,1.7-.22a1.66,1.66,0,0,0,1.81.32c.77-.35.78-.76.36-1.23-.08-.09-.06-.21-.09-.31a9.72,9.72,0,0,1,1-2.88c.38-.61-.28-1.17-.78-1.7-.76-.83-2-1.4-2.91-2.18s-.65-1.3.72-1.64a18.86,18.86,0,0,1,7.63.06c.61.1.8.52,1.21.77a4.05,4.05,0,0,0,3.33.91Z"
            />
            <path
              class="cls-20"
              d="M940.42,492.88a3.77,3.77,0,0,1-2.44-1.34,4.64,4.64,0,0,0-3.52-1.44,6.82,6.82,0,0,1-3.08-.79c-1-.62-1.77-.68-2.51.14-.11.11-.52.13-.8.2v8.6c3.66-.2,7.31,0,11,0-.88-1.62.44-2.93,1.76-4.24C941.21,493.56,941.23,493.17,940.42,492.88Z"
            />
            <path
              class="cls-21"
              d="M940.45,467.9a17.68,17.68,0,0,1-8.27-1c-1.18-.42-2.81-.3-4.11-.7v12c1.63.34,3.31,0,5,.13,1.09-.32,1.19-1,1.62-1.57a3.14,3.14,0,0,1,2.05-2.16c.75-.3,1-.77.86-1.31-.68-.86-1.49-1.68-1-2.72a1.91,1.91,0,0,1,1.76-1.18,6.55,6.55,0,0,0,2.08-.54C940.91,468.6,941,468.24,940.45,467.9Z"
            />
            <path
              class="cls-22"
              d="M1366,485.78c-1.44-.29-2.9-.56-3.43-1.57a1.26,1.26,0,0,0-.78-.4,21,21,0,0,0-8.21,0c-1.76.44-2.06,1.13-.94,2,1,.78,2.06,1.5,3,2.27.83.65,1,1.4.34,2.11a1.66,1.66,0,0,0-.24,2.27,1.77,1.77,0,0,0,1.44-.07c3.06-1.16,6.44-2.06,8.77-3.8Z"
            />
            <path
              class="cls-23"
              d="M1354.73,498.69a2.35,2.35,0,0,1-1.75.4c-.63,0-.82.23-.81.57s.18.45.72.49a72.67,72.67,0,0,0,13.11,0v-1.29l-.78-.2A94.12,94.12,0,0,0,1354.73,498.69Z"
            />
            <path
              class="cls-16"
              d="M1359.79,470.53a5,5,0,0,0,.43,1c.34.48.74.9,1.85.46a2,2,0,0,1,2.27.24c.38.44,1,.44,1.66.43v-5.59c-1.8.12-2.33,1.17-3.54,1.73A19.38,19.38,0,0,0,1359.79,470.53Z"
            />
            <path
              class="cls-24"
              d="M928.07,500.4a98.82,98.82,0,0,0,10.33-.24c.63-.07,1-.15,1-.58s-.42-.41-.93-.5a56.23,56.23,0,0,0-10.39-.4Z"
            />
            <path
              class="cls-25"
              d="M933.19,478.24a16.59,16.59,0,0,0-5.12,0v2.36c.38.12.78.21,1.11.35,2.06.91,2.06.91,3.47-.32.33-.29.65-.59,1-.89C934.16,479.19,933.94,478.69,933.19,478.24Z"
            />
            <path
              class="cls-26"
              d="M990.87,464.5c-.16.15-.27.37-.5.44-2.68.75-3.08,2.25-3.84,3.71-.55,1.05-1,2-.47,3.12.32.63-2.35,3-3.4,3-.59,0-.81-.27-1.11-.47a7.49,7.49,0,0,0-4.85-1.11,8.53,8.53,0,0,1-4.47-1c-2-1-2.39-.94-4.34,0,.36,1.1,1.9,1.44,3.39,1.65a20.06,20.06,0,0,1,4.19,1,10.67,10.67,0,0,0,4.42.37c2-.11,2.35,0,2.8,1.15a2,2,0,0,0,1.56,1.23,2.62,2.62,0,0,1,2,1.55,16.34,16.34,0,0,0,.8,1.77,3.48,3.48,0,0,0,2.58,1.68c1.39.27,1.89.81,1.82,1.63a1.34,1.34,0,0,0,.8,1.49c1.19.62,1.09,1.28.28,2a1.25,1.25,0,0,0-.46.69c.08.63,1.28.68,1.67,1.14.36.3.22.72.73,1,1.14.12,1.09-.39,1.19-.8.14-.57-.34-1.12-.16-1.77.92.08,1.75.57,2.73.22a3.84,3.84,0,0,0,1.65-1.26,2.43,2.43,0,0,1,2.71-.53,3.83,3.83,0,0,0,1.39.23,5.64,5.64,0,0,1,4.89,1.73,6.82,6.82,0,0,0,5.23,1.55c.35-.2.14-.39,0-.58a7.18,7.18,0,0,0-2.08-4,.38.38,0,0,1-.07-.43c.53-1.23-.76-1.93-2.15-2.62s-1.44-.71.11-1.35a4.52,4.52,0,0,0,1.81-1.33,4.9,4.9,0,0,1,1.25-1.18,3,3,0,0,1,2.92-.19,10.41,10.41,0,0,0,4.56.92,4.81,4.81,0,0,1,2.45.62,2.37,2.37,0,0,0,2.89-.19,4.63,4.63,0,0,0,1.56-1.43c-.58-1.54.53-2.93,1.05-4.37a2.53,2.53,0,0,0,.2-.49c1-1.78.51-2.31-2.64-2.87-1.8-.31-3.53-.63-3.94-1.92,0-.13-.22-.25-.38-.36-2.9-1.88-1.93-4-1-6.08.35-.79,1.27-.56,2.16-.32a20.69,20.69,0,0,0,7.08.36c-.05-.35-.55-.46-1-.57-.83-.21-1.11-.55-.78-1s0-1-.87-1.22c-1.42-.39-1.81-1.09-1.72-1.94s-.3-1.32-1.91-1.29a2.3,2.3,0,0,1-2.3-1.15c-.29-.51-.66-.94-1.82-.7-.88.19-1-.24-1.17-.57a1.62,1.62,0,0,0-1.9-.72,3.77,3.77,0,0,1-3.36-.91c-1.36-1.13-2.59-2.33-3.91-3.48-.39-.34-.75-.87-1.56-.77s-.71.68-.9,1.07c-.12.24-.19.49-.31.73-.34.68-.88.84-2,.39-1.61-.67-2.18-.57-3,.49-.47.62-.8,1.27-1.22,1.9a4.93,4.93,0,0,1-3.24,2.19c-1.45.36-2,1.06-1.84,2,.09.45.37.93-.26,1.34.22.88,1.39,1.47,2.11,2.17.44.43.32.51-.07.8s-1.81.71-1.16,1.26,1.71.08,2.54-.06a43.6,43.6,0,0,1,4.86-.36c.41,0,1-.12,1.13.17s-.37.4-.72.5a24.65,24.65,0,0,1-7.27,1.21A13.91,13.91,0,0,0,990.87,464.5Z"
            />
            <path
              class="cls-27"
              d="M1078.83,448.79c-1.4-.17-1.2.55-1.4.95-.68,1.33-.66,1.36-2.74.76a1.57,1.57,0,0,0-1.79.37,14.18,14.18,0,0,0-1,1.49,5.36,5.36,0,0,1-3.7,2.76c-1.32.31-1.67,1.08-1.39,1.91s-.21,1.15-1.63,1.29c-3.54.35-5.2,2.51-3.49,4.38,1.47,1.62,1.49,1.64-1.06,2.68-1.59.65-1,1.7-1.54,2.53s-.63,1.63.52,2.33a15.49,15.49,0,0,0,6.9,2.2,5.39,5.39,0,0,1,1.63.46,11,11,0,0,0,5.06.64c1.46-.15,2.37.11,2.65,1s.9,1.31,2.13,1.62a2,2,0,0,1,1.48,1.16c.23.52.46,1,.71,1.55a4.25,4.25,0,0,0,3.23,2.17c1.07.23,1.62.62,1.37,1.3s0,1.41,1.15,1.89c.7.3.69.71.44,1.16s-.79.89-.83,1.41c.61.65,1.77,1,2.42,1.65,1,.21,2.4-.35,2.94.13a8.66,8.66,0,0,1,2.08,2.22,5.3,5.3,0,0,0,2.47,2.69,2.64,2.64,0,0,0,1.68.54c.82-.11.72-.6.86-1a18.86,18.86,0,0,1,.83-2.19c.31-.6.81-.88,1.8-.37a2.37,2.37,0,0,0,1.8.33c.6-.59-.32-.81-.82-1.1-.69-.4-1.58-.67-2-1.22-.54-1.38-1.86-2.62-1.8-4.1,0-.72-1-1.16-1.93-1.6-2-1-2-1.43,0-2.36a18.55,18.55,0,0,0,1.71-1c.68-.4,1.14-.85.59-1.43-.37-.39-.09-.66.4-.93a1.92,1.92,0,0,1,1.49-.05,11.73,11.73,0,0,1,3,.91,20.58,20.58,0,0,0,3.6.14,9.27,9.27,0,0,1,5.13,1.28,1,1,0,0,0,1.13-.65c.2-1.16-.31-2.34.39-3.49.14-.24.09-.53-.31-.68a1.55,1.55,0,0,0-1.29.21c-2.74,1.34-5,1.26-7.36-.28-1-.65-1.81-1.56-3.68-.78-.15.06-.47.05-.51,0-.45-.81-2.16-1.21-2.07-2.14s-.59-1.34-1.85-1.63c-.79-.19-1.58-.38-2.39-.54a3.11,3.11,0,0,1-2-1,2.78,2.78,0,0,0-.71-.75c-2.48-1.61-1.85-3.44-1.08-5.27.39-.91.9-1.06,2.37-.59a17.75,17.75,0,0,0,5.35.34c.36,0,.7-.12.77-.37-.43-.5-1.1-.93-.9-1.58.1-.33-.29-.61-.73-.82-1.22-.6-2-1.31-2-2.29a.56.56,0,0,0-.58-.61c-2-.12-2.81-1.14-4.08-1.81-1,.09-2,.31-2.25-.63-.08-.34-.7-.55-1.27-.47a4.63,4.63,0,0,1-4.31-1.5c-.46-.42-1.06-.78-1.26-1.29,0-.3-.29-.48-.64-.66l-1.07-.91A1.42,1.42,0,0,0,1078.83,448.79Z"
            />
            <path
              class="cls-28"
              d="M1322.22,472a8.4,8.4,0,0,0-.84-1.17c-1.32-1.4-.29-3.05,2.27-3.57.38-.92-1-1-1.82-1.12a7.07,7.07,0,0,1-3.84-1.94c-1.49-1.35-1.22-2.69-.69-4.1.23-.61.75-.86,1.81-.55a9.73,9.73,0,0,0,3.2.25c.55,0,1.29.05,1.37-.48a5.15,5.15,0,0,0-2.4-2.57c-.23-.13-.09-.48-.13-.72s0-.49-.1-.52a15.28,15.28,0,0,1-4.19-1.81c-.34-.18-1.1-.16-1.31-.6a1.12,1.12,0,0,0-1.13-.42,3.9,3.9,0,0,1-3.48-1.22c-.83-.7-1.56-1.45-2.36-2.16a1.45,1.45,0,0,0-1.2-.57c-.54.06-.53.44-.63.72-.28.82-.59,1.57-2.36.7a1.28,1.28,0,0,0-1.27.18c-.11.08-.25.17-.29.27a7.85,7.85,0,0,1-4.95,4c-.41,1.19-1.55,1.95-3.59,2.28a.94.94,0,0,0-.84,1,2.48,2.48,0,0,0,.82,3.13c.7.52,0,1-.73,1.22a2.38,2.38,0,0,0-1.9,1.67c-.38,1.17-1.23,2.23-.78,3.53.25.71-1.32,1.44-2.47,2a.84.84,0,0,1-.48,0c-1.5-1.4-4-1.06-6.2-1.26-.55.77-.56,1.49.53,2.13a15.69,15.69,0,0,0,6.69,2.19,5.74,5.74,0,0,1,1.64.44,11.1,11.1,0,0,0,5.38.6c1.48-.19,2.34.14,2.55,1,.18.72.72,1.26,2,1.53a1.89,1.89,0,0,1,1.44,1,1.77,1.77,0,0,0,.81,1.06,3.28,3.28,0,0,0,2.52.06,2.43,2.43,0,0,1,1.85-.08c1.85.95,4.14,1,6.39,1.21.9.23,1.42.86,2.55.85,1.81-.32,2.62-1.11,2.89-2.15a2.61,2.61,0,0,1,.1-3.06c.28-.5.64-1,1-1.46C1321.12,473.23,1322.53,473.07,1322.22,472Z"
            />
            <path
              class="cls-29"
              d="M1112.73,478.69l-.74.64a3.59,3.59,0,0,1-2.52-.19,6.43,6.43,0,0,0-4.4-.51c-.16.51.57.48,1,.56,1.19.2,1.6.67,1.24,1.31a21.9,21.9,0,0,1-6,6.48,5.45,5.45,0,0,1-1.43.45,1.74,1.74,0,0,0-.68,1.15c.11.71,1.2.9,2,1.28a15.47,15.47,0,0,1,1.3.87,6.39,6.39,0,0,0-2.06,1.52c0,1.07.75,1.33,2.32.76,2.28-.83,3.66-2.18,5.43-3.3.41-.26.77-.55,1.18-.82a3.8,3.8,0,0,1,2.58-.43,11.54,11.54,0,0,1,5.51,2.05c.66.4,0,.58-.32.77-1.91,1.15-3.86,2.28-5.78,3.43-.54.32-1.25.59-1.27,1.12a.65.65,0,0,0,.4.17,3.19,3.19,0,0,0,1.78-.66c1.93-1.13,3.86-2.25,5.76-3.4a7.61,7.61,0,0,1,2.49-1c.33-.18-.09-.79,1-.53a2.15,2.15,0,0,0,2.16-.65,3.44,3.44,0,0,1,2-1,9,9,0,0,0,3.34-1.78,1.5,1.5,0,0,1,2,0,5.15,5.15,0,0,0,3.55.83c.56,0,1.13-.16,1.16-.55s-.48-.48-1-.55c-1.07-.18-2.11-.36-2.48-1.15.59,0,.73.24,1,.39,2.41,1.38,6.09.89,7.25-1a2.81,2.81,0,0,0,.26-.52c.18-.52.21-1.09,1.51-1.12s2.18.08,2.62.84c0,.07.13.12.21.17.73.12.94-.17,1.11-.49-.18-.57.59-.88,1-1.28.86-.77.6-1.63.6-2.48-.16-.89-1.33-1.55-1.52-2.47-.11-.53-1.25-.71-2.11-.9-3-.68-4.76-2.16-4.75-4.06a4.26,4.26,0,0,1,.09-1.07c.38-1.5.52-1.54,3-1.24a9.8,9.8,0,0,0,3.58-.09,1.63,1.63,0,0,0-.82-2.21,2.11,2.11,0,0,1-1.24-1.68c-.7-.92-2-1.11-3.53-1a7.85,7.85,0,0,1-2.35.53,130.71,130.71,0,0,1-14.68,0c-1.06-.07-2-.62-3.13-.31.56,1.46.41,1.57-2.21,1.71-2.3.14-3.8,2.05-2.7,3.47a2.34,2.34,0,0,0,1.4.94c1.27,0,1.91-.69,3-.89a54.16,54.16,0,0,1,6-.75c1.66-.11,2.24.18,2.92,1.19s-.31,1.25-1.39,1.58a1.7,1.7,0,0,1-.32.1c-2.37.4-4.52.91-5.7,2.39-.53.66-1.86.85-3.19.61a2.94,2.94,0,0,1-2.45-1.57c-.18-.44.05-.94-.61-1.3-1.28.11-1.35.75-1.49,1.28-.32,1.17-1.36,2.29-.72,3.54C1113.18,478.12,1112.78,478.4,1112.73,478.69Z"
            />
            <path
              class="cls-30"
              d="M1059.83,470.08c-1.15-.61-.28-1.47-.77-2.17-1.73.35-1.77-.39-1.86-1s.19-1.22-1.4-1.1a5.43,5.43,0,0,1-2.78.9,157.23,157.23,0,0,1-18.8,0c-.8,0-1.52.24-2.28.34-1.56.23-2.55.8-2.84,1.73s-.49,2.15,1.41,2.85a31,31,0,0,1,8.48-1.59c1.56-.13,2.49.11,3.17,1,1.28,1.63,1.35,1.61-1.37,2.42a32.89,32.89,0,0,1-10.23,1.09,7.9,7.9,0,0,1-2.5-.79c-.75,1.47-2,2.91-1.07,4.52.87.12,1.29-.32,1.88-.53,1.89-.67,2.84-.58,4.23.42a3.12,3.12,0,0,0,1.58.86c1.75.18,2.2.9,2.33,1.77s.5,1.33,1.78,1.67a7.26,7.26,0,0,1-1.62.41c-1.16-.05-1.44.35-1.6.9-.22.76-1,1.12-2.33,1a2.38,2.38,0,0,1-1.89-.72c-.3-.47.18-.81.64-1.16s1.85-.58,1-1.15-1.6.14-2.29.42c-1.3.53-2.44,1.18-3.62,1.8a5.51,5.51,0,0,1-4,.46,2.71,2.71,0,0,0-2.77.55c-1,1-2.4,1.9-3.45,2.9a9,9,0,0,1-3,1.53l.35.4c1,.7,1,1.3-.09,2s-1.92,1.38-1.92,2.34c.74.87,1.77.6,2.7.19a61.31,61.31,0,0,0,9.26-4.73,4.39,4.39,0,0,1,5.22.35,3.22,3.22,0,0,0,4.47.43.79.79,0,0,1,.63-.15,2.63,2.63,0,0,0,2.85-.65,2.41,2.41,0,0,1,2.57-.54,7.42,7.42,0,0,0,1.78.17,2.44,2.44,0,0,1,2.14.81c.85,1.07,2.39,1.57,4.3,1.74a4.15,4.15,0,0,1,2,.48,1.55,1.55,0,0,0,1.32.19,4.35,4.35,0,0,1,3.49.46c1.14-.37,1.17-1,.88-1.59a2.78,2.78,0,0,1-.22-1.89,2.86,2.86,0,0,0-.42-2c-.68-1.2-.32-1.86,1.65-2.34,3.65-.89,4.2-2.76,4.65-4.7a1.51,1.51,0,0,0-.89-1.36c-.36-.21-.65-.45-.54-.76.35-.94-.64-1.37-1.91-1.51-4.25-.48-6.48-4.12-4.69-6.34.44-.55.94-.5,1.73-.34A9.1,9.1,0,0,0,1059.83,470.08Z"
            />
            <path
              class="cls-31"
              d="M1282.43,470.09c-1.09-.55-.26-1.33-.72-1.95l-1.88-.84c-5.18.86-10.5.75-15.8.75a2.19,2.19,0,0,1-1-.16c-1.24-.8-2.46-.47-3.75-.05a26.24,26.24,0,0,1-4.77.65c-1.16.15-.73-.62-1.27-.84-1.73,1.28-1.68,2.59-.24,3.93,1.65-.22,2.91-1,4.66-1.11,1.08-.07,2.13-.27,3.22-.37,2.81-.25,2.82-.25,4.11,1.18a4,4,0,0,0,.61.53c1.39,1,1.4,1.21-.49,1.84a29.94,29.94,0,0,1-13.32,1.4c-.63-.08-1.3-.35-1.72.19-.85.83-1.13,1.68-.39,2.59a2,2,0,0,0,1.52,0c2.85-.67,2.85-.67,5,.7a3.51,3.51,0,0,0,1.49.59c1.21.15,1.65.63,1.82,1.3a2.22,2.22,0,0,0,1.1,1.77c.25.14.27.33,0,.48a3.37,3.37,0,0,0-1.41,1.71c-.24.5-1,.45-1.68.39-2.21-.22-4.4-.51-6.6-.78a14.77,14.77,0,0,0-5.35-.17,2.16,2.16,0,0,1-1.94-.59,1.71,1.71,0,0,0-1.46-.51c-.78.15-.56.58-.48.92.23,1-.53,1.65-2.07,2-1,.25-1.67.53-.48,1.11.94.45.32.91-.06,1.33-.5.57-1.46,1-1.69,1.64.79.85.32,1.47-.72,2.19s-2.16,1.47-2.16,2.52a2.26,2.26,0,0,0,2.63.26c2-.92,4.06-1.82,6-2.78a1.69,1.69,0,0,0,1-1.12c.17-.8.95-1.38,1.84-1.93a2.41,2.41,0,0,1,2.77-.24,3.45,3.45,0,0,0,1.38.22,7.49,7.49,0,0,1,3.66,1.07,2.57,2.57,0,0,0,2.39.35,1.91,1.91,0,0,1,.89,0,2.55,2.55,0,0,0,2.85-.62,2.34,2.34,0,0,1,2.55-.55,4.8,4.8,0,0,0,1.42.15,3,3,0,0,1,2.7,1,5,5,0,0,0,3.22,1.45c1.1.18,2.31.15,3.14.74a1.35,1.35,0,0,0,1,.05,4.39,4.39,0,0,1,3.51.46c1.07-.33,1.18-.93.9-1.48a3.49,3.49,0,0,1-.23-2.22,2.77,2.77,0,0,0-.43-1.78c-.66-1.18-.36-1.83,1.48-2.29,3.85-.95,4.53-2.86,4.8-5a1.51,1.51,0,0,0-.87-1.14c-.36-.2-.68-.43-.56-.75.36-.93-.63-1.27-1.86-1.54-4.4-1-6.28-3.29-4.93-6,.35-.69.82-.9,2.09-.65A8.78,8.78,0,0,0,1282.43,470.09Z"
            />
            <path
              class="cls-32"
              d="M1222.61,470.29c-.44-.37-.93-.7-.75-1.23s-.24-.67-1-.72a38.84,38.84,0,0,0-4.31.19c-1.7,0-3.22-.62-4.76-.57s-2.81.9-4.53.89c-2.54,0-5.08-.08-7.62.06-1.71.09-3.35.33-5,.56a3.24,3.24,0,0,0-1.51.56c-.32.24-.5.51-.25.8s.68.26,1.11.25a38.68,38.68,0,0,0,4.47-.51,28.8,28.8,0,0,1,3.39-.39,3.24,3.24,0,0,1,2.81.93,5.2,5.2,0,0,0,1.48,1.21c1.24.75,1.22.93-.33,1.54a29.39,29.39,0,0,1-15.81,1.52c-1.56.48-1.08,1.33-1.1,2.09a.94.94,0,0,0,.14.33c.38.49.91.55,1.75.32,3.13-.86,2.9-.66,5.44.48,2,.9,3.28,1.81,3.93,3.25.3.67.77,1.13.07,1.81s-.08,1.24.54,1.79c.41.36,1,.7.52,1.16s-1.25.36-2,.39c-1.41.06-2.76-.23-4.16-.22a22.88,22.88,0,0,0-3.61.21,8.47,8.47,0,0,1-5.31-.46,2.17,2.17,0,0,0-2.46.39c-2,1.63-4.4,3-6.48,4.62-.81,1.36-.09,2,2.34,2.13a65,65,0,0,0,6.62-3.64,4.73,4.73,0,0,1,5.82.3,3.11,3.11,0,0,0,4.39.14.94.94,0,0,1,.68,0,2.15,2.15,0,0,0,2.65-.5c.61-.78,1.46-.89,2.81-.64,2.41.45,2.93.58,4.54,1.63a3.52,3.52,0,0,0,1.58.7c2.33.25,4.42,1.24,7,.79a2,2,0,0,1,1.58.39c1.63,0,1.36-.68,1.13-1.16a2.85,2.85,0,0,1-.19-2.21c.2-.62-.2-1.19-.55-1.76-.75-1.27-.5-1.73,1.58-2.31,3.61-1,4.61-2.86,4.87-5,0-.45-.38-.81-.93-1.12s-.71-.49-.64-.84c.18-.86-.65-1.28-1.89-1.44-4.3-.58-6.32-4-4.77-6.25.45-.65,1.07-.62,2-.42A8.41,8.41,0,0,0,1222.61,470.29Z"
            />
            <path
              class="cls-33"
              d="M933.19,478.24c.15.51.29,1,.43,1.52,1.18-.25,2-.87,3.34-1s2.29,0,2.9.72a3.52,3.52,0,0,0,2.71,1.21c1.23.1,1.56.82,1.56,1.51a1.44,1.44,0,0,0,1.16,1.67c.81.27.34.51-.07.74-1.32.71-1.26,1.46-.19,2.25s1.59,1.28-.63,1.53c-.89.1-.45.39-.11.6a2.8,2.8,0,0,1,1.26,1.15c.44.76,1.59.81,2.65.86a3.11,3.11,0,0,1,2.43.93,5.51,5.51,0,0,0,3.84,1.61c1.79.17,3.38,1,5.37.54.64-.13,1,.34,1.43.56,1.35-.23,1.6-.86,1.3-1.51a3.09,3.09,0,0,1-.17-2.11c.16-.69-.35-1.33-.68-2-.52-1-.28-1.58,1.38-2,3.92-1.06,5-3,4.87-5.29-.25-.87-1.31-1.55-1.54-2.46-.13-.53-1.27-.73-2.16-.85-4.32-.59-5.62-4.26-4.09-6.3.39-.52,1-.37,1.66-.25a9.76,9.76,0,0,0,4.89-.05c-.49-.32-1-.53-.78-1.15s-1.4-.92-2-1.45c-3.44.06-6.85.38-10.31.36a8.16,8.16,0,0,1-4-.53,2.11,2.11,0,0,0-1.54.06c-3,.85-6.32.51-9.47.83-.92.1-.45-.47-.75-.69-1.69.46-2.62,2-1.81,3a11.14,11.14,0,0,0,1.09,1.08c1.87-.27,3.37-1.06,5.34-1.21,1.19-.09,2.39-.25,3.58-.36a2.62,2.62,0,0,1,2.61.85,3.12,3.12,0,0,0,1.23,1.18c1.07.56.7.94-.33,1.33a30.74,30.74,0,0,1-13.93,1.7,3.35,3.35,0,0,0-1.41-.05Z"
            />
            <path
              class="cls-34"
              d="M1143.76,466.44a1.24,1.24,0,0,0,.78,1.44c.73.37,1.62.73,1.13,1.49-.11.17.41.47.64.72A8.45,8.45,0,0,0,1151,472c2.42-1.38,4.75-2.81,7.15-4.19-1.9,1.12-3.82,2.24-5.71,3.37-.45.28-1.3.54-.49,1.05,1,.3,2.11.54,3.1.9a11.48,11.48,0,0,0,5.11.43c1.43-.14,2.27.21,2.41,1s.69,1.22,1.88,1.55c1.37.37,1.52,1.22,1.89,2,.45.94.63,2,2.52,2.44,1-.11,1-.61.93-1-.09-1,.79-1.52,2.28-1.81a16,16,0,0,0,2.14-.59c.62-.21,1.08-.53.95-.95-.2-.65.3-1.09,1-1.54,1.58-1.12,1.52-2.84-.15-4-.4-.28-.88-.5-.66-.92.38-.75-.36-1.14-1.32-1.46a2.93,2.93,0,0,0-.66-.18c-3.19-.22-4.36-1.74-5.71-3.12-1.51-1.55-.43-3.05.47-4.54.16-.26.62-.32,1.09-.24a4.21,4.21,0,0,0,1.59.13c1.12-.63,2.66-1.06,3-2.08l-1.53-.82c-.28-.29-.09-1-1.1-.71-1.89.5-3.83.2-5.74.31-2.66.15-5.35.51-8,.42-4.09-.14-8.24.21-12.27-.47a2.71,2.71,0,0,1-1.11.21c-2.45.17-3.11.69-3.69,2-.48,1.14.18,2.05,1.29,2.92a29.48,29.48,0,0,1,7.38-1.65c.48-.06,1-.13,1.43-.17,3.15-.23,3.52-.11,5,1.53s1.48,1.69-1.46,2.57a31,31,0,0,1-7.65,1.3A4,4,0,0,0,1143.76,466.44Z"
            />
            <path
              class="cls-35"
              d="M1223.67,480.41a2.43,2.43,0,0,1-1.74,2.77c-.09.05-.27.12-.25.14.85,1.54-1.65,1.37-2.77,1.78-2.23.81-2.71,1.26-1.68,2.69a1.93,1.93,0,0,1,.33,2.27c-.28.49,0,1,.37,1.45s.54.89-.51,1.13c-.66.07-.58.36-.35.56a22.61,22.61,0,0,1,2,2.61,3.77,3.77,0,0,0,1.08.85c1.16.63,1.81.51,2.28-.4.27-.55.35-1.12.65-1.66a.84.84,0,0,1,1.16-.42,3.21,3.21,0,0,0,2.79,0c1-.64.39-1.25,0-1.88-.08-.14,0,0,0-.11a1.17,1.17,0,0,1,.2-1.55c.92-1,.56-1.92-.56-2.79-.77-.6-1.66-1.13-2.4-1.74-1.14-.94-.83-1.66,1-2a21.92,21.92,0,0,1,6.47,0,1.88,1.88,0,0,1,1.41.77,15.12,15.12,0,0,0,1.9,2.43.79.79,0,0,1,.22,1c-.21.35-.33.69.13,1,.65.25,1.1.84,2.16.49.63-.48,1.29-.94,1.88-1.44,1.23-1,1.09-1.49-.78-2.21,3-.47,4.36-1.5,3.31-3.26.66-.12.85.07,1,.25a2.92,2.92,0,0,0,3.6.73,4.11,4.11,0,0,1,1.78,0c3.06.4,6.12.8,9.19,1.17,1.28.15,2.31.08,2.26-1,0-.79,1-1.25,2.14-1.76-2.22-.42-1.78-1.56-2.12-2.44-.23-.61-.59-1-1.7-1a2.79,2.79,0,0,1-1.88-.75c-1.78-1.4-2.64-1.52-5.14-.66a3.58,3.58,0,0,1-1.49.33c-.31.83-1.3,1.4-2.22,2a1,1,0,0,1-1.33-.08,7.12,7.12,0,0,0-3-1.07,14.14,14.14,0,0,1-4.25-.84,4.71,4.71,0,0,0-2.46-.12c-1.73.28-3.79.15-3.86,1.81,0,.52-1.33,1-2.21,1.36a1.62,1.62,0,0,1-1.75-.16c-.57-.55.39-.57.87-.69,1.77-.44,2.93-1.17,3-2.32s-.92-1.74-2.28-2.3a5,5,0,0,0-2.61-.27c-.89.13-1.87.23-2.18.83s.51.83,1,1.17,1.31.75,1.9,1.16c.2.14.37.31.21.49s-.6.22-1,.17a2.17,2.17,0,0,1-1.92-1.3c-.14-.32-.14-.82-1-.75s-.66.53-.71.88a.83.83,0,0,0,.16.74C1224.83,479.24,1224.36,479.83,1223.67,480.41Z"
            />
            <path
              class="cls-36"
              d="M1170.75,460.19c-3-.57-2.91-.55-3.89,1.34-.85,1.66-.2,3,1.18,4.51,1.22,1.36,2.85,1.84,5,2.27,1.24.25,2.72.56,1.53,1.66a.26.26,0,0,0,.14.47c2.17.35,1.5,1.6,2.13,2.41.75,1-1.08,1.47-1.91,2.11-.34.27-.78.34-.36.75.59.58.2,1-.86,1.26-.28.06-.53.18-.82.23-2.5.39-4.17,1.12-3.61,2.86,0,.1-.21.24-.33.36.41.74,1.62.63,2.54.83a2.67,2.67,0,0,0,1.64-.36c1.15-1,2.55-1.88,3.07-3.09.15-1.09.73-1.54,2.58-1.72a35.71,35.71,0,0,1,6.7,0,3,3,0,0,1,2.11.91,1.54,1.54,0,0,0,1.79.61c.17-.73-.41-1.55.75-2.17a10.28,10.28,0,0,1,3.1-2.81c.67-.36.55-.94,0-1.47-1.36-1.28-.68-2.65,1.57-3.43.56-.19,1.28-.34.83-.87a1.68,1.68,0,0,1-1.5-1.46c-.28-1.35-1-1.72-3.23-1.48a13.05,13.05,0,0,1-6.56-.81,4.49,4.49,0,0,0-1.63-.45,14.2,14.2,0,0,1-6.78-2.05A10,10,0,0,0,1170.75,460.19Z"
            />
            <path
              class="cls-37"
              d="M1112.73,478.69c1.12-.38.64-1,.67-1.53a5.44,5.44,0,0,1,1.9-4.05c1.71-.14,2.09-.46,1.82-1.52-2.28-1.68-1.85-3.36,1.12-4.31-1.06-1.91-1.06-1.94-4.42-1.68a11.79,11.79,0,0,1-5.65-.76,10.61,10.61,0,0,0-3.86-.82c-2.23-.09-3.58-1.07-5.09-1.87-.31-.09,0-.58-.71-.4-2.12.15-4.26.4-6.21-.37-1.35-.53-2.08-.26-2.54.58a7,7,0,0,0-.74,4c0,.62,1.06,1,1.35,1.47,1,1.7,3.23,2.37,5.86,2.81,1.29.22,1.85.64,1.3,1.43a.27.27,0,0,0-.06.1,12.5,12.5,0,0,0,2.69,2.43,1,1,0,0,0,.81-.12c1.17-.89,1.74-.35,2.53.28a8.69,8.69,0,0,0,7,1.51c1.06-.24,1.31-1,2.73-1.32A4.72,4.72,0,0,0,1112.73,478.69Z"
            />
            <path
              class="cls-38"
              d="M966.73,471.8c-1.91,0-3.88.22-5.65-.47-.74-.28-1.11,0-1.28.42-.73,1.76-1.36,3.39.62,5.19a7.66,7.66,0,0,0,4.21,1.81c1,.18,2.16.46,1.49,1.37-.22.31.09.56.58.7.66.18.83.49.8.87a1,1,0,0,0,1.21.13,2.13,2.13,0,0,1,2.54.34,5.23,5.23,0,0,0,3,1.27,5.3,5.3,0,0,0,3.76-.71,5,5,0,0,1,3.62-.66c.9.1,1.59.35,1.75.94.07.25.06.59.4.7,2.57.81,2.74,3,5.82,3.5,1.09.18.55.67.39,1.06a2.28,2.28,0,0,0,2.28.33,14.9,14.9,0,0,0,1.22-1.32c.36-.5.61-1.11-.39-1.43-1.21-.39-1.34-1-1.19-1.64.23-1-.29-1.59-2-1.8a2.78,2.78,0,0,1-2.38-1.47c-.38-.75-.71-1.51-1.06-2.27-.16-.35-.31-.83-.85-.91-2-.29-2.48-1.12-2.8-2.17-.19-.64-1.3-.84-2.34-.69a10.46,10.46,0,0,1-6-.67,4.91,4.91,0,0,0-2-.48,7.8,7.8,0,0,1-4.62-1.48Z"
            />
            <path
              class="cls-39"
              d="M1195.58,466.88c0,.27-.23.46-.67.58-3.09.85-3.84,2.11-2.1,3.82.69.68.46,1.29-.41,1.58a2.89,2.89,0,0,0-2.3,2.6,3.12,3.12,0,0,0,2.19.62,32.06,32.06,0,0,0,14.44-2.19c1.52-.66,1.52-.89,0-1.65-.55-.27-1.19-.54-1.39-1-.72-1.56-2.08-1.57-4.91-1.3-2.2.22-4.31.71-6.55.84-.29,0-.6.14-.77-.09s0-.35.23-.49a3.28,3.28,0,0,1,1.54-.54,72.29,72.29,0,0,1,11-.53c1.73.07,4,.23,5.26-.92.38-.33.77-.08,1.1,0a16.53,16.53,0,0,0,8.58.09,1.54,1.54,0,0,1-1.09-1.62c0-.49-.28-.87-1.22-.86a2.07,2.07,0,0,1-2-.87,1,1,0,0,0-1.28-.54.89.89,0,0,1-.35,0c-1.45-1.4-5.37-1-6.16-2.9-.15-.37-.62-.69-1-1s-.77-1.06-1.69-1-.69.74-.93,1.15c-.32.56-.68.84-1.65.42a1.6,1.6,0,0,0-2.22.48c-.44.62-.86,1.25-1.33,1.87a2.87,2.87,0,0,1-1.69,1.08c-1.37.36-2.15.92-1.82,1.86C1196.61,466.88,1196,466.82,1195.58,466.88Z"
            />
            <path
              class="cls-38"
              d="M1223.67,480.41c1.17-.47,2.22-.89.92-1.85-.49-.35-.29-1,0-1.45.83,0,.5.42.57.65a2.52,2.52,0,0,0,2.06,1.5,2.71,2.71,0,0,0,2-.23c.65-.45-.2-.7-.61-1-.78-.5-1.6-1-2.45-1.45s-.67-.75.31-1a5.18,5.18,0,0,1,5.08,1c1,1,.47,2.19-1.34,2.87-.4.15-.9.21-1.28.38s-1.46-.06-1.44.44.68.8,1.43,1a1.77,1.77,0,0,0,1.75-.22c1-.86,3.5-1.25,2.65-2.77-.16-.28.48-.33.75-.19a2.46,2.46,0,0,0,2.26-.12,3.79,3.79,0,0,1,2.85.23,5.5,5.5,0,0,0,3.87.42c-.25-.59-.5-1.18-.78-1.76a1.39,1.39,0,0,0-1.19-.88c-1.68-.11-2-.72-2.09-1.55s-1-1.26-2.34-1.09a12.2,12.2,0,0,1-6.68-.86,1.37,1.37,0,0,0-.5-.13c-2.85-.07-4.83-1.13-6.88-2.11-1.86,0-3.75.17-5.44-.5a1.16,1.16,0,0,0-1.33.25c-1.4,1.29-.83,3.74.4,5.12s2.84,1.91,5.06,2.24c.52.08,1,.3.85.58-.55.84.11,1.31,1.2,1.73C1223.73,479.86,1223.67,480.16,1223.67,480.41Z"
            />
            <path
              class="cls-40"
              d="M1145.11,457a4,4,0,0,0,2.65.69c3,0,6,.11,9,.15s5.87-.29,8.8-.49a5.72,5.72,0,0,1,1.6,0,6.16,6.16,0,0,0,3.49-.24c1.06-.45,1.16.05,1.55.34l-.09-1.17c0-.59-.45-1-1.54-.94a2.33,2.33,0,0,1-1.81-.57c-.52-.55-.61-1.43-2.34-1a.32.32,0,0,1-.16,0c-.4-1.76-3.69-.67-4.91-1.75s-2.23-2-3.37-3a6,6,0,0,0-.88-.68c-.6-.38-1-.29-1.29.19a4.54,4.54,0,0,0-.32.72c-.3.87-.79,1.38-2.35.61a1.52,1.52,0,0,0-1.92.32,13.23,13.23,0,0,0-1.1,1.58,4.94,4.94,0,0,1-3.33,2.4c-1.14.29-1.66.92-1.38,1.69C1145.55,456.16,1145.65,456.58,1145.11,457Z"
            />
            <path
              class="cls-41"
              d="M1253.2,467.65c-.09.24-.2.48-.27.73-.12.46.13.7,1,.53,2.28-.43,4.88-.24,6.88-1.22.29-.14.76-.26,1-.05,1.35,1.43,3.77.77,5.53.79,3,0,6.12-.34,9.22-.28a4.67,4.67,0,0,0,3.31-.85c0-.84.14-1.7-2-1.66a1.37,1.37,0,0,1-1.14-.63c-.31-.44-1.41-.66-1.5-.76-1-1.2-3.6-.67-4.84-1.58-1.07-.79-1.87-1.67-2.84-2.49-.39-.34-.65-.91-1.49-.81s-.62.63-.77,1c-.27.68-.7,1.09-1.93.49a1.41,1.41,0,0,0-1.87.34c-.41.52-.73,1.06-1.09,1.59a3.91,3.91,0,0,1-2.53,1.73c-1,.27-1.6.8-1.36,1.49s-.19,1.22-1.62,1.26A2.89,2.89,0,0,0,1253.2,467.65Z"
            />
            <path
              class="cls-18"
              d="M937.92,469.23c-.29.36-1.14.7-.51,1.13s1.08-.12,1.64-.15q3.23-.19,6.47-.33a8.71,8.71,0,0,0,1.77-.18c1-.25,2-1,2.94.08.12.14.91.07,1.39.09,3.39.16,6.75-.27,10.14-.21a8.34,8.34,0,0,0,2.19-.46c0-.94.08-1.91-2.27-1.91a1.05,1.05,0,0,1-.84-.53,1.49,1.49,0,0,0-1.79-.77.6.6,0,0,1-.64-.32c-.28-.61-.91-.75-1.94-.63a2.7,2.7,0,0,1-2.2-.78c-1-.85-1.94-1.74-2.92-2.6a1.49,1.49,0,0,0-1.18-.59c-.66.05-.65.48-.75.78-.27.79-.5,1.49-2.23.69a1.26,1.26,0,0,0-1.68.44c-.44.54-.77,1.12-1.16,1.69a3.71,3.71,0,0,1-2.34,1.56c-1.23.31-1.59.93-1.56,1.67C940.85,469.16,938.9,468.87,937.92,469.23Z"
            />
            <path
              class="cls-16"
              d="M1325.49,467.08c-.07.54.46.61,1.24.66,1.68.1,3.34,0,5,0,3.12-.06,6.26-.07,9.38,0,1.87,0,3.65-.38,5.59-.14,1.29.15,1.68-.75,2.06-1.38,0-.25-.21-.46-.59-.46-1.4,0-2.29-.37-2.67-1.17-.13-.27-.79-.25-1-.36-1.63-1.1-4.8-.75-6-2.25a17.46,17.46,0,0,0-2-1.92c-.35-.31-.65-.8-1.41-.72s-.61.58-.73.92c-.28.79-.69,1.18-2.12.55s-1.46.62-2.4.7a7.57,7.57,0,0,1-3.79,3.13C1324.67,465.18,1324.89,466.19,1325.49,467.08Z"
            />
            <path
              class="cls-42"
              d="M1030.62,471.59a2.12,2.12,0,0,1-1.07-2.75c.23-.69.8-1.22,2.08-1.43a4.86,4.86,0,0,0,2.28-.55c.53-.84.94-1.71,1.45-2.55-2.27-.34-3.74-1.38-5.48-2.18a13,13,0,0,0-2.86-.21,11.14,11.14,0,0,1-4.69-.61c-1.13-.45-1.8-.16-2.18.51a7.58,7.58,0,0,0-.82,4.65c0,.37.44.65.73,1,.66.7,2,1.15,2,2.1,0,.26.56.46,1,.57.78.2,1.55.43,2.35.57,3.54.6,3.69.73,2.71,2.65C1030.09,473.17,1031,472.59,1030.62,471.59Z"
            />
            <path
              class="cls-43"
              d="M1035.36,464.31c-1.37.67-1.67,1.56-1.45,2.55a13,13,0,0,0,3.68.44c5,0,10,.05,15-.26,1.25-.08,3.33.19,3.22-1.26-.28-.06-.74-.09-.82-.2-.67-1-2.68-1.15-3.55-2a1.29,1.29,0,0,0-1.08-.31,3.6,3.6,0,0,1-3.24-1.06c-.91-.76-1.69-1.57-2.55-2.35a1.41,1.41,0,0,0-1.08-.51c-.61,0-.66.39-.74.65-.26.9-.55,1.61-2.44.75a1.17,1.17,0,0,0-1.49.51c-.51.64-.89,1.33-1.4,2A2.41,2.41,0,0,1,1035.36,464.31Z"
            />
            <path
              class="cls-44"
              d="M1120.45,465.57c4.43,1.05,9.06.95,13.67.75,1.33-.05,2.65,0,4-.11,1.09-.07,2.38,0,2.75-.85,0-1.09-.24-1.23-2-1.11a3.73,3.73,0,0,0-3.12-1,2.56,2.56,0,0,1-1.88-.91c-.94-.83-1.84-1.67-2.77-2.5a1.41,1.41,0,0,0-1.08-.52c-.6,0-.61.42-.69.68-.3.87-.59,1.63-2.46.73a1.16,1.16,0,0,0-1.42.38,9.51,9.51,0,0,0-.89,1.28,4.24,4.24,0,0,1-3,2.18C1121,464.75,1120.38,465.05,1120.45,465.57Z"
            />
            <path
              class="cls-40"
              d="M1138.88,464.25c1.4-.09,1.57.58,2,1.11.89.43,2.6.1,2.92,1.08,2.31-.69,5-.46,7.35-1a47.77,47.77,0,0,0,5.36-1.55c1-.34,1-.74.35-1.24a6.64,6.64,0,0,1-1-.89c-1.67-1.91-1.82-2-5.39-1.73a49.53,49.53,0,0,0-6.49,1,5.07,5.07,0,0,0-2.35,1.13C1141.86,463.35,1140,463.63,1138.88,464.25Z"
            />
            <path
              class="cls-45"
              d="M1325.49,467.08c.18-.23.3-.44.16-.71-.44-.9.19-1.53,1.55-1.94a3.29,3.29,0,0,0,2.68-2.91,10.13,10.13,0,0,1-5.23-1.75,1.68,1.68,0,0,0-1-.42,8.51,8.51,0,0,1-4.83-.19c-.88-.33-1.38-.29-1.78.32-1.44,2.22-.78,4.23,1.65,6.07a4.59,4.59,0,0,0,2,.68c1.11.2,2.39.29,2.92,1.06Z"
            />
            <path
              class="cls-41"
              d="M1250,475.24a31.86,31.86,0,0,1,4.14.27,28.94,28.94,0,0,0,12.36-2.11c1.21-.49,1-.85.12-1.32a3.1,3.1,0,0,1-1.65-1.49c-.23-.69-1.11-1-2.12-.91-3.48.28-7.15.29-9.92,1.9.38.47.16.92-.54,1.11A2.73,2.73,0,0,0,1250,475.24Z"
            />
            <path
              class="cls-46"
              d="M990.87,464.5c3.14-.83,6.71-.37,9.87-1.11,1.12-.27,2.24-.54,3.32-.86.51-.16,1.55-.21,1.14-.75a2.29,2.29,0,0,0-1.88-.43,56.58,56.58,0,0,0-7.4.81l-.38-.31c.85-.43,1.73-.84,2.53-1.3.58-.34.6-.65-.43-.57-.35,0-.56.09-.59-.18-.08-.89-1.43-1.28-2.17-1.91a3,3,0,0,1-.5.1c-3.62.05-5,1.28-5.37,3.26a2.12,2.12,0,0,0,.78,1.8C990.21,463.52,990.8,463.94,990.87,464.5Z"
            />
            <path
              class="cls-40"
              d="M1170.75,460.19c1.62.49,3.49,0,5.13.44-.89-.56-2.07-1-1.46-2,.11-.17-.37-.34-.7-.43C1172.84,458.93,1171.43,459.37,1170.75,460.19Z"
            />
            <path
              class="cls-47"
              d="M1125.55,488.53a2.3,2.3,0,0,0-2.09,1,1.63,1.63,0,0,1-2.51.36.63.63,0,0,0-.61-.11.4.4,0,0,0-.21.36,6.07,6.07,0,0,0,.19.82,3.57,3.57,0,0,1-1,1.65c-.28.23-.36.52,0,.79,3,.41,4.74,1.89,7.24,2.72.68.22.67.64.72,1s0,.88.82,1.11h12.55a3,3,0,0,0,1.21-.11c1.82-1.52,4.44-.44,6.63-.74a.8.8,0,0,1,.48.1c.63,1.22,2.34.72,3.62.75,2.3.06,4.6,0,6.91,0-.13-.57-.93-.46-1.52-.48-1.5,0-3,0-4.54,0,1.09-.47,2.93-.21,3.3-1.25.09-.24.18-.05.22,0a3.2,3.2,0,0,0,2.5-.18c5.16-1.49,8.63-3.87,10.52-7,.54-.91.92-1.86.27-2.83a2.65,2.65,0,0,0-1.71-.49c-2.16,0-4.3-.1-6.45-.1-.22.06-.48.12-.5.27-.57,3.42-4.7,4.79-9.52,5.77a6.38,6.38,0,0,0-1.34.3.5.5,0,0,0-.24.39c-.08,1.3-.09,1.31-2,.76a1.79,1.79,0,0,0-2.24.61c-.54.68-.31,1.48-1,2.2-2.24-.78-2-2.34-3.32-3.37-.91-1.22-1.49-1.35-3.82-.82-.47.1-.77.33-1.17-.13s-1.32-.43-2.09-.54c-1.31-.18-2.71-.39-3.32-1.15C1130.26,488.53,1127.89,488.58,1125.55,488.53Z"
            />
            <path
              class="cls-15"
              d="M1277.36,492.87c-.17-.92-.85-1.14-2.74-.78-.77.14-1.32.34-1.9-.23a4.42,4.42,0,0,0-1.69-.28c-2-.15-3.58-.64-4.36-1.8a2.2,2.2,0,0,0-2.26-.8,4.87,4.87,0,0,1-.54,0,8.39,8.39,0,0,0-4.93,1.07,1.57,1.57,0,0,1-1.72-.08c-.43-.26-.87-.5-1.07.1-.7.76.32,1.7-.73,2.44-.37.26-.61.61-.47,1,2.16.82,4.53,1.42,6.66,2.28.83.33,1.38.6,1.4,1.21s.27,1,1.15,1.23l11.48,0a2.19,2.19,0,0,0,.71,0c2.24-1.62,5.25-.56,7.87-.81,1.44-.31,3-.31,4.45-.5,7.73-1,13.21-3.59,16.2-7.94,1.31-1.85.08-3-3.24-3.06a19.48,19.48,0,0,0-3.58-.09c-.22.06-.45.14-.47.3-.47,2.57-3.46,4-6.93,5.11a4.33,4.33,0,0,1-4.18-.33c-.94.06-.73.47-.66.81s.36.6.51.91.4.64-.06.9-1,0-1.45-.14c-1.18-.46-1.91-.2-2.38.5a16.3,16.3,0,0,0-1.08,2.38,3.68,3.68,0,0,1-2.17-1.94C1278.81,493.74,1278.69,493,1277.36,492.87Z"
            />
            <path
              class="cls-48"
              d="M961.36,494.57c.18-1.08-1.11-.93-2.15-.81s-1.81.33-2.61-.24a3.06,3.06,0,0,0-1.2-.2c-2.18-.08-3.82-.62-4.67-1.86a2.18,2.18,0,0,0-2.15-.75,6.3,6.3,0,0,1-3-.58,1.8,1.8,0,0,0-1.64.84c-1.24,1.29-1.23,1.3-3.39.53,0,.48-.07.93-.1,1.38.19.36.44.68-.14,1.07-1.13.75-1.36,1.79-2.17,2.65-.61.66.95,1,.92,1.62.4-.68,1.15-1,2.41-.86,1,.08,2.06,0,3.09,0,.69,0,1.31,0,1.51.53s1,.33,1.52.34h5.82c-.09.54-.68.44-1,.39-2-.31-3.77.21-5.62.45-.49.06-.79.16-.79.47s.26.54.84.6a87.81,87.81,0,0,0,12.14.14c.65,0,1.31-.13,2-.13s1-.1,1.06-.54-.45-.48-1.06-.55a28.44,28.44,0,0,0-6-.42l0-.41c1.69,0,3.39,0,5.08,0,.8,0,1.74.17,2-.58.12-.37.78-.27,1.24-.28H967c.72,0,1.45-.07,1.67.54s1,.32,1.55.32c3.22,0,6.45,0,9.67,0-.25-.66-1.19-.48-1.89-.49-2.35,0-4.7,0-7.08-.1a46.79,46.79,0,0,0,7.76-1.6,15.52,15.52,0,0,0,8.64-6.1c.47-.68.73-1.45-.18-2.13a29.57,29.57,0,0,0-5.08-.27c-.31.07-.48.2-.5.4-.31,2.66-3.22,4.1-6.92,5.18a12,12,0,0,1-4.27.14c-.6.46,0,.89.12,1.32.07.26.12.51-.25.7a1.42,1.42,0,0,1-1.16-.05c-1.7-.48-2-.4-2.77.68-.23.33-.25.75-.92.88a1.76,1.76,0,0,1-2.08-.69C962.93,495.48,962.77,494.75,961.36,494.57Z"
            />
            <path
              class="cls-49"
              d="M1226.6,492.23a3.08,3.08,0,0,0,.4.7c.49.52.14.87-.53,1.21a1.71,1.71,0,0,1-1.76-.17c-1.23-.77-1.72-.29-2,.4a16.3,16.3,0,0,0-.77,2.08c-.15.5-.48.52-1.06.22a4.08,4.08,0,0,1-1.52-1.19c-.64-.94-1.26-1.89-1.89-2.84-.18-.79-1.05-.6-1.91-.49-3,.39-7.47-.78-9-2.36a3.16,3.16,0,0,0-2.17-.67c-2.4-.23-4.5-.56-5.63,1.24-.27.42-1.16,0-1.62-.32-.84-.51-.75,0-.85.27-.64.75-.09,1.57-.43,2.34a3.36,3.36,0,0,0,1.56.87,19.16,19.16,0,0,1,2.92,1.69,8.59,8.59,0,0,1,3.67,3c1.75.13,3.52-.12,5.26.15a1.43,1.43,0,0,0,1-.24c.44-.25.35-.78,1.31-.76,1.7,0,4.18-.39,5,.12,2.06,1.33,4.35.6,6.48.73,2.59.15,5.23,0,7.84,0,1,0,2.24.28,2.6-.7.09-.26.86-.17,1.34-.17l4.92,0c.22-.46-.48-.48-.82-.46a3.45,3.45,0,0,1-3.55-1.75l-.54-.79a9.94,9.94,0,0,1,3-2.88c1-.6,1-1.17-.2-1.68-.83.05-1.16-.47-1.85-.58-1.79,1.93-4.73,2.68-8.26,2.83A1.75,1.75,0,0,0,1226.6,492.23Z"
            />
            <path
              class="cls-50"
              d="M1012.38,494.16a9.55,9.55,0,0,1,2.56-2.5c1.27-.77,1-1.31-.75-1.83-2.85-.16-4.83-1-6-2.55a2.79,2.79,0,0,0-2.61-.87,7.19,7.19,0,0,1-3.15-.34,2.32,2.32,0,0,0-2.7.44c-.32.3-.55.63-.85.94a2,2,0,0,1-2.72.31c-.28-.16-.53-.48-1-.35s-.3.51-.27.77c.06.6.23,1.2.33,1.8,0,.28-.1.5-.67.49-.67.64,0,1,.87,1.12,1.6.32,2,.92,1.63,1.83-.29.76-.06,1.48,1.28,1.79,1.94.45,2.38,1.3,2.24,2.39a.9.9,0,0,0,.5.62l3.65,0c.66,0,1.39.06,1.45-.53,0-.2.26-.33.6-.33l5.65,0c1,0,.31.74,1.05.84.85-.74.53-1.48-.15-2.16A2.92,2.92,0,0,1,1012.38,494.16Z"
            />
            <path
              class="cls-51"
              d="M1054.75,492.87c-.17-.92-.84-1.14-2.74-.78-.76.14-1.34.36-1.89-.23a3.63,3.63,0,0,0-1.51-.26c-2.08-.12-3.72-.61-4.54-1.81a2.29,2.29,0,0,0-2.27-.8,5.77,5.77,0,0,1-.72,0,7.73,7.73,0,0,0-4.74,1.06,1.55,1.55,0,0,1-1.72-.06c-.88-.55-1-.19-1.07.3.14,1-.61,1.87-.84,2.81a8.47,8.47,0,0,0,2.47.88,15.08,15.08,0,0,1,2.39,1.12c1.56.77,3.16,1.45,3.3,2.8,0,.16.43.24.68.33,2.67,0,5.34,0,8,0,1,0,1.93.19,2.47-.67.29-.46,1.67-.19,2.55-.19,1.51,0,3.25-.44,4.26.72.13.15.89.14,1.37.14,3.51,0,7,0,10.55,0-.31-.69-1.33-.52-2.09-.53-2.55,0-5.11,0-7.65,0-1.45.1-1-.88-1.83-1.13a5.13,5.13,0,0,1-2.81-2.55A1.84,1.84,0,0,0,1054.75,492.87Z"
            />
            <path
              class="cls-52"
              d="M1234.71,494.4c-.23,1.62,1.34,2.74,4,2.81.35,0,.73,0,1,.19,0,.64.44.94,1.59.85.7-.06,1.41,0,2.12,0a3.2,3.2,0,0,0,.87-.53c1.56-1.44,3.8-1.77,6.38-.92a6.25,6.25,0,0,0,3.44.33c.65-.14,1.51-.47,1.17-.81-.94-.95-.2-1.85-.12-2.77,1.11-1.06,1.9-2.16,1.07-3.43-.75.1-1.4.27-2-.32a6.15,6.15,0,0,0-3.37-1.15c-1-.13-2,0-2.62-.68-.24-.3-.71-.11-1.08,0-1.68.72-3.24,1.47-3.4,2.83a1.41,1.41,0,0,1-.93,1c-1.9.88-3.85,1.71-5.71,2.62A2.29,2.29,0,0,1,1234.71,494.4Z"
            />
            <path
              class="cls-53"
              d="M1032.82,493.09c.82-.88,1.67-1.76.73-2.8-1,.85-2.91.87-3.46-.12-.79-1.42-2.65-1.33-4.42-1.54-.39,0-.8,0-1,.16-1.08,1.18-3.41,1.7-4.43,2.92-.49.59-1.75.58-2.53,1-1,.49-1.94,1-2.92,1.43-.79.38-1.59.72-2.43,0-.61.49-.65,1.11-.08,1.48a2.45,2.45,0,0,1,1.18,2.57h7.26a3.82,3.82,0,0,0,.86-.54c1.55-1.44,3.8-1.77,6.38-.92a7,7,0,0,0,2.58.41c1.82-.07,2.36-.53,1.67-1.52a1,1,0,0,1,.09-1.34C1032.61,493.93,1033,493.54,1032.82,493.09Z"
            />
            <path
              class="cls-54"
              d="M1324.72,492.86c.44-.54,1.45-1,.73-1.7l-6.77,3.84c.66-1,2-1.56,3.14-2.31.27-.18.66-.3,1-.48,1.59-1,1.59-1-.32-1.73a2.23,2.23,0,0,1-1-.73c-1.08-1.46-4.54-1.63-6.32-.44a46.7,46.7,0,0,1-6.89,3.9,37.79,37.79,0,0,0-4.3,2.25c0,1.08.89,1.69,2.88,1.93-.06.66.44.91,1.59.86s2.61,0,3.91,0c1-.23,1.16-.81,1.65-1.25a2.67,2.67,0,0,1,2.11-.61,13.59,13.59,0,0,1,4.67.68,4.67,4.67,0,0,0,3-.09c.61-.18,1-.49.57-.86-1-.77-.59-1.47.06-2.2C1324.65,493.57,1324.6,493.2,1324.72,492.86Z"
            />
            <path
              class="cls-55"
              d="M1110.17,495.87c2.55-1.53,5.1-3.05,7.63-4.59.65-.39,1.85-.86-.27-1a1.06,1.06,0,0,1-.68-.31c-.94-1.71-3.92-1.3-5.87-1.94-.64-.22-1.11.2-1.5.45-1.77,1.17-3.49,2.36-5.28,3.52a11,11,0,0,1-1.82.87c-1.26.51-1.76.22-1.69-.6-1.75.53-3.06,2.36-2.43,3.41,1,1.61,1,1.61,3.94,1.63a3.63,3.63,0,0,1,1.4.1c-.1.66.36.95,1.51.87.7-.05,1.41,0,2.11,0C1108.14,497.41,1109.25,496.68,1110.17,495.87Z"
            />
            <path
              class="cls-56"
              d="M1081,497.38c.11.33,0,.73.75.87a76.58,76.58,0,0,0,14.91,0c.25-.19.37-.39.24-.62-1.33-.74-2.05-1.59-2-2.72,0-.86-.9-1.45-2.25-1.75-.82-.19-1.39-.48-1.28-1,.27-1.41-.26-2.53-2.78-3.05-.2,0-.33-.2-.51-.3-1.44-.29-1.61.4-1.95.9a19.78,19.78,0,0,1-5.13,5.17c-.67.47-1.52.81-2.24,1.25-.47.28-1,.63-.7,1s1,.11,1.51.16A4.42,4.42,0,0,1,1081,497.38Z"
            />
            <path
              class="cls-57"
              d="M1081,497.38c-.74-.45-1.76-.05-2.59-.3-.13-.46.43-.72.93-.95a17.46,17.46,0,0,0,7.24-6.35c.28-.4.23-1,1.35-1,.21-.14.23-.28,0-.44-.19-.79-1.16-1.17-2.27-1.48a9.23,9.23,0,0,0-2.08-.68,2.23,2.23,0,0,0-1.59,0c-.29,5.53-8.28,9.42-17,10.23-1.13.11-2.28.2-3.42.28-1.33.1-1.95.52-1.41,1.33h8.87a3.15,3.15,0,0,1,1.71.2h2.17a2.58,2.58,0,0,0,.88,0c1.82-1.6,4.56-.53,6.81-.82A2.17,2.17,0,0,1,1081,497.38Z"
            />
            <path
              class="cls-58"
              d="M987.2,487.93c-.15,3.52-3.54,5.86-8.25,7.68a30.37,30.37,0,0,1-8,1.65c-.52.05-1.49.08-1.42.5s1,.25,1.53.26c2.37,0,4.74,0,7.11,0a3.06,3.06,0,0,1,1.71.2l3.07,0c.77,0,1.57.08,1.77-.59.1-.37.75-.28,1.21-.29l4.15,0c.11-.1.11-.19,0-.28-.54-.29-1.3-.12-2.08-.4,2.77-2.22,5.08-4.58,6.13-7.29-.33-.5-1.24-.56-1.84-.84a5.33,5.33,0,0,1-2.2-.44A2.73,2.73,0,0,0,987.2,487.93Z"
            />
            <path
              class="cls-59"
              d="M1306.83,497.39a4.43,4.43,0,0,1-2.88-1.93c-.54-.29-.47-.66-.22-1a11.54,11.54,0,0,1,2.71-2.75c1.5-1,1.49-1.08-.18-1.9l-.84-.4a1,1,0,0,0-1.06-.44c-3,4.27-8.52,6.75-16.09,7.71-1,.13-2.16,0-3.22.24-.46.09-.76.19-.83.47l0,.41c.43.43,1.15.3,1.78.32,2.57.07,5.14-.14,7.7.1l4.7,0c.72,0,1.46.07,1.63-.55.13-.44.84-.32,1.34-.33C1303.21,497.37,1305,497.38,1306.83,497.39Z"
            />
            <path
              class="cls-60"
              d="M1170.06,486.62c0,2.56-1.71,4.66-4.63,6.53a19.15,19.15,0,0,1-6.06,2.79c-1.93.47-1.9.51-3.61-.25-.16.44,1,.61.54,1a4.75,4.75,0,0,1-1.78.47c-.84.19-1.69.35-2.68.56.66.47,1.42.25,2.06.29,1.84.14,3.73-.24,5.54.23h.33a.89.89,0,0,0,.78,0c1,0,2,0,3.08,0a2.77,2.77,0,0,0,1-.1c.69-1.26,2.45-.68,3.77-.76,1.13-.07,2.28,0,3.43,0a1.09,1.09,0,0,1,.08-.15c-.58-.52-1.51-.33-2.32-.37a21.83,21.83,0,0,1-2.85-.11,15.72,15.72,0,0,1,2.85-2,12.59,12.59,0,0,0,4.13-4.13c.27-.44.77-.81,1-1.24a2.26,2.26,0,0,0,.09-1.18c-.23-.83-1.19-1.27-2.43-1.55a11.88,11.88,0,0,0-1.9-.19A1.13,1.13,0,0,0,1170.06,486.62Z"
            />
            <path
              class="cls-61"
              d="M1110.17,495.87a4.27,4.27,0,0,0-3,2.35l11.24,0c.36,0,.79,0,1-.17s.2-.72,1.08-.71a50.31,50.31,0,0,1,5.23.11c.67.08,1,1,2.27.75-.11-.28-.34-.55-.32-.82.07-.92,0-1.71-2-1.85a2.32,2.32,0,0,1-1.19-.62c-1.26-1.1-3.18-1.43-5.23-1.64-1.45.54-2.07,1.42-1.64,2.32.13.28.76.58.15.86a3,3,0,0,1-1.91,0,19.18,19.18,0,0,0-2.11-.61,24.56,24.56,0,0,0-3.21,0A2.17,2.17,0,0,1,1110.17,495.87Z"
            />
            <path
              class="cls-62"
              d="M1324.72,492.86c-.52.63-1,1.27-1.58,1.9s.06.91.59,1.24c.74.47.39.63-.44.79s-1.78.38-2.26.08c-1.62-1-3.76-.54-5.6-.85a1.25,1.25,0,0,0-1.3.35l-1.8,1.85,9.25,0c.41,0,.93.06,1.17-.18s.2-.72,1.08-.7c1.75,0,4.27-.38,5.08.14,1.41.91,2.76.66,4.24.72a3,3,0,0,1-.37-1.36c.1-.65-.29-1.11-1.52-1.21a1.26,1.26,0,0,1-.5-.08C1329.35,494.2,1326.66,493.82,1324.72,492.86Z"
            />
            <path
              class="cls-61"
              d="M1032.82,493.09c-.46.54-1,1.06-1.35,1.61a.7.7,0,0,0,.16,1c.88.84.54,1.18-1.19,1.23a2.85,2.85,0,0,1-1.39-.15c-1.26-.72-2.85-.56-4.36-.74-1.85-.21-2.53.3-3.15,1.09-.28.35-.54.71-.8,1.07l7.06,0a1.83,1.83,0,0,0,1-.16c.38-.28.35-.76,1.31-.73,1.75.05,4.24-.38,5.1.14,2,1.25,4.25.51,6.33.73l-.15-.19c-.67-1.1-.34-2.6-3.24-2.81C1037.15,493.85,1034.83,493.61,1032.82,493.09Z"
            />
            <path
              class="cls-63"
              d="M1255.08,493.51c-.65.84-2,1.63-.31,2.59.5.28,0,.51-.45.65a4.55,4.55,0,0,1-3.4-.22c-1.57-.81-3.57-.52-5.19-.45-1.41.07-1.8,1.32-2.39,2.13l10.92,0a1.49,1.49,0,0,0,1.29-.42c.42-.5,5.18-.76,5.46-.29.64,1.11,2,.59,3.15.69a1.27,1.27,0,0,0-.24-.28c-.89-.63.2-1.8-.89-2.07C1260.28,495.19,1258.16,493.78,1255.08,493.51Z"
            />
            <path
              class="cls-64"
              d="M1204,498.23c-.12-.31-.36-.62-.32-.93.09-.83-.16-1.45-1.86-1.55a1.34,1.34,0,0,1-1.08-.51c-.76-1.4-2.93-1.88-4.77-2.58-1.56.55-2.75,2.35-2.15,3.25.46.7.14,1-1.11.89a4,4,0,0,1-1.35-.29c-1.61-.65-3.49-.48-5.26-.57-.9,0-1.49.28-1.17.9.21.26.74.37.86.68-.25.29-.73.2-1.11.2-3.39,0-6.78,0-10.18,0a25.75,25.75,0,0,1-2.6-.39l0,.07c-.13.65.35.87,1.45.86,4.43,0,8.85,0,13.27,0,.35,0,.9,0,1-.11,1.67-1.57,4.24-.43,6.31-.75C1196.88,499.22,1200.63,497.82,1204,498.23Z"
            />
            <path
              class="cls-65"
              d="M1088,488.35c0,.15,0,.3,0,.44,0,.5.26.81,1.2.87,1.44.1,1.88.64,1.75,1.44a10.75,10.75,0,0,0,0,1.39c0,.45.28.74,1.1.82,2,.21,2.67,1,2.53,2.1s.5,1.89,2.41,2.2c2.2-.54,4.48-.12,6.72-.23a1.83,1.83,0,0,0-1-.22c-1-.09-2.41.33-2.84-.25-.76-1-2.22-2.11-.47-3.31.58-.4.67-1,1.37-1.36a4.2,4.2,0,0,0,1.81-1.51,2.8,2.8,0,0,1-2-.65c-.94-.62-1.64-.39-2,.25a27.46,27.46,0,0,0-1.15,2.91c-.08.2.11.47-.29.57s-.72-.18-1-.32a5.11,5.11,0,0,1-2.66-2.73,2.4,2.4,0,0,0-1.27-1.38c-.1,0-.26-.09-.27-.14C1091.69,487.22,1089.45,488.36,1088,488.35Z"
            />
            <path
              class="cls-47"
              d="M1134.36,500.4a61.11,61.11,0,0,0,6.91-.22c.63-.05,1-.14,1-.57s-.34-.43-.88-.53c-3.49-.63-7.11-.42-10.67-.6-1.46-.07-2.62.64-4.09.69-.49,0-.4.39-.36.64s.51.31.94.37A51.64,51.64,0,0,0,1134.36,500.4Z"
            />
            <path
              class="cls-66"
              d="M1174.47,498.68a2.18,2.18,0,0,1-1.72.43c-.51,0-.82.09-.83.41s.16.55.77.61a72.51,72.51,0,0,0,12.59.08c.47,0,1,0,1.44-.06s1.1,0,1.18-.45-.39-.59-1-.72a7.7,7.7,0,0,1-1.89-.31C1181.49,498.52,1178,498.49,1174.47,498.68Z"
            />
            <path
              class="cls-67"
              d="M1202.78,500.41a64.39,64.39,0,0,0,6.79-.25c.56,0,.93-.12.93-.5s-.21-.47-.8-.57c-3.92-.71-7.94-.37-11.92-.42-.92,0-1.69.5-2.73.45-.55,0-.54.32-.54.58s.45.4,1,.47A53.74,53.74,0,0,0,1202.78,500.41Z"
            />
            <path
              class="cls-68"
              d="M1332.08,498.67a2.74,2.74,0,0,1-1.76.42c-.65,0-.81.24-.8.57s.18.45.72.5a86.5,86.5,0,0,0,12.47.11c.66,0,1.32-.09,2-.11.49,0,.82-.12.83-.44s0-.62-.52-.57c-1.51.13-2.68-.63-4.16-.48A80,80,0,0,0,1332.08,498.67Z"
            />
            <path
              class="cls-69"
              d="M971.49,498.67a4,4,0,0,1-1.79.43c-.61,0-1.1.07-1,.52s.51.49,1.11.54a88.81,88.81,0,0,0,14,0c.6,0,.85-.2.86-.54s-.26-.53-.87-.53a2.77,2.77,0,0,1-2.06-.44C978.32,498.52,974.9,498.51,971.49,498.67Z"
            />
            <path
              class="cls-70"
              d="M1269,500.41a59.25,59.25,0,0,0,7-.24c.64-.07,1.23-.1,1.25-.58s-.73-.41-1.28-.51c-2.86-.57-5.81-.36-8.73-.44a27.71,27.71,0,0,0-5.27.44c-.63.11-.71.32-.7.63s.5.39,1,.47A51.47,51.47,0,0,0,1269,500.41Z"
            />
            <path
              class="cls-71"
              d="M1247.45,500.4a57.72,57.72,0,0,0,7.21-.25c.61-.08,1-.17,1-.58s-.43-.4-.94-.49c-3.27-.57-6.64-.34-10-.48-1.64-.06-3,.44-4.51.48-.58,0-.56.31-.57.57s.34.43.9.51A52,52,0,0,0,1247.45,500.4Z"
            />
            <path
              class="cls-72"
              d="M1291.94,500.41a59.87,59.87,0,0,0,7.22-.24c.62-.07,1-.17,1.07-.58s-.5-.44-1.07-.54c-3.29-.57-6.67-.31-10-.43-1.59-.05-2.86.46-4.35.51-.57,0-.55.32-.54.58s.36.37.82.44A47.54,47.54,0,0,0,1291.94,500.41Z"
            />
            <path
              class="cls-73"
              d="M1044.39,500.41a54.49,54.49,0,0,0,6.33-.24c.6-.06,1.07-.09,1.08-.53s-.47-.46-1-.56c-3.23-.6-6.56-.32-9.84-.46-1.65-.07-3,.47-4.55.49-.53,0-.61.3-.55.57s.5.42,1,.49A57.1,57.1,0,0,0,1044.39,500.41Z"
            />
            <path
              class="cls-74"
              d="M1151.79,498.68a2.27,2.27,0,0,1-1.73.42c-.62,0-.84.2-.83.54s.18.46.71.5a77.7,77.7,0,0,0,12.58.1c.47,0,1-.07,1.43-.08.66,0,1.23-.07,1.26-.56s-.59-.51-1.22-.54-1.39.16-1.71-.36A96.59,96.59,0,0,0,1151.79,498.68Z"
            />
            <path
              class="cls-75"
              d="M998.63,500.42a59,59,0,0,0,6.62-.27c.56,0,.9-.12.93-.49s-.33-.49-.95-.6c-3.28-.58-6.64-.34-10-.46-1.65-.06-3,.48-4.53.51-.56,0-.57.31-.53.57s.52.4,1,.48A55.19,55.19,0,0,0,998.63,500.42Z"
            />
            <path
              class="cls-76"
              d="M1314.85,500.38a52.73,52.73,0,0,0,7.06-.24c.64-.07,1-.2,1-.61s-.53-.36-1-.45c-3-.55-6-.36-9.05-.46a35.72,35.72,0,0,0-5.24.44c-.68.08-.69.33-.69.63s.46.4,1,.47A51.62,51.62,0,0,0,1314.85,500.38Z"
            />
            <path
              class="cls-77"
              d="M1218.56,499.1c-.64,0-1.41-.11-1.43.52s.61.49,1.23.55a89.58,89.58,0,0,0,13.9,0c.71,0,.92-.24.92-.62s-.45-.6-1.15-.64-1.46.47-1.83-.23a50.26,50.26,0,0,0-7.26,0h0C1221.51,498.91,1220,498.75,1218.56,499.1Z"
            />
            <path
              class="cls-78"
              d="M1083.18,500.17a5,5,0,0,0,2.09.23c3.43-.06,6.85.11,10.28-.21,1.34-.13,1.66-.37,1.46-1.06-3.91-.81-8-.66-12-.69-1.32,0-2.12.77-3.49.64-.37,0-.34.32-.34.53s.12.41.58.45A5.15,5.15,0,0,1,1083.18,500.17Z"
            />
            <path
              class="cls-79"
              d="M1061.27,498.67l-.37.21c-.47.39-2.16.66-.35,1.27a4.18,4.18,0,0,0,1.89.26c3.61,0,7.23.15,10.82-.23.63-.07,1.2-.06,1.19-.57s-.6-.54-1.23-.54-1.36,0-1.74-.39C1068.08,498.5,1064.67,498.51,1061.27,498.67Z"
            />
            <path
              class="cls-80"
              d="M1111.72,500.14h6.53c.71,0,1.39,0,1.34-.61s-.84-.34-1.35-.45c-3.14-.67-6.4-.3-9.59-.47-1.65-.09-3,.46-4.5.5-.59,0-.49.33-.49.58s.44.46,1,.46h7.08Z"
            />
            <path
              class="cls-81"
              d="M1020.77,500.35a50.78,50.78,0,0,0,7.51-.22c.6,0,.8-.26.8-.59s-.3-.4-.79-.46a36.46,36.46,0,0,0-7.55-.4C1020.12,499.24,1020,499.79,1020.77,500.35Z"
            />
            <path
              class="cls-82"
              d="M1020.77,500.35l0-1.67a28.75,28.75,0,0,0-7,.39c-.55.1-.6.29-.62.55s.29.46.87.52A45.21,45.21,0,0,0,1020.77,500.35Z"
            />
            <path
              class="cls-83"
              d="M1083.18,500.17a2.39,2.39,0,0,0-1.18-.2c-.42,0-.64-.16-.64-.42s.23-.35.63-.43c3.74-.77,7.61-.46,11.4-.36,1.11,0,2.38.33,3.62.37-.58-.51-1.65,0-2.35-.42.42-.51,1.57,0,2-.48l-14.91,0c.27.28.91.15,1.36.4-.7.41-2.66.07-2.08,1.14C1081.39,500.48,1082.42,500.1,1083.18,500.17Z"
            />
            <path
              class="cls-75"
              d="M990.1,497.18a1.55,1.55,0,0,0,0,.22c0,.61.5.87,1.58.86,3.14,0,6.28,0,9.41,0,0-.21,0-.41,0-.61-1.62,0-3.22.14-4.84.12A20.48,20.48,0,0,1,990.1,497.18Z"
            />
            <path
              class="cls-47"
              d="M1151.79,498.68l10.49,0c-.34-.46-1.33-.05-1.73-.44h-.78c-1.87.44-3.82.08-5.73.21C1153.29,498.51,1152.45,498.29,1151.79,498.68Z"
            />
            <path
              class="cls-51"
              d="M1060.55,500.15c-1.13-.54.4-.83.35-1.27a4.75,4.75,0,0,0-.54,0c-.75.12-2,0-1.92.67S1059.71,500.12,1060.55,500.15Z"
            />
            <path
              class="cls-15"
              d="M1354.73,498.69h10.49a2.42,2.42,0,0,0-1.69-.22C1360.6,498.59,1357.63,498.17,1354.73,498.69Z"
            />
            <path
              class="cls-64"
              d="M1174.47,498.68H1185c-2.67-.46-5.41-.11-8.11-.19A4.49,4.49,0,0,0,1174.47,498.68Z"
            />
            <path
              class="cls-51"
              d="M1061.27,498.67h10.21a6.2,6.2,0,0,0-2.94-.2C1066.12,498.55,1063.66,498.2,1061.27,498.67Z"
            />
            <path
              class="cls-48"
              d="M971.49,498.67h10.24c-2.58-.44-5.22-.11-7.82-.18A4.82,4.82,0,0,0,971.49,498.67Z"
            />
            <path
              class="cls-15"
              d="M1293.73,498.24c-1.24-.44-2.6-.12-3.9-.2-1.85-.12-3.76.21-5.58-.22.09.55.81.43,1.37.43C1288.32,498.26,1291,498.25,1293.73,498.24Z"
            />
            <path
              class="cls-15"
              d="M1332.08,498.67h8.76A37.74,37.74,0,0,0,1332.08,498.67Z"
            />
            <path
              class="cls-49"
              d="M1222.94,498.67l7.26,0A24.54,24.54,0,0,0,1222.94,498.67Z"
            />
            <path
              class="cls-49"
              d="M1218.56,499.1a17.66,17.66,0,0,0,4.38-.43C1221.45,498.73,1219.85,498.38,1218.56,499.1Z"
            />
            <path
              class="cls-84"
              d="M1304.36,489l1.06.44a28.39,28.39,0,0,1,3.72-2.88,25.26,25.26,0,0,0,2.27-2.05c1.49-1.56,2.21-1.81,5.22-1.48s5.92.67,8.84,1.09c1.69.25,3.08.36,3.85-.83.22-.34.85-.59,1.37-.93a1.9,1.9,0,0,1-1.6-2c0-.74-.21-1.54-2.1-1.45a2.27,2.27,0,0,1-1.71-.71c-1.74-1.45-3.25-1.58-5.63-.46-.24.12-.48.22-.73.32-1,.65-1.21,1.68-2.91,2-1.35.23-1.59-.48-2.2-.88a2.4,2.4,0,0,0-1.53-.21,8.62,8.62,0,0,1-4.52-.91,2.55,2.55,0,0,0-2.71-.05c-.74.47-1.44.17-2.17.08-.62.38-.17.82-.19,1.23a1.48,1.48,0,0,1-1.19,1.47c-1,.31-1.38-.22-2-.5a7.94,7.94,0,0,0-6.2.2,4.35,4.35,0,0,1-4.95-.05l-.37-.24c-2-1.32-2.53-1.31-4.49.05a2.27,2.27,0,0,1-1.49,2.72s-.12.06-.11.08c.4,1.52-1.83,1.51-3.27,2-1.8.6-2.3,1.39-1.49,2.51a2.54,2.54,0,0,1,.31,2.61.73.73,0,0,0,.15.92c.73.65.58,1.28-.27,1.86a2.41,2.41,0,0,1,1.17,1.17,3.76,3.76,0,0,0,.65,1.12c.51.6,1,1.44,2.24,1.39,1,0,.46-.92.85-1.38.19-.22.19-.49.3-.73.59-1.25.74-1.3,2.44-.54a1.76,1.76,0,0,0,1.47,0c.7-.26.71-.6.58-1-.22-.66-1.49-1.21-.63-2,1.59-.76,1.91-1.51,1-2.51a16.28,16.28,0,0,0-3.12-2.5c-1.32-.88-1.06-1.56.83-1.95a18.35,18.35,0,0,1,6.81,0c.69.11,1,.53,1.41.81a6.81,6.81,0,0,0,4.37,1.22c1.73.06,3.46.09,5.19.17,1.33.06,2.5,1.37,1.93,2.13C1304.7,488.55,1304.33,488.71,1304.36,489Z"
            />
            <path
              class="cls-85"
              d="M1322.22,472c-.13.81-1.61.93-2.23,1.49.75.2,1.4.32,1.57,1,.32,1.28,1.55,1.8,3.6,1.82,2.24,0,3.71-.5,4.12-1.74.25-.78.88-1.16,2-1.38a6.36,6.36,0,0,0,1.3-.38c.81-.37,2.5-.31,2.07-1.31-.7-1.61-1.25-1.74-3.64-1.68a51.14,51.14,0,0,0-5.17.5C1324.22,470.55,1322.85,471,1322.22,472Z"
            />
            <path
              class="cls-16"
              d="M1353.23,470.73l2.41.71c.6.18,1.3.06,1.4-.22.32-.9,1.43-.68,2.39-.71a4.5,4.5,0,0,0-3.83-.46C1354.78,470.23,1354,470.5,1353.23,470.73Z"
            />
            <path
              class="cls-18"
              d="M934.29,476.75a20.5,20.5,0,0,0,7.77.38,27.37,27.37,0,0,0,8.5-2c.94-.41,1.3-.75.2-1.24a3.13,3.13,0,0,1-1.64-1.5,2.47,2.47,0,0,0-2.52-1,57.15,57.15,0,0,0-7.23,1,21.53,21.53,0,0,0-2.17,1,1,1,0,0,1-.83,1.18A2.47,2.47,0,0,0,934.29,476.75Z"
            />
            <path
              class="cls-86"
              d="M1013.84,489.43a3,3,0,0,0,2.22-.56,42.46,42.46,0,0,0,4.54-3.71,2,2,0,0,1,2.33-.44,5.16,5.16,0,0,0,4.15-.37c1.45-.85,3.11-1.58,4.68-2.36.33-.16.71-.4,1.07-.11s-.27.37-.56.52c-1,.49-2.11,1-1.41,1.87a3.71,3.71,0,0,0,3.09.85c1.52-.1,2.16-.7,2.16-1.57,0-.17.09-.5.31-.42,1.6.58,1.74-.58,2.84-.69-2.16-.5-1.67-1.64-2-2.52-.24-.61-.61-1-1.72-1a2.32,2.32,0,0,1-1.75-.67c-1.41-1.64-3.32-1.66-6.07-.31-.23.12-.47.22-.71.33s-.69.5-1,.75c-1.45,1.16-1.45,1.17-3.25.32a5.45,5.45,0,0,0-2.55-.43,8.27,8.27,0,0,1-3.72-.71c-1.71-.82-3.11-.71-4.33.4a11.3,11.3,0,0,0-1.09,1.23A3.88,3.88,0,0,1,1009,481c-1.55.4-1.61.65-.19,1.24.8.34,1.48.74,2.19,1.12s.88.73.6,1.16c-.47.7.08,1.26.57,1.82.7.8,2,1.48.87,2.53C1012.74,489.08,1013.43,489.29,1013.84,489.43Z"
            />
            <path
              class="cls-87"
              d="M990.1,497.18a4.23,4.23,0,0,0,3.19.87c1.8-.07,3.61-.05,5.42,0a5,5,0,0,0,2.33-.43c.27-1.25,0-2.25-2.53-2.64-1.28-.19-1.19-.89-1-1.52.48-1.49.35-1.66-2-2.09-.81-.15-1-.47-1-.88s.16-.76-.4-1.05a4.88,4.88,0,0,0-1.53,1.92,16.75,16.75,0,0,1-4.35,4.65c-.37.3-1.28.5-.91.94s1.2.16,1.83.22C989.48,497.19,989.79,497.17,990.1,497.18Z"
            />
            <path
              class="cls-43"
              d="M1030.62,471.59c0,1-1.34,1.33-2.53,1.73l0,.42c.23.62.86,1,2,1.07a33.1,33.1,0,0,0,12.27-1.5c1.88-.65,1.93-.78.69-1.88a2.82,2.82,0,0,1-.49-.69c-.56-.95-1.67-1.23-3.29-1s-3.44.39-5.15.6A6,6,0,0,0,1030.62,471.59Z"
            />
            <path
              class="cls-88"
              d="M1083.54,486.43a5.59,5.59,0,0,0,2.14.44c.33-.39.68-.77,1-1.16.57-.73.93-1.4-.79-1.85-.89-.23-1-.77-.69-1.31.47-.94.11-1.56-1.75-1.8a3.14,3.14,0,0,1-2.5-1.43c-.37-.72-.72-1.44-1-2.16a2.14,2.14,0,0,0-2-1.35,1.6,1.6,0,0,1-1.6-1.4c-.35-1.11-.92-1.35-2.85-1.15a10.54,10.54,0,0,1-5-.59,9,9,0,0,0-3.2-.69c-2.32-.06-3.5-1.32-5.35-1.9-1.83-.07-3.75.27-5.42-.49a1,1,0,0,0-1.28.32c-.51,1.36-1.75,2.77-.47,4.13s2.17,2.86,5.36,3.06c1.1.07,2.22.38,1.33,1.29-.38.39,0,.59.56.75.88.27,1.09.72,1,1.26,2.15-.87,3.45-.18,4.94.75a5.27,5.27,0,0,0,5.29-.14,5,5,0,0,1,5.93.59c1.66,1.28,2.72,3,5.43,3.73C1083.32,485.56,1083.77,485.88,1083.54,486.43Z"
            />
            <path
              class="cls-37"
              d="M1099.25,488.58c.83-.22.7-.67.72-1.08.3-.44-.23-.74-.54-1.07s-.87-.83-.78-1.29c.27-1.36-1-2.23-2.62-3-1.12-.5-1.11-.81.19-1.16a5,5,0,0,0,2.28-1.62,4.86,4.86,0,0,1,4.19-1.47l.2-.1c-.28-.88-1.87-.55-2.54-.94-1.26-.73-1.73-.12-2.56.27s-.79.57-.15.93.5.75-.14,1.09a13.38,13.38,0,0,1-2.59,1.33c-1.42.44-1.42,1.11-.59,1.79a5.49,5.49,0,0,0,1.57.88c1,.38,1.65.93,1.55,1.59C1097.22,486.19,1098.7,487.3,1099.25,488.58Z"
            />
            <path
              class="cls-89"
              d="M1105.1,478.72a7.81,7.81,0,0,1,4.5.82,1.68,1.68,0,0,0,2.39-.21c-.81-1.44-3-1.35-4.92-1.48-1.38-.1-2.79,0-4.18,0l0,0C1103.05,478.72,1103.48,478.89,1105.1,478.72Z"
            />
            <path
              class="cls-90"
              d="M1283.53,480.19c1.18.06,1.51-1.15,2.74-.74a11,11,0,0,1,2.07,1.31,4.57,4.57,0,0,0,5.3-.17c1.27-.84,4.81-.84,5.91,0a2.33,2.33,0,0,0,3.32-.27c.63-.78.17-1.53,0-2.3-.57-.65-.16-1.68-1.46-2-1.92-.44-2.42-1.22-2.71-2.3-.16-.62-1.43-.76-2.41-.59a10.53,10.53,0,0,1-5.84-.63,2.91,2.91,0,0,0-1-.29c-2.89-.12-4.94-1.19-7.08-2.15-1.83-.11-3.77.3-5.45-.49a.84.84,0,0,0-1.19.38c-1,1.75-1.54,3.33.51,5.15a9.27,9.27,0,0,0,4.83,2.05c.93.18,1.54.48.91,1.11-.4.4-.2.65.48.85S1283.6,479.7,1283.53,480.19Z"
            />
            <path
              class="cls-14"
              d="M1313.81,479.12c.36.62.52,1.4,2.2.88C1315,480,1314.66,479.31,1313.81,479.12Z"
            />
            <path
              class="cls-91"
              d="M1170.41,486.61a7.84,7.84,0,0,0,1.83.23c2.09-1,2.31-2,.7-3.16-.36-.26-.62-.52-.51-.87.28-.69.47-1.37-1-1.75l-2.56-.64a3.6,3.6,0,0,1-2.18-2.5,2.85,2.85,0,0,0-2.89-2.29c-.85-.1-.71-.59-.77-1-.19-1.26-1-1.64-3.07-1.42a10.65,10.65,0,0,1-5.21-.54,8.21,8.21,0,0,0-3-.68c-.21-.11-.33-.34-.74-.2-2-.18-3-1.31-4.74-1.72-1.8,0-3.64.18-5.3-.47-.72-.29-1.12,0-1.29.4-.72,1.76-1.38,3.39.6,5.19a7.73,7.73,0,0,0,4,1.78c1.06.21,2.34.42,1.67,1.41-.22.31.09.56.57.69.65.19.84.49.8.88a.9.9,0,0,0,.64.15,3.58,3.58,0,0,1,3.73.72,5.57,5.57,0,0,0,6.11.06,4.9,4.9,0,0,1,5.67.67c1.53,1.29,2.71,2.89,5.26,3.67C1169.9,485.57,1170.36,486,1170.41,486.61Z"
            />
            <path
              class="cls-92"
              d="M1170.41,486.61c.86-.76.56-1.25-1-1.48a4,4,0,0,1-2.53-1.28,3.43,3.43,0,0,0-2.47-1.72.66.66,0,0,1-.61-.61c0-.85-.7-1.37-2.09-1.47-1.55-.12-3.11-.23-4.26.68a4.45,4.45,0,0,1-5,.15c-1.47-1-2.68-2-5.1-.91-.14.88.43,1.82-.72,2.6.23.46-.55.69-.73,1.05,0,.31-.25.54-.75.65a10.77,10.77,0,0,0-4.67,1.24,13.46,13.46,0,0,0-2.81,1.67c-.3.23-.59.51-.09.76a1.47,1.47,0,0,0,1.16-.09c.51-.17.89-.7,1.48-.49.81.29,1.2,1,.94,1.42-1,1.44.61,2.75.33,4.13.89.67,1,1.53,1.6,2.26a2.09,2.09,0,0,0,.55.56c.58.34,1,1,1.88.87s.27-.76.53-1.15c.36-.56.11-1.21.74-1.75a1.11,1.11,0,0,1,1.44-.21c.59.31,1,.94,2.07.5,1.23-.5.57-1.14.27-1.74a7.24,7.24,0,0,1,.94-2.49c.56-.77-.15-1.47-.92-2.09s-1.69-1.21-2.52-1.83c-1.12-.84-.87-1.48.77-1.85a19.43,19.43,0,0,1,7.33.08c.62.09.84.49,1.25.75a6.07,6.07,0,0,0,4.15,1.21c2.28.21,4.58.15,6.87.18a2.17,2.17,0,0,1,1.56.41A2.08,2.08,0,0,0,1170.41,486.61Z"
            />
            <path
              class="cls-93"
              d="M1141.55,492.91c.32-.71,1.22-1.4-.18-2.12-.45-.24-.32-.83.15-1.2a.71.71,0,0,0,.17-1.1c-.37-.56-.42-1.43-1.08-1.63-1-.32-1.43.65-2.29.91-.15,0-.32.05-.84.13a17.52,17.52,0,0,1,7.73-3.63c.12-.91-.56-1.32-2.13-1.29-1.33,0-2.65-.17-2.68,1.11s-1.16,2-3.27,2.25a4.66,4.66,0,0,1-4.11-1.12,1,1,0,0,0-1-.39c-.59.13-.4.51-.31.75.31.8,1.32,1.15,2.61,1.27.45,0,1.15,0,1.07.37s-.76.26-1.22.28a4,4,0,0,1-3.07-.94,1.47,1.47,0,0,0-2.29,0,11.21,11.21,0,0,1-3.3,1.95,11.94,11.94,0,0,0,3.32.47,1.6,1.6,0,0,1,1.55.59c.92,1.31,2.69,1.85,5,2,.81.06,2.07.06,1.36,1C1139.82,491.57,1140.78,491.64,1141.55,492.91Z"
            />
            <path
              class="cls-94"
              d="M1105.1,478.72a2.74,2.74,0,0,1-2.23-.87c-2.26-.39-2.88-.26-4.34,1-1,.9-1.68,2-3.82,2.28-.76.1-.51.5,0,.74s1.21.6,1.83.88c1.24.56,1.86,1.25,1.65,2.22s1.18,1.67,1.81,2.51a2.15,2.15,0,0,0,2.17-.62,30.09,30.09,0,0,0,5-5.18C1108.56,479.73,1108.36,479.32,1105.1,478.72Z"
            />
            <path
              class="cls-44"
              d="M1117.12,471.59a2,2,0,0,1-1.82,1.52,2.23,2.23,0,0,0,.76,2.25,5.08,5.08,0,0,0,3.65.93,4.25,4.25,0,0,0,3.46-1.85c.33-.55.71-.68,1.62-.72a11.29,11.29,0,0,0,4.38-1.19c1.55-.69,0-1.35-.24-2s-1.31-.95-2.43-.85c-2.07.2-4.15.41-6.19.73A12.46,12.46,0,0,0,1117.12,471.59Z"
            />
            <path
              class="cls-55"
              d="M1110.53,495.88a1.82,1.82,0,0,0,1.32.23,6.52,6.52,0,0,1,3.52.6,3.42,3.42,0,0,0,2.06.21c1-.15,2.09-.25.87-1.14s.33-1.69,1-2.48c.21-.29.29-.68.66-.86.95-.46.86-.95.41-1.51-.89-.38-1.3.08-1.79.36Z"
            />
            <path
              class="cls-91"
              d="M1146,483.62c.87-.2,1.35-.49.73-1.05C1146.51,482.93,1145.16,483,1146,483.62Z"
            />
            <path
              class="cls-95"
              d="M1083.54,486.43c1.42-.52.62-1-.27-1.21a4.88,4.88,0,0,1-3.42-2.06,1.94,1.94,0,0,0-1.46-.88,1.13,1.13,0,0,1-1.09-.9c-.14-.74-.75-1.28-2.12-1.36-1.53-.09-3.08-.14-4.21.63a4.63,4.63,0,0,1-5.09.21l-.51-.3c-2.08-1.28-2.08-1.28-4.45-.16a2.07,2.07,0,0,1-1.36,2.43c-.18.08-.43.26-.38.35.59,1.23-1.12,1.27-2.32,1.55-2.48.6-3.15,1.47-2.17,2.95a2,2,0,0,1,.4.92c.07,1-.6,2.08.31,3.11.31.36-.07.84-.65,1.16.88.39,1,1,1.4,1.57a4.12,4.12,0,0,0,2.94,2.31c.92-.35.73-1,1-1.47a6.25,6.25,0,0,1,.46-1c.21-.29.47-.46,1.1-.35,3,.5,3.61.15,2.91-1.59a1.77,1.77,0,0,1,.06-1.89c.8-1.21.23-2.25-1.15-3.18-.72-.49-1.42-1-2.06-1.5-.91-.74-.7-1.23.63-1.66a15.46,15.46,0,0,1,4.82-.36A6.18,6.18,0,0,1,1071,485a8.81,8.81,0,0,0,5,1.34,31.85,31.85,0,0,0,4.89.21,2.21,2.21,0,0,0,1.15-.29A3.5,3.5,0,0,1,1083.54,486.43Z"
            />
            <path
              class="cls-39"
              d="M1174.42,488.15v1.28a4.4,4.4,0,0,1,3.29,2.16,53.72,53.72,0,0,0,6.28-4.41,1.75,1.75,0,0,1,2.51-.21,4.43,4.43,0,0,0,3.19.5,46.53,46.53,0,0,1,10.08-.19c.86,0,1.76,0,2.2-.51s0-1-.71-1.43c-1.06-.69-1.26-1.45,0-2.16.65-.36.92-.6-.1-.94a1.65,1.65,0,0,1-1.22-1.7c-.06-.77-.26-1.42-2-1.45a2.86,2.86,0,0,1-1.81-.84c-1.7-1.25-3.08-1.4-5.36-.49-.49.19-.86.57-1.4.07-.68.32-.79.86-1.3,1.25a2,2,0,0,1-2.37.24,5,5,0,0,0-3.69-.26c-.23,2.29-2,4.26-3.88,6.19a4.7,4.7,0,0,1-3,1.54c-.37.39-.14.82-.25,1.23,0,.1.08.2,0,.3C1174.85,488.16,1174.71,488.08,1174.42,488.15Z"
            />
            <path
              class="cls-96"
              d="M1185,496.74c.09-.26.34-.62.7-.55,1.72.33,3.69-.21,5.27.52a4.61,4.61,0,0,0,2.54.4c1.67-.18,1.83-.38.84-1.2-.33-.27-.68-.51-.38-.87l2-2.38c1.28-.73.13-1.57.31-2.35-1.65,1.06-2.81.95-4-.35s-4-1.44-5.63-.54a56.13,56.13,0,0,1-6.19,3.45c-.36.15-.57.37-.57.64a5.33,5.33,0,0,1,.63,2.39,1.61,1.61,0,0,0,.94,1.35C1182.86,498.07,1184.23,497.87,1185,496.74Z"
            />
            <path
              class="cls-91"
              d="M1185,496.74c-.76.2-.81,1.1-2.24.68-1.28-.37-1.7-.92-1.74-1.69s.36-1.66-1.08-2.22c-2.43-.22-2.94-.67-2.18-1.92,0-1.57-.77-2-3.29-2.16-1.1.41-1.08,1.16-1.49,1.76-1.22,1.8-3.37,3.19-5.47,4.61-.57.38-1.88.68-1.49,1.18s1.66.11,2.53.18c1.12.09,2.29-.19,3.36.19a2.18,2.18,0,0,0,2,.71c3.83-.05,7.66,0,11.49,0,.57,0,1.44.2,1.64-.19s-.63-.63-1.17-.85C1185.52,496.88,1185.22,496.82,1185,496.74Z"
            />
            <path
              class="cls-97"
              d="M1182.07,479.11c1.53-.06,3-.09,4.06.78a1.11,1.11,0,0,0,1.37,0c1-.59,2-1.16,1.92-2.07a.53.53,0,0,1-.07-.2c-.59,0-1.19-.25-1.25-.54-.2-1.13-1.7-1.27-3-1.33a26,26,0,0,0-7.54.22c-1.29.32-2.56.81-1.65,1.87a23.4,23.4,0,0,1,4.19,1.15A2.51,2.51,0,0,0,1182.07,479.11Z"
            />
            <path
              class="cls-95"
              d="M987.2,487.93a8.79,8.79,0,0,1,2.91.22c.61,0,1.08-.18,1-.59s-.52-.5-1-.57c-2-.28-3.09-1-3.63-2.15a1.41,1.41,0,0,0-.88-.65c-1.32-.23-1.8-.7-1.81-1.5s-1.1-.8-2-.92a6.09,6.09,0,0,0-4.15.67,5.06,5.06,0,0,1-5.29.13,3.67,3.67,0,0,1-.73-.47c-.89-.89-1.83-1.51-3.38-.38-.23.17-.56,0-.83,0-.12,1.11.54,2.35-1.58,3.1.43,1.56-2,1.48-3.37,2-1.61.62-2.1,1.2-1.39,2.25s1.09,1.8.53,2.79a.66.66,0,0,0,.07.83c1,.74.36,1.32-.4,1.91a2.87,2.87,0,0,1,1.6,1.84c.29.65.95.77,2,.8s1.46-.29,1.63-.84a3.37,3.37,0,0,1,.52-.91c.31-.43.76-.5,1.38-.16s1.11.86,2.1.37.62-1,.18-1.55c-.21-.26-.41-.52-.33-.82,2.05-2.16,2-2.74-.57-4.62a18.84,18.84,0,0,1-1.87-1.32c-.71-.71-.51-1.26.76-1.58a19.1,19.1,0,0,1,7.68,0c.56.09.74.45,1.09.7a7.45,7.45,0,0,0,4.2,1.28A52.62,52.62,0,0,0,987.2,487.93Z"
            />
            <path
              class="cls-40"
              d="M1151.05,471.81l.74.2c0-.54.8-.77,1.33-1.09,2.05-1.22,4.13-2.42,6.18-3.64Z"
            />
            <path
              class="cls-98"
              d="M1226.6,492.23c3.1.65,5.19-.67,7.6-1.35,1.18-.33,1.74-.84,1.5-1.62-.1-.12-.35-.32-.29-.36,1.32-.93.11-1.64-.55-2.4-.33-.38-.78-.76-.88-1.17-.32-1.31-1.82-1.64-3.73-1.68a22.94,22.94,0,0,0-5.56.23c-1.93.46-2.29,1.31-1,2.27,1,.69,1.92,1.37,2.83,2.08s1.09,1.48.25,2.28C1226.22,491.06,1226,491.63,1226.6,492.23Z"
            />
            <path
              class="cls-38"
              d="M1228.47,475.89c-.5.05-1.19-.14-1.42.28s.35.51.68.71a7.94,7.94,0,0,0,1,.6c.6.28.94.9,1.78.8.68-.07.44-.61.42-.95,0-.64-.44-1.19-1.59-1.41A5.31,5.31,0,0,0,1228.47,475.89Z"
            />
            <path
              class="cls-99"
              d="M1182.07,479.11a7.88,7.88,0,0,1-3.32-1c-.82-.53-1.89-.29-2.88-.3-.9.9-1.77,1.8-2.71,2.68a2.92,2.92,0,0,1-1.68.53c.78.52,1,1.08.38,1.71,1.27.79,2.58,1.52,2,2.83-.21.45.36,1,1.32,1.25a2.58,2.58,0,0,0,2.29-.5,19.21,19.21,0,0,0,4.9-5.9A1.05,1.05,0,0,0,1182.07,479.11Z"
            />
            <path
              class="cls-22"
              d="M1161.63,486c-1.7-.44-3.61-.71-4.36-1.91a.89.89,0,0,0-.35-.24c-1.52-.7-7.81-.59-9.26.18-.93.49-1.26,1-.33,1.66s1.86,1.31,2.76,2c1.08.79,1.66,1.61.63,2.62a1.22,1.22,0,0,0-.09,1.93c5.12-.4,8.76-2,11.11-4.69A1,1,0,0,0,1161.63,486Z"
            />
            <path
              class="cls-22"
              d="M1297.74,486c-1.71-.48-3.78-.67-4.51-1.95,0-.06-.14-.11-.23-.16-1.58-.85-8.23-.6-9.66.34-.84.55-.56,1.05.1,1.53s1.63,1.15,2.46,1.72c1.57,1.06,2.21,2.18.53,3.42.38,1,1.86,1.31,3.89.77a16.44,16.44,0,0,0,7.1-3.84C1298,487.31,1298.3,486.68,1297.74,486Z"
            />
            <path
              class="cls-100"
              d="M981.72,487.75c-1.64-.61-3.7-.84-4.56-2.1-.34-.5-1.55-.3-2.36-.38a18.14,18.14,0,0,0-5.93.13c-2.1.47-2.49,1.28-1.11,2.31.82.62,1.75,1.19,2.58,1.81,1.08.82,1.62,1.68.46,2.65a1,1,0,0,0-.37,1.13c2.29,1,4.36.18,6.21-.42a10.71,10.71,0,0,0,5-3.3C982.13,489,982.33,488.37,981.72,487.75Z"
            />
            <path
              class="cls-101"
              d="M1059.79,495.22c-.54.46-.34,1-.7,1.53.8.3-.06,1.09,1.09,1.28,0-.73.48-1,1.84-1.09,5.5-.21,10.6-1.2,14.67-3.43,2.89-1.59,5-3.58,5.72-5.94a1.22,1.22,0,0,0-.33-1.35H1081a5.54,5.54,0,0,0-3.74,2.34c-1.12,1.92-3.64,3.16-6.11,4.42a4.66,4.66,0,0,1-1.64.44c-2.61.29-5,1.2-7.73,1.1C1060.9,494.48,1060.5,495,1059.79,495.22Z"
            />
            <path
              class="cls-32"
              d="M1175.15,486.85c-.61-.74-1.26-1.4-.92-2.37s-1-1.42-2.37-1.71c0,.4-.11.85.56,1.06,1.88.59,1.29,1.35.55,2.15-.26.28-.49.57-.73.86.92.33,2,.57,2.18,1.31.16.14.31.39.48.39.45,0,.17-.25.28-.38A.85.85,0,0,0,1175.15,486.85Z"
            />
            <path
              class="cls-30"
              d="M1028.4,481.52c-.84.25-1.39.44-2,.59-.31.07-.82,0-.72.32s.55.38,1,.29C1027.5,482.54,1028.33,482.34,1028.4,481.52Z"
            />
            <path
              class="cls-29"
              d="M1118.25,474.08c-.59.25-1.55-.2-1.69.42s1.53,1.21,2.83,1.17c.55,0,1.4-.07,1.18-.42A2.65,2.65,0,0,0,1118.25,474.08Z"
            />
            <path
              class="cls-102"
              d="M1075.86,486c-2.08-.25-4.16-.52-5.09-1.86a1.14,1.14,0,0,0-.78-.41,21,21,0,0,0-8,0c-2,.48-2.29,1.23-.88,2.24.69.5,1.41,1,2.11,1.47,1.28.91,1.94,1.85.85,3a1.33,1.33,0,0,0,.16,1.95,3,3,0,0,0,2.3.37c4.66-.8,8-2.47,9.87-5.14C1076.81,487.08,1076.85,486.48,1075.86,486Z"
            />
            <path
              class="cls-51"
              d="M1075.86,486c.59.75.28,1.41-.32,2.13-1.91,2.27-5,3.61-9,4.39a7.14,7.14,0,0,1-2.28-.1,5.59,5.59,0,0,1,.31.83c.07.38-.37.57-.88.74a1.55,1.55,0,0,1-1.16-.07c-1.86-.73-2.09-.67-2.61.64a2.82,2.82,0,0,0-.09.64c.09,0,.22.15.26.14,3.18-.84,6.67-1.05,10-1.7,1.66-.33,2.59-1.15,3.86-1.73a8.35,8.35,0,0,0,4-3.56c.55-1,2.16-1.41,3.13-2.16Z"
            />
            <rect class="cls-103" x="1" y="434" width="1366" height="72.67" />
            <path
              class="cls-13"
              d="M890.94,504.11c-4.62,0-9.24-.07-13.85-.07H700.3l-2.37,0a5.06,5.06,0,0,1-2.23.34H682.63a5.11,5.11,0,0,1-2.23-.34l-36.09,0h-62l-88.78,0v-3.87a3.77,3.77,0,0,1,1.74-.12c3,0,5.93.05,8.89,0a5.16,5.16,0,0,0,2.3-.4,19.89,19.89,0,0,0-2-.65,9.63,9.63,0,0,0-3.39-.21,44.54,44.54,0,0,0-6.33.14,1.83,1.83,0,0,1-1.18,0v-.43a3.34,3.34,0,0,1,2.4-.55c2.91,0,5.82,0,8.73,0a5.56,5.56,0,0,0,2.52-.46,13.68,13.68,0,0,1,7,0,6.18,6.18,0,0,0,2.7.47c3.15,0,6.3,0,9.45,0a15.54,15.54,0,0,0,3.92-.58,11.16,11.16,0,0,1,6.76.19,6.44,6.44,0,0,0,2.39.37c2.55,0,5.1,0,7.64,0,1,0,1.91,0,2.86,0a4.4,4.4,0,0,0,2.84-.67c2.66-.19,5.32-.65,7.8.47.87.39,2.12.15,3.2.18.66,0,1.33,0,2,0,2.46.08,4.93,0,7.39,0a3,3,0,0,0,1.62-.36,2.69,2.69,0,0,1,.76-.37c2.67-.16,5.39-.58,7.87.48a5.46,5.46,0,0,0,2.12.2c3.27,0,6.55,0,9.82,0a7.61,7.61,0,0,0,2.86-.47,9.54,9.54,0,0,1,6,0,8.11,8.11,0,0,0,2.71.45c3,0,6,0,9.05,0,1.44,0,3,.16,4-.7,2.54-.13,5.14-.63,7.44.52a4.38,4.38,0,0,0,1.77.15h9.27a17.15,17.15,0,0,0,4.27-.57,10.83,10.83,0,0,1,6.88.27,4.3,4.3,0,0,0,1.86.32c1.39,0,2.78-.05,4.17,0,1.95-.05,3.89,0,5.84,0a8.14,8.14,0,0,0,3.74-.58c1.18-.6,5.76-.34,6.89.28a3.39,3.39,0,0,0,1.65.33c3.89,0,7.78,0,11.67,0a3.52,3.52,0,0,0,2.22-.6c2.66-.31,5.31-.68,7.81.35,1,.4,2.3.08,3.36.39.69.76-.89.53-1.12.9a14.77,14.77,0,0,1-2.31.65,61.21,61.21,0,0,0,14.06.11,10.6,10.6,0,0,0-2.16-.8c-1.83-.38-3.72-.09-5.58-.19-.73,0-1.62.11-2-.48a1.25,1.25,0,0,1,.52-.24c2-.2,4.1-.06,6.16-.09a16.1,16.1,0,0,0,4.09-.59,13.07,13.07,0,0,1,7,.07,9.55,9.55,0,0,0,2.88.47c3.69,0,7.38,0,11.07,0a1.76,1.76,0,0,0,.88-.06c1.8-1.18,4.15-.7,6.33-.76a1.28,1.28,0,0,1,.53.05c3,1.33,6.41.61,9.64.77,1.08.06,2.18,0,3.26,0,1.45,0,3,.18,4-.68a22.2,22.2,0,0,1,6.41.05c.4.18.58.47.95.66l.29.12c.49.2,1.48.07,1.47.59s-.92.42-1.48.56a.48.48,0,0,0-.32.23c.21.49,1,.4,1.49.44a89.68,89.68,0,0,0,11.24.06c.41,0,.82,0,1.23-.08s.6-.1.62-.31-.23-.28-.5-.38c-1.59-.57-1.59-.58.08-1.19.51-.23.71-.65,1.36-.81a40.92,40.92,0,0,1,4.7-.11,3,3,0,0,1,1.39.2,7,7,0,0,0,3.87.64c3.33.05,6.65,0,10,0a3.85,3.85,0,0,0,1.85-.31,12,12,0,0,1,7.32-.18,5.67,5.67,0,0,0,2.51.46c2.48,0,5,0,7.45,0a25.61,25.61,0,0,0,6.31-.63,10.68,10.68,0,0,1,6.77.32,5.33,5.33,0,0,0,2.08.3c1.89,0,3.77,0,5.65,0,2.25-.11,4.53.14,6.76-.17a13.17,13.17,0,0,1,8.39-.14,6.83,6.83,0,0,0,2.59.29c.66,0,1.32,0,2,0,2.85,0,5.71,0,8.56,0a3.25,3.25,0,0,0,2.32-.65c2.17-.25,4.29-.56,6.33.38,1.09.5,2.58.16,3.88.23,3.1.08,6.2,0,9.3,0a3.62,3.62,0,0,0,1.4-.17,10.92,10.92,0,0,1,8.05-.07,8.81,8.81,0,0,0,2.67.22c.85,0,1.71,0,2.55,0,.52,0,1.26,0,1.27.44s-.63.51-1.19.54a24.05,24.05,0,0,0-4.11.44c-.27.06-.6.05-.77.23,2.2.64,11.22.66,13.88,0a14.21,14.21,0,0,0-3.75-.62c-.36,0-.73,0-1.09,0-.75,0-1.86.09-1.87-.52s1.05-.48,1.74-.51c.91-.05,1.82,0,2.74,0a7.11,7.11,0,0,0,3.21-.54c1.52-.73,6-.37,7.46.45,2.72.21,5.45-.2,8.18.08a6.05,6.05,0,0,1,2.24.34v.43a7.4,7.4,0,0,1-3.16.32,24.68,24.68,0,0,0-7.2.64,14.43,14.43,0,0,0,3.56.41c1.51.06,3,0,4.55,0a4.9,4.9,0,0,1,2.25.33v3.65H901.4c-.91,0-1.82,0-2.73,0A20.72,20.72,0,0,1,890.94,504.11Z"
            />
            <path
              class="cls-14"
              d="M508.5,467.08l.24,1.18c1.89-.32,1.95-1.18,2.05-2,1.73,1.41,4.42,1,6.74,1.15,4.29.25,8.6-.05,12.91.13a7.6,7.6,0,0,0,3.47-.5,4.67,4.67,0,0,1,2.07,0c2.81.6,4,2.41,2.69,3.95A3.67,3.67,0,0,1,537.5,472a.74.74,0,0,1-.66-.07c-2.4-1.84-6-1.66-9.31-1.86a1.84,1.84,0,0,0-2,1.2c-.37.58.22.86,1,1.1s1.28.42,2,.57a2.74,2.74,0,0,1,2.26,1.52c.45,1.06,1.62,1.53,3.26,1.55,1.92,0,2.82-.34,3.45-1.52a1.89,1.89,0,0,1,2.23-1.08c2,1.46,2.42,3.44,1.08,4.64-1,.15-1.54-.35-2.3-.53-1.7-.41-2.53-.31-3.57.58a4.3,4.3,0,0,1-2.58,1.08,1.31,1.31,0,0,0-1.17.59,6.51,6.51,0,0,1-1.2,2.55c-.56.57,2,1.74,3.36,1.56,2-.27,4-.51,6-.78a36.81,36.81,0,0,1,5.77-.41,3.54,3.54,0,0,1,2.71.89,30.75,30.75,0,0,0,5.74,4.82c.4.27.74.56.78.94,0,0,0,.09,0,.11-2.12,1-1.42,2,.15,3a5.15,5.15,0,0,1,1.6,1.78c.29.45.63,1-.36,1.31a2.79,2.79,0,0,1-1.39-.45,99.37,99.37,0,0,1-10.54-5.74c-1.29-.86-4.25-.62-5.18.37a2.81,2.81,0,0,1-1.34,1c-1.33.42-.95.89-.1,1.33,1.28.66,2.38,1.43,3.6,2.12.38.22.9.57.5.84s-1.14,0-1.54-.24a59.18,59.18,0,0,1-5.93-3.62c-.25-.33,0-.9-1.27-.66a2,2,0,0,1-2.08-.8,2.26,2.26,0,0,0-2.52-.58,7.39,7.39,0,0,1-1.77.2,2.92,2.92,0,0,0-2.19.81,7.37,7.37,0,0,1-4.35,1.76c-1.64.23-3.14.83-5,.49-.79-.15-1,.6-1.81.58-1-.41-1.18-1-.84-1.61a2.07,2.07,0,0,0,.18-1.79,2.29,2.29,0,0,1,.52-2c.75-1.26.41-1.76-1.51-2.36-3.55-1.12-5.13-3-4.57-5.42.39-.7,1.27-1.25,1.36-2.06.08-.61,1.21-.92,2.16-1,4.35-.43,5.76-4.43,4.26-6.3a.9.9,0,0,0-1.07-.4,21.33,21.33,0,0,1-4.81.44c-.75,0-1.32.36-2,.46a3.35,3.35,0,0,1-1.67-.27,6.24,6.24,0,0,0-4.52,0,1.8,1.8,0,0,1-.52,0c-2.37-1-4-2.42-6.22-3.53v-1.29a2.75,2.75,0,0,1,2.19.13c2.78,1,5.94,1.21,9,1.68C506.2,467.83,507.26,467.29,508.5,467.08Z"
            />
            <path
              class="cls-15"
              d="M512.92,492.91c.22-1.05,1.47-1.06,2.74-.85.81.12,1.42.3,2.1-.21a4.63,4.63,0,0,1,1.71-.27c1.92-.18,3.45-.68,4.26-1.77a2.46,2.46,0,0,1,2.44-.82h.37c2.43-.08,3.17.08,4.86,1.07,1.05.61,1.71-.1,2.71-.39v1.49c.2.63.88,1.17.89,1.83a.58.58,0,0,1-.38.35c-2.44.59-4.12,1.82-6.32,2.61-.71.26-1,.57-1,1a1.26,1.26,0,0,1-.84,1.25l-10.9,0c-.64,0-1.38.08-1.52-.5-.08-.31-.5-.37-1-.37H508.5c-.43,0-.93,0-1,.33-.14.63-.93.54-1.64.54l-10.18,0a6.48,6.48,0,0,0-2.12.19v-9.89a1.42,1.42,0,0,1,1.24.3c2.4,1.76,5.93,2.51,9.09,3.59.19.2.11.42.13.63,0,.61.5.72,1.42.45,1.7-.5,2.19-.35,2.84.74.36.59.35,1.25.83,1.86a3.34,3.34,0,0,0,2.19-1.81C511.65,493.79,511.65,493.09,512.92,492.91Z"
            />
            <path
              class="cls-16"
              d="M508.5,467.08c-.81.95-2.31,1-3.73.82-3.17-.46-6.51-.65-9.34-1.77a4.43,4.43,0,0,0-1.87-.34V445.15c1.29-.36,1.73,0,1.75.72,0,.32,0,.64.05,1,.05.8.53,1.11,2,.72,1.63-.44,2.31-.21,2.7.81.24.63.35,1.27.53,1.91a4,4,0,0,0,2.68,2.8c1.35.54,1.7,1.38,1,2.28s-.25,1.28,1.25,1.6c3.71.8,4.77,3.31,2.27,5.11l-.8.59c-1.29.95-1.32,1.37.29,2.15C508.51,465.45,508.92,466.16,508.5,467.08Z"
            />
            <path
              class="cls-17"
              d="M506.34,470.73a6.92,6.92,0,0,1,3.53-.65,6.69,6.69,0,0,0,3.29-.44c.68-.34,1.29-.2,1.53.29.84,1.73,1.38,3.38-.45,5.13a7.15,7.15,0,0,1-4.31,2c-1,.15-2.13.44-1.51,1.37.47.72-1.51.69-1.37,1.36-.2.43-.6.62-1.28.31a2,2,0,0,0-2.4.34,6,6,0,0,1-4.26,1.34,3.28,3.28,0,0,1-1.69-.31,10.09,10.09,0,0,0-3.86-1.46v-7.31c1.28-.63,2.39-1.48,4.42-.95a.85.85,0,0,0,.92-.41c.22-.29.32-.62.87-.78l.36,0c.6-.22,1.5-.41,1.86-.11C503.3,471.49,504.85,470.85,506.34,470.73Z"
            />
            <path
              class="cls-18"
              d="M931.49,480.62v9c-.09.05-.25.12-.31.09-1.56-.79-2.81-.19-4.09.31a1.88,1.88,0,0,1-.67.16,7.26,7.26,0,0,0-5.18,2,2.24,2.24,0,0,1-2.22.67c-.43-.24-.27-.6-.54-.93a2.49,2.49,0,0,1-3.1-.72,9.59,9.59,0,0,0-1.51-1.17c-.15-.35.13-.63.46-.89s.44-.55-.22-.77c-1.17-.4-.9-1-.28-1.47,1-.79,1.25-1.53,0-2.32-.48-.31-.4-.67.11-1a2,2,0,0,0,1-1.67c.12-.82.77-1.43,2.19-1.66a3.76,3.76,0,0,0,1.76-.72c1.85-1.4,3.37-1.55,5.89-.58.4.16.78.35,1.17.51a3,3,0,0,1,.5.31c.6.43.92,1,1.79,1.3,1.12.35,1.58-.5,2.49-.59A1.6,1.6,0,0,1,931.49,480.62Z"
            />
            <path
              class="cls-19"
              d="M493.56,480c1.49,0,2.83.07,3.68,1,.61.67,3,.72,4.28.15a5.73,5.73,0,0,0,1.49-.93c.87-.75,1.71-1.27,3.05-.3.48.35.67-.07,1-.15-.2,1.2-.56,2.42,1.5,3.27.12.05.24.2.19.27-.59.93.62,1.06,1.63,1.32,3.52.89,3.8,1.26,2.54,3.39a1.65,1.65,0,0,0-.15,1.77c.19.35.33.88,0,1.14-.88.73-.33,1.34.14,2a2.79,2.79,0,0,0-1.06,1.21,9.38,9.38,0,0,1-.73,1.2,2.84,2.84,0,0,1-2.2,1.27c-.72,0-.46-.91-.75-1.39s-.38-.89-.63-1.32c-.34-.6-.91-.7-1.7-.22A1.66,1.66,0,0,1,504,494c-.77-.35-.78-.76-.36-1.23.08-.09.06-.21.09-.31a9.72,9.72,0,0,0-1-2.88c-.38-.61.29-1.17.78-1.7.76-.83,2-1.4,2.91-2.18s.65-1.3-.72-1.64a18.86,18.86,0,0,0-7.63.06c-.61.1-.8.52-1.21.77a4.05,4.05,0,0,1-3.33.91Z"
            />
            <path
              class="cls-20"
              d="M919.14,492.88a3.74,3.74,0,0,0,2.44-1.34,4.64,4.64,0,0,1,3.52-1.44,6.89,6.89,0,0,0,3.09-.79c1-.62,1.76-.68,2.5.14.11.11.52.13.8.2v8.6c-3.66-.2-7.31,0-11,0,.88-1.62-.44-2.93-1.76-4.24C918.35,493.56,918.33,493.17,919.14,492.88Z"
            />
            <path
              class="cls-21"
              d="M919.11,467.9a17.68,17.68,0,0,0,8.27-1c1.18-.42,2.81-.3,4.11-.7v12c-1.63.34-3.31,0-5,.13-1.1-.32-1.2-1-1.63-1.57a3.14,3.14,0,0,0-2-2.16c-.75-.3-1-.77-.86-1.31.69-.86,1.49-1.68,1-2.72a1.91,1.91,0,0,0-1.76-1.18,6.42,6.42,0,0,1-2.07-.54C918.65,468.6,918.55,468.24,919.11,467.9Z"
            />
            <path
              class="cls-22"
              d="M493.56,485.78c1.44-.29,2.9-.56,3.43-1.57a1.27,1.27,0,0,1,.79-.4,21,21,0,0,1,8.2,0c1.76.44,2.06,1.13.95,2s-2.07,1.5-3.06,2.27c-.83.65-1.05,1.4-.34,2.11a1.66,1.66,0,0,1,.24,2.27,1.77,1.77,0,0,1-1.44-.07c-3.06-1.16-6.43-2.06-8.77-3.8Z"
            />
            <path
              class="cls-23"
              d="M504.83,498.69a2.35,2.35,0,0,0,1.75.4c.63,0,.82.23.81.57s-.18.45-.72.49a72.67,72.67,0,0,1-13.11,0v-1.29l.78-.2A94.12,94.12,0,0,1,504.83,498.69Z"
            />
            <path
              class="cls-16"
              d="M499.77,470.53a4.45,4.45,0,0,1-.43,1c-.34.48-.74.9-1.85.46a2,2,0,0,0-2.27.24c-.38.44-1,.44-1.66.43v-5.59c1.8.12,2.33,1.17,3.54,1.73A19.38,19.38,0,0,1,499.77,470.53Z"
            />
            <path
              class="cls-24"
              d="M931.49,500.4a98.57,98.57,0,0,1-10.32-.24c-.64-.07-1-.15-1-.58s.42-.41.94-.5a56.13,56.13,0,0,1,10.38-.4Z"
            />
            <path
              class="cls-25"
              d="M926.37,478.24a16.59,16.59,0,0,1,5.12,0v2.36c-.38.12-.78.21-1.11.35-2.06.91-2.06.91-3.47-.32-.33-.29-.65-.59-1-.89C925.4,479.19,925.62,478.69,926.37,478.24Z"
            />
            <path
              class="cls-26"
              d="M868.69,464.5c.16.15.27.37.5.44,2.68.75,3.08,2.25,3.84,3.71.55,1.05,1,2,.47,3.12-.32.63,2.35,3,3.4,3a1.52,1.52,0,0,0,1.12-.47,7.45,7.45,0,0,1,4.84-1.11,8.53,8.53,0,0,0,4.47-1c2-1,2.39-.94,4.34,0-.36,1.1-1.9,1.44-3.39,1.65a20.06,20.06,0,0,0-4.19,1,10.67,10.67,0,0,1-4.42.37c-2-.11-2.35,0-2.79,1.15a2.07,2.07,0,0,1-1.57,1.23,2.62,2.62,0,0,0-2,1.55,16.34,16.34,0,0,1-.8,1.77,3.48,3.48,0,0,1-2.58,1.68c-1.39.27-1.89.81-1.82,1.63a1.35,1.35,0,0,1-.79,1.49c-1.2.62-1.1,1.28-.28,2a1.28,1.28,0,0,1,.45.69c-.08.63-1.28.68-1.67,1.14-.36.3-.22.72-.73,1-1.14.12-1.09-.39-1.19-.8-.14-.57.34-1.12.16-1.77-.92.08-1.75.57-2.73.22a3.84,3.84,0,0,1-1.65-1.26,2.43,2.43,0,0,0-2.71-.53,3.83,3.83,0,0,1-1.39.23,5.64,5.64,0,0,0-4.89,1.73,6.82,6.82,0,0,1-5.23,1.55c-.35-.2-.14-.39,0-.58a7.18,7.18,0,0,1,2.08-4,.38.38,0,0,0,.07-.43c-.53-1.23.76-1.93,2.15-2.62s1.44-.71-.11-1.35a4.59,4.59,0,0,1-1.81-1.33,4.9,4.9,0,0,0-1.25-1.18,3,3,0,0,0-2.92-.19,10.41,10.41,0,0,1-4.56.92,4.81,4.81,0,0,0-2.45.62,2.37,2.37,0,0,1-2.89-.19,4.73,4.73,0,0,1-1.56-1.43c.58-1.54-.53-2.93-1.05-4.37a3.37,3.37,0,0,1-.2-.49c-1-1.78-.5-2.31,2.64-2.87,1.8-.31,3.53-.63,3.94-1.92,0-.13.22-.25.38-.36,2.9-1.88,1.93-4,1-6.08-.35-.79-1.28-.56-2.17-.32a20.69,20.69,0,0,1-7.08.36c.05-.35.55-.46,1-.57.83-.21,1.11-.55.78-1s0-1,.87-1.22c1.42-.39,1.81-1.09,1.72-1.94s.3-1.32,1.91-1.29a2.3,2.3,0,0,0,2.3-1.15c.29-.51.66-.94,1.82-.7.88.19,1-.24,1.17-.57a1.62,1.62,0,0,1,1.9-.72,3.77,3.77,0,0,0,3.36-.91c1.36-1.13,2.59-2.33,3.91-3.48.39-.34.75-.87,1.56-.77s.71.68.9,1.07c.12.24.19.49.31.73.34.68.88.84,2,.39,1.61-.67,2.18-.57,3,.49.47.62.8,1.27,1.22,1.9a4.93,4.93,0,0,0,3.24,2.19c1.45.36,2,1.06,1.84,2-.09.45-.37.93.26,1.34-.22.88-1.38,1.47-2.11,2.17-.44.43-.32.51.07.8s1.81.71,1.16,1.26-1.71.08-2.54-.06a43.6,43.6,0,0,0-4.86-.36c-.41,0-.95-.12-1.13.17s.37.4.72.5a24.65,24.65,0,0,0,7.27,1.21A13.91,13.91,0,0,1,868.69,464.5Z"
            />
            <path
              class="cls-27"
              d="M780.73,448.79c1.4-.17,1.2.55,1.41.95.67,1.33.65,1.36,2.73.76a1.57,1.57,0,0,1,1.79.37,12.82,12.82,0,0,1,1,1.49,5.36,5.36,0,0,0,3.7,2.76c1.32.31,1.68,1.08,1.4,1.91s.2,1.15,1.62,1.29c3.54.35,5.2,2.51,3.49,4.38-1.46,1.62-1.49,1.64,1.06,2.68,1.59.65,1,1.7,1.54,2.53s.63,1.63-.52,2.33a15.49,15.49,0,0,1-6.9,2.2,5.39,5.39,0,0,0-1.63.46,11,11,0,0,1-5.06.64c-1.46-.15-2.37.11-2.64,1a2.64,2.64,0,0,1-2.14,1.62,2,2,0,0,0-1.48,1.16c-.23.52-.46,1-.71,1.55a4.25,4.25,0,0,1-3.23,2.17c-1.07.23-1.62.62-1.37,1.3s0,1.41-1.15,1.89c-.7.3-.69.71-.44,1.16s.79.89.83,1.41c-.61.65-1.77,1-2.42,1.65-1,.21-2.4-.35-2.94.13a8.84,8.84,0,0,0-2.08,2.22,5.3,5.3,0,0,1-2.47,2.69,2.63,2.63,0,0,1-1.67.54c-.83-.11-.73-.6-.87-1a18.86,18.86,0,0,0-.83-2.19c-.31-.6-.81-.88-1.8-.37a2.35,2.35,0,0,1-1.79.33c-.61-.59.31-.81.81-1.1.69-.4,1.58-.67,2-1.22.54-1.38,1.86-2.62,1.8-4.1,0-.72,1-1.16,1.93-1.6,2-1,2-1.43,0-2.36a18.55,18.55,0,0,1-1.71-1c-.68-.4-1.14-.85-.59-1.43.37-.39.09-.66-.4-.93a1.92,1.92,0,0,0-1.49-.05,11.73,11.73,0,0,0-3,.91,20.58,20.58,0,0,1-3.6.14,9.29,9.29,0,0,0-5.13,1.28,1,1,0,0,1-1.13-.65c-.2-1.16.32-2.34-.39-3.49-.14-.24-.09-.53.31-.68a1.55,1.55,0,0,1,1.29.21c2.74,1.34,5,1.26,7.36-.28,1-.65,1.81-1.56,3.68-.78.15.06.47.05.51,0,.45-.81,2.16-1.21,2.07-2.14s.59-1.34,1.86-1.63c.79-.19,1.57-.38,2.38-.54a3.11,3.11,0,0,0,2-1,2.78,2.78,0,0,1,.71-.75c2.48-1.61,1.85-3.44,1.08-5.27-.39-.91-.9-1.06-2.37-.59a17.75,17.75,0,0,1-5.35.34c-.36,0-.7-.12-.77-.37.43-.5,1.1-.93.91-1.58-.11-.33.28-.61.72-.82,1.23-.6,2-1.31,1.95-2.29a.56.56,0,0,1,.58-.61c2-.12,2.81-1.14,4.08-1.81,1,.09,2,.31,2.25-.63.08-.34.71-.55,1.27-.47A4.62,4.62,0,0,0,777,452c.46-.42,1.06-.78,1.27-1.29,0-.3.28-.48.63-.66l1.07-.91A1.42,1.42,0,0,1,780.73,448.79Z"
            />
            <path
              class="cls-28"
              d="M537.34,472a8.4,8.4,0,0,1,.84-1.17c1.32-1.4.29-3.05-2.27-3.57-.38-.92,1-1,1.82-1.12a7.07,7.07,0,0,0,3.84-1.94c1.49-1.35,1.22-2.69.69-4.1-.23-.61-.75-.86-1.81-.55a9.73,9.73,0,0,1-3.2.25c-.55,0-1.29.05-1.37-.48a5.19,5.19,0,0,1,2.4-2.57c.23-.13.09-.48.13-.72s0-.49.11-.52a15.34,15.34,0,0,0,4.18-1.81c.34-.18,1.1-.16,1.31-.6a1.13,1.13,0,0,1,1.14-.42,3.89,3.89,0,0,0,3.47-1.22c.83-.7,1.56-1.45,2.36-2.16a1.45,1.45,0,0,1,1.2-.57c.54.06.53.44.63.72.28.82.59,1.57,2.36.7a1.28,1.28,0,0,1,1.27.18c.11.08.25.17.29.27a7.85,7.85,0,0,0,5,4c.4,1.19,1.54,1.95,3.58,2.28a.94.94,0,0,1,.84,1,2.48,2.48,0,0,1-.82,3.13c-.7.52,0,1,.73,1.22a2.39,2.39,0,0,1,1.91,1.67c.38,1.17,1.22,2.23.77,3.53-.25.71,1.32,1.44,2.47,2a.84.84,0,0,0,.48,0c1.5-1.4,4-1.06,6.2-1.26.55.77.56,1.49-.52,2.13a15.79,15.79,0,0,1-6.7,2.19,5.74,5.74,0,0,0-1.64.44,11.07,11.07,0,0,1-5.38.6c-1.48-.19-2.34.14-2.55,1-.18.72-.72,1.26-2,1.53a1.89,1.89,0,0,0-1.44,1,1.77,1.77,0,0,1-.81,1.06,3.28,3.28,0,0,1-2.52.06,2.43,2.43,0,0,0-1.85-.08c-1.85.95-4.14,1-6.39,1.21-.9.23-1.42.86-2.55.85-1.81-.32-2.62-1.11-2.89-2.15a2.61,2.61,0,0,0-.1-3.06c-.28-.5-.64-1-1-1.46C538.44,473.23,537,473.07,537.34,472Z"
            />
            <path
              class="cls-29"
              d="M746.83,478.69l.74.64a3.59,3.59,0,0,0,2.52-.19,6.43,6.43,0,0,1,4.4-.51c.16.51-.57.48-1,.56-1.19.2-1.6.67-1.24,1.31a21.9,21.9,0,0,0,6,6.48,5.57,5.57,0,0,0,1.43.45,1.74,1.74,0,0,1,.68,1.15c-.11.71-1.2.9-1.94,1.28a14.17,14.17,0,0,0-1.31.87,6.39,6.39,0,0,1,2.06,1.52c0,1.07-.74,1.33-2.32.76-2.28-.83-3.66-2.18-5.43-3.3-.41-.26-.77-.55-1.18-.82a3.79,3.79,0,0,0-2.58-.43,11.54,11.54,0,0,0-5.51,2.05c-.65.4,0,.58.32.77,1.91,1.15,3.86,2.28,5.78,3.43.54.32,1.25.59,1.28,1.12a.7.7,0,0,1-.41.17,3.19,3.19,0,0,1-1.78-.66c-1.93-1.13-3.86-2.25-5.76-3.4a7.61,7.61,0,0,0-2.49-1c-.33-.18.09-.79-1-.53a2.15,2.15,0,0,1-2.16-.65,3.44,3.44,0,0,0-2-1,9,9,0,0,1-3.34-1.78,1.5,1.5,0,0,0-2,0,5.12,5.12,0,0,1-3.54.83c-.57,0-1.14-.16-1.17-.55s.49-.48,1-.55c1.07-.18,2.11-.36,2.48-1.15-.59,0-.73.24-1,.39-2.41,1.38-6.09.89-7.25-1a2.81,2.81,0,0,1-.26-.52c-.18-.52-.21-1.09-1.51-1.12s-2.18.08-2.62.84c0,.07-.13.12-.21.17-.73.12-.94-.17-1.11-.49.19-.57-.59-.88-1-1.28-.87-.77-.61-1.63-.61-2.48.17-.89,1.33-1.55,1.52-2.47.11-.53,1.26-.71,2.11-.9,3-.68,4.76-2.16,4.75-4.06a4.26,4.26,0,0,0-.09-1.07c-.38-1.5-.52-1.54-3-1.24a9.74,9.74,0,0,1-3.57-.09,1.62,1.62,0,0,1,.81-2.21,2.11,2.11,0,0,0,1.24-1.68c.7-.92,2-1.11,3.53-1a7.85,7.85,0,0,0,2.35.53,130.71,130.71,0,0,0,14.68,0c1.06-.07,2-.62,3.13-.31-.56,1.46-.41,1.57,2.21,1.71,2.3.14,3.8,2.05,2.7,3.47a2.35,2.35,0,0,1-1.39.94c-1.28,0-1.92-.69-3-.89a54.27,54.27,0,0,0-6-.75c-1.67-.11-2.25.18-2.93,1.19s.31,1.25,1.39,1.58a1.7,1.7,0,0,0,.32.1c2.37.4,4.52.91,5.7,2.39.53.66,1.86.85,3.19.61a2.92,2.92,0,0,0,2.45-1.57c.18-.44-.05-.94.61-1.3,1.28.11,1.35.75,1.49,1.28.32,1.17,1.36,2.29.72,3.54C746.38,478.12,746.79,478.4,746.83,478.69Z"
            />
            <path
              class="cls-30"
              d="M799.73,470.08c1.15-.61.28-1.47.77-2.17,1.73.35,1.77-.39,1.87-1s-.2-1.22,1.39-1.1a5.46,5.46,0,0,0,2.79.9,157.05,157.05,0,0,0,18.79,0c.8,0,1.52.24,2.28.34,1.56.23,2.55.8,2.84,1.73s.49,2.15-1.41,2.85a31,31,0,0,0-8.48-1.59c-1.56-.13-2.49.11-3.17,1-1.28,1.63-1.35,1.61,1.37,2.42A32.92,32.92,0,0,0,829,474.53a7.84,7.84,0,0,0,2.49-.79c.75,1.47,2,2.91,1.07,4.52-.87.12-1.28-.32-1.88-.53-1.89-.67-2.84-.58-4.23.42a3.12,3.12,0,0,1-1.58.86c-1.75.18-2.2.9-2.33,1.77s-.5,1.33-1.78,1.67a7.26,7.26,0,0,0,1.62.41c1.16-.05,1.44.35,1.6.9.22.76,1,1.12,2.33,1a2.36,2.36,0,0,0,1.89-.72c.3-.47-.18-.81-.64-1.16s-1.85-.58-1-1.15,1.6.14,2.29.42c1.3.53,2.44,1.18,3.62,1.8a5.51,5.51,0,0,0,4,.46,2.71,2.71,0,0,1,2.77.55c1,1,2.4,1.9,3.45,2.9a9,9,0,0,0,3,1.53l-.35.4c-1,.7-1,1.3.09,2s1.92,1.38,1.92,2.34c-.74.87-1.77.6-2.7.19a61.31,61.31,0,0,1-9.26-4.73,4.37,4.37,0,0,0-5.21.35,3.24,3.24,0,0,1-4.48.43.79.79,0,0,0-.63-.15,2.63,2.63,0,0,1-2.85-.65,2.4,2.4,0,0,0-2.57-.54,7.42,7.42,0,0,1-1.78.17,2.44,2.44,0,0,0-2.14.81c-.85,1.07-2.39,1.57-4.3,1.74a4.15,4.15,0,0,0-2,.48,1.53,1.53,0,0,1-1.31.19,4.36,4.36,0,0,0-3.5.46c-1.14-.37-1.17-1-.88-1.59a2.84,2.84,0,0,0,.23-1.89,2.8,2.8,0,0,1,.41-2c.68-1.2.32-1.86-1.65-2.34-3.65-.89-4.2-2.76-4.65-4.7a1.51,1.51,0,0,1,.89-1.36c.36-.21.65-.45.54-.76-.35-.94.64-1.37,1.91-1.51,4.25-.48,6.48-4.12,4.69-6.34-.44-.55-.94-.5-1.73-.34A9.1,9.1,0,0,1,799.73,470.08Z"
            />
            <path
              class="cls-31"
              d="M577.14,470.09c1.08-.55.25-1.33.71-1.95l1.88-.84c5.18.86,10.5.75,15.8.75a2.19,2.19,0,0,0,1-.16c1.24-.8,2.47-.47,3.75-.05a26.24,26.24,0,0,0,4.77.65c1.16.15.73-.62,1.27-.84,1.73,1.28,1.68,2.59.24,3.93-1.65-.22-2.91-1-4.66-1.11-1.08-.07-2.13-.27-3.22-.37-2.81-.25-2.82-.25-4.11,1.18a4.45,4.45,0,0,1-.6.53c-1.4,1-1.41,1.21.48,1.84a29.94,29.94,0,0,0,13.32,1.4c.63-.08,1.3-.35,1.72.19.85.83,1.13,1.68.39,2.59a2,2,0,0,1-1.52,0c-2.84-.67-2.85-.67-5,.7a3.51,3.51,0,0,1-1.49.59c-1.21.15-1.65.63-1.82,1.3a2.22,2.22,0,0,1-1.1,1.77c-.25.14-.27.33,0,.48a3.45,3.45,0,0,1,1.42,1.71c.23.5,1,.45,1.67.39,2.21-.22,4.4-.51,6.6-.78a14.83,14.83,0,0,1,5.36-.17,2.13,2.13,0,0,0,1.93-.59,1.71,1.71,0,0,1,1.46-.51c.78.15.56.58.48.92-.23,1,.53,1.65,2.07,2,1,.25,1.67.53.48,1.11-.94.45-.32.91.06,1.33.5.57,1.46,1,1.69,1.64-.79.85-.31,1.47.72,2.19s2.16,1.47,2.16,2.52a2.26,2.26,0,0,1-2.63.26c-2-.92-4-1.82-6-2.78a1.69,1.69,0,0,1-1-1.12c-.17-.8-.95-1.38-1.83-1.93a2.42,2.42,0,0,0-2.78-.24,3.45,3.45,0,0,1-1.38.22,7.49,7.49,0,0,0-3.66,1.07,2.57,2.57,0,0,1-2.39.35,1.91,1.91,0,0,0-.89,0,2.55,2.55,0,0,1-2.85-.62,2.34,2.34,0,0,0-2.55-.55,4.8,4.8,0,0,1-1.42.15,3,3,0,0,0-2.7,1,5,5,0,0,1-3.22,1.45c-1.1.18-2.31.15-3.14.74a1.35,1.35,0,0,1-1,.05,4.39,4.39,0,0,0-3.51.46c-1.07-.33-1.18-.93-.9-1.48a3.49,3.49,0,0,0,.23-2.22,2.72,2.72,0,0,1,.44-1.78c.65-1.18.35-1.83-1.49-2.29-3.85-.95-4.53-2.86-4.79-5a1.47,1.47,0,0,1,.87-1.14c.35-.2.67-.43.55-.75-.36-.93.63-1.27,1.86-1.54,4.4-1,6.28-3.29,4.93-6-.35-.69-.82-.9-2.09-.65A8.74,8.74,0,0,1,577.14,470.09Z"
            />
            <path
              class="cls-32"
              d="M637,470.29c.44-.37.94-.7.75-1.23s.24-.67,1-.72a38.84,38.84,0,0,1,4.31.19c1.7,0,3.22-.62,4.76-.57s2.82.9,4.53.89c2.54,0,5.08-.08,7.62.06,1.72.09,3.35.33,5,.56a3.24,3.24,0,0,1,1.51.56c.32.24.5.51.25.8s-.68.26-1.11.25a38.68,38.68,0,0,1-4.47-.51,28.8,28.8,0,0,0-3.39-.39,3.25,3.25,0,0,0-2.81.93,5.2,5.2,0,0,1-1.48,1.21c-1.24.75-1.21.93.34,1.54a29.34,29.34,0,0,0,15.8,1.52c1.56.48,1.08,1.33,1.1,2.09a.94.94,0,0,1-.14.33c-.38.49-.91.55-1.75.32-3.13-.86-2.89-.66-5.44.48-2,.9-3.28,1.81-3.93,3.25-.29.67-.77,1.13-.07,1.81s.09,1.24-.54,1.79c-.4.36-1,.7-.52,1.16s1.25.36,2,.39c1.41.06,2.76-.23,4.16-.22A22.74,22.74,0,0,1,668,487a8.47,8.47,0,0,0,5.31-.46,2.17,2.17,0,0,1,2.46.39c2,1.63,4.4,3,6.48,4.62.81,1.36.09,2-2.34,2.13a65,65,0,0,1-6.62-3.64,4.73,4.73,0,0,0-5.82.3,3.11,3.11,0,0,1-4.39.14.94.94,0,0,0-.68,0,2.15,2.15,0,0,1-2.65-.5c-.61-.78-1.46-.89-2.81-.64-2.41.45-2.93.58-4.54,1.63a3.52,3.52,0,0,1-1.58.7c-2.33.25-4.42,1.24-7,.79a2,2,0,0,0-1.58.39c-1.63,0-1.36-.68-1.13-1.16a2.85,2.85,0,0,0,.19-2.21c-.2-.62.2-1.19.55-1.76.75-1.27.5-1.73-1.58-2.31-3.61-1-4.6-2.86-4.87-5,0-.45.38-.81.93-1.12s.72-.49.64-.84c-.18-.86.65-1.28,1.89-1.44,4.3-.58,6.32-4,4.77-6.25-.45-.65-1.07-.62-2-.42A8.41,8.41,0,0,1,637,470.29Z"
            />
            <path
              class="cls-33"
              d="M926.37,478.24c-.14.51-.29,1-.43,1.52-1.18-.25-2-.87-3.34-1s-2.28,0-2.9.72a3.52,3.52,0,0,1-2.71,1.21c-1.22.1-1.56.82-1.55,1.51a1.45,1.45,0,0,1-1.17,1.67c-.81.27-.34.51.07.74,1.32.71,1.26,1.46.19,2.25-.92.67-1.59,1.28.63,1.53.89.1.45.39.11.6a2.8,2.8,0,0,0-1.26,1.15c-.43.76-1.59.81-2.65.86a3.13,3.13,0,0,0-2.43.93,5.51,5.51,0,0,1-3.84,1.61c-1.79.17-3.38,1-5.37.54-.64-.13-1,.34-1.43.56-1.35-.23-1.6-.86-1.3-1.51a3.09,3.09,0,0,0,.17-2.11c-.15-.69.35-1.33.68-2,.53-1,.28-1.58-1.38-2-3.92-1.06-5-3-4.87-5.29.25-.87,1.31-1.55,1.54-2.46.13-.53,1.27-.73,2.16-.85,4.32-.59,5.62-4.26,4.09-6.3-.39-.52-1-.37-1.66-.25a9.76,9.76,0,0,1-4.89-.05c.49-.32,1-.53.78-1.15s1.4-.92,2-1.45c3.44.06,6.86.38,10.31.36a8.16,8.16,0,0,0,4-.53,2.11,2.11,0,0,1,1.54.06c3,.85,6.32.51,9.47.83.92.1.45-.47.75-.69,1.69.46,2.62,2,1.81,3a11.14,11.14,0,0,1-1.09,1.08c-1.86-.27-3.37-1.06-5.34-1.21-1.19-.09-2.38-.25-3.58-.36a2.62,2.62,0,0,0-2.61.85,3.12,3.12,0,0,1-1.23,1.18c-1.07.56-.69.94.33,1.33a30.74,30.74,0,0,0,13.93,1.7,3.35,3.35,0,0,1,1.41-.05Z"
            />
            <path
              class="cls-34"
              d="M715.8,466.44a1.24,1.24,0,0,1-.78,1.44c-.73.37-1.62.73-1.13,1.49.11.17-.41.47-.64.72A8.45,8.45,0,0,1,708.6,472c-2.42-1.38-4.75-2.81-7.15-4.19,1.9,1.12,3.82,2.24,5.71,3.37.45.28,1.31.54.49,1.05-1,.3-2.11.54-3.1.9a11.48,11.48,0,0,1-5.11.43c-1.43-.14-2.27.21-2.41,1s-.69,1.22-1.88,1.55c-1.37.37-1.52,1.22-1.89,2-.45.94-.63,2-2.52,2.44-1-.11-1-.61-.92-1,.08-1-.8-1.52-2.28-1.81a15.75,15.75,0,0,1-2.15-.59c-.62-.21-1.08-.53-.95-.95.2-.65-.3-1.09-.94-1.54-1.59-1.12-1.53-2.84.14-4,.4-.28.88-.5.67-.92-.39-.75.35-1.14,1.31-1.46a3.08,3.08,0,0,1,.66-.18c3.19-.22,4.37-1.74,5.71-3.12,1.51-1.55.43-3.05-.47-4.54-.16-.26-.62-.32-1.09-.24a4.21,4.21,0,0,1-1.59.13c-1.12-.63-2.66-1.06-3-2.08l1.53-.82c.28-.29.09-1,1.1-.71,1.89.5,3.83.2,5.74.31,2.66.15,5.35.51,8,.42,4.09-.14,8.24.21,12.27-.47a2.71,2.71,0,0,0,1.11.21c2.45.17,3.11.69,3.69,2,.48,1.14-.18,2.05-1.29,2.92a29.48,29.48,0,0,0-7.38-1.65c-.48-.06-1-.13-1.43-.17-3.15-.23-3.52-.11-5,1.53s-1.48,1.69,1.46,2.57a31,31,0,0,0,7.65,1.3A4,4,0,0,1,715.8,466.44Z"
            />
            <path
              class="cls-35"
              d="M635.89,480.41a2.43,2.43,0,0,0,1.74,2.77c.09.05.27.12.25.14-.85,1.54,1.65,1.37,2.77,1.78,2.23.81,2.71,1.26,1.68,2.69a1.93,1.93,0,0,0-.33,2.27c.28.49,0,1-.37,1.45s-.54.89.51,1.13c.67.07.58.36.36.56a21.66,21.66,0,0,0-2,2.61,3.77,3.77,0,0,1-1.08.85c-1.16.63-1.81.51-2.27-.4-.28-.55-.36-1.12-.66-1.66a.84.84,0,0,0-1.16-.42,3.21,3.21,0,0,1-2.79,0c-1-.64-.39-1.25,0-1.88.08-.14,0,0,0-.11a1.17,1.17,0,0,0-.2-1.55c-.91-1-.56-1.92.56-2.79.77-.6,1.66-1.13,2.4-1.74,1.14-.94.83-1.66-1-2a21.92,21.92,0,0,0-6.47,0,1.88,1.88,0,0,0-1.41.77,15.12,15.12,0,0,1-1.9,2.43.79.79,0,0,0-.22,1c.21.35.33.69-.13,1-.65.25-1.1.84-2.16.49-.63-.48-1.29-.94-1.88-1.44-1.23-1-1.09-1.49.78-2.21-3-.47-4.36-1.5-3.31-3.26-.66-.12-.85.07-1,.25a2.92,2.92,0,0,1-3.6.73,4.11,4.11,0,0,0-1.78,0c-3.06.4-6.12.8-9.19,1.17-1.28.15-2.31.08-2.26-1,0-.79-1-1.25-2.14-1.76,2.22-.42,1.78-1.56,2.12-2.44.23-.61.59-1,1.7-1a2.77,2.77,0,0,0,1.88-.75c1.78-1.4,2.64-1.52,5.14-.66a3.62,3.62,0,0,0,1.49.33c.31.83,1.3,1.4,2.22,2a1.06,1.06,0,0,0,1.34-.08,7,7,0,0,1,3-1.07,14.14,14.14,0,0,0,4.25-.84,4.71,4.71,0,0,1,2.46-.12c1.73.28,3.79.15,3.86,1.81,0,.52,1.34,1,2.21,1.36a1.62,1.62,0,0,0,1.75-.16c.57-.55-.39-.57-.86-.69-1.78-.44-2.94-1.17-3.06-2.32s.92-1.74,2.29-2.3a4.92,4.92,0,0,1,2.6-.27c.89.13,1.88.23,2.18.83s-.51.83-1,1.17-1.31.75-1.9,1.16c-.2.14-.37.31-.21.49a1.1,1.1,0,0,0,1,.17,2.16,2.16,0,0,0,1.92-1.3c.14-.32.14-.82,1-.75s.66.53.71.88a.83.83,0,0,1-.16.74C634.73,479.24,635.2,479.83,635.89,480.41Z"
            />
            <path
              class="cls-36"
              d="M688.81,460.19c3-.57,2.91-.55,3.89,1.34.86,1.66.21,3-1.18,4.51-1.22,1.36-2.85,1.84-5,2.27-1.24.25-2.72.56-1.53,1.66a.26.26,0,0,1-.14.47c-2.17.35-1.5,1.6-2.13,2.41-.75,1,1.08,1.47,1.91,2.11.34.27.78.34.36.75-.59.58-.2,1,.86,1.26.28.06.53.18.82.23,2.5.39,4.17,1.12,3.61,2.86,0,.1.21.24.33.36-.41.74-1.62.63-2.54.83a2.67,2.67,0,0,1-1.64-.36c-1.14-1-2.55-1.88-3.07-3.09-.15-1.09-.73-1.54-2.58-1.72a35.71,35.71,0,0,0-6.7,0A3,3,0,0,0,672,477a1.54,1.54,0,0,1-1.79.61c-.17-.73.41-1.55-.75-2.17a10.28,10.28,0,0,0-3.1-2.81c-.67-.36-.55-.94,0-1.47,1.36-1.28.68-2.65-1.57-3.43-.56-.19-1.28-.34-.82-.87a1.67,1.67,0,0,0,1.49-1.46c.28-1.35,1-1.72,3.23-1.48a13.05,13.05,0,0,0,6.56-.81,4.49,4.49,0,0,1,1.63-.45,14.2,14.2,0,0,0,6.78-2.05A10,10,0,0,1,688.81,460.19Z"
            />
            <path
              class="cls-37"
              d="M746.83,478.69c-1.12-.38-.64-1-.67-1.53a5.46,5.46,0,0,0-1.89-4.05c-1.72-.14-2.09-.46-1.83-1.52,2.29-1.68,1.85-3.36-1.12-4.31,1.06-1.91,1.06-1.94,4.42-1.68a11.85,11.85,0,0,0,5.66-.76,10.51,10.51,0,0,1,3.85-.82c2.23-.09,3.58-1.07,5.09-1.87.32-.09,0-.58.71-.4,2.12.15,4.26.4,6.21-.37,1.35-.53,2.08-.26,2.54.58a7,7,0,0,1,.74,4c0,.62-1.06,1-1.35,1.47-1,1.7-3.23,2.37-5.86,2.81-1.29.22-1.85.64-1.3,1.43a.27.27,0,0,1,.06.1,12.26,12.26,0,0,1-2.69,2.43,1,1,0,0,1-.81-.12c-1.17-.89-1.74-.35-2.53.28a8.69,8.69,0,0,1-7,1.51c-1.06-.24-1.31-1-2.73-1.32A4.72,4.72,0,0,1,746.83,478.69Z"
            />
            <path
              class="cls-38"
              d="M892.83,471.8c1.91,0,3.88.22,5.65-.47.75-.28,1.11,0,1.28.42.73,1.76,1.36,3.39-.62,5.19a7.66,7.66,0,0,1-4.21,1.81c-1,.18-2.16.46-1.49,1.37.22.31-.09.56-.58.7-.66.18-.83.49-.8.87a1,1,0,0,1-1.21.13,2.13,2.13,0,0,0-2.54.34,5.23,5.23,0,0,1-3,1.27,5.3,5.3,0,0,1-3.76-.71,5,5,0,0,0-3.62-.66c-.9.1-1.59.35-1.75.94-.07.25-.06.59-.4.7-2.57.81-2.74,3-5.82,3.5-1.09.18-.55.67-.39,1.06a2.27,2.27,0,0,1-2.27.33,13.66,13.66,0,0,1-1.23-1.32c-.36-.5-.61-1.11.39-1.43,1.21-.39,1.34-1,1.19-1.64-.23-1,.29-1.59,2-1.8a2.78,2.78,0,0,0,2.38-1.47c.38-.75.71-1.51,1.06-2.27.16-.35.31-.83.85-.91,2-.29,2.48-1.12,2.8-2.17.19-.64,1.3-.84,2.34-.69a10.46,10.46,0,0,0,6-.67,4.92,4.92,0,0,1,2-.48,7.79,7.79,0,0,0,4.61-1.48Z"
            />
            <path
              class="cls-39"
              d="M664,466.88c0,.27.23.46.66.58,3.09.85,3.84,2.11,2.1,3.82-.69.68-.45,1.29.42,1.58a2.89,2.89,0,0,1,2.29,2.6,3.11,3.11,0,0,1-2.19.62,32.06,32.06,0,0,1-14.44-2.19c-1.52-.66-1.51-.89,0-1.65.55-.27,1.19-.54,1.39-1,.72-1.56,2.08-1.57,4.92-1.3,2.19.22,4.3.71,6.54.84.3,0,.6.14.77-.09s0-.35-.23-.49a3.28,3.28,0,0,0-1.54-.54,72.29,72.29,0,0,0-11-.53c-1.73.07-4,.23-5.26-.92-.38-.33-.77-.08-1.1,0a16.53,16.53,0,0,1-8.58.09,1.54,1.54,0,0,0,1.09-1.62c0-.49.28-.87,1.22-.86a2.07,2.07,0,0,0,2-.87,1,1,0,0,1,1.28-.54c.12,0,.33.05.35,0,1.46-1.4,5.37-1,6.16-2.9.15-.37.63-.69,1-1s.77-1.06,1.69-1,.69.74.93,1.15c.32.56.68.84,1.65.42a1.6,1.6,0,0,1,2.22.48c.44.62.86,1.25,1.33,1.87a2.9,2.9,0,0,0,1.69,1.08c1.37.36,2.15.92,1.82,1.86C663,466.88,663.54,466.82,664,466.88Z"
            />
            <path
              class="cls-38"
              d="M635.89,480.41c-1.17-.47-2.21-.89-.91-1.85.48-.35.28-1,0-1.45-.84,0-.51.42-.58.65a2.52,2.52,0,0,1-2.06,1.5,2.72,2.72,0,0,1-2-.23c-.65-.45.2-.7.61-1,.79-.5,1.6-1,2.45-1.45s.67-.75-.31-1a5.18,5.18,0,0,0-5.08,1c-1,1-.47,2.19,1.34,2.87.4.15.9.21,1.28.38s1.46-.06,1.44.44-.68.8-1.43,1a1.77,1.77,0,0,1-1.75-.22c-1-.86-3.5-1.25-2.65-2.77.16-.28-.48-.33-.75-.19a2.46,2.46,0,0,1-2.26-.12,3.79,3.79,0,0,0-2.85.23,5.5,5.5,0,0,1-3.87.42c.26-.59.5-1.18.78-1.76a1.39,1.39,0,0,1,1.19-.88c1.69-.11,2-.72,2.1-1.55s1-1.26,2.33-1.09a12.2,12.2,0,0,0,6.68-.86,1.42,1.42,0,0,1,.5-.13c2.85-.07,4.83-1.13,6.88-2.11,1.86,0,3.75.17,5.44-.5a1.16,1.16,0,0,1,1.33.25c1.4,1.29.83,3.74-.4,5.12s-2.84,1.91-5.06,2.24c-.52.08-1,.3-.85.58.55.84-.11,1.31-1.2,1.73C635.83,479.86,635.89,480.16,635.89,480.41Z"
            />
            <path
              class="cls-40"
              d="M714.45,457a4,4,0,0,1-2.65.69c-3,0-6,.11-9,.15s-5.87-.29-8.8-.49a5.65,5.65,0,0,0-1.59,0,6.19,6.19,0,0,1-3.5-.24c-1.06-.45-1.16.05-1.55.34l.09-1.17c0-.59.45-1,1.54-.94a2.33,2.33,0,0,0,1.81-.57c.53-.55.61-1.43,2.34-1a.32.32,0,0,0,.16,0c.4-1.76,3.69-.67,4.91-1.75s2.23-2,3.37-3a6,6,0,0,1,.88-.68c.6-.38,1-.29,1.29.19a5.76,5.76,0,0,1,.33.72c.29.87.78,1.38,2.34.61a1.52,1.52,0,0,1,1.92.32,13.23,13.23,0,0,1,1.1,1.58,4.94,4.94,0,0,0,3.33,2.4c1.14.29,1.66.92,1.38,1.69C714,456.16,713.91,456.58,714.45,457Z"
            />
            <path
              class="cls-41"
              d="M606.36,467.65c.09.24.2.48.27.73.12.46-.12.7-1,.53-2.28-.43-4.88-.24-6.87-1.22-.3-.14-.76-.26-1-.05-1.35,1.43-3.77.77-5.53.79-3,0-6.12-.34-9.22-.28a4.67,4.67,0,0,1-3.31-.85c0-.84-.14-1.7,2-1.66a1.37,1.37,0,0,0,1.14-.63c.31-.44,1.41-.66,1.5-.76,1-1.2,3.6-.67,4.84-1.58,1.07-.79,1.88-1.67,2.84-2.49.39-.34.65-.91,1.49-.81s.62.63.77,1c.27.68.7,1.09,1.93.49a1.41,1.41,0,0,1,1.87.34c.41.52.73,1.06,1.09,1.59a3.93,3.93,0,0,0,2.53,1.73c1,.27,1.6.8,1.36,1.49s.19,1.22,1.62,1.26A2.89,2.89,0,0,1,606.36,467.65Z"
            />
            <path
              class="cls-18"
              d="M921.64,469.23c.29.36,1.14.7.51,1.13s-1.08-.12-1.64-.15q-3.22-.19-6.47-.33a8.79,8.79,0,0,1-1.77-.18c-1-.25-2-1-2.94.08-.12.14-.91.07-1.39.09-3.39.16-6.75-.27-10.13-.21a8.33,8.33,0,0,1-2.2-.46c0-.94-.08-1.91,2.27-1.91a1.05,1.05,0,0,0,.84-.53,1.49,1.49,0,0,1,1.79-.77.6.6,0,0,0,.64-.32c.28-.61.91-.75,1.94-.63a2.7,2.7,0,0,0,2.2-.78c1-.85,1.94-1.74,2.92-2.6a1.49,1.49,0,0,1,1.18-.59c.66.05.65.48.75.78.27.79.5,1.49,2.24.69a1.25,1.25,0,0,1,1.67.44c.45.54.77,1.12,1.16,1.69a3.71,3.71,0,0,0,2.34,1.56c1.23.31,1.59.93,1.56,1.67C918.71,469.16,920.66,468.87,921.64,469.23Z"
            />
            <path
              class="cls-16"
              d="M534.07,467.08c.07.54-.45.61-1.24.66-1.68.1-3.33,0-5,0-3.12-.06-6.26-.07-9.38,0-1.87,0-3.64-.38-5.59-.14-1.29.15-1.68-.75-2.06-1.38,0-.25.21-.46.59-.46,1.4,0,2.29-.37,2.68-1.17.12-.27.79-.25,1-.36,1.63-1.1,4.8-.75,6-2.25a17.46,17.46,0,0,1,2-1.92c.35-.31.65-.8,1.41-.72s.61.58.73.92c.28.79.69,1.18,2.13.55s1.45.62,2.39.7a7.57,7.57,0,0,0,3.79,3.13C534.9,465.18,534.67,466.19,534.07,467.08Z"
            />
            <path
              class="cls-42"
              d="M828.94,471.59a2.13,2.13,0,0,0,1.08-2.75c-.24-.69-.81-1.22-2.09-1.43a4.89,4.89,0,0,1-2.28-.55c-.53-.84-.94-1.71-1.45-2.55,2.27-.34,3.74-1.38,5.48-2.18a13,13,0,0,1,2.86-.21,11.14,11.14,0,0,0,4.69-.61c1.13-.45,1.8-.16,2.18.51a7.58,7.58,0,0,1,.82,4.65c0,.37-.44.65-.73,1-.66.7-2,1.15-2,2.1,0,.26-.55.46-1,.57-.78.2-1.54.43-2.35.57-3.54.6-3.69.73-2.71,2.65C829.47,473.17,828.61,472.59,828.94,471.59Z"
            />
            <path
              class="cls-43"
              d="M824.2,464.31c1.37.67,1.67,1.56,1.45,2.55a13,13,0,0,1-3.68.44c-5,0-10,.05-15-.26-1.24-.08-3.33.19-3.22-1.26.28-.06.75-.09.82-.2.67-1,2.68-1.15,3.55-2a1.29,1.29,0,0,1,1.08-.31,3.6,3.6,0,0,0,3.24-1.06c.91-.76,1.69-1.57,2.55-2.35a1.41,1.41,0,0,1,1.08-.51c.61,0,.66.39.74.65.26.9.55,1.61,2.44.75a1.17,1.17,0,0,1,1.49.51c.51.64.89,1.33,1.41,2A2.39,2.39,0,0,0,824.2,464.31Z"
            />
            <path
              class="cls-44"
              d="M739.11,465.57c-4.43,1.05-9.06.95-13.67.75-1.32-.05-2.65,0-4-.11-1.09-.07-2.39,0-2.76-.85,0-1.09.24-1.23,2-1.11a3.76,3.76,0,0,1,3.12-1,2.56,2.56,0,0,0,1.88-.91c.94-.83,1.84-1.67,2.78-2.5a1.37,1.37,0,0,1,1.07-.52c.6,0,.61.42.7.68.29.87.58,1.63,2.45.73a1.16,1.16,0,0,1,1.42.38,9.51,9.51,0,0,1,.89,1.28,4.24,4.24,0,0,0,3,2.18C738.58,464.75,739.18,465.05,739.11,465.57Z"
            />
            <path
              class="cls-40"
              d="M720.68,464.25c-1.4-.09-1.57.58-2,1.11-.89.43-2.6.1-2.92,1.08-2.3-.69-5-.46-7.35-1a47.77,47.77,0,0,1-5.36-1.55c-1-.34-1-.74-.35-1.24a6.64,6.64,0,0,0,1-.89c1.67-1.91,1.82-2,5.39-1.73a49.53,49.53,0,0,1,6.49,1,5.07,5.07,0,0,1,2.35,1.13C717.7,463.35,719.58,463.63,720.68,464.25Z"
            />
            <path
              class="cls-45"
              d="M534.07,467.08c-.18-.23-.3-.44-.16-.71.44-.9-.19-1.53-1.55-1.94a3.29,3.29,0,0,1-2.68-2.91,10.13,10.13,0,0,0,5.23-1.75,1.68,1.68,0,0,1,1-.42,8.51,8.51,0,0,0,4.83-.19c.88-.33,1.38-.29,1.78.32,1.44,2.22.78,4.23-1.65,6.07a4.59,4.59,0,0,1-2,.68c-1.11.2-2.39.29-2.92,1.06Z"
            />
            <path
              class="cls-41"
              d="M609.53,475.24a31.86,31.86,0,0,0-4.14.27A28.94,28.94,0,0,1,593,473.4c-1.21-.49-1-.85-.12-1.32a3.06,3.06,0,0,0,1.65-1.49c.23-.69,1.11-1,2.12-.91,3.49.28,7.16.29,9.92,1.9-.38.47-.16.92.54,1.11A2.73,2.73,0,0,1,609.53,475.24Z"
            />
            <path
              class="cls-46"
              d="M868.69,464.5c-3.14-.83-6.7-.37-9.87-1.11-1.12-.27-2.24-.54-3.32-.86-.51-.16-1.55-.21-1.14-.75a2.29,2.29,0,0,1,1.88-.43,56.4,56.4,0,0,1,7.4.81l.38-.31c-.85-.43-1.73-.84-2.53-1.3-.58-.34-.6-.65.43-.57.36,0,.56.09.59-.18.08-.89,1.43-1.28,2.17-1.91a3,3,0,0,0,.5.1c3.62.05,5,1.28,5.37,3.26a2.12,2.12,0,0,1-.78,1.8C869.36,463.52,868.76,463.94,868.69,464.5Z"
            />
            <path
              class="cls-40"
              d="M688.81,460.19c-1.62.49-3.49,0-5.13.44.89-.56,2.07-1,1.46-2-.11-.17.37-.34.7-.43C686.73,458.93,688.13,459.37,688.81,460.19Z"
            />
            <path
              class="cls-47"
              d="M734,488.53a2.3,2.3,0,0,1,2.09,1,1.63,1.63,0,0,0,2.51.36.63.63,0,0,1,.61-.11.4.4,0,0,1,.21.36,4.86,4.86,0,0,1-.19.82,3.57,3.57,0,0,0,1,1.65c.29.23.36.52,0,.79-2.95.41-4.74,1.89-7.24,2.72-.68.22-.67.64-.72,1s0,.88-.82,1.11H719a3,3,0,0,1-1.2-.11c-1.83-1.52-4.45-.44-6.63-.74a.82.82,0,0,0-.49.1c-.63,1.22-2.33.72-3.62.75-2.29.06-4.6,0-6.91,0,.13-.57.93-.46,1.52-.48,1.5,0,3,0,4.54,0-1.09-.47-2.93-.21-3.3-1.25-.08-.24-.18-.05-.22,0a3.2,3.2,0,0,1-2.5-.18c-5.16-1.49-8.62-3.87-10.52-7-.54-.91-.92-1.86-.27-2.83a2.65,2.65,0,0,1,1.71-.49c2.16,0,4.3-.1,6.45-.1.22.06.48.12.5.27.57,3.42,4.7,4.79,9.52,5.77a6.38,6.38,0,0,1,1.34.3.5.5,0,0,1,.24.39c.08,1.3.09,1.31,2,.76a1.79,1.79,0,0,1,2.24.61c.54.68.31,1.48,1,2.2,2.24-.78,2-2.34,3.32-3.37.91-1.22,1.49-1.35,3.82-.82.47.1.77.33,1.17-.13s1.33-.43,2.09-.54c1.31-.18,2.71-.39,3.32-1.15C729.3,488.53,731.67,488.58,734,488.53Z"
            />
            <path
              class="cls-15"
              d="M582.2,492.87c.17-.92.85-1.14,2.74-.78.77.14,1.32.34,1.9-.23a4.42,4.42,0,0,1,1.69-.28c2-.15,3.58-.64,4.36-1.8a2.2,2.2,0,0,1,2.26-.8,4.87,4.87,0,0,0,.54,0,8.39,8.39,0,0,1,4.93,1.07,1.57,1.57,0,0,0,1.72-.08c.43-.26.87-.5,1.07.1.7.76-.32,1.7.73,2.44.38.26.61.61.47,1-2.16.82-4.53,1.42-6.66,2.28-.83.33-1.38.6-1.4,1.21s-.27,1-1.15,1.23l-11.48,0a2.19,2.19,0,0,1-.71,0c-2.24-1.62-5.25-.56-7.87-.81-1.44-.31-3-.31-4.45-.5-7.73-1-13.21-3.59-16.2-7.94-1.31-1.85-.08-3,3.24-3.06a19.56,19.56,0,0,1,3.59-.09c.21.06.44.14.46.3.47,2.57,3.46,4,6.93,5.11a4.33,4.33,0,0,0,4.18-.33c.94.06.73.47.66.81s-.36.6-.51.91-.4.64.06.9,1,0,1.45-.14c1.18-.46,1.91-.2,2.39.5a17.42,17.42,0,0,1,1.07,2.38,3.68,3.68,0,0,0,2.17-1.94C580.75,493.74,580.87,493,582.2,492.87Z"
            />
            <path
              class="cls-48"
              d="M898.2,494.57c-.18-1.08,1.11-.93,2.15-.81s1.81.33,2.61-.24a3.06,3.06,0,0,1,1.2-.2c2.18-.08,3.82-.62,4.67-1.86a2.19,2.19,0,0,1,2.16-.75,6.26,6.26,0,0,0,3-.58,1.8,1.8,0,0,1,1.64.84c1.24,1.29,1.23,1.3,3.39.53,0,.48.07.93.1,1.38-.19.36-.44.68.14,1.07,1.13.75,1.36,1.79,2.17,2.65.61.66-1,1-.92,1.62-.39-.68-1.15-1-2.4-.86-1,.08-2.07,0-3.1,0-.69,0-1.31,0-1.5.53s-1,.33-1.53.34h-5.82c.09.54.68.44,1,.39,2-.31,3.77.21,5.62.45.49.06.79.16.79.47s-.26.54-.84.6a87.81,87.81,0,0,1-12.14.14c-.65,0-1.31-.13-2-.13s-1.06-.1-1.06-.54.44-.48,1.05-.55a28.44,28.44,0,0,1,5.95-.42l0-.41c-1.69,0-3.39,0-5.08,0-.8,0-1.74.17-2-.58-.12-.37-.78-.27-1.24-.28h-3.65c-.72,0-1.45-.07-1.67.54s-1,.32-1.55.32c-3.22,0-6.45,0-9.67,0,.25-.66,1.19-.48,1.89-.49,2.35,0,4.7,0,7.08-.1a46.79,46.79,0,0,1-7.76-1.6,15.52,15.52,0,0,1-8.64-6.1c-.47-.68-.73-1.45.18-2.13a29.57,29.57,0,0,1,5.08-.27c.31.07.48.2.5.4.31,2.66,3.22,4.1,6.93,5.18a12,12,0,0,0,4.26.14c.6.46,0,.89-.12,1.32-.07.26-.12.51.25.7a1.42,1.42,0,0,0,1.16-.05c1.7-.48,2-.4,2.77.68.23.33.26.75.92.88a1.76,1.76,0,0,0,2.08-.69C896.63,495.48,896.79,494.75,898.2,494.57Z"
            />
            <path
              class="cls-49"
              d="M633,492.23a3.08,3.08,0,0,1-.4.7c-.49.52-.14.87.53,1.21a1.71,1.71,0,0,0,1.76-.17c1.23-.77,1.72-.29,2,.4a14.91,14.91,0,0,1,.77,2.08c.15.5.48.52,1.06.22a4.08,4.08,0,0,0,1.52-1.19c.64-.94,1.26-1.89,1.89-2.84.18-.79,1.05-.6,1.91-.49,3,.39,7.47-.78,9-2.36a3.16,3.16,0,0,1,2.17-.67c2.4-.23,4.51-.56,5.64,1.24.26.42,1.15,0,1.61-.32.84-.51.75,0,.85.27.64.75.09,1.57.43,2.34a3.31,3.31,0,0,1-1.56.87,19.16,19.16,0,0,0-2.92,1.69,8.59,8.59,0,0,0-3.67,3c-1.74.13-3.52-.12-5.26.15a1.43,1.43,0,0,1-1-.24c-.44-.25-.35-.78-1.31-.76-1.7,0-4.17-.39-5,.12-2.06,1.33-4.35.6-6.48.73-2.59.15-5.22,0-7.84,0-1,0-2.24.28-2.6-.7-.09-.26-.86-.17-1.34-.17l-4.92,0c-.22-.46.48-.48.82-.46a3.45,3.45,0,0,0,3.55-1.75l.54-.79a9.94,9.94,0,0,0-3-2.88c-1-.6-1-1.17.2-1.68.83.05,1.16-.47,1.85-.58,1.79,1.93,4.73,2.68,8.26,2.83A1.75,1.75,0,0,1,633,492.23Z"
            />
            <path
              class="cls-50"
              d="M847.18,494.16a9.55,9.55,0,0,0-2.56-2.5c-1.27-.77-1-1.31.75-1.83,2.85-.16,4.83-1,6-2.55a2.79,2.79,0,0,1,2.61-.87,7.19,7.19,0,0,0,3.15-.34,2.32,2.32,0,0,1,2.7.44c.32.3.56.63.85.94a2,2,0,0,0,2.72.31c.28-.16.53-.48,1-.35s.3.51.27.77c-.06.6-.23,1.2-.33,1.8-.05.28.1.5.68.49.66.64,0,1-.88,1.12-1.6.32-2,.92-1.63,1.83.29.76.06,1.48-1.28,1.79-1.94.45-2.38,1.3-2.24,2.39a.9.9,0,0,1-.5.62l-3.65,0c-.66,0-1.39.06-1.45-.53,0-.2-.26-.33-.6-.33l-5.65,0c-1,0-.31.74-1,.84-.85-.74-.53-1.48.15-2.16A2.92,2.92,0,0,0,847.18,494.16Z"
            />
            <path
              class="cls-51"
              d="M804.81,492.87c.17-.92.84-1.14,2.74-.78.76.14,1.34.36,1.89-.23a3.65,3.65,0,0,1,1.52-.26c2.07-.12,3.71-.61,4.53-1.81a2.29,2.29,0,0,1,2.27-.8,5.77,5.77,0,0,0,.72,0,7.73,7.73,0,0,1,4.74,1.06,1.55,1.55,0,0,0,1.72-.06c.89-.55,1-.19,1.08.3-.15,1,.6,1.87.83,2.81a8.47,8.47,0,0,1-2.47.88A15.08,15.08,0,0,0,822,495.1c-1.56.77-3.16,1.45-3.3,2.8,0,.16-.43.24-.68.33-2.67,0-5.34,0-8,0-.94,0-1.93.19-2.47-.67-.28-.46-1.67-.19-2.55-.19-1.51,0-3.25-.44-4.26.72-.13.15-.89.14-1.36.14-3.52,0-7,0-10.56,0,.31-.69,1.33-.52,2.09-.53,2.55,0,5.11,0,7.66,0,1.44.1,1-.88,1.82-1.13a5.13,5.13,0,0,0,2.81-2.55A1.85,1.85,0,0,1,804.81,492.87Z"
            />
            <path
              class="cls-52"
              d="M624.85,494.4c.23,1.62-1.34,2.74-4,2.81-.35,0-.73,0-1,.19,0,.64-.45.94-1.6.85-.7-.06-1.41,0-2.12,0a3.2,3.2,0,0,1-.87-.53c-1.56-1.44-3.8-1.77-6.38-.92a6.25,6.25,0,0,1-3.44.33c-.65-.14-1.51-.47-1.17-.81.94-.95.2-1.85.12-2.77-1.11-1.06-1.9-2.16-1.07-3.43.75.1,1.4.27,2-.32a6.08,6.08,0,0,1,3.36-1.15c1-.13,2,0,2.62-.68.24-.3.72-.11,1.08,0,1.68.72,3.24,1.47,3.4,2.83a1.4,1.4,0,0,0,.94,1c1.89.88,3.84,1.71,5.7,2.62A2.29,2.29,0,0,0,624.85,494.4Z"
            />
            <path
              class="cls-53"
              d="M826.74,493.09c-.82-.88-1.67-1.76-.72-2.8,1,.85,2.9.87,3.45-.12.79-1.42,2.65-1.33,4.42-1.54.39,0,.8,0,1,.16,1.08,1.18,3.41,1.7,4.43,2.92.49.59,1.75.58,2.53,1,.95.49,1.94,1,2.92,1.43.79.38,1.59.72,2.43,0,.61.49.65,1.11.08,1.48a2.45,2.45,0,0,0-1.18,2.57h-7.26a3.82,3.82,0,0,1-.86-.54c-1.55-1.44-3.8-1.77-6.38-.92a7,7,0,0,1-2.58.41c-1.81-.07-2.36-.53-1.66-1.52a1,1,0,0,0-.09-1.34C827,493.93,826.57,493.54,826.74,493.09Z"
            />
            <path
              class="cls-54"
              d="M534.84,492.86c-.44-.54-1.45-1-.73-1.7l6.77,3.84c-.66-1-2-1.56-3.14-2.31-.27-.18-.66-.3-1-.48-1.59-1-1.59-1,.32-1.73a2.23,2.23,0,0,0,1-.73c1.08-1.46,4.54-1.63,6.32-.44a46.7,46.7,0,0,0,6.89,3.9,37.79,37.79,0,0,1,4.3,2.25c0,1.08-.89,1.69-2.87,1.93,0,.66-.45.91-1.6.86s-2.61,0-3.91,0c-1-.23-1.15-.81-1.65-1.25a2.67,2.67,0,0,0-2.11-.61,13.62,13.62,0,0,0-4.67.68,4.67,4.67,0,0,1-3-.09c-.61-.18-1.05-.49-.57-.86,1-.77.59-1.47-.06-2.2C534.91,493.57,535,493.2,534.84,492.86Z"
            />
            <path
              class="cls-55"
              d="M749.39,495.87c-2.55-1.53-5.1-3.05-7.63-4.59-.64-.39-1.85-.86.27-1a1.06,1.06,0,0,0,.68-.31c.94-1.71,3.92-1.3,5.87-1.94.64-.22,1.11.2,1.5.45,1.77,1.17,3.49,2.36,5.28,3.52a11,11,0,0,0,1.82.87c1.26.51,1.76.22,1.69-.6,1.75.53,3.06,2.36,2.43,3.41-1,1.61-1,1.61-3.94,1.63a3.63,3.63,0,0,0-1.4.1c.11.66-.36.95-1.51.87-.7-.05-1.41,0-2.11,0C751.42,497.41,750.31,496.68,749.39,495.87Z"
            />
            <path
              class="cls-56"
              d="M778.58,497.38c-.11.33,0,.73-.75.87a76.47,76.47,0,0,1-14.9,0c-.26-.19-.38-.39-.25-.62,1.33-.74,2.06-1.59,2-2.72,0-.86.9-1.45,2.25-1.75.82-.19,1.39-.48,1.28-1-.27-1.41.26-2.53,2.78-3.05.2,0,.33-.2.51-.3,1.44-.29,1.61.4,1.95.9a19.78,19.78,0,0,0,5.13,5.17c.67.47,1.52.81,2.24,1.25.47.28,1,.63.7,1s-1,.11-1.51.16A4.42,4.42,0,0,0,778.58,497.38Z"
            />
            <path
              class="cls-57"
              d="M778.58,497.38c.74-.45,1.76-.05,2.6-.3.12-.46-.44-.72-.94-.95a17.46,17.46,0,0,1-7.24-6.35c-.28-.4-.23-1-1.35-1-.21-.14-.23-.28,0-.44.2-.79,1.16-1.17,2.27-1.48a9.23,9.23,0,0,1,2.08-.68,2.23,2.23,0,0,1,1.59,0c.3,5.53,8.29,9.42,17,10.23,1.14.11,2.28.2,3.42.28,1.33.1,1.95.52,1.41,1.33h-8.87a3.15,3.15,0,0,0-1.71.2h-2.17a2.58,2.58,0,0,1-.88,0c-1.82-1.6-4.55-.53-6.81-.82A2.17,2.17,0,0,0,778.58,497.38Z"
            />
            <path
              class="cls-58"
              d="M872.36,487.93c.15,3.52,3.54,5.86,8.25,7.68a30.37,30.37,0,0,0,8,1.65c.53.05,1.49.08,1.42.5s-1,.25-1.53.26c-2.37,0-4.74,0-7.11,0a3.06,3.06,0,0,0-1.71.2l-3.07,0c-.77,0-1.57.08-1.77-.59-.1-.37-.75-.28-1.21-.29l-4.15,0c-.11-.1-.11-.19,0-.28.54-.29,1.3-.12,2.08-.4-2.77-2.22-5.08-4.58-6.12-7.29.32-.5,1.23-.56,1.84-.84a5.32,5.32,0,0,0,2.19-.44A2.73,2.73,0,0,1,872.36,487.93Z"
            />
            <path
              class="cls-59"
              d="M552.74,497.39a4.44,4.44,0,0,0,2.87-1.93c.54-.29.47-.66.22-1a11.54,11.54,0,0,0-2.71-2.75c-1.5-1-1.49-1.08.18-1.9l.84-.4a1,1,0,0,1,1.06-.44c3,4.27,8.52,6.75,16.09,7.71,1.05.13,2.16,0,3.22.24.46.09.76.19.83.47l0,.41c-.42.43-1.15.3-1.78.32-2.57.07-5.14-.14-7.7.1l-4.7,0c-.72,0-1.46.07-1.63-.55-.13-.44-.84-.32-1.34-.33C556.35,497.37,554.54,497.38,552.74,497.39Z"
            />
            <path
              class="cls-60"
              d="M689.5,486.62c0,2.56,1.71,4.66,4.63,6.53a19.15,19.15,0,0,0,6.06,2.79c1.93.47,1.9.51,3.61-.25.16.44-1,.61-.54,1a4.75,4.75,0,0,0,1.78.47c.84.19,1.69.35,2.68.56-.66.47-1.42.25-2.06.29-1.84.14-3.73-.24-5.54.23h-.33a.89.89,0,0,1-.78,0c-1,0-2,0-3.08,0a2.77,2.77,0,0,1-1-.1c-.69-1.26-2.45-.68-3.77-.76-1.13-.07-2.28,0-3.43,0a1.09,1.09,0,0,0-.08-.15c.58-.52,1.51-.33,2.32-.37a21.77,21.77,0,0,0,2.85-.11,15.72,15.72,0,0,0-2.85-2,12.69,12.69,0,0,1-4.13-4.13c-.27-.44-.77-.81-1-1.24a2.26,2.26,0,0,1-.09-1.18c.23-.83,1.19-1.27,2.43-1.55a11.88,11.88,0,0,1,1.9-.19A1.09,1.09,0,0,1,689.5,486.62Z"
            />
            <path
              class="cls-61"
              d="M749.39,495.87a4.27,4.27,0,0,1,3,2.35l-11.24,0c-.36,0-.79,0-1-.17s-.2-.72-1.08-.71a50.31,50.31,0,0,0-5.23.11c-.67.08-1,1-2.27.75.11-.28.34-.55.32-.82-.07-.92,0-1.71,2-1.85a2.32,2.32,0,0,0,1.19-.62c1.26-1.1,3.18-1.43,5.23-1.64,1.46.54,2.07,1.42,1.64,2.32-.13.28-.76.58-.15.86a3,3,0,0,0,1.91,0,19.18,19.18,0,0,1,2.11-.61,24.56,24.56,0,0,1,3.21,0A2.17,2.17,0,0,0,749.39,495.87Z"
            />
            <path
              class="cls-62"
              d="M534.84,492.86l1.58,1.9c.44.52-.06.91-.59,1.24-.74.47-.39.63.44.79s1.78.38,2.26.08c1.62-1,3.76-.54,5.6-.85a1.25,1.25,0,0,1,1.3.35l1.8,1.85-9.25,0c-.41,0-.93.06-1.17-.18s-.2-.72-1.08-.7c-1.75,0-4.27-.38-5.08.14-1.41.91-2.76.66-4.24.72a3,3,0,0,0,.37-1.36c-.1-.65.29-1.11,1.52-1.21a1.36,1.36,0,0,0,.51-.08C530.21,494.2,532.9,493.82,534.84,492.86Z"
            />
            <path
              class="cls-61"
              d="M826.74,493.09c.46.54,1,1.06,1.35,1.61a.7.7,0,0,1-.16,1c-.87.84-.54,1.18,1.19,1.23a2.85,2.85,0,0,0,1.39-.15c1.26-.72,2.85-.56,4.36-.74,1.85-.21,2.53.3,3.15,1.09.28.35.54.71.8,1.07l-7.06,0a1.83,1.83,0,0,1-1-.16c-.38-.28-.35-.76-1.31-.73-1.75.05-4.24-.38-5.1.14-2.05,1.25-4.25.51-6.33.73l.15-.19c.67-1.1.34-2.6,3.24-2.81C822.41,493.85,824.73,493.61,826.74,493.09Z"
            />
            <path
              class="cls-63"
              d="M604.48,493.51c.65.84,2,1.63.31,2.59-.5.28,0,.51.46.65a4.53,4.53,0,0,0,3.39-.22c1.57-.81,3.57-.52,5.19-.45,1.41.07,1.8,1.32,2.39,2.13l-10.92,0a1.49,1.49,0,0,1-1.29-.42c-.42-.5-5.18-.76-5.46-.29-.64,1.11-2,.59-3.15.69a1.27,1.27,0,0,1,.24-.28c.89-.63-.2-1.8.89-2.07C599.28,495.19,601.4,493.78,604.48,493.51Z"
            />
            <path
              class="cls-64"
              d="M655.6,498.23c.12-.31.36-.62.32-.93-.09-.83.16-1.45,1.86-1.55a1.34,1.34,0,0,0,1.08-.51c.76-1.4,2.93-1.88,4.77-2.58,1.56.55,2.75,2.35,2.15,3.25-.46.7-.14,1,1.11.89a4,4,0,0,0,1.35-.29c1.61-.65,3.49-.48,5.26-.57.9,0,1.49.28,1.17.9-.21.26-.74.37-.86.68.25.29.73.2,1.11.2,3.39,0,6.79,0,10.18,0a25.75,25.75,0,0,0,2.6-.39l0,.07c.13.65-.35.87-1.45.86-4.42,0-8.85,0-13.27,0-.35,0-.9,0-1-.11-1.67-1.57-4.24-.43-6.31-.75C662.68,499.22,658.93,497.82,655.6,498.23Z"
            />
            <path
              class="cls-65"
              d="M771.61,488.35c0,.15,0,.3,0,.44,0,.5-.26.81-1.2.87-1.44.1-1.88.64-1.75,1.44a9.22,9.22,0,0,1,0,1.39c0,.45-.28.74-1.1.82-2,.21-2.66,1-2.53,2.1s-.5,1.89-2.41,2.2c-2.2-.54-4.48-.12-6.72-.23a1.83,1.83,0,0,1,1-.22c1-.09,2.41.33,2.84-.25.76-1,2.22-2.11.47-3.31-.57-.4-.67-1-1.37-1.36a4.2,4.2,0,0,1-1.81-1.51,2.8,2.8,0,0,0,2-.65c.94-.62,1.64-.39,2,.25a27.46,27.46,0,0,1,1.15,2.91c.08.2-.11.47.29.57s.72-.18,1-.32a5.17,5.17,0,0,0,2.67-2.73,2.37,2.37,0,0,1,1.27-1.38c.09,0,.26-.09.26-.14C767.87,487.22,770.11,488.36,771.61,488.35Z"
            />
            <path
              class="cls-47"
              d="M725.2,500.4a60.87,60.87,0,0,1-6.9-.22c-.64-.05-1-.14-1-.57s.35-.43.88-.53c3.49-.63,7.11-.42,10.67-.6,1.46-.07,2.62.64,4.1.69.48,0,.39.39.35.64s-.51.31-.93.37A51.84,51.84,0,0,1,725.2,500.4Z"
            />
            <path
              class="cls-66"
              d="M685.1,498.68a2.14,2.14,0,0,0,1.71.43c.51,0,.82.09.83.41s-.16.55-.77.61a72.4,72.4,0,0,1-12.58.08c-.48,0-1,0-1.45-.06s-1.1,0-1.18-.45.39-.59,1-.72a7.7,7.7,0,0,0,1.89-.31C678.07,498.52,681.58,498.49,685.1,498.68Z"
            />
            <path
              class="cls-67"
              d="M656.78,500.41a64.39,64.39,0,0,1-6.79-.25c-.56,0-.93-.12-.93-.5s.21-.47.8-.57c3.92-.71,7.94-.37,11.92-.42.92,0,1.69.5,2.73.45.55,0,.54.32.54.58s-.45.4-1,.47A53.68,53.68,0,0,1,656.78,500.41Z"
            />
            <path
              class="cls-68"
              d="M527.48,498.67a2.74,2.74,0,0,0,1.76.42c.65,0,.81.24.8.57s-.18.45-.72.5a86.49,86.49,0,0,1-12.47.11c-.66,0-1.32-.09-2-.11-.49,0-.82-.12-.83-.44s0-.62.52-.57c1.51.13,2.68-.63,4.16-.48A80,80,0,0,1,527.48,498.67Z"
            />
            <path
              class="cls-69"
              d="M888.07,498.67a4,4,0,0,0,1.79.43c.61,0,1.1.07,1,.52s-.51.49-1.11.54a88.81,88.81,0,0,1-14,0c-.6,0-.85-.2-.86-.54s.27-.53.87-.53a2.77,2.77,0,0,0,2.06-.44C881.24,498.52,884.66,498.51,888.07,498.67Z"
            />
            <path
              class="cls-70"
              d="M590.61,500.41a59,59,0,0,1-7-.24c-.65-.07-1.24-.1-1.26-.58s.73-.41,1.28-.51c2.86-.57,5.81-.36,8.73-.44a27.71,27.71,0,0,1,5.27.44c.63.11.71.32.7.63s-.5.39-1,.47A51.41,51.41,0,0,1,590.61,500.41Z"
            />
            <path
              class="cls-71"
              d="M612.11,500.4a57.79,57.79,0,0,1-7.21-.25c-.61-.08-1-.17-1-.58s.44-.4.94-.49c3.27-.57,6.64-.34,10-.48,1.64-.06,3,.44,4.51.48.58,0,.56.31.57.57s-.34.43-.89.51A52.23,52.23,0,0,1,612.11,500.4Z"
            />
            <path
              class="cls-72"
              d="M567.63,500.41a60,60,0,0,1-7.23-.24c-.61-.07-1-.17-1.07-.58s.51-.44,1.07-.54c3.29-.57,6.67-.31,10-.43,1.59-.05,2.86.46,4.35.51.57,0,.55.32.54.58s-.36.37-.82.44A47.4,47.4,0,0,1,567.63,500.41Z"
            />
            <path
              class="cls-73"
              d="M815.17,500.41a54.49,54.49,0,0,1-6.33-.24c-.6-.06-1.07-.09-1.08-.53s.47-.46,1-.56c3.23-.6,6.56-.32,9.84-.46,1.65-.07,3,.47,4.55.49.53,0,.61.3.55.57s-.5.42-1,.49A57,57,0,0,1,815.17,500.41Z"
            />
            <path
              class="cls-74"
              d="M707.77,498.68a2.29,2.29,0,0,0,1.73.42c.62,0,.84.2.83.54s-.18.46-.71.5a77.59,77.59,0,0,1-12.57.1c-.48,0-1-.07-1.44-.08-.65,0-1.23-.07-1.26-.56s.59-.51,1.22-.54,1.39.16,1.71-.36A96.59,96.59,0,0,1,707.77,498.68Z"
            />
            <path
              class="cls-75"
              d="M860.93,500.42a59,59,0,0,1-6.62-.27c-.56,0-.9-.12-.93-.49s.33-.49,1-.6c3.28-.58,6.64-.34,10-.46,1.65-.06,3,.48,4.53.51.56,0,.57.31.53.57s-.51.4-1,.48A55.19,55.19,0,0,1,860.93,500.42Z"
            />
            <path
              class="cls-76"
              d="M544.71,500.38a52.73,52.73,0,0,1-7.06-.24c-.64-.07-1-.2-1-.61s.53-.36,1-.45c3-.55,6-.36,9.05-.46a35.72,35.72,0,0,1,5.24.44c.68.08.69.33.69.63s-.45.4-1,.47A51.62,51.62,0,0,1,544.71,500.38Z"
            />
            <path
              class="cls-77"
              d="M641,499.1c.63,0,1.4-.11,1.42.52s-.61.49-1.23.55a89.58,89.58,0,0,1-13.9,0c-.71,0-.92-.24-.92-.62s.45-.6,1.16-.64,1.45.47,1.82-.23a50.26,50.26,0,0,1,7.26,0h0C638.06,498.91,639.6,498.75,641,499.1Z"
            />
            <path
              class="cls-78"
              d="M776.38,500.17a5,5,0,0,1-2.09.23c-3.43-.06-6.85.11-10.28-.21-1.34-.13-1.66-.37-1.46-1.06,3.91-.81,8-.66,12-.69,1.32,0,2.12.77,3.49.64.37,0,.34.32.34.53s-.12.41-.58.45A5.15,5.15,0,0,0,776.38,500.17Z"
            />
            <path
              class="cls-79"
              d="M798.29,498.67l.37.21c.47.39,2.16.66.35,1.27a4.18,4.18,0,0,1-1.89.26c-3.6,0-7.22.15-10.82-.23-.63-.07-1.2-.06-1.19-.57s.6-.54,1.23-.54,1.36,0,1.74-.39C791.49,498.5,794.89,498.51,798.29,498.67Z"
            />
            <path
              class="cls-80"
              d="M747.84,500.14h-6.53c-.71,0-1.39,0-1.34-.61s.85-.34,1.35-.45c3.14-.67,6.4-.3,9.6-.47,1.64-.09,3,.46,4.49.5.59,0,.49.33.49.58s-.44.46-1,.46h-7.08Z"
            />
            <path
              class="cls-81"
              d="M838.79,500.35a50.78,50.78,0,0,1-7.51-.22c-.6,0-.8-.26-.8-.59s.3-.4.79-.46a36.46,36.46,0,0,1,7.55-.4C839.44,499.24,839.53,499.79,838.79,500.35Z"
            />
            <path
              class="cls-82"
              d="M838.79,500.35l0-1.67a28.73,28.73,0,0,1,7,.39c.55.1.6.29.62.55s-.29.46-.87.52A45.21,45.21,0,0,1,838.79,500.35Z"
            />
            <path
              class="cls-83"
              d="M776.38,500.17a2.39,2.39,0,0,1,1.18-.2c.42,0,.64-.16.64-.42s-.23-.35-.63-.43c-3.74-.77-7.61-.46-11.4-.36-1.11,0-2.37.33-3.62.37.58-.51,1.66,0,2.35-.42-.42-.51-1.57,0-2-.48l14.9,0c-.27.28-.91.15-1.36.4.71.41,2.66.07,2.08,1.14C778.17,500.48,777.14,500.1,776.38,500.17Z"
            />
            <path
              class="cls-75"
              d="M869.46,497.18a1.55,1.55,0,0,1,0,.22c0,.61-.5.87-1.58.86-3.14,0-6.28,0-9.41,0,0-.21,0-.41,0-.61,1.62,0,3.22.14,4.85.12A20.45,20.45,0,0,0,869.46,497.18Z"
            />
            <path
              class="cls-47"
              d="M707.77,498.68l-10.49,0c.34-.46,1.33-.05,1.73-.44h.78c1.87.44,3.82.08,5.73.21C706.27,498.51,707.11,498.29,707.77,498.68Z"
            />
            <path
              class="cls-51"
              d="M799,500.15c1.13-.54-.4-.83-.35-1.27a5.07,5.07,0,0,1,.55,0c.74.12,1.95,0,1.91.67S799.85,500.12,799,500.15Z"
            />
            <path
              class="cls-15"
              d="M504.83,498.69H494.34a2.42,2.42,0,0,1,1.69-.22C499,498.59,501.93,498.17,504.83,498.69Z"
            />
            <path
              class="cls-64"
              d="M685.1,498.68H674.56c2.68-.46,5.41-.11,8.12-.19A4.51,4.51,0,0,1,685.1,498.68Z"
            />
            <path
              class="cls-51"
              d="M798.29,498.67H788.08a6.2,6.2,0,0,1,2.94-.2C793.44,498.55,795.9,498.2,798.29,498.67Z"
            />
            <path
              class="cls-48"
              d="M888.07,498.67H877.83c2.58-.44,5.22-.11,7.83-.18A4.79,4.79,0,0,1,888.07,498.67Z"
            />
            <path
              class="cls-15"
              d="M565.83,498.24c1.24-.44,2.6-.12,3.9-.2,1.85-.12,3.76.21,5.58-.22-.08.55-.8.43-1.37.43C571.24,498.26,568.53,498.25,565.83,498.24Z"
            />
            <path
              class="cls-15"
              d="M527.48,498.67h-8.76A37.74,37.74,0,0,1,527.48,498.67Z"
            />
            <path
              class="cls-49"
              d="M636.62,498.67l-7.26,0A24.54,24.54,0,0,1,636.62,498.67Z"
            />
            <path
              class="cls-49"
              d="M641,499.1a17.69,17.69,0,0,1-4.39-.43C638.11,498.73,639.71,498.38,641,499.1Z"
            />
            <path
              class="cls-84"
              d="M555.2,489l-1.06.44a28.39,28.39,0,0,0-3.72-2.88,25.26,25.26,0,0,1-2.27-2.05c-1.48-1.56-2.21-1.81-5.22-1.48s-5.92.67-8.84,1.09c-1.69.25-3.08.36-3.85-.83-.22-.34-.85-.59-1.37-.93a1.9,1.9,0,0,0,1.6-2c0-.74.21-1.54,2.1-1.45a2.27,2.27,0,0,0,1.71-.71c1.74-1.45,3.25-1.58,5.63-.46.24.12.49.22.73.32,1,.65,1.22,1.68,2.91,2,1.35.23,1.59-.48,2.2-.88a2.4,2.4,0,0,1,1.53-.21,8.59,8.59,0,0,0,4.52-.91,2.55,2.55,0,0,1,2.71-.05c.74.47,1.44.17,2.17.08.62.38.17.82.2,1.23a1.46,1.46,0,0,0,1.18,1.47c1,.31,1.38-.22,2-.5a7.94,7.94,0,0,1,6.2.2,4.35,4.35,0,0,0,4.95-.05l.37-.24c2-1.32,2.54-1.31,4.49.05a2.27,2.27,0,0,0,1.49,2.72c.05,0,.12.06.11.08-.4,1.52,1.83,1.51,3.27,2,1.8.6,2.31,1.39,1.49,2.51a2.54,2.54,0,0,0-.31,2.61.73.73,0,0,1-.15.92c-.73.65-.58,1.28.27,1.86A2.41,2.41,0,0,0,581,494a3.76,3.76,0,0,1-.65,1.12c-.51.6-1,1.44-2.23,1.39-1,0-.47-.92-.86-1.38a2.88,2.88,0,0,1-.3-.73c-.59-1.25-.74-1.3-2.44-.54a1.76,1.76,0,0,1-1.47,0c-.7-.26-.71-.6-.58-1,.22-.66,1.49-1.21.63-2-1.59-.76-1.91-1.51-1-2.51a16.36,16.36,0,0,1,3.13-2.5c1.31-.88,1-1.56-.84-1.95a18.35,18.35,0,0,0-6.81,0c-.69.11-1,.53-1.4.81a6.86,6.86,0,0,1-4.38,1.22c-1.73.06-3.46.09-5.19.17-1.33.06-2.5,1.37-1.93,2.13C554.86,488.55,555.23,488.71,555.2,489Z"
            />
            <path
              class="cls-85"
              d="M537.34,472c.13.81,1.61.93,2.23,1.49-.75.2-1.4.32-1.57,1-.32,1.28-1.55,1.8-3.6,1.82-2.24,0-3.71-.5-4.12-1.74-.25-.78-.88-1.16-2-1.38a6.55,6.55,0,0,1-1.3-.38c-.81-.37-2.5-.31-2.07-1.31.71-1.61,1.25-1.74,3.64-1.68a51.14,51.14,0,0,1,5.17.5C535.35,470.55,536.71,471,537.34,472Z"
            />
            <path
              class="cls-16"
              d="M506.34,470.73l-2.42.71c-.6.18-1.29.06-1.4-.22-.32-.9-1.43-.68-2.39-.71a4.5,4.5,0,0,1,3.83-.46C504.78,470.23,505.55,470.5,506.34,470.73Z"
            />
            <path
              class="cls-18"
              d="M925.27,476.75a20.5,20.5,0,0,1-7.77.38,27.44,27.44,0,0,1-8.5-2c-.94-.41-1.29-.75-.2-1.24a3.13,3.13,0,0,0,1.64-1.5,2.47,2.47,0,0,1,2.52-1,57.15,57.15,0,0,1,7.23,1,21.53,21.53,0,0,1,2.17,1,1,1,0,0,0,.83,1.18A2.46,2.46,0,0,1,925.27,476.75Z"
            />
            <path
              class="cls-86"
              d="M845.72,489.43a3,3,0,0,1-2.22-.56,42.46,42.46,0,0,1-4.54-3.71,2,2,0,0,0-2.33-.44,5.17,5.17,0,0,1-4.15-.37c-1.45-.85-3.11-1.58-4.68-2.36-.33-.16-.7-.4-1.06-.11s.26.37.55.52c1,.49,2.11,1,1.41,1.87a3.71,3.71,0,0,1-3.09.85c-1.52-.1-2.16-.7-2.15-1.57,0-.17-.1-.5-.32-.42-1.6.58-1.74-.58-2.84-.69,2.16-.5,1.67-1.64,2-2.52.24-.61.61-1,1.72-1a2.32,2.32,0,0,0,1.75-.67c1.41-1.64,3.32-1.66,6.07-.31.23.12.47.22.71.33s.69.5,1,.75c1.45,1.16,1.46,1.17,3.25.32a5.45,5.45,0,0,1,2.55-.43,8.25,8.25,0,0,0,3.72-.71c1.71-.82,3.11-.71,4.33.4a11.3,11.3,0,0,1,1.09,1.23A3.87,3.87,0,0,0,850.6,481c1.54.4,1.6.65.18,1.24-.8.34-1.47.74-2.19,1.12s-.88.73-.6,1.16c.47.7-.08,1.26-.57,1.82-.7.8-2,1.48-.87,2.53C846.82,489.08,846.13,489.29,845.72,489.43Z"
            />
            <path
              class="cls-87"
              d="M869.46,497.18a4.23,4.23,0,0,1-3.19.87c-1.8-.07-3.61-.05-5.42,0a5,5,0,0,1-2.33-.43c-.27-1.25.05-2.25,2.53-2.64,1.28-.19,1.19-.89,1-1.52-.47-1.49-.35-1.66,2-2.09.81-.15,1-.47,1-.88s-.16-.76.41-1.05a4.94,4.94,0,0,1,1.52,1.92,16.75,16.75,0,0,0,4.35,4.65c.37.3,1.28.5.91.94s-1.2.16-1.83.22C870.08,497.19,869.77,497.17,869.46,497.18Z"
            />
            <path
              class="cls-43"
              d="M828.94,471.59c0,1,1.34,1.33,2.53,1.73l0,.42c-.23.62-.86,1-2,1.07a33.1,33.1,0,0,1-12.27-1.5c-1.88-.65-1.93-.78-.68-1.88a2.77,2.77,0,0,0,.48-.69c.56-.95,1.67-1.23,3.29-1s3.44.39,5.15.6A6,6,0,0,1,828.94,471.59Z"
            />
            <path
              class="cls-88"
              d="M776,486.43a5.59,5.59,0,0,1-2.14.44c-.33-.39-.67-.77-1-1.16-.56-.73-.93-1.4.79-1.85.9-.23,1-.77.69-1.31-.47-.94-.11-1.56,1.75-1.8a3.14,3.14,0,0,0,2.5-1.43c.37-.72.72-1.44,1-2.16a2.14,2.14,0,0,1,2-1.35,1.6,1.6,0,0,0,1.6-1.4c.35-1.11.92-1.35,2.86-1.15a10.51,10.51,0,0,0,5-.59,9,9,0,0,1,3.2-.69c2.32-.06,3.5-1.32,5.35-1.9,1.83-.07,3.75.27,5.42-.49a1,1,0,0,1,1.28.32c.51,1.36,1.76,2.77.47,4.13s-2.17,2.86-5.36,3.06c-1.1.07-2.22.38-1.33,1.29.38.39,0,.59-.55.75-.89.27-1.09.72-1,1.26-2.15-.87-3.45-.18-4.94.75a5.27,5.27,0,0,1-5.29-.14,5,5,0,0,0-5.93.59c-1.66,1.28-2.72,3-5.43,3.73C776.24,485.56,775.8,485.88,776,486.43Z"
            />
            <path
              class="cls-37"
              d="M760.31,488.58c-.83-.22-.7-.67-.72-1.08-.3-.44.23-.74.54-1.07s.87-.83.78-1.29c-.27-1.36,1-2.23,2.62-3,1.12-.5,1.12-.81-.19-1.16a5,5,0,0,1-2.28-1.62,4.86,4.86,0,0,0-4.19-1.47l-.2-.1c.28-.88,1.87-.55,2.54-.94,1.26-.73,1.73-.12,2.56.27s.79.57.15.93-.5.75.14,1.09a13.68,13.68,0,0,0,2.59,1.33c1.43.44,1.42,1.11.6,1.79a5.69,5.69,0,0,1-1.58.88c-1,.38-1.65.93-1.55,1.59C762.34,486.19,760.86,487.3,760.31,488.58Z"
            />
            <path
              class="cls-89"
              d="M754.46,478.72a7.81,7.81,0,0,0-4.5.82,1.68,1.68,0,0,1-2.39-.21c.81-1.44,3-1.35,4.92-1.48,1.38-.1,2.79,0,4.19,0v0C756.52,478.72,756.08,478.89,754.46,478.72Z"
            />
            <path
              class="cls-90"
              d="M576,480.19c-1.18.06-1.51-1.15-2.74-.74a11,11,0,0,0-2.07,1.31,4.57,4.57,0,0,1-5.3-.17c-1.27-.84-4.81-.84-5.91,0a2.34,2.34,0,0,1-3.32-.27c-.63-.78-.17-1.53,0-2.3.57-.65.16-1.68,1.46-2,1.92-.44,2.42-1.22,2.71-2.3.16-.62,1.43-.76,2.41-.59a10.53,10.53,0,0,0,5.84-.63,2.91,2.91,0,0,1,.95-.29c2.89-.12,4.94-1.19,7.09-2.15,1.82-.11,3.76.3,5.44-.49a.84.84,0,0,1,1.19.38c1,1.75,1.54,3.33-.51,5.15a9.27,9.27,0,0,1-4.83,2.05c-.93.18-1.54.48-.91,1.11.4.4.2.65-.47.85S576,479.7,576,480.19Z"
            />
            <path
              class="cls-14"
              d="M545.75,479.12c-.36.62-.52,1.4-2.2.88C544.57,480,544.91,479.31,545.75,479.12Z"
            />
            <path
              class="cls-91"
              d="M689.16,486.61a8,8,0,0,1-1.84.23c-2.09-1-2.31-2-.7-3.16.36-.26.62-.52.52-.87-.29-.69-.48-1.37.94-1.75l2.56-.64a3.6,3.6,0,0,0,2.18-2.5,2.85,2.85,0,0,1,2.89-2.29c.85-.1.72-.59.77-1,.2-1.26,1-1.64,3.07-1.42a10.65,10.65,0,0,0,5.21-.54,8.21,8.21,0,0,1,3-.68c.21-.11.33-.34.74-.2,2-.18,3-1.31,4.74-1.72,1.8,0,3.64.18,5.3-.47.72-.29,1.12,0,1.29.4.72,1.76,1.38,3.39-.6,5.19a7.69,7.69,0,0,1-4,1.78c-1.06.21-2.34.42-1.67,1.41.22.31-.08.56-.57.69-.65.19-.84.49-.8.88a.89.89,0,0,1-.64.15,3.55,3.55,0,0,0-3.72.72,5.58,5.58,0,0,1-6.12.06,4.91,4.91,0,0,0-5.67.67c-1.53,1.29-2.7,2.89-5.25,3.67C689.66,485.57,689.21,486,689.16,486.61Z"
            />
            <path
              class="cls-92"
              d="M689.16,486.61c-.87-.76-.57-1.25,1-1.48a4,4,0,0,0,2.53-1.28,3.43,3.43,0,0,1,2.47-1.72.66.66,0,0,0,.61-.61c0-.85.7-1.37,2.09-1.47,1.55-.12,3.11-.23,4.26.68a4.47,4.47,0,0,0,5,.15c1.46-1,2.67-2,5.09-.91.14.88-.43,1.82.73,2.6-.24.46.54.69.72,1.05,0,.31.25.54.75.65a10.77,10.77,0,0,1,4.67,1.24,13.46,13.46,0,0,1,2.81,1.67c.3.23.59.51.09.76a1.47,1.47,0,0,1-1.16-.09c-.51-.17-.89-.7-1.48-.49-.8.29-1.2,1-.94,1.42,1,1.44-.6,2.75-.33,4.13-.88.67-1,1.53-1.6,2.26a2.09,2.09,0,0,1-.55.56c-.58.34-1,1-1.88.87s-.27-.76-.53-1.15c-.36-.56-.11-1.21-.74-1.75a1.11,1.11,0,0,0-1.44-.21c-.59.31-1,.94-2.07.5-1.23-.5-.57-1.14-.27-1.74a6.86,6.86,0,0,0-.94-2.49c-.56-.77.16-1.47.92-2.09s1.7-1.21,2.52-1.83c1.12-.84.87-1.48-.77-1.85a19.43,19.43,0,0,0-7.33.08c-.62.09-.84.49-1.25.75a6.07,6.07,0,0,1-4.15,1.21c-2.28.21-4.58.15-6.87.18a2.17,2.17,0,0,0-1.56.41A1.93,1.93,0,0,1,689.16,486.61Z"
            />
            <path
              class="cls-93"
              d="M718,492.91c-.32-.71-1.22-1.4.18-2.12.45-.24.32-.83-.15-1.2a.71.71,0,0,1-.17-1.1c.37-.56.42-1.43,1.08-1.63,1-.32,1.43.65,2.29.91.15,0,.33.05.84.13-2-1.84-4.69-2.86-7.73-3.63-.12-.91.56-1.32,2.13-1.29,1.33,0,2.65-.17,2.68,1.11s1.16,2,3.27,2.25a4.66,4.66,0,0,0,4.11-1.12,1,1,0,0,1,1-.39c.59.13.4.51.31.75-.3.8-1.32,1.15-2.61,1.27-.45,0-1.15,0-1.07.37s.76.26,1.23.28a4,4,0,0,0,3.06-.94,1.47,1.47,0,0,1,2.29,0,11.34,11.34,0,0,0,3.3,1.95,11.94,11.94,0,0,1-3.32.47,1.6,1.6,0,0,0-1.55.59c-.91,1.31-2.69,1.85-5,2-.81.06-2.07.06-1.36,1C719.74,491.57,718.78,491.64,718,492.91Z"
            />
            <path
              class="cls-94"
              d="M754.46,478.72a2.72,2.72,0,0,0,2.23-.87c2.26-.39,2.88-.26,4.34,1,1,.9,1.68,2,3.83,2.28.75.1.5.5,0,.74s-1.21.6-1.83.88c-1.24.56-1.86,1.25-1.65,2.22s-1.18,1.67-1.81,2.51a2.15,2.15,0,0,1-2.17-.62,30.09,30.09,0,0,1-5-5.18C751,479.73,751.2,479.32,754.46,478.72Z"
            />
            <path
              class="cls-44"
              d="M742.44,471.59a2,2,0,0,0,1.83,1.52,2.26,2.26,0,0,1-.77,2.25,5.08,5.08,0,0,1-3.65.93,4.25,4.25,0,0,1-3.46-1.85c-.33-.55-.71-.68-1.62-.72a11.34,11.34,0,0,1-4.38-1.19c-1.54-.69,0-1.35.25-2s1.3-.95,2.42-.85c2.07.2,4.15.41,6.2.73A12.52,12.52,0,0,1,742.44,471.59Z"
            />
            <path
              class="cls-55"
              d="M749,495.88a1.82,1.82,0,0,1-1.32.23,6.54,6.54,0,0,0-3.52.6,3.42,3.42,0,0,1-2.06.21c-1-.15-2.09-.25-.87-1.14s-.33-1.69-1-2.48c-.21-.29-.29-.68-.66-.86-.95-.46-.86-.95-.41-1.51.89-.38,1.3.08,1.79.36Z"
            />
            <path
              class="cls-91"
              d="M713.6,483.62c-.87-.2-1.35-.49-.72-1.05C713.05,482.93,714.41,483,713.6,483.62Z"
            />
            <path
              class="cls-95"
              d="M776,486.43c-1.42-.52-.62-1,.27-1.21a4.88,4.88,0,0,0,3.42-2.06,1.94,1.94,0,0,1,1.46-.88,1.13,1.13,0,0,0,1.09-.9c.14-.74.75-1.28,2.12-1.36,1.53-.09,3.08-.14,4.21.63a4.63,4.63,0,0,0,5.09.21l.52-.3c2.07-1.28,2.07-1.28,4.44-.16a2.07,2.07,0,0,0,1.36,2.43c.18.08.43.26.38.35-.59,1.23,1.12,1.27,2.32,1.55,2.49.6,3.15,1.47,2.17,2.95a2,2,0,0,0-.4.92c-.07,1,.6,2.08-.31,3.11-.31.36.07.84.65,1.16-.88.39-1,1-1.4,1.57a4.12,4.12,0,0,1-2.94,2.31c-.91-.35-.73-1-1-1.47a6.25,6.25,0,0,0-.46-1c-.2-.29-.47-.46-1.1-.35-3,.5-3.61.15-2.91-1.59a1.77,1.77,0,0,0-.06-1.89c-.8-1.21-.23-2.25,1.15-3.18.72-.49,1.43-1,2.06-1.5.91-.74.7-1.23-.63-1.66a15.46,15.46,0,0,0-4.82-.36,6.18,6.18,0,0,0-4.14,1.24,8.81,8.81,0,0,1-5,1.34,31.8,31.8,0,0,1-4.89.21,2.21,2.21,0,0,1-1.15-.29A3.5,3.5,0,0,0,776,486.43Z"
            />
            <path
              class="cls-39"
              d="M685.14,488.15v1.28a4.4,4.4,0,0,0-3.29,2.16,53.72,53.72,0,0,1-6.28-4.41,1.75,1.75,0,0,0-2.51-.21,4.43,4.43,0,0,1-3.19.5,46.53,46.53,0,0,0-10.08-.19c-.86,0-1.76,0-2.2-.51s0-1,.71-1.43c1.06-.69,1.26-1.45,0-2.16-.65-.36-.92-.6.1-.94a1.65,1.65,0,0,0,1.22-1.7c.06-.77.26-1.42,2-1.45a2.86,2.86,0,0,0,1.81-.84c1.7-1.25,3.08-1.4,5.37-.49.48.19.85.57,1.39.07.68.32.79.86,1.31,1.25a1.94,1.94,0,0,0,2.36.24,5,5,0,0,1,3.69-.26c.23,2.29,2,4.26,3.88,6.19a4.7,4.7,0,0,0,3,1.54c.37.39.14.82.25,1.23,0,.1-.08.2,0,.3C684.71,488.16,684.85,488.08,685.14,488.15Z"
            />
            <path
              class="cls-96"
              d="M674.61,496.74c-.08-.26-.33-.62-.7-.55-1.72.33-3.69-.21-5.26.52a4.66,4.66,0,0,1-2.55.4c-1.67-.18-1.82-.38-.84-1.2.34-.27.68-.51.38-.87l-2-2.38c-1.28-.73-.13-1.57-.31-2.35,1.65,1.06,2.81.95,4-.35s4-1.44,5.63-.54a56.13,56.13,0,0,0,6.19,3.45c.36.15.58.37.58.64a5.22,5.22,0,0,0-.64,2.39,1.61,1.61,0,0,1-.94,1.35C676.7,498.07,675.33,497.87,674.61,496.74Z"
            />
            <path
              class="cls-91"
              d="M674.61,496.74c.76.2.81,1.1,2.24.68,1.28-.37,1.71-.92,1.74-1.69s-.36-1.66,1.09-2.22c2.42-.22,2.93-.67,2.17-1.92,0-1.57.77-2,3.29-2.16,1.1.41,1.08,1.16,1.49,1.76,1.22,1.8,3.37,3.19,5.48,4.61.56.38,1.88.68,1.48,1.18s-1.66.11-2.53.18c-1.12.09-2.29-.19-3.36.19a2.17,2.17,0,0,1-2,.71c-3.83-.05-7.66,0-11.49,0-.57,0-1.44.2-1.64-.19s.63-.63,1.17-.85C674,496.88,674.34,496.82,674.61,496.74Z"
            />
            <path
              class="cls-97"
              d="M677.5,479.11c-1.54-.06-3-.09-4.07.78a1.11,1.11,0,0,1-1.37,0c-1-.59-2-1.16-1.92-2.07a.53.53,0,0,0,.07-.2c.59,0,1.19-.25,1.25-.54.21-1.13,1.7-1.27,3-1.33a26.12,26.12,0,0,1,7.55.22c1.28.32,2.55.81,1.64,1.87A23.4,23.4,0,0,0,679.5,479,2.49,2.49,0,0,1,677.5,479.11Z"
            />
            <path
              class="cls-95"
              d="M872.36,487.93a8.81,8.81,0,0,0-2.91.22c-.61,0-1.08-.18-1-.59s.51-.5,1-.57c2-.28,3.09-1,3.63-2.15a1.44,1.44,0,0,1,.88-.65c1.32-.23,1.8-.7,1.81-1.5s1.1-.8,2-.92a6.09,6.09,0,0,1,4.15.67,5.06,5.06,0,0,0,5.29.13,4.08,4.08,0,0,0,.74-.47c.88-.89,1.82-1.51,3.37-.38.23.17.56,0,.83,0,.12,1.11-.54,2.35,1.58,3.1-.43,1.56,2,1.48,3.37,2,1.61.62,2.1,1.2,1.39,2.25s-1.08,1.8-.53,2.79a.66.66,0,0,1-.07.83c-1,.74-.36,1.32.4,1.91a2.87,2.87,0,0,0-1.6,1.84c-.29.65-1,.77-2,.8s-1.46-.29-1.62-.84a3.71,3.71,0,0,0-.53-.91c-.31-.43-.76-.5-1.38-.16s-1.11.86-2.09.37-.63-1-.19-1.55c.22-.26.41-.52.33-.82-2-2.16-2-2.74.57-4.62a17.74,17.74,0,0,0,1.87-1.32c.71-.71.52-1.26-.76-1.58a19.1,19.1,0,0,0-7.68,0c-.56.09-.74.45-1.09.7a7.45,7.45,0,0,1-4.2,1.28A52.62,52.62,0,0,1,872.36,487.93Z"
            />
            <path
              class="cls-40"
              d="M708.51,471.81l-.74.2c0-.54-.8-.77-1.33-1.09-2.05-1.22-4.13-2.42-6.18-3.64Z"
            />
            <path
              class="cls-98"
              d="M633,492.23c-3.1.65-5.18-.67-7.6-1.35-1.18-.33-1.74-.84-1.5-1.62.1-.12.35-.32.29-.36-1.32-.93-.11-1.64.55-2.4.33-.38.78-.76.88-1.17.32-1.31,1.82-1.64,3.73-1.68a23,23,0,0,1,5.57.23c1.92.46,2.28,1.31,1,2.27-1,.69-1.92,1.37-2.83,2.08s-1.09,1.48-.25,2.28C633.34,491.06,633.58,491.63,633,492.23Z"
            />
            <path
              class="cls-38"
              d="M631.09,475.89c.5.05,1.19-.14,1.42.28s-.35.51-.67.71a8.8,8.8,0,0,1-1,.6c-.6.28-.94.9-1.78.8-.68-.07-.44-.61-.42-.95,0-.64.45-1.19,1.59-1.41A5.31,5.31,0,0,1,631.09,475.89Z"
            />
            <path
              class="cls-99"
              d="M677.5,479.11a7.88,7.88,0,0,0,3.31-1c.82-.53,1.89-.29,2.88-.3.9.9,1.77,1.8,2.71,2.68a2.92,2.92,0,0,0,1.68.53c-.78.52-1,1.08-.37,1.71-1.27.79-2.59,1.52-2,2.83.21.45-.35,1-1.31,1.25a2.59,2.59,0,0,1-2.3-.5,19.21,19.21,0,0,1-4.9-5.9A1,1,0,0,1,677.5,479.11Z"
            />
            <path
              class="cls-22"
              d="M697.93,486c1.7-.44,3.61-.71,4.36-1.91a1,1,0,0,1,.35-.24c1.52-.7,7.81-.59,9.26.18.93.49,1.26,1,.33,1.66s-1.86,1.31-2.76,2c-1.08.79-1.66,1.61-.63,2.62a1.22,1.22,0,0,1,.09,1.93c-5.12-.4-8.76-2-11.11-4.69A1,1,0,0,1,697.93,486Z"
            />
            <path
              class="cls-22"
              d="M561.82,486c1.71-.48,3.78-.67,4.51-1.95,0-.06.14-.11.23-.16,1.58-.85,8.23-.6,9.66.34.85.55.56,1.05-.1,1.53s-1.63,1.15-2.46,1.72c-1.57,1.06-2.21,2.18-.53,3.42-.38,1-1.85,1.31-3.89.77a16.44,16.44,0,0,1-7.1-3.84C561.55,487.31,561.26,486.68,561.82,486Z"
            />
            <path
              class="cls-100"
              d="M877.84,487.75c1.64-.61,3.7-.84,4.56-2.1.34-.5,1.55-.3,2.36-.38a18.14,18.14,0,0,1,5.93.13c2.1.47,2.49,1.28,1.11,2.31-.82.62-1.75,1.19-2.57,1.81-1.09.82-1.63,1.68-.47,2.65a1,1,0,0,1,.37,1.13c-2.29,1-4.36.18-6.21-.42a10.76,10.76,0,0,1-5-3.3C877.43,489,877.23,488.37,877.84,487.75Z"
            />
            <path
              class="cls-101"
              d="M799.77,495.22c.55.46.34,1,.7,1.53-.8.3.06,1.09-1.09,1.28,0-.73-.48-1-1.84-1.09-5.5-.21-10.6-1.2-14.67-3.43-2.89-1.59-5-3.58-5.72-5.94a1.22,1.22,0,0,1,.33-1.35h1.1a5.54,5.54,0,0,1,3.74,2.34c1.13,1.92,3.64,3.16,6.11,4.42a4.66,4.66,0,0,0,1.64.44c2.61.29,4.95,1.2,7.73,1.1C798.66,494.48,799.06,495,799.77,495.22Z"
            />
            <path
              class="cls-32"
              d="M684.42,486.85c.6-.74,1.25-1.4.91-2.37s1-1.42,2.38-1.71c0,.4.1.85-.57,1.06-1.88.59-1.29,1.35-.55,2.15.26.28.49.57.73.86-.92.33-2,.57-2.18,1.31-.16.14-.31.39-.48.39-.45,0-.16-.25-.28-.38A.85.85,0,0,1,684.42,486.85Z"
            />
            <path
              class="cls-30"
              d="M831.16,481.52c.84.25,1.4.44,2,.59.31.07.82,0,.72.32s-.55.38-1,.29C832.06,482.54,831.23,482.34,831.16,481.52Z"
            />
            <path
              class="cls-29"
              d="M741.31,474.08c.59.25,1.55-.2,1.69.42s-1.53,1.21-2.83,1.17c-.55,0-1.4-.07-1.18-.42A2.66,2.66,0,0,1,741.31,474.08Z"
            />
            <path
              class="cls-102"
              d="M783.7,486c2.08-.25,4.16-.52,5.09-1.86a1.14,1.14,0,0,1,.78-.41,21,21,0,0,1,8,0c2,.48,2.29,1.23.88,2.24-.69.5-1.41,1-2.11,1.47-1.28.91-1.94,1.85-.85,3a1.32,1.32,0,0,1-.16,1.95,3,3,0,0,1-2.3.37c-4.66-.8-8-2.47-9.87-5.14C782.75,487.08,782.71,486.48,783.7,486Z"
            />
            <path
              class="cls-51"
              d="M783.7,486c-.59.75-.28,1.41.32,2.13,1.91,2.27,5.05,3.61,9,4.39a7.14,7.14,0,0,0,2.28-.1,7,7,0,0,0-.31.83c-.07.38.37.57.88.74a1.55,1.55,0,0,0,1.16-.07c1.86-.73,2.09-.67,2.61.64a2.82,2.82,0,0,1,.09.64c-.09,0-.22.15-.26.14-3.18-.84-6.67-1.05-10-1.7-1.66-.33-2.59-1.15-3.86-1.73a8.35,8.35,0,0,1-4-3.56c-.55-1-2.16-1.41-3.13-2.16Z"
            />
          </g>
          <g id="calles">
            <line class="cls-104" x1="684" y1="491" x2="681.15" y2="491" />
            <polygon
              class="cls-104"
              points="1367.5 502.5 712 491 1367.21 491 1367.5 502.5"
            />
            <line class="cls-104" x1="684" y1="491" x2="676.19" y2="492.06" />
            <polyline
              class="cls-104"
              points="712 491 685.83 490.54 684.91 490.52 684.76 490.52 684.74 490.52 684.67 490.52 684.62 490.52 684.58 490.52 684.57 490.52 684.56 490.52 684.55 490.52 684.54 490.52 683.5 490.5 681.15 491"
            />
            <polyline
              class="cls-104"
              points="692.83 491 684.91 490.52 684.76 490.52 684.74 490.52 684.5 490.5 685.83 490.54 700.76 491"
            />
            <polyline
              class="cls-104"
              points="690.39 491 684.76 490.52 684.74 490.52 684.5 490.5 684.62 490.52 684.67 490.52 688.61 491"
            />
            <polyline
              class="cls-104"
              points="687.47 491 684.62 490.52 684.5 490.5 684.54 490.52 684.55 490.52 684.56 490.52 684.57 490.52 684.58 490.52 686.15 491"
            />
            <polyline
              class="cls-104"
              points="684.54 490.52 684.55 490.52 684.56 490.52 684.57 490.52 685.7 491"
            />
            <line
              class="cls-104"
              x1="1353.5"
              y1="768.5"
              x2="1351.09"
              y2="767.5"
            />
            <polyline
              class="cls-104"
              points="685.76 491 684.73 490.59 684.57 490.52 684.56 490.52 684.55 490.52 684.54 490.52 684.5 490.5"
            />
            <polygon
              class="cls-105"
              points="681.15 491 676.19 492.06 676.17 492.06 1.5 583.28 1.5 491 681.15 491"
            />
            <polygon
              class="cls-106"
              points="686.17 490.06 670.7 493.22 670.67 493.23 1.5 605 1.5 583.28 686.17 490.06"
            />
            <polygon
              class="cls-107"
              points="670.67 493.23 1.5 635.5 1.5 605 670.67 493.23"
            />
            <polygon
              class="cls-108"
              points="684.5 491.5 1.5 644.32 1.5 635.5 670.67 493.23 670.7 493.22 683.8 491.03 684.5 491.5"
            />
            <path
              class="cls-109"
              d="M775,470.25c.17,1.16.33,2.32.42,3.48.11.8.22,1.6.32,2.41q.35,3,.7,5.91c.14,1.17.27,2.33.42,3.5l.57,4.67c0,.12,0,.23,0,.34,0,.33.08.66.11,1a1.82,1.82,0,0,1,.12.89c.07.63.06.63.78.77a2.47,2.47,0,0,0,.67.11c-.08-.62-.17-1.23-.24-1.85-.1-.93-.18-1.85-.29-2.78-.15-1.35-.3-2.69-.48-4-.07-.55-.08-1.1-.16-1.65-.24-1.71-.42-3.42-.59-5.14-.09-.84-.22-1.68-.32-2.52s-.25-1.68-.29-2.53c0-.1,0-.21.09-.27s.18.08.27.13c1.82-.06,3.65-.11,5.47-.19.43,0,.54.11.56.46s.09,1,.14,1.52c.25,2.54.49,5.08.74,7.62.29,2.88.57,5.76.86,8.64.12,1.21.25,2.42.38,3.63,0,.22.23.24.4.27a5.85,5.85,0,0,0,1,.16c0-1.12-.16-2.23-.27-3.34-.13-1.4-.24-2.79-.39-4.19-.22-2.07-.37-4.14-.58-6.21-.06-.61-.09-1.21-.15-1.82-.16-1.8-.34-3.6-.51-5.41-.14-1.42-.27-2.84-.4-4.26l-5.28.34-3.79.26C775.21,470.15,775.07,470.13,775,470.25Z"
            />
            <path
              class="cls-110"
              d="M785.28,494.35c-.13-1.21-.26-2.42-.38-3.63-.29-2.88-.57-5.76-.86-8.64-.25-2.54-.49-5.08-.74-7.62,0-.51-.11-1-.14-1.52s-.13-.48-.56-.46c-1.82.08-3.65.13-5.47.19a3.14,3.14,0,0,0,.14,1.1h.18l4.42-.11c.15,0,.32-.07.42.09a.15.15,0,0,1,0,.07.61.61,0,0,1,.07.42l0,.18c0,.15.17.28,0,.44V475a20.79,20.79,0,0,1,.24,2.35c0,.25-.18.21-.35.2a5.09,5.09,0,0,1-1.1,0l-3.54-.06c.09,1.05.2,2.1.36,3.13a12.56,12.56,0,0,1,2,.11h.82a.47.47,0,0,1,.31,0l1.56.07c.12,0,.27,0,.21.17.15.08.1.22.13.34l0,.18.23,2.63,0,.17v.16c.05.52,0,.57-.55.51-.28,0-.55-.07-.83-.09-1.18-.09-2.35-.28-3.54-.3l.28,2.63a.38.38,0,0,1,.32.17s0,0,0,0h.07a.16.16,0,0,1,.21-.12,5.48,5.48,0,0,1,1.21.21h.18a.78.78,0,0,1,.56.07h.18a.3.3,0,0,1,.29.05l.27,0a.28.28,0,0,1,.29.06h.27c.33.05.68-.05,1,.18a.37.37,0,0,1,.1.56v.14l.08.43v.19a5.82,5.82,0,0,1,.16,1.86c.11.07.1.16.08.26v.15c0,.22-.06.28-.28.24l-2.09-.35a13.62,13.62,0,0,0-2.47-.36l.22,2.21c1.51.21,3,.55,4.5.83A8.24,8.24,0,0,0,785.28,494.35Z"
            />
            <path
              class="cls-111"
              d="M784.4,469.55c.13,1.42.26,2.84.4,4.26.17,1.81.35,3.61.51,5.41.06.61.09,1.21.15,1.82.21,2.07.36,4.14.58,6.21.15,1.4.26,2.79.39,4.19.11,1.11.24,2.22.27,3.34.38.05.68-.18,1-.23l1.28-.45c0-.2,0-.4,0-.59q-.18-2-.39-4.08c0-.33.09-.47.46-.43.1-.33.29-.35.83-.11.23,0,.29-.17.51-.33.17,2.11.33,4.15.5,6.19.24.11.39-.18.62-.13l.72-.26c0-.42-.08-.84-.11-1.25-.17-.22-.13-.35.17-.41s.58-.16.87-.24c.15-.27,0-.59.15-.86a2.89,2.89,0,0,0-.05-1.17c0-.92-.06-.92.93-.72.17,0,.35,0,.36.24,0,.64.08,1.29.11,1.94h.05l.27-.06,0-1.86a10.15,10.15,0,0,1-.13-1.45,12.23,12.23,0,0,0-2.09-.29,6.11,6.11,0,0,0-1.86-.15,13.68,13.68,0,0,1-1.44.33,18.64,18.64,0,0,1-2.47-.26c-.2,0-.18-.16-.19-.28-.06-.67-.13-1.33-.19-2,0-.11-.05-.23.08-.31-.07-.78-.14-1.55-.2-2.33-.12-1.35-.24-2.71-.35-4.06a2.36,2.36,0,0,1-.1-1.46v-1c-.15-.09-.1-.23-.11-.35-.1-1.3-.2-2.61-.29-3.91h0c-.17-.12-.07-.29-.09-.43a.24.24,0,0,1,0-.08.2.2,0,0,1-.14-.16c-.06-.56-.11-1.12-.17-1.69,0-.18.12-.19.27-.2l2.4-.12c.43-.09.89.18,1.31-.07-.07-.05-.16-.14-.22-.13a26.73,26.73,0,0,1-3.69,0s-.06.11-.09.11-.08-.08-.09-.14Z"
            />
            <path
              class="cls-112"
              d="M833,492.78l-3.69,3.15a.65.65,0,0,1-.44.22c0,.24-.22.36-.4.5-.54.65-1.32,1.07-1.92,1.66a.86.86,0,0,1-.54.42l-1.32,1.15a.32.32,0,0,0,.24.18l.47.09a.58.58,0,0,1,.48.11,14.57,14.57,0,0,0,2,.31.68.68,0,0,0,.61-.2c1-1.05,2.12-2.08,3.18-3.12.73-.7,1.4-1.46,2.18-2.11l.1-.09a12,12,0,0,1-.08-1.69c0-.39-.14-.7-.67-.67Z"
            />
            <path
              class="cls-113"
              d="M820.64,494.11h.1l1.42-2.75c0-.16.07-.25.26-.24,0-.68,0-1.36,0-2,0-.14,0-.31.21-.32s.15.2.16.32c.09.63-.15,1.27,0,1.9l.15-.16c0-.08.13-.09.21-.11.3-.6.6-1.2.91-1.79.18-.34.41-.37.78-.11l.37.18c-.14-.29,0-.58,0-.87,0-.09,0-.22.15-.21s.12.14.13.23l0,1.1c0,.17,0,.33,0,.5s0,.34-.26.36c0,.4-.07.8-.1,1.21,0,.15.12.13.23.13l.16-.09,0-.18c.12-.23.41-.35.4-.7,0-.9,0-1.8.06-2.7a15.6,15.6,0,0,0-2.16-.18c.18.28,0,.38-.26.48l-2.41,1.15c-1.18.55-2.32,1.18-3.54,1.65-.82,0-1.61-.22-2.43-.21l.1.32,1.41.15c.13,0,.25,0,.27.18.51.16.83.43.79,1s.06,1.27,0,1.9Z"
            />
            <path
              class="cls-111"
              d="M837.26,472.22c0-.87.09-1.74.15-2.6,0-.28-.08-.36-.36-.39-.91-.09-1.81-.22-2.71-.34l-.27,0a19.54,19.54,0,0,1,0,2.42q-.07,1.35-.12,2.7c0,1.48-.18,3-.21,4.44s-.14,2.79-.2,4.19a.78.78,0,0,0,.46.23c0-.19,0-.39,0-.59l.33-7.13c.05-1.13.09-2.25.14-3.38,0-.72,0-.72.74-.71a4.7,4.7,0,0,0,.65,0c.35,0,.48.09.45.4l.28-.11c.08,1.49-.18,3-.18,4.44,0,.82-.07,1.63-.11,2.45-.08,1.4-.17,2.79-.24,4.19,0,1,0,2-.13,3-.13,1.34-.14,2.68-.22,4a1.31,1.31,0,0,0,.72-1.54l.12-2.23c.06-1.1.11-2.2.17-3.3C836.88,479,837.07,475.61,837.26,472.22Z"
            />
            <path
              class="cls-109"
              d="M836.29,471.48l0,.28c0,.19.09.39-.18.49l0,.19a1.69,1.69,0,0,1-.06,1c.09.55-.11,1.09,0,1.64a.39.39,0,0,1-.09.32.65.65,0,0,1,.12.52,15.35,15.35,0,0,0,0,1.79c0,.61-.46,1.1-.38,1.7l0,.59c.06.65-.11,1.29,0,1.94h0c.06,0,.14,0,.14.09a20.94,20.94,0,0,1-.12,2.44.64.64,0,0,1-.14-.53q0-.62,0-1.23c0-.09,0-.22-.15-.21s-.12.12-.12.2,0,.4,0,.59-.12.43-.45.3a1,1,0,0,1,.31,1.19v.26a23.36,23.36,0,0,1-.18,2.89,2.26,2.26,0,0,1,0,.26c0,.71-.1,1.42-.11,2.13a4.83,4.83,0,0,0,0,.76c0,.23-.08.34-.27.42.25.13.22.36.2.56a14.12,14.12,0,0,0-.1,2.43c-.2.66,0,1.37-.28,2.16a11.57,11.57,0,0,0-.21-1.8c-.11,0-.15.11-.22.17l-.1.09a7.81,7.81,0,0,1,.14,1.74l.09.84c.12,0,.31-.17.34,0s.07.47-.31.49c-.26.29-.08.73-.38,1,.4.42-.22.65-.23,1a7.2,7.2,0,0,1,1.38.37c.12,0,.24.07.33-.05a1.49,1.49,0,0,1-.12-.66c-.14,0-.14-.11-.13-.22,0-.38.07-.75.1-1.13-.21-.27-.08-.58-.12-.86s0-.74.07-1.11c0-.2,0-.4,0-.6a.1.1,0,0,1,0-.17,11.7,11.7,0,0,1,.13-2.05,14.34,14.34,0,0,1,.09-2.93c0-1,0-2.05.07-3.19a.85.85,0,0,1,.13.69c0,.3,0,.59,0,.89s.05.31.29.26c.08-1.34.09-2.68.22-4,.1-1,.08-2,.13-3,.07-1.4.16-2.79.24-4.19,0-.82.12-1.63.11-2.45,0-1.48.26-2.95.18-4.44Zm-2,25.84a.15.15,0,0,1,0-.07s.08,0,.09,0,0,.06,0,.09S834.27,497.36,834.27,497.32Zm-.12,1.59c.2,0,.33,0,.45.08C834.43,499.07,834.33,499,834.15,498.91Z"
            />
            <path
              class="cls-112"
              d="M834.91,497.68c0,.28-.09.59.12.86.19,0,.34,0,.36.24a3.73,3.73,0,0,1-.23.93v.1a.25.25,0,0,0,0,.08c.18,0,.43,0,.42.19a.45.45,0,0,1-.4.47.24.24,0,0,1-.33.05,6.54,6.54,0,0,0-1.38-.37c0-.36.64-.59.23-1l-.21.13-.29.33a10.21,10.21,0,0,1-.89,1.08c-.13.17-.43.34-.33.51a.85.85,0,0,0,.64.28c1,0,1.9.34,2.86.42a.52.52,0,0,0,.57-.24c.9-1.26,1.82-2.51,2.74-3.75.17-.23.12-.34-.15-.45a6.86,6.86,0,0,0-1.42-.35,2.55,2.55,0,0,1-.73-.06c-.52-.09-1-.09-1.32.4A.3.3,0,0,1,834.91,497.68Z"
            />
            <path
              class="cls-109"
              d="M799.43,495.86l.52,0c0-2.33-.23-4.66-.32-7a4.55,4.55,0,0,0-.21-1.71.42.42,0,0,0-.46.28c.07,0,.09.1,0,.16l-.08.09c0,.08,0,.16-.08.23-.42.38-.86.17-1.31.06h0c-.16,0-.34,0-.47-.08s-.56.06-.55-.05c0-.28-.06-.19-.21-.1a1.31,1.31,0,0,1-.85.07c-.31,0-.61-.08-.91-.13h-.17c-.79-.09-1.59-.16-2.37-.28a16.41,16.41,0,0,1-2.22-.27.41.41,0,0,0,.16.72,7.55,7.55,0,0,1,1,.17,6.11,6.11,0,0,1,1.86.15,12.23,12.23,0,0,1,2.09.29c1.33,0,2.63.29,4,.42.18,0,.24.1.22.25s0,.45,0,.67a12.9,12.9,0,0,1,.15,2.4l.1,1.67a.29.29,0,0,1,0,.3l0,.39,0,.08c-.07.1,0,.19,0,.29Z"
            />
            <path
              class="cls-114"
              d="M815.36,491c0-.1-.07-.21-.1-.32a5.29,5.29,0,0,0-1.32-.15,12.54,12.54,0,0,1,1.16,1.34,7.22,7.22,0,0,1-3.07,0c.19,1.19.07,1.34-1.08,1.31h0c-.24,0-.34-.09-.34-.3,0-.41,0-.82,0-1.23a4,4,0,0,0-1.69,0c0,.84,0,1.69.08,2.53,0,.17,0,.35.2.43h.29a5.41,5.41,0,0,1,1.15-1.14.5.5,0,0,1,.43-.07l4.36.64C815.44,493,815.35,492,815.36,491Z"
            />
            <path
              class="cls-110"
              d="M815.36,491c0,1,.08,2,0,3v.26c0,.68.07,1.36,0,2.05v.84c0,.17,0,.34,0,.52s0,.21,0,.31l.09.11c.14,0,.27-.14.42,0l.19,0,.84.15.1-.2c-.1-2.24-.08-4.49,0-6.73,0-.15-.14-.17-.27-.18Z"
            />
            <path
              class="cls-115"
              d="M804.79,495.86a4.19,4.19,0,0,0,1.25-.47,2.72,2.72,0,0,1,.8-.28,8.77,8.77,0,0,1-.11-2.1,16.36,16.36,0,0,0,.07-2,12.42,12.42,0,0,0-2.23-1.16c0,.11,0,.23,0,.34C804.62,492.1,804.71,494,804.79,495.86Z"
            />
            <path
              class="cls-112"
              d="M835.24,490.82a14.34,14.34,0,0,0-.09,2.93c.66-.52,1.21-1.13,1.81-1.7l1.94-1.88c.17-.17.33-.34.48-.52s.25-.17.16-.32-.25-.08-.39-.09a5.83,5.83,0,0,1-.83-.08,1.88,1.88,0,0,0-1.85.63A6.79,6.79,0,0,1,835.24,490.82Z"
            />
            <path
              class="cls-110"
              d="M806.8,491a16.36,16.36,0,0,1-.07,2,8.77,8.77,0,0,0,.11,2.1,10.64,10.64,0,0,1,1.69-.17c.3,0,.49-.12.59-.38-.23-.08-.19-.26-.2-.43,0-.84-.06-1.69-.08-2.53h0Z"
            />
            <path
              class="cls-111"
              d="M778,480.65c-.16-1-.27-2.08-.36-3.13l-.3-2.81a1.45,1.45,0,0,1-.1-.77v-.17a3.14,3.14,0,0,1-.14-1.1c-.09-.05-.14-.18-.27-.13s-.09.17-.09.27c0,.85.18,1.69.29,2.53s.23,1.68.32,2.52c.17,1.72.35,3.43.59,5.14.08.55.09,1.1.16,1.65.18,1.35.33,2.69.48,4,.11.93.19,1.85.29,2.78.07.62.16,1.23.24,1.85h.32l-.22-2.21v-.34a8.52,8.52,0,0,1-.23-1.95l0-.17a2.53,2.53,0,0,1-.11-1v-.17a.14.14,0,0,1-.08-.18l-.28-2.63Z"
            />
            <path
              class="cls-110"
              d="M824.88,488.8c-.37-.26-.6-.23-.78.11-.31.59-.61,1.19-.91,1.79,0,.88,0,1.75,0,2.63a.81.81,0,0,0,.09.53l1.45.14Z"
            />
            <path
              class="cls-112"
              d="M841.25,490.73l.17,2.09a9.25,9.25,0,0,0-1.39-.16c-.3,0-.38-.11-.16-.36Z"
            />
            <path
              class="cls-109"
              d="M827.27,491.82a13.2,13.2,0,0,1,0,1.78c0,.85,0,.85,1,.84,0-.88.08-1.75.11-2.62,0-1.06.07-2.11.09-3.17,0-.18,0-.39-.25-.42a1.8,1.8,0,0,0-.73-.05Z"
            />
            <path
              class="cls-110"
              d="M804.79,495.86c-.08-1.88-.17-3.76-.25-5.64,0-.11,0-.23,0-.34-.22-.26-.32-.16-.35.1a5.35,5.35,0,0,0-.05.55c0,.64,0,1.29.05,1.94,0,.45.07.9.07,1.35,0,.15.15.46-.2.39s-.79.13-.81-.4c0-1-.07-1.95-.1-2.92l0-.17-.35-.09c0,1.67.09,3.33.17,5A7.44,7.44,0,0,0,804.79,495.86Z"
            />
            <path
              class="cls-113"
              d="M828.48,493.58c.28-.33.11-.77.32-1.12a2.65,2.65,0,0,1,.06-.74c0-.17.12-.19.28-.13v-.15l-.19-.24a2.93,2.93,0,0,1,0-1.85c.11-.06.26-.36.27,0s.15.1.25.08c.17-.19.12-.52.45-.61l.12-.3c-.1-.76.06-1.51,0-2.26h-.21a2.27,2.27,0,0,0-.75.32c-.09,0-.24.14-.28.12-.27-.18-.2,0-.2.14,0,1.21-.12,2.42-.13,3.63A28.77,28.77,0,0,0,828.48,493.58Z"
            />
            <path
              class="cls-115"
              d="M817,491.3c-.06,2.24-.08,4.49,0,6.73a2,2,0,0,1,.73-.1l.56-.12c-.2-.14-.51.06-.56-.24a7.74,7.74,0,0,0,0-1.8c0-.53.21-1.06,0-1.58.09-.63,0-1.27,0-1.9S817.55,491.46,817,491.3Z"
            />
            <path
              class="cls-115"
              d="M803,495.63c-.08-1.67-.17-3.33-.17-5-.35-.06-.56-.39-.93-.42,0,1.91.19,3.81.25,5.71C802.45,495.93,802.65,495.65,803,495.63Z"
            />
            <path
              class="cls-116"
              d="M815.36,494.24V494l-4.36-.64a.5.5,0,0,0-.43.07,5.41,5.41,0,0,0-1.15,1.14,17.33,17.33,0,0,0,3.22-.08c.14,0,.21-.09.3-.18a1.16,1.16,0,0,1,.86,0C814.32,494.34,814.84,494.21,815.36,494.24Z"
            />
            <path
              class="cls-111"
              d="M828.48,493.58a28.77,28.77,0,0,1,0-3.08c0-1.21.08-2.42.13-3.63,0-.12-.07-.32.2-.14,0,0,.19-.08.28-.12a2.27,2.27,0,0,1,.75-.32,1.29,1.29,0,0,1,.8-.41c.33-.41.29-.63-.13-.68,0,.12-.11.18-.23.24l-1.62.79c-.09-.06,0-.21-.18-.25a9.11,9.11,0,0,0,0,1.65c0,.14.09.35-.16.39s-.42.09-.57-.06,0-.29.12-.41A.9.9,0,0,0,828,487c0-.19-.06-.31-.3-.28-.21.35-.55.25-.89.24s-.92-.21-1.32.14a2.52,2.52,0,0,0,.82.08c.67,0,.68,0,.66.6.45-.14.45-.14.46.42a1.8,1.8,0,0,1,.73.05c.28,0,.26.24.25.42,0,1.06,0,2.11-.09,3.17,0,.87-.07,1.74-.11,2.62.32-.07.15-.35.25-.51a.18.18,0,0,1,0-.27A.24.24,0,0,1,828.48,493.58Z"
            />
            <path
              class="cls-109"
              d="M817.8,494.19c.23.52,0,1.05,0,1.58a7.74,7.74,0,0,1,0,1.8,2,2,0,0,0,.57-.87c.35-.64.72-1.26,1.1-1.88a.21.21,0,0,1,.25-.19,1.37,1.37,0,0,0,.72-.2c.07-.1.23-.16.21-.32Z"
            />
            <path
              class="cls-113"
              d="M827.42,488.18c0-.56,0-.56-.46-.42-.24.13-.48-.07-.72,0l0,.09c.29,0,.26.17.28.34a20.8,20.8,0,0,1,0,2.62,1.42,1.42,0,0,1-.13.78l0,.17.89.07Z"
            />
            <path
              class="cls-110"
              d="M822.16,491.35l-1.42,2.75c.39.26.86.18,1.29.29.24.06.21-.18.24-.32,0-.46,0-.91.05-1.37l0-.25C822.19,492.09,822.4,491.69,822.16,491.35Z"
            />
            <path
              class="cls-110"
              d="M802.12,495.92c-.06-1.9-.28-3.8-.25-5.71-.37-.28-.42-.1-.41.23.09,1.83.17,3.67.25,5.5l.06.07C801.88,496,802,496,802.12,495.92Z"
            />
            <path
              class="cls-115"
              d="M824.88,488.8l-.15,5.2c.61.08.35-.39.47-.62a4.22,4.22,0,0,1,0-.94c-.1-.37.25-.66.21-1-.11,0-.24,0-.23-.13,0-.41.06-.81.1-1.22-.15-.28,0-.57,0-.85l0-.25Z"
            />
            <path
              class="cls-113"
              d="M795.64,495l.11-.11a.36.36,0,0,0,.08-.47c-.06-.1-.18-.23,0-.3s.3-.18.42-.09a.26.26,0,0,1,0,.38c0,.06,0,.16-.06.25.23.06.46.12.53-.19a2,2,0,0,1,.07-1.38c-.06-.28,0-.58-.12-.85-.15.14-.09.32-.09.49s-.05.3-.24.3-.08-.2-.12-.29.1-.19-.07-.26c-.12.2.08.66-.31.58s-.25.15-.36.23a.51.51,0,0,1-.17.07v.28c.15,0,.16.13.18.25C795.56,494.23,795.6,494.6,795.64,495Z"
            />
            <path
              class="cls-117"
              d="M795.64,495c0-.37-.08-.74-.11-1.11,0-.12,0-.22-.18-.25a.39.39,0,0,1-.34.09l-2.06-.32a.34.34,0,0,1-.25-.18h-.09l-.14,0c-.14,0-.18-.2-.34-.1,0,.41.07.83.11,1.25h.25c0-.75,0-.75.72-.52a14.19,14.19,0,0,1,1.94.29c.17,0,.23.12.2.27s0,.38,0,.57l.16,0Z"
            />
            <path
              class="cls-115"
              d="M822.32,492.7c0,.46,0,.91-.05,1.37a1.6,1.6,0,0,0,1-.21.81.81,0,0,1-.09-.53c0-.88,0-1.75,0-2.63-.08,0-.17,0-.21.11s.09.13.08.19c0,.58,0,1.16,0,1.73,0,.14-.07.21-.22.22S822.48,492.78,822.32,492.7Z"
            />
            <path
              class="cls-109"
              d="M796.84,494.43l.73.13V494q-.33-.45.27-.54a.54.54,0,0,0,.36-.16l-1.1-.16a.48.48,0,0,0-.27.52A6.6,6.6,0,0,1,796.84,494.43Z"
            />
            <path
              class="cls-117"
              d="M797.56,494v.56c.08.24-.06.52.18.73a.59.59,0,0,0,0-.41c-.06-.33.06-.43.42-.34s.7.11,1,.16l.07-.08,0-.39a2.39,2.39,0,0,1-1.37-.17C797.79,494.16,797.73,493.76,797.56,494Z"
            />
            <path
              class="cls-113"
              d="M799.3,494.71h.05c-.07.1,0,.19,0,.29a1.36,1.36,0,0,0-1.43.28.12.12,0,0,1-.16,0,.59.59,0,0,0,0-.41c-.06-.33.06-.43.42-.34s.7.11,1,.16Zm-1.23.22c.09,0,.19-.05.19-.15s-.09-.07-.15-.08-.13.05-.13.12S798,495,798.07,494.93Z"
            />
            <path
              class="cls-113"
              d="M795.35,494.39c0-.15,0-.24-.2-.27a14.19,14.19,0,0,0-1.94-.29l0,.16A17.63,17.63,0,0,0,795.35,494.39Z"
            />
            <path
              class="cls-117"
              d="M826.38,491.75l0-.17a.82.82,0,0,1-.49-.49c-.09,0-.16.11-.27.07l0,.18s0,0,0,0C825.68,492.14,825.68,492.14,826.38,491.75Z"
            />
            <path
              class="cls-118"
              d="M796.22,494.63c0-.09,0-.19.06-.25a.26.26,0,0,0,0-.38c-.12-.09-.28,0-.42.09s-.1.2,0,.3a.36.36,0,0,1-.08.47C796,494.89,796.08,494.73,796.22,494.63Z"
            />
            <path
              class="cls-118"
              d="M793.18,494l0-.16c-.77-.23-.77-.23-.72.52Z"
            />
            <path
              class="cls-113"
              d="M829.15,491.69l.84.22c.55,0,1,.25,1.58.24l0,0A7,7,0,0,0,829.15,491.69Z"
            />
            <path
              class="cls-109"
              d="M801.77,496l-.06-.07c-.24,0-.48,0-.65-.18a.4.4,0,0,1-.35.1V496l.39.13C801.35,496.25,801.55,496.09,801.77,496Z"
            />
            <path
              class="cls-111"
              d="M796.84,494.43a6.6,6.6,0,0,0,0-.77.48.48,0,0,1,.27-.52l0-.05-.23,0a2,2,0,0,0-.07,1.38Z"
            />
            <path
              class="cls-109"
              d="M825.21,492.44a4.22,4.22,0,0,0,0,.94c.09-.26.2-.51.28-.77S825.39,492.38,825.21,492.44Z"
            />
            <path
              class="cls-113"
              d="M834.08,498.21c.38,0,.33-.32.31-.49s-.22,0-.34,0C834,497.89,833.92,498.06,834.08,498.21Z"
            />
            <path
              class="cls-113"
              d="M831.57,492.15a5.37,5.37,0,0,0,1.31.4l0,0a2.9,2.9,0,0,0-1.32-.39Z"
            />
            <path
              class="cls-117"
              d="M813.79,494.28a1.16,1.16,0,0,0-.86,0A1,1,0,0,0,813.79,494.28Z"
            />
            <path
              class="cls-113"
              d="M833,492.78l.18-.09.09-.08v-.08l-.36,0,0,0Z"
            />
            <path class="cls-113" d="M828.46,493.66a.18.18,0,0,0,0,.27Z" />
            <path
              class="cls-110"
              d="M812.18,490.28a12,12,0,0,0-1.69-.19,11.83,11.83,0,0,0-1.69-.21l-4.49-.54c-.61-.07-.61-.06-.46-.61s.08-.75-.58-.78a7.89,7.89,0,0,0-2.27-.17.52.52,0,0,0-.18,0c-.42.19-.59.09-.55-.35,0-.29-.3-.38-.85-.26a.42.42,0,0,0-.46.28v.16l-.08.09c-.09,0-.22.08-.25,0-.21-.59-.67-.3-1.06-.27-.13,0-.21.16-.37.14-.16-.43-.53-.42-.92-.34-.16,0-.32.08-.49.13,0-.23-.14-.3-.39-.26s-.29,0-.44,0l-.67.1c0-.16,0-.28-.26-.3a1.88,1.88,0,0,0-.94.14c-.18-.32-.49-.32-.81-.28l-.49.08c0-.41,0-.81,0-1.22a.39.39,0,0,0-.18-.4c-.08-2-.28-4-.47-6a.34.34,0,0,0,.08-.32,3.08,3.08,0,0,0-.18-1.47c-.12-1.58-.24-3.15-.37-4.73,0-.21,0-.42-.06-.63a.53.53,0,0,0,0-.33,11.91,11.91,0,0,0-.17-2c0-.6,0-.62.8-.67,1.15-.08,2.31-.11,3.47-.2.84-.06,1.69-.09,2.54-.15,2-.15,3.93-.29,5.91-.37,0,.9.07,1.81.1,2.71.12,3,.22,6,.37,9,.09,2,.19,4,.25,5.94,0,.23,0,.5.38.4a6.33,6.33,0,0,0,1.62.22c1.85.19,3.71.35,5.56.52l6.25.57v3c-.82,0-1.61-.22-2.43-.21a5.29,5.29,0,0,0-1.32-.15A9.41,9.41,0,0,0,812.18,490.28Zm-12.24-10.74-4.64-.15a.22.22,0,0,0-.2.08h-.53c-.28-.28-.64-.15-1-.12a1.3,1.3,0,0,1-.62,0l.09,3.07c0,.41.07.82.09,1.23,0,.25.13.33.38.28a7.8,7.8,0,0,0,1.74.19c1.58.14,3.17.23,4.75.37.35,0,.35-.07.22-.3.2-.3,0-.62.06-.94l0-.26c0-.7,0-1.41-.07-2.11v-.11c.08-.18,0-.33-.09-.49v-.18l0-.44C800.12,479.58,800,479.54,799.94,479.54Zm-7.25-3.33c0,.29.24.24.44.2,1.44,0,2.88.07,4.31,0,.73,0,1.46.08,2.18,0,.15,0,.37.06.39-.19,0-1.11-.14-2.2-.17-3.3v-.43l0-.7c0-.21,0-.31-.3-.3l-5.57.22-1.29.08c-.13,0-.26,0-.23.19C792.51,473.43,792.6,474.82,792.69,476.21Z"
            />
            <path
              class="cls-109"
              d="M821.88,473.66c0,1.13,0,2.26,0,3.39q0,4-.07,8c-1.39,0-2.77-.17-4.15-.25-2.19-.14-4.37-.3-6.56-.45.07-4.89-.29-9.78-.24-14.68l3.52-.2,7.55-.38C821.89,470.6,821.89,472.13,821.88,473.66Zm-7.16-1.05v-.33a2.73,2.73,0,0,0-1.36,0h-.12a9.89,9.89,0,0,0,.12,2.17l.06,1.57c0,.1,0,.25.15.26a6.25,6.25,0,0,0,1.06,0c.24,0,.11-.24.09-.38a1.59,1.59,0,0,0,0-.78v-.19l0-1.78v-.43A.06.06,0,0,0,814.72,472.61Zm-1.18,10.95a.3.3,0,0,0,0,.4c0,.15.07.24.24.24l.46,0c.62,0,.62,0,.61-.54l0-1.27a20.42,20.42,0,0,0,0-2.07c0-.18-.1-.24-.28-.25-.36,0-.71,0-1.06,0a.3.3,0,0,0-.13.34,5.62,5.62,0,0,0,.12,1.53v.19a.44.44,0,0,0,0,.49l0,.61q-.1.09,0,.15Z"
            />
            <path
              class="cls-111"
              d="M807.17,485.39a3.79,3.79,0,0,0-.89.33h-.09c-.73.09-.75.09-.75-.59,0-1.88-.14-3.76-.2-5.64l0-1.35q-.16-4.38-.32-8.76l6,.28c-.05,4.9.31,9.79.24,14.68Zm2.48-5.22c-.22,0-.46,0-.45.35,0,1.18.07,2.37.11,3.56,0,.14,0,.35.27.24s.47,0,.46-.33c0-1.17,0-2.34-.11-3.51C809.92,480.31,810,480.11,809.65,480.17Zm.43-4.09c0-1.25-.08-2.5-.11-3.75l-.26.22c-.06-.18.1-.49-.34-.47-.24,0-.36.07-.35.33,0,1.17,0,2.35,0,3.52,0,.38.07.6.55.48a1.64,1.64,0,0,1,.23,0C810.05,476.4,810.08,476.26,810.08,476.08Z"
            />
            <path
              class="cls-115"
              d="M828.89,471.15c-.13,0-.38.12-.37-.16a9.08,9.08,0,0,1,.07-1.73.42.42,0,0,1,0-.1s-.07,0-.07-.06c0-.54-.34-.65-.85-.69-1.24-.1-2.48-.24-3.72-.37l-.06,3.78c0,2.74-.09,5.48-.13,8.21l-.06,5.06c0,.18,0,.35-.24.39a5.84,5.84,0,0,1-1.49.66c-1.43.6-2.88,1.16-4.33,1.73,0,1,0,2,0,3,1.22-.47,2.36-1.1,3.54-1.65l2.41-1.15c.21-.1.44-.2.26-.48s-.28-.51.07-.73a3.89,3.89,0,0,1,1.5-.52,1.79,1.79,0,0,1,.87-.51,3.92,3.92,0,0,1,1.71-.62c0-.34-.14-.68.14-1,0-.88,0-1.75,0-2.62l-.66,0a2.29,2.29,0,0,1-.11,1c-.15-.23,0-.47-.08-.7s0-.25.19-.27c-.46-.27-.33.22-.51.33a.9.9,0,0,0-.06.49c0,.14,0,.21-.18.22a1.36,1.36,0,0,0-.51.18c-.15.15-.31,0-.46,0-.09.25-.33.24-.54.28h-.19l-.08.05h0a4.78,4.78,0,0,1,0-1.31h.12l.16-.11a.66.66,0,0,0-.5-.16c-.15,0-.35,0-.34-.19s.18-.24.36-.23.4,0,.39-.26c-.08,0-.23,0-.2-.1s.73-.52,1-.49l.35-.1a.64.64,0,0,1,.65-.2h.1c.08-.11.16-.25.27,0h.09c0-.22,0-.45,0-.68-.16,0-.36,0-.48,0a4.72,4.72,0,0,1-1.7.42c-.09,0-.2.14-.25,0s0-.23.15-.26a10.91,10.91,0,0,1,2.34-.47.65.65,0,0,1,.08.45c0,.64,0,1.27-.05,1.91a.17.17,0,0,1,0,.07h.75c-.08-1,0-2,.05-3a8.55,8.55,0,0,1,.08-2.26c-.07-1.51.16-3,.06-4.54,0-.3.19-.34.45-.34l2.69-.07v-.08Zm-1.16,3.91c0,.11,0,.2-.17.21a.19.19,0,0,1-.28,0h-.36a.83.83,0,0,1-.56,0c-.14.06-.33-.09-.44.09l-.59.11c-.3.06-.19-.17-.18-.25a14.71,14.71,0,0,0,0-2,.41.41,0,0,1,.19-.4.54.54,0,0,1,.64,0c.15.18.27.07.39,0a.56.56,0,0,1,.63,0h.15c.07-.09.14-.11.22,0l.17,0c0-.22,0-.45,0-.68l-2,0c-.2,0-.4,0-.38-.29s.18-.29.4-.29c.66,0,1.32.08,2,0a.31.31,0,0,1,.24.1s.08.1.07.15C827.79,472.93,827.76,474,827.73,475.06Zm-2.27-2.59c0-.13.14-.12.25-.13s.21,0,.23.1-.12.14-.22.15S825.5,472.6,825.46,472.47Zm1,0c0-.12.07-.14.17-.15s.23,0,.27.07-.08.16-.18.17S826.54,472.59,826.49,472.47Z"
            />
            <path
              class="cls-110"
              d="M823.5,485.48c.25,0,.24-.21.24-.39l.06-5.06q.06-4.09.13-8.21L824,468a5.23,5.23,0,0,0-1.89.13c-.16,0-.15.16-.15.27l-.06.63c0,1.53,0,3.06,0,4.59,0,1.13,0,2.26,0,3.39q0,4-.07,8c0,.22.15.27.36.3A12.75,12.75,0,0,1,823.5,485.48Z"
            />
            <path
              class="cls-115"
              d="M806.28,485.72h-.09c-.73.09-.75.09-.75-.59,0-1.88-.14-3.76-.2-5.64a2.69,2.69,0,0,1,0-1.35q-.16-4.38-.32-8.76a1.3,1.3,0,0,1,0-.34c0-.39-.15-.53-.57-.52a8.69,8.69,0,0,0-1.14,0c0,.9.07,1.81.1,2.71.12,3,.22,6,.37,9,.09,2,.19,4,.25,5.94,0,.23,0,.5.38.4a2.38,2.38,0,0,1,.9-.29A2.45,2.45,0,0,0,806.28,485.72Z"
            />
            <path
              class="cls-109"
              d="M827.55,481.58l.66,0a5.5,5.5,0,0,1,1.21.16l.64,0,.21.06.28.06c.18.08.45,0,.51.27l0,0,0,0c.11-.11.17,0,.23,0a1.44,1.44,0,0,1,.65.11.06.06,0,0,1,.06,0,.47.47,0,0,1,.55,0c.31.14.64.26,1,.4.06-1.4.16-2.79.2-4.19s.16-3,.21-4.44q0-1.35.12-2.7a19.54,19.54,0,0,0,0-2.42l-5.44.25,0,.1c1,0,2.1-.15,3.15-.12.26,0,.52.05.78.05s.36.13.34.37c0,.42,0,.84-.05,1.26,0,.12,0,.23-.15.28,0,.21-.07.43-.1.65.17.34,0,.69,0,1-.12,1.68,0,3.36,0,5,0,.19,0,.41-.25.51a.64.64,0,0,0-.08.43l-.08.09h0a.66.66,0,0,1,0,.37l-.09,2.45c0,.5-.06.51-.55.27a.34.34,0,0,1-.26,0l-.19,0-.18-.06-.19,0-.12-.05-.25-.09-.28,0a11.83,11.83,0,0,1-1.68-.19h-.85c-.15,0-.32,0-.41-.12H827c0,.19-.13.1-.22.07l-.18,0v.16l.2,0c.41-.05.16.24.22.37.18-.11.05-.6.51-.33Z"
            />
            <path
              class="cls-117"
              d="M790.6,471.83a11.91,11.91,0,0,0-.17-2,2.53,2.53,0,0,0-1.28-.13c-.42.25-.88,0-1.31.07,0,.7.19,1.38.15,2.08l.1,0Z"
            />
            <path
              class="cls-109"
              d="M785.06,469.56c0,.06,0,.14.09.14s.06-.07.09-.11Z"
            />
            <path
              class="cls-117"
              d="M780.07,480.76c.18.15.55.1.53.45,0,.07.13.13.23.1s.1-.13.06-.21-.15-.22,0-.33a.47.47,0,0,1,.31,0c.18.27.52,0,.73.17-.21,0-.43,0-.64,0s-.25.18-.09.26a1.46,1.46,0,0,0,1,.07c.1,0,.05-.18,0-.27a.66.66,0,0,1,.65,0c-.16,0-.43-.08-.42.18s.27.15.43.17h.23l0,.18H783c-.17,0-.42-.09-.48.11s.29.09.35.28c-.29,0-.36.09-.31.38.1.64.11,1.29.17,1.93,0,.18-.1.42.18.52s.29-.21.47-.26c.05.52,0,.57-.55.51-.28,0-.55-.07-.83-.09-1.18-.09-2.35-.28-3.54-.3l-.46-4A12.56,12.56,0,0,1,780.07,480.76Zm1.15,1.48a17.87,17.87,0,0,1,.17,2.07c0,.1,0,.22.16.22s.09-.13.13-.19.11-.13.17-.2c.29.06.13.31.26.54,0-.24,0-.49.29-.47.13,0,.11-.11.1-.19-.06-.59-.08-1.18-.17-1.77-.06-.39-.45-.28-.73-.31S781.18,482,781.22,482.24Zm-1.68,2c0,.18.12.22.26.24s.55.06.82.08.2-.06.18-.18a17.24,17.24,0,0,1-.24-2.15c0-.14,0-.35-.27-.34s-.57-.16-.86,0c-.1,0-.07.15,0,.23A19.24,19.24,0,0,1,779.54,484.25Zm-.79-.16c.06.32.25.31.48.31s.11-.23.11-.34c0-.62-.1-1.24-.16-1.86,0-.15,0-.32-.18-.4a.41.41,0,0,0-.36,0c-.21.11-.09.3-.12.49A17.39,17.39,0,0,1,778.75,484.09Zm2.29-1.9c0-.13-.06-.32-.26-.28s0,.21,0,.33a10.38,10.38,0,0,1,.16,1.76,1.48,1.48,0,0,0,.07.42c0,.1,0,.25.22.21a.11.11,0,0,0,.09-.15C781.19,483.65,781.12,482.92,781,482.19Zm-.62-1.07c0-.24-.24-.15-.39-.17a5.17,5.17,0,0,0-.55-.07c-.1,0-.24,0-.26.11s.06.21.21.24l.55.08C780.18,481.26,780.42,481.36,780.42,481.12Zm.78.51c0,.23.32.13.5.14s.56.14.56-.15-.36-.06-.55-.13S781.2,481.42,781.2,481.63Zm-.79,0c0-.21-.22-.12-.35-.14a5.14,5.14,0,0,0-.55-.06c-.09,0-.2,0-.22.1s.08.13.18.15l.57.08C780.19,481.69,780.4,481.77,780.41,481.6Zm-1.4,0a.09.09,0,0,0,0-.15.64.64,0,0,0-.59.06C778.67,481.62,778.83,481.72,779,481.6Zm3.56,3a.27.27,0,0,0-.08-.07.36.36,0,0,0,0,.1s0,0,.07,0S782.58,484.6,782.57,484.59Z"
            />
            <path
              class="cls-117"
              d="M779.1,487.45s0,0,0,0-.07.41.2.5.36.12.43-.09,0-.33-.24-.37l-.32,0a.16.16,0,0,1,.21-.12,5.48,5.48,0,0,1,1.21.21c-.13.15-.29,0-.43,0s-.3,0-.3.23.05.27.26.28a5.63,5.63,0,0,1,.59.05c.18,0,.36,0,.42-.17s-.1-.23-.25-.27-.07-.09-.11-.13a.78.78,0,0,1,.56.07c-.08.19-.15.38,0,.55a.16.16,0,0,0,.21,0c.14-.18,0-.35-.05-.52a.3.3,0,0,1,.29.05c-.08.19-.18.43,0,.53a1,1,0,0,0,.88.09c.29-.16,0-.36-.1-.53.33.05.68-.05,1,.18l-.27,0c-.16,0-.3,0-.3.23s.13.19.28.21l.39.09v.14l-.27,0c-.13,0-.31-.1-.35.08s.09.28.3.3.27.05.4.07v.19c-.21,0-.43-.06-.62.07s-.19-.22-.38-.15a.69.69,0,0,0-.47-.06l-.28-.08c-.11,0-.19.08-.17.17.18.63,0,1.29.24,1.91,0,0,.05.07.08.1.25,0,.54.29.75-.08h0c.25,0,.25-.11.21-.3a2.9,2.9,0,0,1,0-1.21c0,.37.11.74.13,1.11,0,.66,0,.67.75.79,0,.22-.06.28-.28.24l-2.09-.35a13.62,13.62,0,0,0-2.47-.36v-.34c.18-.18.07-.39.08-.59s0-.31.09-.43l0,.59c0,.2-.08.46.29.5s.39-.08.37-.33l-.15-1.5c0-.22-.18-.27-.38-.28s-.27.08-.26.25,0,.38,0,.63c-.24-.28.06-.63-.31-.79l0-.17c.12-.35.23-.71-.11-1v-.17Zm2.24,1.76c0-.23-.15-.27-.36-.28s-.58-.06-.87-.09l0,.75a2.94,2.94,0,0,0,.1.88c.06.17-.08.42.16.49a2.86,2.86,0,0,0,1,.13c.24,0,0-.27.14-.39A5.82,5.82,0,0,1,781.34,489.21Zm-1.78-1c-.13,0-.31,0-.35.12s.13.21.27.21a10.87,10.87,0,0,1,1.41.19c.12,0,.27.06.31-.09s-.1-.22-.24-.24-.48-.07-.76-.11C780,488.56,779.79,488.21,779.56,488.21Zm2.24,1c0-.12,0-.23-.21-.22a.15.15,0,0,0-.15.18c.18.64,0,1.32.34,1.94A8.05,8.05,0,0,0,781.8,489.25Zm1.16-.38c0-.11,0-.19-.15-.23a3,3,0,0,0-1.22-.13.15.15,0,0,0-.16.17s.05.12.09.12c.39.07.78.12,1.18.18C782.79,489,782.92,489,783,488.87Z"
            />
            <path
              class="cls-117"
              d="M777.45,473.77c.15.12.32.07.49.07l4.35-.09a.15.15,0,0,1,0,.07c-.22.07-.64-.13-.63.22s.43.15.66.2h0l0,.18-.42,0c-.11,0-.27,0-.25.15s.06.25.24.26h.46V475c-.73.07-.75.08-.62.74a4.15,4.15,0,0,1,.09,1,.7.7,0,0,0,.42.76,5.09,5.09,0,0,1-1.1,0l-3.54-.06-.3-2.81h.19c.11.32.4.28.65.22a4.68,4.68,0,0,1,1.24-.06c.12,0,.3.1.3-.11a.25.25,0,0,0-.3-.25l-1.8,0,0-.17c.15,0,.33,0,.44,0s.2-.29-.08-.38h-.72v-.17Zm3.48,1.28c-.58,0-.59,0-.55.54a9.41,9.41,0,0,1,.16,1.58.13.13,0,0,0,.11.16c.13,0,.14-.09.15-.18s0-.28.09-.4a.68.68,0,0,0,.09.44c.1.36.41.24.65.22s.19-.26.18-.41c0-.52-.08-1.05-.15-1.56,0-.19,0-.43-.37-.39Zm-1.11.29c0-.17-.1-.24-.29-.26-.94-.1-1.15.1-1,.95a9.56,9.56,0,0,1,.17,1.05c0,.23.1.34.36.32h0c.83,0,.83,0,.79-.88C779.91,476.21,779.86,475.78,779.82,475.34Zm-2,1.57c0,.27.13.57.53.48s.18-.37.16-.57a9.83,9.83,0,0,1-.19-1.34c0-.26-.1-.37-.41-.36s-.25.22-.25.49A9.42,9.42,0,0,1,777.84,476.91Zm2.17-3c-.13,0-.22.05-.21.17s0,.16.06.19.19,0,.26-.08,0-.18.13-.05c.29.35.67.12,1,.13.13,0,.2-.11.18-.25s-.12-.15-.24-.14h-.6Zm.24,1.48c0-.1,0-.3-.23-.25s-.06.18,0,.28a14.76,14.76,0,0,0,.17,1.63c0,.09,0,.2.18.32A11.69,11.69,0,0,0,780.25,475.37Zm-.59-1.27c0-.36-.42-.18-.64-.18s-.62-.15-.61.22.42.11.64.2C779.25,474.23,779.68,474.48,779.66,474.1Zm1.59.77c.13,0,.3,0,.3-.19s-.16-.21-.3-.22h-.65c-.16,0-.33,0-.33.21s.16.22.33.21h.65Zm-1.21,0c.11,0,.13-.1.12-.19s0-.17-.14-.17-.12.09-.12.18S779.92,474.87,780,474.87Z"
            />
            <path
              class="cls-116"
              d="M782.81,489.65a1.46,1.46,0,0,1,0-.42c.19-.07.15.32.38.15s.41-.06.62-.07a5.82,5.82,0,0,1,.16,1.86c-.11.12-.08.21.08.26v.15c-.71-.12-.7-.13-.75-.79,0-.37-.09-.74-.13-1.11a2.9,2.9,0,0,0,0,1.21c0,.19,0,.3-.21.3C782.93,490.68,782.88,490.16,782.81,489.65Zm.9,1a.54.54,0,0,0,0,.6A.58.58,0,0,0,783.71,490.66Z"
            />
            <path
              class="cls-116"
              d="M783.14,481.57H783c-.17,0-.42-.09-.48.11s.29.09.35.28c-.29,0-.36.09-.31.38.1.64.11,1.29.17,1.93,0,.18-.1.42.18.52s.29-.21.47-.26v-.16c-.11,0-.19-.09,0-.17Z"
            />
            <path
              class="cls-116"
              d="M782.43,475c-.73.07-.75.08-.62.74a4.15,4.15,0,0,1,.09,1,.7.7,0,0,0,.42.76c.17,0,.37,0,.35-.2A20.79,20.79,0,0,0,782.43,475Z"
            />
            <path
              class="cls-116"
              d="M780.64,487.58c-.13.15-.29,0-.43,0s-.3,0-.3.23.05.27.26.28a5.63,5.63,0,0,1,.59.05c.18,0,.36,0,.42-.17s-.1-.23-.25-.27-.07-.09-.11-.13Z"
            />
            <path
              class="cls-116"
              d="M781.85,487.72c-.08.19-.18.43,0,.53a1,1,0,0,0,.88.09c.29-.16,0-.36-.1-.53h-.27c-.12.1-.22.09-.29-.06Z"
            />
            <path
              class="cls-115"
              d="M777.45,473.77c.15.12.32.07.49.07l4.35-.09c-.1-.16-.27-.1-.42-.09Z"
            />
            <path
              class="cls-116"
              d="M783.65,488l-.27,0c-.16,0-.3,0-.3.23s.13.19.28.21l.39.09A.37.37,0,0,0,783.65,488Z"
            />
            <path
              class="cls-116"
              d="M782.39,474.42l-.42,0c-.11,0-.27,0-.25.15s.06.25.24.26h.46C782.56,474.7,782.37,474.57,782.39,474.42Z"
            />
            <path
              class="cls-116"
              d="M782.3,473.82c-.22.07-.64-.13-.63.22s.43.15.66.2h0A.61.61,0,0,0,782.3,473.82Z"
            />
            <path
              class="cls-116"
              d="M779.15,487.49c0,.18-.07.41.2.5s.36.12.43-.09,0-.33-.24-.37l-.32,0Z"
            />
            <path
              class="cls-116"
              d="M783.75,488.69l-.27,0c-.13,0-.31-.1-.35.08s.09.28.3.3.27.05.4.07Z"
            />
            <path
              class="cls-115"
              d="M780.07,480.76c.18.15.55.1.53.45,0,.07.13.13.23.1s.1-.13.06-.21-.15-.22,0-.33Z"
            />
            <path
              class="cls-115"
              d="M781.2,480.81c.18.27.52,0,.73.17a.31.31,0,0,0,.28.09.66.66,0,0,1,.65,0H783c.06-.19-.09-.16-.21-.17Z"
            />
            <path
              class="cls-116"
              d="M783,481.05h-.11c-.16,0-.43-.08-.42.18s.27.15.43.17h.23C783.07,481.27,783.12,481.13,783,481.05Z"
            />
            <path
              class="cls-116"
              d="M781.38,487.66c-.08.19-.15.38,0,.55a.16.16,0,0,0,.21,0c.14-.18,0-.35-.05-.52Z"
            />
            <path
              class="cls-117"
              d="M784,491.17c-.11.12-.08.21.08.26C784.09,491.33,784.1,491.24,784,491.17Z"
            />
            <path
              class="cls-117"
              d="M782.12,487.74c.07.15.17.16.29.06A.28.28,0,0,0,782.12,487.74Z"
            />
            <path
              class="cls-115"
              d="M778.86,487.46h.24a.38.38,0,0,0-.32-.17A.14.14,0,0,0,778.86,487.46Z"
            />
            <path class="cls-117" d="M783.37,484.2c-.15.08-.07.13,0,.17Z" />
            <path
              class="cls-117"
              d="M790.22,487.12a1.15,1.15,0,0,0-.47.07.41.41,0,0,0,.16.72,7.55,7.55,0,0,1,1,.17,13.68,13.68,0,0,1-1.44.33,14.82,14.82,0,0,1-.23-2.1c-.05-.38-.18-.52-.57-.55-.66-.05-1.32-.12-2-.19-.07-.78-.14-1.55-.2-2.33-.12-1.35-.24-2.71-.35-4.06.68,0,1.37,0,2,.05.34,0,.47-.11.44-.42s0-.7,0-1.05a15.38,15.38,0,0,1,2.14-.14,1.76,1.76,0,0,0,.3-.1,3.08,3.08,0,0,1,.18,1.47l-2.2.21c-.17,0-.32,0-.27.25l0,.08c-.15,0-.34,0-.33.24s.19.25.36.3l0,.16h0c-.17,0-.36,0-.34.24a.33.33,0,0,0,.36.34l.08,0,0,.17-.09.09c-.19-.09-.3,0-.28.16.07.9.11,1.8.22,2.69.05.41.06.82.07,1.22,0,.25.1.38.39.35h0c0,.24.16.27.37.22l2-.46a.39.39,0,0,1,.18.4c0,.41,0,.81,0,1.22A2.57,2.57,0,0,1,790.22,487.12Zm-2-5.69c0-.27-.12-.42-.45-.42s-.71,0-1.06-.05-.35.06-.32.33c.14,1.18.26,2.36.34,3.54,0,.43.22.54.62.54a3.4,3.4,0,0,1,.64,0c.42.09.61,0,.48-.52C788.45,483.8,788.36,482.61,788.27,481.43Zm-.11-.86c0-.35-.24-.31-.49-.32l-1-.05c-.19,0-.32.05-.31.26s.11.24.3.25.67,0,1,.07S788.15,481,788.16,480.57Zm-.32-.58c.15,0,.28,0,.29-.2a.25.25,0,0,0-.24-.27c-.42,0-.85-.06-1.28-.08a.22.22,0,0,0-.25.24c0,.15.06.25.24.26l1,.08v0Z"
            />
            <path
              class="cls-116"
              d="M786,476.73v.15c0,.05.08.1.08.14,0,.47.26.57.69.53.25,0,.49,0,.74,0s.31,0,.39.13h.17c0-.38-.09-.76-.12-1.14-.06-.91-.19-1.82-.18-2.74a.51.51,0,0,0-.57-.57H786c-.27,0-.27.16-.25.35.09.79.18,1.57.23,2.36A1.91,1.91,0,0,1,786,476.73Z"
            />
            <path
              class="cls-110"
              d="M789.42,488.41a14.82,14.82,0,0,1-.23-2.1c-.05-.38-.18-.52-.57-.55-.66-.05-1.32-.12-2-.19-.13.08-.09.2-.08.31.06.66.13,1.32.19,2,0,.12,0,.27.19.28A18.64,18.64,0,0,0,789.42,488.41Z"
            />
            <path
              class="cls-110"
              d="M788,471.88c0-.7-.19-1.38-.15-2.08l-2.4.12c-.15,0-.29,0-.27.2.06.57.11,1.13.17,1.69a.2.2,0,0,0,.14.16Z"
            />
            <path
              class="cls-110"
              d="M788.07,477.67h-.17l-1.9.05a2.36,2.36,0,0,0,.1,1.46c.68,0,1.37,0,2,.05.34,0,.47-.11.44-.42s0-.7,0-1.05a.19.19,0,0,1,0-.07l-.27,0C788.2,477.75,788.14,477.75,788.07,477.67Z"
            />
            <path
              class="cls-109"
              d="M790.3,494.24c0,.38.17.56.6.51-.17-2-.33-4.08-.5-6.19-.22.16-.28.37-.51.33l0,.29Z"
            />
            <path
              class="cls-114"
              d="M799,489.19c0-.15,0-.24-.22-.25-1.33-.13-2.63-.38-4-.42a10.15,10.15,0,0,0,.13,1.45.21.21,0,0,1,.08,0s0,0,0,0a17,17,0,0,0,.14,1.74c.07.41.44.27.69.31s.24-.19.24-.34a4.52,4.52,0,0,0-.12-1.1c-.12.19-.27.39-.53.32s-.2-.32-.22-.51c-.06-.45-.12-.9-.19-1.34,0-.23,0-.31.28-.3a.57.57,0,0,1,.62.63c0,.2-.06.43.11.61.18-.25.08-.52.06-.78s.12-.4.45-.34c.66.12,1.34.12,2,.29Z"
            />
            <path
              class="cls-109"
              d="M794.67,491.89c0-.65-.07-1.3-.11-1.94,0-.23-.19-.21-.36-.24-1-.2-1-.2-.93.72a2.89,2.89,0,0,1,.05,1.17A5.16,5.16,0,0,0,794.67,491.89Z"
            />
            <path
              class="cls-117"
              d="M794.67,491.89a5.16,5.16,0,0,1-1.35-.29c-.19.27,0,.59-.15.86h.26a.19.19,0,0,1,0-.08c0-.15-.19-.46.25-.34l.2.09c.09-.08.17-.14.26,0l0,.07c.11,0,.26-.19.26.07s-.05.27.17.27l.16-.06c0-.39.25-.19.41-.21s.32.07.3.27.08.4-.16.44-.47,0-.6-.2l-.15.18v.2l.77.17a.51.51,0,0,0,.17-.07c.11-.08,0-.31.36-.23s.19-.38.31-.58c.17.07,0,.18.07.26s-.11.29.12.29.23-.15.24-.3-.06-.35.09-.49c-.06-.18-.43,0-.4-.32a4.8,4.8,0,0,0-.23-1.8c-.13.16-.06.35-.08.52a4.52,4.52,0,0,1,.12,1.1c0,.15.06.4-.24.34s-.62.1-.69-.31A17,17,0,0,1,795,490s0,0,0,0a.21.21,0,0,0-.08,0l0,1.86c-.06.15-.17.09-.27.06Z"
            />
            <path
              class="cls-109"
              d="M789,494.1l.51.08c-.14-1.69-.28-3.38-.43-5.07l0-.11c-.37,0-.49.1-.46.43q.21,2,.39,4.08C789,493.7,789,493.9,789,494.1Z"
            />
            <path
              class="cls-117"
              d="M788,476.53c-.06-.91-.19-1.82-.18-2.74a.51.51,0,0,0-.57-.57H786c-.27,0-.27.16-.25.35.09.79.18,1.57.23,2.36a1.91,1.91,0,0,1,0,.79c-.15-.09-.1-.23-.11-.35-.1-1.3-.2-2.61-.29-3.91a.72.72,0,0,0,.59.15l1.16,0c.18,0,.3-.06.29-.25s-.08-.26-.28-.25l-1.39,0c-.27,0-.33.17-.37.36-.17-.12-.07-.29-.09-.43L788,472c-.1.11-.32.13-.26.34a.33.33,0,0,0,.35.26.2.2,0,0,1,0,.07c-.15,0-.27.06-.26.23s.13.2.28.21v.09c-.36,0-.3.24-.26.43.18.93.08,1.89.25,2.83.07.4.09.81.13,1.22-.06.09-.12.09-.19,0C788,477.29,788,476.91,788,476.53Zm-.62-3.43c.16,0,.32,0,.31-.22s-.15-.19-.29-.19a10.27,10.27,0,0,0-1.47.09c-.11,0-.17,0-.17.15s.06.2.19.2l.79,0h.64Z"
            />
            <path
              class="cls-113"
              d="M793.43,492.46h-.26c-.29.08-.58.17-.87.24s-.34.19-.17.41c.16-.1.2.13.34.1.09-.33.37-.46.8-.39h.27Z"
            />
            <path
              class="cls-117"
              d="M786,477.72l1.9-.05c-.08-.17-.25-.13-.39-.13s-.49,0-.74,0c-.43,0-.72-.06-.69-.53,0,0-.05-.09-.08-.14Z"
            />
            <path
              class="cls-113"
              d="M789.06,489l0,.11.78.07,0-.29C789.35,488.65,789.16,488.67,789.06,489Z"
            />
            <path
              class="cls-119"
              d="M785.5,472.05,788,472h.09s0-.05,0-.07l-.1,0-2.51.09A.24.24,0,0,0,785.5,472.05Z"
            />
            <path class="cls-109" d="M794.72,491.89c.1,0,.21.09.27-.06Z" />
            <path
              class="cls-118"
              d="M833.26,492.61l-.09.08c.53,0,.66.28.67.67a12,12,0,0,0,.08,1.69c.07-.06.11-.15.22-.17l.11-.24a13.8,13.8,0,0,1-.24-1.81,1.88,1.88,0,0,0,0-.34c0-.12-.17-.19-.21-.06C833.68,492.75,833.43,492.56,833.26,492.61Z"
            />
            <path
              class="cls-109"
              d="M824,486.85c-.35.22-.35.47-.07.73a15.6,15.6,0,0,1,2.16.18h.18c.24-.06.48.14.72,0,0-.61,0-.62-.66-.6a2.52,2.52,0,0,1-.82-.08C825,486.93,824.43,487.13,824,486.85Z"
            />
            <path
              class="cls-114"
              d="M822.32,492.7c.16.08.23.32.49.25,0-.66,0-1.32,0-2-.15-.63.09-1.27,0-1.9,0-.12.09-.33-.16-.32s-.2.18-.21.32c0,.68,0,1.36,0,2,0,.27,0,.53,0,.79s.14.42-.14.56Z"
            />
            <path
              class="cls-111"
              d="M826.24,487.75h-.18c0,.9-.09,1.8-.06,2.7,0,.35-.28.47-.4.7.11,0,.18,0,.27-.07a.68.68,0,0,0,.35-.67c0-.86,0-1.72,0-2.58Z"
            />
            <path
              class="cls-117"
              d="M822.83,491c0,.66,0,1.32,0,2,.15,0,.22-.08.22-.22,0-.57,0-1.15,0-1.73,0-.06,0-.12-.08-.19Z"
            />
            <path
              class="cls-114"
              d="M825.25,489l0,.25h.27l0-1.1c0-.09,0-.22-.13-.23s-.16.12-.15.21C825.25,488.4,825.11,488.69,825.25,489Z"
            />
            <path
              class="cls-115"
              d="M822.3,492.45c.28-.14.13-.37.14-.56s0-.52,0-.79c-.19,0-.25.09-.26.25C822.4,491.69,822.19,492.09,822.3,492.45Z"
            />
            <path
              class="cls-109"
              d="M825.54,489.23h-.27c0,.28-.13.57,0,.85.26,0,.27-.17.26-.35S825.54,489.4,825.54,489.23Z"
            />
            <path
              class="cls-115"
              d="M835,472.28a3.68,3.68,0,0,1,1.1,0c.27-.1.21-.3.18-.49a10.94,10.94,0,0,0-1.81,0c-.05,1.13-.09,2.25-.14,3.38L834,482.3c0,.2,0,.4,0,.59a.88.88,0,0,0,0,.15c.11.15.42.16.38.42l.1,0a.28.28,0,0,1,.27.18q.5.19.45-.3c0-.19,0-.39,0-.59s0-.19.12-.2.15.12.15.21q0,.61,0,1.23a.64.64,0,0,0,.14.53,20.94,20.94,0,0,0,.12-2.44c0-.07-.08-.08-.14-.09l0,0,0,0c-.1-.65.07-1.29,0-1.94-.08-.2-.72-.42,0-.59-.08-.6.43-1.09.38-1.7a15.35,15.35,0,0,1,0-1.79.65.65,0,0,0-.12-.52l-.12-.1h-.13c0,.07-.09.13-.13.19h-.25a.35.35,0,0,1-.28.09h-.19a1.44,1.44,0,0,1-.08-1.13c0-.27-.18-.6.18-.81,0-.13,0-.36.3-.2h.18a.17.17,0,0,1,.28,0h.08a.12.12,0,0,1,.2,0H836a1.69,1.69,0,0,0,.06-1,1.17,1.17,0,0,1-1.17.14c-.08,0-.2,0-.18-.14S834.87,472.31,835,472.28Zm-.69,10.29a2.75,2.75,0,0,1,1-.45A1.74,1.74,0,0,1,834.29,482.57Zm.94-2.54a2.78,2.78,0,0,1-.08,1.8h-.24c-.06.12-.09.26-.27.26a.94.94,0,0,1-.1.1c-.08.08-.16.17-.27.11s0-.15,0-.23a5.29,5.29,0,0,1,0-.89c.06-.34-.09-.73.22-1h.25l.26,0C835,480,835.1,479.91,835.23,480Zm-.83,3.43Z"
            />
            <path
              class="cls-113"
              d="M834.45,471.79a10.94,10.94,0,0,1,1.81,0l0-.28c0-.31-.1-.44-.45-.4a4.7,4.7,0,0,1-.65,0C834.44,471.07,834.44,471.07,834.45,471.79Z"
            />
            <path
              class="cls-113"
              d="M834,483l0-.15a.78.78,0,0,1-.46-.23c-.32-.14-.65-.26-1-.4a.47.47,0,0,0-.55,0s0,0,0,0a1.32,1.32,0,0,1,.65.14A11.15,11.15,0,0,0,834,483Z"
            />
            <path
              class="cls-115"
              d="M835.08,484.81a1,1,0,0,0-.31-1.19h0a.27.27,0,0,1-.37-.16h0c-.18,0-.27-.19-.46-.15-.05,1.06-.11,2.12-.15,3.18-.07,1.44-.12,2.88-.18,4.32a.64.64,0,0,0,.43-.2,1,1,0,0,1,.74-.26c0-.71.15-1.42.11-2.13a1.64,1.64,0,0,0-.59.37c-.09.07-.18.2-.31.13s0-.2,0-.31-.13-.1-.1-.18a3.32,3.32,0,0,0,.08-.89,10.46,10.46,0,0,1,.15-1.76C834.18,485.06,834.68,485,835.08,484.81Z"
            />
            <path
              class="cls-119"
              d="M834.78,490.35a1,1,0,0,0-.74.26.64.64,0,0,1-.43.2.6.6,0,0,1-.47.69,4.17,4.17,0,0,1-.5,0l-2.67-.27c0,.17-.12.25-.27.07l-.24-.05-.33.19v.25a7,7,0,0,1,2.44.43,2.9,2.9,0,0,1,1.32.39l.36,0,1.26-1c.19-.08.31-.19.27-.42A4.79,4.79,0,0,1,834.78,490.35Z"
            />
            <path
              class="cls-112"
              d="M834.53,491.53l-1.26,1v.08c.17-.05.42.14.52-.18,0-.13.18-.06.21.06a1.88,1.88,0,0,1,0,.34,13.8,13.8,0,0,0,.24,1.81c.12-.05.21-.21.38-.12a14.12,14.12,0,0,1,.1-2.43C834.75,491.89,834.78,491.66,834.53,491.53Z"
            />
            <path
              class="cls-116"
              d="M834.11,485.58a10.46,10.46,0,0,0-.15,1.76,3.32,3.32,0,0,1-.08.89c0,.08,0,.17.1.18h.09l.18-.09a.59.59,0,0,0,.47-.35l-.39.09c-.19,0-.23-.16-.23-.31,0-.42,0-.84.07-1.26,0-.18,0-.42.28-.47l.24-.1c0-.06.09-.15.14-.16s.1.12.09.18a5.19,5.19,0,0,0,0,1.18.86.86,0,0,1-.17.6V488h.19a23.36,23.36,0,0,0,.18-2.89C834.73,485.2,834.51,485.54,834.11,485.58Z"
            />
            <path
              class="cls-120"
              d="M836.08,472.25a3.68,3.68,0,0,0-1.1,0c-.11,0-.22,0-.23.16s.1.11.18.14a1.17,1.17,0,0,0,1.17-.14Z"
            />
            <path
              class="cls-114"
              d="M834.11,485.58c.4,0,.62-.38,1-.51v-.26C834.68,485,834.18,485.06,834.11,485.58Z"
            />
            <path
              class="cls-117"
              d="M836,473.46H836a8.3,8.3,0,0,0-.16,1.86l.12.1a.39.39,0,0,0,.09-.32C835.93,474.55,836.13,474,836,473.46Z"
            />
            <path
              class="cls-118"
              d="M835.39,498.78c0-.21-.17-.25-.36-.24,0,.38-.06.75-.1,1.13,0,.11,0,.19.13.22h0l.09-.08v-.1C835.2,499.39,834.94,499,835.39,498.78Z"
            />
            <path
              class="cls-118"
              d="M835.18,500.55a.45.45,0,0,0,.4-.47c0-.2-.24-.19-.42-.19h-.1A1.49,1.49,0,0,0,835.18,500.55Z"
            />
            <path
              class="cls-117"
              d="M834.07,488.41H834c0,.11-.12.23,0,.31s.22-.06.31-.13a1.64,1.64,0,0,1,.59-.37V488h-.18a.59.59,0,0,1-.47.35A.18.18,0,0,1,834.07,488.41Z"
            />
            <path class="cls-117" d="M835.62,479.43c-.75.17-.11.39,0,.59Z" />
            <path
              class="cls-118"
              d="M834.15,498.91c.18.12.28.16.45.08C834.48,498.87,834.35,498.89,834.15,498.91Z"
            />
            <path
              class="cls-113"
              d="M834.37,497.38s0-.06,0-.09-.06,0-.09,0a.21.21,0,0,0,0,.07S834.3,497.39,834.37,497.38Z"
            />
            <path
              class="cls-111"
              d="M801,487.78a.52.52,0,0,0-.18,0c-.42.19-.59.09-.55-.35,0-.29-.3-.38-.85-.26a4.55,4.55,0,0,1,.21,1.71c.09,2.33.34,4.66.32,7a1.47,1.47,0,0,0,.75.13v-.17c.09-.2-.23-.49.16-.63a.08.08,0,0,1,.08,0l.19,0c0-.22-.22-.21-.39-.23s0-.31-.1-.46c-.1-.32.18-.66-.07-1a1.18,1.18,0,0,1,0-.62v-.18a6.12,6.12,0,0,1-.06-1.48v-.34c-.2-.36,0-.74,0-1.1v-.19a.9.9,0,0,1-.09-.58c-.3,0-.4-.15-.42-.4s.18-.45.44-.52A.88.88,0,0,0,801,487.78Z"
            />
            <path
              class="cls-113"
              d="M835.39,498.78c-.45.23-.19.61-.23.93A3.73,3.73,0,0,0,835.39,498.78Z"
            />
            <path class="cls-109" d="M835.06,499.89h.1a.25.25,0,0,1,0-.08Z" />
            <path
              class="cls-118"
              d="M792.28,486.81c.32,0,.63,0,.81.28-.09.3,0,.42.35.32s.57-.1.85-.16l.67-.1-.19.35h-.26s-.11-.1-.14,0,.07.08.13.09v.08h0l-.16.06c-.79-.09-1.59-.16-2.37-.28a16.41,16.41,0,0,1-2.22-.27,1.15,1.15,0,0,1,.47-.07,2.57,2.57,0,0,0,1.57-.23Zm.45.36s0,0-.07,0l0,0,.06,0Zm0,.25,0,0s0,0,.06,0l0,0Z"
            />
            <path
              class="cls-117"
              d="M797.05,493.09l0,.05,1.1.16c.3,0,.62,0,.59-.4a.1.1,0,0,1,.11-.11c.1,0,.11.07.12.15,0,.34,0,.66-.41.78l-.05.06a2,2,0,0,1,.73.15l-.1-1.67c-.58-.08-.58-.08-.57-.86-.18-.33-.05-.69-.12-1h-.18l.05,1.39a.79.79,0,0,1,.06.5c0,.12,0,.25,0,.37,0,.49,0,.52-.53.44l-.77-.12Z"
            />
            <path
              class="cls-118"
              d="M797.2,487.6c-.16-.43-.53-.42-.92-.34-.16,0-.32.08-.49.13s-.36-.19-.45.09l.08.06a.23.23,0,0,1-.27-.05l-.33.09-.31.09h0s0,0,0,.06c.3.05.6.1.91.13a1.31,1.31,0,0,0,.85-.07c.15-.09.22-.18.21.1,0,.11.35,0,.55.05h0c0-.11.07-.16.18-.18Z"
            />
            <path
              class="cls-114"
              d="M798.61,491.4c0,.78,0,.78.57.86a12.9,12.9,0,0,0-.15-2.4l-.37.1A5,5,0,0,1,798.61,491.4Z"
            />
            <path
              class="cls-111"
              d="M797.57,487.46c.39,0,.85-.32,1.06.27,0,.08.16,0,.25,0s0,.16-.08.23c-.42.38-.86.17-1.31.06l.18,0s0,0,0,0a.13.13,0,0,0-.15.07c-.16,0-.34,0-.47-.08h0a.17.17,0,0,0,.18-.18v-.17C797.36,487.62,797.44,487.47,797.57,487.46Zm.85.42-.06,0,0,0,.06,0Z"
            />
            <path
              class="cls-119"
              d="M799.28,493.93a2,2,0,0,0-.73-.15L798,494l0,.1a2.39,2.39,0,0,0,1.37.17A.29.29,0,0,0,799.28,493.93Z"
            />
            <path
              class="cls-116"
              d="M798.66,490l.37-.1,0-.67h-.44l-.09.18c0,.19,0,.39,0,.58Z"
            />
            <path
              class="cls-111"
              d="M799,487.48v.16C799.05,487.58,799,487.53,799,487.48Z"
            />
            <path class="cls-111" d="M794.51,487.74s0,0,0-.06l-.16.06Z" />
            <path class="cls-119" d="M799.26,494.7h.09l0-.08Z" />
            <path
              class="cls-115"
              d="M812.18,490.28a12,12,0,0,0-1.69-.19v.44l0,.43v.66c0,.41,0,.82,0,1.23,0,.21.1.32.34.3h0c1.15,0,1.27-.12,1.08-1.31l.08-.61,0-.48A.78.78,0,0,1,812.18,490.28Z"
            />
            <path
              class="cls-116"
              d="M812.11,491.23l-.08.61a7.22,7.22,0,0,0,3.07,0,12.54,12.54,0,0,0-1.16-1.34,9.41,9.41,0,0,0-1.76-.22.78.78,0,0,0-.09.47c.44.06.89.1,1.32.18.2,0,.61-.08.51.29s-.41.12-.63.14a.18.18,0,0,1-.13,0C812.83,491.05,812.47,491.17,812.11,491.23Z"
            />
            <path
              class="cls-116"
              d="M810.53,491.62V491c-.28,0-.56,0-.83-.06-.58-.06-.85.16-.84.7h0A4,4,0,0,1,810.53,491.62Z"
            />
            <path
              class="cls-113"
              d="M806.8,491a12.42,12.42,0,0,0-2.23-1.16c-.22-.26-.32-.16-.35.1l-.55-.06c-.36-.05-.6,0-.46.43a1.81,1.81,0,0,1,0,.25l-.07.07a.09.09,0,0,0,0,.05l-.35-.09c-.35-.06-.56-.39-.93-.42-.37-.28-.42-.1-.41.23.09,1.83.17,3.67.25,5.5-.24,0-.48,0-.65-.18a.85.85,0,0,0,.08-.54c0-.22-.22-.21-.39-.23.06-.21.11-.42.17-.63,0-.05,0-.14,0-.15.49-.12.22-.49.3-.75s0-.44,0-.66,0-.63,0-.94a13.27,13.27,0,0,1-.14-2.09c0-.18-.07-.3-.29-.31s-.17.23-.36.19a.9.9,0,0,1-.09-.58c.56,0,1.1.21,1.66.19l1.84-.53c-.15.55-.15.54.46.61l4.49.54c0,.41.2.55.6.58a8.13,8.13,0,0,0,1.1.07l0,.43c-.28,0-.56,0-.83-.06-.58-.06-.85.16-.84.7Zm-2.69-1.4c0-.22-.21-.17-.33-.2a.8.8,0,0,0-.59,0c-.05,0,0,.11,0,.16s.36.13.56.14S804.08,489.81,804.11,489.64Z"
            />
            <path
              class="cls-115"
              d="M779.55,488.73c-.2,0-.27.08-.26.25s0,.38,0,.63c-.24-.28.06-.63-.31-.79a8.52,8.52,0,0,0,.23,1.95c.18-.18.07-.39.08-.59s0-.31.09-.43.22-.22.16-.36A1.23,1.23,0,0,1,779.55,488.73Z"
            />
            <path
              class="cls-115"
              d="M777.64,473.94h-.36a1.45,1.45,0,0,0,.1.77h.19l.09-.17,0-.17C777.48,474.22,777.64,474.08,777.64,473.94Z"
            />
            <path
              class="cls-115"
              d="M779,488.65c.12-.35.23-.71-.11-1A2.53,2.53,0,0,0,779,488.65Z"
            />
            <path
              class="cls-116"
              d="M804.22,490l-.55-.06c-.36-.05-.6,0-.46.43a1.81,1.81,0,0,1,0,.25l-.07.07a.09.09,0,0,0,0,.05l0,.17a1.17,1.17,0,0,1,.18.6c0,.26-.24.56,0,.77s.56.12.84.21c0-.65,0-1.3-.05-1.94A5.35,5.35,0,0,1,804.22,490Z"
            />
            <path
              class="cls-114"
              d="M804.22,492.47c-.28-.09-.62,0-.84-.21s0-.51,0-.77a1.17,1.17,0,0,0-.18-.6c0,1,.06,1.95.1,2.92,0,.53.52.33.81.4s.2-.24.2-.39C804.29,493.37,804.25,492.92,804.22,492.47Z"
            />
            <path
              class="cls-109"
              d="M830,491.23l2.67.27a4.17,4.17,0,0,0,.5,0c0-.76,0-1.52.06-2.28.07-1.93.25-3.85.27-5.78,0-.12-.07-.29.11-.33a.3.3,0,0,1,.36.2c.19,0,.28.17.46.15,0-.26-.27-.27-.38-.42a11.15,11.15,0,0,1-1.33-.58,1.32,1.32,0,0,0-.65-.14,4.3,4.3,0,0,1,0,1.29l0,.3.35,0a3.61,3.61,0,0,1,0,1.73c0,.05-.09.08-.13.12a.11.11,0,0,1,0,.15c-.3.52-.6,1.05-.89,1.58a.4.4,0,0,1-.43.19.48.48,0,0,0-.53.32,5.54,5.54,0,0,1-.33.51l-.12.3v.26a.69.69,0,0,1,0,.68l0,.85C830,490.83,829.91,491,830,491.23Z"
            />
            <path
              class="cls-111"
              d="M830.07,488.55a5.54,5.54,0,0,0,.33-.51.48.48,0,0,1,.53-.32.4.4,0,0,0,.43-.19c.29-.53.59-1.06.89-1.58a.11.11,0,0,0,0-.15l-.87.42c-.21.14-.44,0-.67,0s-.4-.08-.59,0C830.13,487,830,487.79,830.07,488.55Z"
            />
            <path
              class="cls-115"
              d="M829.13,491.44l.33-.19c0-.42.09-.85.08-1.28,0-.17.17-.36,0-.51-.1,0-.23.19-.25-.08s-.16-.09-.27,0a16.32,16.32,0,0,1,0,1.85Z"
            />
            <path
              class="cls-110"
              d="M829.5,489.46c.21.15,0,.34,0,.51,0,.43,0,.86-.08,1.28l.23.05c.21-.18,0-.47.19-.66l0-.85a.64.64,0,0,1,0-.68v-.26C829.62,488.94,829.67,489.27,829.5,489.46Z"
            />
            <path
              class="cls-117"
              d="M828.94,491.2a16.32,16.32,0,0,0,0-1.85A2.93,2.93,0,0,0,828.94,491.2Z"
            />
            <path
              class="cls-120"
              d="M830.08,486.29c.19-.1.39,0,.59,0-.12-.13,0-.26,0-.39a1.29,1.29,0,0,0-.8.41Z"
            />
            <path
              class="cls-109"
              d="M828.05,485.2a3.92,3.92,0,0,0-1.71.62,1.79,1.79,0,0,0-.87.51h0a6.9,6.9,0,0,1,2,.19l.2.19c.24,0,.3.09.3.28a.9.9,0,0,1-.14.57c-.08.12-.26.26-.12.41s.38.09.57.06.16-.25.16-.39a9,9,0,0,1,0-1.64c-.52,0-1-.25-1.53-.3l.69,0c-.07-.12-.25,0-.39-.18l1.27.11v0l-.88,0c.36.22.82-.05,1.18.19a.54.54,0,0,0-.16.37l1.62-.79c.12-.06.21-.12.23-.24A9.88,9.88,0,0,1,828.05,485.2Zm-.27.18s0,0,0,0h.34a.15.15,0,0,1,0,.07Zm.66.08a.77.77,0,0,1,.63,0Zm.73.24-.09,0,.07,0,.08,0S829.19,485.71,829.17,485.7Zm.34-.17-.07,0,.07,0s0,0,.08,0Z"
            />
            <path
              class="cls-110"
              d="M828.05,485.2a9.88,9.88,0,0,0,2.49,0c.42.05.46.27.13.68,0,.13-.12.26,0,.39s.46.09.67,0c-.14-.94-.29-1.88,1-2.27l-.35,0a3.14,3.14,0,0,1-1.12.45c-.9,0-1.8-.07-2.7-.14C827.91,484.52,828,484.86,828.05,485.2Z"
            />
            <path
              class="cls-118"
              d="M827.69,486.7l-.2-.19a8.21,8.21,0,0,1-2-.19h0a3.89,3.89,0,0,0-1.5.52c.46.28,1,.08,1.51.23.4-.35.88-.16,1.32-.14S827.48,487.05,827.69,486.7Z"
            />
            <path
              class="cls-113"
              d="M827.67,485.67l-.69,0c.52.05,1,.26,1.53.29.14,0,.09.19.18.25a.65.65,0,0,1,.16-.37c-.36-.24-.82,0-1.18-.19Z"
            />
            <path
              class="cls-119"
              d="M826.26,487.84c0,.86,0,1.72,0,2.58a.68.68,0,0,1-.35.67.82.82,0,0,0,.49.49,1.42,1.42,0,0,0,.13-.78,20.8,20.8,0,0,0,0-2.62C826.52,488,826.55,487.82,826.26,487.84Z"
            />
            <path
              class="cls-117"
              d="M789.87,489.18l-.78-.07c.15,1.69.29,3.38.43,5.07l.78.06Z"
            />
            <path
              class="cls-114"
              d="M797.05,493.09l.11-.15a4.17,4.17,0,0,1,1.26-.69.79.79,0,0,0-.06-.5,3.71,3.71,0,0,1-1.29.2l-.77-.06c0,.27.34.14.4.32s.06.57.12.85Z"
            />
            <path
              class="cls-119"
              d="M795.34,493.33l-.77-.17-1.35-.18c-.22-.05-.31.19-.51.19v0a.34.34,0,0,0,.25.18l2.06.32a.39.39,0,0,0,.34-.09Z"
            />
            <path
              class="cls-118"
              d="M792.71,493.17c.2,0,.29-.24.51-.19l0-.16c-.43-.07-.71.06-.8.39l.14,0Z"
            />
            <path class="cls-113" d="M792.71,493.17l-.1,0h.09Z" />
            <path
              class="cls-120"
              d="M797.93,494.06l0-.1c-.06-.28.21-.28.39-.36s.23,0,.25.12c.46-.12.45-.44.41-.78,0-.08,0-.15-.12-.15a.1.1,0,0,0-.11.11c0,.41-.29.39-.59.4a.54.54,0,0,1-.36.16q-.6.09-.27.54C797.73,493.76,797.79,494.16,797.93,494.06Z"
            />
            <path
              class="cls-119"
              d="M798,494.82c0,.06,0,.13.09.11s.19-.05.19-.15-.09-.07-.15-.08S798,494.75,798,494.82Z"
            />
            <path
              class="cls-120"
              d="M801.06,495.76a.85.85,0,0,0,.08-.54l-.19,0h0l0,0c-.39.14-.07.43-.16.63A.4.4,0,0,0,801.06,495.76Z"
            />
            <path
              class="cls-117"
              d="M806.28,485.72a2.45,2.45,0,0,1-1.13.55,2.38,2.38,0,0,0-.9.29,6.33,6.33,0,0,0,1.62.22c1.85.19,3.71.35,5.56.52l6.25.57c1.45-.57,2.9-1.13,4.33-1.73a5.84,5.84,0,0,0,1.49-.66,12.75,12.75,0,0,0-1.37-.15c-.21,0-.36-.08-.36-.3-1.39,0-2.77-.17-4.15-.25-2.19-.14-4.37-.3-6.56-.45l-3.89,1.06A3.79,3.79,0,0,0,806.28,485.72Z"
            />
            <path
              class="cls-117"
              d="M799.88,483.47l0,.29c-.1.1-.07.17.06.21s.29.07.31.24.13.32-.22.3c-1.58-.14-3.17-.23-4.75-.37a7.8,7.8,0,0,1-1.74-.19c0-.91,0-1.83-.12-2.73,0-.41,0-.82-.09-1.22s.07-.37.35-.22.32.06.48.07.15.16.2,0,0-.14.1-.11a3.56,3.56,0,0,0,2,.23c.19,0,.22-.12.23-.25l.11.06c0,.23.17.26.37.26a.23.23,0,0,0,.26-.26h.08c0,.3.29.3.52.32s.77,0,1.15,0,.18-.17.22-.28l.17.06c0,.38.36.21.57.24v.18h-.27c-.16,0-.26.05-.26.21s.11.21.27.22.23,0,.35.06v.11c-.62,0-.62,0-.61.55,0,.34,0,.68,0,1,0,.58,0,.58.65.54l0,.26C800.19,483.36,799.87,483.09,799.88,483.47Zm-2.63-.45c.28-.12.35-.24.3-.5a10.09,10.09,0,0,1-.07-1.35c0-.19,0-.39-.3-.38s-.26.19-.26.37a17.85,17.85,0,0,0,.23,2.86c.13-.23.41-.2.49-.42v-.35C797.61,483.08,797.44,483.09,797.25,483Zm2.25.18.08-.17c-.05-.61-.1-1.21-.14-1.82,0-.21-.1-.28-.33-.31a2.36,2.36,0,0,0-1.32,0c-.4.22,0,.73-.09,1.12a5.32,5.32,0,0,0,0,.89c0,.12,0,.26.15.33.47.2.23.35-.12.5.58.31,1.17.08,1.72.21.12,0,.13-.13.13-.23v-.34Zm-2.76-2.09c0-.3-.21-.35-.45-.37a12.92,12.92,0,0,1-1.39-.05c-.24-.05-.34.09-.29.3.2.82,0,1.67.22,2.49.06.31.18.42.5.42a9.55,9.55,0,0,1,1.2.09c.36.06.4-.08.37-.34s0-.31,0-.47C796.86,482.49,796.71,481.81,796.74,481.11ZM794.5,481c0-.42-.35-.36-.63-.38s-.31.21-.3.41c0,.76.1,1.52.17,2.28a.5.5,0,0,0,.21.45.69.69,0,0,0,.58.05c.2-.06.12-.23.13-.36a1.9,1.9,0,0,0,0-.34A15,15,0,0,1,794.5,481Zm2-.44c.12,0,.25,0,.25-.15s0-.3-.21-.27c-.64.11-1.3-.23-1.93.07-.13.06-.1,0-.14-.08-.23-.2-.49-.1-.75-.08-.1,0-.13.1-.13.19s.13.2.28.21l2.21.13h.42Zm2.95,0c0-.14,0-.28-.2-.29-.49,0-1-.06-1.48-.08a.16.16,0,0,0-.17.16.24.24,0,0,0,.19.26,2,2,0,0,0,.64.06l.79,0C799.3,480.73,799.39,480.7,799.41,480.57Zm-2.23.05c.15,0,.27,0,.27-.21s-.11-.22-.27-.22-.27,0-.27.21S797,480.62,797.18,480.62Z"
            />
            <path
              class="cls-117"
              d="M799.61,472.48c-.13,0-.3,0-.31.15s.16.17.3.17h.23V473c-.42-.05-.58.08-.55.49.08.79.05,1.59.15,2.38,0,.38.17.51.57.43,0,.25-.24.17-.39.19-.72.06-1.45,0-2.18,0-1.43,0-2.87,0-4.31,0l-.27-3.7c0-.17,0-.33,0-.5H793c0,.16,0,.32.28.31s.55.08.64-.36c.21.46.59.35.92.31a6.77,6.77,0,0,1,1-.09c.27,0,.35-.12.33-.34h.15c0,.15,0,.32.3.31s.3-.1.29-.29l.18,0c0,.21.14.26.34.25q.64,0,1.29,0c.28,0,.35-.13.33-.35.2,0,.17.21.34.33,0-.31.08-.47.38-.45l0,.7A.58.58,0,0,0,799.61,472.48Zm-5.78.45a.08.08,0,0,0,.08-.12.16.16,0,0,0-.17-.11h-.69l0,.06,0,0C793.26,473.11,793.57,472.91,793.83,472.93Zm5,2.48c.51,0,.45-.31.4-.58a8.77,8.77,0,0,1-.12-1.53c0-.21-.09-.31-.33-.3-.44,0-.87,0-1.31,0-.23,0-.33.09-.32.31.06.9.12,1.8.17,2.7,0,.08,0,.2.13.2.37,0,.78.16,1.09-.17.13-.12.06-.28.07-.42S798.7,475.4,798.84,475.41Zm-2.54.85c.26-.37-.29-.39-.28-.64.44-.26.36-.66.34-1s0-.74,0-1.1-.12-.35-.4-.34c-.53,0-1.08,0-1.62,0-.17,0-.23.07-.2.2.19.8.07,1.63.19,2.44.05.34.18.52.59.46a3.62,3.62,0,0,1,.55.05c.24,0,.52,0,.51-.34C796.21,475.89,796.19,476.14,796.3,476.26Zm-3.06-.41a.6.6,0,0,0,.85.42c.11,0,.09-.14.08-.22a22.35,22.35,0,0,1-.17-2.58c0-.32-.25-.27-.47-.26s-.46,0-.46.27c0,.11,0,.23,0,.47A12,12,0,0,1,793.24,475.85Zm3.74-2.53c0-.17-.07-.27-.27-.27s-.23.08-.25.26c-.1.73.18,1.43.11,2.16,0,.21.34-.12.28.16,0,.12-.05.25-.07.37s0,.25.17.26.2-.11.2-.23c0-.35,0-.71,0-1.2A11.13,11.13,0,0,0,797,473.32Zm-1-.43c.12,0,.22,0,.21-.17s-.11-.16-.22-.16l-1.66,0c-.12,0-.22,0-.21.17s.1.17.22.16l.83,0Zm2.85-.07c.13,0,.26,0,.24-.19s-.13-.15-.24-.14l-1.43,0c-.13,0-.25,0-.23.19s.12.14.23.14l.74,0h0Zm-2.15.06c.13,0,.26,0,.25-.18s-.13-.16-.26-.15-.25,0-.25.17S796.56,472.88,796.68,472.88Zm2.54,2.9s0,0,0-.08,0,0,0-.06l0,.07Z"
            />
            <path
              class="cls-115"
              d="M789.7,485.32c.28.12.37,0,.36-.23-.07-.8-.08-1.61-.2-2.4a7.31,7.31,0,0,0-.2-1.55h0l0-.06,0,0c-.27-.18-.56,0-.84-.07l0-.17.54-.1c.26-.06.2-.26.18-.42s-.19-.11-.31-.1l-.51,0,0-.16,0,0c.28-.12.82.05.73-.52l.35-.09c0,.16-.19.4.21.42.72.05.82,0,.82-.53l.27,0c.19,2,.39,4,.47,6l-2,.46c-.21,0-.37,0-.37-.22A.85.85,0,0,0,789.7,485.32Zm.29-2.92c0,.15,0,.3,0,.45a.3.3,0,0,0,.09.25c0,.62,0,1.25.06,1.87,0,.3.14.36.44.29.77-.17.82-.17.73-.88-.14-1.08-.07-2.17-.26-3.25a1.62,1.62,0,0,0-.1-.18c-.26-.38-.57,0-.86-.05s-.17.21-.15.34-.12.33,0,.49v.43Zm.08-2.31a.27.27,0,0,0-.23.35c0,.2.2.18.35.17.4,0,.75-.1.68-.61A4.17,4.17,0,0,0,790.07,480.09Z"
            />
            <path
              class="cls-109"
              d="M800.35,489.07c.56,0,1.1.21,1.66.19-.13-.49,0-.8.57-1,.24-.07.59,0,.69-.35a7.89,7.89,0,0,0-2.27-.17.88.88,0,0,1-.63.37c-.26.07-.46.23-.44.52S800.05,489.08,800.35,489.07Z"
            />
            <path
              class="cls-115"
              d="M788.15,473.07h.59c.12,0,.27,0,.27-.15s-.1-.25-.29-.25h-.59l0,0a.2.2,0,0,0,0-.07h.48c.28,0,.4-.1.37-.35l.17,0c0,.22.11.38.39.35s.8.15.92-.36l.13,0c0,.21.05.42.06.63.13,1.58.25,3.15.37,4.73a1.76,1.76,0,0,1-.3.1,15.38,15.38,0,0,0-2.14.14.19.19,0,0,1,0-.07l0-.11a.46.46,0,0,0,.39-.1c.4,0,.56-.09.44-.49s.06-.72-.15-1.05v-.15h.19l.09.16c0,.36,0,.71,0,1.06,0,.53.49.34.81.37s.42-.13.4-.41,0-.71,0-1.06v-.15c0-.12,0-.25-.1-.35v-.09a.61.61,0,0,0,0-.67,4.56,4.56,0,0,1-.13-1.22c0-.21-.08-.33-.33-.3s-.69-.08-1,.19h-.12c-.26-.32-.6-.1-.91-.13h0v-.09Zm2,0c.17,0,.31,0,.3-.23s-.15-.19-.3-.18h-.56c-.15,0-.32,0-.32.21s.16.21.32.21h.56Z"
            />
            <path
              class="cls-115"
              d="M793.56,484c0-.91,0-1.83-.12-2.73,0-.41,0-.82-.09-1.22s.07-.37.35-.22c.18-.35.53-.32.87-.3-.28-.28-.64-.15-1-.12a1.3,1.3,0,0,1-.62,0l.09,3.07c0,.41.07.82.09,1.23C793.19,483.92,793.31,484,793.56,484Z"
            />
            <path
              class="cls-120"
              d="M796.94,472.08l.18,0a3.06,3.06,0,0,1,2-.13c.2,0,.17.21.34.33,0-.31.08-.47.38-.45,0-.21,0-.31-.3-.3l-5.57.22-1.29.08c-.13,0-.26,0-.23.19.18,0,.3.1.44.17H793c.36-.32.82-.15,1.23-.19a5.33,5.33,0,0,1,2,0h.15C796.55,472,796.76,471.83,796.94,472.08Z"
            />
            <path
              class="cls-116"
              d="M799.84,473c-.42-.05-.58.08-.55.49.08.79.05,1.59.15,2.38,0,.38.17.51.57.43C800,475.17,799.87,474.08,799.84,473Z"
            />
            <path
              class="cls-115"
              d="M792.85,472.21c-.14-.07-.26-.19-.44-.17.1,1.39.19,2.78.28,4.17,0,.29.24.24.44.2l-.27-3.7C792.85,472.54,792.85,472.38,792.85,472.21Z"
            />
            <path
              class="cls-111"
              d="M803.27,488c-.1.33-.45.28-.69.35-.55.16-.7.47-.57,1l1.84-.53C804,488.07,803.93,488,803.27,488Z"
            />
            <path
              class="cls-116"
              d="M800.24,480.9c-.62,0-.62,0-.61.55,0,.34,0,.68,0,1,0,.58,0,.58.65.54C800.27,482.31,800.33,481.6,800.24,480.9Z"
            />
            <path
              class="cls-116"
              d="M794.57,479.48c-.34,0-.69-.05-.87.3.15.11.32.06.48.07l.2,0c0-.05,0-.14.1-.11a3.56,3.56,0,0,0,2,.23c.19,0,.22-.12.23-.25a.39.39,0,0,0-.39-.17,6.1,6.1,0,0,1-1.21-.06Z"
            />
            <path
              class="cls-116"
              d="M808.8,489.88c0,.41.2.55.6.58a8.13,8.13,0,0,0,1.1.07v-.44A11.83,11.83,0,0,0,808.8,489.88Z"
            />
            <path
              class="cls-119"
              d="M795.1,479.47a6.1,6.1,0,0,0,1.21.06.39.39,0,0,1,.39.17l.11.06c.21-.11.42-.26.63,0h.09c.59-.35,1.21-.07,1.81-.05,0,0,0,.07.07.11l.17.06a.36.36,0,0,1,.55-.2c0-.1-.09-.14-.19-.14l-4.64-.15A.22.22,0,0,0,795.1,479.47Z"
            />
            <path
              class="cls-113"
              d="M790.82,479.33l.27,0a.34.34,0,0,0,.08-.32l-2.2.21c-.17,0-.32,0-.27.25H789c.17,0,.35,0,.49.07l.35-.09C790.12,479.26,790.48,479.37,790.82,479.33Z"
            />
            <path
              class="cls-111"
              d="M793.09,487.09c-.09.3,0,.42.35.32s.57-.1.85-.16c0-.16,0-.28-.26-.3A1.88,1.88,0,0,0,793.09,487.09Z"
            />
            <path
              class="cls-113"
              d="M790.43,472.18l.13,0a.53.53,0,0,0,0-.33l-2.51.07s0,.05,0,.07h0c.29.07.62,0,.85.23l.17,0A1.33,1.33,0,0,1,790.43,472.18Z"
            />
            <path
              class="cls-116"
              d="M800.14,480.3h-.27c-.16,0-.26.05-.26.21s.11.21.27.22.23,0,.35.06C800.31,480.61,800.2,480.46,800.14,480.3Z"
            />
            <path
              class="cls-111"
              d="M795.34,487.48c.09-.28.31,0,.45-.09,0-.23-.14-.3-.39-.26s-.29,0-.44,0l-.19.35.05.08.33-.09Z"
            />
            <path
              class="cls-116"
              d="M800.33,483.27c-.14.09-.46-.18-.45.2.15,0,.33-.06.34.14s-.18.16-.32.15-.07.17.06.21.29.07.31.24C800.47,483.91,800.3,483.59,800.33,483.27Z"
            />
            <path
              class="cls-116"
              d="M800.13,479.68a.36.36,0,0,0-.55.2c0,.38.36.21.57.24Z"
            />
            <path
              class="cls-116"
              d="M799.82,472.55a.58.58,0,0,0-.21-.07c-.13,0-.3,0-.31.15s.16.17.3.17h.23Z"
            />
            <path
              class="cls-116"
              d="M813.51,480.05c.35,0,.7,0,1.06,0,.18,0,.3.07.28.25a20.42,20.42,0,0,1,0,2.07c-.16.25,0,.51-.07.77-.38,0-.5.29-.29.71.17,0,.14-.22.3-.21h.1c0,.57,0,.57-.61.54l-.46,0c-.17,0-.25-.09-.24-.24v-.75l0-.61,0-.49v-.19C813.5,481.3,813.5,480.67,813.51,480.05Zm.25,2.95c.19.16.36.11.65.05A.7.7,0,0,0,813.76,483Z"
            />
            <path
              class="cls-116"
              d="M814.58,475c0,.08.12.07.2.08a1.59,1.59,0,0,1,0,.78c-.26.35-.66.24-1,.23-.15,0-.19-.14-.19-.26,0-.82,0-1.64,0-2.46,0-.2.14-.23.31-.23l.89,0,0,1.78C814.7,474.93,814.56,474.89,814.58,475Zm-.19-.09a.45.45,0,0,0-.49,0C814.1,475,814.22,475,814.39,474.92Z"
            />
            <path
              class="cls-117"
              d="M814.73,475.87c-.26.35-.66.24-1,.23-.15,0-.19-.14-.19-.26,0-.82,0-1.64,0-2.46,0-.2.14-.23.31-.23l.89,0V473l-1,0c-.1,0-.2,0-.21-.12s.11-.12.2-.12l1,0a.06.06,0,0,0,0-.08h-.91c-.11,0-.24,0-.26-.12s.12-.17.22-.18l1,0a2.73,2.73,0,0,0-1.36,0c-.09.73,0,1.45,0,2.18l.06,1.57c0,.1,0,.25.15.26a6.25,6.25,0,0,0,1.06,0C814.88,476.22,814.75,476,814.73,475.87Z"
            />
            <path
              class="cls-116"
              d="M814.73,472.28l-1,0c-.1,0-.23.06-.22.18s.15.12.26.12h.91Z"
            />
            <path
              class="cls-116"
              d="M814.72,472.69l-1,0c-.09,0-.2,0-.2.12s.11.12.21.12l1,0Z"
            />
            <path
              class="cls-111"
              d="M813.37,474.43c0-.73-.09-1.45,0-2.18h-.12A9.89,9.89,0,0,0,813.37,474.43Z"
            />
            <path
              class="cls-111"
              d="M813.5,481.92c0-.62,0-1.25,0-1.87a.3.3,0,0,0-.13.34A5.62,5.62,0,0,0,813.5,481.92Z"
            />
            <path
              class="cls-115"
              d="M814.82,482.41c-.16.25,0,.51-.07.77v.5h.1Z"
            />
            <path
              class="cls-114"
              d="M814.78,474.9c-.08,0-.22,0-.2.11s.12.07.2.08Z"
            />
            <path
              class="cls-111"
              d="M813.51,482.6l0-.49A.44.44,0,0,0,813.51,482.6Z"
            />
            <path class="cls-111" d="M813.55,484v-.4A.3.3,0,0,0,813.55,484Z" />
            <path
              class="cls-111"
              d="M813.53,483.36v-.15Q813.43,483.3,813.53,483.36Z"
            />
            <path
              class="cls-114"
              d="M809.71,472.55c-.06-.18.1-.49-.34-.47-.24,0-.36.07-.35.33,0,1.17,0,2.35,0,3.52,0,.38.07.6.55.48a1.64,1.64,0,0,1,.23,0l0-.17a.28.28,0,0,1-.09-.23c0-.85-.05-1.71-.08-2.57a.31.31,0,0,1,.09-.27Z"
            />
            <path
              class="cls-114"
              d="M809.93,480.48c0-.17,0-.37-.28-.31s-.46,0-.45.35c0,1.18.07,2.37.11,3.56,0,.14,0,.35.27.24s.24-.5.26-.79c.06-.91,0-1.83,0-2.74A.39.39,0,0,1,809.93,480.48Z"
            />
            <path
              class="cls-109"
              d="M809.71,472.55v.6l.08,3.07,0,.17c.23,0,.26-.13.26-.31,0-1.25-.08-2.5-.11-3.75Z"
            />
            <path
              class="cls-116"
              d="M809.93,480.48a.39.39,0,0,0-.09.31c0,.91.06,1.83,0,2.74,0,.29,0,.57-.26.79.25,0,.47,0,.46-.33C810,482.82,810,481.65,809.93,480.48Z"
            />
            <path class="cls-117" d="M805.19,478.13a2.69,2.69,0,0,0,0,1.35Z" />
            <path
              class="cls-110"
              d="M828.42,476.12a8.55,8.55,0,0,0-.08,2.26c.95,0,1.9-.05,2.85.05.09,0,.18.09.27,0-.07-.76,0-1.53,0-2.29l-.08,0A24.69,24.69,0,0,1,828.42,476.12Z"
            />
            <path
              class="cls-110"
              d="M831.74,469.14c-1,0-2.1.08-3.15.12a9.08,9.08,0,0,0-.07,1.73c0,.28.24.16.37.16l2.73-.06.07,0Z"
            />
            <path
              class="cls-117"
              d="M828.48,471.58c0-.3.19-.34.45-.34l2.69-.07c.1.06,0,.11,0,.17H831c-.26,0-.24.19-.26.34s.13.18.27.18h.51v.21c-.17,0-.34,0-.5,0s-.28,0-.27.14a.23.23,0,0,0,.28.21h.41c.08.15,0,.15-.15.16s-.4-.05-.57.09c0,.85-.08,1.7-.11,2.54a.83.83,0,0,1-.07.38l-.12-.11c0-.86,0-1.72.07-2.57,0-.13.06-.27-.15-.3l-1.43,0c-.21,0-.25.07-.27.28a7.61,7.61,0,0,0,.07,1.72l0-.85c.38.3.47.75.79,1.06v.32a.25.25,0,0,0,0,.07l0,0v.16c-.11.15-.17.37,0,.45a1,1,0,0,0,.85,0l.2-.1a1.26,1.26,0,0,1,.81-.3c.15,0,.09-.21.1-.33l.12-2.27h.14l-.08,3.05-.44-.09.19.26a24.69,24.69,0,0,1-3,0C828.35,474.61,828.58,473.1,828.48,471.58Zm1.4.51c-.33-.07-.65.12-1,0a.16.16,0,0,0-.2.17c0,.14,0,.23.2.23l.73,0h.64c.1,0,.23,0,.25-.12s0-.26-.16-.29h-.47Zm-.89-.68c-.17,0-.24.09-.24.24s.07.27.27.26l.59,0h.68c.21,0,.24-.13.23-.29s-.09-.22-.26-.21l-.68,0Z"
            />
            <path
              class="cls-117"
              d="M828.21,481.6a5.5,5.5,0,0,1,1.21.16l-.08.36c-.07.07-.11.2,0,.21.26,0,.57.21.76-.14l0-.4.21.06c0,.67,0,1.35,0,2,0,.1-.12.32.17.28l.4.1.09.11c-.9,0-1.8-.07-2.7-.14Zm1.79,1.47c0-.2-.15-.25-.35-.26s-.29.11-.29.3a1.91,1.91,0,0,1,0,.63c-.05.15-.06.32.19.34s.42,0,.48-.21a3.59,3.59,0,0,0,0-.46h0C830,483.29,830,483.18,830,483.07Z"
            />
            <path
              class="cls-117"
              d="M831.09,478.6h-.41c-.11,0-.26,0-.25.16s0,.26.22.26a5,5,0,0,0,.55,0,.26.26,0,0,1-.17.24.88.88,0,0,0-.48,0,.17.17,0,0,0-.17.08l-1.42-.11c-.17,0-.45-.1-.48.1s.29.19.44.19c.57,0,1.15,0,1.72,0l.19.06h.2a.2.2,0,0,1,.09.18l-.08,0c-.48-.09-.72.08-.7.54s0,.9,0,1.35l-.28,0c0-.53,0-1,0-1.57a.36.36,0,0,0-.4-.42c-.35,0-.71,0-1.06,0-.19,0-.23.12-.22.26a9.78,9.78,0,0,1-.05,1.53h-.1c-.08-1,0-2,.05-3,.95,0,1.9-.05,2.85.05Zm-1,.44c.16,0,.14-.13.16-.22s-.05-.19-.18-.19c-.43,0-.85-.11-1.28-.06-.16,0-.27.05-.27.22s.13.2.29.21l.93.05Z"
            />
            <path
              class="cls-114"
              d="M826,472.87a.53.53,0,0,0-.64,0c0,.88,0,1.76,0,2.64l.59-.11c0-.49,0-1,0-1.47A3.09,3.09,0,0,1,826,472.87Z"
            />
            <path
              class="cls-114"
              d="M826.36,475.3a.83.83,0,0,0,.56,0c.1-.82-.06-1.64.11-2.46a.56.56,0,0,0-.63,0c-.08.22.1.41.05.63A8.09,8.09,0,0,0,826.36,475.3Z"
            />
            <path
              class="cls-114"
              d="M827.74,471.72a.31.31,0,0,0-.24-.1c-.66,0-1.32,0-2,0-.22,0-.38,0-.4.29s.18.29.38.29l2,0Z"
            />
            <path
              class="cls-117"
              d="M826.36,475.3a8.09,8.09,0,0,1,.09-1.84c0-.22-.13-.41-.05-.63-.12.1-.24.21-.39,0a3.09,3.09,0,0,0-.07,1.05c0,.49,0,1,0,1.47C826,475.21,826.22,475.36,826.36,475.3Z"
            />
            <path
              class="cls-110"
              d="M826.62,481.52v-.16l-.32-.16c-.16,0-.33,0-.45-.09-.33.18-.38-.33-.67-.24,0,.26-.18.27-.39.26s-.36,0-.36.23.19.18.34.19a.66.66,0,0,1,.5.16h0l.08,0,.14-.07.35-.05a.55.55,0,0,1,.4.06Z"
            />
            <path
              class="cls-114"
              d="M827.5,479a10.91,10.91,0,0,0-2.34.47c-.16,0-.2.13-.15.26s.16,0,.25,0a4.72,4.72,0,0,0,1.7-.42c.12-.06.32,0,.48,0Z"
            />
            <path
              class="cls-114"
              d="M825.36,481.68l-.08,0c.12.45-.08.92,0,1.38.21,0,.45,0,.54-.28a7.46,7.46,0,0,0,0-1.25l-.35.05Z"
            />
            <path
              class="cls-110"
              d="M827.74,471.72l-.19.4,0,.68c.09.82-.1,1.65,0,2.47.13,0,.16-.1.17-.21,0-1.06.06-2.13.08-3.19A.34.34,0,0,0,827.74,471.72Z"
            />
            <path
              class="cls-114"
              d="M826.31,481.2l.32.16.18,0c.13-.44,0-.91.13-1.35a.64.64,0,0,0-.65.2C826.3,480.52,826.3,480.86,826.31,481.2Z"
            />
            <path
              class="cls-113"
              d="M831.62,471.17c.1.06,0,.11,0,.17s.17.07.17.11c0,.59.43.39.77.3,0-.22.06-.44.1-.65l-1,0-.07,0Z"
            />
            <path
              class="cls-114"
              d="M826.62,481.52l-.37.1,0,1.18a1.36,1.36,0,0,1,.51-.18c0-.36,0-.72,0-1.08Z"
            />
            <path
              class="cls-117"
              d="M827.56,475.27c-.09-.82.1-1.65,0-2.47l-.17,0c-.14.82,0,1.65-.12,2.47A.19.19,0,0,0,827.56,475.27Z"
            />
            <path
              class="cls-117"
              d="M826.29,482.8l0-1.18a.55.55,0,0,0-.4-.06,7.46,7.46,0,0,1,0,1.25C826,482.79,826.14,483,826.29,482.8Z"
            />
            <path
              class="cls-114"
              d="M827.28,475.29c.12-.82,0-1.65.12-2.47-.08-.09-.15-.07-.22,0l-.09,2.45Z"
            />
            <path
              class="cls-114"
              d="M825.19,480.87c.29-.09.34.42.67.24,0-.28-.07-.57.08-.83a1.42,1.42,0,0,0-1,.49C825,480.9,825.11,480.86,825.19,480.87Z"
            />
            <path
              class="cls-117"
              d="M827.09,475.29l.09-2.45H827c-.17.82,0,1.64-.11,2.46Z"
            />
            <path
              class="cls-117"
              d="M825.94,480.28c-.15.26,0,.55-.08.83.12.13.29.09.45.09,0-.34,0-.68,0-1Z"
            />
            <path
              class="cls-117"
              d="M825.33,475.5c0-.88,0-1.76,0-2.64a.41.41,0,0,0-.19.4,13.24,13.24,0,0,1,0,2C825.14,475.33,825,475.56,825.33,475.5Z"
            />
            <path
              class="cls-110"
              d="M827.5,479l-.06.32,0,.68c.09.45-.06.92.13,1.36,0-.64,0-1.27.05-1.91A.64.64,0,0,0,827.5,479Z"
            />
            <path
              class="cls-117"
              d="M827.53,481.32c-.19-.44,0-.91-.13-1.36h-.09c-.11.15-.06.33-.07.49s.09.57-.11.82c.09.16.26.13.41.12A.17.17,0,0,0,827.53,481.32Z"
            />
            <path
              class="cls-114"
              d="M827.13,481.27c.2-.25.08-.54.11-.82s0-.34.07-.49c-.11-.23-.19-.09-.27,0v1.28Z"
            />
            <path
              class="cls-117"
              d="M825.29,483.09c-.09-.46.11-.93,0-1.38h0l-.16.11,0,1.26Z"
            />
            <path
              class="cls-117"
              d="M827,481.26V480h-.1c-.16.44,0,.91-.13,1.35C826.9,481.36,827,481.45,827,481.26Z"
            />
            <path
              class="cls-114"
              d="M825.09,483.08l0-1.26H825a4.42,4.42,0,0,0,0,1.31h0A.18.18,0,0,0,825.09,483.08Z"
            />
            <path
              class="cls-121"
              d="M827.55,481.58c-.19,0-.21.14-.19.27s-.07.47.08.7a2.29,2.29,0,0,0,.11-1Z"
            />
            <path
              class="cls-117"
              d="M826.82,481.54c0,.36,0,.72,0,1.08.16,0,.22-.09.18-.22a.9.9,0,0,1,.06-.49C827,481.78,827.23,481.49,826.82,481.54Z"
            />
            <path
              class="cls-114"
              d="M825.46,472.47c0,.13.15.12.26.12s.24,0,.22-.15-.14-.1-.23-.1S825.49,472.34,825.46,472.47Z"
            />
            <path
              class="cls-114"
              d="M826.49,472.47c0,.12.16.1.26.09s.23,0,.18-.17-.18-.07-.27-.07S826.47,472.35,826.49,472.47Z"
            />
            <path
              class="cls-116"
              d="M830.07,481.59c0-.53,0-1,0-1.57a.36.36,0,0,0-.4-.42c-.35,0-.71,0-1.06,0-.19,0-.23.12-.22.26a9.78,9.78,0,0,1-.05,1.53A11.83,11.83,0,0,0,830.07,481.59Z"
            />
            <path
              class="cls-117"
              d="M831.48,476.13c0,.76-.09,1.53,0,2.29a2.28,2.28,0,0,1,.82-.1c.26-.1.24-.32.25-.51.06-1.67-.09-3.35,0-5h-.12c-.13.9,0,1.82-.24,2.71.19.45.16.5-.35.51l-.18,0Z"
            />
            <path
              class="cls-117"
              d="M831.69,471.06l1,0c.15-.05.15-.16.15-.28,0-.42,0-.84.05-1.26,0-.24,0-.38-.34-.37s-.52,0-.78-.05Z"
            />
            <path
              class="cls-114"
              d="M831.28,481.88a.34.34,0,0,0,.26,0,1.36,1.36,0,0,0,.37-1.1,6.39,6.39,0,0,1,.13-1.38c-.24.05-.53,0-.66.28Z"
            />
            <path
              class="cls-116"
              d="M831,479.72c-.48-.09-.72.08-.7.54s0,.9,0,1.35l.25.09.12.05.19,0C831.07,481.1,830.88,480.4,831,479.72Z"
            />
            <path
              class="cls-116"
              d="M831.94,482.29a1.44,1.44,0,0,0-.65-.11,4.86,4.86,0,0,0,0,1.7h.54l.1-.12v-.11A2.81,2.81,0,0,1,831.94,482.29Z"
            />
            <path
              class="cls-115"
              d="M831.73,472.89h-.14c-.22-.34-.57-.09-.85-.16.17-.14.38-.07.57-.09s.23,0,.15-.16c.1-.12.19-.24.08-.39v-.21a.84.84,0,0,0,.08-.54h0c.06,0,.17.07.17.11,0,.59.43.39.77.3.17.34,0,.69,0,1h-.12C832.17,472.64,831.92,472.58,831.73,472.89Zm.39-.45c.15,0,.29,0,.26-.21s-.17-.13-.29-.13-.24,0-.24.19S832,472.44,832.12,472.44Z"
            />
            <path
              class="cls-116"
              d="M830.27,481.85c0,.67,0,1.35,0,2,0,.1-.12.32.17.28,0-.33,0-.67,0-1s.07-.29.29-.29.27.1.27.26,0,.34,0,.51a6.82,6.82,0,0,0,.09-1.49l0,0,0,0c-.13,0-.27,0-.4,0s-.24-.13-.11-.28Z"
            />
            <path
              class="cls-117"
              d="M832,479.44a6.39,6.39,0,0,0-.13,1.38,1.36,1.36,0,0,1-.37,1.1c.49.24.53.23.55-.27l.09-2.45a.66.66,0,0,0,0-.37c-.14.12-.07.28-.11.42A1.11,1.11,0,0,1,832,479.44Z"
            />
            <path
              class="cls-114"
              d="M832,479.25c0-.14,0-.3.11-.42h0l.08-.09a.64.64,0,0,1,.08-.43,2.28,2.28,0,0,0-.82.1c-.09.1-.18,0-.27,0l-.1.17c0,.12,0,.25.1.34s0-.13.09-.12.09.12.1.2.27-.14.41,0c0,.17-.34.11-.33.34Z"
            />
            <path
              class="cls-117"
              d="M831.28,481.88c0-.72.06-1.44.1-2.16h-.16a12.57,12.57,0,0,0-.13,2.13Z"
            />
            <path
              class="cls-117"
              d="M831.06,482.14a6.82,6.82,0,0,1-.09,1.49.56.56,0,0,0-.08.44c.26.15.25-.12.37-.19a4.86,4.86,0,0,1,0-1.7C831.23,482.1,831.17,482,831.06,482.14Z"
            />
            <path
              class="cls-114"
              d="M831.09,481.84a12.57,12.57,0,0,1,.13-2.13h-.1l-.08,0c-.16.68,0,1.38-.13,2.06Z"
            />
            <path class="cls-121" d="M830.08,482.19l0-.4-.64,0-.08.36Z" />
            <path
              class="cls-117"
              d="M831.94,482.29a2.81,2.81,0,0,0-.05,1.35l.1,0a4.3,4.3,0,0,0,0-1.29s0,0,0,0A.06.06,0,0,0,831.94,482.29Z"
            />
            <path
              class="cls-121"
              d="M830.55,481.91c-.13.15-.12.26.11.28s.27,0,.4,0C831,481.92,830.73,482,830.55,481.91Z"
            />
            <path class="cls-114" d="M830.72,481.75l-.12-.05Z" />
            <path class="cls-115" d="M832.2,478.75l-.08.09Z" />
            <path
              class="cls-116"
              d="M779.4,482.1a19.24,19.24,0,0,1,.14,2.15c0,.18.12.22.26.24s.55.06.82.08.2-.06.18-.18a17.24,17.24,0,0,1-.24-2.15c0-.14,0-.35-.27-.34s-.57-.16-.86,0C779.33,481.91,779.36,482,779.4,482.1Z"
            />
            <path
              class="cls-114"
              d="M781.85,484.14c.29.06.13.31.26.54,0-.24,0-.49.29-.47.13,0,.11-.11.1-.19-.06-.59-.08-1.18-.17-1.77-.06-.39-.45-.28-.73-.31C781.57,482.69,781.84,483.4,781.85,484.14Z"
            />
            <path
              class="cls-116"
              d="M778.52,482.27a17.39,17.39,0,0,1,.23,1.82c.06.32.25.31.48.31s.11-.23.11-.34c0-.62-.1-1.24-.16-1.86,0-.15,0-.32-.18-.4a.41.41,0,0,0-.36,0C778.43,481.89,778.55,482.08,778.52,482.27Z"
            />
            <path
              class="cls-116"
              d="M781.85,484.14c0-.74-.28-1.45-.25-2.2-.24,0-.42,0-.38.3a17.87,17.87,0,0,1,.17,2.07c0,.1,0,.22.16.22s.09-.13.13-.19S781.79,484.21,781.85,484.14Z"
            />
            <path
              class="cls-116"
              d="M781.28,484.48c-.09-.83-.16-1.56-.24-2.29,0-.13-.06-.32-.26-.28s0,.21,0,.33a10.38,10.38,0,0,1,.16,1.76,1.48,1.48,0,0,0,.07.42c0,.1,0,.25.22.21A.11.11,0,0,0,781.28,484.48Z"
            />
            <path
              class="cls-116"
              d="M780,481.31c.2-.05.44.05.44-.19s-.24-.15-.39-.17a5.17,5.17,0,0,0-.55-.07c-.1,0-.24,0-.26.11s.06.21.21.24Z"
            />
            <path
              class="cls-116"
              d="M782.21,481.07a.31.31,0,0,1-.28-.09c-.21,0-.43,0-.64,0s-.25.18-.09.26a1.46,1.46,0,0,0,1,.07C782.27,481.31,782.22,481.16,782.21,481.07Z"
            />
            <path
              class="cls-116"
              d="M781.71,481.49c-.18.07-.51-.07-.51.14s.32.13.5.14.56.14.56-.15S781.9,481.56,781.71,481.49Z"
            />
            <path
              class="cls-116"
              d="M780,481.73c.15,0,.36,0,.37-.13s-.22-.12-.35-.14a5.14,5.14,0,0,0-.55-.06c-.09,0-.2,0-.22.1s.08.13.18.15Z"
            />
            <path
              class="cls-116"
              d="M778.41,481.51c.26.11.42.21.6.09a.09.09,0,0,0,0-.15A.64.64,0,0,0,778.41,481.51Z"
            />
            <path
              class="cls-114"
              d="M782.54,484.66s0-.06,0-.07a.27.27,0,0,0-.08-.07.36.36,0,0,0,0,.1S782.52,484.65,782.54,484.66Z"
            />
            <path
              class="cls-116"
              d="M781.5,490.7a5.82,5.82,0,0,1-.16-1.49c0-.23-.15-.27-.36-.28s-.58-.06-.87-.09l0,.75a2.94,2.94,0,0,0,.1.88c.06.17-.08.42.16.49a2.86,2.86,0,0,0,1,.13C781.6,491.07,781.41,490.82,781.5,490.7Z"
            />
            <path
              class="cls-116"
              d="M779.55,488.73a1.23,1.23,0,0,0,0,.66c.06.14,0,.27-.16.36,0,.19,0,.39,0,.59.34.05.27.29.29.5.28,0,.39-.08.37-.33l-.15-1.5C779.91,488.79,779.75,488.74,779.55,488.73Z"
            />
            <path
              class="cls-114"
              d="M783,491.19c-.05-.51-.1-1-.17-1.54a1.46,1.46,0,0,1,0-.42.69.69,0,0,0-.47-.06,5.65,5.65,0,0,1,.12,1.36v.16c.19.15.06.56.5.5Z"
            />
            <path
              class="cls-116"
              d="M780.2,488.29c-.23.27-.41-.08-.64-.08s-.31,0-.35.12.13.21.27.21a10.87,10.87,0,0,1,1.41.19c.12,0,.27.06.31-.09s-.1-.22-.24-.24S780.48,488.33,780.2,488.29Z"
            />
            <path
              class="cls-116"
              d="M781.78,491.15a8.05,8.05,0,0,0,0-1.9c0-.12,0-.23-.21-.22a.15.15,0,0,0-.15.18C781.62,489.85,781.45,490.53,781.78,491.15Z"
            />
            <path
              class="cls-116"
              d="M782.7,489c.09,0,.22,0,.26-.11s0-.19-.15-.23a3,3,0,0,0-1.22-.13.15.15,0,0,0-.16.17s.05.12.09.12C781.91,488.87,782.3,488.92,782.7,489Z"
            />
            <path
              class="cls-116"
              d="M782.48,490.53a5.65,5.65,0,0,0-.12-1.36l-.28-.08a5.69,5.69,0,0,0,.13,1.42Z"
            />
            <path
              class="cls-115"
              d="M782.21,490.51a5.69,5.69,0,0,1-.13-1.42c-.11,0-.19.08-.17.17.18.63,0,1.29.24,1.91,0,0,.05.07.08.1v-.15Z"
            />
            <path
              class="cls-116"
              d="M782.23,491.12v.15c.25,0,.54.29.75-.08-.44.06-.31-.35-.5-.5C782.22,490.75,782.4,491,782.23,491.12Z"
            />
            <path
              class="cls-115"
              d="M779.71,490.84c0-.21,0-.45-.29-.5C779.45,490.54,779.34,490.8,779.71,490.84Z"
            />
            <path
              class="cls-116"
              d="M779.94,476.51c0-.3-.08-.73-.12-1.17,0-.17-.1-.24-.29-.26-.94-.1-1.15.1-1,.95a9.56,9.56,0,0,1,.17,1.05c0,.23.1.34.36.32h0C780,477.41,780,477.41,779.94,476.51Z"
            />
            <path
              class="cls-116"
              d="M781,476.06c-.1.23,0,.47-.11.69s-.08.27-.09.4,0,.18-.15.18a.13.13,0,0,1-.11-.16,9.41,9.41,0,0,0-.16-1.58c0-.55,0-.55.55-.54.05.2-.11.56.23.54s.09-.35.13-.54c.33,0,.35.2.37.39.07.51.12,1,.15,1.56,0,.15.09.38-.18.41s-.55.14-.65-.22A1.82,1.82,0,0,0,781,476.06Zm.33.92c.11,0,.18,0,.15-.15s0-.2-.17-.22-.12.09-.14.13S781.19,477,781.33,477Zm-.08-.83a.16.16,0,0,0,.17.15c.11,0,.18-.05.15-.16a.17.17,0,0,0-.19-.13A.13.13,0,0,0,781.25,476.15Z"
            />
            <path
              class="cls-116"
              d="M777.68,475.61a9.42,9.42,0,0,1,.16,1.3c0,.27.13.57.53.48s.18-.37.16-.57a9.83,9.83,0,0,1-.19-1.34c0-.26-.1-.37-.41-.36S777.68,475.34,777.68,475.61Z"
            />
            <path
              class="cls-116"
              d="M777.66,474.53l-.09.17c.11.32.4.28.65.22a4.68,4.68,0,0,1,1.24-.06c.12,0,.3.1.3-.11a.25.25,0,0,0-.3-.25Z"
            />
            <path
              class="cls-116"
              d="M780.6,473.87l-.59,0c-.13,0-.22.05-.21.17s0,.16.06.19.19,0,.26-.08,0-.18.13-.05c.29.35.67.12,1,.13.13,0,.2-.11.18-.25s-.12-.15-.24-.14Z"
            />
            <path
              class="cls-116"
              d="M780.32,477.35a11.69,11.69,0,0,0-.07-2c0-.1,0-.3-.23-.25s-.06.18,0,.28a14.76,14.76,0,0,0,.17,1.63C780.17,477.12,780.12,477.23,780.32,477.35Z"
            />
            <path
              class="cls-116"
              d="M779.05,474.34c.2-.11.63.14.61-.24s-.42-.18-.64-.18-.62-.15-.61.22S778.83,474.25,779.05,474.34Z"
            />
            <path
              class="cls-116"
              d="M780.88,474.88h.37c.13,0,.3,0,.3-.19s-.16-.21-.3-.22h-.65c-.16,0-.33,0-.33.21s.16.22.33.21Z"
            />
            <path
              class="cls-116"
              d="M777.64,473.94c0,.14-.16.28,0,.42s.33,0,.44,0,.2-.29-.08-.38c-.06.07-.12.06-.18,0Z"
            />
            <path
              class="cls-114"
              d="M780.93,475.05c.05.2-.11.56.23.54s.09-.35.13-.54Z"
            />
            <path
              class="cls-114"
              d="M781,477.19a1.82,1.82,0,0,0,0-1.13c-.1.23,0,.47-.11.69A.68.68,0,0,0,781,477.19Z"
            />
            <path
              class="cls-116"
              d="M779.9,474.69c0,.09,0,.18.14.18s.13-.1.12-.19,0-.17-.14-.17S779.9,474.6,779.9,474.69Z"
            />
            <path class="cls-115" d="M777.82,473.94c.06.06.12.07.18,0Z" />
            <path
              class="cls-117"
              d="M783.72,491.26a.58.58,0,0,0,0-.6A.54.54,0,0,0,783.72,491.26Z"
            />
            <path
              class="cls-116"
              d="M788.52,484.87c-.07-1.07-.16-2.26-.25-3.44,0-.27-.12-.42-.45-.42s-.71,0-1.06-.05-.35.06-.32.33c.14,1.18.26,2.36.34,3.54,0,.43.22.54.62.54a3.4,3.4,0,0,1,.64,0C788.46,485.48,788.65,485.4,788.52,484.87Z"
            />
            <path
              class="cls-114"
              d="M789.14,485.51a.85.85,0,0,0,.56-.19c0-.36-.14-.7-.11-1.05s-.28-.9.12-1.31c-.23-.24-.4-.48-.05-.76,0,0-.07-.1-.14-.14s-.14-.2-.08-.25c.22-.19.08-.47.22-.67h0s0-.06,0-.08c-.27-.18-.56,0-.84-.07l-.09.09c.24,1.46.25,3,.4,4.42Z"
            />
            <path
              class="cls-116"
              d="M789.14,485.51c-.15-1.47-.16-3-.4-4.42-.19-.09-.3,0-.28.16.07.9.11,1.8.22,2.69.05.41.06.82.07,1.22C788.76,485.41,788.85,485.54,789.14,485.51Z"
            />
            <path
              class="cls-116"
              d="M787.68,480.78c.18-.07.47.18.48-.21s-.24-.31-.49-.32l-1-.05c-.19,0-.32.05-.31.26s.11.24.3.25S787.36,480.75,787.68,480.78Z"
            />
            <path
              class="cls-116"
              d="M787.56,480h.28c.15,0,.28,0,.29-.2a.25.25,0,0,0-.24-.27c-.42,0-.85-.06-1.28-.08a.22.22,0,0,0-.25.24c0,.15.06.25.24.26l1,.08Z"
            />
            <path
              class="cls-114"
              d="M788.81,480.83l.54-.1c.26-.06.2-.26.18-.42s-.19-.11-.31-.1l-.51,0h0l0,.58Z"
            />
            <path
              class="cls-116"
              d="M788.73,480.81l0-.58c-.17,0-.36,0-.34.24A.33.33,0,0,0,788.73,480.81Z"
            />
            <path
              class="cls-116"
              d="M788.66,479.53c-.15,0-.34,0-.33.24s.19.25.36.3l0,0,0-.5Z"
            />
            <path
              class="cls-116"
              d="M789,479.46h-.25l0,.08,0,0C788.78,479.54,788.89,479.54,789,479.46Z"
            />
            <path
              class="cls-116"
              d="M788.53,477.69l0-.11c-.13-1.46-.26-2.93-.4-4.39h0c-.36,0-.3.24-.26.43.18.93.08,1.89.25,2.83.07.4.09.81.13,1.22Z"
            />
            <path
              class="cls-120"
              d="M796.3,491.89l.77.06a3.71,3.71,0,0,0,1.29-.2c0-.47,0-.93-.05-1.39a3.38,3.38,0,0,1,0-.45c0-.19-.13-.42.16-.54l.09-.18c-.64-.17-1.32-.17-2-.29-.33-.06-.48,0-.45.34s.12.53-.06.78c0,0,0,.05,0,.07A4.8,4.8,0,0,1,796.3,491.89Z"
            />
            <path
              class="cls-116"
              d="M796.07,490.09s0,0,0-.07c-.17-.18-.1-.41-.11-.61a.57.57,0,0,0-.62-.63c-.27,0-.32.07-.28.3.07.44.13.89.19,1.34,0,.19,0,.44.22.51s.41-.13.53-.32S795.94,490.25,796.07,490.09Z"
            />
            <path
              class="cls-119"
              d="M794.62,492.54l.16-.06c0-.39.25-.19.41-.21s.32.07.3.27.08.4-.16.44-.47,0-.6-.2Zm.57-.09a.1.1,0,0,0-.14.07c-.06.17.14.17.21.3C795.32,492.65,795.34,492.53,795.19,492.45Z"
            />
            <path
              class="cls-119"
              d="M793.43,492.46l.11.35a1.11,1.11,0,0,0,.57.07l0-.33-.05-.35-.14-.07-.2-.09c0,.17,0,.34-.25.34A.19.19,0,0,0,793.43,492.46Z"
            />
            <path
              class="cls-109"
              d="M794.09,492.55l0,.33a.84.84,0,0,0,.47.08l.15-.18a2.56,2.56,0,0,0-.11-.24c-.22,0-.16-.15-.17-.27s-.15-.11-.26-.07S794.21,492.45,794.09,492.55Z"
            />
            <path
              class="cls-110"
              d="M794.58,493a.84.84,0,0,1-.47-.08,1.11,1.11,0,0,1-.57-.07h-.27l0,.16,1.35.18Z"
            />
            <path
              class="cls-113"
              d="M793.45,492.38c.27,0,.26-.17.25-.34C793.26,491.92,793.48,492.23,793.45,492.38Z"
            />
            <path
              class="cls-111"
              d="M794.09,492.55c.12-.1.08-.23.1-.35l0-.07-.12.07Z"
            />
            <path
              class="cls-120"
              d="M794,492.2l.12-.07c-.09-.14-.17-.08-.26,0Z"
            />
            <path
              class="cls-116"
              d="M785.59,472.47a.72.72,0,0,0,.59.15l1.16,0c.18,0,.3-.06.29-.25s-.08-.26-.28-.25l-1.39,0c-.27,0-.33.17-.37.36Z"
            />
            <path
              class="cls-116"
              d="M786.69,473.11h.64c.16,0,.32,0,.31-.22s-.15-.19-.29-.19a10.27,10.27,0,0,0-1.47.09c-.11,0-.17,0-.17.15s.06.2.19.2l.79,0Z"
            />
            <path
              class="cls-116"
              d="M788.1,472H788c-.1.11-.32.13-.26.34a.33.33,0,0,0,.35.26h0c0-.2,0-.4,0-.59Z"
            />
            <path
              class="cls-116"
              d="M788.11,472.65c-.15,0-.27.06-.26.23s.13.2.28.21l0,0c0-.13,0-.27,0-.4Z"
            />
            <path
              class="cls-117"
              d="M835.41,473.47h-.19a7.75,7.75,0,0,0-.16,1.79l0,.11v.24a.4.4,0,0,0,.28-.1C835.34,474.83,835.37,474.15,835.41,473.47Z"
            />
            <path
              class="cls-114"
              d="M834.54,482.18l.1-.09c0-.65.06-1.3.08-1.95h-.25c0,.6-.07,1.2-.11,1.8C834.36,482.06,834.37,482.17,834.54,482.18Z"
            />
            <path
              class="cls-117"
              d="M834.72,480.14c0,.65-.05,1.3-.08,1.95.18,0,.21-.15.27-.26,0-.58.05-1.16.07-1.73Z"
            />
            <path
              class="cls-114"
              d="M835,480.1c0,.57-.05,1.15-.07,1.73h.24c0-.6.05-1.2.08-1.8C835.1,479.91,835,480,835,480.1Z"
            />
            <path
              class="cls-114"
              d="M835.06,475.26a7.75,7.75,0,0,1,.16-1.79c-.27-.16-.25.06-.29.2,0,.65-.07,1.3-.1,1.94H835v-.24Z"
            />
            <path
              class="cls-114"
              d="M835.41,473.47c0,.68-.07,1.36-.11,2h.25a7.84,7.84,0,0,1,.14-2.05A.18.18,0,0,0,835.41,473.47Z"
            />
            <path
              class="cls-117"
              d="M834.54,482.18c-.17,0-.18-.12-.18-.24,0-.6.07-1.2.11-1.8-.31.3-.16.69-.22,1a5.41,5.41,0,0,0,0,.9c0,.07-.09.18,0,.23S834.46,482.26,834.54,482.18Z"
            />
            <path
              class="cls-117"
              d="M835.69,473.46a7.84,7.84,0,0,0-.14,2.05l.13-.19.09-1.85Z"
            />
            <path
              class="cls-114"
              d="M835.77,473.47l-.09,1.85h.13a8.3,8.3,0,0,1,.16-1.86A.12.12,0,0,0,835.77,473.47Z"
            />
            <path
              class="cls-117"
              d="M834.83,475.61c0-.64.06-1.29.1-1.94-.36.21-.13.54-.18.81A1.44,1.44,0,0,0,834.83,475.61Z"
            />
            <path
              class="cls-117"
              d="M835.23,480c0,.6-.06,1.2-.08,1.8A2.78,2.78,0,0,0,835.23,480Z"
            />
            <path
              class="cls-117"
              d="M835.29,482.12a2.75,2.75,0,0,0-1,.45A1.74,1.74,0,0,0,835.29,482.12Z"
            />
            <path
              class="cls-109"
              d="M834.4,483.46a.27.27,0,0,0,.37.16A.27.27,0,0,0,834.4,483.46Z"
            />
            <path class="cls-117" d="M835.58,482l0,0,0,0Z" />
            <path
              class="cls-111"
              d="M833.94,483.31a.3.3,0,0,0-.36-.2c-.18,0-.11.21-.11.33,0,1.93-.2,3.85-.27,5.78,0,.76-.08,1.52-.06,2.28a.6.6,0,0,0,.47-.69c.06-1.44.11-2.88.18-4.32C833.83,485.43,833.89,484.37,833.94,483.31Z"
            />
            <path
              class="cls-115"
              d="M829.88,490.64c-.2.19,0,.48-.19.66.16.18.24.1.28-.07S830,490.83,829.88,490.64Z"
            />
            <path
              class="cls-117"
              d="M834.69,485.92l-.24.1-.12,2,.39-.09h0v-.25A10.82,10.82,0,0,1,834.69,485.92Z"
            />
            <path
              class="cls-114"
              d="M834.33,488.06l.12-2c-.3.05-.27.29-.28.47,0,.42,0,.84-.07,1.26C834.1,487.9,834.14,488,834.33,488.06Z"
            />
            <path
              class="cls-114"
              d="M834.69,485.92a10.82,10.82,0,0,0,0,1.8.86.86,0,0,0,.17-.6,5.19,5.19,0,0,1,0-1.18c0-.06.06-.19-.09-.18S834.74,485.86,834.69,485.92Z"
            />
            <path class="cls-115" d="M834.07,488.41a.18.18,0,0,0,.18-.09Z" />
            <path
              class="cls-116"
              d="M801.25,492.8c0-.31,0-.63,0-.94a.25.25,0,0,1-.29-.25,12.94,12.94,0,0,1-.14-2.15c-.25-.14-.17.23-.36.19v.19a1,1,0,0,1,0,1.1v.34c.08.09,0,.22.08.32.13.37,0,.8.31,1.13A.49.49,0,0,0,801.25,492.8Z"
            />
            <path
              class="cls-117"
              d="M800.75,495c.06-.21.11-.42.17-.63,0-.05,0-.14,0-.15.49-.12.22-.49.3-.75l-.41,0a.36.36,0,0,1-.27.08c.25.31,0,.65.07,1C800.7,494.68,800.57,494.87,800.75,495Z"
            />
            <path
              class="cls-110"
              d="M800.85,493.48l.41,0c0-.22,0-.44,0-.66a.49.49,0,0,1-.36-.07l-.33,0v.18C801,493,800.74,493.31,800.85,493.48Z"
            />
            <path
              class="cls-113"
              d="M800.49,490.94a1,1,0,0,0,0-1.1C800.46,490.2,800.29,490.58,800.49,490.94Z"
            />
            <path
              class="cls-113"
              d="M800.56,492.76l.33,0c-.32-.33-.18-.76-.31-1.13,0-.1,0-.23-.08-.32A6.12,6.12,0,0,0,800.56,492.76Z"
            />
            <path
              class="cls-113"
              d="M800.85,493.48c-.11-.17.11-.49-.29-.54a1.18,1.18,0,0,0,0,.62A.36.36,0,0,0,800.85,493.48Z"
            />
            <path
              class="cls-113"
              d="M800.87,495.23l0,0h0A.08.08,0,0,0,800.87,495.23Z"
            />
            <path
              class="cls-109"
              d="M794.82,487.58l-.05-.08h-.26s0,.05,0,.08v.08Z"
            />
            <path
              class="cls-111"
              d="M794.5,487.59s0,0,0-.08-.11-.1-.14,0S794.44,487.58,794.5,487.59Z"
            />
            <path class="cls-109" d="M792.69,487.19l0,0s0,0-.07,0l0,0Z" />
            <path class="cls-109" d="M792.79,487.39l-.06,0,0,0s0,0,.06,0Z" />
            <path
              class="cls-116"
              d="M798.42,492.25a4.17,4.17,0,0,0-1.26.69l.77.12c.5.08.55.05.53-.44C798.45,492.5,798.43,492.37,798.42,492.25Z"
            />
            <path
              class="cls-120"
              d="M798.66,490h-.16c0,.14,0,.27,0,.41.07.35-.06.71.12,1A5,5,0,0,0,798.66,490Z"
            />
            <path
              class="cls-113"
              d="M798.49,490.36c0-.14,0-.27,0-.41s0-.39,0-.58c-.29.12-.14.35-.16.54a3.38,3.38,0,0,0,0,.45Z"
            />
            <path
              class="cls-109"
              d="M798.6,493.72c0-.16-.11-.18-.25-.12s-.45.08-.39.36l.59-.18Z"
            />
            <path
              class="cls-109"
              d="M797,488a.17.17,0,0,0,.18-.18C797.1,487.79,797,487.84,797,488Z"
            />
            <path
              class="cls-109"
              d="M795.34,487.48h-.19a.23.23,0,0,0,.27.05Z"
            />
            <path
              class="cls-109"
              d="M797.49,488l.18,0s0,0,0,0a.13.13,0,0,0-.15.07Z"
            />
            <path class="cls-109" d="M798.39,487.91l0,0-.06,0,0,0Z" />
            <path
              class="cls-113"
              d="M812.11,491.23c.36-.06.72-.18,1,.09a.18.18,0,0,0,.13,0c.22,0,.56.16.63-.14s-.31-.25-.51-.29c-.43-.08-.88-.12-1.32-.18Z"
            />
            <path
              class="cls-114"
              d="M800.8,489.46a12.94,12.94,0,0,0,.14,2.15.25.25,0,0,0,.29.25,13.27,13.27,0,0,1-.14-2.09C801.08,489.59,801,489.47,800.8,489.46Z"
            />
            <path
              class="cls-116"
              d="M803.76,489.76c.12,0,.32.05.35-.12s-.21-.17-.33-.2a.8.8,0,0,0-.59,0c-.05,0,0,.11,0,.16S803.56,489.75,803.76,489.76Z"
            />
            <path class="cls-114" d="M803.16,490.67l.07-.07Z" />
            <path
              class="cls-117"
              d="M832.36,484c-1.31.39-1.16,1.33-1,2.27l.87-.42s.12-.07.13-.12A3.61,3.61,0,0,0,832.36,484Z"
            />
            <path
              class="cls-115"
              d="M832,483.61l-.1,0v.11l-.1.12h-.54c-.12.07-.11.34-.37.19l-.09.18.09.11a3.14,3.14,0,0,0,1.12-.45Z"
            />
            <path
              class="cls-115"
              d="M829.94,489.11a.64.64,0,0,0,0,.68A.69.69,0,0,0,829.94,489.11Z"
            />
            <path
              class="cls-113"
              d="M825.51,486.32a8.21,8.21,0,0,0,2,.19A6.9,6.9,0,0,0,825.51,486.32Z"
            />
            <path
              class="cls-113"
              d="M827.67,485.67l.88,0v0l-1.27-.11c.14.14.32.06.39.18Z"
            />
            <path
              class="cls-113"
              d="M828.44,485.46l.63,0A.77.77,0,0,0,828.44,485.46Z"
            />
            <path class="cls-113" d="M828.13,485.35h-.34v0l.36,0Z" />
            <path
              class="cls-113"
              d="M829.51,485.53l.08,0s-.05,0-.08,0l-.07,0Z"
            />
            <path class="cls-113" d="M829.15,485.64l-.07,0,.09,0s0,0,.06,0Z" />
            <path
              class="cls-116"
              d="M796.89,483.18c0-.69-.18-1.37-.15-2.07,0-.3-.21-.35-.45-.37a12.92,12.92,0,0,1-1.39-.05c-.24-.05-.34.09-.29.3.2.82,0,1.67.22,2.49.06.31.18.42.5.42a9.55,9.55,0,0,1,1.2.09c.36.06.4-.08.37-.34S796.89,483.34,796.89,483.18Z"
            />
            <path
              class="cls-116"
              d="M799.58,483c-.05-.61-.1-1.21-.14-1.82,0-.21-.1-.28-.33-.31a2.36,2.36,0,0,0-1.32,0c-.4.22,0,.73-.09,1.12a5.32,5.32,0,0,0,0,.89c0,.12,0,.26.15.33.47.2.23.35-.12.5.58.31,1.17.08,1.72.21.12,0,.13-.13.13-.23a4.86,4.86,0,0,1-1-.06c-.14,0-.31,0-.27-.2s.18-.13.3-.11a5.25,5.25,0,0,0,1,0l-.09-.18-1.15-.09C798.77,482.88,799.17,483.08,799.58,483Z"
            />
            <path
              class="cls-116"
              d="M794.65,483.11a15,15,0,0,1-.15-2.11c0-.42-.35-.36-.63-.38s-.31.21-.3.41c0,.76.1,1.52.17,2.28a.5.5,0,0,0,.21.45.69.69,0,0,0,.58.05c.2-.06.12-.23.13-.36A1.9,1.9,0,0,0,794.65,483.11Z"
            />
            <path
              class="cls-116"
              d="M797.63,483.25c0-.17-.19-.16-.38-.23.28-.12.35-.24.3-.5a10.09,10.09,0,0,1-.07-1.35c0-.19,0-.39-.3-.38s-.26.19-.26.37a17.85,17.85,0,0,0,.23,2.86c.13-.23.41-.2.49-.42-.13,0-.34,0-.35-.17S797.5,483.27,797.63,483.25Z"
            />
            <path
              class="cls-116"
              d="M796,480.57h.42c.12,0,.25,0,.25-.15s0-.3-.21-.27c-.64.11-1.3-.23-1.93.07-.13.06-.1,0-.14-.08-.23-.2-.49-.1-.75-.08-.1,0-.13.1-.13.19s.13.2.28.21l2.21.13Z"
            />
            <path
              class="cls-116"
              d="M799.41,479.82s0-.11-.07-.11c-.6,0-1.22-.3-1.81.05,0,.3.28.3.51.32s.77,0,1.15,0S799.37,479.93,799.41,479.82Z"
            />
            <path
              class="cls-116"
              d="M799.18,480.66c.12.07.21,0,.23-.09s0-.28-.2-.29c-.49,0-1-.06-1.48-.08a.16.16,0,0,0-.17.16.24.24,0,0,0,.19.26,2,2,0,0,0,.64.06Z"
            />
            <path
              class="cls-121"
              d="M799.59,483.38a5.25,5.25,0,0,1-1,0c-.12,0-.27-.05-.3.11s.13.18.27.2a4.86,4.86,0,0,0,1,.06Z"
            />
            <path
              class="cls-116"
              d="M796.91,480.4c0,.17.1.22.27.22s.27,0,.27-.21-.11-.22-.27-.22S796.91,480.23,796.91,480.4Z"
            />
            <path
              class="cls-121"
              d="M799.58,483c-.41.05-.81-.15-1.23.08l1.15.09Z"
            />
            <path
              class="cls-116"
              d="M797.44,479.76c-.21-.26-.42-.11-.63,0,0,.23.17.26.37.26A.23.23,0,0,0,797.44,479.76Z"
            />
            <path
              class="cls-121"
              d="M799.9,483.76c.14,0,.33.08.32-.15s-.19-.16-.34-.14Z"
            />
            <path
              class="cls-121"
              d="M797.63,483.25c-.13,0-.34,0-.34.18s.22.14.35.17Z"
            />
            <path
              class="cls-115"
              d="M794.38,479.83l-.2,0C794.25,479.88,794.33,480,794.38,479.83Z"
            />
            <path
              class="cls-116"
              d="M796,475.62c.44-.26.36-.66.34-1s0-.74,0-1.1-.12-.35-.4-.34c-.53,0-1.08,0-1.62,0-.17,0-.23.07-.2.2.19.8.07,1.63.19,2.44.05.34.18.52.59.46a3.62,3.62,0,0,1,.55.05c.24,0,.52,0,.51-.34-.26-.13-.6,0-.87-.18.19-.13.39,0,.55-.11-.08-.11-.25,0-.33-.12A1.5,1.5,0,0,1,796,475.62Z"
            />
            <path
              class="cls-116"
              d="M798.62,475.65c0-.12.08-.25.22-.24.51,0,.45-.31.4-.58a8.77,8.77,0,0,1-.12-1.53c0-.21-.09-.31-.33-.3-.44,0-.87,0-1.31,0-.23,0-.33.09-.32.31.06.9.12,1.8.17,2.7,0,.08,0,.2.13.2.37,0,.78.16,1.09-.17-.21-.24-.51-.14-.78-.15-.1,0-.25,0-.27-.11s.17-.21.25-.19C798,475.68,798.34,475.51,798.62,475.65Z"
            />
            <path
              class="cls-116"
              d="M793.09,474a12,12,0,0,1,.15,1.9.6.6,0,0,0,.85.42c.11,0,.09-.14.08-.22a22.35,22.35,0,0,1-.17-2.58c0-.32-.25-.27-.47-.26s-.46,0-.46.27C793.08,473.59,793.08,473.71,793.09,474Z"
            />
            <path
              class="cls-116"
              d="M797.11,474.83a11.13,11.13,0,0,0-.13-1.51c0-.17-.07-.27-.27-.27s-.23.08-.25.26c-.1.73.18,1.43.11,2.16,0,.21.34-.12.28.16,0,.12-.05.25-.07.37s0,.25.17.26.2-.11.2-.23C797.14,475.68,797.13,475.32,797.11,474.83Z"
            />
            <path
              class="cls-116"
              d="M796.2,472.05a5.33,5.33,0,0,0-2,0c-.41,0-.87-.13-1.23.19,0,.16,0,.32.28.31s.55.08.64-.36c.21.46.59.35.92.31a6.77,6.77,0,0,1,1-.09C796.14,472.4,796.22,472.27,796.2,472.05Z"
            />
            <path
              class="cls-116"
              d="M799.08,472a3.06,3.06,0,0,0-2,.13c0,.21.14.26.34.25q.64,0,1.29,0C799,472.32,799.1,472.19,799.08,472Z"
            />
            <path
              class="cls-116"
              d="M795.15,472.91l.83,0c.12,0,.22,0,.21-.17s-.11-.16-.22-.16l-1.66,0c-.12,0-.22,0-.21.17s.1.17.22.16Z"
            />
            <path
              class="cls-116"
              d="M798.14,472.84l.69,0c.13,0,.26,0,.24-.19s-.13-.15-.24-.14l-1.43,0c-.13,0-.25,0-.23.19s.12.14.23.14l.74,0Z"
            />
            <path
              class="cls-114"
              d="M796,475.62a1.5,1.5,0,0,0-.73-.06c.08.14.25,0,.33.12-.16.1-.36,0-.55.11.27.18.61,0,.87.18.27-.08.25.17.36.29C796.56,475.89,796,475.87,796,475.62Z"
            />
            <path
              class="cls-114"
              d="M798.62,475.65c-.28-.14-.58,0-.87,0-.08,0-.27.05-.25.19s.17.1.27.11c.27,0,.57-.09.78.15C798.68,476,798.61,475.79,798.62,475.65Z"
            />
            <path
              class="cls-116"
              d="M793.05,472.8c.21.31.52.11.78.13a.08.08,0,0,0,.08-.12.16.16,0,0,0-.17-.11h-.69Z"
            />
            <path
              class="cls-116"
              d="M796.94,472.08c-.18-.25-.39-.11-.59,0,0,.15,0,.32.3.31S797,472.27,796.94,472.08Z"
            />
            <path
              class="cls-116"
              d="M796.42,472.72c0,.15.14.16.26.16s.26,0,.25-.18-.13-.16-.26-.15S796.42,472.56,796.42,472.72Z"
            />
            <path
              class="cls-116"
              d="M799.19,475.71l0,.07s0,0,0-.08,0,0,0-.06Z"
            />
            <path class="cls-115" d="M793.05,472.8v-.09l0,.06Z" />
            <path
              class="cls-117"
              d="M790.09,483.1c0,.62,0,1.25.06,1.87,0,.3.14.36.44.29.77-.17.82-.17.73-.88-.14-1.08-.07-2.17-.26-3.25a1.62,1.62,0,0,0-.1-.18v1.2l0,.31a.4.4,0,0,1,.06.38c.1.21,0,.32-.23.32A2,2,0,0,1,790.09,483.1Z"
            />
            <path
              class="cls-117"
              d="M789.66,481.14c-.14.2,0,.48-.22.67-.06.05,0,.19.08.25s.18.11.14.14c-.35.28-.18.52.05.76-.4.41-.08.88-.12,1.31s.15.69.11,1.05c.28.12.37,0,.36-.23-.07-.8-.08-1.61-.2-2.4A7.31,7.31,0,0,0,789.66,481.14Z"
            />
            <path
              class="cls-114"
              d="M791,481.77V481c-.26-.38-.57,0-.86-.05s-.17.21-.15.34-.12.33,0,.49A3.73,3.73,0,0,1,791,481.77Z"
            />
            <path
              class="cls-114"
              d="M790.87,480a4.17,4.17,0,0,0-.8.09.27.27,0,0,0-.23.35c0,.2.2.18.35.17C790.59,480.59,790.94,480.51,790.87,480Z"
            />
            <path
              class="cls-114"
              d="M790.82,479.33c-.34,0-.7-.07-1,.11,0,.16-.19.4.21.42C790.72,479.91,790.82,479.86,790.82,479.33Z"
            />
            <path
              class="cls-116"
              d="M791.05,482.84a.4.4,0,0,0-.06-.38,4.2,4.2,0,0,0-1-.06v.45Z"
            />
            <path class="cls-116" d="M791,481.77a3.73,3.73,0,0,0-1,0v.43h1Z" />
            <path
              class="cls-114"
              d="M789,479.46c-.06.08-.17.08-.26.09l0,.5c.28-.12.82.05.73-.52C789.3,479.41,789.12,479.46,789,479.46Z"
            />
            <path
              class="cls-114"
              d="M791.05,482.84h-1a.3.3,0,0,0,.09.25,2,2,0,0,0,.73.06C791.07,483.16,791.15,483.05,791.05,482.84Z"
            />
            <path
              class="cls-114"
              d="M791,482.15h-1l0,.24a4.2,4.2,0,0,1,1,.06C791,482.36,791,482.25,791,482.15Z"
            />
            <path class="cls-117" d="M789.67,481.07s0,.05,0,.08l0-.06Z" />
            <path
              class="cls-114"
              d="M788.15,473.19c.14,1.46.27,2.93.4,4.39a.46.46,0,0,0,.39-.1c0-.4,0-.79-.07-1.18s.11-.35.36-.36v-.15c-.15-.05-.37,0-.42-.16s.34-.08.35-.29-.39,0-.4-.26.28-.17.37-.3l-.07-1.46C788.8,473,788.46,473.22,788.15,473.19Z"
            />
            <path
              class="cls-114"
              d="M790.59,474.65a4.56,4.56,0,0,1-.13-1.22c0-.21-.08-.33-.33-.3s-.69-.08-1,.19c0,.4.23.78.1,1.19,0,.15,0,.33.21.38a2.87,2.87,0,0,0,1,0C790.6,474.87,790.59,474.75,790.59,474.65Z"
            />
            <path
              class="cls-117"
              d="M789.51,476c0,.36,0,.71,0,1.06,0,.53.49.34.81.37s.42-.13.4-.41,0-.71,0-1.06Z"
            />
            <path
              class="cls-117"
              d="M790.59,474.65c0,.1,0,.22-.13.24a2.87,2.87,0,0,1-1,0c-.22-.05-.2-.23-.21-.38l-.15.27c-.09.13-.39,0-.37.3s.29.14.4.26-.41,0-.35.29.27.11.42.16h.19l1.3,0c0-.12,0-.25-.1-.35a2,2,0,0,1-1.22,0,1,1,0,0,1-.1-.17c0-.06-.12-.17,0-.19s.08.12.09.19a4.15,4.15,0,0,1,1.22.05A.61.61,0,0,0,790.59,474.65Z"
            />
            <path
              class="cls-117"
              d="M789.23,475.94c-.25,0-.39.1-.36.36s0,.78.07,1.18c.4,0,.56-.09.44-.49S789.44,476.27,789.23,475.94Z"
            />
            <path
              class="cls-114"
              d="M790.43,472.18a1.33,1.33,0,0,0-1.31,0c0,.22.11.38.39.35S790.31,472.69,790.43,472.18Z"
            />
            <path
              class="cls-114"
              d="M789.85,473h.28c.17,0,.31,0,.3-.23s-.15-.19-.3-.18h-.56c-.15,0-.32,0-.32.21s.16.21.32.21Z"
            />
            <path
              class="cls-114"
              d="M788.1,472c0,.19,0,.39,0,.59h.46c.28,0,.4-.1.37-.35C788.72,472,788.39,472.05,788.1,472Z"
            />
            <path
              class="cls-114"
              d="M788.13,472.67c0,.13,0,.27,0,.4h.59c.12,0,.27,0,.27-.15s-.1-.25-.29-.25Z"
            />
            <path
              class="cls-114"
              d="M790.62,475.32a4.15,4.15,0,0,0-1.22-.05v.17a2,2,0,0,0,1.22,0Z"
            />
            <path
              class="cls-116"
              d="M789.13,474.78l.15-.27c.13-.41-.1-.79-.1-1.19h-.12C789.08,473.8,789.11,474.29,789.13,474.78Z"
            />
            <path class="cls-114" d="M790.72,475.76l-1.3,0,.09.16,1.21,0Z" />
            <path
              class="cls-114"
              d="M814.75,483.25v-.07c-.38,0-.5.29-.29.71.17,0,.14-.22.3-.21v-.16C814.52,483.44,814.54,483.35,814.75,483.25Z"
            />
            <path
              class="cls-114"
              d="M814.41,483.05a.7.7,0,0,0-.65-.05C814,483.16,814.12,483.11,814.41,483.05Z"
            />
            <path
              class="cls-114"
              d="M813.9,474.9c.2.12.32.14.49,0A.45.45,0,0,0,813.9,474.9Z"
            />
            <path class="cls-116" d="M814.75,483.25c-.21.1-.23.19,0,.27Z" />
            <path
              class="cls-116"
              d="M809.8,476.22l-.08-3.07a.31.31,0,0,0-.09.27c0,.86,0,1.72.08,2.57A.28.28,0,0,0,809.8,476.22Z"
            />
            <path
              class="cls-116"
              d="M831.48,476.13l.19-.1,0-.09-.44-.09.19.26Z"
            />
            <path
              class="cls-114"
              d="M829.49,474.9v.58l.1.09.83,0c0-.86,0-1.72.07-2.57,0-.13.06-.27-.15-.3a.77.77,0,0,1-.26.07c-.48-.06-.6.15-.56.56A6.13,6.13,0,0,1,829.49,474.9Z"
            />
            <path
              class="cls-114"
              d="M831.59,472.89c-.22-.34-.57-.09-.85-.16,0,.85-.08,1.7-.11,2.54a.77.77,0,0,1-.07.37v.15a1.26,1.26,0,0,1,.81-.3c.15,0,.09-.21.1-.33Z"
            />
            <path
              class="cls-114"
              d="M831.65,475.94l0,.09.18,0c.08-.19.1-.42.35-.51.21-.89.11-1.81.24-2.71-.27-.15-.52-.21-.71.1C831.71,473.91,831.68,474.92,831.65,475.94Z"
            />
            <path
              class="cls-116"
              d="M829.49,474.9a6.13,6.13,0,0,0,0-1.6c0-.41.08-.62.56-.56a.77.77,0,0,0,.26-.07l-1.43,0c-.21,0-.25.07-.27.28a7.61,7.61,0,0,0,.07,1.72l0-.85C829.08,474.14,829.17,474.59,829.49,474.9Z"
            />
            <path
              class="cls-114"
              d="M829.61,471.89h.68c.21,0,.24-.13.23-.29s-.09-.22-.26-.21l-.68,0Z"
            />
            <path
              class="cls-114"
              d="M831.54,471.88a.84.84,0,0,0,.08-.54H831c-.26,0-.24.19-.26.34s.13.18.27.18Z"
            />
            <path
              class="cls-116"
              d="M829.61,471.89l0-.49H829c-.17,0-.24.09-.24.24s.07.27.27.26Z"
            />
            <path
              class="cls-116"
              d="M829.88,472.09c-.33-.07-.65.12-1,0a.16.16,0,0,0-.2.17c0,.14,0,.23.2.23l.73,0C829.55,472.27,829.7,472.17,829.88,472.09Z"
            />
            <path
              class="cls-114"
              d="M829.88,472.09c-.18.08-.33.18-.26.39h.64c.1,0,.23,0,.25-.12s0-.26-.16-.29h-.47Z"
            />
            <path
              class="cls-122"
              d="M830.56,475.79v-.15l-.12-.1-.83,0c0,.58.49.24.75.32Z"
            />
            <path
              class="cls-114"
              d="M831.46,472.48c.1-.12.19-.24.08-.39-.17,0-.34,0-.5,0s-.28,0-.27.14a.23.23,0,0,0,.28.21Z"
            />
            <path
              class="cls-116"
              d="M830.36,475.89c-.26-.08-.74.26-.75-.32l-.1-.09c-.11.15-.17.37,0,.45A1,1,0,0,0,830.36,475.89Z"
            />
            <path class="cls-116" d="M830.24,472.08h0Z" />
            <path class="cls-116" d="M829.5,475.32v-.1a.25.25,0,0,0,0,.07Z" />
            <path
              class="cls-121"
              d="M830,483.41c0-.12,0-.23,0-.34s-.15-.25-.35-.26-.29.11-.29.3a1.91,1.91,0,0,1,0,.63c-.05.15-.06.32.19.34s.42,0,.48-.21a3.59,3.59,0,0,0,0-.46Z"
            />
            <path
              class="cls-121"
              d="M830.8,484.25l.09-.18a.56.56,0,0,1,.08-.44c0-.17,0-.34,0-.51s-.07-.25-.27-.26-.3.1-.29.29,0,.67,0,1Z"
            />
            <path
              class="cls-116"
              d="M830.08,482.19l-.74-.07c-.07.07-.11.2,0,.21C829.58,482.37,829.89,482.54,830.08,482.19Z"
            />
            <path
              class="cls-116"
              d="M829.72,479.05h.35c.16,0,.14-.13.16-.22s-.05-.19-.18-.19c-.43,0-.85-.11-1.28-.06-.16,0-.27.05-.27.22s.13.2.29.21Z"
            />
            <path
              class="cls-116"
              d="M831,479.26a.88.88,0,0,0-.48,0l-.17.08-1.42-.11c-.17,0-.45-.1-.48.1s.29.19.44.19c.57,0,1.15,0,1.72,0l.19.06h.2Z"
            />
            <path
              class="cls-115"
              d="M831,479.26v.26a.2.2,0,0,1,.09.18h.26c.13-.27.42-.23.66-.28l0-.19-.56.08c0-.23.28-.17.33-.34-.14-.11-.27,0-.41,0h-.18A.26.26,0,0,1,831,479.26Z"
            />
            <path
              class="cls-116"
              d="M831.19,478.94c-.12-.09-.09-.22-.1-.34h-.41c-.11,0-.26,0-.25.16s0,.26.22.26a5,5,0,0,0,.55,0h0Z"
            />
            <path
              class="cls-115"
              d="M830.38,479.3l.17-.08A.17.17,0,0,0,830.38,479.3Z"
            />
            <path class="cls-115" d="M830.83,479.53l-.19-.06Z" />
            <path class="cls-115" d="M825.36,481.68l.14-.07Z" />
            <path
              class="cls-116"
              d="M832.2,475.5c-.25.09-.27.32-.35.51C832.36,476,832.39,476,832.2,475.5Z"
            />
            <path class="cls-117" d="M831.8,483.87l.1-.12Z" />
            <path
              class="cls-113"
              d="M831.85,472.29c0,.15.15.15.27.15s.29,0,.26-.21-.17-.13-.29-.13S831.85,472.14,831.85,472.29Z"
            />
            <path
              class="cls-117"
              d="M831.19,478.94V479h.18c0-.08,0-.18-.1-.2S831.2,478.89,831.19,478.94Z"
            />
            <path
              class="cls-117"
              d="M782.23,491.12c.17-.1,0-.37.25-.43v-.16l-.27,0Z"
            />
            <path
              class="cls-114"
              d="M781.17,476.74c0,.14,0,.24.16.24s.18,0,.15-.15,0-.2-.17-.22S781.19,476.7,781.17,476.74Z"
            />
            <path
              class="cls-117"
              d="M781.38,476a.13.13,0,0,0-.13.14.16.16,0,0,0,.17.15c.11,0,.18-.05.15-.16A.17.17,0,0,0,781.38,476Z"
            />
            <path
              class="cls-117"
              d="M795.26,492.82c.06-.17.08-.29-.07-.37a.1.1,0,0,0-.14.07C795,492.69,795.19,492.69,795.26,492.82Z"
            />
            <path class="cls-115" d="M835.06,475.26l0,.11Z" />
            <path
              class="cls-116"
              d="M789.4,475.44v-.17c0-.07,0-.2-.09-.19s0,.13,0,.19A1,1,0,0,0,789.4,475.44Z"
            />
            <polygon
              class="cls-105"
              points="663.41 767.5 684.5 494.5 684.38 494.59 590.25 564.43 684.5 491.5 683.8 491.03 684 491 685.7 491 1351.09 767.5 663.41 767.5"
            />
            <polygon
              class="cls-105"
              points="684.5 491.5 590.25 564.43 316.56 767.5 1.5 767.5 1.5 644.32 684.5 491.5"
            />
            <polygon
              class="cls-108"
              points="590.25 564.43 327.82 767.5 316.56 767.5 590.25 564.43"
            />
            <polygon
              class="cls-123"
              points="684.38 494.59 654.45 767.5 327.82 767.5 590.25 564.43 684.38 494.59"
            />
            <polygon
              class="cls-108"
              points="684.5 494.5 663.41 767.5 654.45 767.5 684.38 494.59 684.5 494.5"
            />
            <polygon
              class="cls-108"
              points="1367.5 761.5 1367.5 767.5 1351.09 767.5 685.7 491 685.76 491 1367.5 761.5"
            />
            <polygon
              class="cls-107"
              points="1367.5 697.5 1367.5 761.5 685.76 491 686.15 491 1367.5 697.5"
            />
            <polygon
              class="cls-106"
              points="1367.5 605.5 1367.5 697.5 686.15 491 687.47 491 1367.5 605.5"
            />
            <polygon
              class="cls-124"
              points="1367.5 573.5 1367.5 605.5 687.47 491 688.61 491 1367.5 573.5"
            />
            <polygon
              class="cls-124"
              points="1367.5 548.5 1367.5 573.5 688.61 491 690.39 491 1367.5 548.5"
            />
            <polygon
              class="cls-124"
              points="1367.5 531.5 1367.5 548.5 690.39 491 692.83 491 1367.5 531.5"
            />
            <polygon
              class="cls-124"
              points="1367.5 511.5 1367.5 531.5 692.83 491 700.76 491 1367.5 511.5"
            />
            <polygon
              class="cls-106"
              points="1367.5 502.5 1367.5 511.5 700.76 491 712 491 1367.5 502.5"
            />
            <line class="cls-104" x1="1.5" y1="644.32" x2="1" y2="644.43" />
            <polygon
              class="cls-125"
              points="829 518 829 494.21 855 494.21 855 497 855 500 849 502 849 503 844 505 844 509 838 510 838 515 829 518"
            />
            <polygon
              class="cls-126"
              points="829 518 826 517 826 494 829 494 829 518"
            />
            <polygon
              class="cls-127"
              points="855 494 829 494.21 826 494 855 494"
            />
            <polygon
              class="cls-128"
              points="592 493 518 493 518.72 485.92 591 487 592 493"
            />
            <polygon
              class="cls-128"
              points="684 491 624 493 624.46 485.92 684 490 684 491"
            />
            <polygon
              class="cls-128"
              points="684 491 747 492 747 485.92 684 490 684 491"
            />
            <polyline
              class="cls-105"
              points="388 513 567.76 515.11 567.76 508.04"
            />
          </g>
          <g id="edificiosfondo">
            <path
              class="cls-129"
              d="M780.68,480.61c-.09.5-.16,1-.2,1.49-.05.34-.11.68-.15,1l-.33,2.53c-.07.5-.13,1-.2,1.49-.09.67-.19,1.34-.28,2a.76.76,0,0,0,0,.15l0,.42a.56.56,0,0,0-.06.38c0,.27,0,.27-.48.34a2.84,2.84,0,0,1-.42.05c0-.26.08-.53.11-.79s.08-.79.13-1.19c.07-.57.14-1.15.23-1.73,0-.23,0-.47.06-.7.13-.73.21-1.47.29-2.2,0-.36.1-.72.15-1.08a8,8,0,0,0,.13-1.08s0-.09-.06-.11-.11,0-.17.06l-3.5,0c-.26,0-.34.06-.34.2s0,.44-.06.66l-.33,3.25c-.12,1.23-.25,2.46-.37,3.7-.06.51-.12,1-.17,1.55,0,.09-.14.1-.25.12s-.43.07-.65.08c0-.48.06-1,.1-1.43s.1-1.19.17-1.79c.1-.88.15-1.77.25-2.66,0-.25,0-.51.06-.77.07-.77.15-1.54.22-2.31.06-.61.11-1.22.17-1.83l3.38.09,2.42.07C780.55,480.57,780.63,480.56,780.68,480.61Z"
            />
            <path
              class="cls-110"
              d="M774.6,491c0-.52.11-1,.17-1.55.12-1.24.25-2.47.37-3.7l.33-3.25c0-.22,0-.44.06-.66s.08-.2.34-.2l3.5,0a.88.88,0,0,1-.07.47h-2.94c-.09,0-.2,0-.26,0v0a.18.18,0,0,0,0,.18v.08c0,.06-.11.12,0,.19v0a6.91,6.91,0,0,0-.1,1c0,.1.12.08.23.08a5.45,5.45,0,0,0,.7,0l2.26-.06c0,.45-.09.89-.17,1.34-.44,0-.87,0-1.29.06l-.53,0a.39.39,0,0,0-.19,0l-1,.05c-.08,0-.17,0-.13.07s-.06.1-.08.15l0,.08-.09,1.12,0,.07v.07c0,.22,0,.25.36.21l.53-.05c.75-.05,1.49-.14,2.25-.16l-.13,1.12c-.08,0-.16,0-.2.08h-.07c0-.05-.08-.06-.14-.05a6.48,6.48,0,0,0-.77.1h-.11a.63.63,0,0,0-.36,0h-.11a.3.3,0,0,0-.19,0l-.17,0a.22.22,0,0,0-.18,0h-.17a1.58,1.58,0,0,0-.62.09c-.13.07-.15.15,0,.24v.06l0,.18v.08c-.15.26,0,.53-.06.8-.07,0-.06.07-.05.11v.06c0,.1,0,.12.18.1l1.33-.17a13.29,13.29,0,0,1,1.56-.18l-.09.94c-1,.11-1.9.27-2.85.41A8,8,0,0,1,774.6,491Z"
            />
            <path
              class="cls-130"
              d="M774.67,480.41c-.06.61-.11,1.22-.17,1.83-.07.77-.15,1.54-.22,2.31,0,.26,0,.52-.06.77-.1.89-.15,1.78-.25,2.66-.07.6-.11,1.19-.17,1.79s-.1,1-.1,1.43a3.5,3.5,0,0,1-.66-.09l-.83-.18a2.09,2.09,0,0,1,0-.25c0-.58.11-1.16.17-1.74,0-.15-.07-.2-.3-.18-.07-.14-.19-.15-.53,0-.15,0-.19-.07-.33-.14l-.2,2.65c-.15,0-.26-.07-.4-.05l-.46-.1,0-.54c.1-.09.08-.15-.11-.17s-.38-.06-.56-.09,0-.25-.12-.37,0-.33,0-.49c0-.4,0-.4-.61-.31-.1,0-.22,0-.22.11,0,.28,0,.55,0,.83h0l-.18,0v-.8a3.14,3.14,0,0,0,0-.61,11.51,11.51,0,0,1,1.33-.15,5.13,5.13,0,0,1,1.18-.08c.32,0,.6.12.93.12.53,0,1-.1,1.57-.14.12,0,.11-.07.11-.12l.09-.85s0-.1-.06-.13c0-.33.06-.66.08-1l.15-1.73a.68.68,0,0,0,0-.62v-.43c.09,0,.06-.1.06-.15,0-.55.08-1.11.11-1.67h0c.11-.06,0-.13,0-.19a0,0,0,0,0,0,0c.05,0,.08,0,.08-.07,0-.24.06-.48.08-.72,0-.08-.08-.09-.17-.09l-1.54,0c-.28,0-.56.08-.83,0,0,0,.09-.06.13-.05.79.08,1.57-.06,2.36-.05,0,0,0,.05.06.05s0,0,0-.06Z"
            />
            <path
              class="cls-113"
              d="M752,491.28H752l-1-1.16c0-.06-.06-.1-.17-.1,0-.29-.05-.58-.07-.86,0-.07,0-.14-.14-.14s-.09.09-.1.14c0,.27.13.54,0,.81l-.1-.07s-.08,0-.13,0l-.62-.76c-.12-.14-.27-.15-.5,0l-.23.08c.08-.13,0-.25,0-.37s0-.1-.09-.09-.08.06-.08.1v.68c0,.08,0,.15.17.15,0,.17.07.34.09.51s-.07.06-.14.06l-.11,0v-.07c-.08-.1-.27-.15-.27-.3,0-.38-.06-.76-.09-1.14a10.4,10.4,0,0,1,1.37-.1c-.11.12,0,.16.18.19l1.56.47c.76.22,1.5.48,2.29.67.52,0,1-.12,1.54-.12l0,.14-.9.08c-.08,0-.16,0-.17.07-.32.08-.52.2-.48.44s0,.54.05.81Z"
            />
            <path
              class="cls-109"
              d="M765.6,491.8l-.34,0c0-1,.06-2,.07-3a1.47,1.47,0,0,1,.1-.74.32.32,0,0,1,.3.12s-.05,0,0,.07l0,0a.09.09,0,0,0,.05.1,1.16,1.16,0,0,0,.84,0h0a.75.75,0,0,0,.3,0c.12,0,.35,0,.34,0s0-.08.13,0a1.46,1.46,0,0,0,.55,0l.58-.07h.11l1.5-.15a13.38,13.38,0,0,0,1.42-.14c.16.1.11.27-.09.31a6,6,0,0,0-.61.09,5.13,5.13,0,0,0-1.18.08,11.51,11.51,0,0,0-1.33.15c-.85,0-1.67.15-2.51.22-.12,0-.16,0-.15.11v.28a3.58,3.58,0,0,0,0,1l0,.71s0,.08,0,.13l0,.17v0s0,.08,0,.12Z"
            />
            <path
              class="cls-114"
              d="M755.34,489.89l0-.14a6,6,0,0,1,.84-.08,6.64,6.64,0,0,0-.71.58,6.78,6.78,0,0,0,2,0c-.1.51,0,.57.71.55h0c.15,0,.21,0,.21-.14s0-.35,0-.52a3.91,3.91,0,0,1,1.08,0v1.08c0,.07,0,.15-.12.19h-.18a3.79,3.79,0,0,0-.76-.48.52.52,0,0,0-.28,0l-2.77.32A11,11,0,0,1,755.34,489.89Z"
            />
            <path
              class="cls-110"
              d="M755.34,489.89a11,11,0,0,0,.06,1.28v.11a6.33,6.33,0,0,0,0,.87l0,.3v.28l0,.14,0,.05c-.09,0-.18-.06-.27,0H755l-.53.07-.07-.08a27.74,27.74,0,0,0-.12-2.88c0-.06.09-.07.17-.07Z"
            />
            <path
              class="cls-115"
              d="M762.18,491.85a3,3,0,0,1-.81-.18,2.89,2.89,0,0,0-.51-.11,2.73,2.73,0,0,0,0-.9,4.78,4.78,0,0,1-.08-.84,11.58,11.58,0,0,1,1.4-.52.77.77,0,0,1,0,.15C762.21,490.25,762.19,491.05,762.18,491.85Z"
            />
            <path
              class="cls-110"
              d="M760.8,489.82a4.78,4.78,0,0,0,.08.84,2.73,2.73,0,0,1,0,.9,8,8,0,0,0-1.09-.05c-.19,0-.31-.05-.38-.16.14,0,.11-.12.12-.19v-1.08h0Z"
            />
            <path
              class="cls-111"
              d="M779,485.08c.08-.45.13-.89.17-1.34l.13-1.2a.43.43,0,0,0,0-.33v-.07a.88.88,0,0,0,.07-.47c.06,0,.08-.08.17-.06s.06.07.06.11a8,8,0,0,1-.13,1.08c-.05.36-.12.72-.15,1.08-.08.73-.16,1.47-.29,2.2,0,.23,0,.47-.06.7-.09.58-.16,1.16-.23,1.73,0,.4-.08.79-.13,1.19s-.08.53-.11.79h-.21l.09-.94v-.14a2.42,2.42,0,0,0,.1-.84v-.07a.68.68,0,0,0,0-.44V488s.06-.05,0-.08l.13-1.12Z"
            />
            <path
              class="cls-110"
              d="M749.22,489.07c.23-.12.38-.11.5,0l.62.76c0,.37,0,.74,0,1.12,0,.08,0,.15,0,.22l-.92.08Z"
            />
            <path
              class="cls-109"
              d="M747.75,490.38a4.85,4.85,0,0,0,0,.76c0,.36,0,.36-.59.36l-.12-1.11L747,489c0-.08,0-.17.15-.18a1.49,1.49,0,0,1,.47,0Z"
            />
            <path
              class="cls-110"
              d="M762.18,491.85c0-.8,0-1.6,0-2.4a.77.77,0,0,0,0-.15c.14-.11.2-.07.23,0s0,.16,0,.23v.83c0,.2,0,.39,0,.58s-.09.2.13.16.51.05.51-.18c0-.41,0-.83,0-1.24l0-.08.23,0c0,.71,0,1.42,0,2.13A6.23,6.23,0,0,1,762.18,491.85Z"
            />
            <path
              class="cls-113"
              d="M747,491.14c-.18-.14-.08-.32-.22-.47a.81.81,0,0,0,0-.31c0-.08-.09-.09-.18-.06v-.06l.11-.11a.83.83,0,0,0-.06-.79c-.06,0-.16-.15-.17,0s-.09.05-.15,0-.09-.22-.3-.26l-.08-.13c0-.32-.07-.64,0-1H746a1.78,1.78,0,0,1,.48.13.62.62,0,0,0,.18.05c.17-.08.13,0,.13,0,.06.52.12,1,.16,1.55A7.2,7.2,0,0,1,747,491.14Z"
            />
            <path
              class="cls-115"
              d="M754.27,490a27.74,27.74,0,0,1,.12,2.88,1.44,1.44,0,0,0-.46,0l-.36,0c.12-.07.32,0,.35-.11a2,2,0,0,1-.06-.77c0-.22-.15-.45,0-.67-.06-.27,0-.55-.05-.81S754,490.12,754.27,490Z"
            />
            <path
              class="cls-115"
              d="M763.33,491.74c0-.71,0-1.42,0-2.13.22,0,.34-.18.58-.2.06.82,0,1.63,0,2.44C763.67,491.86,763.54,491.74,763.33,491.74Z"
            />
            <path
              class="cls-116"
              d="M755.4,491.28v-.11l2.77-.32a.52.52,0,0,1,.28,0,3.79,3.79,0,0,1,.76.48,17.7,17.7,0,0,1-2.06,0,.4.4,0,0,1-.2-.07,1.14,1.14,0,0,0-.55,0C756.07,491.31,755.73,491.26,755.4,491.28Z"
            />
            <path
              class="cls-111"
              d="M747,491.14a7.2,7.2,0,0,0-.07-1.31c0-.52-.1-1-.16-1.55,0,0,0-.13-.13,0a.62.62,0,0,1-.18-.05,1.78,1.78,0,0,0-.48-.13,1.14,1.14,0,0,0-.52-.17c-.22-.17-.2-.26.07-.29,0,.05.07.08.15.1l1,.32c.06,0,0-.09.11-.11a2.44,2.44,0,0,1,.06.71c0,.06,0,.14.11.16a.65.65,0,0,0,.37,0c.08-.07,0-.12-.09-.18a.29.29,0,0,1-.1-.24c0-.08,0-.13.18-.12s.36.1.58.09a1.64,1.64,0,0,1,.85,0,2.32,2.32,0,0,1-.53,0c-.43,0-.43,0-.41.27-.29-.06-.29-.06-.28.18a1.49,1.49,0,0,0-.47,0c-.18,0-.16.1-.15.18l.12,1.35.12,1.11c-.2,0-.1-.14-.17-.21s.06-.08,0-.11A0,0,0,0,0,747,491.14Z"
            />
            <path
              class="cls-109"
              d="M753.84,491.29c-.13.22,0,.45,0,.67a2,2,0,0,0,.06.77c-.22-.09-.28-.24-.39-.37s-.48-.53-.74-.79c0-.05-.07-.09-.16-.08a1.17,1.17,0,0,1-.46-.07c0-.05-.15-.07-.14-.14Z"
            />
            <path
              class="cls-113"
              d="M747.59,488.83c0-.24,0-.24.28-.18s.31,0,.46,0v0c-.19,0-.16.08-.17.15a6.09,6.09,0,0,0,.08,1.12.43.43,0,0,0,.1.33v.07l-.57,0C747.7,489.86,747.64,489.35,747.59,488.83Z"
            />
            <path
              class="cls-110"
              d="M751,490.12l1,1.16a3.2,3.2,0,0,1-.82.14c-.15,0-.14-.08-.16-.14l-.06-.58v-.1C751,490.44,750.86,490.27,751,490.12Z"
            />
            <path
              class="cls-110"
              d="M763.88,491.85c0-.81.11-1.62,0-2.44.23-.12.27,0,.26.1,0,.78,0,1.56-.05,2.34l0,0C764,491.87,763.94,491.9,763.88,491.85Z"
            />
            <path
              class="cls-115"
              d="M749.22,489.07l.2,2.21c-.39,0-.23-.16-.31-.26a1.08,1.08,0,0,0,0-.4c.06-.16-.17-.28-.15-.43s.15,0,.14-.06-.06-.34-.09-.51,0-.25,0-.37v-.1Z"
            />
            <path
              class="cls-113"
              d="M768,491.37l-.07,0c-.09-.06-.11-.12,0-.2s.11-.1,0-.13-.19-.07-.27,0-.06.1,0,.16a.21.21,0,0,1,0,.11c-.14,0-.29.05-.34-.08a.63.63,0,0,0-.07-.59c0-.12,0-.24.06-.36.09.06.06.14.07.21s0,.13.15.12,0-.08.08-.12-.07-.08,0-.11,0,.28.21.24.16.06.24.1l.1,0v.12c-.1,0-.11.06-.11.11Z"
            />
            <path
              class="cls-117"
              d="M768,491.37l.06-.47s0-.1.11-.11a.33.33,0,0,0,.22,0l1.3-.16a.24.24,0,0,0,.16-.08H770c.09,0,.12-.09.22,0l0,.54H770c0-.32,0-.32-.46-.22s-.83.09-1.24.15c-.11,0-.14.05-.12.11s0,.17,0,.25H768Z"
            />
            <path
              class="cls-115"
              d="M750.93,490.7l.06.58a1.41,1.41,0,0,1-.65-.08c.07-.07,0-.14,0-.22,0-.38,0-.75,0-1.12,0,0,.1,0,.13,0s-.05.06-.05.08l.06.74c0,.06,0,.09.14.09S750.83,490.74,750.93,490.7Z"
            />
            <path
              class="cls-109"
              d="M767.22,491.16l-.46.06V491c.14-.13.07-.2-.18-.22a.45.45,0,0,1-.23-.07l.7-.08c.14.05.19.12.18.22S767.22,491.05,767.22,491.16Z"
            />
            <path
              class="cls-117"
              d="M766.75,491v.24c0,.1,0,.22-.1.31a.16.16,0,0,1,0-.17c0-.14,0-.18-.28-.14s-.44.06-.66.08l0,0,0-.17a2.12,2.12,0,0,0,.87-.09C766.61,491.05,766.64,490.88,766.75,491Z"
            />
            <path
              class="cls-113"
              d="M765.68,491.3c.22,0,.45,0,.66-.08s.31,0,.28.14a.16.16,0,0,0,0,.17.14.14,0,0,1-.11,0,1.23,1.23,0,0,0-.91-.11s0-.08,0-.12h0Zm.82,0s0-.06-.09,0l-.09,0s.07.06.12.07S766.5,491.36,766.5,491.34Z"
            />
            <path
              class="cls-113"
              d="M768.17,491.12c0-.06,0-.1.12-.11.41-.06.82-.13,1.24-.15l0,.07A12.72,12.72,0,0,1,768.17,491.12Z"
            />
            <path
              class="cls-117"
              d="M748.32,490.34v-.07c.14,0,.26-.11.3-.22a.28.28,0,0,0,.18,0v.09C748.78,490.5,748.78,490.5,748.32,490.34Z"
            />
            <path
              class="cls-118"
              d="M767.62,491.24a.21.21,0,0,0,0-.11c-.08-.06-.08-.13,0-.16s.18,0,.27,0,.07.09,0,.13,0,.14,0,.2A.53.53,0,0,1,767.62,491.24Z"
            />
            <path
              class="cls-118"
              d="M769.55,490.93l0-.07c.48-.1.48-.1.46.22Z"
            />
            <path
              class="cls-113"
              d="M746.55,490.34l-.53.11c-.35,0-.66.12-1,.12l0,0A6.66,6.66,0,0,1,746.55,490.34Z"
            />
            <path
              class="cls-109"
              d="M764.11,491.89l0,0c.15,0,.31,0,.41-.08a.35.35,0,0,0,.23,0v.07l-.24.06A.8.8,0,0,1,764.11,491.89Z"
            />
            <path
              class="cls-111"
              d="M767.22,491.16c0-.11,0-.22,0-.33s0-.17-.18-.22l0,0,.15,0a.63.63,0,0,1,.07.59Z"
            />
            <path
              class="cls-109"
              d="M749.08,490.62a1.08,1.08,0,0,1,0,.4c-.07-.11-.14-.21-.2-.32S749,490.6,749.08,490.62Z"
            />
            <path class="cls-113" d="M745,490.57l0,0v0h0Z" />
            <path
              class="cls-117"
              d="M756.4,491.28a1.14,1.14,0,0,1,.55,0A1,1,0,0,1,756.4,491.28Z"
            />
            <path class="cls-113" d="M747,491.18c.07,0,.05.07,0,.11Z" />
            <path
              class="cls-131"
              d="M770.41,487.2c0-.85.1-1.7.18-2.55a.12.12,0,0,1-.05-.14c0-.21-.07-.42.08-.63,0-.67.1-1.34.14-2a2.51,2.51,0,0,1,0-.27.14.14,0,0,1,0-.13,3,3,0,0,1,.07-.85c0-.25,0-.26-.52-.27l-2.22,0-1.62,0c-1.26,0-2.52-.08-3.78-.09,0,.38,0,.77,0,1.16,0,1.28,0,2.57-.06,3.86,0,.84,0,1.69,0,2.53,0,.1,0,.21-.24.17a5.91,5.91,0,0,1-1,.12l-3.54.28-4,.31.06,1.28c.52,0,1-.12,1.54-.12a6,6,0,0,1,.84-.08,8.33,8.33,0,0,1,1.12-.11,9.63,9.63,0,0,1,1.08-.1,9.46,9.46,0,0,1,1.07-.11l2.86-.28c.39,0,.39,0,.28-.27s-.07-.32.35-.33a6.36,6.36,0,0,1,1.45-.1h.11c.28.08.38,0,.35-.16s.18-.16.53-.12a.32.32,0,0,1,.3.12v.07l0,0c.05,0,.14,0,.16,0,.12-.25.42-.13.67-.13.08,0,.14.07.24.06.09-.18.33-.18.58-.15l.31,0c0-.09.09-.13.24-.11a2.8,2.8,0,0,0,.29,0l.43,0c0-.07,0-.12.16-.13a1.72,1.72,0,0,1,.6.05c.11-.14.3-.14.51-.13l.32,0v-.52A.14.14,0,0,1,770.41,487.2Zm-5.56-3.75c0-.47,0-.94,0-1.4v-.49c0-.09,0-.13.19-.13,1.18,0,2.37,0,3.55,0l.83,0c.08,0,.16,0,.15.08,0,.6-.07,1.19-.1,1.78,0,.13-.15.11-.28.09l-1,0c-.57,0-1.14,0-1.72,0s-.92.05-1.39,0C765,483.53,764.86,483.56,764.85,483.45Zm4.26,3.2a5.88,5.88,0,0,1-1.11.1c-1,.08-2,.14-3,.21-.22,0-.23,0-.15-.12-.13-.13,0-.27-.05-.4v-.11a6.76,6.76,0,0,1,0-.9v-.05c-.06-.08,0-.14.05-.21v-.26c0-.05,0-.06.11-.07l3-.11a.18.18,0,0,1,.13,0h.34a.94.94,0,0,1,.6-.06,1,1,0,0,0,.4,0V486c0,.17,0,.35,0,.52S769.27,486.67,769.11,486.65Z"
            />
            <path
              class="cls-129"
              d="M757.82,480.75l-2.25-.05-4.83-.08c0,.65.06,1.3.1,2l.09,1.44c.07,1.14.13,2.27.2,3.4.89,0,1.76-.1,2.65-.15L758,487C757.81,484.92,757.94,482.83,757.82,480.75Zm-2.38,2.69a.43.43,0,0,1,0-.33.22.22,0,0,0,0-.08v-.94a.08.08,0,0,1,0,0,.66.66,0,0,0,0-.14,2.83,2.83,0,0,1,.87,0h.07a2.6,2.6,0,0,1,0,.92v.67s0,.11-.09.11a5.17,5.17,0,0,1-.68,0C755.36,483.59,755.43,483.5,755.44,483.44Zm.77,3.54-.3,0c-.39,0-.39,0-.4-.23v-.54a6.51,6.51,0,0,1-.06-.88c0-.08.06-.11.18-.11l.68,0a.12.12,0,0,1,.09.14c0,.22.06.44,0,.66v.08a.13.13,0,0,1,0,.21v.26s0,0,0,.06a.11.11,0,0,1,0,.08.11.11,0,0,1,0,.18C756.36,486.94,756.32,487,756.21,487Z"
            />
            <path
              class="cls-130"
              d="M758,487c-.14-2.09,0-4.18-.13-6.26l3.79-.19,0,3.74v.58c0,.8-.05,1.6,0,2.4,0,.3,0,.3-.46.26H761a3.51,3.51,0,0,0-.58-.13Zm.65-1.66c-.05.5,0,1,0,1.5,0,.13.15.14.31.14s.16-.05.16-.11c0-.51,0-1,0-1.52,0-.13-.15-.13-.29-.14S758.6,485.28,758.6,485.35Zm0-1.74h.15c.3.05.33,0,.34-.2,0-.51-.05-1-.06-1.51,0-.11-.08-.13-.23-.13s-.17.12-.21.2l-.17-.09c0,.53,0,1.07,0,1.6C758.42,483.56,758.44,483.61,758.59,483.61Z"
            />
            <path
              class="cls-132"
              d="M753.79,488.59,751,487.9l-.12,0-.13,0a2.78,2.78,0,0,1-.6-.16l-.11,0H750l-.05,0h0a.2.2,0,0,1,0-.11c0-.72-.08-1.44-.13-2.15l-.24-3.5-.12-1.61c-.79.06-1.57.14-2.37.19-.32,0-.54.08-.53.31l0,0h0l0,0a2.6,2.6,0,0,1,.08.73c0,.12-.15.07-.24.07h-.63v0h.62c.17,0,.31,0,.3.14,0,.65.14,1.29.12,1.94a2.43,2.43,0,0,1,.1,1,9.32,9.32,0,0,1,.09,1.29h.48v0c0-.28,0-.55-.07-.82,0-.06,0-.13.05-.19a10.59,10.59,0,0,1,1.5.17c.1,0,.13.06.1.11s-.1,0-.16,0a4.28,4.28,0,0,1-1.09-.16,1.07,1.07,0,0,0-.31,0,2.54,2.54,0,0,1,0,.29h.06c.06-.1.12,0,.17,0h.06a.54.54,0,0,1,.42.08l.23,0a1.16,1.16,0,0,1,.61.2c0,.06-.07,0-.12.05s.12.11.25.1.23,0,.24.1-.12.08-.22.08a.62.62,0,0,0-.31.07l.1,0H749a1.32,1.32,0,0,1,0,.56h0l0,0h-.12c-.14,0-.29,0-.35-.11s-.2.06-.3,0a1.6,1.6,0,0,0-.33-.07c-.1,0-.14,0-.11-.09s0-.14-.06-.21h0c-.09-.05,0-.24-.32-.12.12,0,.14.05.13.11s.06.2,0,.3c-.12-.13-.07-.28-.1-.41H747l.06,1.12c.18.12.12.27.11.42a3.27,3.27,0,0,1,1.1.24,1.44,1.44,0,0,1,.57.21,3.28,3.28,0,0,1,1,.21c.23.08.23.19.06.31s0,.15.18.19l1.56.47c.76.22,1.5.48,2.29.67Zm-5.12-5.19-.37,0h0l0,0h0a1.41,1.41,0,0,1-.2,0,.92.92,0,0,1-.37,0h-.23a.15.15,0,0,1-.17,0c-.09,0-.11,0-.12-.09,0-.45-.08-.91-.11-1.36,0,0,0,0,0-.07a.24.24,0,0,1,.15,0c.43,0,.85,0,1.27,0,.14,0,.24,0,.25.12s-.1.12-.23.13h-1.31v.29h.2l.05,0h.12l.05,0h.13l.2,0c.08.05.16.09.25,0a.51.51,0,0,1,.4,0,.19.19,0,0,1,.14.17,4,4,0,0,0,0,.85S748.87,483.42,748.67,483.4Zm-.14-1.29c0,.06-.1.05-.16.05s-.16,0-.14-.06.08,0,.14,0S748.51,482.06,748.53,482.11Zm-.65,0c0,.05-.11.05-.17,0s-.15,0-.12-.07.11,0,.18,0S747.88,482.07,747.88,482.12Z"
            />
            <path
              class="cls-110"
              d="M750,487.64c-.16,0-.16-.09-.17-.17,0-.72-.08-1.44-.13-2.15l-.24-3.5-.12-1.61a4.45,4.45,0,0,1,1.21,0c.1,0,.1.07.1.11s0,.18,0,.27c0,.65.06,1.3.1,2,0,.48.06,1,.09,1.44.07,1.14.13,2.27.2,3.4,0,.1-.09.12-.22.14A8.27,8.27,0,0,0,750,487.64Z"
            />
            <path
              class="cls-133"
              d="M761,487.55h.06c.46,0,.47,0,.46-.26,0-.8,0-1.6,0-2.4a.78.78,0,0,0,0-.58c0-1.25,0-2.49,0-3.74a.65.65,0,0,0,0-.14c0-.17.08-.23.35-.23s.48-.05.73,0c0,.38,0,.77,0,1.16,0,1.28,0,2.57-.06,3.86,0,.84,0,1.69,0,2.53,0,.1,0,.21-.24.17a2.21,2.21,0,0,0-.58-.11A2,2,0,0,1,761,487.55Z"
            />
            <path
              class="cls-129"
              d="M746.47,480.78l-.73,0v0h.71S746.46,480.76,746.47,480.78Z"
            />
            <path
              class="cls-129"
              d="M748,486h-.13c-.26,0-.1.1-.14.16h0c-.09-.05,0-.24-.32-.12H747a5,5,0,0,0-.78.08l-.4,0-.13,0-.18,0a.9.9,0,0,1-.16,0v-.09h0l.07,0,.16,0h.18c.36,0,.71-.07,1.07-.1h.54c.1,0,.2,0,.25-.06h.07c0,.08.09,0,.14,0H748Z"
            />
            <path
              class="cls-117"
              d="M770.76,481.46a3,3,0,0,1,.07-.85,2.49,2.49,0,0,1,.82-.07c.27.1.55,0,.83,0,0,.3-.09.59-.05.89h-1.67Z"
            />
            <path class="cls-109" d="M774.25,480.43s0,.06,0,.06,0,0-.06-.05Z" />
            <path
              class="cls-117"
              d="M777.66,485.14c-.12.07-.35.05-.34.21s-.08,0-.14,0-.07-.06,0-.09.1-.09,0-.14a.39.39,0,0,0-.19,0c-.12.12-.34,0-.47.08h.41c.12,0,.16.07.06.1a1.14,1.14,0,0,1-.61,0c-.07,0,0-.07,0-.11a.58.58,0,0,0-.41,0c.1,0,.27,0,.27.07s-.17.07-.27.08h-.15l0,.08h.06c.11,0,.27,0,.32.05s-.19,0-.23.12c.19,0,.24,0,.21.16s0,.55-.07.82c0,.08.07.18-.11.23s-.18-.09-.3-.11c0,.22,0,.24.36.21l.53-.05c.75-.05,1.49-.14,2.25-.16.07-.57.14-1.14.22-1.71C778.51,485.07,778.08,485.11,777.66,485.14Zm-1,.33c.12,0,.32,0,.33.06s-.2.06-.31.06-.36.07-.37,0S776.5,485.51,776.62,485.47Zm-.47,1.36,0,0s0,0,.06,0,0,0,0,.05Zm.63-.06c-.08,0-.06,0-.09-.08l-.1-.08c-.19,0-.08.13-.16.23,0-.1,0-.21-.2-.2s-.06,0-.06-.08c0-.25,0-.5.07-.75s.28-.13.46-.14.27,0,.25.12a5.22,5.22,0,0,0-.07.88C776.88,486.72,776.87,486.77,776.78,486.77Zm.47-1a3.84,3.84,0,0,0-.06.76.39.39,0,0,1,0,.18s0,.1-.14.09,0-.07,0-.06c0-.36.07-.67.11-1,0-.06,0-.14.15-.12S777.26,485.73,777.25,485.78Zm.65,1-.52,0c-.1,0-.13,0-.12-.08a4.72,4.72,0,0,0,.11-.92.14.14,0,0,1,.16-.15,2,2,0,0,1,.55,0c.07,0,0,.06,0,.1a5.68,5.68,0,0,0-.05.92C778.07,486.7,778,486.72,777.9,486.73Zm.16-1.21-.37,0c-.09,0-.23,0-.24-.05s.14-.06.22-.07l.35,0c.06,0,.13,0,.15,0S778.11,485.51,778.06,485.52Zm0-.18-.35,0c-.12,0-.28,0-.28-.08s.15-.06.24-.08l.35,0c.06,0,.16,0,.17,0S778.17,485.33,778.07,485.34Zm.49,1.21c0,.14-.16.14-.3.14s-.08-.1-.07-.14c0-.27,0-.53.06-.8,0-.06,0-.13.1-.17a.46.46,0,0,1,.23,0c.14.05.07.13.09.21A5.05,5.05,0,0,0,778.56,486.55Zm-.21-1.06s0-.05,0-.06a.56.56,0,0,1,.38,0C778.56,485.5,778.46,485.54,778.35,485.49Z"
            />
            <path
              class="cls-117"
              d="M778.56,488h-.19c0,.08,0,.18-.12.22s-.22,0-.27,0,0-.14.15-.16l.2,0c0-.05-.08-.06-.14-.05a6.48,6.48,0,0,0-.77.1c.09.06.19,0,.28,0s.19,0,.2.1,0,.11-.16.12l-.39,0c-.11,0-.22,0-.27-.07s.07-.1.16-.12a.18.18,0,0,0,.07-.05.63.63,0,0,0-.36,0c.06.08.11.16,0,.24a.12.12,0,0,1-.13,0c-.1-.08,0-.15,0-.22a.3.3,0,0,0-.19,0c.06.08.13.19,0,.23a1,1,0,0,1-.56.05c-.19-.07,0-.15.06-.23a1.58,1.58,0,0,0-.62.09h.17c.11,0,.2,0,.2.09s-.08.09-.17.1a1,1,0,0,0-.25,0v.06h.17c.09,0,.2-.05.23,0s-.05.12-.19.13l-.25,0v.08a.9.9,0,0,1,.4,0,.1.1,0,0,0,.14,0v0h0a.11.11,0,0,1,.06,0,.48.48,0,0,1,.29,0l.19,0c.06,0,.12,0,.11.07-.11.27,0,.55-.12.82l0,0c-.16,0-.34.13-.48,0h0c-.16,0-.16-.05-.14-.13a.92.92,0,0,0,0-.52c0,.16-.05.32-.06.48s0,.28-.46.34c0,.1,0,.12.18.1l1.33-.17a13.29,13.29,0,0,1,1.56-.18c0-.05,0-.1,0-.14s0-.17-.07-.26,0-.13-.06-.18v.25c0,.09.06.2-.17.22s-.25,0-.24-.14l.06-.64c0-.09.11-.12.24-.12s.18,0,.17.1v.27c.15-.12,0-.27.18-.34a.17.17,0,0,0,0-.07c-.08-.15-.16-.3,0-.44Zm-2.42.69c-.06,0-.14,0-.17,0s0-.09.09-.1a2.87,2.87,0,0,1,.78-.07c.06,0,.11,0,.1.07a.06.06,0,0,1-.06,0Zm.8.09c-.1.27,0,.56-.17.82a2,2,0,0,1,0-.8c0-.06,0-.1.13-.1S777,488.73,776.94,488.77Zm.7.73a2.43,2.43,0,0,1-.61.06c-.15,0,0-.11-.09-.16a1.73,1.73,0,0,0,.07-.64c0-.09.09-.11.22-.12l.56-.05c0,.11,0,.21,0,.32a.83.83,0,0,1,0,.38C777.7,489.36,777.79,489.47,777.64,489.5Zm.54-1c-.3,0-.6.05-.9.09-.07,0-.16,0-.19,0s.06-.1.14-.11l.49-.05c.15.11.26,0,.41,0s.19,0,.22,0S778.27,488.45,778.18,488.46Z"
            />
            <path
              class="cls-117"
              d="M778.72,482.64a4.17,4.17,0,0,0-.79,0c-.08,0-.19.05-.2,0s.07-.11.19-.11h1.15s0,0,0-.07a.86.86,0,0,1-.28,0c-.14-.06-.13-.13,0-.16h.46v-.07h-.11a.65.65,0,0,1-.31,0H776.1v0c.14,0,.4-.06.4.09s-.27.06-.42.09h0v.08h.27c.07,0,.17,0,.16.06s0,.11-.15.12H776v0c.47,0,.48,0,.42.31a1.15,1.15,0,0,0,0,.45c0,.14,0,.25-.25.33a5.45,5.45,0,0,0,.7,0l2.26-.06c0-.4.09-.8.13-1.2h-.12C779.06,482.67,778.88,482.66,778.72,482.64Zm-.53-.42c.14,0,.39-.07.39.08s-.26.06-.4.1-.4.06-.39-.1S778.05,482.22,778.19,482.22Zm-.84.73a2.5,2.5,0,0,0-.06.67s0,.06-.08.07-.09,0-.09-.07,0-.12-.07-.17a.16.16,0,0,1,0,.18c0,.16-.25.11-.4.1s-.14-.1-.13-.17c0-.22,0-.45.06-.67,0-.07,0-.18.23-.16H777C777.36,482.71,777.37,482.71,777.35,483Zm-.15-.3h-.41c-.09,0-.2,0-.2-.08s.1-.09.19-.1h.41c.1,0,.21,0,.21.08S777.31,482.65,777.2,482.65Zm.34.91s0,.08-.11.13a3,3,0,0,1,0-.84.1.1,0,0,1,.13-.11c.12,0,0,.08,0,.12A5.53,5.53,0,0,1,777.54,483.56Zm0-1.08c.08,0,.08,0,.09.08a.08.08,0,0,1-.09.07c-.07,0-.09,0-.08-.07S777.49,482.48,777.56,482.48Zm.1-.11a.15.15,0,0,1-.17,0s0-.08-.08,0-.43.06-.64.06-.13,0-.12-.1.07-.06.15-.07h.38c.12,0,.25,0,.38,0s.14,0,.14.07A.1.1,0,0,1,777.66,482.37Zm.86.74a3.58,3.58,0,0,0-.09.45c0,.1-.06.15-.22.14h0c-.54,0-.54,0-.53-.37,0-.13,0-.31.06-.5s.06-.1.18-.11C778.49,482.66,778.62,482.75,778.52,483.11Zm.56-.19a2.36,2.36,0,0,0-.08.56c0,.12-.07.24-.33.21s-.12-.16-.11-.24a2.82,2.82,0,0,0,.09-.57c0-.12.06-.16.26-.16S779.07,482.81,779.08,482.92Z"
            />
            <path
              class="cls-116"
              d="M776.06,488.79a.11.11,0,0,0-.06,0h0v0a.1.1,0,0,1-.14,0,.9.9,0,0,0-.4,0c-.15.26,0,.53-.06.8.07.05,0,.09-.05.11v.06c.45-.06.44-.06.46-.34s0-.32.06-.48a.92.92,0,0,1,0,.52c0,.08,0,.13.14.13,0-.22,0-.45.08-.67A.5.5,0,0,0,776.06,488.79Zm-.53.87a.17.17,0,0,1,0-.25C775.6,489.51,775.6,489.59,775.53,489.66Z"
            />
            <path
              class="cls-116"
              d="M775.71,485.53h.06c.11,0,.27,0,.32.05s-.19,0-.23.12c.19,0,.24,0,.21.16s0,.55-.07.82c0,.08.07.18-.1.23s-.19-.09-.31-.11v-.07c.07,0,.11,0,0-.07Z"
            />
            <path
              class="cls-116"
              d="M776,482.71c.47,0,.48,0,.42.31a1.15,1.15,0,0,0,0,.45c0,.14,0,.25-.25.33s-.24,0-.23-.08A6.91,6.91,0,0,1,776,482.71Z"
            />
            <path
              class="cls-116"
              d="M777.42,488.06c.09.06.19,0,.28,0s.19,0,.2.1,0,.11-.16.12-.26,0-.38,0-.23,0-.28-.07.07-.1.16-.12a.18.18,0,0,0,.07-.05Z"
            />
            <path
              class="cls-116"
              d="M776.65,488.13c.06.08.13.19,0,.23a1,1,0,0,1-.56.05c-.18-.07,0-.15.06-.23h.17c.08.05.14,0,.18,0Z"
            />
            <path
              class="cls-115"
              d="M779.19,482.14a.65.65,0,0,1-.31,0H776.1c.06-.07.17,0,.26,0Z"
            />
            <path
              class="cls-116"
              d="M775.51,488.27h.17c.11,0,.2,0,.2.09s-.08.09-.17.1a1,1,0,0,0-.25,0C775.36,488.42,775.38,488.34,775.51,488.27Z"
            />
            <path
              class="cls-116"
              d="M776.05,482.47h.27c.07,0,.17,0,.16.06s0,.11-.15.12H776C775.94,482.59,776.07,482.53,776.05,482.47Z"
            />
            <path
              class="cls-116"
              d="M776.1,482.21c.14,0,.4-.06.4.09s-.27.06-.42.09h0A.18.18,0,0,1,776.1,482.21Z"
            />
            <path
              class="cls-116"
              d="M778.37,488c0,.08,0,.18-.12.22s-.22,0-.27,0,0-.14.15-.16l.2,0Z"
            />
            <path
              class="cls-116"
              d="M775.46,488.57h.17c.09,0,.2-.05.23,0s-.05.12-.19.13l-.25,0Z"
            />
            <path
              class="cls-115"
              d="M777.66,485.14c-.12.07-.35.05-.34.21s-.08,0-.14,0-.07-.06,0-.09.1-.09,0-.14Z"
            />
            <path
              class="cls-115"
              d="M776.94,485.18c-.12.12-.34,0-.47.08a.26.26,0,0,1-.18,0,.58.58,0,0,0-.41,0h-.07c0-.08.05-.07.13-.07Z"
            />
            <path
              class="cls-116"
              d="M775.81,485.3h.07c.1,0,.27,0,.27.07s-.17.07-.27.08h-.15C775.75,485.4,775.72,485.34,775.81,485.3Z"
            />
            <path
              class="cls-116"
              d="M777,488.1c.06.08.11.16,0,.24a.12.12,0,0,1-.13,0c-.1-.08,0-.15,0-.22Z"
            />
            <path
              class="cls-117"
              d="M775.36,489.63c.07.05,0,.09-.05.11S775.29,489.66,775.36,489.63Z"
            />
            <path
              class="cls-117"
              d="M776.48,488.15c0,.06-.1.07-.18,0A.22.22,0,0,1,776.48,488.15Z"
            />
            <path
              class="cls-115"
              d="M778.56,488h-.16c0-.06.12-.07.2-.08S778.6,488,778.56,488Z"
            />
            <path class="cls-117" d="M775.62,486.65c.09,0,0,.05,0,.07Z" />
            <path
              class="cls-117"
              d="M772.47,484.58c-.22,0-.3,0-.29-.17s0-.3,0-.45c-.46,0-.92,0-1.38,0a.72.72,0,0,1-.19,0c-.15.21-.08.42-.08.63l1.41.07h.18a.06.06,0,0,1,0,0v0l0,0h.2v0h0v0c0,.1-.12.11-.23.14V485h0c.11,0,.23,0,.22.09s-.06.15-.22.15h0v.07l.06,0c.12,0,.19,0,.18.07a11.35,11.35,0,0,1-.09,1.15,4.43,4.43,0,0,0,0,.52c0,.1-.06.16-.24.15h0c0,.1-.1.12-.23.1l-1.32-.17a.14.14,0,0,0-.11.17v.52a2.38,2.38,0,0,0,1,.08,1.13,1.13,0,0,1,.31,0c.16.1.11.27-.1.31s-.41,0-.6.09c.32,0,.6.12.93.12a4.59,4.59,0,0,0,.1-.9c0-.16.11-.22.36-.24l1.25-.1c0-.33.06-.66.08-1l.15-1.73Zm.17.12.82-.05c.11,0,.16,0,.16.11s0,.1-.15.11l-.61,0h-.18c-.1,0-.18,0-.19-.09S772.54,484.71,772.64,484.7Zm1,.39c0,.08-.06.1-.18.11l-.63,0c-.12,0-.3.08-.31-.08s.15-.14.31-.15l.61,0C773.54,485,773.62,485,773.61,485.09Zm-.16,1.87c0,.18-.13.23-.38.23s-.28,0-.41,0-.39,0-.32-.22c0-.46.06-1,.09-1.47,0-.11.07-.18.28-.18s.45,0,.68,0,.22,0,.21.14C773.54,486,773.48,486.45,773.45,487Z"
            />
            <path
              class="cls-116"
              d="M773.8,483.49v.07s-.06,0-.06.06c0,.2-.15.24-.43.23h-.46c-.1,0-.2,0-.25.07h-.11c0-.17,0-.33,0-.49a9.17,9.17,0,0,0,.06-1.17c0-.15.1-.25.36-.25h.77c.17,0,.17.07.16.15,0,.33-.08.67-.1,1C773.79,483.27,773.74,483.38,773.8,483.49Z"
            />
            <path
              class="cls-110"
              d="M771.84,488.51a4.59,4.59,0,0,0,.1-.9c0-.16.11-.22.36-.24l1.25-.1c.08,0,.06.08.06.13l-.09.85c0,.05,0,.11-.11.12C772.88,488.41,772.37,488.51,771.84,488.51Z"
            />
            <path
              class="cls-110"
              d="M772.43,481.45c0-.3.09-.59.05-.89l1.54,0c.09,0,.18,0,.17.09,0,.24-.05.48-.08.72,0,0,0,.06-.08.07Z"
            />
            <path
              class="cls-110"
              d="M772.49,483.92h1.32a.68.68,0,0,1,0,.62l-1.31,0c-.22,0-.3,0-.29-.17s0-.3,0-.45a0,0,0,0,0,0,0l.18,0A.08.08,0,0,0,772.49,483.92Z"
            />
            <path
              class="cls-109"
              d="M771.39,491c0,.17-.1.25-.37.23l.2-2.65c.14.07.18.16.33.14l0,.12Z"
            />
            <path
              class="cls-114"
              d="M765.74,489c0-.07,0-.1.15-.11.84-.07,1.66-.19,2.51-.22a3.14,3.14,0,0,1,0,.61h-.07a4.6,4.6,0,0,1,0,.74c0,.18-.28.12-.44.14s-.15-.07-.15-.14a1.24,1.24,0,0,1,.05-.47.36.36,0,0,0,.34.13c.17,0,.12-.14.14-.22a5.62,5.62,0,0,1,.09-.57c0-.1,0-.13-.18-.13s-.39.11-.39.28,0,.18-.06.26c-.12-.1-.06-.22,0-.33s-.09-.17-.29-.14c-.42.05-.85.06-1.26.14Z"
            />
            <path
              class="cls-109"
              d="M768.55,490.05c0-.28,0-.55,0-.83,0-.09.12-.09.22-.11.63-.09.61-.09.61.31,0,.16-.1.33,0,.49A4.68,4.68,0,0,1,768.55,490.05Z"
            />
            <path
              class="cls-117"
              d="M768.55,490.05a4.68,4.68,0,0,0,.86-.14c.13.12,0,.25.12.37h-.17v0c0-.07.11-.2-.17-.15l-.13,0a.12.12,0,0,0-.17,0,0,0,0,0,1,0,0c-.07,0-.17-.08-.17,0s0,.11-.1.12l-.1,0c0-.16-.16-.08-.27-.08s-.2,0-.18.12,0,.17.11.18.3,0,.37-.09l.11.08v.08l-.49.08-.1,0c-.08,0,0-.14-.24-.1s-.13-.16-.21-.24,0,.07,0,.11.07.12-.08.12-.15-.06-.15-.12,0-.15-.07-.21.27,0,.24-.14a1.47,1.47,0,0,1,.12-.77c.09.07,0,.15.06.22a1.24,1.24,0,0,0-.05.47c0,.07,0,.17.15.14s.4,0,.44-.14a4.6,4.6,0,0,0,0-.74h.07v.8c0,.06.11,0,.18,0Z"
            />
            <path
              class="cls-109"
              d="M772.21,490.93l-.33,0,.18-2.16,0-.05c.23,0,.32,0,.3.18-.06.58-.12,1.16-.17,1.74A2.09,2.09,0,0,0,772.21,490.93Z"
            />
            <path
              class="cls-117"
              d="M774,481.67c.1-.05,0-.12,0-.18h-1.6c.06,0,.2.05.17.14a.22.22,0,0,1-.22.12v0c.09,0,.17,0,.17.09s-.08.09-.18.09v0c.22,0,.19.1.17.18-.09.4,0,.81-.1,1.21a4.88,4.88,0,0,0-.06.52.08.08,0,0,0,.12,0c0-.17,0-.33,0-.49a11.48,11.48,0,0,0,.07-1.17c0-.15.09-.25.35-.25h.77c.17,0,.17.07.16.15,0,.33-.08.67-.1,1,0,.11,0,.22,0,.33.09,0,.06-.1.06-.15C773.9,482.79,773.94,482.23,774,481.67Zm-.19.28h-.91c-.1,0-.21,0-.2-.09s.09-.08.18-.09c.32,0,.63,0,.94,0,.07,0,.11,0,.11.06S773.87,482,773.78,482Zm-.19-.21h-.74c-.11,0-.19,0-.19-.1s.05-.11.18-.11h.89c.17,0,.21.06.24.14A.67.67,0,0,1,773.59,481.74Z"
            />
            <path
              class="cls-113"
              d="M769.36,490.28h.17c.18,0,.37.07.56.09s.21.08.11.17-.13.06-.22,0-.24-.19-.51-.16h-.18Z"
            />
            <path
              class="cls-117"
              d="M773.81,483.92H772.6c0-.08.15-.06.25-.07h.46c.28,0,.46,0,.43-.23,0,0,0,0,.06-.06Z"
            />
            <path
              class="cls-113"
              d="M772.08,488.76l0,.05-.49,0,0-.12C771.89,488.61,772,488.62,772.08,488.76Z"
            />
            <path
              class="cls-119"
              d="M774,481.49h-1.66v0H774A0,0,0,0,1,774,481.49Z"
            />
            <path class="cls-109" d="M768.53,490.05c-.07,0-.14,0-.18,0Z" />
            <path
              class="cls-109"
              d="M749.77,488.22c.22.09.22.2.05.32a10.4,10.4,0,0,0-1.37.1h-.12c-.15,0-.3.07-.46,0,0-.26,0-.27.41-.27a2.32,2.32,0,0,0,.53,0A5.14,5.14,0,0,0,749.77,488.22Z"
            />
            <path
              class="cls-114"
              d="M750.93,490.7c-.1,0-.14.14-.31.11,0-.28,0-.56,0-.84s-.08-.54,0-.81c0-.05-.06-.14.1-.14s.13.07.14.14c0,.28,0,.57.07.86,0,.11,0,.23,0,.34s-.08.18.09.24Z"
            />
            <path
              class="cls-111"
              d="M748.33,488.63h.12c0,.38.09.76.09,1.14,0,.15.19.2.27.3a.28.28,0,0,1-.18,0c-.17-.06-.23-.15-.23-.28,0-.37,0-.73-.08-1.1Z"
            />
            <path
              class="cls-117"
              d="M750.57,490c0,.28,0,.56,0,.84-.09,0-.14,0-.14-.09l-.06-.74s0-.05.05-.08Z"
            />
            <path
              class="cls-114"
              d="M749,489.15v.1h-.17v-.47s0-.1.08-.1.1.05.09.09S749.07,489,749,489.15Z"
            />
            <path
              class="cls-115"
              d="M750.93,490.6c-.17-.06-.08-.16-.09-.24s0-.23,0-.34.16,0,.17.1C750.86,490.27,751,490.44,750.93,490.6Z"
            />
            <path
              class="cls-109"
              d="M748.81,489.26H749c0,.12.09.25,0,.37s-.17-.07-.17-.15Z"
            />
            <path
              class="cls-119"
              d="M746.56,490.24v.1a6.66,6.66,0,0,0-1.55.21h0l0-.31,1-.09c0,.07.08.1.18,0l.15,0Z"
            />
            <path
              class="cls-111"
              d="M764.44,488.37h.11c.28.08.38,0,.35-.16s.18-.16.53-.12a1.47,1.47,0,0,0-.1.74c0,1-.12,2-.07,3a1.22,1.22,0,0,1-.47.06v-.07c-.06-.08.14-.21-.11-.27h-.17c0-.09.13-.09.24-.1s0-.13,0-.2-.13-.28,0-.41a.36.36,0,0,0,0-.27v-.07a1.53,1.53,0,0,0,0-.64v-.14c.12-.16,0-.31,0-.47v-.08a.28.28,0,0,0,0-.25c.19,0,.25-.07.25-.17s-.12-.19-.28-.22A.67.67,0,0,1,764.44,488.37Z"
            />
            <path
              class="cls-118"
              d="M771.3,488a2.38,2.38,0,0,1-1-.08l-.32,0c-.21,0-.4,0-.51.13.06.12,0,.18-.22.14l-.54-.06-.43,0,.12.15h.17s.07,0,.09,0,0,0-.08,0v0h0l.11,0,1.5-.15a13.38,13.38,0,0,0,1.42-.14A1.13,1.13,0,0,0,771.3,488Zm-1.61.17,0,0h0l0,0Zm0-.11h0l0,0h0Z"
            />
            <path
              class="cls-117"
              d="M767.06,490.59l0,0-.7.08c-.19,0-.4,0-.39-.16s0,0-.07,0-.07,0-.07.07,0,.28.28.32l0,0a1.7,1.7,0,0,0-.46.07l0-.71c.37,0,.37,0,.34-.37.11-.15,0-.3.06-.45h.12V490a.23.23,0,0,0,0,.21,1,1,0,0,0,0,.17c0,.2,0,.22.35.18l.49-.06Z"
            />
            <path
              class="cls-118"
              d="M766.86,488.25c.09-.18.33-.18.58-.15l.31,0c.1,0,.23-.08.29,0l0,0a.24.24,0,0,0,.17,0l.22,0,.2,0h0v0l-.58.07a1.46,1.46,0,0,1-.55,0c-.09,0-.14-.08-.13,0s-.22,0-.34,0h0s-.05-.07-.13-.08Z"
            />
            <path
              class="cls-114"
              d="M766,489.89c0,.33,0,.33-.34.37a3.58,3.58,0,0,1,0-1l.23,0A1.62,1.62,0,0,0,766,489.89Z"
            />
            <path
              class="cls-111"
              d="M766.86,488.25v.07c0,.05,0,.07.13.08h0a.75.75,0,0,1-.3,0,.1.1,0,0,0-.1,0h.1a1.16,1.16,0,0,1-.84,0,.09.09,0,0,1-.05-.1c.05,0,.14,0,.16,0,.12-.25.42-.13.67-.13C766.7,488.2,766.76,488.26,766.86,488.25Zm-.76.14h0Z"
            />
            <path
              class="cls-119"
              d="M765.66,491a1.7,1.7,0,0,1,.46-.07l.38.07,0,0a2.12,2.12,0,0,1-.87.09C765.62,491.05,765.61,491,765.66,491Z"
            />
            <path class="cls-116" d="M766,489.27l-.23,0V489H766l.06.08v.25Z" />
            <path
              class="cls-111"
              d="M765.73,488.22v.07C765.68,488.26,765.69,488.24,765.73,488.22Z"
            />
            <path class="cls-111" d="M768.58,488.28v0l.11,0Z" />
            <path class="cls-119" d="M765.68,491.3h0v0Z" />
            <path
              class="cls-115"
              d="M757.35,489.56a9.42,9.42,0,0,1,1.08-.1v.65c0,.17,0,.35,0,.52s-.06.14-.21.14h0c-.73,0-.81,0-.71-.55l-.07-.26v-.2A.23.23,0,0,0,757.35,489.56Z"
            />
            <path
              class="cls-116"
              d="M757.41,490l.07.26a6.78,6.78,0,0,1-2,0,6.64,6.64,0,0,1,.71-.58,8.33,8.33,0,0,1,1.12-.11.23.23,0,0,1,.07.2l-.84.09c-.13,0-.39,0-.32.13s.26,0,.41,0l.08,0A1.06,1.06,0,0,1,757.41,490Z"
            />
            <path
              class="cls-116"
              d="M758.43,490.11v-.28l.52,0c.37,0,.55.06.55.29h0A3.91,3.91,0,0,0,758.43,490.11Z"
            />
            <path
              class="cls-113"
              d="M759.5,490.08c0-.23-.18-.32-.55-.29l-.52,0v-.19c.24,0,.47,0,.7,0s.41-.07.37-.25l2.86-.28c.38,0,.39,0,.28-.27l1.18.21c.36,0,.7-.08,1.06-.1a.28.28,0,0,1,0,.25c-.12,0-.08-.14-.23-.08s-.18.06-.18.14a3.8,3.8,0,0,1,0,.89v.68c.06.11-.11.28.21.32,0,0,0,0,0,.07l.12.26c-.11,0-.23,0-.24.1s0,.16,0,.23c-.1.1-.26.08-.41.08,0-.78,0-1.56.05-2.34,0-.14,0-.22-.26-.1s-.36.16-.58.2l-.23,0h0l0,0a.17.17,0,0,1,0-.1c.08-.18-.07-.2-.3-.18l-.35,0c0-.11-.09-.15-.23,0a11.58,11.58,0,0,0-1.4.52Zm3.21-.84c.13,0,.27,0,.36-.06s0-.06,0-.07a.67.67,0,0,0-.37,0c-.08,0-.24,0-.21.09S762.63,489.24,762.71,489.24Z"
            />
            <path
              class="cls-115"
              d="M778.14,488.54c.13,0,.17,0,.17.1v.27c.15-.12,0-.27.18-.34a2.42,2.42,0,0,1-.1.84c-.12-.08,0-.17-.07-.26s0-.13-.06-.18-.15-.09-.11-.15A.39.39,0,0,0,778.14,488.54Z"
            />
            <path
              class="cls-115"
              d="M779.07,482.21h.23a.43.43,0,0,1,0,.33h-.12l-.06-.07v-.07C779.18,482.33,779.07,482.27,779.07,482.21Z"
            />
            <path
              class="cls-115"
              d="M778.5,488.5c-.08-.15-.16-.3,0-.44A.68.68,0,0,1,778.5,488.5Z"
            />
            <path
              class="cls-116"
              d="M762.43,489.34l.35,0c.23,0,.38,0,.3.18a.17.17,0,0,0,0,.1l0,0h0l0,.08a.44.44,0,0,0-.1.26c0,.11.17.23,0,.33a2.17,2.17,0,0,1-.54.09v-.83C762.46,489.5,762.44,489.42,762.43,489.34Z"
            />
            <path
              class="cls-114"
              d="M762.47,490.4a2.17,2.17,0,0,0,.54-.09c.16-.1,0-.22,0-.33a.44.44,0,0,1,.1-.26c0,.41,0,.83,0,1.24,0,.23-.33.15-.51.18s-.13-.1-.13-.16S762.47,490.6,762.47,490.4Z"
            />
            <path
              class="cls-129"
              d="M746,490.16l-1,.09.13-1.61a.4.4,0,0,0,.22,0,.36.36,0,0,1,.34.13,1.55,1.55,0,0,0,.23.21.57.57,0,0,0,.08.13h0v.11a.22.22,0,0,0,0,.29c0,.12,0,.25,0,.37S746.06,490.08,746,490.16Z"
            />
            <path
              class="cls-111"
              d="M745.91,489a1.55,1.55,0,0,1-.23-.21.36.36,0,0,0-.34-.13.4.4,0,0,1-.22,0l0-.58c.1,0,.2,0,.3,0a1.7,1.7,0,0,1,.39,0C745.84,488.37,746,488.69,745.91,489Z"
            />
            <path
              class="cls-115"
              d="M746.56,490.24l-.21-.08a3.31,3.31,0,0,1-.08-.55c0-.07-.12-.15,0-.21s.15.08.15,0,.11,0,.17,0a6.83,6.83,0,0,0,.06.79Z"
            />
            <path
              class="cls-110"
              d="M746.29,489.4c-.14.06,0,.14,0,.21a3.31,3.31,0,0,0,.08.55l-.15,0c-.14-.08,0-.21-.13-.28l0-.37c.05-.1.08-.19,0-.29v-.11C746.2,489.18,746.17,489.32,746.29,489.4Z"
            />
            <path
              class="cls-117"
              d="M746.67,490.13a6.83,6.83,0,0,1-.06-.79A.83.83,0,0,1,746.67,490.13Z"
            />
            <path
              class="cls-120"
              d="M745.86,488.05a1.7,1.7,0,0,0-.39,0c.08-.06,0-.11,0-.17a1.14,1.14,0,0,1,.52.17Z"
            />
            <path
              class="cls-109"
              d="M748.23,487.81a3.27,3.27,0,0,0-1.1-.24,9.38,9.38,0,0,1-1.59,0c0,.05.07.08.15.1l1,.32a.26.26,0,0,0-.11-.15c.23-.11.52,0,.75-.1h-.56v0l.8-.06c-.08.06-.2,0-.24.08h.44c-.33,0-.64.12-1,.14a2.44,2.44,0,0,1,.06.71c0,.06,0,.14.11.16a.61.61,0,0,0,.36,0c.09-.07,0-.12-.08-.18a.29.29,0,0,1-.1-.24c0-.08,0-.13.18-.12l.13-.08h0l.31-.05h.08l.15,0h.12c.2,0,.4,0,.6,0h0A1.44,1.44,0,0,0,748.23,487.81Zm-2-.09h0s0,0,0,0Zm.22.07h0Zm.06-.09a.68.68,0,0,1,.4,0Zm.59,0v0h.22v0Z"
            />
            <path
              class="cls-110"
              d="M747,487.15c-.5,0-1,.07-1.51.08h-.24a.14.14,0,0,1,0,.08l-.05.74c.1,0,.2,0,.3,0s0-.11,0-.17c-.22-.17-.2-.26.07-.29a9.38,9.38,0,0,0,1.59,0C747.14,487.42,747.2,487.27,747,487.15Z"
            />
            <path
              class="cls-118"
              d="M747.38,488.2l.13-.08a8.68,8.68,0,0,0,1.26-.1h0a3.8,3.8,0,0,1,1,.2,5.14,5.14,0,0,1-1,.12,1.64,1.64,0,0,0-.85,0C747.74,488.3,747.52,488.35,747.38,488.2Z"
            />
            <path
              class="cls-113"
              d="M747.38,487.76h.44c-.33,0-.64.12-1,.14-.09,0-.05.09-.11.11a.21.21,0,0,0-.11-.15c.23-.11.52,0,.75-.1Z"
            />
            <path
              class="cls-119"
              d="M748.32,488.67c0,.37.07.73.08,1.1,0,.13.06.22.23.28,0,.11-.16.17-.3.22a.43.43,0,0,1-.1-.33,6.09,6.09,0,0,1-.08-1.12C748.16,488.75,748.13,488.67,748.32,488.67Z"
            />
            <path class="cls-117" d="M771.57,488.84l.49,0-.18,2.16-.49,0Z" />
            <path
              class="cls-114"
              d="M767.06,490.59l-.07-.06a3.45,3.45,0,0,0-.82-.29.23.23,0,0,1,0-.21,3.74,3.74,0,0,0,.82.08l.49,0c0,.12-.21.06-.24.14s0,.24-.06.36Z"
            />
            <path
              class="cls-119"
              d="M768.15,490.67l.49-.08.86-.09c.14,0,.21.08.33.08h0a.24.24,0,0,1-.16.08l-1.3.16a.33.33,0,0,1-.22,0Z"
            />
            <path
              class="cls-118"
              d="M769.83,490.58c-.12,0-.19-.1-.33-.08l0-.07c.27,0,.45,0,.51.16h-.15Z"
            />
            <path class="cls-113" d="M769.83,490.58h0Z" />
            <path
              class="cls-120"
              d="M766.52,491l0,0c0-.12-.14-.12-.26-.15s-.15,0-.15.05c-.3,0-.3-.18-.28-.32s0-.07.07-.07.07,0,.07,0,.2.16.39.16a.45.45,0,0,0,.23.07c.25,0,.32.09.18.22C766.64,490.88,766.61,491.05,766.52,491Z"
            />
            <path
              class="cls-119"
              d="M766.5,491.34s0,.05-.06.05-.12,0-.12-.07l.09,0C766.48,491.28,766.5,491.31,766.5,491.34Z"
            />
            <path
              class="cls-120"
              d="M764.55,491.77c-.07-.07,0-.15,0-.23h.17c.25.06.05.19.11.27A.35.35,0,0,1,764.55,491.77Z"
            />
            <path
              class="cls-133"
              d="M761,487.55a2,2,0,0,0,.73.22,2.21,2.21,0,0,1,.58.11,5.91,5.91,0,0,1-1,.12l-3.54.28-4,.31L751,487.9a4.83,4.83,0,0,1-1-.26,8.27,8.27,0,0,1,.87-.08c.13,0,.23,0,.22-.14.89,0,1.76-.1,2.65-.15L758,487l2.5.41A3.51,3.51,0,0,1,761,487.55Z"
            />
            <path
              class="cls-117"
              d="M769.13,485.49c0-.18,0-.35,0-.52s0-.13-.08-.13h0l-.1,0h-.33s-.09.07-.13,0a.05.05,0,0,0-.06-.05,3.36,3.36,0,0,1-1.27.12h-.06l0,0h0s0,0,0,0h0l-.07,0c0,.09-.1.11-.23.11s-.16,0-.17-.11h0c0,.13-.18.13-.32.14l-.74,0c-.17,0-.12-.06-.14-.11l-.11,0c0,.16-.22.09-.36.1v.08H765c.1,0,.17,0,.17.08s-.07.09-.16.1l-.23,0v.05c.4,0,.4,0,.4.22s0,.3,0,.44,0,.25-.41.24v.11c.09,0,.29-.09.29.08v.12c.07.05.05.07,0,.09s-.19,0-.2.11-.07.14.15.12c1-.07,2-.13,3-.21a5.88,5.88,0,0,0,1.11-.1C769.11,486.26,769.1,485.87,769.13,485.49Zm-3.7-.34.94,0c.07,0,.11,0,.11.07s0,.09-.11.11a1.84,1.84,0,0,1-.41,0h-.5c-.08,0-.14,0-.15,0S765.33,485.16,765.43,485.15Zm-.09,1.57c-.08,0-.09-.06-.09-.1v-.14a.35.35,0,0,0,0-.08l0-.07c0-.26,0-.52,0-.78,0-.09.06-.12.21-.14a2.38,2.38,0,0,1,.84,0c.26.09,0,.31.08.47a1.21,1.21,0,0,1,0,.38c0,.06,0,.12-.08.15-.3.09-.14.15.08.21A5.17,5.17,0,0,1,765.34,486.72Zm1.38-1.63c.1,0,.18,0,.18.09s-.06.09-.16.09-.18,0-.18-.08S766.62,485.09,766.72,485.09Zm.1,1.63c-.08-.09-.27-.08-.32-.17v-.15c0-.07.12-.07.24-.1-.18-.05-.23-.1-.21-.21a2.26,2.26,0,0,0,0-.58c0-.08,0-.16.19-.16s.17.08.17.15A5.09,5.09,0,0,1,766.82,486.72Zm.34-1.66a6.32,6.32,0,0,1,1.23,0c.08,0,.06,0,.09,0a.93.93,0,0,1,.47,0c.07,0,.09,0,.09.08s-.08.09-.17.1l-1.41.08h-.26c-.09,0-.17,0-.17-.06S767,485.05,767.16,485.06Zm1.13,1.41c0,.13-.11.18-.31.18s-.51,0-.76.05-.26,0-.25-.14a1.33,1.33,0,0,0,0-.2,6.4,6.4,0,0,0,.06-.88c0-.13.12-.15.27-.16.3,0,.6,0,.89,0s.22,0,.19.12C768.27,485.76,768.38,486.11,768.29,486.47Zm.57.11a.77.77,0,0,1-.37,0c-.13,0-.09-.1-.09-.16s0-.09,0-.14a4,4,0,0,0,.06-.91c0-.17.22-.15.4-.16s.2.08.19.17c0,.32,0,.65,0,1A.23.23,0,0,1,768.86,486.58Z"
            />
            <path
              class="cls-117"
              d="M769.33,481.86a1.61,1.61,0,0,0,0-.22h-.11c0,.07,0,.13-.17.13s-.35,0-.41-.14c-.13.2-.37.15-.58.14s-.43,0-.65,0-.23-.05-.22-.14h-.1c0,.06,0,.13-.18.13s-.19,0-.19-.12h-.11c0,.09-.09.11-.22.11h-.82c-.18,0-.22-.05-.22-.14s-.1.09-.21.14c0-.13-.06-.2-.25-.19v.3l.13,0c.09,0,.2,0,.2.06s-.09.08-.18.08h-.15v.08c.26,0,.37,0,.36.2,0,.34,0,.68,0,1,0,.17-.1.22-.35.19,0,.11.15.08.24.08.47,0,.93,0,1.39,0s1.15,0,1.72,0l1,0C769.27,482.91,769.3,482.38,769.33,481.86Zm-3.81,0h.91c.09,0,.17,0,.16.07s-.08.07-.15.07h-.91c-.09,0-.17,0-.16-.08S765.45,481.83,765.52,481.82Zm-.18,1.41,0,0s0,0,0,0l0,0Zm1.13.18c-.24,0-.49.08-.7-.06s0-.12,0-.18a.14.14,0,0,0-.15-.1c-.32,0-.29-.13-.26-.24a2.4,2.4,0,0,0,0-.65c0-.09,0-.14.21-.14h.83c.15,0,.22,0,.21.13,0,.38,0,.77-.05,1.15C766.54,483.36,766.53,483.41,766.47,483.41Zm.88-1.58h1.06c.08,0,.14,0,.14.07s-.07.07-.14.08h-1.06c-.08,0-.14,0-.14-.07S767.28,481.83,767.35,481.83Zm-.45,0c.08,0,.16,0,.16.07s-.08.07-.16.07-.17,0-.16-.07S766.82,481.83,766.9,481.83Zm0,1.31a1,1,0,0,1,0,.16c0,.05,0,.1-.1.11s-.13,0-.13-.09,0-.31,0-.52a3.11,3.11,0,0,1,.06-.64c0-.07,0-.11.17-.12s.14,0,.16.11c.08.31-.08.61,0,.92C767,483.16,766.8,483,766.85,483.14Zm1.64.05c0,.14-.11.22-.37.2s-.23,0-.35,0-.33,0-.34-.14c-.17,0-.15.07-.22.13-.18-.16.18-.18.17-.28-.29-.11-.25-.28-.24-.44s0-.32,0-.47.08-.15.25-.15h1c.12,0,.15,0,.14.08A6.18,6.18,0,0,0,768.49,483.19Zm.17-1.28a.15.15,0,0,1,.12-.05h.43l0,0v0c-.13.13-.33.05-.5.06S768.65,481.94,768.66,481.91Zm0,1.48c-.07,0-.06-.06,0-.1a8,8,0,0,0,.06-1.1c0-.13.15-.12.29-.12s.29,0,.29.11v.2a3.58,3.58,0,0,0-.05.82C769.15,483.35,768.84,483.46,768.62,483.39Z"
            />
            <path
              class="cls-115"
              d="M771.6,487.2c-.18.05-.24,0-.23-.1a8.76,8.76,0,0,1,.08-1,2.21,2.21,0,0,1,.09-.67s0,0,0,0h0c.16-.08.35,0,.53,0v-.07l-.35,0c-.17,0-.13-.1-.12-.17s.12-.05.2-.05h.32V485h0c-.18-.05-.53,0-.48-.21l-.23,0c0,.07.14.17-.12.18-.46,0-.52,0-.53-.22h-.18c-.08.85-.16,1.7-.18,2.55l1.32.17c.13,0,.23,0,.23-.1A.83.83,0,0,1,771.6,487.2Zm-.85-2.26a4.24,4.24,0,0,1,.51,0c.14,0,.17.07.16.15s-.13.08-.23.07C770.94,485.19,770.71,485.16,770.75,484.94Zm.28,2.24c-.5-.06-.53-.06-.48-.37s0-.92.1-1.38a.47.47,0,0,1,.06-.09c.16-.16.36,0,.55,0s.11.08.1.14.08.14,0,.21v.47a.1.1,0,0,1-.06.11v.8C771.31,487.18,771.22,487.21,771,487.18Z"
            />
            <path
              class="cls-109"
              d="M764.88,488.91c-.36,0-.7.1-1.06.1.08-.21,0-.34-.38-.4-.15,0-.38,0-.45-.14a6.36,6.36,0,0,1,1.45-.1.67.67,0,0,0,.41.15c.16,0,.3.09.28.22S765.07,488.91,764.88,488.91Z"
            />
            <path
              class="cls-115"
              d="M772.35,482H772c-.07,0-.17,0-.18-.06s.07-.11.18-.11.26,0,.38,0h0v0h-.31c-.17,0-.25,0-.24-.14h-.11c0,.1-.06.16-.24.15s-.51.08-.6-.14h-.07a2.51,2.51,0,0,0,0,.27c0,.68-.09,1.35-.14,2a.72.72,0,0,0,.19,0c.46,0,.92,0,1.38,0v0a.09.09,0,0,0,0-.05h0a.36.36,0,0,1-.21-.05c-.26,0-.36,0-.29-.2s0-.3.07-.45v-.06h-.12l-.06.07c0,.15,0,.3,0,.45s-.3.15-.51.17-.27-.05-.26-.17,0-.3,0-.45v-.07c0-.05,0-.11.06-.15v0a.19.19,0,0,1,0-.28,1.38,1.38,0,0,0,.06-.53c0-.08,0-.14.2-.13a1.17,1.17,0,0,1,.62.08h.07c.16-.14.38-.05.58-.06h0v0Zm-.91,0h-.35c-.11,0-.21,0-.2-.09s.09-.09.19-.09h.35c.1,0,.21,0,.21.09S771.54,482,771.44,482Z"
            />
            <path
              class="cls-115"
              d="M769.11,486.65c0-.39,0-.78,0-1.16,0-.18,0-.35,0-.52s-.06-.16-.23-.09c-.13-.15-.35-.13-.56-.12a.94.94,0,0,1,.6-.06,1,1,0,0,0,.4,0V486c0,.17,0,.35,0,.52S769.27,486.67,769.11,486.65Z"
            />
            <path
              class="cls-120"
              d="M766.72,481.63h-.11a2.82,2.82,0,0,0-1.26,0c-.12,0-.1.09-.21.14,0-.13-.06-.2-.25-.19,0-.09,0-.13.19-.13,1.18,0,2.37,0,3.55,0l.83,0c.08,0,.16,0,.15.08a.77.77,0,0,0-.28.08h-.11c-.23-.14-.52-.06-.78-.07a5.22,5.22,0,0,0-1.25,0h-.1C767,481.58,766.83,481.52,766.72,481.63Z"
            />
            <path
              class="cls-116"
              d="M764.89,482.05c.26,0,.37,0,.36.2,0,.34,0,.68,0,1,0,.17-.1.22-.35.19C764.81,483,764.89,482.51,764.89,482.05Z"
            />
            <path
              class="cls-115"
              d="M769.33,481.64a.77.77,0,0,1,.28-.08c0,.6-.07,1.19-.1,1.78,0,.13-.15.11-.28.09,0-.52.07-1.05.1-1.57A1.61,1.61,0,0,0,769.33,481.64Z"
            />
            <path
              class="cls-111"
              d="M763,488.47c.07.14.3.11.45.14.36.06.46.19.38.4l-1.18-.21C762.53,488.52,762.57,488.48,763,488.47Z"
            />
            <path
              class="cls-116"
              d="M764.79,485.43c.4,0,.4,0,.4.22s0,.3,0,.44,0,.25-.4.24A6.76,6.76,0,0,1,764.79,485.43Z"
            />
            <path
              class="cls-116"
              d="M768.38,484.76c.21,0,.43,0,.56.12a.78.78,0,0,1-.31,0h-.13a.05.05,0,0,0-.06-.05,3.36,3.36,0,0,1-1.27.12c-.12,0-.14-.05-.15-.1a.31.31,0,0,1,.24-.08,6.68,6.68,0,0,0,.78,0Z"
            />
            <path
              class="cls-116"
              d="M759.5,489.35c0,.18-.11.24-.37.25s-.46,0-.7,0v-.18A9.46,9.46,0,0,1,759.5,489.35Z"
            />
            <path
              class="cls-119"
              d="M768,484.76a6.68,6.68,0,0,1-.78,0,.31.31,0,0,0-.24.08l-.07,0c-.13-.05-.27-.12-.4,0h0a2.83,2.83,0,0,0-1.16,0s0,0,0,0l-.11,0a.27.27,0,0,0-.35-.08c0-.05,0-.06.11-.07l3-.11A.18.18,0,0,1,768,484.76Z"
            />
            <path
              class="cls-113"
              d="M770.77,484.65h-.18a.12.12,0,0,1-.05-.14l1.41.07c.11,0,.2,0,.17.1H772a.54.54,0,0,0-.31,0l-.23,0A2.37,2.37,0,0,0,770.77,484.65Z"
            />
            <path
              class="cls-111"
              d="M769.47,488c.06.12,0,.18-.22.14l-.54-.06c0-.07,0-.12.16-.13A1.72,1.72,0,0,1,769.47,488Z"
            />
            <path
              class="cls-113"
              d="M770.88,481.6h-.08a.14.14,0,0,1,0-.13h1.6v0h0c-.18,0-.4,0-.54.11h-.11A1.19,1.19,0,0,0,770.88,481.6Z"
            />
            <path
              class="cls-116"
              d="M764.84,485.17H765c.1,0,.17,0,.17.09s-.07.08-.16.09l-.23,0C764.73,485.3,764.81,485.24,764.84,485.17Z"
            />
            <path
              class="cls-111"
              d="M768,488.18c-.06-.12-.19,0-.29,0s.09-.13.24-.11a2.8,2.8,0,0,0,.29,0l.12.15,0,0-.22,0Z"
            />
            <path
              class="cls-116"
              d="M764.78,486.44c.09,0,.29-.09.29.08-.1,0-.22,0-.22.06s.12.07.21.06.05.07,0,.09-.19,0-.2.11C764.7,486.71,764.8,486.57,764.78,486.44Z"
            />
            <path
              class="cls-116"
              d="M764.84,484.91a.27.27,0,0,1,.35.08c0,.16-.22.09-.36.1Z"
            />
            <path
              class="cls-116"
              d="M764.89,481.86l.13,0c.09,0,.2,0,.2.06s-.09.08-.18.08h-.15Z"
            />
            <path
              class="cls-116"
              d="M756.35,486v.87c0,.06,0,.1-.15.1l-.3,0c-.39,0-.39,0-.4-.23h.07c.1,0,.09.09.19.09.13-.18.05-.3-.2-.3,0-.11,0-.23-.06-.33a6.51,6.51,0,0,1-.06-.88c0-.08.06-.11.18-.11l.68,0C756.32,485.48,756.33,485.74,756.35,486Zm-.56.49a.61.61,0,0,0,.41,0A.59.59,0,0,0,755.79,486.5Z"
            />
            <path
              class="cls-116"
              d="M755.39,483v-.76H756c.11,0,.2,0,.2.1l.06,1.05c0,.05,0,.1-.12.11s-.47.06-.65-.09a.43.43,0,0,1,0-.33c.05,0,.12,0,.12,0S755.44,483,755.39,483Zm.57,0a.44.44,0,0,0-.32,0A.36.36,0,0,0,756,483Z"
            />
            <path
              class="cls-117"
              d="M755.44,483.44c.18.15.43.09.65.09s.12-.06.12-.11l-.06-1.05c0-.09-.09-.1-.2-.1h-.56v-.07H756c.06,0,.13,0,.13-.05s-.07-.05-.13-.05h-.61a.08.08,0,0,1,0,0H756c.07,0,.15,0,.16-.06s-.08-.07-.14-.07h-.62a2.83,2.83,0,0,1,.87,0c.07.31,0,.62,0,.93v.67s0,.11-.09.11a5.17,5.17,0,0,1-.68,0C755.36,483.59,755.43,483.5,755.44,483.44Z"
            />
            <path
              class="cls-116"
              d="M755.37,481.91H756c.06,0,.14,0,.14.07s-.09.06-.16.06h-.59Z"
            />
            <path
              class="cls-116"
              d="M755.39,482.09H756c.06,0,.13,0,.13.05s-.07.05-.13.05h-.61Z"
            />
            <path
              class="cls-111"
              d="M756.28,482.81c0-.31,0-.62,0-.93h.07A2.6,2.6,0,0,1,756.28,482.81Z"
            />
            <path
              class="cls-111"
              d="M756.35,486c0-.27,0-.53,0-.8a.12.12,0,0,1,.09.14C756.37,485.57,756.46,485.79,756.35,486Z"
            />
            <path
              class="cls-115"
              d="M755.51,486.23c.11.1,0,.22.06.33v.21h-.07Z"
            />
            <path
              class="cls-114"
              d="M755.39,483c.05,0,.14,0,.13,0s-.07,0-.12,0Z"
            />
            <path
              class="cls-111"
              d="M756.35,486.3v-.21A.13.13,0,0,1,756.35,486.3Z"
            />
            <path
              class="cls-111"
              d="M756.36,486.88v-.18A.11.11,0,0,1,756.36,486.88Z"
            />
            <path
              class="cls-111"
              d="M756.35,486.62v-.06S756.4,486.6,756.35,486.62Z"
            />
            <path
              class="cls-114"
              d="M758.58,482c0-.08-.07-.21.21-.2s.23,0,.23.13c0,.5.06,1,.06,1.51,0,.16,0,.25-.34.2h-.15v-.07a.12.12,0,0,0,0-.1v-1.1a.1.1,0,0,0-.06-.11Z"
            />
            <path
              class="cls-114"
              d="M758.6,485.35c0-.07,0-.15.17-.13s.29,0,.29.14c0,.51,0,1,0,1.52,0,.06,0,.15-.16.11s-.17-.21-.19-.34a9,9,0,0,1-.05-1.16A.14.14,0,0,0,758.6,485.35Z"
            />
            <path
              class="cls-109"
              d="M758.58,482v1.64c-.15,0-.17-.05-.17-.13,0-.53,0-1.07,0-1.6Z"
            />
            <path
              class="cls-116"
              d="M758.6,485.35a.14.14,0,0,1,.06.14,9,9,0,0,0,.05,1.16c0,.13,0,.25.19.34-.16,0-.31,0-.31-.14C758.59,486.35,758.55,485.85,758.6,485.35Z"
            />
            <path class="cls-117" d="M761.57,484.3a.78.78,0,0,1,0,.58Z" />
            <path
              class="cls-110"
              d="M746.71,483.7c-.39,0-.77,0-1.16,0l0,0-.08.93,1.38,0A2.43,2.43,0,0,0,746.71,483.7Z"
            />
            <path
              class="cls-110"
              d="M746.31,481.58h-.63l.06-.83.73,0a2.6,2.6,0,0,1,.08.73C746.56,481.63,746.4,481.58,746.31,481.58Z"
            />
            <path
              class="cls-117"
              d="M746.26,481.7c.1,0,.15,0,.16.1s0,.11-.17.11h-.53a.13.13,0,0,0,0,.08c.19,0,.39,0,.58,0s.13,0,.14.07,0,.09-.13.09h-.57a.24.24,0,0,1-.06.09h.61c.14,0,.16,0,.18.12a2.24,2.24,0,0,1,0,.73v-.36c-.23.13-.28.32-.48.46v.17h0v.07c.07.06.11.15,0,.19l-.1,0h-.29a.23.23,0,0,1-.07.07c.39,0,.77,0,1.16,0,0-.65-.16-1.29-.12-1.94,0-.12-.13-.14-.3-.14h-.62v.08h.59Z"
            />
            <path
              class="cls-117"
              d="M747,486a5,5,0,0,0-.78.08l.07.16s.07.08,0,.09-.36.09-.49-.06,0-.11,0-.16l-.13,0c0,.29.05.58.06.86,0,0,.09.14-.11.13l-.25,0-.05.05h.21c.51,0,1-.05,1.51-.08Zm-.79,1.08c-.13,0-.27,0-.31-.09a.64.64,0,0,1,0-.2h0a.66.66,0,0,1,0-.14c0-.08.09-.11.22-.11s.19,0,.19.12a.57.57,0,0,0,0,.26C746.32,487,746.33,487.09,746.17,487.11Z"
            />
            <path
              class="cls-117"
              d="M746.81,484.66l-1.38,0h0s0,.06,0,.1h0a.05.05,0,0,1,.06.06.1.1,0,0,1-.06.1V485h0a.15.15,0,0,1,.1,0l.91-.06c.11,0,.29,0,.31,0s-.18.08-.28.09h-1.05v.12a.21.21,0,0,1,.16.21c0,.2,0,.39,0,.58h.18c0-.23,0-.45-.06-.67s.07-.18.24-.18h.68c.12,0,.15.05.15.11a2.39,2.39,0,0,0,.06.65h.06A9.32,9.32,0,0,0,746.81,484.66Zm-.27.27-.6,0h-.22c-.1,0-.09,0-.11-.09s0-.08.11-.08c.28,0,.54-.06.82,0,.1,0,.17,0,.17.09S746.63,484.92,746.54,484.93Z"
            />
            <path
              class="cls-114"
              d="M748.19,482.28a.51.51,0,0,1,.4,0c0,.38.06.75.08,1.13l-.37,0c0-.21,0-.42,0-.63A.88.88,0,0,0,748.19,482.28Z"
            />
            <path
              class="cls-114"
              d="M748,483.33a.87.87,0,0,1-.36,0,7.48,7.48,0,0,0-.11-1.05.5.5,0,0,1,.4,0c.06.1-.05.18,0,.27A2.34,2.34,0,0,1,748,483.33Z"
            />
            <path
              class="cls-114"
              d="M747.06,481.81a.24.24,0,0,1,.15,0c.43,0,.85,0,1.27,0,.14,0,.24,0,.25.12s-.1.12-.23.13h-1.31Z"
            />
            <path
              class="cls-117"
              d="M748,483.33a2.34,2.34,0,0,0-.09-.79c0-.09.08-.17,0-.27.08.05.16.09.25,0a.88.88,0,0,1,.06.45c0,.21,0,.42,0,.63C748.22,483.29,748.1,483.35,748,483.33Z"
            />
            <path
              class="cls-110"
              d="M748,486v-.07l.2-.07a.5.5,0,0,0,.28,0c.22.07.24-.15.43-.11,0,.11.12.11.25.1s.23,0,.24.1-.12.08-.22.08a.62.62,0,0,0-.31.07h-.05l-.1,0-.22,0a.55.55,0,0,0-.26,0Z"
            />
            <path
              class="cls-114"
              d="M747.36,484.9a10.59,10.59,0,0,1,1.5.17c.1,0,.13.06.1.11s-.1,0-.16,0a4.28,4.28,0,0,1-1.09-.16,1.07,1.07,0,0,0-.31,0Z"
            />
            <path
              class="cls-114"
              d="M748.78,486h.05c-.07.2.07.4,0,.59-.14,0-.29,0-.35-.11a1.9,1.9,0,0,1,0-.53l.22,0Z"
            />
            <path
              class="cls-110"
              d="M747.06,481.81l.13.17v.29c0,.36.1.7.06,1.06-.09,0-.11,0-.12-.09,0-.45-.08-.91-.11-1.36C747,481.86,747.05,481.84,747.06,481.81Z"
            />
            <path
              class="cls-114"
              d="M748.16,485.84l-.2.07h-.12c-.09-.19,0-.39-.11-.57a.54.54,0,0,1,.42.08Z"
            />
            <path
              class="cls-114"
              d="M748,486l.23,0v.5a1.47,1.47,0,0,0-.33-.07l0-.46Z"
            />
            <path
              class="cls-117"
              d="M747.25,483.33c0-.36-.1-.7-.06-1.06h.11c.1.35,0,.7.12,1.05A.15.15,0,0,1,747.25,483.33Z"
            />
            <path
              class="cls-117"
              d="M748.2,486.52V486a.55.55,0,0,1,.26,0,1.9,1.9,0,0,0,0,.53C748.4,486.52,748.3,486.58,748.2,486.52Z"
            />
            <path
              class="cls-114"
              d="M747.42,483.33c-.09-.35,0-.7-.12-1.05a.11.11,0,0,1,.14,0c0,.35.07.7.1,1.05Z"
            />
            <path
              class="cls-114"
              d="M748.87,485.69c-.19,0-.21.18-.43.11,0-.12,0-.25-.06-.36a1.16,1.16,0,0,1,.61.2C749,485.7,748.92,485.68,748.87,485.69Z"
            />
            <path
              class="cls-117"
              d="M747.54,483.33c0-.35-.06-.7-.1-1.05h.1a7.48,7.48,0,0,1,.11,1.05Z"
            />
            <path
              class="cls-117"
              d="M748.38,485.44c.1.11,0,.24.06.36a.5.5,0,0,1-.28,0v-.43Z"
            />
            <path
              class="cls-117"
              d="M748.67,483.4c0-.38,0-.75-.08-1.13a.19.19,0,0,1,.14.17,4,4,0,0,0,0,.85S748.86,483.42,748.67,483.4Z"
            />
            <path
              class="cls-110"
              d="M747.36,484.9l0,.14,0,.29c-.05.19.06.39-.06.57,0-.27,0-.54-.07-.81C747.31,485,747.29,485,747.36,484.9Z"
            />
            <path
              class="cls-117"
              d="M747.38,485.9c.12-.18,0-.38.06-.57h.06c.07.07,0,.14,0,.21s0,.24.08.35c0,.07-.15.06-.25.06Z"
            />
            <path
              class="cls-114"
              d="M747.63,485.88c-.12-.11-.06-.23-.08-.35s0-.14,0-.21.12,0,.17,0l0,.55Z"
            />
            <path
              class="cls-117"
              d="M748.85,486.63c0-.19-.09-.39,0-.59h0l.1,0,0,.54Z"
            />
            <path
              class="cls-117"
              d="M747.7,485.88l0-.55h.06c.12.18,0,.38.11.57C747.79,485.91,747.71,486,747.7,485.88Z"
            />
            <path
              class="cls-114"
              d="M749,486.63l0-.54H749a1.32,1.32,0,0,1,0,.56h0Z"
            />
            <path
              class="cls-121"
              d="M747.37,486c.13,0,.14.05.13.11s.06.2,0,.3c-.12-.13-.07-.28-.1-.41Z"
            />
            <path
              class="cls-117"
              d="M747.84,486l0,.46c-.1,0-.14,0-.11-.09s0-.14-.06-.21S747.58,486,747.84,486Z"
            />
            <path
              class="cls-114"
              d="M748.53,482.11c0,.06-.1.05-.16.05s-.16,0-.14-.06.08,0,.14,0S748.51,482.06,748.53,482.11Z"
            />
            <path
              class="cls-114"
              d="M747.88,482.12c0,.05-.11.05-.17,0s-.15,0-.12-.07.11,0,.18,0S747.88,482.07,747.88,482.12Z"
            />
            <path
              class="cls-116"
              d="M745.77,486.05c0-.23,0-.45-.06-.67s.07-.18.24-.18h.68c.12,0,.15.05.15.11a2.39,2.39,0,0,0,.06.65C746.48,486,746.13,486.05,745.77,486.05Z"
            />
            <path
              class="cls-116"
              d="M745.57,485.48a.21.21,0,0,0-.16-.21c0,.22-.06.44-.08.66a1.23,1.23,0,0,0,0,.2h.05l.07,0,.16,0C745.58,485.87,745.57,485.68,745.57,485.48Z"
            />
            <path
              class="cls-116"
              d="M745.71,487c0-.28,0-.57-.06-.86l-.18,0c.09.06.08.11-.07.12h-.11v0c0,.09,0,.19,0,.29l.1,0c.15,0,.2,0,.2.12v.43C745.8,487.16,745.71,487.06,745.71,487Z"
            />
            <path class="cls-121" d="M745.77,486.3v-.16l.4,0,.07.16Z" />
            <path class="cls-114" d="M745.36,486.12l.07,0Z" />
            <path
              class="cls-116"
              d="M778.11,485.71a5.68,5.68,0,0,0-.05.92c0,.07-.07.09-.16.1l-.53,0c-.09,0-.12,0-.11-.08a4.72,4.72,0,0,0,.11-.92.14.14,0,0,1,.16-.15,2,2,0,0,1,.55,0C778.15,485.63,778.13,485.67,778.11,485.71Z"
            />
            <path
              class="cls-114"
              d="M776.59,486.61c-.19,0-.08.13-.16.23,0-.1,0-.21-.2-.2s-.07,0-.06-.08c0-.25,0-.5.07-.75s.28-.13.46-.14C776.74,486,776.58,486.29,776.59,486.61Z"
            />
            <path
              class="cls-116"
              d="M778.67,485.77a5.05,5.05,0,0,0-.11.78c0,.14-.16.14-.3.14s-.08-.1-.07-.14c0-.27,0-.53.06-.8,0-.06,0-.13.1-.17a.46.46,0,0,1,.23,0C778.73,485.61,778.65,485.69,778.67,485.77Z"
            />
            <path
              class="cls-116"
              d="M776.59,486.61c0-.32.15-.63.11-.94.15,0,.27,0,.25.12a5.22,5.22,0,0,0-.07.88.09.09,0,0,1-.1.1c-.08,0-.06,0-.09-.08Z"
            />
            <path
              class="cls-116"
              d="M777,486.75c0-.36.07-.67.11-1a.11.11,0,0,1,.15-.12c.13,0,0,.08,0,.13a4.77,4.77,0,0,0-.07.76.29.29,0,0,1,0,.18s0,.1-.13.09S777,486.74,777,486.75Z"
            />
            <path
              class="cls-116"
              d="M777.72,485.38c-.12,0-.28,0-.28-.08s.15-.06.24-.08l.35,0c.06,0,.16,0,.17,0s0,.1-.13.11Z"
            />
            <path
              class="cls-116"
              d="M776.29,485.3a.26.26,0,0,0,.18,0h.41c.12,0,.16.07.06.1a1.14,1.14,0,0,1-.61,0C776.26,485.4,776.29,485.34,776.29,485.3Z"
            />
            <path
              class="cls-116"
              d="M776.62,485.47c.12,0,.32,0,.33.06s-.2.06-.31.06-.36.07-.37,0S776.5,485.51,776.62,485.47Z"
            />
            <path
              class="cls-116"
              d="M777.69,485.56c-.09,0-.23,0-.24-.05s.14-.06.22-.07l.35,0c.06,0,.13,0,.15,0s-.06.06-.11.07Z"
            />
            <path
              class="cls-116"
              d="M778.73,485.45c-.17.05-.27.09-.38,0s0-.05,0-.06A.56.56,0,0,1,778.73,485.45Z"
            />
            <path class="cls-114" d="M776.15,486.83l0,0s0,0,.06,0,0,0,0,.05Z" />
            <path
              class="cls-116"
              d="M776.94,489.4a1.73,1.73,0,0,0,.07-.64c0-.09.09-.11.22-.12l.56-.05c0,.11,0,.21,0,.32a.83.83,0,0,1,0,.38c0,.07.06.18-.09.21a2.43,2.43,0,0,1-.61.06C776.88,489.56,777,489.45,776.94,489.4Z"
            />
            <path
              class="cls-116"
              d="M778.14,488.54a.39.39,0,0,1,0,.28c0,.06,0,.12.11.15v.25c-.21,0-.16.13-.17.22-.18,0-.25,0-.24-.14l.06-.64C777.91,488.57,778,488.54,778.14,488.54Z"
            />
            <path
              class="cls-114"
              d="M776,489.63c0-.22,0-.45.08-.67a.5.5,0,0,0,0-.17.48.48,0,0,1,.29,0,1.87,1.87,0,0,0,0,.58v.07c-.12.06,0,.24-.31.22Z"
            />
            <path
              class="cls-116"
              d="M777.72,488.36c.15.11.26,0,.41,0s.19,0,.22,0-.08.09-.17.1c-.3,0-.6.05-.9.09-.07,0-.16,0-.19,0s.06-.1.14-.11Z"
            />
            <path
              class="cls-116"
              d="M776.77,489.59a2,2,0,0,1,0-.8c0-.06,0-.1.13-.1s.11,0,.09.07C776.84,489,777,489.33,776.77,489.59Z"
            />
            <path
              class="cls-116"
              d="M776.14,488.68c-.06,0-.14,0-.17,0s0-.09.09-.1a2.87,2.87,0,0,1,.78-.07c.06,0,.11,0,.1.07a.06.06,0,0,1-.06,0Z"
            />
            <path
              class="cls-116"
              d="M776.31,489.34a1.87,1.87,0,0,1,0-.58l.19,0a1.81,1.81,0,0,1-.06.61Z"
            />
            <path
              class="cls-115"
              d="M776.48,489.33a1.81,1.81,0,0,0,.06-.61c.06,0,.12,0,.11.07-.11.27,0,.55-.12.82l0,0v-.32Z"
            />
            <path
              class="cls-116"
              d="M776.48,489.59v.06c-.16,0-.34.13-.48,0,.28,0,.19-.16.31-.22S776.37,489.55,776.48,489.59Z"
            />
            <path
              class="cls-115"
              d="M778.08,489.44c0-.09,0-.19.17-.22C778.24,489.31,778.31,489.42,778.08,489.44Z"
            />
            <path
              class="cls-116"
              d="M777.65,483.33c0-.13,0-.31.06-.5s.06-.1.18-.11c.6-.06.73,0,.63.39a3.58,3.58,0,0,0-.09.45c0,.1-.06.15-.22.14h0C777.64,483.72,777.64,483.72,777.65,483.33Z"
            />
            <path
              class="cls-116"
              d="M777,482.72c0,.09.08.24-.13.23s-.07-.15-.1-.22c-.21,0-.22.09-.23.16,0,.22,0,.45-.06.67,0,.07-.05.16.13.17s.35.06.4-.1c-.12-.16-.06-.32,0-.48.07.1,0,.2.08.3s.06.11.07.17,0,.07.09.07.08,0,.08-.07a2.5,2.5,0,0,1,.06-.67C777.37,482.71,777.36,482.71,777,482.72Zm-.39.47s.06-.05.12-.06.09,0,.09.06,0,.07-.11.07S776.59,483.24,776.6,483.19Zm.17.36c-.07,0-.11,0-.09-.06s0-.09.1-.1.08,0,.09.06S776.86,483.54,776.77,483.55Z"
            />
            <path
              class="cls-116"
              d="M779.08,482.92a2.36,2.36,0,0,0-.08.56c0,.12-.07.24-.33.21s-.12-.16-.11-.24a2.82,2.82,0,0,0,.09-.57c0-.12.06-.16.26-.16S779.07,482.81,779.08,482.92Z"
            />
            <path
              class="cls-116"
              d="M779.07,482.46l.06.07c-.07.14-.25.13-.41.11a4.17,4.17,0,0,0-.79,0c-.08,0-.19.05-.2,0s.07-.11.19-.11Z"
            />
            <path
              class="cls-116"
              d="M777.18,482.22c.13,0,.25,0,.38,0s.14,0,.14.07a.1.1,0,0,1,0,.08.15.15,0,0,1-.17,0s0-.08-.08,0-.42.06-.64.06-.13,0-.12-.1.07-.06.15-.07h.38Z"
            />
            <path
              class="cls-116"
              d="M777.43,483.69a3,3,0,0,1,0-.84s0-.13.14-.11,0,.08,0,.12a5.53,5.53,0,0,1-.07.7S777.56,483.64,777.43,483.69Z"
            />
            <path
              class="cls-116"
              d="M778.18,482.4c-.13,0-.4.06-.39-.1s.26-.08.4-.08.39-.07.39.08S778.32,482.36,778.18,482.4Z"
            />
            <path
              class="cls-116"
              d="M777,482.65h-.23c-.09,0-.2,0-.2-.08s.1-.09.19-.1h.41c.1,0,.21,0,.21.08s-.09.1-.2.1Z"
            />
            <path
              class="cls-116"
              d="M779.07,482.21c0,.06.11.12,0,.18a1.26,1.26,0,0,1-.28,0c-.14-.06-.13-.12,0-.16a.09.09,0,0,0,.11,0Z"
            />
            <path
              class="cls-114"
              d="M777,482.72c0,.09.07.24-.14.23s-.07-.15-.1-.22Z"
            />
            <path
              class="cls-114"
              d="M777,483.63c-.12-.16-.06-.32,0-.48.07.1,0,.2.08.3A.18.18,0,0,1,777,483.63Z"
            />
            <path
              class="cls-116"
              d="M777.65,482.56a.08.08,0,0,1-.09.07c-.07,0-.09,0-.09-.07s0-.08.09-.08S777.64,482.52,777.65,482.56Z"
            />
            <path class="cls-115" d="M779,482.21a.09.09,0,0,1-.11,0Z" />
            <path
              class="cls-117"
              d="M775.53,489.66a.17.17,0,0,1,0-.25C775.6,489.51,775.6,489.59,775.53,489.66Z"
            />
            <path
              class="cls-116"
              d="M772.34,487c0-.46.06-1,.09-1.47,0-.11.07-.18.28-.18s.45,0,.68,0,.22,0,.21.14c-.06.5-.12,1-.15,1.52,0,.18-.13.23-.38.23s-.28,0-.41,0S772.27,487.22,772.34,487Z"
            />
            <path
              class="cls-114"
              d="M772,487.27a.83.83,0,0,1-.36-.07c0-.16.08-.3,0-.45s.16-.39-.1-.56c.14-.1.24-.21,0-.32,0,0,.05-.05.09-.06s.09-.09.05-.11-.06-.2-.16-.29h0v0c.16-.08.35,0,.53,0l.06,0c-.12.63-.1,1.26-.17,1.89Z"
            />
            <path
              class="cls-116"
              d="M772,487.27c.07-.63,0-1.26.17-1.89.12,0,.19,0,.18.07,0,.38,0,.76-.09,1.15a4.43,4.43,0,0,0,0,.52C772.2,487.22,772.14,487.28,772,487.27Z"
            />
            <path
              class="cls-116"
              d="M772.8,485.24c-.12,0-.3.08-.31-.08s.15-.14.31-.15l.61,0c.13,0,.21,0,.2.11s-.06.1-.18.11Z"
            />
            <path
              class="cls-116"
              d="M772.86,484.9h-.18c-.1,0-.18,0-.19-.08s0-.11.15-.12l.82-.05c.11,0,.16,0,.16.11s0,.1-.15.11l-.61,0Z"
            />
            <path
              class="cls-114"
              d="M772.08,485.27l-.35,0c-.17,0-.13-.1-.12-.17s.12-.05.2-.05h.32v.24Z"
            />
            <path
              class="cls-116"
              d="M772.13,485.26V485c.11,0,.23,0,.22.09S772.29,485.26,772.13,485.26Z"
            />
            <path
              class="cls-116"
              d="M772.15,484.72c.1,0,.22,0,.22.09s-.12.11-.23.14h0v-.22Z"
            />
            <path
              class="cls-116"
              d="M772,484.69h.16l0,0h0A.32.32,0,0,1,772,484.69Z"
            />
            <path
              class="cls-116"
              d="M772.19,483.93v-.05c.06-.62.11-1.25.17-1.87h0c.22,0,.19.1.17.18-.09.4,0,.81-.1,1.21a4.6,4.6,0,0,0-.06.52Z"
            />
            <path
              class="cls-120"
              d="M767.51,490.07l-.49,0a3.74,3.74,0,0,1-.82-.08c0-.2,0-.39,0-.59a1.21,1.21,0,0,0,0-.19c0-.08.08-.18-.11-.23l-.06-.08c.41-.08.84-.09,1.26-.14.2,0,.3,0,.29.14s-.07.23,0,.33v0A1.47,1.47,0,0,0,767.51,490.07Z"
            />
            <path
              class="cls-116"
              d="M767.63,489.3v0c.11-.08.06-.18.06-.26s.1-.26.39-.28.2,0,.18.13a5.62,5.62,0,0,0-.09.57c0,.08,0,.19-.14.22a.36.36,0,0,1-.34-.13C767.67,489.45,767.72,489.37,767.63,489.3Z"
            />
            <path
              class="cls-119"
              d="M768.5,490.3c0-.16-.16-.08-.27-.08s-.2,0-.18.12,0,.17.11.18.3,0,.37-.09a.61.61,0,0,0,.07-.1Zm-.3.15c-.05-.07-.06-.12,0-.15a.09.09,0,0,1,.1,0C768.37,490.4,768.24,490.4,768.2,490.45Z"
            />
            <path
              class="cls-119"
              d="M769.36,490.28l-.07.15a.85.85,0,0,1-.36,0v-.14l0-.15.09,0,.13,0c0,.08,0,.15.17.15Z"
            />
            <path
              class="cls-109"
              d="M768.94,490.33v.14a.88.88,0,0,1-.29,0l-.11-.08.07-.1c.14,0,.1-.07.1-.12s.1,0,.17,0S768.86,490.29,768.94,490.33Z"
            />
            <path
              class="cls-110"
              d="M768.64,490.51a.88.88,0,0,0,.29,0,.85.85,0,0,0,.36,0h.18l0,.07-.86.09Z"
            />
            <path
              class="cls-113"
              d="M769.35,490.25c-.18,0-.17-.07-.17-.15C769.46,490.05,769.32,490.18,769.35,490.25Z"
            />
            <path
              class="cls-111"
              d="M768.94,490.33c-.08,0-.06-.1-.07-.15a0,0,0,0,0,0,0l.08,0Z"
            />
            <path class="cls-120" d="M769,490.18l-.08,0a.12.12,0,0,1,.17,0Z" />
            <path
              class="cls-116"
              d="M774,481.67a.67.67,0,0,1-.38.07h-.74c-.11,0-.19,0-.19-.1s.05-.11.18-.11h.89c.17,0,.21.06.24.15Z"
            />
            <path
              class="cls-116"
              d="M773.28,482h-.41c-.1,0-.21,0-.2-.09s.09-.08.18-.09c.32,0,.63,0,.94,0,.07,0,.11,0,.11.06s0,.08-.12.08Z"
            />
            <path
              class="cls-116"
              d="M772.36,481.49h.06c.06,0,.2.05.17.14a.22.22,0,0,1-.22.12h0v-.25Z"
            />
            <path
              class="cls-116"
              d="M772.37,481.78c.09,0,.17,0,.17.09s-.08.09-.18.09h0v-.17Z"
            />
            <path
              class="cls-115"
              d="M746.07,489.91c.13.07,0,.2.13.28-.1.07-.15,0-.18,0S746,490,746.07,489.91Z"
            />
            <path
              class="cls-116"
              d="M764.38,490.51v-.4c.12,0,.16,0,.18-.11a3.56,3.56,0,0,0,.05-.92c.15-.06.11.1.23.08v.08a.32.32,0,0,0,0,.47v.14c-.05,0,0,.1,0,.14s0,.35-.18.49A.4.4,0,0,1,764.38,490.51Z"
            />
            <path
              class="cls-117"
              d="M764.74,491.44l-.12-.26s0-.07,0-.07c-.32,0-.15-.21-.21-.32h.26a.48.48,0,0,0,.18,0c-.16.13,0,.28,0,.41S764.85,491.38,764.74,491.44Z"
            />
            <path
              class="cls-110"
              d="M764.64,490.8h-.26v-.28a.4.4,0,0,0,.22,0h.21v.07C764.56,490.59,764.71,490.72,764.64,490.8Z"
            />
            <path
              class="cls-113"
              d="M764.82,489.71a.32.32,0,0,1,0-.47C764.83,489.4,764.94,489.55,764.82,489.71Z"
            />
            <path
              class="cls-113"
              d="M764.81,490.49h-.21c.2-.14.1-.33.18-.49s0-.09,0-.14A1.53,1.53,0,0,1,764.81,490.49Z"
            />
            <path
              class="cls-113"
              d="M764.64,490.8c.07-.08-.08-.21.18-.24a.36.36,0,0,1,0,.27A.48.48,0,0,1,764.64,490.8Z"
            />
            <path class="cls-113" d="M764.67,491.54h0Z" />
            <path class="cls-109" d="M768.38,488.21l0,0h.17v.07Z" />
            <path
              class="cls-111"
              d="M768.58,488.22v0s.07,0,.09,0S768.62,488.21,768.58,488.22Z"
            />
            <path class="cls-109" d="M769.73,488h0l0,0h0Z" />
            <path class="cls-109" d="M769.67,488.11l0,0h0l0,0Z" />
            <path
              class="cls-116"
              d="M766.17,490.24a3.45,3.45,0,0,1,.82.29l-.49.06c-.32,0-.35,0-.35-.18A1,1,0,0,1,766.17,490.24Z"
            />
            <path
              class="cls-120"
              d="M766,489.27h.11v.17c0,.15,0,.3-.06.45A1.62,1.62,0,0,1,766,489.27Z"
            />
            <path
              class="cls-113"
              d="M766.09,489.44V489c.19.05.09.15.11.23a1.21,1.21,0,0,1,0,.19Z"
            />
            <path
              class="cls-109"
              d="M766.09,490.87c0-.06.06-.07.15-.05s.29,0,.26.15l-.38-.07Z"
            />
            <path
              class="cls-109"
              d="M767,488.4c-.08,0-.12,0-.13-.08S767,488.35,767,488.4Z"
            />
            <path class="cls-109" d="M768,488.18h.12a.24.24,0,0,1-.17,0Z" />
            <path class="cls-109" d="M766.68,488.43h-.1a.1.1,0,0,1,.1,0Z" />
            <path class="cls-109" d="M766.1,488.39h0Z" />
            <path
              class="cls-113"
              d="M757.41,490a1.06,1.06,0,0,0-.66.05l-.08,0c-.15,0-.36.07-.41,0s.19-.11.32-.13l.84-.09Z"
            />
            <path
              class="cls-114"
              d="M764.6,489.08a3.56,3.56,0,0,1-.05.92c0,.07-.06.11-.18.11a3.8,3.8,0,0,0,0-.89C764.42,489.14,764.46,489.09,764.6,489.08Z"
            />
            <path
              class="cls-116"
              d="M762.71,489.24c-.08,0-.2,0-.22,0s.13-.08.21-.09a.67.67,0,0,1,.37,0s0,0,0,.07S762.84,489.23,762.71,489.24Z"
            />
            <path class="cls-114" d="M763.11,489.63l0,0Z" />
            <path
              class="cls-115"
              d="M746,489.25c.11.1.08.19,0,.29A.22.22,0,0,1,746,489.25Z"
            />
            <path
              class="cls-113"
              d="M748.77,488a8.68,8.68,0,0,1-1.26.1A5.85,5.85,0,0,1,748.77,488Z"
            />
            <path
              class="cls-113"
              d="M747.38,487.76h-.56v0l.8-.06c-.08.06-.2,0-.24.08Z"
            />
            <path
              class="cls-113"
              d="M746.88,487.68l-.4,0A.68.68,0,0,1,746.88,487.68Z"
            />
            <path class="cls-113" d="M747.08,487.63h.22v0l-.23,0Z" />
            <path class="cls-113" d="M746.2,487.72h0s0,0,0,0Z" />
            <path class="cls-113" d="M746.43,487.77h0Z" />
            <path
              class="cls-116"
              d="M767,486.36a6.4,6.4,0,0,0,.06-.88c0-.13.12-.15.27-.16.3,0,.6,0,.89,0s.22,0,.19.12c-.11.36,0,.71-.09,1.07,0,.13-.11.18-.31.18s-.52,0-.76.05-.26,0-.25-.14A1.33,1.33,0,0,0,767,486.36Z"
            />
            <path
              class="cls-116"
              d="M765.25,486.33c0-.26,0-.52,0-.78,0-.09.06-.12.21-.14a2.38,2.38,0,0,1,.84,0c.26.09,0,.31.08.47a1.28,1.28,0,0,1,0,.39c0,.05,0,.1-.08.14-.3.09-.14.15.08.21a5.17,5.17,0,0,1-1.09.11c-.08,0-.09-.06-.09-.1a4.72,4.72,0,0,0,.65,0c.08,0,.19,0,.16-.09s-.12-.06-.19-.05a4.29,4.29,0,0,1-.62,0l0-.08.73,0A2.55,2.55,0,0,0,765.25,486.33Z"
            />
            <path
              class="cls-116"
              d="M768.4,486.31a4.59,4.59,0,0,0,.05-.91c0-.17.22-.15.4-.16s.2.08.2.17c0,.32,0,.65-.07,1a.2.2,0,0,1-.12.2.66.66,0,0,1-.37,0c-.13,0-.09-.1-.09-.16A.65.65,0,0,1,768.4,486.31Z"
            />
            <path
              class="cls-116"
              d="M766.5,486.4c0-.07.12-.07.24-.1-.18-.05-.23-.1-.21-.21a2.26,2.26,0,0,0,0-.58c0-.08,0-.16.19-.16s.17.08.17.15a5.09,5.09,0,0,1-.09,1.22c-.09-.09-.27-.08-.32-.17s.22,0,.22-.08S766.58,486.41,766.5,486.4Z"
            />
            <path
              class="cls-116"
              d="M767.46,485.24h-.26c-.09,0-.17,0-.17-.06s0-.13.13-.12a6.32,6.32,0,0,1,1.23,0c.08,0,.06,0,.09,0a.93.93,0,0,1,.47,0c.07,0,.09,0,.09.08s-.08.09-.17.1l-1.41.08Z"
            />
            <path
              class="cls-116"
              d="M765.3,485s0,0,0,0a2.83,2.83,0,0,1,1.16,0c0,.13-.18.13-.32.14l-.74,0C765.27,485.08,765.32,485,765.3,485Z"
            />
            <path
              class="cls-116"
              d="M765.46,485.31c-.08,0-.14,0-.15,0s0-.12.12-.13l.94,0c.07,0,.11,0,.11.07s0,.09-.11.11a1.84,1.84,0,0,1-.41,0Z"
            />
            <path
              class="cls-121"
              d="M765.25,486.48a4.29,4.29,0,0,0,.62,0c.07,0,.17,0,.19.05s-.08.07-.16.09a4.72,4.72,0,0,1-.65,0Z"
            />
            <path
              class="cls-116"
              d="M766.9,485.18c0,.07-.06.09-.16.09s-.18,0-.18-.08.06-.1.17-.1S766.9,485.11,766.9,485.18Z"
            />
            <path
              class="cls-121"
              d="M765.25,486.33a2.55,2.55,0,0,1,.78,0l-.73,0Z"
            />
            <path
              class="cls-116"
              d="M766.55,484.91c.13-.12.27-.05.4,0s-.1.11-.23.11S766.56,485,766.55,484.91Z"
            />
            <path
              class="cls-121"
              d="M765.06,486.64c-.09,0-.21,0-.21-.06s.12-.07.22-.06Z"
            />
            <path
              class="cls-121"
              d="M766.5,486.4c.08,0,.22,0,.22.07s-.14.07-.22.08Z"
            />
            <path
              class="cls-115"
              d="M768.5,484.91h.13S768.54,485,768.5,484.91Z"
            />
            <path
              class="cls-116"
              d="M767.38,483.13c-.29-.11-.25-.28-.24-.44s0-.32,0-.47.08-.15.25-.15h1c.12,0,.15,0,.14.08a6.18,6.18,0,0,0-.07,1.05c0,.14-.11.22-.37.2s-.23,0-.35,0-.33,0-.34-.14c.17-.06.39,0,.55-.09-.12-.05-.24,0-.35,0,0,0,.16,0,.21,0A1.17,1.17,0,0,0,767.38,483.13Z"
            />
            <path
              class="cls-116"
              d="M765.72,483.17c0-.05-.05-.11-.14-.1-.33,0-.3-.13-.27-.24a2.4,2.4,0,0,0,0-.65c0-.09,0-.14.21-.14h.83c.15,0,.22,0,.21.13,0,.38,0,.77-.05,1.15,0,0,0,.09-.08.09-.24,0-.49.08-.7-.06.13-.11.32-.07.49-.08s.17,0,.18,0-.12-.09-.17-.08S765.89,483.11,765.72,483.17Z"
            />
            <path
              class="cls-116"
              d="M769.21,482.38a3.58,3.58,0,0,0-.05.82c0,.15-.32.25-.54.19s-.06-.06,0-.1a8,8,0,0,0,.06-1.1c0-.13.15-.12.29-.12s.29,0,.29.11Z"
            />
            <path
              class="cls-116"
              d="M766.66,482.8a3.11,3.11,0,0,1,.06-.64c0-.07,0-.11.17-.12s.14,0,.16.11c.08.31-.08.61,0,.92,0,.09-.22-.05-.17.07a1,1,0,0,1,0,.16c0,.05,0,.1-.1.11s-.13,0-.13-.09S766.67,483,766.66,482.8Z"
            />
            <path
              class="cls-116"
              d="M767.19,481.61a5.22,5.22,0,0,1,1.25,0c.26,0,.55-.07.78.07,0,.07,0,.13-.17.13s-.35,0-.41-.14c-.13.2-.38.15-.58.14s-.43,0-.65,0S767.18,481.7,767.19,481.61Z"
            />
            <path
              class="cls-116"
              d="M765.35,481.61a2.82,2.82,0,0,1,1.26,0c0,.09-.09.11-.21.11h-.83C765.39,481.76,765.35,481.7,765.35,481.61Z"
            />
            <path
              class="cls-116"
              d="M767.88,482h-.53c-.08,0-.14,0-.14-.07s.07-.07.14-.07h1.06c.08,0,.14,0,.14.08s-.07.06-.14.07Z"
            />
            <path
              class="cls-116"
              d="M766,482h-.44c-.09,0-.17,0-.16-.08s.08-.07.15-.07h.91c.09,0,.17,0,.16.07s-.08.07-.15.07Z"
            />
            <path
              class="cls-114"
              d="M767.38,483.13a1.17,1.17,0,0,1,.46,0c-.05.06-.16,0-.21,0,.11,0,.23,0,.35,0-.16.08-.38,0-.55.09s-.15.07-.22.13C767,483.25,767.39,483.23,767.38,483.13Z"
            />
            <path
              class="cls-114"
              d="M765.72,483.17c.17-.06.37,0,.55,0s.18,0,.17.08-.11,0-.18,0-.36,0-.49.08C765.68,483.3,765.73,483.23,765.72,483.17Z"
            />
            <path
              class="cls-116"
              d="M769.22,481.9c-.13.13-.33.05-.5.06s-.07,0-.06,0a.15.15,0,0,1,.12-.05h.43Z"
            />
            <path
              class="cls-116"
              d="M766.72,481.63c.11-.11.24-.05.37,0s0,.13-.18.13S766.72,481.71,766.72,481.63Z"
            />
            <path
              class="cls-116"
              d="M767.07,481.9c0,.06-.09.07-.17.07s-.16,0-.16-.07.08-.07.16-.07S767.06,481.83,767.07,481.9Z"
            />
            <path class="cls-116" d="M765.36,483.2l0,0,0,0s0,0,0,0Z" />
            <path class="cls-115" d="M769.22,481.9v0l0,0Z" />
            <path
              class="cls-117"
              d="M771.3,486.25v.8c0,.13-.08.16-.27.13-.5-.06-.53-.06-.48-.37s0-.92.1-1.38a.47.47,0,0,1,.06-.09V486c0,.05-.07.11,0,.16s0,.14.15.14A1.39,1.39,0,0,0,771.3,486.25Z"
            />
            <path
              class="cls-117"
              d="M771.54,485.41c.1.09,0,.21.16.29s0,.08-.05.11-.11,0-.09.06c.23.11.13.22,0,.32.26.17.07.37.1.56s-.08.29,0,.45c-.18.05-.24,0-.23-.1a8.76,8.76,0,0,1,.08-1A2.21,2.21,0,0,1,771.54,485.41Z"
            />
            <path
              class="cls-114"
              d="M770.72,485.7v-.36c.16-.16.36,0,.55,0s.11.08.1.14.08.14,0,.21A3.43,3.43,0,0,0,770.72,485.7Z"
            />
            <path
              class="cls-114"
              d="M770.75,484.94a4.24,4.24,0,0,1,.51,0c.14,0,.17.07.16.15s-.13.08-.23.08C770.94,485.19,770.71,485.16,770.75,484.94Z"
            />
            <path
              class="cls-114"
              d="M770.77,484.65a2.37,2.37,0,0,1,.65,0c0,.07.14.17-.12.18C770.84,484.9,770.78,484.88,770.77,484.65Z"
            />
            <path
              class="cls-116"
              d="M770.69,486.15s0-.11,0-.16a3.44,3.44,0,0,1,.64,0v.19Z"
            />
            <path
              class="cls-116"
              d="M770.72,485.7a3.43,3.43,0,0,1,.64,0v.18h-.64Z"
            />
            <path
              class="cls-114"
              d="M772,484.69a.32.32,0,0,0,.17,0v.22c-.18-.05-.53,0-.48-.21A.54.54,0,0,1,772,484.69Z"
            />
            <path
              class="cls-114"
              d="M770.69,486.15h.67a.1.1,0,0,1-.06.11,1.39,1.39,0,0,1-.46,0C770.68,486.29,770.63,486.24,770.69,486.15Z"
            />
            <path
              class="cls-114"
              d="M770.72,485.86h.64v.1a3.44,3.44,0,0,0-.64,0Z"
            />
            <path class="cls-117" d="M771.54,485.38v0l0,0Z" />
            <path
              class="cls-114"
              d="M772.35,482c-.06.62-.11,1.25-.17,1.87a.35.35,0,0,1-.25,0c0-.16,0-.33,0-.5s-.07-.15-.23-.15v-.06c.09,0,.24,0,.27-.08s-.22,0-.23-.11.25,0,.25-.12-.18-.07-.24-.13v-.62C771.93,481.93,772.15,482,772.35,482Z"
            />
            <path
              class="cls-114"
              d="M770.82,482.66a1.38,1.38,0,0,0,.06-.53c0-.08,0-.14.2-.13a1.17,1.17,0,0,1,.62.08c0,.16-.14.33-.05.5s0,.14-.12.16a3.24,3.24,0,0,1-.62,0C770.82,482.75,770.83,482.7,770.82,482.66Z"
            />
            <path
              class="cls-117"
              d="M771.53,483.2c0,.15,0,.3,0,.45s-.3.15-.51.17-.27-.05-.26-.17,0-.3,0-.45Z"
            />
            <path
              class="cls-117"
              d="M770.82,482.66s0,.09.09.1a3.24,3.24,0,0,0,.62,0c.14,0,.12-.09.12-.16l.11.11c.06.06.24,0,.24.13s-.19.06-.25.12.26,0,.23.11-.18.06-.27.08h-1c0-.05,0-.11.06-.15a1.82,1.82,0,0,0,.77,0l.07-.07s.07-.08,0-.08,0,.05-.06.08a4,4,0,0,0-.77,0A.19.19,0,0,1,770.82,482.66Z"
            />
            <path
              class="cls-117"
              d="M771.72,483.19c.16,0,.24,0,.23.15s0,.34,0,.5c-.26,0-.36,0-.29-.2S771.59,483.34,771.72,483.19Z"
            />
            <path
              class="cls-114"
              d="M770.88,481.6a1.19,1.19,0,0,1,.83,0c0,.1-.06.16-.24.15S771,481.82,770.88,481.6Z"
            />
            <path
              class="cls-114"
              d="M771.26,482h-.17c-.11,0-.21,0-.2-.09s.09-.09.19-.09h.35c.1,0,.21,0,.21.09s-.1.09-.2.09Z"
            />
            <path
              class="cls-114"
              d="M772.36,481.49v.25h-.3c-.17,0-.25,0-.24-.14S772.18,481.52,772.36,481.49Z"
            />
            <path
              class="cls-114"
              d="M772.35,481.79V482H772c-.07,0-.17,0-.18-.06s.07-.11.18-.11S772.23,481.79,772.35,481.79Z"
            />
            <path
              class="cls-114"
              d="M770.82,482.94a4,4,0,0,1,.77,0V483a1.82,1.82,0,0,1-.77,0Z"
            />
            <path
              class="cls-116"
              d="M771.76,482.69l-.11-.11c-.09-.17.05-.34.05-.5h.07Z"
            />
            <path class="cls-114" d="M770.76,483.13h.83l-.06.07h-.77Z" />
            <path
              class="cls-114"
              d="M755.57,486.59v0c.25,0,.33.12.2.3-.1,0-.09-.1-.19-.09v-.07C755.72,486.66,755.71,486.63,755.57,486.59Z"
            />
            <path
              class="cls-114"
              d="M755.79,486.5a.59.59,0,0,1,.41,0A.61.61,0,0,1,755.79,486.5Z"
            />
            <path
              class="cls-114"
              d="M756,483a.36.36,0,0,1-.32,0A.44.44,0,0,1,756,483Z"
            />
            <path class="cls-116" d="M755.57,486.59c.14,0,.15.07,0,.11Z" />
            <path
              class="cls-116"
              d="M758.6,483.54v-1.31a.1.1,0,0,1,.06.11v1.1A.12.12,0,0,1,758.6,483.54Z"
            />
            <path
              class="cls-114"
              d="M746,483.37v-.18a1.58,1.58,0,0,1-.06-.68c0-.15-.05-.24-.27-.24l-.06,0-.08,1a1.32,1.32,0,0,1,.12.2h.28l.07,0Z"
            />
            <path
              class="cls-116"
              d="M746.5,482.36c0-.09,0-.12-.18-.12h-.61l0,0c.22,0,.28.09.27.24a1.58,1.58,0,0,0,.06.68c.2-.14.25-.33.48-.46v.36A2.24,2.24,0,0,0,746.5,482.36Z"
            />
            <path
              class="cls-114"
              d="M745.72,481.91h.15v-.21h-.22A1.66,1.66,0,0,0,745.72,481.91Z"
            />
            <path
              class="cls-116"
              d="M745.87,481.91v-.21h.38c.1,0,.15,0,.16.1s0,.11-.17.11Z"
            />
            <path
              class="cls-116"
              d="M746.47,482.07c0-.06-.06-.09-.14-.07s-.39,0-.58,0v0c.09,0,.15.07.11.15h.47C746.44,482.16,746.47,482.12,746.47,482.07Z"
            />
            <path
              class="cls-116"
              d="M746,483.44l-.07,0c0,.15-.11.15-.24.14h-.05l0,0h.29l.1,0C746.12,483.59,746.08,483.5,746,483.44Z"
            />
            <path class="cls-116" d="M746,483.37v0Z" />
            <path
              class="cls-121"
              d="M745.84,486.82a.66.66,0,0,1,0-.14c0-.08.09-.11.22-.11s.19,0,.19.12a.57.57,0,0,0,0,.26c0,.07,0,.14-.12.16s-.27,0-.31-.09a.64.64,0,0,1,0-.2Z"
            />
            <path
              class="cls-121"
              d="M745.6,486.72c0-.08-.05-.12-.19-.12l-.11,0c0,.13,0,.26,0,.39a.17.17,0,0,1,0,.1l.06.08.25,0Z"
            />
            <path
              class="cls-116"
              d="M745.77,486.3l.48,0s.07.08,0,.09S745.9,486.45,745.77,486.3Z"
            />
            <path
              class="cls-116"
              d="M745.94,485h-.22c-.1,0-.09,0-.11-.09s0-.08.11-.08c.28,0,.54-.06.82,0,.1,0,.17,0,.17.09s-.08.08-.17.09Z"
            />
            <path
              class="cls-116"
              d="M746.43,485l-.91.06-.1,0h0a.41.41,0,0,0,0,.11h1.05c.1,0,.3,0,.28-.09S746.54,485,746.43,485Z"
            />
            <path
              class="cls-115"
              d="M745.52,485.07l-.1,0A.15.15,0,0,1,745.52,485.07Z"
            />
            <path class="cls-115" d="M748.78,486l-.1,0Z" />
            <path
              class="cls-117"
              d="M776.48,489.59c-.11,0,0-.16-.17-.18v-.07h.17Z"
            />
            <path
              class="cls-114"
              d="M776.87,483.45c0,.05,0,.09-.1.1s-.11,0-.09-.06,0-.09.1-.1S776.86,483.43,776.87,483.45Z"
            />
            <path
              class="cls-117"
              d="M776.72,483.13q.09,0,.09.06s0,.07-.11.07-.11,0-.1-.07S776.66,483.14,776.72,483.13Z"
            />
            <path
              class="cls-117"
              d="M768.2,490.45c0-.07-.06-.12,0-.15a.09.09,0,0,1,.1,0C768.37,490.4,768.24,490.4,768.2,490.45Z"
            />
            <path
              class="cls-116"
              d="M771.59,483v-.07s0-.09.06-.08,0,.05,0,.08Z"
            />
            <path class="cls-12" d="M745.49,483.84l0,.71" />
            <path class="cls-12" d="M745.61,482.38c0,.26,0,.53-.07.79" />
            <path class="cls-12" d="M745.8,480l-.12,1.56" />
            <path
              class="cls-129"
              d="M724.2,486.33a7.32,7.32,0,0,0-.11.8c0,.18-.06.37-.08.55l-.18,1.37c0,.26-.07.53-.11.8l-.15,1.08V491l0,.22a.31.31,0,0,0,0,.21c0,.14,0,.14-.26.18a1.81,1.81,0,0,1-.23,0l.06-.43c0-.21,0-.42.07-.64l.12-.93c0-.12,0-.25,0-.38.07-.39.11-.79.15-1.18,0-.19.06-.39.09-.58s.06-.39.07-.58c0,0,0-.05,0-.06s-.06,0-.09,0l-1.88,0c-.15,0-.18,0-.19.11s0,.24,0,.35c-.06.59-.11,1.17-.17,1.76l-.21,2-.09.83c0,.05-.07.06-.13.07s-.23,0-.35,0c0-.26,0-.51,0-.77l.09-1c.06-.48.09-1,.14-1.43l0-.42.12-1.25.09-1,1.82,0,1.3,0S724.17,486.3,724.2,486.33Z"
            />
            <path
              class="cls-110"
              d="M720.92,491.92l.09-.83.21-2c.06-.59.11-1.17.17-1.76,0-.11,0-.23,0-.35s0-.11.19-.11l1.88,0a.54.54,0,0,1,0,.25h-1.59s-.11,0-.14,0v0a.09.09,0,0,0,0,.1v0s-.05.07,0,.1v0a3.29,3.29,0,0,0-.05.54c0,.06.06.05.12,0a2.41,2.41,0,0,0,.38,0l1.21,0a5.67,5.67,0,0,1-.09.72c-.23,0-.46,0-.69,0h-.39l-.54,0s-.09,0-.07,0,0,.06,0,.08V489l0,.6v.08c0,.12,0,.13.19.11l.28,0c.41,0,.81-.07,1.22-.08l-.07.6c-.05,0-.09,0-.11,0h0a.08.08,0,0,0-.07,0c-.14,0-.29,0-.42.06h-.06a.4.4,0,0,0-.19,0h-.06a.11.11,0,0,0-.1,0h-.09a.11.11,0,0,0-.1,0h-.1a.91.91,0,0,0-.33,0c-.07,0-.08.08,0,.13v0l0,.1v.05c-.09.14,0,.28,0,.42s0,0,0,.07v0c0,.05,0,.06.1.05l.72-.09a7.71,7.71,0,0,1,.84-.1l-.05.51c-.52.06-1,.15-1.54.22A3.26,3.26,0,0,1,720.92,491.92Z"
            />
            <path
              class="cls-130"
              d="M721,486.22l-.09,1-.12,1.25,0,.42c-.05.47-.08.95-.14,1.43l-.09,1c0,.26,0,.51,0,.77a2.08,2.08,0,0,1-.36,0l-.44-.09a.66.66,0,0,1,0-.14c0-.31.05-.63.09-.94,0-.08,0-.11-.16-.09s-.11-.08-.29,0-.1,0-.18-.08l-.11,1.43c-.08,0-.13,0-.21,0l-.25,0,0-.29c.06-.05.05-.08-.06-.1l-.3-.05c-.05-.06,0-.13-.06-.19s0-.18,0-.27,0-.21-.32-.16c-.06,0-.12,0-.13.06s0,.29,0,.44h-.11V491c0-.11,0-.22,0-.33a5.51,5.51,0,0,1,.71-.08,3.39,3.39,0,0,1,.64,0c.17,0,.32.06.49.06s.57-.05.85-.07c.07,0,.06,0,.06-.07s0-.3,0-.46,0-.05,0-.07c0-.17,0-.35,0-.53s.05-.62.08-.94a.38.38,0,0,0,0-.33v-.23s0-.05,0-.08c0-.3,0-.6.06-.9h0c.06,0,0-.06,0-.1a0,0,0,0,0,0,0,0,0,0,0,0,0,0c0-.13,0-.26,0-.39s0-.05-.09-.05h-.83c-.15,0-.3.05-.45,0,0,0,0,0,.08,0,.42.05.84,0,1.26,0l0,0s0,0,0,0Z"
            />
            <path
              class="cls-113"
              d="M708.77,492.08h0l-.52-.62a.07.07,0,0,0-.09-.05c0-.16,0-.31,0-.47a.06.06,0,0,0-.07-.07c-.09,0,0,0-.06.07s.07.29,0,.44l-.05,0s0,0-.07,0l-.33-.41a.21.21,0,0,0-.27,0l-.13.05c0-.07,0-.14,0-.2s0-.06,0-.05-.05,0-.05.05a2,2,0,0,0,0,.25v.12s0,.08.09.08,0,.18,0,.28,0,0-.08,0l-.06,0v0c0-.06-.15-.08-.15-.16s0-.41,0-.62a6,6,0,0,1,.74,0c-.06.06,0,.08.09.1l.85.25c.41.12.8.26,1.23.36s.55-.06.83-.06l0,.07-.48.05c-.05,0-.09,0-.09,0-.18,0-.28.1-.26.23a3.25,3.25,0,0,0,0,.44Z"
            />
            <path
              class="cls-109"
              d="M716.08,492.35h-.18c0-.53,0-1.07,0-1.6a.7.7,0,0,1,.06-.4.18.18,0,0,1,.16.06s0,0,0,0l0,0a.06.06,0,0,0,0,.06.63.63,0,0,0,.45,0h0a.3.3,0,0,0,.16,0c.06,0,.19,0,.19,0s0-.05.07,0a.57.57,0,0,0,.29,0l.31,0h.06l.81-.08a6.53,6.53,0,0,0,.76-.08c.09.06.06.15,0,.17a1.77,1.77,0,0,0-.32,0,3.39,3.39,0,0,0-.64,0,5.51,5.51,0,0,0-.71.08c-.46,0-.91.08-1.36.12-.06,0-.08,0-.08.06V491a2.11,2.11,0,0,0,0,.56v.38s0,0,0,.07v.11s0,0,0,.06Z"
            />
            <path
              class="cls-114"
              d="M710.55,491.32l0-.07a2.28,2.28,0,0,1,.45,0,3.68,3.68,0,0,0-.38.31,3.36,3.36,0,0,0,1.05,0c-.05.28,0,.31.39.3h0c.08,0,.12,0,.12-.07a2.81,2.81,0,0,1,0-.29,2.33,2.33,0,0,1,.59,0c0,.19,0,.39,0,.58s0,.08-.06.1h-.1a1.6,1.6,0,0,0-.4-.25.26.26,0,0,0-.15,0l-1.5.18C710.55,491.79,710.56,491.55,710.55,491.32Z"
            />
            <path
              class="cls-110"
              d="M710.55,491.32c0,.23,0,.47,0,.7v.05a3.62,3.62,0,0,0,0,.47v.39l0,0s-.09,0-.14,0h-.06l-.29,0,0-.05c0-.51,0-1-.06-1.54,0,0,0,0,.09,0Z"
            />
            <path
              class="cls-115"
              d="M714.23,492.38a1.5,1.5,0,0,1-.43-.1,1.27,1.27,0,0,0-.28-.06,1.29,1.29,0,0,0,0-.48,2.3,2.3,0,0,1,0-.45,5.68,5.68,0,0,1,.76-.28s0,.05,0,.08Z"
            />
            <path
              class="cls-110"
              d="M713.49,491.29a2.3,2.3,0,0,0,0,.45,1.29,1.29,0,0,1,0,.48,5.62,5.62,0,0,0-.58,0c-.11,0-.17,0-.21-.09s.06-.06.06-.1,0-.39,0-.58h0Z"
            />
            <path
              class="cls-111"
              d="M723.26,488.73a5.67,5.67,0,0,0,.09-.72l.08-.64a.23.23,0,0,0,0-.18v0a.54.54,0,0,0,0-.25s0,0,.09,0,0,0,0,.06c0,.19,0,.38-.07.58s-.07.39-.09.58c0,.39-.08.79-.15,1.18,0,.13,0,.26,0,.38l-.12.93c0,.22,0,.43-.07.64l-.06.43h-.11l.05-.51v-.08a1.33,1.33,0,0,0,.06-.45v0a.34.34,0,0,0,0-.24v0s0,0,0,0l.07-.6Z"
            />
            <path
              class="cls-110"
              d="M707.26,490.88a.21.21,0,0,1,.27,0l.33.41c0,.2,0,.4,0,.6a.11.11,0,0,1,0,.12l-.5,0Z"
            />
            <path
              class="cls-109"
              d="M706.47,491.59a1.88,1.88,0,0,0,0,.41c0,.19,0,.19-.31.19,0-.2,0-.39-.07-.6s-.05-.48-.07-.72c0,0,0-.09.09-.1a1,1,0,0,1,.25,0Z"
            />
            <path
              class="cls-110"
              d="M714.23,492.38l0-1.29s0,0,0-.08.1,0,.12,0a.51.51,0,0,1,0,.13v.44c0,.11,0,.21,0,.31s0,.11.08.09.27,0,.27-.1v-.71l.12,0c0,.38,0,.77,0,1.15A3.28,3.28,0,0,1,714.23,492.38Z"
            />
            <path
              class="cls-113"
              d="M706.07,492c-.1-.07,0-.18-.12-.26a.45.45,0,0,0,0-.16s0-.05-.1,0v0l.06-.05a.47.47,0,0,0,0-.43s-.09-.08-.09,0,0,0-.08,0,0-.12-.16-.14l0-.07a4.36,4.36,0,0,0,0-.51h.08a1.1,1.1,0,0,1,.26.06s.08,0,.09,0,.07,0,.08,0c0,.28.06.56.08.83A5.63,5.63,0,0,1,706.07,492Z"
            />
            <path
              class="cls-115"
              d="M710,491.41c0,.51.07,1,.06,1.54a1,1,0,0,0-.25,0l-.19,0c.06,0,.17,0,.19-.06a1.12,1.12,0,0,1,0-.41c0-.12-.09-.24,0-.36a3.25,3.25,0,0,1,0-.44C709.7,491.51,709.8,491.45,710,491.41Z"
            />
            <path
              class="cls-115"
              d="M714.86,492.32c0-.38,0-.77,0-1.15.12,0,.19-.09.32-.1,0,.44,0,.87,0,1.31C715,492.39,715,492.32,714.86,492.32Z"
            />
            <path
              class="cls-116"
              d="M710.58,492.07V492l1.5-.18a.26.26,0,0,1,.15,0,1.6,1.6,0,0,1,.4.25,8.08,8.08,0,0,1-1.1,0,.18.18,0,0,1-.11,0,.61.61,0,0,0-.3,0C710.94,492.09,710.76,492.06,710.58,492.07Z"
            />
            <path
              class="cls-111"
              d="M706.07,492a5.63,5.63,0,0,0,0-.71c0-.27-.06-.55-.08-.83,0,0,0-.07-.08,0s-.06,0-.09,0a1.1,1.1,0,0,0-.26-.06.53.53,0,0,0-.28-.1q-.18-.14,0-.15s0,0,.08.05l.57.17s0,0,.06-.05a1.16,1.16,0,0,1,0,.37s0,.08.06.09a.27.27,0,0,0,.2,0c.05,0,0-.06,0-.09a.17.17,0,0,1-.05-.13s0-.07.1-.06.19.05.31.05a.77.77,0,0,1,.45,0,1.27,1.27,0,0,1-.28,0c-.23,0-.23,0-.22.15-.16,0-.16,0-.15.09a1,1,0,0,0-.25,0c-.1,0-.09.06-.09.1,0,.24.05.48.07.72s0,.4.07.6c-.12,0-.06-.07-.1-.11s0,0,0-.06Z"
            />
            <path
              class="cls-109"
              d="M709.75,492.08c-.08.12,0,.24,0,.36a1.12,1.12,0,0,0,0,.41c-.12,0-.15-.13-.21-.19s-.26-.29-.4-.43,0-.05-.09,0a.64.64,0,0,1-.24,0s-.09,0-.08-.07Z"
            />
            <path
              class="cls-113"
              d="M706.38,490.75c0-.12,0-.12.15-.09s.17,0,.25,0v0c-.1,0-.09,0-.09.08a4,4,0,0,0,0,.6c0,.06,0,.12.06.18v0l-.3,0Z"
            />
            <path
              class="cls-110"
              d="M708.22,491.45l.52.62a1.63,1.63,0,0,1-.45.08c-.08,0-.07,0-.08-.07l0-.32v-.05C708.21,491.62,708.14,491.53,708.22,491.45Z"
            />
            <path
              class="cls-110"
              d="M715.15,492.38c0-.44.06-.87,0-1.31.12-.07.14,0,.14.05l0,1.26,0,0S715.18,492.41,715.15,492.38Z"
            />
            <path
              class="cls-115"
              d="M707.26,490.88l.1,1.19c-.21,0-.12-.08-.16-.13a.78.78,0,0,0,0-.22c0-.09-.09-.15-.08-.23s.08,0,.08,0,0-.19,0-.28,0-.13,0-.2v-.05Z"
            />
            <path
              class="cls-113"
              d="M717.37,492.12l0,0c-.05,0-.07-.06,0-.11s.06-.05,0-.07-.11,0-.15,0,0,0,0,.08a.07.07,0,0,1,0,.06c-.07,0-.15,0-.18,0a.31.31,0,0,0,0-.32c0-.06,0-.13,0-.19s0,.07,0,.11a.08.08,0,0,0,.09.07c.07,0,0-.05,0-.07s0,0,0-.06,0,.15.12.13.09,0,.12.05l.06,0v.06c-.05,0-.05,0-.05.06Z"
            />
            <path
              class="cls-117"
              d="M717.37,492.12l0-.25s0-.05.05-.06a.17.17,0,0,0,.12,0l.7-.09a.13.13,0,0,0,.09,0h.08s.06,0,.11,0l0,.29h-.09c0-.17,0-.17-.25-.11s-.44,0-.66.08c-.06,0-.08,0-.07.06v.13h-.08Z"
            />
            <path
              class="cls-115"
              d="M708.18,491.76l0,.32a.81.81,0,0,1-.35-.05.11.11,0,0,0,0-.12c0-.2,0-.4,0-.6,0,0,.06,0,.07,0s0,0,0,.05l0,.39s0,.05.08.05S708.12,491.78,708.18,491.76Z"
            />
            <path
              class="cls-109"
              d="M717,492l-.25,0v-.13c.07-.07,0-.11-.1-.12a.31.31,0,0,1-.13,0l.38-.05c.08,0,.1.07.1.12A1.08,1.08,0,0,0,717,492Z"
            />
            <path
              class="cls-117"
              d="M716.7,491.91V492c0,.06,0,.12-.05.17a.08.08,0,0,1,0-.09c0-.08,0-.1-.15-.08l-.36,0,0,0V492a1.24,1.24,0,0,0,.47-.05S716.64,491.86,716.7,491.91Z"
            />
            <path
              class="cls-113"
              d="M716.12,492.09l.36,0c.12,0,.16,0,.15.08a.08.08,0,0,0,0,.09.06.06,0,0,1-.06,0,.64.64,0,0,0-.49-.06s0,0,0-.06h0Zm.44,0s0,0,0,0,0,0,0,0,0,0,.06,0S716.56,492.12,716.56,492.11Z"
            />
            <path
              class="cls-113"
              d="M717.46,492s0-.06.07-.06c.22,0,.43-.07.66-.08v0Z"
            />
            <path
              class="cls-117"
              d="M706.77,491.57v0c.07,0,.14-.06.16-.12a.16.16,0,0,0,.1,0v0h0C707,491.65,707,491.65,706.77,491.57Z"
            />
            <path
              class="cls-118"
              d="M717.16,492.05a.07.07,0,0,0,0-.06s0-.07,0-.08.1,0,.15,0,0,.05,0,.07,0,.08,0,.11A.29.29,0,0,1,717.16,492.05Z"
            />
            <path class="cls-118" d="M718.2,491.89v0c.26-.06.26-.06.25.11Z" />
            <path
              class="cls-113"
              d="M705.82,491.57l-.29.06c-.18,0-.35.06-.54.06h0A3.69,3.69,0,0,1,705.82,491.57Z"
            />
            <path
              class="cls-109"
              d="M715.27,492.4l0,0c.08,0,.17,0,.22,0a.27.27,0,0,0,.13,0v0l-.13,0A.48.48,0,0,1,715.27,492.4Z"
            />
            <path
              class="cls-111"
              d="M717,492a1.08,1.08,0,0,1,0-.18c0-.05,0-.09-.1-.12h.09a.31.31,0,0,1,0,.32Z"
            />
            <path
              class="cls-109"
              d="M707.18,491.72a.78.78,0,0,1,0,.22,1.74,1.74,0,0,1-.11-.18C707.06,491.69,707.12,491.71,707.18,491.72Z"
            />
            <path class="cls-113" d="M705,491.69h0v0h0Z" />
            <path
              class="cls-117"
              d="M711.12,492.07a.61.61,0,0,1,.3,0A.51.51,0,0,1,711.12,492.07Z"
            />
            <path class="cls-113" d="M706.08,492s0,0,0,.06Z" />
            <path
              class="cls-131"
              d="M718.67,489.87c0-.45.05-.91.09-1.37a.06.06,0,0,1,0-.07c0-.11,0-.23,0-.34,0-.36.05-.72.08-1.09,0-.05,0-.09,0-.14a.08.08,0,0,1,0-.08,1.71,1.71,0,0,1,0-.45c0-.14,0-.14-.28-.15l-1.19,0-.88,0c-.67,0-1.35-.05-2-.06,0,.21,0,.42,0,.63,0,.69,0,1.38,0,2.08,0,.45,0,.91,0,1.36,0,.05,0,.12-.13.1a5.14,5.14,0,0,1-.55.06l-1.91.15-2.14.17,0,.68c.28,0,.55-.06.83-.06a2.28,2.28,0,0,1,.45,0,4.07,4.07,0,0,1,.6-.06l.58-.06a5.67,5.67,0,0,1,.58,0l1.54-.16c.21,0,.21,0,.15-.14s0-.17.19-.18a3.38,3.38,0,0,1,.78-.05h.06c.15,0,.21,0,.19-.08s.1-.09.29-.07a.18.18,0,0,1,.16.06v0l0,0s.07,0,.08,0,.23-.07.36-.07.08,0,.13,0,.18-.1.31-.08l.18,0c0-.06,0-.07.13-.07h.15l.23,0s0-.07.09-.08a.85.85,0,0,1,.32,0,.32.32,0,0,1,.28-.07l.17,0V490A.09.09,0,0,1,718.67,489.87Zm-3-2c0-.25,0-.51,0-.76v-.26s0-.07.09-.07l1.92,0h.44c.05,0,.09,0,.08,0,0,.32,0,.64-.05,1,0,.07-.08.06-.15.05l-.55,0h-.93c-.25,0-.5,0-.75,0C715.75,487.9,715.68,487.92,715.67,487.86Zm2.3,1.72a4.07,4.07,0,0,1-.6.06l-1.63.11c-.12,0-.12,0-.08-.07s0-.14,0-.21v-.06a2.67,2.67,0,0,1,0-.49v0s0-.08,0-.12v-.14s0,0,.07,0l1.59-.06h.25a.52.52,0,0,1,.33,0,1.46,1.46,0,0,0,.21,0v.7a2.83,2.83,0,0,1,0,.29Q718.09,489.6,718,489.58Z"
            />
            <path
              class="cls-129"
              d="M711.89,486.4l-1.22,0-2.59-.05c0,.36,0,.71,0,1.06s0,.52,0,.78c0,.61.07,1.22.11,1.83.47,0,.94-.06,1.42-.09l2.25-.14C711.88,488.65,712,487.53,711.89,486.4Zm-1.28,1.45c-.05-.06,0-.12,0-.18v-.55s0,0,0,0a.17.17,0,0,1,0-.07,1.47,1.47,0,0,1,.47,0h0a1.61,1.61,0,0,1,0,.49v.36s0,.06,0,.06a2.29,2.29,0,0,1-.37,0C710.56,487.93,710.6,487.89,710.61,487.85Zm.41,1.91h-.16c-.21,0-.21,0-.21-.12v-.3a2.42,2.42,0,0,1,0-.47s0-.06.1-.06h.36s0,0,0,.07,0,.24,0,.35v0a.08.08,0,0,1,0,.11v.14s0,0,0,0v0a.06.06,0,0,1,0,.09S711.08,489.76,711,489.76Z"
            />
            <path
              class="cls-130"
              d="M712,489.77c-.08-1.12,0-2.24-.07-3.37l2-.1,0,2v.31c0,.43,0,.86,0,1.29,0,.16,0,.16-.25.14h0a1.77,1.77,0,0,0-.31-.08Zm.34-.89c0,.27,0,.54,0,.81,0,.07.08.07.17.07s.09,0,.09-.06c0-.27,0-.54,0-.81,0-.08-.09-.07-.16-.08S712.31,488.84,712.3,488.88Zm0-.94h.08c.17,0,.18,0,.18-.12,0-.27,0-.54,0-.81,0,0,0-.07-.12-.07s-.09.07-.11.11l-.09-.05v.86S712.22,488,712.3,487.94Z"
            />
            <path
              class="cls-132"
              d="M709.72,490.63l-1.51-.38h-.06l-.07,0a1.67,1.67,0,0,1-.32-.08l-.06,0h-.08a.13.13,0,0,1,0-.06c0-.38-.05-.77-.07-1.16,0-.63-.09-1.25-.14-1.88l-.06-.87-1.27.11c-.18,0-.3,0-.29.16h0l0,0a1.72,1.72,0,0,1,0,.39c0,.07-.08,0-.13,0h-.34v0h.33c.09,0,.16,0,.16.08,0,.35.08.69.07,1a1.3,1.3,0,0,1,.05.52c0,.23.06.46,0,.69h.26v0c0-.15,0-.29,0-.44s0-.07,0-.1a5.43,5.43,0,0,1,.81.09c.06,0,.07,0,.06.06s-.06,0-.09,0a2.34,2.34,0,0,1-.59-.09h-.16l0,.16h0c0-.06.06,0,.09,0h0a.33.33,0,0,1,.23,0l.12,0a.59.59,0,0,1,.33.11s0,0-.06,0,.06.06.13.06.13,0,.13.05-.06,0-.11.05a.29.29,0,0,0-.17,0l.05,0h0a.61.61,0,0,1,0,.3h-.1c-.08,0-.16,0-.19-.06s-.11,0-.16,0a1,1,0,0,0-.18,0s-.07,0-.06-.05,0-.07,0-.11h0s0-.13-.17-.07c.07,0,.08,0,.07.06s0,.11,0,.16,0-.15,0-.22H706l0,.6c.1.07.07.15.06.22a2.28,2.28,0,0,1,.6.13.73.73,0,0,1,.3.12,1.78,1.78,0,0,1,.52.11c.12.05.12.1,0,.17s0,.08.09.1l.85.25c.41.12.8.26,1.23.36Zm-2.76-2.8-.2,0h-.15a.45.45,0,0,1-.2,0h-.12a.07.07,0,0,1-.09,0c-.05,0-.06,0-.07-.05l-.06-.73,0,0a.12.12,0,0,1,.09,0c.22,0,.45,0,.68,0,.07,0,.13,0,.13.07s0,.06-.12.06h-.71v.15h.1l0,0h.16l.11,0s.08,0,.13,0a.28.28,0,0,1,.22,0,.09.09,0,0,1,.07.1,2.27,2.27,0,0,0,0,.45S707.07,487.84,707,487.83Zm-.07-.69s-.06,0-.09,0-.09,0-.08,0,0,0,.08,0S706.87,487.11,706.89,487.14Zm-.36,0s0,0-.09,0-.08,0-.06,0,.06,0,.09,0S706.54,487.11,706.53,487.14Z"
            />
            <path
              class="cls-110"
              d="M707.7,490.11c-.09,0-.09-.05-.09-.09,0-.38-.05-.77-.07-1.16,0-.63-.09-1.25-.14-1.88l-.06-.87a2.35,2.35,0,0,1,.65,0c.06,0,.06,0,.06.06l0,.14c0,.36,0,.71,0,1.06s0,.52,0,.78c0,.61.07,1.22.1,1.83,0,.05,0,.06-.11.07S707.85,490.08,707.7,490.11Z"
            />
            <path
              class="cls-133"
              d="M713.62,490.07h0c.25,0,.25,0,.25-.14,0-.43,0-.86,0-1.29a.42.42,0,0,0,0-.31l0-2v-.08c0-.08,0-.12.19-.12s.26,0,.39,0c0,.21,0,.42,0,.63,0,.69,0,1.38,0,2.08,0,.45,0,.91,0,1.36,0,.05,0,.12-.13.1a1.08,1.08,0,0,0-.31-.07A1.06,1.06,0,0,1,713.62,490.07Z"
            />
            <path class="cls-129" d="M705.78,486.42h-.4v0h.37Z" />
            <path
              class="cls-129"
              d="M706.58,489.22h-.07c-.14,0,0,0-.07.08h0s0-.13-.17-.07H706a3,3,0,0,0-.42,0h-.22l-.07,0h-.09l-.09,0v-.05h0l0,0,.08,0h.1a5.51,5.51,0,0,0,.57-.06h.3a.18.18,0,0,0,.13,0h0s0,0,.08,0h.06Z"
            />
            <path
              class="cls-117"
              d="M718.86,486.78a1.71,1.71,0,0,1,0-.45,1.32,1.32,0,0,1,.44,0c.15.06.3,0,.45,0s0,.32,0,.48h-.89Z"
            />
            <path class="cls-109" d="M720.74,486.23s0,0,0,0l0,0Z" />
            <path
              class="cls-117"
              d="M722.57,488.77c-.06,0-.19,0-.18.11s0,0-.08,0,0,0,0,0,.05-.05,0-.07h-.1c-.06.06-.18,0-.25,0h.22c.06,0,.09,0,0,.05a.73.73,0,0,1-.33,0s0,0,0-.07a.45.45,0,0,0-.23,0c.06,0,.15,0,.15,0s-.09,0-.15,0h-.08V489h0c.06,0,.15,0,.17,0s-.1,0-.12.06.13,0,.12.09a3.27,3.27,0,0,0,0,.44s0,.1-.06.12-.1,0-.16,0,0,.13.19.11l.28,0c.41,0,.81-.07,1.22-.08l.11-.93C723,488.73,722.8,488.75,722.57,488.77ZM722,489c.06,0,.17,0,.18,0s-.11,0-.17,0-.19,0-.2,0S722,489,722,489Zm-.25.73v0h0v0Zm.34,0c-.05,0,0,0-.05,0l-.06,0c-.1,0,0,.07-.08.12s0-.11-.11-.1,0,0,0-.05a2.71,2.71,0,0,1,0-.4c0-.09.15-.07.25-.08s.14,0,.13.07a2.49,2.49,0,0,0,0,.47S722.15,489.64,722.1,489.64Zm.25-.53a1.9,1.9,0,0,0,0,.41.17.17,0,0,1,0,.1.07.07,0,0,1-.08.05s0,0,0,0c0-.19,0-.36.06-.52s0-.08.09-.07S722.36,489.09,722.35,489.11Zm.35.52-.28,0s-.07,0-.06,0a2.73,2.73,0,0,0,0-.5s0-.08.09-.08a1,1,0,0,1,.3,0,0,0,0,0,1,0,.05,4.19,4.19,0,0,0,0,.5S722.75,489.62,722.7,489.63Zm.08-.66-.19,0c-.05,0-.13,0-.13,0s.07,0,.12,0l.19,0s.07,0,.07,0S722.82,489,722.78,489Zm0-.1-.19,0c-.06,0-.15,0-.15,0s.08,0,.13-.05h.19s.09,0,.09,0S722.84,488.87,722.79,488.87Zm.27.66c0,.07-.09.07-.17.07s0-.05,0-.08,0-.28,0-.42,0-.08.05-.1a.19.19,0,0,1,.13,0c.07,0,0,.07,0,.11A1.93,1.93,0,0,0,723.06,489.53Zm-.12-.57a0,0,0,0,1,0,0,.35.35,0,0,1,.2,0A.3.3,0,0,1,722.94,489Z"
            />
            <path
              class="cls-117"
              d="M723.05,490.3H723s0,.09-.06.12-.12,0-.15,0,0-.08.08-.09h.11a.08.08,0,0,0-.07,0c-.14,0-.29,0-.42.06a.19.19,0,0,0,.15,0c.06,0,.11,0,.11.05s0,.06-.09.07h-.2c-.06,0-.13,0-.15,0s0-.06.09-.07l0,0a.4.4,0,0,0-.19,0c0,.05.06.09,0,.13h-.07c0-.05,0-.08,0-.12a.11.11,0,0,0-.1,0s.07.1,0,.12a.54.54,0,0,1-.31,0c-.1,0,0-.08,0-.12a.91.91,0,0,0-.33,0h.1s.1,0,.1.05,0,0-.09.05l-.14,0v0h.09s.1,0,.12,0,0,.07-.1.07l-.14,0v.05a.5.5,0,0,1,.21,0,0,0,0,0,0,.07,0h.06a.41.41,0,0,1,.16,0l.1,0s.06,0,0,0,0,.3-.06.44l0,0c-.08,0-.18.07-.25,0h0c-.09,0-.09,0-.08-.07a.42.42,0,0,0,0-.27,2.17,2.17,0,0,0,0,.25c0,.16,0,.16-.25.19,0,.05,0,.06.1.05l.72-.09a7.71,7.71,0,0,1,.84-.1v-.08c-.06,0,0-.09,0-.13s0-.07,0-.1V491s0,.1-.09.11-.14,0-.13-.07l0-.35c0-.05.06-.06.13-.06s.09,0,.09,0v.15c.08-.07,0-.15.1-.19v0c0-.08-.08-.17,0-.24Zm-1.3.37s-.08,0-.09,0,0,0,.05,0a1.16,1.16,0,0,1,.42,0s.06,0,0,0l0,0Zm.43.05c0,.15,0,.3-.09.45a1.09,1.09,0,0,1,0-.44s0-.05.07-.05S722.19,490.7,722.18,490.72Zm.38.39a1.19,1.19,0,0,1-.33,0c-.08,0,0-.06-.05-.09a1,1,0,0,0,0-.34c0-.05,0-.06.12-.07l.3,0v.17a.46.46,0,0,1,0,.2S722.64,491.1,722.56,491.11Zm.29-.56a3.93,3.93,0,0,0-.48.06s-.09,0-.11,0,0,0,.08-.06l.26,0c.09.06.14,0,.22,0s.11,0,.12,0S722.9,490.55,722.85,490.55Z"
            />
            <path
              class="cls-117"
              d="M723.14,487.42a3.05,3.05,0,0,0-.43,0s-.1,0-.1,0,0-.06.1-.06h.62v0a.4.4,0,0,1-.16,0c-.07,0-.07-.07,0-.09h.24v0h-.07a.3.3,0,0,1-.16,0h-1.5v0c.07,0,.21,0,.22.05s-.15,0-.23.05h0v0h.15s.09,0,.09,0,0,.06-.09.06h-.15v0c.26,0,.26,0,.23.17a.49.49,0,0,0,0,.24c0,.08,0,.13-.14.17a2.41,2.41,0,0,0,.38,0l1.21,0c0-.21,0-.43.08-.64h-.07C723.33,487.44,723.23,487.43,723.14,487.42Zm-.29-.23c.08,0,.22,0,.22.05s-.15,0-.22.05-.21,0-.21-.05S722.78,487.19,722.85,487.19Zm-.45.4a2.19,2.19,0,0,0,0,.36s0,0,0,0-.05,0-.05,0,0-.07,0-.09a.13.13,0,0,1,0,.1c0,.08-.14.05-.22.05s-.07-.06-.07-.09l0-.36s0-.1.13-.09h.12C722.41,487.46,722.41,487.46,722.4,487.59Zm-.08-.17h-.22c-.05,0-.1,0-.1-.05s0,0,.1-.05h.22s.11,0,.11,0S722.38,487.43,722.32,487.42Zm.18.5s0,0,0,.07a1.77,1.77,0,0,1,0-.46s0-.06.07-.06,0,0,0,.07A1.64,1.64,0,0,1,722.5,487.92Zm0-.58s0,0,0,0,0,0,0,0,0,0,0,0S722.48,487.34,722.52,487.34Zm.05-.06a.1.1,0,0,1-.09,0s0,0,0,0-.23,0-.35,0-.07,0-.07,0,.05,0,.09,0h.41s.07,0,.07,0S722.59,487.27,722.57,487.28Zm.46.4a1,1,0,0,0,0,.24c0,.05,0,.08-.13.07h0c-.29,0-.29,0-.28-.2s0-.16,0-.26,0-.06.09-.07C723,487.43,723.09,487.48,723,487.68Zm.3-.11a2.72,2.72,0,0,0,0,.3c0,.07,0,.14-.17.12s-.07-.09-.06-.13.05-.21.05-.31,0-.09.13-.09S723.33,487.51,723.33,487.57Z"
            />
            <path
              class="cls-116"
              d="M721.71,490.73h-.06a0,0,0,0,1-.07,0,.5.5,0,0,0-.21,0c-.09.14,0,.28,0,.42s0,.05,0,.07v0c.25,0,.24,0,.25-.19a2.17,2.17,0,0,1,0-.25.42.42,0,0,1,0,.27c0,.05,0,.07.08.07s0-.23,0-.35A.16.16,0,0,0,721.71,490.73Zm-.29.47a.09.09,0,0,1,0-.13A.09.09,0,0,1,721.42,491.2Z"
            />
            <path
              class="cls-116"
              d="M721.52,489h0c.06,0,.15,0,.17,0s-.1,0-.12.06.13,0,.12.09a3.27,3.27,0,0,0,0,.44s0,.1-.06.12-.1,0-.16,0v0s.06,0,0,0Z"
            />
            <path
              class="cls-116"
              d="M721.69,487.46c.26,0,.26,0,.23.17a.49.49,0,0,0,0,.24c0,.08,0,.14-.14.17s-.13,0-.12,0A3.29,3.29,0,0,1,721.69,487.46Z"
            />
            <path
              class="cls-116"
              d="M722.44,490.34a.19.19,0,0,0,.15,0c.06,0,.11,0,.11.05s0,.06-.09.07h-.2c-.06,0-.13,0-.15,0s0-.06.09-.07l0,0Z"
            />
            <path
              class="cls-116"
              d="M722,490.38s.07.1,0,.12a.54.54,0,0,1-.31,0c-.1,0,0-.08,0-.12h.1a.08.08,0,0,0,.1,0Z"
            />
            <path
              class="cls-115"
              d="M723.39,487.15a.3.3,0,0,1-.16,0h-1.5s.09,0,.14,0Z"
            />
            <path
              class="cls-116"
              d="M721.41,490.45h.1s.1,0,.1.05,0,0-.09.05l-.14,0C721.33,490.53,721.34,490.49,721.41,490.45Z"
            />
            <path
              class="cls-116"
              d="M721.7,487.33h.15s.09,0,.09,0,0,.06-.09.06h-.15C721.65,487.4,721.71,487.36,721.7,487.33Z"
            />
            <path
              class="cls-116"
              d="M721.73,487.19c.07,0,.21,0,.22.05s-.15,0-.23.05h0A.09.09,0,0,1,721.73,487.19Z"
            />
            <path
              class="cls-116"
              d="M723,490.31s0,.09-.06.12-.12,0-.15,0,0-.08.08-.09H723Z"
            />
            <path
              class="cls-116"
              d="M721.39,490.61h.09s.1,0,.12,0,0,.07-.1.07l-.14,0Z"
            />
            <path
              class="cls-115"
              d="M722.57,488.77c-.06,0-.19,0-.18.11s0,0-.08,0,0,0,0,0,.05-.05,0-.07Z"
            />
            <path
              class="cls-115"
              d="M722.18,488.79c-.06.06-.18,0-.25,0a.13.13,0,0,1-.09,0,.45.45,0,0,0-.23,0h0s0,0,.07,0Z"
            />
            <path
              class="cls-116"
              d="M721.57,488.85h0c.06,0,.15,0,.15,0s-.09,0-.15,0h-.08S721.52,488.87,721.57,488.85Z"
            />
            <path
              class="cls-116"
              d="M722.19,490.36c0,.05.06.09,0,.13h-.07c0-.05,0-.08,0-.12Z"
            />
            <path
              class="cls-117"
              d="M721.33,491.18s0,.05,0,.07S721.29,491.2,721.33,491.18Z"
            />
            <path
              class="cls-117"
              d="M721.94,490.39a.08.08,0,0,1-.1,0A.11.11,0,0,1,721.94,490.39Z"
            />
            <path
              class="cls-115"
              d="M723.05,490.3H723s.06,0,.11,0S723.08,490.29,723.05,490.3Z"
            />
            <path class="cls-117" d="M721.47,489.58s0,0,0,0Z" />
            <path
              class="cls-117"
              d="M719.78,488.47c-.12,0-.17,0-.16-.1a1.92,1.92,0,0,0,0-.24c-.24,0-.49,0-.74,0l-.1,0c-.08.11,0,.23,0,.34l.75,0h.1v0h.13c0,.05-.06.06-.12.07v0h0c.06,0,.13,0,.12.05s0,.08-.12.08h0v0l0,0c.07,0,.1,0,.1,0,0,.21,0,.42-.05.62a2.72,2.72,0,0,0,0,.28c0,.06,0,.09-.13.08h0c0,.06,0,.07-.12.06l-.71-.1a.09.09,0,0,0-.06.1v.28a1.21,1.21,0,0,0,.54,0,.92.92,0,0,1,.16,0c.09.06.06.15,0,.17a1.77,1.77,0,0,0-.32,0c.17,0,.32.06.49.06a2,2,0,0,0,.06-.48c0-.09.06-.12.19-.13l.68-.06c0-.17,0-.35,0-.53s.05-.62.08-.94Zm.09.06.44,0c.06,0,.08,0,.08.05s0,.06-.07.06l-.33,0h-.1s-.1,0-.1,0S719.81,488.54,719.87,488.53Zm.52.21s0,.05-.1.06l-.34,0c-.06,0-.16,0-.17,0s.09-.08.17-.08l.33,0C720.35,488.68,720.39,488.69,720.39,488.74Zm-.08,1c0,.09-.07.12-.21.12h-.22c-.14,0-.21,0-.17-.12s0-.51,0-.79c0-.06,0-.09.15-.09l.36,0c.09,0,.12,0,.11.07C720.35,489.2,720.32,489.47,720.31,489.75Z"
            />
            <path
              class="cls-116"
              d="M720.49,487.88v0l0,0c0,.11-.08.13-.23.12H720c-.05,0-.11,0-.14,0h-.05a2.46,2.46,0,0,0,0-.26,4.44,4.44,0,0,0,0-.63c0-.08,0-.14.19-.14h.41c.1,0,.1,0,.09.08s0,.36,0,.54S720.46,487.82,720.49,487.88Z"
            />
            <path
              class="cls-110"
              d="M719.43,490.58a2,2,0,0,0,.06-.48c0-.09.06-.12.19-.13l.68-.06s0,0,0,.07,0,.31,0,.46,0,.06-.06.07C720,490.53,719.72,490.58,719.43,490.58Z"
            />
            <path
              class="cls-110"
              d="M719.75,486.78c0-.16,0-.32,0-.48h.83s.1,0,.09.05,0,.26,0,.39a0,0,0,0,1,0,0Z"
            />
            <path
              class="cls-110"
              d="M719.79,488.11h.71a.38.38,0,0,1,0,.33l-.7,0c-.12,0-.17,0-.16-.1a1.92,1.92,0,0,0,0-.24h.1S719.76,488.13,719.79,488.11Z"
            />
            <path
              class="cls-109"
              d="M719.19,491.93c0,.08-.05.13-.2.12l.11-1.43c.08,0,.1.09.18.08v.06Z"
            />
            <path
              class="cls-114"
              d="M716.15,490.82s0-.06.08-.06c.45,0,.9-.1,1.36-.12,0,.11,0,.22,0,.33h0a2.69,2.69,0,0,1,0,.4c0,.09-.15.06-.23.08s-.09,0-.09-.08a.69.69,0,0,1,0-.25.22.22,0,0,0,.19.07c.08,0,.06-.08.07-.12s0-.21,0-.31,0-.07-.1-.07-.21.06-.21.15,0,.1,0,.14,0-.12,0-.18,0-.09-.16-.07-.45,0-.67.08Z"
            />
            <path
              class="cls-109"
              d="M717.67,491.41c0-.15,0-.3,0-.44s.07-.05.13-.06c.34-.05.33-.05.32.16s0,.18,0,.27A2.32,2.32,0,0,1,717.67,491.41Z"
            />
            <path
              class="cls-117"
              d="M717.67,491.41a2.32,2.32,0,0,0,.46-.07c.07.06,0,.13.06.19h-.09v0s.06-.11-.09-.08l-.06,0s-.07,0-.09,0v0s-.09,0-.09,0,0,.06-.06.06h-.05c0-.09-.09,0-.15-.05s-.11,0-.1.07,0,.09.06.1.17,0,.21-.05l.05,0v0l-.27.05-.06,0s0-.07-.12-.05-.07-.09-.12-.13,0,0,0,.06,0,.06,0,.07a.08.08,0,0,1-.09-.07s0-.08,0-.11.15,0,.14-.08,0-.28.06-.41c.05,0,0,.08,0,.12a.69.69,0,0,0,0,.25s0,.09.09.08.21,0,.23-.08a2.69,2.69,0,0,0,0-.4h0v.43s.06,0,.09,0Z"
            />
            <path
              class="cls-109"
              d="M719.64,491.89l-.18,0,.09-1.17,0,0c.12,0,.17,0,.16.09,0,.31-.07.63-.09.94A.66.66,0,0,0,719.64,491.89Z"
            />
            <path
              class="cls-117"
              d="M720.58,486.9c.06,0,0-.06,0-.1h-.86s.11,0,.09.08-.05.06-.12.06v0s.09,0,.09.05,0,.05-.09.05v0c.12,0,.1.05.09.1,0,.21,0,.43-.06.65a2.4,2.4,0,0,0,0,.28s0,0,.07,0a2.46,2.46,0,0,0,0-.26,4.44,4.44,0,0,0,0-.63c0-.08,0-.14.19-.14h.41c.1,0,.1,0,.09.08s0,.36,0,.54,0,.12,0,.18,0-.05,0-.08Q720.57,487.35,720.58,486.9Zm-.1.15H720s-.11,0-.11,0,0-.05.1-.05h.51s.06,0,.06,0S720.53,487.05,720.48,487.05Zm-.1-.11H720c-.06,0-.1,0-.1-.06s0-.06.09-.06h.48c.09,0,.12,0,.13.08A.31.31,0,0,1,720.38,486.94Z"
            />
            <path
              class="cls-113"
              d="M718.1,491.54h.09l.3.05c.11,0,.12.05.06.1s-.06,0-.11,0-.13-.1-.28-.08h-.09Z"
            />
            <path
              class="cls-117"
              d="M720.5,488.11h-.66s.09,0,.14,0h.25c.15,0,.25,0,.23-.12l0,0Z"
            />
            <path
              class="cls-113"
              d="M719.57,490.72l0,0-.26,0v-.06C719.46,490.64,719.53,490.64,719.57,490.72Z"
            />
            <path
              class="cls-119"
              d="M720.61,486.8h-.89v0h.9A0,0,0,0,1,720.61,486.8Z"
            />
            <path class="cls-109" d="M717.65,491.41s-.07,0-.09,0Z" />
            <path
              class="cls-109"
              d="M707.55,490.43c.12.05.12.1,0,.17a6,6,0,0,0-.74,0h-.06c-.08,0-.16,0-.25,0s0-.15.22-.15a1.27,1.27,0,0,0,.28,0C707.2,490.45,707.39,490.5,707.55,490.43Z"
            />
            <path
              class="cls-114"
              d="M708.18,491.76c-.06,0-.08.08-.17.06l0-.45c0-.15,0-.29,0-.44s0-.07.06-.07a.06.06,0,0,1,.07.07c0,.16,0,.31,0,.47a1.08,1.08,0,0,0,0,.18s0,.09,0,.13Z"
            />
            <path
              class="cls-111"
              d="M706.78,490.65h.06c0,.21,0,.41,0,.62s.1.1.15.16a.16.16,0,0,1-.1,0,.17.17,0,0,1-.13-.15,5.85,5.85,0,0,0,0-.59Z"
            />
            <path
              class="cls-117"
              d="M708,491.37l0,.45s-.07,0-.08-.05l0-.39s0,0,0-.05Z"
            />
            <path
              class="cls-114"
              d="M707.13,490.93V491H707a2,2,0,0,1,0-.25s0-.05.05-.05,0,0,0,.05S707.18,490.86,707.13,490.93Z"
            />
            <path
              class="cls-115"
              d="M708.18,491.71c-.09,0,0-.09,0-.13a1.08,1.08,0,0,1,0-.18.07.07,0,0,1,.09.05C708.14,491.53,708.21,491.62,708.18,491.71Z"
            />
            <path
              class="cls-109"
              d="M707,491h.09c0,.07,0,.13,0,.2s-.09,0-.09-.08Z"
            />
            <path
              class="cls-119"
              d="M705.83,491.51v.06a3.69,3.69,0,0,0-.83.11h0v-.16l.55,0s.05.06.1,0h.08Z"
            />
            <path
              class="cls-111"
              d="M715.45,490.51h.06c.15,0,.21,0,.19-.08s.1-.09.29-.07a.7.7,0,0,0-.06.4c0,.53-.06,1.07,0,1.6a.57.57,0,0,1-.26,0v0c0-.05.07-.11-.07-.14s0,0,0,0h-.07c0-.06.07-.06.13-.06s0-.07,0-.11-.07-.15,0-.22a.17.17,0,0,0,0-.14v0a1,1,0,0,0,0-.34v-.08c.06-.09,0-.17,0-.25v-.05a.16.16,0,0,0,0-.13c.1,0,.13,0,.14-.09s-.07-.11-.16-.12A.44.44,0,0,1,715.45,490.51Z"
            />
            <path
              class="cls-118"
              d="M719.15,490.29a1.21,1.21,0,0,1-.54,0l-.17,0a.32.32,0,0,0-.28.07c0,.07,0,.1-.12.08a2.58,2.58,0,0,0-.29,0l-.23,0,.07.08h.09s0,0,0,0,0,0,0,0v0h0l.06,0,.81-.08a6.53,6.53,0,0,0,.76-.08A.92.92,0,0,0,719.15,490.29Zm-.87.09h0Zm0-.06h0Z"
            />
            <path
              class="cls-117"
              d="M716.86,491.7h0l-.38.05c-.1,0-.21,0-.2-.09s0,0,0,0,0,0,0,0,0,.15.15.18h0a.64.64,0,0,0-.24,0v-.39c.2,0,.2,0,.19-.2s0-.16,0-.24h.06v.32a.17.17,0,0,0,0,.12s0,.05,0,.08,0,.12.19.1l.27,0Z"
            />
            <path
              class="cls-118"
              d="M716.75,490.44c.06-.1.18-.1.31-.08l.18,0s.12-.05.15,0l0,0a.12.12,0,0,0,.1,0l.11,0,.11,0h0v0l-.31,0a.57.57,0,0,1-.29,0c-.06,0-.08,0-.07,0s-.13,0-.19,0h0a.07.07,0,0,0-.07,0Z"
            />
            <path
              class="cls-114"
              d="M716.31,491.32c0,.18,0,.18-.19.2a2.06,2.06,0,0,1,0-.55l.13,0A.61.61,0,0,0,716.31,491.32Z"
            />
            <path
              class="cls-111"
              d="M716.75,490.44v0s0,0,.07,0h0a.3.3,0,0,1-.16,0,.06.06,0,0,0-.06,0h.06a.63.63,0,0,1-.45,0,.06.06,0,0,1,0-.06s.07,0,.08,0,.23-.07.36-.07S716.7,490.45,716.75,490.44Zm-.4.08h0Z"
            />
            <path
              class="cls-119"
              d="M716.11,491.91a.64.64,0,0,1,.24,0l.21,0v0a1.24,1.24,0,0,1-.47.05S716.08,491.93,716.11,491.91Z"
            />
            <path class="cls-116" d="M716.28,491l-.13,0v-.15h.16l0,0V491Z" />
            <path
              class="cls-111"
              d="M716.15,490.42v0S716.12,490.44,716.15,490.42Z"
            />
            <path class="cls-111" d="M717.68,490.46v0l.06,0Z" />
            <path class="cls-119" d="M716.12,492.09h0v0Z" />
            <path
              class="cls-115"
              d="M711.64,491.15l.57-.06v.35a2.81,2.81,0,0,0,0,.29s0,.07-.12.07h0c-.4,0-.44,0-.39-.3l0-.14v-.11A.13.13,0,0,0,711.64,491.15Z"
            />
            <path
              class="cls-116"
              d="M711.67,491.36l0,.14a3.36,3.36,0,0,1-1.05,0,3.68,3.68,0,0,1,.38-.31,4.07,4.07,0,0,1,.61-.06.13.13,0,0,1,0,.1l-.45.05c-.07,0-.21,0-.17.07s.14,0,.22,0h0A.62.62,0,0,1,711.67,491.36Z"
            />
            <path
              class="cls-116"
              d="M712.21,491.44v-.15l.29,0c.2,0,.29,0,.29.16h0A2.33,2.33,0,0,0,712.21,491.44Z"
            />
            <path
              class="cls-113"
              d="M712.79,491.43c0-.13-.09-.17-.29-.16l-.29,0v-.1a2.3,2.3,0,0,0,.37,0c.14,0,.22,0,.2-.13l1.54-.16c.21,0,.21,0,.15-.14l.64.11c.19,0,.38,0,.57-.05a.16.16,0,0,1,0,.13c-.06,0,0-.07-.12,0s-.1,0-.1.07a2.72,2.72,0,0,1,0,.49v.36c0,.06-.06.15.11.17,0,0,0,0,0,0l.06.14c-.06,0-.12,0-.13.06s0,.08,0,.12-.14,0-.22,0l0-1.26c0-.08,0-.12-.14-.05s-.2.09-.32.1l-.12,0h0s0,0,0-.06,0-.11-.16-.1l-.19,0c0-.06,0-.08-.12,0a5.68,5.68,0,0,0-.76.28Zm1.73-.45c.07,0,.15,0,.19,0s0,0,0,0a.34.34,0,0,0-.2,0s-.12,0-.11.05S714.48,491,714.52,491Z"
            />
            <path
              class="cls-115"
              d="M722.83,490.6c.07,0,.09,0,.09,0v.15c.08-.07,0-.15.1-.19a1.33,1.33,0,0,1-.06.45c-.06,0,0-.09,0-.13s0-.07,0-.1-.08-.05-.06-.08A.2.2,0,0,0,722.83,490.6Z"
            />
            <path
              class="cls-115"
              d="M723.33,487.19h.12a.23.23,0,0,1,0,.18h-.07l0,0v0S723.33,487.22,723.33,487.19Z"
            />
            <path
              class="cls-115"
              d="M723,490.58c0-.08-.08-.17,0-.24A.34.34,0,0,1,723,490.58Z"
            />
            <path
              class="cls-116"
              d="M714.37,491l.19,0c.12,0,.2,0,.16.1s0,0,0,.06h0v0a.2.2,0,0,0-.05.14c0,.06.09.13,0,.18a1.16,1.16,0,0,1-.29.05v-.44A.51.51,0,0,0,714.37,491Z"
            />
            <path
              class="cls-114"
              d="M714.39,491.6a1.16,1.16,0,0,0,.29-.05c.09-.05,0-.12,0-.18a.2.2,0,0,1,.05-.14v.67c0,.13-.18.08-.27.1s-.08-.05-.08-.09S714.39,491.71,714.39,491.6Z"
            />
            <path
              class="cls-129"
              d="M705.53,491.47l-.55,0,.07-.87a.22.22,0,0,0,.12,0,.18.18,0,0,1,.18.07.63.63,0,0,0,.12.11l0,.07h0V491c0,.06,0,.11,0,.16l0,.19C705.51,491.38,705.55,491.43,705.53,491.47Z"
            />
            <path
              class="cls-111"
              d="M705.47,490.85a.63.63,0,0,1-.12-.11.18.18,0,0,0-.18-.07.22.22,0,0,1-.12,0l0-.31a1,1,0,0,0,.17,0c.07,0,.14,0,.2,0A4.36,4.36,0,0,1,705.47,490.85Z"
            />
            <path
              class="cls-115"
              d="M705.83,491.51l-.12,0a1.45,1.45,0,0,1,0-.29s-.07-.08,0-.12.08,0,.08,0,.06,0,.09,0a3.28,3.28,0,0,0,0,.43Z"
            />
            <path
              class="cls-110"
              d="M705.68,491.06c-.08,0,0,.08,0,.12a1.45,1.45,0,0,0,0,.29h-.08c-.07,0,0-.1-.07-.15l0-.19a.11.11,0,0,0,0-.16v-.06C705.63,490.94,705.62,491,705.68,491.06Z"
            />
            <path
              class="cls-117"
              d="M705.89,491.46a3.28,3.28,0,0,1,0-.43A.47.47,0,0,1,705.89,491.46Z"
            />
            <path
              class="cls-120"
              d="M705.44,490.34c-.06,0-.13,0-.2,0s0-.05,0-.09a.53.53,0,0,1,.28.1Z"
            />
            <path
              class="cls-109"
              d="M706.73,490.2a2.28,2.28,0,0,0-.6-.13,4.94,4.94,0,0,1-.86,0s0,0,.08.05l.57.17s0,0-.06-.08c.12-.06.28,0,.41-.05H706l.44,0s-.11,0-.13,0h.23c-.18,0-.34.06-.52.08a1.16,1.16,0,0,1,0,.37s0,.08.06.09a.27.27,0,0,0,.2,0c.05,0,0-.06,0-.09a.17.17,0,0,1-.05-.13s0-.07.1-.06l.07-.05h0l.16,0H707A.73.73,0,0,0,706.73,490.2Zm-1.1,0h0Zm.12,0h0Zm0-.05a.33.33,0,0,1,.22,0Zm.32,0h0Z"
            />
            <path
              class="cls-110"
              d="M706.07,489.85l-.81,0h-.13a.05.05,0,0,1,0,0l0,.4a1,1,0,0,0,.17,0s0-.06,0-.09-.11-.14,0-.15a4.94,4.94,0,0,0,.86,0C706.14,490,706.17,489.92,706.07,489.85Z"
            />
            <path
              class="cls-118"
              d="M706.27,490.42l.07-.05a3.78,3.78,0,0,0,.67-.05h0a1.78,1.78,0,0,1,.52.11c-.16.07-.35,0-.52.06a.77.77,0,0,0-.45,0C706.46,490.47,706.34,490.5,706.27,490.42Z"
            />
            <path
              class="cls-113"
              d="M706.27,490.18h.23c-.18,0-.34.06-.52.08s0,0-.06.05,0,0-.06-.08c.12-.06.28,0,.41-.05Z"
            />
            <path
              class="cls-119"
              d="M706.77,490.67a5.85,5.85,0,0,1,0,.59.17.17,0,0,0,.13.15c0,.06-.09.09-.16.12s0-.12-.06-.18a4,4,0,0,1,0-.6S706.67,490.67,706.77,490.67Z"
            />
            <path class="cls-117" d="M719.29,490.76l.26,0-.09,1.17-.27,0Z" />
            <path
              class="cls-114"
              d="M716.86,491.7l0,0a2,2,0,0,0-.45-.15.17.17,0,0,1,0-.12,2.12,2.12,0,0,0,.44,0l.27,0c0,.06-.12,0-.14.08s0,.13,0,.19Z"
            />
            <path
              class="cls-119"
              d="M717.45,491.75l.27-.05.46,0c.07,0,.11,0,.17,0h0a.13.13,0,0,1-.09,0l-.7.09a.17.17,0,0,1-.12,0Z"
            />
            <path
              class="cls-118"
              d="M718.35,491.69c-.06,0-.1-.05-.17,0l0,0c.15,0,.24,0,.28.08h-.09Z"
            />
            <path class="cls-113" d="M718.35,491.69h0Z" />
            <path
              class="cls-120"
              d="M716.57,491.93v0c0-.07-.08-.07-.14-.08s-.08,0-.08,0c-.16,0-.16-.1-.15-.18s0,0,0,0,0,0,0,0,.1.09.2.09a.31.31,0,0,0,.13,0c.14,0,.17,0,.1.12S716.62,492,716.57,491.93Z"
            />
            <path
              class="cls-119"
              d="M716.56,492.11s0,0,0,0-.06,0-.06,0,0,0,0,0S716.56,492.09,716.56,492.11Z"
            />
            <path
              class="cls-120"
              d="M715.51,492.34s0-.08,0-.12h.09c.14,0,0,.09.07.14A.27.27,0,0,1,715.51,492.34Z"
            />
            <path
              class="cls-133"
              d="M713.62,490.07a1.06,1.06,0,0,0,.39.11,1.08,1.08,0,0,1,.31.07,5.14,5.14,0,0,1-.55.06l-1.91.15-2.14.17-1.5-.38a2.09,2.09,0,0,1-.52-.14c.15,0,.31,0,.47,0s.12,0,.11-.07c.48,0,1-.06,1.43-.09l2.25-.14,1.35.22A1.77,1.77,0,0,1,713.62,490.07Z"
            />
            <path
              class="cls-117"
              d="M718,489c0-.09,0-.18,0-.28s0-.06,0-.06h-.25s-.05,0-.07,0,0,0,0,0a2,2,0,0,1-.69.06h-.11c0,.05-.06.06-.13.06s-.09,0-.09-.06h0c0,.06-.1.07-.17.07H716c-.09,0-.06,0-.08-.06l0,0c0,.08-.13,0-.2.05v0h.09s.09,0,.09.05,0,.05-.09.05l-.12,0v0c.21,0,.21,0,.21.12v.24c0,.13,0,.13-.21.13v.06s.16-.05.16,0v.07s0,0,0,0-.1,0-.11.06,0,.08.08.07l1.63-.11a4.07,4.07,0,0,0,.6-.06C718,489.37,718,489.16,718,489Zm-2-.18.5,0s.06,0,.06,0,0,.05-.06.06a.78.78,0,0,1-.22,0H716s-.07,0-.08,0S715.93,488.78,716,488.77Zm0,.85c-.05,0-.05,0-.05-.05v-.08l0,0,0,0,0-.42c0-.05,0-.07.11-.07a1.15,1.15,0,0,1,.45,0c.14,0,0,.17,0,.25a.74.74,0,0,1,0,.21s0,.06,0,.07-.08.09,0,.12A3.94,3.94,0,0,1,715.94,489.62Zm.74-.88c.06,0,.1,0,.1.05s0,0-.09,0-.1,0-.1,0S716.63,488.74,716.68,488.74Zm.05.88c0-.05-.14,0-.17-.09v-.08s.07,0,.13-.06c-.1,0-.12-.05-.11-.11a1.61,1.61,0,0,0,0-.31c0-.05,0-.09.1-.09s.09,0,.09.08A2.48,2.48,0,0,1,716.73,489.62Zm.19-.89a3.64,3.64,0,0,1,.66,0s0,0,0,0,.17,0,.25,0,0,0,0,0,0,0-.09,0l-.76,0h-.14c-.05,0-.09,0-.09,0S716.85,488.72,716.92,488.73Zm.6.75c0,.07,0,.1-.16.1s-.28,0-.41,0-.14,0-.14-.08a.17.17,0,0,0,0-.1,2.58,2.58,0,0,0,0-.48c0-.07.07-.08.15-.09s.32,0,.48,0,.12,0,.1.07S717.57,489.29,717.52,489.48Zm.31.06a.34.34,0,0,1-.2,0c-.07,0,0-.06,0-.09v-.07a2.05,2.05,0,0,0,0-.49c0-.1.12-.08.22-.09s.1.05.1.09l0,.53A.09.09,0,0,1,717.83,489.54Z"
            />
            <path
              class="cls-117"
              d="M718.09,487v-.12H718s0,.07-.09.07-.19,0-.23-.08c-.07.11-.2.08-.31.08l-.35,0c-.09,0-.12,0-.12-.07h0s0,.07-.1.07-.1,0-.1-.06h-.06c0,.05,0,.06-.12.06h-.44c-.1,0-.12,0-.12-.07s-.05,0-.11.07,0-.1-.13-.1V487l.08,0s.1,0,.1,0,0,0-.1,0h-.08v0c.15,0,.2,0,.2.11s0,.37,0,.55-.05.12-.19.1.08,0,.13,0c.25,0,.5,0,.75,0h.93l.55,0ZM716,487h.49c.05,0,.09,0,.09,0s0,0-.08,0H716s-.09,0-.09,0S716,487,716,487Zm-.09.76,0,0h0Zm.6.1c-.12,0-.26,0-.37,0s0-.06,0-.09a.08.08,0,0,0-.08-.06c-.17,0-.15-.07-.14-.13a1,1,0,0,0,0-.35c0-.05,0-.07.12-.07h.44c.08,0,.12,0,.12.07l0,.62S716.58,487.83,716.54,487.84ZM717,487h.57s.07,0,.07,0,0,0-.07,0H717s-.08,0-.08,0S717,487,717,487Zm-.24,0s.08,0,.09,0,0,0-.09,0-.09,0-.09,0S716.73,487,716.78,487Zm0,.71a.29.29,0,0,1,0,.09s0,.05,0,.06-.07,0-.07,0v-.28a2.36,2.36,0,0,1,0-.35s0-.06.09-.06.08,0,.09.06-.05.33,0,.49S716.73,487.63,716.75,487.69Zm.88,0c0,.07-.06.12-.2.1l-.19,0c-.08,0-.17,0-.18-.08s-.08,0-.12.07.1-.09.09-.14-.13-.15-.12-.24v-.26c0-.06,0-.07.13-.07h.56c.06,0,.08,0,.07,0A3.64,3.64,0,0,0,717.63,487.72Zm.1-.69s0,0,.06,0H718c-.06.07-.17,0-.26,0S717.72,487,717.73,487Zm0,.79s0,0,0-.05a3.81,3.81,0,0,0,0-.59c0-.07.08-.06.15-.06s.16,0,.16.06v.1a2.08,2.08,0,0,0,0,.44C718,487.8,717.82,487.86,717.7,487.82Z"
            />
            <path
              class="cls-115"
              d="M719.31,489.87c-.1,0-.13,0-.13-.05a3.41,3.41,0,0,1,.05-.55,1.12,1.12,0,0,1,0-.36h0a1,1,0,0,1,.29,0v0l-.19,0c-.09,0-.07-.06-.07-.1s.07,0,.11,0h.17v0h0c-.1,0-.28,0-.26-.12h-.12s.07.09-.06.09-.28,0-.29-.11h-.1c0,.46-.08.92-.09,1.37l.71.1c.07,0,.12,0,.12-.06A.3.3,0,0,1,719.31,489.87Zm-.46-1.21a1.18,1.18,0,0,1,.27,0c.08,0,.1,0,.09.07s-.07.05-.12.05S718.83,488.78,718.85,488.66Zm.15,1.21c-.27,0-.28,0-.26-.2s0-.5.06-.75l0,0c.08-.09.19,0,.29,0s.06.05.06.08,0,.07,0,.11v.26a.06.06,0,0,1,0,.06c0,.14,0,.28,0,.43S719.1,489.88,719,489.87Z"
            />
            <path
              class="cls-109"
              d="M715.69,490.8c-.19,0-.38.05-.57.05,0-.11,0-.18-.21-.22s-.2,0-.24-.07a3.38,3.38,0,0,1,.78-.05.44.44,0,0,0,.22.08c.09,0,.16.05.16.12S715.79,490.8,715.69,490.8Z"
            />
            <path
              class="cls-115"
              d="M719.71,487.05h-.2s-.1,0-.1,0,0-.06.1-.06h.21v0h-.16c-.1,0-.14,0-.13-.08h-.06c0,.05,0,.08-.13.08s-.27,0-.32-.08h0c0,.05,0,.09,0,.14,0,.37-.05.73-.08,1.09l.1,0c.25,0,.5,0,.74,0h0v0h0a.2.2,0,0,1-.11,0c-.14,0-.2,0-.16-.11s0-.16,0-.24v0h-.07l0,0V488c0,.12-.16.08-.27.09s-.15,0-.14-.1v-.27s0-.06,0-.08v0a.09.09,0,0,1,0-.15.67.67,0,0,0,0-.28s0-.08.11-.07a.61.61,0,0,1,.33,0h0c.08-.08.21,0,.31,0h0v0Zm-.49,0H719c-.06,0-.11,0-.11-.05s.05-.05.1-.05h.2s.11,0,.11.05S719.28,487.06,719.22,487.06Z"
            />
            <path
              class="cls-115"
              d="M718,489.58c0-.21,0-.42,0-.63s0-.18,0-.28,0-.08-.13,0-.18-.07-.3-.07c.09-.06.22,0,.33,0a1.46,1.46,0,0,0,.21,0v.7a2.83,2.83,0,0,1,0,.29Q718.09,489.6,718,489.58Z"
            />
            <path
              class="cls-120"
              d="M716.68,486.88h-.06a1.56,1.56,0,0,0-.68,0c-.06,0-.05,0-.11.07s0-.1-.13-.1,0-.07.09-.07l1.92,0h.44c.05,0,.09,0,.08,0a.47.47,0,0,0-.14,0H718a1,1,0,0,0-.43,0,2.51,2.51,0,0,0-.67,0h0C716.81,486.85,716.74,486.82,716.68,486.88Z"
            />
            <path
              class="cls-116"
              d="M715.69,487.1c.15,0,.2,0,.2.11s0,.37,0,.55-.05.12-.19.1C715.65,487.61,715.69,487.35,715.69,487.1Z"
            />
            <path
              class="cls-115"
              d="M718.09,486.88a.47.47,0,0,1,.14,0c0,.32,0,.64-.05,1,0,.07-.08.06-.15.05l.06-.85Z"
            />
            <path
              class="cls-111"
              d="M714.67,490.56c0,.07.16.06.24.07s.25.11.21.22l-.64-.11C714.42,490.59,714.45,490.57,714.67,490.56Z"
            />
            <path
              class="cls-116"
              d="M715.64,488.92c.21,0,.21,0,.21.12v.24c0,.13,0,.13-.21.13A2.67,2.67,0,0,1,715.64,488.92Z"
            />
            <path
              class="cls-116"
              d="M717.57,488.56c.12,0,.24,0,.3.07a.42.42,0,0,1-.16,0h-.07s0,0,0,0a2,2,0,0,1-.69.06c-.06,0-.07,0-.08-.05a.12.12,0,0,1,.13,0l.42,0Z"
            />
            <path
              class="cls-116"
              d="M712.79,491c0,.09-.06.12-.2.13a2.3,2.3,0,0,1-.37,0v-.1A5.67,5.67,0,0,1,712.79,491Z"
            />
            <path
              class="cls-119"
              d="M717.39,488.56l-.42,0a.12.12,0,0,0-.13,0h0c-.08,0-.15-.06-.22,0h0a1.49,1.49,0,0,0-.63,0l0,0,0,0a.16.16,0,0,0-.2-.05s0,0,.07,0l1.59-.06Z"
            />
            <path
              class="cls-113"
              d="M718.86,488.51h-.1a.06.06,0,0,1,0-.07l.75,0c.06,0,.11,0,.1,0h-.09c-.06,0-.12,0-.17,0l-.12,0A1,1,0,0,0,718.86,488.51Z"
            />
            <path
              class="cls-111"
              d="M718.16,490.3c0,.07,0,.1-.12.08a2.58,2.58,0,0,0-.29,0s0-.07.08-.08A1.16,1.16,0,0,1,718.16,490.3Z"
            />
            <path
              class="cls-113"
              d="M718.92,486.86h0a.08.08,0,0,1,0-.08h.86v0h0c-.1,0-.22,0-.29.06h-.06A.63.63,0,0,0,718.92,486.86Z"
            />
            <path
              class="cls-116"
              d="M715.67,488.78h.09s.09,0,.09.05,0,.05-.09.05l-.12,0S715.65,488.82,715.67,488.78Z"
            />
            <path
              class="cls-111"
              d="M717.39,490.4c0-.06-.1,0-.15,0s0-.07.13-.07h.15l.07.08h0l-.11,0Z"
            />
            <path
              class="cls-116"
              d="M715.63,489.47s.16-.05.16,0-.11,0-.12,0,.07,0,.12,0,0,0,0,0-.1,0-.11.06S715.65,489.54,715.63,489.47Z"
            />
            <path
              class="cls-116"
              d="M715.66,488.64a.16.16,0,0,1,.2.05c0,.08-.13,0-.2.05Z"
            />
            <path
              class="cls-116"
              d="M715.69,487l.08,0s.1,0,.1,0,0,0-.1,0h-.08Z"
            />
            <path
              class="cls-116"
              d="M711.1,489.23v.47s0,.06-.08.06h-.16c-.21,0-.21,0-.21-.12h0c.06,0,.05.05.1,0s0-.16-.1-.16,0-.12,0-.18a2.42,2.42,0,0,1,0-.47s0-.06.1-.06h.36Zm-.31.27a.35.35,0,0,0,.23,0A.37.37,0,0,0,710.79,489.5Z"
            />
            <path
              class="cls-116"
              d="M710.58,487.63v-.41h.3c.06,0,.11,0,.11,0l0,.57a.05.05,0,0,1-.06.06c-.12,0-.26,0-.35,0s0-.12,0-.18h.07S710.61,487.64,710.58,487.63Zm.3,0a.29.29,0,0,0-.16,0A.16.16,0,0,0,710.88,487.62Z"
            />
            <path
              class="cls-117"
              d="M710.61,487.85c.09.08.23,0,.35,0a.05.05,0,0,0,.06-.06l0-.57s0,0-.11,0h-.3v0h.33s.07,0,.07,0,0,0-.07,0h-.33s0,0,0,0h.31s.08,0,.09,0-.05,0-.08,0h-.33a1.47,1.47,0,0,1,.47,0,4.26,4.26,0,0,1,0,.5v.36s0,.06,0,.06a2.29,2.29,0,0,1-.37,0C710.56,487.93,710.6,487.89,710.61,487.85Z"
            />
            <path
              class="cls-116"
              d="M710.57,487h.33s.08,0,.08,0-.05,0-.09,0h-.31Z"
            />
            <path
              class="cls-116"
              d="M710.58,487.12h.33s.07,0,.07,0,0,0-.07,0h-.33Z"
            />
            <path
              class="cls-111"
              d="M711.06,487.51a4.26,4.26,0,0,0,0-.5h0A1.61,1.61,0,0,1,711.06,487.51Z"
            />
            <path
              class="cls-111"
              d="M711.1,489.23l0-.42s0,0,0,.07A1,1,0,0,1,711.1,489.23Z"
            />
            <path
              class="cls-115"
              d="M710.65,489.35c.05.06,0,.12,0,.18v.12h0Z"
            />
            <path class="cls-114" d="M710.58,487.63s.07,0,.07,0h-.07Z" />
            <path
              class="cls-111"
              d="M711.1,489.39v-.11A.08.08,0,0,1,711.1,489.39Z"
            />
            <path
              class="cls-111"
              d="M711.1,489.7v-.09A.06.06,0,0,1,711.1,489.7Z"
            />
            <path class="cls-111" d="M711.1,489.57v0A0,0,0,0,1,711.1,489.57Z" />
            <path
              class="cls-114"
              d="M712.3,487.06s0-.11.11-.11.12,0,.12.07c0,.27,0,.54,0,.81,0,.09,0,.14-.18.12h-.08v0s0,0,0,0v-.59a.06.06,0,0,0,0-.06Z"
            />
            <path
              class="cls-114"
              d="M712.3,488.88s0-.08.1-.07.16,0,.16.08c0,.27,0,.54,0,.81,0,0,0,.09-.09.06s-.09-.11-.1-.18a4.43,4.43,0,0,1,0-.63A.07.07,0,0,0,712.3,488.88Z"
            />
            <path
              class="cls-109"
              d="M712.3,487.06v.88c-.08,0-.09,0-.09-.07V487Z"
            />
            <path
              class="cls-116"
              d="M712.3,488.88a.07.07,0,0,1,0,.07,4.43,4.43,0,0,0,0,.63c0,.07,0,.13.1.18-.09,0-.17,0-.17-.07C712.3,489.42,712.28,489.15,712.3,488.88Z"
            />
            <path class="cls-117" d="M713.91,488.32a.42.42,0,0,1,0,.31Z" />
            <path
              class="cls-110"
              d="M705.91,488c-.21,0-.42,0-.63,0h0l0,.5H706A1.3,1.3,0,0,0,705.91,488Z"
            />
            <path
              class="cls-110"
              d="M705.69,486.85h-.34l0-.44h.4a1.72,1.72,0,0,1,0,.39C705.82,486.88,705.74,486.85,705.69,486.85Z"
            />
            <path
              class="cls-117"
              d="M705.66,486.91q.09,0,.09.06s0,.06-.09.06h-.29a.08.08,0,0,0,0,0,1.61,1.61,0,0,0,.31,0s.07,0,.07,0,0,.05-.06.05h-.31l0,0h.33c.07,0,.08,0,.09.06a1.34,1.34,0,0,1,0,.4v-.2c-.13.07-.16.17-.26.25v.09h0v0s.06.09,0,.1l-.06,0h-.15l0,0c.21,0,.42,0,.63,0,0-.35-.09-.69-.07-1,0-.07-.07-.08-.16-.08h-.33v0h.32Z"
            />
            <path
              class="cls-117"
              d="M706,489.25a3,3,0,0,0-.42,0l0,.08s.05.05,0,.05-.19.05-.26,0v-.09l-.07,0c0,.15,0,.31,0,.46s0,.07-.06.07l-.14,0,0,0h.12l.81,0Zm-.42.58c-.07,0-.15,0-.17-.05a.2.2,0,0,1,0-.11h0s0-.05,0-.07,0-.06.11-.06.11,0,.11.06a.32.32,0,0,0,0,.14S705.7,489.82,705.62,489.83Z"
            />
            <path
              class="cls-117"
              d="M706,488.51h-.76v.05h0s0,0,0,0a.06.06,0,0,1,0,.06v.05h0a.07.07,0,0,1,.06,0l.48,0c.06,0,.16,0,.17,0s-.1,0-.15,0h-.56s0,0,0,.07a.1.1,0,0,1,.09.11c0,.11,0,.21,0,.31h.1l0-.36c0-.07,0-.1.13-.1h.36c.07,0,.08,0,.08.06a1.34,1.34,0,0,0,0,.35h0C706,489,706,488.74,706,488.51Zm-.15.14-.32,0h-.12s0,0-.06-.05,0,0,.06,0,.29,0,.44,0,.1,0,.1.05S705.86,488.65,705.81,488.65Z"
            />
            <path
              class="cls-114"
              d="M706.7,487.23a.28.28,0,0,1,.22,0c0,.21,0,.41,0,.61l-.2,0c0-.11,0-.23,0-.34A.51.51,0,0,0,706.7,487.23Z"
            />
            <path
              class="cls-114"
              d="M706.61,487.79a.45.45,0,0,1-.2,0,3.43,3.43,0,0,0-.06-.56.28.28,0,0,1,.22,0s0,.1,0,.15A1.51,1.51,0,0,1,706.61,487.79Z"
            />
            <path
              class="cls-114"
              d="M706.09,487a.12.12,0,0,1,.09,0c.22,0,.45,0,.68,0,.07,0,.13,0,.13.07s0,.06-.12.06h-.71Z"
            />
            <path
              class="cls-117"
              d="M706.61,487.79a1.51,1.51,0,0,0-.05-.42c0-.05,0-.1,0-.15s.08,0,.13,0a.51.51,0,0,1,0,.24c0,.11,0,.23,0,.34C706.72,487.77,706.66,487.8,706.61,487.79Z"
            />
            <path
              class="cls-110"
              d="M706.58,489.22v0l.11,0s.11,0,.15,0,.12-.08.23-.06.06.06.13.06.13,0,.13.05-.06,0-.11.05a.29.29,0,0,0-.17,0h0l0,0h-.12a.22.22,0,0,0-.14,0Z"
            />
            <path
              class="cls-114"
              d="M706.25,488.64a5.43,5.43,0,0,1,.81.09c.06,0,.07,0,.06.06s-.06,0-.09,0a2.34,2.34,0,0,1-.59-.09h-.16Z"
            />
            <path
              class="cls-114"
              d="M707,489.25h0c0,.11,0,.22,0,.32s-.16,0-.19-.06a.88.88,0,0,1,0-.28H707Z"
            />
            <path
              class="cls-110"
              d="M706.09,487l.07.09v.15c0,.19.05.38,0,.57-.05,0-.06,0-.07-.05l-.06-.73Z"
            />
            <path
              class="cls-114"
              d="M706.69,489.15l-.11,0h-.06c-.06-.1,0-.21-.07-.31a.33.33,0,0,1,.23,0Z"
            />
            <path
              class="cls-114"
              d="M706.58,489.22l.13,0v.27a1,1,0,0,0-.18,0l0-.24Z"
            />
            <path
              class="cls-117"
              d="M706.2,487.79c0-.19-.06-.38,0-.57h.05c.06.19,0,.38.07.56A.07.07,0,0,1,706.2,487.79Z"
            />
            <path
              class="cls-117"
              d="M706.71,489.51v-.27a.22.22,0,0,1,.14,0,.88.88,0,0,0,0,.28C706.81,489.51,706.76,489.55,706.71,489.51Z"
            />
            <path
              class="cls-114"
              d="M706.29,487.79c0-.18,0-.37-.07-.56a.06.06,0,0,1,.08,0c0,.19,0,.37.05.56Z"
            />
            <path
              class="cls-114"
              d="M707.07,489.06c-.11,0-.11.1-.23.06s0-.13,0-.19a.59.59,0,0,1,.33.11S707.09,489.06,707.07,489.06Z"
            />
            <path
              class="cls-117"
              d="M706.35,487.79c0-.19,0-.37-.05-.56h.05a3.43,3.43,0,0,1,.06.56Z"
            />
            <path
              class="cls-117"
              d="M706.8,488.93c.06.06,0,.13,0,.19s-.1,0-.15,0v-.24Z"
            />
            <path
              class="cls-117"
              d="M707,487.83c0-.2,0-.4,0-.61a.09.09,0,0,1,.07.1,2.27,2.27,0,0,0,0,.45S707.07,487.84,707,487.83Z"
            />
            <path
              class="cls-110"
              d="M706.25,488.64l0,.07,0,.16c0,.1,0,.21,0,.31,0-.15,0-.29,0-.44S706.22,488.67,706.25,488.64Z"
            />
            <path
              class="cls-117"
              d="M706.27,489.18c.06-.1,0-.21,0-.31h0s0,.07,0,.11,0,.13,0,.19a.18.18,0,0,1-.13,0Z"
            />
            <path
              class="cls-114"
              d="M706.4,489.17c-.07-.06,0-.13,0-.19s0-.08,0-.11.06,0,.09,0l0,.29Z"
            />
            <path
              class="cls-117"
              d="M707.06,489.57c0-.1,0-.21,0-.32h0l.05,0,0,.29Z"
            />
            <path
              class="cls-117"
              d="M706.44,489.16l0-.29h0c.07.1,0,.21.07.31S706.45,489.21,706.44,489.16Z"
            />
            <path
              class="cls-114"
              d="M707.12,489.57l0-.29h0a.61.61,0,0,1,0,.3h0Z"
            />
            <path
              class="cls-121"
              d="M706.26,489.24c.07,0,.08,0,.07.06s0,.11,0,.16,0-.15,0-.22Z"
            />
            <path
              class="cls-117"
              d="M706.51,489.23l0,.24s-.07,0-.06-.05,0-.07,0-.11S706.37,489.22,706.51,489.23Z"
            />
            <path
              class="cls-114"
              d="M706.89,487.14a.08.08,0,0,1-.09,0s-.09,0-.08,0,0,0,.08,0S706.87,487.11,706.89,487.14Z"
            />
            <path
              class="cls-114"
              d="M706.53,487.14s0,0-.09,0-.08,0-.06,0,.06,0,.09,0S706.54,487.11,706.53,487.14Z"
            />
            <path
              class="cls-116"
              d="M705.4,489.26c0-.12,0-.24,0-.36s0-.1.14-.1h.36c.07,0,.08,0,.08.06a1.34,1.34,0,0,0,0,.35A5.51,5.51,0,0,1,705.4,489.26Z"
            />
            <path
              class="cls-116"
              d="M705.29,489a.1.1,0,0,0-.09-.11c0,.11,0,.23,0,.35s0,.07,0,.11h0l0,0,.08,0C705.3,489.16,705.29,489.06,705.29,489Z"
            />
            <path
              class="cls-116"
              d="M705.37,489.78c0-.15,0-.31,0-.46h-.09s0,.06,0,.07h-.06a.76.76,0,0,0,0,.15h.05c.08,0,.11,0,.11.07v.23C705.41,489.85,705.37,489.8,705.37,489.78Z"
            />
            <path class="cls-121" d="M705.4,489.39v-.09h.22l0,.08Z" />
            <path class="cls-114" d="M705.18,489.3l0,0Z" />
            <path
              class="cls-116"
              d="M722.81,489.07a4.19,4.19,0,0,0,0,.5s0,.05-.08.06l-.28,0s-.07,0-.06,0a2.83,2.83,0,0,0,0-.5s0-.08.09-.08a1,1,0,0,1,.3,0A0,0,0,0,1,722.81,489.07Z"
            />
            <path
              class="cls-114"
              d="M722,489.56c-.1,0,0,.07-.08.12s0-.11-.11-.1,0,0,0-.05a2.71,2.71,0,0,1,0-.4c0-.09.15-.07.25-.08C722.07,489.22,722,489.39,722,489.56Z"
            />
            <path
              class="cls-116"
              d="M723.12,489.11a1.93,1.93,0,0,0-.06.42c0,.07-.09.07-.17.07s0-.05,0-.08,0-.28,0-.42,0-.08.05-.1a.19.19,0,0,1,.13,0C723.14,489,723.1,489.07,723.12,489.11Z"
            />
            <path
              class="cls-116"
              d="M722,489.56c0-.17.08-.34.07-.51.08,0,.14,0,.13.07a2.49,2.49,0,0,0,0,.47s0,.05,0,.05,0,0-.05,0Z"
            />
            <path
              class="cls-116"
              d="M722.19,489.63c0-.19,0-.36.06-.52s0-.08.09-.07,0,0,0,.07a1.9,1.9,0,0,0,0,.41.17.17,0,0,1,0,.1.07.07,0,0,1-.08.05S722.19,489.63,722.19,489.63Z"
            />
            <path
              class="cls-116"
              d="M722.6,488.9c-.06,0-.15,0-.15,0s.08,0,.13-.05h.19s.08,0,.09,0,0,.05-.07.05Z"
            />
            <path
              class="cls-116"
              d="M721.84,488.85a.13.13,0,0,0,.09,0h.22c.06,0,.09,0,0,.05a.73.73,0,0,1-.33,0S721.83,488.88,721.84,488.85Z"
            />
            <path
              class="cls-116"
              d="M722,489c.06,0,.17,0,.18,0s-.11,0-.17,0-.19,0-.2,0S722,489,722,489Z"
            />
            <path
              class="cls-116"
              d="M722.59,489c-.05,0-.13,0-.13,0s.07,0,.12,0l.19,0s.07,0,.07,0,0,0-.06,0Z"
            />
            <path
              class="cls-116"
              d="M723.14,488.93a.3.3,0,0,1-.2,0,0,0,0,0,1,0,0A.35.35,0,0,1,723.14,488.93Z"
            />
            <path class="cls-114" d="M721.76,489.68v0h0v0Z" />
            <path
              class="cls-116"
              d="M722.18,491.06a1,1,0,0,0,0-.34c0-.05,0-.06.12-.07l.3,0v.17a.46.46,0,0,1,0,.2s0,.1-.05.11a1.19,1.19,0,0,1-.33,0C722.15,491.15,722.21,491.09,722.18,491.06Z"
            />
            <path
              class="cls-116"
              d="M722.83,490.6a.2.2,0,0,1,0,.15s0,.06.06.08V491c-.12,0-.09.07-.09.11s-.14,0-.13-.07l0-.35C722.71,490.61,722.76,490.6,722.83,490.6Z"
            />
            <path
              class="cls-114"
              d="M721.68,491.18c0-.12,0-.23,0-.35a.16.16,0,0,0,0-.1.41.41,0,0,1,.16,0,1.16,1.16,0,0,0,0,.32v0c-.06,0,0,.13-.16.12Z"
            />
            <path
              class="cls-116"
              d="M722.6,490.5c.08.06.14,0,.22,0s.11,0,.12,0,0,.05-.09.05a3.93,3.93,0,0,0-.48.06s-.09,0-.11,0,0,0,.08-.06Z"
            />
            <path
              class="cls-116"
              d="M722.09,491.17a1.09,1.09,0,0,1,0-.44s0-.05.07-.05.06,0,0,0S722.2,491,722.09,491.17Z"
            />
            <path
              class="cls-116"
              d="M721.75,490.67s-.08,0-.09,0,0,0,.05,0a1.16,1.16,0,0,1,.42,0s.06,0,0,0l0,0Z"
            />
            <path
              class="cls-116"
              d="M721.84,491a1.16,1.16,0,0,1,0-.32l.1,0a1.23,1.23,0,0,1,0,.33Z"
            />
            <path
              class="cls-115"
              d="M721.94,491a1.23,1.23,0,0,0,0-.33s.06,0,0,0,0,.3-.06.44l0,0V491Z"
            />
            <path
              class="cls-116"
              d="M721.93,491.16v0c-.08,0-.18.07-.25,0,.15,0,.1-.08.16-.12S721.88,491.14,721.93,491.16Z"
            />
            <path
              class="cls-115"
              d="M722.8,491.08s0-.1.09-.11S722.92,491.07,722.8,491.08Z"
            />
            <path
              class="cls-116"
              d="M722.57,487.79c0-.06,0-.16,0-.26s0-.06.09-.07c.33,0,.4,0,.34.22a1,1,0,0,0,0,.24c0,.05,0,.08-.13.07h0C722.56,488,722.56,488,722.57,487.79Z"
            />
            <path
              class="cls-116"
              d="M722.21,487.47s0,.12-.07.12,0-.08,0-.12-.12,0-.13.09l0,.36s0,.08.07.09.19,0,.22-.05a.27.27,0,0,1,0-.26c0,.05,0,.11,0,.16s0,.06,0,.09,0,0,.05,0,0,0,0,0a2.19,2.19,0,0,1,0-.36C722.41,487.46,722.41,487.46,722.21,487.47Zm-.21.25s0,0,.07,0,0,0,0,0,0,0-.05,0S722,487.74,722,487.72Zm.09.19s-.06,0-.05,0,0-.05.06-.05,0,0,0,0S722.14,487.91,722.09,487.91Z"
            />
            <path
              class="cls-116"
              d="M723.33,487.57a2.72,2.72,0,0,0,0,.3c0,.07,0,.14-.17.12s-.07-.09-.07-.13a1.12,1.12,0,0,0,.05-.31c0-.06,0-.09.14-.09S723.33,487.51,723.33,487.57Z"
            />
            <path
              class="cls-116"
              d="M723.33,487.33l0,0c0,.08-.13.07-.22.06a3,3,0,0,0-.42,0c-.05,0-.11,0-.11,0s0-.06.1-.06Z"
            />
            <path
              class="cls-116"
              d="M722.31,487.19h.21s.07,0,.07,0,0,0,0,0a.1.1,0,0,1-.09,0s0,0,0,0-.23,0-.35,0-.07,0-.07,0,.05,0,.09,0Z"
            />
            <path
              class="cls-116"
              d="M722.45,488a1.77,1.77,0,0,1,0-.46s0-.06.07-.06,0,0,0,.07a1.69,1.69,0,0,1,0,.38S722.51,488,722.45,488Z"
            />
            <path
              class="cls-116"
              d="M722.85,487.29c-.07,0-.21,0-.21-.05s.14-.05.21-.05.22,0,.22.05S722.92,487.27,722.85,487.29Z"
            />
            <path
              class="cls-116"
              d="M722.23,487.43h-.13c-.05,0-.1,0-.1-.05s0,0,.1-.05h.22s.11,0,.11.05,0,.05-.11,0h-.09Z"
            />
            <path
              class="cls-116"
              d="M723.33,487.19s.06.06,0,.1h-.16c-.07,0-.07-.07,0-.09a0,0,0,0,0,.06,0Z"
            />
            <path
              class="cls-114"
              d="M722.21,487.47s0,.12-.07.12,0-.08,0-.12Z"
            />
            <path
              class="cls-114"
              d="M722.22,488c-.07-.09,0-.18,0-.26s0,.11,0,.16A.13.13,0,0,1,722.22,488Z"
            />
            <path
              class="cls-116"
              d="M722.56,487.38s0,0,0,0,0,0,0,0,0,0,0,0S722.56,487.36,722.56,487.38Z"
            />
            <path class="cls-115" d="M723.27,487.19a0,0,0,0,1-.06,0Z" />
            <path
              class="cls-117"
              d="M721.42,491.2a.09.09,0,0,1,0-.13A.09.09,0,0,1,721.42,491.2Z"
            />
            <path
              class="cls-116"
              d="M719.71,489.76c0-.24,0-.51,0-.79,0-.06,0-.09.15-.09l.36,0c.09,0,.12,0,.11.07,0,.27-.06.54-.07.82,0,.09-.07.12-.21.12h-.22C719.74,489.91,719.67,489.89,719.71,489.76Z"
            />
            <path
              class="cls-114"
              d="M719.5,489.91a.3.3,0,0,1-.19,0c0-.08,0-.16,0-.24s.09-.21-.05-.3c.07-.05.13-.11,0-.17s0,0,0,0,0-.05,0-.06,0-.11-.09-.16h0v0a.93.93,0,0,1,.29,0l0,0c-.06.34-.05.68-.09,1Z"
            />
            <path
              class="cls-116"
              d="M719.5,489.91c0-.33,0-.67.09-1,.07,0,.1,0,.1,0,0,.21,0,.42-.05.62a2.72,2.72,0,0,0,0,.28C719.63,489.89,719.6,489.92,719.5,489.91Z"
            />
            <path
              class="cls-116"
              d="M720,488.82c-.06,0-.16,0-.17,0s.09-.08.17-.08l.33,0c.07,0,.11,0,.11.06s0,.05-.1.06Z"
            />
            <path
              class="cls-116"
              d="M720,488.64h-.09s-.1,0-.1,0,0-.06.08-.07l.44,0c.06,0,.08,0,.08.05s0,.06-.07.06l-.33,0Z"
            />
            <path
              class="cls-114"
              d="M719.57,488.84l-.19,0c-.09,0-.07-.06-.07-.1s.07,0,.11,0h.17v.13Z"
            />
            <path
              class="cls-116"
              d="M719.59,488.83v-.13c.06,0,.13,0,.12.05S719.68,488.83,719.59,488.83Z"
            />
            <path
              class="cls-116"
              d="M719.6,488.54c.06,0,.12,0,.12,0s-.06.06-.12.07h0v-.12Z"
            />
            <path class="cls-116" d="M719.5,488.53h.09v0h-.1Z" />
            <path
              class="cls-116"
              d="M719.63,488.12v0l.09-1h0c.12,0,.1.05.09.09,0,.22,0,.44-.06.66a2.4,2.4,0,0,0,0,.28Z"
            />
            <path
              class="cls-120"
              d="M717.11,491.42l-.27,0a2.12,2.12,0,0,1-.44,0v-.32a.34.34,0,0,0,0-.1s0-.1-.06-.12l0,0c.22-.05.45-.05.67-.08s.17,0,.16.07,0,.13,0,.18v0C717.08,491.14,717.12,491.28,717.11,491.42Z"
            />
            <path
              class="cls-116"
              d="M717.17,491v0c.06,0,0-.09,0-.14s.06-.14.21-.15.11,0,.1.07,0,.21,0,.31,0,.1-.07.12a.22.22,0,0,1-.19-.07S717.22,491,717.17,491Z"
            />
            <path
              class="cls-119"
              d="M717.64,491.55c0-.09-.09,0-.15-.05s-.11,0-.1.07,0,.09.06.1.17,0,.21-.05l0-.06Zm-.17.08s0-.07,0-.08,0,0,0,0S717.5,491.6,717.47,491.63Z"
            />
            <path
              class="cls-119"
              d="M718.1,491.54l0,.08a.68.68,0,0,1-.2,0v-.16l.05,0,.06,0s0,.08.09.08Z"
            />
            <path
              class="cls-109"
              d="M717.88,491.56v.08a.39.39,0,0,1-.16,0l-.05,0,0-.06c.08,0,.06,0,.06-.06s0,0,.09,0S717.83,491.54,717.88,491.56Z"
            />
            <path
              class="cls-110"
              d="M717.71,491.66a.39.39,0,0,0,.16,0,.68.68,0,0,0,.2,0h.09l0,0-.46,0Z"
            />
            <path
              class="cls-113"
              d="M718.09,491.52c-.09,0-.09,0-.09-.08S718.08,491.48,718.09,491.52Z"
            />
            <path class="cls-111" d="M717.88,491.56s0-.05,0-.08v0l0,0Z" />
            <path class="cls-120" d="M717.89,491.48l0,0s0,0,.09,0Z" />
            <path
              class="cls-116"
              d="M720.58,486.9a.31.31,0,0,1-.2,0H720c-.06,0-.1,0-.1-.06s0-.06.09-.06h.48c.09,0,.12,0,.13.08Z"
            />
            <path
              class="cls-116"
              d="M720.21,487.05H720s-.11,0-.11,0,0-.05.1-.05h.51s.06,0,.06,0,0,0-.07,0Z"
            />
            <path
              class="cls-116"
              d="M719.72,486.8h0s.11,0,.09.08-.05.06-.12.06h0v-.14Z"
            />
            <path
              class="cls-116"
              d="M719.72,487s.09,0,.09.05,0,.05-.09.05h0V487Z"
            />
            <path
              class="cls-115"
              d="M705.56,491.33c.07.05,0,.11.07.15s-.08,0-.1,0S705.51,491.38,705.56,491.33Z"
            />
            <path
              class="cls-116"
              d="M715.42,491.66v-.21c.07,0,.09,0,.1-.07a2,2,0,0,0,0-.49c.08,0,.06.05.12,0v0a.18.18,0,0,0,0,.26v.08s0,.05,0,.07,0,.19-.09.26A.23.23,0,0,1,715.42,491.66Z"
            />
            <path
              class="cls-117"
              d="M715.61,492.16l-.06-.14s0,0,0,0c-.17,0-.08-.11-.11-.17h.14a.15.15,0,0,0,.09,0c-.08.07,0,.15,0,.22S715.67,492.13,715.61,492.16Z"
            />
            <path
              class="cls-110"
              d="M715.56,491.81h-.14v-.15a.23.23,0,0,0,.12,0h.11v0C715.52,491.7,715.6,491.77,715.56,491.81Z"
            />
            <path
              class="cls-113"
              d="M715.66,491.23a.18.18,0,0,1,0-.26C715.66,491.06,715.72,491.14,715.66,491.23Z"
            />
            <path
              class="cls-113"
              d="M715.65,491.65h-.11c.11-.07.05-.17.09-.26s0-.05,0-.07A1,1,0,0,1,715.65,491.65Z"
            />
            <path
              class="cls-113"
              d="M715.56,491.81s0-.11.1-.12a.17.17,0,0,1,0,.14A.15.15,0,0,1,715.56,491.81Z"
            />
            <path
              class="cls-113"
              d="M715.57,492.22h0S715.56,492.21,715.57,492.22Z"
            />
            <path class="cls-109" d="M717.57,490.42h.11v0Z" />
            <path
              class="cls-111"
              d="M717.68,490.42h0s0,0,0,0S717.7,490.42,717.68,490.42Z"
            />
            <path class="cls-109" d="M718.3,490.32h0Z" />
            <path class="cls-109" d="M718.27,490.37h0Z" />
            <path
              class="cls-116"
              d="M716.38,491.52a2,2,0,0,1,.45.15l-.27,0c-.17,0-.19,0-.19-.1S716.38,491.55,716.38,491.52Z"
            />
            <path
              class="cls-120"
              d="M716.28,491h.05v.09c0,.08,0,.17,0,.24A.61.61,0,0,1,716.28,491Z"
            />
            <path
              class="cls-113"
              d="M716.34,491.08v-.22c.1,0,0,.08.06.12a.34.34,0,0,1,0,.1Z"
            />
            <path
              class="cls-109"
              d="M716.34,491.86s0-.05.08,0,.16,0,.14.08l-.21,0Z"
            />
            <path
              class="cls-109"
              d="M716.82,490.52s-.07,0-.07,0A.07.07,0,0,1,716.82,490.52Z"
            />
            <path class="cls-109" d="M717.39,490.4h.07a.12.12,0,0,1-.1,0Z" />
            <path class="cls-109" d="M716.66,490.54h-.06a.06.06,0,0,1,.06,0Z" />
            <path class="cls-109" d="M716.35,490.52h0Z" />
            <path
              class="cls-113"
              d="M711.67,491.36a.62.62,0,0,0-.36,0h0c-.08,0-.19,0-.22,0s.1-.06.17-.07l.45-.05Z"
            />
            <path
              class="cls-114"
              d="M715.54,490.89a2,2,0,0,1,0,.49s0,.06-.1.07a2.05,2.05,0,0,0,0-.49S715.46,490.89,715.54,490.89Z"
            />
            <path
              class="cls-116"
              d="M714.52,491s-.11,0-.12,0,.07,0,.11-.05a.34.34,0,0,1,.2,0s0,0,0,0S714.59,491,714.52,491Z"
            />
            <path class="cls-114" d="M714.74,491.18h0Z" />
            <path
              class="cls-115"
              d="M705.52,491a.11.11,0,0,1,0,.16C705.48,491.09,705.5,491,705.52,491Z"
            />
            <path
              class="cls-113"
              d="M707,490.32a3.78,3.78,0,0,1-.67.05A3,3,0,0,1,707,490.32Z"
            />
            <path class="cls-113" d="M706.27,490.18H706l.44,0s-.11,0-.13,0Z" />
            <path
              class="cls-113"
              d="M706,490.13l-.22,0A.41.41,0,0,1,706,490.13Z"
            />
            <path class="cls-113" d="M706.1,490.11h0Z" />
            <path class="cls-113" d="M705.63,490.16h0Z" />
            <path class="cls-113" d="M705.75,490.18h0Z" />
            <path
              class="cls-116"
              d="M716.81,489.43a2.58,2.58,0,0,0,0-.48c0-.07.07-.08.15-.09s.32,0,.48,0,.12,0,.1.07,0,.38-.05.57,0,.1-.16.1-.28,0-.41,0-.14,0-.14-.08A.34.34,0,0,0,716.81,489.43Z"
            />
            <path
              class="cls-116"
              d="M715.89,489.41l0-.42c0-.05,0-.07.11-.07a1.15,1.15,0,0,1,.45,0c.14,0,0,.17,0,.25a.74.74,0,0,1,0,.21s0,.06,0,.07-.08.09,0,.12a2.93,2.93,0,0,1-.58.06c-.05,0-.05,0-.05-.05l.35,0s.1,0,.09-.05-.07,0-.11,0h-.33l0,0,.39,0A1.48,1.48,0,0,0,715.89,489.41Z"
            />
            <path
              class="cls-116"
              d="M717.58,489.4a2.05,2.05,0,0,0,0-.49c0-.1.12-.08.22-.09s.1.05.1.09l0,.53a.09.09,0,0,1-.07.1.34.34,0,0,1-.2,0c-.07,0,0-.06,0-.09Z"
            />
            <path
              class="cls-116"
              d="M716.56,489.45s.07,0,.13-.06c-.1,0-.12-.05-.11-.11a1.61,1.61,0,0,0,0-.31c0-.05,0-.09.1-.09s.09,0,.09.08a2.48,2.48,0,0,1,0,.66c0-.05-.14,0-.17-.09s.12,0,.12,0S716.61,489.45,716.56,489.45Z"
            />
            <path
              class="cls-116"
              d="M717.08,488.82h-.14c-.05,0-.09,0-.09,0s0-.07.07-.06a3.64,3.64,0,0,1,.66,0s0,0,0,0,.17,0,.25,0,0,0,0,0,0,0-.09,0l-.76,0Z"
            />
            <path
              class="cls-116"
              d="M715.91,488.67l0,0a1.49,1.49,0,0,1,.63,0c0,.06-.1.07-.17.07H716C715.9,488.74,715.93,488.7,715.91,488.67Z"
            />
            <path
              class="cls-116"
              d="M716,488.86s-.07,0-.08,0,0-.06.07-.07l.5,0s.06,0,.06,0,0,.05-.06.06a.78.78,0,0,1-.22,0Z"
            />
            <path
              class="cls-121"
              d="M715.89,489.49h.33s.09,0,.11,0-.05,0-.09.05l-.35,0Z"
            />
            <path
              class="cls-116"
              d="M716.78,488.79s0,0-.09,0-.1,0-.1,0,0-.05.09-.05S716.78,488.75,716.78,488.79Z"
            />
            <path
              class="cls-121"
              d="M715.89,489.41a1.48,1.48,0,0,1,.42,0l-.39,0Z"
            />
            <path
              class="cls-116"
              d="M716.59,488.64c.07-.06.14,0,.22,0s-.06.06-.13.06S716.59,488.68,716.59,488.64Z"
            />
            <path
              class="cls-121"
              d="M715.79,489.58s-.12,0-.12,0,.07,0,.12,0Z"
            />
            <path
              class="cls-121"
              d="M716.56,489.45c.05,0,.12,0,.12,0s-.07,0-.12,0Z"
            />
            <path
              class="cls-115"
              d="M717.64,488.64h.07S717.66,488.68,717.64,488.64Z"
            />
            <path
              class="cls-116"
              d="M717,487.69c-.15-.06-.13-.15-.13-.24a2.26,2.26,0,0,0,0-.26c0-.06,0-.07.13-.07h.56c.06,0,.08,0,.07,0a3.64,3.64,0,0,0,0,.57c0,.07-.06.12-.2.1l-.19,0c-.08,0-.17,0-.18-.08s.21,0,.3,0c-.06,0-.13,0-.19,0s.09,0,.11,0A.71.71,0,0,0,717,487.69Z"
            />
            <path
              class="cls-116"
              d="M716.14,487.71a.08.08,0,0,0-.08-.06c-.17,0-.15-.07-.14-.13a1,1,0,0,0,0-.35c0-.05,0-.07.12-.07h.44c.08,0,.12,0,.12.07l0,.62s0,0-.05,0-.26,0-.37,0c.07-.05.17,0,.26,0s.09,0,.1,0-.06-.05-.09-.05S716.24,487.67,716.14,487.71Z"
            />
            <path
              class="cls-116"
              d="M718,487.28a2.08,2.08,0,0,0,0,.44c0,.08-.17.14-.29.1s0,0,0-.05a3.81,3.81,0,0,0,0-.59c0-.07.08-.06.15-.06s.16,0,.16.06Z"
            />
            <path
              class="cls-116"
              d="M716.65,487.51a2.36,2.36,0,0,1,0-.35s0-.06.09-.06.08,0,.09.06-.05.33,0,.49-.11,0-.09,0a.29.29,0,0,1,0,.09s0,.05,0,.06-.07,0-.07,0Z"
            />
            <path
              class="cls-116"
              d="M716.93,486.87a2.51,2.51,0,0,1,.67,0,1,1,0,0,1,.43,0s0,.07-.09.07-.19,0-.23-.08c-.07.11-.2.08-.31.08l-.35,0C717,487,716.93,486.92,716.93,486.87Z"
            />
            <path
              class="cls-116"
              d="M715.94,486.87a1.56,1.56,0,0,1,.68,0c0,.05,0,.06-.12.06h-.44C716,487,715.94,486.92,715.94,486.87Z"
            />
            <path
              class="cls-116"
              d="M717.3,487.06H717s-.08,0-.08,0,0,0,.08,0h.57s.07,0,.07,0,0,0-.07,0Z"
            />
            <path
              class="cls-116"
              d="M716.28,487.06H716s-.09,0-.09,0,0,0,.08,0h.5s.08,0,.08,0,0,0-.08,0Z"
            />
            <path
              class="cls-114"
              d="M717,487.69a.71.71,0,0,1,.25,0s-.08,0-.11,0,.13,0,.19,0c-.09,0-.21,0-.3,0s-.08,0-.12.07S717,487.74,717,487.69Z"
            />
            <path
              class="cls-114"
              d="M716.14,487.71c.1,0,.2,0,.3,0s.09,0,.09.05-.06,0-.1,0-.19,0-.26,0S716.15,487.74,716.14,487.71Z"
            />
            <path
              class="cls-116"
              d="M718,487c-.06.07-.17,0-.26,0s0,0,0,0,0,0,.06,0H718Z"
            />
            <path
              class="cls-116"
              d="M716.68,486.88c.06-.06.13,0,.2,0s0,.07-.1.07S716.68,486.92,716.68,486.88Z"
            />
            <path
              class="cls-116"
              d="M716.87,487s0,0-.09,0-.09,0-.09,0,0,0,.09,0S716.86,487,716.87,487Z"
            />
            <path class="cls-116" d="M716,487.72v0l0,0h0Z" />
            <path class="cls-115" d="M718,487v0h0Z" />
            <path
              class="cls-117"
              d="M719.15,489.37c0,.14,0,.28,0,.43s0,.08-.15.07c-.27,0-.28,0-.26-.2s0-.5.06-.75l0,0v.35s0,0,0,.08,0,.08.08.08A2.11,2.11,0,0,0,719.15,489.37Z"
            />
            <path
              class="cls-117"
              d="M719.27,488.91c.06,0,0,.11.09.16s0,0,0,.06-.06,0,0,0,.06.12,0,.17c.14.09,0,.2.05.3s0,.16,0,.24-.13,0-.13-.05a5.09,5.09,0,0,1,0-.55A2.23,2.23,0,0,1,719.27,488.91Z"
            />
            <path
              class="cls-114"
              d="M718.84,489.07v-.19c.08-.09.19,0,.29,0s.06.05.06.08,0,.07,0,.11A1.94,1.94,0,0,0,718.84,489.07Z"
            />
            <path
              class="cls-114"
              d="M718.85,488.66a1.18,1.18,0,0,1,.27,0c.08,0,.1,0,.09.07s-.07.05-.12.05S718.83,488.78,718.85,488.66Z"
            />
            <path
              class="cls-114"
              d="M718.86,488.51a1,1,0,0,1,.35,0s.07.1-.06.1S718.87,488.63,718.86,488.51Z"
            />
            <path
              class="cls-116"
              d="M718.82,489.31s0-.06,0-.08a2,2,0,0,1,.35,0v.1Z"
            />
            <path
              class="cls-116"
              d="M718.84,489.07a1.94,1.94,0,0,1,.34,0v.1h-.34Z"
            />
            <path
              class="cls-114"
              d="M719.5,488.53h.09v.12c-.1,0-.28,0-.26-.12S719.44,488.53,719.5,488.53Z"
            />
            <path
              class="cls-114"
              d="M718.82,489.31h.36a.06.06,0,0,1,0,.06,2.11,2.11,0,0,1-.25,0C718.81,489.39,718.78,489.36,718.82,489.31Z"
            />
            <path class="cls-114" d="M718.84,489.15h.34v.06a2,2,0,0,0-.35,0Z" />
            <path class="cls-117" d="M719.27,488.9v0Z" />
            <path
              class="cls-114"
              d="M719.71,487.08l-.09,1s-.1,0-.13,0a2.44,2.44,0,0,1,0-.27c0-.06,0-.08-.13-.08v0s.13,0,.14,0-.12,0-.12-.06.13,0,.13-.06-.1,0-.13-.07v-.33C719.48,487,719.61,487.09,719.71,487.08Z"
            />
            <path
              class="cls-114"
              d="M718.89,487.43a.67.67,0,0,0,0-.28s0-.08.11-.07a.61.61,0,0,1,.33,0c0,.09-.07.18,0,.27s0,.08-.07.09h-.33C718.89,487.48,718.89,487.45,718.89,487.43Z"
            />
            <path
              class="cls-117"
              d="M719.27,487.72V488c0,.12-.16.08-.27.09s-.15,0-.14-.1v-.24Z"
            />
            <path
              class="cls-117"
              d="M718.89,487.43s0,.05.05.05h.33c.07,0,.06-.05.07-.09l0,.06s.13,0,.13.07-.1,0-.13.06.14,0,.12.06-.09,0-.14,0h-.51s0-.06,0-.08a.94.94,0,0,0,.41,0l0,0s0,0,0-.05,0,0,0,.05a2.77,2.77,0,0,0-.41,0A.09.09,0,0,1,718.89,487.43Z"
            />
            <path
              class="cls-117"
              d="M719.37,487.72c.09,0,.13,0,.13.08a2.44,2.44,0,0,0,0,.27c-.14,0-.2,0-.16-.11S719.3,487.8,719.37,487.72Z"
            />
            <path
              class="cls-114"
              d="M718.92,486.86a.63.63,0,0,1,.45,0c0,.05,0,.08-.13.08S719,487,718.92,486.86Z"
            />
            <path
              class="cls-114"
              d="M719.13,487.06H719c-.06,0-.11,0-.11-.05s.05-.05.11-.05h.19s.11,0,.11.05-.05.05-.11.05Z"
            />
            <path
              class="cls-114"
              d="M719.72,486.8v.14h-.15c-.1,0-.14,0-.13-.08S719.62,486.82,719.72,486.8Z"
            />
            <path
              class="cls-114"
              d="M719.71,487v.09h-.2s-.1,0-.1,0,0-.06.1-.06Z"
            />
            <path
              class="cls-114"
              d="M718.89,487.58a2.77,2.77,0,0,1,.41,0v0a.94.94,0,0,1-.41,0Z"
            />
            <path
              class="cls-116"
              d="M719.39,487.45l0-.06c-.05-.09,0-.18,0-.27h0Z"
            />
            <path class="cls-114" d="M718.86,487.69h.44l0,0h-.41Z" />
            <path
              class="cls-114"
              d="M710.68,489.55v0c.13,0,.17.07.1.16s0-.05-.1,0v0C710.76,489.59,710.75,489.57,710.68,489.55Z"
            />
            <path
              class="cls-114"
              d="M710.79,489.5a.37.37,0,0,1,.23,0A.35.35,0,0,1,710.79,489.5Z"
            />
            <path
              class="cls-114"
              d="M710.88,487.62a.16.16,0,0,1-.16,0A.29.29,0,0,1,710.88,487.62Z"
            />
            <path class="cls-116" d="M710.68,489.55c.07,0,.08,0,0,.06Z" />
            <path
              class="cls-116"
              d="M712.3,487.9v-.7a.06.06,0,0,1,0,.06v.59S712.33,487.89,712.3,487.9Z"
            />
            <path
              class="cls-114"
              d="M705.53,487.81v-.09a.94.94,0,0,1,0-.37c0-.08,0-.13-.14-.13l0,0,0,.51.06.11h.15l0,0Z"
            />
            <path
              class="cls-116"
              d="M705.79,487.27s0-.06-.09-.06h-.35c.12,0,.15,0,.14.13a.94.94,0,0,0,0,.37c.1-.08.13-.18.26-.25v.2A1.34,1.34,0,0,0,705.79,487.27Z"
            />
            <path class="cls-114" d="M705.37,487h.08v-.12h-.12Z" />
            <path
              class="cls-116"
              d="M705.45,487v-.12h.2q.09,0,.09.06s0,.06-.09.06Z"
            />
            <path
              class="cls-116"
              d="M705.77,487.11s0,0-.07,0a1.61,1.61,0,0,1-.31,0h0c.05,0,.08,0,.07.08h.25S705.78,487.14,705.77,487.11Z"
            />
            <path
              class="cls-116"
              d="M705.53,487.85l0,0c0,.08-.06.09-.13.08h0v0h.15l.06,0C705.59,487.94,705.56,487.89,705.53,487.85Z"
            />
            <path class="cls-116" d="M705.53,487.81v0Z" />
            <path
              class="cls-121"
              d="M705.44,489.67s0-.05,0-.07,0-.06.11-.06.11,0,.11.06a.32.32,0,0,0,0,.14s0,.08-.06.09-.15,0-.17-.05a.2.2,0,0,1,0-.11Z"
            />
            <path
              class="cls-121"
              d="M705.31,489.62c0-.05,0-.07-.11-.07h-.05c0,.07,0,.14,0,.21a.06.06,0,0,1,0,.06l0,0,.14,0Z"
            />
            <path
              class="cls-116"
              d="M705.4,489.39l.25,0s.05.05,0,.05S705.47,489.47,705.4,489.39Z"
            />
            <path
              class="cls-116"
              d="M705.49,488.67h-.12s0,0-.06-.05,0,0,.06,0,.29,0,.44,0,.1,0,.1.05,0,0-.1,0Z"
            />
            <path
              class="cls-116"
              d="M705.75,488.7l-.48,0h-.06v0h.56c.05,0,.16,0,.15,0S705.81,488.7,705.75,488.7Z"
            />
            <path
              class="cls-115"
              d="M705.27,488.73h-.06A.07.07,0,0,1,705.27,488.73Z"
            />
            <path class="cls-115" d="M707,489.25l0,0Z" />
            <path class="cls-117" d="M721.93,491.16s0-.08-.09-.1v0h.1Z" />
            <path
              class="cls-114"
              d="M722.15,487.86s0,.05-.06.05-.06,0-.05,0,0-.05.06-.05S722.14,487.85,722.15,487.86Z"
            />
            <path
              class="cls-117"
              d="M722.07,487.69s0,0,0,0,0,0-.05,0-.06,0-.06,0S722,487.69,722.07,487.69Z"
            />
            <path
              class="cls-117"
              d="M717.47,491.63s0-.07,0-.09,0,0,0,0S717.5,491.6,717.47,491.63Z"
            />
            <path class="cls-116" d="M719.3,487.6v0s0-.05,0-.05,0,0,0,.05Z" />
            <path class="cls-12" d="M705.25,488.07c0,.13,0,.25,0,.38" />
            <path class="cls-12" d="M705.31,487.28l0,.43" />
            <path class="cls-12" d="M705.42,486c0,.28,0,.56-.07.84" />
            <path
              class="cls-129"
              d="M553,449.93a62.39,62.39,0,0,0-1,7.14c-.27,1.64-.58,3.28-.82,4.93-.59,4-1.16,8.09-1.74,12.14-.35,2.39-.69,4.78-1,7.17-.48,3.2-1,6.39-1.46,9.59a5.32,5.32,0,0,0,0,.69c-.1.68-.2,1.36-.29,2a2.51,2.51,0,0,0-.31,1.82c-.14,1.29-.14,1.29-2.53,1.6a12.36,12.36,0,0,1-2.22.27c.2-1.27.43-2.53.6-3.8.25-1.89.43-3.79.68-5.69.37-2.77.74-5.53,1.2-8.29.18-1.13.15-2.26.35-3.38.64-3.51,1.08-7,1.49-10.54.2-1.73.53-3.46.81-5.18a36.72,36.72,0,0,0,.69-5.19c0-.2.08-.44-.33-.54s-.6.17-.88.28c-6.14,0-12.27,0-18.41-.12-1.42,0-1.79.27-1.82,1,0,1.05-.21,2.09-.32,3.13-.57,5.21-1.12,10.42-1.7,15.63q-1,8.85-2,17.7c-.28,2.49-.59,5-.89,7.46-.08.45-.75.48-1.33.56a29.15,29.15,0,0,1-3.41.38,63,63,0,0,1,.55-6.85c.31-2.86.53-5.72.89-8.58.53-4.24.8-8.49,1.3-12.73.14-1.24.19-2.49.31-3.73.36-3.7.79-7.39,1.18-11.09.31-2.91.59-5.83.89-8.74l17.76.42,12.78.33C552.29,449.74,552.74,449.67,553,449.93Z"
            />
            <path
              class="cls-110"
              d="M521,499.76c.3-2.49.61-5,.89-7.46q1-8.85,2-17.7c.58-5.21,1.13-10.42,1.7-15.63.11-1,.27-2.08.32-3.13,0-.7.4-1,1.82-1,6.14.08,12.27.09,18.41.12a4.16,4.16,0,0,1-.36,2.26H530.27c-.49,0-1.06-.12-1.4.21a.22.22,0,0,0,0,.14.86.86,0,0,0-.22.87l0,.38c.09.3-.55.58-.07.89V460a27,27,0,0,0-.57,4.81c0,.5.64.42,1.22.38a28.55,28.55,0,0,0,3.7,0l11.87-.3a56.31,56.31,0,0,1-.9,6.42,66.48,66.48,0,0,0-6.78.32l-2.78.07a2.3,2.3,0,0,0-1,.1l-5.24.23c-.4,0-.9,0-.7.35-.46.17-.29.45-.38.69l-.11.38-.51,5.38-.11.37,0,.31c-.12,1.08.09,1.18,1.92,1,.91-.08,1.83-.16,2.76-.22,4-.23,7.86-.69,11.84-.79l-.66,5.39a1.59,1.59,0,0,0-1,.36c-.11,0-.16,0-.16.08a.52.52,0,0,0-.25,0c-.1-.21-.41-.28-.72-.24a33.11,33.11,0,0,0-4,.5l-.6,0a4,4,0,0,0-1.89.17l-.58,0a1.54,1.54,0,0,0-1,.13l-.89.05a1.52,1.52,0,0,0-1,.12l-.9.05c-1.09.11-2.3-.06-3.23.42-.68.34-.78.72-.3,1.15l0,.29-.23.87c0,.13,0,.26,0,.39-.81,1.25-.22,2.54-.34,3.82-.36.14-.32.34-.24.54l0,.29c-.16.46.22.58,1,.49,2.33-.28,4.66-.57,7-.83a79.35,79.35,0,0,1,8.23-.87c-.16,1.51-.33,3-.5,4.53-5,.52-10,1.3-15,1.94C523.92,499.45,522.48,499.71,521,499.76Z"
            />
            <path
              class="cls-130"
              d="M521.35,449c-.3,2.91-.58,5.83-.89,8.74-.39,3.7-.82,7.39-1.18,11.09-.12,1.24-.17,2.49-.31,3.73-.5,4.24-.77,8.49-1.3,12.73-.36,2.86-.58,5.72-.89,8.58a63,63,0,0,0-.55,6.85,19.6,19.6,0,0,1-3.47-.41l-4.35-.86a9.77,9.77,0,0,1,0-1.21c.29-2.78.57-5.57.91-8.35.08-.69-.36-1-1.58-.86-.39-.66-1-.7-2.8-.18-.78.09-1-.33-1.75-.66-.35,4.32-.69,8.51-1,12.69-.81.23-1.34-.34-2.11-.23l-2.42-.49c.08-.86.16-1.72.23-2.57.53-.45.4-.71-.61-.83s-2-.29-3-.45c-.53-.54.06-1.2-.59-1.73-.51-.8,0-1.6,0-2.4,0-1.89.13-1.89-3.19-1.44-.56.07-1.18.06-1.19.51-.05,1.33-.11,2.65-.17,4a.22.22,0,0,1-.16,0l-.9-.11,0-3.82a13.53,13.53,0,0,0,.28-3,62,62,0,0,1,7-.68c2.08-.15,4.08-.67,6.23-.41,1.66.11,3.17.58,4.86.59,2.82,0,5.51-.46,8.28-.65.66-.05.58-.35.6-.6.16-1.36.32-2.72.45-4.07,0-.22.13-.48-.3-.64.15-1.59.3-3.18.44-4.77l.75-8.32a3,3,0,0,0,.17-3c0-.57-.05-1.15-.07-1.72v-.32c.5-.18.32-.46.34-.71.2-2.67.39-5.34.59-8l0,0c.57-.25.2-.58.25-.88A.23.23,0,0,0,518,454c.27-.06.42-.19.44-.33.14-1.15.27-2.31.4-3.46,0-.39-.43-.4-.93-.4l-8.07-.12c-1.46-.16-3,.41-4.4-.08.24-.09.52-.29.72-.27,4.17.42,8.26-.29,12.4-.22.1.08.2.22.3.22.32,0,.27-.16.3-.29Z"
            />
            <path
              class="cls-113"
              d="M402.19,501.12h-.35l-5-5.56c0-.31-.28-.51-.91-.48l-.36-4.15c0-.31-.06-.66-.72-.66-.84,0-.48.42-.52.67-.21,1.3.66,2.58.21,3.88l-.52-.31c-.14-.17-.44-.18-.71-.22-1.08-1.2-2.15-2.41-3.25-3.61-.64-.69-1.42-.73-2.63-.19l-1.21.39c.44-.59-.09-1.18,0-1.78,0-.19,0-.46-.51-.43s-.42.3-.42.49c0,.75,0,1.5,0,2.24,0,.35,0,.69,0,1s0,.7.9.71c.16.83.33,1.65.47,2.48.05.31-.4.27-.75.28l-.56-.18c0-.12-.05-.24-.08-.36-.44-.48-1.42-.7-1.42-1.42,0-1.83-.31-3.67-.5-5.5,2.38-.35,4.83-.35,7.26-.48-.58.57.21.76.9.95l8.23,2.23c4,1.07,7.9,2.29,12.06,3.2,2.75,0,5.37-.54,8.12-.56l-.28.66-4.74.37c-.43,0-.83.07-.88.37-1.68.38-2.73.94-2.55,2.08.21,1.29-.06,2.6.3,3.89Z"
            />
            <path
              class="cls-109"
              d="M473.6,503.58l-1.76.11c-.29-4.77.29-9.54.37-14.3,0-1.16-.22-2.38.53-3.52a1.73,1.73,0,0,1,1.57.54c-.25.11-.29.23,0,.33l.28.19c0,.17,0,.33.28.47,1.45.75,2.93.29,4.41.06h0a3.55,3.55,0,0,0,1.57-.18c.64-.06,1.87.09,1.84-.13-.09-.58.18-.38.68-.22a7.28,7.28,0,0,0,2.87.11c1-.08,2-.21,3.05-.32l.56,0c2.65-.22,5.31-.41,7.94-.69,2.46-.26,5-.2,7.43-.66.89.47.62,1.26-.48,1.48s-2.18.09-3.17.4c-2.15-.26-4.15.26-6.23.41a62,62,0,0,0-7,.68c-4.46.15-8.82.74-13.24,1.07-.61,0-.81.21-.74.53s0,.91,0,1.37a16.35,16.35,0,0,0-.26,4.93c-.06,1.13-.11,2.27-.17,3.4a.43.43,0,0,0,0,.61c0,.27,0,.54-.07.8l0,.18c.24.19.12.38.07.58C473.74,502.39,473.67,503,473.6,503.58Z"
            />
            <path
              class="cls-114"
              d="M419.6,494.43l.28-.66a27.92,27.92,0,0,1,4.41-.38,33.23,33.23,0,0,0-3.75,2.8c3.43,0,6.89.68,10.33-.16-.54,2.44-.1,2.75,3.74,2.61h.15c.8,0,1.11-.2,1.1-.63,0-.84,0-1.68,0-2.52a22.25,22.25,0,0,1,5.71-.13c0,1.73,0,3.46,0,5.18,0,.34.14.72-.6.9l-1,0c-1-.95-2.62-1.53-4-2.26a2.51,2.51,0,0,0-1.48-.11l-14.57,1.53A50.58,50.58,0,0,1,419.6,494.43Z"
            />
            <path
              class="cls-110"
              d="M419.6,494.43a50.58,50.58,0,0,0,.32,6.15v.52a26.65,26.65,0,0,0,.16,4.19c0,.47.07.95.11,1.42,0,.1,0,.2,0,.31l0,1.05c0,.22-.08.44-.11.66l-.27.22c-.48,0-.95-.28-1.43,0l-.62.05-2.83.35-.34-.4a122.1,122.1,0,0,0-.63-13.78c0-.3.45-.34.88-.37Z"
            />
            <path
              class="cls-115"
              d="M455.58,503.86a18.54,18.54,0,0,1-4.23-.9,13.23,13.23,0,0,0-2.72-.51c.1-1.45.63-2.94.16-4.32a17.93,17.93,0,0,1-.44-4,54,54,0,0,1,7.37-2.48,4,4,0,0,1,.12.68Q455.72,498.09,455.58,503.86Z"
            />
            <path
              class="cls-110"
              d="M448.35,494.11a17.93,17.93,0,0,0,.44,4c.47,1.38-.06,2.87-.16,4.32a51.33,51.33,0,0,0-5.7-.26c-1-.07-1.66-.23-2-.75.74-.18.6-.56.6-.9,0-1.72,0-3.45,0-5.18h-.05Z"
            />
            <path
              class="cls-111"
              d="M543.85,471.36a56.31,56.31,0,0,0,.9-6.42c.24-1.92.47-3.84.71-5.77a1.93,1.93,0,0,0,.26-1.57l0-.35a4.16,4.16,0,0,0,.36-2.26c.28-.11.43-.38.88-.28s.34.34.33.54a36.72,36.72,0,0,1-.69,5.19c-.28,1.72-.61,3.45-.81,5.18-.41,3.51-.85,7-1.49,10.54-.2,1.12-.17,2.25-.35,3.38-.46,2.76-.83,5.52-1.2,8.29-.25,1.9-.43,3.8-.68,5.69-.17,1.27-.4,2.53-.6,3.8h-1.1c.17-1.51.34-3,.5-4.53l0-.68a11.34,11.34,0,0,0,.56-4l.06-.34a3.27,3.27,0,0,0,.26-2.1l0-.34c.24-.09.3-.22.23-.37l.66-5.39Z"
            />
            <path
              class="cls-110"
              d="M387.39,490.48c1.21-.54,2-.5,2.63.19,1.1,1.2,2.17,2.41,3.25,3.61.08,1.79.12,3.59.26,5.38,0,.38.13.74-.25,1.08l-4.86.37C388.08,497.57,387.73,494,387.39,490.48Z"
            />
            <path
              class="cls-109"
              d="M379.67,496.79a17.68,17.68,0,0,0,.24,3.63c.17,1.73.08,1.75-3.09,1.76-.22-1.78-.45-3.56-.64-5.34-.24-2.16-.44-4.32-.64-6.47,0-.37-.13-.81.82-.89a10,10,0,0,1,2.45-.12Z"
            />
            <path
              class="cls-110"
              d="M455.58,503.86q.14-5.78.26-11.55a4,4,0,0,0-.12-.68c.71-.54,1-.35,1.19.19a7.34,7.34,0,0,1,.21,1.1c0,1.33,0,2.65,0,4-.05.93-.13,1.85-.1,2.78,0,.29-.45.94.72.77,1-.14,2.67.23,2.69-.85,0-2,0-4,0-6l.09-.35,1.19-.19c.17,3.41,0,6.82-.07,10.22A38.21,38.21,0,0,1,455.58,503.86Z"
            />
            <path
              class="cls-113"
              d="M375.78,500.45c-.95-.67-.43-1.57-1.17-2.27a3.48,3.48,0,0,0-.27-1.51c-.16-.36-.45-.39-1-.25,0-.1,0-.21,0-.31l.59-.5a3.81,3.81,0,0,0-.32-3.79c-.35-.12-.88-.72-.9.08,0,.56-.48.22-.82.17-.6-.37-.45-1.06-1.58-1.22l-.42-.61c.23-1.55-.37-3.08-.27-4.62h.7a10,10,0,0,1,2.54.61c.33.08.82.28,1,.22.87-.37.67,0,.69.28.28,2.47.63,4.95.81,7.42C375.53,496.25,376,498.35,375.78,500.45Z"
            />
            <path
              class="cls-115"
              d="M414,495.17a122.1,122.1,0,0,1,.63,13.78,10.49,10.49,0,0,0-2.45-.17l-1.9-.22c.63-.29,1.71.09,1.86-.51a9.06,9.06,0,0,1-.28-3.69c0-1.07-.83-2.14-.11-3.22-.36-1.29-.09-2.6-.3-3.89C411.25,496.11,412.3,495.55,414,495.17Z"
            />
            <path
              class="cls-115"
              d="M461.68,503.29c.08-3.4.24-6.81.07-10.22,1.17-.15,1.83-.83,3.05-.92.32,3.9-.24,7.8-.23,11.71C463.47,503.89,462.75,503.32,461.68,503.29Z"
            />
            <path
              class="cls-116"
              d="M419.92,501.1v-.52l14.57-1.53a2.51,2.51,0,0,1,1.48.11c1.36.73,3,1.31,4,2.26-3.6.51-7.21-.09-10.82,0a1.69,1.69,0,0,1-1-.34,6.36,6.36,0,0,0-2.91,0C423.43,501.26,421.68,501,419.92,501.1Z"
            />
            <path
              class="cls-111"
              d="M375.78,500.45c.25-2.1-.25-4.2-.4-6.3-.18-2.47-.53-4.95-.81-7.42,0-.24.18-.65-.69-.28-.14.06-.63-.14-1-.22a10,10,0,0,0-2.54-.61,5.76,5.76,0,0,0-2.75-.81c-1.14-.82-1-1.27.37-1.4.08.26.4.38.8.48l5.52,1.54c.32-.13.14-.43.59-.51a10.94,10.94,0,0,1,.33,3.36c0,.29-.24.71.58.78a3.18,3.18,0,0,0,1.91-.15c.47-.31-.17-.58-.45-.83a1.43,1.43,0,0,1-.53-1.16c0-.38.2-.62,1-.59.75.72,1.91.49,3,.45,1.5-.06,3.08-.47,4.47.22a14,14,0,0,1-2.76.21c-2.26,0-2.27,0-2.16,1.26-1.53-.26-1.53-.26-1.48.89a10,10,0,0,0-2.45.12c-.95.08-.85.52-.82.89.2,2.15.4,4.31.64,6.47.19,1.78.42,3.56.64,5.34-1.08-.12-.53-.69-.89-1,.21-.19.3-.37-.05-.54A.24.24,0,0,0,375.78,500.45Z"
            />
            <path
              class="cls-109"
              d="M411.73,501.14c-.72,1.08.11,2.15.11,3.22a9.06,9.06,0,0,0,.28,3.69c-1.12-.42-1.44-1.15-2-1.75-1.24-1.29-2.55-2.55-3.9-3.8-.08-.26-.38-.41-.84-.36a7.2,7.2,0,0,1-2.43-.38c-.27-.21-.81-.32-.74-.64Z"
            />
            <path
              class="cls-113"
              d="M378.81,489.36c-.05-1.15-.05-1.15,1.48-.89.83.24,1.61-.17,2.43-.06l-.07.18c-1,0-.85.37-.88.71a26.79,26.79,0,0,0,.41,5.36c.06.52,0,1.1.54,1.59l-.07.34-3,.2C379.38,494.31,379.1,491.83,378.81,489.36Z"
            />
            <path
              class="cls-110"
              d="M396.8,495.55l5,5.56c-1.26.55-2.88.41-4.31.65-.79.14-.72-.35-.82-.63-.1-.94-.2-1.88-.31-2.81l0-.5C396.75,497.07,396,496.27,396.8,495.55Z"
            />
            <path
              class="cls-110"
              d="M464.57,503.86c0-3.91.55-7.81.23-11.71,1.23-.58,1.42-.21,1.4.45-.1,3.76-.18,7.51-.26,11.26l-.18.16C465.38,503.93,464.89,504.08,464.57,503.86Z"
            />
            <path
              class="cls-115"
              d="M387.39,490.48c.34,3.55.69,7.09,1,10.63-2,.2-1.19-.78-1.63-1.24a4.69,4.69,0,0,0-.14-1.93c.31-.75-.91-1.32-.78-2.05.35,0,.8,0,.75-.28-.14-.83-.31-1.65-.47-2.48.47-.58,0-1.17,0-1.75l0-.51Z"
            />
            <path
              class="cls-113"
              d="M486.21,501.56l-.38-.22c-.48-.28-.61-.58-.29-.94.18-.21.58-.49-.17-.63-.48-.09-1-.35-1.43-.16s-.35.51.07.78c.17.12.16.33.23.5-.76.13-1.52.28-1.81-.35.57-1,.18-1.9-.35-2.83.17-.57-.2-1.17.31-1.73.51.28.32.65.36,1s.17.63.82.61.25-.4.39-.61-.37-.37.18-.53c.42.41-.18,1.36,1.1,1.17s.87.3,1.25.46a3.81,3.81,0,0,0,.56.14l0,.56c-.51.07-.56.28-.58.52C486.42,500,486.31,500.8,486.21,501.56Z"
            />
            <path
              class="cls-117"
              d="M486.21,501.56c.1-.76.21-1.52.29-2.28,0-.24.07-.45.58-.52a1.83,1.83,0,0,0,1.15.17c2.29-.24,4.58-.5,6.86-.76a1.29,1.29,0,0,0,.83-.38l.31,0,.45.05c.47,0,.59-.43,1.15-.24-.07.85-.15,1.71-.23,2.57h-.86c.1-1.53.1-1.53-2.46-1-2.22.08-4.34.45-6.5.71-.58.06-.74.26-.65.56s-.05.78-.08,1.17l-.53.06Z"
            />
            <path
              class="cls-115"
              d="M396.4,498.32c.11.93.21,1.87.31,2.81a8.4,8.4,0,0,1-3.43-.39c.38-.34.28-.7.25-1.08-.14-1.79-.18-3.59-.26-5.38.27,0,.57.05.71.22-.09.13-.27.26-.27.39.08,1.18.2,2.36.3,3.54,0,.28.27.42.77.42C395.66,499,395.87,498.5,396.4,498.32Z"
            />
            <path
              class="cls-109"
              d="M482.13,500.51l-2.42.31,0-1.13c.69-.64.36-1-1-1.1a2.6,2.6,0,0,1-1.25-.32l3.69-.38c.76.23,1,.58.95,1.06A11.6,11.6,0,0,0,482.13,500.51Z"
            />
            <path
              class="cls-117"
              d="M479.69,499.69c0,.38,0,.75,0,1.13-.25.49.26,1.07-.53,1.5a.77.77,0,0,1-.21-.83c.15-.68-.25-.87-1.46-.67s-2.32.26-3.47.39l-.26-.18c0-.26.05-.53.07-.8a12.22,12.22,0,0,0,4.58-.42C478.93,500,479.09,499.2,479.69,499.69Z"
            />
            <path
              class="cls-113"
              d="M474,501.21c1.15-.13,2.34-.2,3.47-.39s1.61,0,1.46.67a.77.77,0,0,0,.21.83.64.64,0,0,1-.56,0,6.94,6.94,0,0,0-4.8-.5c.05-.2.17-.39-.07-.58H474Zm4.32.18c0-.16-.13-.3-.47-.25-.19,0-.49.11-.48.17s.34.27.64.3S478.35,501.5,478.36,501.39Z"
            />
            <path
              class="cls-113"
              d="M487.13,500.36c-.09-.3.07-.5.65-.56,2.16-.26,4.28-.63,6.5-.71l.12.34C492,499.86,489.58,500.13,487.13,500.36Z"
            />
            <path
              class="cls-117"
              d="M382.65,496.59c0-.11,0-.23.07-.34.73-.25,1.38-.54,1.59-1a1.83,1.83,0,0,0,.92.13c0,.12,0,.24.08.36a.19.19,0,0,0,0,.08C385.06,497.36,385.06,497.36,382.65,496.59Z"
            />
            <path
              class="cls-118"
              d="M484.24,500.89c-.07-.17-.06-.38-.23-.5-.42-.27-.4-.62-.07-.78s.95.07,1.43.16c.75.14.35.42.17.63-.32.36-.19.66.29.94A2.82,2.82,0,0,1,484.24,500.89Z"
            />
            <path
              class="cls-118"
              d="M494.4,499.43l-.12-.34c2.56-.49,2.56-.49,2.46,1Z"
            />
            <path
              class="cls-113"
              d="M373.36,496.61l-2.81.51c-1.84,0-3.45.56-5.28.56l-.07-.05A36.75,36.75,0,0,1,373.36,496.61Z"
            />
            <path
              class="cls-109"
              d="M465.76,504l.18-.16a3.32,3.32,0,0,0,2.15-.4,2.25,2.25,0,0,0,1.21.2l.05.33-1.29.3A5,5,0,0,1,465.76,504Z"
            />
            <path
              class="cls-111"
              d="M482.13,500.51a11.6,11.6,0,0,1,0-1.56c.06-.48-.19-.83-.95-1.06l.12-.1.79-.08c.53.93.92,1.86.35,2.83Z"
            />
            <path
              class="cls-109"
              d="M386.65,497.94a4.69,4.69,0,0,1,.14,1.93c-.34-.52-.72-1-1-1.57S386.06,497.84,386.65,497.94Z"
            />
            <path class="cls-113" d="M365.27,497.68l-.27.09v-.14h.19Z" />
            <path
              class="cls-117"
              d="M425.19,501.1a6.36,6.36,0,0,1,2.91,0A5.43,5.43,0,0,1,425.19,501.1Z"
            />
            <path
              class="cls-113"
              d="M375.88,500.62c.35.17.26.35.05.54C375.91,501,375.89,500.8,375.88,500.62Z"
            />
            <path
              class="cls-131"
              d="M498.94,481.52c.07-4.08.53-8.15.94-12.21a.57.57,0,0,1-.28-.66c0-1-.37-2,.45-3q.36-4.85.74-9.7c0-.43.11-.86.17-1.29a.66.66,0,0,1-.19-.66,14.17,14.17,0,0,1,.38-4c-.18-1.23-.18-1.27-2.76-1.33-3.89-.1-7.79-.1-11.67-.22-2.85-.09-5.7-.09-8.55-.18-6.63-.21-13.25-.38-19.88-.46,0,1.86-.05,3.72-.07,5.57-.09,6.17-.12,12.34-.31,18.5-.11,4.06-.21,8.11-.21,12.17,0,.45.15,1-1.24.83a34.82,34.82,0,0,1-5.44.54c-6.2.48-12.41.9-18.62,1.34l-20.94,1.51c.1,2,.19,4.08.29,6.12,2.76,0,5.38-.54,8.13-.56a27.92,27.92,0,0,1,4.41-.38,49.94,49.94,0,0,1,5.9-.55q2.79-.36,5.66-.48c1.86-.26,3.75-.4,5.65-.5q7.51-.69,15.05-1.35c2-.18,2-.17,1.47-1.28-.59-1.34-.36-1.53,1.87-1.62a41.73,41.73,0,0,1,7.6-.47,3,3,0,0,1,.61.05c1.44.37,2,.16,1.82-.75-.11-.59.95-.78,2.82-.57a1.73,1.73,0,0,1,1.57.54c0,.11,0,.22,0,.34l.28.18c.29,0,.75.16.85,0,.64-1.21,2.22-.64,3.51-.59.45,0,.74.31,1.26.27.51-.89,1.74-.89,3-.75.56.06,1.11.15,1.67.23,0-.46.46-.62,1.27-.55.49.05,1,0,1.51,0l2.24.18c0-.34,0-.58.84-.64a10.79,10.79,0,0,1,3.18.23c.56-.65,1.6-.67,2.69-.61l1.67.14c0-.83,0-1.65,0-2.49A.72.72,0,0,1,498.94,481.52Zm-29.3-18c-.2-2.25.24-4.5.23-6.75v-.38c0-.16,0-.33,0-.5l0-1.43c-.13-.43,0-.64,1-.63,6.23.07,12.47.1,18.71.16,1.46,0,2.91.06,4.36.09.45,0,.87,0,.78.37-.17,2.85-.33,5.7-.51,8.55,0,.59-.77.51-1.46.44l-5.43.15c-3,.08-6,.14-9,.14-2.44,0-4.87.25-7.31.16C470.44,463.91,469.72,464.08,469.64,463.56Zm22.44,15.35a43.1,43.1,0,0,1-5.82.49c-5.29.38-10.62.64-15.92,1-1.16.08-1.19-.12-.76-.59-.72-.61-.18-1.28-.31-1.91l0-.54a32.78,32.78,0,0,1,0-4.32v-.23c-.29-.37.1-.68.25-1l0-.36c0-.3,0-.6,0-.89s.27-.3.62-.31l15.56-.54a1.14,1.14,0,0,1,.7.14h1.77c.9-.59,2.12-.34,3.16-.29a7.85,7.85,0,0,0,2.09,0c0,2.1,0,4.2,0,6.3,0,.84-.15,1.68-.16,2.51C493.31,478.83,492.93,479,492.08,478.91Z"
            />
            <path
              class="cls-129"
              d="M432.63,450.58q-5.91-.12-11.83-.22L395.39,450c.17,3.13.33,6.25.52,9.38.14,2.31.34,4.62.5,6.93q.52,8.16,1,16.32c4.67-.09,9.29-.49,13.93-.74,7.33-.38,14.65-.83,22-1.25C432.6,470.61,433.3,460.59,432.63,450.58ZM420.14,463.5c-.44-.51-.27-1.06-.23-1.6l0-.37,0-3.65v-.34c0-.18,0-.36,0-.53a.15.15,0,0,1,0-.17c0-.23,0-.46-.05-.68a15.2,15.2,0,0,1,4.57-.13h.38c0,1.48.41,3-.17,4.44,0,1.07,0,2.14,0,3.21,0,.22.15.52-.47.55a35.3,35.3,0,0,1-3.56,0C419.7,464.23,420.09,463.79,420.14,463.5Zm4,17c-.52,0-1,0-1.55.06-2.08.09-2.08.09-2.09-1.07v-2.61c-.53-1.4,0-2.82-.31-4.23-.08-.36.29-.5.93-.52,1.18,0,2.37-.09,3.55-.14.48.16.5.42.47.68-.13,1.05.33,2.11-.25,3.14l0,.39a.62.62,0,0,1,0,1c0,.42,0,.84,0,1.26.22.11.21.21,0,.31,0,.13,0,.26,0,.39a.48.48,0,0,1,0,.83C425,480.3,424.75,480.48,424.16,480.5Z"
            />
            <path
              class="cls-130"
              d="M433.34,480.62c-.74-10,0-20-.7-30l20-.89q-.11,9-.2,17.94v2.76c0,3.85-.28,7.7-.1,11.55.06,1.39,0,1.39-2.44,1.24a1.71,1.71,0,0,0-.31,0,17.86,17.86,0,0,0-3-.63Zm3.4-7.94a66.14,66.14,0,0,0,0,7.18c0,.61.76.67,1.6.65,1,.21.89-.22.89-.51,0-2.42,0-4.85,0-7.28,0-.65-.81-.63-1.56-.7C436.62,471.93,436.74,472.33,436.74,472.68Zm0-8.36a4.89,4.89,0,0,1,.77,0c1.61.21,1.78-.23,1.79-1,0-2.4-.23-4.8-.29-7.21,0-.52-.42-.62-1.24-.64-1.48,0-.88.6-1.07,1l-.89-.45c0,2.57,0,5.13,0,7.69C435.79,464.05,435.91,464.34,436.71,464.32Z"
            />
            <path
              class="cls-132"
              d="M411.46,488.21c-4.9-1.1-9.83-2.17-14.7-3.31l-.65-.14-.65-.13a23.25,23.25,0,0,1-3.19-.77l-.57-.23h-.15l-.1,0-.09,0-.08,0a.55.55,0,0,1-.23-.12l-.09-.09a.79.79,0,0,1-.13-.5c-.23-3.45-.46-6.9-.71-10.35q-.63-8.39-1.28-16.77l-.6-7.73c-4.15.32-8.3.68-12.46.94-1.7.1-2.88.35-2.79,1.45,0,0-.13.08-.2.13h0a2.39,2.39,0,0,0,.13.21c.53,1.16.26,2.36.41,3.53.06.58-.79.34-1.24.35h-3.35v.18H372c.87,0,1.6.07,1.56.68-.19,3.1.75,6.18.65,9.27a10.75,10.75,0,0,1,.51,4.62,42.78,42.78,0,0,1,.49,6.18l2.52-.06v-.15c-.12-1.3-.26-2.6-.36-3.9,0-.31-.14-.64.23-.93a60.37,60.37,0,0,1,7.91.84c.52.06.67.26.54.52s-.53.1-.85.08a24,24,0,0,1-5.75-.76,7,7,0,0,0-1.6,0l.18,1.39h.32c.35-.48.62-.2.91,0h.31a3.23,3.23,0,0,1,2.22.38l1.18.17c.73-.07,3.08.59,3.24,1s-.39.18-.66.21c0,.53.63.54,1.34.51s1.2.08,1.24.46-.63.37-1.12.4a3.34,3.34,0,0,0-1.66.34l.52.23a3.31,3.31,0,0,1,.42,0,5.68,5.68,0,0,1,.19,2.68.18.18,0,0,1-.13,0,1.09,1.09,0,0,1-.25-.1l-.65,0c-.73-.06-1.54,0-1.84-.54-.52,0-1,.3-1.56,0a6.25,6.25,0,0,0-1.73-.34c-.54,0-.74-.17-.62-.45s-.1-.68-.27-1l-.08,0c-.47-.27-.21-1.16-1.66-.6.64,0,.74.28.68.55-.1.47.29.94-.18,1.43-.64-.62-.36-1.32-.5-2l-2.19.08c.11,1.78.21,3.56.32,5.34,1,.6.64,1.31.57,2,2.24-.08,3.94.71,5.83,1.16a8.14,8.14,0,0,1,3,1,20,20,0,0,1,5.09,1c1.17.43,1.2.93.31,1.5-.58.58.21.76.9.95,2.74.75,5.48,1.5,8.24,2.23,4,1.07,7.89,2.29,12,3.2C411.65,492.29,411.56,490.25,411.46,488.21Zm-26.94-24.9-2-.19h0l-.11-.09-.09,0a.71.71,0,0,0-.2,0c-.35,0-.75.08-1.07,0a4.73,4.73,0,0,1-1.91,0h-1.2a.87.87,0,0,1-.93,0c-.46,0-.57-.18-.6-.41-.2-2.18-.42-4.36-.61-6.53,0-.1.15-.21.23-.3a1.26,1.26,0,0,1,.8-.22c2.23.05,4.43-.12,6.65-.19.74,0,1.27,0,1.35.57s-.56.6-1.22.61l-6.91,0c0,.46,0,.92,0,1.39l.55,0h0l.09-.06,0,0h0l.08,0h.25a.67.67,0,0,1,.28.14l.5,0,.13-.06a2.67,2.67,0,0,1,.26-.09l.34-.06h.33a4.55,4.55,0,0,1,1.07.19c.41.2.82.4,1.3,0a2.76,2.76,0,0,1,2.13,0,.85.85,0,0,1,.71.81,17.36,17.36,0,0,0,.29,4.06C385.14,462.94,385.52,463.42,384.52,463.31Zm-.74-6.19c-.13.27-.52.26-.88.25s-.81,0-.74-.29.45-.21.75-.21S383.66,456.86,383.78,457.12Zm-3.46.06c-.16.23-.55.21-.88.19s-.79-.08-.63-.35.59-.15.92-.14S380.35,456.93,380.32,457.18Z"
            />
            <path
              class="cls-110"
              d="M391.7,483.63c-.84-.08-.85-.43-.87-.79-.23-3.45-.46-6.9-.71-10.34q-.63-8.4-1.28-16.78l-.6-7.73c2.16-.41,4.25.08,6.37.16.52,0,.5.32.54.55.07.43.16.85.24,1.28.17,3.13.32,6.25.52,9.37.14,2.32.34,4.63.49,6.94q.54,8.16,1,16.32c0,.45-.48.57-1.16.64C394.76,483.41,393.19,483.36,391.7,483.63Z"
            />
            <path
              class="cls-133"
              d="M449.55,483.21a1.71,1.71,0,0,1,.31,0c2.45.15,2.5.15,2.44-1.24-.18-3.85.1-7.7.1-11.55a3.44,3.44,0,0,0,0-2.76q.1-9,.2-17.94a3.18,3.18,0,0,0,0-.69c-.19-.79.44-1.1,1.83-1.09s2.55-.25,3.85-.15c0,1.85-.05,3.7-.07,5.56-.1,6.17-.12,12.34-.31,18.51-.12,4.05-.22,8.1-.21,12.16,0,.45.15,1-1.24.83a13,13,0,0,0-3.08-.56A11.06,11.06,0,0,1,449.55,483.21Z"
            />
            <path
              class="cls-129"
              d="M372.92,450.72l-3.84-.06,0-.19,3.69,0h0A2.39,2.39,0,0,0,372.92,450.72Z"
            />
            <path
              class="cls-129"
              d="M380.8,475.69l-.67.05c-1.38-.09-.51.49-.72.76l-.08,0c-.47-.27-.21-1.16-1.66-.6h0l-2.19.08a28.91,28.91,0,0,0-4.08.38l-2.13.11-.68.12-1,.15a4.92,4.92,0,0,1-.81.12l0-.42.22,0,.38-.12.84-.2.93-.06c1.92,0,3.76-.3,5.63-.47h.34l2.52-.06c.5,0,1.05.07,1.34-.26l.35,0c.06.38.44.18.74.13l.59,0C380.75,475.47,380.78,475.58,380.8,475.69Z"
            />
            <path
              class="cls-117"
              d="M500.77,454c-.24-1.36.23-2.69.37-4a13.58,13.58,0,0,1,4.29-.34c1.44.49,2.94-.08,4.4.08.22,1.42-.5,2.83-.27,4.25l-.37.05Z"
            />
            <path
              class="cls-109"
              d="M519.15,449c0,.13,0,.3-.3.29-.1,0-.2-.14-.3-.22Z"
            />
            <path
              class="cls-117"
              d="M537.07,471.68c-.59.31-1.84.24-1.75,1,0,.13-.43.26-.75.2s-.35-.26-.25-.42.5-.45,0-.67a2.3,2.3,0,0,0-1,.1c-.6.55-1.76,0-2.44.38.72,0,1.44,0,2.15,0s.86.35.33.51a7.46,7.46,0,0,1-3.24.19c-.36-.05-.2-.35-.17-.54a3.46,3.46,0,0,0-2.18,0c.52.08,1.43-.18,1.43.35s-.89.31-1.44.36a6.48,6.48,0,0,1-.76,0c0,.13-.07.26-.11.39a1.62,1.62,0,0,1,.31,0c.58,0,1.41-.2,1.65.21s-1,.19-1.16.6c1,0,1.22.15,1.09.74a37.64,37.64,0,0,0-.39,4c0,.37.37.85-.54,1.07s-1-.41-1.61-.51c-.12,1.08.08,1.18,1.92,1,.91-.08,1.83-.16,2.76-.22,4-.23,7.86-.69,11.85-.79.38-2.73.76-5.47,1.13-8.2A66.48,66.48,0,0,0,537.07,471.68Zm-5.46,1.58c.61.13,1.71-.18,1.75.25s-1.06.3-1.66.32-1.89.32-1.91-.27S531,473.41,531.61,473.26Zm-2.47,6.52s-.13-.11-.1-.14a1,1,0,0,1,.28-.14c0,.07.08.14.06.21S529.23,479.76,529.14,479.78Zm3.33-.31c-.43,0-.32-.25-.47-.39a4.36,4.36,0,0,0-.57-.39c-1,.15-.41.63-.81,1.11-.13-.48.08-1-1-.94-.44,0-.36-.22-.35-.39.13-1.21.15-2.42.4-3.62.16-.8,1.47-.6,2.43-.67.78-.05,1.37,0,1.27.58A22.55,22.55,0,0,0,533,479C533,479.21,533,479.46,532.47,479.47Zm2.48-4.73a14.74,14.74,0,0,0-.36,3.62,1.86,1.86,0,0,1-.17.86c-.09.2-.13.51-.73.44s-.31-.33-.3-.31c.2-1.7.36-3.19.57-4.69,0-.27.15-.67.84-.58S535,474.51,535,474.74Zm3.4,4.56c-.91.09-1.84.14-2.76.21-.5,0-.66-.11-.6-.36a22.78,22.78,0,0,0,.58-4.41c0-.29.13-.73.86-.72a10.76,10.76,0,0,1,2.89-.1c.32.08.24.3.11.47.12,1.47-.61,2.92-.25,4.4C539.27,479.15,538.81,479.25,538.35,479.3Zm.82-5.83-1.9.19c-.52-.06-1.24.11-1.28-.23s.73-.27,1.17-.32c.61-.06,1.22-.11,1.84-.15.3,0,.68,0,.75.2S539.48,473.44,539.17,473.47Zm.08-.87-1.85.2c-.65-.08-1.47.13-1.49-.36s.79-.33,1.3-.38,1.23-.13,1.84-.16c.32,0,.82-.09.88.21S539.75,472.55,539.25,472.6Zm2.58,5.82c-.16.66-.82.66-1.6.65-1.2,0-.39-.45-.37-.67.07-1.27.21-2.54.33-3.81,0-.31-.1-.66.56-.84a2.32,2.32,0,0,1,1.2-.06c.74.21.33.61.48,1C541.88,475.88,542.16,477.16,541.83,478.42Zm-1.13-5.08c-.18-.08-.16-.23,0-.3a3.3,3.3,0,0,1,2,.09C541.84,473.37,541.32,473.58,540.7,473.34Z"
            />
            <path
              class="cls-117"
              d="M541.82,485.32H541c-.11,0-.16,0-.16.08-.05.38.27.84-.64,1-.5.11-1.17.26-1.44-.16s0-.68.78-.77l1.05-.1c-.1-.21-.41-.28-.72-.23a31.25,31.25,0,0,0-4,.49c.47.29,1,0,1.45,0s1,.06,1.05.45-.17.55-.86.58-1.33.1-2,.15-1.18.07-1.42-.33.32-.47.83-.58c.15,0,.24-.17.35-.26a4,4,0,0,0-1.89.17c.29.38.57.76,0,1.12a.73.73,0,0,1-.7,0c-.49-.36,0-.71.12-1.06a1.46,1.46,0,0,0-1,.13c.29.38.66.87-.11,1.08a5.3,5.3,0,0,1-2.95.23c-1-.32,0-.73.29-1.09-1.09.11-2.3-.06-3.23.42.3,0,.6,0,.9,0,.55,0,1,.06,1,.46s-.41.39-.9.44-.88.13-1.31.2c0,.09,0,.19,0,.29l.92-.06c.44,0,1-.22,1.17.15s-.26.58-1,.63c-.46,0-.91.1-1.37.15,0,.13,0,.26,0,.39a5.51,5.51,0,0,1,2.07.13c.44.18.59,0,.74-.14l.08-.08.09-.07.06,0a.51.51,0,0,1,.31,0,3.67,3.67,0,0,1,1.56-.15l.95-.19c.35,0,.65.16.58.34-.54,1.3.07,2.65-.6,3.94,0,.08-.18.14-.28.2-.84,0-1.78.62-2.51-.12h0c-.83,0-.86-.22-.74-.61a3.72,3.72,0,0,0-.14-2.48c-.12.76-.3,1.53-.35,2.29-.07,1.36,0,1.36-2.41,1.64-.16.46.22.58,1,.49,2.33-.28,4.65-.57,7-.83a79.35,79.35,0,0,1,8.23-.87c0-.23,0-.45,0-.68-.62-.36-.26-.81-.35-1.21s.14-.63-.32-.89l0,1.22c-.07.41.31.94-.91,1-.94.09-1.34-.13-1.28-.65.13-1,.23-2.05.33-3.08,0-.45.58-.56,1.25-.59s.93.15.91.5,0,.78,0,1.29c.77-.57-.27-1.29,1-1.64l.06-.34c-.43-.72-.85-1.44.26-2.1Zm-12.74,3.32c-.32,0-.75,0-.9-.21s.12-.4.47-.48a16.4,16.4,0,0,1,4.1-.35c.36,0,.58.15.55.35a.4.4,0,0,1-.3.26C531.71,488.37,530.4,488.5,529.08,488.64Zm4.23.4c-.54,1.31.12,2.7-.91,4-.55-1.29-.26-2.59-.28-3.88,0-.25.11-.48.68-.46C533.19,488.69,533.38,488.87,533.31,489Zm3.67,3.52a15.34,15.34,0,0,1-3.19.31c-.81,0-.2-.54-.51-.79a7.44,7.44,0,0,0,.39-3c0-.48.46-.57,1.18-.6,1-.05,1.93-.15,2.9-.23,0,.51,0,1,0,1.53a3.77,3.77,0,0,1-.26,1.81C537.29,491.89,537.79,492.41,537,492.56Zm2.85-5c-1.6.07-3.17.25-4.72.46-.4.06-.88.14-1-.17s.32-.46.78-.51c.8-.1,1.62-.17,2.56-.26.8.53,1.36-.19,2.13-.2.43,0,1-.12,1.17.23S540.32,487.55,539.83,487.57Z"
            />
            <path
              class="cls-117"
              d="M542.67,459.65a25.26,25.26,0,0,0-4.17-.07c-.42,0-1,.23-1-.21s.38-.53,1-.53l6,0,.06-.36a5.47,5.47,0,0,1-1.49-.06c-.73-.26-.69-.58.21-.77h2.43l0-.35h-.6a3.9,3.9,0,0,1-1.64.16l-14.63,0a.32.32,0,0,0,0,.14c.73.15,2.11-.28,2.12.43s-1.42.31-2.19.45h-.15l0,.38c.47,0,.93,0,1.4,0s.93-.07.88.3-.2.52-.8.54l-1.55.05c0,.09,0,.18,0,.28,2.46.1,2.52.11,2.17,1.47a5.25,5.25,0,0,0-.21,2.15c.1.69-.2,1.22-1.31,1.57a28.55,28.55,0,0,0,3.7,0l11.87-.3c.24-1.92.47-3.85.71-5.77l-.63,0C544.47,459.81,543.51,459.74,542.67,459.65Zm-2.81-2c.73,0,2.09-.35,2.08.41s-1.4.25-2.11.45c-.7-.21-2.1.32-2.08-.46S539.12,457.64,539.86,457.64Zm-4.39,3.49a12.72,12.72,0,0,0-.35,3.24c0,.15-.06.3-.38.32s-.47-.17-.51-.34.07-.59-.35-.82a.86.86,0,0,1-.26.9c-.28.74-1.33.51-2.14.48s-.69-.52-.67-.83c.08-1.07.17-2.14.34-3.2.07-.38.11-.87,1.21-.81h1.23C535.53,460,535.56,460,535.47,461.13Zm-.79-1.44h-2.19c-.46,0-1,0-1-.37s.5-.43,1-.46c.73,0,1.46,0,2.18,0,.53,0,1.11,0,1.12.42S535.23,459.7,534.68,459.69Zm1.75,4.38c-.07.18.11.4-.56.65a14.79,14.79,0,0,1,0-4.05c0-.21.07-.61.73-.53s.22.37.18.58A17.39,17.39,0,0,1,536.43,464.07Zm.14-5.17c.4,0,.43.18.44.36s-.06.36-.45.37-.45-.19-.44-.37S536.18,458.9,536.57,458.9Zm.53-.54a.85.85,0,0,1-.9-.14c-.08-.06-.05-.38-.42-.1-.94.72-2.25.27-3.38.31-.44,0-.71-.22-.65-.49s.41-.31.79-.32h4c.41,0,.72.09.72.34A.39.39,0,0,1,537.1,458.36Zm4.51,3.58a10.08,10.08,0,0,0-.45,2.14c0,.47-.32.71-1.2.67h-.15c-2.82.08-2.82.08-2.77-1.77.08-.61.21-1.5.3-2.39,0-.35.31-.5.94-.55C541.44,459.78,542.16,460.19,541.61,461.94Zm2.93-.92a11.84,11.84,0,0,0-.38,2.67c-.09.56-.39,1.18-1.74,1s-.66-.76-.6-1.16a13,13,0,0,0,.49-2.75c0-.54.3-.76,1.34-.77C544.94,460,544.53,460.48,544.54,461Z"
            />
            <path
              class="cls-116"
              d="M528.66,489.15a.51.51,0,0,0-.31,0l-.06,0-.09.07-.08.08c-.15.16-.3.32-.74.14a5.51,5.51,0,0,0-2.07-.13c-.81,1.25-.21,2.54-.34,3.82.37.24.27.42-.24.54,0,.1,0,.19,0,.29,2.37-.28,2.34-.28,2.41-1.64,0-.76.23-1.53.35-2.29a3.72,3.72,0,0,1,.14,2.48c-.12.39-.09.62.74.61.14-1.06.22-2.12.43-3.17A1.89,1.89,0,0,0,528.66,489.15Zm-2.78,4.21c-.35-.36-.4-.72,0-1.24C526.27,492.64,526.25,493,525.88,493.36Z"
            />
            <path
              class="cls-116"
              d="M526.84,473.5c.11,0,.21,0,.31,0,.57,0,1.41-.2,1.65.21s-1,.19-1.16.6c1,0,1.22.15,1.09.74-.28,1.31-.24,2.64-.39,4,0,.37.37.85-.54,1.07s-1-.41-1.61-.51l0-.31c.37-.09.62-.2.11-.37Z"
            />
            <path
              class="cls-116"
              d="M528.53,460c2.47.09,2.52.11,2.17,1.47a5.43,5.43,0,0,0-.22,2.15c.11.69-.19,1.22-1.3,1.57-.58,0-1.24.12-1.22-.38A27,27,0,0,1,528.53,460Z"
            />
            <path
              class="cls-116"
              d="M535.84,485.66c.47.29,1,0,1.45,0s1,.06,1.05.45-.17.55-.86.58-1.33.1-2,.15-1.19.07-1.42-.33.32-.47.83-.58c.15,0,.24-.17.35-.26Z"
            />
            <path
              class="cls-116"
              d="M531.78,486c.29.38.66.87-.11,1.08a5.4,5.4,0,0,1-2.95.24c-1-.33,0-.74.29-1.1l.9-.05c.43.22.76.19,1-.12Z"
            />
            <path
              class="cls-115"
              d="M545.14,457.26a3.74,3.74,0,0,1-1.64.15l-14.63,0c.34-.33.91-.21,1.4-.21Z"
            />
            <path
              class="cls-116"
              d="M525.78,486.66c.3,0,.6,0,.9,0,.55,0,1,.06,1,.46s-.41.39-.9.44-.88.13-1.32.2C525,487.38,525.1,487,525.78,486.66Z"
            />
            <path
              class="cls-116"
              d="M528.61,458.85c.47,0,.94,0,1.4,0s.93-.07.88.3-.19.52-.8.54l-1.55.05C528.06,459.43,528.7,459.15,528.61,458.85Z"
            />
            <path
              class="cls-116"
              d="M528.86,457.6c.73.15,2.11-.28,2.12.43s-1.42.31-2.18.45h-.16A.86.86,0,0,1,528.86,457.6Z"
            />
            <path
              class="cls-116"
              d="M540.84,485.39c-.05.38.27.85-.64,1-.5.11-1.17.26-1.44-.16s0-.68.78-.77l1.05-.1A.52.52,0,0,1,540.84,485.39Z"
            />
            <path
              class="cls-116"
              d="M525.5,488.1c.31,0,.62,0,.92-.06s1-.22,1.17.15-.26.58-1,.63c-.46,0-.91.1-1.37.15C525.35,488.68,525.43,488.39,525.5,488.1Z"
            />
            <path
              class="cls-115"
              d="M537.07,471.68c-.59.31-1.84.24-1.75,1,0,.13-.43.26-.75.2s-.35-.26-.25-.42.5-.45,0-.67Z"
            />
            <path
              class="cls-115"
              d="M533.27,471.85c-.6.55-1.75,0-2.44.38a1.53,1.53,0,0,1-.93.2,3.46,3.46,0,0,0-2.18,0h-.39c-.2-.39.3-.34.7-.35Z"
            />
            <path
              class="cls-116"
              d="M527.33,472.43h.39c.52.08,1.43-.18,1.43.35s-.89.32-1.44.36a6.48,6.48,0,0,1-.76,0C527,472.88,526.87,472.6,527.33,472.43Z"
            />
            <path
              class="cls-116"
              d="M533.35,485.86c.29.38.57.76,0,1.12a.73.73,0,0,1-.7,0c-.49-.36,0-.71.12-1.06Z"
            />
            <path
              class="cls-117"
              d="M525,493.18c.37.24.27.42-.24.54C524.65,493.52,524.61,493.32,525,493.18Z"
            />
            <path
              class="cls-117"
              d="M530.89,486.07c-.22.31-.55.34-1,.12A1.52,1.52,0,0,1,530.89,486.07Z"
            />
            <path
              class="cls-115"
              d="M541.82,485.32H541a1.59,1.59,0,0,1,1-.36C542.12,485.1,542.06,485.23,541.82,485.32Z"
            />
            <path
              class="cls-117"
              d="M526.33,478.88c.51.17.26.28-.11.37C526.26,479.13,526.3,479,526.33,478.88Z"
            />
            <path
              class="cls-117"
              d="M509.77,469c-1.17,0-1.59-.19-1.52-.83s0-1.44,0-2.16c-2.4-.2-4.81-.16-7.22-.18a5,5,0,0,1-1-.18c-.82,1-.44,2-.45,3L507,469c.15,0,.28,0,.41,0l.14,0h0l.11,0,.07,0,.07,0,0,0,0,0a.1.1,0,0,1,0,.05.11.11,0,0,1,0,.07.42.42,0,0,1,0,.19l.05.07.06.09h0l.41,0h.23l.13,0,.07,0,.09,0,.05,0,0,0s0,0,0,0l.06.08a.07.07,0,0,1,0,.05.2.2,0,0,1,0,.11c0,.46-.61.53-1.18.64l-.06.33h0c.57,0,1.21,0,1.15.46s-.31.72-1.18.72l-.25,0,0,.35.3.19c.64-.2,1-.12,1,.31-.13,1.84-.18,3.68-.45,5.51a17.53,17.53,0,0,0-.13,2.5c0,.51-.29.77-1.25.72h0c0,.49-.52.56-1.24.48l-6.92-.83a.72.72,0,0,0-.59.82c0,.84,0,1.66,0,2.49a13.63,13.63,0,0,0,5.28.38,6.54,6.54,0,0,1,1.6.14c.89.46.63,1.26-.48,1.48s-2.18.09-3.16.4c1.65.11,3.16.58,4.86.59.55-1.42.35-2.87.55-4.31.12-.78.57-1.06,1.87-1.14,2.21-.14,4.4-.34,6.6-.51.15-1.59.3-3.18.44-4.77l.75-8.32C514.35,468.84,512.05,468.88,509.77,469Zm.88.58c1.43-.1,2.88-.17,4.32-.23.56,0,.84.16.84.48s-.15.51-.76.54l-3.24.21s0,0,0,0h-.93c-.52,0-.95,0-1-.4S510.14,469.59,510.65,469.56Zm5.14,1.85c0,.37-.35.49-1,.51-1.13.05-2.26.13-3.34.2-.59-.13-1.56.4-1.64-.39s.79-.66,1.63-.69c1.08,0,2.16-.12,3.23-.16C515.38,470.85,515.81,471,515.79,471.41Zm-.84,8.95c0,.87-.69,1.12-2,1.14a17,17,0,0,0-2.16.08c-1.38.21-2.06,0-1.68-1.05.16-2.19.33-4.62.49-7,0-.55.38-.86,1.47-.87s2.38-.11,3.57-.17c.84,0,1.17.11,1.1.65C515.38,475.52,515.07,477.94,515,480.36Z"
            />
            <path
              class="cls-116"
              d="M516.75,463.74v.32c-.09.1-.28.2-.27.29.15,1-.8,1.18-2.27,1.12-.82,0-1.64,0-2.46,0-.5,0-1.06-.05-1.31.3h-.57c.09-.78.23-1.55.28-2.33a44.19,44.19,0,0,0,.33-5.63c-.05-.7.5-1.16,1.87-1.19s2.69,0,4,0c.92,0,.92.32.87.7-.2,1.61-.42,3.22-.52,4.84C516.71,462.67,516.43,463.21,516.75,463.74Z"
            />
            <path
              class="cls-110"
              d="M506.43,487.82c.56-1.42.36-2.87.57-4.31.11-.78.56-1.06,1.86-1.14,2.21-.14,4.4-.34,6.6-.51.43.16.33.42.3.64-.13,1.35-.29,2.71-.45,4.07,0,.25.06.55-.6.6C511.94,487.36,509.25,487.83,506.43,487.82Z"
            />
            <path
              class="cls-110"
              d="M509.56,453.93c-.23-1.42.49-2.83.27-4.25l8.07.12c.5,0,1,0,.93.4-.13,1.15-.26,2.31-.4,3.46,0,.14-.17.27-.44.33Z"
            />
            <path
              class="cls-110"
              d="M509.87,465.78h7a3,3,0,0,1-.17,3c-2.29.07-4.59.11-6.89.21-1.16,0-1.58-.19-1.52-.83s0-1.44,0-2.16a.17.17,0,0,0,0-.15l.92-.06A.46.46,0,0,0,509.87,465.78Z"
            />
            <path
              class="cls-109"
              d="M504.08,499.78c.1.78-.5,1.17-1.95,1.08.35-4.18.69-8.37,1-12.69.76.33,1,.75,1.75.66l.1.58Z"
            />
            <path
              class="cls-114"
              d="M474.37,489.92c-.07-.32.13-.49.74-.53,4.42-.33,8.78-.92,13.24-1.07a13.53,13.53,0,0,1-.28,3h-.26a.14.14,0,0,0-.08.07,23.59,23.59,0,0,1-.28,3.55c-.22.85-1.47.58-2.3.69-1,.13-.81-.38-.83-.7a6,6,0,0,1,.27-2.25,2,2,0,0,0,1.82.63c.86-.15.64-.66.7-1.05.16-.92.29-1.84.51-2.76.1-.46-.07-.63-1-.58-1.49.07-2,.51-2,1.3,0,.42.25.88-.29,1.26-.64-.49-.35-1.06-.3-1.59.06-.71-.44-.81-1.54-.68-2.19.28-4.47.32-6.63.71Z"
            />
            <path
              class="cls-109"
              d="M489.16,495.21c.06-1.33.12-2.65.17-4,0-.45.63-.44,1.19-.51,3.32-.45,3.21-.45,3.19,1.44,0,.8-.54,1.6,0,2.4A27.49,27.49,0,0,1,489.16,495.21Z"
            />
            <path
              class="cls-117"
              d="M489.16,495.21a27.49,27.49,0,0,0,4.52-.65c.65.53.06,1.19.59,1.73l-.87,0a.65.65,0,0,0-.08-.17c-.13-.29.58-.93-.89-.67l-.65.18c-.3-.16-.6-.27-.88,0a.31.31,0,0,1-.09.14c-.37-.06-.89-.37-.88.17,0,.25.2.54-.54.56a2.9,2.9,0,0,1-.52-.12c.12-.79-.85-.38-1.4-.4-.72,0-1.09.16-1,.57s-.23.81.59.88,1.58.08,2-.44l.54.37,0,.41-2.58.39a3.81,3.81,0,0,1-.56-.14c-.38-.16-.05-.64-1.25-.46s-.68-.76-1.1-1.17c-.55.16-.07.37-.18.53s.37.59-.39.61-.78-.3-.82-.61.15-.7-.36-1c.18-.37,1.42-.13,1.29-.68.09-1.24-.23-2.49.59-3.69.47.32.24.7.32,1.05a6,6,0,0,0-.27,2.25c0,.32-.18.83.83.7.83-.11,2.08.16,2.3-.69a23.59,23.59,0,0,0,.28-3.55.14.14,0,0,1,.08-.07h.26l0,3.82c.2.29.56.18.9.11A.22.22,0,0,0,489.16,495.21Z"
            />
            <path
              class="cls-109"
              d="M508.41,499.43l-1.72.2q.45-5.2.92-10.39l.11-.23c1.22-.11,1.66.17,1.58.86-.34,2.78-.62,5.57-.91,8.35A9.77,9.77,0,0,0,508.41,499.43Z"
            />
            <path
              class="cls-117"
              d="M517.68,455c.54-.25.18-.59.23-.88h-8.42c.34.2,1.09.24.89.68s-.49.55-1.15.55v.15c.5,0,.91.1.9.45s-.42.42-.93.43a1.23,1.23,0,0,1,0,.19c1.19,0,1,.49.92.87-.51,1.92-.09,3.87-.55,5.8a21.26,21.26,0,0,0-.32,2.51.46.46,0,0,0,.64,0c.09-.78.23-1.55.27-2.33a40.72,40.72,0,0,0,.34-5.63c-.05-.7.5-1.16,1.87-1.19s2.69,0,4,0c.93,0,.92.32.87.7-.21,1.61-.42,3.23-.52,4.84,0,.53-.31,1.07,0,1.6.5-.18.32-.46.34-.71C517.29,460.36,517.48,457.7,517.68,455Zm-1,1.35h-4.81c-.54,0-1.09,0-1.07-.43s.48-.39,1-.4c1.66,0,3.3,0,5,.11.37,0,.57.08.57.3S517.13,456.37,516.69,456.38Zm-1-1c-1.3,0-2.6,0-3.9,0-.59,0-1-.09-1-.48s.26-.54.92-.54c1.56,0,3.11,0,4.67,0,.89,0,1.12.32,1.28.7A3.69,3.69,0,0,1,515.69,455.36Z"
            />
            <path
              class="cls-113"
              d="M493.4,496.31l.87,0c1,.16,2,.33,3,.45s1.14.38.61.83c-.56-.19-.68.28-1.14.24-.33-.68-1.27-.94-2.72-.76l-.92,0Z"
            />
            <path
              class="cls-117"
              d="M516.82,465.78h-6.38c.25-.35.81-.29,1.31-.3.82,0,1.64,0,2.46,0,1.47.06,2.42-.16,2.27-1.12,0-.09.18-.19.27-.29C516.77,464.63,516.8,465.21,516.82,465.78Z"
            />
            <path
              class="cls-113"
              d="M507.72,489l-.11.23-2.59.17-.1-.58C506.69,488.31,507.33,488.35,507.72,489Z"
            />
            <path
              class="cls-119"
              d="M517.91,454.15h-8.72V454l.37-.05L518,454A.23.23,0,0,1,517.91,454.15Z"
            />
            <path class="cls-109" d="M489,495.22c-.34.07-.7.18-.9-.11Z" />
            <path
              class="cls-109"
              d="M390.26,486.45c1.17.43,1.2.93.31,1.5-2.43.13-4.88.13-7.26.48l-.59,0c-.82-.11-1.6.3-2.43.06-.11-1.25-.1-1.26,2.16-1.26a14,14,0,0,0,2.76-.21C386.84,486.66,388.72,487.05,390.26,486.45Z"
            />
            <path
              class="cls-114"
              d="M396.4,498.32c-.53.18-.74.68-1.62.53-.09-1.34-.18-2.69-.28-4,.45-1.3-.42-2.58-.21-3.88,0-.25-.32-.67.52-.67.66,0,.7.35.72.66l.36,4.15a10.85,10.85,0,0,0,0,1.61c.05.39-.43.87.5,1.14Z"
            />
            <path
              class="cls-111"
              d="M382.72,488.41l.59,0c.19,1.83.49,3.67.5,5.5,0,.72,1,.94,1.42,1.42a1.83,1.83,0,0,1-.92-.13c-.92-.32-1.23-.75-1.25-1.36-.05-1.76-.26-3.51-.41-5.27Z"
            />
            <path
              class="cls-117"
              d="M394.5,494.81c.1,1.35.19,2.7.28,4-.5,0-.75-.14-.77-.42-.1-1.18-.22-2.36-.3-3.54,0-.13.18-.26.27-.39Z"
            />
            <path
              class="cls-114"
              d="M386.18,490.87c0,.17,0,.34,0,.51h-.91c0-.74,0-1.49,0-2.24,0-.19,0-.46.42-.49s.53.24.51.43C386.09,489.69,386.62,490.28,386.18,490.87Z"
            />
            <path
              class="cls-115"
              d="M396.42,497.82c-.93-.27-.45-.75-.5-1.14a10.85,10.85,0,0,1,0-1.61c.63,0,.87.17.91.48C396,496.27,396.75,497.07,396.42,497.82Z"
            />
            <path
              class="cls-109"
              d="M385.23,491.39h.91c0,.58.48,1.17,0,1.75-.87,0-.91-.35-.9-.71S385.24,491.74,385.23,491.39Z"
            />
            <path
              class="cls-119"
              d="M373.4,496.11l0,.31a1.37,1.37,0,0,0,0,.19,36.75,36.75,0,0,0-8.16,1H365l.13-1.48,5.4-.43c.18.35.44.5.94.14l.8-.12Z"
            />
            <path
              class="cls-111"
              d="M467.49,487.14a3,3,0,0,1,.61.05c1.44.37,2,.16,1.82-.75-.11-.59.95-.78,2.82-.57-.75,1.14-.52,2.36-.53,3.52-.08,4.76-.66,9.53-.37,14.3a7.5,7.5,0,0,1-2.49.3l-.05-.33c-.33-.41.72-1-.61-1.3a.55.55,0,0,0-.26,0l-.64,0c.07-.46.7-.45,1.28-.49.61-.27.15-.64.29-1,.29-.65-.68-1.33.12-2a1.42,1.42,0,0,0,0-1.27l0-.37a7.55,7.55,0,0,0,.07-3l0-.7c.63-.74,0-1.5.06-2.25v-.38a1.16,1.16,0,0,0,.23-1.19c1,0,1.32-.34,1.37-.84s-.64-.92-1.51-1A3.68,3.68,0,0,1,467.49,487.14Z"
            />
            <path
              class="cls-118"
              d="M503.62,485.21a13.63,13.63,0,0,1-5.28-.38l-1.67-.14c-1.09-.06-2.13,0-2.69.61.34.61.07.87-1.16.7-.94-.14-1.91-.2-2.86-.29l-2.24-.18.65.72h.87c.16-.07.36-.2.48,0s-.21.17-.41.19a1.1,1.1,0,0,0,0,.18h0l.55.11c2.65-.22,5.31-.41,7.94-.69,2.47-.26,5-.2,7.43-.66A6.54,6.54,0,0,0,503.62,485.21Zm-8.51.81-.2-.07.12-.05.19.08S495.13,486,495.11,486Zm.22-.52-.11,0a.68.68,0,0,1,.2-.07s.07,0,.11,0Z"
            />
            <path
              class="cls-117"
              d="M481.29,497.79l-.12.1-3.69.38c-1,0-2.06.06-2-.78,0-.12-.15-.23-.38-.22s-.36.16-.38.31c-.11.7-.09,1.36,1.47,1.58a.58.58,0,0,1,.15.11,11.87,11.87,0,0,0-2.42.35c.06-1.13.11-2.27.17-3.4,1.94-.21,1.94-.21,1.81-1.79.56-.7.11-1.44.29-2.15h.63c0,.94,0,1.89-.05,2.83-.3.33-.19.68-.14,1a6.73,6.73,0,0,0-.09.77c0,1,.14,1.06,1.83.86l2.58-.28Z"
            />
            <path
              class="cls-118"
              d="M480.22,486.58c.51-.89,1.74-.89,3-.75.56.06,1.11.15,1.67.23s1.18-.39,1.53.16l-.28.14a1.16,1.16,0,0,0,.91-.13l1.12.17,1.07.18h0s0,.09,0,.13c-1,.11-2,.24-3.05.32a7.28,7.28,0,0,1-2.87-.11c-.5-.16-.77-.36-.68.22,0,.22-1.2.07-1.84.13h0c0-.23-.25-.34-.64-.37Z"
            />
            <path
              class="cls-114"
              d="M475.88,494.43c.13,1.58.13,1.58-1.81,1.79a16.35,16.35,0,0,1,.26-4.93l1.24.19C475.64,492.46,475.32,493.46,475.88,494.43Z"
            />
            <path
              class="cls-111"
              d="M480.22,486.58v.34c0,.23.24.34.64.37h0a3.55,3.55,0,0,1-1.57.18.66.66,0,0,0-.52-.13s-.05.05-.07.07l.6.06c-1.48.23-3,.69-4.41-.06-.27-.14-.25-.3-.28-.47.29,0,.75.16.85,0,.64-1.21,2.22-.64,3.51-.59C479.42,486.32,479.7,486.62,480.22,486.58Zm-4,.68.2-.07-.11-.05-.21.07Z"
            />
            <path
              class="cls-119"
              d="M473.9,499.62a11.87,11.87,0,0,1,2.42-.35l2,.36.09.18a12.22,12.22,0,0,1-4.58.42A.43.43,0,0,1,473.9,499.62Z"
            />
            <path
              class="cls-116"
              d="M475.57,491.48l-1.24-.19c0-.46,0-.92,0-1.37l1.48,0,.34.35c0,.4,0,.8-.07,1.2Z"
            />
            <path
              class="cls-111"
              d="M474.31,486.41v.33C474,486.64,474.06,486.52,474.31,486.41Z"
            />
            <path class="cls-111" d="M489.29,486.72s0-.09,0-.13l.55.11Z" />
            <path class="cls-119" d="M474,501.21h-.29l0-.18Z" />
            <path
              class="cls-115"
              d="M430.19,492.84q2.79-.36,5.66-.48c0,.3,0,.6,0,.9v2.23c0,.84,0,1.68,0,2.52,0,.43-.3.65-1.1.63h-.15c-3.84.14-4.28-.17-3.74-2.61l-.35-1.24,0-1A1.1,1.1,0,0,0,430.19,492.84Z"
            />
            <path
              class="cls-116"
              d="M430.52,494.79l.35,1.24c-3.44.84-6.9.2-10.33.16a33.23,33.23,0,0,1,3.75-2.8,51.93,51.93,0,0,1,5.9-.55,1.1,1.1,0,0,1,.35,1c-1.48.14-3,.25-4.41.44-.67.09-2.05-.14-1.69.62s1.39.22,2.15.24A.94.94,0,0,0,427,495,5.93,5.93,0,0,1,430.52,494.79Z"
            />
            <path
              class="cls-116"
              d="M435.86,495.49c0-.45,0-.9,0-1.35.93-.05,1.85-.09,2.77-.16,2-.15,2.86.27,2.9,1.38h.05A22.25,22.25,0,0,0,435.86,495.49Z"
            />
            <path
              class="cls-113"
              d="M441.52,495.36c0-1.11-.94-1.53-2.9-1.38-.92.07-1.84.11-2.77.16,0-.29,0-.59,0-.88,1.25,0,2.47-.14,3.7-.21s2.16-.36,1.94-1.2l15-1.34c2-.18,2-.17,1.48-1.28l6.22,1c1.9,0,3.68-.38,5.55-.46a1.16,1.16,0,0,1-.23,1.19c-.62.1-.41-.68-1.24-.37-.74,0-.93.27-.93.64a17.65,17.65,0,0,1-.25,4.29c0,.64,0,1.28,0,1.91,0,.46,0,.91,0,1.37.31.51-.56,1.3,1.11,1.51.08,0,.08.21.14.31l.63,1.28c-.58,0-1.21,0-1.28.49s-.1.75.3,1.09a3.32,3.32,0,0,1-2.15.4c.08-3.75.16-7.5.26-11.26,0-.66-.17-1-1.4-.45-1.22.09-1.88.77-3.05.92l-1.19.19s0-.07,0-.09l-.23-.15a1.53,1.53,0,0,1,0-.52c.42-.84-.39-1-1.59-.85l-1.84.17c-.15-.54-.48-.73-1.19-.19a54,54,0,0,0-7.37,2.48Zm16.9-4c.67,0,1.4.05,1.87-.33.12-.1.18-.24,0-.31a3.9,3.9,0,0,0-2,0c-.43.07-1.24,0-1.1.42S458,491.31,458.42,491.34Z"
            />
            <path
              class="cls-115"
              d="M539.61,488c.68,0,.92.15.91.5s0,.78,0,1.29c.77-.57-.27-1.29,1-1.64a11.34,11.34,0,0,1-.56,4c-.62-.36-.26-.81-.35-1.21s.13-.63-.32-.88-.77-.44-.58-.73C540,488.84,539.69,488.4,539.61,488Z"
            />
            <path
              class="cls-115"
              d="M544.52,457.61h1.2a1.93,1.93,0,0,1-.26,1.57h-.63l-.32-.34.06-.36C545.07,458.17,544.52,457.9,544.52,457.61Z"
            />
            <path
              class="cls-115"
              d="M541.53,487.76c-.43-.72-.85-1.44.26-2.1A3.27,3.27,0,0,1,541.53,487.76Z"
            />
            <path
              class="cls-116"
              d="M456.91,491.82l1.84-.17c1.2-.11,2,0,1.59.85a1.53,1.53,0,0,0,0,.52l.23.15c.05,0,.06.06,0,.09l-.09.35a1.86,1.86,0,0,0-.53,1.25c-.05.53.87,1.12,0,1.58s-1.88.26-2.8.45c0-1.32,0-2.64,0-4A7.34,7.34,0,0,0,456.91,491.82Z"
            />
            <path
              class="cls-114"
              d="M457.16,496.89c.92-.19,2.09-.06,2.8-.45s-.07-1.05,0-1.58a1.86,1.86,0,0,1,.53-1.25c0,2,0,4,0,6,0,1.08-1.74.71-2.69.85-1.17.17-.71-.48-.72-.77C457,498.74,457.11,497.82,457.16,496.89Z"
            />
            <path
              class="cls-129"
              d="M370.54,495.72l-5.4.43.67-7.71a2.12,2.12,0,0,0,1.15.15,2,2,0,0,1,1.82.62,11.94,11.94,0,0,0,1.17,1c.14.2.28.4.41.61h0c0,.18.06.36.08.53-.25.48-.39.95.17,1.39l.18,1.75C370.35,494.9,370.74,495.33,370.54,495.72Z"
            />
            <path
              class="cls-111"
              d="M370,490.24a11.94,11.94,0,0,1-1.17-1,2,2,0,0,0-1.82-.62,2.12,2.12,0,0,1-1.15-.15l.24-2.77c.54,0,1.09-.08,1.63-.06a8.92,8.92,0,0,1,2,0C369.58,487.16,370.18,488.69,370,490.24Z"
            />
            <path
              class="cls-115"
              d="M373.4,496.11l-1.13-.37a18.31,18.31,0,0,1-.42-2.62c0-.34-.61-.73.1-1.05.34.05.8.39.82-.17,0-.8.55-.2.9-.08-.19,1.27.32,2.52.32,3.79Z"
            />
            <path
              class="cls-110"
              d="M372,492.07c-.71.32-.1.71-.1,1.05a18.31,18.31,0,0,0,.42,2.62l-.79.12c-.71-.37,0-1-.69-1.34l-.18-1.75c.26-.47.4-.94-.17-1.39,0-.17-.05-.35-.07-.53C371.5,491,371.35,491.7,372,492.07Z"
            />
            <path
              class="cls-117"
              d="M374,495.61c0-1.27-.51-2.52-.32-3.79A3.81,3.81,0,0,1,374,495.61Z"
            />
            <path
              class="cls-120"
              d="M369.68,485.62a8.92,8.92,0,0,0-2,0c.38-.27-.15-.53-.05-.8a5.76,5.76,0,0,1,2.75.81Z"
            />
            <path
              class="cls-109"
              d="M382.2,484.45c-1.89-.45-3.59-1.24-5.83-1.16-2.79.06-5.55.5-8.36.12.07.26.39.37.79.48l5.52,1.54c-.13-.42-.13-.42-.56-.75,1.18-.51,2.75,0,3.94-.45h-2.94s0-.07,0-.1l4.23-.28c-.45.28-1.06.12-1.27.38H380c-1.75.14-3.36.58-5.1.69a11.26,11.26,0,0,1,.33,3.36c0,.29-.24.71.58.78a3.18,3.18,0,0,0,1.91-.15c.47-.31-.17-.58-.45-.83a1.43,1.43,0,0,1-.53-1.16c0-.38.2-.62,1-.59l.67-.39h0c.53-.1,1.08-.18,1.63-.24l.41-.05.82-.07.59,0c1.05-.06,2.11-.08,3.17-.09a.42.42,0,0,0,.16,0A8.14,8.14,0,0,0,382.2,484.45ZM371.51,484l-.27,0a1.22,1.22,0,0,1,.27-.09,1.31,1.31,0,0,1,.23.06Zm1.15.35a.6.6,0,0,1-.2-.07l.25-.06.25.05A1.47,1.47,0,0,1,372.66,484.38Zm.32-.44a3.93,3.93,0,0,1,2.1-.11Zm3.11-.2c0-.05,0-.1,0-.15l1.16,0a.36.36,0,0,1,0,.1Z"
            />
            <path
              class="cls-110"
              d="M375.8,481.28c-2.63.17-5.27.36-7.93.42l-1.13,0h-.13a1.16,1.16,0,0,1-.25.41l-.31,3.54c.54,0,1.09-.08,1.63-.06.38-.27-.15-.53-.05-.8-1.13-.82-1-1.27.38-1.4,2.81.38,5.57-.06,8.36-.12C376.44,482.59,376.76,481.88,375.8,481.28Z"
            />
            <path
              class="cls-118"
              d="M377.72,486.33l.67-.39a45.35,45.35,0,0,0,6.62-.49.29.29,0,0,0,.16,0,20.42,20.42,0,0,1,5.09,1c-1.54.6-3.42.21-5.05.55-1.39-.69-3-.28-4.47-.22C379.63,486.82,378.47,487.05,377.72,486.33Z"
            />
            <path
              class="cls-113"
              d="M377.71,484.23H380c-1.75.14-3.36.58-5.1.69-.45.08-.27.38-.59.51-.13-.42-.13-.42-.56-.75,1.18-.51,2.75,0,3.94-.45Z"
            />
            <path
              class="cls-119"
              d="M382.65,488.59c.15,1.76.36,3.51.41,5.27,0,.61.33,1,1.25,1.36-.21.49-.86.78-1.59,1-.57-.49-.48-1.07-.54-1.59a26.79,26.79,0,0,1-.41-5.36C381.8,489,381.68,488.57,382.65,488.59Z"
            />
            <path
              class="cls-117"
              d="M505,489.41l2.59-.17q-.47,5.19-.92,10.39l-2.61.15C504.4,496.32,504.71,492.87,505,489.41Z"
            />
            <path
              class="cls-114"
              d="M481.29,497.79l-.36-.3a20.23,20.23,0,0,0-4.32-1.35c-.05-.35-.16-.7.14-1a20.13,20.13,0,0,0,4.35.36c.86-.07,1.72-.11,2.58-.17.13.55-1.11.31-1.29.68-.51.56-.14,1.16-.31,1.73Z"
            />
            <path
              class="cls-119"
              d="M487.05,498.2l2.58-.39,4.53-.44c.73-.13,1.06.37,1.71.35l.05.07a1.29,1.29,0,0,1-.83.38c-2.28.26-4.57.52-6.86.76a1.83,1.83,0,0,1-1.15-.17Z"
            />
            <path
              class="cls-118"
              d="M495.87,497.72c-.65,0-1-.48-1.71-.35l-.19-.32c1.45-.18,2.39.08,2.72.76l-.46-.05Z"
            />
            <path class="cls-113" d="M495.87,497.72l.36,0-.31,0Z" />
            <path
              class="cls-120"
              d="M478.43,499.81l-.09-.18c.16-.59-.74-.57-1.34-.72s-.79-.08-.83.25c-1.56-.22-1.58-.88-1.47-1.58,0-.15.05-.3.38-.31s.39.1.38.22c0,.84,1,.78,2,.78a2.6,2.6,0,0,0,1.25.32c1.32.11,1.65.46,1,1.1C479.09,499.2,478.93,500,478.43,499.81Z"
            />
            <path
              class="cls-119"
              d="M478.36,501.39c0,.11,0,.25-.31.22s-.63-.1-.64-.3.29-.14.48-.17C478.23,501.09,478.33,501.23,478.36,501.39Z"
            />
            <path
              class="cls-120"
              d="M468.09,503.46c-.4-.34-.29-.72-.3-1.09l.64,0,.14,0,.12-.05c1.33.27.28.89.61,1.3A2.25,2.25,0,0,1,468.09,503.46Z"
            />
            <path
              class="cls-133"
              d="M449.55,483.21a11.06,11.06,0,0,0,3.83,1.05,13,13,0,0,1,3.08.56,34.82,34.82,0,0,1-5.44.54c-6.2.48-12.41.9-18.62,1.34l-20.94,1.51c-4.9-1.1-9.83-2.17-14.7-3.31a29.72,29.72,0,0,1-5.06-1.27c1.49-.27,3.06-.22,4.58-.38.68-.07,1.2-.19,1.16-.64,4.67-.09,9.29-.49,13.93-.74,7.33-.39,14.65-.83,22-1.25l13.18,2A17.86,17.86,0,0,1,449.55,483.21Z"
            />
            <path
              class="cls-117"
              d="M492.21,473.32c.09-.83.05-1.67.18-2.5.07-.4-.06-.59-.39-.6h-.19a2.72,2.72,0,0,0-.51.13l-.13,0-.18.07-.09,0-.2,0a4.67,4.67,0,0,1-.84,0h-.28c-.23.06-.48.34-.68,0,0-.11-.16-.29-.34-.22-2.05.84-4.42.49-6.67.58a1,1,0,0,1-.25,0h-.08a.47.47,0,0,1-.19-.06l-.06,0,0,0,0-.05a.09.09,0,0,1,0-.06.3.3,0,0,1-.07-.15.16.16,0,0,1,0-.09h0l-.35.15c0,.46-.55.53-1.21.55s-.88-.2-.91-.52h-.28c-.06.62-.93.63-1.68.67-1.29.06-2.59,0-3.88.1-.92.05-.63-.32-.75-.56l-.58.15c-.11.76-1.17.44-1.88.51l0,.36h.91c.53,0,.9.09.91.43s-.36.43-.88.45-.79.09-1.19.14V473c2.09,0,2.09,0,2.09,1.09,0,.7,0,1.4,0,2.09,0,1.19,0,1.19-2.13,1.14l0,.54c.48.16,1.53-.41,1.53.37l0,.61c.35.2.24.33-.19.42s-1,.16-1,.51c-.43.47-.4.67.76.59,5.3-.35,10.63-.61,15.92-1a43.1,43.1,0,0,0,5.82-.49C492.1,477,492,475.18,492.21,473.32Zm-19.48-1.61c1.64-.11,3.3-.18,4.94-.25.36,0,.55.14.59.33s-.14.43-.59.54a10.38,10.38,0,0,1-2.16.15h-2.63c-.42.15-.72.1-.79-.17S472.18,471.74,472.73,471.71Zm-.5,7.51c-.41.06-.45-.26-.47-.46v-.69l.29-.37-.28-.35c.09-1.24.21-2.48.27-3.73,0-.44.33-.58,1.09-.65,1.5-.14,3.28-.44,4.43-.08,1.35.44.22,1.5.42,2.29a6.52,6.52,0,0,1,0,1.82c0,.25.08.53-.46.68-1.56.45-.74.74.43,1C476.08,479.38,474.05,478.93,472.23,479.22Zm7.3-7.79c.52,0,.93.06.94.41s-.33.45-.88.45-.93-.07-.94-.41S479,471.43,479.53,471.43Zm.49,7.81c-.44-.45-1.39-.38-1.69-.82v-.73c.06-.33.64-.32,1.27-.49-1-.21-1.22-.46-1.08-1a12.29,12.29,0,0,0,.1-2.78c0-.38-.06-.79,1-.78s.9.37.9.73A21.53,21.53,0,0,1,480,479.24Zm1.8-8c2.16.18,4.33-.54,6.47,0,.44.12.34-.1.48-.18a4.83,4.83,0,0,1,2.49-.2c.36,0,.45.21.46.39,0,.35-.41.42-.92.45l-7.39.38a0,0,0,0,0,0,0H482c-.43,0-.87.06-.87-.3S481.2,471.23,481.82,471.28Zm5.94,6.75c-.18.63-.57.85-1.63.89-1.34,0-2.7.07-4,.23s-1.35-.14-1.3-.67a7.69,7.69,0,0,0,0-1,28.68,28.68,0,0,0,.29-4.24c-.07-.61.65-.73,1.47-.78,1.55-.08,3.11,0,4.65-.19.81-.11,1.17.17,1,.61C487.67,474.61,488.24,476.33,487.76,478Zm3,.52a3.77,3.77,0,0,1-1.95.14c-.67-.11-.45-.47-.48-.75a5.3,5.3,0,0,1,0-.69,19.1,19.1,0,0,0,.31-4.33c0-.85,1.13-.75,2.08-.8,1.14-.05,1.05.41,1,.82-.09,1.56-.19,3.12-.31,4.68A1,1,0,0,1,490.76,478.55Z"
            />
            <path
              class="cls-117"
              d="M493.26,455.9c0-.35,0-.69,0-1l-.56,0c0,.33-.09.66-.91.64s-1.85.19-2.18-.68c-.67.95-2,.72-3.06.67s-2.26-.17-3.4-.13c-.93,0-1.2-.23-1.16-.68l-.51,0c-.12.3-.11.64-1,.65s-1-.19-1-.57l-.58.05c0,.42-.46.52-1.13.52-1.45,0-2.9,0-4.35,0-.93,0-1.17-.25-1.15-.69-.64,0-.53.43-1.1.7.05-.64-.3-1-1.3-.91l0,1.43a6,6,0,0,1,.71-.16c.45,0,1-.08,1.06.3s-.52.36-1,.37h-.78v.38c1.39-.13,2,.14,1.87,1-.16,1.62,0,3.24-.25,4.87-.13.78-.52,1-1.85.9.08.52.8.35,1.31.37,2.44.09,4.87-.15,7.31-.16,3,0,6-.06,9-.14l5.43-.16Q493,459.67,493.26,455.9Zm-20.07-.15H478c.44,0,.86.05.82.37s-.41.31-.78.31h-4.8c-.44,0-.86-.06-.82-.38S472.82,455.75,473.19,455.75Zm-.94,6.76c-.07-.06-.16-.11-.18-.17s.08-.08.13-.13l.13.14Zm5.93.84c-1.24,0-2.58.37-3.66-.28-.47-.25-.24-.57-.29-.87a.69.69,0,0,0-.75-.48c-1.73.07-1.55-.61-1.4-1.16a11.74,11.74,0,0,0,.24-3.12c0-.43.26-.65,1.08-.64,1.46,0,2.92,0,4.37,0,.79,0,1.15.16,1.12.61-.11,1.84-.2,3.69-.3,5.53C478.58,463.11,478.52,463.35,478.18,463.35Zm4.64-7.59h5.58c.4,0,.73.08.72.34s-.34.33-.73.34h-5.58c-.39,0-.73-.07-.73-.34S482.44,455.76,482.82,455.76Zm-2.37,0c.43,0,.84,0,.87.33s-.45.34-.87.34-.87,0-.86-.34S480,455.76,480.45,455.76Zm-.27,6.3a3.84,3.84,0,0,1,.25.77c0,.24,0,.5-.52.53s-.69-.2-.69-.45c0-.73,0-1.45,0-2.47a13.25,13.25,0,0,1,.29-3.09c0-.34.2-.54.89-.56s.76.16.85.52c.4,1.48-.44,2.94-.15,4.41C481.17,462.16,480,461.5,480.18,462.06Zm8.62.24c-.13.68-.56,1.06-1.94.95-.6,0-1.22.13-1.84.14-.83,0-1.75,0-1.76-.67-.91-.15-.81.36-1.18.62-.92-.75.95-.83.88-1.33-1.51-.5-1.28-1.32-1.25-2.11s0-1.51,0-2.26c0-.53.4-.7,1.31-.7,1.82,0,3.63,0,5.44-.06.6,0,.8.14.72.4C488.63,458.94,489.11,460.63,488.8,462.3Zm.94-6.15c.07-.15.32-.23.58-.23h2.31a1.06,1.06,0,0,1,.1.12s-.05,0-.08.06c-.66.65-1.74.25-2.62.31C489.82,456.41,489.68,456.29,489.74,456.15Zm-.23,7.1c-.37-.11-.31-.29-.28-.45a29.41,29.41,0,0,0,.3-5.3c0-.64.82-.56,1.53-.56s1.57-.11,1.57.54v.95a15.59,15.59,0,0,0-.31,3.91C492.29,463.07,490.67,463.57,489.51,463.25Z"
            />
            <path
              class="cls-115"
              d="M505.17,481.51c-.9.27-1.25.07-1.21-.45a42.79,42.79,0,0,1,.43-4.92c.2-1.06-.08-2.14.49-3.18a.48.48,0,0,1-.11-.09l.08-.05a8.81,8.81,0,0,1,2.82-.19l0-.35-1.82-.18c-.9-.11-.7-.51-.67-.84s.63-.24,1-.23c.57,0,1.14,0,1.71,0l.06-.33-.06,0c-1-.25-2.77.15-2.53-1l-1.18-.18c0,.34.7.81-.65.88-2.42.13-2.75,0-2.82-1.05h-.92c-.41,4.06-.87,8.13-.94,12.21l6.92.83c.72.08,1.24,0,1.24-.48A4.24,4.24,0,0,1,505.17,481.51Zm-4.45-10.82a20.94,20.94,0,0,1,2.67.16c.72.1.91.32.83.69s-.66.39-1.18.38C501.7,471.89,500.51,471.75,500.72,470.69Zm1.47,10.75c-2.61-.3-2.78-.3-2.55-1.75.35-2.22,0-4.46.56-6.66,0-.14.19-.27.29-.39.84-.78,1.93-.1,2.89-.13.66,0,.61.41.55.68s.43.67,0,1c0,.29,0,.58,0,.87s0,.33,0,.5,0,.6,0,.91a.47.47,0,0,1-.3.52c0,1.28,0,2.56,0,3.83C503.65,481.43,503.19,481.56,502.19,481.44Z"
            />
            <path
              class="cls-109"
              d="M469.79,489.75c-1.87.08-3.65.48-5.55.46.4-1-.13-1.62-2-1.92-.8-.13-2,0-2.33-.68a41.73,41.73,0,0,1,7.6-.47,3.68,3.68,0,0,0,2.16.73c.87.12,1.57.43,1.51,1S470.81,489.75,469.79,489.75Z"
            />
            <path
              class="cls-115"
              d="M509.14,456.38l-2,0c-.39,0-.91,0-.93-.29s.33-.54,1-.54,1.33,0,2,0l.07,0v-.15l-.06,0c-.52,0-1,0-1.54,0-.94,0-1.34-.19-1.26-.7l-.58,0c0,.46-.34.78-1.28.73-1.15-.07-2.66.36-3.14-.68l-.41,0c-.06.43-.14.86-.17,1.29q-.37,4.86-.74,9.7a5,5,0,0,0,1,.18c2.41,0,4.82,0,7.22.18a.2.2,0,0,0,0-.15c0-.07,0-.15-.05-.22h0l-.25,0a1.88,1.88,0,0,1-1.07-.21c-1.36.1-1.89-.15-1.52-1s-.29-1.47.37-2.17c0-.1,0-.2,0-.31l-.63,0c-.09.11-.2.22-.29.34,0,.72,0,1.44,0,2.16-.07,1.1-1.59.72-2.66.8s-1.44-.24-1.39-.82,0-1.44,0-2.16c0-.11,0-.21,0-.32s-.11-.51.29-.71a1.09,1.09,0,0,1,0-.18.88.88,0,0,1,0-1.38,5.38,5.38,0,0,0,.32-2.5c0-.43.24-.67,1.07-.64,1.1,0,2.31-.19,3.24.36l.39,0c.82-.67,2-.23,3-.31l.06,0a1.23,1.23,0,0,0,0-.19Zm-4.79,0h-1.87c-.57,0-1.06-.05-1-.45s.49-.4,1-.4h1.87c.52,0,1.1,0,1.12.41S504.9,456.4,504.35,456.41Z"
            />
            <path
              class="cls-115"
              d="M492.08,478.91c0-1.87-.06-3.73.13-5.59.09-.83.05-1.67.18-2.5.11-.65-.29-.75-1.22-.42-.65-.72-1.8-.62-2.93-.57.89-.59,2.11-.34,3.15-.29a7.85,7.85,0,0,0,2.09,0c0,2.1,0,4.2,0,6.3,0,.84-.15,1.68-.17,2.51C493.32,478.83,492.93,479,492.08,478.91Z"
            />
            <path
              class="cls-120"
              d="M479.5,454.83l-.59.05c-2.15-.68-4.39-.38-6.62-.17-.64,0-.53.43-1.1.7.05-.64-.3-1-1.3-.91-.13-.43,0-.64,1-.63,6.24.07,12.48.1,18.72.16,1.45,0,2.9.06,4.35.09.45,0,.87,0,.78.37a4.23,4.23,0,0,0-1.45.37l-.57,0c-1.24-.64-2.77-.27-4.14-.32a29.37,29.37,0,0,0-6.56.14l-.51,0C480.79,454.57,480.09,454.29,479.5,454.83Z"
            />
            <path
              class="cls-116"
              d="M469.87,456.81c1.4-.13,2,.14,1.87,1-.16,1.62,0,3.24-.25,4.87-.13.78-.52,1-1.85.9C469.44,461.31,469.88,459.06,469.87,456.81Z"
            />
            <path
              class="cls-115"
              d="M493.25,454.86a4.23,4.23,0,0,1,1.45-.37l-.51,8.55c0,.59-.77.5-1.46.43.18-2.52.36-5.05.53-7.57C493.28,455.55,493.25,455.21,493.25,454.86Z"
            />
            <path
              class="cls-111"
              d="M459.89,487.61c.35.66,1.53.55,2.33.68,1.89.3,2.42.93,2,1.92l-6.22-1C457.44,487.89,457.66,487.69,459.89,487.61Z"
            />
            <path
              class="cls-116"
              d="M469.34,473c2.09,0,2.09,0,2.09,1.09,0,.7,0,1.4,0,2.09,0,1.2,0,1.2-2.12,1.13A32.65,32.65,0,0,1,469.34,473Z"
            />
            <path
              class="cls-116"
              d="M488.24,469.83c1.13-.05,2.28-.15,2.93.57a4.38,4.38,0,0,1-1.59.16l-.68,0c0-.11-.16-.29-.34-.22-2.05.84-4.42.49-6.67.58-.63,0-.75-.24-.81-.52a1.73,1.73,0,0,1,1.29-.35,37.09,37.09,0,0,0,4.09-.19Z"
            />
            <path
              class="cls-116"
              d="M441.5,491.85c.22.84-.6,1.13-1.94,1.2s-2.45.25-3.7.21c0-.3,0-.6,0-.9C437.7,492.1,439.6,492,441.5,491.85Z"
            />
            <path
              class="cls-119"
              d="M486.46,469.84a37.09,37.09,0,0,1-4.09.19,1.73,1.73,0,0,0-1.29.35l-.35.15c-.71-.22-1.44-.53-2.12,0h-.28c-2-.68-4.08-.09-6.11,0-.08,0-.13.15-.2.23l-.58.15a1.54,1.54,0,0,0-1.86-.38c0-.22.27-.3.62-.31l15.56-.54A1.06,1.06,0,0,1,486.46,469.84Z"
            />
            <path
              class="cls-113"
              d="M500.8,469.32h-.92a.57.57,0,0,1-.28-.66L507,469c.58,0,1.06.06.94.49l-.87,0a3.39,3.39,0,0,0-1.63.18l-1.18-.18A13.85,13.85,0,0,0,500.8,469.32Z"
            />
            <path
              class="cls-111"
              d="M494,485.3c.35.61.08.87-1.15.7-.94-.14-1.91-.2-2.86-.29,0-.34,0-.58.84-.64A10.7,10.7,0,0,1,494,485.3Z"
            />
            <path
              class="cls-113"
              d="M501.37,454.68l-.41,0a.66.66,0,0,1-.19-.66h8.42v.16h0c-.95.16-2.09,0-2.82.52l-.57,0A7,7,0,0,0,501.37,454.68Z"
            />
            <path
              class="cls-116"
              d="M469.59,471.79h.91c.53,0,.9.09.91.43s-.35.43-.88.45-.79.09-1.19.14C469.05,472.43,469.44,472.12,469.59,471.79Z"
            />
            <path
              class="cls-111"
              d="M486.47,486.22c-.35-.55-1,0-1.53-.16,0-.46.46-.62,1.27-.55.5.05,1,0,1.51,0l.65.72-.15.15-1.12-.17Z"
            />
            <path
              class="cls-116"
              d="M469.28,477.89c.47.16,1.52-.41,1.52.37-.49,0-1.11-.1-1.12.32s.62.31,1.1.29c.35.2.24.33-.19.42s-1,.16-1,.51C468.86,479.19,469.4,478.52,469.28,477.89Z"
            />
            <path
              class="cls-116"
              d="M469.58,470.54a1.54,1.54,0,0,1,1.86.38c-.11.76-1.17.44-1.88.51Z"
            />
            <path
              class="cls-116"
              d="M469.86,455.93a6,6,0,0,1,.71-.16c.45,0,1-.08,1.06.3s-.52.36-1,.37h-.78C469.87,456.26,469.87,456.1,469.86,455.93Z"
            />
            <path
              class="cls-116"
              d="M424.91,475.81l0,.39V480c0,.32-.21.5-.8.52s-1,0-1.55.06c-2.08.09-2.08.09-2.09-1.07h.33c.55,0,.47.44,1,.41.66-.87.26-1.41-1-1.43-.14-.52.25-1.08-.3-1.58-.55-1.4,0-2.82-.32-4.23-.08-.36.29-.5.93-.52,1.18,0,2.37-.09,3.55-.14C424.77,473.26,424.84,474.54,424.91,475.81Zm-3,2.36a3.49,3.49,0,0,0,2.2-.14A3.76,3.76,0,0,0,422,478.17Z"
            />
            <path
              class="cls-116"
              d="M419.88,461.53l0-3.65h3c.57,0,1.05.06,1.08.46.1,1.67.2,3.35.29,5,0,.25-.13.52-.61.53-1.2,0-2.51.3-3.43-.41-.44-.51-.26-1.06-.23-1.6.25,0,.63,0,.65-.15S420.15,461.58,419.88,461.53Zm3-.06a2.48,2.48,0,0,0-1.65.07A1.89,1.89,0,0,0,422.85,461.47Z"
            />
            <path
              class="cls-117"
              d="M420.14,463.5c.92.71,2.23.46,3.43.41.48,0,.63-.28.61-.53-.09-1.68-.19-3.36-.29-5,0-.4-.51-.46-1.08-.46h-3v-.34h3.23c.32,0,.68,0,.68-.26s-.38-.24-.69-.24l-3.23,0a.15.15,0,0,1,0-.17l3.09,0c.35,0,.8,0,.83-.26s-.4-.35-.74-.36c-1.07,0-2.15,0-3.23,0a14.88,14.88,0,0,1,4.57-.12c.37,1.47,0,3,.21,4.44,0,1.07,0,2.14,0,3.21,0,.22.15.52-.47.55-1.19,0-2.39.12-3.56.05C419.7,464.23,420.09,463.79,420.14,463.5Z"
            />
            <path
              class="cls-116"
              d="M419.78,456.16c1.08,0,2.16,0,3.23,0,.34,0,.77.11.74.36s-.48.25-.83.26l-3.09,0Z"
            />
            <path
              class="cls-116"
              d="M419.84,457l3.23,0c.31,0,.68,0,.69.24s-.36.26-.68.26h-3.23Z"
            />
            <path
              class="cls-111"
              d="M424.56,460.48c-.23-1.48.16-3-.21-4.44h.38C424.71,457.52,425.14,459,424.56,460.48Z"
            />
            <path
              class="cls-111"
              d="M424.91,475.81c-.07-1.27-.14-2.55-.22-3.82.48.16.5.42.47.68C425,473.72,425.49,474.78,424.91,475.81Z"
            />
            <path
              class="cls-115"
              d="M420.53,476.88c.55.5.16,1.06.3,1.58v.69l0,.33h-.33Z"
            />
            <path
              class="cls-114"
              d="M419.88,461.53c.27.05.73,0,.68.22s-.4.14-.65.15Z"
            />
            <path
              class="cls-111"
              d="M424.94,477.2v-1A.62.62,0,0,1,424.94,477.2Z"
            />
            <path class="cls-111" d="M425,480v-.82A.47.47,0,0,1,425,480Z" />
            <path
              class="cls-111"
              d="M424.94,478.77v-.31C425.17,478.56,425.17,478.67,424.94,478.77Z"
            />
            <path
              class="cls-114"
              d="M436.67,456.46c.19-.38-.41-1,1.07-1,.82,0,1.22.12,1.24.64.06,2.41.31,4.81.29,7.21,0,.78-.18,1.22-1.79,1a4.89,4.89,0,0,0-.77,0l0-.36a.49.49,0,0,0,.29-.47c0-1.75,0-3.5,0-5.26a.52.52,0,0,0-.33-.55Z"
            />
            <path
              class="cls-114"
              d="M436.74,472.68c0-.35-.12-.75.9-.66.75.07,1.57.05,1.56.7,0,2.43,0,4.86,0,7.28,0,.29.1.72-.89.51-.93-.42-.87-1-1-1.6a38.76,38.76,0,0,1-.27-5.59A.61.61,0,0,0,436.74,472.68Z"
            />
            <path
              class="cls-109"
              d="M436.67,456.46l0,1.22c0,2.1,0,4.19.05,6.28l0,.36c-.8,0-.92-.27-.92-.62,0-2.56,0-5.12,0-7.69Z"
            />
            <path
              class="cls-116"
              d="M436.74,472.68a.61.61,0,0,1,.34.64,38.76,38.76,0,0,0,.27,5.59c.1.6,0,1.18,1,1.6-.84,0-1.59,0-1.6-.65A66.14,66.14,0,0,1,436.74,472.68Z"
            />
            <path class="cls-117" d="M452.41,467.63a3.44,3.44,0,0,1,0,2.76Z" />
            <path
              class="cls-110"
              d="M374.19,464.73c-2,.18-4.09.18-6.14.17l-.21.11-.39,4.48c2.42-.09,4.84-.05,7.25-.14A10.75,10.75,0,0,0,374.19,464.73Z"
            />
            <path
              class="cls-110"
              d="M372.09,454.6h-3.35l.34-3.95,3.84.06c.53,1.16.26,2.36.41,3.53C373.39,454.83,372.54,454.59,372.09,454.6Z"
            />
            <path
              class="cls-117"
              d="M371.8,455.14c.56,0,.82.16.84.48s-.23.55-.88.55l-2,0h-.84c.05.14.1.27.16.4a29.13,29.13,0,0,0,3.1,0c.39-.07.67.09.7.34s-.15.45-.67.46h-3a1.35,1.35,0,0,1-.33.41l3.22,0c.72,0,.85.11.95.54a10,10,0,0,1-.06,3.54V460.1c-1.23.63-1.48,1.54-2.53,2.19V463a.91.91,0,0,1,.07.14s-.05,0-.08.06v.33c.36.31.59.75,0,.91a4.88,4.88,0,0,1-.55.12l-.24,0-.26,0H369a4,4,0,0,1-.49,0,1.86,1.86,0,0,1-.42.35c2.05,0,4.1,0,6.14-.17.1-3.09-.84-6.17-.65-9.27,0-.61-.69-.68-1.56-.68h-3.25l0,.34h3.1Z"
            />
            <path
              class="cls-117"
              d="M375.48,475.94a28.91,28.91,0,0,0-4.08.38l.33.74c.22.14.4.4.1.43-.88.09-1.92.45-2.58-.25,0-.27,0-.54,0-.81l-.68.12c.11,1.38.26,2.76.33,4.13,0,.21.44.65-.56.59l-1.34.21-.28.24h0l1.14,0c2.66-.06,5.3-.25,7.93-.42C375.69,479.5,375.59,477.72,375.48,475.94Zm-4.13,5.14c-.69.05-1.41.06-1.64-.42a3.75,3.75,0,0,1-.19-.93h.07c0-.23,0-.46,0-.69.05-.4.51-.53,1.16-.54s1,.2,1,.58a2.55,2.55,0,0,0,.21,1.29C372.13,480.67,372.19,481,371.35,481.08Z"
            />
            <path
              class="cls-117"
              d="M374.7,469.35c-2.41.09-4.83,0-7.25.14h-.21c0,.15.05.3.07.46h.1c.18,0,.32.09.3.29a.52.52,0,0,1-.34.5c0,.14,0,.29,0,.44h0a.73.73,0,0,1,.57.15c1.59-.1,3.17-.22,4.77-.3.57,0,1.5-.22,1.61.19s-.94.39-1.46.41c-1.83.06-3.68.05-5.51.06,0,.19,0,.38,0,.56a1,1,0,0,1,.87,1.05c0,.92.07,1.83.11,2.75l.93-.06c-.1-1.07-.17-2.14-.32-3.2-.08-.56.37-.84,1.28-.88,1.19,0,2.39,0,3.58,0,.63,0,.78.23.77.52a11.82,11.82,0,0,0,.32,3.12h.34A42.78,42.78,0,0,0,374.7,469.35Zm-1.43,1.29-3.13.16H369c-.53,0-.47-.26-.55-.44s.14-.4.57-.4c1.45,0,2.85-.28,4.31-.19.53,0,.92.09.92.44S373.78,470.62,373.27,470.64Z"
            />
            <path
              class="cls-114"
              d="M382,458a2.78,2.78,0,0,1,2.14,0l.42,5.4-2-.19c-.07-1-.12-2-.21-3C382.24,459.38,382.43,458.65,382,458Z"
            />
            <path
              class="cls-114"
              d="M381.05,463a4.73,4.73,0,0,1-1.91,0c-.41-1.67,0-3.36-.61-5a2.85,2.85,0,0,1,2.13,0c.29.43-.3.84-.13,1.28A10.59,10.59,0,0,1,381.05,463Z"
            />
            <path
              class="cls-114"
              d="M376,455.71a1.26,1.26,0,0,1,.8-.22c2.23.05,4.43-.12,6.65-.19.73,0,1.27,0,1.35.57s-.56.6-1.22.61l-6.91,0Z"
            />
            <path
              class="cls-117"
              d="M381.05,463a10.59,10.59,0,0,0-.52-3.77c-.17-.44.42-.85.13-1.28.41.19.82.4,1.3,0,.47.7.28,1.43.35,2.15.09,1,.14,2,.21,3C382.14,462.76,381.52,463.07,381.05,463Z"
            />
            <path
              class="cls-110"
              d="M380.8,475.69l-.07-.34,1.09-.33a2.92,2.92,0,0,0,1.49-.21c1.13.34,1.22-.69,2.22-.52,0,.52.63.53,1.34.5s1.2.08,1.24.46-.63.37-1.12.4a3.34,3.34,0,0,0-1.66.34h0l-.28,0-.5-.14-1.18-.08a2.68,2.68,0,0,0-1.33.15Z"
            />
            <path
              class="cls-114"
              d="M377.58,470.49a60.19,60.19,0,0,1,7.91.84c.52.06.67.26.54.52s-.53.1-.85.08a24.17,24.17,0,0,1-5.76-.76,6.93,6.93,0,0,0-1.59,0Z"
            />
            <path
              class="cls-114"
              d="M385.05,476l.28,0c-.36.95.36,1.88.1,2.83-.73-.06-1.53,0-1.84-.54a10.43,10.43,0,0,1-.22-2.55l1.18.08Z"
            />
            <path
              class="cls-110"
              d="M376,455.71l.67.81,0,1.39c-.23,1.68.49,3.35.28,5-.46,0-.57-.19-.59-.41-.21-2.18-.43-4.36-.62-6.53C375.79,455.91,376,455.81,376,455.71Z"
            />
            <path
              class="cls-114"
              d="M381.82,475l-1.09.33-.59,0c-.49-.9,0-1.87-.59-2.76a3.22,3.22,0,0,1,2.22.38C381.79,473.62,381.8,474.32,381.82,475Z"
            />
            <path
              class="cls-114"
              d="M380.8,475.69l1.24.19c0,.8,0,1.61,0,2.41a6.64,6.64,0,0,0-1.73-.34c-.06-.74-.11-1.47-.17-2.21Z"
            />
            <path
              class="cls-117"
              d="M377,463c.21-1.69-.51-3.36-.28-5l.54,0c.56,1.67.17,3.37.66,5A.85.85,0,0,1,377,463Z"
            />
            <path
              class="cls-117"
              d="M382,478.29c0-.8,0-1.61,0-2.41a2.68,2.68,0,0,1,1.33-.15,10.43,10.43,0,0,0,.22,2.55C383.07,478.25,382.56,478.58,382,478.29Z"
            />
            <path
              class="cls-114"
              d="M377.93,463c-.49-1.67-.1-3.37-.66-5a.6.6,0,0,1,.77,0c.17,1.67.35,3.34.53,5Z"
            />
            <path
              class="cls-114"
              d="M385.53,474.29c-1-.17-1.09.86-2.22.52-.17-.57.18-1.17-.36-1.71.73-.07,3.08.59,3.24,1S385.8,474.25,385.53,474.29Z"
            />
            <path
              class="cls-117"
              d="M378.57,463c-.18-1.67-.36-3.34-.53-5l.49,0c.64,1.66.2,3.35.61,5Z"
            />
            <path
              class="cls-117"
              d="M383,473.1c.54.54.19,1.14.36,1.71a2.92,2.92,0,0,1-1.49.21c0-.7,0-1.4-.05-2.09Z"
            />
            <path
              class="cls-117"
              d="M384.52,463.31l-.42-5.4a.82.82,0,0,1,.69.81,17.93,17.93,0,0,0,.3,4.06C385.14,462.94,385.52,463.42,384.52,463.31Z"
            />
            <path
              class="cls-110"
              d="M377.58,470.49l.25.66.18,1.39c-.24.93.31,1.87-.3,2.78-.12-1.3-.26-2.6-.36-3.9C377.33,471.11,377.21,470.78,377.58,470.49Z"
            />
            <path
              class="cls-117"
              d="M377.71,475.32c.61-.91.06-1.85.3-2.78h.32c.38.31.22.67.29,1,.11.56-.25,1.15.43,1.67-.29.33-.84.26-1.34.26Z"
            />
            <path
              class="cls-114"
              d="M379.05,475.21c-.68-.52-.32-1.11-.43-1.67-.07-.34.09-.7-.29-1,.35-.48.62-.2.91,0l.16,2.62Z"
            />
            <path
              class="cls-117"
              d="M385.43,478.82c.26-.95-.46-1.88-.1-2.83h0l.52.23c.08.86.16,1.72.23,2.58Z"
            />
            <path
              class="cls-117"
              d="M379.4,475.18l-.16-2.62h.31c.61.89.1,1.86.59,2.76C379.84,475.36,379.46,475.56,379.4,475.18Z"
            />
            <path
              class="cls-114"
              d="M386.08,478.8c-.07-.86-.15-1.72-.23-2.58a3.31,3.31,0,0,1,.42,0,5.68,5.68,0,0,1,.19,2.68.28.28,0,0,1-.14,0A1.22,1.22,0,0,1,386.08,478.8Z"
            />
            <path
              class="cls-121"
              d="M377.67,475.86c.64,0,.74.28.68.55-.1.47.29.94-.18,1.43-.64-.62-.36-1.32-.5-2Z"
            />
            <path
              class="cls-117"
              d="M380.13,475.74c.06.74.11,1.47.17,2.21-.54,0-.74-.17-.62-.45s-.1-.68-.27-1C379.63,476.24,378.75,475.65,380.13,475.74Z"
            />
            <path
              class="cls-114"
              d="M383.77,457.12c-.12.27-.51.26-.87.25s-.81,0-.74-.29.45-.21.75-.21S383.66,456.86,383.77,457.12Z"
            />
            <path
              class="cls-114"
              d="M380.32,457.18c-.16.23-.54.21-.88.19s-.79-.08-.63-.35.59-.14.92-.14S380.35,456.93,380.32,457.18Z"
            />
            <path
              class="cls-116"
              d="M369.23,476c-.11-1.07-.18-2.14-.33-3.2-.08-.56.37-.84,1.28-.88,1.19,0,2.39,0,3.58,0,.64,0,.78.23.77.52a11.82,11.82,0,0,0,.32,3.12C373,475.7,371.14,476,369.23,476Z"
            />
            <path
              class="cls-116"
              d="M368.18,473.31a1,1,0,0,0-.87-1.05c-.09,1.05-.28,2.1-.41,3.17,0,.32-.08.65-.11,1h.06l.22,0,.38-.12.84-.2C368.25,475.14,368.17,474.23,368.18,473.31Z"
            />
            <path
              class="cls-116"
              d="M368.92,480.68c-.07-1.37-.22-2.75-.33-4.13l-1,.15c.47.29.44.51-.32.57h-.61s0,.05,0,.07q.06.69.06,1.38a1.66,1.66,0,0,1,.56-.08c.74,0,1,.18,1,.57,0,.68,0,1.37,0,2C369.36,481.33,368.93,480.89,368.92,480.68Z"
            />
            <path
              class="cls-121"
              d="M369.25,477.24c0-.27,0-.54,0-.81l2.14-.11.32.74Z"
            />
            <path class="cls-114" d="M367.07,476.38l.38-.12Z" />
            <path
              class="cls-116"
              d="M539.43,474.39c.12,1.47-.61,2.92-.25,4.4.09.36-.37.46-.83.51-.91.09-1.84.15-2.76.21-.5,0-.66-.11-.6-.36a22.78,22.78,0,0,0,.58-4.41c0-.29.12-.73.86-.72a10.76,10.76,0,0,1,2.89-.1C539.65,474,539.57,474.22,539.43,474.39Z"
            />
            <path
              class="cls-114"
              d="M531.43,478.69c-1,.15-.42.63-.81,1.11-.14-.48.08-1-1-.94-.44,0-.36-.22-.34-.39.12-1.21.15-2.42.38-3.62.16-.8,1.48-.6,2.43-.67C532.23,475.7,531.38,477.17,531.43,478.69Z"
            />
            <path
              class="cls-116"
              d="M542.43,474.7c-.55,1.18-.27,2.46-.59,3.72-.17.65-.83.66-1.61.65-1.2,0-.39-.45-.37-.67.07-1.27.21-2.54.33-3.81,0-.31-.1-.66.56-.84a2.33,2.33,0,0,1,1.2-.06C542.69,473.9,542.28,474.31,542.43,474.7Z"
            />
            <path
              class="cls-116"
              d="M531.43,478.69c0-1.52.8-3,.62-4.51.79-.05,1.39.05,1.28.58A21.75,21.75,0,0,0,533,479c0,.2,0,.45-.53.46s-.32-.25-.47-.39A4.36,4.36,0,0,0,531.43,478.69Z"
            />
            <path
              class="cls-116"
              d="M533.39,479.36c.2-1.71.36-3.2.57-4.69,0-.28.15-.68.83-.59s.2.43.16.66a14.78,14.78,0,0,0-.36,3.62,1.86,1.86,0,0,1-.17.86c-.08.2-.13.52-.73.44S533.38,479.33,533.39,479.36Z"
            />
            <path
              class="cls-116"
              d="M537.4,472.8c-.65-.08-1.47.13-1.49-.36s.79-.33,1.3-.38,1.22-.13,1.84-.16c.32,0,.82-.09.88.21s-.18.44-.68.49Z"
            />
            <path
              class="cls-116"
              d="M529.9,472.43a1.53,1.53,0,0,0,.93-.2c.72,0,1.44,0,2.15,0s.86.35.33.51a7.46,7.46,0,0,1-3.24.19C529.71,472.92,529.87,472.62,529.9,472.43Z"
            />
            <path
              class="cls-116"
              d="M531.61,473.26c.61.13,1.71-.18,1.75.25s-1.06.3-1.66.33-1.88.3-1.92-.28S531,473.41,531.61,473.26Z"
            />
            <path
              class="cls-116"
              d="M537.27,473.66c-.52-.06-1.23.1-1.28-.23s.73-.27,1.17-.32c.61-.06,1.23-.12,1.84-.15.3,0,.68,0,.75.2s-.27.27-.58.31Z"
            />
            <path
              class="cls-116"
              d="M542.7,473.13c-.86.24-1.38.45-2,.21-.18-.08-.16-.23,0-.29A3.21,3.21,0,0,1,542.7,473.13Z"
            />
            <path
              class="cls-114"
              d="M529.14,479.78s-.12-.11-.1-.14a1.22,1.22,0,0,1,.28-.14c0,.07.08.14.06.21S529.23,479.76,529.14,479.78Z"
            />
            <path
              class="cls-116"
              d="M533.28,492.08a7.44,7.44,0,0,0,.39-3c0-.48.46-.57,1.17-.6,1-.05,1.94-.15,2.91-.23,0,.51,0,1,0,1.53a3.66,3.66,0,0,1-.26,1.81c-.18.34.32.86-.49,1a15.34,15.34,0,0,1-3.19.31C533,492.85,533.59,492.33,533.28,492.08Z"
            />
            <path
              class="cls-116"
              d="M539.61,488c.08.45.35.89,0,1.35-.19.29.05.57.58.73l0,1.21c-1.13.12-.86.61-.9,1-.94.09-1.34-.13-1.28-.65.13-1,.23-2.05.33-3.08C538.41,488.09,538.94,488,539.61,488Z"
            />
            <path
              class="cls-114"
              d="M528.35,493.17c.13-1.06.22-2.12.43-3.17a1.89,1.89,0,0,0-.12-.85,3.67,3.67,0,0,1,1.56-.15,7.6,7.6,0,0,0-.25,2.8v.32c-.59.32-.14,1.15-1.61,1.06Z"
            />
            <path
              class="cls-116"
              d="M537.41,487.08c.79.54,1.36-.18,2.13-.19.43,0,1-.12,1.17.23s-.39.43-.88.45c-1.6.07-3.17.25-4.72.46-.4.06-.87.14-1-.17s.32-.46.78-.51C535.65,487.25,536.47,487.18,537.41,487.08Z"
            />
            <path
              class="cls-116"
              d="M532.4,493c-.55-1.29-.26-2.59-.28-3.88,0-.25.11-.48.68-.46.39,0,.58.19.51.36C532.77,490.35,533.43,491.74,532.4,493Z"
            />
            <path
              class="cls-116"
              d="M529.08,488.64c-.32,0-.75,0-.9-.21s.12-.4.47-.48a16.36,16.36,0,0,1,4.1-.35c.36,0,.58.15.55.35a.4.4,0,0,1-.3.26C531.71,488.37,530.41,488.5,529.08,488.64Z"
            />
            <path
              class="cls-116"
              d="M530,491.8a7.6,7.6,0,0,1,.25-2.8l.95-.19a7.32,7.32,0,0,1-.29,2.93Z"
            />
            <path
              class="cls-115"
              d="M530.88,491.74a7.32,7.32,0,0,0,.29-2.93c.35,0,.65.16.58.34-.55,1.3.06,2.65-.6,3.94,0,.08-.18.13-.28.2v-1.55Z"
            />
            <path
              class="cls-116"
              d="M530.87,493v.3c-.84,0-1.78.62-2.51-.11,1.47.09,1-.74,1.61-1.06C530.86,492.22,530.29,492.78,530.87,493Z"
            />
            <path
              class="cls-115"
              d="M539.31,492.27c0-.42-.23-.91.9-1C540.14,491.65,540.53,492.18,539.31,492.27Z"
            />
            <path
              class="cls-116"
              d="M537,463c.08-.61.21-1.5.31-2.39,0-.35.29-.5.93-.55,3.16-.26,3.88.15,3.32,1.9a10.71,10.71,0,0,0-.44,2.14c0,.47-.33.71-1.2.67h-.15C537,464.83,537,464.83,537,463Z"
            />
            <path
              class="cls-116"
              d="M533.59,460.06c-.16.4.42,1.12-.73,1.1-1,0-.34-.71-.5-1.09-1.1-.06-1.14.43-1.21.81-.17,1.06-.26,2.13-.34,3.2,0,.31-.26.78.67.83s1.86.26,2.14-.48c-.66-.77-.3-1.54-.16-2.31.34.46-.1,1,.42,1.41.42.23.3.54.35.82s.08.36.51.34.4-.17.38-.32a12.72,12.72,0,0,1,.35-3.24C535.56,460,535.53,460,533.59,460.06Zm-2.06,2.26c.05-.19.3-.28.63-.29s.45.12.45.28-.2.31-.56.32S531.47,462.54,531.53,462.32Zm.89,1.71c-.37,0-.6-.09-.5-.3s.08-.43.53-.47.43.18.5.27C533,463.8,532.89,464,532.42,464Z"
            />
            <path
              class="cls-116"
              d="M544.54,461a11.29,11.29,0,0,0-.38,2.66c-.09.57-.39,1.19-1.74,1s-.66-.76-.6-1.16a13.13,13.13,0,0,0,.49-2.75c0-.54.3-.76,1.34-.77C544.94,460,544.53,460.48,544.54,461Z"
            />
            <path
              class="cls-116"
              d="M544.51,458.82l.32.34c-.36.66-1.32.58-2.16.49a25.27,25.27,0,0,0-4.17-.07c-.42,0-1,.23-1-.21s.38-.53,1-.53Z"
            />
            <path
              class="cls-116"
              d="M534.55,457.63h2c.41,0,.72.09.72.34a.39.39,0,0,1-.18.39.85.85,0,0,1-.9-.14c-.08-.06-.05-.38-.42-.1-.94.72-2.24.27-3.38.31-.44,0-.71-.22-.65-.49s.41-.31.79-.32h2Z"
            />
            <path
              class="cls-116"
              d="M535.86,464.72a15.19,15.19,0,0,1,0-4.05c0-.21.07-.61.73-.53s.22.37.19.58a18.23,18.23,0,0,1-.4,3.35C536.36,464.25,536.54,464.47,535.86,464.72Z"
            />
            <path
              class="cls-116"
              d="M539.82,458.5c-.69-.21-2.09.32-2.07-.46s1.37-.4,2.11-.4,2.09-.35,2.08.41S540.54,458.3,539.82,458.5Z"
            />
            <path
              class="cls-116"
              d="M533.74,459.7h-1.25c-.45,0-1,0-1-.37s.51-.43,1-.46c.72,0,1.45,0,2.18,0,.52,0,1.09,0,1.11.42s-.51.44-1.06.44h-.94Z"
            />
            <path
              class="cls-116"
              d="M544.52,457.61c0,.29.55.56.05.85a5.47,5.47,0,0,1-1.49-.06c-.73-.26-.69-.58.21-.77a.53.53,0,0,0,.61,0Z"
            />
            <path
              class="cls-114"
              d="M533.59,460.05c-.16.41.42,1.13-.73,1.11-1,0-.34-.71-.5-1.09Z"
            />
            <path
              class="cls-114"
              d="M533.62,464.42c-.66-.76-.3-1.53-.16-2.3.34.46-.1,1,.42,1.41A.84.84,0,0,1,533.62,464.42Z"
            />
            <path
              class="cls-116"
              d="M537,459.26c0,.17-.06.37-.45.37s-.45-.19-.45-.37.07-.36.46-.36S537,459.08,537,459.26Z"
            />
            <path class="cls-115" d="M543.9,457.62a.53.53,0,0,1-.61,0Z" />
            <path
              class="cls-117"
              d="M525.89,493.36c-.36-.36-.41-.72,0-1.24C526.26,492.64,526.25,493,525.89,493.36Z"
            />
            <path
              class="cls-116"
              d="M509.08,480.53c.16-2.19.33-4.62.49-7,0-.54.38-.86,1.48-.87s2.37-.11,3.56-.16c.83,0,1.17.1,1.1.64-.33,2.42-.64,4.85-.76,7.27,0,.88-.69,1.12-2,1.14a19.41,19.41,0,0,0-2.17.08C509.38,481.79,508.7,481.62,509.08,480.53Z"
            />
            <path
              class="cls-114"
              d="M507.09,481.86a4.1,4.1,0,0,1-1.92-.35c-.16-.73.42-1.44.28-2.14-.17-.9.83-1.87-.53-2.68.72-.5,1.29-1,.08-1.55-.13-.06.23-.22.46-.3.39-.13.45-.41.23-.52-.75-.38-.3-.95-.82-1.36l0,0a1.24,1.24,0,0,1,0-.16,8.5,8.5,0,0,1,2.81-.19l.31.19c-.65,3-.54,6-.87,9Z"
            />
            <path
              class="cls-116"
              d="M507.1,481.86c.33-3,.22-6,.87-9,.64-.2,1-.12,1,.31-.13,1.84-.19,3.68-.45,5.51a17.55,17.55,0,0,0-.14,2.5C508.34,481.65,508.06,481.91,507.1,481.86Z"
            />
            <path
              class="cls-116"
              d="M511.49,472.12c-.59-.13-1.56.4-1.64-.39s.8-.66,1.63-.69c1.08,0,2.16-.11,3.23-.16.67,0,1.1.09,1.08.53s-.35.49-1,.51C513.7,472,512.57,472.05,511.49,472.12Z"
            />
            <path
              class="cls-116"
              d="M511.81,470.53h-.93c-.52,0-.94,0-1-.4s.25-.54.75-.57c1.44-.1,2.88-.17,4.32-.23.57,0,.84.16.84.48s-.15.51-.76.54c-1.08.06-2.16.14-3.23.21Z"
            />
            <path
              class="cls-114"
              d="M507.71,472.28c-.61-.06-1.22-.11-1.82-.18-.9-.1-.7-.51-.67-.84s.63-.24,1.06-.23l1.7,0h0c0,.39,0,.79,0,1.18Z"
            />
            <path
              class="cls-116"
              d="M508,472.24c0-.39,0-.79,0-1.18.57,0,1.21,0,1.15.46S508.83,472.24,508,472.24Z"
            />
            <path
              class="cls-116"
              d="M508.06,469.62c.54,0,1.16,0,1.16.47s-.61.53-1.18.64l-.06,0c0-.35,0-.69,0-1Z"
            />
            <path
              class="cls-116"
              d="M507.08,469.49l.87,0,.11.16-.07,0A1.67,1.67,0,0,1,507.08,469.49Z"
            />
            <path
              class="cls-116"
              d="M508.31,465.84a1.74,1.74,0,0,0-.05-.22c.29-3,.58-6,.86-9l.06,0c1.19,0,1,.49.92.87-.51,1.92-.09,3.87-.55,5.8a21.26,21.26,0,0,0-.32,2.51Z"
            />
            <path
              class="cls-120"
              d="M483.68,495.3c-.86.06-1.72.1-2.58.17a20.13,20.13,0,0,1-4.35-.36c0-.94,0-1.89.05-2.83a4.82,4.82,0,0,0,0-.93c-.09-.38.41-.86-.58-1.1l-.34-.35c2.16-.39,4.44-.43,6.63-.71,1.1-.13,1.6,0,1.54.68,0,.53-.34,1.1.3,1.59a.88.88,0,0,0-.05.15C483.45,492.81,483.77,494.06,483.68,495.3Z"
            />
            <path
              class="cls-116"
              d="M484.27,491.61a.88.88,0,0,1,.05-.15c.54-.38.29-.84.29-1.26,0-.79.54-1.23,2-1.3.91,0,1.08.12,1,.58-.22.92-.35,1.84-.51,2.76-.06.39.16.9-.7,1.05a2,2,0,0,1-1.82-.63C484.51,492.31,484.74,491.93,484.27,491.61Z"
            />
            <path
              class="cls-119"
              d="M488.87,496.42c.12-.79-.85-.38-1.41-.4s-1.08.17-1,.57-.23.81.59.88,1.58.08,2-.44l.34-.49A2.9,2.9,0,0,1,488.87,496.42Zm-1.6.72c-.21-.34-.3-.59.2-.75a.45.45,0,0,1,.49.12C488.17,496.87,487.52,496.88,487.27,497.14Z"
            />
            <path
              class="cls-119"
              d="M493.4,496.31c-.11.24-.23.48-.35.72a5.39,5.39,0,0,1-1.89.17l0-.67.12-.71.47-.17.65-.18c0,.34,0,.7.89.67A.65.65,0,0,1,493.4,496.31Z"
            />
            <path
              class="cls-109"
              d="M491.19,496.53l0,.67a3.86,3.86,0,0,1-1.57.2l-.54-.37c.11-.16.23-.32.34-.49.74,0,.55-.31.54-.56,0-.54.51-.23.88-.17C490.88,496.06,490.77,496.34,491.19,496.53Z"
            />
            <path
              class="cls-110"
              d="M489.59,497.4a3.86,3.86,0,0,0,1.57-.2,5.39,5.39,0,0,0,1.89-.17l.92,0,.19.32-4.53.44Z"
            />
            <path
              class="cls-113"
              d="M493.32,496.14c-.91,0-.88-.33-.89-.67C493.9,495.21,493.19,495.85,493.32,496.14Z"
            />
            <path
              class="cls-111"
              d="M491.19,496.53c-.42-.19-.31-.47-.38-.72a.31.31,0,0,0,.09-.14l.41.15Z"
            />
            <path
              class="cls-120"
              d="M491.31,495.82l-.41-.15c.28-.29.58-.18.88,0Z"
            />
            <path
              class="cls-116"
              d="M517.68,455a3.67,3.67,0,0,1-2,.35c-1.29,0-2.59,0-3.89,0-.59,0-1-.09-1-.49s.26-.53.92-.53c1.56,0,3.11,0,4.67,0,.9,0,1.12.33,1.28.71Z"
            />
            <path
              class="cls-116"
              d="M514.05,456.39h-2.17c-.54,0-1.09,0-1.07-.43s.48-.39,1-.4c1.66,0,3.3,0,5,.11.37,0,.57.08.57.3s-.17.4-.61.41h-2.64Z"
            />
            <path
              class="cls-116"
              d="M509.19,454.14h.29c.35.2,1.1.24.9.68s-.49.54-1.15.55l-.06,0c0-.4,0-.8,0-1.2Z"
            />
            <path
              class="cls-116"
              d="M509.23,455.53c.5,0,.9.1.9.45s-.42.42-.93.43l-.06,0c0-.27,0-.54,0-.82Z"
            />
            <path
              class="cls-115"
              d="M370.79,494.52c.7.37,0,1,.69,1.34-.5.36-.76.21-.94-.14C370.74,495.33,370.35,494.9,370.79,494.52Z"
            />
            <path
              class="cls-116"
              d="M467.18,497.41c0-.63,0-1.27,0-1.91.62,0,.86-.18.93-.54a15.43,15.43,0,0,0,.25-4.39c.83-.31.62.47,1.24.37,0,.12,0,.25,0,.38a1.41,1.41,0,0,0-.06,2.25c0,.23,0,.47,0,.7-.28.2-.14.45-.25.66-.39.77.13,1.64-.92,2.32A2.3,2.3,0,0,1,467.18,497.41Z"
            />
            <path
              class="cls-117"
              d="M469.07,501.88l-.63-1.28c-.06-.1-.06-.29-.14-.31-1.67-.21-.8-1-1.11-1.51h1.38a1.9,1.9,0,0,0,.91.15c-.8.65.17,1.33-.12,2C469.22,501.24,469.68,501.61,469.07,501.88Z"
            />
            <path
              class="cls-110"
              d="M468.57,498.79h-1.38c0-.46,0-.91,0-1.37a2.3,2.3,0,0,0,1.18-.16l1.1.05,0,.38C468.15,497.78,468.92,498.43,468.57,498.79Z"
            />
            <path
              class="cls-113"
              d="M469.51,493.57a1.41,1.41,0,0,1,.06-2.25C469.55,492.07,470.14,492.83,469.51,493.57Z"
            />
            <path
              class="cls-113"
              d="M469.46,497.3l-1.1-.05c1.05-.68.53-1.55.92-2.32.11-.21,0-.46.25-.66A7.55,7.55,0,0,1,469.46,497.3Z"
            />
            <path
              class="cls-113"
              d="M468.57,498.79c.35-.36-.42-1,.92-1.11a1.4,1.4,0,0,1,0,1.26A1.9,1.9,0,0,1,468.57,498.79Z"
            />
            <path
              class="cls-113"
              d="M468.69,502.36l-.12.05-.14,0A.55.55,0,0,1,468.69,502.36Z"
            />
            <path
              class="cls-109"
              d="M488.22,486.4l.15-.15h.87a.77.77,0,0,0,.07.16l0,.18Z"
            />
            <path
              class="cls-111"
              d="M489.31,486.4a.77.77,0,0,1-.07-.16c.15-.07.36-.2.48,0S489.51,486.38,489.31,486.4Z"
            />
            <path
              class="cls-109"
              d="M495.33,485.5l-.12,0a.74.74,0,0,1,.21-.07l.11,0Z"
            />
            <path class="cls-109" d="M495,485.9l.2.08s-.1,0-.12,0l-.2-.07Z" />
            <path
              class="cls-116"
              d="M476.61,496.14a20.23,20.23,0,0,1,4.32,1.35l-2.58.28c-1.69.2-1.84.13-1.83-.86A6.73,6.73,0,0,1,476.61,496.14Z"
            />
            <path
              class="cls-120"
              d="M475.57,491.48l.55,0c0,.28,0,.56.05.83-.18.71.27,1.45-.29,2.15C475.32,493.46,475.64,492.46,475.57,491.48Z"
            />
            <path
              class="cls-113"
              d="M476.17,492.28c0-.27,0-.55-.05-.83s.05-.8.07-1.2c1,.24.49.72.58,1.1a4.82,4.82,0,0,1,0,.93Z"
            />
            <path
              class="cls-109"
              d="M476.17,499.16c0-.33.35-.37.83-.25s1.5.13,1.34.72l-2-.36A.58.58,0,0,0,476.17,499.16Z"
            />
            <path
              class="cls-109"
              d="M480.85,487.29c-.4,0-.62-.14-.64-.37C480.6,487,480.82,487.06,480.85,487.29Z"
            />
            <path
              class="cls-109"
              d="M486.47,486.22h.63a1.16,1.16,0,0,1-.91.13Z"
            />
            <path
              class="cls-109"
              d="M479.29,487.46l-.6-.06s0-.06.07-.07a.66.66,0,0,1,.52.13Z"
            />
            <path class="cls-109" d="M476.27,487.26l-.12-.05.21-.07.11.05Z" />
            <path
              class="cls-113"
              d="M430.52,494.79a5.93,5.93,0,0,0-3.5.23.94.94,0,0,1-.43.08c-.76,0-1.87.37-2.15-.24s1-.53,1.69-.62c1.45-.19,2.93-.3,4.41-.44C430.53,494.13,430.52,494.46,430.52,494.79Z"
            />
            <path
              class="cls-114"
              d="M468.32,490.57a15.43,15.43,0,0,1-.25,4.39c-.07.36-.31.53-.93.54a17.65,17.65,0,0,0,.25-4.29C467.39,490.84,467.58,490.59,468.32,490.57Z"
            />
            <path
              class="cls-116"
              d="M458.42,491.34c-.42,0-1.07.11-1.18-.23s.67-.35,1.1-.42a3.9,3.9,0,0,1,2,0c.18.07.12.21,0,.31C459.82,491.39,459.09,491.29,458.42,491.34Z"
            />
            <path class="cls-114" d="M460.52,493.17l-.23-.15Z" />
            <path
              class="cls-115"
              d="M370.44,491.38c.57.45.43.92.17,1.39C370.05,492.33,370.19,491.86,370.44,491.38Z"
            />
            <path
              class="cls-113"
              d="M385,485.45a45.35,45.35,0,0,1-6.62.49A37.13,37.13,0,0,1,385,485.45Z"
            />
            <path
              class="cls-113"
              d="M377.7,484.23h-2.94v-.1l4.23-.28c-.46.28-1.06.12-1.27.38Z"
            />
            <path
              class="cls-113"
              d="M375.08,483.83l-2.1.11A3.92,3.92,0,0,1,375.08,483.83Z"
            />
            <path class="cls-113" d="M376.11,483.59l1.16,0,0,.1-1.2.09Z" />
            <path
              class="cls-113"
              d="M371.51,484l-.27,0a1.34,1.34,0,0,1,.26-.09,1.05,1.05,0,0,1,.24.06Z"
            />
            <path
              class="cls-113"
              d="M372.71,484.25l.26.05a2,2,0,0,1-.31.08,1,1,0,0,1-.2-.07Z"
            />
            <path
              class="cls-116"
              d="M480.82,477.53a30.37,30.37,0,0,0,.3-4.25c-.08-.61.64-.73,1.46-.78,1.55-.09,3.11,0,4.65-.19.81-.1,1.17.17,1,.61-.58,1.69,0,3.41-.49,5.11-.17.63-.57.85-1.63.89-1.34,0-2.71.07-4,.23s-1.35-.14-1.3-.67C480.85,478.16,480.82,477.84,480.82,477.53Z"
            />
            <path
              class="cls-116"
              d="M471.77,477.35c.09-1.24.21-2.49.26-3.73,0-.44.34-.58,1.1-.65,1.5-.14,3.28-.44,4.43-.08,1.35.44.22,1.5.42,2.29a6.52,6.52,0,0,1,0,1.82c0,.25.08.53-.46.68-1.56.45-.74.74.44,1-1.9.67-3.93.22-5.75.51-.41.06-.45-.26-.47-.46a27.52,27.52,0,0,0,3.41-.17c.46-.06,1,0,.88-.43s-.63-.25-1-.2a29.51,29.51,0,0,1-3.26.11l.29-.37,3.84-.26C474.48,477,473.13,477.43,471.77,477.35Z"
            />
            <path
              class="cls-116"
              d="M488.32,477.25a19.1,19.1,0,0,0,.31-4.33c0-.85,1.13-.75,2.08-.8,1.14-.05,1.06.41,1,.82-.09,1.56-.19,3.12-.32,4.67a.94.94,0,0,1-.66.94,3.77,3.77,0,0,1-1.95.14c-.67-.12-.45-.47-.48-.75A5.3,5.3,0,0,1,488.32,477.25Z"
            />
            <path
              class="cls-116"
              d="M478.33,477.69c.06-.33.64-.33,1.27-.49-1-.21-1.22-.46-1.08-1a11.74,11.74,0,0,0,.1-2.78c0-.38-.07-.79,1-.78s.9.38.9.73a21.93,21.93,0,0,1-.48,5.86c-.44-.45-1.39-.38-1.69-.82.45-.07,1.16.06,1.16-.37S478.79,477.74,478.33,477.69Z"
            />
            <path
              class="cls-116"
              d="M483.4,472.14H482c-.42,0-.86.06-.86-.3s.06-.61.67-.56c2.17.18,4.34-.53,6.48,0,.44.12.34-.1.48-.18a4.83,4.83,0,0,1,2.49-.2c.36,0,.45.21.46.39,0,.35-.41.42-.92.45l-7.39.38Z"
            />
            <path
              class="cls-116"
              d="M472,470.77c.07-.08.12-.23.2-.23,2-.07,4.08-.66,6.11,0-.06.62-.93.63-1.68.67-1.29.06-2.59,0-3.87.1C471.85,471.38,472.14,471,472,470.77Z"
            />
            <path
              class="cls-116"
              d="M472.88,472.48c-.42.15-.73.1-.79-.17s.1-.57.64-.6c1.64-.11,3.29-.18,4.94-.25.36,0,.55.14.59.33s-.14.44-.59.54a10.33,10.33,0,0,1-2.16.15Z"
            />
            <path
              class="cls-121"
              d="M471.76,478.07A29.51,29.51,0,0,0,475,478c.4,0,.91-.12,1,.2s-.42.37-.88.43a27.52,27.52,0,0,1-3.41.17Z"
            />
            <path
              class="cls-116"
              d="M480.47,471.84c0,.34-.33.45-.88.45s-.93-.07-.94-.41.34-.45.88-.45S480.46,471.49,480.47,471.84Z"
            />
            <path
              class="cls-121"
              d="M471.77,477.35c1.36.08,2.71-.34,4.12.09l-3.84.26Z"
            />
            <path
              class="cls-116"
              d="M478.61,470.56c.68-.56,1.41-.25,2.12,0,0,.46-.54.53-1.21.54S478.64,470.88,478.61,470.56Z"
            />
            <path
              class="cls-121"
              d="M470.78,478.87c-.48,0-1.11.16-1.1-.29s.63-.34,1.12-.32C470.79,478.46,470.78,478.67,470.78,478.87Z"
            />
            <path
              class="cls-121"
              d="M478.33,477.69c.46.05,1.15-.08,1.16.36s-.71.3-1.16.37Z"
            />
            <path
              class="cls-115"
              d="M488.9,470.54l.68,0C489.35,470.63,489.1,470.9,488.9,470.54Z"
            />
            <path
              class="cls-116"
              d="M483,462c-1.51-.5-1.28-1.32-1.26-2.11s.05-1.51,0-2.26c0-.53.4-.7,1.31-.7,1.82,0,3.63,0,5.45-.06.59,0,.79.14.71.4-.55,1.66-.07,3.35-.38,5-.13.68-.56,1.06-1.94.95-.59,0-1.22.13-1.84.14-.83,0-1.75,0-1.76-.67.86-.28,2,0,2.9-.41-.63-.26-1.31,0-1.86-.19.25-.24.84,0,1.11-.27A7.91,7.91,0,0,0,483,462Z"
            />
            <path
              class="cls-116"
              d="M474.23,462.2a.69.69,0,0,0-.75-.48c-1.73.07-1.55-.61-1.4-1.16a11.74,11.74,0,0,0,.24-3.12c0-.43.26-.65,1.08-.64,1.46,0,2.92,0,4.37,0,.79,0,1.15.16,1.12.61-.11,1.85-.2,3.69-.3,5.53a.39.39,0,0,1-.41.42c-1.24,0-2.58.37-3.66-.28.68-.51,1.69-.32,2.58-.36.36,0,.86,0,.9-.23s-.59-.43-.86-.38C476.17,462.25,475.16,461.9,474.23,462.2Z"
            />
            <path
              class="cls-116"
              d="M492.63,458.43a16.07,16.07,0,0,0-.31,3.91c0,.73-1.66,1.23-2.81.91-.37-.1-.31-.29-.28-.45a28.52,28.52,0,0,0,.3-5.3c0-.64.82-.56,1.54-.56s1.56-.11,1.56.54Z"
            />
            <path
              class="cls-116"
              d="M479.21,460.44a13.25,13.25,0,0,1,.29-3.09c0-.34.21-.54.89-.56s.76.16.85.52c.4,1.48-.44,2.94-.15,4.41.08.44-1.14-.22-.91.34a3.84,3.84,0,0,1,.25.77c.05.24,0,.5-.52.54s-.69-.21-.69-.46C479.21,462.18,479.21,461.46,479.21,460.44Z"
            />
            <path
              class="cls-116"
              d="M482,454.72a29.37,29.37,0,0,1,6.56-.14c1.37.05,2.9-.32,4.14.32,0,.33-.08.66-.9.64s-1.85.19-2.18-.69c-.67.95-2,.73-3.06.68s-2.26-.17-3.41-.13C482.22,455.44,481.94,455.17,482,454.72Z"
            />
            <path
              class="cls-116"
              d="M472.29,454.71c2.23-.21,4.47-.51,6.62.17,0,.42-.45.52-1.12.52-1.45,0-2.9,0-4.35,0C472.51,455.42,472.27,455.15,472.29,454.71Z"
            />
            <path
              class="cls-116"
              d="M485.6,456.43h-2.79c-.39,0-.73-.07-.73-.34s.36-.33.74-.33h5.58c.4,0,.73.08.72.34s-.34.33-.73.34Z"
            />
            <path
              class="cls-116"
              d="M475.55,456.44h-2.32c-.44,0-.86-.06-.82-.38s.41-.31.78-.31H478c.44,0,.86.05.82.37s-.41.31-.79.31Z"
            />
            <path
              class="cls-114"
              d="M483,462a7.91,7.91,0,0,1,2.45-.16c-.27.3-.86,0-1.11.27.55.19,1.23-.07,1.86.19-.89.39-2,.13-2.9.41-.91-.15-.81.36-1.18.62C481.16,462.59,483,462.51,483,462Z"
            />
            <path
              class="cls-114"
              d="M474.23,462.2c.93-.3,1.94.05,2.91-.1.27-.05.92.1.86.38s-.54.21-.9.23c-.89,0-1.9-.15-2.58.36C474.05,462.82,474.28,462.5,474.23,462.2Z"
            />
            <path
              class="cls-116"
              d="M492.65,456.09c-.67.65-1.74.24-2.62.31-.22,0-.35-.11-.29-.24a.66.66,0,0,1,.58-.24h2.31Z"
            />
            <path
              class="cls-116"
              d="M479.5,454.83c.59-.54,1.29-.26,2-.08-.12.3-.11.64-1,.65S479.48,455.21,479.5,454.83Z"
            />
            <path
              class="cls-116"
              d="M481.32,456.09c0,.32-.45.34-.87.34s-.87,0-.86-.34.44-.33.86-.33S481.29,455.77,481.32,456.09Z"
            />
            <path
              class="cls-116"
              d="M472.33,462.35l-.09.16c-.06-.06-.15-.11-.17-.17s.08-.09.13-.13Z"
            />
            <path
              class="cls-115"
              d="M492.65,456.09l0-.18a.53.53,0,0,1,.1.12S492.68,456.07,492.65,456.09Z"
            />
            <path
              class="cls-117"
              d="M503.63,477c0,1.27,0,2.55,0,3.82,0,.61-.43.74-1.44.62-2.61-.3-2.79-.3-2.55-1.75.36-2.22,0-4.45.56-6.67,0-.13.19-.25.29-.38l.09,1.69v1.41c-.22.24-.38.49-.16.77-.32.44,0,.66.8.65A10.28,10.28,0,0,0,503.63,477Z"
            />
            <path
              class="cls-117"
              d="M504.87,473c.52.41.07,1,.82,1.36.22.11.16.39-.23.52-.23.08-.59.24-.46.3,1.21.55.64,1.05-.08,1.55,1.36.81.36,1.78.53,2.68.14.7-.44,1.41-.28,2.14-.9.27-1.24.07-1.2-.45a42.76,42.76,0,0,1,.41-4.92C504.59,475.08,504.31,474,504.87,473Z"
            />
            <path
              class="cls-114"
              d="M500.58,474.33l-.09-1.69c.84-.78,1.93-.1,2.89-.14.66,0,.61.42.55.69s.43.66,0,1A18.94,18.94,0,0,0,500.58,474.33Z"
            />
            <path
              class="cls-114"
              d="M500.72,470.69a23.08,23.08,0,0,1,2.67.16c.73.1.91.32.83.69s-.66.39-1.18.38C501.7,471.89,500.51,471.75,500.72,470.69Z"
            />
            <path
              class="cls-114"
              d="M500.8,469.32a13.85,13.85,0,0,1,3.47.17c0,.34.7.8-.65.88C501.2,470.5,500.87,470.4,500.8,469.32Z"
            />
            <path
              class="cls-116"
              d="M500.4,476.51c-.22-.28-.06-.53.16-.77a19.7,19.7,0,0,1,3.36-.18c0,.3,0,.61,0,.91Z"
            />
            <path
              class="cls-116"
              d="M500.58,474.33a18.94,18.94,0,0,1,3.37-.14c0,.29,0,.58,0,.87l-3.37,0Z"
            />
            <path
              class="cls-114"
              d="M507.08,469.49a1.67,1.67,0,0,0,.91.17c0,.34,0,.68,0,1-1-.24-2.77.15-2.53-1A3.39,3.39,0,0,1,507.08,469.49Z"
            />
            <path
              class="cls-114"
              d="M500.4,476.51l3.53,0a.48.48,0,0,1-.3.53,10.28,10.28,0,0,1-2.43.16C500.35,477.17,500.08,477,500.4,476.51Z"
            />
            <path
              class="cls-114"
              d="M500.57,475.09l3.37,0c0,.17,0,.33,0,.5a19.7,19.7,0,0,0-3.36.18C500.56,475.52,500.57,475.31,500.57,475.09Z"
            />
            <path
              class="cls-117"
              d="M504.85,472.82a1.24,1.24,0,0,0,0,.16s-.09-.07-.11-.11S504.82,472.84,504.85,472.82Z"
            />
            <path
              class="cls-114"
              d="M509.12,456.63c-.28,3-.57,6-.86,9a2.13,2.13,0,0,1-1.32-.19c0-.8,0-1.6.11-2.4.06-.54-.4-.72-1.25-.73l0-.31c.5-.09,1.27.09,1.41-.35s-1.14-.13-1.21-.56c.35-.25,1.31,0,1.33-.55s-1-.34-1.28-.61c0-1,.05-2,.08-3C506.92,456.27,508.11,456.71,509.12,456.63Z"
            />
            <path
              class="cls-114"
              d="M501.08,459.74a5.38,5.38,0,0,0,.32-2.5c0-.42.24-.67,1.07-.64,1.1,0,2.31-.19,3.24.35,0,.82-.72,1.61-.24,2.43,0,.32.07.69-.67.79a16,16,0,0,1-3.25.05C501.09,460.18,501.11,459.94,501.08,459.74Z"
            />
            <path
              class="cls-117"
              d="M504.85,462.35c0,.72,0,1.44,0,2.16-.07,1.1-1.59.72-2.66.8s-1.44-.24-1.39-.82,0-1.44,0-2.16Z"
            />
            <path
              class="cls-117"
              d="M501.08,459.74c0,.2,0,.44.47.48a16,16,0,0,0,3.25-.05c.74-.1.65-.47.67-.79l.55.54c.32.27,1.29.08,1.28.61s-1,.3-1.33.55c.07.43,1.38.05,1.21.56s-.91.26-1.41.35h-5c0-.24-.11-.51.29-.71a11,11,0,0,0,4.08,0,1.84,1.84,0,0,0,.34-.35c.06-.13.38-.36-.07-.39s-.24.24-.27.39a21.41,21.41,0,0,0-4.09.17A.88.88,0,0,1,501.08,459.74Z"
            />
            <path
              class="cls-117"
              d="M505.8,462.3c.85,0,1.31.19,1.25.73-.09.8-.08,1.6-.11,2.4-1.36.1-1.89-.15-1.53-1S505.13,463,505.8,462.3Z"
            />
            <path
              class="cls-114"
              d="M501.37,454.68a7,7,0,0,1,4.42-.05c0,.46-.34.78-1.28.73C503.36,455.29,501.85,455.72,501.37,454.68Z"
            />
            <path
              class="cls-114"
              d="M503.42,456.41h-.94c-.57,0-1.05-.05-1-.46s.49-.39,1-.39h1.87c.52,0,1.1,0,1.12.41s-.52.43-1.07.44Z"
            />
            <path
              class="cls-114"
              d="M509.18,454.15c0,.4,0,.8,0,1.2-.52,0-1,0-1.54,0-.93,0-1.34-.19-1.27-.7C507.09,454.14,508.23,454.31,509.18,454.15Z"
            />
            <path
              class="cls-114"
              d="M509.16,455.56c0,.28,0,.55,0,.82-.66,0-1.33,0-2,0-.39,0-.91,0-.93-.29s.33-.54,1-.55Z"
            />
            <path
              class="cls-114"
              d="M501.07,461.12a21.41,21.41,0,0,1,4.09-.17v.35a11,11,0,0,1-4.08,0Z"
            />
            <path
              class="cls-116"
              d="M506,459.92l-.55-.54c-.48-.82.25-1.61.24-2.43h.39C506.07,457.93,506,458.93,506,459.92Z"
            />
            <path
              class="cls-114"
              d="M500.79,462h4.35c-.1.12-.2.23-.29.35l-4.07,0Z"
            />
            <path
              class="cls-114"
              d="M420.83,478.6v-.14c1.3,0,1.7.56,1,1.43-.55,0-.47-.44-1-.41l0-.33C421.63,479,421.56,478.79,420.83,478.6Z"
            />
            <path
              class="cls-114"
              d="M422,478.17a3.76,3.76,0,0,1,2.2-.14A3.49,3.49,0,0,1,422,478.17Z"
            />
            <path
              class="cls-114"
              d="M422.85,461.47a1.89,1.89,0,0,1-1.65.07A2.48,2.48,0,0,1,422.85,461.47Z"
            />
            <path class="cls-116" d="M420.83,478.6c.73.19.8.37,0,.55Z" />
            <path
              class="cls-116"
              d="M436.74,464c0-2.09,0-4.18-.05-6.28a.52.52,0,0,1,.33.55c0,1.76,0,3.51,0,5.26A.49.49,0,0,1,436.74,464Z"
            />
            <path
              class="cls-114"
              d="M370.48,463.16c0-.07,0-.13,0-.2v-.67a7.37,7.37,0,0,1-.33-3.25c.08-.74-.24-1.14-1.39-1.15a2.66,2.66,0,0,1-.33.21l-.4,4.58a5.71,5.71,0,0,1,.59,1h0l1.52,0,.33-.19Z"
            />
            <path
              class="cls-116"
              d="M373.08,458.3c-.1-.43-.23-.55-.95-.54l-3.22,0-.14.11c1.15,0,1.47.41,1.39,1.15a7.37,7.37,0,0,0,.33,3.25c1.05-.65,1.3-1.56,2.53-2.19v1.74A10,10,0,0,0,373.08,458.3Z"
            />
            <path
              class="cls-114"
              d="M368.94,456.15h.84l0-1h-1.17C368.77,455.47,368.83,455.81,368.94,456.15Z"
            />
            <path
              class="cls-116"
              d="M369.78,456.14l0-1h2c.56,0,.82.16.83.48s-.22.55-.87.55Z"
            />
            <path
              class="cls-116"
              d="M372.9,456.91c0-.25-.31-.41-.7-.34a29.13,29.13,0,0,1-3.1,0l.06.1c.48.14.81.34.62.72h2.45C372.75,457.36,372.93,457.17,372.9,456.91Z"
            />
            <path
              class="cls-116"
              d="M370.48,463.49l-.33.19c0,.72-.6.75-1.27.7l-.28,0a.8.8,0,0,1-.13.19,4,4,0,0,0,.49,0h.5l.26,0,.24,0a4.88,4.88,0,0,0,.55-.12C371.07,464.24,370.84,463.8,370.48,463.49Z"
            />
            <path
              class="cls-116"
              d="M370.48,463.16c0-.07,0-.13,0-.2a1,1,0,0,1,.08.14S370.51,463.14,370.48,463.16Z"
            />
            <path
              class="cls-121"
              d="M369.59,479.72c0-.23,0-.46,0-.69.05-.4.51-.53,1.16-.54s1,.2,1,.58a2.54,2.54,0,0,0,.2,1.29c.17.3.23.66-.61.72s-1.41.07-1.64-.42a3.75,3.75,0,0,1-.19-.93Z"
            />
            <path
              class="cls-121"
              d="M368.31,479.22c0-.39-.26-.59-1-.57a1.42,1.42,0,0,0-.56.09c0,.62,0,1.25,0,1.88a.72.72,0,0,1,0,.5l.32.36,1.33-.21C368.34,480.59,368.32,479.9,368.31,479.22Z"
            />
            <path
              class="cls-116"
              d="M369.25,477.24l2.48-.18c.23.13.4.4.1.43C371,477.58,369.91,477.94,369.25,477.24Z"
            />
            <path
              class="cls-116"
              d="M370.14,470.8H369c-.53,0-.48-.26-.55-.44s.14-.4.57-.41c1.45,0,2.85-.27,4.32-.18.52,0,.91.09.91.44s-.42.41-.93.43Z"
            />
            <path
              class="cls-116"
              d="M372.71,471c-1.6.08-3.18.2-4.77.3l-.57-.15h0c0,.17,0,.34,0,.51,1.83,0,3.68,0,5.51-.06.52,0,1.56,0,1.46-.41S373.28,471,372.71,471Z"
            />
            <path
              class="cls-115"
              d="M367.94,471.34l-.57-.15A.73.73,0,0,1,367.94,471.34Z"
            />
            <path class="cls-115" d="M385.05,476l-.5-.14Z" />
            <path
              class="cls-117"
              d="M530.87,493c-.58-.21,0-.77-.9-.87v-.32l.91-.06C530.87,492.15,530.87,492.57,530.87,493Z"
            />
            <path
              class="cls-114"
              d="M533,463.53c0,.27-.06.47-.53.5s-.6-.09-.5-.3.08-.43.53-.47S532.88,463.44,533,463.53Z"
            />
            <path
              class="cls-117"
              d="M532.16,462c.29,0,.45.12.45.28s-.2.31-.56.31-.58-.09-.52-.3S531.83,462,532.16,462Z"
            />
            <path
              class="cls-117"
              d="M487.27,497.14c-.21-.34-.3-.59.2-.75a.45.45,0,0,1,.49.12C488.17,496.87,487.52,496.89,487.27,497.14Z"
            />
            <path
              class="cls-116"
              d="M505.16,461.3V461c0-.15-.1-.42.27-.39s.13.26.07.39A1.84,1.84,0,0,1,505.16,461.3Z"
            />
            <path class="cls-12" d="M367.74,465.42q-.06,1.71-.15,3.42" />
            <path
              class="cls-12"
              d="M368.41,458.42c-.13,1.27-.26,2.53-.38,3.8"
            />
            <path class="cls-12" d="M369.4,447c-.22,2.5-.43,5-.65,7.5" />
            <path
              class="cls-109"
              d="M589.92,479.41c.1.71.18,1.43.23,2.14.06.5.13,1,.18,1.49.14,1.22.27,2.44.4,3.65l.24,2.16c.11,1,.22,1.93.32,2.89,0,.07,0,.14,0,.21l.06.61a1.29,1.29,0,0,1,.07.55c0,.39,0,.39.44.47a1,1,0,0,0,.38.07c0-.38-.1-.76-.14-1.14,0-.57-.1-1.14-.16-1.72-.09-.83-.17-1.66-.27-2.49,0-.34-.05-.68-.09-1-.14-1.06-.24-2.12-.34-3.18,0-.52-.12-1-.18-1.55s-.14-1-.16-1.57c0-.06,0-.13.05-.16s.1.05.15.08c1,0,2.07-.07,3.1-.12.24,0,.3.07.31.28s.06.63.08.94l.42,4.71c.16,1.78.32,3.56.49,5.34l.21,2.24c0,.14.13.14.23.16a2.27,2.27,0,0,0,.58.1c0-.69-.09-1.37-.15-2.06-.08-.86-.14-1.72-.23-2.59-.12-1.27-.2-2.55-.32-3.83,0-.38-.06-.75-.09-1.13-.09-1.11-.19-2.22-.29-3.34-.08-.87-.15-1.75-.22-2.63l-3,.21-2.15.16C590,479.34,590,479.33,589.92,479.41Z"
            />
            <path
              class="cls-110"
              d="M595.73,494.29l-.21-2.24c-.17-1.78-.33-3.56-.49-5.34l-.42-4.71c0-.31-.06-.62-.08-.94s-.07-.29-.31-.28c-1,.05-2.07.08-3.1.12a2.22,2.22,0,0,0,.08.68h.1l2.51-.07c.08,0,.17,0,.23.05a0,0,0,0,1,0,.05.4.4,0,0,1,.05.26V482c0,.09.1.17,0,.27v.08c.07.48.11,1,.14,1.45,0,.15-.11.13-.2.12a2.66,2.66,0,0,1-.63,0l-2,0c.05.64.11,1.29.21,1.93a6.23,6.23,0,0,1,1.14.06h.47a.2.2,0,0,1,.17,0l.89,0c.07,0,.15,0,.12.1s.05.14.07.21l0,.12.13,1.62,0,.11v.09c0,.33,0,.36-.31.32a3.78,3.78,0,0,0-.47-.06c-.67-.05-1.33-.17-2-.18l.16,1.62c.07,0,.14,0,.18.11s0,0,0,0h0a.09.09,0,0,1,.12-.07,2.72,2.72,0,0,1,.68.13h.1c.11,0,.22,0,.32.05h.1a.16.16,0,0,1,.17,0h.14a.15.15,0,0,1,.17,0h.15c.19,0,.39,0,.55.11a.24.24,0,0,1,.06.35v.08l0,.27v.11a3.73,3.73,0,0,1,.09,1.15.16.16,0,0,1,0,.17v.08c0,.14,0,.18-.16.16l-1.18-.22a7.19,7.19,0,0,0-1.39-.22l.12,1.36c.86.13,1.7.34,2.54.51A4.91,4.91,0,0,0,595.73,494.29Z"
            />
            <path
              class="cls-111"
              d="M595.24,479c.07.88.14,1.76.22,2.63.1,1.12.2,2.23.29,3.34,0,.38,0,.75.09,1.13.12,1.28.2,2.56.32,3.83.09.87.15,1.73.23,2.59.06.69.13,1.37.15,2.06.21,0,.38-.11.58-.14l.72-.28c0-.12,0-.24,0-.36-.07-.84-.14-1.68-.22-2.52,0-.21,0-.29.26-.27.06-.2.17-.21.47-.06.13,0,.16-.11.29-.21l.28,3.82c.14.07.22-.1.35-.07l.41-.16-.06-.78c-.1-.13-.08-.21.09-.25s.33-.1.5-.15,0-.36.08-.53a1.94,1.94,0,0,0,0-.72c0-.57,0-.57.53-.45.09,0,.2,0,.2.15,0,.4,0,.8.07,1.2h0l.15,0,0-1.15a6.69,6.69,0,0,1-.08-.89,5.8,5.8,0,0,0-1.18-.18,3.1,3.1,0,0,0-1.05-.09,8,8,0,0,1-.81.2,9.38,9.38,0,0,1-1.4-.16c-.11,0-.1-.1-.11-.18,0-.41-.07-.81-.11-1.22,0-.07,0-.14,0-.2l-.12-1.43c-.06-.84-.13-1.67-.2-2.51a1.63,1.63,0,0,1-.05-.9v-.62c-.09,0-.06-.14-.07-.21-.05-.81-.11-1.61-.16-2.42h0c-.1-.07,0-.18,0-.27l0,0a.12.12,0,0,1-.07-.1c0-.35-.07-.7-.1-1.05,0-.11.07-.12.15-.12l1.36-.07c.25-.06.5.11.74-.05,0,0-.09-.08-.12-.08a14.58,14.58,0,0,1-2.09,0s0,.06-.05.06,0-.05,0-.08Z"
            />
            <path
              class="cls-112"
              d="M622.73,493.32l-2.09,1.95a.41.41,0,0,1-.25.13c0,.15-.13.22-.23.31-.31.4-.75.66-1.09,1a.43.43,0,0,1-.3.26l-.75.72a.18.18,0,0,0,.14.1l.26.06a.29.29,0,0,1,.27.07,8.33,8.33,0,0,0,1.13.19.36.36,0,0,0,.34-.12c.59-.65,1.2-1.29,1.8-1.93.41-.43.79-.9,1.24-1.31l0,0a7.24,7.24,0,0,1,0-1c0-.25-.08-.44-.38-.42Z"
            />
            <path
              class="cls-113"
              d="M615.74,494.14h0l.81-1.71c0-.09,0-.15.14-.15l0-1.25c0-.09,0-.2.12-.2s.08.12.09.2a9.14,9.14,0,0,0,0,1.17l.08-.1c0-.05.07-.05.12-.06.17-.37.34-.74.52-1.11.1-.21.23-.23.44-.07l.2.11c-.08-.18,0-.36,0-.53s0-.14.09-.14.07.09.07.15c0,.22,0,.45,0,.68v.3c0,.11,0,.22-.14.22l-.06.75c0,.1.07.08.13.08l.09-.05v-.11c.07-.15.23-.22.23-.44,0-.55,0-1.11,0-1.66a8.26,8.26,0,0,0-1.22-.11c.1.17,0,.23-.14.29l-1.37.71c-.67.35-1.31.73-2,1-.47,0-.91-.14-1.37-.13l0,.19.8.09c.07,0,.14,0,.15.11a.57.57,0,0,1,.45.61c0,.4,0,.79,0,1.18Z"
            />
            <path
              class="cls-111"
              d="M625.14,480.62c0-.54.05-1.07.09-1.61,0-.17-.05-.22-.21-.24-.51,0-1-.13-1.53-.21l-.15,0a14.81,14.81,0,0,1,0,1.49c0,.56-.05,1.11-.07,1.67,0,.91-.1,1.83-.12,2.74s-.08,1.72-.11,2.59a.39.39,0,0,0,.26.14v-.36c.07-1.47.13-2.94.19-4.41,0-.69,0-1.39.08-2.09,0-.44,0-.44.42-.43a2.17,2.17,0,0,0,.36,0c.2,0,.28.06.26.25l.16-.07c0,.92-.1,1.83-.1,2.75,0,.5,0,1-.07,1.51,0,.86-.09,1.73-.13,2.59,0,.62,0,1.24-.07,1.85-.08.83-.08,1.66-.13,2.49a.85.85,0,0,0,.41-1l.07-1.37.09-2C624.93,484.81,625,482.72,625.14,480.62Z"
            />
            <path
              class="cls-109"
              d="M624.59,480.16a.88.88,0,0,1,0,.17c0,.12.06.25-.1.31v.12a1,1,0,0,1,0,.62c0,.34-.06.68,0,1a.26.26,0,0,1-.05.19.55.55,0,0,1,.07.33,8.13,8.13,0,0,0,0,1.1c0,.38-.26.68-.22,1.05,0,.12,0,.25,0,.37,0,.4-.06.8,0,1.19h0s.07,0,.07.06a13.43,13.43,0,0,1-.07,1.51.45.45,0,0,1-.07-.33c0-.26,0-.51,0-.76,0-.06,0-.14-.08-.13s-.07.07-.07.12,0,.25,0,.37-.07.26-.26.18a.66.66,0,0,1,.17.74.76.76,0,0,1,0,.15,15.22,15.22,0,0,1-.11,1.79v.16c0,.44-.06.88-.06,1.32a3.69,3.69,0,0,0,0,.47.23.23,0,0,1-.16.26c.15.08.13.22.12.34a9.41,9.41,0,0,0-.06,1.5c-.11.41,0,.85-.16,1.34a7,7,0,0,0-.12-1.11c-.06,0-.08.06-.12.1l0,0a6.54,6.54,0,0,1,.08,1.08c0,.18,0,.35,0,.52.07,0,.18-.11.19,0s0,.29-.17.3c-.15.18,0,.45-.22.63.23.26-.12.4-.12.62a3.66,3.66,0,0,1,.78.23.13.13,0,0,0,.18,0,1.13,1.13,0,0,1-.06-.41c-.08,0-.08-.07-.08-.14,0-.23,0-.46.06-.69s0-.36-.07-.54,0-.45,0-.68,0-.25,0-.37a.08.08,0,0,1,0-.11,7.62,7.62,0,0,1,.08-1.26,9.11,9.11,0,0,1,0-1.81c0-.63,0-1.27,0-2a.57.57,0,0,1,.07.42c0,.19,0,.37,0,.55s0,.2.16.17c0-.83,0-1.66.13-2.49,0-.61,0-1.23.07-1.85,0-.86.09-1.73.13-2.59,0-.5.07-1,.07-1.51,0-.92.14-1.83.1-2.75Zm-1.14,16v0l.06,0a.14.14,0,0,1,0,.06S623.45,496.15,623.45,496.12Zm-.07,1c.11,0,.18,0,.26.05A.24.24,0,0,1,623.38,497.11Z"
            />
            <path
              class="cls-112"
              d="M623.81,496.34c0,.18,0,.37.07.54.1,0,.19,0,.2.14a2.86,2.86,0,0,1-.13.58v.11c.1,0,.24,0,.24.12a.28.28,0,0,1-.23.29.13.13,0,0,1-.18,0,3.66,3.66,0,0,0-.78-.23c0-.22.36-.36.12-.62l-.11.08-.17.2a6.48,6.48,0,0,1-.5.67c-.08.1-.25.21-.19.31a.47.47,0,0,0,.36.18,14.39,14.39,0,0,1,1.62.26.32.32,0,0,0,.33-.15c.51-.78,1-1.55,1.55-2.32.09-.14.06-.21-.09-.28a3.78,3.78,0,0,0-.8-.21,1.93,1.93,0,0,1-.42,0c-.29-.06-.57-.06-.74.25A.17.17,0,0,1,623.81,496.34Z"
            />
            <path
              class="cls-109"
              d="M603.74,495.22l.29,0c0-1.44-.13-2.87-.18-4.31a2.94,2.94,0,0,0-.12-1.06.25.25,0,0,0-.26.17s0,.07,0,.1l0,.06c0,.05,0,.1,0,.14-.23.24-.49.1-.74,0h0c-.09,0-.18,0-.26,0s-.32,0-.31,0,0-.12-.12-.07a.72.72,0,0,1-.48.05l-.52-.08h-.09c-.45-.05-.9-.09-1.34-.17a8.86,8.86,0,0,1-1.26-.16.26.26,0,0,0,.09.44c.18.06.37,0,.54.11a3.1,3.1,0,0,1,1.05.09,5.8,5.8,0,0,1,1.18.18c.76,0,1.49.18,2.24.25.1,0,.14.07.13.16l0,.41a8.27,8.27,0,0,1,.08,1.49l.06,1a.23.23,0,0,1,0,.18v.3c0,.05,0,.11,0,.17Z"
            />
            <path
              class="cls-114"
              d="M612.75,492.2l0-.19a2.76,2.76,0,0,0-.75-.1,8,8,0,0,1,.65.83,3.75,3.75,0,0,1-1.73,0c.11.73,0,.83-.61.81h0c-.13,0-.19-.06-.19-.19s0-.51,0-.76a2.08,2.08,0,0,0-1,0c0,.52,0,1,.05,1.56,0,.1,0,.22.11.27h.16a3.6,3.6,0,0,1,.65-.7.25.25,0,0,1,.25,0l2.47.39C612.79,493.44,612.74,492.82,612.75,492.2Z"
            />
            <path
              class="cls-110"
              d="M612.75,492.2c0,.62,0,1.24,0,1.86v.16c0,.42,0,.84,0,1.26v.84l0,.2,0,.07c.08,0,.16-.09.24,0h.11l.48.1.05-.13c-.05-1.38,0-2.77,0-4.16,0-.09-.08-.1-.15-.11Z"
            />
            <path
              class="cls-115"
              d="M606.77,495.22a2.09,2.09,0,0,0,.71-.29,1.44,1.44,0,0,1,.45-.17,5.7,5.7,0,0,1-.06-1.3c.06-.41,0-.81,0-1.22a6.56,6.56,0,0,0-1.27-.71c0,.07,0,.14,0,.21C606.68,492.9,606.72,494.06,606.77,495.22Z"
            />
            <path
              class="cls-112"
              d="M624,492.11a9.11,9.11,0,0,0,0,1.81,14.62,14.62,0,0,0,1-1.06c.37-.38.73-.77,1.1-1.16l.27-.31c0-.06.14-.11.09-.2s-.14-.05-.22-.06a1.83,1.83,0,0,1-.47-.05,1,1,0,0,0-1,.39A4.19,4.19,0,0,1,624,492.11Z"
            />
            <path
              class="cls-110"
              d="M607.91,492.24c0,.41,0,.81,0,1.22a5.7,5.7,0,0,0,.06,1.3,4.41,4.41,0,0,1,1-.1.36.36,0,0,0,.33-.24c-.13-.05-.11-.17-.11-.27,0-.52,0-1-.05-1.56h0Z"
            />
            <path
              class="cls-111"
              d="M591.64,485.83c-.1-.64-.16-1.29-.21-1.93l-.17-1.74a1,1,0,0,1,0-.48v-.1a2.22,2.22,0,0,1-.08-.68s-.07-.11-.15-.08-.05.1-.05.16c0,.53.1,1,.16,1.57s.13,1,.18,1.55c.1,1.06.2,2.12.34,3.18,0,.34,0,.68.09,1,.1.83.18,1.66.27,2.49.06.58.11,1.15.16,1.72,0,.38.09.76.14,1.14h.18l-.12-1.36v-.21a6.14,6.14,0,0,1-.13-1.21v-.1a1.69,1.69,0,0,1-.06-.63V490a.09.09,0,0,1,0-.11l-.16-1.62Z"
            />
            <path
              class="cls-110"
              d="M618.14,490.86c-.21-.16-.34-.14-.44.07-.18.37-.35.74-.52,1.11,0,.54,0,1.08,0,1.62a.51.51,0,0,0,.05.32l.82.09Z"
            />
            <path
              class="cls-112"
              d="M627.4,492.05l.09,1.29a5.18,5.18,0,0,0-.78-.09c-.17,0-.22-.07-.09-.23Z"
            />
            <path
              class="cls-109"
              d="M619.49,492.73a9.91,9.91,0,0,1,0,1.09c0,.53,0,.53.53.52,0-.54,0-1.08.07-1.61s0-1.31,0-2c0-.11,0-.25-.15-.26a.81.81,0,0,0-.41,0Z"
            />
            <path
              class="cls-110"
              d="M606.77,495.22c0-1.16-.09-2.32-.14-3.48,0-.07,0-.14,0-.21s-.17-.1-.19.06,0,.23,0,.34l0,1.2c0,.27,0,.55,0,.83,0,.09.08.29-.12.24s-.44.08-.46-.25c0-.6,0-1.2,0-1.8l0-.11-.2-.05c0,1,.06,2.06.1,3.09A3.56,3.56,0,0,0,606.77,495.22Z"
            />
            <path
              class="cls-113"
              d="M620.17,493.81c.16-.2.06-.47.18-.69a1.71,1.71,0,0,1,0-.45c0-.11.07-.12.16-.08v-.1l-.1-.15a1.93,1.93,0,0,1,0-1.14s.14-.22.15,0,.08.06.14,0,.07-.32.25-.38l.07-.19c-.05-.46,0-.93,0-1.39H621c-.17,0-.28.13-.42.2s-.14.09-.16.07-.12,0-.12.09c0,.74-.06,1.49-.07,2.24S620.12,493.18,620.17,493.81Z"
            />
            <path
              class="cls-115"
              d="M613.7,492.4c0,1.39,0,2.78,0,4.16a1,1,0,0,1,.41-.06l.32-.08c-.11-.08-.29,0-.32-.14a4.59,4.59,0,0,0,0-1.11,2.69,2.69,0,0,0,0-1c0-.39,0-.78,0-1.18A.57.57,0,0,0,613.7,492.4Z"
            />
            <path
              class="cls-115"
              d="M605.74,495.08c0-1-.1-2.06-.1-3.09-.2,0-.31-.24-.52-.26,0,1.18.11,2.35.14,3.53C605.44,495.27,605.56,495.09,605.74,495.08Z"
            />
            <path
              class="cls-116"
              d="M612.75,494.22v-.16l-2.47-.39a.25.25,0,0,0-.25,0,3.6,3.6,0,0,0-.65.7,8.51,8.51,0,0,0,1.82-.05.2.2,0,0,0,.17-.11c.16-.1.33,0,.49,0S612.45,494.2,612.75,494.22Z"
            />
            <path
              class="cls-111"
              d="M620.17,493.81c0-.63,0-1.26,0-1.9s0-1.5.07-2.24c0-.08,0-.2.12-.09s.1-.05.16-.07.25-.19.42-.2a.68.68,0,0,1,.45-.25c.19-.26.16-.39-.07-.43a.18.18,0,0,1-.13.15l-.92.49s0-.13-.1-.15a7,7,0,0,0,0,1c0,.09.05.21-.09.24s-.24.05-.32,0,0-.18.07-.25a.73.73,0,0,0,.08-.36c0-.11,0-.18-.17-.17-.12.22-.32.16-.51.15s-.52-.13-.75.09a1.51,1.51,0,0,0,.47.05c.38,0,.38,0,.37.37.26-.09.26-.09.26.26a.81.81,0,0,1,.41,0c.16,0,.15.15.15.26,0,.65,0,1.3,0,2s0,1.07-.07,1.61c.19,0,.09-.21.15-.31s-.06-.11,0-.17A.11.11,0,0,1,620.17,493.81Z"
            />
            <path
              class="cls-109"
              d="M614.13,494.19a2.69,2.69,0,0,1,0,1,4.59,4.59,0,0,1,0,1.11,1.17,1.17,0,0,0,.33-.54c.19-.39.4-.78.62-1.16a.12.12,0,0,1,.14-.12c.16,0,.28-.07.41-.12s.13-.1.12-.2Z"
            />
            <path
              class="cls-113"
              d="M619.57,490.48c0-.35,0-.35-.26-.26s-.27-.05-.41,0l0,.06c.16,0,.14.1.15.21a14.59,14.59,0,0,1,0,1.62,1,1,0,0,1-.08.48l0,.1.5.05C619.52,492,619.54,491.23,619.57,490.48Z"
            />
            <path
              class="cls-110"
              d="M616.6,492.43l-.81,1.71c.22.16.49.11.74.17s.11-.11.13-.19l0-.85v-.15C616.62,492.89,616.74,492.65,616.6,492.43Z"
            />
            <path
              class="cls-110"
              d="M605.26,495.26c0-1.18-.16-2.35-.14-3.53-.21-.17-.24-.06-.23.14.05,1.13.09,2.27.14,3.4l0,.05C605.12,495.29,605.21,495.33,605.26,495.26Z"
            />
            <path
              class="cls-115"
              d="M618.14,490.86l-.09,3.21c.35.05.2-.24.27-.38a2.25,2.25,0,0,1,0-.58c-.05-.23.15-.41.12-.63-.06,0-.14,0-.13-.08l.06-.75c-.09-.17,0-.35,0-.52V491Z"
            />
            <path
              class="cls-113"
              d="M601.6,494.67l.06-.07a.21.21,0,0,0,0-.28c0-.07-.1-.15,0-.19s.18-.11.24-.06a.17.17,0,0,1,0,.24s0,.1,0,.15.26.08.3-.11a1.4,1.4,0,0,1,0-.86c0-.17,0-.36-.07-.52-.08.09-.05.2-.05.3s0,.19-.13.18,0-.12-.07-.18.06-.11,0-.16c-.07.13,0,.41-.17.36s-.15.1-.21.15l-.09,0v.17c.08,0,.09.08.1.15C601.55,494.21,601.57,494.44,601.6,494.67Z"
            />
            <path
              class="cls-117"
              d="M601.6,494.67c0-.23-.05-.46-.07-.69,0-.07,0-.13-.1-.15a.21.21,0,0,1-.2.06l-1.16-.2a.19.19,0,0,1-.14-.11h0l-.08,0c-.08,0-.1-.13-.19-.07l.06.78h.14c0-.46,0-.46.41-.33a8.44,8.44,0,0,1,1.1.19c.1,0,.13.07.11.16l0,.36h.14Z"
            />
            <path
              class="cls-115"
              d="M616.69,493.27l0,.85a.82.82,0,0,0,.57-.14.51.51,0,0,1-.05-.32c0-.54,0-1.08,0-1.62,0,0-.1,0-.12.06a.31.31,0,0,1,.05.12c0,.36,0,.71,0,1.07a.12.12,0,0,1-.13.13C616.82,493.47,616.78,493.32,616.69,493.27Z"
            />
            <path
              class="cls-109"
              d="M602.27,494.34l.41.08v-.35c-.12-.19-.07-.29.15-.33a.32.32,0,0,0,.21-.1l-.63-.1a.31.31,0,0,0-.15.32A3.85,3.85,0,0,1,602.27,494.34Z"
            />
            <path
              class="cls-117"
              d="M602.68,494.07v.35c.05.14,0,.32.11.45a.33.33,0,0,0,0-.26c0-.2,0-.26.25-.2s.39.06.58.1l0-.06v-.24a1.24,1.24,0,0,1-.78-.1C602.81,494.17,602.77,493.93,602.68,494.07Z"
            />
            <path
              class="cls-113"
              d="M603.67,494.51h0c0,.05,0,.11,0,.17a.71.71,0,0,0-.8.18.08.08,0,0,1-.09,0,.33.33,0,0,0,0-.26c0-.2,0-.26.25-.2s.39.06.58.1Zm-.7.14s.11,0,.11-.1-.05,0-.09-.05-.07,0-.07.08S602.92,494.66,603,494.65Z"
            />
            <path
              class="cls-113"
              d="M601.43,494.31c0-.09,0-.15-.11-.16a8.44,8.44,0,0,0-1.1-.19l0,.11A10.28,10.28,0,0,0,601.43,494.31Z"
            />
            <path
              class="cls-117"
              d="M619,492.68l0-.1a.49.49,0,0,1-.27-.31c-.05,0-.1.07-.16.05v.13C618.59,492.93,618.59,492.93,619,492.68Z"
            />
            <path
              class="cls-118"
              d="M601.92,494.46s0-.12,0-.15a.17.17,0,0,0,0-.24c-.06-.05-.16,0-.24.06s-.05.12,0,.19a.21.21,0,0,1,0,.28C601.78,494.62,601.84,494.52,601.92,494.46Z"
            />
            <path
              class="cls-118"
              d="M600.2,494.07l0-.11c-.44-.13-.44-.13-.41.33Z"
            />
            <path
              class="cls-113"
              d="M620.55,492.64l.48.14c.31,0,.58.16.89.15v0A3.81,3.81,0,0,0,620.55,492.64Z"
            />
            <path
              class="cls-109"
              d="M605.06,495.32l0-.05c-.14,0-.27,0-.37-.11a.24.24,0,0,1-.2.06v.1l.21.09C604.82,495.46,604.94,495.36,605.06,495.32Z"
            />
            <path
              class="cls-111"
              d="M602.27,494.34a3.85,3.85,0,0,0,0-.48.31.31,0,0,1,.15-.32l0,0-.13,0a1.4,1.4,0,0,0,0,.86Z"
            />
            <path
              class="cls-109"
              d="M618.32,493.11a2.25,2.25,0,0,0,0,.58c0-.16.11-.32.16-.48S618.42,493.07,618.32,493.11Z"
            />
            <path
              class="cls-113"
              d="M623.34,496.67c.21,0,.19-.19.17-.3s-.12,0-.19,0A.26.26,0,0,0,623.34,496.67Z"
            />
            <path
              class="cls-113"
              d="M621.92,492.93a2.81,2.81,0,0,0,.74.25l0,0a1.55,1.55,0,0,0-.75-.24Z"
            />
            <path
              class="cls-117"
              d="M611.86,494.24c-.16,0-.33-.09-.49,0A.53.53,0,0,0,611.86,494.24Z"
            />
            <path class="cls-113" d="M622.73,493.32l.1-.06,0-.05v0h-.2l0,0Z" />
            <path class="cls-113" d="M620.16,493.86c-.06.06,0,.11,0,.17Z" />
            <path
              class="cls-110"
              d="M611,491.78a5,5,0,0,0-1-.12,6.32,6.32,0,0,0-1-.13l-2.54-.34c-.35,0-.35,0-.26-.37s0-.47-.33-.48a3.71,3.71,0,0,0-1.28-.11s-.08,0-.11,0c-.24.12-.33.05-.31-.22s-.17-.23-.48-.16a.25.25,0,0,0-.26.17v.1l0,.06s-.13.05-.15,0c-.11-.37-.38-.19-.59-.17s-.12.1-.21.09c-.1-.27-.3-.26-.52-.21l-.28.08c0-.14-.08-.19-.22-.16h-.25l-.38.06c0-.1,0-.17-.14-.18a1.08,1.08,0,0,0-.54.08c-.1-.19-.27-.19-.46-.17l-.28.05c0-.25,0-.5,0-.75a.25.25,0,0,0-.11-.25c0-1.23-.15-2.45-.26-3.68a.21.21,0,0,0,0-.2,2,2,0,0,0-.1-.91c-.07-1-.13-1.95-.2-2.92,0-.13,0-.26,0-.39a.27.27,0,0,0,0-.2,8.35,8.35,0,0,0-.09-1.22c0-.37,0-.38.45-.41.65-.05,1.31-.07,2-.12l1.44-.1c1.11-.09,2.22-.18,3.34-.23l.06,1.68c.07,1.86.12,3.72.21,5.58,0,1.23.1,2.45.14,3.67,0,.14,0,.31.21.25a3.66,3.66,0,0,0,.92.14l3.15.31,3.54.36v1.85c-.47,0-.91-.14-1.37-.13a2.76,2.76,0,0,0-.75-.1A4.81,4.81,0,0,0,611,491.78ZM604,485.14l-2.63-.09a.12.12,0,0,0-.11.05H601c-.16-.18-.36-.1-.54-.08a.59.59,0,0,1-.35,0c0,.64,0,1.27,0,1.9,0,.26,0,.51.05.76s.07.2.22.17a4,4,0,0,0,1,.12c.89.09,1.79.15,2.69.23.19,0,.2,0,.12-.18.12-.19,0-.39,0-.58v-.17c0-.43,0-.87,0-1.3v-.07c0-.11,0-.2-.05-.3v-.38C604.13,485.16,604.09,485.14,604,485.14Zm-4.1-2.06c0,.18.13.15.25.13.81,0,1.62,0,2.44,0,.41,0,.82,0,1.23,0,.08,0,.2,0,.21-.12,0-.68-.07-1.35-.09-2v-.7c0-.13,0-.19-.17-.18l-3.15.13-.73.05c-.08,0-.15,0-.13.12C599.82,481.37,599.87,482.23,599.93,483.08Z"
            />
            <path
              class="cls-109"
              d="M616.44,481.51l0,2.09,0,4.93c-.79,0-1.57-.1-2.35-.15l-3.71-.28c0-3-.16-6-.14-9.07l2-.12,4.28-.23C616.44,479.62,616.44,480.56,616.44,481.51Zm-4.05-.65v-.21a1.44,1.44,0,0,0-.77,0h-.06a6,6,0,0,0,.07,1.34l0,1c0,.07,0,.16.08.16a3,3,0,0,0,.6,0c.14,0,.07-.15,0-.24a1,1,0,0,0,0-.48v-.11l0-1.11v-.26A0,0,0,0,0,612.39,480.86Zm-.67,6.76a.23.23,0,0,0,0,.25c0,.09,0,.15.14.15h.26c.36,0,.36,0,.35-.33l0-.79c.08-.42,0-.85,0-1.28,0-.11-.05-.15-.16-.15l-.6,0a.18.18,0,0,0-.07.2,3.77,3.77,0,0,0,.07.95v.12a.29.29,0,0,0,0,.3v.38s0,.06,0,.09Z"
            />
            <path
              class="cls-111"
              d="M608.12,488.75a2.28,2.28,0,0,0-.51.21h-.05c-.41.06-.42.06-.42-.36,0-1.16-.08-2.32-.12-3.49l0-.83c-.06-1.8-.13-3.61-.19-5.41l3.37.17c0,3,.18,6.05.14,9.07Zm1.4-3.22c-.12,0-.26,0-.26.22,0,.73,0,1.46.07,2.19,0,.09,0,.22.15.15s.27,0,.26-.2c0-.73,0-1.45-.06-2.17C609.68,485.62,609.69,485.49,609.52,485.53Zm.24-2.52-.06-2.33-.15.15c0-.12.06-.31-.19-.29s-.2,0-.2.19c0,.73,0,1.46,0,2.18,0,.24,0,.37.31.3h.13C609.75,483.2,609.76,483.11,609.76,483Z"
            />
            <path
              class="cls-115"
              d="M620.41,480c-.08,0-.22.07-.21-.1a5.47,5.47,0,0,1,0-1.07l0-.06,0,0c0-.33-.19-.4-.48-.42-.71-.06-1.41-.15-2.11-.23l0,2.34c0,1.69-.05,3.38-.07,5.07,0,1,0,2.08,0,3.12,0,.11,0,.22-.14.24a3.27,3.27,0,0,1-.84.41c-.81.37-1.63.71-2.44,1.07v1.85c.69-.3,1.33-.68,2-1l1.37-.71c.11-.06.24-.12.14-.29s-.15-.32,0-.45a2.32,2.32,0,0,1,.85-.33A1.06,1.06,0,0,1,619,489a2,2,0,0,1,1-.38c0-.21-.08-.43.08-.61,0-.54,0-1.08,0-1.62h-.37a1.52,1.52,0,0,1-.07.6c-.08-.14,0-.29,0-.43s0-.16.11-.17c-.26-.17-.19.14-.29.2a.55.55,0,0,0,0,.31c0,.08,0,.13-.1.14s-.19.06-.29.11-.17,0-.26,0-.18.15-.3.17h-.11l0,0h0a3.14,3.14,0,0,1,0-.81h.07l.09-.07a.37.37,0,0,0-.28-.1c-.08,0-.2,0-.19-.11s.1-.15.2-.15.22,0,.22-.16c0,0-.13,0-.11-.06s.41-.32.54-.3l.19-.06a.36.36,0,0,1,.37-.13h.06c0-.07.09-.15.15,0h0c0-.14,0-.28,0-.42a.8.8,0,0,0-.27,0,2.33,2.33,0,0,1-1,.26c-.05,0-.11.09-.14,0a.11.11,0,0,1,.08-.16,6,6,0,0,1,1.33-.29.4.4,0,0,1,0,.28c0,.39,0,.79,0,1.18v0h.42c0-.62,0-1.25,0-1.87a5.89,5.89,0,0,1,0-1.39c0-.94.09-1.87,0-2.8,0-.19.11-.21.26-.22l1.52,0v-.05Zm-.66,2.42c0,.06,0,.12-.1.12s-.1.07-.15,0h-.21a.44.44,0,0,1-.32,0c-.08,0-.18,0-.25.06l-.33.07c-.17,0-.11-.11-.1-.16a8.42,8.42,0,0,0,0-1.23.28.28,0,0,1,.12-.25c.12-.06.24-.1.35,0s.16,0,.22,0a.29.29,0,0,1,.36,0h.09a.07.07,0,0,1,.12,0h.1c0-.14,0-.28,0-.42l-1.16,0c-.12,0-.23,0-.22-.18s.1-.18.23-.18a10.4,10.4,0,0,0,1.12,0,.16.16,0,0,1,.13.06s0,.06,0,.09C619.78,481.06,619.76,481.72,619.75,482.38Zm-1.29-1.61c0-.07.09-.07.15-.07s.11,0,.12.06-.06.08-.12.09S618.49,480.86,618.46,480.77Zm.59,0c0-.08,0-.09.09-.1s.13,0,.16,0,0,.1-.11.11S619.07,480.85,619.05,480.78Z"
            />
            <path
              class="cls-110"
              d="M617.35,488.81c.14,0,.14-.13.14-.24l0-3.12c0-1.69.05-3.38.08-5.07l0-2.34a2.77,2.77,0,0,0-1.07.08c-.09,0-.08.1-.08.17l0,.39c0,.94,0,1.88,0,2.83l0,2.09,0,4.93c0,.14.08.17.2.19A6.48,6.48,0,0,1,617.35,488.81Z"
            />
            <path
              class="cls-115"
              d="M607.61,489h-.05c-.41.06-.42.06-.42-.36,0-1.16-.08-2.32-.12-3.49a1.79,1.79,0,0,1,0-.83c-.06-1.8-.13-3.61-.19-5.41a1.47,1.47,0,0,1,0-.21c0-.24-.09-.33-.32-.32s-.43-.06-.65,0l.06,1.68c.07,1.86.12,3.72.21,5.58,0,1.23.1,2.45.14,3.67,0,.14,0,.31.21.25a1.36,1.36,0,0,1,.52-.19A1.28,1.28,0,0,0,607.61,489Z"
            />
            <path
              class="cls-109"
              d="M619.65,486.4H620a3.28,3.28,0,0,1,.69.1l.36,0,.11,0,.16,0c.1.05.26,0,.29.16h0c.06-.07.1,0,.13,0a.79.79,0,0,1,.37.07h0a.24.24,0,0,1,.3,0l.55.25c0-.87.09-1.73.11-2.59s.09-1.83.12-2.74c0-.56,0-1.11.07-1.67a14.81,14.81,0,0,0,0-1.49l-3.09.15,0,.06c.6,0,1.19-.09,1.79-.07.15,0,.29,0,.44,0s.2.08.19.23,0,.52,0,.78c0,.07,0,.14-.08.17l-.06.4c.1.21,0,.42,0,.64-.07,1,0,2.07,0,3.1,0,.12,0,.26-.14.32a.46.46,0,0,0,0,.26l0,.06h0a.58.58,0,0,1,0,.23l-.06,1.52c0,.3,0,.31-.31.16a.17.17,0,0,1-.14,0l-.11,0-.1,0-.11,0-.07,0-.14-.05-.16,0a6.15,6.15,0,0,1-1-.11h-.48c-.09,0-.18,0-.23-.08h-.06c0,.12-.07.06-.12.05h-.1v.1l.11,0c.24,0,.09.14.13.22s0-.37.29-.2Z"
            />
            <path
              class="cls-117"
              d="M598.74,480.38a8.35,8.35,0,0,0-.09-1.22,1.39,1.39,0,0,0-.73-.08c-.24.16-.49,0-.74.05,0,.43.11.85.08,1.28h.07Z"
            />
            <path class="cls-109" d="M595.61,479s0,.09,0,.08,0,0,.05-.06Z" />
            <path
              class="cls-117"
              d="M592.78,485.89c.1.09.31.07.31.29,0,0,.07.07.12.05s.06-.08,0-.13-.09-.13,0-.2a.2.2,0,0,1,.17,0c.11.16.3,0,.42.1-.12,0-.24,0-.36,0s-.15.11-.06.16a.75.75,0,0,0,.55,0c.06,0,0-.11,0-.16a.34.34,0,0,1,.36,0c-.08,0-.24,0-.23.12s.15.09.24.1h.13l0,.12h0c-.1,0-.24-.05-.28.07s.17.06.2.18c-.16,0-.2.05-.18.23.06.39.07.79.1,1.19,0,.11,0,.26.1.32s.17-.13.27-.16c0,.33,0,.36-.31.32a3.78,3.78,0,0,0-.47-.06c-.67-.05-1.33-.17-2-.18l-.26-2.47A6.23,6.23,0,0,1,592.78,485.89Zm.66.92a10.86,10.86,0,0,1,.09,1.28c0,.06,0,.13.09.13s.06-.07.08-.12a.94.94,0,0,1,.09-.12c.17,0,.08.19.15.33,0-.14,0-.3.17-.29s0-.06,0-.11c0-.37,0-.73-.1-1.09s-.25-.18-.41-.2S593.42,486.64,593.44,486.81Zm-1,1.24c0,.11.06.14.14.15l.47.05c.08,0,.11,0,.1-.11a9.83,9.83,0,0,1-.14-1.33c0-.09,0-.22-.15-.21s-.32-.1-.49,0,0,.09,0,.14C592.4,487.17,592.54,487.6,592.49,488.05ZM592,488c0,.2.14.19.27.19s.06-.14.06-.21c0-.38-.06-.76-.09-1.14,0-.1,0-.2-.1-.25a.24.24,0,0,0-.2,0c-.12.07-.05.19-.07.31C592,487.18,592,487.57,592,488Zm1.29-1.17c0-.08,0-.2-.14-.17s0,.13,0,.2a9.81,9.81,0,0,1,.09,1.09,1.22,1.22,0,0,0,0,.26c0,.06,0,.15.13.13a.07.07,0,0,0,.05-.1C593.42,487.68,593.38,487.23,593.33,486.78Zm-.34-.66c0-.15-.14-.1-.23-.11a1.55,1.55,0,0,0-.31,0c-.05,0-.14,0-.15.07a.13.13,0,0,0,.12.14l.32.05C592.85,486.21,593,486.27,593,486.12Zm.43.31c0,.14.18.08.28.09s.32.08.33-.09-.21,0-.32-.09S593.43,486.3,593.42,486.43Zm-.44,0c0-.14-.12-.08-.2-.09l-.31,0c-.05,0-.12,0-.13.06s0,.08.1.09l.33.05C592.85,486.47,593,486.52,593,486.42Zm-.79,0s0-.07,0-.09a.34.34,0,0,0-.33,0C592,486.43,592.08,486.49,592.19,486.41Zm2,1.85a.1.1,0,0,0-.05,0s0,0,0,.06l.05,0S594.21,488.27,594.2,488.26Z"
            />
            <path
              class="cls-117"
              d="M592.24,490s0,0,0,0,0,.26.11.31.2.07.24-.05a.16.16,0,0,0-.14-.23l-.17,0a.09.09,0,0,1,.12-.07,2.72,2.72,0,0,1,.68.13c-.08.09-.16,0-.25,0s-.17,0-.17.14,0,.17.15.17l.34,0c.1,0,.2,0,.24-.11s-.06-.14-.15-.17,0-.05-.06-.08.22,0,.32.05-.09.23,0,.33a.08.08,0,0,0,.12,0c.08-.11,0-.21,0-.32a.16.16,0,0,1,.17,0c0,.11-.11.26,0,.32a.56.56,0,0,0,.5.06c.16-.1,0-.22-.06-.33.19,0,.39,0,.55.11l-.15,0c-.09,0-.17,0-.17.14s.07.12.16.13l.22.06v.08h-.16c-.07,0-.17-.06-.19.05a.16.16,0,0,0,.16.19.85.85,0,0,1,.23,0v.11c-.12,0-.24,0-.35.05s-.11-.14-.21-.09a.32.32,0,0,0-.27,0l-.16,0c-.06,0-.11,0-.09.1.1.39,0,.8.13,1.19l0,.06c.14,0,.3.18.42-.05h0c.14,0,.15-.07.12-.19a2.36,2.36,0,0,1,0-.75c0,.23.07.46.08.69,0,.41,0,.41.42.48,0,.14,0,.18-.16.16l-1.18-.22a7.19,7.19,0,0,0-1.39-.22v-.21c.1-.11,0-.24.05-.37s0-.19,0-.27v.37c0,.12,0,.29.16.31s.22-.05.21-.21-.06-.61-.08-.92c0-.14-.1-.17-.22-.17s-.15,0-.15.15,0,.24,0,.39c-.13-.17,0-.39-.17-.49v-.1c.06-.22.13-.44-.06-.63V490Zm1.26,1.09c0-.15-.08-.17-.2-.18l-.49-.05c0,.15,0,.3,0,.46a2.48,2.48,0,0,0,.06.54c0,.1,0,.26.09.3a1.48,1.48,0,0,0,.54.08c.14,0,0-.16.08-.24A4,4,0,0,1,593.5,491.12Zm-1-.62c-.08,0-.18,0-.2.07s.07.13.15.13a5.32,5.32,0,0,1,.8.12c.07,0,.15,0,.17-.06s0-.13-.13-.15l-.43-.07C592.73,490.71,592.63,490.49,592.5,490.5Zm1.26.64c0-.08,0-.14-.11-.14a.1.1,0,0,0-.09.12,6,6,0,0,0,.19,1.19A5.09,5.09,0,0,0,593.76,491.14Zm.66-.23a.12.12,0,0,0-.08-.15,1.67,1.67,0,0,0-.7-.08c-.06,0-.09,0-.09.1s0,.08.06.08l.66.11C594.33,491,594.4,491,594.42,490.91Z"
            />
            <path
              class="cls-117"
              d="M591.3,481.58c.09.07.19,0,.28,0l2.46-.06a0,0,0,0,1,0,.05c-.12,0-.35-.08-.35.13s.24.09.37.13h0V482h-.24c-.06,0-.15,0-.14.09s0,.16.14.16h.26v.08c-.41,0-.42.05-.35.46a2.35,2.35,0,0,1,.05.65.44.44,0,0,0,.24.46,2.66,2.66,0,0,1-.63,0l-2,0-.17-1.74h.11c.07.2.23.17.37.14a2.34,2.34,0,0,1,.7,0c.07,0,.17.06.17-.07a.14.14,0,0,0-.17-.15l-1,0v-.11c.08,0,.19,0,.25,0s.11-.18,0-.24h-.41v-.1Zm2,.79c-.33,0-.33,0-.31.33a6.49,6.49,0,0,1,.09,1s0,.09.07.09.07,0,.08-.1,0-.18,0-.25a.42.42,0,0,0,0,.27c.06.22.23.15.37.13s.11-.16.1-.25c0-.32,0-.64-.08-1,0-.12,0-.26-.21-.24Zm-.63.18c0-.11,0-.15-.16-.16-.53-.07-.65.06-.54.59,0,.21.07.42.09.64s.06.21.21.2h0c.48,0,.48,0,.45-.55C592.7,483.08,592.67,482.82,592.64,482.55Zm-1.12,1c0,.17.08.36.3.31s.11-.24.09-.36a7.35,7.35,0,0,1-.1-.82c0-.17-.06-.23-.23-.23s-.15.14-.14.3A6.18,6.18,0,0,1,591.52,483.51Zm1.23-1.86c-.07,0-.12,0-.12.11a.14.14,0,0,0,0,.11c.06.05.1,0,.14,0s0-.12.08,0,.38.07.57.07.11-.07.1-.15-.07-.09-.13-.09h-.68Zm.13.92c0-.07,0-.19-.12-.16s0,.11,0,.17a8.43,8.43,0,0,0,.1,1c0,.06,0,.13.1.2A7,7,0,0,0,592.88,482.57Zm-.33-.79c0-.22-.23-.11-.36-.11s-.35-.1-.34.13.24.07.36.13S592.56,482,592.55,481.78Zm.9.48c.08,0,.17,0,.17-.12s-.09-.13-.17-.13h-.36c-.09,0-.19,0-.19.13s.09.13.18.12h.37Zm-.68,0c.06,0,.07-.06.07-.11s0-.11-.08-.11-.07.06-.07.12S592.7,482.26,592.77,482.25Z"
            />
            <path
              class="cls-116"
              d="M594.33,491.38a.69.69,0,0,1,0-.25c.1-.05.08.19.21.09s.23,0,.35-.05a3.73,3.73,0,0,1,.09,1.15c-.06.08,0,.13,0,.17v.08c-.4-.07-.39-.07-.42-.48,0-.23,0-.46-.08-.69a2.36,2.36,0,0,0,0,.75c0,.12,0,.19-.12.19C594.4,492,594.38,491.7,594.33,491.38Zm.51.63a.37.37,0,0,0,0,.37A.38.38,0,0,0,594.84,492Z"
            />
            <path
              class="cls-116"
              d="M594.52,486.4h0c-.1,0-.24-.05-.28.07s.17.06.2.18c-.16,0-.2.05-.18.23.06.39.07.79.1,1.19,0,.11,0,.26.1.32s.17-.13.27-.16v-.09c-.06,0-.1-.06,0-.11Z"
            />
            <path
              class="cls-116"
              d="M594.12,482.33c-.41,0-.42.05-.35.46a2.35,2.35,0,0,1,.05.65.44.44,0,0,0,.24.46c.09,0,.21,0,.2-.12C594.23,483.3,594.19,482.81,594.12,482.33Z"
            />
            <path
              class="cls-116"
              d="M593.11,490.11c-.08.09-.16,0-.25,0s-.17,0-.17.14,0,.17.15.17l.34,0c.1,0,.2,0,.24-.11s-.06-.14-.15-.17,0-.05-.06-.08Z"
            />
            <path
              class="cls-116"
              d="M593.8,490.2c0,.11-.11.26,0,.32a.56.56,0,0,0,.5.06c.16-.1,0-.22-.06-.33h-.15c-.07.07-.13.06-.17,0Z"
            />
            <path
              class="cls-115"
              d="M591.3,481.58c.09.07.19,0,.28,0l2.46-.06c-.06-.09-.15-.06-.23-.05Z"
            />
            <path
              class="cls-116"
              d="M594.81,490.36l-.15,0c-.09,0-.17,0-.17.14s.07.12.16.13l.22.06A.24.24,0,0,0,594.81,490.36Z"
            />
            <path
              class="cls-116"
              d="M594.1,482h-.24c-.06,0-.15,0-.14.09s0,.16.14.16h.26C594.2,482.15,594.09,482.07,594.1,482Z"
            />
            <path
              class="cls-116"
              d="M594,481.61c-.12,0-.35-.08-.35.13s.24.09.37.13h0A.4.4,0,0,0,594,481.61Z"
            />
            <path
              class="cls-116"
              d="M592.27,490.05c0,.11,0,.26.11.31s.2.07.24-.05a.16.16,0,0,0-.14-.23l-.17,0Z"
            />
            <path
              class="cls-116"
              d="M594.87,490.79h-.16c-.07,0-.17-.06-.19.05a.16.16,0,0,0,.16.19.85.85,0,0,1,.23,0Z"
            />
            <path
              class="cls-115"
              d="M592.78,485.89c.1.09.31.07.31.29,0,0,.07.07.12.05s.06-.08,0-.13-.09-.13,0-.2Z"
            />
            <path
              class="cls-115"
              d="M593.42,485.93c.11.16.3,0,.42.1a.19.19,0,0,0,.16.06.34.34,0,0,1,.36,0h.07c0-.11,0-.1-.12-.1Z"
            />
            <path
              class="cls-116"
              d="M594.43,486.07h-.07c-.08,0-.24,0-.23.12s.15.09.24.1h.13C594.48,486.21,594.51,486.12,594.43,486.07Z"
            />
            <path
              class="cls-116"
              d="M593.53,490.16c0,.11-.09.23,0,.33a.08.08,0,0,0,.12,0c.08-.11,0-.21,0-.32Z"
            />
            <path
              class="cls-117"
              d="M595,492.32c-.06.08,0,.13,0,.17A.16.16,0,0,0,595,492.32Z"
            />
            <path
              class="cls-117"
              d="M593.94,490.21c0,.09.1.1.17,0A.15.15,0,0,0,593.94,490.21Z"
            />
            <path
              class="cls-115"
              d="M592.1,490h.14c0-.08-.11-.09-.18-.11A.09.09,0,0,0,592.1,490Z"
            />
            <path class="cls-117" d="M594.65,488c-.08.05,0,.08,0,.11Z" />
            <path
              class="cls-117"
              d="M598.53,489.82a.68.68,0,0,0-.27.05.26.26,0,0,0,.09.44c.18.06.37,0,.54.11a8,8,0,0,1-.81.2,8.18,8.18,0,0,1-.13-1.3c0-.23-.11-.32-.33-.33l-1.11-.13-.12-1.43c-.06-.84-.13-1.67-.2-2.51l1.17,0c.19,0,.26-.07.25-.26s0-.43,0-.65a9.87,9.87,0,0,1,1.22-.09.52.52,0,0,0,.16-.06,2,2,0,0,1,.1.91l-1.24.13c-.1,0-.18,0-.15.15l0,.06c-.09,0-.2,0-.19.14s.1.16.2.19v.1h0c-.09,0-.2,0-.19.14s.06.22.21.22h0v.1l0,.06c-.11-.06-.17,0-.16.1,0,.55.06,1.11.12,1.66,0,.25,0,.5.05.75s0,.23.21.22h0c0,.14.1.16.22.14l1.15-.29a.25.25,0,0,1,.11.25c0,.25,0,.5,0,.75A1.34,1.34,0,0,1,598.53,489.82Zm-1.1-3.51c0-.17-.07-.26-.26-.26l-.6,0c-.14,0-.2,0-.18.2.08.73.15,1.46.19,2.19,0,.26.13.33.35.33a1.53,1.53,0,0,1,.37,0c.23.05.34,0,.27-.33C597.52,487.77,597.47,487,597.43,486.31Zm-.07-.53c0-.22-.13-.2-.28-.2l-.54,0c-.11,0-.18,0-.18.16a.15.15,0,0,0,.17.15l.56.05C597.19,485.86,597.36,486,597.36,485.78Zm-.18-.36c.09,0,.16,0,.16-.12a.14.14,0,0,0-.13-.17c-.24,0-.48,0-.73-.05-.09,0-.14.05-.13.15s0,.15.13.16l.54,0h.16Z"
            />
            <path
              class="cls-116"
              d="M596.14,483.4v.1s.05.06.05.09c0,.28.14.35.39.32H597c.09,0,.18,0,.22.09h.1c0-.23,0-.46-.06-.7,0-.56-.11-1.13-.11-1.69,0-.22-.09-.35-.32-.35h-.68c-.16,0-.16.09-.14.21,0,.49.09,1,.12,1.46A1.29,1.29,0,0,1,596.14,483.4Z"
            />
            <path
              class="cls-110"
              d="M598.08,490.62a8.18,8.18,0,0,1-.13-1.3c0-.23-.11-.32-.33-.33l-1.11-.13c-.07.06,0,.13,0,.2,0,.41.07.81.11,1.22,0,.08,0,.17.11.18A9.38,9.38,0,0,0,598.08,490.62Z"
            />
            <path
              class="cls-110"
              d="M597.26,480.41c0-.43-.1-.85-.08-1.28l-1.36.07c-.08,0-.16,0-.15.12,0,.35.06.7.1,1.05a.12.12,0,0,0,.07.1Z"
            />
            <path
              class="cls-110"
              d="M597.31,484h-.1l-1.07,0a1.63,1.63,0,0,0,.05.9l1.17,0c.19,0,.26-.07.25-.26s0-.43,0-.65c0,0,0,0,0,0l-.15,0C597.39,484,597.35,484,597.31,484Z"
            />
            <path
              class="cls-109"
              d="M598.57,494.22c0,.23.1.35.34.31l-.28-3.82c-.13.1-.16.23-.29.21v.17Z"
            />
            <path
              class="cls-114"
              d="M603.49,491.1c0-.09,0-.14-.13-.16-.75-.07-1.48-.23-2.24-.25a6.69,6.69,0,0,0,.08.89h0s0,0,0,0c0,.36,0,.72.08,1.07s.25.17.4.2.13-.12.13-.22a3.05,3.05,0,0,0-.07-.67c-.06.11-.15.24-.3.2s-.11-.2-.12-.32c0-.27-.07-.55-.11-.83s0-.19.16-.18a.33.33,0,0,1,.35.38c0,.13,0,.27.06.38a.72.72,0,0,0,0-.48c0-.21.06-.25.25-.21a10.45,10.45,0,0,1,1.12.18Z"
            />
            <path
              class="cls-109"
              d="M601.05,492.77c0-.4,0-.8-.07-1.2,0-.14-.11-.13-.2-.15-.56-.12-.55-.12-.53.45a1.94,1.94,0,0,1,0,.72A2.88,2.88,0,0,0,601.05,492.77Z"
            />
            <path
              class="cls-117"
              d="M601.05,492.77a2.88,2.88,0,0,1-.77-.18c-.11.17,0,.36-.08.53h.14s0,0,0-.05-.1-.28.15-.21l.11.05c0-.05.1-.08.15,0s0,0,0,0,.15-.12.15,0,0,.17.1.17l.09,0c0-.24.14-.12.23-.13s.18.05.17.17,0,.25-.09.27-.27,0-.34-.12l-.09.11v.13l.44.1.09,0c.06-.05,0-.2.21-.15s.1-.23.17-.36c.1.05,0,.11,0,.16s-.06.18.07.18.13-.09.13-.18,0-.21.05-.3-.24,0-.22-.2a3.48,3.48,0,0,0-.13-1.11c-.08.1,0,.21-.05.32a3.05,3.05,0,0,1,.07.67c0,.1,0,.25-.13.22s-.35.06-.4-.2-.05-.71-.08-1.07c0,0,0,0,0,0h0l0,1.15c0,.09-.09.06-.15,0Z"
            />
            <path
              class="cls-109"
              d="M597.84,494.13l.29.05-.24-3.13,0-.07c-.21,0-.28.06-.26.27.08.84.15,1.68.22,2.52C597.84,493.89,597.84,494,597.84,494.13Z"
            />
            <path
              class="cls-117"
              d="M597.25,483.28c0-.56-.11-1.13-.11-1.69,0-.22-.09-.35-.32-.35h-.68c-.16,0-.16.09-.14.21,0,.49.09,1,.12,1.46a1.29,1.29,0,0,1,0,.48c-.09,0-.06-.14-.07-.21-.05-.81-.11-1.61-.16-2.42a.4.4,0,0,0,.33.1l.66,0c.1,0,.17,0,.16-.16s0-.16-.16-.15l-.78,0c-.15,0-.19.1-.21.22-.1-.07,0-.18,0-.27l1.42,0c-.06.07-.18.08-.15.21a.19.19,0,0,0,.2.16v.05c-.08,0-.15,0-.15.14s.08.12.16.12v.06c-.2,0-.17.15-.15.27.1.58,0,1.17.14,1.75,0,.24.06.5.08.75,0,.06-.07,0-.11,0C597.29,483.75,597.26,483.52,597.25,483.28Zm-.36-2.12c.09,0,.19,0,.18-.13s-.09-.12-.17-.12a4.64,4.64,0,0,0-.83.06c-.06,0-.09,0-.09.09s0,.12.1.12h.81Z"
            />
            <path
              class="cls-113"
              d="M600.34,493.12h-.14c-.17.05-.33.11-.5.15s-.19.12-.09.25c.09-.06.11.08.19.07.05-.21.21-.29.45-.24h.16Z"
            />
            <path
              class="cls-117"
              d="M596.14,484l1.07,0c0-.11-.13-.09-.22-.09h-.41c-.25,0-.41,0-.39-.32,0,0,0-.06-.05-.09Z"
            />
            <path
              class="cls-113"
              d="M597.87,491l0,.07.44,0v-.17C598,490.77,597.93,490.78,597.87,491Z"
            />
            <path
              class="cls-119"
              d="M595.86,480.51l1.42,0h.05v-.05h-.07l-1.42.06Z"
            />
            <path class="cls-109" d="M601.07,492.77c.06,0,.12.05.15,0Z" />
            <path
              class="cls-118"
              d="M622.88,493.21l0,.05c.3,0,.37.17.38.42a7.24,7.24,0,0,0,0,1s.06-.09.12-.1l.07-.15a8.36,8.36,0,0,1-.14-1.12,1.48,1.48,0,0,0,0-.21c0-.07-.09-.12-.12,0S623,493.18,622.88,493.21Z"
            />
            <path
              class="cls-109"
              d="M617.62,489.66c-.19.13-.19.28,0,.45a8.26,8.26,0,0,1,1.22.11h.1c.14,0,.28.09.41,0,0-.38,0-.38-.37-.37a1.51,1.51,0,0,1-.47-.05C618.2,489.7,617.88,489.83,617.62,489.66Z"
            />
            <path
              class="cls-114"
              d="M616.69,493.27c.09.05.13.2.27.15,0-.41,0-.81,0-1.22a9.14,9.14,0,0,1,0-1.17c0-.08,0-.21-.09-.2s-.12.11-.12.2l0,1.25a4,4,0,0,1,0,.49c0,.12.08.26-.07.35Z"
            />
            <path
              class="cls-111"
              d="M618.9,490.21h-.1c0,.55,0,1.11,0,1.66,0,.22-.16.29-.23.44s.11,0,.16-.05a.41.41,0,0,0,.19-.41c0-.53,0-1.06,0-1.59Z"
            />
            <path
              class="cls-117"
              d="M617,492.2c0,.41,0,.81,0,1.22a.12.12,0,0,0,.13-.13c0-.36,0-.71,0-1.07a.31.31,0,0,0-.05-.12Z"
            />
            <path
              class="cls-114"
              d="M618.34,491v.16h.16c0-.23,0-.46,0-.68,0-.06,0-.14-.07-.15s-.09.08-.09.14S618.26,490.79,618.34,491Z"
            />
            <path
              class="cls-115"
              d="M616.68,493.12c.15-.09.07-.23.07-.35a4,4,0,0,0,0-.49c-.1,0-.14.06-.14.15S616.62,492.89,616.68,493.12Z"
            />
            <path
              class="cls-109"
              d="M618.51,491.13h-.16c0,.17-.07.35,0,.52.14,0,.15-.11.14-.22Z"
            />
            <path
              class="cls-115"
              d="M623.85,480.66a1.62,1.62,0,0,1,.62,0c.16-.06.12-.19.1-.31a5.8,5.8,0,0,0-1,0c0,.69,0,1.39-.08,2.08-.06,1.47-.13,2.94-.19,4.41v.36l0,.09c.06.1.23.1.21.26h.06c.07,0,.12,0,.15.11.19.08.27,0,.26-.18s0-.25,0-.37,0-.11.07-.12.08.07.08.13c0,.25,0,.5,0,.76a.45.45,0,0,0,.07.33,13.43,13.43,0,0,0,.07-1.51s0-.05-.07-.06l0,0,0,0c-.05-.39,0-.79,0-1.19-.05-.13-.41-.27,0-.37,0-.37.24-.67.22-1.05a8.13,8.13,0,0,1,0-1.1.55.55,0,0,0-.07-.33l-.07,0h-.08l-.07.11H624a.19.19,0,0,1-.16.06h-.1a1,1,0,0,1,0-.71c0-.16-.1-.37.1-.49,0-.09,0-.22.17-.13h.1a.1.1,0,0,1,.16,0h0c0-.05.07-.05.11,0h0a1,1,0,0,0,0-.62.61.61,0,0,1-.66.08c-.05,0-.11,0-.1-.08S623.79,480.67,623.85,480.66Zm-.39,6.35a1.31,1.31,0,0,1,.57-.27A1,1,0,0,1,623.46,487Zm.53-1.56a1.73,1.73,0,0,1,0,1.1h-.13c0,.07,0,.16-.15.16l-.06.06c0,.05-.09.11-.15.07s0-.09,0-.14a3.37,3.37,0,0,1,0-.55c0-.21-.05-.45.12-.64h.14l.15,0C623.88,485.42,623.92,485.37,624,485.45Zm-.47,2.11Z"
            />
            <path
              class="cls-113"
              d="M623.55,480.35a7.06,7.06,0,0,1,1,0v-.17c0-.19-.06-.27-.26-.25a2.17,2.17,0,0,1-.36,0C623.54,479.91,623.54,479.91,623.55,480.35Z"
            />
            <path
              class="cls-113"
              d="M623.31,487.3l0-.09a.39.39,0,0,1-.26-.14l-.55-.25a.24.24,0,0,0-.3,0s0,0,0,0a.71.71,0,0,1,.38.09A5.73,5.73,0,0,0,623.31,487.3Z"
            />
            <path
              class="cls-115"
              d="M623.9,488.4a.66.66,0,0,0-.17-.74h0c-.1,0-.16,0-.21-.1h0c-.1,0-.15-.11-.26-.09l-.09,2c0,.89-.06,1.78-.1,2.67.11,0,.17-.06.25-.12a.51.51,0,0,1,.42-.16c0-.44.08-.88.06-1.32a1,1,0,0,0-.34.23c-.05,0-.1.12-.17.08s0-.12,0-.19-.08-.06-.06-.11a2.55,2.55,0,0,0,0-.55,8,8,0,0,1,.09-1.09C623.4,488.55,623.68,488.5,623.9,488.4Z"
            />
            <path
              class="cls-119"
              d="M623.74,491.82a.51.51,0,0,0-.42.16c-.08.06-.14.13-.25.12,0,.2,0,.37-.26.43a2.81,2.81,0,0,1-.29,0l-1.5-.17c0,.11-.07.15-.16.05l-.13,0-.19.11v.15a3.81,3.81,0,0,1,1.38.27,1.55,1.55,0,0,1,.75.24h.2l.71-.61a.23.23,0,0,0,.16-.26A3.69,3.69,0,0,1,623.74,491.82Z"
            />
            <path
              class="cls-112"
              d="M623.59,492.55l-.71.61v0c.1,0,.24.09.29-.11s.1,0,.12,0a1.48,1.48,0,0,1,0,.21,8.36,8.36,0,0,0,.14,1.12c.07,0,.11-.13.21-.08a9.41,9.41,0,0,1,.06-1.5C623.72,492.77,623.74,492.63,623.59,492.55Z"
            />
            <path
              class="cls-116"
              d="M623.36,488.87a8,8,0,0,0-.09,1.09,2.55,2.55,0,0,1,0,.55c0,.05,0,.1.06.11h.05l.1-.06a.31.31,0,0,0,.26-.21l-.22.06c-.11,0-.13-.1-.13-.2,0-.26,0-.52,0-.78s0-.26.16-.29l.13-.06s.06-.09.08-.1.06.08.06.11a3,3,0,0,0,0,.73.56.56,0,0,1-.1.38v.15h.1a15.22,15.22,0,0,0,.11-1.79C623.71,488.64,623.59,488.84,623.36,488.87Z"
            />
            <path
              class="cls-120"
              d="M624.47,480.64a1.62,1.62,0,0,0-.62,0c-.06,0-.12,0-.13.1s0,.06.1.08a.61.61,0,0,0,.66-.08Z"
            />
            <path
              class="cls-114"
              d="M623.36,488.87c.23,0,.35-.23.55-.32v-.15C623.68,488.5,623.4,488.55,623.36,488.87Z"
            />
            <path
              class="cls-117"
              d="M624.45,481.38h0a5.47,5.47,0,0,0-.09,1.15l.07,0a.26.26,0,0,0,.05-.19C624.39,482.06,624.5,481.72,624.45,481.38Z"
            />
            <path
              class="cls-118"
              d="M624.08,497c0-.13-.1-.15-.2-.14,0,.23,0,.46-.06.69,0,.07,0,.12.08.14h0l.05,0v-.06C624,497.4,623.83,497.17,624.08,497Z"
            />
            <path
              class="cls-118"
              d="M624,498.12a.28.28,0,0,0,.23-.29c0-.12-.14-.12-.24-.12h-.05A1.13,1.13,0,0,0,624,498.12Z"
            />
            <path
              class="cls-117"
              d="M623.34,490.62h-.05c0,.07-.08.14,0,.19s.12,0,.17-.08a1,1,0,0,1,.34-.23v-.16h-.1a.31.31,0,0,1-.26.21A.1.1,0,0,1,623.34,490.62Z"
            />
            <path class="cls-117" d="M624.21,485.07c-.42.11-.06.24,0,.37Z" />
            <path
              class="cls-118"
              d="M623.38,497.11a.24.24,0,0,0,.26.05C623.56,497.08,623.49,497.09,623.38,497.11Z"
            />
            <path
              class="cls-113"
              d="M623.5,496.16a.14.14,0,0,0,0-.06l0,0a.08.08,0,0,0,0,0S623.46,496.17,623.5,496.16Z"
            />
            <path
              class="cls-111"
              d="M604.63,490.23s-.08,0-.11,0c-.24.12-.33.05-.31-.22s-.17-.23-.48-.16a2.94,2.94,0,0,1,.12,1.06c0,1.44.19,2.87.18,4.31a.72.72,0,0,0,.43.08v-.1c0-.12-.13-.3.09-.39h.15c0-.14-.12-.14-.22-.14s0-.2-.05-.29.1-.41,0-.6a.7.7,0,0,1,0-.38v-.11a4.73,4.73,0,0,1,0-.92v-.21c-.11-.22,0-.45,0-.68v-.11a.57.57,0,0,1,0-.36c-.17,0-.23-.1-.24-.25a.3.3,0,0,1,.25-.32A.49.49,0,0,0,604.63,490.23Z"
            />
            <path
              class="cls-113"
              d="M624.08,497c-.25.15-.11.38-.13.58A2.86,2.86,0,0,0,624.08,497Z"
            />
            <path class="cls-109" d="M623.9,497.71H624v0Z" />
            <path
              class="cls-118"
              d="M599.69,489.63c.19,0,.36,0,.46.17s0,.26.2.2l.48-.1.38-.06-.11.22H601s-.07-.06-.08,0,0,0,.07.05v.05h0l-.09,0c-.45-.05-.9-.09-1.34-.17a8.86,8.86,0,0,1-1.26-.16.68.68,0,0,1,.27-.05,1.34,1.34,0,0,0,.88-.14Zm.25.22,0,0,0,0,0,0Zm0,.16h0l0,0h0Z"
            />
            <path
              class="cls-117"
              d="M602.39,493.51l0,0,.63.1c.17,0,.35,0,.33-.25a.07.07,0,0,1,.06-.07c.06,0,.07.05.07.1,0,.21,0,.41-.23.48l0,0a1.12,1.12,0,0,1,.41.1l-.06-1c-.32-.05-.32-.05-.31-.53-.11-.21,0-.43-.07-.65h-.11l0,.86a.65.65,0,0,1,0,.31c0,.08,0,.15,0,.23,0,.3,0,.32-.3.27l-.44-.07Z"
            />
            <path
              class="cls-118"
              d="M602.48,490.12c-.1-.27-.3-.26-.52-.21l-.28.08c-.08,0-.2-.12-.26.05l.05,0a.11.11,0,0,1-.15,0l-.19.06-.18.05h0v0l.52.08a.72.72,0,0,0,.48-.05c.08-.05.13-.11.12.07s.2,0,.31,0h0a.11.11,0,0,1,.1-.12Z"
            />
            <path
              class="cls-114"
              d="M603.28,492.47c0,.48,0,.48.31.53a8.27,8.27,0,0,0-.08-1.49l-.21.07A3.32,3.32,0,0,1,603.28,492.47Z"
            />
            <path
              class="cls-111"
              d="M602.69,490c.21,0,.48-.2.59.17,0,.05.1,0,.15,0s0,.1,0,.14c-.23.24-.49.1-.74,0l.1,0s0,0,0,0a.08.08,0,0,0-.09,0c-.09,0-.18,0-.26,0h0a.11.11,0,0,0,.1-.12v-.1C602.57,490.13,602.61,490,602.69,490Zm.48.26,0,0,0,0,0,0Z"
            />
            <path
              class="cls-119"
              d="M603.65,494a1.12,1.12,0,0,0-.41-.1l-.34.12v.06a1.24,1.24,0,0,0,.78.1A.23.23,0,0,0,603.65,494Z"
            />
            <path
              class="cls-116"
              d="M603.3,491.58l.21-.07,0-.41h-.25l0,.11,0,.36Z"
            />
            <path
              class="cls-111"
              d="M603.47,490v.1S603.51,490.08,603.47,490Z"
            />
            <path class="cls-111" d="M601,490.21v0l-.09,0Z" />
            <path class="cls-119" d="M603.64,494.51h.05v-.06Z" />
            <path
              class="cls-115"
              d="M611,491.78a5,5,0,0,0-1-.12v.94c0,.25,0,.51,0,.76s.06.2.19.19h0c.65,0,.72-.08.61-.81l0-.38v-.29A.56.56,0,0,1,611,491.78Z"
            />
            <path
              class="cls-116"
              d="M610.91,492.36l0,.38a3.75,3.75,0,0,0,1.73,0,8,8,0,0,0-.65-.83,4.81,4.81,0,0,0-1-.13.56.56,0,0,0-.05.29c.25,0,.5.06.75.11s.34-.06.29.18-.24.07-.36.08l-.08,0C611.32,492.25,611.12,492.32,610.91,492.36Z"
            />
            <path
              class="cls-116"
              d="M610,492.6v-.41l-.47,0c-.33,0-.48.09-.47.43h0A2.08,2.08,0,0,1,610,492.6Z"
            />
            <path
              class="cls-113"
              d="M607.91,492.24a6.56,6.56,0,0,0-1.27-.71c-.12-.16-.17-.1-.19.06l-.31,0c-.21,0-.34,0-.27.26a.88.88,0,0,1,0,.16l0,0s0,0,0,0l-.2-.05c-.2,0-.31-.24-.52-.26-.21-.17-.24-.06-.23.14.05,1.13.09,2.27.14,3.4-.14,0-.27,0-.37-.11a.48.48,0,0,0,0-.33c0-.14-.12-.14-.22-.14s.07-.26.1-.39,0-.09,0-.1c.28-.07.13-.3.17-.46v-1a8,8,0,0,1-.08-1.29c0-.11,0-.19-.16-.19s-.1.14-.21.12a.57.57,0,0,1,0-.36c.32,0,.62.13.94.11l1-.32c-.09.33-.09.33.26.37l2.54.34c0,.25.11.34.34.35a3.24,3.24,0,0,0,.62.05v.26l-.47,0c-.33,0-.48.09-.47.43Zm-1.53-.86c0-.14-.11-.1-.18-.12a.38.38,0,0,0-.33,0s0,.06,0,.09.2.08.32.09S606.37,491.48,606.38,491.38Z"
            />
            <path
              class="cls-115"
              d="M592.49,490.82c-.11,0-.15,0-.15.15s0,.24,0,.39c-.13-.17,0-.39-.17-.49a6.14,6.14,0,0,0,.13,1.21c.1-.11,0-.24.05-.37s0-.19,0-.27a.18.18,0,0,0,.09-.22A.78.78,0,0,1,592.49,490.82Z"
            />
            <path
              class="cls-115"
              d="M591.41,481.68h-.2a1,1,0,0,0,0,.48h.11l0-.1v-.11C591.32,481.85,591.41,481.77,591.41,481.68Z"
            />
            <path
              class="cls-115"
              d="M592.17,490.77c.06-.22.13-.44-.06-.63A1.69,1.69,0,0,0,592.17,490.77Z"
            />
            <path
              class="cls-116"
              d="M606.45,491.59l-.31,0c-.21,0-.34,0-.27.26a.88.88,0,0,1,0,.16l0,0s0,0,0,0l0,.11a.79.79,0,0,1,.1.37c0,.17-.13.35,0,.48s.32.07.48.13l0-1.2C606.42,491.82,606.44,491.7,606.45,491.59Z"
            />
            <path
              class="cls-114"
              d="M606.45,493.13c-.16-.06-.35,0-.48-.13s0-.31,0-.48a.79.79,0,0,0-.1-.37c0,.6,0,1.2,0,1.8,0,.33.3.21.46.25s.12-.15.12-.24C606.49,493.68,606.46,493.4,606.45,493.13Z"
            />
            <path
              class="cls-109"
              d="M621,492.36l1.5.17a2.81,2.81,0,0,0,.29,0c0-.47,0-.94,0-1.41,0-1.19.14-2.38.16-3.57,0-.07,0-.18.06-.2a.16.16,0,0,1,.2.12c.11,0,.16.11.26.09s-.15-.16-.21-.26a5.73,5.73,0,0,1-.75-.35.71.71,0,0,0-.38-.09,2.68,2.68,0,0,1,0,.8v.18l.2,0a2.62,2.62,0,0,1,0,1.08s0,0-.07.07a.08.08,0,0,1,0,.09l-.51,1a.21.21,0,0,1-.24.11.27.27,0,0,0-.3.2,3.21,3.21,0,0,1-.19.31l-.07.19v.16a.48.48,0,0,1,0,.42l0,.53C621,492.11,621,492.24,621,492.36Z"
            />
            <path
              class="cls-111"
              d="M621.07,490.7a3.21,3.21,0,0,0,.19-.31.27.27,0,0,1,.3-.2.21.21,0,0,0,.24-.11l.51-1a.08.08,0,0,0,0-.09l-.49.25c-.12.09-.25,0-.38,0s-.22-.05-.33,0C621.11,489.77,621,490.24,621.07,490.7Z"
            />
            <path
              class="cls-115"
              d="M620.54,492.49l.19-.11c0-.27,0-.53,0-.8,0-.1.1-.22,0-.31s-.13.12-.14,0-.1-.06-.15,0c0,.38,0,.76,0,1.14Z"
            />
            <path
              class="cls-110"
              d="M620.75,491.27c.12.09,0,.21,0,.31,0,.27,0,.53,0,.8l.13,0c.12-.12,0-.29.1-.41l0-.53a.42.42,0,0,1,0-.42v-.16C620.82,491,620.85,491.15,620.75,491.27Z"
            />
            <path
              class="cls-117"
              d="M620.44,492.34c0-.38.06-.76,0-1.14A1.93,1.93,0,0,0,620.44,492.34Z"
            />
            <path
              class="cls-120"
              d="M621.08,489.31c.11-.06.22,0,.33,0-.06-.08,0-.16,0-.24a.68.68,0,0,0-.45.25Z"
            />
            <path
              class="cls-109"
              d="M619.93,488.64a2,2,0,0,0-1,.38,1.06,1.06,0,0,0-.49.31h0a3.51,3.51,0,0,1,1.12.12l.12.11c.13,0,.16.06.17.18a.72.72,0,0,1-.08.35c-.05.07-.15.16-.07.25s.21.06.32,0,.09-.15.09-.24a7,7,0,0,1,0-1c-.29,0-.57-.15-.86-.18h.38c0-.08-.14,0-.21-.11l.71.06v0l-.5,0c.21.13.47,0,.67.12a.36.36,0,0,0-.09.22l.92-.49a.18.18,0,0,0,.13-.15A5.12,5.12,0,0,1,619.93,488.64Zm-.15.11v0h.2v0Zm.37.05a.38.38,0,0,1,.36,0Zm.41.15,0,0,0,0,.05,0Zm.19-.11,0,0,0,0s0,0,0,0Z"
            />
            <path
              class="cls-110"
              d="M619.93,488.64a5.12,5.12,0,0,0,1.41,0c.23,0,.26.17.07.43,0,.08-.06.16,0,.24s.26.05.38,0c-.08-.57-.16-1.15.58-1.4l-.2,0c-.21.09-.38.27-.63.28-.51,0-1-.05-1.53-.09C619.85,488.21,619.91,488.43,619.93,488.64Z"
            />
            <path
              class="cls-118"
              d="M619.73,489.56l-.12-.11a4.74,4.74,0,0,1-1.12-.12h0a2.16,2.16,0,0,0-.85.33c.26.17.58,0,.85.14.23-.22.5-.1.75-.09S619.61,489.78,619.73,489.56Z"
            />
            <path
              class="cls-113"
              d="M619.71,488.93h-.38c.29,0,.57.16.86.18.08,0,0,.12.1.15a.41.41,0,0,1,.09-.23c-.2-.14-.46,0-.67-.11Z"
            />
            <path
              class="cls-119"
              d="M618.92,490.27c0,.53,0,1.06,0,1.59a.41.41,0,0,1-.19.41.49.49,0,0,0,.27.31,1,1,0,0,0,.08-.48,14.59,14.59,0,0,0,0-1.62C619.06,490.37,619.08,490.25,618.92,490.27Z"
            />
            <path class="cls-117" d="M598.33,491.09l-.44,0,.24,3.13.44,0Z" />
            <path
              class="cls-114"
              d="M602.39,493.51l.06-.09a2.3,2.3,0,0,1,.72-.43.65.65,0,0,0,0-.31,2,2,0,0,1-.73.13l-.44,0c0,.17.19.09.22.2s0,.35.07.52Z"
            />
            <path
              class="cls-119"
              d="M601.43,493.66l-.44-.1-.77-.12c-.12,0-.17.12-.28.12v0a.19.19,0,0,0,.14.11l1.16.2a.21.21,0,0,0,.2-.06Z"
            />
            <path
              class="cls-118"
              d="M599.94,493.56c.11,0,.16-.15.28-.12l0-.09c-.24-.05-.4,0-.45.24l.08,0Z"
            />
            <path class="cls-113" d="M599.94,493.56h0Z" />
            <path
              class="cls-120"
              d="M602.89,494.11v-.06c0-.18.13-.18.23-.22s.13,0,.14.07c.26-.07.25-.27.23-.48,0-.05,0-.09-.07-.1a.07.07,0,0,0-.06.07c0,.26-.16.24-.33.25a.32.32,0,0,1-.21.1c-.22,0-.27.14-.15.33C602.77,493.93,602.81,494.17,602.89,494.11Z"
            />
            <path
              class="cls-119"
              d="M602.92,494.58s0,.08.05.07.11,0,.11-.1-.05,0-.09-.05S602.92,494.53,602.92,494.58Z"
            />
            <path
              class="cls-120"
              d="M604.66,495.16a.48.48,0,0,0,0-.33h-.15c-.22.09,0,.27-.09.39A.24.24,0,0,0,604.66,495.16Z"
            />
            <path
              class="cls-117"
              d="M607.61,489a1.28,1.28,0,0,1-.63.33,1.36,1.36,0,0,0-.52.19,3.66,3.66,0,0,0,.92.14l3.15.31,3.54.36c.81-.36,1.63-.7,2.44-1.07a3.12,3.12,0,0,0,.84-.41,6.48,6.48,0,0,0-.77-.09c-.12,0-.21-.05-.2-.19-.79,0-1.57-.1-2.35-.15l-3.71-.28-2.2.65A2.28,2.28,0,0,0,607.61,489Z"
            />
            <path
              class="cls-117"
              d="M604,487.57v.18c-.06.06,0,.1,0,.13s.16,0,.17.15.07.2-.12.18c-.9-.08-1.8-.14-2.69-.23a4,4,0,0,1-1-.12c0-.56,0-1.12-.07-1.68,0-.25,0-.51-.05-.76s0-.22.2-.13a.42.42,0,0,0,.27,0s.08.1.11,0,0-.09.06-.06c.35.24.74.12,1.12.14.11,0,.13-.08.14-.16l.06,0c0,.14.09.16.2.16s.15-.06.15-.16h0c0,.18.16.18.29.19h.65c.16,0,.11-.1.12-.17l.1,0c0,.23.2.13.32.15v.11H604c-.09,0-.15,0-.15.13s.06.13.15.14a1.2,1.2,0,0,1,.2,0V486c-.35,0-.35,0-.34.34s0,.42,0,.63c0,.36,0,.36.37.33v.17C604.17,487.5,604,487.33,604,487.57Zm-1.49-.28a.25.25,0,0,0,.18-.31,5.7,5.7,0,0,1,0-.83c0-.12,0-.24-.18-.24s-.14.12-.14.23a10.86,10.86,0,0,0,.13,1.77c.07-.14.23-.13.28-.26v-.22C602.71,487.33,602.61,487.33,602.5,487.29Zm1.28.11,0-.1c0-.38-.05-.75-.07-1.13,0-.13-.07-.17-.19-.19s-.56-.12-.75,0,0,.45,0,.69a3.37,3.37,0,0,0,0,.55c0,.08,0,.16.08.2.27.13.13.22-.06.32.32.19.66,0,1,.12.07,0,.07-.08.08-.14v-.21Zm-1.57-1.29c0-.18-.11-.22-.25-.23a6.78,6.78,0,0,1-.78,0c-.14,0-.2,0-.17.19.11.5,0,1,.13,1.54,0,.18.1.25.28.26a4,4,0,0,1,.68.05c.2,0,.22-.05.21-.21a2.81,2.81,0,0,1,0-.29C602.28,487,602.2,486.54,602.21,486.11ZM601,486c0-.26-.2-.22-.36-.23s-.17.13-.17.25c0,.47.06.94.1,1.41a.32.32,0,0,0,.12.28.36.36,0,0,0,.32,0c.12,0,.08-.14.08-.23v-.21A8,8,0,0,1,601,486Zm1.11-.27c.07,0,.14,0,.14-.09s0-.19-.12-.17c-.36.07-.73-.14-1.09.05-.07,0-.06,0-.08-.06s-.28-.06-.42-.05a.11.11,0,0,0-.08.12c0,.11.08.13.16.13l1.25.09h.24Zm1.67,0c0-.09,0-.17-.12-.18-.27,0-.55,0-.83-.05-.06,0-.09,0-.1.1a.15.15,0,0,0,.11.16,1.1,1.1,0,0,0,.36,0h.44C603.67,485.88,603.72,485.86,603.73,485.78Zm-1.27,0c.09,0,.16,0,.16-.13s-.06-.14-.15-.14-.16,0-.16.13S602.37,485.81,602.46,485.81Z"
            />
            <path
              class="cls-117"
              d="M603.84,480.78c-.08,0-.17,0-.18.09s.1.11.17.11H604v.12c-.24,0-.33.05-.31.3,0,.49,0,1,.09,1.47,0,.24.09.32.31.27,0,.15-.13.1-.21.11-.41,0-.82,0-1.23,0-.82,0-1.63,0-2.44,0,0-.76-.11-1.52-.16-2.29v-.31h.09c0,.1,0,.2.16.19s.31.05.36-.22c.12.29.34.21.52.19a3.66,3.66,0,0,1,.57,0c.16,0,.2-.08.19-.22H602c0,.09,0,.2.16.19s.18-.06.17-.17h.1c0,.13.08.15.19.15l.73,0c.16,0,.2-.08.19-.21s.1.12.19.2c0-.19,0-.29.22-.28v.43A.56.56,0,0,0,603.84,480.78Zm-3.27.28s.06,0,0-.08a.11.11,0,0,0-.1-.06h-.39l0,0s0,0,0,0C600.24,481.17,600.42,481,600.57,481.06Zm2.83,1.53c.29,0,.26-.19.23-.36a6,6,0,0,1-.07-.94c0-.13,0-.19-.19-.19l-.73,0c-.14,0-.19.05-.19.19,0,.56.07,1.11.1,1.67,0,0,0,.12.07.12.21,0,.44.1.62-.1s0-.17,0-.26S603.32,482.58,603.4,482.59Zm-1.43.53c.15-.23-.17-.25-.16-.4.25-.16.2-.41.19-.64s0-.46,0-.69-.07-.21-.22-.2h-.92c-.1,0-.13,0-.12.12.11.5,0,1,.11,1.51,0,.21.1.32.33.28s.21,0,.31,0,.3,0,.29-.2C601.92,482.88,601.9,483,602,483.12Zm-1.73-.26a.33.33,0,0,0,.48.26c.06,0,0-.08,0-.13-.07-.53-.08-1.07-.1-1.6,0-.19-.14-.17-.26-.16s-.26,0-.26.17,0,.14,0,.29A9.79,9.79,0,0,1,600.24,482.86Zm2.11-1.56c0-.1,0-.16-.15-.17s-.13.05-.14.16c-.06.45.1.89.06,1.33,0,.14.19-.07.16.1a2,2,0,0,0,0,.24c0,.07,0,.15.09.15s.12-.06.12-.14,0-.43,0-.74A8.77,8.77,0,0,0,602.35,481.3Zm-.56-.26c.06,0,.12,0,.12-.11s-.07-.1-.13-.1l-.94,0c-.07,0-.12,0-.12.1s.06.1.13.1h.94Zm1.61-.05c.07,0,.14,0,.13-.12s-.07-.09-.13-.08l-.81,0c-.07,0-.14,0-.13.12s.07.09.13.09l.42,0h.39Zm-1.22,0c.08,0,.15,0,.15-.1s-.08-.1-.15-.1-.14,0-.15.11S602.11,481,602.18,481Zm1.44,1.8,0-.05,0,0,0,0Z"
            />
            <path
              class="cls-115"
              d="M598.24,488.71c.15.08.21,0,.19-.14,0-.5,0-1-.11-1.48a4.42,4.42,0,0,0-.11-1h0l0,0h0c-.15-.12-.32,0-.48,0v-.1l.3-.07c.15,0,.12-.15.11-.25s-.11-.07-.18-.07l-.29,0v-.1h0c.16-.08.47,0,.42-.32l.2-.06c0,.1-.12.24.11.26.41,0,.46,0,.47-.33H599c.11,1.23.22,2.45.26,3.68l-1.15.29c-.12,0-.21,0-.22-.14A.5.5,0,0,0,598.24,488.71Zm.16-1.8v.27a.19.19,0,0,0,.06.16l0,1.15c0,.19.08.23.25.19.43-.11.46-.11.41-.55-.08-.67,0-1.34-.15-2a.43.43,0,0,0,0-.12c-.15-.23-.33,0-.49,0s-.1.13-.09.21-.06.21,0,.3v.42Zm0-1.43a.17.17,0,0,0-.13.22c0,.12.11.11.2.1s.43-.06.38-.38A2.32,2.32,0,0,0,598.44,485.48Z"
            />
            <path
              class="cls-109"
              d="M604.26,491c.32,0,.62.13.94.11a.42.42,0,0,1,.32-.59c.14,0,.33,0,.39-.21a3.71,3.71,0,0,0-1.28-.11.49.49,0,0,1-.36.23.3.3,0,0,0-.25.32C604,490.93,604.09,491,604.26,491Z"
            />
            <path
              class="cls-115"
              d="M597.35,481.14h.34c.07,0,.15,0,.16-.09a.16.16,0,0,0-.17-.16h-.35v-.05h.27c.16,0,.22-.06.21-.21l.09,0c0,.14.07.24.22.21s.46.1.53-.22h.07c0,.13,0,.26,0,.39.07,1,.13,1.95.2,2.92a.52.52,0,0,1-.16.06,9.87,9.87,0,0,0-1.22.09s0,0,0,0v-.07a.23.23,0,0,0,.22-.06c.23,0,.32-.06.25-.3s0-.45-.08-.65v-.1h.1l.06.11c0,.21,0,.43,0,.65s.27.21.45.22.24-.07.23-.25,0-.43,0-.65v-.1c0-.07,0-.15-.06-.21v0a.42.42,0,0,0,0-.42,3.19,3.19,0,0,1-.08-.75c0-.13,0-.2-.18-.19s-.39-.05-.54.12h-.07c-.14-.2-.34-.06-.51-.08h0v-.06Zm1.13,0c.09,0,.17,0,.17-.14s-.09-.12-.17-.12h-.32c-.09,0-.18,0-.18.13s.09.13.18.13h.32Z"
            />
            <path
              class="cls-115"
              d="M600.42,487.86c0-.56,0-1.12-.07-1.68,0-.25,0-.51-.05-.76s0-.22.2-.13c.1-.22.3-.2.49-.18-.16-.18-.36-.1-.54-.08a.59.59,0,0,1-.35,0c0,.64,0,1.27,0,1.9,0,.26,0,.51.05.76S600.27,487.89,600.42,487.86Z"
            />
            <path
              class="cls-120"
              d="M602.33,480.54h.1a1.53,1.53,0,0,1,1.11-.08c.11,0,.1.12.19.2,0-.19,0-.29.22-.28,0-.13,0-.19-.17-.18l-3.15.13-.73.05c-.08,0-.15,0-.13.12s.17.06.25.1h.09c.21-.2.47-.1.7-.11a2.72,2.72,0,0,1,1.1,0H602C602.11,480.46,602.23,480.38,602.33,480.54Z"
            />
            <path
              class="cls-116"
              d="M604,481.09c-.24,0-.33.05-.31.3,0,.49,0,1,.09,1.47,0,.24.09.32.31.27C604.08,482.44,604,481.77,604,481.09Z"
            />
            <path
              class="cls-115"
              d="M600,480.61c-.08,0-.15-.11-.25-.1.05.86.1,1.72.16,2.57,0,.18.13.15.25.13,0-.76-.11-1.52-.16-2.29Z"
            />
            <path
              class="cls-111"
              d="M605.91,490.34c-.06.2-.25.17-.39.21a.42.42,0,0,0-.32.59l1-.32C606.32,490.41,606.28,490.35,605.91,490.34Z"
            />
            <path
              class="cls-116"
              d="M604.19,486c-.35,0-.35,0-.34.34s0,.42,0,.63c0,.36,0,.36.37.33C604.22,486.85,604.25,486.41,604.19,486Z"
            />
            <path
              class="cls-116"
              d="M601,485.11c-.19,0-.39,0-.49.18a.42.42,0,0,0,.27,0h.11s0-.09.06-.06c.35.24.74.12,1.12.14.11,0,.13-.08.14-.16a.2.2,0,0,0-.22-.1,3.94,3.94,0,0,1-.69,0Z"
            />
            <path
              class="cls-116"
              d="M609,491.53c0,.25.11.34.34.35a3.24,3.24,0,0,0,.62.05v-.27A6.32,6.32,0,0,0,609,491.53Z"
            />
            <path
              class="cls-119"
              d="M601.29,485.1a3.94,3.94,0,0,0,.69,0,.2.2,0,0,1,.22.1l.06,0c.11-.07.23-.17.35,0h0c.34-.22.69,0,1,0,0,0,0,.05,0,.07l.1,0c.07-.14.16-.2.31-.12,0-.07,0-.09-.1-.09l-2.63-.09A.12.12,0,0,0,601.29,485.1Z"
            />
            <path
              class="cls-113"
              d="M598.87,485H599a.21.21,0,0,0,0-.2l-1.24.13c-.1,0-.18,0-.15.15h.14c.1,0,.2,0,.28.05l.2-.06C598.47,485,598.67,485,598.87,485Z"
            />
            <path
              class="cls-111"
              d="M600.15,489.8c0,.19,0,.26.2.2l.48-.1c0-.1,0-.17-.14-.18A1.08,1.08,0,0,0,600.15,489.8Z"
            />
            <path
              class="cls-113"
              d="M598.65,480.59h.07a.27.27,0,0,0,0-.2l-1.41,0v.05h0c.16,0,.35,0,.48.15l.09,0A.72.72,0,0,1,598.65,480.59Z"
            />
            <path
              class="cls-116"
              d="M604.14,485.61H604c-.09,0-.15,0-.15.13s.06.13.15.14a1.2,1.2,0,0,1,.2,0C604.24,485.8,604.17,485.71,604.14,485.61Z"
            />
            <path
              class="cls-111"
              d="M601.42,490c.06-.17.18,0,.26-.05s-.08-.19-.22-.16h-.25l-.11.22,0,.05.19-.06Z"
            />
            <path
              class="cls-116"
              d="M604.25,487.45c-.08.05-.26-.12-.26.12.09,0,.19,0,.19.09s-.1.1-.18.09,0,.1,0,.13.16,0,.17.15C604.33,487.84,604.23,487.64,604.25,487.45Z"
            />
            <path
              class="cls-116"
              d="M604.13,485.23c-.15-.08-.24,0-.31.12s.2.13.32.15Z"
            />
            <path
              class="cls-116"
              d="M604,480.82a.56.56,0,0,0-.12,0c-.08,0-.17,0-.18.09s.1.11.17.11H604Z"
            />
            <path
              class="cls-116"
              d="M611.7,485.46l.6,0c.11,0,.17,0,.16.15,0,.43.06.86,0,1.28-.09.16,0,.32,0,.48-.22,0-.29.18-.17.44.1,0,.08-.14.17-.13h.06c0,.35,0,.35-.35.33h-.26c-.1,0-.14-.06-.14-.15v-2.41Zm.14,1.81c.11.11.21.07.38,0A.38.38,0,0,0,611.84,487.27Z"
            />
            <path
              class="cls-116"
              d="M612.31,482.35s.07,0,.11,0a1,1,0,0,1,0,.48c-.14.22-.37.15-.57.14s-.11-.08-.11-.15c0-.51,0-1,0-1.53,0-.12.08-.13.18-.14l.5,0,0,1.11S612.3,482.27,612.31,482.35Zm-.11-.07a.28.28,0,0,0-.28,0C612,482.35,612.11,482.36,612.2,482.28Z"
            />
            <path
              class="cls-117"
              d="M612.39,482.87c-.14.22-.37.15-.57.14s-.11-.08-.11-.15c0-.51,0-1,0-1.53,0-.12.08-.13.18-.14l.5,0v-.1h-.54c-.05,0-.12,0-.12-.07s.06-.08.12-.08l.54,0a0,0,0,0,0,0-.05h-.52c-.06,0-.13,0-.14-.07s.06-.11.12-.12l.54,0a1.44,1.44,0,0,0-.77,0c0,.45,0,.89,0,1.34l0,1c0,.07,0,.16.08.16a3,3,0,0,0,.6,0C612.48,483.09,612.41,483,612.39,482.87Z"
            />
            <path
              class="cls-116"
              d="M612.39,480.65l-.54,0c-.06,0-.13,0-.12.12s.08.07.14.07h.52Z"
            />
            <path
              class="cls-116"
              d="M612.39,480.91l-.54,0c-.06,0-.12,0-.12.08s.07.07.12.07h.54Z"
            />
            <path
              class="cls-111"
              d="M611.63,482c0-.45-.06-.89,0-1.34h-.06A6,6,0,0,0,611.63,482Z"
            />
            <path
              class="cls-111"
              d="M611.7,486.61v-1.15a.18.18,0,0,0-.07.2A3.77,3.77,0,0,0,611.7,486.61Z"
            />
            <path
              class="cls-115"
              d="M612.44,486.91c-.09.16,0,.32,0,.48v.31h.06Z"
            />
            <path
              class="cls-114"
              d="M612.42,482.28s-.12,0-.11.07.07,0,.11,0Z"
            />
            <path class="cls-111" d="M611.7,487v-.3A.29.29,0,0,0,611.7,487Z" />
            <path
              class="cls-111"
              d="M611.72,487.87v-.25A.23.23,0,0,0,611.72,487.87Z"
            />
            <path
              class="cls-111"
              d="M611.72,487.5v-.09S611.68,487.47,611.72,487.5Z"
            />
            <path
              class="cls-114"
              d="M609.55,480.83c0-.12.06-.31-.19-.29s-.2,0-.2.19c0,.73,0,1.46,0,2.18,0,.24,0,.37.31.3h.13v-.11a.16.16,0,0,1-.06-.14c0-.53,0-1.06,0-1.59a.18.18,0,0,1,0-.16Z"
            />
            <path
              class="cls-114"
              d="M609.68,485.72c0-.1,0-.23-.16-.19s-.26,0-.26.22c0,.73,0,1.46.07,2.19,0,.09,0,.22.15.15s.14-.3.15-.49c0-.56,0-1.12,0-1.69A.26.26,0,0,1,609.68,485.72Z"
            />
            <path
              class="cls-109"
              d="M609.55,480.83v.37l.05,1.89v.11c.14,0,.15-.09.15-.19l-.06-2.33Z"
            />
            <path
              class="cls-116"
              d="M609.68,485.72a.26.26,0,0,0,0,.19c0,.57,0,1.13,0,1.69,0,.19,0,.36-.15.49.14,0,.27,0,.26-.2C609.73,487.16,609.74,486.44,609.68,485.72Z"
            />
            <path class="cls-117" d="M607,484.27a1.79,1.79,0,0,0,0,.83Z" />
            <path
              class="cls-110"
              d="M620.14,483a5.89,5.89,0,0,0,0,1.39c.54,0,1.08,0,1.61,0,0,0,.11.05.16,0,0-.47,0-.94,0-1.42h0A11.78,11.78,0,0,1,620.14,483Z"
            />
            <path
              class="cls-110"
              d="M622,478.72c-.6,0-1.19,0-1.79.07a6.38,6.38,0,0,0,0,1.07c0,.17.13.1.21.1l1.54,0,0,0Z"
            />
            <path
              class="cls-117"
              d="M620.17,480.23c0-.19.11-.21.26-.22l1.52,0c.06,0,0,.07,0,.1h-.34c-.14,0-.13.11-.15.2s.08.11.16.12h.28v.13l-.28,0c-.06,0-.16,0-.15.08s.06.14.16.13h.23c0,.1,0,.09-.09.1s-.22,0-.32.06l-.06,1.57a.66.66,0,0,1,0,.23l-.07-.07c0-.53,0-1.06,0-1.59,0-.08,0-.16-.08-.18h-.81c-.12,0-.14,0-.16.17a6.39,6.39,0,0,0,0,1.07v-.53c.21.19.26.46.44.65v.21s0,0,0,0a0,0,0,0,1,0,0v.09c0,.1-.09.23,0,.28a.51.51,0,0,0,.48,0l.11-.07a.68.68,0,0,1,.46-.18c.08,0,.05-.13.05-.21,0-.46,0-.93.07-1.4H622l0,1.88-.25-.06.1.16a11.78,11.78,0,0,1-1.68,0C620.1,482.09,620.23,481.16,620.17,480.23Zm.8.31c-.19,0-.37.07-.56,0a.1.1,0,0,0-.12.11c0,.08,0,.14.12.14l.41,0h.36c.06,0,.13,0,.14-.08s0-.15-.09-.17H621Zm-.51-.42c-.09,0-.14.05-.14.15a.14.14,0,0,0,.16.16l.33,0h.39c.11,0,.13-.08.13-.18s-.06-.13-.15-.13h-.72Z"
            />
            <path
              class="cls-117"
              d="M620,486.41a3.28,3.28,0,0,1,.69.1l-.05.22s-.07.13,0,.14.32.12.43-.09v-.25l.11,0c0,.41,0,.83,0,1.25,0,.06-.07.19.1.17l.23.06,0,.07c-.51,0-1-.05-1.53-.09Zm1,.91c0-.12-.08-.16-.19-.16s-.17.07-.17.18a1.7,1.7,0,0,1,0,.39c0,.1,0,.2.11.22s.24,0,.27-.14a1.32,1.32,0,0,0,0-.28h0A1.48,1.48,0,0,0,621,487.32Z"
            />
            <path
              class="cls-117"
              d="M621.65,484.56h-.23c-.06,0-.15,0-.14.09s0,.16.12.17h.31a.15.15,0,0,1-.1.15.49.49,0,0,0-.27,0,.09.09,0,0,0-.09.05l-.81-.07c-.09,0-.25-.06-.27.07s.16.11.25.12c.33,0,.65,0,1,0l.11,0h.11a.11.11,0,0,1,0,.11h0c-.27-.05-.4.05-.4.34s0,.55,0,.83l-.16,0c0-.32,0-.64,0-1s-.07-.26-.22-.26h-.61c-.1,0-.13.08-.12.17a6,6,0,0,1,0,.94h-.06c0-.62,0-1.24,0-1.87.54,0,1.08,0,1.61,0Zm-.58.27c.09,0,.08-.08.09-.13s0-.12-.1-.12c-.24,0-.48-.07-.73,0-.08,0-.15,0-.15.14s.08.12.17.13l.52,0Z"
            />
            <path
              class="cls-114"
              d="M618.77,481c-.11-.11-.23-.07-.36,0,0,.55,0,1.09,0,1.64l.33-.07c0-.3,0-.61,0-.91A2.35,2.35,0,0,1,618.77,481Z"
            />
            <path
              class="cls-114"
              d="M619,482.52a.44.44,0,0,0,.32,0c.06-.51,0-1,.06-1.52a.29.29,0,0,0-.36,0c0,.13.06.25,0,.38A5.45,5.45,0,0,0,619,482.52Z"
            />
            <path
              class="cls-114"
              d="M619.75,480.31a.16.16,0,0,0-.13-.06c-.38,0-.75,0-1.12,0-.13,0-.22,0-.23.17s.1.18.22.18l1.16,0Z"
            />
            <path
              class="cls-117"
              d="M619,482.52a5.45,5.45,0,0,1,.06-1.14c0-.13-.08-.25,0-.38-.06.06-.13.12-.22,0a2.35,2.35,0,0,0,0,.65c0,.3,0,.61,0,.91C618.79,482.47,618.89,482.56,619,482.52Z"
            />
            <path
              class="cls-110"
              d="M619.12,486.36v-.1l-.19-.09c-.09,0-.18,0-.25-.06-.19.11-.21-.2-.38-.15,0,.16-.1.17-.22.16s-.2,0-.2.15.11.11.19.11a.37.37,0,0,1,.28.1h0l0,0,.08,0,.2,0a.25.25,0,0,1,.22,0Z"
            />
            <path
              class="cls-114"
              d="M619.62,484.78a6.08,6.08,0,0,0-1.33.29.11.11,0,0,0-.08.16c0,.11.09,0,.14,0a2.48,2.48,0,0,0,1-.25.6.6,0,0,1,.27,0Z"
            />
            <path
              class="cls-114"
              d="M618.41,486.46l0,0c.07.28-.05.57,0,.85.12,0,.26,0,.3-.17a5,5,0,0,0,0-.77l-.2,0Z"
            />
            <path
              class="cls-110"
              d="M619.75,480.31l-.1.25V481c.05.51-.06,1,0,1.52.08,0,.1-.06.1-.12,0-.66,0-1.32,0-2C619.8,480.37,619.77,480.34,619.75,480.31Z"
            />
            <path
              class="cls-114"
              d="M618.94,486.17l.19.09h.1c.07-.28,0-.57.07-.84a.36.36,0,0,0-.37.13Z"
            />
            <path
              class="cls-113"
              d="M622,480c.06,0,0,.07,0,.11s.09,0,.09.07c0,.36.25.23.44.18l.06-.4-.55,0,0,0Z"
            />
            <path
              class="cls-114"
              d="M619.12,486.36l-.21.07,0,.73c.1-.05.18-.12.29-.11,0-.23,0-.45,0-.67Z"
            />
            <path
              class="cls-117"
              d="M619.65,482.5c0-.51.06-1,0-1.52h-.1c-.08.51,0,1-.07,1.53A.1.1,0,0,0,619.65,482.5Z"
            />
            <path
              class="cls-117"
              d="M618.93,487.16l0-.73a.25.25,0,0,0-.22,0,5,5,0,0,1,0,.77C618.76,487.15,618.85,487.25,618.93,487.16Z"
            />
            <path
              class="cls-114"
              d="M619.49,482.52c.07-.51,0-1,.07-1.53a.07.07,0,0,0-.12,0c0,.51,0,1-.05,1.51Z"
            />
            <path
              class="cls-114"
              d="M618.31,486c.17,0,.19.26.38.15,0-.17,0-.35,0-.51-.13,0-.52.19-.54.3S618.27,486,618.31,486Z"
            />
            <path
              class="cls-117"
              d="M619.39,482.51c0-.5,0-1,.05-1.51h-.09c-.09.5,0,1-.06,1.52Z"
            />
            <path
              class="cls-117"
              d="M618.74,485.6c-.09.16,0,.34,0,.51s.16.06.25.06v-.63Z"
            />
            <path
              class="cls-117"
              d="M618.39,482.65c0-.55,0-1.09,0-1.64a.3.3,0,0,0-.11.25,8.42,8.42,0,0,1,0,1.23C618.28,482.54,618.22,482.68,618.39,482.65Z"
            />
            <path
              class="cls-110"
              d="M619.62,484.78l0,.2,0,.42a3.92,3.92,0,0,0,.08.84c0-.39,0-.79,0-1.18A.4.4,0,0,0,619.62,484.78Z"
            />
            <path
              class="cls-117"
              d="M619.64,486.24a3.92,3.92,0,0,1-.08-.84h0c-.06.1,0,.2,0,.3s0,.35-.06.51c.05.1.14.08.23.08Z"
            />
            <path
              class="cls-114"
              d="M619.41,486.21c.11-.16.05-.34.06-.51s0-.2,0-.3-.11-.06-.15,0v.79Z"
            />
            <path
              class="cls-117"
              d="M618.37,487.33c-.06-.28.06-.57,0-.85h0l-.09.07c0,.26,0,.52,0,.78Z"
            />
            <path
              class="cls-117"
              d="M619.35,486.2v-.79h-.06c-.09.27,0,.56-.07.84C619.28,486.26,619.34,486.32,619.35,486.2Z"
            />
            <path
              class="cls-114"
              d="M618.26,487.33c0-.26,0-.52,0-.78h-.07a3.14,3.14,0,0,0,0,.81h0Z"
            />
            <path
              class="cls-121"
              d="M619.65,486.4c-.11,0-.12.09-.11.17s0,.29,0,.43a1.52,1.52,0,0,0,.07-.6Z"
            />
            <path
              class="cls-117"
              d="M619.23,486.38c0,.22,0,.44,0,.67.09,0,.13-.06.1-.14a.65.65,0,0,1,0-.31C619.32,486.52,619.47,486.34,619.23,486.38Z"
            />
            <path
              class="cls-114"
              d="M618.46,480.77c0,.09.09.08.15.08s.14,0,.12-.09-.07-.07-.12-.06S618.48,480.7,618.46,480.77Z"
            />
            <path
              class="cls-114"
              d="M619,480.78c0,.07.1.06.15.05s.14,0,.11-.11-.1,0-.16,0S619,480.7,619,480.78Z"
            />
            <path
              class="cls-116"
              d="M621.07,486.4c0-.32,0-.64,0-1s-.07-.26-.22-.26h-.61c-.1,0-.13.08-.12.17a6,6,0,0,1,0,.94A6.15,6.15,0,0,0,621.07,486.4Z"
            />
            <path
              class="cls-117"
              d="M621.87,483c0,.48,0,1,0,1.42.15,0,.3-.11.46-.06s.14-.2.14-.32c0-1-.05-2.07,0-3.1h-.07c-.07.56,0,1.12-.13,1.68.11.27.09.3-.2.31H622Z"
            />
            <path
              class="cls-117"
              d="M622,479.9l.55,0c.08,0,.08-.1.08-.17,0-.26,0-.52,0-.78s0-.24-.19-.23-.29,0-.44,0Z"
            />
            <path
              class="cls-114"
              d="M621.76,486.59a.17.17,0,0,0,.14,0,.86.86,0,0,0,.21-.68,4,4,0,0,1,.08-.85c-.14,0-.31,0-.38.17Z"
            />
            <path
              class="cls-116"
              d="M621.62,485.25c-.27-.05-.4.05-.4.34s0,.55,0,.83l.14.05.07,0,.11,0C621.64,486.1,621.53,485.67,621.62,485.25Z"
            />
            <path
              class="cls-116"
              d="M622.13,486.84a.79.79,0,0,0-.37-.07,3.7,3.7,0,0,0,0,1.05h.31l.06-.07v-.06A2,2,0,0,1,622.13,486.84Z"
            />
            <path
              class="cls-115"
              d="M622,481h-.08c-.12-.21-.32,0-.48-.09.1-.09.21-.05.32-.06s.13,0,.09-.1.11-.15,0-.24v-.13a.54.54,0,0,0,.05-.33h0s.09,0,.09.07c0,.36.25.23.44.18.1.21,0,.42,0,.64h-.07C622.26,480.88,622.12,480.84,622,481Zm.22-.28c.09,0,.17,0,.15-.13s-.1-.08-.17-.08-.13,0-.13.11S622.16,480.76,622.23,480.76Z"
            />
            <path
              class="cls-116"
              d="M621.18,486.57c0,.41,0,.83,0,1.25,0,.06-.07.19.1.17,0-.21,0-.41,0-.62s0-.18.17-.18.15.06.15.16,0,.21,0,.31a4.63,4.63,0,0,0,0-.91h-.23c-.12,0-.13-.08-.06-.17Z"
            />
            <path
              class="cls-117"
              d="M622.19,485.08a4,4,0,0,0-.08.85.86.86,0,0,1-.21.68c.28.15.3.14.31-.16l.06-1.52a.58.58,0,0,0,0-.23c-.08.07,0,.17-.06.26Z"
            />
            <path
              class="cls-114"
              d="M622.18,485c0-.09,0-.19.06-.26h0l0-.06a.46.46,0,0,1,0-.26c-.16-.05-.31,0-.46.06s-.11,0-.16,0l-.05.1c0,.08,0,.15.05.21s0-.08.06-.07,0,.07.06.12.14-.09.23,0-.19.07-.19.21Z"
            />
            <path
              class="cls-117"
              d="M621.76,486.59c0-.45,0-.89,0-1.34h-.09a9.73,9.73,0,0,0-.07,1.32Z"
            />
            <path
              class="cls-117"
              d="M621.63,486.75a4.63,4.63,0,0,1,0,.91.39.39,0,0,0,0,.28c.14.09.14-.08.2-.12a3.7,3.7,0,0,1,0-1.05S621.69,486.68,621.63,486.75Z"
            />
            <path
              class="cls-114"
              d="M621.65,486.56a9.73,9.73,0,0,1,.07-1.32h-.1c-.09.42,0,.85-.07,1.28Z"
            />
            <path class="cls-121" d="M621.08,486.78v-.25l-.36,0-.05.22Z" />
            <path
              class="cls-117"
              d="M622.13,486.84a1.94,1.94,0,0,0,0,.83h.06a2.68,2.68,0,0,0,0-.8s0,0,0,0Z"
            />
            <path
              class="cls-121"
              d="M621.34,486.61c-.07.09-.06.15.06.17h.23C621.6,486.61,621.44,486.66,621.34,486.61Z"
            />
            <path class="cls-114" d="M621.44,486.51l-.07,0Z" />
            <path class="cls-115" d="M622.28,484.65l0,.06Z" />
            <path
              class="cls-116"
              d="M592.41,486.72c0,.45.13.88.08,1.33,0,.11.06.14.14.15l.47.05c.08,0,.11,0,.1-.11a9.83,9.83,0,0,1-.14-1.33c0-.09,0-.22-.15-.21s-.32-.1-.49,0S592.38,486.67,592.41,486.72Z"
            />
            <path
              class="cls-114"
              d="M593.79,488c.17,0,.08.19.15.33,0-.14,0-.3.17-.29s0-.06,0-.11c0-.37,0-.73-.1-1.09s-.25-.18-.41-.2C593.63,487.08,593.79,487.52,593.79,488Z"
            />
            <path
              class="cls-116"
              d="M591.91,486.83c.1.35.06.74.13,1.12,0,.2.14.19.27.19s.06-.14.06-.21c0-.38-.06-.76-.09-1.14,0-.1,0-.2-.1-.25a.24.24,0,0,0-.2,0C591.86,486.59,591.93,486.71,591.91,486.83Z"
            />
            <path
              class="cls-116"
              d="M593.79,488c0-.46-.16-.9-.14-1.36-.13,0-.23,0-.21.19a10.86,10.86,0,0,1,.09,1.28c0,.06,0,.13.09.13s.06-.07.08-.12A.94.94,0,0,1,593.79,488Z"
            />
            <path
              class="cls-116"
              d="M593.47,488.19c-.05-.51-.09-1-.14-1.41,0-.08,0-.2-.14-.17s0,.13,0,.2a9.81,9.81,0,0,1,.09,1.09,1.22,1.22,0,0,0,0,.26c0,.06,0,.15.13.13A.07.07,0,0,0,593.47,488.19Z"
            />
            <path
              class="cls-116"
              d="M592.74,486.23c.11,0,.24,0,.25-.11s-.14-.1-.23-.11a1.55,1.55,0,0,0-.31,0c-.05,0-.14,0-.15.07a.13.13,0,0,0,.12.14Z"
            />
            <path
              class="cls-116"
              d="M594,486.09a.19.19,0,0,1-.16-.06c-.12,0-.24,0-.36,0s-.15.11-.06.16a.75.75,0,0,0,.55,0C594,486.23,594,486.14,594,486.09Z"
            />
            <path
              class="cls-116"
              d="M593.71,486.34c-.1.05-.28,0-.29.09s.18.08.28.09.32.08.33-.09S593.82,486.39,593.71,486.34Z"
            />
            <path
              class="cls-116"
              d="M592.77,486.49c.08,0,.2,0,.21-.07s-.12-.08-.2-.09l-.31,0c-.05,0-.12,0-.13.06s0,.08.1.09Z"
            />
            <path
              class="cls-116"
              d="M591.85,486.36c.14.07.23.13.34.05s0-.07,0-.09A.34.34,0,0,0,591.85,486.36Z"
            />
            <path
              class="cls-114"
              d="M594.19,488.3s0,0,0,0a.1.1,0,0,0-.05,0s0,0,0,.06Z"
            />
            <path
              class="cls-116"
              d="M593.59,492a4,4,0,0,1-.09-.91c0-.15-.08-.17-.2-.18l-.49-.05c0,.15,0,.3,0,.46a2.48,2.48,0,0,0,.06.54c0,.1,0,.26.09.3a1.48,1.48,0,0,0,.54.08C593.65,492.26,593.54,492.11,593.59,492Z"
            />
            <path
              class="cls-116"
              d="M592.49,490.82a.78.78,0,0,0,0,.4.18.18,0,0,1-.09.22v.37c.19,0,.15.18.16.31s.22-.05.21-.21-.06-.61-.08-.92C592.7,490.85,592.61,490.82,592.49,490.82Z"
            />
            <path
              class="cls-114"
              d="M594.43,492.34c0-.32,0-.64-.1-1a.69.69,0,0,1,0-.25.32.32,0,0,0-.27,0,4,4,0,0,1,.07.84v.1c.1.09,0,.34.28.31Z"
            />
            <path
              class="cls-116"
              d="M592.86,490.54c-.13.17-.23-.05-.36,0s-.18,0-.2.07.07.13.15.13a5.32,5.32,0,0,1,.8.12c.07,0,.15,0,.17-.06s0-.13-.13-.15Z"
            />
            <path
              class="cls-116"
              d="M593.75,492.31a5.09,5.09,0,0,0,0-1.17c0-.08,0-.14-.11-.14a.1.1,0,0,0-.09.12A6,6,0,0,0,593.75,492.31Z"
            />
            <path
              class="cls-116"
              d="M594.27,491c.06,0,.13,0,.15-.06a.12.12,0,0,0-.08-.15,1.67,1.67,0,0,0-.7-.08c-.06,0-.09,0-.09.1s0,.08.06.08Z"
            />
            <path
              class="cls-116"
              d="M594.15,491.93a4,4,0,0,0-.07-.84l-.16,0a3.75,3.75,0,0,0,.08.88Z"
            />
            <path
              class="cls-115"
              d="M594,491.92a3.75,3.75,0,0,1-.08-.88c-.06,0-.11,0-.09.1.1.39,0,.8.13,1.19l0,.06v-.47Z"
            />
            <path
              class="cls-116"
              d="M594,492.29v.1c.14,0,.3.18.42-.05-.25,0-.18-.22-.28-.31S594.1,492.23,594,492.29Z"
            />
            <path
              class="cls-115"
              d="M592.58,492.12c0-.13,0-.28-.16-.31C592.43,491.93,592.37,492.1,592.58,492.12Z"
            />
            <path
              class="cls-116"
              d="M592.71,483.27c0-.19,0-.45-.07-.72,0-.11,0-.15-.16-.16-.53-.07-.65.06-.54.59,0,.21.07.42.09.64s.06.21.21.2h0C592.74,483.82,592.74,483.82,592.71,483.27Z"
            />
            <path
              class="cls-116"
              d="M593.31,483c0,.14,0,.29-.06.43s0,.16,0,.25,0,.11-.08.1-.07,0-.07-.09a6.49,6.49,0,0,0-.09-1c0-.34,0-.34.31-.33,0,.12-.06.34.13.33s.05-.22.08-.33.19.12.21.24c0,.32.06.64.08,1,0,.09.05.23-.1.25s-.31.09-.37-.13A1.19,1.19,0,0,0,593.31,483Zm.19.57c.06,0,.1,0,.08-.09s0-.13-.09-.14-.07.06-.08.08S593.42,483.56,593.5,483.56Zm0-.52c0,.07,0,.1.1.1s.1,0,.09-.1a.11.11,0,0,0-.11-.08S593.45,483,593.45,483Z"
            />
            <path
              class="cls-116"
              d="M591.44,482.71a6.18,6.18,0,0,1,.08.8c0,.17.08.36.3.31s.11-.24.09-.36a7.35,7.35,0,0,1-.1-.82c0-.17-.06-.23-.23-.23S591.43,482.55,591.44,482.71Z"
            />
            <path
              class="cls-116"
              d="M591.42,482.05l0,.1c.07.2.23.17.37.14a2.34,2.34,0,0,1,.7,0c.07,0,.17.06.17-.07a.14.14,0,0,0-.17-.15Z"
            />
            <path
              class="cls-116"
              d="M593.09,481.64h-.34c-.07,0-.12,0-.12.11a.14.14,0,0,0,0,.11c.06.05.1,0,.14,0s0-.12.08,0,.38.07.57.07.11-.07.1-.15-.07-.09-.13-.09Z"
            />
            <path
              class="cls-116"
              d="M592.93,483.79a7,7,0,0,0,0-1.22c0-.07,0-.19-.12-.16s0,.11,0,.17a8.43,8.43,0,0,0,.1,1C592.84,483.65,592.81,483.72,592.93,483.79Z"
            />
            <path
              class="cls-116"
              d="M592.21,481.93c.11-.07.35.09.34-.15s-.23-.11-.36-.11-.35-.1-.34.13S592.09,481.87,592.21,481.93Z"
            />
            <path
              class="cls-116"
              d="M593.24,482.26h.21c.08,0,.17,0,.17-.12s-.09-.13-.17-.13h-.36c-.09,0-.19,0-.19.13s.09.13.18.12Z"
            />
            <path
              class="cls-116"
              d="M591.41,481.68c0,.09-.09.17,0,.26s.19,0,.25,0,.11-.18,0-.24a.07.07,0,0,1-.11,0Z"
            />
            <path
              class="cls-114"
              d="M593.27,482.37c0,.12-.06.34.13.33s.05-.22.08-.33Z"
            />
            <path
              class="cls-114"
              d="M593.3,483.69a1.19,1.19,0,0,0,0-.7c0,.14,0,.29-.06.43A.42.42,0,0,0,593.3,483.69Z"
            />
            <path
              class="cls-116"
              d="M592.69,482.15c0,.05,0,.11.08.1s.07-.06.07-.11,0-.11-.08-.11S592.69,482.09,592.69,482.15Z"
            />
            <path class="cls-115" d="M591.51,481.68a.07.07,0,0,0,.11,0Z" />
            <path
              class="cls-117"
              d="M594.85,492.38a.38.38,0,0,0,0-.37A.37.37,0,0,0,594.85,492.38Z"
            />
            <path
              class="cls-116"
              d="M597.57,488.43c-.05-.66-.1-1.39-.14-2.12,0-.17-.07-.26-.26-.26l-.6,0c-.14,0-.2,0-.18.2.08.73.15,1.46.19,2.19,0,.26.13.33.35.33a1.53,1.53,0,0,1,.37,0C597.53,488.81,597.64,488.76,597.57,488.43Z"
            />
            <path
              class="cls-114"
              d="M597.91,488.83a.5.5,0,0,0,.33-.12c0-.22-.09-.43-.07-.65s-.15-.55.07-.81c-.13-.14-.23-.29,0-.46,0,0,0-.07-.08-.09a.1.1,0,0,1,0-.16c.12-.12,0-.29.12-.41h0s0,0,0,0-.32,0-.48,0l0,.06c.14.9.14,1.82.22,2.73Z"
            />
            <path
              class="cls-116"
              d="M597.91,488.83c-.08-.91-.08-1.83-.22-2.73-.11-.06-.17,0-.16.1,0,.55.06,1.11.12,1.66,0,.25,0,.5.05.75S597.75,488.84,597.91,488.83Z"
            />
            <path
              class="cls-116"
              d="M597.09,485.91c.1-.05.27.11.27-.13s-.13-.2-.28-.2l-.54,0c-.11,0-.18,0-.18.16a.15.15,0,0,0,.17.15Z"
            />
            <path
              class="cls-116"
              d="M597,485.43h.16c.09,0,.16,0,.16-.12a.14.14,0,0,0-.13-.17c-.24,0-.48,0-.73-.05-.09,0-.14.05-.13.15s0,.15.13.16l.54,0Z"
            />
            <path
              class="cls-114"
              d="M597.73,485.94l.3-.07c.15,0,.12-.15.11-.25s-.11-.07-.18-.07l-.29,0h0l0,.36Z"
            />
            <path
              class="cls-116"
              d="M597.69,485.93l0-.36c-.09,0-.2,0-.19.14S597.54,485.93,597.69,485.93Z"
            />
            <path
              class="cls-116"
              d="M597.65,485.14c-.09,0-.2,0-.19.14s.1.16.2.19h0v-.31Z"
            />
            <path
              class="cls-116"
              d="M597.81,485.09h-.14l0,.06h0C597.72,485.14,597.77,485.14,597.81,485.09Z"
            />
            <path
              class="cls-116"
              d="M597.57,484v-.07c-.07-.9-.15-1.81-.22-2.71h0c-.2,0-.17.15-.15.27.1.58,0,1.17.14,1.75,0,.24.06.5.08.75Z"
            />
            <path
              class="cls-120"
              d="M602,492.77l.44,0a2,2,0,0,0,.73-.13c0-.29,0-.57,0-.86a2.43,2.43,0,0,1,0-.27c0-.12-.08-.26.09-.34l0-.11a10.45,10.45,0,0,0-1.12-.18c-.19,0-.27,0-.25.21a.72.72,0,0,1,0,.48s0,0,0,.05A3.48,3.48,0,0,1,602,492.77Z"
            />
            <path
              class="cls-116"
              d="M601.84,491.66s0,0,0-.05-.06-.25-.06-.38a.33.33,0,0,0-.35-.38c-.16,0-.18,0-.16.18s.07.56.11.83c0,.12,0,.28.12.32s.24-.09.3-.2S601.76,491.76,601.84,491.66Z"
            />
            <path
              class="cls-119"
              d="M601,493.17l.09,0c0-.24.14-.12.23-.13s.18.05.17.17,0,.25-.09.27-.27,0-.34-.12Zm.32-.05a.06.06,0,0,0-.08,0c0,.11.08.12.12.19C601.41,493.24,601.43,493.16,601.34,493.12Z"
            />
            <path
              class="cls-119"
              d="M600.34,493.12l.07.22a.57.57,0,0,0,.32,0v-.2l0-.22-.08,0-.11-.05c0,.1,0,.21-.15.21C600.35,493.09,600.34,493.1,600.34,493.12Z"
            />
            <path
              class="cls-109"
              d="M600.72,493.18v.2a.4.4,0,0,0,.26.05l.09-.11-.06-.15c-.13,0-.1-.09-.1-.17s-.08-.06-.15,0S600.79,493.12,600.72,493.18Z"
            />
            <path
              class="cls-110"
              d="M601,493.43a.4.4,0,0,1-.26-.05.57.57,0,0,1-.32,0h-.16l0,.09.77.12Z"
            />
            <path
              class="cls-113"
              d="M600.35,493.07c.16,0,.15-.11.15-.21C600.25,492.79,600.37,493,600.35,493.07Z"
            />
            <path
              class="cls-111"
              d="M600.72,493.18c.07-.06,0-.15,0-.22s0,0,0,0l-.07,0Z"
            />
            <path class="cls-120" d="M600.69,493l.07,0c0-.08-.1-.05-.15,0Z" />
            <path
              class="cls-116"
              d="M595.91,480.77a.4.4,0,0,0,.33.1l.66,0c.1,0,.17,0,.16-.16s0-.16-.16-.15l-.78,0c-.15,0-.19.1-.21.22Z"
            />
            <path
              class="cls-116"
              d="M596.53,481.17h.36c.09,0,.19,0,.18-.13s-.09-.12-.17-.12a4.64,4.64,0,0,0-.83.06c-.06,0-.09,0-.09.09s0,.12.1.12Z"
            />
            <path
              class="cls-116"
              d="M597.33,480.47h-.05c-.06.07-.18.08-.15.21a.19.19,0,0,0,.2.16h0v-.36Z"
            />
            <path
              class="cls-116"
              d="M597.33,480.89c-.08,0-.15,0-.15.14s.08.12.16.12h0v-.24Z"
            />
            <path
              class="cls-117"
              d="M624.09,481.39H624a5.2,5.2,0,0,0-.09,1.11l0,.06v.15a.19.19,0,0,0,.16-.06Z"
            />
            <path
              class="cls-114"
              d="M623.6,486.77l.06-.06,0-1.2h-.14l-.06,1.11C623.5,486.7,623.51,486.76,623.6,486.77Z"
            />
            <path
              class="cls-117"
              d="M623.7,485.51l0,1.2c.1,0,.12-.09.15-.16l0-1.06Z"
            />
            <path
              class="cls-114"
              d="M623.85,485.49l0,1.06h.13c0-.37,0-.73,0-1.1C623.92,485.37,623.88,485.42,623.85,485.49Z"
            />
            <path
              class="cls-114"
              d="M623.9,482.5a5.2,5.2,0,0,1,.09-1.11c-.16-.09-.15,0-.17.13,0,.4,0,.8-.05,1.2h.1v-.15Z"
            />
            <path
              class="cls-114"
              d="M624.09,481.39l-.06,1.26h.14a5.43,5.43,0,0,1,.08-1.27A.1.1,0,0,0,624.09,481.39Z"
            />
            <path
              class="cls-117"
              d="M623.6,486.77c-.09,0-.1-.07-.1-.15l.06-1.11c-.17.19-.09.43-.12.64a3.37,3.37,0,0,0,0,.55c0,.05-.05.11,0,.14S623.56,486.82,623.6,486.77Z"
            />
            <path
              class="cls-117"
              d="M624.25,481.38a5.43,5.43,0,0,0-.08,1.27l.07-.11.06-1.15Z"
            />
            <path
              class="cls-114"
              d="M624.3,481.39l-.06,1.15h.08a5.47,5.47,0,0,1,.09-1.15C624.37,481.34,624.33,481.34,624.3,481.39Z"
            />
            <path
              class="cls-117"
              d="M623.77,482.72c0-.4,0-.8.05-1.2-.2.12-.07.33-.1.49A1,1,0,0,0,623.77,482.72Z"
            />
            <path
              class="cls-117"
              d="M624,485.45c0,.37,0,.73,0,1.1A1.73,1.73,0,0,0,624,485.45Z"
            />
            <path
              class="cls-117"
              d="M624,486.74a1.31,1.31,0,0,0-.57.27A1,1,0,0,0,624,486.74Z"
            />
            <path
              class="cls-109"
              d="M623.52,487.56c.05.09.11.15.21.1A.15.15,0,0,0,623.52,487.56Z"
            />
            <path class="cls-117" d="M624.19,486.63l0,0,0,0Z" />
            <path
              class="cls-111"
              d="M623.26,487.47a.16.16,0,0,0-.2-.12c-.1,0-.06.13-.06.2,0,1.19-.12,2.38-.16,3.57,0,.47,0,.94,0,1.41.22-.06.26-.23.26-.43,0-.89.07-1.78.1-2.67Z"
            />
            <path
              class="cls-115"
              d="M621,492c-.11.12,0,.29-.1.41.09.1.13.06.16-.05S621,492.11,621,492Z"
            />
            <path
              class="cls-117"
              d="M623.68,489.08l-.13.06c0,.42,0,.84-.07,1.27l.22-.06h0v-.15A8.39,8.39,0,0,1,623.68,489.08Z"
            />
            <path
              class="cls-114"
              d="M623.48,490.41c0-.43,0-.85.07-1.27-.17,0-.15.18-.16.29s0,.52,0,.78C623.35,490.31,623.37,490.39,623.48,490.41Z"
            />
            <path
              class="cls-114"
              d="M623.68,489.08a8.39,8.39,0,0,0,0,1.12.56.56,0,0,0,.1-.38,3,3,0,0,1,0-.73s0-.11-.06-.11S623.71,489.05,623.68,489.08Z"
            />
            <path class="cls-115" d="M623.34,490.62a.1.1,0,0,0,.1-.06Z" />
            <path
              class="cls-116"
              d="M604.77,493.33v-.58c-.11,0-.15-.05-.17-.16a8.35,8.35,0,0,1-.07-1.32c-.15-.09-.1.14-.21.12v.11a.66.66,0,0,1,0,.68v.21c0,.06,0,.14,0,.2.07.23,0,.5.17.7A.31.31,0,0,0,604.77,493.33Z"
            />
            <path
              class="cls-117"
              d="M604.48,494.69c0-.13.07-.26.1-.39s0-.09,0-.1c.28-.07.13-.3.17-.46h-.23a.2.2,0,0,1-.15.05c.14.19,0,.4,0,.6S604.38,494.61,604.48,494.69Z"
            />
            <path
              class="cls-110"
              d="M604.54,493.75h.23v-.41a.31.31,0,0,1-.21,0l-.18,0v.11C604.6,493.45,604.48,493.64,604.54,493.75Z"
            />
            <path
              class="cls-113"
              d="M604.34,492.18a.66.66,0,0,0,0-.68C604.32,491.73,604.23,492,604.34,492.18Z"
            />
            <path
              class="cls-113"
              d="M604.38,493.31l.18,0c-.18-.2-.1-.47-.17-.7,0-.06,0-.14,0-.2A4.73,4.73,0,0,0,604.38,493.31Z"
            />
            <path
              class="cls-113"
              d="M604.54,493.75c-.06-.11.06-.3-.16-.33a.7.7,0,0,0,0,.38A.2.2,0,0,0,604.54,493.75Z"
            />
            <path class="cls-113" d="M604.55,494.83h0Z" />
            <path
              class="cls-109"
              d="M601.13,490.11l0-.05H601a.11.11,0,0,0,0,.05v.05Z"
            />
            <path
              class="cls-111"
              d="M601,490.11a.11.11,0,0,1,0-.05s-.07-.06-.08,0S600.91,490.1,601,490.11Z"
            />
            <path class="cls-109" d="M599.93,489.87v0l0,0,0,0Z" />
            <path class="cls-109" d="M600,490l0,0h0l0,0Z" />
            <path
              class="cls-116"
              d="M603.17,493a2.3,2.3,0,0,0-.72.43l.44.07c.28.05.31,0,.3-.27C603.19,493.14,603.17,493.07,603.17,493Z"
            />
            <path
              class="cls-120"
              d="M603.3,491.58h-.09v.25c0,.22,0,.44.07.65A3.32,3.32,0,0,0,603.3,491.58Z"
            />
            <path
              class="cls-113"
              d="M603.21,491.82v-.25c0-.12,0-.24,0-.36-.17.08-.08.22-.09.34a2.43,2.43,0,0,0,0,.27Z"
            />
            <path
              class="cls-109"
              d="M603.27,493.9c0-.1-.07-.11-.14-.07s-.26,0-.23.22l.34-.12Z"
            />
            <path
              class="cls-109"
              d="M602.38,490.34a.11.11,0,0,0,.1-.12A.11.11,0,0,0,602.38,490.34Z"
            />
            <path class="cls-109" d="M601.42,490h-.1a.11.11,0,0,0,.15,0Z" />
            <path
              class="cls-109"
              d="M602.64,490.38l.1,0s0,0,0,0a.08.08,0,0,0-.09,0Z"
            />
            <path class="cls-109" d="M603.15,490.31l0,0,0,0,0,0Z" />
            <path
              class="cls-113"
              d="M610.91,492.36c.21,0,.41-.11.59.06l.08,0c.12,0,.32.1.36-.08s-.18-.16-.29-.18-.5-.08-.75-.11Z"
            />
            <path
              class="cls-114"
              d="M604.52,491.27a8.35,8.35,0,0,0,.07,1.32c0,.11.06.16.17.16a8,8,0,0,1-.08-1.29C604.67,491.35,604.64,491.27,604.52,491.27Z"
            />
            <path
              class="cls-116"
              d="M606.19,491.45c.07,0,.18,0,.19-.07s-.11-.1-.18-.12a.38.38,0,0,0-.33,0s0,.06,0,.09S606.07,491.44,606.19,491.45Z"
            />
            <path class="cls-114" d="M605.85,492l0,0Z" />
            <path
              class="cls-117"
              d="M622.37,487.86c-.74.25-.66.83-.58,1.4l.49-.25s.07-.05.07-.07A2.62,2.62,0,0,0,622.37,487.86Z"
            />
            <path
              class="cls-115"
              d="M622.16,487.66h-.06v.07l-.06.07h-.31c-.06,0-.06.21-.2.12l0,.11,0,.07c.25,0,.42-.19.63-.28Z"
            />
            <path
              class="cls-115"
              d="M621,491.05a.42.42,0,0,0,0,.42A.48.48,0,0,0,621,491.05Z"
            />
            <path
              class="cls-113"
              d="M618.49,489.33a4.74,4.74,0,0,0,1.12.12A3.51,3.51,0,0,0,618.49,489.33Z"
            />
            <path
              class="cls-113"
              d="M619.71,488.93l.5,0v0l-.71-.06c.07.08.18,0,.21.11Z"
            />
            <path
              class="cls-113"
              d="M620.15,488.8l.36,0A.38.38,0,0,0,620.15,488.8Z"
            />
            <path class="cls-113" d="M620,488.73h-.2v0l.2,0Z" />
            <path class="cls-113" d="M620.75,488.84h0s0,0,0,0l0,0Z" />
            <path class="cls-113" d="M620.55,488.91l0,0,0,0,0,0Z" />
            <path
              class="cls-116"
              d="M602.3,487.39c0-.43-.1-.85-.09-1.28,0-.18-.11-.22-.25-.23a6.78,6.78,0,0,1-.78,0c-.14,0-.2,0-.17.19.11.5,0,1,.13,1.54,0,.18.1.25.28.26a4,4,0,0,1,.68.05c.2,0,.22-.05.21-.21A2.81,2.81,0,0,1,602.3,487.39Z"
            />
            <path
              class="cls-116"
              d="M603.82,487.3c0-.38-.05-.75-.07-1.13,0-.13-.07-.17-.19-.19s-.56-.12-.75,0,0,.45,0,.69a3.37,3.37,0,0,0,0,.55c0,.08,0,.16.08.2.27.13.13.22-.06.32.32.19.66,0,1,.12.07,0,.07-.08.08-.14a2.24,2.24,0,0,1-.58,0c-.08,0-.17,0-.15-.13s.1-.08.17-.07a2.53,2.53,0,0,0,.55,0l-.05-.11-.65-.06C603.36,487.21,603.59,487.33,603.82,487.3Z"
            />
            <path
              class="cls-116"
              d="M601,487.34A8,8,0,0,1,601,486c0-.26-.2-.22-.36-.23s-.17.13-.17.25c0,.47.06.94.1,1.41a.32.32,0,0,0,.12.28.36.36,0,0,0,.32,0c.12,0,.08-.14.08-.23Z"
            />
            <path
              class="cls-116"
              d="M602.72,487.43c0-.1-.11-.1-.22-.14a.25.25,0,0,0,.18-.31,5.7,5.7,0,0,1,0-.83c0-.12,0-.24-.18-.24s-.14.12-.14.23a10.86,10.86,0,0,0,.13,1.77c.07-.14.23-.13.28-.26s-.2,0-.2-.11S602.64,487.45,602.72,487.43Z"
            />
            <path
              class="cls-116"
              d="M601.82,485.78h.24c.07,0,.14,0,.14-.09s0-.19-.12-.17c-.36.07-.73-.14-1.09.05-.07,0-.06,0-.08-.06s-.28-.06-.42-.05a.11.11,0,0,0-.08.12c0,.11.08.13.16.13l1.25.09Z"
            />
            <path
              class="cls-116"
              d="M603.72,485.31s0-.07,0-.07c-.34,0-.69-.18-1,0,0,.18.16.18.29.19h.65C603.76,485.5,603.71,485.38,603.72,485.31Z"
            />
            <path
              class="cls-116"
              d="M603.59,485.83c.08.05.13,0,.14-.05s0-.17-.12-.18c-.27,0-.55,0-.83-.05-.06,0-.09,0-.1.1a.15.15,0,0,0,.11.16,1.1,1.1,0,0,0,.36,0Z"
            />
            <path
              class="cls-121"
              d="M603.83,487.51a2.53,2.53,0,0,1-.55,0c-.07,0-.15,0-.17.07s.07.11.15.13a2.24,2.24,0,0,0,.58,0Z"
            />
            <path
              class="cls-116"
              d="M602.31,485.67c0,.11.06.14.15.14s.16,0,.16-.13-.06-.14-.15-.14S602.31,485.57,602.31,485.67Z"
            />
            <path
              class="cls-121"
              d="M603.82,487.3c-.23,0-.46-.09-.69,0l.65.06Z"
            />
            <path
              class="cls-116"
              d="M602.61,485.28c-.12-.17-.24-.07-.35,0s.09.16.2.16S602.61,485.38,602.61,485.28Z"
            />
            <path
              class="cls-121"
              d="M604,487.75c.08,0,.19,0,.18-.09s-.1-.1-.19-.09Z"
            />
            <path
              class="cls-121"
              d="M602.72,487.43c-.08,0-.19,0-.19.11s.12.09.2.11Z"
            />
            <path
              class="cls-115"
              d="M600.88,485.32h-.11S600.85,485.43,600.88,485.32Z"
            />
            <path
              class="cls-116"
              d="M601.81,482.72c.25-.16.2-.41.19-.64s0-.46,0-.69-.07-.21-.22-.2h-.92c-.1,0-.13,0-.12.12.11.5,0,1,.11,1.51,0,.21.1.32.33.28s.21,0,.31,0,.3,0,.29-.2-.33,0-.49-.12c.11-.08.22,0,.31-.06s-.14,0-.19-.08A.84.84,0,0,1,601.81,482.72Z"
            />
            <path
              class="cls-116"
              d="M603.28,482.74c0-.08,0-.16.12-.15.29,0,.26-.19.23-.36a6,6,0,0,1-.07-.94c0-.13,0-.19-.19-.19l-.73,0c-.14,0-.19.05-.19.19,0,.56.07,1.11.1,1.67,0,0,0,.12.07.12.21,0,.44.1.62-.1-.12-.15-.29-.09-.44-.1s-.14,0-.15-.06.09-.13.14-.12S603.12,482.65,603.28,482.74Z"
            />
            <path
              class="cls-116"
              d="M600.15,481.69a9.79,9.79,0,0,1,.09,1.17.33.33,0,0,0,.48.26c.06,0,0-.08,0-.13-.07-.53-.08-1.07-.1-1.6,0-.19-.14-.17-.26-.16s-.26,0-.26.17S600.15,481.54,600.15,481.69Z"
            />
            <path
              class="cls-116"
              d="M602.43,482.23a8.77,8.77,0,0,0-.08-.93c0-.1,0-.16-.15-.17s-.13.05-.14.16c-.06.45.1.89.06,1.33,0,.14.19-.07.16.1a2,2,0,0,0,0,.24c0,.07,0,.15.09.15s.12-.06.12-.14S602.43,482.54,602.43,482.23Z"
            />
            <path
              class="cls-116"
              d="M601.91,480.51a2.72,2.72,0,0,0-1.1,0c-.23,0-.49-.09-.7.11,0,.1,0,.2.16.19s.31.05.36-.22c.12.29.34.21.52.19a3.66,3.66,0,0,1,.57,0C601.88,480.73,601.92,480.65,601.91,480.51Z"
            />
            <path
              class="cls-116"
              d="M603.54,480.47a1.53,1.53,0,0,0-1.11.08c0,.13.08.15.19.15l.73,0C603.51,480.68,603.55,480.6,603.54,480.47Z"
            />
            <path
              class="cls-116"
              d="M601.32,481.05h.47c.06,0,.12,0,.12-.11s-.07-.1-.13-.1l-.94,0c-.07,0-.12,0-.12.1s.06.1.13.1Z"
            />
            <path
              class="cls-116"
              d="M603,481h.39c.07,0,.14,0,.13-.12s-.07-.09-.13-.08l-.81,0c-.07,0-.14,0-.13.12s.07.09.13.09l.42,0Z"
            />
            <path
              class="cls-114"
              d="M601.81,482.72a.84.84,0,0,0-.42,0c.05.09.15,0,.19.08s-.2,0-.31.06c.16.12.35,0,.49.12s.14.1.21.18C602.12,482.89,601.8,482.87,601.81,482.72Z"
            />
            <path
              class="cls-114"
              d="M603.28,482.74c-.16-.09-.33,0-.49,0s-.15,0-.14.12.09.06.15.06.32,0,.44.1C603.32,482.92,603.27,482.83,603.28,482.74Z"
            />
            <path
              class="cls-116"
              d="M600.13,481c.11.19.29.06.44.08s.06,0,0-.08a.11.11,0,0,0-.1-.06h-.39Z"
            />
            <path
              class="cls-116"
              d="M602.33,480.54c-.1-.16-.22-.08-.33,0s0,.2.16.19S602.34,480.65,602.33,480.54Z"
            />
            <path
              class="cls-116"
              d="M602,480.93c0,.09.08.1.15.09s.15,0,.15-.1-.08-.1-.15-.1S602,480.83,602,480.93Z"
            />
            <path class="cls-116" d="M603.6,482.77l0,.05,0-.05,0,0Z" />
            <path
              class="cls-115"
              d="M600.13,481v-.06l0,0S600.12,481,600.13,481Z"
            />
            <path
              class="cls-117"
              d="M598.46,487.34l0,1.15c0,.19.08.23.25.19.43-.11.46-.11.41-.55-.08-.67,0-1.34-.15-2a.43.43,0,0,0,0-.12V487a.26.26,0,0,1,0,.23c0,.13,0,.2-.13.2A.94.94,0,0,1,598.46,487.34Z"
            />
            <path
              class="cls-117"
              d="M598.21,486.13c-.08.12,0,.29-.12.41a.1.1,0,0,0,0,.16s.1.07.08.09c-.2.17-.1.32,0,.46-.22.26,0,.54-.07.81s.09.43.07.65c.15.08.21,0,.19-.14,0-.5,0-1-.11-1.48A4.42,4.42,0,0,0,598.21,486.13Z"
            />
            <path
              class="cls-114"
              d="M599,486.52V486c-.15-.23-.33,0-.49,0s-.1.13-.09.21-.06.21,0,.3A1.82,1.82,0,0,1,599,486.52Z"
            />
            <path
              class="cls-114"
              d="M598.89,485.42a2.32,2.32,0,0,0-.45.06.17.17,0,0,0-.13.22c0,.12.11.11.2.1S598.94,485.74,598.89,485.42Z"
            />
            <path
              class="cls-114"
              d="M598.87,485c-.2,0-.4-.05-.58.07,0,.1-.12.24.11.26C598.81,485.37,598.86,485.34,598.87,485Z"
            />
            <path
              class="cls-116"
              d="M599,487.18a.26.26,0,0,0,0-.23,1.77,1.77,0,0,0-.56,0v.27Z"
            />
            <path
              class="cls-116"
              d="M599,486.52a1.82,1.82,0,0,0-.57,0v.27H599Z"
            />
            <path
              class="cls-114"
              d="M597.81,485.09c0,.05-.09.05-.15.06v.31c.16-.08.47,0,.42-.32C598,485.06,597.91,485.09,597.81,485.09Z"
            />
            <path
              class="cls-114"
              d="M599,487.18h-.6a.19.19,0,0,0,.06.16.94.94,0,0,0,.41,0C599,487.38,599.05,487.31,599,487.18Z"
            />
            <path
              class="cls-114"
              d="M599,486.75h-.56v.15a1.77,1.77,0,0,1,.56,0Z"
            />
            <path class="cls-117" d="M598.22,486.09s0,0,0,0l0,0Z" />
            <path
              class="cls-114"
              d="M597.36,481.22c.07.9.15,1.81.22,2.71a.23.23,0,0,0,.22-.06c0-.25,0-.49,0-.73s.06-.22.21-.22v-.1c-.09,0-.21,0-.24-.1s.19,0,.2-.17-.22,0-.23-.16.16-.11.21-.19l0-.9C597.73,481.1,597.53,481.24,597.36,481.22Z"
            />
            <path
              class="cls-114"
              d="M598.74,482.12a3.19,3.19,0,0,1-.08-.75c0-.13,0-.2-.18-.19s-.39-.05-.54.12.13.48.06.73,0,.21.12.24a1.63,1.63,0,0,0,.54,0C598.74,482.25,598.74,482.18,598.74,482.12Z"
            />
            <path
              class="cls-117"
              d="M598.13,482.93c0,.21,0,.43,0,.65s.27.21.45.22.24-.07.23-.25,0-.43,0-.65Z"
            />
            <path
              class="cls-117"
              d="M598.74,482.12c0,.06,0,.13-.08.15a1.63,1.63,0,0,1-.54,0c-.13,0-.12-.14-.12-.24l-.09.17c0,.08-.22,0-.21.19s.17.08.23.16-.23,0-.2.17.15.08.24.1h.1l.74,0c0-.07,0-.15-.06-.21a1,1,0,0,1-.68,0s-.05-.07-.06-.1-.07-.11,0-.12,0,.07,0,.12a1.78,1.78,0,0,1,.69,0A.42.42,0,0,0,598.74,482.12Z"
            />
            <path
              class="cls-117"
              d="M598,482.92c-.15,0-.22.06-.21.22s0,.48,0,.73c.23,0,.32-.06.25-.3S598.09,483.12,598,482.92Z"
            />
            <path
              class="cls-114"
              d="M598.65,480.59a.72.72,0,0,0-.75,0c0,.14.07.24.22.21S598.58,480.91,598.65,480.59Z"
            />
            <path
              class="cls-114"
              d="M598.32,481.13h.16c.09,0,.17,0,.17-.14s-.09-.12-.17-.12h-.32c-.09,0-.18,0-.18.13s.09.13.18.13Z"
            />
            <path
              class="cls-114"
              d="M597.33,480.47v.36h.26c.16,0,.22-.06.21-.21S597.49,480.52,597.33,480.47Z"
            />
            <path
              class="cls-114"
              d="M597.34,480.9v.24h.34c.07,0,.15,0,.16-.09a.16.16,0,0,0-.17-.16Z"
            />
            <path
              class="cls-114"
              d="M598.75,482.54a1.78,1.78,0,0,0-.69,0v.1a1,1,0,0,0,.68,0Z"
            />
            <path
              class="cls-116"
              d="M597.91,482.2,598,482c.07-.25-.06-.48-.06-.73h-.07Z"
            />
            <path class="cls-114" d="M598.81,482.8l-.74,0,.06.11.68,0Z" />
            <path
              class="cls-114"
              d="M612.41,487.43v0c-.22,0-.29.18-.17.44.1,0,.08-.14.17-.13v-.1C612.28,487.55,612.29,487.49,612.41,487.43Z"
            />
            <path
              class="cls-114"
              d="M612.22,487.31a.38.38,0,0,0-.38,0C612,487.38,612.05,487.34,612.22,487.31Z"
            />
            <path
              class="cls-114"
              d="M611.92,482.27c.11.08.19.09.28,0A.28.28,0,0,0,611.92,482.27Z"
            />
            <path class="cls-116" d="M612.41,487.43c-.12.06-.13.12,0,.17Z" />
            <path
              class="cls-116"
              d="M609.61,483.09l-.05-1.89a.18.18,0,0,0,0,.16c0,.53,0,1.06,0,1.59A.16.16,0,0,0,609.61,483.09Z"
            />
            <path class="cls-116" d="M621.87,483,622,483v-.05l-.25-.06.1.16Z" />
            <path
              class="cls-114"
              d="M620.74,482.27v.36l.06.06.47,0c0-.53,0-1.06,0-1.59,0-.08,0-.16-.08-.18s-.1.05-.15,0c-.27,0-.34.09-.32.35A3.57,3.57,0,0,1,620.74,482.27Z"
            />
            <path
              class="cls-114"
              d="M621.93,481c-.12-.21-.32,0-.48-.09l-.06,1.57a.66.66,0,0,1,0,.23v.08a.68.68,0,0,1,.46-.18c.08,0,.05-.13.05-.21C621.89,482,621.91,481.5,621.93,481Z"
            />
            <path
              class="cls-114"
              d="M622,482.92V483h.1c0-.12.06-.26.2-.31.12-.56.06-1.12.13-1.68-.15-.09-.29-.13-.4.07C622,481.66,622,482.29,622,482.92Z"
            />
            <path
              class="cls-116"
              d="M620.74,482.27a3.57,3.57,0,0,0,0-1c0-.26.05-.38.32-.35,0,0,.1,0,.15,0h-.81c-.12,0-.14,0-.16.17a6.39,6.39,0,0,0,0,1.07v-.53C620.51,481.81,620.56,482.08,620.74,482.27Z"
            />
            <path
              class="cls-114"
              d="M620.81,480.41h.39c.11,0,.13-.08.13-.18s-.06-.13-.15-.13h-.38Z"
            />
            <path
              class="cls-114"
              d="M621.9,480.41a.54.54,0,0,0,.05-.33h-.34c-.14,0-.13.11-.15.2s.08.11.16.12Z"
            />
            <path
              class="cls-116"
              d="M620.81,480.41v-.3h-.34c-.09,0-.14.05-.14.15a.14.14,0,0,0,.16.16Z"
            />
            <path
              class="cls-116"
              d="M621,480.54c-.19,0-.37.07-.56,0a.1.1,0,0,0-.12.11c0,.08,0,.14.12.14l.41,0C620.78,480.65,620.86,480.59,621,480.54Z"
            />
            <path
              class="cls-114"
              d="M621,480.54c-.11,0-.19.11-.15.24h.36c.06,0,.13,0,.14-.08s0-.15-.09-.17H621Z"
            />
            <path
              class="cls-122"
              d="M621.35,482.82v-.08l-.07-.07-.47,0c0,.36.28.15.43.2Z"
            />
            <path
              class="cls-114"
              d="M621.86,480.78c0-.07.11-.15,0-.24l-.28,0c-.06,0-.16,0-.15.08s.06.14.16.13Z"
            />
            <path
              class="cls-116"
              d="M621.24,482.89c-.15-.05-.42.16-.43-.2l-.06-.06c0,.1-.09.23,0,.28A.51.51,0,0,0,621.24,482.89Z"
            />
            <path class="cls-116" d="M621.17,480.53h0Z" />
            <path
              class="cls-116"
              d="M620.75,482.54v-.06s0,0,0,0A0,0,0,0,1,620.75,482.54Z"
            />
            <path
              class="cls-121"
              d="M621,487.53a1.48,1.48,0,0,0,0-.21c0-.12-.08-.16-.19-.16s-.17.07-.17.18a1.7,1.7,0,0,1,0,.39c0,.1,0,.2.11.22s.24,0,.27-.14a1.32,1.32,0,0,0,0-.28Z"
            />
            <path
              class="cls-121"
              d="M621.49,488.05l0-.11a.39.39,0,0,1,0-.28c0-.1,0-.2,0-.31s0-.15-.15-.16-.17.06-.17.18,0,.41,0,.62Z"
            />
            <path
              class="cls-116"
              d="M621.08,486.78l-.42,0s-.07.13,0,.14S621,487,621.08,486.78Z"
            />
            <path
              class="cls-116"
              d="M620.87,484.84h.2c.09,0,.08-.08.09-.13s0-.12-.1-.12c-.24,0-.48-.07-.73,0-.08,0-.15,0-.15.14s.08.12.17.13Z"
            />
            <path
              class="cls-116"
              d="M621.61,485a.49.49,0,0,0-.27,0l-.09.05-.81-.07c-.09,0-.25-.06-.27.07s.16.11.25.12c.33,0,.65,0,1,0l.11,0h.11Z"
            />
            <path
              class="cls-115"
              d="M621.61,485v.16a.11.11,0,0,1,0,.11h.15c.07-.17.24-.14.38-.17V485l-.32.05c0-.14.15-.1.19-.21s-.16,0-.23,0h-.11A.15.15,0,0,1,621.61,485Z"
            />
            <path
              class="cls-116"
              d="M621.7,484.77c-.06-.06-.05-.13-.05-.21h-.23c-.06,0-.15,0-.14.09s0,.16.12.17h.31Z"
            />
            <path
              class="cls-115"
              d="M621.25,485l.09-.05A.09.09,0,0,0,621.25,485Z"
            />
            <path class="cls-115" d="M621.5,485.14l-.11,0Z" />
            <path class="cls-115" d="M618.41,486.46l.08,0Z" />
            <path
              class="cls-116"
              d="M622.28,482.65c-.14.05-.15.19-.2.31C622.37,483,622.39,482.92,622.28,482.65Z"
            />
            <path class="cls-117" d="M622.05,487.81l.06-.07Z" />
            <path
              class="cls-113"
              d="M622.08,480.66c0,.09.08.1.15.1s.17,0,.15-.13-.1-.08-.17-.08S622.08,480.57,622.08,480.66Z"
            />
            <path
              class="cls-117"
              d="M621.7,484.77v.05h.11c0-.05,0-.11-.06-.12S621.71,484.74,621.7,484.77Z"
            />
            <path
              class="cls-117"
              d="M594,492.29c.09-.06,0-.23.14-.26v-.1H594Z"
            />
            <path
              class="cls-114"
              d="M593.41,483.41c0,.09,0,.15.09.15s.1,0,.08-.09,0-.13-.09-.14S593.42,483.39,593.41,483.41Z"
            />
            <path
              class="cls-117"
              d="M593.53,483s-.08,0-.08.08,0,.1.1.1.1,0,.09-.1A.11.11,0,0,0,593.53,483Z"
            />
            <path
              class="cls-117"
              d="M601.38,493.34c0-.1,0-.18,0-.22a.06.06,0,0,0-.08,0C601.23,493.26,601.34,493.27,601.38,493.34Z"
            />
            <path class="cls-115" d="M623.9,482.5l0,.06Z" />
            <path
              class="cls-116"
              d="M598.07,482.61v-.1c0-.05,0-.13,0-.12s0,.08,0,.12S598.05,482.57,598.07,482.61Z"
            />
          </g>
          <g id="central">
            <polygon
              class="cls-134"
              points="388.31 507.29 551.5 508.5 381.37 532.4 381.5 507.5 388.31 507.29"
            />
            <polygon
              class="cls-135"
              points="567.76 508.04 385 507 385 513 567.76 515.11 567.76 508.04"
            />
            <polygon
              class="cls-136"
              points="329.5 388.5 329.5 539.5 89.13 571.74 89.13 351.65 108.5 350.5 329.5 388.5"
            />
            <polygon
              class="cls-137"
              points="89.13 351.65 89.13 571.74 15.29 581.65 15.3 354.3 24.5 355.5 89.13 351.65"
            />
            <polygon
              class="cls-136"
              points="15.3 354.3 15.29 581.65 1.5 583.5 1.5 352.5 15.3 354.3"
            />
            <polygon
              class="cls-138"
              points="85.5 371.5 85.5 442.5 15.5 442.74 15.5 374.82 85.5 371.5"
            />
            <polygon
              class="cls-139"
              points="15.5 374.82 15.5 442.74 15.29 442.74 1.5 442.11 1.5 372.91 15.3 374.83 15.5 374.82"
            />
            <line class="cls-140" x1="15.5" y1="443" x2="15.5" y2="442.74" />
            <line class="cls-140" x1="15.5" y1="374.82" x2="15.5" y2="374.5" />
            <polygon
              class="cls-141"
              points="94.5 371.5 150.5 379.5 150.5 433.5 94.5 430.5 94.5 371.5"
            />
            <polygon
              class="cls-142"
              points="110.5 375.5 110.5 387.5 136.5 391.5 136.5 380.5 110.5 375.5"
            />
            <polygon
              class="cls-143"
              points="110.5 394.5 136.5 396.5 136.5 430.5 110.5 428.5 110.5 394.5"
            />
            <polygon
              class="cls-141"
              points="94.5 453.5 94.5 513.5 150.5 509.5 150.5 454.5 94.5 453.5"
            />
            <polygon
              class="cls-144"
              points="110.5 456.5 110.5 468.5 137.5 468.5 137.5 457.5 110.5 456.5"
            />
            <polygon
              class="cls-145"
              points="109.5 473.5 137.5 473.5 137.5 506.5 109.5 509.5 109.5 473.5"
            />
            <polygon
              class="cls-138"
              points="84.5 480.5 84.5 539.5 15.29 541.53 15.5 480.02 84.5 480.5"
            />
            <polygon
              class="cls-139"
              points="15.5 480.02 15.29 541.53 1.5 541.94 1.5 480.02 15.5 480.02"
            />
            <line class="cls-140" x1="15.5" y1="480.02" x2="15.5" y2="480" />
            <polygon
              class="cls-146"
              points="1.5 486.34 11.5 486.5 11.5 497.5 1.5 497.5 1.5 486.34"
            />
            <rect
              class="cls-146"
              x="1.5"
              y="502.96"
              width="10"
              height="34.54"
            />
            <rect class="cls-147" x="20.5" y="486.5" width="16" height="10" />
            <polygon
              class="cls-147"
              points="40.5 486.5 40.5 496.5 57.5 496.5 57.5 487.5 40.5 486.5"
            />
            <polygon
              class="cls-147"
              points="62.5 487.5 62.5 496.5 77.5 496.5 77.5 488.5 62.5 487.5"
            />
            <rect class="cls-147" x="20.5" y="501.5" width="16" height="37" />
            <rect class="cls-147" x="41.5" y="501.5" width="16" height="37" />
            <rect class="cls-147" x="62.5" y="501.5" width="15" height="37" />
            <polygon
              class="cls-146"
              points="1.5 379.17 12.5 380.5 12.5 391.5 1.5 390.28 1.5 379.17"
            />
            <polygon
              class="cls-146"
              points="1.5 395.51 12.5 396.5 12.5 437.5 1.5 436.75 1.5 395.51"
            />
            <rect class="cls-141" x="21.5" y="380.5" width="15" height="10" />
            <rect class="cls-148" x="41.5" y="380.5" width="16" height="10" />
            <rect class="cls-141" x="62.5" y="380.5" width="16" height="9" />
            <rect class="cls-141" x="21.5" y="395.5" width="15" height="40" />
            <polygon
              class="cls-148"
              points="41.5 395.5 57.5 394.5 57.5 435.5 41.5 435.5 41.5 395.5"
            />
            <rect class="cls-141" x="62.5" y="394.5" width="16" height="41" />
            <polygon
              class="cls-149"
              points="278.5 389.5 278.5 403.13 250.5 398.5 250.5 383.5 278.5 389.5"
            />
            <polygon
              class="cls-141"
              points="278.5 403.13 278.5 432.5 250.5 428.5 250.5 398.5 278.5 403.13"
            />
            <polygon
              class="cls-149"
              points="309.5 395.5 309.5 408.06 280.5 403.55 280.5 389.5 309.5 395.5"
            />
            <polygon
              class="cls-141"
              points="309.5 408.06 309.5 434.5 280.5 432.5 280.5 403.55 309.5 408.06"
            />
            <polygon
              class="cls-149"
              points="320.5 397.5 320.5 408.91 311.5 407.13 311.5 395.5 320.5 397.5"
            />
            <polygon
              class="cls-141"
              points="320.5 408.91 320.5 434.5 311.5 433.5 311.5 407.13 320.5 408.91"
            />
            <polygon
              class="cls-150"
              points="253.5 386.5 253.5 393.5 275.5 398.5 275.5 391.5 253.5 386.5"
            />
            <polygon
              class="cls-151"
              points="253.5 399.5 275.5 402.5 275.5 428.5 253.5 424.5 253.5 399.5"
            />
            <polygon
              class="cls-152"
              points="287.5 393.5 287.5 401.5 301.5 403.5 301.5 396.5 287.5 393.5"
            />
            <polygon
              class="cls-153"
              points="287.5 406.5 301.5 408.5 301.5 431.5 287.5 430.5 287.5 406.5"
            />
            <polygon
              class="cls-154"
              points="313.5 398.5 313.5 405.5 320.5 406.96 320.5 400.28 313.5 398.5"
            />
            <polygon
              class="cls-155"
              points="313.5 409.5 320.5 410.75 320.5 433.21 313.5 432.5 313.5 409.5"
            />
            <polygon
              class="cls-141"
              points="250.5 453.5 278.5 454.5 278.5 496.5 250.5 498.5 250.5 453.5"
            />
            <polygon
              class="cls-141"
              points="280.5 454.5 280.5 498.5 310.5 495.5 310.5 456.5 280.5 454.5"
            />
            <polygon
              class="cls-141"
              points="312.5 456.5 321.5 456.5 321.5 496.5 312.5 497.5 312.5 456.5"
            />
            <polygon
              class="cls-156"
              points="256.5 456.5 256.5 463.5 271.5 463.5 271.5 457.5 256.5 456.5"
            />
            <rect class="cls-157" x="256.5" y="465.5" width="15" height="4" />
            <polygon
              class="cls-158"
              points="256.5 472.5 271.5 472.5 271.5 494.5 256.5 495.5 256.5 472.5"
            />
            <rect class="cls-159" x="288.5" y="457.5" width="14" height="8" />
            <polygon
              class="cls-160"
              points="288.5 470.5 302.5 469.5 302.5 493.5 288.5 494.5 288.5 470.5"
            />
            <rect class="cls-161" x="314.5" y="458.5" width="7" height="8" />
            <polygon
              class="cls-162"
              points="314.5 469.5 321.5 469.5 321.5 494.83 314.5 495.5 314.5 469.5"
            />
            <path class="cls-140" d="M319.91,382.5c-.27.16-.41.33-.41.5v-.5Z" />
            <path
              class="cls-163"
              d="M388.31,500v31.5l-30.81,4V500.1h.32c-.21,0-.32-.06-.32-.1,0-.28,6.94-.5,15.5-.5S388.31,499.72,388.31,500Z"
            />
            <path
              class="cls-164"
              d="M361.45,535l-41.95,5.85V383c0-.17.14-.34.41-.5,1.86-1.14,9.92-2,19.59-2s17.93.86,19.8,2h0Z"
            />
            <polygon
              class="cls-163"
              points="22.63 337.34 22.63 359.4 1.5 357.08 1.5 333.5 22.63 337.34"
            />
            <polygon
              class="cls-137"
              points="107.5 332.5 107.5 356.5 23.5 359.5 22.63 359.4 22.63 337.34 23.5 337.5 107.5 332.5"
            />
            <polygon
              class="cls-165"
              points="340.5 381.5 340.5 395.5 251.13 380.54 251.13 362.7 340.5 381.5"
            />
            <line
              class="cls-140"
              x1="212.98"
              y1="374.27"
              x2="212.98"
              y2="374.16"
            />
            <path class="cls-164" d="M251.5,357.5s-41-6-55,0V557.42l55-7.8Z" />
            <path class="cls-166" d="M200.5,349.5s-27-6-50,0V563.89l52-7.39Z" />
            <rect
              class="cls-167"
              x="286.5"
              y="504.47"
              width="15"
              height="2.62"
            />
            <polygon
              class="cls-163"
              points="212.98 354.68 212.98 374.16 200.95 372.14 200.95 352.15 212.98 354.68"
            />
            <polygon
              class="cls-163"
              points="177.48 347.22 177.48 368.21 107.5 356.5 107.5 332.5 177.48 347.22"
            />
            <polygon
              class="cls-138"
              points="381.37 532.4 362.76 534.82 261.5 534.5 261.5 548.61 251.5 549.5 251.5 509.09 282.5 509.5 282.5 503.5 286.5 503.5 286.5 518.5 291.5 518.5 291.5 522.5 296.5 522.5 296.5 526.5 300.5 526.5 300.5 531.5 380.57 532.39 381.37 532.4"
            />
            <polygon
              class="cls-138"
              points="306.5 503.5 306.5 512.57 286.5 512.57 286.5 509.13 301.5 509.13 301.5 503.5 306.5 503.5"
            />
            <polygon
              class="cls-168"
              points="306.5 512.57 306.5 516.5 291.5 518.77 291.5 518.5 286.5 518.5 286.5 512.57 306.5 512.57"
            />
            <polygon
              class="cls-168"
              points="311.89 520.5 296.5 522.5 291.5 522.5 291.5 518.77 306.5 516.5 311.5 516.5 311.5 520.5 311.89 520.5"
            />
            <polygon
              class="cls-168"
              points="316.5 520.5 316.5 524.5 300.5 526.5 296.5 526.5 296.5 522.5 311.89 520.5 316.5 520.5"
            />
            <polygon
              class="cls-168"
              points="323.77 527.5 300.5 531.5 300.5 526.5 316.5 524.5 323.5 524.5 323.5 527.5 323.77 527.5"
            />
            <polygon
              class="cls-128"
              points="415.5 527.5 380.57 532.39 300.5 531.5 323.77 527.5 415.5 527.5"
            />
            <polygon
              class="cls-169"
              points="306.5 512.5 286.5 514.62 286.5 512.5 306.5 512.5"
            />
            <polygon
              class="cls-167"
              points="251.5 503.5 282.5 504.21 282.5 506.64 251.5 506.64 251.5 503.5"
            />
            <polygon
              class="cls-170"
              points="43.6 529.94 90.5 526.5 90.5 571.44 43.6 577.79 43.6 529.94"
            />
            <path
              class="cls-136"
              d="M72.5,533.5c0,.17-.14.34-.42.5-2.26,1.36-13.46,2.5-29,3.08v-7.16C60.52,530.57,72.5,531.93,72.5,533.5Z"
            />
            <path
              class="cls-171"
              d="M72.5,534v39.69l-71,9.81V537.26c5.61.16,11.67.24,18,.24,8.48,0,16.49-.15,23.59-.42,15.53-.58,26.73-1.72,29-3.08Z"
            />
            <polygon
              class="cls-137"
              points="261.5 548.5 261.5 534.5 365.22 534.5 261.5 548.5"
            />
            <polygon
              class="cls-172"
              points="254 366 254 375.5 334 390 334 383 254 366"
            />
          </g>
          <g id="biblioteca">
            <polygon
              class="cls-173"
              points="835.5 428.5 863.5 418.5 863.5 428.1 863.5 430.5 835.5 430.5 835.5 428.5"
            />
            <polygon
              class="cls-174"
              points="835.5 428.62 1003.37 425.5 1003.37 492.49 835.5 492.49 835.5 428.62"
            />
            <polygon points="1003.37 492.49 930.5 492.49 930.5 434.5 1003.37 436.5 1003.37 492.49" />
            <polygon
              class="cls-175"
              points="949.81 439.03 949.81 442.5 930.5 442.23 930.5 438.5 949.81 439.03"
            />
            <polygon
              class="cls-175"
              points="949.81 442.5 949.81 486.5 930.5 486.5 930.5 442.23 949.81 442.5"
            />
            <polygon
              class="cls-175"
              points="969.47 439.57 969.47 442.78 949.81 442.5 949.81 439.03 969.47 439.57"
            />
            <polygon
              class="cls-175"
              points="973.47 439.68 973.47 442.84 969.47 442.78 969.47 439.57 973.47 439.68"
            />
            <polygon
              class="cls-176"
              points="973.47 442.84 973.47 486.5 969.47 486.5 969.47 442.78 973.47 442.84"
            />
            <polygon
              class="cls-175"
              points="981.9 439.91 981.9 442.96 973.47 442.84 973.47 439.68 981.9 439.91"
            />
            <polygon
              class="cls-175"
              points="1003.37 440.5 1003.37 443.26 981.9 442.96 981.9 439.91 1003.37 440.5"
            />
            <polygon
              class="cls-177"
              points="1003.37 443.26 1003.37 486.5 981.9 486.5 981.9 442.96 1003.37 443.26"
            />
            <rect
              class="cls-178"
              x="930.5"
              y="486.5"
              width="72.87"
              height="5.99"
            />
            <polygon
              class="cls-179"
              points="969.47 442.78 969.47 486.5 949.81 486.5 949.81 442.5 969.47 442.78"
            />
            <polygon
              class="cls-180"
              points="1003.37 486.5 1003.37 492.5 957.04 492.5 957.03 492.49 951.5 486.5 1003.37 486.5"
            />
            <polygon
              class="cls-181"
              points="957.04 492.5 930.5 492.5 930.5 486.5 951.5 486.5 957.03 492.49 957.04 492.5"
            />
            <polygon
              class="cls-179"
              points="981.9 442.96 981.9 486.5 973.47 486.5 973.47 442.84 981.9 442.96"
            />
            <rect x="932.5" y="438.5" width="3" height="54" />
            <polygon
              class="cls-182"
              points="907.5 422.5 907.5 434.5 1003.5 436.5 1003.5 425.5 907.5 422.5"
            />
            <polygon
              class="cls-183"
              points="863.5 418.5 1003.5 421.5 1003.5 429.5 863.5 425.5 863.5 418.5"
            />
            <path
              class="cls-184"
              d="M842.57,492.5l.47-66.69s33.4-3.68,66.43,1V492.5Z"
            />
            <polygon
              class="cls-185"
              points="998.5 206.5 1103.5 138.5 1103.5 497.5 998.5 495.5 998.5 206.5"
            />
            <line
              class="cls-186"
              x1="1020.6"
              y1="97.67"
              x2="1020.59"
              y2="96.71"
            />
            <line
              class="cls-186"
              x1="1022.78"
              y1="92.84"
              x2="1022.78"
              y2="92.82"
            />
            <line
              class="cls-186"
              x1="1027.5"
              y1="90.93"
              x2="1027.5"
              y2="90.5"
            />
            <line
              class="cls-186"
              x1="1030.5"
              y1="91.04"
              x2="1030.5"
              y2="90.05"
            />
            <polygon
              class="cls-187"
              points="993.5 205.5 991.79 495.31 988.5 495.23 990.5 207.5 993.5 205.5"
            />
            <polygon
              class="cls-187"
              points="993.5 205.5 990.5 207.5 975.5 192.5 979.5 192.5 993.5 205.5"
            />
            <path
              class="cls-188"
              d="M980.5,110.5c12.6-25.2,18,4,18,4v19h-23S978.5,114.5,980.5,110.5Z"
            />
            <polygon
              class="cls-187"
              points="979.5 131.5 979.5 192.5 975.5 192.5 975.5 133.5 979.5 131.5"
            />
            <polygon
              class="cls-189"
              points="991.79 495.31 993.5 205.5 979.5 192.5 979.5 131.5 1000.5 133.5 1000.5 207.5 1000.57 495.54 991.79 495.31"
            />
            <polygon
              class="cls-190"
              points="1003.75 205.55 1000.5 207.5 994.5 200.5 994.5 121.5 998.32 115.85 998.5 199.5 1003.75 205.55"
            />
            <polygon
              class="cls-190"
              points="1007.48 203.31 1003.75 205.55 998.5 199.5 998.32 115.85 1001.5 114.67 1001.5 197.5 1007.48 203.31"
            />
            <polygon
              class="cls-190"
              points="1010.38 201.57 1007.48 203.31 1001.5 197.5 1001.5 114.67 1004.5 113.57 1004.5 195.5 1010.38 201.57"
            />
            <polygon
              class="cls-190"
              points="1013.61 199.63 1010.38 201.57 1004.5 195.5 1004.5 113.57 1007.5 112.46 1007.5 193.5 1013.61 199.63"
            />
            <polygon
              class="cls-190"
              points="1015.5 109.5 1015.5 198.5 1013.61 199.63 1007.5 193.5 1007.5 112.46 1015.5 109.5"
            />
            <polygon
              class="cls-187"
              points="1015.5 191.43 1015.5 191.5 1011.5 192.5 998.52 179.49 1001.5 177.5 1001.5 177.93 1015.5 191.43"
            />
            <polygon
              class="cls-187"
              points="1001.5 113.5 1001.5 177.5 998.52 179.49 998.46 179.43 998.5 114.5 1001.5 113.5"
            />
            <path
              class="cls-188"
              d="M1023.5,116.5,1000.05,113s2.45-32.46,15.45-35.46c0,0,8-2,10,16C1025.5,93.5,1024.5,113.5,1023.5,116.5Z"
            />
            <polygon
              class="cls-187"
              points="1015.5 191.5 1011.43 495.75 1008.86 495.7 1011.5 192.5 1015.5 191.5"
            />
            <polygon
              class="cls-189"
              points="1022.5 113.5 1022.5 210.5 1020.72 495.92 1011.43 495.75 1015.5 191.43 1001.5 177.93 1001.5 113.5 1022.5 113.5"
            />
            <polygon
              class="cls-190"
              points="1027.59 189.92 1023.5 192.5 1017.5 185.5 1017.5 106.5 1020 99 1020.6 97.67 1021.5 184.5 1027.59 189.92"
            />
            <polygon
              class="cls-190"
              points="1030.82 187.88 1027.59 189.92 1021.5 184.5 1020.6 97.67 1022.78 92.84 1024.5 181.5 1030.82 187.88"
            />
            <polygon
              class="cls-190"
              points="1033.7 186.06 1030.82 187.88 1024.5 181.5 1022.78 92.84 1023.71 90.78 1027.5 90.93 1027.5 179.5 1033.7 186.06"
            />
            <polygon
              class="cls-190"
              points="1037.52 183.65 1033.7 186.06 1027.5 179.5 1027.5 90.93 1030.5 91.04 1030.5 177.5 1037.52 183.65"
            />
            <polygon
              class="cls-190"
              points="1040.69 181.64 1037.52 183.65 1030.5 177.5 1030.5 91.04 1034.5 91.19 1034.5 175.5 1040.69 181.64"
            />
            <polygon
              class="cls-190"
              points="1042.5 91.5 1042.5 180.5 1040.69 181.64 1034.5 175.5 1034.5 91.19 1042.5 91.5"
            />
            <polygon
              class="cls-187"
              points="1043.5 174.5 1042.79 496.34 1037.86 496.25 1040.5 175.5 1043.5 174.5"
            />
            <polygon
              class="cls-187"
              points="1043.5 174.5 1040.5 175.5 1024.5 158.9 1027.55 157.07 1043.5 174.5"
            />
            <path
              class="cls-188"
              d="M1050.5,94.5l-23-4s3-37,18-38C1045.5,52.5,1062.5,58.5,1050.5,94.5Z"
            />
            <polygon
              class="cls-187"
              points="1027.5 157.01 1027.55 157.07 1024.5 158.9 1024.05 158.44 1024.5 92.5 1027.5 90.5 1027.59 90.51 1027.5 157.01"
            />
            <polygon
              class="cls-189"
              points="1053.5 94.5 1053.5 186.5 1051 496.5 1042.79 496.34 1043.5 174.5 1027.5 157.01 1027.59 90.51 1053.5 94.5"
            />
            <polygon
              class="cls-190"
              points="1072.5 73.5 1072.5 162.5 1071.15 163.27 1063.5 157.5 1063.5 70.16 1072.5 73.5"
            />
            <polygon
              class="cls-190"
              points="1071.15 163.27 1066.55 165.9 1059.5 158.5 1059.5 68.67 1063.5 70.16 1063.5 157.5 1071.15 163.27"
            />
            <polygon
              class="cls-190"
              points="1066.55 165.9 1062.54 168.19 1055.5 161.5 1055.5 67.19 1059.5 68.67 1059.5 158.5 1066.55 165.9"
            />
            <polygon
              class="cls-190"
              points="1062.54 168.19 1058.5 170.5 1051.5 163.5 1051.5 66.25 1051.71 65.78 1055.5 67.19 1055.5 161.5 1062.54 168.19"
            />
            <polygon
              class="cls-190"
              points="1058.5 170.5 1055.39 172.28 1048.5 166.5 1048.5 72.89 1051.5 66.25 1051.5 163.5 1058.5 170.5"
            />
            <polygon
              class="cls-190"
              points="1055.39 172.28 1051.5 174.5 1044.5 167.5 1044.5 88.5 1048 74 1048.5 72.89 1048.5 166.5 1055.39 172.28"
            />
            <path
              class="cls-188"
              d="M1083.5,71.5l-26-6s2-37,20-41C1077.5,24.5,1097.5,27.5,1083.5,71.5Z"
            />
            <polygon
              class="cls-187"
              points="1074.5 154.5 1074.5 497.12 1068.29 496.83 1070.5 156.9 1074.5 154.5"
            />
            <polygon
              class="cls-187"
              points="1070.5 156.9 1070.5 156.5 1053.51 138.5 1057.5 137.34 1057.5 138.5 1074.5 154.5 1070.5 156.9"
            />
            <polygon
              class="cls-187"
              points="1057.5 65.5 1057.5 137.34 1053.51 138.5 1053.5 138.5 1053.5 67.19 1057.5 65.5"
            />
            <polygon
              class="cls-189"
              points="1082.5 364.5 1082.5 497.5 1074.5 497.12 1074.5 154.5 1057.5 138.5 1057.5 65.5 1081.5 68.5 1082.5 364.5"
            />
            <polygon
              class="cls-190"
              points="1104.5 53.5 1104.5 142.5 1103.15 143.27 1095.5 137.5 1095.5 45.16 1104.5 53.5"
            />
            <polygon
              class="cls-190"
              points="1103.15 143.27 1098.55 145.9 1091.5 138.5 1091.5 43.67 1095.5 45.16 1095.5 137.5 1103.15 143.27"
            />
            <polygon
              class="cls-190"
              points="1098.55 145.9 1094.54 148.19 1087.5 141.5 1087.5 40.19 1091.5 43.67 1091.5 138.5 1098.55 145.9"
            />
            <polygon
              class="cls-190"
              points="1094.54 148.19 1090.5 150.5 1083.5 143.5 1083.5 43.25 1083.71 42.78 1087.5 40.19 1087.5 141.5 1094.54 148.19"
            />
            <polygon
              class="cls-190"
              points="1090.5 150.5 1087.39 152.28 1080.5 146.5 1080.5 48.89 1083.5 43.25 1083.5 143.5 1090.5 150.5"
            />
            <polygon
              class="cls-190"
              points="1087.39 152.28 1083.5 154.5 1076.5 147.5 1076.5 63.5 1080 50 1080.5 48.89 1080.5 146.5 1087.39 152.28"
            />
            <path class="cls-191" d="M994.5,98.5l10,2-5,14h-1s-2-13-6-16Z" />
            <path class="cls-191" d="M1029.5,77.5l-3,13h-1s-2-12-7-14Z" />
            <path class="cls-191" d="M1061.5,52.5l-5,13h-1s-3-13-9-14Z" />
            <path
              class="cls-192"
              d="M1325.5,82.5l29,5s-2-16-14-20l-256-44-7-1s12,5,12,21Z"
            />
            <path
              class="cls-193"
              d="M1087.5,42.5l2-.23s1-20.77-15-18.77c0,0-13.38.79-17.19,39.89l-2.21.61s-6.6-26.5-19.6-6.5a69.49,69.49,0,0,0-8.6,31.27l-1.71.2S1021.5,68.5,1010.5,77.5c0,0-9.61,12.9-10.31,34l-2,1.32S992.5,84.5,981.5,103.5c0,0-6,16-7,30h2s2-24.22,10.51-32.11c0,0,6.5-6.89,11.5,13.11l2.66-1.38s5.34-35.62,15.34-33.62c0,0,5,1,8,13l3.35-1.94s4.65-24.06,9.65-30.06,9-10,16,5l5-1s11-49,23-35A24.06,24.06,0,0,1,1087.5,42.5Z"
            />
            <polygon
              class="cls-187"
              points="1107.5 134.5 1105.5 497.5 1098.43 497.5 1102.5 137.84 1107.5 134.5"
            />
            <polygon
              class="cls-187"
              points="1102.5 137.84 1102.5 137.5 1083.68 117.47 1089.5 116.5 1107.5 134.5 1102.5 137.84"
            />
            <polygon
              class="cls-187"
              points="1089.5 41.28 1089.5 116.5 1083.68 117.47 1083.5 117.28 1084.5 45.16 1089.5 41.28"
            />
            <polygon
              class="cls-189"
              points="1116.5 45.5 1116.5 497.5 1105.5 497.5 1107.5 134.5 1089.5 116.5 1089.5 41.28 1090.5 40.5 1116.5 45.5"
            />
            <polygon
              class="cls-189"
              points="1355.5 154.5 1339.5 167.5 1341.5 497.5 1332.02 497.45 1332.02 82.47 1355.5 86.5 1355.5 154.5"
            />
            <polygon
              class="cls-189"
              points="1332.02 82.47 1332.02 497.45 1116.5 496.34 1116.5 45.5 1332.02 82.47"
            />
            <polygon
              class="cls-194"
              points="1140.5 151.5 1140.5 206.5 1137.5 206 1137.5 153.5 1128.5 152.79 1128.5 150.5 1140.5 151.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 153.5 1137.5 177.5 1128.5 175.93 1128.5 152.79 1137.5 153.5"
            />
            <polygon
              class="cls-196"
              points="1137.5 177.5 1137.5 179.93 1128.5 178.5 1128.5 175.93 1137.5 177.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 179.93 1137.5 206 1128.5 204.5 1128.5 178.5 1137.5 179.93"
            />
            <polygon
              class="cls-194"
              points="1140.5 223.5 1140.5 278.5 1137.5 278 1137.5 225.5 1128.5 224.79 1128.5 222.5 1140.5 223.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 225.5 1137.5 249.5 1128.5 247.93 1128.5 224.79 1137.5 225.5"
            />
            <polygon
              class="cls-196"
              points="1137.5 249.5 1137.5 251.93 1128.5 250.5 1128.5 247.93 1137.5 249.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 251.93 1137.5 278 1128.5 276.5 1128.5 250.5 1137.5 251.93"
            />
            <polygon
              class="cls-194"
              points="1140.5 305.5 1140.5 360.5 1137.5 360 1137.5 307.5 1128.5 306.79 1128.5 304.5 1140.5 305.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 307.5 1137.5 331.5 1128.5 329.93 1128.5 306.79 1137.5 307.5"
            />
            <polygon
              class="cls-196"
              points="1137.5 331.5 1137.5 333.93 1128.5 332.5 1128.5 329.93 1137.5 331.5"
            />
            <polygon
              class="cls-195"
              points="1137.5 333.93 1137.5 360 1128.5 358.5 1128.5 332.5 1137.5 333.93"
            />
            <line
              class="cls-197"
              x1="998.52"
              y1="179.49"
              x2="998.5"
              y2="179.5"
            />
            <line
              class="cls-197"
              x1="1083.68"
              y1="117.47"
              x2="1083.5"
              y2="117.5"
            />
            <line
              class="cls-198"
              x1="1074.5"
              y1="497.29"
              x2="1074.5"
              y2="497.12"
            />
            <line
              class="cls-198"
              x1="1332.02"
              y1="497.5"
              x2="1332.02"
              y2="497.45"
            />
            <path
              class="cls-184"
              d="M1041.5,382.5s5-4,50-4h22.86a2.14,2.14,0,0,1,2.14,2.14V497.5l-75-.72Z"
            />
            <polygon
              class="cls-199"
              points="1136.5 395.5 1136.48 397.86 1113.53 402.07 1113.5 399.5 1136.5 395.5"
            />
            <polygon
              class="cls-200"
              points="1136.48 397.86 1135.5 498.5 1114.5 498.5 1113.53 402.07 1136.48 397.86"
            />
            <rect class="cls-201" x="1119.5" y="482" width="11" height="4.5" />
            <polygon
              class="cls-202"
              points="1121.75 482 1119.5 482 1119.5 406.5 1121.64 406.31 1121.75 482"
            />
            <polygon
              class="cls-203"
              points="1128.26 410.37 1127.75 482 1121.75 482 1121.65 410.7 1128.26 410.37"
            />
            <polygon
              class="cls-201"
              points="1128.29 405.7 1128.26 410.32 1128.26 410.37 1121.65 410.7 1121.64 406.31 1128.29 405.7"
            />
            <polygon
              class="cls-202"
              points="1130.5 405.5 1130.5 482 1127.75 482 1128.26 410.32 1128.29 405.7 1130.5 405.5"
            />
            <polygon
              class="cls-200"
              points="1280.5 376.5 1289.5 374.5 1289.5 501.5 1280.5 501.5 1280.5 376.5"
            />
            <polygon
              class="cls-199"
              points="1255.5 377.5 1290.5 370.5 1290.5 375.5 1275.5 378.5 1255.5 377.5"
            />
            <polygon
              class="cls-204"
              points="1100.5 386.5 1100.5 401.5 1150.5 393.5 1150.5 377.5 1100.5 386.5"
            />
            <path
              class="cls-205"
              d="M1149.5,394.5s-10-3-15,1l-1.07,103h16.07Z"
            />
            <path
              class="cls-184"
              d="M1145.5,360.5s-8-9,65-9l40.56,1.89a2.56,2.56,0,0,1,2.44,2.56V500.7l-108.26-2.2Z"
            />
            <polygon
              class="cls-204"
              points="1238.5 361.5 1238.5 380.5 1298.5 369.5 1298.5 351.5 1238.5 361.5"
            />
            <path
              class="cls-206"
              d="M1248.5,376.5s21.76-2,35.38,0l-.24,125-35.14-1Z"
            />
            <path
              class="cls-207"
              d="M1297.5,369.5s-8.46-3.31-11.23,1.85l-.06,130.15h11.29Z"
            />
            <path
              class="cls-184"
              d="M1367.5,322.5s-34-1-59,3c0,0-14,3-15,7v169h73Z"
            />
          </g>
          <g id="arbustos">
            <path
              class="cls-208"
              d="M685.12,489.39h0a1.46,1.46,0,0,1,.51,0c.16,0,.24.1.21.2s0,0,0,0,.07.12,0,.17a.13.13,0,0,1-.14,0s.08.09-.05.1-.27-.06-.39,0-.13.07-.2.11a.29.29,0,0,1-.1,0c-.11,0-.22,0-.22.1s-.12,0-.17.06c-.2.07-.2.07-.25-.06a.21.21,0,0,1,.11-.12l0,0s.13,0,.11-.09a.12.12,0,0,0-.09,0c-.11,0-.11.06-.1.1s0,.09-.1.09a.12.12,0,0,1-.13-.08s0-.08-.06-.11c-.08.12,0,.18.18.27a.82.82,0,0,0,.22.18l0,0c-.06,0-.15,0-.14.07s.09.06.15.07.09,0,.09.05.18.13.33.15c.47.07,1,.09,1.4.2a15.43,15.43,0,0,0,2.48.28c1.28.08,2.58.08,3.87.08A17.41,17.41,0,0,0,695,491c.4-.07.81-.1,1.21-.16h.07a3.68,3.68,0,0,1,.58-.06h.08c.8-.07,1.59,0,2.39,0h.19a2.16,2.16,0,0,0,1.35-.3l.13-.07a1.82,1.82,0,0,1,.75-.13s.11.07.16,0h.25l.07,0a.28.28,0,0,0,.22,0,.58.58,0,0,1,.39,0,.92.92,0,0,0,.33,0c.77,0,1.54,0,2.31,0,0-.08-.1-.09-.16-.1-.3-.06-.59-.14-.9-.18-.12,0-.24,0-.22-.15a.38.38,0,0,1-.38.05s0,0,0,0c-.17.09-.24,0-.34-.06a4,4,0,0,0-.62-.12c-.06,0-.15,0-.19-.06s0-.05,0-.07l.14-.07a.46.46,0,0,1,.47,0h0a2.2,2.2,0,0,0,.37.06h0a1.76,1.76,0,0,1,.41.11c.17,0,.32.1.5,0,0,0,0,0,0,0,0,.16.28.13.43.18s.39.08.57.13l1.56.38c.11,0,.3.07.27.16s-.22.11-.35.11c-.79,0-1.58,0-2.37,0a14.74,14.74,0,0,0-1.88,0,2.54,2.54,0,0,0-1.32.5,1.88,1.88,0,0,1-1.17.32l-2.17-.06a14.8,14.8,0,0,0-2.91.27,19.26,19.26,0,0,1-3.82.37c-.82,0-1.64,0-2.46,0a39,39,0,0,1-4.07-.36.43.43,0,0,1-.17,0,8.87,8.87,0,0,0-2.11-.41c-.46-.07-.72-.33-.62-.65s.36-.43.78-.49a6.46,6.46,0,0,0,1.58-.47,4,4,0,0,1,.41-.12c.15,0,.26,0,.31.1s0,.07.11.06S685,489.47,685.12,489.39Z"
            />
            <path
              class="cls-209"
              d="M702.66,489.58l0,.06a.37.37,0,0,1-.15,0h-.13c-.18,0-.29-.05-.33-.16,0,.09,0,.09-.14.12h-.27l-.05,0a.46.46,0,0,1-.14-.07c-.07-.07-.22-.11-.25-.2a.08.08,0,0,0-.1,0,.07.07,0,0,0-.08.06,1.39,1.39,0,0,1-.06.13l0,0c-.11,0,0,.15-.21.15s-.07-.1-.13-.15-.1,0-.17,0h-.15a2.18,2.18,0,0,0-.7-.14s0,.09,0,.11a.18.18,0,0,1-.21,0s0,0,0,0-.25.05-.38,0h0l-.08,0c-.18-.07-.19-.07-.32.07h-.06a.82.82,0,0,1-.22,0l0,0c0-.05,0-.1-.08-.13a.27.27,0,0,0-.25,0,.22.22,0,0,1-.27,0c0-.06,0-.1.07-.14a2.88,2.88,0,0,1,.78-.11,16.79,16.79,0,0,1,2.13.06c.61.06,1.2.14,1.79.24C702.32,489.44,702.47,489.52,702.66,489.58Z"
            />
            <path
              class="cls-210"
              d="M689.17,489.47c0-.15.06-.19.31-.15l.58.07a.11.11,0,0,0,.09,0,.34.34,0,0,1,.11-.05c.23,0,.45.07.69.07.08,0,0,.07.07.09s0,.17-.26.15a1,1,0,0,0-.47.05.43.43,0,0,1-.31-.09c-.05,0-.06,0-.08,0s-.29,0-.31.14a.12.12,0,0,1-.12.07.17.17,0,0,1-.16-.06.35.35,0,0,1,0-.08c0-.08.14-.06.21-.1-.15.05-.25,0-.29-.07A0,0,0,0,0,689.17,489.47Z"
            />
            <path
              class="cls-211"
              d="M695.58,489.34c0-.07-.05-.11-.18-.13l.13,0c.24.09.55,0,.77.14s.08,0,.08.17a.16.16,0,0,1-.22,0c0-.05,0-.12-.14-.14a.16.16,0,0,0,.05.14c0,.05.14.1,0,.16a.4.4,0,0,1-.32,0,.36.36,0,0,1-.12-.08,1.49,1.49,0,0,0-.7.06.25.25,0,0,1-.21-.09.27.27,0,0,1-.07-.14s-.05,0,0,0h0s0,.05,0,.05-.08,0,0-.05-.15-.11,0-.15a.32.32,0,0,1,.31.06.29.29,0,0,0,.24,0,.38.38,0,0,1,.46,0l.1,0Z"
            />
            <path
              class="cls-212"
              d="M692.42,489.39c.1,0,0,.1.14.11s.26.05.28.15.07.05.12.07.12.08.06.13-.12,0-.18,0a.61.61,0,0,0-.13,0s-.05-.08-.08,0a.07.07,0,0,1-.09,0c-.06-.05-.14,0-.2,0a1.11,1.11,0,0,0-.16-.11.62.62,0,0,0,.17.11c.18.08.11.15,0,.22s-.05,0-.07,0a1.24,1.24,0,0,1-.42-.29c0,.06-.12.07-.21.1-.3.05-.13-.09-.16-.15s0-.15.1-.19,0,.05.1,0a.45.45,0,0,0,.28,0,.44.44,0,0,1-.2-.05c0-.05,0-.07.1-.08s.2,0,.23-.07.07,0,.11,0,0,0,0,0-.08.05,0,.09,0,0,.07,0,.12.09.24.07C692.4,489.49,692.28,489.45,692.42,489.39Z"
            />
            <path
              class="cls-213"
              d="M688.09,489.39a.49.49,0,0,1,.27,0s.06,0,.08,0,.11,0,.15,0,.11.05.12.1-.1.07-.18.06l-.09,0a.24.24,0,0,0-.12,0s0,0,.07,0a0,0,0,0,1,0,0s0,.05-.11.06-.15,0-.24,0-.24.07-.37.08l-.09,0-.11,0-.21-.18,0,0c-.09-.08,0-.1.1-.09s.19-.05.16.05,0,.05.07.06c.08-.17.17-.18.4-.07C688,489.34,688.06,489.38,688.09,489.39Z"
            />
            <path
              class="cls-214"
              d="M697,489.2a.78.78,0,0,1,.46-.06c0,.06-.1.15.09.18a.14.14,0,0,1,.07.06c0,.1,0,.2-.26.21a.1.1,0,0,1-.07,0s.08-.11-.08-.12c.09.1,0,.12-.15.14s-.24.11-.39,0a.16.16,0,0,1-.07-.07v0a.54.54,0,0,1,.13-.07.66.66,0,0,1-.15,0c-.13,0-.15-.06-.13-.12a.24.24,0,0,1,.19-.08A.38.38,0,0,0,697,489.2Z"
            />
            <path
              class="cls-215"
              d="M691.51,489.72c.06,0,0,0,0,.08s.05.06.12.05h0c.07.05.12.1.08.16s-.15,0-.23,0-.12-.15-.28-.16-.08.16-.21.2h-.12a.22.22,0,0,1-.15-.18c0-.08-.12-.1-.19-.16s-.09,0-.14,0-.23,0-.16-.07a.59.59,0,0,1,.51-.07c.18,0,.2-.05.23-.12s0,0,0,.07c.16,0,.12.15.26.18a.1.1,0,0,0,.13,0C691.52,489.78,691.47,489.71,691.51,489.72Z"
            />
            <path
              class="cls-216"
              d="M685.85,489.61c-.08-.06-.08-.06.15-.2-.32.1-.56-.07-.84,0a2.27,2.27,0,0,1,.69,0,2.83,2.83,0,0,0,.65,0s.07,0,.1,0,0,0,0,.06.07.11,0,.16a.22.22,0,0,1-.21,0c-.06,0-.11-.07-.19,0S686.07,489.71,685.85,489.61Z"
            />
            <path
              class="cls-217"
              d="M686.58,489.45s0,0,0-.06a.37.37,0,0,0,.23,0s0,0,.08,0,0,0,0,.06.12.11.15.17-.13-.06-.09-.12l.26-.08h0c0,.07.21.1.19.19a.67.67,0,0,1-.15.06c-.07,0-.06.11-.11.16s-.31-.05-.47-.05-.1,0-.08-.09S686.62,489.53,686.58,489.45Z"
            />
            <path
              class="cls-218"
              d="M702.66,489.58c-.34-.06-.42-.11-.37-.27a1.77,1.77,0,0,1,.46.07.48.48,0,0,0,.29,0c.14-.05.16,0,.21.09-.18,0-.36-.05-.47.08S702.7,489.57,702.66,489.58Z"
            />
            <path
              class="cls-219"
              d="M691.51,489.72s0,0,0,0-.08,0-.13,0-.22,0-.16-.09-.14-.05-.11-.11a1.35,1.35,0,0,1,.53,0C691.51,489.58,691.64,489.67,691.51,489.72Z"
            />
            <path
              class="cls-220"
              d="M693.48,489.47c.06,0,.11,0,.13-.05a.08.08,0,0,1,.11,0c-.07.09.08.12.13.17s0,.07,0,.1.09.06,0,.1a1.16,1.16,0,0,1-.32,0c-.06-.05,0-.11,0-.17a.1.1,0,0,1-.15,0s0,0,0-.06S693.39,489.49,693.48,489.47Z"
            />
            <path
              class="cls-221"
              d="M688.66,489.47l-.07-.08c.19-.09.31.06.48.06l.1,0h0c0,.12-.11.17-.29.13A1.26,1.26,0,0,1,688.66,489.47Z"
            />
            <path
              class="cls-222"
              d="M696.63,489.28l-.18.05c-.12,0-.08,0-.05-.08a.19.19,0,0,0,.09-.05s-.1-.1,0-.11.21,0,.25.07l0,0C696.83,489.3,696.81,489.31,696.63,489.28Z"
            />
            <path
              class="cls-223"
              d="M694,489.45a.44.44,0,0,1,.35-.13c.07,0,0,0,.07.05s0,.07,0,.12-.22,0-.33.05-.07,0-.09,0S694,489.48,694,489.45Z"
            />
            <path
              class="cls-224"
              d="M692.79,489.64c0-.1-.19-.07-.23-.14.13,0,.12-.08.22-.1a.57.57,0,0,1,.32,0s0,0,0,.07l0,0c-.06,0-.21,0-.14.08v0a.23.23,0,0,1-.11.07Z"
            />
            <path
              class="cls-225"
              d="M685.12,489.39a.27.27,0,0,0,.09.15s.1,0,.06.09a.13.13,0,0,1-.12,0c-.07,0-.17,0-.16-.08s-.1-.13-.24-.14A1.44,1.44,0,0,1,685.12,489.39Z"
            />
            <path
              class="cls-226"
              d="M693.71,489.48a.09.09,0,0,0-.1-.06c-.07,0-.13-.06-.07-.11s.2,0,.3,0,.14.12.12.2S693.76,489.56,693.71,489.48Z"
            />
            <path
              class="cls-227"
              d="M694.59,489.42c.06,0,.06,0,.1,0l.1.15s-.13,0,0,.06.06.05,0,.08a.28.28,0,0,1-.18,0,.11.11,0,0,1-.08-.06c-.06-.08-.14-.16-.07-.25A.2.2,0,0,1,694.59,489.42Z"
            />
            <path
              class="cls-228"
              d="M696.4,489.25s0,.06.05.08,0,.12.13.12,0,0,0,.05v0s0,.06-.09.06a.87.87,0,0,1-.14-.12c-.14,0,.06-.12-.05-.16S696.29,489.22,696.4,489.25Z"
            />
            <path
              class="cls-229"
              d="M691.77,489.51h.07c.06,0,.18,0,.21,0s-.07.06-.13.07-.19,0-.23,0Z"
            />
            <path
              class="cls-209"
              d="M697.49,489.34c-.22,0-.23,0-.08-.2h.08c.06.05,0,.11.08.15S697.56,489.35,697.49,489.34Z"
            />
            <path
              class="cls-230"
              d="M687,489.49c.08.06.19.12,0,.22,0-.06.05-.13-.14-.14s0-.08,0-.13Z"
            />
            <path
              class="cls-231"
              d="M692.42,489.39c-.07.06,0,.09.06.12s0,.05,0,.08-.12,0-.18,0-.08,0,0-.07,0-.06-.08-.06Z"
            />
            <path
              class="cls-211"
              d="M694.48,489.39c-.07.09.12.15.09.24a.17.17,0,0,1-.17,0,.08.08,0,0,1-.07,0c-.05-.06.08-.07.1-.11l0-.13Z"
            />
            <path
              class="cls-232"
              d="M693.48,489.47a.15.15,0,0,0-.06.11c-.15,0-.18-.08-.17-.16s0-.05.09-.06.1,0,.1,0S693.43,489.45,693.48,489.47Z"
            />
            <path
              class="cls-233"
              d="M694,489.5c-.17,0-.14-.12-.14-.19s.15.08.19.14l0,.05Z"
            />
            <path
              class="cls-234"
              d="M692.9,489.26s-.06.05-.11.05-.13,0-.13-.05,0-.05.1-.06A.17.17,0,0,1,692.9,489.26Z"
            />
            <path
              class="cls-218"
              d="M704,489.64a1.38,1.38,0,0,1-.41-.11C703.84,489.45,703.9,489.58,704,489.64Z"
            />
            <path
              class="cls-235"
              d="M696.63,489.28c.09,0,.19,0,.18-.08H697C696.84,489.34,696.75,489.36,696.63,489.28Z"
            />
            <path
              class="cls-236"
              d="M693.34,489.36l-.05.07a.19.19,0,0,1-.18,0v-.08C693.18,489.38,693.26,489.31,693.34,489.36Z"
            />
            <path
              class="cls-218"
              d="M703.62,489.53c-.12,0-.28.05-.37-.06A.9.9,0,0,1,703.62,489.53Z"
            />
            <path
              class="cls-237"
              d="M697.54,489.28c-.15,0,0-.09,0-.14l.1,0,0,.13v0Z"
            />
            <path
              class="cls-238"
              d="M691.8,489.33c.05,0,.1,0,.11,0s0,.05-.09,0-.09,0-.09,0S691.76,489.33,691.8,489.33Z"
            />
            <path
              class="cls-239"
              d="M688.09,489.39l-.1,0s0-.08.08-.11S688.07,489.35,688.09,489.39Z"
            />
            <path
              class="cls-240"
              d="M696.22,490.9l-1.84.23a9.5,9.5,0,0,1-1.31.09c-.85,0-1.71,0-2.56,0s-1.84-.06-2.75-.15l-.92-.09a3.13,3.13,0,0,1-.53-.12c-.45-.09-.93-.12-1.39-.18a.89.89,0,0,1-.3-.06c-.11,0-.18-.09,0-.16s0-.14-.05-.19a.35.35,0,0,1-.23-.17.07.07,0,0,1,.09,0l.07.14c0-.13.17-.14.3-.14h0c0-.07.19-.07.22-.14l.07,0a.21.21,0,0,1,.12,0s0,0,0,0,0-.06,0-.06.1,0,.1,0,.19.2.2.32-.06,0,0,.05h0s0-.05,0-.08-.08-.1,0-.16a.25.25,0,0,1,.17,0c.07,0,.07.06.09.1s.12.05.19.06.08.06.1,0,.22-.05.34,0a.28.28,0,0,1,.07.09.29.29,0,0,0,.37,0s0-.07.1,0,.12.17.17.26a.3.3,0,0,0,.19,0c.07,0,.11.05.19,0a.34.34,0,0,0,.25-.05s.12.05.11,0,0-.06.07-.06.06,0,.08.08a.93.93,0,0,0,0,.13.11.11,0,0,0,.1,0c.06,0,.05,0,.06-.06s-.05-.16.1-.16.07.1.07.15l0,0s0,0,0,0,0,0,0,0,.06-.06.12-.07l.2,0,0,0c.09,0,.09-.11.18-.09s.09.1.12.15-.14,0-.14.08.11,0,.16-.05a.69.69,0,0,1,.25,0l.15,0a.17.17,0,0,1,.1.08c0,.07,0,.1.15.1s-.12-.09-.1-.16l0,0c.06,0,.1-.08.18-.07s.07.08.09.13h0c0,.05-.06.13.08.13s.11-.07.14-.12l.05-.05a.16.16,0,0,1,.14.07.13.13,0,0,1,.13-.1.27.27,0,0,1,.12.06c.08,0,.21,0,.19.09s0-.06,0-.1a.11.11,0,0,1,.07-.09c.07,0,.09,0,.12.05s.24.06.21.14,0-.07.07-.1h0a.37.37,0,0,0,.26,0c.1,0,.18,0,.23,0s.17,0,.24,0a.42.42,0,0,1,.32.12c0-.06-.09-.11-.09-.18s0-.06,0-.07a.08.08,0,0,1,.08,0,.19.19,0,0,0,.24.05.18.18,0,0,1,.14,0,.48.48,0,0,0,.24,0,.32.32,0,0,1,.27,0s.06,0,.08,0a.2.2,0,0,1,.21,0c0-.06,0-.14.08-.19s.27.11.28.21,0,0,0,0h0a.11.11,0,0,1,0-.16.16.16,0,0,1,.1,0s0,.12.12,0l.06,0a.18.18,0,0,1,.15.06c-.05-.09.08-.07.14-.1a.17.17,0,0,1,.2.05.17.17,0,0,0,.2,0c.09,0,.2,0,.2-.11s0-.09.06-.1a.12.12,0,0,1,.14.08c0,.1.19.13.28.2s0-.1,0-.19a.2.2,0,0,0-.12-.16c-.11,0-.11-.11-.18-.16s-.08-.06-.15-.08-.07-.06,0-.08.18-.1.33,0c0-.09-.08-.14,0-.2a.08.08,0,0,1,.05-.05h.07s0,.11.15,0a.11.11,0,0,1,.17.06s-.06-.1,0-.14a.58.58,0,0,1,.19,0,.27.27,0,0,1,.23.22.09.09,0,0,0,0,.05c.09.14.08.14-.16.17,0,0,0,0,0,0h0q.08,0,.09,0s0,.06-.07.09a.42.42,0,0,1-.26.06l-.08-.09s0,0-.07,0a.18.18,0,0,1-.17,0,.92.92,0,0,1,.27.16c0-.05-.18-.09-.1-.18s.09.05.14.08a.23.23,0,0,1,.12.09c0,.09.08.1.2.09h.09c.06,0,.08.05.11.08a.23.23,0,0,0,.24,0c.16,0,.19,0,.16.09a2.51,2.51,0,0,0-.55.06.64.64,0,0,0-.11-.16C696.16,490.79,696.27,490.83,696.22,490.9Z"
            />
            <path
              class="cls-241"
              d="M701.75,490.32a2.77,2.77,0,0,0-.78.14c-.1,0-.12-.06-.1-.12s0-.09-.14-.1,0,.05,0,.07,0,.08-.11.1-.14,0-.16-.05-.13-.07-.19,0a.53.53,0,0,1-.19.17s-.05,0,0,.07a.2.2,0,0,0,.13,0,1.33,1.33,0,0,0,.32-.11.3.3,0,0,1,.36,0,2.42,2.42,0,0,1-.82.31,5.09,5.09,0,0,1-.55,0,.12.12,0,0,0-.19,0c-.82,0-1.64-.07-2.46,0,0,0,0,0,0,0,.2,0,.09-.14.14-.2a.37.37,0,0,1,.18,0s.06,0,.07,0-.1.08,0,.12a.22.22,0,0,0,.21,0,.22.22,0,0,0,.2-.13.67.67,0,0,1,.2,0s.1,0,.09.07-.06,0-.07.06,0,0,.06-.05,0-.12.15-.14,0,0,0,0,0-.08.06-.12-.17,0-.18.06,0,.1-.11.12h-.06a.13.13,0,0,1-.06-.07s0,0,0,0l0,0-.05,0c-.18,0-.39,0-.28-.19s-.12,0-.16-.08a.35.35,0,0,1-.1-.2c.07-.06.24,0,.29-.1h.05c.07.05.11.12.25.12l0,0s0,0,0,0a.3.3,0,0,1,0-.13.11.11,0,0,1,.13-.08c.08,0,.14,0,.14.13a.22.22,0,0,1,.17-.16h.06s.09.06,0,.08,0,.1,0,.15,0,.06,0,.08h0c0-.05,0-.07-.05-.11s0-.12.31-.08a1.73,1.73,0,0,1,.32,0c.16,0,.24.06.18.17s0,.12.13.14c-.12-.07-.17-.14,0-.2s.1,0,.14,0,.08,0,.08,0,0,0,0-.05,0-.18.19-.18.13.1.17.16.06.14.23.1.2-.07.28,0a.45.45,0,0,0,.28,0,1,1,0,0,0,.31-.06H701a.38.38,0,0,0,.17.06c.29,0,.39-.06.45-.18s.18-.12.34,0a.29.29,0,0,0,.26.09.11.11,0,0,1,.09,0c0,.05.12.06.16.1s0,.1-.08.1-.17.05-.26.05h0c-.12,0-.12,0-.09.05h-.08S701.81,490.34,701.75,490.32Z"
            />
            <path
              class="cls-242"
              d="M702.11,490.24c.08,0,.12-.09.24-.07s0-.05.08-.07-.15,0-.18-.09l0,0c-.05,0-.15,0-.14-.11s0,0,0,0c-.22-.07-.24-.09-.19-.25s.14,0,.16-.13a.32.32,0,0,0,.34.16s.08.09.13,0l.14,0a2.88,2.88,0,0,1,.51.1c.09,0,.1,0,.17-.07s0,.11.15.12.18,0,.11.11c.15,0,.08-.09.15-.11s0,0,.09.06.19.08.25,0,0-.05.1-.05.07,0,.07.07,0,.05.12.07a9.56,9.56,0,0,1,1.09.22c.06,0,.15,0,.14.08s-.1,0-.17.05l-.2,0h-2.07s0-.08,0-.12a.15.15,0,0,0-.12-.05.07.07,0,0,0-.08.06s0,.09-.12.09a.7.7,0,0,0-.36.05.27.27,0,0,0-.3,0l0,0S702.08,490.26,702.11,490.24Z"
            />
            <path
              class="cls-243"
              d="M700.88,490.52c-.24-.09-.37.05-.54.09l-.19.05a.2.2,0,0,1-.17-.05s0-.09,0-.1.19-.14.27-.22a.16.16,0,0,1,.14-.05c.05,0,.1,0,.08.05s0,.08.08.09a.13.13,0,0,0,.09,0c.05-.05,0-.09-.06-.12l0,0c.29,0,.33,0,.32.17s.06.05.07.08S700.93,490.51,700.88,490.52Z"
            />
            <path
              class="cls-244"
              d="M696.91,490.81l0,0h-.05s0-.12-.14,0-.3-.1-.21-.24,0,0,0,0-.06,0-.06,0,0,.1-.09.14l0,0a.32.32,0,0,1-.12-.11c0-.05,0-.11,0-.16l.09-.06a.72.72,0,0,0,.33,0,.15.15,0,0,1,.1,0c.06.09.15.17.13.27h.1c.07,0,.14,0,.17.05s0,.06-.08.08A.09.09,0,0,0,696.91,490.81Z"
            />
            <path
              class="cls-245"
              d="M685.53,490.1c0,.06.06.1,0,.16h0c-.07,0,0-.14-.2-.13s0,0,0-.05,0-.12-.11-.16.1.08.06.14l-.22-.12c0-.07.17-.05.19-.11s.3.08.42,0,0-.08.06-.11a.17.17,0,0,0,.11.09c.18.08.07.14-.05.2h-.11C685.51,490,685.46,490,685.53,490.1Z"
            />
            <path
              class="cls-246"
              d="M685.75,490c.11-.05.18-.11.09-.19v-.17c.07.06.21,0,.29.05s.06,0,.06-.08c.16,0,.17.09.21.15s-.09.07-.14.1a.88.88,0,0,0-.16,0c-.13,0,0,0,0,.07s-.19.06-.28.09S685.75,490,685.75,490Z"
            />
            <path
              class="cls-247"
              d="M684.38,490.08l-.09,0c-.19,0-.3-.15-.27-.27s0-.08.12-.08.11,0,.1.09,0,.05,0,.08,0,.07.08.07.06-.05.06-.08.09,0,.1.06Z"
            />
            <path
              class="cls-248"
              d="M684.52,490.27c.1,0,.17,0,.18.1s0,.08-.13.09h-.05c-.12,0-.26,0-.26-.1S684.41,490.27,684.52,490.27Z"
            />
            <path
              class="cls-249"
              d="M702.8,490.3s.08-.05.07-.08,0-.1.09-.12a.27.27,0,0,1,.24.1c.08.06,0,.09-.08.12S702.89,490.4,702.8,490.3Z"
            />
            <path
              class="cls-250"
              d="M684.48,490l-.1-.06c-.1-.08,0-.11.09-.13s.2,0,.22.07S684.61,490,684.48,490Z"
            />
            <path
              class="cls-251"
              d="M685.67,489.8s0,.1-.08.11a.54.54,0,0,1-.34-.08s0-.09.1-.07Z"
            />
            <path
              class="cls-252"
              d="M685,490c0,.05.1.13-.1.11s-.07.06-.14.11v-.24C684.81,490.05,684.93,489.88,685,490Z"
            />
            <path
              class="cls-253"
              d="M702.14,490.32c0-.06.06-.09.17-.09s.12.07.13.12A.27.27,0,0,1,702.14,490.32Z"
            />
            <path
              class="cls-254"
              d="M702.11,490.24v.06a.15.15,0,0,1-.13,0c0-.06-.21,0-.14-.08S702,490.21,702.11,490.24Z"
            />
            <path
              class="cls-255"
              d="M699.32,490.84c-.06,0,0-.09.07-.09s.18,0,.12.09Z"
            />
            <path
              class="cls-254"
              d="M701.75,490.32l.14,0s0,.1-.09.1S701.71,490.36,701.75,490.32Z"
            />
            <path
              class="cls-256"
              d="M696.22,490.9c0-.06-.1-.11-.09-.19s.13.12.13.19h0Z"
            />
            <path
              class="cls-257"
              d="M698.82,489.33s.1,0,.13,0,.1.09.21.07.05-.09.05-.15.09,0,.08.05.06.1.14.09,0-.06,0-.08,0-.07.13-.05a1.76,1.76,0,0,1,.62.14c.06.06,0,.14.1.19s0,.06-.07.07-.17,0-.19-.09a.31.31,0,0,0-.06-.13.37.37,0,0,0-.16.1c-.06,0-.13,0-.19,0s-.1-.06,0-.1,0,0,0,0a.09.09,0,0,0,0-.06s0,0,0,.05-.07.12-.21.09a.28.28,0,0,0-.36.07l0,0a.08.08,0,0,1-.07,0s0-.1-.13,0a.28.28,0,0,1-.22,0l-.05,0a.14.14,0,0,1,0-.1.36.36,0,0,1,0-.09l.05,0,.09,0s0,.05.08.05S698.76,489.36,698.82,489.33Z"
            />
            <path
              class="cls-258"
              d="M700.92,490c-.06.09-.19.08-.31.08s-.3-.12-.26-.32c0,0,.16,0,0-.07s-.07,0-.07-.06-.18-.1,0-.15a.53.53,0,0,1,.25,0c.07,0,.09,0,0,.08s0,.05,0,.06,0,.1.09.15.21.07.11.15,0,0,0,0h.07S700.94,490,700.92,490Z"
            />
            <path
              class="cls-259"
              d="M701.42,489.5c.07,0,.12,0,.14.06a.64.64,0,0,1,.08.14s.05.06,0,.08a.15.15,0,0,1-.15,0,.11.11,0,0,0-.09,0l-.1,0-.14,0a.43.43,0,0,1-.25-.13l-.1-.07s0-.07,0-.09l0,0a.21.21,0,0,1,.23,0C701.2,489.49,701.32,489.47,701.42,489.5Z"
            />
            <path
              class="cls-260"
              d="M701.37,489.69s.1-.06.14,0,0,.08.11.08-.13-.14-.06-.21h0a.29.29,0,0,1,.17.13c0-.05-.05-.09,0-.12l.09,0c0,.05.06.09,0,.15s0,.06,0,.08.11,0,.2-.05,0,.14.09.21-.06.14-.16,0-.11,0-.13-.06-.16-.14-.31-.06a.08.08,0,0,1-.08,0C701.44,489.8,701.36,489.76,701.37,489.69Z"
            />
            <path
              class="cls-261"
              d="M697.54,489.28v0a.18.18,0,0,0,.22,0c.18,0,.24.1.36.13h0a.32.32,0,0,1,0,.31H698c-.12,0-.19-.09-.32-.08a.07.07,0,0,1-.07-.07s.06-.06.12-.07.13,0,.11,0-.09,0-.14,0-.15,0-.2,0l0-.05S697.54,489.3,697.54,489.28Z"
            />
            <path
              class="cls-262"
              d="M701.42,489.5c-.12,0-.24.05-.32-.05s-.15,0-.22,0,0-.11,0-.17,0-.07.08-.07.15,0,.18,0a.42.42,0,0,0,.27.2S701.44,489.48,701.42,489.5Z"
            />
            <path
              class="cls-263"
              d="M700.93,489.6a.48.48,0,0,0,.23.14c0,.05.1.09.05.14a.76.76,0,0,1-.26,0,.62.62,0,0,0-.25-.09s-.1,0,0,0,0-.08,0-.11.09,0,.07-.05,0-.08.11-.09,0,0,0,.08S700.82,489.64,700.93,489.6Z"
            />
            <path
              class="cls-264"
              d="M698.09,489.66a.63.63,0,0,1,0-.3c.07,0,.16,0,.22,0a.19.19,0,0,1,0,.08s.08.08.06.13S698.23,489.67,698.09,489.66Z"
            />
            <path
              class="cls-265"
              d="M698.13,489.35c-.2,0-.19-.13-.36-.13.09-.1.24-.06.34,0S698.28,489.29,698.13,489.35Z"
            />
            <path
              class="cls-266"
              d="M700.33,489.5h0s0,0,0,0,.05.06,0,.09h0c-.26,0-.06-.13-.1-.2h.18C700.43,489.46,700.37,489.48,700.33,489.5Z"
            />
            <path
              class="cls-267"
              d="M698.82,489.33c-.06,0,.16.14-.08.14-.07,0,0-.07-.11-.08h-.08c0-.05,0-.09,0-.11a.18.18,0,0,1,.19,0Z"
            />
            <path
              class="cls-264"
              d="M698.78,489.31c-.17-.06-.21,0-.23.08h0a.15.15,0,0,1-.13,0c0-.07,0-.13.16-.15S698.75,489.24,698.78,489.31Z"
            />
            <path
              class="cls-259"
              d="M701.75,489.56s0,.06,0,.09.05.06,0,.08-.11,0-.1-.06-.06-.08-.1-.12Z"
            />
            <path
              class="cls-268"
              d="M698.42,489.39h.13s0,.06,0,.08a.11.11,0,0,1-.13,0s-.1,0,0-.07Z"
            />
            <path class="cls-269" d="M702.47,489.61l0,.15h0l-.08-.15Z" />
            <path class="cls-257" d="M700.33,489.5s0-.05,0-.08.18,0,.19.05Z" />
            <path
              class="cls-270"
              d="M689.32,490.76l-.23-.06,0,0c-.1,0-.11-.08-.1-.16-.07.07-.08.16-.23.12s-.15,0-.16-.05,0,0,.09-.06,0-.12,0-.18a.08.08,0,0,1,0-.05.23.23,0,0,1,.16-.1h.07s0,.06,0,.09,0,0,0,0,0,0,0,0,.07,0,.1,0,0,0,0,0,0,0,0-.07,0,0,0,0h-.09a.27.27,0,0,1-.13-.16c0-.08-.07-.09-.16-.09s-.06-.05,0-.09.12,0,0-.06-.16-.15-.17-.24h0s0-.05.06-.05l0,0c.1,0,.2,0,.24.12s.13,0,.19,0,.17-.06.18,0-.1.05,0,.07l.15,0,.07,0s0,.09.13.06.14-.07.22,0,.07.09.15,0l0,0,0,0c.12-.08.15,0,.19.05l0,0a.14.14,0,0,0,.13,0s0,0,0,0,0-.05-.1-.06h-.07c-.2-.05-.15-.18-.23-.27s0-.06.08,0a.63.63,0,0,0,.3.12c0,.07.05.08.14,0s.21-.16.23,0c.26.05.14.21.26.3s-.07,0-.12.06-.13,0-.15,0,.05.06.1.08l.14,0a.08.08,0,0,1,0,.05l0,0a1.05,1.05,0,0,1-.5,0c-.12,0-.08.08-.15.09a1,1,0,0,1-.34,0,.64.64,0,0,0-.41.05c-.06,0-.07.07-.13.1s-.05-.11-.08-.17h0c0,.06-.24.07-.17.16s.21,0,.33,0l.09,0C689.54,490.69,689.44,490.73,689.32,490.76Z"
            />
            <path
              class="cls-271"
              d="M690.06,489.89c0-.07-.06-.09-.15,0s0-.07-.08,0-.11-.05-.14-.09.12.1.22.11v0a.26.26,0,0,1-.23,0c-.09-.06-.12,0-.18,0s-.14,0-.17-.07l-.07,0a.12.12,0,0,1,0-.1,0,0,0,0,1,.06,0c.12,0,.06.15.2.12s.07-.1.11-.15.2-.06.32-.05.16.07.13.14.06.08.12.12S690.11,489.89,690.06,489.89Z"
            />
            <path
              class="cls-272"
              d="M689.27,489.66l0,0a.14.14,0,0,1-.15,0c-.09-.05-.16,0-.24,0s-.18.07-.14,0-.18-.06-.2-.13.17,0,.16-.06.12,0,.17,0a.21.21,0,0,0,.35,0s.07,0,.07,0,.1.11.17.05.14,0,.23,0C689.55,489.63,689.36,489.59,689.27,489.66Z"
            />
            <path
              class="cls-273"
              d="M695.44,490s-.07.08,0,.12,0,.08,0,.1a.09.09,0,0,1-.12,0c-.07-.05-.1,0-.14,0s-.06,0-.08,0,0-.16-.06-.23-.16-.1-.19-.17,0,0,0-.06,0-.09.1-.11h.07c.15,0,.19-.15.29-.11a.5.5,0,0,0,.34,0l0,0s0,.09.09.09l.15,0c.13,0,.22,0,.09-.11a.23.23,0,0,1-.09-.24c.14,0,.32,0,.23.19.06.07.21.1.28.17l0,0a.11.11,0,0,1,0,.11.44.44,0,0,1-.38-.05c-.07,0-.09,0-.14,0a.14.14,0,0,0-.1.1l0,.1s0,.06,0,.06-.1,0-.14,0,0,0,0-.05,0,0,0,0-.1,0-.09,0,.05.08,0,.12-.06-.15-.19-.18-.19-.14-.2-.22C695.22,489.82,695.4,489.89,695.44,490Z"
            />
            <path
              class="cls-235"
              d="M696.45,489.69c-.1-.06-.27-.08-.27-.19a.15.15,0,0,0,.17,0c.08,0,.16,0,.14.11S696.51,489.66,696.45,489.69Z"
            />
            <path
              class="cls-274"
              d="M695,489.61c0,.06.08.11,0,.17s-.07,0-.11-.06-.11,0-.12-.05,0,0,0-.06-.11,0-.1,0,.06-.05.12-.05A.19.19,0,0,0,695,489.61Z"
            />
            <path
              class="cls-273"
              d="M695.58,489.34c.11,0,.14.05.2.09l0,0c-.1,0-.15-.05-.16-.11Z"
            />
            <path
              class="cls-275"
              d="M695.8,489.64l0,.1c0-.07-.1-.12-.06-.19Z"
            />
            <path
              class="cls-276"
              d="M692.79,489.64h0a1.21,1.21,0,0,1,.34.06c.14.06.19,0,.23-.05l0,0c.25,0,.18.09.19.17h0a1.15,1.15,0,0,0-.38.14.26.26,0,0,0-.12,0s.15,0,.19,0,.1.14,0,.21h-.06c-.05-.1-.08,0-.12,0s-.15,0-.17-.09a1,1,0,0,0-.24-.31v0h.2s0,.1.1,0,0-.07-.06-.07S692.79,489.7,692.79,489.64Z"
            />
            <path
              class="cls-277"
              d="M691.65,489.85c0-.05.22-.05.18-.16l.12.13s0,.08.08,0,.06,0,.05,0,.12.15.25.19v0c0,.08-.14.1-.27.08a1.47,1.47,0,0,0-.42-.28Z"
            />
            <path
              class="cls-277"
              d="M692.33,489.83c.1,0,.07-.05.1-.08l.14.09c.06,0-.12-.1,0-.13s.11.05.15.09h0c0,.09,0,.2-.16.27a.34.34,0,0,1-.2,0h0c.08-.07.11-.14,0-.21Z"
            />
            <path
              class="cls-278"
              d="M692.33,489.83c-.18,0-.2-.11-.18-.2,0,.09.2.11.18.2Z"
            />
            <path
              class="cls-279"
              d="M688.73,490.35a.88.88,0,0,0,0,.15s0,.06-.07.07-.09,0-.11,0,.09,0,.12.06-.06.05-.08.05-.23,0-.19.14a.2.2,0,0,1-.11-.24h-.06v.14c-.15,0-.17-.11-.32-.11v-.05h0v.14c-.09,0,0-.08-.14-.06s-.16-.09-.2-.16a.07.07,0,0,1,0-.05s.11,0,.08-.07a.2.2,0,0,0-.08-.08.47.47,0,0,0-.17,0c-.07,0-.11,0-.18,0s0-.09-.13-.11-.13.11-.27.06a.25.25,0,0,0-.17,0c-.07,0-.15,0-.12.11s0,.09-.12,0l-.05-.08c-.06-.05-.07-.11-.12-.16a.33.33,0,0,0-.06-.1c-.05,0-.1-.07-.07-.12s0,0,0,0c.2-.08.25,0,.35.1a.3.3,0,0,0,.36,0,.33.33,0,0,1,.31,0,.32.32,0,0,0,.3,0s.07-.06.13-.07,0,0,0-.07-.09-.13,0-.19l0,0c.13,0,.25,0,.28.1s-.06.05,0,.09a.34.34,0,0,1,.08.09v0a.27.27,0,0,0,0,.09s0,.05,0,.06.15.13,0,.17c0,0,0,0,0,0a.11.11,0,0,0,.12,0c.07-.07.21-.06.3-.12a.15.15,0,0,1,.15,0C688.59,490.32,688.66,490.33,688.73,490.35Z"
            />
            <path
              class="cls-280"
              d="M687.43,489.61c0-.08-.23-.09-.17-.19a.41.41,0,0,1,.27.19.22.22,0,0,1-.07.34.43.43,0,0,1-.29-.12.2.2,0,0,1,.09-.19A.14.14,0,0,0,687.43,489.61Z"
            />
            <path
              class="cls-281"
              d="M688,489.94l-.09-.08s.06-.05.05-.09-.1-.13-.25-.06l0,0a.32.32,0,0,0,.17-.06.21.21,0,0,1,.23,0c.14,0,.13.09.11.15s0,.08,0,.13S688.07,489.93,688,489.94Z"
            />
            <path
              class="cls-282"
              d="M688.18,489.86c-.11,0-.11-.05-.06-.1s0-.12,0-.18,0-.09.09,0a.22.22,0,0,0,.14.06.26.26,0,0,1,.24.15,0,0,0,0,1,0,0h-.09C688.36,489.8,688.28,489.85,688.18,489.86Z"
            />
            <path
              class="cls-281"
              d="M687.44,489.94c.1-.1.08-.22.09-.33l.1,0c-.06.06.12.12,0,.18s0,.06,0,.09l-.1.09Q687.43,490,687.44,489.94Z"
            />
            <path
              class="cls-283"
              d="M688.54,489.77l-.23-.15.1-.07c.06.07.18.13.18.22Z"
            />
            <path
              class="cls-284"
              d="M688.46,489.51l-.06.05c-.09,0-.13,0-.15-.09s0,0,0,0S688.45,489.44,688.46,489.51Z"
            />
            <path
              class="cls-285"
              d="M697.54,489.39a.39.39,0,0,0,.31-.07c.07,0,.06,0,.08.06s.1.07.05.11-.11,0-.17,0-.11,0-.12,0,0,.05.1,0,.14.1.26.09.12.06.13.12a.75.75,0,0,1-.27.19c.07-.05.09-.09,0-.13s-.09,0-.14,0l0,0c-.11,0,0,0,0,.06s0,.05,0,.06,0,.09-.12.06,0-.16-.15-.19-.06,0-.06,0,.06-.07.13-.1,0,0-.05-.05-.16-.05-.11-.12S697.45,489.45,697.54,489.39Z"
            />
            <path
              class="cls-286"
              d="M696.45,489.69l0-.11.09-.05,0,.05a.14.14,0,0,0,.14.05c.06,0,.09,0,.1.05s-.07.07,0,.1l0,0c0,.06,0,.1.14.12s.06,0,.07,0,.13.13.09.21h0a.68.68,0,0,1-.39-.23.1.1,0,0,0-.08,0,.16.16,0,0,1-.09-.06s0,.08.09.08l.08,0c0,.05.1.11,0,.14a.3.3,0,0,1-.26,0s-.13-.06-.16-.11a.06.06,0,0,1,0,0,.08.08,0,0,1,0-.05c.12-.05.08-.11,0-.17Z"
            />
            <path
              class="cls-286"
              d="M697,489.52c.32,0,0-.11.07-.18a.53.53,0,0,0,.32.09c0,.05-.18.05-.13.12s0,.12,0,.18a.41.41,0,0,1-.37.07h0s0-.07,0-.1.08,0,.05,0S696.94,489.56,697,489.52Z"
            />
            <path
              class="cls-287"
              d="M697,489.52s-.06.08,0,.12,0,.06-.09.08-.06,0,0,0-.24,0-.22-.11C696.79,489.66,696.88,489.55,697,489.52Z"
            />
            <path
              class="cls-288"
              d="M697.27,489.71c-.15,0-.08-.1,0-.16l0,0c0,.06.13.06.14.11s0,0,0,0S697.31,489.78,697.27,489.71Z"
            />
            <path
              class="cls-235"
              d="M696.59,489.5c-.07,0,0,0,0-.05l0,0c.07,0,.14-.11.21,0s-.12,0-.17.08Z"
            />
            <path
              class="cls-289"
              d="M691.05,490.05c.1-.07.06-.18.19-.25.06.09.26.15.19.27s0,.06,0,.09.05-.08.06-.12a.09.09,0,0,1,.06,0c.07,0,.12.06.2,0s.18,0,.24.1.06.17.2.22.05.14-.11.13h0a0,0,0,0,0,0,0q-.09.15-.3.06c-.22,0-.23,0-.12-.15a.35.35,0,0,0,.1-.11c-.13,0-.13.05-.13.11s-.06.07-.12.09a1.6,1.6,0,0,1-.49,0c-.13,0-.17-.07-.09-.14h0c.07,0,.17,0,.26,0-.08-.09-.22,0-.32-.05s-.12-.05-.09-.11S691,490.16,691.05,490.05Z"
            />
            <path
              class="cls-290"
              d="M692,490.13c-.05-.06-.26,0-.23-.11s-.1-.1-.09-.16c.18,0,.22.09.33.14s0,.07.13.07-.05,0-.05.05A.1.1,0,0,1,692,490.13Z"
            />
            <path
              class="cls-291"
              d="M691.54,490l0,0s0,.07-.12.06,0-.14-.11-.18,0-.06,0-.1A.53.53,0,0,1,691.54,490Z"
            />
            <path
              class="cls-292"
              d="M691.05,490.05s.08.07,0,.09a.33.33,0,0,1-.29,0s0,0,0-.05l.14,0Z"
            />
            <path
              class="cls-293"
              d="M691,489.81c0-.06-.14-.08-.07-.14s.06,0,.08,0S691.1,489.75,691,489.81Z"
            />
            <path
              class="cls-294"
              d="M691.33,489.75c.07,0,0-.06,0-.1s.12,0,.11.09S691.38,489.83,691.33,489.75Z"
            />
            <path
              class="cls-295"
              d="M686.39,489.74c-.08,0-.09-.12-.19-.16a.22.22,0,0,1,.22,0,.23.23,0,0,0,.2,0c0,.08.1.16-.07.23A.24.24,0,0,1,686.39,489.74Z"
            />
            <path
              class="cls-296"
              d="M686.54,489.83c.12-.06,0-.15.08-.22s0-.08-.07-.11,0-.05,0-.05.18.14.11.24,0,.07.08.08,0,.11-.12.12l-.11,0A0,0,0,0,1,686.54,489.83Z"
            />
            <path
              class="cls-297"
              d="M686.63,489.86c.08,0,.21,0,.14-.09a.59.59,0,0,1,.4.06c.1,0,.23,0,.27.11l.09.06c-.1.09-.21,0-.32,0a.29.29,0,0,0-.35,0,.29.29,0,0,1-.38,0C686.4,489.9,686.52,489.88,686.63,489.86Z"
            />
            <path
              class="cls-298"
              d="M687.43,489.61s0,.08,0,.09-.13,0-.13-.06A.47.47,0,0,1,687.43,489.61Z"
            />
            <path
              class="cls-299"
              d="M694.39,489.63h.18s0,0,0,.06.07.07.12.1.11.07.12.12-.05.07-.12.07l-.06,0s-.09,0-.14,0h-.06c-.13,0-.18.07-.29.08s-.16,0-.1-.09a.22.22,0,0,0,.06-.14.23.23,0,0,1-.2,0h0c0-.06-.08-.08-.12-.12s-.09-.06,0-.07l.3-.11c.08-.07.2,0,.29,0s-.11.05-.08.11.18.12.06.23c.07-.08.07-.08,0-.12S694.34,489.67,694.39,489.63Z"
            />
            <path
              class="cls-300"
              d="M694.14,489.53c0,.1-.16.11-.3.11s-.37,0-.13-.16c.08,0,.18,0,.27,0h.08Z"
            />
            <path
              class="cls-301"
              d="M693.62,489.8a.65.65,0,0,1,.31,0h0c0,.11,0,.13-.27.13a.18.18,0,0,1-.13-.07s0-.07.08-.09Z"
            />
            <path
              class="cls-302"
              d="M693.11,489.45a.55.55,0,0,0,.18,0c0,.07.07.11.13.15v.05h0a.11.11,0,0,1-.11,0l-.19-.09s0,0,0-.09Z"
            />
            <path
              class="cls-303"
              d="M693.33,489.61l.1,0c0,.16-.08.18-.27.09s-.28,0-.33-.08l.1-.06A.5.5,0,0,1,693.33,489.61Z"
            />
            <path
              class="cls-304"
              d="M693.11,489.44l.06.09c-.07.06-.16,0-.24,0s0-.07-.07-.11Z"
            />
            <path
              class="cls-305"
              d="M692.93,489.54c.07-.07.16,0,.24,0a.19.19,0,0,1,.16.08,1.8,1.8,0,0,0-.4,0Z"
            />
            <path
              class="cls-306"
              d="M694.72,489.81c-.08,0-.11-.07-.1-.12a.47.47,0,0,1,.17,0l.12.05v.06A.19.19,0,0,1,694.72,489.81Z"
            />
            <path
              class="cls-307"
              d="M694.39,489.63a.06.06,0,0,0,.06.07c.11,0,.13.05.06.11a.18.18,0,0,1-.25,0c.29-.06,0-.16.09-.24Z"
            />
            <path
              class="cls-308"
              d="M691.79,490.49a.21.21,0,0,0,.27,0h0c.17,0,.13,0,.09-.11a.11.11,0,0,1,.1,0c.18,0,.27.11.3.22l0,.08a.49.49,0,0,0,0-.11.05.05,0,0,1,0,0s-.06-.06,0-.08.09,0,.12,0,0,0,.05,0,0,0,0,0,0-.11.09-.11.08.06.1.09.09.08.13.12-.11-.07-.09-.12,0-.1.12-.1.31.08.37.2.07,0,.12,0,.17.07,0,.13-.07.16,0,.27c-.07-.05-.08-.11-.19-.1s-.07.07-.12.12a.2.2,0,0,0-.33-.05c-.08.06-.1-.08-.17,0a.19.19,0,0,0-.14-.07c-.1,0,0,.05,0,.06s-.21,0-.26-.06,0-.06-.09-.08l.14.32c-.15,0-.1-.09-.18-.13s-.29,0-.4-.06-.06,0-.08,0,0-.11-.09-.09-.29,0-.2.14c-.1,0,0-.13-.19-.08l0,0c0-.07-.1-.13-.1-.2a.1.1,0,0,1,.06-.05c.07,0,.18,0,.23-.05a.2.2,0,0,1,.11,0c.14,0,.25.07.28.17C691.8,490.59,691.7,490.54,691.79,490.49Z"
            />
            <path
              class="cls-309"
              d="M695.44,490.49s.06,0,.08,0,.09.14.05.17.07.15,0,.23a.62.62,0,0,1-.46-.31c.08.16-.1.2-.27.24s-.19.06-.22,0-.08-.12-.22-.05-.05,0-.08,0l0,0s.13,0,.12.06l0,0a.2.2,0,0,1-.14,0,.11.11,0,0,0-.14-.06c-.09,0,0,.07-.09.1l-.16-.14c-.19,0-.23,0-.22-.12a.67.67,0,0,1,.07-.18.25.25,0,0,1,.12,0c.19,0,.15.11.19.17s0,0,0,0,0,0,0,0,.08,0,.11,0,0-.15,0-.22a.11.11,0,0,1,.16-.05,1.21,1.21,0,0,0,.33.07c.17.07.17.07.17.18,0,0,0-.1,0-.16s0-.09.07-.11a.21.21,0,0,1,.19.07.86.86,0,0,1,.13.14S695.37,490.54,695.44,490.49Z"
            />
            <path
              class="cls-310"
              d="M689.32,490.76l.18-.16c0-.06.07-.09.15-.12h.06l.22.1c0-.06,0-.1,0-.13a.15.15,0,0,1,.1,0c.15.07.18,0,.18-.06s-.09-.17.15-.11a.78.78,0,0,0,.34.3s.09.09,0,.14-.16,0-.22,0-.08.11-.11.18-.08-.12-.17-.15,0-.05,0-.09,0,.1,0,.14a.36.36,0,0,0,0,.09c0,.07-.12.08-.21.07s-.13-.05-.09-.11,0-.12,0-.19l-.22.09h0a.25.25,0,0,0-.17,0Z"
            />
            <path
              class="cls-311"
              d="M687.63,490.45l0,0a.3.3,0,0,1-.09.21c-.12.05-.13,0-.19-.05a.59.59,0,0,0-.23,0c-.07-.1-.05-.21-.14-.3s0,0,.09-.05a.6.6,0,0,1,.23,0c.06,0,.08-.11.18,0h.2a.09.09,0,0,1,.08.1A.23.23,0,0,1,687.63,490.45Z"
            />
            <path
              class="cls-312"
              d="M695.12,490.35a.2.2,0,0,0-.14-.08s0,.08,0,.1a.14.14,0,0,1-.15,0c-.08-.09-.06-.21-.15-.3s0-.08.07-.11a.16.16,0,0,0,.14,0,.27.27,0,0,1,.22,0c.13,0,.11.08.09.12a.43.43,0,0,0,0,.13c-.12.07,0,.06,0,.06s.16,0,.1.11S695.23,490.39,695.12,490.35Z"
            />
            <path
              class="cls-313"
              d="M686.29,490.13c.11,0,.1.1.1.17-.2-.09-.3-.05-.29.1-.1,0-.06-.12-.17-.13a.48.48,0,0,0-.17,0c-.07,0,0-.08,0-.12s.08-.07.13-.1.2-.05.28-.08l0,0c0,.06,0,.09.09.12S686.21,490.1,686.29,490.13Z"
            />
            <path
              class="cls-314"
              d="M693.79,490.41c.05,0,0,.1,0,.15s0,.14.15.15c0,.06,0,.12,0,.19,0-.11-.19-.17-.3-.25s0-.06-.08-.07l0,0a2.48,2.48,0,0,0-.42-.26s0-.06,0-.09l0,0,0,0c.05,0,0,.07.09.08s.08,0,.12.05l0,.06c0,.13.14.14.3.09A.06.06,0,0,1,693.79,490.41Z"
            />
            <path
              class="cls-308"
              d="M690.69,490.73c.1,0,0-.09,0-.13a.07.07,0,0,1,0-.05s0-.1.08-.1.09.05.11.09l.06.07,0,0s0,.11.12.07.11.07.14.11h0c-.06,0,0,.09-.09.17,0-.16-.28-.14-.28-.27-.15.09,0,.18-.09.28,0-.12-.1-.14-.23-.16C690.61,490.81,690.62,490.76,690.69,490.73Z"
            />
            <path
              class="cls-315"
              d="M696.27,490.68c0-.06.1-.11,0-.17l.09-.06.17.08c.05,0,0,.05,0,0s-.11.11,0,.14.12,0,.11.08-.29.06-.32-.08S696.3,490.68,696.27,490.68Z"
            />
            <path
              class="cls-316"
              d="M687,490.32l-.1,0c0,.11-.17.14-.3.15s-.22,0-.2-.12.11,0,.08,0,0-.11.14-.13a.23.23,0,0,0,.25.08C687,490.28,687,490.26,687,490.32Z"
            />
            <path
              class="cls-317"
              d="M696.53,490.35a.22.22,0,0,1-.31,0s-.1,0-.16,0l.11,0c.1,0,.23,0,.05-.11s0-.05,0-.07l.09,0h.07c.06,0,.11.05.09.1S696.52,490.28,696.53,490.35Z"
            />
            <path
              class="cls-318"
              d="M686.57,490.75c0,.07-.17.11-.27.07s-.09-.14-.2-.19.06,0,.08,0a2.35,2.35,0,0,0,.35.11S686.56,490.74,686.57,490.75Z"
            />
            <path
              class="cls-319"
              d="M688,490.62c.11,0,.2,0,.23.05s0,.05.09.06,0,.11-.12.11-.16,0-.16-.1A.56.56,0,0,0,688,490.62Z"
            />
            <path
              class="cls-320"
              d="M685.84,490c0,.07-.06.08-.13.1h-.18c-.06,0-.16-.05-.1-.1s.21-.05.32,0Z"
            />
            <path
              class="cls-321"
              d="M695.44,490c-.14-.06-.13-.18-.29-.23s0-.06,0-.06.12-.09.22-.07,0,0,0,.05c-.26,0-.08.11,0,.17l.05.09Z"
            />
            <path
              class="cls-322"
              d="M695.76,490.38c0,.09.19.14.12.24-.13-.07-.21-.19-.41-.22,0,0-.08,0,0-.06a.07.07,0,0,1,.09,0c.06.07.15,0,.24,0Z"
            />
            <path
              class="cls-323"
              d="M687.5,490.7c-.06-.08.08-.15,0-.22h.07c.07.05,0,.13.17.16C687.7,490.73,687.61,490.73,687.5,490.7Z"
            />
            <path
              class="cls-324"
              d="M695.12,490.35s.09,0,.14,0,.07.12.18.14.08.06,0,.06-.15.05-.19,0A.4.4,0,0,0,695.12,490.35Z"
            />
            <path
              class="cls-325"
              d="M696.13,490.54c.08,0,.09.06.09.11a.34.34,0,0,1-.24,0c-.08,0,0-.09,0-.13s0,0,0-.05S696.09,490.51,696.13,490.54Z"
            />
            <path
              class="cls-310"
              d="M689.65,490.79c.05.06.14.11.12.18-.26,0-.26,0-.22-.13s0-.07.09,0Z"
            />
            <path
              class="cls-326"
              d="M689.05,490.68l0,0c0,.06,0,.12-.14.11s-.15,0-.13-.08S689,490.69,689.05,490.68Z"
            />
            <path
              class="cls-327"
              d="M696.3,490.07h-.08a.27.27,0,0,0-.18-.21c-.06,0-.1,0-.11-.08a.13.13,0,0,1,.16,0,.9.9,0,0,1,.18.15C696.3,490,696.35,490,696.3,490.07Z"
            />
            <path
              class="cls-328"
              d="M685.53,490.26h0c.06,0,.12.05.07.1s-.1,0-.15,0-.1,0-.1-.06S685.47,490.27,685.53,490.26Z"
            />
            <path
              class="cls-329"
              d="M685.61,490.51c.06,0,.13,0,.12.06s-.05.05-.11.05-.13,0-.12-.05S685.55,490.52,685.61,490.51Z"
            />
            <path
              class="cls-330"
              d="M696.13,490.54s-.1-.07-.14,0-.09,0-.09-.08h0l.23-.08C696.11,490.43,696.17,490.49,696.13,490.54Z"
            />
            <path
              class="cls-331"
              d="M690.69,490.73c0,.07,0,.11-.14.11l0-.08s0-.05,0-.07S690.63,490.72,690.69,490.73Z"
            />
            <path
              class="cls-245"
              d="M685.21,490.26a.31.31,0,0,0-.29-.08l.22-.12Z"
            />
            <path
              class="cls-332"
              d="M695.93,489.78c.05,0,.12,0,.11.08a.58.58,0,0,1-.19,0C695.78,489.82,695.81,489.79,695.93,489.78Z"
            />
            <path
              class="cls-333"
              d="M690.23,490.84l-.06,0a.12.12,0,0,1,0-.15h.05c.06.05,0,.1,0,.16Z"
            />
            <path
              class="cls-322"
              d="M695.81,490.78a.2.2,0,0,0,.25,0c0,.07-.06.08-.13.07S695.82,490.83,695.81,490.78Z"
            />
            <path
              class="cls-334"
              d="M687.08,490.65a.15.15,0,0,1,.23,0A.24.24,0,0,1,687.08,490.65Z"
            />
            <path
              class="cls-335"
              d="M689.64,490.79l-.09,0-.1,0C689.51,490.7,689.57,490.7,689.64,490.79Z"
            />
            <path
              class="cls-336"
              d="M695.76,490.38s0-.06,0-.07a.06.06,0,0,1,.07,0l.06.12h0c-.07,0-.08-.06-.14-.08Z"
            />
            <path
              class="cls-337"
              d="M685.76,490.22c.1,0,.16,0,.17,0S685.77,490.28,685.76,490.22Z"
            />
            <path
              class="cls-338"
              d="M697.22,490.18h.2c.05,0,.09.05,0,.08-.22.11,0,.11.1.14l.13,0s0,.07,0,.1,0,.15-.18.14a.48.48,0,0,1-.16-.08s0-.08-.12,0a.48.48,0,0,1-.18,0c-.15,0-.17-.06-.18-.13s0-.09-.11-.12-.21-.08-.1-.16a.43.43,0,0,1,.35,0s0,.05.08.06l.12,0s-.05-.09,0-.13Z"
            />
            <path
              class="cls-339"
              d="M699.23,490c0,.06-.13.13.08.15,0,0,.06,0,0,.06a.14.14,0,0,1-.13,0c-.07,0-.15,0-.16-.06s0-.08,0-.1-.13-.13-.2-.18,0,0,0,0,0,0,0,0,0,0-.08,0-.06,0-.16,0-.1-.05-.05-.09a.07.07,0,0,0,0-.1s0-.07,0-.1a.85.85,0,0,1,.17,0c.08,0,.17,0,.26,0s.19.09.24.17S699.31,490,699.23,490Z"
            />
            <path
              class="cls-340"
              d="M699.08,490.52s.08-.07.09-.11.12-.07.21-.05h0c.07.05.25,0,.24.06s-.15,0-.23,0a1.18,1.18,0,0,0-.28.12c-.15.09-.16.08-.28,0s-.07-.12-.12-.18,0-.05.07-.05.09,0,.07,0S699,490.45,699.08,490.52Z"
            />
            <path
              class="cls-341"
              d="M700.05,490.05c-.18.06-.27,0-.28-.09s-.12-.08-.08-.14-.12,0-.14,0l-.09.17c-.12,0-.09-.07-.09-.11l0-.08c0-.05,0-.12.13-.12s.24,0,.29.07.06,0,.09,0,.08,0,.08,0,0-.05.11,0,0,.1,0,.14C699.85,489.9,700.13,490,700.05,490.05Z"
            />
            <path
              class="cls-342"
              d="M701,489.85a.35.35,0,0,1,.23,0h.11c.05-.08.14-.09.26-.05l0,0c0,.16-.09.21-.49.21-.07,0,0-.12-.17-.11S700.85,489.88,701,489.85Z"
            />
            <path
              class="cls-338"
              d="M698,490.62s0-.05-.09-.05,0-.06,0-.09,0-.07,0-.1.11-.14.26-.1.13,0,.12.05-.07.05-.13.05h-.08c0,.06.15,0,.14.09s-.07,0-.12,0,0,.11-.16.11Z"
            />
            <path
              class="cls-343"
              d="M696.91,490.46c0,.07,0,.11.13.14s.15.19-.13.21c0,0,0-.06,0-.07s.11,0,.08-.05-.07,0-.12,0-.29.06-.17-.1-.11-.11-.09-.19A.34.34,0,0,1,696.91,490.46Z"
            />
            <path
              class="cls-344"
              d="M698.59,489.64c-.07,0,0,.07,0,.09s0,.08-.06.1-.2-.09-.33-.06h0a.22.22,0,0,1-.13-.12h0a.46.46,0,0,1,.2,0c.1,0,.11,0,.12-.06a.17.17,0,0,1,.14,0h0S698.62,489.6,698.59,489.64Z"
            />
            <path
              class="cls-345"
              d="M700.37,489.75c0,.13.07.24.24.32a.42.42,0,0,1-.33,0c0-.09-.22-.09-.19-.19s.18-.07.2-.14A.08.08,0,0,1,700.37,489.75Z"
            />
            <path
              class="cls-346"
              d="M699.42,489.88c0,.05,0,.1,0,.14s.07.07,0,.08-.12-.05-.19-.08,0-.08-.07-.12,0-.06.07-.07h.14A.1.1,0,0,1,699.42,489.88Z"
            />
            <path
              class="cls-347"
              d="M698.22,489.77c.08,0,.18-.11.21,0l.12,0s0,.06,0,.08c-.11.07-.1,0-.18,0s0,.06-.08.09,0,0,0,0-.24-.1,0-.16Z"
            />
            <path
              class="cls-348"
              d="M697.37,490.59s.13,0,.13.09a.17.17,0,0,1-.19.08c-.08,0-.14,0-.16-.07s.05-.07.11-.1Z"
            />
            <path
              class="cls-349"
              d="M700.11,489.89c0,.06.27.07.17.18l-.09-.06c-.08,0,0,.08-.06.09s-.07,0-.08-.05-.17-.13,0-.2S700.12,489.86,700.11,489.89Z"
            />
            <path
              class="cls-350"
              d="M697.13,490H697c0-.07,0-.11.09-.14a.21.21,0,0,1,.23,0l0,0C697.39,490,697.23,490,697.13,490Z"
            />
            <path
              class="cls-351"
              d="M698.28,490l0,0,.06,0s.11.06,0,.11-.1,0-.16,0S698.21,490,698.28,490Z"
            />
            <path
              class="cls-352"
              d="M701,489.85c-.06,0,0,.08,0,.11s0,0,0,0h-.05l0,0s-.06,0,0-.06-.09-.09-.13-.14S701,489.74,701,489.85Z"
            />
            <path
              class="cls-353"
              d="M699.73,490.73c-.05,0-.12,0-.13,0s.07,0,.12,0,.13,0,.13,0S699.78,490.73,699.73,490.73Z"
            />
            <path
              class="cls-354"
              d="M699.16,490.69c0,.05,0,.12-.11.13s-.11,0-.1,0S699.09,490.73,699.16,490.69Z"
            />
            <path
              class="cls-355"
              d="M698.53,490.66c.06,0,.15.06.12.11s-.08,0-.12,0S698.53,490.7,698.53,490.66Z"
            />
            <path
              class="cls-356"
              d="M698,490.62c0,.05.07.09,0,.11s-.12,0-.12,0,.09-.06.16-.07Z"
            />
            <path
              class="cls-357"
              d="M697.73,489.88h0a.61.61,0,0,1,0,.12s0,.07,0,.08-.08,0-.11-.06v-.08S697.7,489.89,697.73,489.88Z"
            />
            <path
              class="cls-258"
              d="M701,490v0c.07,0,.13-.07.14,0a.27.27,0,0,1,0,.09C701,490.08,701,490.05,701,490Z"
            />
            <path
              class="cls-358"
              d="M697.87,490.48a.06.06,0,0,1,0,.09l-.18,0v-.1h0c.08,0,.09,0,.14.05Z"
            />
            <path
              class="cls-338"
              d="M697.82,490.48a.34.34,0,0,1-.14-.05s0,0,0-.05,0-.07.1-.05,0,0,0,.07Z"
            />
            <path
              class="cls-260"
              d="M702.25,490c.08.06.1-.05.18,0v.12C702.34,490.09,702.25,490.08,702.25,490Z"
            />
            <path
              class="cls-359"
              d="M698.43,490.7s-.06,0-.11,0-.09,0-.07-.06,0,0,.09,0S698.43,490.66,698.43,490.7Z"
            />
            <path
              class="cls-360"
              d="M697.37,490.59h-.11l0,0s-.08,0-.05-.09S697.34,490.53,697.37,490.59Z"
            />
            <path
              class="cls-361"
              d="M702.75,490s0-.08,0-.11,0-.08.12,0,.2,0,.19.09,0,.09,0,.08-.18.09-.3,0-.14,0-.16-.11S702.66,490,702.75,490Z"
            />
            <path
              class="cls-362"
              d="M703.92,490c.08,0,.15,0,.15.08s0,.08-.11.08-.18,0-.19-.08S703.82,490,703.92,490Z"
            />
            <path
              class="cls-363"
              d="M704.33,490.18c.08,0,.18,0,.19.07s-.07,0-.13,0-.2,0-.21-.07S704.27,490.19,704.33,490.18Z"
            />
            <path
              class="cls-364"
              d="M703.15,489.92a.25.25,0,0,1,.24.1C703.24,490,703.18,490,703.15,489.92Z"
            />
            <path
              class="cls-365"
              d="M696.91,490.46l-.27-.08-.11,0c-.1,0-.16-.1-.11-.17s0-.08-.07-.1-.11-.11,0-.14.21.14.38.15,0-.09,0-.13h0a2.63,2.63,0,0,0,.41.21c0,.07.08.13,0,.2l-.38-.16c-.08,0-.16-.05-.21,0s.06.08.12.1S697,490.37,696.91,490.46Z"
            />
            <path
              class="cls-295"
              d="M686.63,489.86c-.08,0-.17.06-.15.13s-.07-.11-.21-.11.06.05,0,.07l-.1-.07s-.07,0-.06-.05.1,0,.15,0a.35.35,0,0,1,.25,0Z"
            />
            <path
              class="cls-366"
              d="M686.51,489.85a.69.69,0,0,1-.25,0c0-.06.06-.08.13-.09s.14,0,.15.09Z"
            />
            <path
              class="cls-367"
              d="M686.11,489.83l.06.05v0l0,0c-.06,0-.18,0-.17-.05S686.05,489.83,686.11,489.83Z"
            />
            <path
              class="cls-349"
              d="M700.1,489.72c-.05,0-.08,0-.09,0s0,0-.08,0c-.19,0-.29-.08-.29-.2v0c.05-.06.08,0,.12,0s.19,0,.28,0,.05.08.14.08,0,0,0,.06A.08.08,0,0,1,700.1,489.72Z"
            />
            <path
              class="cls-368"
              d="M699,489.6c0-.12.19-.12.32-.15s.09,0,0,.08h0s0,.08,0,.11l0,0s0,.07-.07.08a.23.23,0,0,1-.25-.08S699.07,489.62,699,489.6Z"
            />
            <path
              class="cls-369"
              d="M699,489.6s.17-.1.15,0,.09.11.22.11.11.07,0,.11-.1,0-.14,0l0,0c-.22,0-.15-.09-.21-.15s0,0,0,0h0Z"
            />
            <path
              class="cls-370"
              d="M700.05,489.58c-.1,0-.2.07-.28,0s0-.1.08-.1a.24.24,0,0,0,.16-.09C700,489.46,700.16,489.5,700.05,489.58Z"
            />
            <path
              class="cls-368"
              d="M699.37,489.53c.12,0,.13-.07.22-.08h0v0s-.05.06,0,.08h0c.05.14-.09.13-.24.11h0c-.06,0-.12-.08,0-.13Z"
            />
            <path
              class="cls-371"
              d="M698.59,489.64l-.05-.06c.18,0,.24-.1.42-.09v.12c-.08,0-.19,0-.24.08S698.63,489.65,698.59,489.64Z"
            />
            <path
              class="cls-372"
              d="M700.2,489.72v-.06s.08,0,.1-.05h0c.07,0,.18.06.22.14h-.26S700.21,489.74,700.2,489.72Z"
            />
            <path
              class="cls-373"
              d="M698.72,489.69c0-.13.12-.1.24-.08l0,0s0,0,0,0A.45.45,0,0,1,698.72,489.69Z"
            />
            <path class="cls-371" d="M698.55,489.58h-.14s-.11-.07,0-.12h.13Z" />
            <path
              class="cls-374"
              d="M699.61,489.47l0,0s0-.08,0-.12S699.73,489.39,699.61,489.47Z"
            />
            <path
              class="cls-375"
              d="M698.63,489.39c.09,0,.09,0,.11.08S698.64,489.49,698.63,489.39Z"
            />
            <path
              class="cls-376"
              d="M700.83,489.91l0,.06a.18.18,0,0,1-.16,0s0,0,0,0S700.79,489.9,700.83,489.91Z"
            />
            <path
              class="cls-263"
              d="M701.56,489.83c-.2-.07-.15.1-.27.1s-.09-.14,0-.21,0,0,.08,0Z"
            />
            <path
              class="cls-377"
              d="M701.29,489.72c0,.07.12.14,0,.21a.12.12,0,0,1-.1-.05c0-.05-.12-.08,0-.14Z"
            />
            <path
              class="cls-258"
              d="M700.93,489.6s0,.11-.14.07,0-.09.05-.12Z"
            />
            <path
              class="cls-344"
              d="M690.91,490.63c-.12,0-.06-.12-.14-.17s0,.11-.08.14-.37-.19-.31-.3a3.25,3.25,0,0,0,.54,0c0,.18.27.09.4.13s.13,0,.19,0v0h0l-.09,0a.13.13,0,0,1-.13,0c-.09-.06-.06,0-.1,0l-.05,0A.34.34,0,0,1,690.91,490.63Z"
            />
            <path
              class="cls-378"
              d="M690.23,490.41s.12.09,0,.12-.2,0-.3-.07a.48.48,0,0,1-.29,0h0c-.07,0-.15,0-.22-.06s.13-.05.22-.07S690,490.42,690.23,490.41Z"
            />
            <path
              class="cls-379"
              d="M689.41,490.59a.45.45,0,0,1-.23,0c-.07,0-.2,0-.16-.06s-.12-.14.1-.14.12-.08.16-.13.14.09,0,.16,0,.06.06.09S689.44,490.56,689.41,490.59Z"
            />
            <path
              class="cls-380"
              d="M690.87,490.24a.45.45,0,0,1,.28,0c.06,0,.16,0,.13.09s-.12.06-.19.05a.86.86,0,0,1-.17,0l-.06-.05S690.86,490.25,690.87,490.24Z"
            />
            <path
              class="cls-381"
              d="M688.85,490.21c-.05,0,0,.07-.12.09h-.09a.61.61,0,0,0-.18-.08c-.08,0-.12-.06,0-.11a.59.59,0,0,1,.23,0h.11S688.88,490.15,688.85,490.21Z"
            />
            <path
              class="cls-382"
              d="M690.06,489.89l.09-.05a.2.2,0,0,1,.24,0c0,.05,0,.09-.08.1S690.08,490,690.06,489.89Z"
            />
            <path
              class="cls-383"
              d="M690.87,490.24a0,0,0,0,1,0,0c-.16.06-.18-.06-.29-.08s0-.05,0-.08.11,0,.18,0l0,.05C690.76,490.18,690.88,490.19,690.87,490.24Z"
            />
            <path
              class="cls-384"
              d="M688.77,490.12h-.09a2.34,2.34,0,0,1-.26,0l0,0a.11.11,0,0,1,0-.12h0s.12,0,.08,0,0,0,0-.07.06,0,.06,0l.06.1.12.07S688.83,490.09,688.77,490.12Z"
            />
            <path
              class="cls-385"
              d="M689.41,490.59l0,0c0-.05,0-.1.08-.12s.18,0,.22.06l-.18.11Z"
            />
            <path
              class="cls-386"
              d="M689.61,490.08c.06,0,.13,0,.1.05s0,0,0,0,.15,0,.11.07a.21.21,0,0,1-.12,0c-.08,0-.15,0-.09-.11S689.41,490.11,689.61,490.08Z"
            />
            <path
              class="cls-387"
              d="M689.08,489.69h.15c.06,0,0,.07,0,.1a.33.33,0,0,1-.17,0C689,489.76,689,489.72,689.08,489.69Z"
            />
            <path
              class="cls-388"
              d="M689.68,489.88h.23c0,.06,0,.08-.13.07S689.61,490,689.68,489.88Z"
            />
            <path
              class="cls-389"
              d="M688.72,490c-.05,0-.08,0-.07-.07s.05-.07.11,0,.15,0,.06.11A.09.09,0,0,1,688.72,490Z"
            />
            <path
              class="cls-281"
              d="M688.72,490h.1a.31.31,0,0,0,.14.16s0,0-.05,0h-.06l-.08-.09Z"
            />
            <path
              class="cls-389"
              d="M688.59,489.85l-.05,0h0v0h.05c.06,0,.17,0,.17,0S688.66,489.86,688.59,489.85Z"
            />
            <path
              class="cls-390"
              d="M688.91,490.21l.05,0h0s0,0,0,0l0,.07s0,0-.1,0l-.07.07C688.84,490.32,688.92,490.27,688.91,490.21Z"
            />
            <path
              class="cls-391"
              d="M689,490.32l.1,0c.06,0,.14,0,.09.07A.14.14,0,0,1,689,490.32Z"
            />
            <path
              class="cls-392"
              d="M689.33,489.84s.17,0,.17.07S689.28,490,689.33,489.84Z"
            />
            <path
              class="cls-393"
              d="M690.61,489.89c-.05,0-.09,0-.1-.05s0,0,.06,0,.11,0,.12.05S690.65,489.88,690.61,489.89Z"
            />
            <path
              class="cls-394"
              d="M690,490.13a.23.23,0,0,1-.14,0s0,0,0-.05a.08.08,0,0,1,.1,0S690.05,490.1,690,490.13Z"
            />
            <path
              class="cls-395"
              d="M688.62,490.29h.11v.05c-.1,0-.2,0-.19-.06A.11.11,0,0,1,688.62,490.29Z"
            />
            <path
              class="cls-396"
              d="M689,490.21l0,0s0-.05.12,0,0,0,0,0S689.06,490.22,689,490.21Z"
            />
            <path
              class="cls-397"
              d="M689.91,489.85c-.22,0-.3-.08-.21-.2a.17.17,0,0,0,.14.16s-.06-.05,0-.09.08.09.09.14Z"
            />
            <path
              class="cls-398"
              d="M696.22,489.91c0-.06-.14-.09-.13-.16l.35.09s0,0,0,0l0,0A.23.23,0,0,1,696.22,489.91Z"
            />
            <path
              class="cls-274"
              d="M695.07,489.93l-.22,0-.13-.1.18,0C695,489.83,695.07,489.86,695.07,489.93Z"
            />
            <path
              class="cls-235"
              d="M696.44,489.88v-.19C696.58,489.75,696.58,489.82,696.44,489.88Z"
            />
            <path
              class="cls-399"
              d="M693.11,490.21c.08.05,0,.06,0,.09s0,.08-.09.08-.05,0-.1,0l-.06-.08h0a.27.27,0,0,1,0,.09s0,.1,0,.11a.13.13,0,0,1-.14-.09l-.06-.05,0,.14s0,0,0,0-.17-.15-.28-.21a.21.21,0,0,1,.17-.14c.13,0,.14-.08.15-.14a.3.3,0,0,1,.14-.25c.14.09.26.19.28.31S693,490.2,693.11,490.21Z"
            />
            <path
              class="cls-220"
              d="M693.61,489.8l-.05.09c0,.05.1.07.09.12s0,.06-.06.08a.53.53,0,0,1-.35-.13l0,0c0-.12.27-.09.33-.19S693.56,489.8,693.61,489.8Z"
            />
            <path
              class="cls-400"
              d="M693.25,489.94l.3.14a1,1,0,0,0-.22.19l-.07-.06c.07-.07,0-.15,0-.22S693.22,490,693.25,489.94Z"
            />
            <path
              class="cls-401"
              d="M693.25,489.94V490a.27.27,0,0,1-.23,0s0,0,0-.06a.17.17,0,0,1,.19,0Z"
            />
            <path
              class="cls-402"
              d="M692.56,490.05c.11.08.1.14-.09.16s-.13.09-.23.12l-.09,0c-.15-.05-.3-.1-.18-.22h.09a.42.42,0,0,0,.28-.07Z"
            />
            <path
              class="cls-403"
              d="M688.41,490.24s.1.09-.06.07a.14.14,0,0,0-.16.05c-.05.06-.13.05-.21,0s-.11,0-.11-.07.07-.09.17-.09.08-.05.06-.05c-.22,0-.08-.1-.15-.14.1-.05.1.05.13,0a.3.3,0,0,1,.23,0C688.38,490.11,688.37,490.18,688.41,490.24Z"
            />
            <path
              class="cls-404"
              d="M687,490.32c-.07-.05-.12,0-.18,0s-.22,0-.2-.12.25,0,.36,0-.12-.11.06-.13.18.05.17.12a.43.43,0,0,0,0,.05A.53.53,0,0,1,687,490.32Z"
            />
            <path
              class="cls-405"
              d="M688.45,489.94h-.05a.25.25,0,0,1-.4,0v0c0-.05.13-.05.19-.08a.24.24,0,0,1,.26-.06C688.53,489.85,688.58,489.89,688.45,489.94Z"
            />
            <path
              class="cls-281"
              d="M688,490a.34.34,0,0,0,.4,0v.14h-.09c-.12,0-.25.05-.36,0S688,490,688,490Z"
            />
            <path
              class="cls-406"
              d="M688.31,490.08h.09s0,0,0,.05.06.08.16.09.13,0,0,.07h-.08s-.06-.05-.13-.05S688.29,490.14,688.31,490.08Z"
            />
            <path
              class="cls-407"
              d="M687.63,490.12c0,.06-.08.05-.14.06s-.1,0-.1-.05.08-.05.14-.06S687.59,490.11,687.63,490.12Z"
            />
            <path
              class="cls-408"
              d="M686.29,490.13c-.09,0-.19,0-.19-.07s.1,0,.15,0S686.31,490.09,686.29,490.13Z"
            />
            <path
              class="cls-407"
              d="M687.76,490.16c.08,0,.16,0,.12.07a.11.11,0,0,1-.14,0c-.1-.05,0-.07,0-.1Z"
            />
            <path
              class="cls-407"
              d="M687.77,490.16c-.13-.06,0-.11,0-.17h.06s.05,0,0,0-.06.08-.09.13Z"
            />
            <path
              class="cls-409"
              d="M687.63,489.91s-.06-.06,0-.09.15,0,.13.07S687.68,489.92,687.63,489.91Z"
            />
            <path
              class="cls-410"
              d="M688,489.77s.09,0,.08.06-.08,0-.13,0S687.94,489.8,688,489.77Z"
            />
            <path
              class="cls-411"
              d="M687.64,490.27a.13.13,0,0,1-.2,0A.18.18,0,0,1,687.64,490.27Z"
            />
            <path
              class="cls-412"
              d="M687.63,490.45c-.07-.06,0-.07.09-.08S687.76,490.46,687.63,490.45Z"
            />
            <path
              class="cls-283"
              d="M688.45,489.94c.09-.05,0-.09,0-.14h.1v0l0,.09s0,0,0,.06A.13.13,0,0,1,688.45,489.94Z"
            />
            <path
              class="cls-413"
              d="M697.36,489.85c-.18-.05-.29,0-.32.11s-.21-.07-.14-.16.23-.08.37-.09a.19.19,0,0,0,.18,0s.06,0,0,.06A.37.37,0,0,0,697.36,489.85Z"
            />
            <path
              class="cls-414"
              d="M697.73,489.88s0,.05-.05.06-.15,0-.13-.05S697.67,489.87,697.73,489.88Z"
            />
            <path
              class="cls-415"
              d="M697.5,489.77l0-.06v0c.08,0,.16,0,.17.05S697.55,489.78,697.5,489.77Z"
            />
            <path
              class="cls-365"
              d="M696.81,490c-.21,0-.21,0-.2-.16,0,.08.23.06.2.17Z"
            />
            <path
              class="cls-240"
              d="M696.22,489.91h.18v0c-.09,0,.07.1,0,.14h-.05Z"
            />
            <path
              class="cls-416"
              d="M696.85,489.69l0,0s0,0,0,.08-.15,0-.16-.05S696.81,489.71,696.85,489.69Z"
            />
            <path
              class="cls-417"
              d="M691.51,490.49v0s.12-.08.06-.14,0-.06,0-.08.12,0,.14,0,0,.08,0,.11a.16.16,0,0,1-.08.06s-.09.05,0,.08.1,0,.16,0a.13.13,0,0,0,.06.12s.07.08,0,.1-.13,0-.12,0S691.59,490.54,691.51,490.49Z"
            />
            <path
              class="cls-418"
              d="M691.38,490.08l.12-.06.06.06c.08.06.09.1-.06.1s-.1.06-.19,0S691.39,490.13,691.38,490.08Z"
            />
            <path
              class="cls-308"
              d="M692.06,490.46c-.06,0-.13,0-.11-.06s.06,0,.1,0,0,.05,0,.08Z"
            />
            <path
              class="cls-419"
              d="M694.71,490l-.05.12s0,.06,0,.09,0,.1-.14.12a.36.36,0,0,1-.22-.05.28.28,0,0,1-.09-.1.08.08,0,0,1,0,0,.31.31,0,0,1,.26-.13h0a.28.28,0,0,1,.18,0Z"
            />
            <path
              class="cls-420"
              d="M693.65,489.94c.1,0,.3,0,.28-.11H694c.06,0,.16,0,.2,0s0,.1-.06.14,0,0,.06.06.09,0,0,.06h0a.31.31,0,0,1-.1,0c-.07,0-.15,0-.16,0s-.17-.09-.29-.1S693.64,490,693.65,489.94Z"
            />
            <path class="cls-421" d="M694.25,490.1s0,0,0-.06.12-.14.29-.07Z" />
            <path
              class="cls-422"
              d="M694.71,490h-.18a.07.07,0,0,1,.07-.08C694.67,489.88,694.71,489.92,694.71,490Z"
            />
            <path
              class="cls-423"
              d="M693.65,489.94l.06.05c.12,0,.26,0,.2.15a.28.28,0,0,1-.3-.15l-.12-.09s0,0,0,0l0,0Z"
            />
            <path
              class="cls-424"
              d="M690.91,490.63c.06-.07.16,0,.23,0s.14.14.09.22-.07-.13-.23-.08S691,490.65,690.91,490.63Z"
            />
            <path
              class="cls-314"
              d="M692.88,490.4l.1,0c0,.08.16.13.14.23C693.11,490.51,692.86,490.52,692.88,490.4Z"
            />
            <path
              class="cls-425"
              d="M691.19,490.57s-.06-.1.08-.05.1,0,.15,0S691.26,490.54,691.19,490.57Z"
            />
            <path class="cls-426" d="M692.52,490.54l0,0c.09.05,0,.11,0,.17Z" />
            <path
              class="cls-421"
              d="M694.16,490.13a.12.12,0,0,1,.09,0s.06.07.09.11a.18.18,0,0,0,.17.06c.09,0,.11-.06.11-.11l0-.08c.07,0,.25,0,.07.12s0,.06,0,.05c.29,0,0,.08,0,.1s-.08,0-.09,0-.27,0-.35-.08-.07,0-.11,0,0,0-.08,0a.24.24,0,0,1-.15,0s0,0,0,0S694.12,490.19,694.16,490.13Z"
            />
            <path
              class="cls-427"
              d="M694,490.3l.15,0c.17.07.14.17.13.27s-.07,0-.09,0c-.19,0-.15-.14-.22-.22A.05.05,0,0,1,694,490.3Z"
            />
            <path
              class="cls-428"
              d="M694,490.35c.06.07.07.16.18.22-.09,0,0,.12-.11.12s0-.09-.07-.12.06-.15-.15-.14C693.89,490.37,694,490.36,694,490.35Z"
            />
            <path
              class="cls-429"
              d="M694,490.35l-.15.08-.09,0h-.06a.08.08,0,0,1,0-.08.26.26,0,0,1,.17-.1c.1,0,.08.06.13.08h0Z"
            />
            <path
              class="cls-430"
              d="M694.55,490.43c.17,0,.23.09.21.2C694.66,490.57,694.37,490.59,694.55,490.43Z"
            />
            <path
              class="cls-431"
              d="M694.71,490.38s0-.07,0-.07,0,0,.09,0,.09,0,.14,0a.35.35,0,0,1,0,.28C694.83,490.54,694.91,490.41,694.71,490.38Z"
            />
            <path
              class="cls-428"
              d="M694.3,490.6c0-.09,0-.19-.13-.27h.08C694.33,490.41,694.4,490.5,694.3,490.6Z"
            />
            <path
              class="cls-432"
              d="M689.68,490.49a.7.7,0,0,1,.29,0s-.09.05,0,.08.09,0,0,0-.08,0-.11,0S689.7,490.56,689.68,490.49Z"
            />
            <path
              class="cls-433"
              d="M687.24,490.35c.07,0,.14,0,.14,0s-.08.06-.15.06-.14,0-.14,0S687.18,490.36,687.24,490.35Z"
            />
            <path
              class="cls-276"
              d="M693.89,490.21c0,.07-.13.07-.15.12s-.11-.05-.16-.07.15.08.17.14h0c0,.06,0,.09-.16.08s-.17,0-.19-.07a.27.27,0,0,0-.07-.14c0-.11,0-.18.22-.19s.06-.05.06-.09l.28.17S693.91,490.19,693.89,490.21Z"
            />
            <path
              class="cls-257"
              d="M699.41,489.66c.08,0,.25,0,.24-.11a.39.39,0,0,0,.28.22.19.19,0,0,1-.07.12c-.08,0-.06-.13-.18-.15s-.21.07-.26.14l0,0s0-.08,0-.11S699.41,489.69,699.41,489.66Z"
            />
            <path
              class="cls-258"
              d="M700.2,489.72l.08,0c.13.12,0,.13-.17.14l-.05,0a.13.13,0,0,1,0-.13S700.17,489.75,700.2,489.72Z"
            />
            <path
              class="cls-434"
              d="M699.37,489.53l0,.13s-.11,0-.12,0S699.27,489.54,699.37,489.53Z"
            />
            <path
              class="cls-281"
              d="M688.41,490.13c-.06,0,0,0,0-.05s.17.05.28,0Z"
            />
            <path
              class="cls-299"
              d="M693.89,490.21v0c0-.09-.07-.13-.18-.17.1,0,.31-.07.3.1,0,0,.1,0,.15,0s-.14.09-.14.16S694,490.23,693.89,490.21Z"
            />
            <path
              class="cls-435"
              d="M693.75,490.4c0-.08-.29-.1-.2-.23a.39.39,0,0,0,.19.16Z"
            />
            <path
              class="cls-436"
              d="M523,493.36l-.52.26c-.27.15-.44.14-.44-.24s-.19-.41-.5-.24a4.84,4.84,0,0,1-1,.4,20.18,20.18,0,0,0,3-4.21c-.79-.07-1.6-.7-2.38.13,1.55-1.32,2.28-3.08,3.22-4.68-.25-.26-1,.43-.76-.47-.42.06-.73.35-1.2.33,1.21-1.07,2.43-2.06,2.85-3.68-.26-.13-.41.14-.67.12l.52-.74c-.16-.19-.39,0-.62-.2a9.62,9.62,0,0,0,2.37-4,.36.36,0,0,1,.23.33,16.56,16.56,0,0,0,.91,2.82,3.65,3.65,0,0,1,.23.54.48.48,0,0,1-.08.55c-.17.14-.33,0-.48-.06a.58.58,0,0,0-.3-.11.28.28,0,0,0-.28.23c0,.22.13.27.26.32a1.88,1.88,0,0,1,1.2,1.5c.05.24.06.48-.19.55-.55.14-.73.78-1.33.91a3.73,3.73,0,0,1,1.5.64c.23.17.54.17.4.58-.19.58-.52.89-.94.81-.24-.05-.48-.22-.72,0a.7.7,0,0,0,.24,1.17,1.36,1.36,0,0,0,.45.06,1.65,1.65,0,0,1,1.67,1.89c0,.46-.22.66-.69.67s-.76-.36-1.13-.13a10.92,10.92,0,0,1-.94.66c.91-.3,1.73.16,2.59.18a.68.68,0,0,1,.74.66c.07.39.12.77.16,1.16.08.73-.33,1.09-1,.9a6.09,6.09,0,0,0-1.41-.05c-.68,0-1.36,0-2,0s-1.24.06-1.86,0A1.15,1.15,0,0,0,523,493.36Z"
            />
            <path
              class="cls-437"
              d="M523,493.36a.77.77,0,0,1,.92-.64c.67,0,1.34-.05,2,0,.08,0,.19.07.25,0,.74-.32,1.5.21,2.25-.1.35-.15.72.06,1.07.16.52.15.85-.12.81-.66,0,0,0,0,0-.06-.38-.52.39-1.68-.92-1.69-.73,0-1.42-.51-2.17-.13-.48.25-.52-.13-.69-.49a1.18,1.18,0,0,0,1.21-.54c.18-.28.35-.11.56,0,.38.11.89.39,1.15,0s.11-.86-.06-1.3a1.09,1.09,0,0,0-1.32-.82.91.91,0,0,1-1-.35c-.38-.47-.16-.75.07-1.14s.56-.28.86-.1.45,0,.58-.2l.37-.74c-.37-.13-.81,0-1-.51-.06-.18-.45,0-.68-.09s-.5.15-.46-.23.09-.59.45-.52.4,0,.4-.28.24-.25.43-.26c.43,0,.42-.19.29-.55a1.84,1.84,0,0,0-1-1.25,1.09,1.09,0,0,0-.61-.09c.2-1.09.2-1.09,1.27-.54.19-.31,0-.55-.14-.78a11.83,11.83,0,0,1-.91-2.77.27.27,0,0,1,.07-.3c.37.63.74,1.27,1.13,1.89a12,12,0,0,0,1.34,1.71l-.47.23.53.69c-.25.16-.39-.18-.65-.07A6.13,6.13,0,0,0,530.2,483a11.57,11.57,0,0,0,1.66,1.7l-1.08-.4c.07.93-.5.28-.88.36,1.06,1.71,1.78,3.62,3.48,4.88A4.61,4.61,0,0,0,532,489c-.31,0-.63.46-1.12.34a9.37,9.37,0,0,0,1.38,2.23,17.13,17.13,0,0,0,1.77,2,15,15,0,0,1-1.52-.57c-.09,1.61-.91,0-1.39.43-.08.15.2.37.15.68l-.49-.16c-.82-.3-.82-.3-1,.59-.52-.13-.86-.56-1.36-.76l-.13.7c-.27,0-.34-.27-.53-.36-.18.11-.42,0-.6.13a2,2,0,0,1-.72.25c-.54,0-.14-.5-.41-.73l-1.19.77c-.42-.12.06-.87-.56-.79a6,6,0,0,0-1.13.4c.09-.27.16-.44.21-.62C523.49,493,523.12,493.43,523,493.36Z"
            />
            <path
              class="cls-438"
              d="M527.75,494.77a3.92,3.92,0,0,0,1.59.23,10.09,10.09,0,0,1,2.19.34c.17.05.43.07.42.32s-.27.29-.45.33a11.54,11.54,0,0,1-1.54.27,22.71,22.71,0,0,1-6.05-.18c-.32-.06-.79-.09-.82-.4s.47-.36.77-.44a9.75,9.75,0,0,1,2.53-.25c.11.59.56.46,1,.46.18,0,.4,0,.32-.28C527.64,495,527.59,494.88,527.75,494.77Z"
            />
            <path
              class="cls-439"
              d="M527.33,495.57c-.3.22-.64-.13-1,.08-.12.07-.21-.11-.12-.25s.17-.24.14-.41.16-.32,0-.49c.16-.23.47-.21.66-.38s.38.12.41.32A1.37,1.37,0,0,1,527.33,495.57Z"
            />
            <path
              class="cls-440"
              d="M527.33,495.57v-1.09c0-.18,0-.34-.25-.36.23-.28.44-.09.66,0,0,.22,0,.43,0,.65l.15.84C527.68,495.73,527.52,495.52,527.33,495.57Z"
            />
            <path
              class="cls-441"
              d="M647.26,509.77c-1.28.91-2.55,1.86-4,.27-.1-.11-.37-.22-.47-.16-1.28.77-2.26-.19-3.4-.48a16.38,16.38,0,0,0-4.26-1c-2.77,0-3.82-3.06-2.17-5.6a1.78,1.78,0,0,1,1.53-1.4,5.88,5.88,0,0,0,3.78-1.61,2.64,2.64,0,0,1,1.17-.51c.91-.23,6.7.7,7.78,1.39-.39-1.27-.4-2.47.63-3,1.45-.82,2.85-2,4.68-1.77a4.7,4.7,0,0,0,2.65-.27,4.57,4.57,0,0,1,3.23.16c1,.34,1.45.18,1.41-1.07-.1-2.88,1.31-3.8,4.08-2.75a4.5,4.5,0,0,0,3.71-.37c-1-.88-2-.68-3-.82a3.56,3.56,0,0,1-3.09-2.52c-.46-1.39-.3-3,.86-3.69,1.73-1.11,2.61-2.79,3.81-4.27,2.11-1.21,3.94-.69,5.56,1,.61-.36.45-1.32,1.23-1.46,2.51-2.34,4.78-1.82,5.94,1.46.23.65.58.6,1,.69,2.16.4,3,1.45,3,3.65,0,.57,0,1,.52,1.41a5.06,5.06,0,0,1,2.06,6.11c-.84,2.52-2.79,3.6-5.6,3.58,1.43,2.57.48,4.43-1.57,6a6,6,0,0,0-1.2,1.6,1.89,1.89,0,0,1-1.8,1.05c-2-.21-2.41,1.4-2.74,2.57-.46,1.6-1,2.92-2.69,3.34a3.52,3.52,0,0,1-4-1.62c-.05-.08-.19-.09-.52-.23a3.71,3.71,0,0,1-1.61,3.28,2.94,2.94,0,0,1-2.62.42,1,1,0,0,1,0-1.33,33.33,33.33,0,0,1,5.42-6.92c.62,0,1.19-.34,1.78-.33,1.6,0,2.59-.31,1.73-2.22-.35-.78.4-.87.88-1.06s1.11-.62,1-1.34-.86-1-1.56-.89a3.91,3.91,0,0,1-2.14-.3c-.22-.1.07,0-.17-.06-.68-.12-5.66,2-6,2.58a1.91,1.91,0,0,0,.38,2.63c.45.41,1.06.6,1.43,1.12a2.2,2.2,0,0,1-.77,1.79,40.93,40.93,0,0,1-4.67,4.64c-1.56,1.26-2.23,1.17-3.79-.23-.86-1.91-2.51-3.39-3-5.51.62-.38,1.32-.07,2-.22s1.09-.35,1-1-.53-.87-1.13-.95c-3.81-.48-4-.45-7.77,1.34a2.07,2.07,0,0,0-1.29,1.85,2.28,2.28,0,0,0,1.25,2.07C646.25,509.09,647.17,508.82,647.26,509.77Z"
            />
            <path
              class="cls-442"
              d="M666.38,480.49c-.41.59-1,1.11-1.08,1.87s-.54,1.18-1.31,1.49a3.24,3.24,0,0,0-2.23,3.9,3.17,3.17,0,0,0,3.65,2.58c1.33-.1,2.2.73,3.7,1-2.22,1.11-4,2.21-6.12.63a1.55,1.55,0,0,0-2,.27,2.28,2.28,0,0,0-.69,2.65c.22.48.53.79-.16,1.12-.49.24-.72.93-1.53.41a3.31,3.31,0,0,0-4.22.11c-.13.11-.41.27-.47.22-1.81-1.48-3.26.13-4.81.61s-2.17,1.34-1.47,2.91c.17.37.53.73-.07,1.07s-.7-.2-1-.47c-.9-.89-1.85-1.43-3.05-.5-.49.38-.88.08-1.32-.18a3.31,3.31,0,0,0-4.59.68,1.79,1.79,0,0,1-1.72.79,3.44,3.44,0,0,0-2.95,1.12c-.08-.36-.4-.42-.67-.55-3.08-1.59-3.64-4.49-1.36-7.07.2-.21.38-.44.73-.86-1.37-.14-2.72.58-3.66-.62s-.29-2.38.72-3.64c-1.26-.08-2.44,0-3-1.08a2.11,2.11,0,0,1-.27-1.59c.43-1.58,1.69-1.9,4.07-1,.2-2.91.2-2.91,3-3.78a1.21,1.21,0,0,0,.62-.34c1.1-1.58,2.43-1.29,3.79-.46.48-.48.05-1,.13-1.44.26-1.37,1.21-2.65,2.38-2.31a7.33,7.33,0,0,0,4.92-.47,3.79,3.79,0,0,1,2.82.55c.59.31,1.16.77,1.8.08s1-1,.62-1.92a2.56,2.56,0,0,1,4.35-2.54,1.19,1.19,0,0,0,1.58.35,8.52,8.52,0,0,1,2.71-.35c1.24,1.44,3.11,2.26,3.88,4.21.41,1,1.65,1.1,2.69,1.26C665.54,479.34,666.46,479.31,666.38,480.49Z"
            />
            <path
              class="cls-443"
              d="M666.73,505c-1.7,2.24-3.4,4.5-5.11,6.74a2.07,2.07,0,0,0-.43,1.34c-1.67,1.24-2,3.07-2.1,5a26,26,0,0,0,1,6.43c.08,2.21,1,4.24,1.39,6.38.61,3.21,1.15,6.4,0,9.59a2.85,2.85,0,0,1-.48,1,5.82,5.82,0,0,1-4.32.63,1.68,1.68,0,0,1-1.17-2.16,18.18,18.18,0,0,1,1.59-5.06,5.59,5.59,0,0,0,.25-4.44c-.91-2.77-2.09-5.48-1.52-8.56a4.06,4.06,0,0,0-.8-2.78c-1.44-2.22-1.9-4.74-2.39-7.27s-1.22-4.74-3.19-6.43c1-1,1.25-1,2.3.35a28,28,0,0,1,3.2,5.19c.55,1.8,1.4,2.18,2.85,1.06a38.46,38.46,0,0,0,8.36-9.48c.78-.85,1.8-2,2.82-1s-.43,1.78-.94,2.59A1.86,1.86,0,0,1,666.73,505Z"
            />
            <path
              class="cls-444"
              d="M666.38,480.49c-.31-.78-1-.85-1.65-.8s-1.92-.05-2.2-.55c-1.14-2.05-3.38-3.19-4.29-5.38.67-2.51,2-2.79,4.39-.95.42-.23.28-.64.33-1a2.09,2.09,0,0,1,3.73-1,2.35,2.35,0,0,0,2,1.29,1.51,1.51,0,0,1,1.09.87c.4,2.4,3.7,3.58,2.75,6.53,0,0,.29.18.44.28a6.56,6.56,0,0,0-.69,2.78C670.6,480.45,668.81,479.32,666.38,480.49Z"
            />
            <path
              class="cls-445"
              d="M649.45,505.36c1.35-.09,1.72,1,2.15,1.91a15.74,15.74,0,0,1,1.69,5.74c.23,2.94,2.15,5.27,2.9,8,.07.23.26.5.2.69-1,3.38.77,6.3,1.61,9.36a5,5,0,0,1-.43,3.86,23.86,23.86,0,0,0-1.77,5.54c-.17.66.29.85.64,1.17-.45.66-1.15.62-1.82.61-1.91,0-2.38-.91-1.46-2.71a13.69,13.69,0,0,0,2-11.8c-.52-2.06-1.11-4.11-1.79-6.13-1-3-1.92-5.92-1.63-9.1a3.34,3.34,0,0,0-.72-2.36,8.35,8.35,0,0,0-1.59-3.33C649.08,506.4,648.39,505.82,649.45,505.36Z"
            />
            <path
              class="cls-446"
              d="M653.16,539.55c-.19,2.35-.19,2.35,3.28,2.1,1.52.43,2.95-.21,4.42-.35s1.82-.87,1.74-2.3-.53-2.91.53-4.19a6.31,6.31,0,0,1,.25,3.25c0,1,.13,1.52,1.32,1.6a25.5,25.5,0,0,1,4.13.79c.45.11,1.08.26,1.11.82s-.65.78-1.17,1a21.74,21.74,0,0,1-6.13,1c-5.19.15-10.4.44-15.53-.74-.77-.17-2-.1-2-1.15,0-.9,1.17-.89,1.91-1.07A19.71,19.71,0,0,1,653.16,539.55Z"
            />
            <path
              class="cls-447"
              d="M649.45,505.36c-.65.69.17.9.43,1.28.74,1.06,1.59,2.07,1.12,3.52-1.18-.83-2.59.6-3.74-.39-.76-.59-1.83-.3-2.56-1.18a2.56,2.56,0,0,1,1.17-4.3,7.09,7.09,0,0,0,2.79-1.21,2.17,2.17,0,0,1,2.72-.22,1.8,1.8,0,0,0,1.58.22c1.19-.41,2.13-.09,2.33,1.2.25,1.51-.95,1.5-2,1.69-.61.11-1.06-.2-1.59-.22C651,505.39,650.36,504.55,649.45,505.36Z"
            />
            <path
              class="cls-448"
              d="M663.13,534.81a36.3,36.3,0,0,0,0,5.42c.21,1.51-.12,1.74-1.41,1.28a8.67,8.67,0,0,0-.88-.21c-.13-1.5.75-2.78.77-4.3,0-3.76-1.17-7.31-1.69-11-.08-.54-.38-1,.12-1.52C661.09,527.94,662.81,531.17,663.13,534.81Z"
            />
            <path
              class="cls-449"
              d="M666.73,505c.61-.82,1.24-1.63,1.84-2.46.21-.28.51-.62.2-1s-.67-.05-1,.12c-.51.29-1.18.37-1.46,1-.73.88-1.16,2.09-2.49,2.33-1.51-.41-2.76-1.07-2.63-2.94s1.53-2.3,2.93-2.45a2.57,2.57,0,0,0,1.53-.76c.94-.79,2-1.29,3.13-.45a1.05,1.05,0,0,0,1,.21c1.19-.46,2.37-.3,2.65,1,.33,1.48-.74,2.15-2.21,2.14,1.33,2.23.89,3.1-1.61,3.06C668,504.86,667.43,506,666.73,505Z"
            />
            <path
              class="cls-450"
              d="M663.85,505.07l2.49-2.33c-.75,2.45-3,3.74-4.39,5.72a14,14,0,0,1-4.27,4.19,2,2,0,0,1-2.39.16c-.65-.47-1-1.09-.39-1.87,1.2,1.56,2.41,1,3.51-.07A40.93,40.93,0,0,0,663.85,505.07Z"
            />
            <path
              class="cls-451"
              d="M656.79,488c.32.52.53.89.76,1.23a1.73,1.73,0,0,1-.23,2.19c-.59.79-5.43,1.57-6.29,1-1.11-.69-4.39-.31-5.44.4a8.63,8.63,0,0,1-4.18,1.91c-1.44.09-2.3-.57-2.35-1.93,0-1-.27-.87-1-.75a3.6,3.6,0,0,1-3.95-2.26c-.51-1.91.26-3,1.87-4.33a30.48,30.48,0,0,0,3.89-3.56,4.21,4.21,0,0,1,4.48-1.67,2.19,2.19,0,0,0,2-.46,2.14,2.14,0,0,1,3.25,2.55c-.16.34-.5.74.08,1.09s.92.83,1.63.45a3.65,3.65,0,0,1,4.29.22.75.75,0,0,0,1,0,2,2,0,0,1,2.68.06,2,2,0,0,1,.75,2.13,2.2,2.2,0,0,1-2.48,1.46A3,3,0,0,0,656.79,488Z"
            />
            <path
              class="cls-441"
              d="M563,592c-3.48,2.48-6.93,5.07-10.9.75-.28-.3-1-.6-1.27-.45-3.51,2.11-6.17-.52-9.27-1.29-3.8-.94-7.21-2.74-11.59-2.72-7.54,0-10.4-8.32-5.92-15.23.65-2.1,2.07-3.68,4.18-3.81a16,16,0,0,0,10.28-4.39,7.23,7.23,0,0,1,3.19-1.38c2.47-.63,18.23,1.91,21.17,3.77-1-3.45-1.08-6.71,1.71-8.27,4-2.22,7.76-5.53,12.75-4.8a13.09,13.09,0,0,0,7.22-.74c2.86-1.16,5.87-.59,8.78.44,2.62.92,3.95.47,3.84-2.92-.27-7.84,3.57-10.34,11.11-7.5,3.51,1.33,6.67.61,10.11-1-2.62-2.39-5.57-1.85-8.29-2.24a9.69,9.69,0,0,1-8.4-6.86c-1.26-3.77-.81-8,2.32-10.05,4.71-3,7.12-7.59,10.39-11.61,5.74-3.29,10.71-1.88,15.11,2.67,1.68-1,1.23-3.6,3.37-4,6.83-6.39,13-5,16.16,4,.64,1.79,1.58,1.63,2.87,1.88,5.89,1.11,8.27,4,8.19,9.94,0,1.56-.11,2.75,1.4,3.84,5.76,4.17,7.88,9.85,5.62,16.64s-7.58,9.78-15.25,9.74c3.9,7,1.31,12.07-4.28,16.39a16.37,16.37,0,0,0-3.26,4.34c-1.17,1.84-2.77,3.11-4.9,2.88-5.29-.59-6.55,3.81-7.45,7-1.24,4.37-2.7,8-7.31,9.09s-8.17-.54-10.81-4.4c-.14-.21-.54-.25-1.41-.63-.06,3.74-1.29,6.91-4.4,8.93a8,8,0,0,1-7.13,1.15,2.82,2.82,0,0,1-.1-3.63c4.26-6.79,8.82-13.34,14.75-18.82,1.68,0,3.23-.93,4.84-.92,4.34,0,7.05-.83,4.71-6-1-2.13,1.07-2.38,2.39-2.89,1.69-.67,3-1.69,2.66-3.66-.42-2.3-2.33-2.64-4.25-2.4a10.8,10.8,0,0,1-5.81-.83c-.6-.27.18,0-.47-.16-1.83-.34-15.4,5.4-16.35,7-1.52,2.61-1.31,5.05,1,7.16,1.23,1.11,2.91,1.64,3.9,3,.31,2-.91,3.55-2.09,4.87a110.56,110.56,0,0,1-12.72,12.61c-4.25,3.45-6.07,3.21-10.31-.62-2.33-5.19-6.84-9.22-8.11-15,1.69-1,3.59-.19,5.35-.6,1.55-.36,3-.94,2.88-2.83s-1.45-2.38-3.09-2.59c-10.37-1.31-10.87-1.21-21.16,3.66a5.65,5.65,0,0,0-3.5,5c-.16,2.63,1.37,4.26,3.41,5.66C560.25,590.1,562.77,589.37,563,592Z"
            />
            <path
              class="cls-442"
              d="M615,512.25c-1.11,1.63-2.78,3-2.92,5.11-.17,2.4-1.47,3.22-3.57,4-5,2-7.1,6-6.06,10.62s4.47,7.42,9.92,7c3.61-.26,6,2,10.07,2.85-6,3-10.86,6-16.64,1.7a4.24,4.24,0,0,0-5.52.74c-2.05,2-3.05,4.47-1.86,7.21.58,1.32,1.43,2.16-.43,3.06-1.34.65-2,2.52-4.17,1.1-3.75-2.42-7.74-2.79-11.5.32-.36.3-1.11.72-1.27.59-4.94-4-8.87.35-13.09,1.65-3.85,1.19-5.92,3.65-4,7.93.45,1,1.42,2-.19,2.92s-1.91-.56-2.66-1.3c-2.44-2.43-5-3.88-8.3-1.35-1.33,1-2.39.21-3.59-.5-4.62-2.72-8.87-2.22-12.48,1.85-1.29,1.46-2.68,2.53-4.71,2.17-3.29-.58-5.72,1-8,3-.22-1-1.09-1.14-1.81-1.51-8.39-4.31-9.91-12.22-3.7-19.22.52-.59,1-1.21,2-2.36-3.73-.37-7.39,1.6-9.95-1.69-2.81-3.59-.79-6.48,1.95-9.89-3.43-.22-6.63.1-8.28-3a5.65,5.65,0,0,1-.72-4.31c1.16-4.31,4.6-5.18,11.07-2.76.53-7.93.54-7.92,8.32-10.29a3.22,3.22,0,0,0,1.67-.92c3-4.31,6.61-3.51,10.32-1.27,1.32-1.3.14-2.63.37-3.89.68-3.75,3.28-7.22,6.45-6.3,5,1.46,8.94.31,13.39-1.27,2.4-.85,5.26.23,7.69,1.5,1.6.83,3.17,2.08,4.91.2,1.36-1.49,2.62-2.76,1.68-5.22-1.38-3.59,0-6.63,3.27-8.48a6.42,6.42,0,0,1,8.56,1.55c1.38,1.6,2.6,1.67,4.3,1,2.37-1,4.91-.77,7.39-1,3.38,3.92,8.45,6.16,10.55,11.47,1.12,2.83,4.49,3,7.32,3.43C612.77,509.14,615.28,509,615,512.25Z"
            />
            <path
              class="cls-443"
              d="M616,579.08c-4.63,6.12-9.24,12.25-13.91,18.34a5.74,5.74,0,0,0-1.16,3.67c-4.54,3.38-5.46,8.35-5.71,13.5-.28,6,1.43,11.71,2.64,17.49.22,6,2.68,11.55,3.78,17.38,1.64,8.73,3.12,17.41,0,26.11a8.65,8.65,0,0,1-1.3,2.68A15.88,15.88,0,0,1,588.52,680c-2.92-1-3.66-3-3.18-5.88a49.4,49.4,0,0,1,4.31-13.79,15.18,15.18,0,0,0,.69-12.08c-2.48-7.54-5.69-14.92-4.14-23.29.48-2.53-.72-5.32-2.18-7.57-3.92-6-5.18-12.91-6.49-19.8-1.26-6.62-3.32-12.89-8.7-17.49,2.77-2.76,3.41-2.66,6.25.95a73.33,73.33,0,0,1,8.72,14.13c1.51,4.88,3.82,5.92,7.75,2.87,9.2-7.14,16.41-16.11,22.76-25.8,2.13-2.32,4.92-5.36,7.68-2.77,2.51,2.36-1.16,4.83-2.54,7.06A5.1,5.1,0,0,1,616,579.08Z"
            />
            <path
              class="cls-444"
              d="M615,512.25c-.82-2.1-2.59-2.31-4.47-2.16-2.23.19-5.23-.15-6-1.51-3.1-5.59-9.21-8.67-11.68-14.65,1.83-6.82,5.32-7.58,12-2.59,1.13-.6.75-1.73.88-2.66a5.29,5.29,0,0,1,3.91-4.68c2.47-.72,5-.14,6.24,1.95a6.43,6.43,0,0,0,5.34,3.5c1.11.13,2.82,1.4,3,2.36,1.07,6.55,10.06,9.75,7.49,17.79,0,.11.77.5,1.19.76-1.13,2-1.57,4.15-1.89,7.56C626.55,512.16,621.68,509.07,615,512.25Z"
            />
            <path
              class="cls-445"
              d="M569,580c3.68-.22,4.68,2.78,5.87,5.21a42.79,42.79,0,0,1,4.6,15.63c.61,8,5.85,14.33,7.9,21.82.18.64.69,1.36.54,1.89-2.71,9.21,2.09,17.15,4.38,25.47a13.5,13.5,0,0,1-1.19,10.51c-2.49,4.74-3.54,9.94-4.81,15.08-.45,1.81.8,2.33,1.75,3.18-1.23,1.8-3.14,1.69-5,1.66-5.2-.07-6.48-2.48-4-7.36,7-9.84,8.27-20.68,5.39-32.13-1.41-5.62-3-11.2-4.88-16.69-2.72-8.05-5.22-16.1-4.44-24.76a9.07,9.07,0,0,0-2-6.44,22.26,22.26,0,0,0-4.32-9C568,582.78,566.09,581.21,569,580Z"
            />
            <path
              class="cls-446"
              d="M579.07,673c-.52,6.39-.52,6.39,8.93,5.7,4.13,1.17,8-.56,12-1,3.85-.37,5-2.35,4.75-6.26s-1.46-7.92,1.44-11.38c1.37,2.85.84,5.9.68,8.84s.34,4.14,3.59,4.35a68.37,68.37,0,0,1,11.24,2.16c1.21.28,2.95.69,3,2.22.07,1.86-1.76,2.12-3.17,2.58a58.68,58.68,0,0,1-16.7,2.66c-14.12.4-28.3,1.19-42.26-2-2.1-.49-5.49-.3-5.49-3.16,0-2.43,3.18-2.42,5.19-2.91A53.59,53.59,0,0,1,579.07,673Z"
            />
            <path
              class="cls-447"
              d="M569,580c-1.75,1.89.48,2.46,1.19,3.48,2,2.9,4.32,5.66,3,9.59-3.19-2.25-7,1.63-10.18-1.06-2-1.59-5-.82-7-3.21-3.57-4.3-2.18-10.26,3.2-11.7,2.71-.73,5.32-1.44,7.6-3.29s4.76-2.31,7.41-.61a4.78,4.78,0,0,0,4.29.59c3.23-1.09,5.78-.22,6.35,3.28.66,4.12-2.59,4.08-5.46,4.61-1.65.3-2.88-.55-4.34-.6C573.15,580,571.45,577.75,569,580Z"
            />
            <path
              class="cls-448"
              d="M606.22,660.14c-.05,4.92-.67,9.93,0,14.75.6,4.1-.31,4.74-3.83,3.47a19.33,19.33,0,0,0-2.39-.57c-.35-4.07,2-7.57,2.09-11.69.11-10.25-3.17-19.91-4.6-29.87-.21-1.47-1-2.86.34-4.15C600.66,641.43,605.34,650.21,606.22,660.14Z"
            />
            <path
              class="cls-449"
              d="M616,579.08c1.68-2.23,3.37-4.43,5-6.68.57-.77,1.37-1.69.55-2.63s-1.84-.12-2.64.34c-1.39.79-3.21,1-4,2.72-2,2.4-3.17,5.68-6.79,6.35-4.11-1.13-7.51-2.92-7.14-8,.36-4.9,4.14-6.24,8-6.67a7.1,7.1,0,0,0,4.17-2c2.56-2.16,5.3-3.52,8.52-1.22a2.88,2.88,0,0,0,2.79.55c3.24-1.23,6.47-.81,7.24,2.69.89,4-2,5.87-6,5.83,3.63,6.09,2.43,8.45-4.37,8.35C619.46,578.61,617.93,581.61,616,579.08Z"
            />
            <path
              class="cls-450"
              d="M608.16,579.18l6.79-6.35c-2,6.66-8.21,10.17-11.94,15.58a38.68,38.68,0,0,1-11.63,11.4c-2.06,1.24-4.32,2.05-6.52.43-1.75-1.29-2.72-3-1.06-5.08,3.27,4.23,6.58,2.74,9.56-.19C598.51,589.92,604,585.19,608.16,579.18Z"
            />
            <path
              class="cls-451"
              d="M589,532.72c.88,1.44,1.43,2.43,2.07,3.36,1.48,2.18.73,4.14-.64,6-1.59,2.13-14.77,4.27-17.1,2.83-3-1.87-12-.84-14.83,1.07-3.45,2.31-6.88,4.9-11.36,5.2-3.92.27-6.28-1.53-6.4-5.24-.09-2.64-.75-2.37-2.84-2-4.75.76-9.74-2.32-10.76-6.16-1.38-5.22.72-8.26,5.1-11.79a80.22,80.22,0,0,0,10.58-9.69c3.4-3.94,7.23-5.79,12.2-4.56a5.93,5.93,0,0,0,5.5-1.25,5.33,5.33,0,0,1,6.93-.08c2.27,1.79,3.3,4.09,1.94,7-.44,1-1.37,2,.2,3,1.39.86,2.51,2.27,4.45,1.22,4-2.16,7.92-2.31,11.66.6a2,2,0,0,0,2.7,0c2.45-1.67,5-1.86,7.31.17,1.65,1.47,2.88,3.57,2,5.8-1.11,2.93-3.53,4.27-6.76,4A7.88,7.88,0,0,0,589,532.72Z"
            />
            <path
              class="cls-452"
              d="M740.58,491c-.09.29-.15.58.19.79-.39,0-.64.29-1,.29,0,0,0,.09-.07.14-.09.23-.09.23-.28.06,0,0,0,0,0,0-.21.22-.5-.06-.72.1a1.25,1.25,0,0,1-.85.24.21.21,0,0,1-.13.05c-.11,0-.1-.13-.2-.13-.33.08-.38,0-.4-.27,0-.06,0-.14-.08-.16s-.11.08-.18.08-.07.1-.13.12-.2,0-.3-.06a.62.62,0,0,0-.3,0,.88.88,0,0,1-.17,0,.24.24,0,0,1-.33-.07c-.16-.19-.25-.12-.36.06-.18-.27-.19-.63-.49-.79.29-.16.44-.48.8-.58a1.9,1.9,0,0,1,.83.05.74.74,0,0,0,.66-.26c.18-.15.27-.21.47,0s.43.11.59,0a3.08,3.08,0,0,1,.7-.3c.23,0,.42-.16.67-.12a1.73,1.73,0,0,1,.87.57A.59.59,0,0,0,740.58,491Z"
            />
            <path
              class="cls-436"
              d="M738.83,490.49c-.2.18-.54.1-.7.4s-.26-.14-.43,0-.27,0-.29-.18-.14-.11-.16-.07c-.07.26-.42.2-.48.48,0,.13-.16.18-.24,0s0-.13-.19-.08-.36.22-.45-.09c-.22.08-.52,0-.65.22a.67.67,0,0,1-.47.33c-.07-.11-.07-.11.15-.21-.25,0-.45-.06-.35-.36,0-.07-.09-.17-.12-.27s-.24-.22.07-.28c.14,0-.07-.15,0-.25s-.11-.08-.07-.16l.17-.11c0-.13-.09-.07-.14-.09s-.17,0-.09-.17.11-.1.19,0,.25.08.24-.16l.29.23c.17-.23.1-.63.35-.7a.63.63,0,0,1,.69.19.25.25,0,0,1-.21.3c-.26,0-.39.25-.59.36a.25.25,0,0,0-.16.25c0,.15.15.07.21.12a1.31,1.31,0,0,0,1.26.1.89.89,0,0,1,.48.05.44.44,0,0,0,.57-.34c0-.1.13-.15.19-.27a3,3,0,0,0-.73,0c-.37,0-.5-.09-.54-.48,0-.13,0-.28.2-.28s.24-.17.18-.35c.35,0,.53.5.93.28.05,0,.09,0,.13,0a.43.43,0,0,0,.26.15.59.59,0,0,0,.34.13.23.23,0,0,1,.23.21c0,.18-.13.21-.28.25a.22.22,0,0,0-.18.22c0,.12.08.18.18.23a2.5,2.5,0,0,0,.26.07c.11,0,.27,0,.27.18S738.93,490.44,738.83,490.49Z"
            />
            <path
              class="cls-437"
              d="M738.83,490.49l.24-.17a1.43,1.43,0,0,0-.46-.12.34.34,0,0,1-.33-.35.31.31,0,0,1,.32-.33c.16,0,.17-.08.21-.17s.18-.14.3-.1.34.1.47-.09a2,2,0,0,1,.33-.09c.08,0,.22,0,.23,0,.11.43.62.5.81.85a.57.57,0,0,1-.24.71c-.12.07-.46.11-.13.36-.25,0-.42-.18-.57-.3-.35-.31-.52-.39-1-.23A.26.26,0,0,1,738.83,490.49Z"
            />
            <path
              class="cls-453"
              d="M736.58,489.21c.09.17.22.47.37.43s.46.06.62,0,.32.06.47.17c-.11.11-.45,0-.26.36.05.09-.51.35-.67.29a.9.9,0,0,0-.72,0,.82.82,0,0,1-.85-.06c-.11-.09-.21-.23-.38-.07s-.11,0-.11-.07a.58.58,0,0,1,.22-.55c.26-.22.67-.2.83-.54.2.06.17-.13.23-.22C736.43,489,736.39,489.2,736.58,489.21Z"
            />
            <path
              class="cls-454"
              d="M738.11,493l1.08.2c.13,0,.32.05.32.22s-.2.19-.34.22a7.91,7.91,0,0,1-3.39,0c-.13,0-.32,0-.31-.22s.19-.18.33-.21l1-.2c.31,0,.49.2.68.39s.28-.09.4-.18S738,493,738.11,493Z"
            />
            <path
              class="cls-455"
              d="M739.58,489.16c-.07.33-.07.34-.53.16-.1,0-.17-.1-.24,0a.26.26,0,0,0-.26-.09.28.28,0,0,1-.3-.2.45.45,0,0,0-.27-.12l-.09-.08c.07-.41.15-.45.46-.23.15-.36.14-.31.49-.14S739.33,489,739.58,489.16Z"
            />
            <path
              class="cls-456"
              d="M737.42,493.49a1.59,1.59,0,0,0-.64-.48,1.15,1.15,0,0,0-.48-.3.53.53,0,0,1-.35-.4c0-.07.09-.08.16-.07s.13.12.22.17,0-.21.13-.24.14.15.25.12.06.19.13.27,0,0,0,0a.35.35,0,0,1,0-.38L737,492a.14.14,0,0,1,.08.14,1,1,0,0,0,.39.78.39.39,0,0,1,0,.5Z"
            />
            <path
              class="cls-457"
              d="M738.11,493a1.25,1.25,0,0,1-.45.49c-.09.05-.17.1-.24,0h0c.14-.13.17-.32.28-.47a1,1,0,0,0,.08-.45c.17-.14.35-.36.46.08.15-.13.21-.38.45-.26-.08.05-.19.07-.21.2A.56.56,0,0,1,738.11,493Z"
            />
            <path
              class="cls-458"
              d="M734.4,490l.07.16c-.19,0-.08.23-.25.24l-.15-.43C734.2,490,734.3,490.05,734.4,490Z"
            />
            <path
              class="cls-459"
              d="M737.42,493c.23-.15.07-.39.14-.57.15,0,0,.19.14.21s0,.27.07.41c-.15.11-.08.41-.35.43C737.4,493.33,737.56,493.16,737.42,493Z"
            />
            <path
              class="cls-460"
              d="M703.28,490.58c-.31-.12-.59-.25-.45-.68,0-.07-.06-.08-.1-.12-.39-.3-.41-.52-.09-.89.3,0,.62-.05.8.29a.2.2,0,0,0,.32,0,1.25,1.25,0,0,1,1.11-.23c.36.07.48-.06.56-.44a.22.22,0,0,1,.16-.17c.08,0,.17-.08.13-.19s-.13-.1-.22-.09a4.52,4.52,0,0,0-.64,0c-.2,0-.36,0-.38-.28s-.1-.2-.27-.19a1.79,1.79,0,0,0-1.51,1.08.22.22,0,0,1-.13.12c-.35,0-.45-.07-.34-.36s0-.14-.1-.16a.25.25,0,0,1-.2-.33.24.24,0,0,1,.34-.17c.12,0,.17,0,.16-.1s.06-.25.13-.23c.35.06.64-.27,1-.19a.3.3,0,0,0,.41-.2c0-.06,0-.12.06-.17s.16-.17.2-.13c.34.27.55-.35.84-.13a.58.58,0,0,0,.46.08.61.61,0,0,1,.59.26,1.19,1.19,0,0,0,.6.4c0,.18-.19.15-.28.22a.32.32,0,0,0,.07.6,1.63,1.63,0,0,0,.85,0,.28.28,0,0,0,.22-.21c0-.11.09-.2.23-.2s.33,0,.34.24-.11.27-.29.27-.1,0-.06.08c0,.22,0,.54-.39.36a.13.13,0,0,0-.16.05.14.14,0,0,0,0,.2c.19.2.33.46.65.54a.41.41,0,0,1,.33.57c0,.15-.14.3-.26.29-.36,0-.49.25-.68.46-.3-.18-.41-.57-.74-.72-.07,0-.12-.1-.19-.1-.42,0-.66-.24-.92-.49a1.25,1.25,0,0,0-.87-.26c-.13,0-.15.1-.18.2a.35.35,0,0,1-.42.29c-.22,0-.43,0-.65,0s-.23.13-.08.23S703.42,490.39,703.28,490.58Z"
            />
            <path
              class="cls-461"
              d="M703.28,490.58c0-.18.12-.41-.19-.49-.08,0-.11-.15-.07-.25a.24.24,0,0,1,.25-.12c.18,0,.35,0,.52,0s.57,0,.52-.39a.12.12,0,0,1,.15-.11c.38.08.8,0,1.11.37.18.21.38.47.78.38.2,0,.42.22.54.36a1.22,1.22,0,0,1,.39.57c-.06.45-.24.57-.67.4a.5.5,0,0,1-.33-.24c-.13-.26-.1.08-.17.05a.21.21,0,0,1-.18-.08.53.53,0,0,1,0-.28c0,.14,0,.28-.13.38s-.47.24-.53-.18c0,0,0,.08-.09.1s-.22,0-.32-.09-.18,0-.26-.08a.49.49,0,0,1-.1-.15c-.13-.18-.13.07-.21.06a.36.36,0,0,1-.18.07c-.14,0-.19-.22-.35-.11S703.36,490.83,703.28,490.58Z"
            />
            <path
              class="cls-462"
              d="M702.57,488.81c.07-.59.61-.82,1-1.17.21-.2.58-.06.87-.16.11,0,.22.17.18.33s.08.23.17.2.44,0,.66,0,.41,0,.44.21-.2.23-.37.28c.18.44-.09.72-.63.59a1.18,1.18,0,0,0-1.08.22c-.17.13-.35.12-.43-.06s-.15-.24-.35-.23a.93.93,0,0,1-.36-.13Z"
            />
            <path
              class="cls-463"
              d="M706.34,491.37l.83.2c.1,0,.21.07.21.18s-.11.14-.2.18a4.09,4.09,0,0,1-1.1.19,9,9,0,0,1-2.48-.12l-.21-.07c-.09,0-.23-.06-.23-.19s.15-.14.24-.18a8,8,0,0,1,1.07-.2.48.48,0,0,1,.47.2c.2.22.34.14.5,0s.14-.27.31-.29a.52.52,0,0,1,.29.09c.06.11-.09.14-.09.22C706.12,491.56,706.15,491.3,706.34,491.37Z"
            />
            <path
              class="cls-464"
              d="M707.78,487.81l-.1.1c-.1.12,0,.36-.22.4a2,2,0,0,1-1.15-.06.38.38,0,0,1-.2-.4.42.42,0,0,1,.26-.35c.1-.06.25,0,.32-.12.33-.28.71-.1,1-.07S707.91,487.62,707.78,487.81Z"
            />
            <path
              class="cls-464"
              d="M708.22,490.12a.47.47,0,0,0-.46-.52c-.36-.05-.46-.44-.69-.66-.07-.07,0-.2.11-.27s.27,0,.42.11a.77.77,0,0,1,.17-.38,1.58,1.58,0,0,1,1,.89.36.36,0,0,1-.24.52A.4.4,0,0,0,708.22,490.12Z"
            />
            <path
              class="cls-465"
              d="M705.75,491.3c-.19.1-.23.35-.43.46s-.21.15-.3,0a1.26,1.26,0,0,0-.55-.39c-.22-.25-.6-.3-.74-.64,0-.09.1-.17.15-.27.14.08,0,.31.2.32.15.18.12,0,.15-.07s0-.26.2-.23.09.14.1.23,0,.09,0,.13,0,.07,0,.11,0-.09.05-.11.13-.09.19,0a.58.58,0,0,0,.09.23c0,.05.07.12.14.1s0-.11.06-.16,0-.31.18-.46c.07.26,0,.74.48.49a.16.16,0,0,1,.17.1C705.91,491.25,705.86,491.3,705.75,491.3Z"
            />
            <path
              class="cls-466"
              d="M706.34,491.37a2.85,2.85,0,0,1-.32.27c-.07.05-.18.12-.24,0s0-.18.12-.22l.13-.05a.35.35,0,0,1,.08-.32v-.24c0-.07,0-.11.12-.11s.09,0,.09.08c0,.24.17.34.29.48Z"
            />
            <path
              class="cls-467"
              d="M705.89,491.13l-.14-.09c.15-.2,0-.45.13-.68.17.21.06.43.09.63S706,491.11,705.89,491.13Z"
            />
            <path
              class="cls-468"
              d="M1233.56,522.92c1,3.08-1.21,3.75-3.32,4.4a2.49,2.49,0,0,0-1.84,2.23c3-.39-1.5,4.2,2.29,3.43,1.19-.25.66.67.37,1.19-.69,1.25.4,2.06,1,1.78,2.67-1.14,2.88,1.32,3.47,2.47.82,1.64-.69,2.48-2,3.09,0,0,.17.46.27.7.16.81-.11,2.12-.57,2-4.9-.83-5.61,5-9.46,5.78a2.59,2.59,0,0,1-1.14.06c-.94-1.26-5.08-2.92-6.71-3.88-2.83-1.69-4.92.74-7.4.69-1.06,0-2.29.28-3-.44-2.47-2.53-5.51-1.22-8.31-1.5a3.46,3.46,0,0,1-2.18-.05c-1.12-.63-1.88-1.83-3.17-2.15-2.66-.66-3.26-2.58-3.2-4.95-1.66-1.24-2.66-2.76-2.33-5a3.06,3.06,0,0,0-.82-3c-2.09-1.67-2.82-3.41-.89-5.68.68-.79.44-1.44-.6-1.75-2.46-.73-2.9-2.77-3.19-4.92,2.19-3,2.58-3,5.49-.07.27-3.77,1.25-4.14,4.79-1.79.4.4.65,1.66,1.24,1.06,2.63-2.7,5.2-.94,7,.53,3.49,2.84,6.21,1,8.5-1.07,1.81-1.63,2.88-1.16,4.77-.52,4.88,1.64,9.38,4.31,14.64,5,1.73.22,3,1.7,5.06.11C1233.51,519.88,1233,522.19,1233.56,522.92Z"
            />
            <path
              class="cls-469"
              d="M1233.56,522.92c-3-4-2,1.8-4.2,1l-1.26-2.08c-1.57-1.63-1.83,5.07-3.63-.26-.11-.33-3.64-4.24-6.59-1.52-1.2-2.84-4.75-1.61-6.37-3.69-1.13-1.46-1.9-1.53-2.67.34-1,2.49-4.23,1.72-5.74,3.62a1.29,1.29,0,0,1-1.85-.66c-1-2.6-4.58-1-5.91-3.48-.28-.54-1.51.49-2,1.32s-.66,2-1.92,1.39c-1.48-.75-1-1.92-.33-3,.78-2.15-1.5-3.79-1-5.9.08-.32,0-.4-.21-.5-5-2-5-2-4.53-6.41,3-.05,3-.05,3.49-2.87a4.51,4.51,0,0,0,4.86.69c.58-.23,1.49-.55,1.83-.29,3.11,2.37,5.72-.1,8.51-.73.25-.05.49-.28.72-.27,4.17.24,4.17.25,2.9-3.95,2.53.54,4.34-.61,6.3-1.9,1.71-1.13,3.74-1.77,5.87.48a5.51,5.51,0,0,0,5.66.53c2.54-1.3,4.37-.33,3.75,2.18-.83,3.3,2.82,1.25,3,3,1.25,1.39,1.67,3.17,2.28,4.86,1.47,2.2,2.9,2.37,4.47-1-.37,2.43,1,3.71,1.77,3.81,5.06.68,2.64,2.29,0,4.11,5.53,1.45,2.6,5,2.93,8C1239.36,517.88,1235.25,519.26,1233.56,522.92Z"
            />
            <path
              class="cls-436"
              d="M1243.28,596.82a24.29,24.29,0,0,0,6.9,8.08c.62.44,1.64,1,.85,1.78-1.32,1.34-.78,4.05-3,4.5-3.75.78-7.39,2.1-11.28,2.18a2,2,0,0,1-1.92-.94c-2.67-3.91-4-4.24-8.12-1.86a1.72,1.72,0,0,1-1.83.11c-2.16-1.37-4.69-.72-7-1.36a7.73,7.73,0,0,1-1.24-2.38c-.22-3.4-3.85-2.09-5.27-3.82,3.81-6.14,8.09-8,13.75-5.65.35-1.49.3-3.08,1.53-4.44-3.21-.65-5.82-1.48-5.67-5.12,0-1-.61-1.35-1.4-1.63-1.7-.6-1.47-1.92-1.21-3.26.36-3.67,3.58-3.14,5.86-4,1.91.16,3.86,0,6,1.39-.32-3,1.17-5.23.7-7.94-.26-1.53,1.53-2.21,2.88-2.76,3.46-.9,2.9,3,4.76,4-.35.54-.94.6-1.49.74.72.21,1.06-.36,1.51-.73,3.58,4.13,9.81,4.61,12.92,9.54,1,1.67,2.07,3.59,4.27,4.51.94.39-2,4.84-3.33,5.63-1.92,1.15-5-.45-6,2.66C1245.48,596.61,1243.69,593.83,1243.28,596.82Z"
            />
            <path
              class="cls-470"
              d="M1177.4,580.11c-3.29-.81-5.09-3-6.12-6.15a5.31,5.31,0,0,0-8-2.74c-2.49,1.74-9.2-1.14-9.66-4.1-.19-1.29,0-3-2.28-2.6-.53.09-1.4-.18-1-1.2s-.31-3.42,1.11-3.45c3-.07,6.1-3.3,9.06.12.22.26,1.55,1.16,1.8-.13.16-.81,1.87-.35,1-2-1.3-2.5.78-4.5,3.82-4,1.43-.16,2.88,1.12,4.3,0a2.3,2.3,0,0,1,1-.12c2.22,2,5,3,7.74,4.08,1.57,2-.34,2.62-1.55,3.74,3.41.26,4.15,2,3.32,5-.47,1.72.5,2.82,2.5,2.2a7.43,7.43,0,0,1,7.13,1c-.81-3.3,1.23-4.7,2.92-6.28,1.44-.38,2.68.55,4,.62,9.39.87,14.94,7,19.72,14.29a47.46,47.46,0,0,0-2.11,4.37,2.22,2.22,0,0,1-1.26,1c-2.63.38-5.43.35-7.13,3a1.7,1.7,0,0,1-1.07,0c-.39-.34-.82-1.11-1.14-1-3.59,1.26-4.93-1.69-6.86-3.54a12.87,12.87,0,0,0-1.53-.27l-1-.05c-2.48.42-4.58,2-7.53,1s-5.44-1.6-6.06-5.1c-.33-1.88-2.29-1.66-3.43-2.53-1.07,1.61.51,2.73.16,4A1.88,1.88,0,0,1,1177.4,580.11Z"
            />
            <path
              class="cls-437"
              d="M1195.05,563.51c-.84,2-3.41,3.13-2.18,6.15.47,1.15-1.67,1.72-2.44.61-1.32-1.92-3.6.5-4.72-1.37-.19.33-.31.78-.6,1-1.26.92-2.51-.08-3.64-.36s-.7-1.64-.53-2.7c.64-4.09.11-4.64-4.56-5-.05-1.53,1.17-1.43,2.11-1.6,1.44-.26,2.26-.78,1.31-2.34-1.36-2.34-4.78-2.47-5.68-5.31a12.69,12.69,0,0,0-1.46-6.78c-1.22-2.07-.57-3.19,1.43-3.09,3.06.13,4.76-1.78,6.69-3.49.59-.61,1.42-.6,3-1.07-4.23.45-4.18-5-7.93-4-1.62-1-2.3,1.21-3.66,1.08-.93-.28-1.77-.94-2.83-.67a10.67,10.67,0,0,1-4.16-.6c-1.79-.92-2.08-2.4-1.59-4.18-1-.48.2-3.47-2.5-2.17a.82.82,0,0,1-1.06-1.1c.59-1.21-.59-3,1.05-3.69s3.64-.06,5-1.54c1,1.63,3.48-.72,4.47,1.73.43,1.07,1.34-.29,2-.71.84-.54,1.2-1,.13-1.64s-1.19-1.55-.33-2.52c1.37-2.52,3.13-3.73,5.74-1.58,1,.8,2.32,0,3.22.87,1,1.35.23,4.13,3.43,3.79a1.89,1.89,0,0,1,.76,3.3c-1.32,1.42-2.91,3.25.56,4.29.45.14.76,1,1,1.57.8,2.19-1.12,5.51,2.71,6.43l-.56.53c-.64,2-3.15,2.68-3.78,5.42,1.68-1.06,3.17-2,4.35-.3,1.81,2.69.88,4.94-1.53,7,3.23-1,5.31.32,6.87,2.82C1196.29,556.05,1196.83,559.8,1195.05,563.51Z"
            />
            <path
              class="cls-471"
              d="M1217.67,578.47c-4.19-3.15-5.41-9.65-11.74-10.43a2.08,2.08,0,0,1-1.27-.85c-1.15-1.67-2.14-3.2-4.52-1.45-.7.52-1.59-.56-2-1.42a5.79,5.79,0,0,1-.07-1.86c.31-1.58,1.25-3,2.8-2.89,4.5.21,8.4-1.75,12.49-3,4.53.38,8.82,3.35,13.63,1.28.73-.31,1.38.52,1.75,1.27.73,2.27,2.54,3.61,4.35,4.94l3.53,1.29c-3.19.57-1.34,3.2-2.74,4.39-3,2.62-1.58,6.17-1.91,9.34-.16,1.5-1.09,3.15-2,2.43-1.78-1.35-4.08-.72-5.65-2.15C1222.15,578.37,1219.73,579.8,1217.67,578.47Z"
            />
            <path
              class="cls-472"
              d="M1185.48,606.17l.93,1c0,1.28-1.06,1.31-2,1.62,3.28,1.07,5.73,2.85,6.14,6.51-3.6,2.91-7.32,1.33-11,.49,2.78.87,5.41,2.34,8.61,1.2a3,3,0,0,1,3.84,1.91c.69,1.61-.47,2-1.74,2.29-3.17,1.66-6.64,2-10.12,2.38-1.15.11-1.54-.45-2-1.36-1.66-3.47-4.57-4.1-7.94-1.79-2.19,1.5-9.37-1.48-9.38-4.06,0-3-2-2.87-4-3.09-.13-5.81,4.57-8,11.52-5.48.77-5.56,2.3-6,7.87-5.23C1179.79,603,1182.32,605.2,1185.48,606.17Z"
            />
            <path
              class="cls-473"
              d="M1163.64,529.77c.38,1.36.3,3,1.93,3.66a3.46,3.46,0,0,0,4,.62,1.53,1.53,0,0,1,2.31,1,4,4,0,0,0,4.27-.31c1.68,1.73,3.32,3.49,5.1,5.12-1.84,2-3.32,4.67-6.78,3.31-.27.74-2.72,0-1.17,2.12a8.6,8.6,0,0,1,1.77,7.18c-.61,1.44-2.07,1.15-3.19,1.57l0,0c-3.36,1.49-2.26-2.6-4-3.17-2.16-1.27-4.23-1.84-6.6-.18-2.82,2-8.93-.8-9.72-4.14-.2-.85.09-2.55-1.27-2.37-2.39.32-1.84-.91-1.69-2.29.17-1.53.32-2.91,2.35-2.93,2.73,0,5.5-1.7,8.2.63.86.74,2.47-.71,2.13-1.45C1159.74,534.53,1163.73,532.73,1163.64,529.77Z"
            />
            <path
              class="cls-474"
              d="M1228.5,559.69c-.3-.62-.92-1.4-1.43-1.07-4.74,3-8.63-.89-12.91-1.46,2.82-4.73,5.87-6.2,10.53-4.92-.85-.66-1.94-.77-2.16-1.83l.23-.5c1.54-.33,1.89-3,4.13-2.07.13,0,.82-.69.92-1.13.7-3.06.66-3,4.25-2.66,1.17.12,1.13-1.24,1.74-1.84,1.31,1.58,2.38,3.07,5,3.16,3.34.11,3.73,4.28,6.34,5.87.81.49,1.28,2.27,2.74,2.78.64.23,1.34,1,.71,1.46-1.79,1.22-.9,4.19-3.67,4.86a63.18,63.18,0,0,1-11.87,2.14C1231.26,562,1230.92,559.13,1228.5,559.69Z"
            />
            <path
              class="cls-475"
              d="M1179.21,579.28c-.25-1.33-2.32-1.9-1.64-3.54a12.53,12.53,0,0,1,1.82-2.48c.16,2.42,3.32.94,3.83,3,.64,2.54.62,5.32,4.71,5.42,2.48.06,4.83,1.32,6.92-1,.15-.17.93.21,1.42.34a3.24,3.24,0,0,1,1.29,2.75c.12,4.33.15,8.67,0,13a3.17,3.17,0,0,1-1,2.46c-1,.84-2,1.7-3,2.5-.79.61-1.16,1.2-2.77.78-2.15-.55-1.27-1.73-1.7-2.86l-4,2c0-1.58,1.35-1.8,1.72-2.66-.47-1.05-5.93,0-1.37-3.21-1.87-.74-.55-2.26-.83-3.39-1.82,1.28-2.14-1.74-3.72-1.29-.58.17-1.3.3-1.74-.54.1-1.19,1.28-1.2,2-1.41,2.69-.81,3.1-2.23.66-3.54-2.63-1.4,1.21-2.71-.25-3.86C1179.9,581.64,1180.85,579.27,1179.21,579.28Z"
            />
            <path
              class="cls-476"
              d="M1196.49,599.21q-.1-9.11-.22-18.21h1c1.73,3.25,1.75,6.85,1.83,10.34.15,6.56-.83,13.24-.26,19.66.66,7.48,0,14.93.78,22.39a190,190,0,0,1,1.19,19.69,11.86,11.86,0,0,0,.09,3.16c1.47,4.9,0,9.06-3,12.9-.9,1.13-1.39,2.55-2.42,3.6a2.42,2.42,0,0,1-2.19.49c-1.31-.2-2.74-.46-3.11-1.93-.47-1.91,1.61-1.61,2.44-2.42,3.22-1.07,4.53-3.44,4.39-6.69-.53-12-1.57-23.94-1.16-36,.08-2.5-1.34-4.72-3.28-6.45-.89-1.55-2.25-2.89-2.29-4.85-1.82-3.34-4.68-5.36-8.94-6.09,2-1.48,3.91-.25,5.05-1.7a47.74,47.74,0,0,1,10.12,12.47A189.38,189.38,0,0,0,1196.49,599.21Z"
            />
            <path
              class="cls-477"
              d="M1199,581c.35.18.9.27,1,.55,1.13,2.89,3,3.88,6.12,3.06,1.1-.3.58,1.13.88,1.74-4.78,2.09-5.11,5.79-4,10.26a25.61,25.61,0,0,1,.39,5.5c-.2,4-1,8.13.8,12,1.18,2.07-.48,3.45-1.23,5,.12,12.89-.37,25.8,1.51,38.61.59,4,1.31,8.16,5.6,10.26,1.18.86,2.55,1.71,1.84,3.45-.63,1.54-2.15,1.4-3.41,1.16-2.79-.52-5.84.54-8.38-1.41a4,4,0,0,1-.62-3.41c3.22-9.35,1.13-18.82.41-28.16-.78-10-.38-20-.58-30-.17-8-.36-16.06-.79-24.08C1198.49,584.13,1197.86,582.48,1199,581Z"
            />
            <path
              class="cls-478"
              d="M1200.5,671.2c2.49.09,5,.2,7.47.27,1.13,0,2.45,1.23,3.3.08,1-1.37-.87-2.24-1.17-3.44a48,48,0,0,1,16,1.81c1.28.36,3.34.47,3.2,2.32-.11,1.61-2,1.89-3.36,2.25a78.5,78.5,0,0,1-23.51,2c-5.5-.24-11.07-.38-16.39-2.1-1.18-.38-2.88-.62-2.89-2.24s1.74-1.87,2.91-2.2c2.13-.59,4.28-1.37,6.58-1.07-.41,1-2.34,1.11-1.87,2.22.71,1.68,2.83.87,4.18,1.59C1196.92,672.67,1198.48,671.07,1200.5,671.2Z"
            />
            <path
              class="cls-479"
              d="M1185.48,606.17c-.91,0-2.43.38-2.63,0-1.9-3.46-5.8-1.5-8.42-3.28-2.24-1.52-5.18,1.12-4.43,3.9.32,1.2-.46,1.68-.69,2.45-.27.93-1.31.18-1.55-.09-2-2.24-4.2-.66-6.34-.83-4.28-.33-3.46,3-4.59,4.9-1.27-1.11-2.52-2.11-2.3-4.19.1-.91.52-2.67-1.94-2.39-1.89.22-.66-1.78-.91-2.74a1.68,1.68,0,0,1,1.48-2.29c2.56-.34,5.14-.59,7.71-.88.57.84,1.18,1.78,2.35,1.06.76-.48.63-1.25,0-1.89a4,4,0,0,1,3.4-4.13,16.89,16.89,0,0,1,7.3,1.51C1178.07,599.68,1183.21,601.24,1185.48,606.17Z"
            />
            <path
              class="cls-480"
              d="M1181.41,517.42c-1.43.21-2.62,1.4-4.19-.59-1.72-2.18-3.09,1-4.77,1.3-1.07-1.58,1.15-5.37-3.3-4.77-.71.1-.07-4.75.84-4.64,3.06.39,6.13-2.93,9.15.09.63.63,1.36.39,2-.39.51-.62.85-.82.45-1.87-.83-2.17,1.41-4.1,3.77-3.49.73.53,1.68.94.86,2.14s-1.08,1.94,1,1.56c.7-.12.77.24.92,3,.94-1,1.85-2.06,3.23-.76-2.73,2.17,4,4.72-.27,6.83a2.45,2.45,0,0,1-2.1-.87c-.72-.73-1.09-.13-1.48.44s-1.17.74-.06,1.37c1.48.85.76,1.8-.25,2.36-1.43.79-1.37-.84-1.77-1.42C1184.13,515.92,1183,514.7,1181.41,517.42Z"
            />
            <path
              class="cls-481"
              d="M1203,619.24c-1-1.57,1.47-2.72.55-4.29,3.4-4.39,7.67-7.33,13.31-8,1.15.43,1.88,1,1.09,2.36C1212.43,611.84,1208.26,616.37,1203,619.24Z"
            />
            <path
              class="cls-482"
              d="M1190.3,614.93c1.1,1.45,2.36,2.84,2.29,4.85.44,2.6-1.28,1.46-2.39,1.39.37-.72,2-.86,1.07-2.14-.61-.87-1.56-2-2.56-1.43-5,3-8.37-1.16-12.43-2.48,1.68-1.11,3.16-.84,5-.08A10.27,10.27,0,0,0,1190.3,614.93Z"
            />
            <path
              class="cls-483"
              d="M1179.21,579.28c.85-.39.37-2.14,1.49-1.89,1.39.31.49,1.41.23,2.16s.36,1.44.52,2.16c-2.79,1.79-2.79,1.79-4-1.6C1177.78,579.34,1178.52,579.35,1179.21,579.28Z"
            />
            <path
              class="cls-484"
              d="M1234.55,504.79c-1.81-1.13-2.15-3-2.28-4.86.68,0,1.2.85,1.57.87C1240.34,501.07,1234.69,503.42,1234.55,504.79Z"
            />
            <path
              class="cls-474"
              d="M1197.29,544.34c.1-.84.45-1.87,1.37-1.23,1.53,1,2.88,1.88,4.61.58.89-.67,1,0,1.28.66,1.08,2.23,2.44,2.93,4.46.86,1.35-1.39,1,1.64,2.24.92.25-1.1-1-2.18,0-3.57,2.4,2,4.78,4.42,8.34,1.75.56-.42,3.24-.29,2.53,2.2a4.62,4.62,0,0,0,.62,3.4l-.06.07a14.47,14.47,0,0,0-5.9,3.5c-1.31,1.39-3,2.16-4.91.9-5,.24-9.5-1.75-14-3.49a3.76,3.76,0,0,1-.67-1.67C1197.12,547.59,1196.54,546,1197.29,544.34Z"
            />
            <path
              class="cls-485"
              d="M1194.08,551.76c-1.63-.49-2.92-3.53-5-.56-.46.64-1.51.36-2.13-.26-.76-.77-.06-1.48.27-2.13a2.42,2.42,0,0,1,1.11-1.06c2.83-1.22,2-3.61.82-4.87-2.09-2.17-2.45,1.16-3.74,1.78-2.83-4.64,1.26-5.6,3.9-7.33-.24,4.06,4.36,4.22,5.66,7C1195.6,546.94,1195.8,549.46,1194.08,551.76Z"
            />
            <path
              class="cls-486"
              d="M1194.08,551.76c.32-2.46-.46-5,.86-7.39l2.35,0a8.15,8.15,0,0,1,.78,4.95c.08,4.76.94,9.48.76,14.25l-.72.78c-1.34.93-2.25.25-3.06-.81C1194.71,559.6,1195.6,555.58,1194.08,551.76Z"
            />
            <path
              class="cls-461"
              d="M1202.72,602.25a56.3,56.3,0,0,1-1.36-12.66c0-3.94,3.94-1.76,5.62-3.2a1.75,1.75,0,0,0,.51,0c2.43-1,4.59-2.63,7.27-3l.9-.71c1.48-1.26,2.92-2.3,3.63.66l-.36,1.52c3.1.49,3,3,3.75,5.31.78,2.46,3.44,1.39,5.23,1.87.55,1.94-3.37,3-.88,5.49.38.37-1.28,1.88-2.58,1.51-6.49-1.82-6.48-1.84-11.11,3.06a6.59,6.59,0,0,1-1.64,1,9.33,9.33,0,0,1-7.59,1.33C1202.86,604,1202.17,603.63,1202.72,602.25Z"
            />
            <path
              class="cls-487"
              d="M1219.29,583.28c-.92-1.79-2.39-.58-3.63-.66.2-1.61.14-3.35,2-4.15,2.2.24,4.81-2.64,6.59.86-.44,1-1.11,1.88-2.31,1.48C1219.43,580,1219.64,581.88,1219.29,583.28Z"
            />
            <path
              class="cls-488"
              d="M1238.63,573.72c-.44,3.56-2.51.59-3.74,1,.95-1.49,2.45-.8,3.72-1Z"
            />
            <path
              class="cls-489"
              d="M1200.5,671.2c-1.74.91-3,3.46-5.55,1.5.09-.39.06-.88.29-1.14,7.56-8.37,4.13-18.15,3.83-27.64-.28-8.62-.58-17.28-1-25.87-.46-9.26.55-18.44,0-27.65-.18-3.14-1.13-6.21-.79-9.4l1.67,0c1.28,6.6,1,13.33,1.37,20,.55,9.32.21,18.7.12,28.05-.06,5.67,1.09,11.23,1.28,16.82.23,6.73,1.21,13.59-.74,20.24A17.83,17.83,0,0,0,1200.5,671.2Z"
            />
            <path
              class="cls-477"
              d="M1214.76,583.33c-2.14,1.69-4.3,3.33-7.27,3C1208.77,582.61,1211.7,582.83,1214.76,583.33Z"
            />
            <path
              class="cls-490"
              d="M1181.3,539.81a5.68,5.68,0,0,1-5-4.82c-.85-.38-.79-1-.35-1.63,2.18,0,4.45-.34,5,2.9.27,1.6,1.71,1.68,3,.39C1184.45,539.2,1182.33,539,1181.3,539.81Z"
            />
            <path
              class="cls-491"
              d="M1169.62,534.05c-1.73,2.27-3,1.44-4-.62C1166.94,533.5,1168.39,533,1169.62,534.05Z"
            />
            <path
              class="cls-492"
              d="M1198.83,563.54c-1-4.71-2.57-9.39-.76-14.25,0,.49.06,1,.08,1.47a4.93,4.93,0,0,1,1.1,2c.73,3.24,2.92,3.62,5.67,2.88a56.61,56.61,0,0,1,7.56-1.83c2.68,1.28,3.82-1,5.14-2.41,1.5-1.59,2.93-2.52,5.08-1.47l4.12,2.71c-5.62-2.31-9,1.58-12.67,4.47-4.29,1.37-8.17,4.13-13.1,3.29C1199.18,560.14,1199,562.05,1198.83,563.54Z"
            />
            <path
              class="cls-493"
              d="M1212.48,553.86a15.14,15.14,0,0,1-11.59,3c-3-.43-2.54-3.72-2.74-6.13,2.13-.06,4.08-.28,5.91,1.61,1.39,1.44,3.76.91,5.69.44C1211,552.51,1212.11,552.1,1212.48,553.86Z"
            />
            <path
              class="cls-468"
              d="M962.78,462.68c.8,2.37-.92,2.88-2.54,3.38a1.9,1.9,0,0,0-1.42,1.71c2.31-.3-1.15,3.22,1.76,2.63.91-.19.5.52.28.92-.53.95.31,1.57.81,1.36,2.05-.87,2.21,1,2.66,1.9.63,1.25-.52,1.9-1.57,2.37,0,0,.13.35.2.54.13.62-.08,1.62-.43,1.56-3.76-.63-4.31,3.88-7.26,4.44a1.84,1.84,0,0,1-.87.05c-.73-1-3.91-2.24-5.15-3-2.18-1.3-3.78.57-5.68.53-.82,0-1.76.22-2.3-.34-1.89-1.94-4.22-.93-6.37-1.15a2.61,2.61,0,0,1-1.68,0c-.86-.48-1.44-1.4-2.43-1.65-2-.51-2.5-2-2.45-3.79a3.81,3.81,0,0,1-1.79-3.82,2.36,2.36,0,0,0-.63-2.26c-1.6-1.28-2.17-2.62-.68-4.36.52-.61.34-1.1-.46-1.34-1.89-.56-2.23-2.13-2.45-3.78,1.68-2.3,2-2.3,4.21-.05.21-2.9,1-3.18,3.68-1.38.3.31.5,1.28.95.82,2-2.07,4-.72,5.37.41,2.68,2.18,4.76.76,6.52-.82,1.39-1.26,2.21-.89,3.66-.41,3.75,1.26,7.2,3.31,11.23,3.83,1.33.17,2.28,1.3,3.89.08C962.74,460.35,962.38,462.12,962.78,462.68Z"
            />
            <path
              class="cls-469"
              d="M962.78,462.68c-2.3-3.07-1.56,1.38-3.22.75l-1-1.6c-1.2-1.24-1.4,3.9-2.78-.19-.09-.26-2.8-3.25-5.06-1.17-.92-2.17-3.65-1.23-4.89-2.83-.86-1.12-1.46-1.18-2,.26-.78,1.91-3.25,1.32-4.41,2.78a1,1,0,0,1-1.42-.51c-.75-2-3.52-.76-4.54-2.67-.21-.41-1.15.38-1.56,1s-.51,1.55-1.48,1.06c-1.13-.57-.76-1.47-.25-2.31.61-1.64-1.15-2.91-.73-4.52.06-.25,0-.31-.16-.39-3.87-1.54-3.87-1.54-3.48-4.92,2.27,0,2.27,0,2.68-2.2a3.45,3.45,0,0,0,3.72.53c.45-.17,1.15-.42,1.41-.22,2.38,1.82,4.39-.08,6.53-.56.19,0,.37-.22.55-.21,3.21.19,3.21.19,2.23-3,1.94.41,3.33-.47,4.83-1.46,1.32-.86,2.87-1.36,4.51.37a4.22,4.22,0,0,0,4.34.41c1.95-1,3.36-.26,2.87,1.67-.63,2.53,2.17,1,2.33,2.3a10.56,10.56,0,0,1,1.75,3.73c1.13,1.69,2.22,1.82,3.43-.75-.28,1.86.77,2.85,1.36,2.92,3.88.53,2,1.76,0,3.16,4.24,1.11,2,3.86,2.24,6.14C967.23,458.82,964.08,459.88,962.78,462.68Z"
            />
            <path
              class="cls-436"
              d="M970.24,519.39a18.66,18.66,0,0,0,5.29,6.19c.48.35,1.26.76.66,1.37-1,1-.6,3.11-2.28,3.46-2.88.59-5.67,1.61-8.66,1.67a1.55,1.55,0,0,1-1.47-.72c-2-3-3.07-3.26-6.23-1.43a1.3,1.3,0,0,1-1.4.08c-1.66-1-3.6-.55-5.36-1a5.68,5.68,0,0,1-.94-1.83c-.17-2.6-3-1.6-4.05-2.93,2.92-4.71,6.21-6.1,10.55-4.33.27-1.15.23-2.37,1.17-3.41-2.46-.5-4.46-1.13-4.34-3.93,0-.74-.47-1-1.08-1.25-1.3-.46-1.13-1.47-.93-2.5.28-2.82,2.75-2.41,4.5-3.06,1.46.12,3,0,4.59,1.06-.25-2.27.89-4,.54-6.08-.2-1.18,1.17-1.7,2.2-2.13,2.66-.68,2.23,2.3,3.66,3.08-.27.41-.73.45-1.15.56.56.16.82-.27,1.16-.56,2.75,3.17,7.53,3.54,9.91,7.32.81,1.28,1.59,2.76,3.28,3.46.72.3-1.54,3.71-2.55,4.32-1.47.89-3.86-.35-4.62,2C971.93,519.23,970.56,517.09,970.24,519.39Z"
            />
            <path
              class="cls-470"
              d="M919.69,506.56c-2.53-.61-3.91-2.32-4.7-4.71a4.06,4.06,0,0,0-6.17-2.1c-1.91,1.33-7.07-.88-7.41-3.15-.15-1,0-2.28-1.76-2-.4.07-1.07-.13-.73-.92s-.23-2.62.86-2.65c2.29,0,4.67-2.53,7,.1.17.2,1.19.89,1.38-.11.12-.61,1.44-.26.78-1.53-1-1.91.6-3.45,2.93-3.09,1.1-.13,2.21.86,3.31,0a1.76,1.76,0,0,1,.79-.09c1.7,1.56,3.85,2.3,5.94,3.13,1.21,1.5-.26,2-1.19,2.87,2.62.2,3.18,1.51,2.55,3.83-.36,1.31.38,2.16,1.91,1.68a5.73,5.73,0,0,1,5.48.77c-.62-2.53.94-3.6,2.24-4.82,1.1-.28,2,.43,3.11.48,7.2.67,11.46,5.4,15.13,11a37.09,37.09,0,0,0-1.62,3.36,1.73,1.73,0,0,1-1,.77c-2,.29-4.17.27-5.47,2.29a1.22,1.22,0,0,1-.82,0c-.3-.26-.63-.85-.88-.76-2.75,1-3.78-1.3-5.26-2.72a11,11,0,0,0-1.17-.21l-.81,0c-1.9.32-3.51,1.5-5.78.76s-4.17-1.22-4.64-3.91c-.26-1.44-1.76-1.27-2.64-1.94-.82,1.23.4,2.09.13,3.09A1.44,1.44,0,0,1,919.69,506.56Z"
            />
            <path
              class="cls-437"
              d="M933.23,493.83c-.65,1.51-2.61,2.4-1.67,4.72.36.88-1.28,1.32-1.87.47-1-1.48-2.76.37-3.62-1.06-.15.26-.24.6-.46.76-1,.71-1.93-.06-2.8-.27s-.54-1.26-.41-2.07c.49-3.15.09-3.56-3.49-3.83,0-1.18.9-1.1,1.61-1.23,1.11-.2,1.74-.6,1-1.8-1-1.79-3.67-1.89-4.36-4.07a9.62,9.62,0,0,0-1.12-5.2c-.93-1.59-.43-2.45,1.1-2.38,2.35.11,3.65-1.36,5.13-2.68.45-.46,1.09-.46,2.32-.82-3.24.35-3.2-3.8-6.08-3.08-1.24-.77-1.76.93-2.81.83-.71-.21-1.35-.72-2.17-.52a8,8,0,0,1-3.19-.45,2.45,2.45,0,0,1-1.22-3.21c-.78-.37.15-2.66-1.91-1.66a.63.63,0,0,1-.82-.85c.45-.93-.46-2.34.81-2.83s2.79-.05,3.86-1.18c.79,1.25,2.67-.56,3.43,1.32.33.82,1-.22,1.54-.54s.92-.77.11-1.26-.92-1.19-.26-1.93c1.05-1.94,2.4-2.87,4.4-1.22.76.62,1.78,0,2.48.67.76,1,.17,3.17,2.63,2.91a1.46,1.46,0,0,1,.58,2.54c-1,1.08-2.23,2.49.43,3.29.34.1.58.75.75,1.2.61,1.68-.86,4.23,2.07,4.93l-.43.41c-.48,1.54-2.41,2.05-2.9,4.16,1.29-.81,2.44-1.56,3.34-.23,1.39,2.06.68,3.79-1.17,5.39,2.47-.73,4.07.24,5.27,2.17C934.18,488.11,934.6,491,933.23,493.83Z"
            />
            <path
              class="cls-471"
              d="M950.59,505.31c-3.22-2.42-4.15-7.41-9-8a1.53,1.53,0,0,1-1-.65c-.88-1.28-1.64-2.45-3.47-1.11-.54.4-1.22-.43-1.56-1.09a4.29,4.29,0,0,1-.05-1.43c.23-1.21,1-2.27,2.14-2.21,3.46.16,6.45-1.35,9.59-2.33,3.48.29,6.76,2.57,10.46,1,.55-.24,1.06.4,1.34,1,.56,1.75,2,2.78,3.34,3.79l2.71,1c-2.45.44-1,2.45-2.11,3.36-2.28,2-1.21,4.74-1.46,7.17-.12,1.16-.84,2.42-1.56,1.87-1.37-1-3.13-.55-4.34-1.65C954,505.23,952.17,506.33,950.59,505.31Z"
            />
            <path
              class="cls-472"
              d="M925.89,526.56l.71.75c0,1-.81,1-1.54,1.24,2.52.82,4.4,2.19,4.71,5-2.76,2.24-5.62,1-8.48.38,2.14.67,4.16,1.79,6.61.92a2.28,2.28,0,0,1,2.94,1.47c.53,1.23-.35,1.57-1.33,1.76-2.43,1.27-5.09,1.54-7.76,1.82-.88.09-1.19-.34-1.52-1-1.28-2.67-3.51-3.15-6.09-1.38-1.68,1.16-7.2-1.13-7.2-3.12,0-2.29-1.55-2.19-3-2.36-.1-4.47,3.5-6.18,8.83-4.21.59-4.27,1.77-4.63,6-4C921.53,524.16,923.46,525.82,925.89,526.56Z"
            />
            <path
              class="cls-473"
              d="M909.13,467.94c.29,1,.23,2.27,1.48,2.81a2.65,2.65,0,0,0,3.11.47,1.18,1.18,0,0,1,1.77.73,3.09,3.09,0,0,0,3.28-.24c1.29,1.33,2.55,2.68,3.91,3.93-1.41,1.5-2.54,3.59-5.2,2.54-.21.57-2.09,0-.9,1.63a6.61,6.61,0,0,1,1.36,5.51c-.47,1.1-1.59.88-2.45,1.21l0,0c-2.58,1.14-1.73-2-3-2.44-1.66-1-3.25-1.41-5.07-.13-2.16,1.52-6.85-.62-7.46-3.18-.15-.66.07-2-1-1.82-1.84.25-1.41-.7-1.3-1.75s.24-2.24,1.8-2.25c2.1,0,4.23-1.31,6.3.48.65.57,1.9-.55,1.63-1.12C906.14,471.59,909.2,470.21,909.13,467.94Z"
            />
            <path
              class="cls-474"
              d="M958.9,490.9c-.23-.48-.71-1.08-1.1-.83-3.64,2.33-6.62-.68-9.91-1.12,2.17-3.62,4.51-4.75,8.08-3.77-.65-.51-1.48-.59-1.65-1.41l.18-.38c1.18-.25,1.44-2.33,3.17-1.59.1,0,.63-.52.7-.87.53-2.34.51-2.31,3.26-2,.9.09.87-.95,1.33-1.42,1,1.21,1.83,2.36,3.81,2.43,2.56.09,2.86,3.28,4.87,4.5.62.38,1,1.75,2.1,2.14.49.17,1,.78.54,1.11-1.37.94-.68,3.22-2.81,3.73a48,48,0,0,1-9.11,1.65C961,492.63,960.76,490.47,958.9,490.9Z"
            />
            <path
              class="cls-475"
              d="M921.08,505.93c-.19-1-1.78-1.46-1.26-2.72a9.58,9.58,0,0,1,1.4-1.9c.12,1.86,2.54.72,2.93,2.29.5,2,.48,4.08,3.62,4.16,1.9.05,3.7,1,5.31-.77.12-.14.71.16,1.09.26a2.5,2.5,0,0,1,1,2.11c.09,3.32.11,6.65,0,10a2.48,2.48,0,0,1-.81,1.89c-.77.64-1.52,1.31-2.32,1.92-.61.46-.89.92-2.12.6-1.65-.43-1-1.33-1.31-2.2l-3.09,1.52c0-1.21,1-1.38,1.33-2-.37-.81-4.55,0-1.06-2.47-1.43-.56-.42-1.73-.64-2.59-1.39,1-1.64-1.33-2.84-1-.45.13-1,.23-1.34-.42.07-.91,1-.91,1.53-1.08,2.07-.62,2.38-1.71.51-2.71s.93-2.08-.19-3C921.61,507.74,922.34,505.92,921.08,505.93Z"
            />
            <path
              class="cls-476"
              d="M934.34,521.22q-.09-7-.17-14H935c1.33,2.49,1.34,5.25,1.4,7.93.11,5-.63,10.16-.2,15.08.51,5.74,0,11.46.6,17.19a148.91,148.91,0,0,1,.92,15.11,8.48,8.48,0,0,0,.07,2.42c1.12,3.76,0,6.95-2.32,9.9a33.2,33.2,0,0,1-1.85,2.76,1.86,1.86,0,0,1-1.68.38c-1-.16-2.11-.35-2.39-1.48-.36-1.47,1.23-1.24,1.87-1.86,2.48-.82,3.48-2.64,3.37-5.13-.41-9.2-1.2-18.37-.89-27.6a6.48,6.48,0,0,0-2.51-4.94c-.69-1.2-1.73-2.23-1.77-3.73a9,9,0,0,0-6.86-4.67c1.56-1.13,3-.19,3.88-1.3a36.58,36.58,0,0,1,7.77,9.56A145.3,145.3,0,0,0,934.34,521.22Z"
            />
            <path
              class="cls-477"
              d="M936.24,507.28c.27.14.69.21.78.42.86,2.22,2.33,3,4.69,2.35.85-.23.45.87.68,1.33-3.67,1.61-3.93,4.44-3,7.87a19.09,19.09,0,0,1,.3,4.23c-.15,3.1-.75,6.23.62,9.24.91,1.59-.37,2.64-.95,3.87.1,9.89-.28,19.8,1.16,29.62.46,3.09,1,6.27,4.3,7.88.9.66,2,1.31,1.41,2.65-.48,1.18-1.65,1.07-2.62.89-2.13-.4-4.47.41-6.42-1.08a3.07,3.07,0,0,1-.48-2.63c2.47-7.17.87-14.44.31-21.6-.6-7.69-.29-15.36-.44-23-.13-6.17-.28-12.33-.6-18.48C935.87,509.65,935.39,508.38,936.24,507.28Z"
            />
            <path
              class="cls-478"
              d="M937.42,576.46c1.91.07,3.82.15,5.73.2.86,0,1.88,1,2.53.07.78-1.06-.67-1.72-.9-2.64a36.9,36.9,0,0,1,12.28,1.38c1,.29,2.56.37,2.46,1.78-.09,1.25-1.53,1.46-2.59,1.73a60.47,60.47,0,0,1-18,1.54c-4.23-.19-8.5-.29-12.58-1.61-.91-.3-2.21-.48-2.22-1.72s1.34-1.44,2.23-1.69a12.77,12.77,0,0,1,5-.82c-.31.74-1.79.85-1.43,1.7.54,1.29,2.17.67,3.2,1.23C934.67,577.58,935.86,576.36,937.42,576.46Z"
            />
            <path
              class="cls-479"
              d="M925.89,526.56c-.7,0-1.87.3-2,0-1.46-2.65-4.45-1.14-6.46-2.51-1.72-1.17-4,.86-3.4,3,.24.92-.36,1.29-.53,1.88s-1,.14-1.19-.07c-1.51-1.72-3.22-.5-4.86-.63-3.28-.25-2.66,2.27-3.52,3.76-1-.86-1.94-1.62-1.77-3.22.08-.7.4-2-1.49-1.83-1.45.16-.5-1.37-.7-2.11a1.29,1.29,0,0,1,1.14-1.75c2-.26,3.94-.46,5.91-.68.44.65.91,1.37,1.81.81.58-.36.48-1,0-1.45a3,3,0,0,1,2.61-3.17,13.16,13.16,0,0,1,5.6,1.17C920.2,521.58,924.15,522.78,925.89,526.56Z"
            />
            <path
              class="cls-480"
              d="M922.77,458.46c-1.1.16-2,1.08-3.22-.45s-2.37.78-3.66,1c-.82-1.22.89-4.12-2.53-3.66-.54.07-.05-3.65.64-3.56,2.35.29,4.7-2.25,7,.06.49.49,1,.3,1.53-.3s.65-.62.35-1.43c-.64-1.66,1.08-3.14,2.89-2.68.56.41,1.29.73.66,1.64s-.83,1.49.74,1.21c.53-.1.58.18.7,2.33.72-.78,1.42-1.58,2.48-.59-2.1,1.67,3,3.62-.21,5.24a1.84,1.84,0,0,1-1.6-.67c-.56-.56-.84-.1-1.15.35s-.89.56,0,1.05c1.14.65.58,1.38-.2,1.81-1.09.6-1-.65-1.35-1.09C924.85,457.31,924,456.37,922.77,458.46Z"
            />
            <path
              class="cls-481"
              d="M939.32,536.59c-.74-1.21,1.14-2.08.42-3.29A14.86,14.86,0,0,1,950,527.16c.88.33,1.44.8.83,1.81C946.57,530.91,943.37,534.39,939.32,536.59Z"
            />
            <path
              class="cls-482"
              d="M929.58,533.28c.85,1.12,1.82,2.18,1.77,3.73.33,2-1,1.11-1.84,1.06.28-.55,1.5-.66.82-1.64-.47-.67-1.2-1.55-2-1.1-3.82,2.29-6.43-.89-9.54-1.9,1.29-.86,2.42-.65,3.8-.06A7.86,7.86,0,0,0,929.58,533.28Z"
            />
            <path
              class="cls-483"
              d="M921.08,505.93c.65-.3.28-1.65,1.14-1.46,1.07.24.38,1.09.18,1.67s.27,1.1.4,1.65c-2.15,1.38-2.15,1.38-3.11-1.23C920,506,920.55,506,921.08,505.93Z"
            />
            <path
              class="cls-484"
              d="M963.54,448.77c-1.39-.87-1.65-2.26-1.75-3.73.53,0,.92.65,1.21.67C968,445.92,963.65,447.72,963.54,448.77Z"
            />
            <path
              class="cls-474"
              d="M935,479.12c.08-.64.35-1.43,1-.95,1.18.81,2.21,1.45,3.54.45.68-.51.75,0,1,.5.83,1.72,1.88,2.25,3.42.66,1-1.06.77,1.27,1.72.71.19-.84-.78-1.67,0-2.74,1.84,1.51,3.66,3.39,6.39,1.35.44-.33,2.49-.23,1.95,1.69a3.52,3.52,0,0,0,.48,2.6l0,.06a11,11,0,0,0-4.53,2.68c-1,1.07-2.29,1.66-3.77.69-3.86.18-7.29-1.34-10.77-2.68a2.94,2.94,0,0,1-.51-1.27C934.82,481.62,934.38,480.36,935,479.12Z"
            />
            <path
              class="cls-485"
              d="M932.49,484.81c-1.25-.38-2.24-2.71-3.86-.43-.36.49-1.16.28-1.63-.2s0-1.14.2-1.63a1.92,1.92,0,0,1,.85-.82c2.17-.93,1.56-2.76.63-3.73-1.6-1.67-1.88.89-2.86,1.36-2.18-3.56,1-4.29,3-5.62-.19,3.11,3.34,3.24,4.34,5.4C933.66,481.11,933.81,483.05,932.49,484.81Z"
            />
            <path
              class="cls-486"
              d="M932.49,484.81c.25-1.88-.36-3.87.66-5.67l1.8,0a6.24,6.24,0,0,1,.6,3.8c.06,3.65.72,7.27.58,10.93l-.55.6c-1,.71-1.73.19-2.35-.62C933,490.82,933.65,487.74,932.49,484.81Z"
            />
            <path
              class="cls-461"
              d="M939.12,523.55a43,43,0,0,1-1-9.71c0-3,3-1.35,4.32-2.46a1.28,1.28,0,0,0,.39,0c1.86-.76,3.52-2,5.57-2.32l.7-.55c1.13-1,2.24-1.76,2.78.51l-.27,1.17c2.37.37,2.32,2.32,2.87,4.07s2.64,1.06,4,1.43c.42,1.49-2.59,2.34-.68,4.21.3.29-1,1.44-2,1.16-5-1.39-5-1.41-8.52,2.35a5.2,5.2,0,0,1-1.26.73,7.19,7.19,0,0,1-5.83,1C939.23,524.92,938.69,524.61,939.12,523.55Z"
            />
            <path
              class="cls-487"
              d="M951.83,509c-.71-1.37-1.83-.44-2.78-.51.15-1.24.1-2.57,1.54-3.18,1.69.18,3.69-2,5,.66-.33.78-.85,1.44-1.76,1.13C951.94,506.45,952.1,507.93,951.83,509Z"
            />
            <path
              class="cls-488"
              d="M966.67,501.66c-.34,2.73-1.93.45-2.87.78.73-1.15,1.88-.62,2.86-.78Z"
            />
            <path
              class="cls-489"
              d="M937.42,576.46c-1.34.7-2.34,2.66-4.27,1.15.07-.3.05-.68.23-.87,5.8-6.42,3.17-13.93,2.94-21.21-.22-6.62-.45-13.26-.78-19.85-.35-7.11.43-14.15,0-21.22-.13-2.41-.86-4.77-.6-7.21l1.28,0c1,5.06.75,10.23,1,15.33.42,7.15.16,14.35.09,21.53,0,4.34.84,8.61,1,12.9.17,5.16.93,10.42-.57,15.53A13.19,13.19,0,0,0,937.42,576.46Z"
            />
            <path
              class="cls-477"
              d="M948.35,509c-1.64,1.29-3.29,2.55-5.57,2.32C943.76,508.48,946,508.65,948.35,509Z"
            />
            <path
              class="cls-490"
              d="M922.68,475.64a4.34,4.34,0,0,1-3.87-3.7c-.66-.29-.61-.74-.27-1.24,1.67,0,3.41-.27,3.82,2.22.21,1.23,1.31,1.29,2.29.3C925.1,475.17,923.47,475,922.68,475.64Z"
            />
            <path
              class="cls-491"
              d="M913.72,471.22c-1.33,1.74-2.29,1.11-3.11-.47C911.66,470.8,912.78,470.44,913.72,471.22Z"
            />
            <path
              class="cls-492"
              d="M936.13,493.85c-.78-3.61-2-7.2-.58-10.93l.06,1.13a3.63,3.63,0,0,1,.84,1.57c.57,2.49,2.25,2.77,4.35,2.21a43.1,43.1,0,0,1,5.81-1.4c2,1,2.93-.78,3.94-1.85,1.15-1.23,2.25-1.94,3.9-1.13l3.16,2.08c-4.31-1.78-6.88,1.21-9.72,3.42-3.29,1.05-6.27,3.18-10.06,2.53C936.4,491.24,936.23,492.71,936.13,493.85Z"
            />
            <path
              class="cls-493"
              d="M946.61,486.43a11.66,11.66,0,0,1-8.9,2.32c-2.33-.33-2-2.86-2.1-4.7,1.63-.05,3.13-.22,4.54,1.23,1.07,1.11,2.88.69,4.36.34C945.47,485.39,946.32,485.07,946.61,486.43Z"
            />
            <path
              class="cls-468"
              d="M799.81,479.35c.33,1-.39,1.2-1.07,1.41a.79.79,0,0,0-.59.71c1-.13-.48,1.35.74,1.1.38-.08.21.22.11.38-.22.4.13.66.34.57.86-.36.93.43,1.11.79.27.53-.22.8-.65,1a1.64,1.64,0,0,0,.08.22c.06.26,0,.68-.18.66-1.57-.27-1.8,1.61-3,1.85a.93.93,0,0,1-.37,0,11,11,0,0,0-2.15-1.25c-.91-.54-1.58.24-2.37.23-.34,0-.73.09-1-.14-.79-.82-1.76-.4-2.66-.49a1.05,1.05,0,0,1-.7,0c-.36-.2-.6-.59-1-.69-.85-.21-1-.83-1-1.59a1.57,1.57,0,0,1-.75-1.59,1,1,0,0,0-.26-.95c-.67-.53-.91-1.09-.29-1.82.22-.25.14-.46-.19-.56-.79-.23-.93-.89-1-1.58.7-1,.82-1,1.76,0,.08-1.21.4-1.33,1.53-.57.13.13.21.53.4.34.84-.87,1.67-.3,2.24.17,1.12.91,2,.32,2.73-.34.58-.53.92-.38,1.53-.17a25.18,25.18,0,0,0,4.69,1.6c.55.07,1,.54,1.62,0C799.79,478.37,799.64,479.11,799.81,479.35Z"
            />
            <path
              class="cls-469"
              d="M799.81,479.35c-1-1.29-.65.57-1.35.31l-.4-.67c-.51-.52-.59,1.63-1.17-.08,0-.11-1.16-1.36-2.11-.49-.38-.91-1.52-.51-2-1.18-.36-.47-.61-.49-.86.11-.32.8-1.35.55-1.84,1.16a.41.41,0,0,1-.59-.21c-.31-.84-1.47-.32-1.89-1.12-.1-.17-.49.16-.66.43s-.21.65-.62.44-.32-.61-.1-1c.25-.69-.48-1.22-.31-1.89,0-.11,0-.13-.06-.16-1.62-.65-1.62-.65-1.46-2.06.95,0,.95,0,1.12-.92a1.45,1.45,0,0,0,1.56.22c.18-.07.48-.18.59-.09,1,.76,1.83,0,2.72-.24.08,0,.16-.09.24-.08,1.33.08,1.33.08.92-1.27a2.55,2.55,0,0,0,2-.61,1.31,1.31,0,0,1,1.89.16,1.78,1.78,0,0,0,1.81.17c.82-.42,1.4-.11,1.2.7-.26,1.05.91.4,1,1a4.25,4.25,0,0,1,.73,1.55c.48.71.93.76,1.44-.31-.12.78.32,1.19.56,1.22,1.63.22.85.74,0,1.32,1.77.46.83,1.61.93,2.57A2.35,2.35,0,0,0,799.81,479.35Z"
            />
            <path
              class="cls-436"
              d="M802.92,503a7.84,7.84,0,0,0,2.21,2.58c.2.15.53.32.28.57-.43.43-.25,1.3-1,1.45a20,20,0,0,1-3.61.7.67.67,0,0,1-.62-.3c-.85-1.26-1.28-1.36-2.6-.6a.53.53,0,0,1-.58,0c-.7-.44-1.51-.23-2.24-.43a2.46,2.46,0,0,1-.4-.77c-.07-1.08-1.23-.66-1.69-1.22,1.22-2,2.6-2.55,4.41-1.81a2.73,2.73,0,0,1,.49-1.42c-1-.21-1.86-.48-1.82-1.64,0-.31-.19-.44-.45-.53-.54-.19-.47-.61-.38-1,.11-1.18,1.15-1,1.88-1.28a3.67,3.67,0,0,1,1.91.44c-.1-.94.38-1.67.23-2.54-.09-.49.49-.71.92-.89,1.11-.28.93,1,1.53,1.29a.71.71,0,0,1-.48.23c.23.07.34-.11.48-.23,1.15,1.32,3.15,1.48,4.14,3.06a3.17,3.17,0,0,0,1.37,1.44c.3.13-.64,1.55-1.06,1.81-.62.37-1.62-.15-1.93.85C803.63,503,803.05,502.08,802.92,503Z"
            />
            <path
              class="cls-470"
              d="M781.8,497.68a2.69,2.69,0,0,1-2-2,1.7,1.7,0,0,0-2.58-.88c-.8.56-3-.37-3.09-1.32-.07-.41,0-.95-.74-.83-.17,0-.44-.06-.3-.38s-.1-1.1.36-1.11c1,0,2-1.06,2.9,0,.07.08.5.37.58,0,0-.26.6-.11.32-.64-.41-.8.25-1.45,1.23-1.3.46-.05.92.36,1.38,0a.75.75,0,0,1,.33,0,7.58,7.58,0,0,0,2.48,1.31c.51.63-.11.84-.49,1.2,1.09.08,1.32.63,1.06,1.6-.15.55.16.9.8.7a2.43,2.43,0,0,1,2.29.32c-.26-1.05.39-1.5.93-2,.46-.12.86.18,1.3.2,3,.28,4.79,2.26,6.32,4.58-.24.46-.48.92-.68,1.4a.69.69,0,0,1-.4.33c-.84.12-1.74.11-2.28.95a.53.53,0,0,1-.35,0c-.12-.1-.26-.35-.36-.31-1.15.4-1.58-.55-2.2-1.14a4.21,4.21,0,0,0-.49-.09h-.34c-.79.13-1.47.62-2.41.31s-1.75-.51-1.94-1.63c-.11-.6-.74-.53-1.1-.81-.35.51.16.87,0,1.29A.61.61,0,0,1,781.8,497.68Z"
            />
            <path
              class="cls-437"
              d="M787.46,492.36c-.27.63-1.09,1-.7,2,.15.37-.53.55-.78.19-.42-.61-1.15.16-1.51-.44-.06.11-.1.26-.19.32-.41.3-.81,0-1.17-.11s-.23-.53-.17-.87c.2-1.31,0-1.48-1.46-1.6,0-.49.37-.46.67-.51.46-.08.73-.25.42-.75-.43-.75-1.53-.79-1.82-1.7a4.11,4.11,0,0,0-.46-2.17c-.4-.67-.19-1,.45-1a2.94,2.94,0,0,0,2.15-1.12c.19-.19.45-.19,1-.34-1.36.14-1.34-1.59-2.54-1.29-.52-.32-.74.39-1.18.35-.29-.09-.56-.3-.9-.22a3.21,3.21,0,0,1-1.34-.19,1,1,0,0,1-.51-1.34c-.32-.15.07-1.11-.8-.69a.27.27,0,0,1-.34-.36c.19-.38-.19-1,.34-1.18s1.17,0,1.61-.49c.33.52,1.12-.23,1.44.55.13.34.43-.09.64-.23s.39-.32,0-.52-.38-.5-.1-.81c.44-.81,1-1.2,1.84-.51.31.26.74,0,1,.28.32.44.07,1.33,1.1,1.22a.61.61,0,0,1,.24,1.06c-.42.45-.93,1,.18,1.37.15,0,.25.32.31.5.26.71-.35,1.77.87,2.07l-.18.16c-.2.65-1,.86-1.21,1.74.54-.34,1-.65,1.39-.09.58.86.29,1.58-.49,2.25a1.77,1.77,0,0,1,2.21.9A4.87,4.87,0,0,1,787.46,492.36Z"
            />
            <path
              class="cls-471"
              d="M794.71,497.15c-1.34-1-1.73-3.09-3.76-3.34a.71.71,0,0,1-.41-.27c-.36-.54-.68-1-1.44-.47-.23.17-.52-.18-.66-.45a2,2,0,0,1,0-.6c.1-.5.4-.95.9-.92a11.69,11.69,0,0,0,4-1c1.46.12,2.83,1.08,4.37.41.23-.1.44.17.56.41a3.26,3.26,0,0,0,1.4,1.58l1.13.42c-1,.18-.43,1-.88,1.4-.95.85-.51,2-.61,3,0,.48-.35,1-.65.78-.58-.43-1.31-.23-1.81-.69C796.15,497.12,795.37,497.58,794.71,497.15Z"
            />
            <path
              class="cls-472"
              d="M784.4,506l.29.31c0,.41-.34.42-.64.52a2.47,2.47,0,0,1,2,2.09c-1.16.93-2.35.42-3.55.16.9.28,1.74.75,2.76.38a1,1,0,0,1,1.23.61c.23.52-.14.66-.55.74a8.88,8.88,0,0,1-3.25.76c-.36,0-.49-.14-.63-.44-.53-1.11-1.47-1.31-2.55-.57-.7.48-3-.47-3-1.3s-.65-.92-1.27-1c0-1.87,1.47-2.58,3.69-1.76.25-1.78.74-1.93,2.53-1.68A19.52,19.52,0,0,1,784.4,506Z"
            />
            <path
              class="cls-473"
              d="M777.39,481.54c.12.44.1.95.62,1.18a1.11,1.11,0,0,0,1.3.19.49.49,0,0,1,.74.31,1.3,1.3,0,0,0,1.37-.1c.54.55,1.06,1.12,1.63,1.64-.59.63-1.06,1.5-2.17,1.06-.09.24-.87,0-.38.68a2.73,2.73,0,0,1,.57,2.3c-.19.46-.66.37-1,.51h0c-1.07.48-.72-.83-1.27-1a1.75,1.75,0,0,0-2.11,0c-.91.63-2.87-.26-3.12-1.33-.07-.28,0-.82-.41-.76-.77.1-.59-.29-.54-.73s.1-.94.75-.94c.88,0,1.77-.55,2.63.2.28.23.8-.23.68-.47C776.14,483.07,777.42,482.49,777.39,481.54Z"
            />
            <path
              class="cls-474"
              d="M798.18,491.13c-.09-.2-.29-.45-.45-.34-1.52,1-2.77-.29-4.14-.47.9-1.51,1.88-2,3.37-1.58-.27-.21-.62-.24-.69-.58l.08-.16c.49-.11.6-1,1.32-.67,0,0,.26-.22.29-.36.23-1,.22-1,1.37-.85.37,0,.36-.4.55-.59a2,2,0,0,0,1.59,1c1.07,0,1.2,1.38,2,1.88.26.16.41.73.87.9.21.07.43.32.23.46-.57.39-.29,1.35-1.17,1.56a20.59,20.59,0,0,1-3.81.69C799.07,491.86,799,491,798.18,491.13Z"
            />
            <path
              class="cls-475"
              d="M782.39,497.41c-.09-.42-.75-.61-.53-1.13a4,4,0,0,1,.58-.8c0,.78,1.06.31,1.23,1,.2.82.2,1.71,1.51,1.74.79,0,1.55.42,2.22-.32.05-.06.3.06.45.1a1.08,1.08,0,0,1,.42.89c0,1.38.05,2.77,0,4.16a1,1,0,0,1-.34.79c-.32.27-.63.55-1,.8s-.38.39-.89.25c-.69-.17-.41-.55-.55-.91l-1.29.63c0-.51.44-.58.56-.85-.16-.34-1.91,0-.44-1-.6-.24-.18-.73-.27-1.09-.58.41-.69-.55-1.19-.41-.19.05-.42.1-.56-.17,0-.39.41-.39.64-.46.86-.26,1-.71.21-1.13s.39-.87-.08-1.24C782.61,498.17,782.91,497.41,782.39,497.41Z"
            />
            <path
              class="cls-476"
              d="M787.92,503.8c0-1.94,0-3.89-.07-5.84h.33a7.13,7.13,0,0,1,.59,3.31c.05,2.1-.27,4.24-.08,6.3.21,2.4,0,4.79.25,7.18.22,2.09.37,4.2.38,6.31a3.39,3.39,0,0,0,0,1,4.33,4.33,0,0,1-1,4.14c-.29.36-.44.81-.77,1.15a.78.78,0,0,1-.7.16c-.42-.07-.88-.15-1-.62s.51-.52.78-.77A2,2,0,0,0,788.1,524c-.17-3.84-.51-7.67-.38-11.53a2.67,2.67,0,0,0-1.05-2.06,3.36,3.36,0,0,1-.73-1.56,3.73,3.73,0,0,0-2.87-1.95c.65-.48,1.26-.08,1.62-.55a15.48,15.48,0,0,1,3.25,4A59.12,59.12,0,0,0,787.92,503.8Z"
            />
            <path
              class="cls-477"
              d="M788.72,498c.11,0,.29.08.32.17a1.45,1.45,0,0,0,2,1c.35-.09.18.37.28.56-1.54.67-1.64,1.86-1.27,3.29a8.54,8.54,0,0,1,.13,1.76,7.89,7.89,0,0,0,.25,3.86c.38.67-.15,1.11-.39,1.62a91.41,91.41,0,0,0,.48,12.38c.19,1.29.42,2.62,1.8,3.29.37.27.81.55.59,1.1s-.69.45-1.1.38c-.89-.17-1.87.17-2.68-.46a1.27,1.27,0,0,1-.2-1.09c1-3,.36-6,.13-9-.25-3.21-.12-6.41-.19-9.62-.05-2.57-.11-5.15-.25-7.72C788.57,499,788.36,498.44,788.72,498Z"
            />
            <path
              class="cls-478"
              d="M789.21,526.88l2.4.08c.35,0,.78.4,1,0s-.28-.72-.38-1.1a15.12,15.12,0,0,1,5.14.58c.4.11,1.07.15,1,.74s-.63.61-1.08.72a24.79,24.79,0,0,1-7.53.64,19.47,19.47,0,0,1-5.26-.67c-.38-.12-.92-.2-.92-.72s.56-.6.93-.7a5.2,5.2,0,0,1,2.11-.34c-.13.3-.75.35-.6.71.23.54.91.27,1.34.51C788.06,527.35,788.56,526.84,789.21,526.88Z"
            />
            <path
              class="cls-479"
              d="M784.4,506c-.3,0-.79.13-.85,0-.61-1.11-1.86-.48-2.7-1.05s-1.66.36-1.42,1.25c.1.38-.15.54-.22.78s-.42.06-.5,0c-.63-.71-1.34-.21-2-.26-1.37-.11-1.11.95-1.47,1.57-.41-.36-.81-.68-.74-1.34,0-.3.17-.86-.62-.77-.6.07-.21-.57-.29-.88a.53.53,0,0,1,.47-.73c.82-.11,1.65-.19,2.47-.28.19.26.38.57.76.33s.2-.4,0-.6a1.27,1.27,0,0,1,1.09-1.33,5.64,5.64,0,0,1,2.34.49C782,504,783.67,504.45,784.4,506Z"
            />
            <path
              class="cls-480"
              d="M783.09,477.58c-.46.07-.84.45-1.34-.19s-1,.33-1.53.42c-.34-.51.37-1.72-1.06-1.53-.23,0,0-1.52.27-1.48,1,.12,2-.95,2.93,0,.2.21.44.13.64-.12s.27-.27.14-.6a.92.92,0,0,1,1.21-1.12c.24.17.54.3.28.68s-.35.63.31.51c.22,0,.24.07.29,1,.3-.32.59-.66,1-.24-.88.69,1.26,1.51-.09,2.19a.78.78,0,0,1-.67-.28c-.24-.24-.35,0-.48.14s-.37.24,0,.44.25.58-.08.76-.44-.27-.56-.46C784,477.1,783.6,476.71,783.09,477.58Z"
            />
            <path
              class="cls-481"
              d="M790,510.22c-.31-.5.47-.87.17-1.37a6.21,6.21,0,0,1,4.27-2.57c.37.14.6.34.35.76C793,507.85,791.7,509.3,790,510.22Z"
            />
            <path
              class="cls-482"
              d="M785.94,508.84a2.48,2.48,0,0,1,.73,1.56c.14.83-.41.46-.76.44.11-.23.62-.28.34-.68s-.5-.65-.82-.46c-1.6.95-2.68-.38-4-.8a1.48,1.48,0,0,1,1.58,0A3.34,3.34,0,0,0,785.94,508.84Z"
            />
            <path
              class="cls-483"
              d="M782.39,497.41c.27-.12.11-.68.47-.6s.16.45.08.69.11.46.16.69c-.89.58-.89.58-1.3-.51C781.93,497.43,782.16,497.44,782.39,497.41Z"
            />
            <path
              class="cls-484"
              d="M800.12,473.53a1.78,1.78,0,0,1-.73-1.55c.22,0,.39.27.51.27C802,472.34,800.17,473.09,800.12,473.53Z"
            />
            <path
              class="cls-474"
              d="M788.18,486.21c0-.27.15-.6.44-.39.49.34.92.6,1.48.18.28-.21.31,0,.41.21.34.72.78.94,1.43.28.43-.45.32.53.71.3.08-.36-.32-.7,0-1.15.77.63,1.53,1.42,2.67.56.18-.13,1-.09.82.71a1.44,1.44,0,0,0,.2,1.09l0,0a4.65,4.65,0,0,0-1.9,1.12,1.13,1.13,0,0,1-1.57.29,11,11,0,0,1-4.5-1.12,1.3,1.3,0,0,1-.22-.53A3.34,3.34,0,0,1,788.18,486.21Z"
            />
            <path
              class="cls-485"
              d="M787.15,488.59c-.52-.16-.93-1.13-1.61-.18-.15.21-.48.12-.68-.08s0-.48.08-.68a.81.81,0,0,1,.36-.35c.91-.38.65-1.15.26-1.55-.67-.7-.79.37-1.2.56-.9-1.48.41-1.79,1.25-2.35-.08,1.31,1.4,1.36,1.82,2.26A2.62,2.62,0,0,1,787.15,488.59Z"
            />
            <path
              class="cls-486"
              d="M787.15,488.59c.11-.79-.15-1.62.28-2.37h.75a2.65,2.65,0,0,1,.25,1.59c0,1.53.3,3,.24,4.57l-.23.25c-.43.3-.72.08-1-.26C787.35,491.1,787.64,489.82,787.15,488.59Z"
            />
            <path
              class="cls-461"
              d="M789.92,504.78a18.56,18.56,0,0,1-.44-4.06c0-1.27,1.27-.57,1.81-1a.43.43,0,0,0,.16,0,10.34,10.34,0,0,1,2.33-1l.29-.23c.47-.4.94-.73,1.16.21l-.11.49c1,.16,1,1,1.2,1.7s1.1.45,1.68.6c.17.63-1.08,1-.29,1.76.13.12-.41.6-.82.49-2.09-.59-2.08-.59-3.56,1a2.28,2.28,0,0,1-.53.3,3,3,0,0,1-2.43.43C790,505.35,789.74,505.22,789.92,504.78Z"
            />
            <path
              class="cls-487"
              d="M795.23,498.69c-.29-.57-.76-.18-1.16-.21.06-.51,0-1.07.64-1.33.71.08,1.55-.84,2.12.28-.14.33-.36.6-.74.47C795.28,497.63,795.34,498.25,795.23,498.69Z"
            />
            <path
              class="cls-488"
              d="M801.43,495.63c-.14,1.14-.8.19-1.2.32.31-.47.79-.25,1.2-.32Z"
            />
            <path
              class="cls-489"
              d="M789.21,526.88c-.56.29-1,1.11-1.78.48,0-.13,0-.28.09-.37,2.42-2.68,1.33-5.81,1.23-8.86-.09-2.76-.19-5.53-.32-8.29-.15-3,.17-5.91,0-8.86a18,18,0,0,1-.26-3l.54,0a48.92,48.92,0,0,1,.44,6.4c.17,3,.06,6,0,9,0,1.82.35,3.6.41,5.4.07,2.15.39,4.35-.24,6.48A5.64,5.64,0,0,0,789.21,526.88Z"
            />
            <path
              class="cls-477"
              d="M793.78,498.71a3.2,3.2,0,0,1-2.33,1C791.86,498.48,792.8,498.55,793.78,498.71Z"
            />
            <path
              class="cls-490"
              d="M783.05,484.76a1.82,1.82,0,0,1-1.61-1.54c-.28-.13-.26-.31-.12-.53.7,0,1.43-.11,1.6.93.09.52.55.54,1,.13C784.06,484.56,783.38,484.5,783.05,484.76Z"
            />
            <path
              class="cls-491"
              d="M779.31,482.91c-.55.73-1,.46-1.3-.19C778.45,482.74,778.92,482.59,779.31,482.91Z"
            />
            <path
              class="cls-492"
              d="M788.67,492.37c-.32-1.51-.82-3-.24-4.57l0,.47a1.69,1.69,0,0,1,.35.66c.23,1,.93,1.16,1.82.92a16.71,16.71,0,0,1,2.42-.58c.86.41,1.22-.33,1.65-.78s.94-.81,1.63-.47l1.32.87c-1.8-.74-2.88.51-4.06,1.43-1.38.44-2.62,1.33-4.21,1.06C788.78,491.28,788.71,491.89,788.67,492.37Z"
            />
            <path
              class="cls-493"
              d="M793.05,489.27a4.93,4.93,0,0,1-3.72,1c-1-.14-.81-1.2-.87-2a2.15,2.15,0,0,1,1.89.52c.45.46,1.2.29,1.82.14C792.57,488.83,792.93,488.7,793.05,489.27Z"
            />
            <path
              class="cls-494"
              d="M720.29,490.89c-.26-.21-.27-.34,0-.68-.23,0-.42,0-.29-.32.06-.13-.06-.07-.09-.09s-.17-.1-.15-.22a.18.18,0,0,1,.24-.14c.07,0,.12.07.14-.06a.59.59,0,0,1,.55-.36c.12,0,.14,0,.13-.09s.09-.21.16-.19c.26.09.51-.15.77,0s.22,0,.2-.17a.24.24,0,0,1,.11-.27.21.21,0,0,1,.27,0s.06.07.08.06c.44-.18.62.23.92.38a.58.58,0,0,0,.53.12.19.19,0,0,1,.27.09c-.18.17-.05.27.06.39a.13.13,0,0,1-.14.12,2.52,2.52,0,0,0-.41.06c-.15-.07-.3,0-.45,0a.77.77,0,0,1-.3-.06c-.18-.24-.44-.2-.68-.19s-.29,0-.32-.2-.06-.15-.14-.14-.47,0-.66.2-.27.22-.39.35-.12.32.08.39a.57.57,0,0,1,.3.2.17.17,0,0,0,.26,0,.73.73,0,0,1,.81-.15c.09,0,.17-.08.27-.05s.35.16.3.41c0,.07.07.11.13.15s.06.17,0,.25a.15.15,0,0,1-.23,0c-.26-.26-.58-.18-.89-.16a1.41,1.41,0,0,0-1.31.27A.08.08,0,0,1,720.29,490.89Z"
            />
            <path
              class="cls-461"
              d="M721.66,490.58a.89.89,0,0,1,.93.13s.07.08.11.05a.39.39,0,0,0,.11-.17s0-.06-.08-.07-.12,0-.11,0c.06-.26-.18-.36-.26-.54s.07-.18.15-.26a.89.89,0,0,1,.33-.21,1.14,1.14,0,0,0,.58,0c.07,0,.13,0,.16.1s-.21.25-.31.39-.23.18-.18.35a.28.28,0,0,0,.31.19c.15,0,.13.18.23.23s.31.11.37.29.06.19.17.23.13.08.1.18,0,.21.19.24l.37.05c.1.07,0,.13,0,.18a.62.62,0,0,1-.25.11.39.39,0,0,1-.15,0c-.12-.08-.25,0-.38,0a.42.42,0,0,1-.22-.29c0,.11,0,.22-.21.22h-.07a.8.8,0,0,0-.26,0c-.3-.07-.3-.07-.28-.41,0,.12,0,.31-.15.33s-.09-.15-.12-.24,0,.1,0,.15,0,.21-.14.2-.06-.15-.07-.22c0,.11,0,.25-.15.27s-.39-.14-.47-.44c0,.12-.1.2-.23.17s-.1-.15-.11-.22c0,.09.07.18,0,.29-.17-.09-.39,0-.53-.17s0-.13,0-.2a.31.31,0,0,0-.12-.11.21.21,0,0,1-.09-.25.26.26,0,0,1,.25-.17h.31A.34.34,0,0,0,721.66,490.58Z"
            />
            <path
              class="cls-441"
              d="M724.86,489.2c.15,0,0-.1,0-.15s.19-.3.34-.2a.46.46,0,0,0,.34.06.46.46,0,0,1,.41.16.84.84,0,0,0,.88.35.24.24,0,0,1,.26.16c0,.05-.07.22.13.14a.17.17,0,0,1,.24.13c0,.18-.13.2-.2.3a.86.86,0,0,1-.39,0c-.25,0-.44.14-.66.2s-.1.1-.11.17-.13.27-.32.24a1,1,0,0,0-.53-.13.2.2,0,0,1-.21-.2c0-.16-.11-.35.13-.48s0-.17-.09-.16a2.57,2.57,0,0,0-.48,0c-.18,0-.31,0-.31-.24s-.06-.14-.12-.2c0-.22.22-.16.36-.18S724.76,489.27,724.86,489.2Z"
            />
            <path
              class="cls-495"
              d="M726.46,492.22c.09,0,.2,0,.2.13s-.13.12-.21.14a7,7,0,0,1-2.18.13,16,16,0,0,0-2.19-.12,3.24,3.24,0,0,1-1.15-.13c-.09,0-.22,0-.21-.15s.13-.13.22-.16c.31-.11.65-.07,1-.15a.38.38,0,0,1,.29.1c.3.2.32.19.53-.11l.07,0a.34.34,0,0,1,.21.06s0,.18.09.08a.35.35,0,0,1,.14-.06c.21,0,.39.09.6.07a.47.47,0,0,1,.3.12c.15.12.18,0,.2-.1a.12.12,0,0,1,.1,0,.43.43,0,0,1,.13.09.31.31,0,0,0,.52,0,.39.39,0,0,1,.35-.15l.07,0a.36.36,0,0,0,.34.11,1.87,1.87,0,0,0,.34.08C726.27,492.2,726.37,492.17,726.46,492.22Z"
            />
            <path
              class="cls-496"
              d="M725.81,490.73c.17,0,.3,0,.27-.23a.14.14,0,0,1,.08-.17c.19-.07.37-.17.55-.22a1.23,1.23,0,0,1,.6,0l.05.05c-.11.14-.19.33-.44.26-.09,0-.13.08-.08.17s.09.1.11.18a.26.26,0,0,0,0,.24c.14.24.13.41,0,.54a.37.37,0,0,1-.52,0,2.24,2.24,0,0,0-.6-.7A.1.1,0,0,1,725.81,490.73Z"
            />
            <path
              class="cls-497"
              d="M726.92,490.79c-.11-.07-.25-.14-.18-.3s.19-.16.33-.06.06,0,.08-.06a.25.25,0,0,1,.21-.17,2.31,2.31,0,0,1,.51.48c.08.14.17.25.11.4s-.2.2-.36.19C727.21,491.23,727,491.07,726.92,490.79Z"
            />
            <path
              class="cls-498"
              d="M721.66,490.58c0,.19,0,.28-.24.26s-.28.07-.44,0-.17.06-.19.15,0,.15.11.21.21-.06.13.11-.43,0-.64-.06,0-.25-.1-.37A1.25,1.25,0,0,1,721.66,490.58Z"
            />
            <path
              class="cls-499"
              d="M726.92,490.79c.11.34.49.29.7.48-.06.26-.17.46-.49.39-.06,0-.08,0-.08.06,0,.27-.23.27-.43.25s-.11-.06-.17-.09c-.21-.12-.15-.23,0-.35.13.06.24.15.4.07a.31.31,0,0,0,.08-.51C726.84,491,726.77,490.9,726.92,490.79Z"
            />
            <path
              class="cls-500"
              d="M722.74,491.91c-.1.34-.27.4-.53.19a2.59,2.59,0,0,0-.31-.19c-.09-.15-.26-.15-.39-.22s-.11-.28,0-.45l.06.11c0,.07,0,.22.11.22s.1-.13.12-.21,0-.09.09-.09.07.07.07.12a.36.36,0,0,0,.25.41c.14.05.24.05.22-.14a.57.57,0,0,1,.05-.33c.12.15,0,.32.08.48a.64.64,0,0,0,.08-.42c0-.05,0-.11.08-.11s.07.05.09.09S722.83,491.74,722.74,491.91Z"
            />
            <path
              class="cls-501"
              d="M724.86,489.2c0,.11,0,.19-.11.11a.48.48,0,0,0-.53,0,.09.09,0,0,1-.11,0l0,0c-.07-.06-.22,0-.23-.13s.13-.17.23-.23a.52.52,0,0,0,.47.11A.31.31,0,0,1,724.86,489.2Z"
            />
            <path
              class="cls-502"
              d="M720.39,491.26c.14-.09.28,0,.41,0s.15,0,.23,0a.35.35,0,0,0,0,.2.57.57,0,0,0-.32-.08A.27.27,0,0,1,720.39,491.26Z"
            />
            <path
              class="cls-503"
              d="M726.51,491.84l.11.13c0,.12-.13.15-.16.25a.23.23,0,0,1-.27,0C726.21,492,726.39,492,726.51,491.84Z"
            />
            <path
              class="cls-504"
              d="M726.51,491.84c0,.21-.25.22-.32.38a.47.47,0,0,1-.38-.1.89.89,0,0,1-.31-.11h-.06c-.06,0-.16-.06-.09-.17s.15,0,.23,0a.21.21,0,0,0,.13-.3,1.22,1.22,0,0,0-.45-.53.15.15,0,0,0-.23.05c-.09.16-.17.12-.24,0s.09-.25,0-.4a.82.82,0,0,1-.38,0,.46.46,0,0,0-.42.09.45.45,0,0,1-.45.08.54.54,0,0,0-.38-.27c-.24-.05-.26-.35-.07-.53l.45-.42c.15-.17.38,0,.53-.15l.11,0c.16,0,.24.08.2.25s.07.19.16.15.39.06.59,0,.17.06.18.15-.1.22-.2.23c-.1.41.1.53.46.51.06,0,.13.07.2.11a2.36,2.36,0,0,1,.64.8C726.44,491.64,726.26,491.78,726.51,491.84Z"
            />
            <path
              class="cls-505"
              d="M722.84,489.46a1,1,0,0,1-.33.28c-.08.05-.15.09-.15.19a.28.28,0,0,1-.39.09.47.47,0,0,0-.51.08c-.26.23-.32.22-.53-.05-.06-.07-.13,0-.19-.06a.32.32,0,0,1-.26-.24.29.29,0,0,1,.12-.3,4.91,4.91,0,0,1,.48-.43c.21-.16.47-.1.7-.13s.16.09.13.22.07.18.11.15c.19-.15.38,0,.56,0S722.83,489.3,722.84,489.46Z"
            />
            <path
              class="cls-504"
              d="M724.8,491.69c-.19.11-.35-.06-.54,0l0,0c-.15-.1.08-.29-.05-.34s-.22-.12-.21-.27a.76.76,0,0,1,.76-.13c.06,0,0,.09,0,.13a.18.18,0,0,0,0,.31.43.43,0,0,1,.16.29C724.87,491.66,724.84,491.67,724.8,491.69Z"
            />
            <path
              class="cls-506"
              d="M724.64,491s.11-.11,0-.1c-.24,0-.5-.08-.71.11-.06-.18-.23-.21-.38-.27a.47.47,0,0,0,.41-.14.52.52,0,0,1,.57-.06l.1,0c.09,0,.21-.19.25,0a.4.4,0,0,1-.1.44v0A.1.1,0,0,1,724.64,491Z"
            />
            <path
              class="cls-507"
              d="M724.8,491.69l.07-.06c.14.08.32,0,.44.15a.09.09,0,0,1,0,.07l.1.15a.44.44,0,0,0-.29.11c-.38.32-.4.32-.73-.05-.06,0-.09-.09,0-.16h.16a.13.13,0,0,0,.18.07c.08,0,0-.12,0-.17S724.9,491.78,724.8,491.69Z"
            />
            <path
              class="cls-508"
              d="M724.33,492.08c.06.07.12.14,0,.22s-.13,0-.19-.05l-.31-.19a.46.46,0,0,1-.28-.25c.28,0,.07-.31.23-.43.07.19.05.41.26.51A.29.29,0,0,1,724.33,492.08Z"
            />
            <path
              class="cls-509"
              d="M722.74,491.91c0-.18,0-.37,0-.54,0,.11,0,.22,0,.35.1-.14,0-.29.06-.42s0-.09.07-.1.08.05.09.11a1.08,1.08,0,0,1,0,.18c-.07.21,0,.25.21.26,0,.18-.22.08-.33.14l-.15,0h0Z"
            />
            <path
              class="cls-500"
              d="M723.52,491.79c-.09.07-.24.08-.3.21a.49.49,0,0,1-.15.1c-.06,0-.15.12-.2,0s.08-.11.12-.16-.08-.07-.1-.13.27,0,.37-.09A.3.3,0,0,1,723.52,491.79Z"
            />
            <path
              class="cls-510"
              d="M725.5,492c.11,0,.25,0,.31.11C725.67,492.2,725.56,492.18,725.5,492Z"
            />
            <path
              class="cls-511"
              d="M725.34,491.85l-.47-.22c-.09-.1-.12-.23-.25-.32s-.12-.21,0-.31h.16c.06,0,.14.18.17,0a.16.16,0,0,1,.24-.12,1.21,1.21,0,0,1,.59.65C725.9,491.75,725.64,491.92,725.34,491.85Z"
            />
            <path
              class="cls-460"
              d="M547.28,502.58c-.31-.12-.59-.25-.45-.68,0-.07-.06-.08-.1-.12-.39-.3-.41-.52-.09-.89.3,0,.62-.05.8.29a.2.2,0,0,0,.32,0,1.25,1.25,0,0,1,1.11-.23c.36.07.48-.06.56-.44a.22.22,0,0,1,.16-.17c.08,0,.17-.08.13-.19s-.13-.1-.22-.09a4.52,4.52,0,0,0-.64,0c-.2,0-.36,0-.38-.28s-.1-.2-.27-.19a1.79,1.79,0,0,0-1.51,1.08.22.22,0,0,1-.13.12c-.35,0-.45-.07-.34-.36s0-.14-.1-.16a.25.25,0,0,1-.2-.33.24.24,0,0,1,.34-.17c.12,0,.17,0,.16-.1s.06-.25.13-.23c.35.06.64-.27,1-.19a.3.3,0,0,0,.41-.2c0-.06,0-.12.06-.17s.16-.17.2-.13c.34.27.55-.35.84-.13a.58.58,0,0,0,.46.08.61.61,0,0,1,.59.26,1.19,1.19,0,0,0,.6.4c0,.18-.19.15-.28.22a.32.32,0,0,0,.07.6,1.63,1.63,0,0,0,.85,0,.28.28,0,0,0,.22-.21c0-.11.09-.2.23-.2s.33,0,.34.24-.11.27-.29.27-.1,0-.06.08c0,.22,0,.54-.39.36a.13.13,0,0,0-.16.05.14.14,0,0,0,0,.2c.19.2.33.46.65.54a.41.41,0,0,1,.33.57c0,.15-.14.3-.26.29-.36,0-.49.25-.68.46-.3-.18-.41-.57-.74-.72-.07,0-.12-.1-.19-.1-.42,0-.66-.24-.92-.49a1.25,1.25,0,0,0-.87-.26c-.13,0-.15.1-.18.2a.35.35,0,0,1-.42.29c-.22,0-.43,0-.65,0s-.23.13-.08.23S547.42,502.39,547.28,502.58Z"
            />
            <path
              class="cls-461"
              d="M547.28,502.58c0-.18.12-.41-.19-.49-.08,0-.11-.15-.07-.25a.24.24,0,0,1,.25-.12c.18,0,.35,0,.52,0s.57,0,.52-.39a.12.12,0,0,1,.15-.11c.38.08.8,0,1.11.37.18.21.38.47.78.38.2,0,.42.22.54.36a1.22,1.22,0,0,1,.39.57c-.06.45-.24.57-.67.4a.5.5,0,0,1-.33-.24c-.13-.26-.1.08-.17.05a.21.21,0,0,1-.18-.08.53.53,0,0,1,0-.28c0,.14,0,.28-.13.38s-.47.24-.53-.18c0,0,0,.08-.09.1s-.22,0-.32-.09-.18,0-.26-.08a.49.49,0,0,1-.1-.15c-.13-.18-.13.07-.21.06a.36.36,0,0,1-.18.07c-.14,0-.19-.22-.35-.11S547.36,502.83,547.28,502.58Z"
            />
            <path
              class="cls-462"
              d="M546.57,500.81c.07-.59.61-.82,1-1.17.21-.2.58-.06.87-.16.11,0,.22.17.18.33s.08.23.17.2.44,0,.66,0,.41,0,.44.21-.2.23-.37.28c.18.44-.09.72-.63.59a1.18,1.18,0,0,0-1.08.22c-.17.13-.35.12-.43-.06s-.15-.24-.35-.23a.93.93,0,0,1-.36-.13Z"
            />
            <path
              class="cls-463"
              d="M550.34,503.37l.83.2c.1,0,.21.07.21.18s-.11.14-.2.18a4.09,4.09,0,0,1-1.1.19,9,9,0,0,1-2.48-.12l-.21-.07c-.09,0-.23-.06-.23-.19s.15-.14.24-.18a8,8,0,0,1,1.07-.2.48.48,0,0,1,.47.2c.2.22.34.14.5,0s.14-.27.31-.29a.52.52,0,0,1,.29.09c.06.11-.09.14-.09.22C550.12,503.56,550.15,503.3,550.34,503.37Z"
            />
            <path
              class="cls-464"
              d="M551.78,499.81l-.1.1c-.1.12,0,.36-.22.4a2,2,0,0,1-1.15-.06.38.38,0,0,1-.2-.4.42.42,0,0,1,.26-.35c.1-.06.25,0,.32-.12.33-.28.71-.1,1-.07S551.91,499.62,551.78,499.81Z"
            />
            <path
              class="cls-464"
              d="M552.22,502.12a.47.47,0,0,0-.46-.52c-.36-.05-.46-.44-.69-.66-.07-.07,0-.2.11-.27s.27,0,.42.11a.77.77,0,0,1,.17-.38,1.58,1.58,0,0,1,1,.89.36.36,0,0,1-.24.52A.4.4,0,0,0,552.22,502.12Z"
            />
            <path
              class="cls-465"
              d="M549.75,503.3c-.19.1-.23.35-.43.46s-.21.15-.3,0a1.26,1.26,0,0,0-.55-.39c-.22-.25-.6-.3-.74-.64,0-.09.1-.17.15-.27.14.08,0,.31.2.32.15.18.12,0,.15-.07s0-.26.2-.23.09.14.1.23,0,.09,0,.13,0,.07,0,.11,0-.09.05-.11.13-.09.19,0a.58.58,0,0,0,.09.23c0,.05.07.12.14.1s0-.11.06-.16,0-.31.18-.46c.07.26,0,.74.48.49a.16.16,0,0,1,.17.1C549.91,503.25,549.86,503.3,549.75,503.3Z"
            />
            <path
              class="cls-466"
              d="M550.34,503.37a2.85,2.85,0,0,1-.32.27c-.07.05-.18.12-.24,0s0-.18.12-.22l.13-.05a.35.35,0,0,1,.08-.32v-.24c0-.07,0-.11.12-.11s.09,0,.09.08c0,.24.17.34.29.48Z"
            />
            <path
              class="cls-467"
              d="M549.89,503.13l-.14-.09c.15-.2,0-.45.13-.68.17.21.06.43.09.63S550,503.11,549.89,503.13Z"
            />
            <path
              class="cls-494"
              d="M558.29,497.89c-.26-.21-.27-.34,0-.68-.23,0-.42,0-.29-.32.06-.13-.06-.07-.09-.09s-.17-.1-.15-.22a.18.18,0,0,1,.24-.14c.07,0,.12.07.14-.06a.59.59,0,0,1,.55-.36c.12,0,.14,0,.13-.09s.09-.21.16-.19c.26.09.51-.15.77,0s.22,0,.2-.17a.24.24,0,0,1,.11-.27.21.21,0,0,1,.27,0s.06.07.08.06c.44-.18.62.23.92.38a.58.58,0,0,0,.53.12.19.19,0,0,1,.27.09c-.18.17-.05.27.06.39a.13.13,0,0,1-.14.12,2.52,2.52,0,0,0-.41.06c-.15-.07-.3,0-.45,0a.77.77,0,0,1-.3-.06c-.18-.24-.44-.2-.68-.19s-.29,0-.32-.2-.06-.15-.14-.14-.47,0-.66.2-.27.22-.39.35-.12.32.08.39a.57.57,0,0,1,.3.2.17.17,0,0,0,.26,0,.73.73,0,0,1,.81-.15c.09,0,.17-.08.27-.05s.35.16.3.41c0,.07.07.11.13.15s.06.17,0,.25a.15.15,0,0,1-.23,0c-.26-.26-.58-.18-.89-.16a1.41,1.41,0,0,0-1.31.27A.08.08,0,0,1,558.29,497.89Z"
            />
            <path
              class="cls-461"
              d="M559.66,497.58a.89.89,0,0,1,.93.13s.07.08.11.05a.39.39,0,0,0,.11-.17s0-.06-.08-.07-.12,0-.11,0c.06-.26-.18-.36-.26-.54s.07-.18.15-.26a.89.89,0,0,1,.33-.21,1.14,1.14,0,0,0,.58,0c.07,0,.13,0,.16.1s-.21.25-.31.39-.23.18-.18.35a.28.28,0,0,0,.31.19c.15,0,.13.18.23.23s.31.11.37.29.06.19.17.23.13.08.1.18,0,.21.19.24l.37.05c.1.07,0,.13,0,.18a.62.62,0,0,1-.25.11.39.39,0,0,1-.15,0c-.12-.08-.25,0-.38,0a.42.42,0,0,1-.22-.29c0,.11,0,.22-.21.22h-.07a.8.8,0,0,0-.26,0c-.3-.07-.3-.07-.28-.41,0,.12,0,.31-.15.33s-.09-.15-.12-.24,0,.1,0,.15,0,.21-.14.2-.06-.15-.07-.22c0,.11,0,.25-.15.27s-.39-.14-.47-.44c0,.12-.1.2-.23.17s-.1-.15-.11-.22c0,.09.07.18,0,.29-.17-.09-.39,0-.53-.17s0-.13,0-.2a.31.31,0,0,0-.12-.11.21.21,0,0,1-.09-.25.26.26,0,0,1,.25-.17h.31A.34.34,0,0,0,559.66,497.58Z"
            />
            <path
              class="cls-441"
              d="M562.86,496.2c.15,0,0-.1,0-.15s.19-.3.34-.2a.46.46,0,0,0,.34.06.46.46,0,0,1,.41.16.84.84,0,0,0,.88.35.24.24,0,0,1,.26.16c0,.05-.07.22.13.14a.17.17,0,0,1,.24.13c0,.18-.13.2-.2.3a.86.86,0,0,1-.39,0c-.25,0-.44.14-.66.2s-.1.1-.11.17-.13.27-.32.24a1,1,0,0,0-.53-.13.2.2,0,0,1-.21-.2c0-.16-.11-.35.13-.48s0-.17-.09-.16a2.57,2.57,0,0,0-.48,0c-.18,0-.31,0-.31-.24s-.06-.14-.12-.2c0-.22.22-.16.36-.18S562.76,496.27,562.86,496.2Z"
            />
            <path
              class="cls-495"
              d="M564.46,499.22c.09,0,.2,0,.2.13s-.13.12-.21.14a7,7,0,0,1-2.18.13,16,16,0,0,0-2.19-.12,3.24,3.24,0,0,1-1.15-.13c-.09,0-.22,0-.21-.15s.13-.13.22-.16c.31-.11.65-.07,1-.15a.38.38,0,0,1,.29.1c.3.2.32.19.53-.11l.07,0a.34.34,0,0,1,.21.06s0,.18.09.08a.35.35,0,0,1,.14-.06c.21,0,.39.09.6.07a.47.47,0,0,1,.3.12c.15.12.18,0,.2-.1a.12.12,0,0,1,.1,0,.43.43,0,0,1,.13.09.31.31,0,0,0,.52,0,.39.39,0,0,1,.35-.15l.07,0a.36.36,0,0,0,.34.11,1.87,1.87,0,0,0,.34.08C564.27,499.2,564.37,499.17,564.46,499.22Z"
            />
            <path
              class="cls-496"
              d="M563.81,497.73c.17,0,.3,0,.27-.23a.14.14,0,0,1,.08-.17c.19-.07.37-.17.55-.22a1.23,1.23,0,0,1,.6,0l.05.05c-.11.14-.19.33-.44.26-.09,0-.13.08-.08.17s.09.1.11.18a.26.26,0,0,0,0,.24c.14.24.13.41,0,.54a.37.37,0,0,1-.52,0,2.24,2.24,0,0,0-.6-.7A.1.1,0,0,1,563.81,497.73Z"
            />
            <path
              class="cls-497"
              d="M564.92,497.79c-.11-.07-.25-.14-.18-.3s.19-.16.33-.06.06,0,.08-.06a.25.25,0,0,1,.21-.17,2.31,2.31,0,0,1,.51.48c.08.14.17.25.11.4s-.2.2-.36.19C565.21,498.23,565,498.07,564.92,497.79Z"
            />
            <path
              class="cls-498"
              d="M559.66,497.58c0,.19,0,.28-.24.26s-.28.07-.44,0-.17.06-.19.15,0,.15.11.21.21-.06.13.11-.43,0-.64-.06,0-.25-.1-.37A1.25,1.25,0,0,1,559.66,497.58Z"
            />
            <path
              class="cls-499"
              d="M564.92,497.79c.11.34.49.29.7.48-.06.26-.17.46-.49.39-.06,0-.08,0-.08.06,0,.27-.23.27-.43.25s-.11-.06-.17-.09c-.21-.12-.15-.23,0-.35.13.06.24.15.4.07a.31.31,0,0,0,.08-.51C564.84,498,564.77,497.9,564.92,497.79Z"
            />
            <path
              class="cls-500"
              d="M560.74,498.91c-.1.34-.27.4-.53.19a2.59,2.59,0,0,0-.31-.19c-.09-.15-.26-.15-.39-.22s-.11-.28,0-.45l.06.11c0,.07,0,.22.11.22s.1-.13.12-.21,0-.09.09-.09.07.07.07.12a.36.36,0,0,0,.25.41c.14.05.24.05.22-.14a.57.57,0,0,1,.05-.33c.12.15,0,.32.08.48a.64.64,0,0,0,.08-.42c0-.05,0-.11.08-.11s.07.05.09.09S560.83,498.74,560.74,498.91Z"
            />
            <path
              class="cls-501"
              d="M562.86,496.2c0,.11,0,.19-.11.11a.48.48,0,0,0-.53,0,.09.09,0,0,1-.11,0l0,0c-.07-.06-.22,0-.23-.13s.13-.17.23-.23a.52.52,0,0,0,.47.11A.31.31,0,0,1,562.86,496.2Z"
            />
            <path
              class="cls-502"
              d="M558.39,498.26c.14-.09.28,0,.41,0s.15,0,.23,0a.35.35,0,0,0,0,.2.57.57,0,0,0-.32-.08A.27.27,0,0,1,558.39,498.26Z"
            />
            <path
              class="cls-503"
              d="M564.51,498.84l.11.13c0,.12-.13.15-.16.25a.23.23,0,0,1-.27,0C564.21,499,564.39,499,564.51,498.84Z"
            />
            <path
              class="cls-504"
              d="M564.51,498.84c0,.21-.25.22-.32.38a.47.47,0,0,1-.38-.1.89.89,0,0,1-.31-.11h-.06c-.06,0-.16-.06-.09-.17s.15,0,.23,0a.21.21,0,0,0,.13-.3,1.22,1.22,0,0,0-.45-.53.15.15,0,0,0-.23.05c-.09.16-.17.12-.24,0s.09-.25,0-.4a.82.82,0,0,1-.38,0,.46.46,0,0,0-.42.09.45.45,0,0,1-.45.08.54.54,0,0,0-.38-.27c-.24-.05-.26-.35-.07-.53l.45-.42c.15-.17.38,0,.53-.15l.11,0c.16,0,.24.08.2.25s.07.19.16.15.39.06.59,0,.17.06.18.15-.1.22-.2.23c-.1.41.1.53.46.51.06,0,.13.07.2.11a2.36,2.36,0,0,1,.64.8C564.44,498.64,564.26,498.78,564.51,498.84Z"
            />
            <path
              class="cls-505"
              d="M560.84,496.46a1,1,0,0,1-.33.28c-.08.05-.15.09-.15.19a.28.28,0,0,1-.39.09.47.47,0,0,0-.51.08c-.26.23-.32.22-.53-.05-.06-.07-.13,0-.19-.06a.32.32,0,0,1-.26-.24.29.29,0,0,1,.12-.3,4.91,4.91,0,0,1,.48-.43c.21-.16.47-.1.7-.13s.16.09.13.22.07.18.11.15c.19-.15.38,0,.56,0S560.83,496.3,560.84,496.46Z"
            />
            <path
              class="cls-504"
              d="M562.8,498.69c-.19.11-.35-.06-.54,0l0,0c-.15-.1.08-.29-.05-.34s-.22-.12-.21-.27a.76.76,0,0,1,.76-.13c.06,0,0,.09,0,.13a.18.18,0,0,0,0,.31.43.43,0,0,1,.16.29C562.87,498.66,562.84,498.67,562.8,498.69Z"
            />
            <path
              class="cls-506"
              d="M562.64,498s.11-.11,0-.1c-.24,0-.5-.08-.71.11-.06-.18-.23-.21-.38-.27a.47.47,0,0,0,.41-.14.52.52,0,0,1,.57-.06l.1,0c.09,0,.21-.19.25,0a.4.4,0,0,1-.1.44v0A.1.1,0,0,1,562.64,498Z"
            />
            <path
              class="cls-507"
              d="M562.8,498.69l.07-.06c.14.08.32,0,.44.15a.09.09,0,0,1,0,.07l.1.15a.44.44,0,0,0-.29.11c-.38.32-.4.32-.73-.05-.06,0-.09-.09,0-.16h.16a.13.13,0,0,0,.18.07c.08,0,0-.12,0-.17S562.9,498.78,562.8,498.69Z"
            />
            <path
              class="cls-508"
              d="M562.33,499.08c.06.07.12.14,0,.22s-.13,0-.19-.05l-.31-.19a.46.46,0,0,1-.28-.25c.28,0,.07-.31.23-.43.07.19.05.41.26.51A.29.29,0,0,1,562.33,499.08Z"
            />
            <path
              class="cls-509"
              d="M560.74,498.91c0-.18,0-.37,0-.54,0,.11,0,.22,0,.35.1-.14,0-.29.06-.42s0-.09.07-.1.08.05.09.11a1.08,1.08,0,0,1,0,.18c-.07.21,0,.25.21.26,0,.18-.22.08-.33.14l-.15,0h0Z"
            />
            <path
              class="cls-500"
              d="M561.52,498.79c-.09.07-.24.08-.3.21a.49.49,0,0,1-.15.1c-.06,0-.15.12-.2,0s.08-.11.12-.16-.08-.07-.1-.13.27,0,.37-.09A.3.3,0,0,1,561.52,498.79Z"
            />
            <path
              class="cls-510"
              d="M563.5,499c.11,0,.25,0,.31.11C563.67,499.2,563.56,499.18,563.5,499Z"
            />
            <path
              class="cls-511"
              d="M563.34,498.85l-.47-.22c-.09-.1-.12-.23-.25-.32s-.12-.21,0-.31h.16c.06,0,.14.18.17,0a.16.16,0,0,1,.24-.12,1.21,1.21,0,0,1,.59.65C563.9,498.75,563.64,498.92,563.34,498.85Z"
            />
            <path
              class="cls-442"
              d="M71,482.12c-.28-.58.65-1.67-.92-1.77a7.25,7.25,0,0,1-2.88-1c-3-1.65-3-1.69-5.9,0,.29-2.47-2.2-5.3,1.79-6.45,0-1.63-1.91-1.05-2.19-2.46,2-.22,2.75-3.87,5.73-2,.17.1,2.06-.89.8-2.26-.51-.56-1.38-.95-1.06-2.34,2.39,2.47,3.55-1,5.6-1,.68,0,1.23-1.1.83-2.17-.85-2.3,1.55-2.46,2.21-2.13,2.52,1.25,4.33,1.18,6.39-1,1.09-1.16,3.71,0,4.23.65,1.34,1.76,2.83,1.72,4.7,1.42-.16,1.43-1.23,2.37-.86,3.76.21.75.23,1.13,1,.66,2.43-1.55,4.52.55,6.69.52s4.62-.73,7-.5c.41,0,1.2-1.08,1.28-.25.35,3.68,2.59,2.15,4.39,1.74,2.54-.58,3.36,1.07,3.12,2.92a2.05,2.05,0,0,0,.59,2c.78.6,1.31,0,1.9-.73s7,.11,7.17,1c.18,1.12,1.76,2.72-.87,3.45-2.25.62-.86,2.88-1.36,4.33-2.42-1.21-5.12.38-7.54-.75-1.43-.91-2.07.29-2.94,1-1.43,1.22-2.21.63-2.78-1-.25-.69,1.28-1.43.09-1.61-.71-.11-2.21-.69-2.65.88-.52,1.9-1.51,1.87-3.16,1.1a4.22,4.22,0,0,0-5,1.09c-.88.95-2.15,1.45-2.68.69-1.26-1.78-3.62-.76-4.82-2.32a1.27,1.27,0,0,0-1.88-.28c-2.87,2.6-7.43,1.41-10,4.61-.74.92-1.59.48-2.46-.12-1.23-.84-.47.85-1.2,1.09C72.17,483.27,71.54,483.12,71,482.12Z"
            />
            <path
              class="cls-468"
              d="M71,482.12c.54.17,1.45.61,1.56.46.9-1.22,1.57-2.95,3.21-.7a6.68,6.68,0,0,1,3.85-2.72c2.85-1,6.11-1.17,8.38-3.59.09-.09.68.08.83.28.56.73.86,1.92,1.56,2.22,1.29.56.66-1.36,1.25-1.44s.2.84.48,1.23c1.08,1.56,2.44,3.28,3.59.33.89-2.29,2.53.39,3.29-.9,1.27-2.13,2.13-1,3,.34.33.49.77,1,1.41.54a1.17,1.17,0,0,0,.39-1.55c-.31-.69,0-1.92.34-1.62,1.42,1.18,3-.52,4.22.45,1.53,1.16-.38,1-.61,1.5a1.26,1.26,0,0,0,.57,1.77c.73.44,1-.26,1.28-.74.9-1.69,1.74-3.52,3.54-.72a1.08,1.08,0,0,1,.1,1.56c-1.38,1.85-4.18,3.26-1.88,6.23a.6.6,0,0,1-.16.65c-3,1.82-1.83,5.59-3.73,7.91.11,3.36-2.87,3.79-4.87,5.15a7.08,7.08,0,0,1-2.9,0c-3.27,0-6.07,3.41-9.38,1.79a10,10,0,0,0-7.43-.3c-3.12,1.09-5.15,2.48-5.84-2.11-.07-.48-1.06-.49-1.59-.25-2.28,1-3.76-.11-5.07-1.78-2.51-1.78-.22-3.93.62-4,2.87-.19,2.48-2.59,3.42-4,1.11-1.68.62-2.52-1.4-3.11C72.17,484.71,70.13,484.16,71,482.12Z"
            />
            <path
              class="cls-512"
              d="M107,493.52c1.73-2.27-.43-6.22,3.33-7.62.46-.17.73-.92.41-1.15-3.81-2.79,0-3.87,1.2-5.52.46-.63,1.31-1,1.26-2,.65.18,1.68.72,1.88.5,2.18-2.36,3.72-.74,5.32.7,1,1-1.87,1.92,0,3.06,1.41.86,1.79-.8,2.28-.81a26.68,26.68,0,0,1,6.58.79c1.08.25.6,1.59.79,2.46s.14,1.79-1.09,1.35c-.93-.33-.92.23-1.11.74-1.35,3.55-2.36,7.21-4.06,10.64-.42.85,1,2.09.39,3.3-1.11-.41-1.43-.21-2,1.21a1.26,1.26,0,0,1-.44.53c-2.82,1.87-1.41,2.72.81,3.4.53.16,1.17.24,1.32.95-1.94,1.54-3.8,2.81-4.06,5.9-.23,2.68-3.87,4.25-7.47,4.2-1.93-1.78-3.64-2.51-6.38-.79-3.49,2.18-4.64,1.1-5-3.75a48.06,48.06,0,0,1,.23-7.68c.69-1.75,1.72-1.71,3.29-.95s3.32,1.12,2-1.78c-.49-1.05.07-1.75,1.07-2.53C111.12,495.91,111,495.08,107,493.52Z"
            />
            <path
              class="cls-480"
              d="M101.83,512.32c.25,3.77,1.53,4.76,4.21,2.29,3.3-3,4.71-1.12,6.55,1.12a14.92,14.92,0,0,1-1.21,4.57c3.15,2,6.93,1.22,10.19,2.58.23,1.15,3.15,1.44,1,3.49-.35.33,1,2.25,1.89,1.36,2.4-2.43,4.84-.35,7.16-.31,2,0,1,2.37,1.34,3.68-3.36-.12-2.1,3.2-3.4,4.61-.46.5-.65,1.27-1.55,1.14-1.78-3.47-3.61-4.46-7.28-3.43-2.4.68-3.59.27-3.63-2.4,0-1.8-1.23-2.2-2.66-1.67-1.92.71-4.17.35-5.83,2a2.38,2.38,0,0,1-3.23.05c.91-3,1.23-3.37,5.34-6.45-1.78,1.09-2.84,1.93-4,2.66-1.29.83-2.51,1.75-4.16,1.61a3.24,3.24,0,0,1-2.19-1.07c-.86-.65,0-2.24-1.45-2.57-.58.9-.3,2.09-1,2.9a41.17,41.17,0,0,0-6.64-.76,12.1,12.1,0,0,1-8-1.75c-3-1.86-2.54-5.42.67-7.93a18.24,18.24,0,0,1,8.2-6.68c2.35-1.25,5.07-.58,7.51-1.42A4.36,4.36,0,0,1,101.83,512.32Z"
            />
            <path
              class="cls-464"
              d="M70.42,496.09a6.2,6.2,0,0,0,5.78.74c1.81-.61,2.74,1.17,2.56,2.77-.08.71-.52,1.18.31,1.59,1.17.56,1-.36,1.09-1a1.77,1.77,0,0,1,2.68-1.27c2.68,1.63,4.28-.05,6-1.5,1.24.51-.47,2.57.89,2.39s3.76,2.43,4.51-1c.13-.58.49-.94.92-.55,1.9,1.72,3.14-.77,4.77-.65a5.43,5.43,0,0,1,.13,5.52c-1.86,1.4-3.87,2.38-6.3,1.94-1.87-.33-2.77,1.38-4.21,1.91-1.18.32-2.74.1-2.81,2-3,3.35-6.62,3-10.4,1.75-1.73-.38-3.37-1.31-4.24,1.56-.73,2.42-2.95.44-4.46.58a8.08,8.08,0,0,1-8.25-4.41c-.43-1-.53-1.54.42-2,2-.85,2.6-2.9,3.92-4.32,1.15-1.23,1.93-2.55,4-2.66C69.45,499.46,71,498.36,70.42,496.09Z"
            />
            <path
              class="cls-513"
              d="M80.21,549.55c-1.29,2.13-4.7,2.89-7.14,1.84a29.57,29.57,0,0,0-4.27-1c-1.36-.36-2.55-3.53-1.89-5a4.09,4.09,0,0,0,1.3-1.57c3.28-6.7,9.21-8.86,16.12-9.29.38.28,0,.1.33.09,2.59,0,.69,4.48,4,3.79,2.13-.46,4.09.69,6.14,1.1,1.52.77,1.75,2.08,1.55,3.59a3.32,3.32,0,0,1-.38.94c-.35.44-1,.74-1.12,1.27-.66,4.54-4,5-7.6,5.08a6.06,6.06,0,0,1-3.91-.87C82.05,548.44,81.22,549.21,80.21,549.55Z"
            />
            <path
              class="cls-514"
              d="M105.38,531.21c.81,0,2.15.22,2.35-.14,1.53-2.79,4.6-1.55,6.74-2.75,1.79-1,4.36.93,3.83,2.7-.26.82-.89,1.27.19,1.88.84.48,1.32.22,2.14-.25,2.14-1.21,4.43-.24,6.43.49,1.33.49,1.38,2.27,1,3.71-1.53-.36-2.21.25-2.43,1.81-.38,2.74-5.3,4.9-7.7,3.43-2.18-1.34-5.25-1.17-5.79.67-1.24,4.23-4.52.27-6,2.12-.93-1.77-3-.88-4.27-1.81-2.52-.45-2.14-2.39-2-4.1a7.11,7.11,0,0,1,1.4-3.89C102.78,534,102.94,531.38,105.38,531.21Z"
            />
            <path
              class="cls-515"
              d="M121.57,522.88c-3.45.61-6.71-.42-9.93-1.35-1-.28-4-.69-.55-2.49.66-.35-.2-2.67,1.5-3.31,1-.34,2.75.61,2.85-1.51,0-.32,0-.61.51-.69,3.73-.6,4.1-1.39,3-6.1,1.76,0,3.1-1.61,4.94-1.35,2.09.51,5.11,0,3.83,4a1.22,1.22,0,0,0,2,1.24c2.38-2.34,4.65-.08,6.94-.12,1.2,0,1.07,1.54,1.28,2.56s0,1.58-1.18,1.33c-1.37-.29-1.15,1-1.3,1.58-.82,3.27-5.06,5.14-8.22,3.54C125.2,519.14,122.37,520.5,121.57,522.88Z"
            />
            <path
              class="cls-516"
              d="M84.37,518.62c-.07.33,0,.85-.22,1-1,.54-2.88.4-2.3,2.1s.73,4,3.23,4.36c2.09.34,4.18.75,6.27,1.13,0,3.64-2.87,1.79-4.5,2.3-1.81-.32-3-1.71-4.6-2.46-2.14-1,.57,1.38-.7,1-2.9,1.46-5.67,3.16-8.64,4.46a4.24,4.24,0,0,1-4,.19c-1.91-.94-2.37-3.37-4.51-4.22a1.75,1.75,0,0,1-.31-2.76c2.32-2.44,3.93-5.48,7.22-7.13,2.06-1.05,3.49-3.17,6.27-3.05,1,0,.18-1,0-1.62a1.58,1.58,0,0,1,.8-.56c2.1-.94-.48,3.34,2.5,2.1C82.62,514.73,83.58,517.1,84.37,518.62Z"
            />
            <path
              class="cls-517"
              d="M106.14,598.77a15.43,15.43,0,0,1,6.79,1.39c.65.25,1.32.65,1.34,1.44s-.68,1.16-1.31,1.46a21.21,21.21,0,0,1-6.77,1.66c-9.65,1.12-19.29,1.27-28.86-.78a9.73,9.73,0,0,1-2-.56c-.82-.37-2-.58-2-1.67-.07-1.35,1.25-1.63,2.18-1.9A47.89,47.89,0,0,1,92.05,598c.14,1.66.61,2.69,2.69,2.16a10.06,10.06,0,0,1,4.78.11c1.49.49,2.78,2.09,4.59.81C105.54,601,106.53,600.48,106.14,598.77Z"
            />
            <path
              class="cls-518"
              d="M99.83,600.83c-2,.1-3.94.13-5.9.33-1,.1-2.21.89-2.92-.07-.9-1.22.76-2,1-3.05,2.41-.84,3.1-2.95,3.73-5.09,2-6.61,1.39-13.32.91-20-.23-3.23-.32-6.48-.47-9.72.48-3-2-5.68-1-8.76.47-3.49-.33-7,.52-10.52,0-.2,0-.39,0-.59,1.31-1.79.08-3.76.39-5.63.34-2.75-.31-4.49-3.65-4.08-2.85.35-5-1.43-7.28-2.81-.57-.38-1.13-.75-1.72-1.08-.85-.54-1.85-.94-2.12-2.08l-2.42-1c3.56-1.78,5.61,1.31,8.29,2.35,3.49,1.33,6.88-.34,10.32-.34.36-1.44,0-3,1-4.35,2,.4,1.32,2,1.24,3.09-.69,9.65-1.39,19.3-1,29,.5,11.51.9,23,.75,34.55,0,2.3.65,4.6.8,6.93C100.37,598.92,100.64,599.94,99.83,600.83Z"
            />
            <path
              class="cls-519"
              d="M106.14,598.77l1.91,2.19c-1.17,1.11-2.64.46-3.92.69-4.65-2.4-4.95-6.78-4.82-11.15.26-8.74-.12-17.44-.65-26.17A153.92,153.92,0,0,1,99,538a44.73,44.73,0,0,0,.32-7.31c-.06-1.24-.09-2.36,1.27-2.93l2,.76c.3,2.23-.76,4.33-.64,6.54-1.09,2.65-2.46,5.28-.12,8-1.44.38-1.17,1.58-1.18,2.57,0,4.32,0,8.64,0,13.37,4.18-2.83,4.85-9.85,11.62-8.54-6,1.89-7.77,7.34-10.32,12.1a5,5,0,0,0-.63,2.69q.61,14.36,1.17,28.72C102.54,596.52,103.54,598.23,106.14,598.77Z"
            />
            <path
              class="cls-520"
              d="M83.77,529.25a1.22,1.22,0,0,1,1.32.59c.86,1.39,2.48,2.69.46,4.38a1.92,1.92,0,0,1-1.2.71c-2.14-.55-3.69,2.73-6,.92-1.52,3-5.88,1.77-7.4,5.12-.78,1.73-1.9,3.66-4,4.4.21-.53.74-1.36.58-1.54-2.89-3.05.24-5.14,1.74-6.37,1.25-1,1.37-2.5,2.52-3.31,1-3,4.28-2.57,6.39-3.79A11.27,11.27,0,0,1,83.77,529.25Z"
            />
            <path
              class="cls-521"
              d="M84.37,518.62a3.54,3.54,0,0,1-2-1.66c-.81-1.19-.92-1.11-3-.31-1.41-.4,1.32-3.36-1.7-2.75.52-1.42-1-2-1.25-3.14.55-.15.63-1.34,1.23-.91,3.3,2.37,6,.57,8.81-1.06a6.21,6.21,0,0,1,6.39,2.88c-.11.33-.16.91-.33.95C88.86,513.41,86.65,516.05,84.37,518.62Z"
            />
            <path
              class="cls-522"
              d="M96.23,555.05c-1.53,1.48.3,2.87.13,4.34-.14,1.25-.1,2.53-.14,3.8,0-3.23-1.94-5.05-4.43-6.79-3.7-2.58-7.35-5.2-11.58-6.85.67-.7.81-2.14,2.53-1,1.22.82,3,.79,4.54,1.14C90.38,551.3,93.29,553.2,96.23,555.05Z"
            />
            <path
              class="cls-523"
              d="M107,493.52a25.35,25.35,0,0,1,3.14,0c1,.1,2.15,1.21,1.48,1.78-1.55,1.33-1.44,4.09-4.11,4.42-1.22.15-.67,1.23-.19,1.72.64.65,2.53,1.22,1,2-.93.5-2.71,3-4.28.4-.51-.85-1.09-1.18-2-.54-1.1-.85-1-2-.85-3.2a2.56,2.56,0,0,1,1.39-1.76C103.76,496.45,106.78,496.26,107,493.52Z"
            />
            <path
              class="cls-524"
              d="M102.61,498.33l-.7,1.26c-1.19,2.3-.46,4.77-.66,7.16-.11,1.35.27,2.86-1.43,3.56a12.67,12.67,0,0,1-7,1.36l-6.39-2.88c-.84-3.29,1-2.66,2.9-2a3.58,3.58,0,0,1,1.38.14c5.9,1.83,6.12,1.73,8.43-3.65,1.46-1.7.4-3.78.84-5.64A4.33,4.33,0,0,0,102.61,498.33Z"
            />
            <path
              class="cls-525"
              d="M99.82,510.31c1.21-2.27.53-4.73.68-7.11.09-1.37-.11-2.81,1.41-3.61,0,1.23.11,2.47.16,3.7l-.24,9C101,511.81,99.89,511.58,99.82,510.31Z"
            />
            <path
              class="cls-526"
              d="M100.58,527.8c-1.19,2.74-.21,5.61-.52,8.44-1.1,10-.85,20-.47,30,.31,8.44,2.09,16.94.35,25.45a7.48,7.48,0,0,0,2,6.8,26,26,0,0,1,2.17,3.16c-1.9,2.15-3,.22-4.3-.82-1.56-8.77-1.09-17.6-1.16-26.46-.07-8.35-1-16.74-1-25.15a176.94,176.94,0,0,1,1.37-22.66,2.15,2.15,0,0,0-.6-2.25C100.53,524.2,100.53,524.2,100.58,527.8Z"
            />
            <path
              class="cls-527"
              d="M99.12,503.28c-.38,1.81,1.25,4.61-1.08,5.27-2.9.81-6.27,1-8.73-1.76,1.45-1.47,2.41-3.56,5.35-2.33C95.79,504.93,97.61,503.73,99.12,503.28Z"
            />
            <path
              class="cls-528"
              d="M84.35,534.93l.68-.78c2.78-.26,5.43-1.27,8.4-.51,2.41.61,3.12,1.69,2.79,3.9-.16,1.21-1.91,1.15-2,2.45-1.47,1.42-2.38-1.84-4-.48-.36.3-1.39-.76-2.36.41s-2.87-.23-2.32-1C87.27,536.68,84.59,536.27,84.35,534.93Z"
            />
            <path
              class="cls-442"
              d="M401.13,483.13c-.14-.3.33-.85-.46-.9a3.62,3.62,0,0,1-1.46-.52c-1.53-.84-1.52-.85-3,0,.14-1.25-1.12-2.68.9-3.26,0-.83-1-.53-1.11-1.25,1-.11,1.39-1.95,2.9-1,.09.06,1-.44.41-1.14-.26-.28-.7-.48-.54-1.18,1.21,1.25,1.79-.52,2.83-.51.34,0,.62-.56.42-1.1-.43-1.16.78-1.24,1.12-1.08a2.35,2.35,0,0,0,3.23-.51c.55-.58,1.87,0,2.14.33a2.11,2.11,0,0,0,2.37.72c-.08.72-.62,1.19-.43,1.9.1.38.11.57.48.33,1.23-.78,2.29.28,3.39.27a29.35,29.35,0,0,1,3.54-.25c.21,0,.61-.55.65-.13.18,1.86,1.31,1.08,2.22.88,1.29-.3,1.7.54,1.58,1.48a1,1,0,0,0,.29,1c.4.31.67,0,1-.37s3.55.06,3.62.5.89,1.38-.44,1.75c-1.13.31-.43,1.45-.69,2.19-1.22-.62-2.58.19-3.81-.39-.72-.45-1,.15-1.48.53-.73.61-1.12.32-1.41-.5-.13-.35.65-.72.05-.81-.36-.06-1.12-.35-1.34.44-.27,1-.77.95-1.6.56a2.14,2.14,0,0,0-2.54.55c-.44.48-1.08.73-1.35.35-.64-.9-1.83-.38-2.44-1.17a.63.63,0,0,0-1-.14c-1.45,1.31-3.76.71-5.07,2.33-.38.46-.8.24-1.25-.07-.62-.42-.23.43-.6.55C401.71,483.71,401.39,483.63,401.13,483.13Z"
            />
            <path
              class="cls-468"
              d="M401.13,483.13c.27.08.73.3.79.23.46-.62.79-1.49,1.62-.35a3.37,3.37,0,0,1,1.95-1.38c1.44-.53,3.09-.59,4.24-1.81,0-.05.34,0,.42.13.28.38.43,1,.78,1.13.66.28.34-.69.64-.73s.1.43.24.62c.55.79,1.24,1.66,1.82.17.45-1.16,1.27.2,1.66-.46.64-1.08,1.08-.49,1.52.18.17.25.39.49.71.27a.58.58,0,0,0,.2-.78c-.16-.35,0-1,.17-.82.72.6,1.5-.26,2.14.22s-.2.52-.31.76a.64.64,0,0,0,.29.9c.36.22.52-.13.65-.38.45-.85.87-1.78,1.79-.36a.55.55,0,0,1,0,.79c-.69.94-2.11,1.65-.94,3.15a.29.29,0,0,1-.09.32c-1.5.93-.92,2.84-1.88,4,.05,1.7-1.45,1.91-2.47,2.6a3.59,3.59,0,0,1-1.46,0c-1.66,0-3.07,1.73-4.75.91a5,5,0,0,0-3.75-.16c-1.58.55-2.61,1.26-3-1.06,0-.24-.53-.25-.8-.13-1.15.52-1.9,0-2.56-.9a1.09,1.09,0,0,1,.31-2c1.45-.1,1.25-1.31,1.73-2s.31-1.27-.71-1.57C401.71,484.44,400.68,484.16,401.13,483.13Z"
            />
            <path
              class="cls-512"
              d="M419.31,488.89c.88-1.14-.22-3.15,1.68-3.85.24-.09.37-.47.21-.59-1.93-1.4,0-1.95.61-2.78.23-.33.66-.52.64-1,.32.09.84.36.95.25,1.1-1.19,1.87-.37,2.68.36.5.5-.94,1,0,1.54.71.44.9-.4,1.15-.41a13.91,13.91,0,0,1,3.33.4c.55.13.3.81.4,1.25s.07.9-.55.68-.47.12-.56.37c-.69,1.8-1.19,3.65-2.06,5.39-.21.42.49,1.05.2,1.66-.56-.2-.72-.11-1,.62a.58.58,0,0,1-.23.26c-1.42.95-.71,1.38.41,1.72.27.08.59.12.67.48-1,.78-1.92,1.42-2.05,3-.12,1.36-2,2.16-3.78,2.13a2.29,2.29,0,0,0-3.23-.4c-1.76,1.1-2.34.56-2.5-1.9a24,24,0,0,1,.11-3.88c.35-.88.87-.87,1.67-.48s1.67.57,1-.9c-.25-.53,0-.88.54-1.28C421.41,490.1,421.33,489.68,419.31,488.89Z"
            />
            <path
              class="cls-480"
              d="M416.71,498.4c.13,1.9.77,2.41,2.13,1.16,1.67-1.54,2.38-.57,3.31.56a7.38,7.38,0,0,1-.61,2.31c1.59,1,3.5.62,5.15,1.31.12.58,1.6.73.51,1.76-.18.17.51,1.14,1,.69,1.21-1.23,2.45-.18,3.62-.16,1,0,.51,1.2.68,1.86-1.7-.06-1.07,1.62-1.73,2.34-.23.25-.32.64-.78.57-.9-1.75-1.82-2.25-3.68-1.73-1.21.34-1.81.13-1.83-1.22,0-.9-.62-1.11-1.35-.84-1,.36-2.11.17-2.95,1a1.19,1.19,0,0,1-1.63,0c.46-1.49.62-1.7,2.7-3.25-.9.55-1.43,1-2,1.34a3.33,3.33,0,0,1-2.1.81,1.64,1.64,0,0,1-1.11-.54c-.43-.33,0-1.13-.73-1.3-.29.46-.15,1.06-.53,1.47a20,20,0,0,0-3.36-.38,6.11,6.11,0,0,1-4.05-.89c-1.51-.94-1.29-2.74.34-4a9.24,9.24,0,0,1,4.14-3.38c1.2-.63,2.57-.29,3.8-.72A2.23,2.23,0,0,1,416.71,498.4Z"
            />
            <path
              class="cls-464"
              d="M400.83,490.19a3.1,3.1,0,0,0,2.92.37c.91-.3,1.39.59,1.29,1.41,0,.35-.26.59.16.8.59.28.49-.18.55-.51a.9.9,0,0,1,1.36-.64c1.35.82,2.16,0,3.05-.76.62.26-.24,1.3.45,1.21s1.9,1.23,2.28-.49c.06-.29.24-.47.46-.27,1,.87,1.59-.4,2.41-.34a2.74,2.74,0,0,1,.07,2.79,4,4,0,0,1-3.18,1c-.95-.17-1.4.69-2.14,1-.59.16-1.38.05-1.41,1-1.52,1.7-3.35,1.54-5.26.89-.88-.19-1.71-.66-2.15.79-.37,1.22-1.49.22-2.26.29a4.1,4.1,0,0,1-4.17-2.23c-.21-.48-.27-.78.22-1,1-.43,1.31-1.46,2-2.18s1-1.29,2-1.35A1.32,1.32,0,0,0,400.83,490.19Z"
            />
            <path
              class="cls-513"
              d="M405.78,517.22a3,3,0,0,1-3.61.93,13.89,13.89,0,0,0-2.16-.52c-.69-.18-1.29-1.78-1-2.52a2.08,2.08,0,0,0,.66-.8c1.66-3.38,4.66-4.47,8.15-4.69.19.14,0,.05.17.05,1.31,0,.34,2.26,2,1.91,1.08-.23,2.08.35,3.11.56a1.53,1.53,0,0,1,.78,1.81,1.42,1.42,0,0,1-.19.48c-.18.22-.53.37-.56.64-.34,2.29-2,2.52-3.85,2.57a3.06,3.06,0,0,1-2-.44C406.71,516.66,406.29,517.05,405.78,517.22Z"
            />
            <path
              class="cls-514"
              d="M418.5,508c.41,0,1.09.11,1.19-.07.78-1.41,2.33-.78,3.41-1.39.9-.51,2.21.47,1.94,1.36-.13.42-.45.64.09,1s.67.1,1.09-.13c1.08-.61,2.24-.12,3.25.25.67.25.7,1.14.48,1.87-.77-.18-1.11.13-1.22.92-.2,1.38-2.69,2.48-3.9,1.73s-2.65-.59-2.93.34c-.63,2.14-2.28.14-3,1.07-.47-.89-1.51-.44-2.16-.91-1.27-.23-1.08-1.21-1-2.08a3.59,3.59,0,0,1,.7-2C417.19,509.38,417.27,508,418.5,508Z"
            />
            <path
              class="cls-515"
              d="M426.69,503.74a11.14,11.14,0,0,1-5-.68c-.5-.15-2-.35-.28-1.26.34-.18-.1-1.35.76-1.68.53-.17,1.39.31,1.44-.76,0-.16,0-.31.26-.35,1.88-.31,2.08-.71,1.51-3.08.89,0,1.57-.82,2.5-.69s2.58,0,1.94,2a.62.62,0,0,0,1,.63c1.2-1.19,2.35,0,3.5-.07.61,0,.55.78.65,1.3s0,.8-.6.67-.58.5-.65.8a3,3,0,0,1-4.16,1.79A2.17,2.17,0,0,0,426.69,503.74Z"
            />
            <path
              class="cls-516"
              d="M407.88,501.58c0,.17,0,.43-.11.49-.49.27-1.46.2-1.16,1.06s.37,2,1.63,2.21c1.06.17,2.11.38,3.17.57,0,1.84-1.45.9-2.28,1.16-.91-.16-1.53-.86-2.32-1.24-1.08-.52.29.7-.36.51-1.46.74-2.86,1.6-4.37,2.26a2.15,2.15,0,0,1-2,.09c-1-.47-1.2-1.7-2.28-2.13a.88.88,0,0,1-.16-1.39c1.18-1.24,2-2.78,3.65-3.61,1-.53,1.77-1.61,3.17-1.54.5,0,.09-.53,0-.82a.72.72,0,0,1,.4-.28c1.06-.48-.24,1.68,1.27,1.06C407,499.62,407.48,500.82,407.88,501.58Z"
            />
            <path
              class="cls-517"
              d="M418.89,542.11a7.93,7.93,0,0,1,3.43.7c.33.13.67.33.68.73s-.34.59-.66.74a10.72,10.72,0,0,1-3.42.84,44.45,44.45,0,0,1-14.6-.39,5.7,5.7,0,0,1-1-.29c-.41-.18-1-.29-1-.84s.64-.82,1.1-1a24,24,0,0,1,8.39-.89c.07.84.31,1.35,1.36,1.09a5.09,5.09,0,0,1,2.42,0c.75.25,1.41,1.06,2.32.41C418.59,543.24,419.08,543,418.89,542.11Z"
            />
            <path
              class="cls-518"
              d="M415.7,543.16c-1,.05-2,.06-3,.16-.5,0-1.11.45-1.47,0s.39-1,.52-1.54c1.22-.43,1.57-1.5,1.89-2.58,1-3.34.71-6.74.46-10.13-.12-1.64-.16-3.28-.24-4.92.24-1.52-1-2.87-.52-4.43.24-1.76-.17-3.56.26-5.32,0-.1,0-.2,0-.3.66-.9,0-1.9.19-2.84.18-1.39-.15-2.27-1.84-2.07-1.45.18-2.54-.72-3.69-1.42q-.42-.28-.87-.54c-.43-.28-.93-.48-1.06-1.05l-1.23-.51c1.8-.9,2.84.67,4.19,1.19,1.77.67,3.48-.17,5.22-.17.18-.73,0-1.54.49-2.2,1,.2.67,1,.63,1.56a125.85,125.85,0,0,0-.49,14.66c.25,5.82.45,11.64.38,17.47,0,1.16.32,2.32.4,3.5C416,542.19,416.11,542.71,415.7,543.16Z"
            />
            <path
              class="cls-519"
              d="M418.89,542.11l1,1.11c-.6.56-1.34.23-2,.35-2.35-1.22-2.5-3.43-2.43-5.64.13-4.42-.07-8.82-.33-13.23a77.63,77.63,0,0,1,.16-13.29,23,23,0,0,0,.17-3.7c0-.63-.05-1.2.64-1.49l1,.39c.15,1.13-.39,2.19-.33,3.31-.54,1.33-1.24,2.67-.06,4-.72.19-.59.8-.59,1.3,0,2.18,0,4.37,0,6.76,2.12-1.43,2.45-5,5.88-4.32-3.05.95-3.93,3.71-5.22,6.12a2.54,2.54,0,0,0-.32,1.36q.31,7.26.59,14.52A2.22,2.22,0,0,0,418.89,542.11Z"
            />
            <path
              class="cls-520"
              d="M407.58,507a.62.62,0,0,1,.67.3c.43.7,1.25,1.36.23,2.21a1,1,0,0,1-.61.36c-1.08-.27-1.86,1.38-3,.46-.77,1.53-3,.9-3.74,2.6a3.8,3.8,0,0,1-2,2.22c.1-.27.37-.69.29-.78-1.46-1.54.12-2.6.88-3.22s.69-1.26,1.27-1.67c.53-1.5,2.17-1.3,3.24-1.92A5.69,5.69,0,0,1,407.58,507Z"
            />
            <path
              class="cls-521"
              d="M407.88,501.58a1.75,1.75,0,0,1-1-.84c-.41-.6-.47-.56-1.53-.15-.71-.2.67-1.7-.86-1.39.26-.72-.52-1-.63-1.59.27-.08.31-.68.62-.46,1.67,1.19,3.05.28,4.45-.54a3.14,3.14,0,0,1,3.23,1.46c-.05.17-.08.46-.16.48C410.15,499,409,500.29,407.88,501.58Z"
            />
            <path
              class="cls-522"
              d="M413.88,520c-.78.75.15,1.46.06,2.2s-.05,1.28-.07,1.92c0-1.63-1-2.55-2.24-3.43a28.55,28.55,0,0,0-5.85-3.47c.34-.35.4-1.08,1.27-.49a7,7,0,0,0,2.3.57C410.92,518.11,412.39,519.07,413.88,520Z"
            />
            <path
              class="cls-523"
              d="M419.31,488.89a14.09,14.09,0,0,1,1.59,0c.52.06,1.09.62.75.91-.79.67-.73,2.06-2.08,2.23-.62.07-.34.62-.1.87s1.28.62.52,1c-.47.26-1.37,1.53-2.16.2-.26-.43-.55-.59-1-.27-.56-.43-.5-1-.43-1.62a1.31,1.31,0,0,1,.7-.89C417.69,490.37,419.21,490.28,419.31,488.89Z"
            />
            <path
              class="cls-524"
              d="M417.1,491.32l-.35.64c-.6,1.16-.23,2.41-.33,3.62-.06.68.13,1.45-.73,1.8a6.43,6.43,0,0,1-3.55.69l-3.23-1.46c-.42-1.66.52-1.34,1.47-1a1.84,1.84,0,0,1,.7.07c3,.93,3.09.88,4.26-1.84.74-.86.2-1.92.42-2.86A2.15,2.15,0,0,0,417.1,491.32Z"
            />
            <path
              class="cls-525"
              d="M415.69,497.38c.61-1.15.27-2.39.35-3.59,0-.7-.06-1.42.71-1.83,0,.62.05,1.25.08,1.87l-.12,4.57C416.29,498.14,415.73,498,415.69,497.38Z"
            />
            <path
              class="cls-526"
              d="M416.08,506.22c-.6,1.39-.11,2.84-.27,4.27a105.17,105.17,0,0,0-.24,15.17c.16,4.27,1.07,8.57.18,12.88a3.8,3.8,0,0,0,1,3.43,11.92,11.92,0,0,1,1.1,1.6c-1,1.09-1.52.11-2.17-.41-.79-4.44-.55-8.91-.59-13.38,0-4.23-.51-8.47-.48-12.72a89.48,89.48,0,0,1,.69-11.46,1.09,1.09,0,0,0-.3-1.14C416.05,504.41,416.05,504.41,416.08,506.22Z"
            />
            <path
              class="cls-527"
              d="M415.34,493.83c-.19.91.63,2.33-.55,2.66-1.46.41-3.17.5-4.41-.89.73-.74,1.22-1.8,2.71-1.18C413.65,494.66,414.58,494.05,415.34,493.83Z"
            />
            <path
              class="cls-528"
              d="M407.87,509.83l.34-.39c1.41-.13,2.75-.65,4.25-.26,1.22.31,1.58.86,1.41,2-.08.61-1,.58-1,1.24-.75.72-1.21-.93-2-.24-.18.15-.71-.39-1.19.21s-1.45-.12-1.18-.49C409.35,510.72,408,510.51,407.87,509.83Z"
            />
          </g>
          <g id="avatares">
            <path
              class="cls-529"
              d="M850.43,482.33a1.53,1.53,0,0,1,.49,1.34l-.51,2.13a6.67,6.67,0,0,1-.26,1c-.17.18-.16.41-.23.62s-.29.72-.4,1.09a1.86,1.86,0,0,0-.08.78.58.58,0,0,0,.17.48c.11.19.34.37.08.62a.6.6,0,0,1-.35,0,.31.31,0,0,0-.4.2,2.73,2.73,0,0,1-.29.53c-.33.05-.68.05-.79.48,0,.08-.15.11-.24.13a4.44,4.44,0,0,1-1.3.23,5.72,5.72,0,0,1-2.3-.56.82.82,0,0,1-.2-.12.61.61,0,0,1-.18-.94c.33-.56.61-.68,1.22-.45.78.29,1.55.6,2.34.87a12,12,0,0,1-2.51-1.24c-.32-.2-.62-.45-1-.65a.33.33,0,0,1-.16-.22,3.76,3.76,0,0,1-.27-.73,2.22,2.22,0,0,1,.17-.88,19.92,19.92,0,0,1,1.3-3.34,4.25,4.25,0,0,1,2.42-2c.27-.11.48-.29.74-.41.1,0,.19-.05.16.11s.06.24.18.31a2.22,2.22,0,0,1,1.08,1.25c.06.18,0,.37.1.57a1.65,1.65,0,0,0,.16-.86c0-.32,0-.37.35-.37C850.12,482.33,850.28,482.19,850.43,482.33Z"
            />
            <path
              class="cls-530"
              d="M849.39,495.22a14.52,14.52,0,0,0-1.43-.41,18.45,18.45,0,0,1-3.14-1.15,2.77,2.77,0,0,1-1.38-1.8c0-.11,0-.21,0-.32a.58.58,0,0,1,.43,0,9.14,9.14,0,0,0,2.26.33.31.31,0,0,0,.19,0,4.21,4.21,0,0,0,1.32-.23.37.37,0,0,0,.33-.39c0-.19.09-.28.28-.17s.29,0,.44,0,.25,0,.36.1.15.18,0,.27c-.34.2-.73.26-1.07.45l-.08,0c-.35.12-.69.23-1,.37s-.39.36-.08.62a9.39,9.39,0,0,0,2.39,1.3,10.62,10.62,0,0,0,1.73.57c.21.05.24.15.07.28a1.36,1.36,0,0,0-.5.89,2.24,2.24,0,0,1-.52,1.07c-.58.65-1.12,1.34-1.75,1.94-.26.25-.26.31-.11.64a1.51,1.51,0,0,0,.27.39c.09.1.2.19.16.34a.18.18,0,0,1-.21,0,1.86,1.86,0,0,1-1-1.08.56.56,0,0,1,.06-.29c.07-.1.12-.21.18-.31s.17-.26.25-.4c.63-.95,1.24-1.92,1.87-2.87C849.66,495.21,849.43,495.31,849.39,495.22Z"
            />
            <path
              class="cls-531"
              d="M854.65,492.05a1.55,1.55,0,0,1,.59,1,.27.27,0,0,0,.09.2c.06.37,0,.74.06,1.1-.07.81-.07,1.62-.14,2.43a3.29,3.29,0,0,1,0,.44c0,.12,0,.24,0,.35,0,.54-.08,1.06-.07,1.6a.43.43,0,0,1-.1.23,2,2,0,0,1-1.78.21.57.57,0,0,1-.11-.46c.13-.67.14-1.36.26-2a14.51,14.51,0,0,1,.31-1.57A2.09,2.09,0,0,0,853,493a.35.35,0,0,1-.12-.15c0-.12.06-.15.13-.18l1.36-.61A.27.27,0,0,1,854.65,492.05Z"
            />
            <path
              class="cls-532"
              d="M850.43,482.33a3.29,3.29,0,0,1-.63.07c-.12,0-.11.1-.11.19a2.3,2.3,0,0,1-.11.9c0,.08,0,.23-.1.23s-.12-.16-.12-.25a2,2,0,0,0-.35-1,2.25,2.25,0,0,0-.69-.61c-.17-.12-.46-.15-.27-.48,0,0-.07,0-.11,0a.35.35,0,0,0,0-.57,1.6,1.6,0,0,1-.3-.72c.22-.45.59-.46.94,0a.28.28,0,0,0,.11-.26,1.31,1.31,0,0,1,1.19-1.25,2.44,2.44,0,0,1,.54,0c.2,0,.35.1.37.34s.29.4.49.54.21.06.25.18a1.53,1.53,0,0,0-.23.81,3.17,3.17,0,0,1-.57,1.41C850.65,482,850.43,482.09,850.43,482.33Z"
            />
            <path
              class="cls-533"
              d="M851.55,479.55a1.39,1.39,0,0,1-.74-.49.32.32,0,0,1-.09-.17c.06-.34-.17-.33-.39-.34a1.7,1.7,0,0,0-1.11.32,1,1,0,0,0-.43.81,1.33,1.33,0,0,1,0,.28c0,.1-.08.21-.19.22s-.05-.13-.08-.2a.45.45,0,0,0-.68-.11c0,.05-.06.14-.15.16a7.81,7.81,0,0,1-.2-1.27,1.07,1.07,0,0,1,.53-.94,2.59,2.59,0,0,1,2.72-.38c.19.09.4.13.59.2a.67.67,0,0,1,.53.65.31.31,0,0,0,0,.13c.28.52.23.72-.24,1.08A.18.18,0,0,0,851.55,479.55Z"
            />
            <path
              class="cls-534"
              d="M853.26,499.56a7,7,0,0,0,1,0,2,2,0,0,0,.71-.24.14.14,0,0,1,.14,0,6.73,6.73,0,0,0,1.13,1.07l.4.3a.37.37,0,0,1,.17.36c0,.1,0,.16-.09.22a1.41,1.41,0,0,1-1,.28,1.35,1.35,0,0,1-.45-.11,3.64,3.64,0,0,1-.63-.3,3.51,3.51,0,0,0-1-.43c-.46-.13-.57-.28-.57-.76a1.22,1.22,0,0,1,0-.27C853.18,499.65,853.19,499.59,853.26,499.56Z"
            />
            <path
              class="cls-535"
              d="M854.65,492.05l-1.75.79c-.06.1-.17.13-.27.18s-.46.21-.7.31-.22.11-.34,0a.69.69,0,0,1,.13-.57,2.83,2.83,0,0,0,.69-.3,13.21,13.21,0,0,0,2.12-1.16,4,4,0,0,0,1-1.19,24.55,24.55,0,0,0,1.11-2.24s0-.07,0-.11.17-.06.26-.08.08.12,0,.21l-1.2,3.36a.66.66,0,0,1-.43.47C855.11,491.82,854.88,492,854.65,492.05Z"
            />
            <path
              class="cls-536"
              d="M846.3,491.88a2.91,2.91,0,0,1-1.14,0,6.94,6.94,0,0,1-1.74-.38c-.55-.3-.57-.31-.41-.92s.38-1.31.57-2a15,15,0,0,0,3.87,2.17.88.88,0,0,1-.56-.1c-.48-.16-.94-.36-1.41-.52a6.94,6.94,0,0,0-.87-.31.69.69,0,0,0-.78.27c-.52.66-.26,1,.44,1.27A4.89,4.89,0,0,0,846.3,491.88Z"
            />
            <path
              class="cls-537"
              d="M850.2,487.41c.66.6,1.23,1.28,1.86,1.9l.54.54c.09.11,0,.18,0,.26s-.33.43-.62.47a4,4,0,0,0-.49,0,1,1,0,0,1-.43-.22.28.28,0,0,1-.12-.17,1.19,1.19,0,0,0-.17-.38,7.14,7.14,0,0,1-.58-2.16C850.14,487.56,850.12,487.47,850.2,487.41Z"
            />
            <path
              class="cls-538"
              d="M850.2,487.41a6.83,6.83,0,0,0,.51,2.14,2.16,2.16,0,0,0,.29.54c.06.08,0,.08-.08.1a.12.12,0,0,1-.15,0c-.42-.23-.83-.46-1.24-.71a.19.19,0,0,1-.12-.15.64.64,0,0,1,0-.49,20.54,20.54,0,0,1,.69-2s.07,0,.1,0C850.09,487,850,487.23,850.2,487.41Z"
            />
            <path
              class="cls-539"
              d="M856.93,487.7c-.06.09-.18,0-.24.12s-.39.18-.59.24c-.9.29-1.79.61-2.7.9a.94.94,0,0,1-.3.07.12.12,0,0,1-.09-.09l3.39-1.14C856.57,487.75,856.73,487.62,856.93,487.7Z"
            />
            <path
              class="cls-540"
              d="M852.52,490.07l.08-.22a2.27,2.27,0,0,0,.14-.51c.07,0,.11,0,.13.08a2,2,0,0,1-.35,1,.11.11,0,0,1-.08,0A.29.29,0,0,1,852.52,490.07Z"
            />
            <path
              class="cls-541"
              d="M852.83,489.4l-.09-.06c.09-.13.08-.34.27-.4l.06.05A.75.75,0,0,1,852.83,489.4Z"
            />
            <path
              class="cls-538"
              d="M847,484.42c0,.51.08,1,.13,1.52a2.63,2.63,0,0,1-.2,1.18.84.84,0,0,0,0,.73,4.05,4.05,0,0,0,1.17,1.27c.1.09.11,0,.12-.1.08-.36.15-.73.23-1.09a.27.27,0,0,1,.12-.21c-.06.34-.13.63-.2.92-.1.44-.09.78.35,1a.53.53,0,0,1,.24.23,3.25,3.25,0,0,1-.87-.54c-.61-.42-1.21-.84-1.8-1.28s-.64-.31-.38-1,.55-1.65.91-2.44C846.85,484.53,846.85,484.45,847,484.42Z"
            />
            <path
              class="cls-542"
              d="M849,491.42c.11-.08.07-.14,0-.19l-.33-.14c-.06-.09,0-.15,0-.23a.69.69,0,0,1,1-.5c.34-.06.66.11,1,.07.12,0,.2.12.19.26a.16.16,0,0,1,0,.1c-.21.11-.17.26-.07.42a1.7,1.7,0,0,1,.13.4.57.57,0,0,1,0,.13c-.08.41-.29.51-.75.39A1.9,1.9,0,0,1,849,491.42Z"
            />
            <path
              class="cls-543"
              d="M850.81,490.75c0-.17,0-.31-.22-.27a2.18,2.18,0,0,1-.91-.12.33.33,0,0,0-.06-.45s-.1-.06,0-.13.26,0,.37.05a10.69,10.69,0,0,1,1.1.47l.4.22A.58.58,0,0,1,850.81,490.75Z"
            />
            <path
              class="cls-544"
              d="M848.9,501.3c0,.22.18.33.3.48s.29.35.42.53a.26.26,0,0,1-.13.43.6.6,0,0,1-.19.06,2.15,2.15,0,0,1-1.8-.9s0-.12-.11-.15-.08-.18-.11-.27a.54.54,0,0,1-.27-.41.85.85,0,0,0-.07-.38c-.08-.36.1-.56.46-.53a1.3,1.3,0,0,1,.51.22.92.92,0,0,0,.77.17.09.09,0,0,1,.07,0c.08.14,0,.3.1.44S848.94,501.2,848.9,501.3Z"
            />
            <path
              class="cls-531"
              d="M848.71,500.56h0a.46.46,0,0,1-.18-.21c-.1-.27-.37-.41-.49-.68s-.19-.43.12-.72a28.64,28.64,0,0,0,2-2.18,1.48,1.48,0,0,0,.28-.7,1.56,1.56,0,0,1,.68-1.15,8.73,8.73,0,0,1-1.55-.48,12.25,12.25,0,0,1-2.44-1.19,4.54,4.54,0,0,1-.48-.39.32.32,0,0,1,.06-.53,7.07,7.07,0,0,1,1.27-.44,2.53,2.53,0,0,0,.74.31.85.85,0,0,1,.22.09c.18.08.37.14.56.21l.07,0c.35.11.67.27,1,.37a7.7,7.7,0,0,1,1.12.45,2,2,0,0,0,.66-.25l.33-.13a3.66,3.66,0,0,1,.78.84,1.38,1.38,0,0,1,.16,1.26,3.78,3.78,0,0,1-.51,1.05,1.49,1.49,0,0,0-.22.48c-.13,0-.19,0-.27.14-.26.34-.57.65-.86,1-.12.15-.3.24-.39.41-.68.58-1.29,1.23-2,1.8A6.34,6.34,0,0,0,848.71,500.56Z"
            />
            <path
              class="cls-545"
              d="M849.45,492.56h0a1.54,1.54,0,0,0-.58-.23l-.21-.07a1.82,1.82,0,0,0-.45-.2c-.1,0-.23-.05-.27-.17.17-.18.41-.19.62-.28l.49-.19c.07,0,.16,0,.21.06a1.23,1.23,0,0,0,.89.57c-.15.11-.37.06-.52.23a5.34,5.34,0,0,0,.72.28c.37.13.73.29,1.1.4a.22.22,0,0,1,.16.12c0,.17-.05.22-.21.16l-.87-.32A9.27,9.27,0,0,0,849.45,492.56Z"
            />
            <path
              class="cls-546"
              d="M848.5,500.34c.08.05.23.05.18.21s-.17.12-.29.1a1.73,1.73,0,0,1-.61-.26.74.74,0,0,0-.41-.16c-.33,0-.44.14-.36.47,0,.12.23.25,0,.38a1.44,1.44,0,0,1-.52-.84.37.37,0,0,1,.13-.4l.66-.57A1.83,1.83,0,0,0,848.5,500.34Z"
            />
            <path
              class="cls-547"
              d="M847.91,491.89l.51.22c.08,0,.2,0,.21.15l-.57-.2c-.08,0-.19-.05-.16-.18Z"
            />
            <path
              class="cls-548"
              d="M853.19,499.1a10.57,10.57,0,0,0-.23-1.25c-.09-.1-.08-.23-.11-.35s-.07-.4-.1-.59,0-.2,0-.29a.72.72,0,0,1,.2-.56,3.43,3.43,0,0,0,.52-1.07,1.5,1.5,0,0,0-.46-1.53c-.14-.16-.35-.27-.43-.5a.58.58,0,0,1,.28-.12,2.09,2.09,0,0,1,1,2c0,.45-.23.85-.3,1.28-.1.61-.17,1.22-.27,1.83A4.34,4.34,0,0,1,853.19,499.1Z"
            />
            <path
              class="cls-549"
              d="M852.83,489.4c.08-.14.06-.33.24-.41l3.46-1.13.16,0s.08,0,0,.08a17.54,17.54,0,0,1-1.38,2.65,4.55,4.55,0,0,1-2,1.53q-.66.3-1.29.63a.44.44,0,0,1-.33.07c-.09-.11,0-.22,0-.32.21-.63.41-1.26.61-1.89a.36.36,0,0,1,.13-.21Z"
            />
            <path
              class="cls-550"
              d="M852.52,490.36c-.2.76-.48,1.5-.7,2.26a.94.94,0,0,0,0,.16,1.37,1.37,0,0,0-.15.56,6.52,6.52,0,0,1-1.15-.4s0,0,0,0h0c.29.1.58.19.86.3s.21,0,.21-.13a3,3,0,0,1,.22-.86c.09-.31.21-.61.29-.93s.14-.43.22-.64.05-.23.18-.28Z"
            />
            <path
              class="cls-551"
              d="M852.33,490.65a3.11,3.11,0,0,1-.2.61,2.93,2.93,0,0,1-1.31.45v-.11c.17-.21.45-.18.67-.32-.26-.09-.51-.24-.79-.08-.23-.22-.14-.35.11-.45a3,3,0,0,0,.63-.23,1,1,0,0,1,.51,0C852.07,490.58,852.24,490.5,852.33,490.65Z"
            />
            <path
              class="cls-552"
              d="M852.33,490.65a.74.74,0,0,1-.38-.12c.26-.06.38-.3.57-.46l-.06.28Z"
            />
            <path
              class="cls-553"
              d="M850.82,491.71l1.31-.45c-.17.61-.36,1.21-.58,1.8-.72-.19-1.4-.51-2.15-.75a1,1,0,0,1,.72-.26C850.58,492.18,850.77,492.09,850.82,491.71Z"
            />
            <path
              class="cls-554"
              d="M850.7,491.2c0-.17.17-.19.31-.15l.65.22a5,5,0,0,1-.84.33Z"
            />
            <path
              class="cls-555"
              d="M850.48,492.89v.05a6.37,6.37,0,0,1-1-.38c.19-.08.33.07.49.11A3.6,3.6,0,0,1,850.48,492.89Z"
            />
            <path
              class="cls-556"
              d="M848.84,492.33a.63.63,0,0,1,.58.23A2.92,2.92,0,0,1,848.84,492.33Z"
            />
            <path
              class="cls-557"
              d="M854.26,490.86h-.14c-.15-.06-.38,0-.38-.27s.18-.2.32-.24.28-.27.46-.36.17-.13.27,0a.2.2,0,0,1,0,.28,1,1,0,0,0-.1.39C854.71,490.87,854.46,490.87,854.26,490.86Z"
            />
            <path
              class="cls-558"
              d="M378.28,509.41q-2.14,8.49-4.83,16.81c-.08.26-.26.52-.14.83a.7.7,0,0,0,.79.15,1.28,1.28,0,0,0,.55-.53,29.76,29.76,0,0,0,3.74-7c.53-1.61.86-3.28,1.46-4.87.45-1.22,1.09-2.33,1.63-3.49.08-.09.17.09.08,0s-.06,0-.09,0a1.2,1.2,0,0,0,0,.93,10.79,10.79,0,0,1,.06,2,32,32,0,0,1,.33,4.48q0,3.45.2,6.9a1.89,1.89,0,0,0,.56,1.49,1.12,1.12,0,0,0,1.26-.08l.17-.17a1,1,0,0,1-.1-.9,87.18,87.18,0,0,0,1.56-9.37,15.3,15.3,0,0,0,.33-3.09,5.09,5.09,0,0,0-1.5-3.74C382.29,509.77,380.3,509.26,378.28,509.41Z"
            />
            <path
              class="cls-559"
              d="M378.28,509.41a26.36,26.36,0,0,0,6.07.52,1.92,1.92,0,0,0,2.31-.68c.51-.75.2-1.54.15-2.32-.22-.22.16.37-.31.19a8.4,8.4,0,0,1-2.79-1.81,1.63,1.63,0,0,0-1.15-.28,6.9,6.9,0,0,0-1.19.14c-.94.1-1.12-.08-1.11-1,0-.17,0-.34,0-.51-.1-.43-.46-.83-.18-1.32a12.36,12.36,0,0,1-.2-1.62.75.75,0,0,1,.68-.83c.77-.13,1.55-.07,2.32-.18.38-.05.44.27.51.57.17.7.1,1.43.28,2.13a.39.39,0,0,0,.33.24c.59-.05.86.31,1.11.77a2.15,2.15,0,0,0,1,.93.87.87,0,0,0,.67-.2,1,1,0,0,0,.37-.84,17.2,17.2,0,0,0-.43-5.3c-.45-1.64-1.12-2.14-2.85-2.15a13.2,13.2,0,0,1-2-.09,2.2,2.2,0,0,0-.67.12.7.7,0,0,0-.34.21,4,4,0,0,0-2.32,1.8c-.65,1-1.35,2-2,3a2.19,2.19,0,0,0-.13,2.65,1.35,1.35,0,0,0,1.75-.15c.21-.53-.11-1.21.46-1.62a15.81,15.81,0,0,1-.26,2.14,7.53,7.53,0,0,0-.21,2.41C378.17,507.34,377.65,508.4,378.28,509.41Z"
            />
            <path
              class="cls-560"
              d="M383.83,496.05c1.94.11,2.43.64,2.8,2.56a21.64,21.64,0,0,1,.32,4.54c0,.33.09.72-.32.91a.83.83,0,0,0,.16,1.26,6.52,6.52,0,0,0,2-2.89,3.88,3.88,0,0,0-.51-3.69,16.4,16.4,0,0,1-1.46-2.44,3.84,3.84,0,0,1-.49-2.73,4,4,0,0,0,.06-.78c0-1.92-.41-2.43-2.29-2.8a2.5,2.5,0,0,0-3.07,1.84c0,.27-.11.56.11.81.4,0,.48-.38.63-.64.27-.45.5-.4.71.05a2.91,2.91,0,0,0,1.14,1.45c.35.2.3.5.2.83A1.9,1.9,0,0,0,383.83,496.05Z"
            />
            <path
              class="cls-561"
              d="M386.66,509.25a4.19,4.19,0,0,1-2.31.68c1.31,1.94,1.27,4,.95,6.26-.36,2.57-.83,5.13-1.16,7.71a7.44,7.44,0,0,1-.6,2.39c-.25.51,0,.67.47.61a13.38,13.38,0,0,0,.85-3.69c.65-3.83,1.22-7.68,1.64-11.55C386.59,510.86,386.61,510.05,386.66,509.25Z"
            />
            <path
              class="cls-562"
              d="M383.83,496.05a3.5,3.5,0,0,1,.25-1.91c.15-.25.25-.64-.21-.78-.82-.26-1.06-1-1.36-1.66-.07-.16,0-.46-.27-.48s-.41.19-.53.38-.34.65-.6,1.16c-.05-.43-.09-.68-.12-.93-.08.66-.17,1.33-.25,2,0,.87.6,1.44,1,2.1A7.34,7.34,0,0,0,383.83,496.05Z"
            />
            <path
              class="cls-563"
              d="M386.79,505.32a3,3,0,0,1-.16-1.26l-.56.15a3.84,3.84,0,0,0-2-.25c-.19.57-.46,1-1.18,1a.26.26,0,0,0-.28.32,1.44,1.44,0,0,1,1.34.57,3.4,3.4,0,0,0,2.12,1.3c.4.05.49.29.63.69,0-.38.07-.63.09-.88C386.8,506.39,386.8,505.86,386.79,505.32Z"
            />
            <path
              class="cls-564"
              d="M373.45,530.81h.47c.29-.82.86-1.62.33-2.56-.38-.39-.71-.13-1.06.07-.69.41-1.12,1.12-1.81,1.52-.44.22-.88.43-1,1a7.39,7.39,0,0,0,1.88,0c.4-.16.49-.66.89-.84C373.34,530.22,373.16,530.61,373.45,530.81Z"
            />
            <path
              class="cls-565"
              d="M383.84,527.07l-1.21,0a5.56,5.56,0,0,0-.36,2.42c.47.8.67.85,1.54.38A6.31,6.31,0,0,1,383.84,527.07Z"
            />
            <path
              class="cls-566"
              d="M378.14,503.18c-.5.52-1.13.33-1.73.34a10.86,10.86,0,0,0,1.4,2,1.32,1.32,0,0,1,.34.76c.15-.82.3-1.63.44-2.44C378.36,503.69,378.61,503.2,378.14,503.18Z"
            />
            <path
              class="cls-567"
              d="M371.38,529.85c.51.07.72-.37,1.06-.61.53-.37.84-1.14,1.68-1,.38-.35.84-.66.66-1.3a.6.6,0,0,0-.64.07h-.83A17.41,17.41,0,0,1,371.38,529.85Z"
            />
            <path
              class="cls-568"
              d="M383.81,529.84c-.45-.1-1,.38-1.37-.18-.4.38-.74.81-1.15,1.18H384Z"
            />
            <path
              class="cls-569"
              d="M381.74,495.92c0-.41.16-.81-.46-1-.43-.14-.16-.82-.54-1.1a5.9,5.9,0,0,0,0,1.73c.17-.12.25-.13.24.12s.14.29.28.37S381.59,496,381.74,495.92Z"
            />
            <path
              class="cls-570"
              d="M381.26,496l-.27-.84-.25.35c-.05.21.09.36.16.53Z"
            />
            <path
              class="cls-571"
              d="M374.82,527.09a1.69,1.69,0,0,0,1-.72,18.31,18.31,0,0,0,2.71-4.79c.91-2.52,2-5,3.05-7.42.37-1-.1-2-.25-3.1-.48,1-1,1.89-1.42,2.88a42,42,0,0,0-1.53,4.93,19.53,19.53,0,0,1-2.51,5.45c-.58.93-1.18,1.83-1.77,2.74Z"
            />
            <path
              class="cls-572"
              d="M383.85,502.53a18.56,18.56,0,0,0-.2-2.58c0-.37-.18-.6-.59-.56-1,.1-1.94.22-2.91.31a.46.46,0,0,0-.49.55,5.31,5.31,0,0,0,.32,2.2A3.11,3.11,0,0,0,383.85,502.53Z"
            />
            <path
              class="cls-573"
              d="M383.85,502.53a4.79,4.79,0,0,1-3.87-.08c-.62.47-.19.73.19,1,.75.65,1.73.45,2.59.71a1.35,1.35,0,0,0,1.25-.07l2.06.11a5.59,5.59,0,0,1-1.1-1.58C384.78,502,384.23,502.66,383.85,502.53Z"
            />
            <path
              class="cls-574"
              d="M384,504.1l-3.84-.64c-.3.49-.1,1-.1,1.52s.34.47.68.45c.63-.05,1.25-.12,1.88-.18a.81.81,0,0,1,.72-.14C384.19,505.17,384.35,504.8,384,504.1Z"
            />
            <path
              class="cls-575"
              d="M592.38,499.42c.66,7,6.16,6.82,11,7.28,3.78.36,6.69,1.25,8.36,5.23,8.23,19.6,17.13,38.93,23.26,59.35,2.45,8.16,1.7,9.68-6.13,13.74-2.9,2.63-5.95,4.65-10,2.45-5.42-1.29-6.2-6-7.76-10.27-2.39-6.55-1.86-14-6.19-19.93-2.09-5.72-1.67-11.88-3.08-17.71-.43-1.79-.43-4.22-2.48-4.68-2.22-.49-2.94,1.9-3.87,3.45-4.57,7.6-8.68,15.3-4.92,24.61a4.76,4.76,0,0,1-.38,4.23c-8.75,4.17-16.82.61-25-2.16-3-3.49-6.07-4.42-10.76-3.26-1.71.42-3.31.53-4.47-1.17-1.75-4.45.57-6.27,4.53-7,5.21-2.22,4.47-7.21,4.86-11.34.77-8.1,1.18-16.27,1.24-24.41,0-5,1.91-7.92,6.73-9,3.95-.9,7.25-2.64,8.55-6.86C581.27,500.29,586.41,497.14,592.38,499.42Z"
            />
            <path
              class="cls-576"
              d="M612.24,646.81c-.54,4.35-.93,8.73-1.66,13.06-1.71,10-2.27,19.49,1.24,29.84,5.87,17.28,3.57,35.11-2.37,52.33-.73,2.11-2.24,4.11-.91,6.5-4.47,3.8-6,3.42-9.92-2.38-1.82-6-1.78-12.21-2.83-18.31a19.38,19.38,0,0,0-1.7-5.86c-.51-13.83-2.44-27.36-7.82-40.25-4-9.54-4.62-19.85-6.55-29.86-.39-2.06-.34-4.19,1.47-5.79C591.54,646.35,601.93,644.76,612.24,646.81Z"
            />
            <path
              class="cls-576"
              d="M561.73,623.9c-3.73-1.14-4.69-3.58-4.76-7.47a125.43,125.43,0,0,1,5-38.83c-.36-3.26-.92-6.57,2.58-8.69A8,8,0,0,1,570,569c6.47,2.26,13,2,19.6.63,1.42-.3,2.85-.58,4.24.18,1.56,2.07.88,4.36.68,6.63a196.62,196.62,0,0,0-.17,27.46A25.81,25.81,0,0,0,600.5,620c2.21,2.5,2.69,4.62-.43,6.65-7.73,3.16-15.71,1.59-23.62,1.3C571.55,626.56,565.9,627.92,561.73,623.9Z"
            />
            <path
              class="cls-577"
              d="M581,646.57c1.71,13.72,3.91,27.23,9,40.3a78.75,78.75,0,0,1,5.21,35.7c2,4.09-.41,7.72-1.27,11.48a56.18,56.18,0,0,1-2.95,8.27c-.77,1.91-2.16,4.29-.64,5.91,2,2.17,3.53-.91,5.31-1.55,1.36-.5,2.59-1.41,4.15-.84,2,4,4.78,5.19,8.74,2.7q.8,5.6,1.58,11.18l-49.43,0c2.3-6.55,9.52-6.55,14-10.27,3.93-3.23,5.67-6.23,6.17-11.26,2.65-26.68-3.12-52-11.78-76.86-1.63-4.7-2.32-9.73-3.45-14.6,4.66-2.67,9.65-2.88,14.79-2A1.3,1.3,0,0,1,581,646.57Z"
            />
            <path
              class="cls-578"
              d="M599.88,625.36c0-1.05,2.73-1.31.38-3.21-6.12-4.94-7.63-12.25-7.8-19.49-.26-10.74-1-21.56,1.15-32.23,2.16-3,5.18-3.39,8.52-2.9a230,230,0,0,1,17,47.16c1.41,5.74.65,8.57-5.28,9.36C609.44,626.79,604.88,628.43,599.88,625.36Z"
            />
            <path
              class="cls-579"
              d="M651.67,625a57.78,57.78,0,0,0,9.18,18.32,18.5,18.5,0,0,1,2.61,5c3,8.12,1.12,11.61-7.19,13.77-8.67,2.25-17.31,4.61-26.19,5.85-4.88-3.1-7-7.64-6.82-13.29.2-6.89-.77-13.81.67-20.64,1.06-2.28,2.81-2,4.71-1.28C640.3,637,642.38,639.63,651.67,625Z"
            />
            <path
              class="cls-580"
              d="M599.88,625.36c4.79.82,9.3-1.4,14-1.31a139.86,139.86,0,0,1-1.66,22.76c-10.42,1.24-20.84,2.07-31.24-.23-.07-.33-.15-.66-.24-1-4-5.75-2.89-12.77-4.78-19.05C583.94,626.09,592,627.71,599.88,625.36Z"
            />
            <path
              class="cls-581"
              d="M567.22,479.35c-1.87-11,.54-15.49,9.8-18.41,11.35-3.57,19.72-.53,23.86,8.82a38.92,38.92,0,0,1,3.29,15.88c0,7.41-1.29,8.76-8.7,8.74l-4.35-.05c-3.36-1.55-2.54-4.38-2.08-7s.13-4.37-2.45-5.69c-8.51-4.35-8.47-4.42-12.78-10.89C570.37,472.65,572.72,479,567.22,479.35Z"
            />
            <path
              class="cls-582"
              d="M567.22,479.35c4.18-2.81,1.66-9.56,7.27-11.75.9,1.92,1.8,4,2.82,6,1.61,3.15,3,6.07,7.63,6,5.08-.08,7.39,2.88,5.68,8.11a7.57,7.57,0,0,0,.5,6.61c-2.32,2.37,1.12,3.32,1.26,5.09-5.61,0-10.6,4.18-16.48,2.5,0-1.24.3-3.35-.23-3.6C567.3,494.4,569.8,485.75,567.22,479.35Z"
            />
            <path
              class="cls-583"
              d="M589.82,566.17c-5.55-11.62-.5-21.39,5.46-31,1-1.56,2.18-3.63,4.12-3.46s2.81,2.27,3.17,4.22c1.28,7,3.54,14,2.34,21.31l-2.58,6.35C598.81,567.65,594.68,568.73,589.82,566.17Z"
            />
            <path
              class="cls-584"
              d="M651.67,625c.73,7.4-5.63,10.35-10.09,13-2.52,1.51-8-1.7-12-3-1.52-.49-2.54-2.24-4.43-2.1-3.1-4,1.22-6.06,2.47-8.92l4.88-2.53c3.39-.88,6.65-2.76,10.34-1.29C646.16,621.05,650.08,620.88,651.67,625Z"
            />
            <path
              class="cls-585"
              d="M576,626.55c3.13,2.61,3.25,6.37,3.74,10,.41,3,.7,6.05,1,9.08l-15.11,1.15a100.7,100.7,0,0,1-3.93-22.85Z"
            />
            <path
              class="cls-586"
              d="M642.83,620.14c-3.47.24-6.55,3.62-10.34,1.29.72-6.47-1.36-12.19-4.56-17.67s-6.06-10.85-9.07-16.29l10-2.45c1.55,8.75,3.1,17.52,9.62,24.31C641.43,612.36,640.57,616.86,642.83,620.14Z"
            />
            <path
              class="cls-587"
              d="M554.52,553.56c-3.62,1.33-4.21,4.15-3.7,7.52,2,2.19,4.47,4.23,2.38,7.69-7.34-7-14.79-13.91-20.23-22.6,1.6-2.32,4.49-3.48,4.79-7,.59-7.24.27-8-8.4-12.1,9.77-3.26,12-1.88,12.37,7.76.06,1.45-.25,3,.16,4.34.85,2.81-2.38,6.14.07,8.1C545.6,550.15,549.36,553.43,554.52,553.56Z"
            />
            <path
              class="cls-588"
              d="M627.61,624c.21,3.26-3.43,5.46-2.47,8.92,0,4.4,0,8.81-.17,13.2-.38,7.78-.29,15.41,5.1,21.82-4.76,1.12-6.94-1.82-8.38-5.57-2.08-5.37-2.07-11-1.63-16.65a82.71,82.71,0,0,0,.63-11.8C620.4,629.09,622.74,625.48,627.61,624Z"
            />
            <path
              class="cls-589"
              d="M553.2,568.77c-.79-2.57-1.59-5.13-2.38-7.69,3.22.54,6-1.47,7.73-3.17,4.68-4.71,4.82-2.06,4.94,2.25,0,1.17.76,2.31,1.18,3.47,1.55,2,1.7,4.07-.16,6-2.07,2.25-.07,5.81-2.55,7.94C557.53,576.15,554.36,573.46,553.2,568.77Z"
            />
            <path
              class="cls-590"
              d="M564.51,569.66q.07-3,.16-6c8.27,2,16.38,5.52,25.15,2.54,4.38.19,8.47-1,12.51-2.55-.07,1.3-.13,2.61-.2,3.91l-8.52,2.9C583.81,574.09,574.15,572.18,564.51,569.66Z"
            />
            <path
              class="cls-591"
              d="M529.36,527.05c10.18.28,9.88.3,10.31,11,.21,5.28-1.39,7.93-6.7,8.07-2.63.14-4-1-3.82-3.74-.68-1.6-1.23-3.51.12-4.71,4.1-3.64,2.29-7.07.07-10.61Z"
            />
            <path
              class="cls-587"
              d="M529.34,527.1c6.56,3.63,6.76,4.36,1.74,10.25a8.68,8.68,0,0,0-1.93,5.07C524.08,537.25,527.55,532.18,529.34,527.1Z"
            />
            <path
              class="cls-592"
              d="M642.68,653.17c0,4.85-1.69,7.17-5.87,7.32s-9.14-3.86-8.27-7.42c1.18-4.84,6.18-2.62,9.35-3.69S642.81,650.68,642.68,653.17Z"
            />
            <path
              class="cls-593"
              d="M659.05,649.49c.13,4.59-1.56,7.06-6.06,7.24-4.74.2-7.57-2.88-7.35-6.63.33-5.41,6-3.65,9.37-4.6S659.36,646.89,659.05,649.49Z"
            />
            <path
              class="cls-594"
              d="M1318.9,485.39c2.64,6.63,1.55,12.86-2,18.83-2,.23-2.08-1.39-2.23-2.55-.51-4.13-2.79-6.47-6.85-6.9-4.71-.49-9.4-.86-12.58,3.93-1.06,1.6-1.26,4.08-3.81,4.45-2.46-6.31-4.21-12.64-.48-19.11,1.24-2.09,7.08-1.46,3.27-6.73-1.88-2.6,3.93-1.61,4.29-4.58.09-.71,2.24.57,2.84,1.71a38.79,38.79,0,0,1,1.64,4.19c1.85-.8.81-2.62,1.38-3.86.48-1.08,1.85-2.52,2.2-2,3,4.09,5-.39,7.35-.71,1.07-.14,2.32.93,2,1.19-3.27,2.46,5.25,2.95.84,5.39-1,.53-1.85,1.15-3.24,2C1315.57,482.16,1317.73,483.3,1318.9,485.39Z"
            />
            <path
              class="cls-575"
              d="M1332.73,617.36c-.33,13.13-1.09,26.25-.9,39.37.31,19.86,1.49,39.71,1.87,59.57.2,10.49-.51,21-.78,31.48-.06,2.11,0,4.21-2.44,5.19-3.36,3.59-7.4,2.43-11.39,1.63a7.59,7.59,0,0,1-4.37-6.14c-3.29-19.55-6.53-39.11-8.32-58.87a19.24,19.24,0,0,1,.43-6.14c4-14.24,6.24-28.66,4.37-43.54-3.18,3.8-5.51,7.81-4.54,13,.32,1.65.55,3.35-.56,4.86-2,.81-1.79,2.73-2,4.31-1.47,13-2.16,26.16-3.5,39.21-1.61,15.69-4.51,31.19-7,46.76-.47,2.93-1.77,5.33-4.65,6.61-3.94.76-8,1.9-11.29-1.6-2.83-1.39-2.14-4.06-2.35-6.41-2.44-28,.55-55.81,1.14-83.71.32-15.19.12-30.39.16-45.58,3.49-2.85,7-.37,10.5-.06,13.28.39,26.58,1.78,39.78-1C1329,615.8,1331.07,615.62,1332.73,617.36Z"
            />
            <path
              class="cls-595"
              d="M1270.88,596.52c-15.35,1.19-14.62,2.47-13-13.57.53-5.15,1.15-10.3,1.73-15.45a51.63,51.63,0,0,1,6.63-24.69,31.23,31.23,0,0,1,15.68-14c3.68-1.48,7-1,8.29,3.1,4.46,13.73,5.3,41.57-11.73,52.66a2.78,2.78,0,0,1-1.6.33c-1.77-.88-1.47-2.7-1.9-4.25-1.26,1.62.06,2.75.67,4C1274.82,588.94,1273.78,593.1,1270.88,596.52Z"
            />
            <path
              class="cls-596"
              d="M1291.43,503.15c4.15-9.32,6.19-10.71,14.79-10.09,6.94.51,8.19,1.82,10.68,11.16-2.65,7.63-6.61,15.09-3.14,23.54-1.41,4.29-4.34,7-8.84,7.19-5.45.21-9-2.85-11.07-7.75-.57-1.76.78-2.76,1.61-4C1298.75,515.62,1293,509.8,1291.43,503.15Z"
            />
            <path
              class="cls-572"
              d="M1295.46,523.24l-.79,3.87c0,4.13,1.19,8.09,1.81,12.13,2,12.93-.25,25.25-5.37,37.11-1.53,3.56-3.41,7.09-7.11,9.08-2.4.67-4.74,1-6.74-1,16.2-13.91,15.73-31.84,12.19-50.52-.88-4.66-3.17-5.67-7.54-3.66-10.6,4.87-16,13.69-19,24.37-1.21,4.27-2.23,8.59-3.34,12.88-1.14-8.32-2.38-16.62-3.4-25-1-7.79,2.36-13.15,9.6-13.79C1275.91,527.84,1285.66,525.53,1295.46,523.24Z"
            />
            <path
              class="cls-597"
              d="M1277.26,584.43l7.18.16c4-1,8.15-.43,12.22-.49a19.31,19.31,0,0,0,9.17-1.92c3.75-1.66,7.57-3.88,10.69,1a4.82,4.82,0,0,1,0,3.71c-2.23,3.62-5.75,4.6-9.68,4.75a175.13,175.13,0,0,0-18.5,4.13c-4.07.2-8.11,1.78-12.23.42l-5.25.3a29.33,29.33,0,0,1,4.35-11.71.89.89,0,0,1,1.52-.35Z"
            />
            <path
              class="cls-598"
              d="M1276.13,596.22a33.64,33.64,0,0,1,12.64-1.62,1.59,1.59,0,0,1,1.84.84c2.68,5.25.34,18.41-4,22.74l-9.92-.85C1273.19,610.38,1275.67,603.28,1276.13,596.22Z"
            />
            <path
              class="cls-599"
              d="M1277.72,753c3.67,1.19,7.39.77,11.11.44q4.32,4,1.37,9.12l-15,.12a1.43,1.43,0,0,0,0-1C1275.42,758.64,1276.6,755.84,1277.72,753Z"
            />
            <path
              class="cls-595"
              d="M1286.59,618.18c2.34-7.71,5.34-15.36,2.18-23.58,5.66-2.72,11.8-3.4,17.91-4.18,5.53,2.68,6.33,2.36,9-3.54v-3.46c-2.78-5.71-4.85-5.8-8.88-.36-7.21,4.23-14.84,2.44-22.41,1.53,10.88-15.9,13.33-33.29,9.3-51.89-.4-1.83-1.42-4.07.93-5.59,7.21,8.93,10.07,9,19.09.65,16.06-.08,26.22,9.38,34.72,21.5,5.27,7.52,9.49,15.69,14.3,23.48,3.65,5.89,2.66,10.41-1.3,15.15-1.2,1.44-2.41,2.86-3.62,4.28a16.13,16.13,0,0,1-11.74-5.08c-.12-.34-.33-.8-.17-1.05,4.39-6.6,1.4-10.89-4.45-14.29a17.82,17.82,0,0,0-4.47-6.2c-1.62-1.59-3.48-2.34-4.6.68-1,10.79,2.09,21.23,2.5,31.89.07,1.86.63,3.7.06,5.56-.67,2.08-2.56,1.77-4.14,2.11-1.38.29-2.52,1.06-2.48,2.56s1.47,1.3,2.52,1.38c1.81.13,3.31.62,3.34,2.84a6.64,6.64,0,0,1-1.5,4.79c-13.34,2.59-26.82,2.55-40.31,2C1290.44,619.31,1288.23,620,1286.59,618.18Z"
            />
            <path
              class="cls-600"
              d="M1334.23,612.57c-.82-1.1-1.76-2-3.28-1.63s-3.37,1.74-4.49-.33c-.87-1.61.14-3.18,1.1-4.66,1.23-1.91,2.64-2.51,4.71-1.48a10.72,10.72,0,0,0,1.61.49c3.37-.23,4.25-3,5.74-5.34,2.67-4.09,3.08-9.43,7.15-12.72l11.09,5.28c-5.66,7.22-12.51,13.2-19.6,19C1337,612.11,1335.84,612.85,1334.23,612.57Z"
            />
            <path
              class="cls-601"
              d="M1319.39,753.55c3.72.12,7.45.73,11.09-.58a28.24,28.24,0,0,1,2.75,9.59,82.75,82.75,0,0,1-15.26,0C1316,759.2,1316.89,756.25,1319.39,753.55Z"
            />
            <path
              class="cls-602"
              d="M1308.05,682.67q-1.24-12.25-2.51-24.5a24.91,24.91,0,0,1,3.45-19.63c.66-1,.66-2.84,2.3-2.66s1.23,2.07,1.49,3.21c2.1,9.28.91,18.54-.89,27.64C1310.83,672.07,1311.88,678,1308.05,682.67Z"
            />
            <path
              class="cls-603"
              d="M1276.75,584.46l-1.52.35c-3.92-1.36-3.8-2.59,1-7.69Z"
            />
            <path
              class="cls-604"
              d="M1309,511.48c-3.44,3.3-5.48,3.28-8,.57C1303.48,510.84,1305.5,511.35,1309,511.48Z"
            />
            <path
              class="cls-605"
              d="M1306.85,583.06c-.47-3.49-.26-5.8,4.56-5.72,5,.09,4.69,2.78,4.32,6.08C1312.9,580.11,1309.87,581.77,1306.85,583.06Z"
            />
            <path
              class="cls-606"
              d="M1315.72,586.88c-.12,2.53,1.62,6.12-2.79,6.44-2.27.16-6,1.9-6.25-2.9A13.74,13.74,0,0,0,1315.72,586.88Z"
            />
            <path
              class="cls-607"
              d="M1341.82,571.05a54.86,54.86,0,0,1-10.19-6.74c.92-2.14,2.36-2.63,4.34-1.36C1339,564.88,1341.23,567.37,1341.82,571.05Z"
            />
            <path
              class="cls-608"
              d="M428.61,529.27a60.77,60.77,0,0,1,7-22.42c2.17-3.85,3-8.14,3.47-12.48,5.84-12.78,14.69-22.78,27.76-28.25,7.63-3.19,12.26-.45,15.49,7.77-.38,1.09-.77,2.18-.1,3.3.29,6.88.64,13.77.85,20.66.24,7.87,5.56,14.45,5.56,22.37-3.07,2.61-2.72-1.52-4.18-2.09-2.22-2.6-5.56-2.68-8.45-3.78a8.68,8.68,0,0,1-3.32-14.22c6.78-7.11,7.26-14.37,1.5-22.77-2,.53-2,2.48-2.79,3.85-1.6,2.81-3.29,5-7.11,5.18-4.21.16-6.12,2.33-5.32,7.11,1.06,6.31.05,12.6-4,17.81-2.09,2.7-1.2,5.05-.45,7.64a8.87,8.87,0,0,1,.48,3.65,2.21,2.21,0,0,1-2,1.72c-2.19-.32-2.87-2.11-3.67-3.78-2.9-7.1-3.27-7.26-9.68-4.15-4.4,3.65-5.1,9.3-7.64,14-.58,1.06-1.2,2.6-2.58,2.18S428.61,530.45,428.61,529.27Z"
            />
            <path
              class="cls-609"
              d="M482.3,473.89c-8.21-11.46-13-7.47-22.34-2.33-9.72,5.35-13.55,15.59-20.9,22.81-3.08-.82-3.4-3.32-3.62-5.89,1.88-3.72,3.57-7.56,7-10.18,5.92-10.78,16.56-15.15,27-19.83,3.2,1.9,5.94-.75,8.93-1,3.69-.24,7.85-1.61,10.24,2.18s-.58,7.07-2.6,10.12A33.83,33.83,0,0,1,482.3,473.89Z"
            />
            <path
              class="cls-610"
              d="M469.44,458.47c-3.37,4.93-9.52,5.34-14,8.61a113,113,0,0,0-13,11.22c-.19-1-.34-2-.58-3-2.16-9.06-.79-14.3,4.67-17.77C454.45,452.52,462.48,452.85,469.44,458.47Z"
            />
            <path
              class="cls-576"
              d="M433,724.25c-4.51-.89-9-2.18-13.52-2.59-6.42-.59-7.85-3.25-6.61-9.58,5.75-29.51,11-59.12,16.42-88.69a3.27,3.27,0,0,1,3.86-1.25c5.08,1.82,10.62,1.38,15.66,3.27,3.12,1.29,6.22,2,9.13-.52,1.9-7.64,5-15.11,2.7-23.22a12.76,12.76,0,0,1,.05-5.15c1-6.24,1.08-12.63,2.65-18.8,6.31-4.34,13-4.5,20-1.93a10.53,10.53,0,0,1,1.47,1.44,7.87,7.87,0,0,1,1,5.76q1.13,5,2.27,10a395.31,395.31,0,0,0-.05,42.72c-.59,27.71-2.76,55.34-4.5,83-.15,2.41-1.35,3.31-3.32,3.74-4.47,1-9,1.92-13.44,2.87C455.46,727.68,444.15,728.48,433,724.25Z"
            />
            <path
              class="cls-611"
              d="M484.51,578a7.56,7.56,0,0,0-1-.37c-1.42-4.86-4.11-6.29-9.17-4.41-3.75,1.4-8,2.58-11.84-.52-2.39-6.27-.27-12.88-1.51-19.27-1.64-8.4-2.82-16.9-5.84-25-.76-2-.33-4.11-.66-6.15l-1-2.28c2.54-2.32,5.55-2,8.26-.85,5.46,2.24,10.55,1.62,15.77-.71,2.56-1.14,5.26-3,8.3-1.05,1.8.08.26,3.55,2.87,2.82,1,1,.86,2.18.63,3.39-1.15,5.78.63,11.72-.95,17.48-.7,4.77.88,9.34,1.3,14,.2,2.24,1.12,3.95,3.77,3.89,6,2,6.87,4.88,3.63,11.47-3.73-1.55-6.54-4.57-10.4-6.33C485,568.55,487.78,573.78,484.51,578Z"
            />
            <path
              class="cls-612"
              d="M440.47,752.62c-3.24-7.61-6.14-15.31-6.26-23.74,1.29-2.27,3.57-3,5.83-3,8.78,0,17.56.13,26.34.46l1.3,23.91q-3.6,5.78-8.9,1.5c-3.32-5.38-4.69-11.53-6.72-17.19-1.36,5.62-.92,11.79-3.48,17.39C446.07,754.63,443.54,757.13,440.47,752.62Z"
            />
            <path
              class="cls-613"
              d="M440.47,752.62c3.22,3.56,5.2.09,7.54-1.33,2.53-.76,4.3.89,6.07,2.14,2.13,1.5,3.7,1.22,5.1-.87,3.21,1.52,6,0,8.81-1.26,5.53,2.61,9.42,8,15.81,9.17,2.53.47,1.63,3.61,3.39,4.76l-49.47-.05C438.27,760.91,438.24,756.52,440.47,752.62Z"
            />
            <path
              class="cls-614"
              d="M495.88,570.33c2-4.4,2.78-8.55-2.52-11.35,5.94-.47,10-4.58,14.52-7.71,1.93-1.35,3.24-3.62-.27-5.1-2.38-1-1.65-3-1.69-4.77,1.22-.5,1.88.48,2.74,1,2.94,1.72,4.23,1.21,3.7-2.49-.69-4.73,1.71-7.81,5.79-9.82,8.37,15.06-4.17,22.87-11.49,32.27-3.41,4.39-7.88,7.95-11.88,11.88C493.25,572.39,494.1,571.23,495.88,570.33Z"
            />
            <path
              class="cls-615"
              d="M495.88,570.33c-.52,1.26-1.51,2.38-1.1,3.89-1.83,4.09-4.38,7.44-8.92,8.77-1.42-1.41-1.39-3.21-1.35-5V557.9c3.17,4.74,5.45,7.59,9.65,8.12C496,566.25,495.77,568.68,495.88,570.33Z"
            />
            <path
              class="cls-616"
              d="M518.15,530.07c-2.32,4.15-7.58,7.66-2.76,13.36.5.59-.42,1.57-1.36,1.56-2.21,0-4.63.93-6.49-1a15.09,15.09,0,0,1-1.62-2.59l-.51-3c-.51-3.13-2.2-8.4-.43-9C509,527.93,513.94,527,518.15,530.07Z"
            />
            <path
              class="cls-617"
              d="M466.38,726.38c-7.54,1.67-15.08,1-22.6,0-3.63-.49-6.26,2.17-9.57,2.53a5.93,5.93,0,0,1-1.21-4.63,234.33,234.33,0,0,0,33.82,1.07A3.18,3.18,0,0,1,466.38,726.38Z"
            />
            <path
              class="cls-618"
              d="M488.08,635.72c-2.32-8.83-.77-17.82-.92-26.72-.09-5.31-1.36-10.8,1-16C489.33,607.24,488.67,621.48,488.08,635.72Z"
            />
            <path
              class="cls-619"
              d="M488.29,541.08c.5-5.82-1.19-11.75.95-17.48C489.31,529.45,491.55,535.41,488.29,541.08Z"
            />
            <path
              class="cls-617"
              d="M468,751.3c-2.53,2.14-5.07,4.18-8.46,1.51-.33-.37-.4-.68-.2-.94s.33-.34.49-.34c3,2,5.31-.38,7.86-1.24A1.34,1.34,0,0,1,468,751.3Z"
            />
            <path
              class="cls-620"
              d="M450.43,519.84l2.31,4.14c5.1,6.88,5.79,15.27,7.7,23.19,1.95,8.1,1.81,16.4,1.15,24.68a3.31,3.31,0,0,1-1.25,1.63c-3.57,1-6.77.89-8.84-2.79,6.32-4.15,8-9.62,5.38-17.92-1.2-3.8-3.52-7.08-5.32-10.6-.46-.92-1-2.06-2.17-2-1.55,0-1.89,1.54-2.17,2.68-1.72,6.83-3.46,13.67-2.47,20.83-2.49,2.16-3.09,5.17-3.87,8.17-1.69,6.54-2.67,13.35-6.64,19.11a9.3,9.3,0,0,1-2.31,1.61,7.72,7.72,0,0,1-1.81.61,9.57,9.57,0,0,1-10.38-2.94c-2.9-3.37-2.92-7.46-1.86-11.26,2.08-7.45,1.4-15.37,4.16-22.67a3.43,3.43,0,0,0-.39-3.56c2.08-7.89,6.94-15,7-23.44,1.37,2,1.44,2,1.9,1,1.49-3.41,2.87-6.87,4.4-10.26.93-2.07,2-4.13,4.29-5.07C444.34,513.37,447.67,516,450.43,519.84Z"
            />
            <path
              class="cls-559"
              d="M430.47,591.89a5.94,5.94,0,0,1,1-.06c2.24,1.77,1.48,4.42,2,6.69.68,2.06,2.64,1.66,4.16,2.12,5.42,1,11,1.18,16.17,3.33a4.87,4.87,0,0,1,2.48,1.92c1.75,6-.1,11.85-1.35,17.62-.5,2.32-2.12,4.62-5.39,3.44l-20.27-3.56c-6.81-.48-8.06-4.26-6.25-10.17A57.32,57.32,0,0,0,425,604c.34-2.54,1.61-3.7,4-3.88C431.23,597.72,428.25,594.33,430.47,591.89Z"
            />
            <path
              class="cls-621"
              d="M430.47,591.89c-.8,2.7,1.31,5.93-1.49,8.27.06-1.63.66-3.3-.56-5.52-4.4,8.59-10.55,15.76-12.67,25.12-.54,2.39-1.31,5.13-4.37,5.42-1.81.16-2.9-1.54-3.85-2.87-1.86-2.61-.51-5.08,1.24-6.77,7.09-6.86,8.32-16,10.17-24.91a.86.86,0,0,1,1.34-.25C423.75,590.36,426.72,593.79,430.47,591.89Z"
            />
            <path
              class="cls-622"
              d="M420.28,590.38l-1.34.25c-7.64-4.15-8.36-5.86-6-13.87a186.68,186.68,0,0,1,8.71-24.06c5.18-.73,2.41,3.2,2,4.27-3.05,7.4-1.64,15.57-4.32,23.06C418.12,583.3,419.29,587,420.28,590.38Z"
            />
            <path
              class="cls-623"
              d="M485.74,517.39c-6.58,1.1-12.09,6.37-19.25,5-4.36-.82-8.37-3.5-13.08-2.42-1.36-3.81-3.18-6.75,1.19-11,3.58-3.44,4.21-10,2.79-15.46-1.19-4.63-.82-8.1,4.69-8.12,5.74,0,7.55-3.79,9.38-8,.6-1.39.68-3.79,2.83-3.57,1.79.18,2.45,2.2,2.92,3.76,1.82,6.11,4.11,12.2,1,18.65-.73,1.54-1.22,3.67-2.74,4-5.5,1.2-3.32,5.32-3.53,8.47-.25,4,3.29,3.72,5.67,4.51C480.58,514.23,483.92,514.28,485.74,517.39Z"
            />
            <path
              class="cls-624"
              d="M460.47,572.43c1.62-14.22-1.16-27.85-5.56-41.26-.78-2.38-1.45-4.8-2.17-7.19l1.71-1.7c7.09,16.09,9.28,33,8.87,50.44a1.3,1.3,0,0,1-.25,1.62A2.08,2.08,0,0,1,460.47,572.43Z"
            />
            <path
              class="cls-625"
              d="M450.43,519.84c-3.63-1.91-6.92-4.58-11.23-4.94C447,510.91,447.47,511.1,450.43,519.84Z"
            />
            <path
              class="cls-626"
              d="M460.47,572.43l2.5,1.63c1.36,1,.92,2.42.77,3.76-1.39,6.22-1,12.6-1.73,18.88l-.06,5.1c1,4.9,1.24,9.91-1,14.42-1.74,3.52.14,7.38-1.81,10.69-3.19,1.64-6.38,2-9.58,0,3.14-.35,4.14-2.88,4.48-5.25.77-5.28,1-10.63,1.48-16,2-2.4,2.19-5.17,2.13-8.17-.15-7-.53-14.1,1.22-21a7,7,0,0,1,1.59-3.81Z"
            />
            <path
              class="cls-627"
              d="M463.41,577.71c-.14-1.22-.29-2.43-.44-3.65.12-.45.23-.9.35-1.34,6.72.53,13.05-1.34,19.35-3.56.3,3.12.55,5.79.8,8.46-6.42-3.74-12.75-.72-19.12.23C464,578.47,463.63,578.43,463.41,577.71Z"
            />
            <path
              class="cls-628"
              d="M459.14,626.91c-.47-8.53,3.74-16.53,2.8-25.11,2.12,2.35,1.43,5.32,1,7.8C462.06,615.43,460.46,621.15,459.14,626.91Z"
            />
            <path
              class="cls-628"
              d="M463.41,577.71a3,3,0,0,0,.94.14A86.76,86.76,0,0,1,462,596.7C462.18,590.35,460.29,583.85,463.41,577.71Z"
            />
            <path
              class="cls-629"
              d="M444,564.29c-3-9,.49-17.24,2.84-25.59,1.07-3.82,3.6-1.5,4.46-.18,5.53,8.48,9.69,17.43,8,28-.82,5.21-4.93,3.24-7.87,3.85-2.35,1.89-4.44,1-6.47-.6C443.55,568.17,442.59,566.43,444,564.29Z"
            />
            <path
              class="cls-630"
              d="M445.81,571.72l-.3-2.37,5.93,1.06a15.11,15.11,0,0,0,9,2.33c-.07,1.23-.13,2.46-.19,3.69C454.21,578.66,449.61,576.4,445.81,571.72Z"
            />
            <path
              class="cls-631"
              d="M433.14,590.7c1.22,1.49,2.89.78,4.4.89l.62.69c-.9,2.32-2.37,4.38-3,6.85-.4,1.56-1.51,2.54-3.3,1.45-.11-2.92-.23-5.83-.34-8.75Z"
            />
            <path
              class="cls-628"
              d="M445.81,571.72c4.52,2.48,9.17,4.58,14.46,4.72a146.85,146.85,0,0,0-.7,26.43c.26,4-2.65,2-4.05,2.88l-2.28-.8a4.45,4.45,0,0,1,.18-3.23c1-2.31-.93-2.37-2.27-2.87-1.92-.64-4-.93-5.35-2.7-1.33-3.92-5.71-2-7.95-4.12l-.31-.43Q441.67,581.66,445.81,571.72Z"
            />
            <path
              class="cls-632"
              d="M446.38,595.51c1.31,2.11,4.06.66,5.58,2.26a1.81,1.81,0,0,1-1.49,1c.37.43.94.4,1.41.58a3.6,3.6,0,0,1,2.48,2.56L453.24,605l-16.63-3.21c-1.5-3.88,1.17-5.82,3.76-7.55C442.61,592.69,444.76,593.31,446.38,595.51Z"
            />
            <path
              class="cls-633"
              d="M446.38,595.51c-6.19-2.51-7.95,1.89-9.77,6.23-1.63-.22-3.51.59-4.77-1.16,2.36-.34,2.39-2.21,2.14-3.82-.49-3.18,1.89-3.74,3.87-4.73C440.69,593.2,445.76,588.9,446.38,595.51Z"
            />
            <path
              class="cls-634"
              d="M454.36,601.86c-1.7-.73-3.52-1.28-4.47-3.09l2.07-1C453.83,598.51,459,597.3,454.36,601.86Z"
            />
            <path
              class="cls-635"
              d="M202.9,497.9a11.39,11.39,0,0,0,3.67,1.75c.72.21.93.89,1.18,1.52,1,2.42,1.14,5,1.54,7.55a126.94,126.94,0,0,1,1,15.71,1.6,1.6,0,0,1-.21.6,1.75,1.75,0,0,1-2.05-.23c-.54-1.22-.34-2.56-.61-3.82a5,5,0,0,1-.23-2.71c.16-1.75-.12-3.52.12-5.28.16-1.17.19-2.35.3-3.38,0-.33-.31-.13-.14-.17s0,0,0,.05a18,18,0,0,1-.22,3.81c-.18,1.64.06,3.27,0,4.9-.5,1,.33,2.07-.26,3l-.39,1.83c-1.6.25-3.16.7-4.75,1a2.71,2.71,0,0,1-2.16-.16,3.46,3.46,0,0,1-1.08-1.53c-.07-.28-.18-.56.13-.77,1.35-.3,2.74-.33,4.1-.52,2.15-.31,2.35-.54,2.39-2.7,0-.54.08-1.07.14-1.6.24-1.82-.77-2.87-2.55-2.62-.8.11-1.6.17-2.4.2a2.94,2.94,0,0,0-3,3.79,1.37,1.37,0,0,1-.12,1.15c-.78.78-2.08,1.1-2.15,2.49-.54,1-.91,2-1.38,3-.33.31-.61.75-1.18.51-.51-1.65,0-3.24.36-4.82a2.75,2.75,0,0,0-.7-2.66c-1.38-1.51-2.64-3.13-3.92-4.73a3.2,3.2,0,0,1-.3-4c1.34-2.3,2.28-4.82,3.72-7.08a6.39,6.39,0,0,1,3.63-3c1.07-.32,1.89-1.33,3.13-1.35a11.21,11.21,0,0,0,3,1.3c.61.17,1.17.23,1.19-.66a.87.87,0,0,1,.13-.35A.86.86,0,0,1,202.9,497.9Z"
            />
            <path
              class="cls-636"
              d="M206.58,561c-.76-3.25-1-6.58-1.61-9.86-.51-2.92-.81-5.88-1.54-8.77a.69.69,0,0,1-.22-.73,12.25,12.25,0,0,0,.31-5.41c-.26-2.37-.43-4.75-.87-7.11-.27-1.43-1.41-2.45-1.7-3.85a14.88,14.88,0,0,1,5.7-1.11c.92,6.61,2.24,13.18,2.65,19.86-.29,2.4,0,4.81-.13,6.93.06.46.33.24.17.32s-.06,0-.06-.08a20.16,20.16,0,0,1,.08-5.09c.33,3.1.13,6.22.2,9.33,0,1.56,0,3.12,0,4.68C209.28,561.71,208.26,562,206.58,561Z"
            />
            <path
              class="cls-637"
              d="M201,525.28a10.94,10.94,0,0,1,2.41,7.05c.09,2,.59,4,.49,6a13.09,13.09,0,0,1-.5,4c-1.36.55-2.78.12-4.16.26-.55.06-1.15-.2-1.64.26a11.51,11.51,0,0,1-5.47-.16c-1,0-2-.07-2.13-1.45-.49-.73-.25-1.54-.27-2.32,0-1.54,0-3.08,0-4.62a1.05,1.05,0,0,0,.5-1,11.78,11.78,0,0,1,2.25-8.05l1-.59c.57-1,1.73-.79,2.57-1.23a2.77,2.77,0,0,1,1.56-.06c.61.14.66-.23.7-.66.08-.25.15-.51.51-.46l.82,1.37C199.92,524.37,200.88,524.49,201,525.28Z"
            />
            <path
              class="cls-638"
              d="M192.16,542.72a22.26,22.26,0,0,1,5.47.16c-.95,5.74-1.48,11.54-2.18,17.32,0,.42.08.9-.35,1.23a2.21,2.21,0,0,1-3,.05h.07c-.22-2.43,0-4.87-.1-7.31a4.65,4.65,0,0,0-.1-1.58,34.75,34.75,0,0,1,.17-5.49,7.9,7.9,0,0,1,.18,2.9c-.05-2,.14-4-.08-6Z"
            />
            <path
              class="cls-639"
              d="M202.82,498.17c.32,1.35.09,1.66-1.21,1.24-1.13-.36-2.5-.38-3.17-1.67a4.45,4.45,0,0,0-.37-3.6c.14-.27,0-.5-.11-.75-.5-1.59-.5-1.59,1.07-2.06.36-.1.56-.41.83-.64a3.88,3.88,0,0,1,2.69-1.26,19.44,19.44,0,0,1,3,2.59c-.39.59-.22,1.29-.38,1.93a4.59,4.59,0,0,1-1.88,3.08.7.7,0,0,0-.38.87l-.07.08a12.69,12.69,0,0,1-2.57-.84C200.94,497.79,202,497.64,202.82,498.17Z"
            />
            <path
              class="cls-640"
              d="M202.55,489.62a5.14,5.14,0,0,0-2.73,1.52c-.37.36-.6.93-1.38.44-.41-.26-.51.28-.51.74,0,.62.74,1.17.14,1.82a12.69,12.69,0,0,1-1.2-3.1c-.54-2.32.06-3.8,1.86-4.59a4.7,4.7,0,0,1,5.85,1.45,3.63,3.63,0,0,1,.73,2.25A16.2,16.2,0,0,1,202.55,489.62Z"
            />
            <path
              class="cls-641"
              d="M206.58,561c.44-.3.72.22,1.16.21.88,0,1.63,0,1.82-1.1,0,1.59,1.27,2,2.39,2.45.56.25,1.18.36,1.75.59a.9.9,0,0,1,.64.78c0,.45-.39.57-.72.66a6.74,6.74,0,0,1-4.8-.2l-.48-.24C206.32,563.2,206.32,563.2,206.58,561Z"
            />
            <path
              class="cls-642"
              d="M192.06,561.48a5.33,5.33,0,0,0,3-.05,3.65,3.65,0,0,0,2.22,1.56,4.34,4.34,0,0,1,.87.33c.5.28,1.09.58,1,1.26s-.72.73-1.21.87c-2.21.63-4-.44-5.69-1.58C191.46,563.3,192.22,562.28,192.06,561.48Z"
            />
            <path
              class="cls-643"
              d="M208,524.8l2.05.23a8.77,8.77,0,0,1-1,6.71c-.61-1.41-.06-3-.39-4.5-.66.38-.31,1.17-.89,1.58A10.6,10.6,0,0,1,208,524.8Z"
            />
            <path
              class="cls-644"
              d="M201,525.28c-.52-.48-1.55-.55-1.35-1.63,1.67.72,3.14-.52,4.73-.47.73,0,1.41-.88,2.16-.11l.08,1.08A26.93,26.93,0,0,1,201,525.28Z"
            />
            <path
              class="cls-645"
              d="M202.55,489.62a2.73,2.73,0,0,1,2.76.53c.14.62.48,1.21.23,1.87A8.82,8.82,0,0,1,202.55,489.62Z"
            />
            <path
              class="cls-646"
              d="M189.78,534.33c.23.06.33.16.32.46,0,2.16,0,4.32-.07,6.48-.19,0-.39-.08-.39-.27C189.64,538.77,189.33,536.54,189.78,534.33Z"
            />
            <path
              class="cls-647"
              d="M191.93,552.6c.48.92.19,1.92.21,2.88.05,2,0,4,0,6-.4-.14-.33-.48-.33-.78C191.84,558,191.89,555.3,191.93,552.6Z"
            />
            <path
              class="cls-648"
              d="M209.36,546.09v5.39c-.11-2.49-.64-5-.06-7.47Z"
            />
            <path
              class="cls-649"
              d="M192.2,544c.56,2,.05,4.09.27,6.13h-.37v-3C192.13,546.08,192.16,545.05,192.2,544Z"
            />
            <path
              class="cls-650"
              d="M197,519.24a.8.8,0,0,0,.13-.74c-.72-2.83.64-4.51,3.62-4.51a11.11,11.11,0,0,0,2-.22,2.44,2.44,0,0,1,3,3.16,15.24,15.24,0,0,0-.12,2.94,1,1,0,0,1-.87,1.11,20.61,20.61,0,0,1-6,.78A17.4,17.4,0,0,1,197,519.24Z"
            />
            <path
              class="cls-651"
              d="M197,519.24c1.18.43,1.28,1.56,1.66,2.52l.21.52c-.12.18-.23.37-.34.55-1.08.9-2.23.64-3.39.22-.38-.37-.23-.83-.21-1.26C194.59,520.1,196.12,519.94,197,519.24Z"
            />
            <path
              class="cls-652"
              d="M207.16,518.28a19.92,19.92,0,0,1,.55-9.07v1.85a9.72,9.72,0,0,1,0,1.87,23.45,23.45,0,0,0-.25,4.51c0,.31,0,.63-.28.85Z"
            />
            <path
              class="cls-653"
              d="M192.67,509.22a17.5,17.5,0,0,1,2.54-3.35c-.35,2-1.76,3.51-2.18,5.43A1.65,1.65,0,0,1,192.67,509.22Z"
            />
            <path
              class="cls-654"
              d="M194.92,521.79c.29.31.16.69.19,1,0,.75.83.42,1.09.83-.74.74-1.93.33-2.68,1C193.89,523.68,194,522.53,194.92,521.79Z"
            />
            <path
              class="cls-655"
              d="M202.82,498.17a3.61,3.61,0,0,1-3.56-1.86,6.13,6.13,0,0,0,2.94,1.07c.39,0,.42.4.63.6A.17.17,0,0,1,202.82,498.17Z"
            />
            <path
              class="cls-656"
              d="M196.69,541.32c-1.29,0-2.59,0-3.88,0-.82,0-1.23-.17-1.2-1.1.06-1.7,0-3.4,0-5.09,0-.83.28-1.09,1.09-1.08q4.08.06,8.17,0c.95,0,1.39.43,1.18,1.3a18.76,18.76,0,0,0-.21,4.79c0,1-.37,1.22-1.26,1.18C199.28,541.28,198,541.32,196.69,541.32Z"
            />
            <path
              class="cls-657"
              d="M196.2,523.66c-.22-.46-2,1.15-1.09-.83a5,5,0,0,0,3.41,0c.07.32.47.62.21.95s-.57.09-.86,0A4.7,4.7,0,0,0,196.2,523.66Z"
            />
            <path
              class="cls-658"
              d="M987.45,496.14a22,22,0,0,0-3.35.05c-.65.19-1-.07-1.08-.72s.29-.94.87-1.07,1.07-.07,1.6-.18l2.84-.71a7.43,7.43,0,0,0,2.25-1.08,5,5,0,0,0,2.66-.07c1.92-.36,3.83-.78,5.77-1.06a14.91,14.91,0,0,0,3.53-.29,13.25,13.25,0,0,0,5.43.13.94.94,0,0,1,.68,0,7,7,0,0,1,.21.75c.52,2.87-.42,4.21-3.32,4.55a21,21,0,0,1-8.15-.71c-1.9-.53-3.73-.9-5.63,0a5.41,5.41,0,0,1-2.4.45A5.11,5.11,0,0,0,987.45,496.14Z"
            />
            <path
              class="cls-659"
              d="M1008.65,491.12c-1.45.73-3,.5-4.51.37-.54-.05-1.23.26-1.66-.38a.37.37,0,0,1-.07-.27,1.27,1.27,0,0,1,.85-1.35c.47-.16.51-.65.62-1.08.39-1.54.55-3.13.93-4.68a5.54,5.54,0,0,0,.46-2.81,1.24,1.24,0,0,0-.95-1.21c-.58-.17-.94.2-1.25.6a3,3,0,0,0-.49,2c0,.37,0,.75,0,1.13a5.84,5.84,0,0,1-.18,1.56c-.07.3-.11.66-.57.63a4.69,4.69,0,0,0-.62-1,2.08,2.08,0,0,1-.37-2.64,33,33,0,0,0,1.49-3.32,7.78,7.78,0,0,1,1.41-1.62c.67.22.8.92,1.24,1.35.15.15.12.46.42.49a13,13,0,0,1,1.51,4.88C1007.25,486.24,1008.24,488.61,1008.65,491.12Z"
            />
            <path
              class="cls-660"
              d="M1005.41,478.84c-.28.3-.34-.07-.43-.17-.42-.52-.81-1.06-1.21-1.6a6,6,0,0,1-1.38-1.76c-.16-.28-.2-.42-.62-.32a3,3,0,0,1-2.73-.72c-.18-1.45.41-2.3,1.92-2.8a5.44,5.44,0,0,0,1.56,0c2.15-1,3.32-.27,3.34,2.15a9,9,0,0,1-.4,2.58A4.35,4.35,0,0,0,1005.41,478.84Z"
            />
            <path
              class="cls-661"
              d="M1005,483.73c-.29,1.61-.6,3.23-.88,4.84-.12.63-.29,1.18-1.06,1.28s-.12.81-.51,1c-.18.14-.31.09-.41-.09.07-.33,0-.56-.4-.45s-.81.22-1.21.35-1,.22-1.56.34c-1.52.35-3.07.57-4.6.89a2.38,2.38,0,0,1-1.62-.09c-.22-.54.23-.74.54-.93a5,5,0,0,1,3-1,3.52,3.52,0,0,0,1.29-.06c1.27-.31,2.42-1,3.66-1.35a.5.5,0,0,0,.31-.29,4.88,4.88,0,0,0,.29-2.62c.58-.67.42-1.51.54-2.29A2.86,2.86,0,0,1,1005,483.73Z"
            />
            <path
              class="cls-662"
              d="M999,474.27a9.25,9.25,0,0,0,2,.61c.25,0,.53.17.74-.07.52-.61.69-.32.8.28.15.8,1,1.2,1.19,2a4.43,4.43,0,0,1-1.43,1.55c-.21-.49-.4-1-1.11-.55a.67.67,0,0,1-.5,0,4,4,0,0,1-1.36-2A5.66,5.66,0,0,0,999,474.27Z"
            />
            <path
              class="cls-663"
              d="M992.7,491.8a33.66,33.66,0,0,0,5.56-.86c.22,0,.43-.24.66-.05s.22.32.09.52c-2.47.68-5,1-7.51,1.52-.52.12-.53-.51-.92-.5a7.09,7.09,0,0,0-1.29-2.16c-.68-1.08-1.46-2.1-2.16-3.17-.17-.26-.69-.6-.11-.92s.49.29.63.5c1.06,1.49,2.08,3,3.11,4.53.18.27.33.56.71.56C991.88,492.1,992.29,491.65,992.7,491.8Z"
            />
            <path
              class="cls-664"
              d="M983.21,495.46c0,.56.32.82.89.73a13.61,13.61,0,0,0-2.5.61.6.6,0,0,1-.79-.37,11.29,11.29,0,0,1-1.43-4c0-.31-.09-.69.32-.81s.56.22.77.45.42.83.85,1.07C982,493.9,983.15,494.23,983.21,495.46Z"
            />
            <path
              class="cls-665"
              d="M983.21,495.46a1.54,1.54,0,0,0-1-1.19c-.51-.21-.58-.75-.92-1.09,0-.2,0-.4,0-.6,0-.61.31-.71.78-.42a2.86,2.86,0,0,1,.76.57,4.17,4.17,0,0,0,2.66,1.49,3.28,3.28,0,0,1-1.62.41C983.34,494.71,983.15,495,983.21,495.46Z"
            />
            <path
              class="cls-666"
              d="M992.7,491.8a1.62,1.62,0,0,1-1,.34c-.35.06-.28-.16-.22-.37.68-.5,1.4-.95,2-1.51a2.32,2.32,0,0,1,2.29-.69c.59.15,1.2.21,1.8.31-.52.44-1.14.32-1.74.36A4.06,4.06,0,0,0,992.7,491.8Z"
            />
            <path
              class="cls-667"
              d="M1002.52,471.44a1.81,1.81,0,0,1-1.56,0A2.76,2.76,0,0,1,1002.52,471.44Z"
            />
            <path
              class="cls-668"
              d="M987.45,496.14a2.48,2.48,0,0,1,1.91,0A8.14,8.14,0,0,1,987.45,496.14Z"
            />
            <path
              class="cls-669"
              d="M999,491.41l-.09-.52a4.68,4.68,0,0,1,1.68-.39c.56,0,1.14-.23,1.6.28l.34.12-.06.21A5.32,5.32,0,0,1,999,491.41Z"
            />
            <path
              class="cls-670"
              d="M1005,483.73l-2.61-.4a4.84,4.84,0,0,1,.32-2.91c.34-.66.8-1.16,1.65-1a1.41,1.41,0,0,1,1.19,1.59A4.59,4.59,0,0,1,1005,483.73Z"
            />
            <path
              class="cls-671"
              d="M1002.2,490.78l-1.6-.28a4.81,4.81,0,0,1,1.38-.43c.18-.06.42-.13.52.13A.39.39,0,0,1,1002.2,490.78Z"
            />
            <path
              class="cls-660"
              d="M858.88,526.46a16,16,0,0,1,.13-3c.2.18.11.42.13.64,0-3.8-.06-7.59-.23-11.38a1.13,1.13,0,0,1,.66-1.43,16.06,16.06,0,0,1,2.57-1.49,8.74,8.74,0,0,0,1.53.1c.07,0,.26.29.28-.06a.31.31,0,0,1,.18-.22c1.36-.19,2.74-.27,4.11-.47a.73.73,0,0,1,.51.13,135.91,135.91,0,0,1,1.85,14.08,31.09,31.09,0,0,0-.07,3.74c0,2.25,0,4.51.09,6.76-.14,1-.58,1.16-1.86.73a49.41,49.41,0,0,1-.92-5.68c-.73-5-1.68-10-2.77-14.95a2.91,2.91,0,0,0-.55-1.42,36.32,36.32,0,0,0-1,4.61c-1.06,5.49-1.72,11-2.29,16.6,0,.39-.13.78-.19,1.17a3.33,3.33,0,0,0-2.15.55,19,19,0,0,1-.06-5A14.48,14.48,0,0,1,859,533C858.9,530.92,859.06,528.69,858.88,526.46Z"
            />
            <path
              class="cls-672"
              d="M859.22,506a1.51,1.51,0,0,0,.2-2.23c-.48-.41-1-.81-1.5-1.18a2.53,2.53,0,0,1-1-2.9c.37-1.47.78-2.93,1.21-4.38.59-1.94,1.54-3.52,3.84-3.71a4.77,4.77,0,0,0,1-.25,4,4,0,0,0,2.22,2.3,1.38,1.38,0,0,0,1.46-.14c.43-.36.29-.82.19-1.27a1.08,1.08,0,0,1,0-.71c.48.18,1,.06,1.48.34a22.87,22.87,0,0,1,.44,5.54,14.56,14.56,0,0,1-2.83,7.87,1.17,1.17,0,0,1-.68.22c-1.3.17-1.42.37-1.07,1.63a6.72,6.72,0,0,1-3.31,2.8,3.12,3.12,0,0,1-1.18-.1c-.51-.2-.45-.64-.45-1.06A9.52,9.52,0,0,0,859.22,506Z"
            />
            <path
              class="cls-673"
              d="M866.75,491.57a7.93,7.93,0,0,1,.37,1,1.24,1.24,0,0,1-1.35,1.51,4,4,0,0,1-2.94-2.47c0-.07.06-.16.1-.25.45,0,.51-.27.52-.66a11.37,11.37,0,0,0-.57-3c-.13-.23,0-.47,0-.71s.08-.78.51-.85.66.31.74.73c-.13-.75.25-1.08,1-1.09.87,0,1.72-.41,2.6-.1a13.19,13.19,0,0,1-.16,2.74,2.83,2.83,0,0,1-1.07,2.12C865.87,490.94,866.27,491.34,866.75,491.57Z"
            />
            <path
              class="cls-674"
              d="M868.75,509.26a35.85,35.85,0,0,1-4.84.55c-.52.13-1.23.36-1.5-.12s.48-.73.8-1.05a6.69,6.69,0,0,1,1.07-1,.88.88,0,0,1,.53-.07,1.11,1.11,0,0,0,1.33-1.43,1.22,1.22,0,0,1,0-.8,18,18,0,0,0,2.67-7.43,19,19,0,0,0-.15-4.64c0-.33-.16-.67.09-1a5.89,5.89,0,0,1,1.6,2.2c.17.29.31.59.46.88-1.44.33-.89,1.56-1.11,2.45-.18,1.12-.25,2.25-.47,3.35-.15.71.34.73.82.74h5a1.74,1.74,0,0,1,1.22.27c-.25.33-.62.19-.93.19-2,0-3.91,0-5.87,0-.56,0-.74.18-.74.73C868.79,505.17,868.76,507.22,868.75,509.26Z"
            />
            <path
              class="cls-675"
              d="M876.31,502.2c-2.25,0-4.5,0-6.75,0-.59,0-.83-.13-.69-.78.25-1.22.41-2.45.62-3.67a1.9,1.9,0,0,0,1.41.48c1.25,0,2.49,0,3.74,0,.6.36,1.11.83,1.69,1.21Z"
            />
            <path
              class="cls-659"
              d="M864.41,507.74l-1.71,2.07c.22.12.75-.16,1.21,0a.12.12,0,0,1,0,.09,3.39,3.39,0,0,1-1.76,0l-2.85,1.78c-.33.2-.31.5-.25.81a10.7,10.7,0,0,1,0,1.7c-.14.32,0,.72-.27,1-1.9-.32-2.48-1.06-2.2-2.94.22-1.47.49-2.94.76-4.41a2.11,2.11,0,0,1,1.8-1.82c.43,0,.42.36.39.67-.08.8-.15,1.61-.25,2.41,0,.23,0,.41.18.54,0,.23-.15.47.08.72a9.69,9.69,0,0,1,1.26-.6,11.41,11.41,0,0,0,3.12-2.63C864.42,507.15,864.47,507.41,864.41,507.74Z"
            />
            <path
              class="cls-676"
              d="M874.84,498.36a6.65,6.65,0,0,1-2.51.16c-.67.05-1.35,0-2,0s-.87-.15-.82-.75c0-.36,0-.72,0-1.08,0-1.24,0-1.24,1.28-1.32l4.29,0c1.24,0,1.24,0,1.23,1.27l0,.09A1.61,1.61,0,0,0,874.84,498.36Z"
            />
            <path
              class="cls-677"
              d="M867.67,485.71a5.14,5.14,0,0,1-2.06.27c-1.38.13-1.39.1-1.34,1.4-.43-.26-.12-1.14-.77-1.08s-.2.91-.58,1.26c0,0,0,.11,0,.17a7.17,7.17,0,0,1-.71-3c0-.72.4-1.08,1.05-1.29.34-.11.6-.42,1-.45a12.32,12.32,0,0,0,2.19,0C867.43,483.25,867.83,484.11,867.67,485.71Z"
            />
            <path
              class="cls-678"
              d="M868.76,534.57c.36-.22.73,0,1.1,0s.61-.16.59-.58c.26-.67-.13-1.41.21-2.08,0,.42.06.85.08,1.27a2.1,2.1,0,0,0,1.82,2.4c.54.16,1.39.17,1.34.84s-1,.55-1.51.67c-1.34.27-2.45-.44-3.55-1C868.23,535.76,868.66,535.09,868.76,534.57Z"
            />
            <path
              class="cls-679"
              d="M868.75,492.31a17.38,17.38,0,0,1-.33,8.74,14.73,14.73,0,0,1-2.2,4.48c-.27.13-.52.19-.6-.22A15.78,15.78,0,0,0,868,492.54c0-.23-.3-.56.19-.63Z"
            />
            <path
              class="cls-642"
              d="M858.89,535.45a1.72,1.72,0,0,1,2.15-.55,4.28,4.28,0,0,0,1.89,1.06c.42.13.85.38.83.86s-.56.58-1,.68c-1.45.36-2.59-.39-3.72-1.12C858.75,536.17,858.8,535.79,858.89,535.45Z"
            />
            <path
              class="cls-680"
              d="M874.84,498.36c-.14-1.25,0-1.67,1.49-1.67.89.75.89,1.5,0,2.76C875.75,499.2,874.85,499.39,874.84,498.36Z"
            />
            <path
              class="cls-681"
              d="M859,514.3c0-.6,0-1.19.05-1.79a.76.76,0,0,1,.14.6v11.26a.64.64,0,0,1-.13.41l-.09-1.34,0-3.68A39.8,39.8,0,0,1,859,514.3Z"
            />
            <path
              class="cls-682"
              d="M870.66,531.89c-.18.68.17,1.42-.21,2.08q0-4.92,0-9.86c0-.27-.09-.56.16-.77C870.72,526.19,870.71,529,870.66,531.89Z"
            />
            <path
              class="cls-683"
              d="M858.88,526.46c.29.31.16.69.16,1a44.55,44.55,0,0,1-.21,5.54v-2.59Z"
            />
            <path
              class="cls-660"
              d="M859,514.3c0,1.82,0,3.64,0,5.46-.28-1.51,0-3-.17-4.55C859,514.92,858.81,514.57,859,514.3Z"
            />
            <path
              class="cls-684"
              d="M866.39,483a3.42,3.42,0,0,1-2.19,0A4.51,4.51,0,0,1,866.39,483Z"
            />
            <path
              class="cls-685"
              d="M862.19,509.92l1.76,0,.09,0,.12.1A3.32,3.32,0,0,1,862.19,509.92Z"
            />
            <path
              class="cls-686"
              d="M865.62,505.31a.63.63,0,0,0,.6.22c-.19.47.56.75.21,1.34-.49.83-1,1.36-2,.87l-.41-.59c-.15-.36-.66-.61-.34-1.11a1.23,1.23,0,0,1,1.33-.72A3.32,3.32,0,0,0,865.62,505.31Z"
            />
            <path
              class="cls-687"
              d="M860.34,498.28c-.74,2.44,1.56,3.5,2.37,5.39a20.19,20.19,0,0,1-3-3.16c-.24-.31-.09-.7.08-1Z"
            />
            <path
              class="cls-688"
              d="M860.88,509.78a5.25,5.25,0,0,1-1.63,1.07c0-.48-.22-.91.29-1.19Z"
            />
            <path
              class="cls-689"
              d="M863.92,489.87a4,4,0,0,0,1.74.73c.18,0,.4.08.34.33s-.33.15-.5.1A2.23,2.23,0,0,1,863.92,489.87Z"
            />
            <path
              class="cls-690"
              d="M1064.7,499.72l-1,.7c-.59.36-.39.8-.13,1.23,2.31,3.76,3.09,8.05,4.32,12.19.7,2.34.61,4.73,1,7.07a6.31,6.31,0,0,1-.39,2.58c-.42,1.66-.82,3.32-1.1,5-.06.35,0,.92-.7.54-.21-.11-.44-.31-.64-.09a.83.83,0,0,0,0,1,3.64,3.64,0,0,1,.25,2.89,1.4,1.4,0,0,0-.13.34.58.58,0,0,0,.15.52,3.22,3.22,0,0,0,.93,0,21,21,0,0,0,5.7-.48c.37-.07.72-.2,1.09-.24a13.42,13.42,0,0,0,3.81-1.2c.25-.17.49-.4.77,0,.15.22.33.32.53,0a7.27,7.27,0,0,0,.32-3.27,1,1,0,0,1,.48-1.08c-1.22-1.57-1.16-3.45-1.39-5.28a1.82,1.82,0,0,1,.9-2.09,1.36,1.36,0,0,0,.6-.71,2.09,2.09,0,0,0-.55-1.76,4,4,0,0,1-.77-2.2c-.07-.16.16-.05,0,0s-.07.05,0,.12c.6.72.89,1.73,1.93,2.05a17.89,17.89,0,0,0,.17-5.79,68.09,68.09,0,0,0-.63-7,37.92,37.92,0,0,0-1-5,3,3,0,0,0-2.54-2.06c-.55-.09-1.1-.15-1.65-.22-1.6-.21-1.83-.47-2-2.22a1.91,1.91,0,0,0-1.46.39c-.24.29-.74.37-.7.88.12.21.32.35.44.55a.45.45,0,0,1,0,.55c-.18.23-.35,0-.49-.08a.59.59,0,0,0-.76-.13,8.45,8.45,0,0,1-2.23.73A9.87,9.87,0,0,0,1064.7,499.72Z"
            />
            <path
              class="cls-691"
              d="M1104.91,528.44c1.93-.73,3.86-1.46,5.75-2.31a6.2,6.2,0,0,0,4.12-6.08,180.93,180.93,0,0,0-.64-18.49,8.94,8.94,0,0,0-3.06-6.14c-1.47.36-3,.46-4.46.81a31.46,31.46,0,0,0-3.46.92c-3.24,1.13-3.72,1.75-3.67,5.18.1,6.63.35,13.26.89,19.88.14,1.75.47,3.46.77,5.18a1.79,1.79,0,0,0,.8,1.4A3.16,3.16,0,0,0,1104.91,528.44Z"
            />
            <path
              class="cls-692"
              d="M1067.11,533.47a.93.93,0,0,0-.75.21c-.86.66-.71,1.85-1.37,2.62.16,2.5-1.27,4.74-1.14,7.25a3.12,3.12,0,0,1-.66,1.89,1.45,1.45,0,0,1-1.52.45,1,1,0,0,0-1,.18,13,13,0,0,0-1.49,3.74,86.68,86.68,0,0,0-3.43,12c-.47,2.63-.54,5.29-1,7.92-.36,2.27-.54,4.57-.92,6.84-.09.53-.2,1,.23,1.46.92.47,1.83.81,2.67-.16a62.94,62.94,0,0,0,1.83-10.55c.53-5.66,2.66-10.75,5.21-15.72,1-2,2.11-3.83,3.24-5.7a2.17,2.17,0,0,1,1.91-1c.73-.07.62.64.71,1q1.23,5.28,2.68,10.5a14,14,0,0,1,.71,2.76,13.42,13.42,0,0,0,1.4,4.14c.75,1.7,1.64,3.35,2.48,5,.77.17.78.92,1,1.44a73.55,73.55,0,0,1,3.74,11.86,3.15,3.15,0,0,0,3.35-.27c-1.24-2.21-1.61-4.72-2.14-7.13-.46-2.07-1-4.1-1.69-6.08q-1.53-4.69-3.37-9.31a50.72,50.72,0,0,1-2.67-8.52,15.9,15.9,0,0,1-.13-5.8,1.49,1.49,0,0,1,.76-1,8.28,8.28,0,0,0,3.19-3.47,11.26,11.26,0,0,1,.34-1.36c.36-2.28.63-4.56-.32-6.78-.19-.61-.39-1.2-1.14-.49.33,2,.2,2.21-1.74,2.67a20.58,20.58,0,0,1-2.22.38,3.59,3.59,0,0,0-.72.11,19.23,19.23,0,0,1-4.13.59c-1,.07-1.75-.14-1.73-1.36A.67.67,0,0,0,1067.11,533.47Z"
            />
            <path
              class="cls-693"
              d="M1114.2,576.48a86.35,86.35,0,0,0-5.52-16.83c-2.56-5.65-3.61-11.66-4.28-17.76-.24-2.14-.38-4.28-.56-6.42-.14-1.84-.13-1.82-1.67-.81a13.64,13.64,0,0,1-11.37,1.7c-.49-.12-1-.44-1.48-.12a20.92,20.92,0,0,0,.78,6.44.45.45,0,0,0,.51.4c.66-.63,1.33-1.25,2-1.89s.87-.44,1.05.38a70.75,70.75,0,0,0,4.74,15,76.44,76.44,0,0,0,4.45,8,87.52,87.52,0,0,1,6.56,13.36A4.43,4.43,0,0,0,1114.2,576.48Z"
            />
            <path
              class="cls-694"
              d="M1089.33,536.21a13.9,13.9,0,0,0,14.22-2.1c.28.44,0,1,.29,1.36a3.85,3.85,0,0,1,.8-2.84c.62-.74.21-1.76.28-2.65,0-.51,0-1,0-1.54a11.5,11.5,0,0,1-2.93.17,1.23,1.23,0,0,0-1-.16c-.65.29-.8.95-1.12,1.49-1,1.61-2,2.09-3.53,1.7a2.5,2.5,0,0,1-1.56-1.19,7,7,0,0,1-1.07-3.49,95.73,95.73,0,0,0-1.8-13.91c-.9-1.95-.92-4.08-1.2-6.15a25.61,25.61,0,0,1-.42-6.72,4.08,4.08,0,0,1,2.16-3.46.85.85,0,0,0,.53-.59,2.63,2.63,0,0,0-3.78-.05c-2.54,2.46-4.1,5.32-3.58,9.05.49,3.47,1,6.94,1.33,10.42.34,3.2.35,6.39-1.84,9.11a2.52,2.52,0,0,0-.46,1,6.14,6.14,0,0,0,1.52,3.41,2.66,2.66,0,0,1,1.71,2.08c.35,1.3.43,2.65.78,3.95C1088.79,535.49,1088.73,536,1089.33,536.21Z"
            />
            <path
              class="cls-695"
              d="M1092.92,496.14c-2.81,1.14-3.2,2.92-3,6.17.17,3,.71,6,1.1,9a2.67,2.67,0,0,0,.7,1.83,1.23,1.23,0,0,0,1.44.09,3.09,3.09,0,0,0,.27-2.43c-.42-2.95-.76-5.92-1.06-8.89a8,8,0,0,1,.36-3.18c.1-.33.33-.71.78-.53s.27.52.18.82c-.78,2.71-.41,5.46-.3,8.19.09,2.38.15,4.77.38,7.14.26,2.61.24,5.24.62,7.84a6.94,6.94,0,0,0,4.05,5.53c.33.16.63.36.94.54a3.07,3.07,0,0,0,1.68.37h.94a14.16,14.16,0,0,1-1.14-5.15c-.27-3.15-.46-6.32-.58-9.49-.16-4.31-.36-8.63-.46-13a2.83,2.83,0,0,1,1.93-2.93,25.73,25.73,0,0,1,7.92-2,1.68,1.68,0,0,0,1.43-.7,7.66,7.66,0,0,0-5.11-1.25,1.24,1.24,0,0,1-1.44-.82c-.64-1.45-2.38-1.87-4.4-1.11a8.37,8.37,0,0,1-2.64.56,3.09,3.09,0,0,1-.06,2.22c-.3,1.25-.84,1.57-2,1.14C1094.56,495.87,1093.74,495.51,1092.92,496.14Z"
            />
            <path
              class="cls-696"
              d="M1065.17,536.28c.95-.61.69-1.78,1.19-2.6v-.5c-.74,0-.91.81-1.56,1.14.54-1.2,1.6-2.18,1-3.63.63.79.17,1.73.59,2.5.89-.89.5-1.89.24-2.87-.11-.4-.5-.72-.42-1.22.66-.07.51.7.92.88a1.52,1.52,0,0,0,.64-1.1,41.86,41.86,0,0,1,1.28-6c.53-2.18.06-4.34-.21-6.45-.42-3.31-1.64-6.46-2.56-9.67a18.63,18.63,0,0,0-2.48-5.37.81.81,0,0,1,0-1c-2.27,1.24-3.28,1.87-2.69,4.79a7.07,7.07,0,0,1-1,4.66,4.85,4.85,0,0,0,.06,5.19,4,4,0,0,0,2.59,1.55c.61.14.73.4.76,1a23.28,23.28,0,0,1-1.52,10.5,8.71,8.71,0,0,0-.86,4.44,1.73,1.73,0,0,0,.39.25c.24.09.49.16.72.26.65.69-.12,1.29-.1,2a.68.68,0,0,0,.16.49A3.62,3.62,0,0,0,1065.17,536.28Z"
            />
            <path
              class="cls-697"
              d="M1062.4,535.3l-.1-.43c.1-.7.47-1.41,0-2.11l-.73-.2c-.54.63.07,1.48-.42,2.12-1.23,3.09-2.5,6.17-3.7,9.28a93.48,93.48,0,0,0-4.79,14.94,28.68,28.68,0,0,0-.42,5.93,90.85,90.85,0,0,1-.71,12.12,2.41,2.41,0,0,0,2.64.94c-.35-1.08.24-2.07.33-3.11.24-2.75.86-5.46,1.06-8.21a55.31,55.31,0,0,1,1.18-7.58c.59-2.76,1.6-5.38,2.44-8,.5-1.62,1.11-3.2,1.68-4.81a3.88,3.88,0,0,0,0-2.11,7.65,7.65,0,0,1,.57-4.78,22.58,22.58,0,0,0,1-2.44A1.75,1.75,0,0,0,1062.4,535.3Z"
            />
            <path
              class="cls-698"
              d="M1092.92,496.14a4.21,4.21,0,0,1,2.64.45,1.51,1.51,0,0,0,2.13-1.2,3.1,3.1,0,0,1,.11-.7c.27-.7.51-1.38-.31-1.89l-.28-.27c-.67-.41-1.3,0-2,.09a21.4,21.4,0,0,1-4,.26,1.43,1.43,0,0,0-1.2.38,3.39,3.39,0,0,0-.64.85c-.9,2.63-3.22,4-5.16,5.6a5,5,0,0,0-2.08,4.41c.37,5.43.75,10.86.87,16.3a2.08,2.08,0,0,1-.12,1.28,7,7,0,0,0,1.93,4.07c.78-1.5,2-2.81,2.33-4.51a19,19,0,0,0,.1-5.93c-.29-3-.71-5.88-1.08-8.82a24.35,24.35,0,0,1-.27-3.53c0-2.93,1.8-4.94,3.67-6.8A2.51,2.51,0,0,1,1092.92,496.14Z"
            />
            <path
              class="cls-699"
              d="M1097.16,491.36a5.26,5.26,0,0,1,1.61-3.73,5.85,5.85,0,0,0,1.83-4.5c0-.36,0-.72,0-1.07.22-3.37-1.4-5.36-4.76-5.83-.46,0-1.11-.46-1,.61,0,.34-.61.41-1,.5a32.19,32.19,0,0,0-3.19.91c-2.22.86-2.9,2.09-2.44,4.44a1.76,1.76,0,0,0,1,.74,22.55,22.55,0,0,0,3.86,1.07c.53,0,.61.38.48.85-.21.79-.88,1.17-1.44,1.67a1.66,1.66,0,0,0-.3,1.77c.08.26.16.52.25.79a3.27,3.27,0,0,0,4.67,2.19A.82.82,0,0,0,1097.16,491.36Z"
            />
            <path
              class="cls-700"
              d="M1078.78,540.12a9.85,9.85,0,0,1-3.64,3.5.66.66,0,0,0-.41.67,22.87,22.87,0,0,1-.24,2.48,25.94,25.94,0,0,0,1.54,7.89c.81,2.23,1.48,4.51,2.44,6.7.78,1.76,1.33,3.63,1.93,5.46a64.71,64.71,0,0,1,2.22,7.87c.4,2,1,3.91,1.47,5.86a.84.84,0,0,0,1,.72c.84.29,1.53.19,1.9-.73-1.12-6.16-2.18-12.34-4.6-18.17-1-.56-.95-1.65-1.12-2.52-.2-1.11-1-2.22-.33-3.42a5.93,5.93,0,0,0-.51-2.91c-.31-.32-.64-.44-.82.07-.75,2-1.35,4.11.06,6.13a2.26,2.26,0,0,1,.13,2.14c0-1.33-.8-2.3-1.32-3.42a18.33,18.33,0,0,1-1.81-5.77c0-.27,0-.58-.13-.81-1.37-1.92-.87-4.13-1-6.25a2,2,0,0,1,.84-1.62,8.12,8.12,0,0,0,2.34-2.67C1078.88,540.93,1079.17,540.55,1078.78,540.12Z"
            />
            <path
              class="cls-701"
              d="M1089.33,536.21c-.66-1.8-.66-3.74-1.21-5.56-.3-1-.74-1.75-1.91-1.79a.32.32,0,0,0-.37,0,5,5,0,0,0-1.06,3.45,56.88,56.88,0,0,0,1.49,11.09,7.6,7.6,0,0,1-.2,3.52,1.24,1.24,0,0,1-1.53,1c-1.23-.16-2.4-.56-3.61-.79a1,1,0,0,1-.77-1.08c-.1-2.8-.68-5.59-.17-8.43a17.72,17.72,0,0,0,0-4.88,25.41,25.41,0,0,1-.16-2.62c0-1.7,0-1.7,1.5-2.11.28-.36-.06-.44-.26-.59-.38-.12-.76-.3-1.15,0-.48,0-1-.1-.85.68a15.43,15.43,0,0,1-.08,3.9,21.39,21.39,0,0,1,0,7,22.63,22.63,0,0,0,.35,8.52,1.15,1.15,0,0,0,.72.57c1.44.45,2.93.65,4.38,1a2,2,0,0,0,1.38-.23,4.26,4.26,0,0,1,1.83-.78c2.51-.82,2.74-1.12,2.74-3.71,0-.43-.1-.88.23-1.24-.7-1.2-.54-2.57-.79-3.86C1089.62,538.22,1089.49,537.21,1089.33,536.21Z"
            />
            <path
              class="cls-702"
              d="M1076.61,486.31c.69-3.61-.83-6-4.19-6.5-.47-.12-.91-.19-.91.5,0,.9-.58,1.24-1.34,1.42-1.05.25-2.09.54-3.15.72a3.82,3.82,0,0,0-3.11,2.49,1.63,1.63,0,0,0,.11,1.7,2,2,0,0,0,1,.66,31.21,31.21,0,0,0,9.25.54l1.06-.15A1.27,1.27,0,0,0,1076.61,486.31Z"
            />
            <path
              class="cls-703"
              d="M1089.34,483.19l-1-.45a2.06,2.06,0,0,0-2.1-.55,15.84,15.84,0,0,0-.22,7.05,10.76,10.76,0,0,1,.18,2.59c0,1.12.49,1.54,1.52,1.39a19.09,19.09,0,0,0,2-.4c.46-.1.46.12.35.44,1.49-.17,3,.06,4.49-.2.89-.16,1.77-.38,2.66-.53,0-.39,0-.78,0-1.17a8.71,8.71,0,0,1-3.63.13c-.15,0-.37,0-.44-.14-.65-.93-.65-2.09-1.13-3.09-.26-.53.25-.86.5-1.23.53-.69.54-1.32-.23-1.82s-1.3-.12-1.8.78c-.15.27-.19.7-.56.69s-.42-.51-.52-.83a2.62,2.62,0,0,1,0-1.52C1089.41,484,1089.61,483.58,1089.34,483.19Z"
            />
            <path
              class="cls-704"
              d="M1069.93,574.32a2.59,2.59,0,0,1-2.39,1.25,13,13,0,0,1-4.12-.38,3.13,3.13,0,0,0-3.08.52,4.47,4.47,0,0,0,3.52,4.06c2.7.65,5.44,1.13,8.12,1.87a1.42,1.42,0,0,0,1.75-.86,24.74,24.74,0,0,0,.27-5c-.64,0-1.18.58-1.91.34s-1.68-.54-1.84-1.6C1070.23,574.34,1070.12,574.23,1069.93,574.32Z"
            />
            <path
              class="cls-705"
              d="M1076.61,486.31a1.37,1.37,0,0,1-1.2,1,23.93,23.93,0,0,1-7.6.08c-1-.1-1.94-.23-2.92-.35-.06,1.34.68,2.41,1.2,3.54.24.51.67.51,1,0,.08-.14.13-.3.21-.43.17-.28.36-.57.74-.42a.55.55,0,0,1,.29.71c-.47,1.74.54,3.14,1.11,4.63.36,1,1.12,1.17,2.23.83l1.38-.5a5.72,5.72,0,0,1,1.34-2.72A10.1,10.1,0,0,0,1076.61,486.31Z"
            />
            <path
              class="cls-706"
              d="M1071.64,495.86a2.13,2.13,0,0,1-2.4-1.92c-.26-1.2-1.2-2.26-.53-3.64a.81.81,0,0,0-.62-1.1.84.84,0,0,0-1,.57c-.15.34-.27.71-.49,1.28l-1.66-4-.69-.51c-1.06-.63-1.39-.58-1.87.28.41.7.12,1.47.14,2.2a30.85,30.85,0,0,0,.75,6.57c.36,1.48.59,1.68,2.12,1.32l1.26-.32a14.29,14.29,0,0,0,3,.36c.46,0,1,0,1.32-.35C1071.09,496.29,1071.66,496.37,1071.64,495.86Z"
            />
            <path
              class="cls-707"
              d="M1051.28,581c-.41.33-.25.7-.07,1.12a1,1,0,0,0-1.48-.15c-.36.34-.91-.33-1,.33-.92-1.13-2.39-.75-3.54-1.3a1.44,1.44,0,0,0-2.19,1c-.18,1.16.68,1.74,1.38,2.36a8.18,8.18,0,0,0,3.31,1.54c.79.24,1.59.48,2.39.7,1.16.28,2.26.91,3.52.65.43-.06.61-.43.85-.71.32-1.51.84-3,.45-4.58C1053.44,582.48,1052.33,581.81,1051.28,581Z"
            />
            <path
              class="cls-708"
              d="M1110.8,582.17a11.66,11.66,0,0,1-4.44-.15,2.44,2.44,0,0,0-2.5.61c-.1,2.38,1.85,3.06,3.46,3.6a14.47,14.47,0,0,0,7.48.59c1.16-.22,1.71-.75,1.8-1.78a15.8,15.8,0,0,0-1.46-3.8.5.5,0,0,0-.52.2A3.55,3.55,0,0,1,1110.8,582.17Z"
            />
            <path
              class="cls-709"
              d="M1076.94,568.4c0-.26.1-.52-.06-.8a81.69,81.69,0,0,1-3.82-8.35q-1.08,5.5-2.15,11a6.32,6.32,0,0,0,4.38,1.66.6.6,0,0,0,.6-.48Z"
            />
            <path
              class="cls-710"
              d="M1062.33,486.81c.54-.67,1.22-.38,1.87-.28a3.1,3.1,0,0,1,2.78-3.77c1.23-.15,2.4-.54,3.59-.79.8-.17,1.46-.61,1.25-1.57-.13-.62.28-.52.6-.59a10.35,10.35,0,0,0-9.5,2,4.26,4.26,0,0,0-1.1,5.84Z"
            />
            <path
              class="cls-711"
              d="M1088.63,587.22c-.62-1-1-2.09-1.93-2.81a2.39,2.39,0,0,1-3,.83.57.57,0,0,0-.56.06c0,.19,0,.49.08.55.63.34,0,.45-.1.66.15.64-.11.87-.73.74-.3,0-.14.67-.84.37s-1.52.17-2.3.27-1.14.36-1.22,1.08.4,1,.93,1.22a4.59,4.59,0,0,0,.56.18c3.11.92,6,.12,8.76-1.25C1089.06,588.62,1088.84,587.92,1088.63,587.22Z"
            />
            <path
              class="cls-712"
              d="M1085.81,548.81a44.35,44.35,0,0,1-6.28-1.21.52.52,0,0,0-.24.4c.17,1.85,0,3.76.9,5.5a15.81,15.81,0,0,1,.49,3.13c0,.21,0,.29.26.22A72.24,72.24,0,0,1,1085.81,548.81Z"
            />
            <path
              class="cls-713"
              d="M1086.26,482.19c.73.05,1.34.6,2.1.55.05-1.13-.2-2.31.72-3.27a6.28,6.28,0,0,1,2.74-1.28,18.81,18.81,0,0,0,3.28-1c.22-.12.62-.15.51-.52,0-.14-.37-.2-.66-.34l.92-.1c-2.21-.59-4.3.09-6.41.6a6.91,6.91,0,0,1-1.49.37,2.31,2.31,0,0,0-2.43,1.86A2.64,2.64,0,0,0,1086.26,482.19Z"
            />
            <path
              class="cls-714"
              d="M1086,528.88l.24,0-1.35-3.09c-.64-1.36-1.29-2.71-1.93-4.07l-2.22-4.1a14.46,14.46,0,0,0-2-2.25,1.85,1.85,0,0,0,.22,1.87,5.34,5.34,0,0,1,1.06,2.08c.53,2,1.68,3.8,2.43,5.73a9.35,9.35,0,0,0,.78,1.7c.39.67.3,1.13-.38,1.49.17.53.67.58,1.06.57C1084.57,528.76,1085.26,528.92,1086,528.88Z"
            />
            <path
              class="cls-715"
              d="M1075.89,571.44c-.49.46-1,.19-1.56.09a14.81,14.81,0,0,1-3.42-1.27c-.15,1.11-1.17,2.1-.49,3.33a4,4,0,0,0,3.87,1.27c.26-.05.64,0,.72-.28C1075.3,573.53,1076.29,572.67,1075.89,571.44Z"
            />
            <path
              class="cls-716"
              d="M1114.2,576.48a7.2,7.2,0,0,1-4.8,1.43c.35,1.11.12,2.48,1.43,3.15a3.68,3.68,0,0,0,3.78-1c.81-.69.31-1.44.11-2.17A3.1,3.1,0,0,0,1114.2,576.48Z"
            />
            <path
              class="cls-717"
              d="M1086.94,580.54a3.18,3.18,0,0,1-1.9.73,8.28,8.28,0,0,1-3.35.43c0,1.92.11,2.12,1.41,2.21a5,5,0,0,0,3.34-.28A2.2,2.2,0,0,0,1086.94,580.54Z"
            />
            <path
              class="cls-718"
              d="M1054.16,577.89a9.15,9.15,0,0,1-2.64-.94c-.4,1-1,2,.29,2.86a12.63,12.63,0,0,0,3.32.72c1.58-.23,1.57-1.46,1.64-2.64A3.29,3.29,0,0,1,1054.16,577.89Z"
            />
            <path
              class="cls-719"
              d="M1073.73,580.78a2.52,2.52,0,0,1-2.61.32,44.76,44.76,0,0,0-5.65-1.24c-2.54-.41-4.46-1.48-5.13-4.15a1.17,1.17,0,0,0-.06,1.6,6,6,0,0,0,3.33,2.72c.64.19,1.32.27,2,.47,1.27.4,2.64.27,3.83,1.33a4.77,4.77,0,0,0,3.43.62C1073.8,582.34,1073.66,581.46,1073.73,580.78Z"
            />
            <path
              class="cls-720"
              d="M1116.6,585c-.54,1.58-2,1.62-3.23,1.65-3.12.06-6.23-.1-8.78-2.39-.56-.51-.29-1.21-.73-1.67-.59,1-.09,1.64.58,2.27,1.88,1.78,4.25,2.17,6.71,2.34.5,0,1.09-.16,1.46.52.18.36,3.31-.25,3.84-.69C1117.17,586.46,1117,585.75,1116.6,585Z"
            />
            <path
              class="cls-721"
              d="M1070.91,496.59a14.1,14.1,0,0,1-3.31-.19.92.92,0,0,0-1,.18c0,1.45-.92,2.3-1.9,3.14,1.09-.4,2.21-.73,3.26-1.21.75-.33,1.7,0,2.28-.82.11-.14.32,0,.38.12.18.55.44.92,1,.33s.28-1-.24-1.4A1.52,1.52,0,0,0,1070.91,496.59Z"
            />
            <path
              class="cls-722"
              d="M1055.13,580.53a5.22,5.22,0,0,0-3.32-.72c0,.49-.28.8-.53,1.14a2.65,2.65,0,0,0,2.65,1.56,1,1,0,0,0,.94-.55C1055,581.49,1055,581,1055.13,580.53Z"
            />
            <path
              class="cls-723"
              d="M1074.29,574.86a9.46,9.46,0,0,1-3.87-1.27l-.49.73a1.75,1.75,0,0,0,1.46,1.9c.93.26,1.92.69,2.61-.45C1074.1,575.47,1074.19,575.17,1074.29,574.86Z"
            />
            <path
              class="cls-724"
              d="M1114.61,580.06a11.82,11.82,0,0,1-3.78,1l0,1.11c.9,1.22,3.32.56,4.34-.93A3,3,0,0,1,1114.61,580.06Z"
            />
            <path
              class="cls-725"
              d="M1086.44,583.63a11,11,0,0,0-3.34.28c0,.46.29.92,0,1.39a2.84,2.84,0,0,0,3,.14.86.86,0,0,0,.57-1Z"
            />
            <path
              class="cls-726"
              d="M1050.09,586.29c-1.32-.41-2.66-.75-4-1.23A4.33,4.33,0,0,1,1043,582c-.57.74.08,1.23.41,1.71a5.15,5.15,0,0,0,2.42,1.85c1.49.61,3,1.12,4.53,1.67A.78.78,0,0,0,1050.09,586.29Z"
            />
            <path
              class="cls-727"
              d="M1088.15,589c-1.05.37-2.1.71-3.13,1.12a10.36,10.36,0,0,1-5.52.3c1.22.86,2.69.62,4,.6a9.52,9.52,0,0,0,4.64-1.09A.68.68,0,0,0,1088.15,589Z"
            />
            <path
              class="cls-728"
              d="M1080.94,556.85l-.26-.22c-1.14.65.24,1.4-.06,2.21-.22.6.37,1.47.56,2.23s.27,1.32,1.16,1.3A30,30,0,0,1,1080.94,556.85Z"
            />
            <path
              class="cls-729"
              d="M1050.09,586.29a1.49,1.49,0,0,0,.24.94l1.91.75c.74.1.71.09,1-.54,0-.14.48-.05.47-.39C1052.41,587.15,1051.29,586.53,1050.09,586.29Z"
            />
            <path
              class="cls-730"
              d="M1088.15,589l0,.93c1.16-.14,1.45-.55,1.06-1.63a7.37,7.37,0,0,0-.56-1C1088.55,587.82,1088.83,588.52,1088.15,589Z"
            />
            <path
              class="cls-731"
              d="M1053.68,587.05c.16.41-1.16-.23-.48.71.17.24-.65,0-1,.22,1.66.79,2.11.49,2.18-1.44Z"
            />
            <path
              class="cls-732"
              d="M1061.14,534.68c.54.12.46-.28.45-.58,0-.51,0-1,0-1.54l-.44,0C1061.13,533.23,1061.13,534,1061.14,534.68Z"
            />
            <path
              class="cls-733"
              d="M1082.37,587.25c.24.36.39.57.83.09s.31-.59-.1-.83A1.86,1.86,0,0,0,1082.37,587.25Z"
            />
            <path
              class="cls-734"
              d="M1082.61,525a32.24,32.24,0,0,0-2.64-5.72c-2.76,1.46-1.56,3.82-1.29,5.93.1.86,0,2,1.26,2.18l1.09.22A5,5,0,0,0,1082.61,525Z"
            />
            <path
              class="cls-735"
              d="M1067.11,533.47c0,2.08,0,2.13,2,2.06,1.4,0,2.86.07,4.15-.68.46-.7.58-1.35-.25-1.88A27.87,27.87,0,0,1,1067.11,533.47Z"
            />
            <path
              class="cls-736"
              d="M1074,534.83c1.11-.2,2.24-.32,3.33-.61a1.63,1.63,0,0,0,.54-2.72,16.41,16.41,0,0,1-3.8,1.24A1.82,1.82,0,0,0,1074,534.83Z"
            />
            <path
              class="cls-737"
              d="M1074,534.83c0-.7,0-1.39.07-2.09l-1,.23c.43.58.17,1.25.25,1.88Z"
            />
            <path
              class="cls-728"
              d="M1080.19,553.5l-.66-5.9c-.28-2.87-.53-5.75-.55-8.65-.33.35-.13.78-.2,1.17-.23,1.79-1.6,2.76-2.83,3.78a1.65,1.65,0,0,0-.75,1.49c.11,1.66-.22,3.34.24,5a5.94,5.94,0,0,0,.62,1.36c.44.78.28,1.76.56,2.65a20.43,20.43,0,0,1,1.33,4.28.64.64,0,0,0,.38.43,1.67,1.67,0,0,1,.94,2v.12c.09.53.08,1.44.48,1.44.79,0,.31-.87.49-1.33a1.77,1.77,0,0,0-.64-2.11,2.22,2.22,0,0,1-.5-1.78,11,11,0,0,1,.76-3.95A1.72,1.72,0,0,1,1080.19,553.5Z"
            />
            <path
              class="cls-738"
              d="M1062.4,535.3a11.2,11.2,0,0,1-1.32,3.78,6.93,6.93,0,0,0-.69,3.78c.13,1.09.3,2.18.46,3.27.22,0,.61-.13.65-.06.77,1.39.85.16,1.13-.3.21.24.18.72.6.67s.18-.47.3-.69c1.07-2,.32-4.3,1.43-6.28.51-.92.16-2.12.21-3.19A15.21,15.21,0,0,1,1062.4,535.3Z"
            />
            <path
              class="cls-739"
              d="M1101,528.6a2.79,2.79,0,0,0-1.46-.45c-.62.1-.57.69-.79,1.08-.38.68-.78,1.37-1.67,1.31a2,2,0,0,1-1.79-1.53,9.84,9.84,0,0,1-.4-2.23q-.54-6.09-1.21-12.18a2,2,0,0,0-.59-1.51l-1.43,0c.34,2.31.65,4.63,1,6.94a50.64,50.64,0,0,1,.65,6.62,9,9,0,0,0,.82,3.45,3.25,3.25,0,0,0,3.21,2c1.28,0,2-.94,2.7-1.91C1100.46,529.73,1100.73,529.16,1101,528.6Z"
            />
            <path
              class="cls-740"
              d="M1093.13,513.09c.64,3.63,1,7.28,1.27,10.95a37.94,37.94,0,0,0,.38,4.24c.31,1.59,1.16,2.69,2.37,2.73,1,0,1.81-.92,2.21-2.46a2.24,2.24,0,0,1,.22-.4c-.15-.42-.51-.56-.89-.73a6.58,6.58,0,0,1-4.08-5.83c-.32-4.4-.62-8.79-.82-13.2-.11-2.42-.13-4.84-.17-7.27a3.23,3.23,0,0,1,.44-2.06c.41-.56.38-1.06-.26-1.38s-1.19,0-1.4.65a9.65,9.65,0,0,0-.35,4c.27,3,.65,5.91,1.09,8.86A12.06,12.06,0,0,1,1093.13,513.09Z"
            />
            <path
              class="cls-741"
              d="M1101.27,494.8c-.54-.58-1-1.13-1.74-1-.43.08-.56.62-.65,1.06s.11.72.63.53Z"
            />
            <path
              class="cls-742"
              d="M1101,493c.9.49,1.51.83,2.12,1.15.16.08.38.23.54.05s0-.43-.11-.62C1102.9,492.82,1102.08,492.94,1101,493Z"
            />
            <path
              class="cls-690"
              d="M1066.35,533.19a4.23,4.23,0,0,0-.53-3.27c-.2,1.63-.31,3.27-1.59,4.61,1.28.21,1.52-.84,2.13-1.35Z"
            />
            <path
              class="cls-743"
              d="M1062.29,532.76c0,.7,0,1.41,0,2.11.52-.45.36-1.15.6-1.71C1063.07,532.78,1062.61,532.75,1062.29,532.76Z"
            />
            <path
              class="cls-744"
              d="M1089.34,483.19a4.55,4.55,0,0,0-.14,3.44c.14.36.23.67.69.65s.53-.28.61-.61.13-.37.19-.56c.2-.6.58-1,1.23-.79a.9.9,0,0,1,.6,1.24,3.55,3.55,0,0,0-.06.47,2.2,2.2,0,0,0,1-.76c.31-.55.72-1.14.48-1.75s-.91-.25-1.38-.38C1091.5,483.85,1090.42,483.51,1089.34,483.19Z"
            />
            <path
              class="cls-745"
              d="M1086,528.88a1.76,1.76,0,0,0-1.71-.38,1.57,1.57,0,0,1-1.39-.33,3.1,3.1,0,0,0-1.65-.25c-.61.2-1.42-.5-1.76,0s.07,1.21,0,1.84c-.09,2,.37,3.87.27,5.82a13.52,13.52,0,0,1-.39,3.41c-.29.94.18,1.87.17,2.83a23.11,23.11,0,0,0,.39,5c.1.47.28.69.78.68a14.71,14.71,0,0,1,3.46.73c1.43.32,1.86-.14,2.32-1.51.79-2.37-.24-4.52-.52-6.73s-.66-4.36-.79-6.58A9.57,9.57,0,0,1,1086,528.88Z"
            />
            <path
              class="cls-746"
              d="M1081.46,527.9l1.41.27c1.11.14,1.29-.24.72-1.18a20.06,20.06,0,0,1-1-2,16.48,16.48,0,0,0-1.58,2.61Z"
            />
            <path
              class="cls-747"
              d="M123.9,463.83c6,2.25,9.21,7.48,9.35,15.75.13,7.62-1.2,15.09-2.52,22.56-.41,1.31-.91,2.64.44,3.74.68.81,2.12,1.2,1.51,2.73-9.24,3.67-10.84,11.74-11.26,20.2-.57,11.33,3.89,21.43,8.56,31.4A110.83,110.83,0,0,0,137,573c.76,1.87-.49,3-1.61,4.08-1.73,1.64-1.22,3.1,0,4.74s2.4,1.21,3.74.27c.76-.52,1.58-.94,2.45-.14,4.61,4.19,5.11,9.71,4.94,15.42,0,1.68-.72,3-2.59,3.43-6.07,3.83-12.88,4.93-19.83,4.88a63.74,63.74,0,0,1-22.8-4.72c-1.8-.71-3.64-1.37-4.11-3.59a9.44,9.44,0,0,0,1.53-5.45,185.06,185.06,0,0,1,.33-27,91.85,91.85,0,0,0,.06-9.82c0-2.55.4-5.09-2.62-6.7-1.59-.85-.89-2.42.66-3.07a5.63,5.63,0,0,1,6.4,1.25c.48-1.38.84-2.88-.58-3.33-2.54-.8-2.46-2.7-2.45-4.59s-.53-4.09.87-5.88c1.8-.43,1.05,1.62,1.94,2.11,1.28-1,1.27-2.34,1.36-3.67,2.25-6.48,5.07-12.63,10.07-17.54,7.37-5.72,7.42-13.65,6.61-21.84-.09-.9-.36-1.77-.49-2.66-.26-1.83-1.45-3.32-1.88-5.09a10.78,10.78,0,0,0-9.13-5.58c-1.21-.1-2.51.05-3.25-1.24a1.58,1.58,0,0,1,.07-1c4.78-1.9,9.95-2.57,14.67-4.63.82-.36,1.7-.59,2.5-1,3-1.5,3.09-2,.91-4.44C124.16,465.48,123.36,464.9,123.9,463.83Z"
            />
            <path
              class="cls-748"
              d="M82.36,563.29A9.13,9.13,0,0,0,78.08,572c.2,3,.82,6.06-.51,9-1.69,2.42-4.41,2.62-6.93,3-6.14,1-12.29,2.06-18.54.78a1.66,1.66,0,0,1-.9-.83,36.44,36.44,0,0,1-1-10.06c-.09-12.75-1.87-25.42-1.58-38.18.26-8,.07-16,.1-24a10.17,10.17,0,0,0-.57-3.65c-1.21-3.08-.49-5.72,1.27-8.27,4-6,8.38-11.86,11.22-18.61,8,3.45,15.65,7.54,22.33,13.14,3.69,3.1,4.51,8,6.11,12.34.58,1.59,1,3.24,1.49,4.86a4.37,4.37,0,0,1,.29,4.16c-1.15,3-1.41,6.31-3.59,8.87-2.28,0-2.63-1.7-3.1-3.36-1.71-6.11-2.65-12.39-4.25-18.53a11.41,11.41,0,0,0-3.7-5.88c-1.92-1.71-3.2-1.06-4.46.68-1.61,2.25-1.54,4.66-.63,7.13,2,5.42,4.43,10.66,6.07,16.22,1,3.51,1.85,6.89,1.38,10.63a69.29,69.29,0,0,0,0,10.19c0,1.77,0,3.55-.05,5.33-.19,4.17-3.49,6.69-5.36,10-1.34,2.32-3.35,4.25-4.16,6.9-1,.92-1.81-.59-3.11-.1,2.66,3,4.43,6.68,8.76,7.46-.92-1.62-3.51-1.75-3.55-4.09,2.92-4,4.76-8.79,9.3-11.42a14.24,14.24,0,0,1,1.89,3C82.79,560.24,83.58,561.75,82.36,563.29Z"
            />
            <path
              class="cls-749"
              d="M97.3,597.36c3.57,3.5,8.4,4.08,12.86,5.41a49.08,49.08,0,0,0,21.62,1.36,39.2,39.2,0,0,0,11.76-3.7c.41.31.46.65.08,1a27.37,27.37,0,0,1-3.26,12.37,254,254,0,0,0-12,29.57,6.62,6.62,0,0,0,.21,5.22c2.21,5,4.23,10.06,7.23,14.6C145,677,150,692.48,154,708.38a1.8,1.8,0,0,1,.08,1.87c-2.39,1.3-4.31,3.38-7,4.16-1.46.18-2.95.51-4.12-.81-3.59-13.63-9-26.39-18.16-38v57.95a1.06,1.06,0,0,1-.25,1c-2.38,2.35-5,4.14-8.58,4.13-2-.55-5,0-4.43-3.65a1.48,1.48,0,0,1,1.27-.28c4.21.72,4.42.72,4.51-3.6.17-8-.44-16.07-.83-24.1-.88-17.87-2.43-35.72-1.64-53.64.16-3.73.67-7.47,2.64-10.8.79-1,1.83-.59,3-.43-.84-1-2-1.3-2.68-2.11-.6-1.25-2.88-.69-2.83-2.63a3.84,3.84,0,0,1,2.85-.73c1.72,0,1.69-1,1.47-2.26,1.89-5.66,2.88-11.55,4.2-17.34.44-1.94,2.37-3.9,1.29-5.71s-3.58-.6-5.39-1.18c-5.57-1.76-11.61-2.25-16.59-5.58-3.1-2.08-6.54-3.37-9.79-5.08-.9-1.4-.28-2.9-.31-4.36C94.85,594.57,96.11,595.89,97.3,597.36Z"
            />
            <path
              class="cls-750"
              d="M93,599.51a3,3,0,0,1,3.24.11c4.51,2.62,8.69,6.07,13.93,7.19,4.78,1,9.33,3.08,14.39,2.87,2-.09,2.34,1.4,1.45,3.07-2.83,5.33-2.51,11.52-4.64,17.09-.6,1.56-.27,3.61-1.65,5.07-1.86.48-3.52-.45-5.27-.77-1.3-.25-2.59-.69-4,0,.93,2.08,4,.94,4.58,3.31.78,1.28,2.92.33,3.4,2.09-3.19,1.11-6-1.42-8.58-.93a37.57,37.57,0,0,1,5.29,1c1.41.45,3.19.58,3.3,2.69-2.79,5.75-2.82,11.92-2.74,18.1.11,9.61-.29,19.22.67,28.81,1,10.34.87,20.75,1.6,31.08.36,5.06-.49,10.18.75,15.2.33,1.36-1.21,1.52-2.18,1.36-1.67-.28-3.3-.81-4.94-1.23l-.41.1c-1.3-25.2-3.85-50.28-6.67-75.35-.52-4.65.09-9.28.6-13.87a11.84,11.84,0,0,0-.89-6.21A160.78,160.78,0,0,1,93,599.51Z"
            />
            <path
              class="cls-751"
              d="M44.24,708.27c-1.56-14.07-3.06-28.16-6.14-42-2.48-11.08-4.51-22.17-3.24-33.59.17-7.85,3.06-14.93,6.28-21.9,1-.69,2.14-.64,3.21-1s1.92-.77,1.76-2.08-1.08-1.28-2-1.34a11.08,11.08,0,0,1-3.65-.59c-3.46-1.47-5.6-10.67-6.81-10.63-4.52-1.51-5-4.33-5.83-3.1-.92-2.25-.31-4.66-.72-7-.43-2.11.94-1.59,2-1.33,1.75.43,3.33,1.42,5.14,1.73a7.56,7.56,0,0,1,1,.14c5.44,1.14,10.74,3.27,16.47,2.31a4.9,4.9,0,0,1,1.15,0c3.1.43,6.21.13,9.3.22,1.22,0,2.46-.11,3.55.6.86,1.78-.79,1.73-1.49,1.6-1.87-.36-3.79-.07-5.72-.37,0-.09.08.21.21.21,5.19,0,5.17,0,4.16,5A36,36,0,0,1,60.43,603a9.55,9.55,0,0,0-1.07,4.24,3,3,0,0,1-.38,2c-4.87,6-5.2,13.89-8.46,20.56s-3.44,13.47-3.35,20.56c.06,4.86,1.4,9.44,2.63,14A114.69,114.69,0,0,1,53.18,702a14.43,14.43,0,0,0,0,2.37c.43,4.38-1.71,6.17-6,5.06a18.28,18.28,0,0,0-1.93-.66A3.49,3.49,0,0,1,44.24,708.27Z"
            />
            <path
              class="cls-752"
              d="M44.82,708.5c1-1.54,1.67,0,2.5.21a5.29,5.29,0,0,0,4.84-.73c1.54-1.13.2-2.22-.17-3.28-.3-.84.17-1.55.18-2.3,0-8.44.86-16.87-.68-25.33-2.05-11.31-6-22.28-5.37-34.12.33-5.75,2.75-10.63,4.37-15.85,1.37-4.4,3.26-8.64,4.69-13,.53-1.65,0-3.74,2.5-4.2.34-.07.81-.93.77-1.38-.53-5.48,3.32-9.79,4-15,.34-2.67.21-3.14-2.21-2.92a6.44,6.44,0,0,1-2.3-.2c2.64-1,5.53.32,8.1-1.06,3.18-1.63,6.39-3.11,10.11-2a146.47,146.47,0,0,1-13.82,36.45c-2.22,4.2-3.82,8.8-5.93,13.12.42,2.14-.31,3.95-1.11,6-2.17,5.45-2.09,10.68,2.3,15.42a123.21,123.21,0,0,1,14.76,19.33c.64,1.06,2,1.91,1.18,3.6-.24.5,1.8-.26,1.36,1.22-1.58,1.32-3.18,1.15-4.8.1q-2.4-3.76-4.78-7.53c-.13-2-1.71-2.85-2.91-4-.41-1.52-2.05-2-2.69-3.38a8.55,8.55,0,0,0-3.93-4.08c-.39.09-1.22-.08-1.09.39,1.23,4.53.84,9.26,1.78,13.81a81.17,81.17,0,0,0,.36,13c-.14,4.62.3,9.26-.24,13.87l-.1,3.77A9.37,9.37,0,0,1,47.94,711C46.48,710.83,45.09,710.28,44.82,708.5Z"
            />
            <path
              class="cls-713"
              d="M21.81,502.77c-.18-4.2.53-8.33,1-12.47.71-6.12,5.24-8.21,10.51-9.34,2.28.15,2,1.77,1.62,3.15-.88,3.41-.63,6.86-.64,10.31.1,26.72-.06,53.44,0,80.16a43.2,43.2,0,0,1-.11,5.09,3.27,3.27,0,0,1-.41,1.13c-3,1.2-6.56,0-9.27-3.2a12.27,12.27,0,0,1-.82-5.3c-.23-8,.95-16-.51-24-.31-9.67-.1-19.36-.9-29-.36-4.28-.11-8.58-.18-12.87C22.07,505.21,22.41,504,21.81,502.77Z"
            />
            <path
              class="cls-753"
              d="M97.3,597.36l-4.62-2.2a8.81,8.81,0,0,1-2.54-7.7c.86-4.1-.38-7.61-1.8-11.21-.54-3-1.09-6,1.14-8.67a2.51,2.51,0,0,0,.24-2c-.72-5.53,1.21-10.93.78-16.45q2.77-14.1,5.86-28.14a17.35,17.35,0,0,1,1.57-4.47,7.12,7.12,0,0,0,1.34-4.48,4.15,4.15,0,0,1,2.11-3.21c3.16-.3,4.16,2.21,4,4.27a186.48,186.48,0,0,1-2.87,19.06c0,.19-.28.34-.45.48-1.34,2.81-.4,5.77-.55,8.65,0,.49.27,1.32,1,1s1.7-2,2.08-.1c.36,1.77,1.18,3.81.22,5.51-.56,1-2,1.09-2.62-.44-1.23-3.27-3.58-1-5.44-1.12-.37,0-.65.58-.5,1.09a1.3,1.3,0,0,0,1.23,1c2.87-.21,2.55,1.71,2.61,3.58.33,11.76-1.15,23.49-.74,35.25.09,2.77.78,5.51.13,8.36C99.12,596.85,98.63,597.39,97.3,597.36Z"
            />
            <path
              class="cls-754"
              d="M33.41,493.62c-.08-3.54-.25-7.09.91-10.51.39-1.12-.22-1.64-1-2.15-3.53-7.64-5.18-15.55-3.57-24a5.43,5.43,0,0,0-.39-2,1.6,1.6,0,0,1,1.56-.42c5.16,2.16,10.6,1.32,15.93,1.61a5.28,5.28,0,0,1,1.63.35c2.69,1.7,1.39,5,2.76,7.24,3.21-3.94,3.82-4.08,6.26-1.45a7.35,7.35,0,0,1-.83,4.92,8.61,8.61,0,0,0-.26,6.87c0,2.17,2.06,3,3,4.62l-.24.37c-1.54,5.67-4.36,10.78-7.11,15.92-.62,1.17-1,2.54-2.44,3.1-2-.94-.67-2.25-.31-3.37,1.13-3.53,3.55-6.5,4.56-10.31a13.26,13.26,0,0,1-9.87,2.7c-2.51-.21-3.43-2.89-5.72-3.28a6.1,6.1,0,0,0-1.35,0c-2.13,1.85-1.56,4.49-2,6.83C34.67,491.83,35.37,493.44,33.41,493.62Z"
            />
            <path
              class="cls-755"
              d="M156,528.64c1.27,2.8.56,5.75.57,8.63,0,5.71-.71,11.45,1.76,16.94a7.29,7.29,0,0,1,.11,5.63c-1.32,2.92-1.09,5.9-1.27,8.89-2.07-.45-1.06-2.5-1.88-3.59-2.43-3-6.36-3.94-9.1-6.51-.5-6.16-4.66-10.74-7-16.12-.36-.71-.58-1.48-.89-2.21a22,22,0,0,0-1.54-3c-3.17-5.64-6.27-11.32-7.54-17.77,1.26-5.73,4.36-8,9.94-7.18,2.19.81,3,3,4.59,4.46,4.83,7.86,8.18,16.41,11.32,25,.15.4.05.92.57,1.12.17.42.48-.26.13,0-.15.12-.28.08-.31-.13C154.93,538.11,154,533.33,156,528.64Z"
            />
            <path
              class="cls-756"
              d="M56.42,474.16a5.09,5.09,0,0,1-1.08-6.1c.72-1.73,1.19-3.58,1.77-5.37,1.12-2.82,2.47-5.58,2.35-9-3.66,1.21-6.46,4.5-10.58,3.58-3.15,0-6.31,0-9.46.17-3.61.19-6.75-1.36-10-2.37-1.41-2.56-.88-5,.42-7.42,4.55-8.38,16.34-12.84,25.24-9.49,3.46,1.3,5.23,4,7,7.22C66.23,452.8,63.21,459,60,465.41,58.57,468.23,56.92,471,56.42,474.16Z"
            />
            <path
              class="cls-757"
              d="M75,681.77c-2.33.79-1.79-1.49-2.44-2.39-3-4.06-5.3-8.54-8.62-12.36-2.58-3-5-6-7.64-9-3.57-4-4.59-12.35-1.33-16.69,1.18-1.57.32-3.26,1.45-4.51a37.41,37.41,0,0,0,5.89,8.1,83.3,83.3,0,0,1,18.66,32.63C79.83,680.9,78.34,682,75,681.77Z"
            />
            <path
              class="cls-758"
              d="M29.22,742.25c2.64-5.07,7.2-8.44,11.09-12.4a20.81,20.81,0,0,1,4.8,2.25c-.63-.72-1.91-.63-2.25-1.68.08-.29.22-.6.39-.57,2,.28,3.73-.7,5.66-1.39-1.94-1.22-4.31-1.13-6.16-2.35.85-2.48.77-5.24,2.24-7.53,2.13.63,3.5,2.87,6.22,2.48,1.73-.25,2.8-1.74,4.51-1.75,2.7,2.38,1,5.88,2.21,8.64,1,3.14-.25,5.57-2.7,7.33a33.16,33.16,0,0,0-6.64,6.64c-3.62,4.56-8.17,7-14.17,5.76C31,747,29.42,745.27,29.22,742.25Z"
            />
            <path
              class="cls-759"
              d="M73.44,699.48c1.31-.89,1.31-.89,5.21.38-1-1.78-3.12-1.22-4.26-2.42,1-1.93,3.09-1.46,4.84-2-2.06-2.08-2.09-2.14.28-3.21a10.26,10.26,0,0,0,3.7-2.84c.87-1,1.82-1.67,3.2-1,1.62,2.43,4.11,4.15,5.38,6.91,1,2.25,1.29,4-.87,5.88-5.31,4.52-10.53,9.12-16.8,12.31a14,14,0,0,1-7.86,1.24A4,4,0,0,1,62.44,712a3.83,3.83,0,0,1,1.83-4.37c2.53-1.68,5.24-3.11,7.14-5.58a2.39,2.39,0,0,1,2.52-.3c1,.66,1.79.26,2-.55s-1-.56-1.44-1A13.11,13.11,0,0,1,73.44,699.48Z"
            />
            <path
              class="cls-760"
              d="M123.9,463.83a8,8,0,0,0,1.17,1.61c3.86,3.2,4,3.5-.58,5.67-5.56,2.62-11.35,4.81-17.64,5.1-1.21,1.13-2.72.87-4.16.9-2.22.06-4.5-.28-6.5,1.51-1.56-3,1.13-4.81,1.33-7.1C102.65,463.14,114.31,459.74,123.9,463.83Z"
            />
            <path
              class="cls-761"
              d="M27.81,592.08c.07-1.64.15-3.27.22-4.9-.14,4.29,2.52,6.2,6,7.45.77.84,2.74,1.39,3.32,1.8.7,1,.06,2,0,3-.44,3.88,2.46,5.15,6.34,5.69,1.34.18,4.56.63,4.43,2.88s-6.87,2.48-6.6,3c-1.79,6.33-5,12.23-5.56,18.94a10.83,10.83,0,0,1-1.09,2.79C31.38,623,29.91,613,28.67,602.87,28.24,599.3,27.5,595.72,27.81,592.08Z"
            />
            <path
              class="cls-762"
              d="M160,577.59c2,5,2.24,10.32,1.92,15.53-.19,3-4.06,3.16-6.08,4.83-1.07-.1-1.95.52-2.91.82-4.1,1.25-5.37.73-5.8-3.4-.52-5.15-1.7-10.26-1.18-15.49a2.77,2.77,0,0,1,2.69-1.08,8.81,8.81,0,0,0,8.75-4.43c.11,1.67,1.89,2,2.58,3.2-1.36,3.89-5,3.84-8.11,4.82C154.93,581.44,158.62,581.51,160,577.59Z"
            />
            <path
              class="cls-763"
              d="M87,524.49c1-4.36,3.6-8.27,3.55-12.91,2.05.8,1.48-1.27,1.85-1.94,1.61-2.84,3.19-5.53,7-5.43.2,1.16-.63,1.86-1.19,2.69-5.2,7.59-7.54,16.34-9.8,25.07a10.93,10.93,0,0,0,2.16,9.6c1.09,2.18.62,4.41.26,6.65a3.15,3.15,0,0,1-2.72,1,18.44,18.44,0,0,0-7.36,1.13c-.75-1-.51-2.15-.31-3.26,1.19-6.68,3-13.21,4.83-19.74A4.73,4.73,0,0,1,87,524.49Z"
            />
            <path
              class="cls-764"
              d="M116.39,738c3.2-.12,5.25-2.69,8-3.74,1.18,2,.47,3.67-.94,5.06-4.07,4-7.06,8.92-11,13-5.13,3.34-8.89,2.53-11-2.36a2.15,2.15,0,0,1,0-2.23l4.12-4.09c1.33-1.24,2.83-1,4.38-.57,3.83,1.13,5.36.16,6.09-3.85A2,2,0,0,1,116.39,738Z"
            />
            <path
              class="cls-765"
              d="M156,528.64v15.53c-4.23-9.2-8.24-18.34-12.82-27.21.05-.39.05-.8.43-1.06C150.22,517.69,154.93,521.38,156,528.64Z"
            />
            <path
              class="cls-766"
              d="M147.6,713.74c1.89-1.33,3.6-3,6-3.46a6.9,6.9,0,0,1-.58,8.48c-1.37,1.6-3.09,2.89-4.15,4.76a15.52,15.52,0,0,1-11.15,5.56c-4.21.38-5-.09-5.66-4.49,2-2,4.56-3.26,6.87-4.85.44-.1-.09,0,.29-.17,1.78-1,3.18.74,4.74.64,1.86-.11.72-3.13,2.69-3.28C149.83,716.68,147.49,714.86,147.6,713.74Z"
            />
            <path
              class="cls-767"
              d="M91.18,549.4c1.29,4.51-.92,8.85-.65,13.29.18,2.84,1,5.51-1.66,8-1.34,1.23-.33,3.7-.53,5.6q-2-5.29-4-10.57c-.39-1-.54-2.24-2-2.39.64-1.7-.91-3-.73-4.68-1-3.58.7-6.5,4.64-6.74a4.54,4.54,0,0,0,4.25-3C91,548.76,91.19,548.94,91.18,549.4Z"
            />
            <path
              class="cls-768"
              d="M97.52,471.52c.7,2.25-2,3.66-1.4,6,3.33-2.57,7.14-.94,10.73-1.35l-.08.8c-1.56,1.24-3.42.81-5.15.8-2.71,0-3.58,1.33-3.25,3.79.24,1.76.69,3.48.79,5.27.4,7.18,2.89,13.81,5.56,20.37.85,2.1,1.82,4.12,1.7,6.46-.93,6.88-1.56,13.8-3,20.68.16-1.47.35-2.83,2-3.25a4.77,4.77,0,0,1,0,1.64c-.57,1.43-.83,3.82-2.49,3.64s-.55-2.44-.9-3.74c.1-6.22,1.56-12.26,2.45-18.38.37-2.52-.94-4.57-3.24-4.84a14.89,14.89,0,0,1-1.43-2.67c-.18-.93,1.33-1.75.18-2.74-.2-4.54-2.31-8.65-3-13.08-.57-3.65-1.29-7.29-1.83-10.95A10.64,10.64,0,0,1,97.52,471.52Z"
            />
            <path
              class="cls-769"
              d="M100,504c1.39.91.74,1.87.06,2.84.35,1.25-.44,2.16-1,3.11a61.93,61.93,0,0,0-7.66,28.1c-.06,1.38.31,3-1.54,3.71-3.5-3.81-3.28-8.55-1.89-12.72,2.17-6.47,4-13.15,7.26-19.22a23.47,23.47,0,0,1,4.2-5.65Z"
            />
            <path
              class="cls-770"
              d="M21.81,502.77c1.17,2.12,1.2,4.58,1.2,6.8,0,8.21,1.16,16.38.87,24.61-.13,3.77.49,7.55,0,11.33-.14,1,.32,2.06-.67,2.82C19.68,533.23,20.51,518,21.81,502.77Z"
            />
            <path
              class="cls-771"
              d="M157.36,574.37c0,3.74-2.54,4.84-5.66,5.19-1.75.19-3.53.17-5.29.25-.94-.66-1-1.7-1.13-2.69.66-2.84,3.21-4.36,4.66-6.65,2.42-1.44,3.47-4.31,5.93-5.72,1.31,1,.17,2.87,1.26,4Z"
            />
            <path
              class="cls-772"
              d="M44.82,708.5c2.46,2.74,5.42,1.91,8.34,1.09,1.14-.32,2-1.32,3.31-1.35,1.21,3.41-.07,6.49-1.24,9.59-3-.54-6.16,1.26-9-.76-2.81-2.45-2.72-5.55-2-8.8A4.12,4.12,0,0,1,44.82,708.5Z"
            />
            <path
              class="cls-773"
              d="M145.73,576.86c.89.83.44,2,.68,2.95.6,5.48,1.36,11,1.72,16.45.16,2.57,1.35,2.6,3.27,2.38,1.49-.18,2.76-1.71,4.41-.69-3.8,2.07-8,2.9-12.19,3.5,0-.34-.05-.68-.08-1,3.57-1.88,1.87-5.15,1.9-7.84,0-4.23-2.28-7.61-4.77-10.82C141.34,579.08,142.85,577.26,145.73,576.86Z"
            />
            <path
              class="cls-774"
              d="M75,681.77a8.3,8.3,0,0,0,6-4.2c1,2.67,3.51,4.95,2,8.22-2.59,1-4.43,3.63-7.55,3.44-3.52-.88-4.76-3.57-5.36-6.76C71.7,682.21,73.44,682.81,75,681.77Z"
            />
            <path
              class="cls-775"
              d="M101.38,747.75c1.87,6.07,5,7.24,10.83,4,4.69-4.64,9-9.61,13.7-14.26,1.46,2.83,1,5-1.93,6.69a25.26,25.26,0,0,0-6.7,6.07c-3.18,3.91-7.41,5.8-12.59,4.6C100.45,753.9,99.66,752.13,101.38,747.75Z"
            />
            <path
              class="cls-776"
              d="M75.43,689.23c2.69-.76,4.3-3.89,7.55-3.44.53,1.68,2.37,1.69,3.43,2.7a2,2,0,0,0-2.2,1.09,8.33,8.33,0,0,1-6.12,4c1.12.59,2.48,0,3.13,1.23-1.52,2.83-4.65,1.53-6.83,2.66C74,694.61,76.32,692.13,75.43,689.23Z"
            />
            <path
              class="cls-777"
              d="M29.22,742.25c2.16,4.74,8.54,6.63,13.3,3.89a17.06,17.06,0,0,0,5.59-4.87,23.41,23.41,0,0,1,6-6c2.6-1.75,4.35-3.95,3.86-7.33,1.18,2.53.94,5.1-1.17,6.76-4.1,3.25-7.06,7.57-10.91,11s-10.32,4.42-14.5,1.93C29.34,746.47,27.58,745,29.22,742.25Z"
            />
            <path
              class="cls-778"
              d="M116.39,738c1.84,3.07-1,4.38-2.32,6.29s-2.49.3-3.65-.23a7.15,7.15,0,0,0-4.92-.42q2.84-4,5.68-8a1,1,0,0,1,.41-.1C112.28,738.17,114.77,737.25,116.39,738Z"
            />
            <path
              class="cls-779"
              d="M132,724.59c1.27,1.06.84,3.8,2.79,3.79,2.85,0,5.84,0,8.53-1.34a19.9,19.9,0,0,0,5-3.9,85.09,85.09,0,0,1,9.6-8.79c1.11,1.54,1,3.12-.45,4.19-5.54,4-10.37,9.09-17.3,10.91a16.63,16.63,0,0,1-4.69.51C132,729.82,130.94,728.16,132,724.59Z"
            />
            <path
              class="cls-780"
              d="M147.6,713.74c.63,1,2.57,1.13,2.17,2.6s-1.66,1.39-3.06,1.22c-1-.13-.65,1-.72,1.77-.17,1.78-.82,3.25-3,1.67a6.77,6.77,0,0,0-4.1-1.26l4-6.13Z"
            />
            <path
              class="cls-781"
              d="M143.57,515.9c-.14.36-.28.71-.43,1.06l-3.61-3.85a23.71,23.71,0,0,0-.86-2.45c-.9-2.5-2.84-3.69-5.3-4.22a6.35,6.35,0,0,1-2.87-.89c-.56-1.18,0-2,.92-2.61,6.22-.31,9.76,2.45,11.12,8.47C142.88,512.9,142.31,514.62,143.57,515.9Z"
            />
            <path
              class="cls-782"
              d="M52.43,584.47c4.14-.19,8.27-.44,12.4-.56A36.27,36.27,0,0,0,77.57,581c0,.7,0,1.39,0,2.08A4.74,4.74,0,0,1,76,584.36,48.57,48.57,0,0,1,54.82,587C53.54,586.86,51.6,586.84,52.43,584.47Z"
            />
            <path
              class="cls-783"
              d="M46.22,717.07c2.19-.1,4.41.37,6.58-.43,1.15-.43,1.87.27,2.43,1.19.16.49.33,1,.49,1.48-2.76,3.92-8.07,3.56-10.73-.73A2.36,2.36,0,0,1,46.22,717.07Z"
            />
            <path
              class="cls-784"
              d="M76.13,587.27l-10.11,2c-3.6,0-7.19.07-10.78,0-1.06,0-2.3.4-3-.85a1.62,1.62,0,0,1,2-1.66c7.56.88,14.87-.33,22.05-2.63a1.42,1.42,0,0,1,1.26.2C77.9,585.73,76.87,586.43,76.13,587.27Z"
            />
            <path
              class="cls-785"
              d="M77.55,584.36c-7,3.12-14.5,3.29-22,3.27-1.19,0-2.52-.64-3.35.82l-.28.09a2.7,2.7,0,0,1,0-4.22,3.44,3.44,0,0,1,.55.15c.12,1.59,1.21,1.53,2.42,1.61a57.17,57.17,0,0,0,22.7-3Z"
            />
            <path
              class="cls-786"
              d="M125.91,737.53c-.14.65-.06,1.62-.46,1.92-4.93,3.57-7.81,9.33-13.24,12.34,3.13-4.07,6.07-8.3,9.77-11.9,1.57-1.54,2.94-3.17,2.43-5.61.1-.25.21-.49.32-.73C125.13,734.88,125.52,736.2,125.91,737.53Z"
            />
            <path
              class="cls-787"
              d="M42.75,726.11c1.65-.49,3.15.19,4.59.74,1,.38,2.92.54,2.49,2-.25.82-1.93,2.39-3.21.57l2,1.76c-2.3.78-3.33-1.13-5.17-.88,1.11,1.16,3,1.4,3.7,3.7l-6.87-4.12C40.53,728.21,42.54,727.75,42.75,726.11Z"
            />
            <path
              class="cls-788"
              d="M158,714.35c-2.39,3.82-6.16,6.13-9.6,8.8a4.15,4.15,0,0,1,2.12-2.94c3.53-2.58,4.06-6,3.09-9.93.13-.64.25-1.27.37-1.9A9.29,9.29,0,0,1,158,714.35Z"
            />
            <path
              class="cls-789"
              d="M60.64,481.24c.09,3.12-1.66,5.52-3.2,8-2.2,3.49-4.2,7.12-7.09,10.12-.81-1.13.18-1.94.61-2.75,3.11-5.72,6.57-11.27,8.24-17.66l.22-.13Z"
            />
            <path
              class="cls-790"
              d="M34.85,586.34l-1-.07c-1.53-2-4.11-1.93-6.07-3.11-1.13-.67-2.42-1.07-3.14-2.28a2.41,2.41,0,0,0-.16-.54c.75-2.41,2-.55,3-.32,1.93.43,3.53,2.46,5.8,1.11l0-.25a1.34,1.34,0,0,1,1.67.22A5,5,0,0,1,34.85,586.34Z"
            />
            <path
              class="cls-791"
              d="M24.6,580.88c2.58,1.12,5.13,2.3,7.74,3.33,1,.41,1.94.68,1.47,2.06-1.68-.6-3.38-1.13-5-1.8-.88-.37-1.49-.5-1.69.66C26.53,583.55,24.47,582.85,24.6,580.88Z"
            />
            <path
              class="cls-792"
              d="M33.27,581.13c1,1.36,1,2.21-1,1.5s-3.73-1.54-5.61-2.27c-.72-.27-1.49-1.37-2.24,0-1.05-.94.29-1.82.07-2.74A28.39,28.39,0,0,0,33.27,581.13Z"
            />
            <path
              class="cls-751"
              d="M56.57,704.47l-.11-14.6a25.79,25.79,0,0,1,.14-9.71A112.89,112.89,0,0,1,56.57,704.47Z"
            />
            <path
              class="cls-793"
              d="M73.44,699.48c2.62.35,2.62.35,4.45,2.32-1.87-.31-2.14.44-1,2.31-2.12-.76-3.52-2.32-5.5-2A5.11,5.11,0,0,1,73.44,699.48Z"
            />
            <path
              class="cls-757"
              d="M56.6,680.16c-.05,3.24-.09,6.47-.14,9.71-1.35-4.07-.87-8.14,0-12.22Z"
            />
            <path
              class="cls-757"
              d="M55.76,663.45c2.22.48,3.74,1.64,3.93,4.08Z"
            />
            <path class="cls-757" d="M62.38,670.91c1.82.73,3.58,1.51,2.91,4Z" />
            <path
              class="cls-794"
              d="M131.42,502.94c-.16.85-.33,1.69-.49,2.54,0,.42-.14.64-.56.65-2.13-1.53-.65-2.74.36-4Z"
            />
            <path
              class="cls-795"
              d="M121.63,488.46a44.1,44.1,0,0,1,.76,13.11c-.29,5.39-3.17,9.5-7.23,12.86-1.65-2.84-5.23-2.95-7.34-5.15-6.28-5.69-7.62-13.48-9.08-21.23a7.39,7.39,0,0,0,0-3c-.18-3.57.55-4.3,4.22-4.33a11.6,11.6,0,0,1,6.46,1.62C113.25,484.83,117.09,487.32,121.63,488.46Z"
            />
            <path
              class="cls-796"
              d="M136.85,573.91c-4.47-5.48-7.09-12-10-18.32-4.11-9.08-7.15-18.46-6.46-28.64a29.48,29.48,0,0,1,3.73-12.46c2-3.55,4.83-5.89,9-6.37a.91.91,0,0,1,.57.81,3.21,3.21,0,0,1-1.17,2c-6,6.4-7.86,13.71-6.24,22.44,1.39,7.57,4.39,14.44,7.16,21.46,1.18,4.27,3.73,7.89,5.6,11.83.53,1.13,1.28,2.12,1.08,3.45C139.62,571.87,139,573.54,136.85,573.91Z"
            />
            <path
              class="cls-753"
              d="M101.4,575.19v-21c0-1.83-.25-3.84,2.57-3.74,2.36.09,3.25,1.47,2.86,3.61-1.12,6.06-.47,12.26-.77,18.32-.29,5.87-1,12.09.13,18.09a21.84,21.84,0,0,1,.64,6c-.2,2.29-1.62,3-3.73,2.92s-1.8-1.56-1.77-3.14c.12-7,0-14,0-21Z"
            />
            <path
              class="cls-797"
              d="M136.85,573.91l2.77-3.69c.76-1.84,1.21-3.9,3.37-4.74,3.38.47,6.23,1.7,7.44,5.24l-4.7,6.14a29.33,29.33,0,0,0-5.06,4.9c-.2.1-.41.19-.6.31-1.16.78-2.14,2.71-3.53,2-1.8-.85-2.7-2.94-3.7-4.7-.51-.88.42-1.39.91-2Q135.3,575.67,136.85,573.91Z"
            />
            <path
              class="cls-798"
              d="M121.63,488.46c-3.26.57-5.95-.62-8.49-2.56-3-2.27-6.15-4.17-10.1-4.45-2.74-.2-4.11.5-3.72,3.47a25.7,25.7,0,0,1,0,3.4c-1.17.25-1.06-.37-.75-1.12-3-12.45-1.51-10.33,8.17-10.19,1,1,2.29.51,3.46.59a18.62,18.62,0,0,1,9.52,6.1Z"
            />
            <path
              class="cls-799"
              d="M108.15,509.48c3.26.26,6.86,2.81,7,4.95-4.85,4.63-7.16,10.75-9.75,16.7-.73,1.23-1.45,2.47-2.17,3.7l-.54-.12q1.47-10.62,2.93-21.25C106.18,512,105.25,509.51,108.15,509.48Z"
            />
            <path
              class="cls-768"
              d="M119.75,483.7a48,48,0,0,0-9.52-6.1A11.51,11.51,0,0,1,119.75,483.7Z"
            />
            <path
              class="cls-800"
              d="M34.85,586.34,34.73,581c-1-1.17-.69-2.58-.69-3.92,0-17.45-.24-34.91.08-52.36.18-10,.23-19.91,0-29.86A58.72,58.72,0,0,0,35.77,487a5.61,5.61,0,0,1,2.38-3.88c.77-.06,1.58-.32,2.26.3,4.28,3.89,8.45,4,12.88.41l1.86-1.5c-.25,3.32-1.58,5.55-2.72,7.86s-3,4.64-2.79,7.57c.09.21.28.46.21.62-3.5,9.19.15,18.56-.6,27.84a27.63,27.63,0,0,0,.4,9.36l2.22,48.76c0,1.4,0,2.81,0,4.22-5.52,1.7-10.59-.55-15.77-1.8C35.7,586.63,35.28,586.48,34.85,586.34Z"
            />
            <path
              class="cls-801"
              d="M87,524.49c-2.19,8.59-5,17-6,25.9a5.48,5.48,0,0,1-.8,5.45l-8.86,11.63c-1.61.21-2.26-1-3-2.05a1.24,1.24,0,0,1,.29-1.34,3.56,3.56,0,0,1,.75-3.34c2.41-3.09,4.52-6.41,6.74-9.64a6.19,6.19,0,0,0,1.51-3.67c4.06-5.23,2.53-10.7,1-15.35,0,2.71,1.8,6.36-1,9.69A80.4,80.4,0,0,1,78,528.25c.45-3.19-1.44-6.08-2.4-9-1.67-5.15-3.67-10.2-5.66-15.24a7.43,7.43,0,0,1,.41-6.23c1.82-3.75,3.59-3.77,6.8-1.38,2.43,1.81,3.23,4.07,3.81,6.72,1.35,6.25,2.78,12.49,4.13,18.75C85.34,523.05,86.34,523.63,87,524.49Z"
            />
            <path
              class="cls-802"
              d="M49.65,535.56c-1-4.07-.85-8.27-1.16-12.4-.45-5.86.12-11.78-.76-17.63-.44-2.89,1-5.25,1.9-7.79,3-6.05,7.14-11.64,8.36-18.51.17-1,.71-.56,1.21-.32.26,4.68-2.59,8.23-4.46,12.11-1.36,2.82-3.33,5.32-4.39,8.3-2.46,3.47-1.21,7.12-1,10.92C49.9,518.65,49.61,527.12,49.65,535.56Z"
            />
            <path
              class="cls-803"
              d="M80.27,555.84a15.74,15.74,0,0,1,.8-5.45c.66-1.73,2.1-2,3.7-2H90.5a.36.36,0,0,1,.19.37c0,.15,0,.22-.1.22-.09,2.24.72,4.88-3.55,3.65-2.91-.84-5.27,2.21-5.41,6C80.23,558.15,80.55,556.84,80.27,555.84Z"
            />
            <path
              class="cls-804"
              d="M68.72,564.08c0,.37,0,.74,0,1.11,1.38,3.1,4.73,4.09,6.87,6.37.34,1,.08,1.66-1.06,1.2-4.36-1.77-7.19-5.26-9.73-9-.19-.28-.12-1.14,0-1.19a2.72,2.72,0,0,1,1.84-.23A10,10,0,0,1,68.72,564.08Z"
            />
            <path
              class="cls-805"
              d="M75.63,571.56c-2.63-1.75-5.92-2.81-6.87-6.37l2.65,2.28C72.24,569.43,75.21,569.18,75.63,571.56Z"
            />
            <path
              class="cls-806"
              d="M115,637.42c-2.08-1.27-4.8-1.19-7-3.27,4.3-2.46,8-.61,11.69.76,1.37,1.3,1.81,2.35-.73,2.46C117.66,637.43,116.34,637.4,115,637.42Z"
            />
            <path
              class="cls-807"
              d="M118.43,642.25c-2.92-3.54-7.54-2-11.1-3.83,3.9-1.66,7.37,1.17,11.09,1.09,1.11,1.38,3.59,1.39,3.91,4.23Z"
            />
            <path
              class="cls-808"
              d="M34.93,493.85c-.6,2.84.38,5.62.36,8.43Q35,541.64,34.73,581l-1.41-.12.09-87.26c.47-2.81.81-5.66,1.53-8.41.18-.68-.51-2.87,1.74-2.17C36.49,486.71,35.11,490.18,34.93,493.85Z"
            />
            <path
              class="cls-809"
              d="M90.59,548.94a.57.57,0,0,0-.09-.59c-.06-2.2.34-4.44-.62-6.55,1.41-4.31.8-8.85,1.69-13.29,1.55-7.8,4-15.08,8.49-21.63,1.93.14,1.18,1.53,1.19,2.57-.42.92-.85,1.84-1.28,2.76-.92,1.23-.28,2.95-1.29,4.15-3.06,10.33-4.7,21-6.87,31.49a9.33,9.33,0,0,1-.63,1.55Z"
            />
            <path
              class="cls-768"
              d="M98.68,516.36c.09-1.49-.23-3.11,1.29-4.15C100,513.74,100.54,515.42,98.68,516.36Z"
            />
            <path
              class="cls-810"
              d="M48.88,457.23c3.67-1.06,7.23-2.32,10.16-4.91.63-.56,1.17-.44,1.48.47.63,1.83-1.64,8.53-3.41,9.9-2.18-2.45-3.09-2.26-4.31.84-.33.85,0,2.36-1.46,2.31-1.67,0-1.15-1.69-1.38-2.64C49.46,461.24,49.23,459.22,48.88,457.23Z"
            />
            <path
              class="cls-811"
              d="M34.93,493.85A21,21,0,0,1,36.68,483l1.47.06C36.15,486.41,36.59,490.45,34.93,493.85Z"
            />
            <path
              class="cls-812"
              d="M133.17,508.15l6.38,3c.52.67.87,1.34,0,2-5.19-.74-8.42,1.46-9.63,6.54a57.44,57.44,0,0,0-.17,12.84,12.26,12.26,0,0,0,3.75,8.14c2,2.8,3.58-.12,5.34-.47l.75,1.74a13.23,13.23,0,0,1,.93,4c-.12,2.91,0,5.85-.67,8.74-.62,2.57.79,4.82,1.42,7.18a5,5,0,0,1,.32,1.06c0,1.72.88,4.16-1.29,4.64-2,.45-2.09-2.09-2.89-3.49-1.67-2.91-2.93-6-4.68-8.9a101.87,101.87,0,0,1-6.09-15.73c-2.83-9.64-3-19,3.52-27.61C131.11,510.53,133.53,510.46,133.17,508.15Z"
            />
            <path
              class="cls-813"
              d="M133.44,541.81a9.81,9.81,0,0,1-4.18-7c-.8-5.07-1.6-10.18.64-15.13,1.59,6.3,4.9,11.86,7.58,17.7C136.13,538.83,136.07,541.48,133.44,541.81Z"
            />
            <path
              class="cls-814"
              d="M139.51,546.31l.06-4.41c2.34,4.36,4.65,8.74,7,13.08.71,1.3.16,2.39-.25,3.54-.26,2.84-1.75,5.06-3.59,7.11-2.58.22-.88-2.23-1.87-3h0c-2-4.09-1.72-8.35-1.07-12.69A5.21,5.21,0,0,0,139.51,546.31Z"
            />
            <path
              class="cls-815"
              d="M142.77,565.24l3.57-6.71a22.92,22.92,0,0,1,9.53,6.22c-1.36,2.4-2.78,4.76-5.44,6-2.16-2.15-4.36-4.24-7.57-4.7a.48.48,0,0,1-.24-.51C142.66,565.33,142.71,565.24,142.77,565.24Z"
            />
            <path
              class="cls-816"
              d="M133.44,541.81c2.25-.67,1-4.49,4-4.46a4.37,4.37,0,0,1,1.34,2.81C137.49,542.24,136.22,544.48,133.44,541.81Z"
            />
            <path
              class="cls-817"
              d="M160,577.59a3.09,3.09,0,0,1-1.94,3.55,13.38,13.38,0,0,1-9.42,1.38c4-1.31,8.58-1,11.33-4.95Z"
            />
            <path
              class="cls-818"
              d="M108.15,509.48c-1.73.77-1.85,2.55-2.52,4a9.53,9.53,0,0,0-1.14-4.54c-3.18-6.29-4.67-13.14-6.39-19.91a1.5,1.5,0,0,1,.5-1.82c.16.44.13,1,.75,1.12A48.5,48.5,0,0,0,104.19,504c.61,1.26,1.45,2.57,2.8,2.72C109.44,506.94,108.41,508.29,108.15,509.48Z"
            />
            <path
              class="cls-819"
              d="M142.77,565.24l.09.79-3.24,4.19c-1.57-4.43-4.16-8.35-6.16-12.57a4.13,4.13,0,0,1-.75-2.5c2.69,2.43,3.24,6.11,5.23,9,.72,1,.68,3.14,2.22,2.83,1.35-.27.39-2.16.62-3.31.06-.34.07-.68.1-1C142.05,563.11,140.93,565.25,142.77,565.24Z"
            />
            <path
              class="cls-819"
              d="M139.51,546.31c1.4,1.57.83,3.5.66,5.18-.32,3.13-1.22,6.19.71,9.14.31.47,0,1.33,0,2C137,557.48,140,551.75,139.51,546.31Z"
            />
            <path
              class="cls-820"
              d="M332.5,520.72c.1,2.65.23,5.3.3,7.95a38.09,38.09,0,0,0,.56,6.74,28.72,28.72,0,0,1,.18,5.64,1.24,1.24,0,0,1-2,0c-.76-4.94-2.12-9.76-3.05-14.68a3.41,3.41,0,0,1-.06-.9,40,40,0,0,1-.3,4.51c-.05,1.51,0,3,0,4.53,0,1.31-.21,2.61-.18,3.93a1,1,0,0,1-.15.56c-.66.36-1.32.59-2-.05-.29-4.83-.81-9.63-1.43-14.42-.11-.83-.16-1.67-.23-2.51a5.52,5.52,0,0,1,0-3.48c.4-.42.78-.28,1.15.05.2.18.3.45.51.63.31.43.76.39,1.2.36.71,0,1.4.25,2.12.16a6.21,6.21,0,0,0,.73-.07c1-.23,1.08-.16,1.38.83a3.13,3.13,0,0,0,.59,1c.3-.2.2-.66.54-.81a0,0,0,0,1,0,0A.21.21,0,0,1,332.5,520.72Z"
            />
            <path
              class="cls-821"
              d="M324.31,512.18a1.77,1.77,0,0,1-.57-2.3,5.63,5.63,0,0,0,.41-2.08c-.07-1.57.09-1.7,1.64-1.76,1,.12,1.29.47,1,1.42a1.27,1.27,0,0,0,0,.92c.74-.88,1.89-1.3,2.19-2.51,0-.19.08-.4.33-.45.53.17.5.71.69,1.1a.65.65,0,0,1,0,.24.74.74,0,0,0,0,.44,2.69,2.69,0,0,1-.16,2.35,9,9,0,0,0-.45,2.47c-.08,1-.29,1.22-1.33,1.26A7.49,7.49,0,0,1,324.31,512.18Z"
            />
            <path
              class="cls-822"
              d="M324.35,518.44a18.44,18.44,0,0,0-.17,3.56l-.45,0a2.55,2.55,0,0,0-.36-.56c-.63-.62-1.17-.53-1.74.28-.56-.06-1.13-.09-1.69-.17s-.86-.3-.79-.94c.21-1.76.41-3.52.54-5.29,0-.66.32-.79.88-.74,1.1.12,2.21.22,3.31.33.3.07.68,0,.86.36a4.36,4.36,0,0,1,0,2A2.61,2.61,0,0,1,324.35,518.44Z"
            />
            <path
              class="cls-823"
              d="M324.31,512.18a2.78,2.78,0,0,1,1.41.43,6.11,6.11,0,0,0,2.73.47c.43,0,.77-.16.77-.62a10.93,10.93,0,0,1,.87-4.14.75.75,0,0,0-.12-.7.75.75,0,0,1,0-.95,1.6,1.6,0,0,0,1.07.7c.87.14,1,.93,1.18,1.6s.34,1.18.51,1.76a10.12,10.12,0,0,1,.39,3.83c0,.34-.2.62-.6.64a2.79,2.79,0,0,1-.41-1.8,24.6,24.6,0,0,0-.7-4.59c-.08-.31-.24-.79-.64-.68s-.31.58-.25.91c.16.9.47,1.77.6,2.68a3.66,3.66,0,0,1,.09.81,10.63,10.63,0,0,0,.45,4.78,1.75,1.75,0,0,1-.16,1.46,2.1,2.1,0,0,1-1.8.31c-.2-1.51-.43-3-.52-4.55-.05-.85,0-.83-.89-.71a3.33,3.33,0,0,1-2.24-.27,3.64,3.64,0,0,0-1.71-.42.17.17,0,0,1,0-.22Z"
            />
            <path
              class="cls-824"
              d="M330,506.53l-.6-1c-.45-.32-.35-.72-.15-1.11a1.86,1.86,0,0,0,.3-1c-.36.28-.65.24-.88-.14a1.21,1.21,0,0,0-.81-.47,6.89,6.89,0,0,1-1.15-.26,1.44,1.44,0,0,0-1.46.14c-.92-.75-.87-1.39.16-2.1a.64.64,0,0,1,.48-.13c1.13,0,1.13,0,1.29-1.05,2.58-.62,3.72,1.44,3.34,3.3a2.72,2.72,0,0,0,0,1.62,2.82,2.82,0,0,1-.23,2.21A.21.21,0,0,1,330,506.53Z"
            />
            <path
              class="cls-825"
              d="M325.22,502.67a.77.77,0,0,1,1.17-.44,6.21,6.21,0,0,0,1.35.34c.88.19.89.19,1.24,1,0,0,.11,0,.13,0s.12-.65.5-.49.14.5.07.78c-.13.55-.73,1-.31,1.68-.2,1.52-1.58,2.1-2.44,3.09-.19.22-.36.14-.37-.16a1.62,1.62,0,0,1,0-.73c.57-1-.07-1.31-.78-1.65,0-.1.18-.26.14-.32A8,8,0,0,1,325.22,502.67Z"
            />
            <path
              class="cls-826"
              d="M334,544.78a2.81,2.81,0,0,1-2.7,2.85c-.3,0-.64,0-.77-.34a.76.76,0,0,1,.28-.79,6.64,6.64,0,0,0,1.4-2.16,4.85,4.85,0,0,0,1.32-.13Z"
            />
            <path
              class="cls-827"
              d="M331.42,518.76a2.69,2.69,0,0,0,.06-1.38,1.09,1.09,0,0,0,.13-.17,1,1,0,0,1,1-.39c.43,0,.71.23.54.73-.06,1.08-.51,2.1-.62,3.17-.35.28-.18.8-.52,1.09-.46-.26-.56-.78-.82-1.17A2.23,2.23,0,0,1,331.42,518.76Z"
            />
            <path
              class="cls-828"
              d="M323.87,544.32c-.61-.43-.19-.69.18-.9a2.78,2.78,0,0,0,1-.73,3.12,3.12,0,0,0,.91-.9,2.73,2.73,0,0,1,1.64-.22.45.45,0,0,1,.15.38l.1.45c-.05.21-.08.46-.3.56C326.36,543.52,325.39,544.66,323.87,544.32Z"
            />
            <path
              class="cls-829"
              d="M330,506.53h.31c.11.09.21.24.34.28,1.56.53,2,1.8,2.25,3.27a46.51,46.51,0,0,1,.65,5.51c-.34.31-.67.11-1,0-.08-.13-.4-.25,0-.4a.78.78,0,0,0,.44-.85,20,20,0,0,0-.23-2.53c-.25-1.25-.74-2.4-1-3.62a.78.78,0,0,0-.91-.65c-.63,0-.86-.26-.82-.84Z"
            />
            <path
              class="cls-830"
              d="M332.51,515.45c.34,0,.65.21,1,.13a3.38,3.38,0,0,1-.4,2c-.24-.75-.79-.81-1.51-.17a4.69,4.69,0,0,1-.25-2.43C331.89,514.78,332.07,515.41,332.51,515.45Z"
            />
            <path
              class="cls-831"
              d="M333.53,544.21a.89.89,0,0,1-1.32.13c.27-.7-.1-1.39,0-2.09.4-.21.8-.49,1.19,0A10.66,10.66,0,0,0,333.53,544.21Z"
            />
            <path
              class="cls-832"
              d="M327.59,541.65a5.63,5.63,0,0,1-1.63.14,3.58,3.58,0,0,0,.28-1.91.9.9,0,0,1,1.26.08A2.51,2.51,0,0,1,327.59,541.65Z"
            />
            <path
              class="cls-833"
              d="M321.63,521.7c.07-.67.41-1,1-.88a1.17,1.17,0,0,1,1.07,1.16A4,4,0,0,1,321.63,521.7Z"
            />
            <path
              class="cls-834"
              d="M333.37,542.25c-.39-.23-.79.09-1.19,0h-.12c-.7-.18-.8-.48-.43-1.22a1.59,1.59,0,0,0,1.91,0C333.64,541.47,333.77,541.9,333.37,542.25Z"
            />
            <path
              class="cls-835"
              d="M327.15,499.39c.34,1-.07,1.48-1.11,1.28l-.66-.1A2.37,2.37,0,0,1,327.15,499.39Z"
            />
            <path
              class="cls-836"
              d="M327.43,540c-.37-.27-.79-.12-1.19-.14s-.48-.55-.4-1a3.25,3.25,0,0,0,1.88,0C328.06,539.42,328,539.78,327.43,540Z"
            />
            <path
              class="cls-837"
              d="M324.29,512.91l0,.16c.77.27.9,1.28.28,2.08l-.74-.26c.38-.11.26-.43.29-.68C324.22,513.78,324.05,513.33,324.29,512.91Z"
            />
            <path
              class="cls-838"
              d="M331.42,518.76c-.08.63-.17,1.25-.26,1.88-.21-.14-.09-.37-.16-.54s-.3-.56-.66-.41a4,4,0,0,1-2.72.06,2.36,2.36,0,0,0-.65,0,.64.64,0,0,1,.16-1,6.66,6.66,0,0,1,2.55.24C330.28,519.09,330.83,518.76,331.42,518.76Z"
            />
            <path
              class="cls-839"
              d="M324.35,518.44a4.47,4.47,0,0,1,.14-1.15,6,6,0,0,1,1.53,1.22c0,.3.07.64-.28.81C325.29,519,325.16,518.18,324.35,518.44Z"
            />
            <path
              class="cls-840"
              d="M325.74,519.32c.06-.28,0-.6.17-.86.34-.11.44.13.54.36s-.24.25-.06.48c.16-.14,0-.36.16-.48s.42-.35.59,0c-.3.25-.1.59-.17.89C326.48,519.84,326,519.84,325.74,519.32Z"
            />
            <path
              class="cls-821"
              d="M327.14,518.86c-.21-.23-.39.06-.59,0a.11.11,0,0,1-.15,0l-.48-.4a3.09,3.09,0,0,1-1.43-1.17,9,9,0,0,0,.13-2.14,5.47,5.47,0,0,0,.16-1.28.78.78,0,0,0-.44-.8c.8-.4,1.42.16,2.09.42a2.68,2.68,0,0,0,2.15,0c.57-.27.79-.07.77.38-.05,1.17.31,2.3.32,3.46,0,.55.38,1.11,0,1.66A7.49,7.49,0,0,1,327.14,518.86Z"
            />
            <path
              class="cls-841"
              d="M323.87,544.32a4.81,4.81,0,0,0,3-1.23c.31-.24.78-.28,1-.69a.87.87,0,0,1-.66,1.27,9.49,9.49,0,0,1-2.45.79A2,2,0,0,1,323.87,544.32Z"
            />
            <path
              class="cls-821"
              d="M332.51,515.45c-.5.06-.94,0-1-.6a2.77,2.77,0,0,1-.42-1.9c0-.14.05-.29,0-.42a18.33,18.33,0,0,0-.67-3.11,1.85,1.85,0,0,1,0-1.37c.19-.4.47-.44.75-.11a2.64,2.64,0,0,1,.6,1.26c.18,1.14.46,2.27.54,3.42.06.84.12,1.69.21,2.54C332.34,515.26,332.49,515.35,332.51,515.45Z"
            />
            <path
              class="cls-842"
              d="M326.4,518.86l.15,0c.13.21.32.48,0,.63a.43.43,0,0,1-.53-.27C325.9,518.89,326.13,518.84,326.4,518.86Z"
            />
            <path
              class="cls-843"
              d="M748.43,499.15a10.73,10.73,0,0,1,0-1.88c.06-1,.14-2,.28-2.94.06,0,.1,0,.14.06a2.66,2.66,0,0,0,2.87.26c.06,0,.13-.11.22,0a1.06,1.06,0,0,1,0,.53l.12,2.59.09,1.68a2.8,2.8,0,0,1-.12.76c-.32,1.17-.68,2.34-1.05,3.5a.34.34,0,0,1-.13.22.18.18,0,0,1-.07.05,1.19,1.19,0,0,1-.53,0l-.14-.11a11,11,0,0,1,.33-1.8c.16-.74.32-1.46.49-2.19a1.88,1.88,0,0,0,0-.85c-.18-.84-.39-1.68-.64-2.5a.79.79,0,0,0-.17-.36,3.73,3.73,0,0,0-.14.92c-.19,2.19-.49,4.37-.56,6.57a.48.48,0,0,1-.06.26.53.53,0,0,1-.73,0c-.07-1.14-.19-2.27-.22-3.41.06-.56,0-1.12,0-1.7C748.44,498.91,748.5,499,748.43,499.15Z"
            />
            <path
              class="cls-844"
              d="M751.89,494.59a1.57,1.57,0,0,1-1,.41,3,3,0,0,1-1.83-.31,1.12,1.12,0,0,1-.39-.36l0-.12a1.55,1.55,0,0,1,0-.71,5.27,5.27,0,0,0,0-.56c0-.65,0-1.31,0-2,0-.06,0-.17-.1-.07a1.22,1.22,0,0,1-.84-.1c-.09,0-.07-.1-.06-.18a7.69,7.69,0,0,1,.52-1.69c0-.11.1-.23.24-.27a.35.35,0,0,1,.17.12,8.47,8.47,0,0,1,.87,1.36.11.11,0,0,1,0,.08.14.14,0,0,1-.07.1c-.1.08-.21.15-.15.31a.35.35,0,0,0,.33.25c.18,0,.36,0,.48.17.61,1,1.18,2,1.77,3a.62.62,0,0,1,.09.3C752,494.41,752,494.52,751.89,494.59Z"
            />
            <path
              class="cls-844"
              d="M748.8,488.56a6.38,6.38,0,0,1,1-.33c.17.11.16.31.23.46a1.34,1.34,0,0,0,.28.51.22.22,0,0,0,.38,0,1.66,1.66,0,0,0,.37-.78c0-.14.08-.24.24-.23a2,2,0,0,1,1.68,2.27c0,.07,0,.12-.08.14s-.45.09-.67.13,0,.3-.18.41a.3.3,0,0,1-.23,0l-1.41-.39-.18-.08c-.17-.14-.27-.37-.5-.44-.35-.45-.59-1-.92-1.43A.2.2,0,0,1,748.8,488.56Z"
            />
            <path
              class="cls-845"
              d="M750,488.17a.88.88,0,0,0,0-.73c-.17-.42-.45-.85-.23-1.35a.17.17,0,0,1,.08.14c0,.11,0,.23,0,.36.36-.2.81-.08,1.17-.29a.11.11,0,0,1,.11,0c.15.12.07-.06.11-.09s0,0,.05-.06c.3.5-.07.9-.2,1.33a.81.81,0,0,0,0,.63,1.94,1.94,0,0,1-.3.95c-.14.23-.34.23-.5,0A1.78,1.78,0,0,1,750,488.17Z"
            />
            <path
              class="cls-661"
              d="M752.17,490.65l.75,0a11.46,11.46,0,0,1,.06,1.17c0,.23-.1.33-.32.31a2,2,0,0,1-.64-.14c-.16.05-.27-.05-.4-.1-.4-.17-.77-.39-1.16-.56-.1,0-.2-.09-.24-.21a.91.91,0,0,1,.2-.39l1.64.44C752.19,491,752.07,490.79,752.17,490.65Z"
            />
            <path
              class="cls-639"
              d="M747.79,490.8l.86.07c.09.1,0,.22,0,.32a1.53,1.53,0,0,0,0,1,6.18,6.18,0,0,1,.13.75,7.9,7.9,0,0,1-.11,1.28,21.13,21.13,0,0,1-1-2.28c-.12-.32.07-.65.1-1A.88.88,0,0,1,747.79,490.8Z"
            />
            <path
              class="cls-844"
              d="M750.45,491.22l1.57.72a9.06,9.06,0,0,0-.1,1.38.19.19,0,0,1,0,.19c-.13.07-.18,0-.23-.11-.39-.65-.79-1.3-1.19-1.95A.27.27,0,0,1,750.45,491.22Z"
            />
            <path
              class="cls-846"
              d="M748.66,503.88a1,1,0,0,0,.73,0,1.09,1.09,0,0,1-.17.92c-.11.17-.19.31-.42.28-.06,0-.12,0-.18,0s-.41.05-.5-.15,0-.36.16-.52S748.65,504.15,748.66,503.88Z"
            />
            <path
              class="cls-846"
              d="M750.85,503.9h0a2.15,2.15,0,0,0,.45.58c.13.12.25.26.18.44s-.28.19-.45.21c-.58.05-.81-.4-.87-.87,0-.14,0-.29-.05-.42l.11.05A.51.51,0,0,0,750.85,503.9Z"
            />
            <path
              class="cls-847"
              d="M751.9,493.53l0-.21a4.78,4.78,0,0,1,.72.84.31.31,0,0,1,0,.45,3.48,3.48,0,0,1-.62.53c-.13-.17,0-.37-.09-.55l0-.33c.2-.05.17.22.33.26,0-.21-.12-.35-.2-.51S751.82,493.73,751.9,493.53Z"
            />
            <path
              class="cls-848"
              d="M750,488.17c.12.09.1.24.14.36a2.18,2.18,0,0,0,.11.27c.08.15.12.36.32.36s.24-.21.3-.36.17-.47.25-.7l.22.09a.31.31,0,0,0-.17.21,1.61,1.61,0,0,1-.45.91.23.23,0,0,1-.36,0,2,2,0,0,1-.46-.91l-.06-.17Z"
            />
            <path
              class="cls-849"
              d="M748.8,488.56c0,.14.11.24.18.35.26.43.53.86.8,1.29a.18.18,0,0,1-.27,0,11.3,11.3,0,0,0-1-1.56A.33.33,0,0,1,748.8,488.56Z"
            />
            <path
              class="cls-850"
              d="M749.78,486.25l0-.16a.78.78,0,0,1,.46-.63c.56-.25.94,0,1.11.68l0,.08c-.13,0-.17-.15-.24-.24a.63.63,0,0,0-1.11.09C749.92,486.14,749.91,486.26,749.78,486.25Z"
            />
            <path
              class="cls-851"
              d="M750.85,503.9c0,.13-.08.16-.19.15s-.34.05-.4-.17Z"
            />
            <path
              class="cls-852"
              d="M751.9,493.53a3.51,3.51,0,0,0,.4.77c.06.12.11.22,0,.3s-.13-.09-.19-.15-.06-.17-.16-.19a2.12,2.12,0,0,0-.29-.56c-.52-.88-1-1.76-1.55-2.63l0,0a.11.11,0,0,1,.14,0l.2.15,1.32,2.18A.8.8,0,0,0,751.9,493.53Z"
            />
            <path
              class="cls-662"
              d="M749.51,490.22l.27,0c.27,0,.35.26.48.43s-.07.3-.17.42v0a.39.39,0,0,0-.34-.11.45.45,0,0,1-.28,0,.45.45,0,0,1-.25-.36C749.19,490.35,749.38,490.31,749.51,490.22Z"
            />
            <path
              class="cls-853"
              d="M750.09,491.05c0-.16.15-.26.17-.42.06,0,.12,0,.16.05a.69.69,0,0,1-.17.39Z"
            />
            <path
              class="cls-854"
              d="M752.17,490.65c0,.14,0,.28,0,.41s0,.13-.11.06S752,490.78,752.17,490.65Z"
            />
            <path
              class="cls-855"
              d="M749.78,486.25c.12-.12.14-.31.28-.44a.71.71,0,0,1,1.08.14,1.53,1.53,0,0,1,.17.27.56.56,0,0,1,0,.29c-.09-.19-.2-.2-.36-.1a.89.89,0,0,1-.51.11.79.79,0,0,0-.37.07c-.27.11-.29.09-.3-.2A.66.66,0,0,1,749.78,486.25Z"
            />
            <path
              class="cls-576"
              d="M512.68,503.71c0-.74-.12-1.47-.08-2.2l0-.78s0-.05,0-.08a.34.34,0,0,1,.29.08c.13.13.3.1.45.12s.55-.05.83,0c0,0-.13.05-.15-.05a.62.62,0,0,1,.53,0l0,.68a.53.53,0,0,0,0,.25c0,.39,0,.78,0,1.17a4.2,4.2,0,0,1-.06.62c-.07.25-.07.26-.38.25-.12,0-.24,0-.35,0a3.21,3.21,0,0,1-.22-1.1,5.08,5.08,0,0,1-.13.66,1,1,0,0,1-.11.4s0,0,0,0c0,.16-.08.15-.19.12a1.27,1.27,0,0,0-.28,0s-.11,0-.13,0S512.71,503.73,512.68,503.71Z"
            />
            <path
              class="cls-856"
              d="M512.45,499.73c-.14-.05-.22-.18-.32-.28s0-.07,0-.11a4.67,4.67,0,0,1,.61-1.52.72.72,0,0,1,.25-.24c.17,0,.24.17.37.25s.08.1.13.14a.26.26,0,0,0,.39-.05c.12-.08.21-.2.32-.29s.1-.11.18-.08,0,.11,0,.18a2.46,2.46,0,0,0,.09,1.27c0-.08,0-.18-.07-.29a1.23,1.23,0,0,1,0-.33V498a.57.57,0,0,1,0-.18c.06-.12.15-.14.23,0a2.29,2.29,0,0,1,.39.87,1.37,1.37,0,0,0,.1.41.32.32,0,0,1-.12.44l-.13.12a.22.22,0,0,1-.25-.08c-.1-.09-.17-.06-.24,0l-.22.27s-.07.07-.12,0a1.27,1.27,0,0,0-.64,0c-.1,0-.08.15-.16.19a1.26,1.26,0,0,1-.32-.37c-.09-.12-.16-.18-.29-.06A.23.23,0,0,1,512.45,499.73Z"
            />
            <path
              class="cls-857"
              d="M513.25,500.08a.27.27,0,0,1,.36-.25,2.28,2.28,0,0,0,.37,0c.08,0,.12,0,.11.11s.17.12.29,0a.38.38,0,0,1,.27-.1,4.33,4.33,0,0,1,0,.72.27.27,0,0,1,0,.15,2.45,2.45,0,0,0-.54,0,1.78,1.78,0,0,1-.76.05c-.12,0-.25,0-.36-.08s-.2,0-.29-.1a.77.77,0,0,1,0-.52c0-.07,0-.14,0-.21s.2,0,.28.09A.4.4,0,0,0,513.25,500.08Z"
            />
            <path
              class="cls-858"
              d="M514.06,496.67a.8.8,0,0,1-.14.39.17.17,0,0,0,0,.21c.18.28.18.35,0,.59s-.3.19-.55-.08-.08-.34,0-.51,0-.25-.07-.38a.33.33,0,0,1-.06-.19c0-.3.12-.36.42-.33h.09C514,496.41,514,496.41,514.06,496.67Z"
            />
            <path
              class="cls-859"
              d="M515.05,498.7a8,8,0,0,0-.38-.78c0-.06-.06-.16-.14-.14s-.07.11-.08.18V498c0,.05,0,.13-.08.21a2.89,2.89,0,0,1,0-.51c0-.05,0-.12,0-.17s-.08-.08,0-.14a.2.2,0,0,1,.3,0,1.71,1.71,0,0,0,.47.42.22.22,0,0,1,.12.22A1.57,1.57,0,0,1,515.05,498.7Z"
            />
            <path
              class="cls-860"
              d="M514.06,496.67c0-.22-.13-.27-.32-.23l-.08,0c-.28,0-.29,0-.42.28,0-.07,0-.13,0-.19a.35.35,0,0,1,.36-.5.6.6,0,0,1,.35,0c.2.08.25.13.21.35S514.07,496.57,514.06,496.67Z"
            />
            <path
              class="cls-861"
              d="M513.21,505.09h-.51a2.24,2.24,0,0,0,.11-.81.65.65,0,0,1,.39,0A7.48,7.48,0,0,0,513.21,505.09Z"
            />
            <path
              class="cls-861"
              d="M514.57,505.06a0,0,0,0,0,0,0h-.47a.13.13,0,0,1,0-.11,2.16,2.16,0,0,0,0-.67c.11-.13.24-.05.36,0s0,.09,0,.14C514.39,504.64,514.57,504.84,514.57,505.06Z"
            />
            <path
              class="cls-862"
              d="M513.88,503.67h.56c.09,0,.12,0,.12-.11a.33.33,0,0,1,0-.17l0,.08c0,.16,0,.31,0,.47a.15.15,0,0,1-.1.16,1.46,1.46,0,0,1-.51,0A.34.34,0,0,1,513.88,503.67Z"
            />
            <path
              class="cls-863"
              d="M513.25,500.08c-.07.09-.14.09-.24,0a1.85,1.85,0,0,0-.37-.19c0-.09-.16-.09-.19-.19a1,1,0,0,0,.2-.12c.14-.16.23-.1.31.05S513.21,499.9,513.25,500.08Z"
            />
            <path
              class="cls-864"
              d="M514.65,499.88l-.31.18c-.16.09-.2.07-.25-.12l.35-.42c.06-.08.1-.09.16,0a.6.6,0,0,0,.3.17Z"
            />
            <path
              class="cls-865"
              d="M512.68,503.71s0-.12.11-.06.34,0,.51.06,0-.07.05-.1h0l0,0a.23.23,0,0,1,0,.24.24.24,0,0,1-.3.2H513c-.24,0-.24,0-.3-.22A.14.14,0,0,1,512.68,503.71Z"
            />
            <path
              class="cls-866"
              d="M513.37,497.27c0,.05,0,.11,0,.14s0,.24,0,.36.14.13.06.24a2.76,2.76,0,0,0-.47-.43c-.06-.12,0-.19.11-.23Z"
            />
            <path
              class="cls-867"
              d="M514.31,497.41l0,.14c-.17.11-.26.31-.45.4a.07.07,0,0,1,0-.11c.07-.14.19-.27.05-.44s0-.09,0-.13A.69.69,0,0,1,514.31,497.41Z"
            />
            <path
              class="cls-868"
              d="M514,504.08a2.1,2.1,0,0,1,.5,0c0,.1,0,.21,0,.31,0-.07,0-.16-.12-.11s-.17-.06-.26,0S514,504.15,514,504.08Z"
            />
            <path
              class="cls-869"
              d="M513.2,504.28c-.13,0-.26.05-.39,0s0-.16-.07-.2a1.46,1.46,0,0,1,.51,0C513.34,504.15,513.27,504.21,513.2,504.28Z"
            />
            <path
              class="cls-870"
              d="M514.66,502.85s0-.1,0-.15v-1.12c0-.05,0-.11,0-.15A11.21,11.21,0,0,1,514.66,502.85Z"
            />
            <path
              class="cls-871"
              d="M513.27,504.08h-.53c-.07-.06,0-.15,0-.22h0c.08,0,0,.17.09.17h.46c.09,0,0-.14.1-.17C513.42,504,513.41,504.05,513.27,504.08Z"
            />
            <path
              class="cls-872"
              d="M513,500.75a10.54,10.54,0,0,0,1.12,0l.19,0a2.27,2.27,0,0,1-1.41,0Z"
            />
            <path
              class="cls-873"
              d="M514.37,497.72v.44c.07,0,0-.12.08-.14a2.28,2.28,0,0,0,.17,1.15C514.36,499.07,514.24,498.23,514.37,497.72Z"
            />
            <path
              class="cls-874"
              d="M513.89,497.84V498c-.18.18-.2.18-.44.06l-.06-.24s0,0,0,0,.24.25.41.05C513.84,497.84,513.87,497.84,513.89,497.84Z"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default Principal;
